export default [
  {
    id: "1",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "475",
    pmids:
      "22921746,19288022,29048653,27268651,28806703,23777448,26985864,20215512,22828666,28599484,24318305,27614381,28397855,19645775,27263652,22508043,20591475,18039573,24211270,23076367,26980197,17174384,20138829,24486718,12483537,28959140,25542235,24528023,28239299,19724924,10430096,23387971,29356693,19524420,27830358,25118487,25039189,19573523,29094265,22710975,27604683,21876713,15711178,18628248,28038323,19996301,21947854,21924245,14642080,19816657,24377627,12771144,25242081,21772753,19558577,17373813,29297700,26004342,16550606,27550987,29600521,23317243,17069615,25550533,20438793,26796279,19138983,23299550,23846485,16243823,19250217,29138806,14724571,15367704,21239154,16702307,18593918,26899573,28491145,12104041,22290509,27677346,28678551,22772921,26752181,27245953,10445426,28152473,26212257,23946688,26633344,9168916,21232161,27496212,25960232,24312824,29289889,9831541,20734924,11857414,26718769,19118501,22895066,20385124,20661707,20735222,22711297,20030852,17499312,22705896,18946510,17077187,22179587,24236784,27012210,18782044,21986579,28810532,24365254,25226537,26349982,29770869,21629182,24433502,12684430,23023821,22971638,25879038,17922140,12718610,28319780,22186408,26472972,28350049,29189128,23040919,20728364,20036734,28439094,25826489,28053624,17240359,21598989,21484797,25260874,23950593,23448448,16928820,18365880,28842128,26920032,26648459,29641445,11852106,23886126,16354769,24831732,25253691,24625971,28476962,23145775,24465597,29142607,25530715,28804605,26350251,15738001,29541412,25089037,27619078,19771847,28886247,24613085,18682687,27082017,20058253,26937266,23771315,15878268,24377502,26124332,23356739,27221847,25728027,26729534,19093868,22890189,23242714,23429291,20680677,28721737,22994744,17569206,29533214,23042094,29642292,21616659,26413251,19944674,17137104,16960658,20798532,23730211,10969724,25647442,16101141,20655375,27553725,17555831,25031701,25243063,22013068,28300724,25938910,26203688,29732970,29501629,25596714,29047044,27451784,23843843,29040973,24440669,12063069,25284464,26308760,17310108,14511655,20805034,29801408,24593988,22991922,22273695,26369539,22768036,23287774,26325285,27573203,27465411,29187453,15008515,27813185,19319191,17671737,29065834,23730903,29426248,24484937,24622734,27305819,29655698,21702507,24865590,8538195,25819738,27293144,27124646,25229832,29144788,17999991,23251236,29147611,28388785,21510869,28423731,24706375,25991545,28190385,24219305,10814878,27325106,11506803,22204522,21850703,29755534,27152196,23222814,27597657,29966245,27792193,22222040,27040234,29808718,28872903,26947919,27610163,20818158,25416449,26338965,19854644,21295962,25866478,26117780,29239219,25315241,18025290,26516945,21088500,29336533,27306423,23959397,26305906,22634500,28431975,27913127,18098290,26066393,25542609,23661584,17651499,28956452,23162792,23452621,22135900,29512668,28036082,24531225,29571289,21839055,24476216,24363979,9714342,24738331,29448633,26942057,15256456,23489691,23351311,21993423,24371229,19809577,26247019,28819666,21388972,29625162,28972748,28262114,27499229,29296172,28882040,18467956,21870456,24851881,29052674,12097302,20627257,27987753,24864107,24034496,28377996,28724427,22033190,28222671,9667742,28236692,26332341,23942114,28866151,27539316,21713389,15648195,29881406,29719770,26597940,21799049,23505424,26113217,29959633,27779649,27763524,23679865,27350366,22795543,29848101,23395943,27270752,29556774,17613656,28331366,27107900,27103993,23472124,22619526,25793208,25014638,29407161,27621628,27524019,28420987,18462866,27579532,29516756,28738425,27157759,29048630,16722634,29693159,28780353,28417445,29966081,28263565,11467202,20729081,27168683,27405665,13678246,28573926,28408820,28629042,21479462,20460537,21750867,25786779,24566270,28930649,27049468,28457434,29768014,21167595,24156030,27301171,29441997,25863259,14612489,27648633,22194218,25553436,26853158,25987060,29291882,25623080,29790797,27609747,24723227,28930270,12213462,10368648,27244480,24900828,29139094,24375813,22703560,19516890,26561365,29463371,29310081,22193941,23140290,27546165,19249204,28254284,25963307,25900098,23872022,27262332,29606874,25981672,26734584,29355595,27081576,29154195,20697527,26875787,29378273,19908170,26572330,29688063,27481341,29042771,29653171,26924283,29486375,27843313,26631310,26878325",
  },
  {
    id: "2",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "323",
    pmids:
      "22921746,25634350,22170094,28599484,29751678,23302496,22508043,26935808,29039582,18059161,22895548,18421301,24712725,27031849,27862996,17475222,14608118,28911558,27658723,28124838,28207992,23061908,29215574,28356020,28834706,29068745,24478544,23093841,23790880,29532526,24607787,22940714,23456297,23159608,21822728,17415784,25242081,27285995,22353783,12462380,16550606,28766690,21698198,20013881,25453494,23441615,27535497,23805102,19138983,22644859,28868867,29389559,21170718,26349913,28329437,24646833,26284516,23600473,24329111,25299698,24078922,25945840,8350491,12931129,20681660,29086902,27347927,20955751,29913427,19082476,20734924,14979919,24099118,28718669,20030852,18946510,19139005,19131542,18930055,27078842,27498973,20596647,26893740,23145928,26733173,20584749,22871396,29189128,25196850,17848600,19890716,28321778,25647396,25260874,24996346,29624275,10509743,16354769,26762586,29903207,21411498,24491902,9719459,22957077,22350787,22743590,27951515,27268647,26180585,19294520,21455577,20058253,26937266,20155623,17570133,29337349,22415970,11518657,29204075,12421874,23104437,27657126,23042094,16190622,17933449,19530711,18348194,29698680,17555831,15341993,21878663,25243063,20803121,26397047,22083314,15735708,29563789,12002340,15117547,29040973,19094209,24119558,28337113,27178635,27023497,27253407,27491891,15802018,17310108,24593988,27049956,23023566,20669365,20614088,29713632,22768036,26310506,26165362,18813848,18404597,27151203,22219179,24481780,28545532,18607509,15134383,27498957,24484937,15757513,29197410,16449979,8538195,16707458,24508987,11522280,16790523,25229832,23251236,24935390,19399671,23767410,28388785,15756018,16180720,29620223,27231728,20946668,19544670,26401395,27984132,17002470,18089804,28839265,24772933,23475480,11500915,23122108,26473769,24611152,18815743,16404708,29083228,16519995,23222814,25624761,23724044,27610163,19083478,19840838,16091006,25866478,20482276,15363298,29884381,23836544,28784292,16081510,25663548,23493479,14739618,12608775,18850184,26359358,24039951,28937798,26066393,27924981,28877394,25719685,26158795,19936622,27097608,10475615,28926932,26036628,24043896,20045338,11830514,24691968,23167379,21728961,25901160,19723063,22300613,15652269,10861841,25930965,28718725,24069935,28105248,18467956,21225623,17461595,26056816,16061885,24864107,19576744,17490486,28222671,22280355,24583606,26694338,23298290,24745759,25239551,10402233,28124843,19526991,28541359,14528600,18457947,12925309,27524019,16038899,22662208,22919439,27157759,24283885,23943159,24268240,19940992,28719146,28891568,29214243,26694341,15047179,10202393,20460537,26774195,20813524,12067577,25725373,27999314,11928805,25135771,25569691,21535822,10541965,17415955,27478970,29217339,22887783,24001127,16562825,27609747,15084232,9472101,8537983,25436704,18849663,15281219,16680375,19588362,16356836,27262332,29112149,15570052,27906144,24172305,15802301,26265569,15167223,19212014",
  },
  {
    id: "3",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "256",
    pmids:
      "18252963,26915319,23288142,18041768,17251686,29152067,23813779,17539658,11313944,27819344,27829223,15064713,23182046,10606728,16445569,22182776,23708383,18224451,22176685,9642218,29048617,24163404,16928824,23335521,15672868,9585253,12839940,18628248,24805814,19954742,9797142,12054499,19833733,10650934,15958587,12489846,15880691,19538337,23232806,25447816,12446589,14500381,23317243,11245489,21586513,20179161,16397234,10919709,24216289,23468877,20471474,19913079,10949153,11314025,22534171,12471041,27589474,16168116,11241756,15631803,12942541,15231676,17160024,24732598,15642734,11149601,24727858,19747539,25338635,22740919,14704150,22472210,20479004,11278435,17620438,10809781,9652748,11911959,19923913,22096483,9467952,11384880,12628005,10930570,9388270,18181040,16467878,12839332,27384485,12970168,12479366,10197638,25226537,15856005,28988530,10376521,18161870,15930183,15922332,20013077,29695559,26135903,12691824,27216977,19298253,27484709,11781819,27181679,22128158,17676480,24390819,25555875,19801662,18534028,15634404,17925034,10872812,22576740,12023956,11278744,14617784,29846015,15703835,17363451,24718680,10714766,25130739,12883736,21771724,12811831,10753939,11910048,16394177,28781955,10097113,16322252,28274095,10871841,17392272,12586780,17767925,15449318,15156564,9671232,21175263,10347201,16419029,10547071,16170669,22964364,11463858,26519986,10674396,28402270,21669197,12663670,14517342,17289850,17189385,24482702,28560447,10228164,12051724,15714461,10436007,16322288,21147512,15744749,21350004,16613992,29574069,19305150,16785991,9360986,11821958,18266953,24405819,11591826,21643005,9545345,11072781,11359772,25724898,15111768,26059188,11787050,23602052,17113978,10383890,21468925,21216934,14985328,11805108,16207704,27038254,29371916,25727011,10640428,12734209,21236341,22329816,24213635,12082091,15899786,27180173,21904903,16740736,16050133,24434427,18235976,12767061,15199145,14692651,29125193,26398369,19609946,15672871,21841813,11245436,22862967,25961241,24368600,15059947,10066806,14697248,11850215,16752079,11034403,12193533,20947540,21394501,15947004,18622691,15375508,26363202,18443432,11415996,16079255,16678794,16415123,20363323,23170258,17505812,17097066,26526356,9525964,12562385,11713241,20520761,24924199,25180937,19578757,18377656,12531699,18060492,15695373",
  },
  {
    id: "4",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "450",
    pmids:
      "18252963,25613518,17762393,21389782,16889690,18718176,17539658,26483970,18224451,10319943,25009600,12792805,21132400,7819137,15358198,9664138,16758967,18492603,19013426,11506505,22580499,12588701,15672868,25675448,12224597,26771440,8217365,17295235,9563884,29095048,9679118,8567115,8891338,16613577,24573886,16702307,24299158,21965740,18181168,10753641,22227334,17992604,24504162,18508214,21493710,17681752,25826638,10639578,15862028,10340389,9168916,12066207,11748377,25109508,9831541,29954123,10961387,9631496,23973682,18761399,10704911,11767000,17077187,24284485,12879015,9751267,8784471,24331293,21792929,17132221,12853125,14644660,24188694,16094502,9849427,19298253,23342141,9371497,20493747,17640171,10427135,8879680,20651350,9716023,8201603,21340606,12554767,9344853,16309237,8641545,19723084,19932626,10679229,28644496,23686257,16506809,24718680,19427779,15166400,10996850,16969510,24532317,10753939,10953303,19617894,16379557,12963483,12416264,29736565,11096068,29899271,9381980,9848511,27574003,15110097,16434996,20058253,15914273,15617098,26519986,16789754,17478088,10601582,12079141,21419318,25581323,15876409,23379261,7945420,9673352,15030235,17125943,29204990,12421874,10323669,9520374,12710998,16541309,24978400,9168007,9809990,10470366,15744749,17234721,12425726,20399854,18444173,17961621,9066718,16055089,17617943,26199568,29434697,12441353,12967197,15182386,16491457,10463775,15492830,21462322,26783066,17482226,11072781,9703891,23756170,11778268,15323430,11776565,16579725,16061678,11950489,17981312,20549624,19003112,26703673,12897156,22459208,14511655,15105043,24375531,19924815,1279187,14628433,28720470,18955141,15461279,8074476,29101532,18497090,9513045,22219179,26794366,7892295,12776537,15135300,15876411,23337939,21160418,20884965,22415614,8104437,15754008,18632754,7794275,11410520,19928832,9795970,8625449,27033456,17266178,12908908,17976513,20574927,19358274,16596234,16912569,11400165,19126406,17024228,17051425,11506803,16152973,23227466,9770719,8824507,9731492,17690101,11502892,14620916,1883387,15254334,16966488,15126563,12793002,10084649,16870006,12840226,15579072,10491398,26006245,17786319,18025290,9492340,7833143,19800779,12239620,19406242,12549765,16886669,17761019,10376965,16899133,24319544,15829497,15056864,8813150,24894196,24812910,25719685,28396216,9848525,14992594,23452621,26081033,16690804,11110847,15705886,15036763,570914,17015169,9343831,11509969,8875554,18815740,22493348,29955703,24468067,17687646,20127002,11795395,15905199,15090535,15876408,15729618,18192686,20554748,23351311,7903202,21712365,28066099,14720368,10330684,21958026,19733663,15659824,23216111,10867033,17065199,11305594,10923837,22266527,12818423,20455703,21273600,16054198,8878413,11368622,25165122,20028010,28985473,17490757,9137789,12881020,15937998,19073877,12224631,18492816,11739876,21693041,18550029,19996686,9491372,17593413,22864686,12153753,21787627,18669594,16814747,19818612,18570695,10811478,21854827,20821227,18980187,23871935,9443065,19556829,16557470,10523716,11052627,23541764,24260594,24325455,12628503,14691461,25144344,19079905,12670155,15686114,9625730,17640169,26100284,17052999,15456407,18280460,22949852,29963755,11880592,16506217,12530007,16777995,9042303,12946647,21910126,11518614,11431339,21615235,8970179,16399773,22075938,16469160,17369015,11577007,16619504,25385471,8212077,23524099,23645249,25493176,9704568,17948189,29051735,15833874,21097717,27026707,19326083,19590685,25272500,22700791,15068824,15033749,19289110,26853158,25749878,23665760,27609747,20980638,9010330,25844270,24284790,19592245,23661994,16118406,16122394,10956151,10368648,23019147,19035319,15281219,15131010,9607569,10989984,26179608,25661160,16985246,18258689,23189742,25996655,11694655,25190728,15077059,15070945,15570052,17651883,17516862,17644650,16873071,15841278,23095751,12840230,10566643,12189189,18503737,10384821,9167997,25592466,19339397,15880734,15113976,23882126,23678808,16513288,22767648,22583409,22339411,16515472,16515477,20668305,12204553,8886128",
  },
  {
    id: "5",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "281",
    pmids:
      "22418930,28280414,29237430,24223637,22310237,25839119,21857970,26483970,9367858,28207992,23061908,27814592,28834706,25446499,18628248,1879042,12224597,29497723,19017364,27285995,27198988,21042744,25298669,11562764,28814095,23570524,23731217,19293639,23900432,24299158,21965740,7923555,29355544,29905475,19755441,29023013,25186442,24506026,29214656,24929186,10704911,22023707,17077187,28498520,10359656,16462139,25630105,18930055,27393430,17108117,28504248,14644660,28752532,25983116,25596948,27833897,20493747,8201603,22426819,26491966,11052628,21598989,23441618,22447039,25612678,28462502,26974372,27175602,29635751,23317267,19617894,23000408,29069736,24407148,19731038,15836850,12724357,27641938,9381980,25968914,22289578,19294520,26434836,27068577,22627971,21090173,8162591,26748999,16789754,10601582,21104029,21419318,15039598,25581323,22838964,12769521,29353288,24978400,10470366,25984842,9066718,17137104,20804812,7887960,20798532,28808404,9920463,15182386,29698680,17482226,24950183,16619521,20803121,22083314,25849845,18074851,27058756,28337113,23153283,15332496,18958418,22842551,26415619,22459208,25364663,29097115,27041643,28336457,18655187,1279187,23023566,9042300,18955141,19921817,18497090,18404597,17172819,27224244,18607509,24174370,29844670,24958675,19466611,22721393,11522280,29874597,23767410,29019431,16180720,26341291,15533929,27392941,16596234,29434473,26941539,23664836,24693327,29855745,16968064,23442980,27041924,17555822,22445681,21429215,27725731,11502892,28322144,28742385,15254334,28539711,25906385,25331269,18655183,26328486,24573487,9343925,3386279,10376965,23434132,27607841,29150398,15829497,6091650,16114498,26344038,25454664,27234523,23919744,20886886,27232543,8875554,29076772,27318931,28799743,18828600,17851427,19323263,3482545,23767863,28188793,15041478,18456490,15090535,27943644,22300613,18192686,25411067,10861841,29475141,29185031,16054198,23339401,19576744,15937998,23556141,24098354,12224631,21693041,12910683,26600684,22481537,16097445,20447470,22119371,24060926,16544949,26214621,21400027,19250196,25278361,28649063,27980567,19007764,16777995,15796157,15112361,15047179,8970179,28178217,20814239,12206822,28881205,24813683,18454305,25569691,7903198,26922854,20600213,21535822,22700791,24607809,29217339,27609747,28930270,28122160,23661994,16118406,24679058,19909799,25098952,25940566,15281219,8509221,23569988,19528492,15925220,28778140,25701491,17651883,25050787,21371568,17693959,26909969,24959911,24657077,23564766,8313386,29752099,18024139,14980703,19826085",
  },
  {
    id: "6",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "179",
    pmids:
      "29751678,17539658,18059161,23646788,12377984,14608118,28911558,19420761,20537126,17786300,25833196,20008854,25260713,21370452,26783468,15657356,19017364,20149610,25242081,26810571,17902053,25550533,19105967,15706060,26022559,23731217,21170718,28349962,28465354,23600473,24329111,20527725,8350491,12931129,16982771,23348740,23447335,19171136,14767556,19189648,28646740,12960141,17575143,21792929,28927122,20596647,20446926,26733173,17483343,26861392,12925310,22272136,17940513,10509743,23411276,16354769,26107737,21411498,15965275,9719459,19674193,12429981,15367686,18061364,29742465,20078855,20155623,17570133,21300025,12421874,12163680,8826614,25437065,25243063,19744467,25888278,15816564,19020784,29040973,22459208,28693189,25013807,10462699,16720324,26310506,18813848,24044575,24481780,23163783,12168090,16449979,8538195,16707458,24965403,19399671,15756018,18371987,27231728,20946668,19544670,26341291,15533929,23664836,18089804,28839265,24772933,23475480,11500915,18719023,18815743,16404708,17487361,16519995,24847310,28872903,16495219,21295962,25663548,18025290,15620252,16945390,26225796,24039951,23638734,18098290,18813800,18671164,18978700,29157036,15585581,29955703,20045338,26156544,11830514,7585463,20664987,17909003,24915354,27234272,22280355,29787277,27539316,22307971,26077136,15648195,19962231,15457130,11962250,11673900,12925309,23322423,21545231,26855680,29504313,25372613,24283885,10518005,29214243,16317158,10202393,28713815,20973802,18797454,12067577,11928805,18454305,25569691,9600118,14612489,27478970,15068824,27609747,28930270,14600840,24749396,23657153,27262332,29436217,25592466",
  },
  {
    id: "7",
    id_polifenol: "2167",
    polifenol: "phenolic acid",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "206",
    pmids:
      "22868134,25619640,25933717,23939793,27492128,23958424,24849787,22407803,27288921,22536197,26504768,23476711,25447816,28522265,23403296,27410459,28329437,27760539,20170107,27495835,24078922,29249924,27468232,19082476,22070850,14979919,29197545,28807853,25933595,21328179,27078842,16142439,27942664,19815594,25539472,23712134,12718610,23722601,21213408,29303970,24996346,22382861,23950593,23435602,28179945,17486636,23140017,25554015,23317267,22350787,19731038,27168755,21877948,8164253,29451783,24453828,21455577,25862863,15878268,26748999,29337349,25762472,25886964,22369068,26841168,26578148,19530711,25312150,17147415,24752205,21639092,22083314,19606519,15816564,24024974,24289290,19094209,23153283,27348025,28480370,23746754,25364663,21861726,7887982,27651811,23023566,26542239,18813848,28250894,28292015,22219179,15134383,29179615,21167021,25562804,27365992,24885709,28053834,17992292,28222613,25560707,26941539,24693327,19888728,15787436,23442980,21429215,11867263,20510328,28322144,23684998,22102055,27034599,17949360,29870608,15223063,25331269,24506042,28920447,27412352,29884381,29366428,26469183,27685909,29530022,23265523,28363853,23123452,20238105,22628046,28131913,22596041,26703544,27234523,19838923,28496481,28036082,27262066,18828600,28930257,23767863,25005945,28330247,27904404,24191321,15652269,23146235,21812646,25576897,24273864,28105248,28695656,24969892,26056816,23339401,24711053,19655397,17728860,17972413,28345821,15563205,26600684,25694787,22481537,29864137,29959633,24863277,23818393,28541359,23994083,26009985,26075899,24328703,23790919,12547330,29504313,18645000,19865514,28316409,22016638,19007764,29706573,21592469,20729081,28178217,24591315,22888534,24818141,17511007,25004806,27573001,24802115,19468947,23266738,29638061,15878797,29142435,28122160,25098952,28029227,26437391,27153984,29710781,29304552,8313386,19212014",
  },
  {
    id: "8",
    id_polifenol: "49",
    polifenol: "Aspirin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "98",
    pmids:
      "18851958,29492489,29350433,16596229,22333315,26899462,26546721,23292806,25033546,20857911,25369051,21617849,14991771,15337432,29169419,17191809,26596838,22209867,10652584,18483385,26184135,28162289,20457246,24575839,19576865,21984018,19212664,28456486,26125438,20828891,18174252,16010362,23317278,29106390,22552812,29504069,26728433,21562729,23420392,26530254,21646387,26794215,18751381,22494617,29848978,11746823,24113271,27356773,16042578,12700412,25867761,29328467,17665043,16952320,12740651,29133038,22399590,21680800,28190074,12075734,29471853,29705335,29386221,25659932,15658875,21956205,27940576,25997576,28415819,24418973,24923427,27683033,9521170,29087320,18260128,15179621,16531064,16491398,14612489,29885857,24927467,22826466,28264838,24932579,29707148,18045204,18194278,28088656,18447943,26673874,29551451,11566043,24267729,16546864,27186121,22896036,4759939,25085874",
  },
  {
    id: "9",
    id_polifenol: "109",
    polifenol: "Catechin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "132",
    pmids:
      "17554207,17539658,26975752,12377984,18821062,14608118,28911558,19420761,20537126,17786300,28207992,23061908,22536197,26783468,27285995,28766690,26810571,15706060,23570524,26022559,27410459,20170107,28004224,28465354,27347927,17077187,19189648,28807853,20446926,17483343,26861392,25196850,12925310,22272136,26745094,23441618,16536624,21315392,12429981,18061364,21432719,19294520,17570133,15039598,29337349,25861148,23251702,12163680,8826614,9920463,17933449,29278988,21639092,19370870,24289290,28337113,23153283,16964399,23142797,10462699,26284809,27224244,18607509,21167021,12168090,16449979,11522280,19399671,17227049,16180720,24693327,23475480,28108382,23772110,15254334,24573487,15620252,12608775,27357542,23638734,28216880,18671164,18978700,2068000,18828600,28930257,17851427,23767863,15041478,20657380,19723063,7585463,10861841,24069935,28105248,24915354,26056816,23339401,19576744,27234272,22307971,15457130,22481537,11962250,28465816,21882252,14528600,16038899,21545231,29504313,25372613,29706573,10518005,22888534,28713815,11928805,26922854,21535822,24001127,28930270,22045026,28122160,8537983,14600840,15938138,28029227,19588362,15570052,17651883,25338140,17178382,12946404",
  },
  {
    id: "10",
    id_polifenol: "125",
    polifenol: "Isoflavones",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "229",
    pmids:
      "29552162,25613518,21389782,24355881,17962013,12792805,21132400,15358198,9664138,18492603,25287332,19013426,12588701,25675448,12572359,17295235,29095048,24977660,8891338,16613577,24573886,7736326,17046027,22227334,17992604,21493710,25826638,10639578,25663261,23022281,10961387,27473965,22037685,29197545,20169097,24331293,16094502,23342141,25613180,17640171,20669983,23587260,11739882,29368443,28644496,23686257,21284537,10996850,15930306,19617894,12963483,12416264,22087557,9848511,27574003,15914273,16789754,23379261,29204990,27313682,20036234,16773531,15182386,15492830,21462322,26783066,26147490,29523109,16061678,10755463,12115517,14511655,15105043,14628433,19634327,28666461,29101532,18497090,10443335,15135300,15754008,18632754,19928832,17659312,12908908,14618609,20574927,19358274,17024228,8824507,1883387,16966488,12793002,15223063,16870006,21295962,15579072,26006245,17786319,9696881,23568763,9492340,19800779,12549765,17761019,26339345,25395701,17639047,9848525,14992594,15705886,26754253,18815740,27227510,26573593,26703550,11850205,18192686,28066099,22968785,16516478,21958026,23216111,17065199,11305594,10923837,22266527,12818423,20455703,29656660,23274118,19116342,11368622,25165122,20028010,28985473,17490757,9137789,12881020,18492816,19996686,16814747,25593313,19818612,18570695,12199376,20821227,23871935,16557470,24325455,19079905,15686114,17640169,15123269,19250196,26432036,27043076,27456242,11880592,12530007,22464681,9042303,11431339,21615235,16399773,21547849,16469160,11577007,16619504,25961211,20592363,25493176,25553084,29051735,19326083,15068824,12095951,25749878,26086179,18936203,20980638,19003217,19079816,10956151,15938138,15131010,27823732,10989984,26179608,25661160,16080462,16985246,23189742,25996655,11694655,25190728,20460823,15077059,15570052,17516862,23919747,16873071,23095751,20880642,10566643,28777295,18503737,15072585,20235891,10384821,28110438,19339397,11795443,18554862,10625940,15113976,15267241,16513288,23992486,22583409,28112509,22339411,8313386,27584953,27161216,16424064,20668305,9168894,8886128",
  },
  {
    id: "11",
    id_polifenol: "110",
    polifenol: "Chalcones",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "150",
    pmids:
      "22223344,28335434,27814565,28390228,27580587,27819344,27903423,29852328,26500049,29575807,25061803,24844196,22700231,28554201,28852176,18702457,27923159,15986430,22721615,22634834,22536197,26742460,26615871,25707012,25313981,26922065,28522265,28554313,27707625,22177409,26874744,15642415,26859847,21115246,26141760,27358555,27744186,10418944,22503741,29335212,26602275,22386368,16307839,26435001,27017265,28860494,28442256,23861918,20605470,17643984,17530176,28177228,28011424,28494257,25353380,25834398,16434201,17850837,25743216,18598762,24494068,27224920,28258796,23533528,22948604,21170936,29926299,26134484,10953339,28627468,29207336,29630947,28849241,25201534,25466202,22440895,29065840,29335206,23291120,11052628,26643017,21816519,29740713,25323033,28971779,20058253,29573910,29332599,22172099,23562496,20637611,22112540,26994844,28160848,28346873,25499988,24372527,23895019,26179368,23263805,29518053,23501110,17964170,23524161,15848217,22240736,28979310,26863879,21984014,24611893,23691159,26690274,24675137,15202555,29715541,22335538,25276196,21728961,19714673,27777009,16516478,17804245,15863696,29656660,26651537,22239485,23711834,18602831,28292025,26845133,16833018,22076705,21872616,19275612,20729081,28344479,20739102,20696501,25461309,12825923,28372908,21053158,29035298,24879482,28778140,11213444,23874474,28371315,28323527,25226568",
  },
  {
    id: "12",
    id_polifenol: "3089",
    polifenol: "1,1-diphenyl-2-picrylhydrazyl",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "178",
    pmids:
      "23939793,25446237,25213932,27492128,24189312,12417027,29215574,22196508,21772753,25916942,17294687,27410459,28458366,28946185,27760539,22210035,29755561,21232161,29086902,21899551,29249924,27468232,22070850,24658418,22655458,28803257,27148169,25539472,27833897,23712134,23434138,21213408,22382861,27656608,23435602,24649909,28179945,16536624,18720191,25554015,23317267,16029005,19731038,24125835,21877948,22289578,15878268,20548938,27649745,23173924,28583007,25861148,21161823,26578148,29383946,25753739,23892206,25312150,22115493,25887035,22083314,27343853,24024974,24289290,29337321,28337113,23153283,28376770,27348025,24681549,23134323,21861726,21953995,27049956,29956560,24223502,27224244,16528448,24389510,29179615,23841520,24885709,22334062,29382154,28282602,26941539,24693327,29855745,19888728,21429215,26742030,28322144,26559860,20585163,23684998,25906385,21894086,23519250,27034599,29870608,25331269,17474862,29884381,29366428,26373394,27039735,29530022,23493479,27928516,20429956,20850160,28704964,26320438,28216880,27234523,28496481,26320439,20722898,26142508,28074101,17851427,27793897,23767863,25005945,28330247,28008248,28477101,24191321,26320443,27399668,28105248,25954912,20120114,23339401,29753866,19576744,24641353,28345821,29196839,26600684,25694787,22481537,26113217,26449529,29476965,24863277,27879655,28124843,23818393,24328703,19865514,28649063,26939078,29706573,21766451,27601844,28287477,29887909,28933383,19468947,26773895,21535822,29638061,16562825,27231890,29142435,12428954,23569988,27153984,19099226,25050787,29710781,24959911,26265569,21476932,20361301,25226568,22908592",
  },
  {
    id: "13",
    id_polifenol: "114",
    polifenol: "Apigenin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "101",
    pmids:
      "29658601,16579729,26483970,26675309,10319943,28366842,14602723,29215574,22527937,18645020,11299771,25327419,27198988,25936427,16702307,19885610,22634262,24922650,26500281,24048283,11588896,19031366,20681660,18069627,21899551,18300387,28656316,24081687,23973682,16357145,22086925,23592903,17132221,14644660,27137679,18656338,16556064,27378243,15703835,19430615,25299247,19666078,15620704,29736565,20686818,15110097,26872304,21419318,22369068,16541309,17961621,17482226,29541820,18239283,27348025,25473363,29097115,22209285,10801845,22870126,18813848,25560707,19288491,15533929,17437270,9622547,9770719,21912610,23519250,9492340,27123037,19576743,22569706,19020811,28396216,27232543,9343831,25019465,28441391,26594904,29593542,23146235,17154505,10923837,18596662,21505181,18201740,9625730,28649063,22732304,23238254,20551847,21846263,2749004,29217339,26853158,22272829,16118406,10989984,23189742,26437391",
  },
  {
    id: "14",
    id_polifenol: "113",
    polifenol: "Flavones",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "113",
    pmids:
      "25680459,26974371,24122885,27814565,26935193,29552226,23707765,26675309,29215574,18454852,20674374,18628248,29039514,26528965,25686495,25543165,23994263,25190466,17046027,25947916,15878357,29734739,24937184,17363486,17077187,22086925,23592903,24634851,29667279,28294989,11739882,15316567,7840652,17404058,19666078,15930306,10953303,24525192,29869169,20804741,17418982,16789754,10656453,29116937,27400887,22369068,9673352,9809990,22768128,29383946,15182386,27503682,18074851,28480370,25473363,29097115,8866830,1279187,22870126,28464771,9815832,10443335,29179615,27890807,21351299,25560707,10741717,16371244,11850210,15254334,12793002,28839377,9696881,28800661,9492340,21599001,15202555,21741436,19020811,28282562,29955703,25019465,11850205,20454639,15041478,11720850,21728961,19714673,28066099,16516478,10529006,10923837,23274118,24098354,12224631,17261771,16097445,26845133,11262078,18506592,27601844,20551847,15165133,22137340,17948189,2749004,23859042,19528492,28784534,23189742,21366040,1812215,15267241",
  },
  {
    id: "15",
    id_polifenol: "38",
    polifenol: "Gallic Acid",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "107",
    pmids:
      "27087131,26659548,25933717,29864945,27492128,29043662,28938245,28207992,27634460,22316502,28835347,22196508,12127233,27410459,23731217,24864015,23017432,27495835,27347927,26794080,22070850,24099118,26194618,28807853,18930055,25933595,27148169,27833897,23712134,21213408,26047480,22272136,26745094,23441618,23317267,27226907,19731038,27951515,22289578,22627971,25862863,25861148,28808404,22503714,25312150,22115493,21639092,19606519,19370870,24024974,24289290,27348025,25364663,21861726,21953995,27049956,23023566,26284809,27365992,23841520,24885709,21420233,23767410,27231728,26941539,24693327,23442980,23684998,21299246,21894086,15223063,24506042,29393902,23459143,27685909,20429956,22628046,27234523,18586491,28930257,23767863,15652269,21812646,28105248,23339401,29753866,26600684,22481537,28124843,20955699,22016638,29706573,29214243,24802115,27401212,19468947,21535822,29217339,28930270,29142435,28122160,25098952,28029227,24737969,28784534,21570304,29304552",
  },
  {
    id: "16",
    id_polifenol: "117",
    polifenol: "Luteolin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "83",
    pmids:
      "26915319,22926442,29579978,24494074,21792893,16579729,26675309,25272060,10319943,22073986,20811693,22799344,18628248,23994263,12127233,22938042,17294687,25947916,24354186,27707626,20681660,18946510,14644660,25851346,26545287,27378243,23441618,16029005,24525192,24129732,22838964,22369068,25984842,23593654,27959422,26672742,18503759,23065001,19424633,25933972,26828287,27348025,25473363,29097115,26011941,19921817,18813848,28096694,23229294,21351299,24455713,25560707,15533929,26312209,9770719,29928143,28539711,27034599,3386279,20175233,19576743,15202555,21741436,27234523,9343831,15041478,25040994,8049151,29593542,23146235,23790951,26056816,25138022,24098354,12224631,23333558,17064676,16097445,18976853,28552787,16488130,10989984,26437391",
  },
  {
    id: "17",
    id_polifenol: "1",
    polifenol: "Phenols",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "127",
    pmids:
      "21167897,10926802,29745344,23570524,25410727,27113311,24019118,29386969,27468232,19082476,24658418,3815334,24339417,19879930,22814414,29201203,28214590,1311630,29415413,29451783,24453828,21455577,21843795,25886964,24341783,17933449,8271528,25312150,22115493,1955187,22221539,23455189,27651811,19634327,26369539,18813848,22329816,11097223,8603401,14703490,3288331,20949584,24885709,17992292,28222613,11074306,11879974,23193056,8940394,25005983,12880557,3378212,1340210,22789709,2138919,21664138,28258688,22102055,17949360,29870608,27643560,20170382,26516945,9836614,16509576,3458212,9459194,2441761,22628046,12731275,28496481,15135645,24913037,28330247,22531466,19053086,28844931,21812646,2298502,21314204,15862958,7532580,8054267,29753866,27976818,25189525,22254082,2632259,2636025,27155809,2390543,1954908,22481537,25239551,19194970,21121684,29452350,24863277,9928667,3695475,2736207,27406627,12870885,1995907,25882581,12190913,12206822,29887909,15942997,3593365,16741967,16517757,25272500,23032559,20949224,3436356,3607768,29142435,17022106,11170649,17705462,26437391,20668399,17235438,20361301,15720121,9168894",
  },
  {
    id: "18",
    id_polifenol: "105",
    polifenol: "Anthocyanins",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "61",
    pmids:
      "21058201,18623129,26649302,25000305,23869191,29587684,28356020,22536197,29039492,23333825,20132040,25916942,22312562,20170107,15680311,20681660,29086902,29249924,26069256,23199305,27388461,25070704,24996346,12925310,12094617,16277432,24214832,15039598,29337349,25762472,19530711,21034468,17147415,26509161,20564502,28761624,26395027,25124601,23828497,23265523,26985659,27234523,19166352,25420792,20121190,24312561,17851427,23767863,27904404,17651059,28105248,23339401,27655695,19576744,15563205,16139847,28541359,27165855,28287477,21535822,15878797",
  },
  {
    id: "19",
    id_polifenol: "7235",
    polifenol: "silybin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "56",
    pmids:
      "26767948,18635919,24472723,17214970,25891311,19715751,28027688,28509572,22820499,23353996,24716145,22110198,28843263,29755557,19181503,27867187,20554189,28610415,25175149,28321778,27066095,9081370,23886126,29920623,26117209,25773855,14719089,28440514,27268647,24377502,19968587,27402681,24574320,26984157,19509268,22526491,17332330,28223550,25172795,21847388,25603020,25317410,22101790,23878789,24611152,29515635,27133295,25901160,21166494,16597642,29187434,23830941,28791405,20370556,27644625,28713159",
  },
  {
    id: "20",
    id_polifenol: "129",
    polifenol: "Rotenone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "60",
    pmids:
      "20645919,19777565,15485993,18224451,20077420,24252341,27288921,23245650,21785662,25034000,10340389,9831541,19091749,9631496,18761399,12879015,9849427,11929863,10427135,21284537,15897899,24952350,24586439,9520374,15796199,26199568,16773531,10755463,9834970,10951577,12800192,23547759,12840226,23922721,26006245,9492340,7833143,24354192,20535833,9343831,22428931,29080556,10490244,25682864,15561720,29964355,22878391,22016638,2749004,19079816,16410252,24375813,2614425,20460823,15077059,28110438,15113976,10985090,12204553,8886128",
  },
  {
    id: "21",
    id_polifenol: "121",
    polifenol: "Kaempferols",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "78",
    pmids:
      "25839119,10319943,28834706,27198988,25453494,29310425,16702307,29739490,20846786,14603522,20681660,24081687,29214656,26878784,18946510,10359656,27393430,14644660,29042792,26047480,23441618,26974372,19617894,19731038,15110097,26434836,10601582,27745695,20548938,22838964,17961621,15796199,28852738,27902959,15182386,29339084,24289290,28337113,19356725,29097115,23023566,20016737,15533929,28539711,22906240,27234523,25719685,9343831,18443432,15041478,8049151,26594904,22300613,15095143,28105248,10923837,24711053,24098354,25574182,9625730,15796157,8970179,28178217,7903198,26922854,22700791,22272829,25053822,25844270,16118406,24679058,16756079,19909799,17335117,26437391,12058323,26909969,8313386",
  },
  {
    id: "22",
    id_polifenol: "871",
    polifenol: "ABT-737",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "31",
    pmids:
      "25375379,25592064,26870201,29760958,23341456,25350317,22340096,29733883,21887277,22703841,22179721,22689920,25215949,21368833,20876285,23259599,27217294,22433870,18829556,28187446,26910119,22162984,25409124,22895112,26015514,23557083,22464442,21768359,21664043,23861345,23845444",
  },
  {
    id: "23",
    id_polifenol: "6451",
    polifenol: "daidzein",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "120",
    pmids:
      "19889614,24724627,19013426,12588701,29095048,18541420,17681752,25826638,10639578,12066207,29954123,9631496,14644660,16094502,20669983,29496164,28644496,23686257,16506809,24014377,19617894,12416264,9848511,10601582,15876409,29204990,12421874,16773531,16491457,15492830,24487643,23675643,17719612,15105043,28720470,29101532,18497090,23337939,17266178,12908908,20574927,16912569,23227466,1883387,16870006,11566575,23568763,19800779,16898868,16899133,28396216,14992594,15036763,11509969,27227510,26573593,20127002,15876408,18192686,23216111,10923837,20455703,26499209,28985473,12881020,12224631,18492816,22217331,16814747,25593313,19818612,12199376,20821227,10523716,22878391,12670155,9625730,17640169,15123269,22054259,26432036,22016638,16506217,9042303,18322075,15047179,21615235,16399773,16469160,9704568,29051735,9616286,22700791,18310284,25749878,23665760,16118406,16122394,10956151,26179608,25661160,25996655,11694655,25190728,20460823,15070945,17644650,23095751,10566643,25592466,23882126,16513288,22583409,22339411,8313386,16515477,20668305,12204553,9168894,8886128",
  },
  {
    id: "24",
    id_polifenol: "6065",
    polifenol: "baicalein",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "46",
    pmids:
      "24318305,18630529,25672442,26154615,19960010,29215574,29693272,12200139,21817116,12224597,26756423,25686495,25543165,20580866,19031366,25130856,27735841,18087590,14644660,29667279,22384268,24026776,26136875,19666078,16638750,20398386,27143851,23093227,9066718,15182386,27503682,28789417,21618589,25874959,27596118,10443335,19836937,28448441,19576743,28060756,8875554,28008161,26853158,22272829,19528492,18385448",
  },
  {
    id: "25",
    id_polifenol: "7",
    polifenol: "Capsaicin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "35",
    pmids:
      "18818525,19855437,22226932,27055401,15706060,23238560,21240831,16260002,19212624,24941670,27180305,28640864,21300690,12718610,19723084,25894379,28008282,26384954,27663071,28435977,26525975,22459208,16583263,25283529,24889371,12570018,25382686,25736062,23510405,25548580,29100335,25569691,18499282,26734584,28598691",
  },
  {
    id: "26",
    id_polifenol: "4634",
    polifenol: "alvocidib",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "50",
    pmids:
      "29422957,29039550,20638287,12517802,12517783,20855960,10995888,12479366,26924736,27372186,15756030,23908594,10656453,18065490,16951203,15640956,28560460,23839043,14767524,11556844,21885916,15770523,1279187,9815832,27208856,26013319,10741717,17187253,12138401,17123821,10430095,15868376,12769778,12432259,25876993,10493518,10788588,14576842,12839951,21898150,11102317,11052627,11956082,24858691,22948151,28438180,27087139,23636943,25351763,26053278",
  },
  {
    id: "27",
    id_polifenol: "120",
    polifenol: "Flavonols",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "45",
    pmids:
      "26297979,29237430,22785466,25088800,25190466,23570524,29029040,22210035,19755441,24081687,22014228,10359656,22382861,15930306,19617894,24125835,29652200,15182386,17147415,25887035,23679992,28480370,29097115,10443335,24885709,22742959,9492340,19020811,20886886,17851427,28330247,16516478,25189525,27267829,15563205,16097445,27980567,15796157,28178217,7903198,8537983,24679058,24879482,15730249,12946404",
  },
  {
    id: "28",
    id_polifenol: "4522",
    polifenol: "chrysin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "53",
    pmids:
      "24765191,24122885,20645919,24007917,25839119,10319943,26670842,23425937,16702307,28398698,19031366,21899551,23973682,17077187,27470413,22086925,14644660,27137679,28610415,18560226,27761071,23969634,20479999,19666078,29116937,20878083,15796199,29383946,25358452,17482226,29693804,27151585,23134323,27847208,9770719,15254334,25906385,27123037,19576743,25719685,15608138,15102949,17093006,24098354,12224631,26148177,18201740,23868912,17948189,16972788,25987033,21366040,29560796",
  },
  {
    id: "29",
    id_polifenol: "123",
    polifenol: "Rutin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "47",
    pmids:
      "27814592,18628248,27198988,17294687,16702307,28004224,7923555,22070850,18946510,28752532,27942664,27833897,26934120,29204075,16698256,24289290,23679992,18404597,24455713,20578533,28282602,24693327,23442980,29083228,26742030,23659170,28539711,29899696,10781887,20886886,28930257,24711053,29476965,28552787,28649063,22016638,28408800,29706573,22888534,29638061,28122160,19909799,28029227,26437391,15925220,20460823,17178382",
  },
  {
    id: "30",
    id_polifenol: "6062",
    polifenol: "naringenin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "48",
    pmids:
      "26483970,25192075,15744083,11530281,14644660,25957189,19067124,27449398,15039598,29968480,22369068,17961621,9066718,29450133,28370954,9781306,27036297,17482226,22692793,15111768,18074851,24881818,26074733,27348025,22524801,22209285,7503800,16114498,8875554,26226761,29534519,19439809,19733663,21748601,12224631,29766645,18201740,25574182,24260594,9625730,20234972,22935222,24813683,16118406,10989984,16163823,17651883,14980703",
  },
  {
    id: "31",
    id_polifenol: "285",
    polifenol: "bisphenol A",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "113",
    pmids:
      "18252963,28426875,22307313,20875696,29383186,29310425,28844962,23810794,21909620,29330934,25663935,11530281,10614622,24831732,25130739,29758456,10652244,10937835,27551335,27279583,21771643,15110097,26363213,14754635,23373633,28964603,27880919,22692793,22552965,20549624,28244015,27038254,15223131,11867264,29093337,19492024,11693576,14703490,24349450,18544561,11823001,12880557,12628303,12818366,23222814,18635651,29743443,26914403,16029874,22258036,12731275,15635150,15036763,26363202,27182052,17213647,14709801,22531466,12753421,11465389,22132214,11485868,11391616,19270784,28808208,12224631,28735473,28982275,28591870,16328721,27386435,18980187,16931338,23056216,20071456,12429138,12547330,19796866,18280460,22949852,10944450,24156707,17268063,11518614,24496634,17369015,23524099,12206822,11335189,26241069,25411358,27026707,26911702,25096985,19590685,12966991,27740625,9010330,24284790,24533973,25192815,23019147,12737316,19933552,10767642,23391485,17651883,16624408,28703301,9347895,18381411,11732758,26877094",
  },
  {
    id: "32",
    id_polifenol: "39",
    polifenol: "Hydrolyzable Tannins",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "42",
    pmids:
      "23939793,24035960,22387705,22536197,15670892,21232161,15525446,26194618,27656608,27852125,25554015,19731038,25312150,17147415,27253407,27491891,27651811,28292015,21319227,29179615,18435908,28825571,24885709,19888728,20510328,22186328,20170382,20429956,23767863,23339401,25189525,19576744,11277742,27267829,26694338,23818393,24268240,28891568,29706573,24818141,21535822,27153984",
  },
  {
    id: "33",
    id_polifenol: "130",
    polifenol: "Proanthocyanidins",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "22",
    pmids:
      "23093841,15251181,29030256,15525446,29086902,26401377,16597645,10448908,25735761,17147415,28689063,25684483,28216880,20121190,28930257,24969892,20146248,28122160,28029227,15570052,17178382,12946404",
  },
  {
    id: "34",
    id_polifenol: "35",
    polifenol: "Hydroquinones",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "35",
    pmids:
      "16756956,15706060,17000671,14718602,15571862,17077187,24682466,12570375,22753749,17964791,24064738,29562668,7887982,10681517,22565593,15658878,16267026,21912610,9161806,7541730,15025504,9433910,16825487,22776180,16712525,23093860,28578385,15867391,20877240,24564733,24939096,26114310,16854066,24778711,21941890",
  },
  {
    id: "35",
    id_polifenol: "111",
    polifenol: "Flavanones",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "36",
    pmids:
      "24324069,20043141,23174316,25216378,25192075,28554313,26141760,10418944,28398698,29264766,28286420,25201534,15930306,15752472,22369068,29450133,24843190,22692793,26074733,23895019,15797607,25204891,10443335,19928832,21351299,24608571,15305306,9492340,15202555,16545824,11720850,11934235,24582402,18042388,29385698,15267241",
  },
  {
    id: "36",
    id_polifenol: "4502",
    polifenol: "fisetin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "19",
    pmids:
      "28834706,18628248,26101063,29749427,26755433,21922137,28156161,28004315,19606519,18239283,23030699,10443335,18835421,16114498,8049151,29334247,24098354,16314891,26853158",
  },
  {
    id: "37",
    id_polifenol: "6",
    polifenol: "Catechols",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "68",
    pmids:
      "27034692,21642937,20170107,12869569,28041801,19275619,26134484,26961313,20584749,24523750,23437041,24453828,19604582,29964299,17502145,20805034,7887982,18497090,25964542,15501614,17584965,15499624,1963166,15254334,19840838,19839584,16081510,28975790,21665890,21751810,17969215,6284766,20540524,22596041,15135645,8654195,23408432,18192686,8593862,15720130,21777512,10813650,11368557,7982241,9219504,22129592,10649967,27155809,26147830,29058874,12870885,26939078,10696569,11606384,19628038,29757607,18052105,12755597,22140478,15089093,19158089,29792433,11743747,8828921,25496358,6337293,20509668,28905618",
  },
  {
    id: "38",
    id_polifenol: "25",
    polifenol: "Butylated Hydroxytoluene",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "11",
    pmids:
      "16041836,29755561,22655458,27148169,24962691,25059572,23442980,27250582,29460325,27829607,26997648",
  },
  {
    id: "39",
    id_polifenol: "75",
    polifenol: "Butylated Hydroxyanisole",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "14",
    pmids:
      "12809360,25380641,23173924,23861102,24291459,12822488,28477101,3346910,23697596,23027624,29460325,26384289,19526586,2182121",
  },
  {
    id: "40",
    id_polifenol: "15",
    polifenol: "Masoprocol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "26",
    pmids:
      "17562544,18418215,23053656,18087590,16142439,9849427,17486636,16638750,20398386,16544145,7491298,17502145,2224849,16000313,9066651,8750525,1596879,10490244,9088929,17103063,26247680,12110314,18645000,7854776,26853158,8313386",
  },
  {
    id: "41",
    id_polifenol: "6087",
    polifenol: "wogonin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "23",
    pmids:
      "25945460,21448585,24858369,23707765,22182776,17957784,26638893,19031366,21295103,22086925,26905263,24026776,22513472,28774312,24666416,25203554,25039187,25956732,20872277,19836937,19576743,22593043,29689288",
  },
  {
    id: "42",
    id_polifenol: "4519",
    polifenol: "myricetin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "25",
    pmids:
      "29579978,27122002,27031849,28834706,29532526,23570524,18946510,14644660,23441618,19731038,29742465,22838964,9920463,10443335,23767410,24693327,19020811,27234523,25719685,16216908,19323263,28105248,22016638,28178217,27249025",
  },
  {
    id: "43",
    id_polifenol: "4515",
    polifenol: "baicalin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "13",
    pmids:
      "27576521,19960010,25686495,19031366,11746275,23387975,24026776,19031258,29039569,15586243,19836937,16437251,26158280",
  },
  {
    id: "44",
    id_polifenol: "4500",
    polifenol: "procyanidin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "14",
    pmids:
      "29043662,24099118,16740737,15827326,16536624,19530711,25735761,27178635,12608775,25005945,10914742,23626391,14679019,29504313",
  },
  {
    id: "45",
    id_polifenol: "5608",
    polifenol: "epicatechin gallate",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "16",
    pmids:
      "29043662,28911558,28807853,12925310,8826614,16449979,19399671,15620252,7585463,24915354,22307971,15457130,26855680,29504313,10518005,14600840",
  },
  {
    id: "46",
    id_polifenol: "1356",
    polifenol: "gingerol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "14",
    pmids:
      "25619640,28315687,24962868,25686711,26554741,17683926,23448448,29069785,22858304,28112417,27399668,25004806,29393873,26853158",
  },
  {
    id: "47",
    id_polifenol: "54",
    polifenol: "Salicylic Acid",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "15",
    pmids:
      "18851958,24652595,29350433,27393430,22530891,22313179,26990649,11850210,29541369,29133038,21681549,17103063,25997576,29959633,18045204",
  },
  {
    id: "48",
    id_polifenol: "98",
    polifenol: "Propofol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "14",
    pmids:
      "28035403,29103019,21749860,25502773,16168109,26666272,22264881,27687660,29805673,25009196,26383520,24596379,12139540,29415668",
  },
  {
    id: "49",
    id_polifenol: "5607",
    polifenol: "gallocatechol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "26",
    pmids:
      "28911558,19420761,12462380,23570524,26794080,28807853,26861392,25196850,12925310,22272136,20058253,15796199,8826614,19370870,27348025,23457597,16449979,19399671,28872903,10475615,24915354,15457130,10518005,18797454,27609747,14600840",
  },
  {
    id: "50",
    id_polifenol: "5578",
    polifenol: "alpha-naphthoflavone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "37",
    pmids:
      "22837390,25781201,8390116,9015389,18059023,16569260,10620335,8658525,21205633,10478842,25796439,15253042,1536570,11016648,23576571,29332599,22485252,28103884,8806706,10936078,12791542,10619402,14994278,15608138,29955703,19406931,15863696,10529006,12396873,12118336,11191113,10506754,26715507,16387742,16488130,6265068,8204106",
  },
  {
    id: "51",
    id_polifenol: "44",
    polifenol: "Salicylates",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "6",
    pmids: "28415735,17343335,16596229,17309179,10652584,12700412",
  },
  {
    id: "52",
    id_polifenol: "4559",
    polifenol: "theaflavin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "13",
    pmids:
      "17182072,18454316,19812686,19969555,12931129,15341993,17227049,19544670,19883646,16404708,14528600,12067577,11928805",
  },
  {
    id: "53",
    id_polifenol: "5808",
    polifenol: "isoliquiritigenin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "21",
    pmids:
      "23747687,25094029,19065667,25026296,20033868,23861918,25194164,23327692,26134484,25365296,23401151,28827662,25918249,27097427,26734591,26690274,12589938,21693041,28615942,27609747,23874474",
  },
  {
    id: "54",
    id_polifenol: "2344",
    polifenol: "methyl gallate",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "11",
    pmids:
      "26975752,25298669,28004224,12960141,28808404,25887035,27267829,28891568,18797454,25839702,28778140",
  },
  {
    id: "55",
    id_polifenol: "4708",
    polifenol: "xanthohumol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "26",
    pmids:
      "22223344,15986430,28036030,10418944,26842182,17643984,25483453,23503627,23246576,17126313,29422966,23434138,27269377,25771121,22172099,29138867,23562496,18348194,23836544,25044854,16019205,25719685,21997247,16144030,16608212,23874474",
  },
  {
    id: "56",
    id_polifenol: "47",
    polifenol: "Mesalamine",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "3",
    pmids: "29947013,26947606,22753737",
  },
  {
    id: "57",
    id_polifenol: "2284",
    polifenol: "rosmarinic acid",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "17",
    pmids:
      "29790547,25554015,18936204,25141946,26542239,20449663,28222613,23659170,19840838,20170382,20157877,26077136,25239551,26075899,23790919,26075250,29710781",
  },
  {
    id: "58",
    id_polifenol: "112",
    polifenol: "Hesperidin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "8",
    pmids:
      "25182442,19548283,22524801,28539711,23690228,22545420,26437391,29304552",
  },
  {
    id: "59",
    id_polifenol: "6455",
    polifenol: "nobiletin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "12",
    pmids:
      "24692711,17197076,29039514,29914089,28468300,22853317,28177754,25686711,29408579,22524801,23106482,28364779",
  },
  {
    id: "60",
    id_polifenol: "10",
    polifenol: "Estrogens, Catechol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "51",
    pmids:
      "6325410,22571807,17575138,18226522,12714703,17689241,12119004,15142886,10030690,15501614,17584965,17620201,15254334,17582757,12791542,11074351,21665890,9161806,11291067,9433910,18192686,21777512,10813650,24598415,22129592,17964424,14623547,12870885,15456407,18379081,12587805,12009861,11606384,16517757,19138946,20600213,15701888,19289110,18052105,12755597,22140478,15089093,16287077,8828921,19250200,18423413,9214609,8155821,11220654,20509668,28018158",
  },
  {
    id: "61",
    id_polifenol: "4513",
    polifenol: "galangin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "13",
    pmids:
      "29879712,29579978,12097276,16569260,28282786,14644660,9066718,27123037,22434356,8875554,15041478,24098354,7903198",
  },
  {
    id: "62",
    id_polifenol: "6063",
    polifenol: "naringin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "12",
    pmids:
      "23694763,15744083,16702307,12967197,24289290,22524801,29019431,24693327,23442980,8875554,22732304,26158280",
  },
  {
    id: "63",
    id_polifenol: "1380",
    polifenol: "shogaol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "16",
    pmids:
      "23612072,25619640,25621970,24962868,23899529,25686711,26355461,29462602,29464796,22224671,20718733,23417847,23435947,27399668,29393873,27609747",
  },
  {
    id: "64",
    id_polifenol: "2158",
    polifenol: "protocatechuic acid",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "13",
    pmids:
      "19601677,27492128,14979919,27393430,26047480,24752205,19606519,11097223,23737666,26009985,16562825,28122160,29304552",
  },
  {
    id: "65",
    id_polifenol: "5489",
    polifenol: "delphinidin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "13",
    pmids:
      "18623129,28364098,25000305,29587684,15680311,18499206,21792311,12925310,27221932,23346406,19166352,22300613,17651059",
  },
  {
    id: "66",
    id_polifenol: "6273",
    polifenol: "hesperetin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "19",
    pmids:
      "22438130,17927510,27262800,27449398,9066718,9781306,17719612,22524801,22209285,25204891,21741436,8875554,23042260,24394652,28364779,15047179,26502889,23238426,26239185",
  },
  {
    id: "67",
    id_polifenol: "1613",
    polifenol: "demethoxycurcumin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "15",
    pmids:
      "23777448,24757955,20438793,20661707,21629182,19818349,23448448,16928820,25964547,17137104,10969724,22204522,9714342,29719770,26113217",
  },
  {
    id: "68",
    id_polifenol: "93",
    polifenol: "Phloroglucinol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "11",
    pmids:
      "22796323,19393283,26826267,24986654,25476160,25456733,29288028,25843036,27412352,22464681,26812220",
  },
  {
    id: "69",
    id_polifenol: "6454",
    polifenol: "formononetin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "23",
    pmids:
      "24355881,22828872,24977660,25663261,21932171,17135037,29913427,9631496,22328166,25613180,26575424,15796199,16773531,29523109,19634327,29722068,8960061,20015441,570914,28105248,28985473,29577719,9704568",
  },
  {
    id: "70",
    id_polifenol: "81",
    polifenol: "Fenofibrate",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "7",
    pmids: "26621841,20868670,25073512,24529079,28393180,16525649,28733879",
  },
  {
    id: "71",
    id_polifenol: "7550",
    polifenol: "3-methylquercetin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "13",
    pmids:
      "22418930,29905475,26502751,26359917,26434836,22838964,28539711,24573487,26056816,23724057,28178217,15925220,26909969",
  },
  {
    id: "72",
    id_polifenol: "6461",
    polifenol: "acacetin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "14",
    pmids:
      "29626627,17846503,18454852,22438130,25203554,19666078,29332599,29676234,29408579,29097115,28539711,15202555,19020811,22732304",
  },
  {
    id: "73",
    id_polifenol: "4253",
    polifenol:
      "5-(2,4-dihydroxy-5-isopropylphenyl)-4-(4-morpholin-4-ylmethylphenyl)isoxazole-3-carboxylic acid ethylamide",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "12",
    pmids:
      "28108313,26112442,25854583,21882818,29396630,25027745,23395886,27846719,18430202,19324279,24280702,19632215",
  },
  {
    id: "74",
    id_polifenol: "1611",
    polifenol: "bis(4-hydroxycinnamoyl)methane",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "12",
    pmids:
      "23777448,24757955,27550987,20438793,20661707,23950593,16928820,17137104,10969724,9714342,26332341,26113217",
  },
  {
    id: "75",
    id_polifenol: "107",
    polifenol: "beta-Naphthoflavone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "14",
    pmids:
      "24163404,8964830,16596229,11016648,15371557,17011724,21912610,10619402,17875779,19470599,26845133,6265068,2182121,12714001",
  },
  {
    id: "76",
    id_polifenol: "119",
    polifenol: "Silymarin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "4",
    pmids: "12604704,25849845,11006131,26158280",
  },
  {
    id: "77",
    id_polifenol: "69",
    polifenol: "Phenolsulfonphthalein",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "49",
    pmids:
      "29745344,7621894,1763658,3689980,8271528,2737155,1826821,27401115,1836000,23549681,2824472,3331372,8393337,1643647,3378212,8049131,3199811,9350037,3458212,3166028,2706828,1606040,3275677,2295073,9831078,1728602,2590382,2696844,2298502,3304294,2224859,3289739,2632259,24719313,2636025,1622138,2139575,2390543,1954908,24403449,2785242,24652746,2783381,3593365,16741967,3436356,3607768,21422595,9886488",
  },
  {
    id: "78",
    id_polifenol: "126",
    polifenol: "Coumestrol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "37",
    pmids:
      "28986287,9679118,27913286,17681752,23768371,15876409,16491457,15105043,11867264,7892295,9770719,9492340,19800779,24894196,28396216,15036763,570914,9343831,11509969,8049151,15876408,28754571,12224631,16328721,10523716,19007764,16506217,11518614,27400858,18310284,23665760,9010330,16118406,19167446,20460823,17651883,17644650",
  },
  {
    id: "79",
    id_polifenol: "55",
    polifenol: "Sodium Salicylate",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "4",
    pmids: "11960340,20959117,28456486,26415823",
  },
  {
    id: "80",
    id_polifenol: "5806",
    polifenol: "butein",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "8",
    pmids:
      "22895548,20699088,20826149,21170936,24919544,19606519,15757513,15848217",
  },
  {
    id: "81",
    id_polifenol: "108",
    polifenol: "Biflavonoids",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "11",
    pmids:
      "27288921,29968167,17121913,24565962,29085516,22271084,24716136,26594904,12677529,26773895,19742425",
  },
  {
    id: "82",
    id_polifenol: "1558",
    polifenol: "capsazepine",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "8",
    pmids:
      "28849985,28795251,27055401,28640864,26525975,28458574,23510405,25548580",
  },
  {
    id: "83",
    id_polifenol: "5509",
    polifenol: "cyanidin 3-O-glucoside",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "14",
    pmids:
      "28356020,20170107,15680311,27347927,23199305,25070704,16277432,21034468,26985659,19166352,17851427,23767863,27655695,16139847",
  },
  {
    id: "84",
    id_polifenol: "969",
    polifenol: "3,4-dihydroxyphenacyl caffeate phenylpropanoid ester",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "6",
    pmids: "29174417,16198557,23892206,22334062,23049233,16562825",
  },
  {
    id: "85",
    id_polifenol: "5844",
    polifenol: "4-dimethylamino-3',4'-dimethoxychalcone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "15161716",
  },
  {
    id: "86",
    id_polifenol: "6463",
    polifenol: "puerarin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "6",
    pmids: "20077420,19013426,26795076,28558356,22878391,12670155",
  },
  {
    id: "87",
    id_polifenol: "5819",
    polifenol: "licochalcone A",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "9",
    pmids:
      "27903423,29399197,27017265,26134484,10953339,24944769,23401151,28498645,28248089",
  },
  {
    id: "88",
    id_polifenol: "94",
    polifenol: "Phloretin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "8",
    pmids:
      "25229655,20645919,19723092,14644660,12604704,17555594,28132882,9625730",
  },
  {
    id: "89",
    id_polifenol: "4560",
    polifenol: "icariin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "5",
    pmids: "16323292,25577511,24718680,23977023,25272500",
  },
  {
    id: "90",
    id_polifenol: "48",
    polifenol: "Anacardic Acids",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "12",
    pmids:
      "25818779,29795261,20197399,18537201,28886127,26990649,21562729,17876038,24648416,29383121,25326397,29649635",
  },
  {
    id: "91",
    id_polifenol: "5488",
    polifenol: "cyanidin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "7",
    pmids: "15680311,29086902,12925310,19166352,22300613,23339401,21535822",
  },
  {
    id: "92",
    id_polifenol: "4640",
    polifenol: "5,7-dihydroxy-6-methoxy-2-phenylchromen-4-one",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "8",
    pmids:
      "19100732,22245252,24637576,26905263,26741501,25902914,25855962,29571134",
  },
  {
    id: "93",
    id_polifenol: "4537",
    polifenol: "flavone acetic acid",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "3653209",
  },
  {
    id: "94",
    id_polifenol: "2773",
    polifenol: "farnesylthiosalicylic acid",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "12",
    pmids:
      "23425093,15957161,16317288,16103080,15459249,24706375,25593982,18637482,16113100,17616457,12790788,26992462",
  },
  {
    id: "95",
    id_polifenol: "80",
    polifenol: "Clofibrate",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "5",
    pmids: "23028936,26621841,12203367,22266374,26465636",
  },
  {
    id: "96",
    id_polifenol: "132",
    polifenol: "Equol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "27",
    pmids:
      "29095048,18973749,21434324,24564104,21479403,24014377,19427779,24487643,23675643,15105043,29101532,23227466,11566575,23568763,16898868,11305594,22217331,25593313,9625730,27323858,16399773,9616286,25749878,16118406,23095751,16513288,8313386",
  },
  {
    id: "97",
    id_polifenol: "1995",
    polifenol: "2-tert-butylhydroquinone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "6",
    pmids: "26154615,9122238,25172557,22593043,14502842,23032559",
  },
  {
    id: "98",
    id_polifenol: "1673",
    polifenol: "4-hydroxyestradiol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "30",
    pmids:
      "20093341,26981862,12376470,22571807,18226522,20090883,15142886,18497090,27438141,15499624,15254334,12791542,21665890,11291067,15135645,9433910,18192686,21314204,16213115,29290975,20067028,12587805,15126352,10696569,21170676,14630092,24607809,16287077,8828921,9214609",
  },
  {
    id: "99",
    id_polifenol: "7546",
    polifenol: "isoquercitrin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "12",
    pmids:
      "27393430,26934120,19530711,18074851,28539711,22906240,20886886,17851427,19694432,28649063,15925220,24657077",
  },
  {
    id: "100",
    id_polifenol: "6482",
    polifenol: "tangeretin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "13",
    pmids:
      "29626627,24938898,26569090,24573532,17197076,15110097,11675933,22524801,28276668,25151216,12083457,15757658,11056327",
  },
  {
    id: "101",
    id_polifenol: "89",
    polifenol: "Vanillic Acid",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "10",
    pmids:
      "28807853,15854801,25753739,24752205,18813848,27431771,11097223,18277603,15925220,21941890",
  },
  {
    id: "102",
    id_polifenol: "99",
    polifenol: "Pyrogallol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "8",
    pmids:
      "20170107,26416955,27951515,10571255,27491891,23442980,26090316,22016638",
  },
  {
    id: "103",
    id_polifenol: "452",
    polifenol: "acteoside",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "6",
    pmids: "16198557,22634262,22289578,25509294,18404597,23146235",
  },
  {
    id: "104",
    id_polifenol: "1644",
    polifenol: "Cur1 compound",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "9",
    pmids:
      "29065834,27913127,28972748,28866151,28408820,25623080,27244480,28254284,25963307",
  },
  {
    id: "105",
    id_polifenol: "100",
    polifenol: "Resorcinols",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "13",
    pmids:
      "29172085,21751842,24392814,24494068,25172420,20805034,24910342,28641528,25482429,17887663,23896275,16464590,15548050",
  },
  {
    id: "106",
    id_polifenol: "5614",
    polifenol: "catechin gallate",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "6",
    pmids: "26975752,12925310,24508804,12163680,19544670,14600840",
  },
  {
    id: "107",
    id_polifenol: "1866",
    polifenol: "4,6-dinitro-o-cresol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "6",
    pmids: "29137219,2820475,21665890,1933868,24883177,10064571",
  },
  {
    id: "108",
    id_polifenol: "4486",
    polifenol: "amentoflavone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "6",
    pmids: "26637885,23160679,22767439,28286104,19652385,29695559",
  },
  {
    id: "109",
    id_polifenol: "5850",
    polifenol: "cardamonin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "4",
    pmids: "27580587,26506421,25257174,23691159",
  },
  {
    id: "110",
    id_polifenol: "118",
    polifenol: "Flavonolignans",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "6",
    pmids: "22110198,27402681,23054487,21847388,19026551,20370556",
  },
  {
    id: "111",
    id_polifenol: "7541",
    polifenol: "taxifolin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "6",
    pmids: "15533929,29491628,21086652,15041478,26922854,22272829",
  },
  {
    id: "112",
    id_polifenol: "7544",
    polifenol: "quercitrin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "7",
    pmids: "18628248,29564971,25887035,28258038,28539711,22906240,28178217",
  },
  {
    id: "113",
    id_polifenol: "60",
    polifenol: "2,4-Dinitrophenol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "4",
    pmids: "17227049,26276275,27400479,6246118",
  },
  {
    id: "114",
    id_polifenol: "300",
    polifenol: "rhodioloside",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "4",
    pmids: "25814002,29901185,20541529,27262332",
  },
  {
    id: "115",
    id_polifenol: "7912",
    polifenol: "7,9,2',4'-tetrahydroxy-8-isopentenyl-5-methoxychalcone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "7",
    pmids: "27814565,15986430,28036030,23022281,27483224,20667741,10985090",
  },
  {
    id: "116",
    id_polifenol: "6465",
    polifenol: "genistin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "17",
    pmids:
      "29954123,19617894,15492830,14618609,1883387,16899133,24812910,18815740,11305594,20821227,12670155,27043076,11577007,15131010,16985246,23678808,12204553",
  },
  {
    id: "117",
    id_polifenol: "350",
    polifenol: "nonylphenol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "16",
    pmids:
      "11530281,23862621,27550319,10903615,25849766,12188624,18635651,15036763,10330684,8054267,10944450,17369015,20654409,28703301,12714001,15290790",
  },
  {
    id: "118",
    id_polifenol: "4767",
    polifenol: "flavan-3-ol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "8",
    pmids:
      "23570524,22272136,12967197,26284809,23772110,11720850,23343084,12946404",
  },
  {
    id: "119",
    id_polifenol: "2475",
    polifenol: "6-O-galloylglucose",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "5",
    pmids: "22387705,12925310,16449979,19888728,27401212",
  },
  {
    id: "120",
    id_polifenol: "92",
    polifenol: "Triclosan",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "14",
    pmids:
      "29310425,11935210,28844962,25937633,26878784,27902959,17992702,24684733,12654184,20653288,25192815,21935973,15358634,20932229",
  },
  {
    id: "121",
    id_polifenol: "6097",
    polifenol: "8-prenylnaringenin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "17",
    pmids:
      "17681752,17643984,24443427,19103290,25771121,22172099,11675933,23836544,25044854,16019205,15876408,19733663,21997247,18201740,23541764,16608212,23874474",
  },
  {
    id: "122",
    id_polifenol: "2447",
    polifenol: "beta-penta-O-galloyl-glucose",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "9",
    pmids:
      "23731217,21598989,24508804,25358452,25918543,21319227,21289371,20809980,21614488",
  },
  {
    id: "123",
    id_polifenol: "6068",
    polifenol: "pinocembrin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "3",
    pmids: "21899551,15305306,27123037",
  },
  {
    id: "124",
    id_polifenol: "1996",
    polifenol: "2,5-di-tert-butylhydroquinone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "26717916,16712525",
  },
  {
    id: "125",
    id_polifenol: "5071",
    polifenol: "icaritin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "8",
    pmids:
      "21376032,16323292,26079090,25577511,28529129,24718680,23977023,22345291",
  },
  {
    id: "126",
    id_polifenol: "6576",
    polifenol: "5,7,4'-trihydroxyflavone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "3",
    pmids: "23592903,26872304,2749004",
  },
  {
    id: "127",
    id_polifenol: "4585",
    polifenol: "baohuoside I",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "3",
    pmids: "22785466,25407882,26293804",
  },
  {
    id: "128",
    id_polifenol: "6625",
    polifenol: "phenoxodiol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "28408225,26432036",
  },
  {
    id: "129",
    id_polifenol: "6086",
    polifenol: "liquiritigenin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "8",
    pmids:
      "23153457,26134484,25420519,28003019,28396216,23874474,18177995,23882126",
  },
  {
    id: "130",
    id_polifenol: "1616",
    polifenol: "tetrahydrocurcumin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "5",
    pmids: "29094265,26899573,16960658,24593988,29719770",
  },
  {
    id: "131",
    id_polifenol: "59",
    polifenol: "Dinitrophenols",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "2551660,1358431",
  },
  {
    id: "132",
    id_polifenol: "4516",
    polifenol: "diosmetin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "9",
    pmids:
      "17294687,9661887,19424633,25560707,18835421,10923837,18596662,12118336,18976853",
  },
  {
    id: "133",
    id_polifenol: "102",
    polifenol: "Zearalenone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "20",
    pmids:
      "16266544,9679118,11241756,16216639,27311894,15157572,9168007,12112322,7892295,1387742,28396216,570914,15994033,21683775,28965971,19730705,12946647,19555691,22145580,16120254",
  },
  {
    id: "134",
    id_polifenol: "7161",
    polifenol: "scutellarin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "6",
    pmids: "28458133,21899551,29389889,15586243,19836937,29079722",
  },
  {
    id: "135",
    id_polifenol: "2328",
    polifenol: "syringic acid",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "6",
    pmids: "23958424,14979919,23442980,25098952,15925220,21941890",
  },
  {
    id: "136",
    id_polifenol: "7296",
    polifenol: "dihydromyricetin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "28681913",
  },
  {
    id: "137",
    id_polifenol: "40",
    polifenol: "Propyl Gallate",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "20494511,29460325",
  },
  {
    id: "138",
    id_polifenol: "36",
    polifenol: "Hydroxybenzoates",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "16",
    pmids:
      "27393430,12518336,24752205,26854920,12210538,16021681,29382154,24481588,22917524,23049233,28330247,25576897,23994083,24652746,22744862,23364952",
  },
  {
    id: "139",
    id_polifenol: "7134",
    polifenol: "vitexin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "5",
    pmids: "22941432,21432719,29179615,25656679,27601844",
  },
  {
    id: "140",
    id_polifenol: "6558",
    polifenol: "7,3'-dihydroxy-4'-methoxyisoflavone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "10",
    pmids:
      "25613518,24618835,24355881,29241196,29096683,29966979,23609007,29523109,21799188,21612861",
  },
  {
    id: "141",
    id_polifenol: "4796",
    polifenol: "aminoflavone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "18",
    pmids:
      "18059023,24885022,15210858,22485252,16096788,26996297,20012292,22677031,24058584,8784443,8866830,15958581,17018623,24615985,20454639,22295239,27267625,28845963",
  },
  {
    id: "142",
    id_polifenol: "4525",
    polifenol: "eupatilin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "16393119,20804741",
  },
  {
    id: "143",
    id_polifenol: "5455",
    polifenol: "theaflavin-3,3'-digallate",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "12931129",
  },
  {
    id: "144",
    id_polifenol: "2490",
    polifenol: "punicalagin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "3",
    pmids: "20510328,25624761,23493479",
  },
  {
    id: "145",
    id_polifenol: "5815",
    polifenol: "dibenzoylmethane",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "7",
    pmids: "25650742,21924245,17077187,18782044,10814878,9667742,13678246",
  },
  {
    id: "146",
    id_polifenol: "5630",
    polifenol: "polyphenon E",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "18821062,17484049",
  },
  {
    id: "147",
    id_polifenol: "7547",
    polifenol: "hyperoside",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "26437391",
  },
  {
    id: "148",
    id_polifenol: "349",
    polifenol: "4-nitrophenol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "5",
    pmids: "22593037,25271812,12206822,16517757,25741889",
  },
  {
    id: "149",
    id_polifenol: "5495",
    polifenol: "malvidin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "4",
    pmids: "15680311,12925310,19166352,27165855",
  },
  {
    id: "150",
    id_polifenol: "7141",
    polifenol: "apigetrin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "7",
    pmids: "21899551,25473363,28222613,18596662,28649063,21846263,16206043",
  },
  {
    id: "151",
    id_polifenol: "637",
    polifenol: "glabridin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "8",
    pmids:
      "25980823,28522265,28464803,20626003,24754877,11059763,27539316,26594762",
  },
  {
    id: "152",
    id_polifenol: "6301",
    polifenol: "3-methoxyflavone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "3",
    pmids: "18544561,16415123,15757658",
  },
  {
    id: "153",
    id_polifenol: "77",
    polifenol: "Bezafibrate",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "10753637,12009300",
  },
  {
    id: "154",
    id_polifenol: "1810",
    polifenol: "heminordihydroguaiaretic acid",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "3",
    pmids: "16544145,15958646,21643005",
  },
  {
    id: "155",
    id_polifenol: "43",
    polifenol: "Parabens",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "20",
    pmids:
      "26253279,12518336,29074358,29945225,11696396,12210538,16021681,24481588,11867263,22917524,25047802,26502914,23744433,24652746,22744862,23364952,25411358,25192815,27995640,20932229",
  },
  {
    id: "156",
    id_polifenol: "19",
    polifenol: "Pentachlorophenol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "5",
    pmids: "26981120,16626760,15720130,15081572,11732758",
  },
  {
    id: "157",
    id_polifenol: "6783",
    polifenol: "protoapigenone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "13",
    pmids:
      "22652174,24721328,23624174,26716652,25455158,20686818,28436164,22753749,22565593,21912610,21657076,17622129,16206043",
  },
  {
    id: "158",
    id_polifenol: "6477",
    polifenol: "hispidulin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "22418930",
  },
  {
    id: "159",
    id_polifenol: "6510",
    polifenol: "glycitein",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "9",
    pmids:
      "29954123,12416264,15492830,15105043,19800779,26339345,16122394,11694655,23095751",
  },
  {
    id: "160",
    id_polifenol: "7198",
    polifenol: "homoorientin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "4",
    pmids: "27630565,25473363,24455713,27601844",
  },
  {
    id: "161",
    id_polifenol: "128",
    polifenol: "Pterocarpans",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "9",
    pmids:
      "24252341,25034000,19836230,20493896,24952350,25395701,29656660,12057662,28112509",
  },
  {
    id: "162",
    id_polifenol: "7557",
    polifenol: "rhamnetin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "4",
    pmids: "23861102,12870885,26922854,8828921",
  },
  {
    id: "163",
    id_polifenol: "6456",
    polifenol: "daidzin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "11",
    pmids:
      "27592281,29954123,15492830,19003112,1883387,20821227,22878391,12670155,27043076,2749004,15281219",
  },
  {
    id: "164",
    id_polifenol: "103",
    polifenol: "Zeranol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "18",
    pmids:
      "14676845,11859871,27220457,22113133,21187493,15994033,20032412,22993626,15569208,21617224,21378327,16757814,21472316,21472344,12553013,19555691,9010330,16120254",
  },
  {
    id: "165",
    id_polifenol: "1353",
    polifenol: "protocatechualdehyde",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "5",
    pmids: "24712725,23159608,25447816,16562825,19099226",
  },
  {
    id: "166",
    id_polifenol: "4501",
    polifenol: "tricin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "3",
    pmids: "15316567,11097223,22272829",
  },
  {
    id: "167",
    id_polifenol: "4883",
    polifenol: "flavokawain B",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "3",
    pmids: "26922065,25834398,29518053",
  },
  {
    id: "168",
    id_polifenol: "5496",
    polifenol: "pelargonidin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "3",
    pmids: "15680311,12925310,23441618",
  },
  {
    id: "169",
    id_polifenol: "7853",
    polifenol: "Grape Seed Proanthocyanidins",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "10448908,20146248",
  },
  {
    id: "170",
    id_polifenol: "4304",
    polifenol: "5-7-oxo-zeaenol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "3",
    pmids: "22753698,25557171,29777109",
  },
  {
    id: "171",
    id_polifenol: "7612",
    polifenol: "quercetin 3-O-glucuronide",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "7",
    pmids: "29497723,17294687,24929186,22348918,26922854,24607809,24657077",
  },
  {
    id: "172",
    id_polifenol: "7775",
    polifenol: "glyceollin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "11",
    pmids:
      "22740874,20493896,19797619,26703673,17145841,28666461,25771071,19116342,26703648,23395943,22054259",
  },
  {
    id: "173",
    id_polifenol: "5796",
    polifenol: "dihydrochalcone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "3",
    pmids: "15642415,23501110,20715765",
  },
  {
    id: "174",
    id_polifenol: "6066",
    polifenol: "eriodictyol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "4",
    pmids: "18074851,28539711,26344038,15041478",
  },
  {
    id: "175",
    id_polifenol: "353",
    polifenol: "sesamol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "21141889",
  },
  {
    id: "176",
    id_polifenol: "2574",
    polifenol: "4-hydroxybenzoic acid",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "7",
    pmids: "14979919,28807853,29860218,22917524,23049233,27995640,20361301",
  },
  {
    id: "177",
    id_polifenol: "3019",
    polifenol: "nitroaspirin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "26184135,19576865",
  },
  {
    id: "178",
    id_polifenol: "6452",
    polifenol: "chrysoeriol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "6",
    pmids: "22438130,25190466,20553787,28222613,19833205,18835421",
  },
  {
    id: "179",
    id_polifenol: "680",
    polifenol: "xanthorrhizol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "7",
    pmids: "21772753,17201174,19189649,21232161,19118501,19881304,25141924",
  },
  {
    id: "180",
    id_polifenol: "713",
    polifenol:
      "3-(3-chloro-4-hydroxyphenylamino)-4-(4-nitrophenyl)-1H-pyrrole-2,5-dione",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "15753396,11956225",
  },
  {
    id: "181",
    id_polifenol: "4480",
    polifenol: "myricitrin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "27492128,24813683",
  },
  {
    id: "182",
    id_polifenol: "5794",
    polifenol: "2'-hydroxychalcone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "9",
    pmids:
      "23174316,22177409,15642415,23562496,15848217,11720850,15863696,11934235,20729081",
  },
  {
    id: "183",
    id_polifenol: "7377",
    polifenol: "astragalin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "4",
    pmids: "25446499,24748754,25348942,26922854",
  },
  {
    id: "184",
    id_polifenol: "4521",
    polifenol: "3-hydroxyflavone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "3",
    pmids: "23438826,16789754,24098354",
  },
  {
    id: "185",
    id_polifenol: "413",
    polifenol: "4-nonylphenol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "14",
    pmids:
      "9831541,9631496,15166400,27550319,14754635,8013351,14709801,22531466,12224631,12547330,11518614,16393665,17651883,16624408",
  },
  {
    id: "186",
    id_polifenol: "3489",
    polifenol: "anethole",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "3",
    pmids: "22464689,12818366,25792512",
  },
  {
    id: "187",
    id_polifenol: "1672",
    polifenol: "B19 monocarbonyl curcumin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "3",
    pmids: "28397855,27496212,28439094",
  },
  {
    id: "188",
    id_polifenol: "97",
    polifenol: "Probucol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "24930590",
  },
  {
    id: "189",
    id_polifenol: "115",
    polifenol: "Diosmin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "5",
    pmids: "14644660,9661887,27374881,10443335,27890807",
  },
  {
    id: "190",
    id_polifenol: "2014",
    polifenol: "erbstatin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "10463775,17978516",
  },
  {
    id: "191",
    id_polifenol: "6554",
    polifenol: "tectorigenin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "5",
    pmids: "29359782,18508214,22627971,19928832,15787436",
  },
  {
    id: "192",
    id_polifenol: "4715",
    polifenol: "ampelopsin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "7",
    pmids: "24551210,24861637,25088800,27609190,22251058,26189300,10571175",
  },
  {
    id: "193",
    id_polifenol: "7156",
    polifenol: "scutellarein",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "5",
    pmids: "19031366,19666078,29389889,29097115,18835421",
  },
  {
    id: "194",
    id_polifenol: "6800",
    polifenol: "3,6-dimethoxy-6'',6''-dimethylchromeno(2'',3''-7,8)flavone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "4",
    pmids: "29264766,20398386,25382686,18443432",
  },
  {
    id: "195",
    id_polifenol: "299",
    polifenol: "nitrophenylphosphate",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "19624869,21666926",
  },
  {
    id: "196",
    id_polifenol: "5831",
    polifenol: "angoletin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "3",
    pmids: "25773833,19259708,25882313",
  },
  {
    id: "197",
    id_polifenol: "6693",
    polifenol: "2',4',7-trihydroxyisoflavone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "4",
    pmids: "25395701,14992594,11739876,16469160",
  },
  {
    id: "198",
    id_polifenol: "2450",
    polifenol: "Geraniin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "27097871",
  },
  {
    id: "199",
    id_polifenol: "4565",
    polifenol: "morusin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "3",
    pmids: "26538209,28599457,25476160",
  },
  {
    id: "200",
    id_polifenol: "885",
    polifenol: "oleocanthal",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "8",
    pmids:
      "24849787,23403296,27086914,21328179,26248874,28625568,27258622,19094209",
  },
  {
    id: "201",
    id_polifenol: "6129",
    polifenol: "wogonoside",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "4",
    pmids: "23000445,24026776,28774312,26387984",
  },
  {
    id: "202",
    id_polifenol: "6175",
    polifenol: "2'-hydroxyflavanone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "3",
    pmids: "29719590,29088842,19007764",
  },
  {
    id: "203",
    id_polifenol: "6112",
    polifenol: "alpinetin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "17719612",
  },
  {
    id: "204",
    id_polifenol: "896",
    polifenol: "polyphenon B",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "17415784",
  },
  {
    id: "205",
    id_polifenol: "6770",
    polifenol: "5-hydroxy-3,6,7,8,3',4'-hexamethoxyflavone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "3",
    pmids: "29039514,17046027,25686711",
  },
  {
    id: "206",
    id_polifenol: "2283",
    polifenol: "depsidone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "5",
    pmids: "15386197,27102610,26744260,25248047,16163823",
  },
  {
    id: "207",
    id_polifenol: "711",
    polifenol: "ascochlorin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "15721271,18057697",
  },
  {
    id: "208",
    id_polifenol: "6457",
    polifenol: "salvigenin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "5",
    pmids: "29734849,27671497,28552787,24270218,28278660",
  },
  {
    id: "209",
    id_polifenol: "1747",
    polifenol: "6-paradol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "3",
    pmids: "17683926,23435947,29393873",
  },
  {
    id: "210",
    id_polifenol: "2697",
    polifenol: "4-trifluoromethylsalicylic acid",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "8",
    pmids:
      "23958424,19783927,27137757,11742500,18951802,16254462,25419517,26537079",
  },
  {
    id: "211",
    id_polifenol: "5005",
    polifenol: "procyanidin B",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "3",
    pmids: "17851427,14679019,25839702",
  },
  {
    id: "212",
    id_polifenol: "12",
    polifenol: "Guaiacol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "4",
    pmids: "24189312,27693458,24121236,26898456",
  },
  {
    id: "213",
    id_polifenol: "7741",
    polifenol: "biochanin A",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "5",
    pmids: "20169097,10737547,8824507,9848525,20535833",
  },
  {
    id: "214",
    id_polifenol: "2790",
    polifenol: "ginkgolic acid",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "4",
    pmids: "21751842,28402272,25263445,22380770",
  },
  {
    id: "215",
    id_polifenol: "2454",
    polifenol: "corilagin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "26935808,29923307",
  },
  {
    id: "216",
    id_polifenol: "357",
    polifenol: "4-aminophenol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "4",
    pmids: "12417027,16203149,22721713,29606971",
  },
  {
    id: "217",
    id_polifenol: "2343",
    polifenol: "ethyl gallate",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "3",
    pmids: "12127233,25522911,25924474",
  },
  {
    id: "218",
    id_polifenol: "704",
    polifenol: "trizol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "19403417",
  },
  {
    id: "219",
    id_polifenol: "84",
    polifenol: "Halogenated Diphenyl Ethers",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "8",
    pmids:
      "27589474,22472210,18198840,29790728,26988655,18470304,11335189,29117588",
  },
  {
    id: "220",
    id_polifenol: "4479",
    polifenol: "morin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "26297979",
  },
  {
    id: "221",
    id_polifenol: "4052",
    polifenol: "bis-(3-(3',5'-di-tert-butyl-4'-hydroxyphenyl)propyl)sulfide",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "3",
    pmids: "23468877,25276196,25752056",
  },
  {
    id: "222",
    id_polifenol: "4578",
    polifenol: "5,7-dimethoxyflavone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "20369276",
  },
  {
    id: "223",
    id_polifenol: "1687",
    polifenol: "2-hydroxyestrone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "9",
    pmids:
      "6325410,1614394,28454423,19373615,10668495,8593862,9496644,21709000,8828921",
  },
  {
    id: "224",
    id_polifenol: "6100",
    polifenol: "pinostrobin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "4",
    pmids: "27603115,10840157,20064598,20576412",
  },
  {
    id: "225",
    id_polifenol: "347",
    polifenol: "4-nitrophenyl",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "4",
    pmids: "25445037,22564383,25198889,26968704",
  },
  {
    id: "226",
    id_polifenol: "315",
    polifenol: "bakuchiol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "4",
    pmids: "29093680,27252650,21355211,26419930",
  },
  {
    id: "227",
    id_polifenol: "1918",
    polifenol: "2,6-di-tert-butyl-4-(aminomethyl)phenol hydrochloride",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "23845444",
  },
  {
    id: "228",
    id_polifenol: "5538",
    polifenol: "petunidin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "15680311,19166352",
  },
  {
    id: "229",
    id_polifenol: "5875",
    polifenol: "panduratin A",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "29301388",
  },
  {
    id: "230",
    id_polifenol: "4839",
    polifenol: "7-hydroxyflavone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "29116937,24098354",
  },
  {
    id: "231",
    id_polifenol: "7199",
    polifenol: "luteolin-7-glucoside",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "7",
    pmids: "17294687,21899551,16029005,25630793,24455713,28222613,23146235",
  },
  {
    id: "232",
    id_polifenol: "1689",
    polifenol: "16-hydroxyestrone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "8",
    pmids:
      "18272409,10030690,19373615,15691880,10725782,11719282,14630092,21709000",
  },
  {
    id: "233",
    id_polifenol: "5885",
    polifenol: "2',4'-dihydroxy-6'-methoxy-3',5'-dimethylchalcone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "19242112,29035298",
  },
  {
    id: "234",
    id_polifenol: "5537",
    polifenol: "peonidin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "12925310,19166352",
  },
  {
    id: "235",
    id_polifenol: "7140",
    polifenol: "isovitexin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "25473363,20576412",
  },
  {
    id: "236",
    id_polifenol: "428",
    polifenol: "2,2'-bisphenol F",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "4",
    pmids: "29215574,20170107,24365254,22564383",
  },
  {
    id: "237",
    id_polifenol: "7453",
    polifenol: "kaempferol-3-O-glucoside",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "3",
    pmids: "17084606,28539711,24001127",
  },
  {
    id: "238",
    id_polifenol: "11",
    polifenol: "Hydroxyestrones",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "10",
    pmids:
      "6325410,1614394,15488352,9433910,10668495,8593862,12094629,16213115,9496644,1756258",
  },
  {
    id: "239",
    id_polifenol: "4573",
    polifenol: "3,3',4',5,6,7,8-heptamethoxyflavone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "17046027",
  },
  {
    id: "240",
    id_polifenol: "4981",
    polifenol: "jaceosidin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "3",
    pmids: "25295671,17404058,27262066",
  },
  {
    id: "241",
    id_polifenol: "1678",
    polifenol: "2-methoxyestrone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "8",
    pmids:
      "11034086,27269377,14991574,11165021,15994956,16397246,20492690,10715539",
  },
  {
    id: "242",
    id_polifenol: "2573",
    polifenol: "butylparaben",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "13",
    pmids:
      "26253279,12518336,29945225,11696396,12210538,24481588,11867263,26502914,29460325,23744433,24652746,22744862,23524099",
  },
  {
    id: "243",
    id_polifenol: "4639",
    polifenol: "aromadedrin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "19439809",
  },
  {
    id: "244",
    id_polifenol: "7658",
    polifenol: "quercetin 3'-O-glucoside",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "24001127,24657077",
  },
  {
    id: "245",
    id_polifenol: "3258",
    polifenol: "tesmilifene",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "6",
    pmids: "18605231,18986763,10755318,19118039,18480139,1617649",
  },
  {
    id: "246",
    id_polifenol: "4782",
    polifenol: "kurarinone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "17186493,15568770",
  },
  {
    id: "247",
    id_polifenol: "6497",
    polifenol: "isoflavanone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "7",
    pmids: "20638373,19928832,24354192,24345481,12677529,22444875,26417225",
  },
  {
    id: "248",
    id_polifenol: "7895",
    polifenol: "flavokawain A",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "4",
    pmids: "28335434,26859847,25286005,26179368",
  },
  {
    id: "249",
    id_polifenol: "3494",
    polifenol: "asarone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "29174417,25383224",
  },
  {
    id: "250",
    id_polifenol: "4549",
    polifenol: "casticin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "3",
    pmids: "24354186,26115782,20450732",
  },
  {
    id: "251",
    id_polifenol: "6453",
    polifenol: "cirsimaritin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "3",
    pmids: "27938087,15305306,28784292",
  },
  {
    id: "252",
    id_polifenol: "4553",
    polifenol: "sulfuretin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "23292685,19606519",
  },
  {
    id: "253",
    id_polifenol: "70",
    polifenol: "Sulfobromophthalein",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "16180120,17639028",
  },
  {
    id: "254",
    id_polifenol: "5615",
    polifenol: "gallocatechin gallate",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "12925310",
  },
  {
    id: "255",
    id_polifenol: "6549",
    polifenol: "7-hydroxy-2',3',4',5',8-pentamethoxyisoflavan",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "4",
    pmids: "20626003,19928832,11059763,28110438",
  },
  {
    id: "256",
    id_polifenol: "1662",
    polifenol: "BDMC-A",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "3",
    pmids: "24365254,26349982,23242714",
  },
  {
    id: "257",
    id_polifenol: "826",
    polifenol: "4,4',4''-(4-propyl-((1)H)-pyrazole-1,3,5-triyl) tris-phenol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "6",
    pmids: "16007178,16901971,18784357,21847390,21990277,23236424",
  },
  {
    id: "258",
    id_polifenol: "5539",
    polifenol: "peonidin 3-glucoside",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "4",
    pmids: "23199305,25070704,26985659,24312561",
  },
  {
    id: "259",
    id_polifenol: "6008",
    polifenol: "millepachine",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "25643726",
  },
  {
    id: "260",
    id_polifenol: "4632",
    polifenol: "ginkgetin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "29031204,29085516",
  },
  {
    id: "261",
    id_polifenol: "5245",
    polifenol: "BF6-6 biflavone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "29968167,28839377",
  },
  {
    id: "262",
    id_polifenol: "839",
    polifenol: "5-iodo-3-((3,5-dibromo-4-hydroxyphenyl)methylene)-2-indolinone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "17251686,19801662",
  },
  {
    id: "263",
    id_polifenol: "6076",
    polifenol: "vexibinol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "15568770",
  },
  {
    id: "264",
    id_polifenol: "2504",
    polifenol: "pentagalloylglucose",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "4",
    pmids: "14726525,12781329,21598989,16637063",
  },
  {
    id: "265",
    id_polifenol: "792",
    polifenol: "octylphenol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "5",
    pmids: "15110097,24684733,17141713,22531466,17651883",
  },
  {
    id: "266",
    id_polifenol: "2",
    polifenol: "Aminophenols",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "3",
    pmids: "12417027,17092729,16203149",
  },
  {
    id: "267",
    id_polifenol: "6819",
    polifenol: "luteolin-7-O-glucoside",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "4",
    pmids: "21161823,27034599,23146235,28552787",
  },
  {
    id: "268",
    id_polifenol: "4607",
    polifenol: "orientin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "27630565,25473363",
  },
  {
    id: "269",
    id_polifenol: "2807",
    polifenol: "thiosalicylic acid",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "24987803",
  },
  {
    id: "270",
    id_polifenol: "6093",
    polifenol: "pinobanksin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "3",
    pmids: "25192075,27123037,22434356",
  },
  {
    id: "271",
    id_polifenol: "5542",
    polifenol: "delphinidin 3-O-glucopyranoside",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "20170107,27388461",
  },
  {
    id: "272",
    id_polifenol: "4544",
    polifenol: "tiliroside",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "26655407,16833018",
  },
  {
    id: "273",
    id_polifenol: "416",
    polifenol: "phenoxy radical",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "7955118",
  },
  {
    id: "274",
    id_polifenol: "2571",
    polifenol: "methylparaben",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "11",
    pmids:
      "12518336,11696396,12210538,16021681,24481588,11867263,25047802,27581495,23744433,24652746,22744862",
  },
  {
    id: "275",
    id_polifenol: "7437",
    polifenol: "kaempferol-3-O-rutinoside",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "4",
    pmids: "23679992,24711053,16833018,28649063",
  },
  {
    id: "276",
    id_polifenol: "1675",
    polifenol: "catechol estrogen 3,4-quinone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "5",
    pmids: "17582757,17964424,28154783,23994691,18423413",
  },
  {
    id: "277",
    id_polifenol: "5289",
    polifenol: "8-bromo-7-methoxychrysin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "24765191",
  },
  {
    id: "278",
    id_polifenol: "1718",
    polifenol: "dihydroguaiaretic acid",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "26382595",
  },
  {
    id: "279",
    id_polifenol: "2168",
    polifenol: "beta-resorcylic acid",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "3",
    pmids: "22253097,25574154,16120254",
  },
  {
    id: "280",
    id_polifenol: "1106",
    polifenol: "1,1-bis(3'-indolyl)-1-(4-hydroxyphenyl)methane",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "26929200",
  },
  {
    id: "281",
    id_polifenol: "4703",
    polifenol: "eupatorin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "18454852",
  },
  {
    id: "282",
    id_polifenol: "2471",
    polifenol: "oenothein B",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "28282602",
  },
  {
    id: "283",
    id_polifenol: "7422",
    polifenol: "kaempferide",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "4",
    pmids: "24443427,26047480,20369276,23123452",
  },
  {
    id: "284",
    id_polifenol: "4312",
    polifenol: "zearalenol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "7",
    pmids: "27311894,16152973,570914,15994033,19730705,19555691,16120254",
  },
  {
    id: "285",
    id_polifenol: "6684",
    polifenol: "eupafolin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "22418930,21846263",
  },
  {
    id: "286",
    id_polifenol: "2173",
    polifenol: "atranorin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "3",
    pmids: "25233603,26969521,20837130",
  },
  {
    id: "287",
    id_polifenol: "5532",
    polifenol: "malvidin-3-glucoside",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "27165855",
  },
  {
    id: "288",
    id_polifenol: "6680",
    polifenol: "6,7,4'-trihydroxyisoflavone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "3",
    pmids: "27313682,14992594,16814747",
  },
  {
    id: "289",
    id_polifenol: "1754",
    polifenol: "gigantol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "29444668,28844931",
  },
  {
    id: "290",
    id_polifenol: "7590",
    polifenol: "quercetin-3-O-rutinoside",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "4",
    pmids: "28752532,27232543,28178217,24657077",
  },
  {
    id: "291",
    id_polifenol: "444",
    polifenol: "2,4-di-tert-butylphenol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "19471192,26164257",
  },
  {
    id: "292",
    id_polifenol: "1629",
    polifenol: "bis-1,7-(2-hydroxyphenyl)-hepta-1,6-diene-3,5-dione",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "24757955,23242714",
  },
  {
    id: "293",
    id_polifenol: "6687",
    polifenol: "3'-dimethylaminoflavone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "3",
    pmids: "15571862,18720191,29104051",
  },
  {
    id: "294",
    id_polifenol: "1509",
    polifenol: "8-gingerol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "3",
    pmids: "28315687,24962868,22858304",
  },
  {
    id: "295",
    id_polifenol: "6459",
    polifenol: "genkwanin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "5",
    pmids: "19666078,20804741,22753749,18835421,28961040",
  },
  {
    id: "296",
    id_polifenol: "57",
    polifenol: "2,6-Dichloroindophenol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "21034357",
  },
  {
    id: "297",
    id_polifenol: "58",
    polifenol: "Nitrophenols",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "18439640,22593037",
  },
  {
    id: "298",
    id_polifenol: "3490",
    polifenol: "estragole",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "21812646,25789792",
  },
  {
    id: "299",
    id_polifenol: "3386",
    polifenol: "2,2',4,4'-tetrabromodiphenyl ether",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "3",
    pmids: "27589474,26988655,29117588",
  },
  {
    id: "300",
    id_polifenol: "529",
    polifenol: "4-octylphenol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "7",
    pmids: "9831541,11530281,16152973,8013351,12547330,11518614,12117780",
  },
  {
    id: "301",
    id_polifenol: "2565",
    polifenol: "propylparaben",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "9",
    pmids:
      "26253279,11696396,12210538,24481588,11867263,23744433,23056216,24652746,22744862",
  },
  {
    id: "302",
    id_polifenol: "1883",
    polifenol: "2-amino-5-methylphenol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "3",
    pmids: "26135471,26335033,22841366",
  },
  {
    id: "303",
    id_polifenol: "7290",
    polifenol: "5,2'-dihydroxy-7,8-dimethoxy-dihydroflavonol-3-O-acetate",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "28681913",
  },
  {
    id: "304",
    id_polifenol: "3606",
    polifenol:
      "5-(3-methoxy-4-((4-methoxybenzyl)oxy)benzyl)pyrimidine-2,4-diamine",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "20823155",
  },
  {
    id: "305",
    id_polifenol: "818",
    polifenol: "4,4'-isopropylidene diphenol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "4",
    pmids: "8164253,20614088,16892391,19053086",
  },
  {
    id: "306",
    id_polifenol: "4764",
    polifenol: "tectochrysin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "15930306",
  },
  {
    id: "307",
    id_polifenol: "4558",
    polifenol: "2'-hydroxyflavone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "29116937",
  },
  {
    id: "308",
    id_polifenol: "6548",
    polifenol: "artocarpin flavonoid",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "20544395,15165133",
  },
  {
    id: "309",
    id_polifenol: "5101",
    polifenol: "isokaempferide",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "20544395,19101886",
  },
  {
    id: "310",
    id_polifenol: "7614",
    polifenol: "quercetin 3-O-methyl ether",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "3",
    pmids: "25190466,22086611,26344038",
  },
  {
    id: "311",
    id_polifenol: "4698",
    polifenol: "sakuranetin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "20645919",
  },
  {
    id: "312",
    id_polifenol: "4608",
    polifenol: "artonin E",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "4",
    pmids: "28771532,28356713,15165133,27367662",
  },
  {
    id: "313",
    id_polifenol: "5303",
    polifenol: "3,6-dihydroxyflavone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "3",
    pmids: "22616882,28870206,27345219",
  },
  {
    id: "314",
    id_polifenol: "5536",
    polifenol: "prodelphinidin B-2 3'-O-gallate",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "25735761,28216880",
  },
  {
    id: "315",
    id_polifenol: "526",
    polifenol: "liensinine",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "5",
    pmids: "29333179,26219228,26114658,26811496,28132898",
  },
  {
    id: "316",
    id_polifenol: "7427",
    polifenol: "kaempferol 3-O-rhamnoside",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "6",
    pmids: "22783393,17084606,25469259,28539711,21846263,24879482",
  },
  {
    id: "317",
    id_polifenol: "5141",
    polifenol: "6-prenylnaringenin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "3",
    pmids: "27269377,25044854,16019205",
  },
  {
    id: "318",
    id_polifenol: "2339",
    polifenol: "3-O-methylgallic acid",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "19731038",
  },
  {
    id: "319",
    id_polifenol: "1630",
    polifenol: "dimethoxycurcumin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "27550987,24625971",
  },
  {
    id: "320",
    id_polifenol: "1492",
    polifenol: "hirsutenone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "16380122",
  },
  {
    id: "321",
    id_polifenol: "6711",
    polifenol: "3',4'-dimethoxyflavone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "11099636",
  },
  {
    id: "322",
    id_polifenol: "106",
    polifenol: "Benzoflavones",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "3",
    pmids: "15608138,23868912,16387742",
  },
  {
    id: "323",
    id_polifenol: "4548",
    polifenol: "artemetin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "3",
    pmids: "24354186,26115782,8134418",
  },
  {
    id: "324",
    id_polifenol: "630",
    polifenol: "4-tert-octylphenol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "3",
    pmids: "23219593,11867264,12737316",
  },
  {
    id: "325",
    id_polifenol: "3040",
    polifenol:
      "4-(3-thioxo-3H-1,2-dithiol-5-yl)phenyl 2-((4-(nitrooxy)butanoyl)oxy)benzoate",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "28162289",
  },
  {
    id: "326",
    id_polifenol: "2159",
    polifenol: "2,3-dihydroxybenzoic acid",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "29792433",
  },
  {
    id: "327",
    id_polifenol: "2169",
    polifenol: "ethyl protocatechuate",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "3",
    pmids: "25232961,28396358,23539444",
  },
  {
    id: "328",
    id_polifenol: "273",
    polifenol: "bis(4-nitrophenyl)phosphate",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "21618543",
  },
  {
    id: "329",
    id_polifenol: "7478",
    polifenol: "kaempferol-7-methyl ether",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "17335117",
  },
  {
    id: "330",
    id_polifenol: "1688",
    polifenol: "4-hydroxyestrone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "6",
    pmids: "21665890,15135645,10668495,10813650,12094629,20509668",
  },
  {
    id: "331",
    id_polifenol: "5941",
    polifenol: "3-hydroxy-4,3',4',5'-tetramethoxychalcone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "15202555",
  },
  {
    id: "332",
    id_polifenol: "5720",
    polifenol: "4,3',4',5'- tetramethoxychalcone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "26690274",
  },
  {
    id: "333",
    id_polifenol: "6555",
    polifenol: "tectoridin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "4",
    pmids: "22627971,15787436,24252334,19326083",
  },
  {
    id: "334",
    id_polifenol: "3944",
    polifenol: "myrtucommulone A",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "26334623",
  },
  {
    id: "335",
    id_polifenol: "400",
    polifenol: "cardanol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "26694491",
  },
  {
    id: "336",
    id_polifenol: "5827",
    polifenol: "4'-methoxychalcone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "23562496",
  },
  {
    id: "337",
    id_polifenol: "2336",
    polifenol: "octyl gallate",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "29864945",
  },
  {
    id: "338",
    id_polifenol: "6717",
    polifenol: "irigenin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "22627971,15787436",
  },
  {
    id: "339",
    id_polifenol: "2868",
    polifenol: "3-hydroxy-4-prenyl-5-methoxystilbene-2-carboxylic acid",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "6",
    pmids: "25925968,26365581,25716159,27603115,20576412,25925965",
  },
  {
    id: "340",
    id_polifenol: "5909",
    polifenol: "licochalcone E",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "23625311,28522265",
  },
  {
    id: "341",
    id_polifenol: "4082",
    polifenol: "3,3',4,4',5,5'-hexahydroxystilbene",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "18434081",
  },
  {
    id: "342",
    id_polifenol: "6031",
    polifenol: "2',3'-dimethoxyflavanone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "3",
    pmids: "25132643,21351299,15202555",
  },
  {
    id: "343",
    id_polifenol: "343",
    polifenol: "2,5-dichloro-4-bromophenol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "8964830",
  },
  {
    id: "344",
    id_polifenol: "2161",
    polifenol: "nifuroxazide",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "25811798",
  },
  {
    id: "345",
    id_polifenol: "4263",
    polifenol: "amurensin G",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "3",
    pmids: "22842120,20713551,26416354",
  },
  {
    id: "346",
    id_polifenol: "7632",
    polifenol: "quercetin-3-O-beta-D-galactopyranoside",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "18828600,19323263",
  },
  {
    id: "347",
    id_polifenol: "2961",
    polifenol: "acetylsalicylic acid lysinate",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "4",
    pmids: "19112426,17166374,22115493,2513994",
  },
  {
    id: "348",
    id_polifenol: "7633",
    polifenol: "tamarixetin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "26851174,22077457",
  },
  {
    id: "349",
    id_polifenol: "4534",
    polifenol: "3,5,6-trihydroxy-4',7'-dimethoxyflavone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "17404058",
  },
  {
    id: "350",
    id_polifenol: "2484",
    polifenol: "chebulinic acid",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "12127233",
  },
  {
    id: "351",
    id_polifenol: "1867",
    polifenol: "creosol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "27432798",
  },
  {
    id: "352",
    id_polifenol: "6492",
    polifenol: "3(2H)-isoflavene",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "28408225,26432036",
  },
  {
    id: "353",
    id_polifenol: "4574",
    polifenol: "sinensetin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "17046027,19666078",
  },
  {
    id: "354",
    id_polifenol: "7197",
    polifenol: "6-hydroxyluteolin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "19666078,29097115",
  },
  {
    id: "355",
    id_polifenol: "72",
    polifenol: "Phenyl Ethers",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "4",
    pmids: "29102180,26741854,25879502,19795843",
  },
  {
    id: "356",
    id_polifenol: "1246",
    polifenol: "4,4'-hexafluorisopropylidene diphenol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "6",
    pmids: "24727858,29093337,24349450,29743443,28735473,28591870",
  },
  {
    id: "357",
    id_polifenol: "4505",
    polifenol: "pycnogenols",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "10953304",
  },
  {
    id: "358",
    id_polifenol: "3299",
    polifenol: "pentabromodiphenyl ether",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "3",
    pmids: "22472210,18470304,11335189",
  },
  {
    id: "359",
    id_polifenol: "3665",
    polifenol: "3,5-di-tert-butyl-4-hydroxyanisole",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "3",
    pmids: "14972018,22289578,2182121",
  },
  {
    id: "360",
    id_polifenol: "5669",
    polifenol: "pro-F-EGCG2",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "4",
    pmids: "17483343,20155623,18815743,19962231",
  },
  {
    id: "361",
    id_polifenol: "18",
    polifenol: "Hexachlorophene",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "15081572",
  },
  {
    id: "362",
    id_polifenol: "3493",
    polifenol: "mequinol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "8568634",
  },
  {
    id: "363",
    id_polifenol: "7518",
    polifenol: "quercetin-3-O-alpha-arabinofuranoside",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "4",
    pmids: "23767410,29884381,18828600,15730249",
  },
  {
    id: "364",
    id_polifenol: "7289",
    polifenol: "isorhamnetin 3-O-glucoside",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "28649063",
  },
  {
    id: "365",
    id_polifenol: "2474",
    polifenol: "vescalagin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "19888728",
  },
  {
    id: "366",
    id_polifenol: "6633",
    polifenol: "pomiferin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "22087557,20036234",
  },
  {
    id: "367",
    id_polifenol: "7736",
    polifenol: "7-monohydroxyethylrutoside",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "3",
    pmids: "17063376,9815559,11350909",
  },
  {
    id: "368",
    id_polifenol: "393",
    polifenol: "2,6-di-tert-butylphenol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "27162479",
  },
  {
    id: "369",
    id_polifenol: "5616",
    polifenol: "epigallocatechin-3-(3''-O-methyl)gallate",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "26542239",
  },
  {
    id: "370",
    id_polifenol: "1869",
    polifenol: "4-cresol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "25192815",
  },
  {
    id: "371",
    id_polifenol: "2026",
    polifenol: "phenylhydroquinone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "17887663",
  },
  {
    id: "372",
    id_polifenol: "418",
    polifenol: "thiophenol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "29550886",
  },
  {
    id: "373",
    id_polifenol: "1674",
    polifenol: "6-hydroxyestrogen 6-sulfate",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "8828921",
  },
  {
    id: "374",
    id_polifenol: "858",
    polifenol: "2-(3-chloro-4-hydroxyphenyl)-2-(4-hydroxyphenyl)propane",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "3",
    pmids: "22985957,24843190,25036149",
  },
  {
    id: "375",
    id_polifenol: "5945",
    polifenol: "2',5'-dimethoxychalcone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "17320246",
  },
  {
    id: "376",
    id_polifenol: "1451",
    polifenol: "hispolon",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "3",
    pmids: "26171065,26056942,28605338",
  },
  {
    id: "377",
    id_polifenol: "6587",
    polifenol: "glycitin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "15492830",
  },
  {
    id: "378",
    id_polifenol: "6940",
    polifenol: "neobavaisoflavone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "24252341",
  },
  {
    id: "379",
    id_polifenol: "4073",
    polifenol: "myristicin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "29174417,21472076",
  },
  {
    id: "380",
    id_polifenol: "6508",
    polifenol: "prunetin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "29197545,25395701",
  },
  {
    id: "381",
    id_polifenol: "6478",
    polifenol: "cirsilineol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "3",
    pmids: "16393119,25295671,22768128",
  },
  {
    id: "382",
    id_polifenol: "5963",
    polifenol: "3,5,2',4'-tetrahydroxychalcone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "20699088,21170936",
  },
  {
    id: "383",
    id_polifenol: "996",
    polifenol: "2,3-difluoro phenol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "20729081",
  },
  {
    id: "384",
    id_polifenol: "1262",
    polifenol: "4-dodecylaminophenol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "17092729",
  },
  {
    id: "385",
    id_polifenol: "4675",
    polifenol: "3'-methoxy-4'-nitroflavone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "3",
    pmids: "11597580,7840652,16489025",
  },
  {
    id: "386",
    id_polifenol: "6647",
    polifenol: "6-methylflavone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "3",
    pmids: "22753749,20369276,26086179",
  },
  {
    id: "387",
    id_polifenol: "4297",
    polifenol: "curvularin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "23134667,26411029",
  },
  {
    id: "388",
    id_polifenol: "4135",
    polifenol: "orcinol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "26826267,15921417",
  },
  {
    id: "389",
    id_polifenol: "6291",
    polifenol: "alpinumisoflavone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "3",
    pmids: "27288921,19091749,22079771",
  },
  {
    id: "390",
    id_polifenol: "6485",
    polifenol: "3',4',7-trihydroxyisoflavone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "14992594,16814747",
  },
  {
    id: "391",
    id_polifenol: "5697",
    polifenol:
      "3-(3,4-dimethoxyphenyl)-1-(5-hydroxy-2,2-dimethyl-2H-chromen-6-yl)prop-2-en-1-one",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "27658723,17964170",
  },
  {
    id: "392",
    id_polifenol: "4103",
    polifenol: "gnetin H",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "3",
    pmids: "25862967,12135100,28599439",
  },
  {
    id: "393",
    id_polifenol: "7363",
    polifenol: "juglanin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "27899257",
  },
  {
    id: "394",
    id_polifenol: "2332",
    polifenol: "lauryl gallate",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "16624827",
  },
  {
    id: "395",
    id_polifenol: "2290",
    polifenol: "lobaric acid",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "9504441",
  },
  {
    id: "396",
    id_polifenol: "4629",
    polifenol: "5,7,2'-trihydroxyflavone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "28282786",
  },
  {
    id: "397",
    id_polifenol: "7657",
    polifenol: "quercetin 3'-sulfate",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "29497723",
  },
  {
    id: "398",
    id_polifenol: "4524",
    polifenol: "5-hydroxy-3',4',6,7-tetramethoxyflavone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "17046027",
  },
  {
    id: "399",
    id_polifenol: "4244",
    polifenol: "malabaricone A",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "3",
    pmids: "26141757,20805034,19471882",
  },
  {
    id: "400",
    id_polifenol: "5833",
    polifenol: "2',5'-dihydroxychalcone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "15642415,22239485",
  },
  {
    id: "401",
    id_polifenol: "4158",
    polifenol: "malabaricone C",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "24456233,20805034",
  },
  {
    id: "402",
    id_polifenol: "6460",
    polifenol: "ipriflavone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "3",
    pmids: "7736326,12115517,24084576",
  },
  {
    id: "403",
    id_polifenol: "1796",
    polifenol: "(10)-shogaol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "20718733,29393873",
  },
  {
    id: "404",
    id_polifenol: "6642",
    polifenol: "6,7-dihydroxyflavone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "9751276",
  },
  {
    id: "405",
    id_polifenol: "6803",
    polifenol: "isoscutellarein",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "24081687",
  },
  {
    id: "406",
    id_polifenol: "4579",
    polifenol: "hinokiflavone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "22271084",
  },
  {
    id: "407",
    id_polifenol: "2768",
    polifenol: "salophen",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "6",
    pmids: "19259708,28858483,25495038,28923384,20828884,25450023",
  },
  {
    id: "408",
    id_polifenol: "811",
    polifenol: "squaraine",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "28169351",
  },
  {
    id: "409",
    id_polifenol: "7810",
    polifenol: "rotenolone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "4",
    pmids: "9520374,23895019,20804165,24354192",
  },
  {
    id: "410",
    id_polifenol: "5198",
    polifenol: "isosakuranetin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "15202555",
  },
  {
    id: "411",
    id_polifenol: "6883",
    polifenol: "LYG 202",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "26153346",
  },
  {
    id: "412",
    id_polifenol: "5791",
    polifenol: "metochalcone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "23524161,25057485",
  },
  {
    id: "413",
    id_polifenol: "5854",
    polifenol: "2'-hydroxy-3,4,3',4',6'-pentamethoxychalcone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "23438826,27483224",
  },
  {
    id: "414",
    id_polifenol: "5500",
    polifenol: "pelargonidin-3-glucoside",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "23199305",
  },
  {
    id: "415",
    id_polifenol: "6898",
    polifenol: "barbigerone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "29368443",
  },
  {
    id: "416",
    id_polifenol: "5436",
    polifenol: "herbacetin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "3",
    pmids: "26297979,29029040,24081687",
  },
  {
    id: "417",
    id_polifenol: "988",
    polifenol: "4'-O-methylnyasol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "23144548",
  },
  {
    id: "418",
    id_polifenol: "4298",
    polifenol: "dehydrocurvularin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "23134667,26411029",
  },
  {
    id: "419",
    id_polifenol: "2472",
    polifenol: "sanguiin H 6",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "28835347",
  },
  {
    id: "420",
    id_polifenol: "1204",
    polifenol: "2-isopropyl-5-methylphenol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "27068261,25918546",
  },
  {
    id: "421",
    id_polifenol: "7211",
    polifenol: "scolymoside",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "23790919",
  },
  {
    id: "422",
    id_polifenol: "4576",
    polifenol: "gossypetin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "25190466",
  },
  {
    id: "423",
    id_polifenol: "6654",
    polifenol: "5,2',4'-trihydroxy-6,7,5'-trimethoxyflavone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "28110438",
  },
  {
    id: "424",
    id_polifenol: "6952",
    polifenol: "isoangustone A",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "21429724",
  },
  {
    id: "425",
    id_polifenol: "696",
    polifenol: "2,2-bis(4-hydroxyphenyl)-1,1,1-trichloroethane",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "3",
    pmids: "28426875,11530281,15166400",
  },
  {
    id: "426",
    id_polifenol: "689",
    polifenol: "3,4-dixydroxyphenylethanol elenolic acid",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "21805082",
  },
  {
    id: "427",
    id_polifenol: "1649",
    polifenol: "1,5-bis(2-hydroxyphenyl)-1,4-pentadien-3-one",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "28038323",
  },
  {
    id: "428",
    id_polifenol: "3646",
    polifenol: "1,5-bis(2-methoxyphenyl)penta-1,4-dien-3-one",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "29533214",
  },
  {
    id: "429",
    id_polifenol: "1821",
    polifenol: "2,4-D n-butyl ester",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "22789709,26499209",
  },
  {
    id: "430",
    id_polifenol: "7641",
    polifenol: "quercetin-3'-O-beta-D-glucopyranoside",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "3",
    pmids: "23767410,22281382,18828600",
  },
  {
    id: "431",
    id_polifenol: "5167",
    polifenol: "6-hydroxyflavone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "2749004",
  },
  {
    id: "432",
    id_polifenol: "4919",
    polifenol: "bavachinin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "3",
    pmids: "29335212,24012108,10443335",
  },
  {
    id: "433",
    id_polifenol: "7560",
    polifenol: "quercetin-3-O-neohesperidose",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "7923555",
  },
  {
    id: "434",
    id_polifenol: "5465",
    polifenol: "vitexin-2-O-xyloside",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "23411276",
  },
  {
    id: "435",
    id_polifenol: "5557",
    polifenol: "cyanidin 3-galactoside",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "15680311,12769521",
  },
  {
    id: "436",
    id_polifenol: "4986",
    polifenol:
      "5-hydroxy-7-methoxyflavone-(4' -O-8'')-5'',7''-dihydroxy-4'''-methoxyflavone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "15305306",
  },
  {
    id: "437",
    id_polifenol: "5551",
    polifenol: "procyanidin B2-3,3'-di-O-gallate",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "25839702",
  },
  {
    id: "438",
    id_polifenol: "3058",
    polifenol: "2,5-dihydroxybenzoic acid",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "20681660,29885857",
  },
  {
    id: "439",
    id_polifenol: "4820",
    polifenol: "3,7-dihydroxyflavone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "29734739",
  },
  {
    id: "440",
    id_polifenol: "6470",
    polifenol: "O-desmethylangolensin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "3",
    pmids: "24260076,15105043,11566575",
  },
  {
    id: "441",
    id_polifenol: "4677",
    polifenol: "baohuoside II",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "25407882",
  },
  {
    id: "442",
    id_polifenol: "6067",
    polifenol: "carthamidin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "3",
    pmids: "24443427,15056864,24047498",
  },
  {
    id: "443",
    id_polifenol: "2744",
    polifenol: "3,5-diisopropylsalicylic acid",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "22313179",
  },
  {
    id: "444",
    id_polifenol: "409",
    polifenol: "tetrachlorodian",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "15635150,12753421",
  },
  {
    id: "445",
    id_polifenol: "7249",
    polifenol: "rhamnazin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "25704088,10739098",
  },
  {
    id: "446",
    id_polifenol: "7050",
    polifenol: "3'-chloro-5,7-dimethoxyisoflavone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "25395701",
  },
  {
    id: "447",
    id_polifenol: "1556",
    polifenol: "olvanil",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "3",
    pmids: "10785541,10448105,12570018",
  },
  {
    id: "448",
    id_polifenol: "1566",
    polifenol: "arvanil",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "10785541,10448105",
  },
  {
    id: "449",
    id_polifenol: "2590",
    polifenol: "isobutylparaben",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "3",
    pmids: "12518336,11696396,12210538",
  },
  {
    id: "450",
    id_polifenol: "1932",
    polifenol: "3,5-di-tert-butyl-4-hydroxytoluene",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "7887982",
  },
  {
    id: "451",
    id_polifenol: "7659",
    polifenol: "quercetin 7-rhamnoside",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "24711053",
  },
  {
    id: "452",
    id_polifenol: "7151",
    polifenol: "vicenin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "25473363,22272829",
  },
  {
    id: "453",
    id_polifenol: "7564",
    polifenol: "camelliaside B",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "22627971",
  },
  {
    id: "454",
    id_polifenol: "4303",
    polifenol: "hypothemycin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "25574154",
  },
  {
    id: "455",
    id_polifenol: "1658",
    polifenol: "3,5-bis(3,4,5-trimethoxybenzylidene)-1-methylpiperidine-4-one",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "23679865,29042771",
  },
  {
    id: "456",
    id_polifenol: "1626",
    polifenol: "diacetylcurcumin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "3",
    pmids: "26369539,26516945,23872022",
  },
  {
    id: "457",
    id_polifenol: "3435",
    polifenol: "N1-hydroxy-N8-(4-phenoxyphenyl)octanediamide",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "21983700",
  },
  {
    id: "458",
    id_polifenol: "184",
    polifenol: "trilobatin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "25229655",
  },
  {
    id: "459",
    id_polifenol: "5701",
    polifenol: "2',4'-dihydroxy-3,4,5-trimethoxychalcone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "24968064,15202555",
  },
  {
    id: "460",
    id_polifenol: "1553",
    polifenol: "dihydrocapsaicin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "18818525",
  },
  {
    id: "461",
    id_polifenol: "7531",
    polifenol: "7-O-geranylquercetin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "26415619,27980567",
  },
  {
    id: "462",
    id_polifenol: "935",
    polifenol: "oligonol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "17554207",
  },
  {
    id: "463",
    id_polifenol: "6037",
    polifenol: "6-methoxyflavanone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "9751276",
  },
  {
    id: "464",
    id_polifenol: "4248",
    polifenol: "4-(6-hydroxy-2-naphthyl)-1,3-benzenediol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "28656256",
  },
  {
    id: "465",
    id_polifenol: "4149",
    polifenol: "adipostatin A",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "21751842",
  },
  {
    id: "466",
    id_polifenol: "1642",
    polifenol: "FLLL 32",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "20818158",
  },
  {
    id: "467",
    id_polifenol: "7817",
    polifenol: "amorphigenin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "15796199",
  },
  {
    id: "468",
    id_polifenol: "6330",
    polifenol: "5,6,2',3',4'-pentamethoxyflavone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "25151216",
  },
  {
    id: "469",
    id_polifenol: "5802",
    polifenol: "hesperidin methylchalcone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "23562496",
  },
  {
    id: "470",
    id_polifenol: "1348",
    polifenol: "urushiol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "27667098,20617110",
  },
  {
    id: "471",
    id_polifenol: "6464",
    polifenol: "cirsiliol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "18454852",
  },
  {
    id: "472",
    id_polifenol: "322",
    polifenol: "N-methyl-4-aminophenol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "3",
    pmids: "12417027,16203149,29104051",
  },
  {
    id: "473",
    id_polifenol: "7280",
    polifenol: "astilbin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "21315392",
  },
  {
    id: "474",
    id_polifenol: "5974",
    polifenol: "4'-hydroxychalcone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "3",
    pmids: "22721615,15848217,15863696",
  },
  {
    id: "475",
    id_polifenol: "1417",
    polifenol: "1,2-dihydroxy-4'-chlorobiphenyl",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "17681423,15025504",
  },
  {
    id: "476",
    id_polifenol: "3608",
    polifenol:
      "5-(5-ethyl-2-hydroxy-4-methoxyphenyl)-4-(4-methoxyphenyl)isoxazole",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "16234246",
  },
  {
    id: "477",
    id_polifenol: "1634",
    polifenol: "FLLL-12 compound",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "19558577",
  },
  {
    id: "478",
    id_polifenol: "1782",
    polifenol: "6-dehydrogingerdione",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "20175081",
  },
  {
    id: "479",
    id_polifenol: "2531",
    polifenol: "sanguiin H-5",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "28835347",
  },
  {
    id: "480",
    id_polifenol: "4597",
    polifenol: "5-hydroxyflavone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "24098354,19592245",
  },
  {
    id: "481",
    id_polifenol: "2022",
    polifenol: "1,4-naphthohydroquinone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "22682920,19839584",
  },
  {
    id: "482",
    id_polifenol: "5949",
    polifenol: "2,2'-dihydroxychalcone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "16314891",
  },
  {
    id: "483",
    id_polifenol: "4053",
    polifenol: "succinobucol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "25598420,26711864",
  },
  {
    id: "484",
    id_polifenol: "4887",
    polifenol: "isoginkgetin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "17121913",
  },
  {
    id: "485",
    id_polifenol: "4224",
    polifenol: "orsellinic acid",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "15921417",
  },
  {
    id: "486",
    id_polifenol: "361",
    polifenol: "2-aminophenol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "17555822",
  },
  {
    id: "487",
    id_polifenol: "33",
    polifenol: "Dienestrol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "18976723,8568634",
  },
  {
    id: "488",
    id_polifenol: "5533",
    polifenol: "cyanidin-3-O-beta-glucopyranoside",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "20121190",
  },
  {
    id: "489",
    id_polifenol: "2255",
    polifenol: "protocatechuic acid methyl ester",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "25539472",
  },
  {
    id: "490",
    id_polifenol: "5996",
    polifenol: "3-(2-chlorophenyl)-1-(2,4-dihydroxyphenyl)prop-2-en-1-one",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "3",
    pmids: "28849241,22440895,17964170",
  },
  {
    id: "491",
    id_polifenol: "5284",
    polifenol: "didymin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "26893687",
  },
  {
    id: "492",
    id_polifenol: "1415",
    polifenol: "2,6-bis((3,4-dihydroxyphenyl)methylene)cyclohexanone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "4",
    pmids: "9344853,21573566,1568218,21567051",
  },
  {
    id: "493",
    id_polifenol: "1625",
    polifenol: "curcumin III",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "16928820,10969724",
  },
  {
    id: "494",
    id_polifenol: "6247",
    polifenol: "6,4'-dihydroxy-7-methoxyflavanone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "3",
    pmids: "15797607,15202555,11934235",
  },
  {
    id: "495",
    id_polifenol: "1059",
    polifenol: "bis(4-hydroxyphenyl)sulfone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "4",
    pmids: "29758456,29093337,28808208,28591870",
  },
  {
    id: "496",
    id_polifenol: "7583",
    polifenol: "quercetin 3-O-glucopyranoside",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "3",
    pmids: "23000408,20121190,26922854",
  },
  {
    id: "497",
    id_polifenol: "7210",
    polifenol: "luteolin-7-O-glucuronide",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "3",
    pmids: "24455713,23790919,29710781",
  },
  {
    id: "498",
    id_polifenol: "4473",
    polifenol: "robinin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "15796199",
  },
  {
    id: "499",
    id_polifenol: "5680",
    polifenol: "3-O-(3,4,5-trimethoxybenzoyl)catechin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "3",
    pmids: "23251702,27054335,25064027",
  },
  {
    id: "500",
    id_polifenol: "4663",
    polifenol: "rhoifolin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "25509294",
  },
  {
    id: "501",
    id_polifenol: "286",
    polifenol: "butylphen",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "11879974",
  },
  {
    id: "502",
    id_polifenol: "7457",
    polifenol: "kaempferol-7-O-alpha-L-rhamnopyranoside",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "16206043",
  },
  {
    id: "503",
    id_polifenol: "7232",
    polifenol: "IdB 1016",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "3",
    pmids: "17332330,24611152,25901160",
  },
  {
    id: "504",
    id_polifenol: "7355",
    polifenol: "broussoflavonol B",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "4",
    pmids: "23769740,23645733,25973295,25203051",
  },
  {
    id: "505",
    id_polifenol: "2695",
    polifenol: "methyl salicylate",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "28150904",
  },
  {
    id: "506",
    id_polifenol: "844",
    polifenol: "bisphenol B",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "4",
    pmids: "29093337,15635150,22531466,28591870",
  },
  {
    id: "507",
    id_polifenol: "521",
    polifenol: "E 7010",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "8137285",
  },
  {
    id: "508",
    id_polifenol: "7757",
    polifenol: "genistein-7-glucuronide-4'-sulfate",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "4",
    pmids: "22415614,8824507,9848525,25661160",
  },
  {
    id: "509",
    id_polifenol: "6760",
    polifenol: "5,7,8,4'-tetrahydroxyisoflavone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "3",
    pmids: "17976513,14992594,17015169",
  },
  {
    id: "510",
    id_polifenol: "329",
    polifenol: "2,6-dichloro-4-nitrophenol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "12818366,11162873",
  },
  {
    id: "511",
    id_polifenol: "16",
    polifenol: "Chlorophenols",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "24973716",
  },
  {
    id: "512",
    id_polifenol: "2607",
    polifenol: "amorfrutin A",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "28879797,26731300",
  },
  {
    id: "513",
    id_polifenol: "2422",
    polifenol: "ginnalin A",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "23122108",
  },
  {
    id: "514",
    id_polifenol: "4748",
    polifenol: "kazinol B",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "23447335",
  },
  {
    id: "515",
    id_polifenol: "6626",
    polifenol: "cajanol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "20638373",
  },
  {
    id: "516",
    id_polifenol: "6789",
    polifenol:
      "5,7-dihydroxy-3-(3-hydroxy-4-methoxybenzyl)-6-methoxychroman-4-one",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "20638373,23587260",
  },
  {
    id: "517",
    id_polifenol: "3371",
    polifenol:
      "5-(3-(3-(4-phenoxy-2-propylphenoxy)propoxy)phenyl)-2,4-thiazolidinedione",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "19671747",
  },
  {
    id: "518",
    id_polifenol: "5870",
    polifenol: "hydroxydibenzoylmethane",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "25650742",
  },
  {
    id: "519",
    id_polifenol: "4102",
    polifenol: "ardisiphenol D",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "21751842,24392814",
  },
  {
    id: "520",
    id_polifenol: "6164",
    polifenol: "euchrestaflavanone B",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "24443427",
  },
  {
    id: "521",
    id_polifenol: "6704",
    polifenol: "4-hydroxylonchocarpin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "29656660",
  },
  {
    id: "522",
    id_polifenol: "5046",
    polifenol: "4'-methoxyflavone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "7840652",
  },
  {
    id: "523",
    id_polifenol: "4203",
    polifenol: "methyl orsellinate",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "25233603",
  },
  {
    id: "524",
    id_polifenol: "6537",
    polifenol: "daidzein-4'-O-sulfate",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "19013426,9168894",
  },
  {
    id: "525",
    id_polifenol: "6143",
    polifenol: "5-(O-prenyl)naringenin-4',7-diacetate",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "25044854,21997247",
  },
  {
    id: "526",
    id_polifenol: "6347",
    polifenol: "oroxylin A-7-O-glucuronide",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "29571134",
  },
  {
    id: "527",
    id_polifenol: "5792",
    polifenol: "4,4'-dihydroxychalcone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "21573566",
  },
  {
    id: "528",
    id_polifenol: "5320",
    polifenol: "xanthohumol D",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "23434138",
  },
  {
    id: "529",
    id_polifenol: "5933",
    polifenol: "licochalcone B",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "28522265",
  },
  {
    id: "530",
    id_polifenol: "6326",
    polifenol: "eupatorin-5-methyl ether",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "23994263",
  },
  {
    id: "531",
    id_polifenol: "2959",
    polifenol: "(1'-ethoxy)ethyl 2-acetoxybenzoate",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "3",
    pmids: "29492489,21984018,20828891",
  },
  {
    id: "532",
    id_polifenol: "1795",
    polifenol: "1,4-O-diferuloylsecoisolariciresinol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "22700239",
  },
  {
    id: "533",
    id_polifenol: "2420",
    polifenol: "epigallocatechin-3-O-(3''-O-methyl)-gallate",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "17487361",
  },
  {
    id: "534",
    id_polifenol: "5120",
    polifenol: "diosmetin-7-O-xylopyranosyl-1-6-glucopyranoside",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "17294687",
  },
  {
    id: "535",
    id_polifenol: "1797",
    polifenol: "(8)-shogaol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "29393873",
  },
  {
    id: "536",
    id_polifenol: "4945",
    polifenol: "3,5,6,4'-tetrahydroxy-7-methoxyflavonoid",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "20553787,19833205",
  },
  {
    id: "537",
    id_polifenol: "4901",
    polifenol: "myricetin 3-O-(4''-acetyl)rhamnopyranoside",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "19323263",
  },
  {
    id: "538",
    id_polifenol: "2674",
    polifenol: "copper salicylate complex",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "17343335",
  },
  {
    id: "539",
    id_polifenol: "6071",
    polifenol: "7-hydroxyflavanone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "26651537",
  },
  {
    id: "540",
    id_polifenol: "376",
    polifenol: "4-vinylphenol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "29777274",
  },
  {
    id: "541",
    id_polifenol: "1624",
    polifenol: "hydrazinocurcumin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "22179587,23825527",
  },
  {
    id: "542",
    id_polifenol: "1865",
    polifenol: "4-chloro-2-cresol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "18431693",
  },
  {
    id: "543",
    id_polifenol: "5178",
    polifenol: "Flavin7",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "25930965",
  },
  {
    id: "544",
    id_polifenol: "5648",
    polifenol: "4'-O-methylepigallocatechin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "26401377",
  },
  {
    id: "545",
    id_polifenol: "90",
    polifenol: "Mexiletine",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "22879383,25011475",
  },
  {
    id: "546",
    id_polifenol: "4220",
    polifenol: "1,3-dihydroxy-5-(tridec-4',7'-dienyl)benzene",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "20617110",
  },
  {
    id: "547",
    id_polifenol: "4747",
    polifenol: "4'-bromoflavone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "9973203",
  },
  {
    id: "548",
    id_polifenol: "901",
    polifenol: "epicatechin dimer B2",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "12608775",
  },
  {
    id: "549",
    id_polifenol: "7066",
    polifenol: "diethyl flavon-7-yl phosphate",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "22677031,24615985",
  },
  {
    id: "550",
    id_polifenol: "4899",
    polifenol: "bavachin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "26419930",
  },
  {
    id: "551",
    id_polifenol: "3029",
    polifenol: "NCX 4040",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "21664138",
  },
  {
    id: "552",
    id_polifenol: "1021",
    polifenol: "bis(3,5-diiodo-2,4,6-trihydroxyphenyl)squaraine",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "28169351",
  },
  {
    id: "553",
    id_polifenol: "7435",
    polifenol: "kaempferol-3-O-(2,3-di-O-acetyl-alpha-l-rhamnopyranoside)",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "17512736,16723233",
  },
  {
    id: "554",
    id_polifenol: "4584",
    polifenol: "baohuosu",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "3",
    pmids: "19371773,15729618,22345291",
  },
  {
    id: "555",
    id_polifenol: "7047",
    polifenol: "irisflorentin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "22627971,15787436",
  },
  {
    id: "556",
    id_polifenol: "874",
    polifenol: "WAY 200070",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "28003019,23907354",
  },
  {
    id: "557",
    id_polifenol: "2080",
    polifenol: "2-methoxy-1,4-hydroquinone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "22334062",
  },
  {
    id: "558",
    id_polifenol: "4718",
    polifenol: "5,6,7-trimethoxyflavone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "27503682",
  },
  {
    id: "559",
    id_polifenol: "7618",
    polifenol: "8-methoxyquercetin-3-O-glucosyl-(1'''-2'')-O-glucoside",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "25984842,29166547",
  },
  {
    id: "560",
    id_polifenol: "2548",
    polifenol: "1,2,6-tri-O-galloyl-beta-D-glucopyranose",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "23123452",
  },
  {
    id: "561",
    id_polifenol: "5611",
    polifenol: "epiafzelechin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "12967197,23772110",
  },
  {
    id: "562",
    id_polifenol: "308",
    polifenol: "coniferyl alcohol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "21391655",
  },
  {
    id: "563",
    id_polifenol: "6804",
    polifenol: "calycosin-7-O-beta-D-glucoside",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "29523109",
  },
  {
    id: "564",
    id_polifenol: "1781",
    polifenol: "CA 432",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "23232969,21369694",
  },
  {
    id: "565",
    id_polifenol: "1640",
    polifenol: "2,6-bis-4-(hydroxy-3-methoxybenzylidene)cyclohexanone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "29556774",
  },
  {
    id: "566",
    id_polifenol: "4714",
    polifenol: "epimedin C",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "28659032",
  },
  {
    id: "567",
    id_polifenol: "381",
    polifenol: "4-bromophenol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "11879974,29958453",
  },
  {
    id: "568",
    id_polifenol: "4803",
    polifenol: "iriflophenone 2-O-glucopyranoside",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "15787436",
  },
  {
    id: "569",
    id_polifenol: "2570",
    polifenol: "ethyl-p-hydroxybenzoate",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "3",
    pmids: "11867263,25192815,27995640",
  },
  {
    id: "570",
    id_polifenol: "4649",
    polifenol: "centaureidin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "19639540",
  },
  {
    id: "571",
    id_polifenol: "6476",
    polifenol: "norwogonin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "17123821",
  },
  {
    id: "572",
    id_polifenol: "7223",
    polifenol: "hydnocarpin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "19026551",
  },
  {
    id: "573",
    id_polifenol: "4653",
    polifenol: "4',7-dihydroxyflavone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "18835421",
  },
  {
    id: "574",
    id_polifenol: "7635",
    polifenol: "quercetin-3-O-alpha-L-rhamnopyranoside",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "26922854",
  },
  {
    id: "575",
    id_polifenol: "4575",
    polifenol: "orobol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "14992594",
  },
  {
    id: "576",
    id_polifenol: "4299",
    polifenol: "taleranol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "15994033,19555691",
  },
  {
    id: "577",
    id_polifenol: "6152",
    polifenol: "5,7,4',5'',7'',3''',4'''-heptahydroxy(3-8'')biflavanone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "19742425",
  },
  {
    id: "578",
    id_polifenol: "1088",
    polifenol: "1-(3,5-dihydroxyphenyl)heptan-1-one",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "19833361",
  },
  {
    id: "579",
    id_polifenol: "32",
    polifenol: "Desvenlafaxine Succinate",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "20880642",
  },
  {
    id: "580",
    id_polifenol: "2285",
    polifenol: "lithospermic acid",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "26075899,23790919",
  },
  {
    id: "581",
    id_polifenol: "4072",
    polifenol: "elemicin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "20958014",
  },
  {
    id: "582",
    id_polifenol: "1468",
    polifenol: "plantamajoside",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "26674531",
  },
  {
    id: "583",
    id_polifenol: "1671",
    polifenol: "pentagamavunon-0",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "27268651,24528023",
  },
  {
    id: "584",
    id_polifenol: "4636",
    polifenol: "demethoxysudachitin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "27261599,26754253",
  },
  {
    id: "585",
    id_polifenol: "6211",
    polifenol: "4'-chloroflavanone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "20043141,25582302",
  },
  {
    id: "586",
    id_polifenol: "6243",
    polifenol: "thioflavanone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "22076075",
  },
  {
    id: "587",
    id_polifenol: "7051",
    polifenol: "thioflavone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "22076075",
  },
  {
    id: "588",
    id_polifenol: "4269",
    polifenol: "2-methoxy-4-hydroxy-6-pentadecyl-benzene-1-O-acetate",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "21751842,20617110",
  },
  {
    id: "589",
    id_polifenol: "5381",
    polifenol: "gancaonin Q",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "28522265",
  },
  {
    id: "590",
    id_polifenol: "5382",
    polifenol: "6-prenylapigenin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "17511007",
  },
  {
    id: "591",
    id_polifenol: "4627",
    polifenol: "aciculatin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "22272829",
  },
  {
    id: "592",
    id_polifenol: "3917",
    polifenol: "2,4-diacetylphloroglucinol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "26833196",
  },
  {
    id: "593",
    id_polifenol: "7691",
    polifenol:
      "quercetin 3-O-alpha-l-(2,4-di-O-acetyl)rhamnopyranoside-7-O-alpha-L-rhamnopyranoside",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "29382154",
  },
  {
    id: "594",
    id_polifenol: "5795",
    polifenol: "neohesperidin dihydrochalcone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "23562496",
  },
  {
    id: "595",
    id_polifenol: "4930",
    polifenol: "tetra-O-methylscutellarein",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "26569090",
  },
  {
    id: "596",
    id_polifenol: "768",
    polifenol: "eupomatenoid 5",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "25882683,21391177",
  },
  {
    id: "597",
    id_polifenol: "4196",
    polifenol: "ardisiphenol A",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "24392814",
  },
  {
    id: "598",
    id_polifenol: "2213",
    polifenol: "diffractaic acid",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "25233603",
  },
  {
    id: "599",
    id_polifenol: "5994",
    polifenol: "2-hydroxy-3',5,5'-trimethoxychalcone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "26742460,26602275",
  },
  {
    id: "600",
    id_polifenol: "7424",
    polifenol: "3,4'-dimethylkaempferol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "17335117",
  },
  {
    id: "601",
    id_polifenol: "5339",
    polifenol: "2S,3S-3,5,7,3',5'-pentahydroxyflavane",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "25298669",
  },
  {
    id: "602",
    id_polifenol: "5340",
    polifenol: "2R,3R-3,5,6,7,8,4'-hexahydroxyflavane",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "25298669",
  },
  {
    id: "603",
    id_polifenol: "4814",
    polifenol: "glabrol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "28522265,29150398",
  },
  {
    id: "604",
    id_polifenol: "5154",
    polifenol: "5,7-dihydroxy-8-nitrochrysin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "23425937,20878083",
  },
  {
    id: "605",
    id_polifenol: "4530",
    polifenol: "amentoflavone hexaacetate",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "29368952",
  },
  {
    id: "606",
    id_polifenol: "6337",
    polifenol: "3-fluoro-5-hydroxy-7-acetoxyflavone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "29116937",
  },
  {
    id: "607",
    id_polifenol: "171",
    polifenol: "p-decylaminophenol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "17092729",
  },
  {
    id: "608",
    id_polifenol: "3623",
    polifenol: "1,1-dichloro-2-(4-methoxyphenyl)-3-phenylcyclopropane",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "9158870",
  },
  {
    id: "609",
    id_polifenol: "7699",
    polifenol:
      "quercetin-3-O-beta-D-apiofuranosyl-(1-2)-beta-D-galactopyranosyl-7-O-beta-D-glucopyranoside",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "24047498",
  },
  {
    id: "610",
    id_polifenol: "5042",
    polifenol:
      "I-3, II-3, I-5, II-5, I-7, II-7, I-4', II-4'-octahydroxy (I-2', II-2') biflavone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "29968167,24716136",
  },
  {
    id: "611",
    id_polifenol: "7133",
    polifenol: "vitexin rhamnoside",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "16698256",
  },
  {
    id: "612",
    id_polifenol: "3167",
    polifenol: "4-(3,4,5-trimethoxyphenoxy)benzoic acid",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "24692713,24406729",
  },
  {
    id: "613",
    id_polifenol: "4977",
    polifenol: "artelastin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "15878357",
  },
  {
    id: "614",
    id_polifenol: "3798",
    polifenol: "n-hexyl vanillate",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "28920447",
  },
  {
    id: "615",
    id_polifenol: "4517",
    polifenol: "primetin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "11720850",
  },
  {
    id: "616",
    id_polifenol: "3225",
    polifenol: "decabromobiphenyl ether",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "22472210",
  },
  {
    id: "617",
    id_polifenol: "7485",
    polifenol:
      "kaempherol 3-O-beta-rhamnopyranosyl (1-6)-beta-D-glucopyranoside",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "22014228",
  },
  {
    id: "618",
    id_polifenol: "6292",
    polifenol: "tricin 4'-O-(threo-beta-guaiacylglyceryl) ether",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "23054487",
  },
  {
    id: "619",
    id_polifenol: "6293",
    polifenol: "tricin 4'-O-(erythro-beta-guaiacylglyceryl) ether",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "23054487",
  },
  {
    id: "620",
    id_polifenol: "7129",
    polifenol:
      "4-(5-acetyloxy-8,8-dimethyl-6-(3-methylbut-2-en-1-yl)-4-oxo-4,8-dihydropyrano(2,3-f)chromen-3-yl)-1,2-phenylene diacetate",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "27376493",
  },
  {
    id: "621",
    id_polifenol: "5346",
    polifenol: "sideroxylin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "26086179",
  },
  {
    id: "622",
    id_polifenol: "4716",
    polifenol: "5,4'-diamino-6,8,3'-trifluoroflavone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "9191967,9622547",
  },
  {
    id: "623",
    id_polifenol: "7877",
    polifenol: "helichrysetin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "23533528",
  },
  {
    id: "624",
    id_polifenol: "6683",
    polifenol: "5,7,4'-trihydroxy-3'-(3-hydroxy-3-methylbutyl)isoflavone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "29197545,15938138",
  },
  {
    id: "625",
    id_polifenol: "5800",
    polifenol: "chalcone epoxide",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "21816519",
  },
  {
    id: "626",
    id_polifenol: "3994",
    polifenol: "4-geranyloxy-1-(2-methylbutanoyl)phloroglucinol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "19441072",
  },
  {
    id: "627",
    id_polifenol: "714",
    polifenol: "3-(4-hydroxyphenyl)propanol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "15635150",
  },
  {
    id: "628",
    id_polifenol: "7574",
    polifenol: "quercimeritrin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "22906240",
  },
  {
    id: "629",
    id_polifenol: "7561",
    polifenol: "3,7-dimethoxy-5,3',4'-trihydroxyflavone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "28294989",
  },
  {
    id: "630",
    id_polifenol: "6912",
    polifenol: "8-prenylapigenin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "19371773",
  },
  {
    id: "631",
    id_polifenol: "3691",
    polifenol: "2-(4-(2,2-dichlorocyclopropyl)phenoxy)propane",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "9158870",
  },
  {
    id: "632",
    id_polifenol: "7195",
    polifenol: "6-hydroxyluteolin-7-O-glucoside",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "25509294",
  },
  {
    id: "633",
    id_polifenol: "2229",
    polifenol: "gamma-resorcylic acid",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "18537201",
  },
  {
    id: "634",
    id_polifenol: "4308",
    polifenol: "11-alpha-methoxycurvularin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "26411029",
  },
  {
    id: "635",
    id_polifenol: "1416",
    polifenol: "3,4,5-trichlorocatechol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "15720130",
  },
  {
    id: "636",
    id_polifenol: "3992",
    polifenol: "4-geranyloxy-2,6-dihydroxybenzophenone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "19441072,16562847",
  },
  {
    id: "637",
    id_polifenol: "3993",
    polifenol: "4-geranyloxy-1-(2-methylpropanoyl)phloroglucinol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "19441072",
  },
  {
    id: "638",
    id_polifenol: "4498",
    polifenol: "tanacin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "19639540",
  },
  {
    id: "639",
    id_polifenol: "5558",
    polifenol: "cyanidin 3-sambubioside",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "24214832",
  },
  {
    id: "640",
    id_polifenol: "941",
    polifenol: "caftaric acid",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "25554015",
  },
  {
    id: "641",
    id_polifenol: "7779",
    polifenol: "cristacarpin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "27246693",
  },
  {
    id: "642",
    id_polifenol: "2576",
    polifenol: "benzylparaben",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "12518336,22917524",
  },
  {
    id: "643",
    id_polifenol: "6314",
    polifenol: "2-(4-(dimethylamino)phenyl)-7,8-dihydroxy-4H-chromen-4-one",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "22768128",
  },
  {
    id: "644",
    id_polifenol: "508",
    polifenol: "lophirachalcone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "21315392",
  },
  {
    id: "645",
    id_polifenol: "7201",
    polifenol: "luteolin 8-C-rhamnoside-7-O-rhamnoside",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "21315392",
  },
  {
    id: "646",
    id_polifenol: "2848",
    polifenol: "3-methoxysalicylic acid",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "22313179",
  },
  {
    id: "647",
    id_polifenol: "13",
    polifenol: "Guaifenesin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "21184665",
  },
  {
    id: "648",
    id_polifenol: "1669",
    polifenol:
      "5-hydroxy-1-(4-hydroxy-3-methoxyphenyl)-7-(5-methylfuran-2-yl)hepta-1,4,6-trien-3-one",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "27293144",
  },
  {
    id: "649",
    id_polifenol: "277",
    polifenol: "2,4,6-tribromophenol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "11879974",
  },
  {
    id: "650",
    id_polifenol: "7677",
    polifenol:
      "2-(3',4'-dihydroxyphenyl)-5,7-dihydroxy-3-(2'',6''-di-O-(3'''-(4-fluorophenylpropanoyl)))galactosyl-4H-chromen-4-one",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "25172420",
  },
  {
    id: "651",
    id_polifenol: "5832",
    polifenol: "2-chloro-1,3-diphenyl-2-propen-1-one",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "8702221,9216636",
  },
  {
    id: "652",
    id_polifenol: "1260",
    polifenol: "4,4'-thiodiphenol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "27880919,25192815",
  },
  {
    id: "653",
    id_polifenol: "5140",
    polifenol: "5-hydroxy-6,7-dimethoxyflavone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "27503682,21351299",
  },
  {
    id: "654",
    id_polifenol: "7324",
    polifenol: "glycinol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "19116342",
  },
  {
    id: "655",
    id_polifenol: "6193",
    polifenol: "naringenin-7-O-glucoside",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "18074851",
  },
  {
    id: "656",
    id_polifenol: "7532",
    polifenol: "7-O-butylquercetin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "26415619,27980567",
  },
  {
    id: "657",
    id_polifenol: "5413",
    polifenol: "derrone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "26983907",
  },
  {
    id: "658",
    id_polifenol: "7585",
    polifenol: "quercetin 7-O-glucopyranoside",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "27956098",
  },
  {
    id: "659",
    id_polifenol: "7207",
    polifenol: "luteolin 4'-O-glucoside",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "29179615",
  },
  {
    id: "660",
    id_polifenol: "5812",
    polifenol: "3,5-di-tert-butylchalcone 4'-carboxylic acid",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "9099955",
  },
  {
    id: "661",
    id_polifenol: "586",
    polifenol: "1-(4-hydroxyphenyl)-1,2-diphenyl-1-butene",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "17992292,11485868",
  },
  {
    id: "662",
    id_polifenol: "6327",
    polifenol: "6-methoxyflavone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "19592245",
  },
  {
    id: "663",
    id_polifenol: "5586",
    polifenol: "3',4'-dimethoxy-alpha-naphthoflavone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "22235307",
  },
  {
    id: "664",
    id_polifenol: "4612",
    polifenol: "pseudosemiglabrin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "24608571",
  },
  {
    id: "665",
    id_polifenol: "4992",
    polifenol: "acacetin-7-O-glucoside",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "22732304",
  },
  {
    id: "666",
    id_polifenol: "6990",
    polifenol:
      "5-hydroxy-2-(4-hydroxy-3-methoxyphenyl)-3,7-dimethoxy-4H-chromen-4-one",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "28282562",
  },
  {
    id: "667",
    id_polifenol: "4602",
    polifenol: "sigmoidin B",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "26344038",
  },
  {
    id: "668",
    id_polifenol: "1871",
    polifenol: "2-cresol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "23612925",
  },
  {
    id: "669",
    id_polifenol: "904",
    polifenol: "afzelechin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "23772110",
  },
  {
    id: "670",
    id_polifenol: "6918",
    polifenol: "6-hydroxygenistein-7-O-beta-D-glucopyranoside",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "19996686",
  },
  {
    id: "671",
    id_polifenol: "7642",
    polifenol: "quercetin-4'-O-beta-D-galactoside",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "28539711",
  },
  {
    id: "672",
    id_polifenol: "7592",
    polifenol: "5,7,3',4'-tetramethylquercetin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "25906385",
  },
  {
    id: "673",
    id_polifenol: "20",
    polifenol: "Cresols",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "21227691",
  },
  {
    id: "674",
    id_polifenol: "2202",
    polifenol: "4-(2,6-dihydroxybenzoyl)-3-formyl-5-hydroxybenzoic acid",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "2071487,17580843",
  },
  {
    id: "675",
    id_polifenol: "4095",
    polifenol: "1-(3,4,5-trihydroxyphenyl)nonan-1-one",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "19833361",
  },
  {
    id: "676",
    id_polifenol: "7651",
    polifenol: "quercetin 3-O-(2''-galloyl)glucopyranoside",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "15730249",
  },
  {
    id: "677",
    id_polifenol: "7751",
    polifenol: "8-(1,1-dimethylallyl)genistein",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "15056864,19733663",
  },
  {
    id: "678",
    id_polifenol: "1978",
    polifenol: "subereaphenol C",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "25812033",
  },
  {
    id: "679",
    id_polifenol: "6256",
    polifenol: "(2S)-3',4',5'-trimethoxyflavanone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "15202555",
  },
  {
    id: "680",
    id_polifenol: "4529",
    polifenol: "ganhuangenin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "16545824",
  },
  {
    id: "681",
    id_polifenol: "5479",
    polifenol: "cyanidin 3-O-glucopyranoside",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "20121190",
  },
  {
    id: "682",
    id_polifenol: "6119",
    polifenol: "6-(1,1-dimethylallyl)naringenin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "19733663",
  },
  {
    id: "683",
    id_polifenol: "67",
    polifenol: "Phenolphthaleins",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "3620717",
  },
  {
    id: "684",
    id_polifenol: "6543",
    polifenol: "euchrenone b10",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "19252325",
  },
  {
    id: "685",
    id_polifenol: "4848",
    polifenol: "4'-hydroxy-7-methoxyflavan",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "19471882",
  },
  {
    id: "686",
    id_polifenol: "1506",
    polifenol: "4-ethylcatechol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "29058874",
  },
  {
    id: "687",
    id_polifenol: "2737",
    polifenol: "homosalate",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "2",
    pmids: "28990245,11333184",
  },
  {
    id: "688",
    id_polifenol: "7576",
    polifenol: "quercetin-3-O-glucopyranosyl-1-2-xylopyranoside",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "22888534",
  },
  {
    id: "689",
    id_polifenol: "1502",
    polifenol: "artochamin H",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "15165133",
  },
  {
    id: "690",
    id_polifenol: "345",
    polifenol: "2,4,6-trichlorophenol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "2479123",
  },
  {
    id: "691",
    id_polifenol: "4775",
    polifenol: "I3,II8-binaringenin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "16163823",
  },
  {
    id: "692",
    id_polifenol: "583",
    polifenol: "2-fluoro-4-nitrophenol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "16916713",
  },
  {
    id: "693",
    id_polifenol: "7555",
    polifenol: "3,3'-di-O-methylquercetin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "22418930",
  },
  {
    id: "694",
    id_polifenol: "5463",
    polifenol: "triticuside A",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "23909734",
  },
  {
    id: "695",
    id_polifenol: "2485",
    polifenol: "rugosin E",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "16963181",
  },
  {
    id: "696",
    id_polifenol: "2891",
    polifenol: "amorfrutin B",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "26731300",
  },
  {
    id: "697",
    id_polifenol: "7750",
    polifenol: "2'-hydroxy-genistein",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "29552162",
  },
  {
    id: "698",
    id_polifenol: "5773",
    polifenol: "paratocarpin E",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "27814565",
  },
  {
    id: "699",
    id_polifenol: "4004",
    polifenol:
      "1-(3',5'-dihydroxyphenoxy)-7-(2',4',6-trihydroxyphenoxy)-2,4,9-trihydroxydibenzo-1,4-dioxin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "19393283",
  },
  {
    id: "700",
    id_polifenol: "6167",
    polifenol: "dichamanetin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "24324069",
  },
  {
    id: "701",
    id_polifenol: "7684",
    polifenol: "quercetin-5',8-disulfonate",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "22310237",
  },
  {
    id: "702",
    id_polifenol: "6358",
    polifenol: "5-acetyl-6,7,8,4'-tetramethylnortangeretin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "24938898",
  },
  {
    id: "703",
    id_polifenol: "2238",
    polifenol: "benzyl 2-hydroxy-3,6-dimethoxybenzoate",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "23958424",
  },
  {
    id: "704",
    id_polifenol: "3753",
    polifenol: "benzyl-2,6-dimethoxybenzoate",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "23958424",
  },
  {
    id: "705",
    id_polifenol: "1919",
    polifenol: "MON 0585",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "27068261",
  },
  {
    id: "706",
    id_polifenol: "4065",
    polifenol: "propofol stearate",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "23749903",
  },
  {
    id: "707",
    id_polifenol: "408",
    polifenol: "2-bromo-(4-hydroxyphenyl)-1-propene",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "27174797",
  },
  {
    id: "708",
    id_polifenol: "6318",
    polifenol: "2',3',4'-trihydroxyflavone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "29215574",
  },
  {
    id: "709",
    id_polifenol: "6331",
    polifenol: "sigmoidin H",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "24252341",
  },
  {
    id: "710",
    id_polifenol: "1816",
    polifenol: "4-(2,4-dichlorophenoxy)butyric acid",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "24163404",
  },
  {
    id: "711",
    id_polifenol: "5252",
    polifenol: "SR 13179",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "19751965",
  },
  {
    id: "712",
    id_polifenol: "5693",
    polifenol: "YK-3-237",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "23846322",
  },
  {
    id: "713",
    id_polifenol: "5072",
    polifenol: "desmethylicaritin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "16323292",
  },
  {
    id: "714",
    id_polifenol: "5104",
    polifenol: "sudachitin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "22438130",
  },
  {
    id: "715",
    id_polifenol: "6573",
    polifenol: "glisoflavanone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "28522265",
  },
  {
    id: "716",
    id_polifenol: "5297",
    polifenol: "semilicoisoflavone B",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "28522265",
  },
  {
    id: "717",
    id_polifenol: "4034",
    polifenol: "moronone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "23245650",
  },
  {
    id: "718",
    id_polifenol: "5001",
    polifenol: "dorsmanin F",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "26141760",
  },
  {
    id: "719",
    id_polifenol: "5732",
    polifenol: "poinsettifolin B",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "26141760",
  },
  {
    id: "720",
    id_polifenol: "6319",
    polifenol: "5,6-dihydroxy-7-prenyloxyflavone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "24398107",
  },
  {
    id: "721",
    id_polifenol: "6320",
    polifenol: "3-hydroxy-7-geranyloxyflavone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "24398107",
  },
  {
    id: "722",
    id_polifenol: "5881",
    polifenol: "2',3,4,4'-tetrahydroxy-5-prenylchalcone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "10418944",
  },
  {
    id: "723",
    id_polifenol: "4746",
    polifenol: "sophoflavescenol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "22210035",
  },
  {
    id: "724",
    id_polifenol: "1574",
    polifenol: "dohevanil",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "16260002",
  },
  {
    id: "725",
    id_polifenol: "6515",
    polifenol: "sigmoidin I",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "25034000",
  },
  {
    id: "726",
    id_polifenol: "6259",
    polifenol: "7-methylaromadendrin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "18508214",
  },
  {
    id: "727",
    id_polifenol: "5286",
    polifenol:
      "5,4'-dihydroxy-7,8-((3''-hydroxy-4''-one)-2'',2''-dimethylpyrano)flavone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "26655407",
  },
  {
    id: "728",
    id_polifenol: "5550",
    polifenol: "prodelphinidin B2 3,3' di-O-gallate",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "15525446",
  },
  {
    id: "729",
    id_polifenol: "5331",
    polifenol: "kazinol Q",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "23447335",
  },
  {
    id: "730",
    id_polifenol: "808",
    polifenol: "4-(7-hydroxy-2,2,4-trimethyl-chroman-4-yl)benzene-1,3-diol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "23447335",
  },
  {
    id: "731",
    id_polifenol: "6699",
    polifenol: "4'-O-methylalpinumisoflavone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "19091749",
  },
  {
    id: "732",
    id_polifenol: "895",
    polifenol: "4-mercaptophenol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "24658418",
  },
  {
    id: "733",
    id_polifenol: "4650",
    polifenol: "dibutyltin 3-hydroxyflavone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "24658418",
  },
  {
    id: "734",
    id_polifenol: "843",
    polifenol: "5-chlorobiphenyl-2,4'-diol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "23431460",
  },
  {
    id: "735",
    id_polifenol: "6462",
    polifenol: "nevadensin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "27671497",
  },
  {
    id: "736",
    id_polifenol: "3136",
    polifenol: "5-octylphenol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "9631496",
  },
  {
    id: "737",
    id_polifenol: "6072",
    polifenol: "3'-prenylnaringenin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "24443427",
  },
  {
    id: "738",
    id_polifenol: "5783",
    polifenol: "TUB099",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "27224920",
  },
  {
    id: "739",
    id_polifenol: "5211",
    polifenol: "ugonin K",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "23662114",
  },
  {
    id: "740",
    id_polifenol: "1345",
    polifenol: "sonnerphenolic C",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "25933595",
  },
  {
    id: "741",
    id_polifenol: "2872",
    polifenol: "norstictic acid",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "25233603",
  },
  {
    id: "742",
    id_polifenol: "4310",
    polifenol: "desmethyl-lasiodiplodin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "23764760",
  },
  {
    id: "743",
    id_polifenol: "3967",
    polifenol: "prolifenone A",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "17125240",
  },
  {
    id: "744",
    id_polifenol: "3968",
    polifenol: "prolifenone B",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "17125240",
  },
  {
    id: "745",
    id_polifenol: "3966",
    polifenol: "prolificin A",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "17125240",
  },
  {
    id: "746",
    id_polifenol: "488",
    polifenol: "2-(2-hydroxyphenyl)benzothiazole",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "8201603",
  },
  {
    id: "747",
    id_polifenol: "7761",
    polifenol: "ITB 301",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "21340606",
  },
  {
    id: "748",
    id_polifenol: "3906",
    polifenol: "hyperforin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "21751836",
  },
  {
    id: "749",
    id_polifenol: "3936",
    polifenol: "sideroxylonal C",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "24986654",
  },
  {
    id: "750",
    id_polifenol: "7086",
    polifenol: "5,7,3',5'-tetrahydroxy-6,4'-dimethoxyflavone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "25295671",
  },
  {
    id: "751",
    id_polifenol: "5020",
    polifenol: "griffonianone D",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "21284537",
  },
  {
    id: "752",
    id_polifenol: "1006",
    polifenol:
      "6-(4-((1E)-2-(3,5-dihydroxyphenyl)ethenyl)phenoxy)hexanoic acid",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "26666272",
  },
  {
    id: "753",
    id_polifenol: "1217",
    polifenol:
      "1-(5-(5-chloro-2-hydroxyphenyl)-3-(p-tolyl)-4,5-dihydro-1H-pyrazol-1-yl)ethanone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "22985957",
  },
  {
    id: "754",
    id_polifenol: "1218",
    polifenol:
      "1-(3-(4-chlorophenyl)-5-(3,5-dibromo-2-hydroxyphenyl)-4,5-dihydro-1H-pyrazol-1-yl)ethanone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "22985957",
  },
  {
    id: "755",
    id_polifenol: "5078",
    polifenol: "6-prenylchrysin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "15930306",
  },
  {
    id: "756",
    id_polifenol: "4623",
    polifenol: "myricetin 3-O-glucuronide",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "19731038",
  },
  {
    id: "757",
    id_polifenol: "7311",
    polifenol: "engeletin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "21315392",
  },
  {
    id: "758",
    id_polifenol: "3544",
    polifenol: "3-hydroxyanisole",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "28561221",
  },
  {
    id: "759",
    id_polifenol: "574",
    polifenol:
      "N-butyl-N-methyl-13,14-bis(4'-hydroxyphenyl)-12-thiatetradecanamide",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "8164253",
  },
  {
    id: "760",
    id_polifenol: "7766",
    polifenol: "11a-N-tosyl-5-deoxi-pterocarpan",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "27520309",
  },
  {
    id: "761",
    id_polifenol: "6899",
    polifenol: "isocannflavin B",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "19371773",
  },
  {
    id: "762",
    id_polifenol: "2712",
    polifenol: "benzyl salicylate",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "19338011",
  },
  {
    id: "763",
    id_polifenol: "6591",
    polifenol: "irilin A",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "22627971",
  },
  {
    id: "764",
    id_polifenol: "1813",
    polifenol: "maltose-tri-O-methyl nordihydroguaiaretic acid",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "16544145",
  },
  {
    id: "765",
    id_polifenol: "7299",
    polifenol: "isorhamnetin-7-O-beta-gentiobioside",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "16698256",
  },
  {
    id: "766",
    id_polifenol: "5450",
    polifenol: "linderone A",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "23173924",
  },
  {
    id: "767",
    id_polifenol: "4121",
    polifenol: "CPUY201112",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "26743233",
  },
  {
    id: "768",
    id_polifenol: "7461",
    polifenol: "kaempferol-3-O-alpha-L-(6''-methyl)-rhamnopyranoside",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "16723233",
  },
  {
    id: "769",
    id_polifenol: "7068",
    polifenol:
      "3-O-(4'-O-acetyl)rhamnopyranoside-(I-6,II-8)-kaempferol-3-O-(4'-O-acetyl)rhamnopyranoside",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "16723233",
  },
  {
    id: "770",
    id_polifenol: "4223",
    polifenol: "globosumone C",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "15921417",
  },
  {
    id: "771",
    id_polifenol: "27",
    polifenol: "Cyclofenil",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "28858267",
  },
  {
    id: "772",
    id_polifenol: "7220",
    polifenol: "luteolin 3',7-di-O-glucoside",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "25509294",
  },
  {
    id: "773",
    id_polifenol: "7845",
    polifenol: "selligueain A",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "12967197",
  },
  {
    id: "774",
    id_polifenol: "4175",
    polifenol: "3,5-dihydroxy-4-isopropylstilbene",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "23861102",
  },
  {
    id: "775",
    id_polifenol: "567",
    polifenol: "2,3,4,5,6-pentafluorophenol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "17499915",
  },
  {
    id: "776",
    id_polifenol: "1705",
    polifenol: "hylin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "20696583",
  },
  {
    id: "777",
    id_polifenol: "3475",
    polifenol: "homoegonol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "25795470",
  },
  {
    id: "778",
    id_polifenol: "4798",
    polifenol: "3',5-dihydroxy-3,4'5',7-tetramethoxyflavone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "22115493",
  },
  {
    id: "779",
    id_polifenol: "6249",
    polifenol: "eriodictyol-3',7-dimethoxy-4'-O-beta-D-glucoside",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "18074851",
  },
  {
    id: "780",
    id_polifenol: "6532",
    polifenol: "muscomin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "26147490",
  },
  {
    id: "781",
    id_polifenol: "3543",
    polifenol: "LG 100127",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "7700260",
  },
  {
    id: "782",
    id_polifenol: "7364",
    polifenol:
      "kaempferol-3-O-(2'(4-acetylrhamnopyranosyl)-3'-galactopyranosyl)robinobioside",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "23679992",
  },
  {
    id: "783",
    id_polifenol: "6915",
    polifenol: "luteolin 5-O-glucopyranoside",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "25473363",
  },
  {
    id: "784",
    id_polifenol: "5371",
    polifenol: "chrysosplenetin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "26115782",
  },
  {
    id: "785",
    id_polifenol: "7325",
    polifenol: "3-hydroxy-kenusanone B",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "17719612",
  },
  {
    id: "786",
    id_polifenol: "6513",
    polifenol: "sophorol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "17719612",
  },
  {
    id: "787",
    id_polifenol: "5195",
    polifenol: "3'-O-methylorobol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "17719612",
  },
  {
    id: "788",
    id_polifenol: "7281",
    polifenol: "hovenitin I",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "17719612",
  },
  {
    id: "789",
    id_polifenol: "3737",
    polifenol: "4-anisic acid",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "17719612",
  },
  {
    id: "790",
    id_polifenol: "4697",
    polifenol: "4'-iodoflavone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "8866830",
  },
  {
    id: "791",
    id_polifenol: "7740",
    polifenol: "8-methoxycoumestrol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "19634327",
  },
  {
    id: "792",
    id_polifenol: "4686",
    polifenol: "podocarpusflavone A",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "24716136",
  },
  {
    id: "793",
    id_polifenol: "1856",
    polifenol: "4-nitro-3-cresol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "18439640",
  },
  {
    id: "794",
    id_polifenol: "849",
    polifenol: "4-nitro-3-phenylphenol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "18439640",
  },
  {
    id: "795",
    id_polifenol: "6523",
    polifenol: "kievitone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "7794275",
  },
  {
    id: "796",
    id_polifenol: "6514",
    polifenol: "vestitone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "19928832",
  },
  {
    id: "797",
    id_polifenol: "6480",
    polifenol: "6,7-dihydroxy-4'-methoxyisoflavanone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "19928832",
  },
  {
    id: "798",
    id_polifenol: "6768",
    polifenol:
      "chrysoeriol 7-O-(2'''-O-caffeoyl-beta-D-glucopyranosyl-(1-2)-beta-d-glucopyranoside)",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "28222613",
  },
  {
    id: "799",
    id_polifenol: "2297",
    polifenol: "3'-O-beta-D-glucopyranosyl rosmarinic acid",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "28222613",
  },
  {
    id: "800",
    id_polifenol: "1717",
    polifenol: "4-vinylguaiacol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "29164418",
  },
  {
    id: "801",
    id_polifenol: "320",
    polifenol: "2,4-dibromophenol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "11879974",
  },
  {
    id: "802",
    id_polifenol: "4097",
    polifenol:
      "2-(2,4-dihydroxyphenyl)-3-formyl-4-hydroxy-6-methoxy-5-(3-methylbuten-2-yl)benzofuran",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "15579325",
  },
  {
    id: "803",
    id_polifenol: "5290",
    polifenol: "(2'R)-4'-hydroxyemoroidocarpan",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "20804165",
  },
  {
    id: "804",
    id_polifenol: "5292",
    polifenol: "pongavilleanine",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "20804165",
  },
  {
    id: "805",
    id_polifenol: "5291",
    polifenol: "epipervilline",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "20804165",
  },
  {
    id: "806",
    id_polifenol: "7401",
    polifenol:
      "kaempferol-3-O-glucopyranoside-6''-(3-hydroxy-3-methyl glutarate)-7-O-glucopyranoside",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "16968064",
  },
  {
    id: "807",
    id_polifenol: "770",
    polifenol:
      "3,5-dihydroxy-1-(3,4-dihydroxyphenyl)-7-(4-hydroxyphenyl)heptane",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "28258038",
  },
  {
    id: "808",
    id_polifenol: "2896",
    polifenol: "BP-1-102",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "29541369",
  },
  {
    id: "809",
    id_polifenol: "864",
    polifenol: "belalloside A",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "15787436",
  },
  {
    id: "810",
    id_polifenol: "865",
    polifenol: "belalloside B",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "15787436",
  },
  {
    id: "811",
    id_polifenol: "866",
    polifenol: "belamphenone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "15787436",
  },
  {
    id: "812",
    id_polifenol: "6589",
    polifenol: "irilin D",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "15787436",
  },
  {
    id: "813",
    id_polifenol: "3045",
    polifenol: "3-O-(2'-acetoxy)benzoyl-2-glucopyranose",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "22494617",
  },
  {
    id: "814",
    id_polifenol: "6972",
    polifenol: "aromadendrin 3-O-beta-D-glucopyranoside",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "28108382",
  },
  {
    id: "815",
    id_polifenol: "736",
    polifenol: "1,2,4,5-tetrahydroxybenzene",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "28108382",
  },
  {
    id: "816",
    id_polifenol: "7456",
    polifenol:
      "7-O-alpha-L-rhamnopyranosyl-kaempferol-3-O-beta-D-glucopyranoside",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "22281382",
  },
  {
    id: "817",
    id_polifenol: "2801",
    polifenol: "2-hydroxybenzoic acid 3-nitrooxymethylphenyl ester",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "21664138",
  },
  {
    id: "818",
    id_polifenol: "1588",
    polifenol:
      "2- ((4-hydroxy-3,5-dimethylphenyl)methylidene)-5-((3-methoxy-4,5-dimethylphenyl)methylidene)cyclopentan-1-one",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "28258688",
  },
  {
    id: "819",
    id_polifenol: "7484",
    polifenol: "3-O-kaempferol 4-O-(galloyl)-beta-D-glucoside",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "28539711",
  },
  {
    id: "820",
    id_polifenol: "5427",
    polifenol: "patriscabratine",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "22906240",
  },
  {
    id: "821",
    id_polifenol: "4564",
    polifenol: "abyssinone V",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "22079771",
  },
  {
    id: "822",
    id_polifenol: "7426",
    polifenol: "6-hydroxykaempferol-3-O-glucoside",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "29884381",
  },
  {
    id: "823",
    id_polifenol: "4535",
    polifenol: "LM 985",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "3653209",
  },
  {
    id: "824",
    id_polifenol: "4609",
    polifenol: "4',7-dihydroxy-3-methoxy-5,6-dimethylflavone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "28800661",
  },
  {
    id: "825",
    id_polifenol: "5502",
    polifenol: "leucopelargonin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "3386279",
  },
  {
    id: "826",
    id_polifenol: "298",
    polifenol: "4-nitrophenyl acetate",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "22917524",
  },
  {
    id: "827",
    id_polifenol: "2740",
    polifenol: "4-azidosalicylic acid",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "11709193",
  },
  {
    id: "828",
    id_polifenol: "7836",
    polifenol: "erosone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "24354192",
  },
  {
    id: "829",
    id_polifenol: "6125",
    polifenol: "5,6,7,4'-tetramethoxyflavanone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "15202555",
  },
  {
    id: "830",
    id_polifenol: "3530",
    polifenol: "3',4-O-dimethylcedrusin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "29715541",
  },
  {
    id: "831",
    id_polifenol: "7606",
    polifenol: "quercetin pentaacetate",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "26344038",
  },
  {
    id: "832",
    id_polifenol: "6185",
    polifenol: "5,7,2',6'-tetrahydroxy-6-lavandulylated-flavanone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "16545824",
  },
  {
    id: "833",
    id_polifenol: "6583",
    polifenol: "bolusanthol C",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "16545824",
  },
  {
    id: "834",
    id_polifenol: "7439",
    polifenol: "kaempferol-3-beta-D-(6-O-trans-p-coumaroyl)glucopyranoside",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "27232543",
  },
  {
    id: "835",
    id_polifenol: "7559",
    polifenol:
      "quercetin 3-O-alpha-rhamnopyranosyl-(1-2)-beta-galactopyranoside",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "20121190",
  },
  {
    id: "836",
    id_polifenol: "5403",
    polifenol: "sinapyl alcohol 9-O-(E)-p-coumaroyl-4-O-beta-D-glucopyanoside",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "21657076",
  },
  {
    id: "837",
    id_polifenol: "5459",
    polifenol:
      "5,7-dihydroxy-2-(1,2-isopropyldioxy-4-oxo-cyclohex-5-enyl)-chromen-4-one",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "21657076",
  },
  {
    id: "838",
    id_polifenol: "6025",
    polifenol:
      "5-hydroxy-2-(1'-hydroxy-4'-oxo-cyclohex-2'-en-1'-yl)-6,7-dimethoxy-2,3-dihydro-4H-chromen-4-one",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "21657076",
  },
  {
    id: "839",
    id_polifenol: "5561",
    polifenol: "cyaniding 3-glucoside",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "24312561",
  },
  {
    id: "840",
    id_polifenol: "1465",
    polifenol: "3-demethoxy-3'-O-demethylmatairesinol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "8049151",
  },
  {
    id: "841",
    id_polifenol: "708",
    polifenol: "3'-demethoxysecoisolariciresinol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "8049151",
  },
  {
    id: "842",
    id_polifenol: "4354",
    polifenol: "alopecurone A",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "27696895",
  },
  {
    id: "843",
    id_polifenol: "5227",
    polifenol: "breviflavone A",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "15729618",
  },
  {
    id: "844",
    id_polifenol: "1379",
    polifenol: "4-chlorocatechol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "15720130",
  },
  {
    id: "845",
    id_polifenol: "1470",
    polifenol: "4,5-dichlorocatechol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "15720130",
  },
  {
    id: "846",
    id_polifenol: "1469",
    polifenol: "3,4,5,6-tetrachlorocatechol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "15720130",
  },
  {
    id: "847",
    id_polifenol: "1007",
    polifenol: "3-hydroxybisphenol A",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "11465389",
  },
  {
    id: "848",
    id_polifenol: "4487",
    polifenol: "apiin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "10923837",
  },
  {
    id: "849",
    id_polifenol: "3114",
    polifenol: "phenolphthalein glucuronide",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "3620717",
  },
  {
    id: "850",
    id_polifenol: "6471",
    polifenol: "dichotomitin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "29656660",
  },
  {
    id: "851",
    id_polifenol: "6474",
    polifenol: "irisone B",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "29656660",
  },
  {
    id: "852",
    id_polifenol: "7760",
    polifenol: "3',8-dichlorogenistein",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "20028010",
  },
  {
    id: "853",
    id_polifenol: "7759",
    polifenol: "8-chlorogenistein",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "20028010",
  },
  {
    id: "854",
    id_polifenol: "2501",
    polifenol: "4,6-O-isoterchebuloylglucose",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "11277742",
  },
  {
    id: "855",
    id_polifenol: "3452",
    polifenol: "2,2',4,5'-tetrabromodiphenyl ether",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "26988655",
  },
  {
    id: "856",
    id_polifenol: "6581",
    polifenol: "bolusanthol A",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "27604296",
  },
  {
    id: "857",
    id_polifenol: "1614",
    polifenol: "curcumin 4,4'-diacetate",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "29719770",
  },
  {
    id: "858",
    id_polifenol: "386",
    polifenol: "2-sec-butylphenol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "21990277",
  },
  {
    id: "859",
    id_polifenol: "1210",
    polifenol: "2,3,5-tris(2-fluoro-4-hydroxyphenyl)-1-propyl-1H-pyrrole",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "21990277",
  },
  {
    id: "860",
    id_polifenol: "2058",
    polifenol: "2-chloro-1,4-hydroxyquinone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "22481537",
  },
  {
    id: "861",
    id_polifenol: "1893",
    polifenol: "2,6-diformyl-4-methylphenol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "18037489",
  },
  {
    id: "862",
    id_polifenol: "2718",
    polifenol: "1,1,1-tris(5-methoxysalicylaldiminomethyl)ethane",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "28923384",
  },
  {
    id: "863",
    id_polifenol: "4924",
    polifenol: "6-methylapigenin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "25239551",
  },
  {
    id: "864",
    id_polifenol: "4343",
    polifenol: "3-cinnamoyltribuloside",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "25348942",
  },
  {
    id: "865",
    id_polifenol: "5982",
    polifenol: "2-chloro-4',6'-dimethoxy-2'-hydroxychalcone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "22239485",
  },
  {
    id: "866",
    id_polifenol: "5085",
    polifenol: "myristinin D",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "19471882",
  },
  {
    id: "867",
    id_polifenol: "5075",
    polifenol: "myristinin A",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "19471882",
  },
  {
    id: "868",
    id_polifenol: "7769",
    polifenol: "maackiapterocarpan B",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "19252325",
  },
  {
    id: "869",
    id_polifenol: "694",
    polifenol: "4,4'-bis(2,6-di-tert-butylphenol)",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "23052471",
  },
  {
    id: "870",
    id_polifenol: "5102",
    polifenol: "chamaejasmine",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "29403376",
  },
  {
    id: "871",
    id_polifenol: "4318",
    polifenol: "linobiflavonoid",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "24047498",
  },
  {
    id: "872",
    id_polifenol: "5694",
    polifenol:
      "8-(3-(4-(diethylamino)phenyl)acryloyl)-2,2-dimethyl-2H-chromen-5-yl propionate",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "28292025",
  },
  {
    id: "873",
    id_polifenol: "5570",
    polifenol: "oxovitisin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "27165855",
  },
  {
    id: "874",
    id_polifenol: "7150",
    polifenol: "apigenin-7-O-rutinoside",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "23790919",
  },
  {
    id: "875",
    id_polifenol: "652",
    polifenol: "2-O-methylpyrogallol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "20958014",
  },
  {
    id: "876",
    id_polifenol: "614",
    polifenol: "4-propylphenol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "12547330",
  },
  {
    id: "877",
    id_polifenol: "5903",
    polifenol: "2',4'-dihydroxy-3'-(2-hydroxybenzyl)-6'-methoxychalcone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "16833018",
  },
  {
    id: "878",
    id_polifenol: "1140",
    polifenol: "4-(((2-(benzyloxy)phenyl)methyl)amino)phenol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "1995907",
  },
  {
    id: "879",
    id_polifenol: "961",
    polifenol: "5-ethyl-1,2,4-tris(4-hydroxyphenyl)-1H-imidazole",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "17352461",
  },
  {
    id: "880",
    id_polifenol: "5493",
    polifenol: "paeonin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "25068201",
  },
  {
    id: "881",
    id_polifenol: "1036",
    polifenol: "3-pentadecylphenol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "26652038",
  },
  {
    id: "882",
    id_polifenol: "5159",
    polifenol: "7-O-beta-D-glucopyranosylchrysin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "17948189",
  },
  {
    id: "883",
    id_polifenol: "3884",
    polifenol: "baeckenone F",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "26812220",
  },
  {
    id: "884",
    id_polifenol: "3913",
    polifenol: "1,3,5-trimethoxybenzene",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "20877240",
  },
  {
    id: "885",
    id_polifenol: "5439",
    polifenol:
      "quercetin-3-O-beta-D-xylopyranosyl-(1'2)-alpha-D-ribopyranoside",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "23266738",
  },
  {
    id: "886",
    id_polifenol: "5440",
    polifenol:
      "kaempferol-3-O-beta-D-xylopyranosyl-(1'2)-alpha-D-ribopyranoside",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "23266738",
  },
  {
    id: "887",
    id_polifenol: "4840",
    polifenol: "frederine",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "11350909",
  },
  {
    id: "888",
    id_polifenol: "6571",
    polifenol:
      "4',5-dihydroxy-7-O-methylisoflavone-3'-O-(3''-cinnamoyl)glucoside",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "26086179",
  },
  {
    id: "889",
    id_polifenol: "3270",
    polifenol: "2,2',4,4',6-pentachlorodiphenyl ether",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "26251594",
  },
  {
    id: "890",
    id_polifenol: "5096",
    polifenol: "luteolin 7-O-glucoside 4''-sulfate",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "22272829",
  },
  {
    id: "891",
    id_polifenol: "6577",
    polifenol: "8-methoxy-5,6,4'-trihydroxyisoflavone-7-O-glucopyranoside",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "19003217",
  },
  {
    id: "892",
    id_polifenol: "7670",
    polifenol: "8,2'-diprenylquercetin 3-methyl ether",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "19909799",
  },
  {
    id: "893",
    id_polifenol: "4074",
    polifenol: "pyrogallol 1,3-dimethyl ether",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "25879502",
  },
  {
    id: "894",
    id_polifenol: "6285",
    polifenol: "brutieridin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "29626418",
  },
  {
    id: "895",
    id_polifenol: "6207",
    polifenol: "melitidin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "29626418",
  },
  {
    id: "896",
    id_polifenol: "4284",
    polifenol: "1-(2,6-dihydroxyphenyl)octan-l-one",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "22978225",
  },
  {
    id: "897",
    id_polifenol: "4285",
    polifenol:
      "1-(3-(1-(2,6-dihydroxyphenyl)butyl)-2,6-dihydroxyphenyl)octan-l-one",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "22978225",
  },
  {
    id: "898",
    id_polifenol: "4029",
    polifenol: "androforin A",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "22700239",
  },
  {
    id: "899",
    id_polifenol: "923",
    polifenol: "m-bis(hydroxyphenyl)carborane",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "16735120",
  },
  {
    id: "900",
    id_polifenol: "2666",
    polifenol: "3,5-diiodosalicylic acid",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "18045204",
  },
  {
    id: "901",
    id_polifenol: "2934",
    polifenol:
      "5-amino-2-hydroxybenzoic acid 4-(5-thioxo-5H-(1,2)dithiol-3yl)phenyl ester",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "26995527",
  },
  {
    id: "902",
    id_polifenol: "4760",
    polifenol: "gnaphalin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "1812215",
  },
  {
    id: "903",
    id_polifenol: "401",
    polifenol: "2,2'-biphenol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "28703301",
  },
  {
    id: "904",
    id_polifenol: "3833",
    polifenol: "RS100642",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "22429688",
  },
  {
    id: "905",
    id_polifenol: "1401",
    polifenol: "3-methoxycatechol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "18423413",
  },
  {
    id: "906",
    id_polifenol: "994",
    polifenol:
      "2-tridecyl-3-((2-tridecyl-3-acetoxy-4-methoxy-6-hydroxy)phenyl)-6-methoxy-1,4-benzoquinone",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "19833361",
  },
  {
    id: "907",
    id_polifenol: "3410",
    polifenol:
      "methyl 3-(1-acetoxy-3-methylbutyl)-2-methoxy-6-(2- methoxy-4-methyl-6-(2-oxopropyl)phenoxy)benzoate",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "19833361",
  },
  {
    id: "908",
    id_polifenol: "1089",
    polifenol: "1-(3,5-dihydroxyphenyl)pentadecan-1-one",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "19833361",
  },
  {
    id: "909",
    id_polifenol: "7858",
    polifenol: "proanthocyanidin B4",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "17178382",
  },
  {
    id: "910",
    id_polifenol: "6511",
    polifenol: "duartin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "28110438",
  },
  {
    id: "911",
    id_polifenol: "6516",
    polifenol: "8-methoxyvestitol",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "28110438",
  },
  {
    id: "912",
    id_polifenol: "2838",
    polifenol: "3-formylsalicylic acid",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "17580843",
  },
  {
    id: "913",
    id_polifenol: "3413",
    polifenol: "terricollene C",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "19795843",
  },
  {
    id: "914",
    id_polifenol: "73",
    polifenol: "Anisoles",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "18457950",
  },
  {
    id: "915",
    id_polifenol: "5711",
    polifenol: "flemingin G",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "25226568",
  },
  {
    id: "916",
    id_polifenol: "6725",
    polifenol: "kwakhurin",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "10985090",
  },
  {
    id: "917",
    id_polifenol: "6536",
    polifenol: "daidzein-7,4'-di-O-sulfate",
    id_cancer: "484",
    cancer: "Breast Cancer",
    quant: "1",
    pmids: "9168894",
  },
  {
    id: "918",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "388",
    pmids:
      "27261599,23624232,28052097,27823633,29579978,29440765,17418981,29512707,17897817,20561027,24626522,19037088,27025376,21616090,21491996,26416794,24398569,28259937,29423046,26023926,26580959,15713899,25175673,21872580,22160193,17191121,23859040,28110189,28955240,27818240,26157550,27123066,23561189,24008356,19885574,15909122,12866025,10579870,28849234,25337553,26547532,17197076,24940817,19428936,1321338,24995310,25251374,15744083,18455702,22526619,25893829,26958937,15213223,24126433,24528358,27829548,26515162,21741427,29129665,29698783,29471888,10418944,27760539,15545229,24707875,19139819,28572828,26916801,29063088,27707626,23907061,23210512,28385566,29541427,27670274,19719238,16248588,10704911,25008568,29575334,20709524,25386076,15725655,17876056,26123287,12617611,23773626,23317880,11411569,23137376,15163544,26434259,24438177,23337959,27803454,18053307,15334063,15214488,11374833,24026776,23722601,26180625,26606169,23201840,24095020,29303970,25565802,15800915,23840275,22382861,27920817,27876336,23435602,23686257,20398749,28035355,16413414,25771121,25173561,14754875,29032208,25892545,22684842,22184071,11891088,21674787,25844036,20457140,12085217,26445322,21104029,27925497,17176222,17602653,23255485,17148506,22369068,25186940,27013795,23173924,28694750,25705818,22768128,26327408,23453831,23460110,20397199,18440233,20923189,21479885,21298326,18974136,18097692,24266406,23719279,26408343,29515203,10453447,17201169,23159065,19606519,26404080,27220561,16640504,24168160,15139523,12094622,22735354,29899208,22906313,24895583,29373904,28287469,15996021,19638489,25931350,21406604,20633549,22539432,23452983,29442390,24099426,27064876,22870126,26293804,19050992,14614451,16848514,25223958,18222973,10443335,15231453,24344605,24530873,10652438,15221776,25026504,24009741,25075794,27664007,28825571,29580144,23435631,15274140,21337646,15309432,26045985,26069485,29403999,28528091,8033070,21964875,24940499,23442980,28594405,16552572,22200628,28337019,19719968,29407472,28105204,29681865,29348836,25096395,15452831,20547166,28539711,23790944,27279714,27832690,21762688,29432917,23135489,25331269,22815676,21256954,18655183,20648923,24573487,28872373,10919656,27685909,26084155,29076434,2070483,22434356,19424582,15796208,16131149,20429956,24660462,18806956,11442279,26646778,26307342,21849051,9215855,18004724,16540225,20157880,28496481,21548803,17950073,22300907,24590261,20403331,25359775,27262321,23504630,17636936,25796713,26176582,16110120,21467667,16369997,22142698,23824743,24930002,14645680,29453046,10338685,19070422,27279256,29513789,28242546,21458546,20816778,25337584,21458113,24729227,26920053,20183323,18351577,16399234,27059855,27616072,12082016,25694787,19087425,26520390,25239551,16898869,20132046,22119371,22685350,23842450,21075159,23536316,25351676,17347140,12002801,12780904,9018079,29046908,26101614,25605996,21907578,10654159,29584932,12718627,18187256,18974642,24991108,15203384,19914226,15225578,11894763,25553799,20384315,29199553,18570232,26901186,21649465,28677983,23771521,16365058,21466426,15831530,11134977,10920275,16314920,22287334,20158254,23479391,12270215,21121257,26946158,7882322,18375960,15225597,20659486,12216075,28914038,18379113,24024667,20511675,7997472,18692983,24377586,26593537,24868862,25840808,11975496,25495760,24152430,19056647,16129554,28662339,25521038,28933386,29663361,17340576,25081655,19294386,10890034,12559383,29136951,14640528,24402200,27492327,12762790,16217561,20939605,19573959,28539721,17958394,21699017,16868069",
  },
  {
    id: "919",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "379",
    pmids:
      "18339878,22551677,27614381,28024945,29440765,24743574,23616010,25229889,15489172,28337376,22628241,11396178,19421843,24274397,21694723,8844727,16497702,21475877,22438101,20712901,15073046,23686430,23446753,16712454,21780253,28402965,21526346,24496855,26567619,19623659,15486348,23583304,23326480,29225578,11566484,15711178,15256484,25644785,22841393,24511364,19331178,22613224,27787644,21311680,18794115,17000667,29373892,27895783,20815812,25418925,15271854,20472336,27390600,27550987,29673545,12406558,27445823,18423603,15205359,25667441,28601309,23985704,23194063,26893768,27933995,22030090,23451189,16302093,26672603,25640947,25451846,23584140,17201158,12466962,28011386,14739610,22074823,16501251,21900746,21110780,16619535,25692854,24078402,23245566,21183341,27889234,17928719,23880083,25712055,28870897,25431425,20332435,20079215,10557090,17077187,24728517,28967875,19723094,21461234,24550143,23778405,11506814,19661333,15139522,25458791,28994313,14604899,17922140,27689333,16170359,25881826,29058812,23970932,20299603,22997162,29807115,19331692,29477042,26521943,17168675,29641445,16340194,28671249,29966255,12633846,26915414,20473900,25839235,9422331,12929584,25744732,23644215,15661804,11237176,28573788,26608678,19838927,22709992,25157362,25238234,21180609,11370761,19415182,28358339,15340658,10969808,17918158,29368356,17583825,29273065,17044774,27221847,25280404,19580791,21199169,16737669,24187456,21160593,22927762,28420097,20403165,19735878,15843753,25653233,21283869,24859389,24626093,25061290,17317839,29420338,17431105,23353121,29311914,26850372,29744415,19095035,19000900,12881017,18655004,26833194,22992310,24465712,15139523,24570592,29083232,26310065,26308760,29277765,23807084,29294495,20400781,29245915,18381954,15754327,18596194,27214786,21161336,8538195,24581747,27293144,24936217,24404205,21988497,15140256,29605808,10223193,20374023,21774804,22178266,24256565,21859497,25980982,1611594,29547900,29168312,27128654,24486834,22830632,19695862,26985708,28176943,21850703,17171638,23544170,19956394,20133951,12171541,20839263,22895897,26457069,15090465,23460897,23936796,25451013,24438326,22200330,26043573,16166455,20153625,29118580,23894315,25511568,28499854,27091625,24668546,20232614,29800814,21472350,10729246,15683997,25884903,17330230,21306385,24856584,24427321,25277658,29737515,23305919,23233214,20726007,26108778,7812955,21456169,16081279,27194111,24851881,25979230,15841493,20818481,7954412,25824783,9102217,28867734,29956726,21466813,17760412,23386399,26217691,20060305,26608515,20816778,18290715,10783313,11221833,27638711,26570985,26906122,26920053,9162301,23322993,29533631,24583398,24098980,23505424,17116380,19359593,28716495,27241019,9619854,24591829,28210221,22036766,15203376,23266210,17127241,9973206,21314329,22172229,20924967,27801454,23700916,22199293,12553052,15199544,11748382,8681447,27831561,23125222,15339049,15831530,20201417,26094212,17342335,23025432,28469791,22335582,26021807,17448598,12825130,11350917,11201293,20950131,20214562,29525163,14612489,28117012,19861145,26076595,26853158,10668477,27701049,24946270,17767425,12543061,22822540,27324595,15501961,18274631,26366338,11751448,28267439,10657978,20155625,22275831,28415431,26218141,21386635,27404761,17612053,19747544,28745498,12086402,20683505,22953026,27900602,17228149,22648527,24815764,23814530,25082426,12208119,15668484,29274436,28106283,17900536,23768171,29316620,11905754,26468449",
  },
  {
    id: "920",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "310",
    pmids:
      "25634350,22251620,24970012,21437031,11103814,26303273,20561027,26916824,24274397,24712725,24828012,21391128,16448212,29871992,21526346,28294332,25352148,23093841,18367875,11481417,25758919,22613224,28212423,23124926,23159608,26539626,18486125,22216935,29673545,16797120,27038915,12819184,26310874,20442318,25667441,29039600,29606232,16682945,15480430,23996930,24518414,14633667,11853888,15936648,12663506,16617056,27603595,20206613,24329111,24281858,29137335,21110780,27314273,16524888,27347927,12097697,9600345,16248588,22415137,28870897,18037152,16508969,29465116,19661333,18262392,9095331,17296806,22218562,18751377,16516367,27689333,28787469,23201840,11237204,18852136,19890716,19685549,29730933,28090275,18992738,17168675,21467134,26408414,20332434,20682710,25952326,25005957,16413414,19035659,9719459,22957077,28976622,23394584,28870200,15759309,12949793,26577496,17192871,23650147,20718469,17651061,18522405,18061431,12902349,23186731,17148506,28360012,25815689,11745454,20403165,29054984,25705818,18830563,22456307,25188358,19426686,18097692,21888504,28487731,29515203,20694292,21627076,23159065,16426830,18655004,17542601,24168160,28337113,16157446,12094622,18029474,15860507,17727817,27538679,23452983,17999988,26165362,23411228,19063841,15308587,9230122,15790589,28545532,19334045,20944129,27167203,23859043,8538195,15113149,26355019,11522280,19399671,24404205,25857357,23476753,28761044,23527961,22178266,8033070,28494341,26984176,21207318,21058188,21419311,28105204,17202688,29241580,23994611,28323438,29793168,12430003,29432917,29920075,24359816,20924968,19753610,20648923,10919656,22923011,23460897,16410636,16131149,28937798,12042461,29562699,20153625,16540225,22300907,11741742,15802299,19627204,28009871,24324066,25796713,19940103,17330230,23965967,24856584,22365054,25038707,18190797,29854080,20730438,24348703,10338685,19003583,22977466,28105248,16081279,21736387,26056816,16061885,28867734,29956726,24308429,21466813,12880319,21687829,27760368,29707158,18290715,17893236,25412311,27467555,18351577,25132926,20836978,27103343,11705450,25239551,27957845,29258268,21075159,27028006,26995228,12002801,23211994,17127241,26101614,20406206,17442116,19469472,17378580,22919439,16860979,28677983,27831561,21466426,16293270,19083497,9675322,23319439,14760392,24569685,20214562,21598179,18398871,27632812,10668477,8697942,25729881,28531972,8537983,11751448,18412361,17896916,10443334,18636219,29966007,16855537,20455581,28948694,9349688,28745498,19588362,20683505,22960260,26303826,27750207,19527781,22943128,21172399,28389096,23827601,10744131,17012762,23529990,19743405,22727325,17261019,14640528,28899482,29532213,29068698,18850155,23859035,24423548,29684860,15167223,28094544,22141580,22016781,22887153,17958394,16399395,27716626,17033282,29391211,16868069,19127731",
  },
  {
    id: "921",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "144",
    pmids:
      "24424889,12761477,17016604,19148542,16595125,16211242,26673746,23589723,27323826,20198313,15713899,17519236,10585423,12748850,15956247,17604322,22410117,27354597,12851702,18479896,19885606,23448150,18086662,20888181,17513607,25447816,28492141,21109980,20798496,12406558,11888673,14750214,12618885,16387404,16077033,22100846,11528371,14981539,27424123,25371074,22076613,16574647,15122344,27347133,19882352,17329004,17307743,21429662,16214385,24095863,27220321,9797369,15655297,25338635,16575407,12707033,17620438,19520792,25431425,11339819,10484389,17295239,24241351,20564491,19501039,22361730,15930183,14699482,25012123,16079301,11781819,19331159,15867384,15940626,16527254,9191056,25961376,15657353,11459290,11910351,18767967,15298620,17230532,12077118,24019108,29846015,27564600,16077199,15896333,20236587,19777613,10220499,11394874,15655524,19384947,16571666,24265293,18478925,18942115,23255485,16964382,24324366,15880954,18829558,17940558,16142585,12733059,10766192,21638027,24802235,19301097,23464396,15917307,12203364,25688504,15806152,17671195,25569743,18596194,15504345,18454176,12816758,16631161,15760920,16288223,21741165,25643632,19194827,29681865,10910078,19017493,11904289,10748108,23942851,11891209,24211581,18664572,12657625,19843849,22383492,21455573,12016129,12825130,17876544",
  },
  {
    id: "922",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "122",
    pmids:
      "25871428,16329599,8242641,15963949,15488634,12767058,29202800,25880142,25401399,10753641,16379552,24504162,15548175,21801124,29849534,29541427,20957335,24564102,25745776,10704911,17077187,21571909,21639915,25128065,17088408,11295047,18357397,10638662,8201603,26180625,19909554,23686257,16506809,26910375,12684659,7642726,7488237,27057094,22815877,10783318,8574217,23255485,15896711,24324366,29204990,27942504,21462322,28373425,16254887,19220577,26703673,21554132,29568950,21115903,23900272,24390805,27255553,16091008,18850198,11506804,11911282,24530873,25605009,10227051,10453436,23476753,18791934,16288223,10367258,17601486,17202688,23790944,18621112,21161820,20211058,16886669,26506839,18715236,23794041,8813150,14968209,9215855,10762754,18225578,21088384,22359351,12818423,10797565,12593928,22347428,20816778,15937998,9288778,7884564,19169726,25132926,11052627,9018079,15967383,9698072,12899537,21856997,15113973,8200067,26021807,15498380,16117624,15225597,22736306,26853158,7884559,20582579,17477768,12899539,21782699,16155276,19743405,10384821,15579483,21758003,11905754,23672582",
  },
  {
    id: "923",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "169",
    pmids:
      "25337554,27823633,24579782,22310237,28479391,27721177,17191121,1735617,19344998,24535669,24940817,24173369,19428936,1321338,21951556,25298669,19208367,18455702,25893829,28521254,15289867,23530649,19293639,15741050,26351552,20681654,19440933,26021766,27670274,7665238,10704911,17077187,15725655,17876056,11506814,27803454,25829782,26167492,11374833,8201603,15670774,20944146,18852136,27748879,27876336,23441618,20332434,17027136,26946942,28677813,7488237,15759309,29645049,22684842,25024815,25844036,12085217,21104029,10783318,17148506,28360012,27013795,28420097,20923189,21479885,29744415,10453447,21262328,15769125,16640504,28337113,25931350,29442390,17936464,26197788,9230122,20944129,24530873,10652438,15221776,11522280,15309432,21732360,28528091,21716619,26030791,23442980,22830632,19695862,16552572,21207318,21419311,17202688,29681865,25096395,28539711,27279714,25331269,22213289,21256954,18655183,24573487,2070483,23434132,19424582,11442279,9215855,26807543,2351487,24856584,10338685,23195945,28242546,22358425,20816778,15937998,10783313,23556141,17305494,11078914,25132926,22334787,22119371,25351676,26284613,29203747,9018079,26101614,29584932,17378580,18974642,15203384,19914226,27980567,25863613,15796157,8681447,15831530,11134977,10920275,20628003,12160900,28032729,16117624,24569685,25212146,15225597,21598179,23000446,18398871,20396589,15652231,24152430,20455581,16707620,19056647,10541449,16129554,24956844,28137512,16442130,29663361,24908156,17639512,14640528,24423548,20939605,27716626,16868069",
  },
  {
    id: "924",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "142",
    pmids:
      "12530089,11103814,21622140,23741252,26303273,23954321,24828012,24337301,26278714,20346928,25833196,25352148,16797120,12819184,24179522,15814656,22814742,25123131,22566066,28587207,22100846,24518414,14633667,11853888,12663506,20206613,18423375,22101170,24329111,23348740,9600345,17928719,15265009,18037152,16508969,28967875,18175946,9095331,15139522,11594758,11259102,23201840,11237204,20361925,18992738,23411276,16054165,9712707,9719459,28925507,18983978,20718469,25024815,26930714,16288056,12085217,22320717,16123309,23525843,21199169,19726294,18549879,8826614,18830563,17616711,15456639,18586691,21866461,19744467,19157820,15139523,21538846,16157446,19578043,15860507,29723847,12351151,12642472,25544670,20400781,22409325,26003085,28544013,26241688,27167203,24530873,8538195,19399671,23476753,24256565,20682974,11809530,27617982,21207318,26785145,21419311,19719968,17202688,23994611,24359816,20924968,16620709,16997910,24324066,29429153,10202396,18190797,22258296,21088384,19288003,28346686,24915354,21458546,21687829,20816778,17893236,19169726,19138973,11705450,16204466,29203747,17127241,18022615,16817633,22199293,18283038,23255428,17657175,17342335,26021807,9675322,25222193,23319439,16117624,22716294,14612489,25729881,18325726,21479417,10541449,22943128,29290650",
  },
  {
    id: "925",
    id_polifenol: "2167",
    polifenol: "phenolic acid",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "158",
    pmids:
      "26434289,21617225,23958424,22147441,25175673,18952370,12502387,28656311,27288921,28212423,23124926,15271854,22216935,25447816,19883717,23069328,29606232,27760539,29879413,20373763,27328416,26839513,16248588,29465116,29037704,28071050,12617611,23594085,23317880,26167492,23712134,23722601,29113214,29303970,29730933,22382861,27876336,17168675,23435602,16077199,17243699,29645049,29451783,12085217,18061431,19580791,22369068,27013795,23453831,18800807,27235722,21888504,17147415,20694292,19606519,15769125,23784800,27348025,28480370,28694749,22906313,28287469,25931350,28000873,27651811,25466029,17999988,7488239,15790589,25855928,24530873,24001836,15113149,23435631,27099438,29430949,25796013,24256565,26030791,19888728,21964875,28494341,23442980,26984176,21284384,29407472,23994611,28496485,29793168,29920075,25331269,26347954,21674867,22769426,27685909,16131149,26041170,27455311,26307342,22628046,8358716,22136553,16540225,20157880,28496481,29800814,27262321,23504630,17636936,25796713,28671329,29845279,27904404,22365054,25038707,7812955,24348703,28105248,21736387,26056816,29513789,24711053,20816778,10783313,21458113,23039105,15563205,27701810,25694787,17943720,27957845,23842450,25251219,23211994,29046908,23994083,25056133,22898370,25863613,28677983,16365058,21466426,15867310,20158254,23319439,21121257,25212146,23000446,17542482,26593537,25840808,23615403,28662339,28777311,12570342,18850155,20939605,19950996",
  },
  {
    id: "926",
    id_polifenol: "49",
    polifenol: "Aspirin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "309",
    pmids:
      "17418981,16199534,26750401,12832097,23013454,18922898,24503782,10698490,20654727,17510082,12423325,25033546,12538492,20857911,9630216,21617849,20397022,16105666,16282376,16909598,20215502,17971198,21180609,26596838,22171135,20188076,23110215,26319435,9344613,28162291,10738133,16507396,11801560,16388830,21171083,21984018,26094902,7615821,29744415,23535188,26219912,10706128,20828891,26918349,11239649,16819585,16267095,9822550,11078056,25569743,23132258,28717171,15986848,29308184,10607736,18636671,11986787,20886344,14563940,26898989,25815878,16262603,14521608,10480951,15528453,17290354,9151799,24766194,11245463,22552812,21551129,16141240,17899765,10631359,15691389,8625297,16326109,27903583,23852449,3343338,14566053,19908241,18676677,17308107,10678579,17241873,16878161,29794245,15770215,14674624,12813129,10853036,14633677,19695862,29848978,14532966,8549662,8840961,10993886,23850473,22406476,9399670,16032431,15163551,9219313,9661890,20648923,22916316,19724920,18849138,27356773,16042578,16339178,12738997,25940306,29552221,17512900,21840302,16169935,17132819,26314861,18472019,19415698,17488476,26202947,14529404,11309281,23529546,24516128,15703826,29152088,16893520,16110120,23349335,15254653,25109257,21617874,12774850,11906190,19220658,18987430,24002210,18486630,24483845,16818512,29705335,27344083,28154202,7641194,29088823,27998883,29179207,9413930,15570007,15242680,7727422,10357918,29075787,9561441,28087343,14743889,21956205,19999807,17316360,21205744,22342953,12800193,9484814,26799418,28036129,21743961,20514409,21406194,18544566,15505205,8538196,17127241,20514442,9521170,27074574,20674154,21544484,10714217,21597741,18059344,26844701,23033009,15188000,10029375,19236238,24184502,27554763,24613833,10581086,16531064,16618783,14965265,28718829,15199544,22493349,27207670,11093808,21900887,26704566,10601615,25388762,22039321,8631005,11313997,12131661,12054526,23025432,8353834,26021807,10837003,26394025,25503930,16266236,8490537,17371277,29031619,14612489,7829266,20349206,26204233,16859832,28051316,29885857,7728952,16038882,14976132,9831328,12885487,8960892,22893199,27161240,9160111,22724630,25085205,28267439,10571594,10660094,9736731,17612053,7920013,22122764,28556814,15577751,12086402,29259703,15992053,7893840,11194887,19892664,12810952,21914855,8918560,12905826,10668484,11109595,28184026,15899787,9536954,11166002,21158711,10917070,16042586,14697260,9102213,10219835,11577463,16042570,20508278,19785994,12792801,16168238,9596581,29616131,15309515,19114773,28138699,9706142,11566043,29519806,18339853,12973428,16118353,21778329,25023354,15374627,10883057,12769697,18702823,8597161,29316620,11301836,22904679,15252926,27186121,15648192,8646953,12705063,22893201,14640056,26304465,15974946,10472428,25342594,22456425",
  },
  {
    id: "927",
    id_polifenol: "109",
    polifenol: "Catechin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "121",
    pmids:
      "21622140,23741252,22404116,24828012,23225437,26278714,19723101,21780253,17764926,15814656,22566066,22100846,11853888,20206613,27671231,27347927,9600345,15265009,16206041,29465116,17077187,23594085,18175946,9095331,15139522,11259102,28787469,23201840,11237204,20361925,23441618,16413414,9712707,23394584,28925507,26930714,16288056,12085217,22320717,21199169,18549879,8826614,22312277,17616711,23453831,29278988,29515203,25795020,24168160,28337113,19157820,21538846,15860507,26774105,12642472,25544670,28544013,21945981,15308587,15790589,15231453,24530873,27093594,11522280,26673759,19399671,26030791,20682974,28108382,27617982,21207318,26785145,21419311,21535793,23994611,24359816,24573487,15796208,27455311,27357542,28216880,16997910,9215855,19839593,29154190,15683997,29429153,10202396,24856584,18190797,28105248,28346686,24915354,17168588,26056816,29513789,12880319,17893236,29928972,9162301,16204466,21061473,18022615,16817633,25863613,11748382,11196148,24520932,10920275,26855049,25212146,19861145,18398871,27632812,25729881,8537983,15938138,19588362,21479417,14640528,11905754",
  },
  {
    id: "928",
    id_polifenol: "125",
    polifenol: "Isoflavones",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "53",
    pmids:
      "8242641,15963949,23959101,26215320,16379552,21801124,29849534,29541427,17088408,21945666,23686257,22815877,29204990,22456307,18440233,21462322,16254887,26147490,21115903,23900272,24390805,27255553,18850198,11506804,10443335,21161820,28264435,18715236,20391625,12818423,19926933,17127241,21907578,21856997,17662606,20158254,15867311,10668477,19079816,15938138,27823732,7884559,19141699,21782699,16155276,12718590,19743405,10384821,15749628,10625940,21758003,19573959,19950996",
  },
  {
    id: "929",
    id_polifenol: "110",
    polifenol: "Chalcones",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "62",
    pmids:
      "19875299,28808400,25193463,26916824,22019186,27727127,22634834,26615871,26547532,26878127,22987398,26874744,26859847,10418944,29335212,26552551,27017265,28737782,24629239,23538439,16434201,26269760,25008568,25775405,29065840,23291120,24095020,29146133,20398749,19568915,27192488,28694750,23257665,18440233,24211632,23719279,26994844,28160848,24372527,23895019,27371926,21041085,20338479,24344605,8033070,22200628,24675137,22703846,29715541,22668451,28838697,20620131,17804245,22358425,21907578,25379458,17579893,11853176,23189564,18484536,22071256,17627575",
  },
  {
    id: "930",
    id_polifenol: "3089",
    polifenol: "1,1-diphenyl-2-picrylhydrazyl",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "85",
    pmids:
      "21872580,22628260,12502387,28053959,19883717,29606232,28458366,28946185,27760539,26916801,27328416,16206041,22776996,29771951,23317880,23712134,16516367,16933884,18189352,22382861,23435602,28251112,20548938,28360012,23173924,23453831,23892206,25887035,15787435,28337113,28376770,27348025,21953995,23452983,29442390,26304331,29956560,26290675,23841520,29430949,19888728,21964875,29407472,25331269,21674867,26601580,20429956,26307342,21849051,28216880,29562699,19099401,28496481,22300907,27262321,23504630,19627204,17636936,22316295,28671329,24348703,22977466,28105248,21736387,12880319,27701810,25694787,27537869,21075159,23211994,23768340,22898370,23344192,25212146,16719495,28101119,18398871,17542482,10967477,28137512,16506814,28777311,14640528,20939605,28539721",
  },
  {
    id: "931",
    id_polifenol: "114",
    polifenol: "Apigenin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "51",
    pmids:
      "29512707,24626522,27123066,28829588,15213223,24126433,29129665,28572828,22086925,20709524,23773626,29849451,26434259,16077199,22184071,22369068,28360012,12842827,17620292,21298326,10453447,27348025,19638489,28827996,22870126,19050992,15231453,24605779,24530873,24377607,24009741,27664007,21337646,21716619,19695862,16552572,28337019,25965143,21548803,27616072,16898869,26284613,26101614,29584932,27932756,15203384,25553799,15225597,26853158,20511675,16868069",
  },
  {
    id: "932",
    id_polifenol: "113",
    polifenol: "Flavones",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "61",
    pmids:
      "24626522,21617225,28110189,15909122,12866025,26547532,28587286,15289867,25461325,17077187,22086925,20709524,29771951,27116119,22456615,26606169,29808795,15800915,14754875,12589031,17418982,29116937,22369068,22768128,21298326,28480370,19638489,25931350,18214853,22870126,10443335,27671298,15274140,22155348,15452831,28839377,25965143,10919656,12677524,17363487,24631140,22365054,24930002,14645680,17261771,17347140,21907578,25553799,29198745,21649465,16314920,21121257,15225597,19233127,7997472,3708611,16630115,3778803,20564477,17958394,16868069",
  },
  {
    id: "933",
    id_polifenol: "38",
    polifenol: "Gallic Acid",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "58",
    pmids:
      "24579782,18952370,23799608,23124926,28462130,28521254,23996930,27671231,20373763,27347927,17928719,29465116,23712134,23201840,27876336,23441618,20332434,11032918,29645049,12085217,21627076,19606519,15769125,27348025,21953995,25855928,23841520,23435631,27099438,23442980,26984176,25794927,28496485,29393902,27685909,20429956,27455311,22628046,29562699,16540225,28009871,18190797,28105248,29513789,28242546,12880319,26608515,27028006,20014760,25863613,29913068,22572890,25212146,16719495,19527781,21172399,20939605,28539721",
  },
  {
    id: "934",
    id_polifenol: "117",
    polifenol: "Luteolin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "55",
    pmids:
      "29579978,16901994,28791416,23172826,26580959,29434850,28110189,19344998,22269172,25207720,27707626,17296806,24761924,15334063,29808795,23441618,29658045,29277460,29645049,28391045,22184071,22369068,28360012,27013795,23460110,29039580,21479885,27348025,24099426,25075794,20013030,28539711,20403331,22365054,27569028,26056816,20183323,26284613,26101614,29584932,18187256,24991108,15203384,28552787,25553799,16399354,20659486,24532706,24024667,18692983,24377586,25081655,16217561,28539721,25342594",
  },
  {
    id: "935",
    id_polifenol: "1",
    polifenol: "Phenols",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "46",
    pmids:
      "16504517,20561027,28656311,15986412,24511364,25469035,16524888,25658135,28071050,19420803,28251112,29451783,20674562,17577669,15205340,19638489,23455189,27651811,17936464,17999988,11097223,3288331,29430949,23193056,2548717,21664138,15880398,18715236,22628046,21849051,28496481,22365054,24348703,24376369,17943720,25239551,19615911,8401174,29199553,20949224,24868862,18412361,22943128,21885815,18444159,46258",
  },
  {
    id: "936",
    id_polifenol: "105",
    polifenol: "Anthocyanins",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "74",
    pmids:
      "22404116,12502387,19885574,23124926,18729103,23069328,23996930,27314273,20373763,16248588,29037704,21042741,18053307,18751377,16933884,15016660,23368921,17243699,27989839,20060025,17651061,25705818,18800807,26927179,28799785,27235722,21888504,17147415,29515203,26509161,23784800,12094622,26304331,20400781,14690795,26383537,15113149,21165577,21284384,18327700,29407472,21280204,22769426,23828497,16131149,26041170,25442541,25420792,12706854,28009871,17636936,27904404,25038707,28105248,21736387,23039105,24716988,15563205,29662851,20494645,10654159,17442116,28740990,26901186,28677983,21466426,28850070,16719495,18412361,21103079,19294386,16800776,22016781,29316620",
  },
  {
    id: "937",
    id_polifenol: "7235",
    polifenol: "silybin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "46",
    pmids:
      "29607789,29875662,25892866,22555452,26936429,21779837,24528358,20454513,29755557,24440808,23210512,23445752,20823143,12943822,22086675,27402681,19638451,23555889,17201169,29031537,26404080,22526491,23599778,22735354,14614451,18339887,23548635,22213051,15993897,23530816,17950073,19138982,22258296,20537993,29250169,28978118,19274440,24970802,8019514,23674609,20215518,20628792,29780684,25846868,16442130,19654488",
  },
  {
    id: "938",
    id_polifenol: "129",
    polifenol: "Rotenone",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "26",
    pmids:
      "25871428,27280936,26215320,27288921,25401399,21699019,19139819,17671207,25745776,18998398,11825660,17088408,27057094,23023137,16107721,22120717,24390805,24530873,10227051,16323058,19411865,24354192,29740695,23479391,19079816,2614425",
  },
  {
    id: "939",
    id_polifenol: "121",
    polifenol: "Kaempferols",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "38",
    pmids:
      "24579782,25337585,1735617,25337553,15618237,27445823,15289867,19028473,29771951,24549175,23441618,16077199,17027136,29645049,10783318,20548938,27013795,10453447,23159065,28337113,28694749,18680719,20138027,28528091,26030791,28539711,21256954,16540225,10338685,28105248,29199082,24711053,25351676,15796157,15225597,24956844,16442130,14640528",
  },
  {
    id: "940",
    id_polifenol: "871",
    polifenol: "ABT-737",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "33",
    pmids:
      "19088028,27780925,27461218,23233484,26870201,20104024,25304383,27429848,24709422,17973573,18807035,21887277,22179721,29278689,21368833,23680104,24030153,21468686,21393866,20587662,26585594,25192188,27537525,23171055,25208882,19380879,27197306,22006676,29372687,25483065,25715028,25388762,24682005",
  },
  {
    id: "941",
    id_polifenol: "6451",
    polifenol: "daidzein",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "19",
    pmids:
      "8242641,23959101,21258042,16379552,29849534,15304310,23686257,16506809,29204990,16254887,23900272,24390805,11506804,10227051,21161820,23794041,9698072,21782699,28956670",
  },
  {
    id: "942",
    id_polifenol: "6065",
    polifenol: "baicalein",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "24",
    pmids:
      "29749481,29732005,22992837,28259937,28110189,24008356,25268843,26398706,23337959,24026776,20944146,17027136,18974136,22539432,10443335,15008823,26870267,22815676,27262172,17880512,25337584,26021807,26946158,26853158",
  },
  {
    id: "943",
    id_polifenol: "7",
    polifenol: "Capsaicin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "23",
    pmids:
      "19846903,15383218,21082859,23985252,29498663,23581408,22353011,20110283,21764279,24941670,24122993,24643130,25876645,19381455,24530873,17404062,27901346,29155087,22039321,26303826,25944998,1373965,28598691",
  },
  {
    id: "944",
    id_polifenol: "4634",
    polifenol: "alvocidib",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "20",
    pmids:
      "17638911,20638287,12124325,10810375,16982769,12566305,12589031,28560460,11562278,21994185,11641415,17007746,10368639,18381438,11751522,11489836,16024616,14676132,11052627,22948151",
  },
  {
    id: "945",
    id_polifenol: "120",
    polifenol: "Flavonols",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "47",
    pmids:
      "28107519,26434289,25337585,23925650,27073499,1735617,24511002,25337553,17190444,19028473,16248588,16317137,22888531,24549175,20944146,22382861,16077199,14704326,27925497,15027128,18440233,20923189,17147415,7623025,25887035,21262328,28480370,25931350,10443335,20104502,15113149,22742959,23790944,21674867,22769426,16131149,15563205,27980567,25863613,18570232,15796157,21466426,20628003,28101119,18398871,8537983,29663361",
  },
  {
    id: "946",
    id_polifenol: "4522",
    polifenol: "chrysin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "34",
    pmids:
      "22948973,24940817,29806604,26515162,17077187,22086925,27116119,24019108,28959334,20457140,29116937,20878083,26404080,29083232,29899208,29294495,25223958,22155348,21207318,21419311,26347954,11442279,23504630,25914235,21466813,20816778,23536316,15203384,19914226,25723108,15225597,19233127,24956844,16868069",
  },
  {
    id: "947",
    id_polifenol: "123",
    polifenol: "Rutin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "37",
    pmids:
      "26434289,27073499,1735617,28899495,27829548,15741050,20944146,28360012,23442980,21207318,21419311,28539711,2070483,23867787,25442541,24856584,10338685,24711053,10783313,9162301,25738869,23768340,18187256,28552787,16365058,29913068,15831530,24520932,10837003,23000446,15652231,24152430,24908156,20939605,17953789,12896910,8741796",
  },
  {
    id: "948",
    id_polifenol: "6062",
    polifenol: "naringenin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "32",
    pmids:
      "22160193,26157550,27710830,24940817,26797111,15744083,15545229,23137376,15163544,22184071,21674787,22369068,26074733,27348025,24220240,15231453,21762688,20648923,9215855,18004724,16540225,20157880,28264488,12780904,23177257,18176909,15203384,25553799,16117624,20511675,24868862,29345053",
  },
  {
    id: "949",
    id_polifenol: "285",
    polifenol: "bisphenol A",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "4",
    pmids: "20836126,25056133,25534675,25119493",
  },
  {
    id: "950",
    id_polifenol: "39",
    polifenol: "Hydrolyzable Tannins",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "28",
    pmids:
      "25906041,24828012,29778287,16448212,21532339,28462130,22216935,15936648,16248588,23317880,19035659,17192871,11588891,17147415,16426830,22906313,27651811,28825571,19888728,16131149,20429956,24798519,29928972,27028006,20014760,29116460,18412361,10443334",
  },
  {
    id: "951",
    id_polifenol: "130",
    polifenol: "Proanthocyanidins",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "29",
    pmids:
      "17418981,16094708,23093841,22216935,29113217,25123131,17923279,19271284,23026853,17062697,22026386,19035659,15759309,26180579,29463813,17176222,29970694,15456639,17147415,29684110,15113149,28216880,16540225,21642017,16110120,28677983,23771521,11759289,23615403",
  },
  {
    id: "952",
    id_polifenol: "35",
    polifenol: "Hydroquinones",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "15",
    pmids:
      "16504517,16756956,25651526,2113030,17077187,19420803,12570375,15658878,18604227,12139465,26444384,17722905,12054526,15867391,28697309",
  },
  {
    id: "953",
    id_polifenol: "111",
    polifenol: "Flavanones",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "23",
    pmids:
      "26459308,22019186,22648623,22160193,10418944,27840137,15163544,15214488,22369068,24843190,26074733,23895019,15797607,10443335,15231453,21467667,19952433,28264488,23177257,21907578,25553799,21121257,10890034",
  },
  {
    id: "954",
    id_polifenol: "4502",
    polifenol: "fisetin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "18",
    pmids:
      "29574877,28052097,19037088,19264955,20637980,16317137,23840275,24019108,10453447,19606519,19050992,10443335,20974518,28105204,21458546,26946158,26853158,25495760",
  },
  {
    id: "955",
    id_polifenol: "6",
    polifenol: "Catechols",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "10",
    pmids:
      "23799608,28071050,24523750,14704326,24168160,28694749,27093594,20589861,24308429,20417221",
  },
  {
    id: "956",
    id_polifenol: "25",
    polifenol: "Butylated Hydroxytoluene",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "12",
    pmids:
      "16516367,11090257,23453831,26585906,23442980,19359593,24276977,11396144,10541449,18603805,12570342,16314070",
  },
  {
    id: "957",
    id_polifenol: "75",
    polifenol: "Butylated Hydroxyanisole",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "17",
    pmids:
      "17296806,19728331,16516367,23173924,23861102,10498754,9162301,25744397,11396144,7127277,3046307,10541449,17475672,12570342,9823300,17953789,12896910",
  },
  {
    id: "958",
    id_polifenol: "15",
    polifenol: "Masoprocol",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "15",
    pmids:
      "18927292,11485827,17645780,20654727,20937254,20674562,15008823,12898234,15936596,17880512,9619854,12110314,11811948,26853158,2804913",
  },
  {
    id: "959",
    id_polifenol: "6087",
    polifenol: "wogonin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "10",
    pmids:
      "23761018,22992837,24901054,19438509,23907061,18377871,22086925,23337959,24026776,16218664",
  },
  {
    id: "960",
    id_polifenol: "4519",
    polifenol: "myricetin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "19",
    pmids:
      "29579978,15713899,24511002,23561189,29698783,20944146,23441618,29658045,10453447,10443335,28528091,21207318,21419311,10338685,28105248,26101614,15203384,29136951,21699017",
  },
  {
    id: "961",
    id_polifenol: "4515",
    polifenol: "baicalin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "9",
    pmids:
      "29732005,29440765,26398706,23337959,22456615,24026776,25239813,22815676,23157964",
  },
  {
    id: "962",
    id_polifenol: "4500",
    polifenol: "procyanidin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "24",
    pmids:
      "21713362,22026386,15139522,28787469,16820885,26180579,18373064,22312277,15139523,18275839,26774105,20400781,15790589,22074817,17015171,11741742,15802299,24905821,25212146,18398871,18412361,17824958,17094456,19127731",
  },
  {
    id: "963",
    id_polifenol: "5608",
    polifenol: "epicatechin gallate",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "23",
    pmids:
      "23859040,17764926,9600345,23594085,11259102,23201840,12085217,8826614,23719279,19157820,15860507,21945981,15308587,24530873,19399671,17202688,25794927,16540225,28346686,24915354,17168588,11705450,25212146",
  },
  {
    id: "964",
    id_polifenol: "1356",
    polifenol: "gingerol",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "20",
    pmids:
      "18384088,25148824,18058799,22719783,27730672,25157570,19117330,26046324,28167239,19531649,19255554,26403976,24530873,28065501,23066935,19877681,25251219,21792901,23322393,26853158",
  },
  {
    id: "965",
    id_polifenol: "54",
    polifenol: "Salicylic Acid",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "26",
    pmids:
      "17938270,18203887,11351310,9990295,26319435,9540818,17241873,15163551,20648923,26314861,15703826,21617874,29075787,22342953,11100896,24520932,26323873,26204233,16038882,23200247,10571594,15577751,9536954,9729437,12769697,29316620",
  },
  {
    id: "966",
    id_polifenol: "98",
    polifenol: "Propofol",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "10",
    pmids:
      "20888181,25502773,24244442,25692465,27780923,14679008,29569786,29614493,29158975,26669824",
  },
  {
    id: "967",
    id_polifenol: "5607",
    polifenol: "gallocatechol",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "17",
    pmids:
      "9600345,18175946,9095331,11259102,23201840,12085217,8826614,22312277,27348025,15860507,12642472,19399671,17202688,18190797,24915354,12880319,11705450",
  },
  {
    id: "968",
    id_polifenol: "5578",
    polifenol: "alpha-naphthoflavone",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "23749901",
  },
  {
    id: "969",
    id_polifenol: "44",
    polifenol: "Salicylates",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "24",
    pmids:
      "12851702,25024815,12793857,23110215,14634277,28717171,14521608,10631359,8625297,10853036,10993886,16339178,25940306,17132819,8566837,24516128,15703826,21617874,28087343,9484814,28036129,9733711,9536954,10219835",
  },
  {
    id: "970",
    id_polifenol: "4559",
    polifenol: "theaflavin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "11",
    pmids:
      "11103814,20669245,9600345,18037152,11237204,18992738,14723964,16835502,11705450,10541449,22943128",
  },
  {
    id: "971",
    id_polifenol: "5808",
    polifenol: "isoliquiritigenin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "6",
    pmids: "19568915,24530873,25026504,16399234,18360095,11853176",
  },
  {
    id: "972",
    id_polifenol: "2344",
    polifenol: "methyl gallate",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "10",
    pmids:
      "19723101,25298669,29465116,18992738,19035659,25887035,28346686,17168588,29116460,17824958",
  },
  {
    id: "973",
    id_polifenol: "4708",
    polifenol: "xanthohumol",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "7",
    pmids: "15995977,10418944,25771121,21207318,21419311,20547166,17579893",
  },
  {
    id: "974",
    id_polifenol: "47",
    polifenol: "Mesalamine",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "63",
    pmids:
      "22187071,21817114,16082388,18774638,26896068,18544567,11518677,22435743,18976971,21180609,25024815,26033966,19541409,7920212,8100205,25569743,23843037,27310872,20054232,12663503,29794245,10853036,17981262,17539984,19737563,27597248,8566837,16728434,23529546,18495657,19369484,19220658,16803693,28108625,21315419,16914308,19457125,28036129,19774649,29475099,29710467,24184502,11007109,22493349,26780265,29116460,17975166,8691064,10571594,1499439,16939423,25386079,28556814,11194887,15899787,10219835,24005861,19202572,28138699,19420017,29684860,26304465,1397883",
  },
  {
    id: "975",
    id_polifenol: "2284",
    polifenol: "rosmarinic acid",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "18",
    pmids:
      "21112365,29459827,29427084,18936204,23285814,21964875,28496485,20506543,22136553,26608515,26340059,25239551,25210763,22960260,22236574,28813148,24423548,28539721",
  },
  {
    id: "976",
    id_polifenol: "112",
    polifenol: "Hesperidin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "15",
    pmids:
      "26459308,17897817,19782062,25047426,18097692,12384797,25632185,15231453,28539711,23377175,22740080,12718627,20511675,10962453,10890034",
  },
  {
    id: "977",
    id_polifenol: "6455",
    polifenol: "nobiletin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "13",
    pmids:
      "17197076,28107678,29063088,15725655,29313727,26445322,20397199,12384797,19914226,18375960,15225597,27977189,20511675",
  },
  {
    id: "978",
    id_polifenol: "4513",
    polifenol: "galangin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "8",
    pmids:
      "29579978,23925650,21406604,26347954,22434356,23504630,25723108,15225597",
  },
  {
    id: "979",
    id_polifenol: "6063",
    polifenol: "naringin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "9",
    pmids:
      "15744083,26167492,15231453,29580144,29497294,26030791,23442980,15796208,24868862",
  },
  {
    id: "980",
    id_polifenol: "1380",
    polifenol: "shogaol",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "14",
    pmids:
      "23612072,18384088,26119958,24786146,22246389,29464796,23382939,26063410,28641163,28503853,21598039,19877681,25251219,23322393",
  },
  {
    id: "981",
    id_polifenol: "2158",
    polifenol: "protocatechuic acid",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "7",
    pmids: "23799608,19606519,12384797,11097223,26041170,8358716,25038707",
  },
  {
    id: "982",
    id_polifenol: "5489",
    polifenol: "delphinidin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "11",
    pmids:
      "12502387,18729103,15016660,26927179,25442541,28009871,20494645,28740990,21103079,18603805,19294386",
  },
  {
    id: "983",
    id_polifenol: "6273",
    polifenol: "hesperetin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "8",
    pmids:
      "27840137,16413414,29032208,15231453,22409373,22142698,26520390,24868862",
  },
  {
    id: "984",
    id_polifenol: "1613",
    polifenol: "demethoxycurcumin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "6",
    pmids: "24641413,29368356,19580791,19000900,7954412,17760412",
  },
  {
    id: "985",
    id_polifenol: "93",
    polifenol: "Phloroglucinol",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "9",
    pmids:
      "24970012,21268086,28850007,25070748,24986654,22342146,24605779,24530873,23669242",
  },
  {
    id: "986",
    id_polifenol: "6454",
    polifenol: "formononetin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "8",
    pmids:
      "19139819,29620230,23023137,22456307,16254887,24530873,28105248,9698072",
  },
  {
    id: "987",
    id_polifenol: "81",
    polifenol: "Fenofibrate",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "3",
    pmids: "29129665,17631136,23438367",
  },
  {
    id: "988",
    id_polifenol: "7550",
    polifenol: "3-methylquercetin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "11",
    pmids:
      "24398569,27803454,26167492,25186940,20923189,28539711,24573487,23824743,26056816,29046908,15225597",
  },
  {
    id: "989",
    id_polifenol: "6461",
    polifenol: "acacetin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "3",
    pmids: "24901054,28539711,15203384",
  },
  {
    id: "990",
    id_polifenol: "4253",
    polifenol:
      "5-(2,4-dihydroxy-5-isopropylphenyl)-4-(4-morpholin-4-ylmethylphenyl)isoxazole-3-carboxylic acid ethylamide",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "10",
    pmids:
      "27224913,18020435,25982393,26832792,25446253,25389454,26893968,27391062,25210794,19324279",
  },
  {
    id: "991",
    id_polifenol: "1611",
    polifenol: "bis(4-hydroxycinnamoyl)methane",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "6",
    pmids: "27550987,29368356,19000900,7954412,17760412,12543061",
  },
  {
    id: "992",
    id_polifenol: "107",
    polifenol: "beta-Naphthoflavone",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "3",
    pmids: "12818365,9489484,1989500",
  },
  {
    id: "993",
    id_polifenol: "119",
    polifenol: "Silymarin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "7",
    pmids: "12943822,20431887,15993897,25609004,19945967,12216075,8019514",
  },
  {
    id: "994",
    id_polifenol: "69",
    polifenol: "Phenolsulfonphthalein",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "4",
    pmids: "19434493,27477245,21422595,24462388",
  },
  {
    id: "995",
    id_polifenol: "126",
    polifenol: "Coumestrol",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "5",
    pmids: "23768371,29064398,9698072,23674609,15579483",
  },
  {
    id: "996",
    id_polifenol: "55",
    polifenol: "Sodium Salicylate",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "10",
    pmids:
      "12851702,23110215,14634277,14521608,10480951,10631359,11813903,9484814,11704643,9733711",
  },
  {
    id: "997",
    id_polifenol: "5806",
    polifenol: "butein",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "5",
    pmids: "24931875,15214488,19606519,9230122,8033070",
  },
  {
    id: "998",
    id_polifenol: "108",
    polifenol: "Biflavonoids",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "7",
    pmids: "27288921,21915931,20345100,28926234,21471210,18379113,12762790",
  },
  {
    id: "999",
    id_polifenol: "1558",
    polifenol: "capsazepine",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "3",
    pmids: "15383218,22922338,26482371",
  },
  {
    id: "1000",
    id_polifenol: "5509",
    polifenol: "cyanidin 3-O-glucoside",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "10",
    pmids:
      "27347927,29037704,18751377,16933884,26304331,19695862,18327700,29407472,26041170,19950996",
  },
  {
    id: "1001",
    id_polifenol: "969",
    polifenol: "3,4-dihydroxyphenacyl caffeate phenylpropanoid ester",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "9",
    pmids:
      "26546748,27748934,29246220,11411569,28744911,23892206,20506543,21458113,18177907",
  },
  {
    id: "1002",
    id_polifenol: "5844",
    polifenol: "4-dimethylamino-3',4'-dimethoxychalcone",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "10",
    pmids:
      "15161716,11439335,16364925,19464056,11106264,17603079,14986030,15494722,17585452,12657200",
  },
  {
    id: "1003",
    id_polifenol: "6463",
    polifenol: "puerarin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "6",
    pmids: "8242641,27445823,16055262,26795076,16254887,23089583",
  },
  {
    id: "1004",
    id_polifenol: "5819",
    polifenol: "licochalcone A",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "6",
    pmids: "20383690,24253317,27017265,20637733,24944769,18484961",
  },
  {
    id: "1005",
    id_polifenol: "94",
    polifenol: "Phloretin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "6",
    pmids: "18158826,29399200,26633321,23174508,27538679,18398871",
  },
  {
    id: "1006",
    id_polifenol: "4560",
    polifenol: "icariin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "3",
    pmids: "24435883,24590261,25472572",
  },
  {
    id: "1007",
    id_polifenol: "48",
    polifenol: "Anacardic Acids",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "2",
    pmids: "23128090,28717171",
  },
  {
    id: "1008",
    id_polifenol: "5488",
    polifenol: "cyanidin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "12",
    pmids:
      "18053307,18751377,15016660,26927179,29515203,12094622,12706854,28009871,29662851,20494645,28740990,19294386",
  },
  {
    id: "1009",
    id_polifenol: "4640",
    polifenol: "5,7-dihydroxy-6-methoxy-2-phenylchromen-4-one",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "7",
    pmids: "25251374,22526619,26958937,22949302,22607196,28594405,23823704",
  },
  {
    id: "1010",
    id_polifenol: "4537",
    polifenol: "flavone acetic acid",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "8",
    pmids: "25461325,3653209,2394038,3583640,7674335,3546183,3708611,1477076",
  },
  {
    id: "1011",
    id_polifenol: "2773",
    polifenol: "farnesylthiosalicylic acid",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "7",
    pmids: "27710830,20473860,15337531,23227266,11839677,21901261,19372139",
  },
  {
    id: "1012",
    id_polifenol: "80",
    polifenol: "Clofibrate",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "2",
    pmids: "22619672,1403680",
  },
  {
    id: "1013",
    id_polifenol: "132",
    polifenol: "Equol",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "2",
    pmids: "17088408,28628136",
  },
  {
    id: "1014",
    id_polifenol: "1995",
    polifenol: "2-tert-butylhydroquinone",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "4",
    pmids: "12818365,27111399,26608515,11239498",
  },
  {
    id: "1015",
    id_polifenol: "7546",
    polifenol: "isoquercitrin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "9",
    pmids:
      "20944146,27876336,27989839,15759309,12085217,28539711,25359775,26284613,24520932",
  },
  {
    id: "1016",
    id_polifenol: "6482",
    polifenol: "tangeretin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "4",
    pmids: "24573532,17197076,23137376,29313727",
  },
  {
    id: "1017",
    id_polifenol: "89",
    polifenol: "Vanillic Acid",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "8",
    pmids:
      "26546748,29658045,27235722,11097223,21337646,26041170,27701810,24956844",
  },
  {
    id: "1018",
    id_polifenol: "99",
    polifenol: "Pyrogallol",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "3",
    pmids: "11237204,23442980,28346686",
  },
  {
    id: "1019",
    id_polifenol: "452",
    polifenol: "acteoside",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "5",
    pmids: "29886834,28744911,25282590,19099401,28671329",
  },
  {
    id: "1020",
    id_polifenol: "1644",
    polifenol: "Cur1 compound",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "3",
    pmids: "29273065,21283869,21988497",
  },
  {
    id: "1021",
    id_polifenol: "100",
    polifenol: "Resorcinols",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "3",
    pmids: "10783318,24605779,26262998",
  },
  {
    id: "1022",
    id_polifenol: "5614",
    polifenol: "catechin gallate",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "8",
    pmids:
      "19723101,9600345,29596305,23201840,23719279,28346686,17168588,22943128",
  },
  {
    id: "1023",
    id_polifenol: "4486",
    polifenol: "amentoflavone",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "7",
    pmids: "20345100,15787435,25057079,28926234,21471210,24126114,15225597",
  },
  {
    id: "1024",
    id_polifenol: "5850",
    polifenol: "cardamonin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "7",
    pmids: "29928339,23538439,21797841,27192488,29066742,25959811,23814530",
  },
  {
    id: "1025",
    id_polifenol: "118",
    polifenol: "Flavonolignans",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "4",
    pmids: "22555452,21779837,27402681,23555889",
  },
  {
    id: "1026",
    id_polifenol: "7541",
    polifenol: "taxifolin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "3",
    pmids: "22160193,15163544,26482805",
  },
  {
    id: "1027",
    id_polifenol: "7544",
    polifenol: "quercitrin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "7",
    pmids: "29039609,22888531,25887035,25794927,25096395,28539711,12880319",
  },
  {
    id: "1028",
    id_polifenol: "60",
    polifenol: "2,4-Dinitrophenol",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "3",
    pmids: "8950221,2297707,17998105",
  },
  {
    id: "1029",
    id_polifenol: "300",
    polifenol: "rhodioloside",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "4",
    pmids: "27748934,29246220,29115408,25755753",
  },
  {
    id: "1030",
    id_polifenol: "6465",
    polifenol: "genistin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "4",
    pmids: "8242641,23900272,11506804,14968209",
  },
  {
    id: "1031",
    id_polifenol: "350",
    polifenol: "nonylphenol",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "28656208",
  },
  {
    id: "1032",
    id_polifenol: "4767",
    polifenol: "flavan-3-ol",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "5",
    pmids: "29463813,26774105,24905821,18398871,20540818",
  },
  {
    id: "1033",
    id_polifenol: "2475",
    polifenol: "6-O-galloylglucose",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "4",
    pmids: "29871992,12085217,29515203,19888728",
  },
  {
    id: "1034",
    id_polifenol: "6097",
    polifenol: "8-prenylnaringenin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "5",
    pmids: "25771121,20633549,23361834,17579893,16715376",
  },
  {
    id: "1035",
    id_polifenol: "2447",
    polifenol: "beta-penta-O-galloyl-glucose",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "2",
    pmids: "29778287,21048315",
  },
  {
    id: "1036",
    id_polifenol: "6068",
    polifenol: "pinocembrin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "7",
    pmids: "26459308,28385566,17186548,26347954,24660462,23504630,21973101",
  },
  {
    id: "1037",
    id_polifenol: "1996",
    polifenol: "2,5-di-tert-butylhydroquinone",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "28846107",
  },
  {
    id: "1038",
    id_polifenol: "5071",
    polifenol: "icaritin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "3",
    pmids: "27900033,26427664,28103582",
  },
  {
    id: "1039",
    id_polifenol: "6576",
    polifenol: "5,7,4'-trihydroxyflavone",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "5",
    pmids: "24626522,19638489,19050992,21548803,16868069",
  },
  {
    id: "1040",
    id_polifenol: "4585",
    polifenol: "baohuoside I",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "26293804",
  },
  {
    id: "1041",
    id_polifenol: "6625",
    polifenol: "phenoxodiol",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "19220577",
  },
  {
    id: "1042",
    id_polifenol: "6086",
    polifenol: "liquiritigenin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "2",
    pmids: "29471888,27920817",
  },
  {
    id: "1043",
    id_polifenol: "1616",
    polifenol: "tetrahydrocurcumin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "6",
    pmids: "15073046,11237176,11370761,24859389,19000900,11221833",
  },
  {
    id: "1044",
    id_polifenol: "59",
    polifenol: "Dinitrophenols",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "27679575",
  },
  {
    id: "1045",
    id_polifenol: "4516",
    polifenol: "diosmetin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "20183323",
  },
  {
    id: "1046",
    id_polifenol: "102",
    polifenol: "Zearalenone",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "2",
    pmids: "21683775,26920053",
  },
  {
    id: "1047",
    id_polifenol: "7161",
    polifenol: "scutellarin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "5",
    pmids: "29218107,19661313,28035355,16218664,23399159",
  },
  {
    id: "1048",
    id_polifenol: "2328",
    polifenol: "syringic acid",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "7",
    pmids: "23958424,23799608,29465116,29658045,29645049,24688218,23442980",
  },
  {
    id: "1049",
    id_polifenol: "7296",
    polifenol: "dihydromyricetin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "2",
    pmids: "27997436,12880319",
  },
  {
    id: "1050",
    id_polifenol: "40",
    polifenol: "Propyl Gallate",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "2",
    pmids: "22529978,9162301",
  },
  {
    id: "1051",
    id_polifenol: "36",
    polifenol: "Hydroxybenzoates",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "2",
    pmids: "23994083,21466426",
  },
  {
    id: "1052",
    id_polifenol: "7134",
    polifenol: "vitexin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "4",
    pmids: "29423046,29348836,26284613,28539721",
  },
  {
    id: "1053",
    id_polifenol: "6558",
    polifenol: "7,3'-dihydroxy-4'-methoxyisoflavone",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "4",
    pmids: "27393650,26215320,29966979,28445053",
  },
  {
    id: "1054",
    id_polifenol: "4525",
    polifenol: "eupatilin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "25605996",
  },
  {
    id: "1055",
    id_polifenol: "5455",
    polifenol: "theaflavin-3,3'-digallate",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "2",
    pmids: "11103814,18992738",
  },
  {
    id: "1056",
    id_polifenol: "2490",
    polifenol: "punicalagin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "4",
    pmids: "16448212,15936648,16426830,29928972",
  },
  {
    id: "1057",
    id_polifenol: "5815",
    polifenol: "dibenzoylmethane",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "5",
    pmids: "12822933,15073046,17077187,19959557,17942926",
  },
  {
    id: "1058",
    id_polifenol: "5630",
    polifenol: "polyphenon E",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "6",
    pmids: "15814656,17616711,28323438,22258296,17893236,21479417",
  },
  {
    id: "1059",
    id_polifenol: "7547",
    polifenol: "hyperoside",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "5",
    pmids: "27073499,24173369,29067453,27876336,15759309",
  },
  {
    id: "1060",
    id_polifenol: "349",
    polifenol: "4-nitrophenol",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "2",
    pmids: "4053018,22236574",
  },
  {
    id: "1061",
    id_polifenol: "5495",
    polifenol: "malvidin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "5",
    pmids: "12502387,26927179,21888504,20494645,28740990",
  },
  {
    id: "1062",
    id_polifenol: "7141",
    polifenol: "apigetrin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "28827996",
  },
  {
    id: "1063",
    id_polifenol: "6301",
    polifenol: "3-methoxyflavone",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "3",
    pmids: "16077033,16079301,15917307",
  },
  {
    id: "1064",
    id_polifenol: "77",
    polifenol: "Bezafibrate",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "5",
    pmids: "12009300,15892897,11289109,16606335,19884989",
  },
  {
    id: "1065",
    id_polifenol: "1810",
    polifenol: "heminordihydroguaiaretic acid",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "2",
    pmids: "15958646,15008823",
  },
  {
    id: "1066",
    id_polifenol: "43",
    polifenol: "Parabens",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "29451980",
  },
  {
    id: "1067",
    id_polifenol: "6783",
    polifenol: "protoapigenone",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "23624232",
  },
  {
    id: "1068",
    id_polifenol: "6477",
    polifenol: "hispidulin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "3",
    pmids: "10579870,29575334,26045985",
  },
  {
    id: "1069",
    id_polifenol: "6510",
    polifenol: "glycitein",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "3",
    pmids: "17088408,21161820,14968209",
  },
  {
    id: "1070",
    id_polifenol: "7198",
    polifenol: "homoorientin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "2",
    pmids: "26284613,28539721",
  },
  {
    id: "1071",
    id_polifenol: "128",
    polifenol: "Pterocarpans",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "2",
    pmids: "27464528,18440233",
  },
  {
    id: "1072",
    id_polifenol: "7557",
    polifenol: "rhamnetin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "3",
    pmids: "27721177,23861102,21716619",
  },
  {
    id: "1073",
    id_polifenol: "6456",
    polifenol: "daidzin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "3",
    pmids: "16254887,23900272,11506804",
  },
  {
    id: "1074",
    id_polifenol: "1353",
    polifenol: "protocatechualdehyde",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "5",
    pmids: "24712725,27447597,23799608,23159608,25447816",
  },
  {
    id: "1075",
    id_polifenol: "4501",
    polifenol: "tricin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "10",
    pmids:
      "25941936,19638489,19934339,16170019,11097223,25671061,29483221,19695862,16552572,22983843",
  },
  {
    id: "1076",
    id_polifenol: "4883",
    polifenol: "flavokawain B",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "2",
    pmids: "28103302,20398749",
  },
  {
    id: "1077",
    id_polifenol: "5496",
    polifenol: "pelargonidin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "4",
    pmids: "23441618,18800807,21888504,20494645",
  },
  {
    id: "1078",
    id_polifenol: "7853",
    polifenol: "Grape Seed Proanthocyanidins",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "3",
    pmids: "17923279,21642017,11759289",
  },
  {
    id: "1079",
    id_polifenol: "4304",
    polifenol: "5-7-oxo-zeaenol",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "2",
    pmids: "22753724,26114584",
  },
  {
    id: "1080",
    id_polifenol: "7612",
    polifenol: "quercetin 3-O-glucuronide",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "4",
    pmids: "25605996,15225597,16129554,14640528",
  },
  {
    id: "1081",
    id_polifenol: "7775",
    polifenol: "glyceollin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "2",
    pmids: "26703673,28956670",
  },
  {
    id: "1082",
    id_polifenol: "687",
    polifenol: "calix(4)arene",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "3",
    pmids: "22997162,29393416,18597414",
  },
  {
    id: "1083",
    id_polifenol: "5796",
    polifenol: "dihydrochalcone",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "3",
    pmids: "26633321,24273860,12762790",
  },
  {
    id: "1084",
    id_polifenol: "6066",
    polifenol: "eriodictyol",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "3",
    pmids: "28539711,20648923,25553799",
  },
  {
    id: "1085",
    id_polifenol: "353",
    polifenol: "sesamol",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "3",
    pmids: "27328416,24688218,25759517",
  },
  {
    id: "1086",
    id_polifenol: "2574",
    polifenol: "4-hydroxybenzoic acid",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "3",
    pmids: "25738869,22361689,25016231",
  },
  {
    id: "1087",
    id_polifenol: "3019",
    polifenol: "nitroaspirin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "9",
    pmids:
      "12438552,16105666,16169935,17956352,11309281,16818512,22039321,14697260,19114773",
  },
  {
    id: "1088",
    id_polifenol: "680",
    polifenol: "xanthorrhizol",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "2",
    pmids: "19926935,24530873",
  },
  {
    id: "1089",
    id_polifenol: "713",
    polifenol:
      "3-(3-chloro-4-hydroxyphenylamino)-4-(4-nitrophenyl)-1H-pyrrole-2,5-dione",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "17697341",
  },
  {
    id: "1090",
    id_polifenol: "4480",
    polifenol: "myricitrin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "4",
    pmids: "15713899,23561189,25794927,12880319",
  },
  {
    id: "1091",
    id_polifenol: "5794",
    polifenol: "2'-hydroxychalcone",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "4",
    pmids: "28694750,9230122,8033070,20826087",
  },
  {
    id: "1092",
    id_polifenol: "4521",
    polifenol: "3-hydroxyflavone",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "10919656",
  },
  {
    id: "1093",
    id_polifenol: "3489",
    polifenol: "anethole",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "3",
    pmids: "26514509,27537869,26349496",
  },
  {
    id: "1094",
    id_polifenol: "115",
    polifenol: "Diosmin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "5",
    pmids: "12384797,10443335,20183323,12718627,12559383",
  },
  {
    id: "1095",
    id_polifenol: "87",
    polifenol: "Metoclopramide",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "9458091",
  },
  {
    id: "1096",
    id_polifenol: "2014",
    polifenol: "erbstatin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "2",
    pmids: "10367258,10797565",
  },
  {
    id: "1097",
    id_polifenol: "2448",
    polifenol: "ellagitannin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "4",
    pmids: "24077694,26634414,27270323,26995228",
  },
  {
    id: "1098",
    id_polifenol: "7156",
    polifenol: "scutellarein",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "2",
    pmids: "29457739,16218664",
  },
  {
    id: "1099",
    id_polifenol: "6800",
    polifenol: "3,6-dimethoxy-6'',6''-dimethylchromeno(2'',3''-7,8)flavone",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "27661668",
  },
  {
    id: "1100",
    id_polifenol: "5831",
    polifenol: "angoletin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "3",
    pmids: "19259708,26434878,20232614",
  },
  {
    id: "1101",
    id_polifenol: "4565",
    polifenol: "morusin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "18485277",
  },
  {
    id: "1102",
    id_polifenol: "885",
    polifenol: "oleocanthal",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "3",
    pmids: "28656311,17999988,29734791",
  },
  {
    id: "1103",
    id_polifenol: "6129",
    polifenol: "wogonoside",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "3",
    pmids: "29541215,24026776,27102438",
  },
  {
    id: "1104",
    id_polifenol: "6175",
    polifenol: "2'-hydroxyflavanone",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "3",
    pmids: "22648623,15163544,24530873",
  },
  {
    id: "1105",
    id_polifenol: "6112",
    polifenol: "alpinetin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "28103302",
  },
  {
    id: "1106",
    id_polifenol: "6770",
    polifenol: "5-hydroxy-3,6,7,8,3',4'-hexamethoxyflavone",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "3",
    pmids: "21648071,21462329,20397199",
  },
  {
    id: "1107",
    id_polifenol: "2283",
    polifenol: "depsidone",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "28887754",
  },
  {
    id: "1108",
    id_polifenol: "711",
    polifenol: "ascochlorin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "19253369",
  },
  {
    id: "1109",
    id_polifenol: "6457",
    polifenol: "salvigenin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "3",
    pmids: "25193463,29373904,28552787",
  },
  {
    id: "1110",
    id_polifenol: "2697",
    polifenol: "4-trifluoromethylsalicylic acid",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "2",
    pmids: "23958424,12389735",
  },
  {
    id: "1111",
    id_polifenol: "5005",
    polifenol: "procyanidin B",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "21945981",
  },
  {
    id: "1112",
    id_polifenol: "12",
    polifenol: "Guaiacol",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "24121236",
  },
  {
    id: "1113",
    id_polifenol: "2790",
    polifenol: "ginkgolic acid",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "2",
    pmids: "29353042,29113214",
  },
  {
    id: "1114",
    id_polifenol: "357",
    polifenol: "4-aminophenol",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "8425184",
  },
  {
    id: "1115",
    id_polifenol: "704",
    polifenol: "trizol",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "16038031",
  },
  {
    id: "1116",
    id_polifenol: "4479",
    polifenol: "morin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "22350814",
  },
  {
    id: "1117",
    id_polifenol: "6166",
    polifenol: "liquiritin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "7882322",
  },
  {
    id: "1118",
    id_polifenol: "4052",
    polifenol: "bis-(3-(3',5'-di-tert-butyl-4'-hydroxyphenyl)propyl)sulfide",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "23452983",
  },
  {
    id: "1119",
    id_polifenol: "4578",
    polifenol: "5,7-dimethoxyflavone",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "16868069",
  },
  {
    id: "1120",
    id_polifenol: "9",
    polifenol: "1,2-Dihydroxybenzene-3,5-Disulfonic Acid Disodium Salt",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "19728331",
  },
  {
    id: "1121",
    id_polifenol: "6100",
    polifenol: "pinostrobin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "2",
    pmids: "27603115,26347954",
  },
  {
    id: "1122",
    id_polifenol: "347",
    polifenol: "4-nitrophenyl",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "3",
    pmids: "21801146,17409538,9988682",
  },
  {
    id: "1123",
    id_polifenol: "6774",
    polifenol: "5,7-dihydroxy-6,3',4'-trimethoxyflavone",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "12677524",
  },
  {
    id: "1124",
    id_polifenol: "315",
    polifenol: "bakuchiol",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "27033605",
  },
  {
    id: "1125",
    id_polifenol: "5538",
    polifenol: "petunidin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "4",
    pmids: "26927179,28009871,26101614,28740990",
  },
  {
    id: "1126",
    id_polifenol: "5875",
    polifenol: "panduratin A",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "15971119",
  },
  {
    id: "1127",
    id_polifenol: "4839",
    polifenol: "7-hydroxyflavone",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "3",
    pmids: "28587286,29116937,16868069",
  },
  {
    id: "1128",
    id_polifenol: "7199",
    polifenol: "luteolin-7-glucoside",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "2",
    pmids: "27876336,25630793",
  },
  {
    id: "1129",
    id_polifenol: "5885",
    polifenol: "2',4'-dihydroxy-6'-methoxy-3',5'-dimethylchalcone",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "25530783",
  },
  {
    id: "1130",
    id_polifenol: "5537",
    polifenol: "peonidin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "3",
    pmids: "26927179,28009871,28740990",
  },
  {
    id: "1131",
    id_polifenol: "428",
    polifenol: "2,2'-bisphenol F",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "14723964",
  },
  {
    id: "1132",
    id_polifenol: "7453",
    polifenol: "kaempferol-3-O-glucoside",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "28539711",
  },
  {
    id: "1133",
    id_polifenol: "4573",
    polifenol: "3,3',4',5,6,7,8-heptamethoxyflavone",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "19054677",
  },
  {
    id: "1134",
    id_polifenol: "4981",
    polifenol: "jaceosidin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "7997472",
  },
  {
    id: "1135",
    id_polifenol: "4639",
    polifenol: "aromadedrin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "2",
    pmids: "23137376,18176909",
  },
  {
    id: "1136",
    id_polifenol: "7658",
    polifenol: "quercetin 3'-O-glucoside",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "26428271",
  },
  {
    id: "1137",
    id_polifenol: "3258",
    polifenol: "tesmilifene",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "10755318",
  },
  {
    id: "1138",
    id_polifenol: "6497",
    polifenol: "isoflavanone",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "2",
    pmids: "18440233,24354192",
  },
  {
    id: "1139",
    id_polifenol: "7895",
    polifenol: "flavokawain A",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "3",
    pmids: "28808400,26859847,25379458",
  },
  {
    id: "1140",
    id_polifenol: "3494",
    polifenol: "asarone",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "2",
    pmids: "23244151,23357361",
  },
  {
    id: "1141",
    id_polifenol: "6453",
    polifenol: "cirsimaritin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "22184071",
  },
  {
    id: "1142",
    id_polifenol: "4553",
    polifenol: "sulfuretin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "19606519",
  },
  {
    id: "1143",
    id_polifenol: "70",
    polifenol: "Sulfobromophthalein",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "18654741",
  },
  {
    id: "1144",
    id_polifenol: "5615",
    polifenol: "gallocatechin gallate",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "2",
    pmids: "23201840,17202688",
  },
  {
    id: "1145",
    id_polifenol: "6549",
    polifenol: "7-hydroxy-2',3',4',5',8-pentamethoxyisoflavan",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "18440233",
  },
  {
    id: "1146",
    id_polifenol: "1662",
    polifenol: "BDMC-A",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "2",
    pmids: "27889234,12543061",
  },
  {
    id: "1147",
    id_polifenol: "5858",
    polifenol: "isobavachalcone",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "26547532",
  },
  {
    id: "1148",
    id_polifenol: "5539",
    polifenol: "peonidin 3-glucoside",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "2",
    pmids: "23784800,26041170",
  },
  {
    id: "1149",
    id_polifenol: "4632",
    polifenol: "ginkgetin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "28902363",
  },
  {
    id: "1150",
    id_polifenol: "5245",
    polifenol: "BF6-6 biflavone",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "28839377",
  },
  {
    id: "1151",
    id_polifenol: "839",
    polifenol: "5-iodo-3-((3,5-dibromo-4-hydroxyphenyl)methylene)-2-indolinone",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "3",
    pmids: "23172826,17465197,27670374",
  },
  {
    id: "1152",
    id_polifenol: "2504",
    polifenol: "pentagalloylglucose",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "2",
    pmids: "22216935,21048315",
  },
  {
    id: "1153",
    id_polifenol: "2",
    polifenol: "Aminophenols",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "15133197",
  },
  {
    id: "1154",
    id_polifenol: "6819",
    polifenol: "luteolin-7-O-glucoside",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "28552787",
  },
  {
    id: "1155",
    id_polifenol: "4607",
    polifenol: "orientin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "29198745",
  },
  {
    id: "1156",
    id_polifenol: "2807",
    polifenol: "thiosalicylic acid",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "11055588",
  },
  {
    id: "1157",
    id_polifenol: "6093",
    polifenol: "pinobanksin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "3",
    pmids: "26347954,22434356,18389469",
  },
  {
    id: "1158",
    id_polifenol: "7239",
    polifenol: "isosilybin A",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "2",
    pmids: "17201169,23674609",
  },
  {
    id: "1159",
    id_polifenol: "6287",
    polifenol: "neohesperidin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "3",
    pmids: "19782062,15796208,24868862",
  },
  {
    id: "1160",
    id_polifenol: "5542",
    polifenol: "delphinidin 3-O-glucopyranoside",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "4",
    pmids: "29037704,16933884,29407472,25442541",
  },
  {
    id: "1161",
    id_polifenol: "7437",
    polifenol: "kaempferol-3-O-rutinoside",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "3",
    pmids: "27013795,21262328,24711053",
  },
  {
    id: "1162",
    id_polifenol: "1718",
    polifenol: "dihydroguaiaretic acid",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "9619854",
  },
  {
    id: "1163",
    id_polifenol: "1237",
    polifenol: "2,4-bis(p-hydroxyphenyl)-2-butenal",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "4",
    pmids: "24052407,29207641,24009847,26474284",
  },
  {
    id: "1164",
    id_polifenol: "2168",
    polifenol: "beta-resorcylic acid",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "3",
    pmids: "24579782,25574154,29075787",
  },
  {
    id: "1165",
    id_polifenol: "1106",
    polifenol: "1,1-bis(3'-indolyl)-1-(4-hydroxyphenyl)methane",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "2",
    pmids: "25099012,28418095",
  },
  {
    id: "1166",
    id_polifenol: "4703",
    polifenol: "eupatorin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "29373904",
  },
  {
    id: "1167",
    id_polifenol: "7422",
    polifenol: "kaempferide",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "20104502",
  },
  {
    id: "1168",
    id_polifenol: "962",
    polifenol: "2,6-di-tert-butyl-4-methylphenol",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "14704326",
  },
  {
    id: "1169",
    id_polifenol: "2173",
    polifenol: "atranorin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "28887754",
  },
  {
    id: "1170",
    id_polifenol: "5532",
    polifenol: "malvidin-3-glucoside",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "23124926",
  },
  {
    id: "1171",
    id_polifenol: "6680",
    polifenol: "6,7,4'-trihydroxyisoflavone",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "21258042",
  },
  {
    id: "1172",
    id_polifenol: "7590",
    polifenol: "quercetin-3-O-rutinoside",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "2",
    pmids: "26434289,21716619",
  },
  {
    id: "1173",
    id_polifenol: "5841",
    polifenol: "2',6'-dihydroxy-4'-methoxychalcone",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "3",
    pmids: "21797841,25959811,8033070",
  },
  {
    id: "1174",
    id_polifenol: "444",
    polifenol: "2,4-di-tert-butylphenol",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "3",
    pmids: "23517721,24295787,19471192",
  },
  {
    id: "1175",
    id_polifenol: "1629",
    polifenol: "bis-1,7-(2-hydroxyphenyl)-hepta-1,6-diene-3,5-dione",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "3",
    pmids: "28358339,12543061,12208119",
  },
  {
    id: "1176",
    id_polifenol: "1509",
    polifenol: "8-gingerol",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "2",
    pmids: "28065501,25251219",
  },
  {
    id: "1177",
    id_polifenol: "6459",
    polifenol: "genkwanin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "26388189",
  },
  {
    id: "1178",
    id_polifenol: "57",
    polifenol: "2,6-Dichloroindophenol",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "1458556",
  },
  {
    id: "1179",
    id_polifenol: "58",
    polifenol: "Nitrophenols",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "17875720",
  },
  {
    id: "1180",
    id_polifenol: "3490",
    polifenol: "estragole",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "27537869",
  },
  {
    id: "1181",
    id_polifenol: "1883",
    polifenol: "2-amino-5-methylphenol",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "28114318",
  },
  {
    id: "1182",
    id_polifenol: "4764",
    polifenol: "tectochrysin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "3",
    pmids: "27025376,26123287,26347954",
  },
  {
    id: "1183",
    id_polifenol: "4558",
    polifenol: "2'-hydroxyflavone",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "3",
    pmids: "29574877,22184071,29116937",
  },
  {
    id: "1184",
    id_polifenol: "5101",
    polifenol: "isokaempferide",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "22184071",
  },
  {
    id: "1185",
    id_polifenol: "4698",
    polifenol: "sakuranetin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "2",
    pmids: "23285814,15796208",
  },
  {
    id: "1186",
    id_polifenol: "5814",
    polifenol: "2',4'-dihydroxychalcone",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "3",
    pmids: "8033070,19689125,24660462",
  },
  {
    id: "1187",
    id_polifenol: "1585",
    polifenol: "curcumin glucuronide",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "5",
    pmids: "11237176,11370761,28867734,11221833,15668484",
  },
  {
    id: "1188",
    id_polifenol: "52",
    polifenol: "Diflunisal",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "2",
    pmids: "11764005,24650572",
  },
  {
    id: "1189",
    id_polifenol: "5536",
    polifenol: "prodelphinidin B-2 3'-O-gallate",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "28216880",
  },
  {
    id: "1190",
    id_polifenol: "7169",
    polifenol: "apigenin-6,8-di-C-glycopyranoside",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "29849451",
  },
  {
    id: "1191",
    id_polifenol: "7427",
    polifenol: "kaempferol 3-O-rhamnoside",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "28539711",
  },
  {
    id: "1192",
    id_polifenol: "5525",
    polifenol: "cyanidin 3-rutinoside",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "24520932",
  },
  {
    id: "1193",
    id_polifenol: "2339",
    polifenol: "3-O-methylgallic acid",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "3",
    pmids: "23124926,20373763,23319439",
  },
  {
    id: "1194",
    id_polifenol: "1630",
    polifenol: "dimethoxycurcumin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "3",
    pmids: "27550987,28573788,17317839",
  },
  {
    id: "1195",
    id_polifenol: "1811",
    polifenol: "terameprocol",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "11485827",
  },
  {
    id: "1196",
    id_polifenol: "106",
    polifenol: "Benzoflavones",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "27220561",
  },
  {
    id: "1197",
    id_polifenol: "4548",
    polifenol: "artemetin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "11975496",
  },
  {
    id: "1198",
    id_polifenol: "3040",
    polifenol:
      "4-(3-thioxo-3H-1,2-dithiol-5-yl)phenyl 2-((4-(nitrooxy)butanoyl)oxy)benzoate",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "6",
    pmids: "26319435,28162291,22366248,22916316,26394025,26323873",
  },
  {
    id: "1199",
    id_polifenol: "2159",
    polifenol: "2,3-dihydroxybenzoic acid",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "29075787",
  },
  {
    id: "1200",
    id_polifenol: "273",
    polifenol: "bis(4-nitrophenyl)phosphate",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "2",
    pmids: "15205340,21618543",
  },
  {
    id: "1201",
    id_polifenol: "5941",
    polifenol: "3-hydroxy-4,3',4',5'-tetramethoxychalcone",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "2",
    pmids: "19875299,28838697",
  },
  {
    id: "1202",
    id_polifenol: "5720",
    polifenol: "4,3',4',5'- tetramethoxychalcone",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "2",
    pmids: "19875299,28838697",
  },
  {
    id: "1203",
    id_polifenol: "400",
    polifenol: "cardanol",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "2",
    pmids: "26434878,25723108",
  },
  {
    id: "1204",
    id_polifenol: "5827",
    polifenol: "4'-methoxychalcone",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "25193463",
  },
  {
    id: "1205",
    id_polifenol: "2868",
    polifenol: "3-hydroxy-4-prenyl-5-methoxystilbene-2-carboxylic acid",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "27603115",
  },
  {
    id: "1206",
    id_polifenol: "4082",
    polifenol: "3,3',4,4',5,5'-hexahydroxystilbene",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "2",
    pmids: "18497974,24240809",
  },
  {
    id: "1207",
    id_polifenol: "2161",
    polifenol: "nifuroxazide",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "28055016",
  },
  {
    id: "1208",
    id_polifenol: "7149",
    polifenol: "5,7,4'-trimethylapigenin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "16868069",
  },
  {
    id: "1209",
    id_polifenol: "4263",
    polifenol: "amurensin G",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "24118446",
  },
  {
    id: "1210",
    id_polifenol: "74",
    polifenol: "Anethole Trithione",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "8339252",
  },
  {
    id: "1211",
    id_polifenol: "3245",
    polifenol: "obovatol",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "3",
    pmids: "18762427,18241858,19834284",
  },
  {
    id: "1212",
    id_polifenol: "7633",
    polifenol: "tamarixetin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "24956844",
  },
  {
    id: "1213",
    id_polifenol: "4534",
    polifenol: "3,5,6-trihydroxy-4',7'-dimethoxyflavone",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "12677524",
  },
  {
    id: "1214",
    id_polifenol: "6492",
    polifenol: "3(2H)-isoflavene",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "19220577",
  },
  {
    id: "1215",
    id_polifenol: "7197",
    polifenol: "6-hydroxyluteolin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "2",
    pmids: "18852136,23285814",
  },
  {
    id: "1216",
    id_polifenol: "3299",
    polifenol: "pentabromodiphenyl ether",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "25908029",
  },
  {
    id: "1217",
    id_polifenol: "3665",
    polifenol: "3,5-di-tert-butyl-4-hydroxyanisole",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "14556662",
  },
  {
    id: "1218",
    id_polifenol: "6786",
    polifenol: "8-hydroxy-3,4',5,6,7-pentamethoxyflavone",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "3",
    pmids: "21462329,20397199,19054677",
  },
  {
    id: "1219",
    id_polifenol: "18",
    polifenol: "Hexachlorophene",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "3",
    pmids: "19091460,27521834,16735606",
  },
  {
    id: "1220",
    id_polifenol: "7289",
    polifenol: "isorhamnetin 3-O-glucoside",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "2",
    pmids: "22888531,27925497",
  },
  {
    id: "1221",
    id_polifenol: "2474",
    polifenol: "vescalagin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "2",
    pmids: "19888728,25351676",
  },
  {
    id: "1222",
    id_polifenol: "6633",
    polifenol: "pomiferin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "17662606",
  },
  {
    id: "1223",
    id_polifenol: "7736",
    polifenol: "7-monohydroxyethylrutoside",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "22287334",
  },
  {
    id: "1224",
    id_polifenol: "5616",
    polifenol: "epigallocatechin-3-(3''-O-methyl)gallate",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "16204466",
  },
  {
    id: "1225",
    id_polifenol: "1869",
    polifenol: "4-cresol",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "21885815",
  },
  {
    id: "1226",
    id_polifenol: "2648",
    polifenol: "salicylsalicylic acid",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "28745498",
  },
  {
    id: "1227",
    id_polifenol: "858",
    polifenol: "2-(3-chloro-4-hydroxyphenyl)-2-(4-hydroxyphenyl)propane",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "24843190",
  },
  {
    id: "1228",
    id_polifenol: "1451",
    polifenol: "hispolon",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "25842364",
  },
  {
    id: "1229",
    id_polifenol: "6587",
    polifenol: "glycitin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "2",
    pmids: "23900272,14968209",
  },
  {
    id: "1230",
    id_polifenol: "6940",
    polifenol: "neobavaisoflavone",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "28914038",
  },
  {
    id: "1231",
    id_polifenol: "4073",
    polifenol: "myristicin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "22429024",
  },
  {
    id: "1232",
    id_polifenol: "6478",
    polifenol: "cirsilineol",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "22768128",
  },
  {
    id: "1233",
    id_polifenol: "996",
    polifenol: "2,3-difluoro phenol",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "2",
    pmids: "19421843,17342335",
  },
  {
    id: "1234",
    id_polifenol: "4630",
    polifenol: "5,7,2',3'-tetrahydroxyflavone",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "25081655",
  },
  {
    id: "1235",
    id_polifenol: "4135",
    polifenol: "orcinol",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "12487331",
  },
  {
    id: "1236",
    id_polifenol: "6291",
    polifenol: "alpinumisoflavone",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "27288921",
  },
  {
    id: "1237",
    id_polifenol: "2290",
    polifenol: "lobaric acid",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "3",
    pmids: "22628260,29538328,15549672",
  },
  {
    id: "1238",
    id_polifenol: "6736",
    polifenol: "3'-demethylnobiletin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "3",
    pmids: "23894027,26445322,27977189",
  },
  {
    id: "1239",
    id_polifenol: "2517",
    polifenol: "casuarinin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "2",
    pmids: "24697659,25351676",
  },
  {
    id: "1240",
    id_polifenol: "7657",
    polifenol: "quercetin 3'-sulfate",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "15225597",
  },
  {
    id: "1241",
    id_polifenol: "4524",
    polifenol: "5-hydroxy-3',4',6,7-tetramethoxyflavone",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "2",
    pmids: "12677524,24148842",
  },
  {
    id: "1242",
    id_polifenol: "5833",
    polifenol: "2',5'-dihydroxychalcone",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "20826087",
  },
  {
    id: "1243",
    id_polifenol: "1796",
    polifenol: "(10)-shogaol",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "3",
    pmids: "24786146,21598039,23322393",
  },
  {
    id: "1244",
    id_polifenol: "903",
    polifenol: "vineatrol",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "2",
    pmids: "18384089,19334045",
  },
  {
    id: "1245",
    id_polifenol: "6803",
    polifenol: "isoscutellarein",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "14640528",
  },
  {
    id: "1246",
    id_polifenol: "46",
    polifenol: "Aminosalicylic Acid",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "1499439",
  },
  {
    id: "1247",
    id_polifenol: "2768",
    polifenol: "salophen",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "4",
    pmids: "19259708,28858483,25495038,20828884",
  },
  {
    id: "1248",
    id_polifenol: "6968",
    polifenol: "5-hydroxy-6,7,8,4'-tetramethoxyflavone",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "2",
    pmids: "21462329,20397199",
  },
  {
    id: "1249",
    id_polifenol: "3336",
    polifenol:
      "N-hydroxy-5-ethoxymethyloxy-2-methyl-4-(4-phenoxybenzoyl)aminopentanamide",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "15550999",
  },
  {
    id: "1250",
    id_polifenol: "7810",
    polifenol: "rotenolone",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "3",
    pmids: "23895019,20804165,24354192",
  },
  {
    id: "1251",
    id_polifenol: "6883",
    polifenol: "LYG 202",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "21491996",
  },
  {
    id: "1252",
    id_polifenol: "5791",
    polifenol: "metochalcone",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "3",
    pmids: "19875299,25057485,19695862",
  },
  {
    id: "1253",
    id_polifenol: "5854",
    polifenol: "2'-hydroxy-3,4,3',4',6'-pentamethoxychalcone",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "19875299",
  },
  {
    id: "1254",
    id_polifenol: "3908",
    polifenol: "aspidin BB",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "24530873",
  },
  {
    id: "1255",
    id_polifenol: "5436",
    polifenol: "herbacetin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "26676750",
  },
  {
    id: "1256",
    id_polifenol: "988",
    polifenol: "4'-O-methylnyasol",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "29207641",
  },
  {
    id: "1257",
    id_polifenol: "7823",
    polifenol: "tephrosin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "20056314",
  },
  {
    id: "1258",
    id_polifenol: "2472",
    polifenol: "sanguiin H 6",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "28101119",
  },
  {
    id: "1259",
    id_polifenol: "3362",
    polifenol: "bastadin 4",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "20102170",
  },
  {
    id: "1260",
    id_polifenol: "4576",
    polifenol: "gossypetin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "24956844",
  },
  {
    id: "1261",
    id_polifenol: "6952",
    polifenol: "isoangustone A",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "24486984",
  },
  {
    id: "1262",
    id_polifenol: "7352",
    polifenol: "3',4',5'-trimethoxyflavonol",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "20628003",
  },
  {
    id: "1263",
    id_polifenol: "6847",
    polifenol: "3',4'-didemethylnobiletin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "2",
    pmids: "23894027,26445322",
  },
  {
    id: "1264",
    id_polifenol: "1821",
    polifenol: "2,4-D n-butyl ester",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "17190444",
  },
  {
    id: "1265",
    id_polifenol: "5167",
    polifenol: "6-hydroxyflavone",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "28587286",
  },
  {
    id: "1266",
    id_polifenol: "4919",
    polifenol: "bavachinin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "2",
    pmids: "29335212,10443335",
  },
  {
    id: "1267",
    id_polifenol: "6752",
    polifenol: "zapotin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "17516860",
  },
  {
    id: "1268",
    id_polifenol: "5465",
    polifenol: "vitexin-2-O-xyloside",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "3",
    pmids: "28283822,23411276,27719921",
  },
  {
    id: "1269",
    id_polifenol: "5557",
    polifenol: "cyanidin 3-galactoside",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "29662851",
  },
  {
    id: "1270",
    id_polifenol: "4986",
    polifenol:
      "5-hydroxy-7-methoxyflavone-(4' -O-8'')-5'',7''-dihydroxy-4'''-methoxyflavone",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "24930002",
  },
  {
    id: "1271",
    id_polifenol: "3058",
    polifenol: "2,5-dihydroxybenzoic acid",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "2",
    pmids: "29075787,29885857",
  },
  {
    id: "1272",
    id_polifenol: "6067",
    polifenol: "carthamidin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "16218664",
  },
  {
    id: "1273",
    id_polifenol: "1647",
    polifenol: "hexahydrocurcumin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "4",
    pmids: "22654430,11221833,23322993,22224285",
  },
  {
    id: "1274",
    id_polifenol: "7050",
    polifenol: "3'-chloro-5,7-dimethoxyisoflavone",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "21945666",
  },
  {
    id: "1275",
    id_polifenol: "7659",
    polifenol: "quercetin 7-rhamnoside",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "24711053",
  },
  {
    id: "1276",
    id_polifenol: "6616",
    polifenol: "xanthomicrol",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "22184071",
  },
  {
    id: "1277",
    id_polifenol: "7564",
    polifenol: "camelliaside B",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "2",
    pmids: "15796208,25738869",
  },
  {
    id: "1278",
    id_polifenol: "4303",
    polifenol: "hypothemycin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "25574154",
  },
  {
    id: "1279",
    id_polifenol: "7229",
    polifenol: "silychristin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "17201169",
  },
  {
    id: "1280",
    id_polifenol: "4152",
    polifenol: "quracol B",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "17627575",
  },
  {
    id: "1281",
    id_polifenol: "21",
    polifenol: "Bisacodyl",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "16716974",
  },
  {
    id: "1282",
    id_polifenol: "3435",
    polifenol: "N1-hydroxy-N8-(4-phenoxyphenyl)octanediamide",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "2",
    pmids: "26043797,24190633",
  },
  {
    id: "1283",
    id_polifenol: "184",
    polifenol: "trilobatin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "26633321",
  },
  {
    id: "1284",
    id_polifenol: "5701",
    polifenol: "2',4'-dihydroxy-3,4,5-trimethoxychalcone",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "19875299",
  },
  {
    id: "1285",
    id_polifenol: "4712",
    polifenol: "morelloflavone",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "3",
    pmids: "20345100,15787435,28926234",
  },
  {
    id: "1286",
    id_polifenol: "7531",
    polifenol: "7-O-geranylquercetin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "27980567",
  },
  {
    id: "1287",
    id_polifenol: "2491",
    polifenol: "punicalin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "29928972",
  },
  {
    id: "1288",
    id_polifenol: "935",
    polifenol: "oligonol",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "23394584",
  },
  {
    id: "1289",
    id_polifenol: "4689",
    polifenol: "5,3'-dihydroxy-3,6,7,8,4'-pentamethoxyflavone",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "7623025",
  },
  {
    id: "1290",
    id_polifenol: "6037",
    polifenol: "6-methoxyflavanone",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "21616090",
  },
  {
    id: "1291",
    id_polifenol: "3954",
    polifenol: "Aristoforin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "2",
    pmids: "27261575,23099482",
  },
  {
    id: "1292",
    id_polifenol: "4248",
    polifenol: "4-(6-hydroxy-2-naphthyl)-1,3-benzenediol",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "20198347",
  },
  {
    id: "1293",
    id_polifenol: "5145",
    polifenol: "artonin B",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "20384315",
  },
  {
    id: "1294",
    id_polifenol: "1424",
    polifenol: "rooperol",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "25404486",
  },
  {
    id: "1295",
    id_polifenol: "2933",
    polifenol: "balsalazide",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "3",
    pmids: "26130998,10853036,28108625",
  },
  {
    id: "1296",
    id_polifenol: "4149",
    polifenol: "adipostatin A",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "3",
    pmids: "28472978,26434878,16506814",
  },
  {
    id: "1297",
    id_polifenol: "142",
    polifenol: "1,5-bis(3-hydroxyphenyl)-1,4-pentadiene-3-one",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "27801454",
  },
  {
    id: "1298",
    id_polifenol: "1642",
    polifenol: "FLLL 32",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "20712901",
  },
  {
    id: "1299",
    id_polifenol: "7817",
    polifenol: "amorphigenin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "27280936",
  },
  {
    id: "1300",
    id_polifenol: "4274",
    polifenol: "O 1602",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "22965195",
  },
  {
    id: "1301",
    id_polifenol: "3628",
    polifenol: "1,1-bis(3'-indolyl)-1-(p-anisyl)methane",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "17234778",
  },
  {
    id: "1302",
    id_polifenol: "1417",
    polifenol: "1,2-dihydroxy-4'-chlorobiphenyl",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "18561895",
  },
  {
    id: "1303",
    id_polifenol: "6830",
    polifenol: "artocarpesin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "26547532",
  },
  {
    id: "1304",
    id_polifenol: "4597",
    polifenol: "5-hydroxyflavone",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "28587286",
  },
  {
    id: "1305",
    id_polifenol: "5949",
    polifenol: "2,2'-dihydroxychalcone",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "2",
    pmids: "21479453,20826087",
  },
  {
    id: "1306",
    id_polifenol: "1453",
    polifenol: "4-nerolidylcatechol",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "19084293",
  },
  {
    id: "1307",
    id_polifenol: "4224",
    polifenol: "orsellinic acid",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "19795841",
  },
  {
    id: "1308",
    id_polifenol: "361",
    polifenol: "2-aminophenol",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "28325143",
  },
  {
    id: "1309",
    id_polifenol: "5533",
    polifenol: "cyanidin-3-O-beta-glucopyranoside",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "18053307",
  },
  {
    id: "1310",
    id_polifenol: "6247",
    polifenol: "6,4'-dihydroxy-7-methoxyflavanone",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "15797607",
  },
  {
    id: "1311",
    id_polifenol: "4473",
    polifenol: "robinin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "15796208",
  },
  {
    id: "1312",
    id_polifenol: "4872",
    polifenol: "biapigenin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "2",
    pmids: "20345100,15787435",
  },
  {
    id: "1313",
    id_polifenol: "2760",
    polifenol: "2-methoxybenzoic acid",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "22361689",
  },
  {
    id: "1314",
    id_polifenol: "4518",
    polifenol: "robinetin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "2",
    pmids: "10453447,15796208",
  },
  {
    id: "1315",
    id_polifenol: "7230",
    polifenol: "silydianin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "17201169",
  },
  {
    id: "1316",
    id_polifenol: "521",
    polifenol: "E 7010",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "8137285",
  },
  {
    id: "1317",
    id_polifenol: "7492",
    polifenol:
      "kaempferol 3-O-(3'',6''-di-O-E-p-coumaroyl)-beta-D-glucopyranoside",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "25351676",
  },
  {
    id: "1318",
    id_polifenol: "329",
    polifenol: "2,6-dichloro-4-nitrophenol",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "8055652",
  },
  {
    id: "1319",
    id_polifenol: "2607",
    polifenol: "amorfrutin A",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "26731300",
  },
  {
    id: "1320",
    id_polifenol: "2422",
    polifenol: "ginnalin A",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "2",
    pmids: "29693091,22147441",
  },
  {
    id: "1321",
    id_polifenol: "4748",
    polifenol: "kazinol B",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "25394483",
  },
  {
    id: "1322",
    id_polifenol: "5870",
    polifenol: "hydroxydibenzoylmethane",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "12822933",
  },
  {
    id: "1323",
    id_polifenol: "1948",
    polifenol: "2,6-di-tert-butyl-4-benzoquinone",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "23517721",
  },
  {
    id: "1324",
    id_polifenol: "6840",
    polifenol: "calycopterin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "22184071",
  },
  {
    id: "1325",
    id_polifenol: "2402",
    polifenol: "digalloylresveratrol",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "18952370",
  },
  {
    id: "1326",
    id_polifenol: "5046",
    polifenol: "4'-methoxyflavone",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "24930002",
  },
  {
    id: "1327",
    id_polifenol: "4203",
    polifenol: "methyl orsellinate",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "12487331",
  },
  {
    id: "1328",
    id_polifenol: "2794",
    polifenol: "salazinic acid",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "28887754",
  },
  {
    id: "1329",
    id_polifenol: "4538",
    polifenol: "butrin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "2",
    pmids: "28390310,29403999",
  },
  {
    id: "1330",
    id_polifenol: "4046",
    polifenol: "3-hydroxyphloretin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "26633321",
  },
  {
    id: "1331",
    id_polifenol: "2959",
    polifenol: "(1'-ethoxy)ethyl 2-acetoxybenzoate",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "2",
    pmids: "21984018,20828891",
  },
  {
    id: "1332",
    id_polifenol: "1795",
    polifenol: "1,4-O-diferuloylsecoisolariciresinol",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "28378765",
  },
  {
    id: "1333",
    id_polifenol: "5120",
    polifenol: "diosmetin-7-O-xylopyranosyl-1-6-glucopyranoside",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "20183323",
  },
  {
    id: "1334",
    id_polifenol: "1797",
    polifenol: "(8)-shogaol",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "2",
    pmids: "24786146,23322393",
  },
  {
    id: "1335",
    id_polifenol: "5647",
    polifenol: "peracetylated epigallocatechin-3-gallate",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "2",
    pmids: "22409325,16997910",
  },
  {
    id: "1336",
    id_polifenol: "2924",
    polifenol: "2-methoxy-5-amino-N-hydroxybenzamide",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "3",
    pmids: "21817114,22435743,19737563",
  },
  {
    id: "1337",
    id_polifenol: "292",
    polifenol: "3-dimethylaminophenol",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "21801146",
  },
  {
    id: "1338",
    id_polifenol: "4219",
    polifenol: "baeomycesic acid",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "15549672",
  },
  {
    id: "1339",
    id_polifenol: "2674",
    polifenol: "copper salicylate complex",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "2",
    pmids: "9822550,10693173",
  },
  {
    id: "1340",
    id_polifenol: "5511",
    polifenol: "nasunin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "25442541",
  },
  {
    id: "1341",
    id_polifenol: "5716",
    polifenol: "1,3-bis-(2-hydroxy-phenyl)-propenone",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "2",
    pmids: "22200628,17409538",
  },
  {
    id: "1342",
    id_polifenol: "5409",
    polifenol: "5-hydroxy-7-methoxyflavone",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "27116119",
  },
  {
    id: "1343",
    id_polifenol: "90",
    polifenol: "Mexiletine",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "22292988",
  },
  {
    id: "1344",
    id_polifenol: "7382",
    polifenol: "lespenefril",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "22888531",
  },
  {
    id: "1345",
    id_polifenol: "5053",
    polifenol: "5,7,3',4',5'-pentamethoxyflavone",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "2",
    pmids: "19638489,19695862",
  },
  {
    id: "1346",
    id_polifenol: "5338",
    polifenol: "boeravinone B",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "2",
    pmids: "29046665,21625488",
  },
  {
    id: "1347",
    id_polifenol: "5119",
    polifenol: "isorhamnetin 3-O-rutinoside",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "27876336",
  },
  {
    id: "1348",
    id_polifenol: "1505",
    polifenol: "hydroxytyrosyl acetate",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "2",
    pmids: "23452288,23411228",
  },
  {
    id: "1349",
    id_polifenol: "901",
    polifenol: "epicatechin dimer B2",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "16413414",
  },
  {
    id: "1350",
    id_polifenol: "5804",
    polifenol: "sofalcone",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "26840084",
  },
  {
    id: "1351",
    id_polifenol: "3029",
    polifenol: "NCX 4040",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "21664138",
  },
  {
    id: "1352",
    id_polifenol: "2080",
    polifenol: "2-methoxy-1,4-hydroquinone",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "27111399",
  },
  {
    id: "1353",
    id_polifenol: "7179",
    polifenol: "swertisin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "23453831",
  },
  {
    id: "1354",
    id_polifenol: "6804",
    polifenol: "calycosin-7-O-beta-D-glucoside",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "27932756",
  },
  {
    id: "1355",
    id_polifenol: "1781",
    polifenol: "CA 432",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "22705646",
  },
  {
    id: "1356",
    id_polifenol: "5843",
    polifenol: "rhuschalcone-1",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "2",
    pmids: "26408703,12762790",
  },
  {
    id: "1357",
    id_polifenol: "5549",
    polifenol: "luteolinidin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "2",
    pmids: "26304331,24655033",
  },
  {
    id: "1358",
    id_polifenol: "5507",
    polifenol: "apigeninidin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "2",
    pmids: "26304331,24655033",
  },
  {
    id: "1359",
    id_polifenol: "78",
    polifenol: "Clofenapate",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "12912864",
  },
  {
    id: "1360",
    id_polifenol: "4791",
    polifenol: "myricetin 3-O-(2'',3''-di-O-galloyl)rhamnopyranoside",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "25794927",
  },
  {
    id: "1361",
    id_polifenol: "7223",
    polifenol: "hydnocarpin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "24018191",
  },
  {
    id: "1362",
    id_polifenol: "4653",
    polifenol: "4',7-dihydroxyflavone",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "16868069",
  },
  {
    id: "1363",
    id_polifenol: "7542",
    polifenol: "pachypodol",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "18570232",
  },
  {
    id: "1364",
    id_polifenol: "2987",
    polifenol: "succinyldisalicylic acid",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "2",
    pmids: "25109257,21617874",
  },
  {
    id: "1365",
    id_polifenol: "32",
    polifenol: "Desvenlafaxine Succinate",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "21446053",
  },
  {
    id: "1366",
    id_polifenol: "4713",
    polifenol: "epimedin B",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "24402200",
  },
  {
    id: "1367",
    id_polifenol: "4072",
    polifenol: "elemicin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "18177907",
  },
  {
    id: "1368",
    id_polifenol: "5332",
    polifenol: "MHY336",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "24365999",
  },
  {
    id: "1369",
    id_polifenol: "2307",
    polifenol: "vicanicin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "22628260",
  },
  {
    id: "1370",
    id_polifenol: "4636",
    polifenol: "demethoxysudachitin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "27261599",
  },
  {
    id: "1371",
    id_polifenol: "6340",
    polifenol: "cudraflavone C",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "28107519",
  },
  {
    id: "1372",
    id_polifenol: "5099",
    polifenol: "(2R,3S)-3',4',5,7-tetrahydroxyflavan-3-yl octadecanoate",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "21622140",
  },
  {
    id: "1373",
    id_polifenol: "1648",
    polifenol: "(1E,4E)-1,5-bis(2-methoxyphenyl)penta-1,4-dien-3-one",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "20060305",
  },
  {
    id: "1374",
    id_polifenol: "3917",
    polifenol: "2,4-diacetylphloroglucinol",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "26283170",
  },
  {
    id: "1375",
    id_polifenol: "2213",
    polifenol: "diffractaic acid",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "22628260",
  },
  {
    id: "1376",
    id_polifenol: "5103",
    polifenol: "abyssinone II",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "18484536",
  },
  {
    id: "1377",
    id_polifenol: "4192",
    polifenol: "geoditin A",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "2",
    pmids: "20161972,22412813",
  },
  {
    id: "1378",
    id_polifenol: "2716",
    polifenol: "ethyl salicylate",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "2",
    pmids: "28270064,24520932",
  },
  {
    id: "1379",
    id_polifenol: "5123",
    polifenol: "flavonoid cycloartobiloxanthone",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "20384315",
  },
  {
    id: "1380",
    id_polifenol: "585",
    polifenol: "protosappanin A",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "26036624",
  },
  {
    id: "1381",
    id_polifenol: "6011",
    polifenol: "1-phenyl-3-(thiophen-2-yl)prop-2-en-1-one",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "22987398",
  },
  {
    id: "1382",
    id_polifenol: "2365",
    polifenol: "hamamelitannin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "22216935",
  },
  {
    id: "1383",
    id_polifenol: "5339",
    polifenol: "2S,3S-3,5,7,3',5'-pentahydroxyflavane",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "25298669",
  },
  {
    id: "1384",
    id_polifenol: "5340",
    polifenol: "2R,3R-3,5,6,7,8,4'-hexahydroxyflavane",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "25298669",
  },
  {
    id: "1385",
    id_polifenol: "5154",
    polifenol: "5,7-dihydroxy-8-nitrochrysin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "20878083",
  },
  {
    id: "1386",
    id_polifenol: "6337",
    polifenol: "3-fluoro-5-hydroxy-7-acetoxyflavone",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "2",
    pmids: "28587286,29116937",
  },
  {
    id: "1387",
    id_polifenol: "4770",
    polifenol: "3-bromo-6-methyl-2'-hydroxy flavone",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "15289867",
  },
  {
    id: "1388",
    id_polifenol: "88",
    polifenol: "Trimebutine",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "25343691",
  },
  {
    id: "1389",
    id_polifenol: "6992",
    polifenol:
      "2-(cis-1,2-dihydroxy 4-oxo-cyclohex-5-enyl)-5,7-dihydroxychromone",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "21741427",
  },
  {
    id: "1390",
    id_polifenol: "6937",
    polifenol: "ladanein",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "12677524",
  },
  {
    id: "1391",
    id_polifenol: "3032",
    polifenol: "phosphoaspirin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "18922898",
  },
  {
    id: "1392",
    id_polifenol: "5399",
    polifenol: "7,7''-dimethoxyagastisflavone",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "21915931",
  },
  {
    id: "1393",
    id_polifenol: "5602",
    polifenol: "meciadanol",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "20206613",
  },
  {
    id: "1394",
    id_polifenol: "1532",
    polifenol:
      "12-(3-methoxy-4-(methoxymethoxy) phenyl)-10-oxododec-8-enoic acid ethyl ester",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "22246389",
  },
  {
    id: "1395",
    id_polifenol: "4252",
    polifenol: "4,6-diacetylresorcinol",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "25796013",
  },
  {
    id: "1396",
    id_polifenol: "6737",
    polifenol: "4'-demethylnobiletin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "2",
    pmids: "29063088,26445322",
  },
  {
    id: "1397",
    id_polifenol: "6683",
    polifenol: "5,7,4'-trihydroxy-3'-(3-hydroxy-3-methylbutyl)isoflavone",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "15938138",
  },
  {
    id: "1398",
    id_polifenol: "4520",
    polifenol: "avicularin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "24956844",
  },
  {
    id: "1399",
    id_polifenol: "3994",
    polifenol: "4-geranyloxy-1-(2-methylbutanoyl)phloroglucinol",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "19441072",
  },
  {
    id: "1400",
    id_polifenol: "2229",
    polifenol: "gamma-resorcylic acid",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "29075787",
  },
  {
    id: "1401",
    id_polifenol: "3992",
    polifenol: "4-geranyloxy-2,6-dihydroxybenzophenone",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "19441072",
  },
  {
    id: "1402",
    id_polifenol: "3993",
    polifenol: "4-geranyloxy-1-(2-methylpropanoyl)phloroglucinol",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "19441072",
  },
  {
    id: "1403",
    id_polifenol: "3969",
    polifenol: "arzanol",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "28476462",
  },
  {
    id: "1404",
    id_polifenol: "5558",
    polifenol: "cyanidin 3-sambubioside",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "29407472",
  },
  {
    id: "1405",
    id_polifenol: "941",
    polifenol: "caftaric acid",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "21601008",
  },
  {
    id: "1406",
    id_polifenol: "6314",
    polifenol: "2-(4-(dimethylamino)phenyl)-7,8-dihydroxy-4H-chromen-4-one",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "22768128",
  },
  {
    id: "1407",
    id_polifenol: "7201",
    polifenol: "luteolin 8-C-rhamnoside-7-O-rhamnoside",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "28539721",
  },
  {
    id: "1408",
    id_polifenol: "2086",
    polifenol: "epoxyquinol A",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "16360644",
  },
  {
    id: "1409",
    id_polifenol: "6003",
    polifenol: "boesenbergin A",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "22358425",
  },
  {
    id: "1410",
    id_polifenol: "5553",
    polifenol: "cyanidin 3-xylosylrutinoside",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "24520932",
  },
  {
    id: "1411",
    id_polifenol: "1669",
    polifenol:
      "5-hydroxy-1-(4-hydroxy-3-methoxyphenyl)-7-(5-methylfuran-2-yl)hepta-1,4,6-trien-3-one",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "27293144",
  },
  {
    id: "1412",
    id_polifenol: "7677",
    polifenol:
      "2-(3',4'-dihydroxyphenyl)-5,7-dihydroxy-3-(2'',6''-di-O-(3'''-(4-fluorophenylpropanoyl)))galactosyl-4H-chromen-4-one",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "23719279",
  },
  {
    id: "1413",
    id_polifenol: "5095",
    polifenol: "benzotropolone",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "2",
    pmids: "14723964,28642033",
  },
  {
    id: "1414",
    id_polifenol: "5642",
    polifenol: "4',4''-di-O-methyl-EGCG",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "16204466",
  },
  {
    id: "1415",
    id_polifenol: "7532",
    polifenol: "7-O-butylquercetin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "27980567",
  },
  {
    id: "1416",
    id_polifenol: "2095",
    polifenol: "farnesyl-O-acetylhydroquinone",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "14643448",
  },
  {
    id: "1417",
    id_polifenol: "5810",
    polifenol: "isobutrin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "29403999",
  },
  {
    id: "1418",
    id_polifenol: "4992",
    polifenol: "acacetin-7-O-glucoside",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "21716619",
  },
  {
    id: "1419",
    id_polifenol: "2743",
    polifenol: "salicylacyl glucuronide",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "11764005",
  },
  {
    id: "1420",
    id_polifenol: "3559",
    polifenol: "hierridin B",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "2",
    pmids: "27589771,23922738",
  },
  {
    id: "1421",
    id_polifenol: "7642",
    polifenol: "quercetin-4'-O-beta-D-galactoside",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "28539711",
  },
  {
    id: "1422",
    id_polifenol: "6256",
    polifenol: "(2S)-3',4',5'-trimethoxyflavanone",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "11975496",
  },
  {
    id: "1423",
    id_polifenol: "7565",
    polifenol: "quercetin 3-sambubioside",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "25442541",
  },
  {
    id: "1424",
    id_polifenol: "5486",
    polifenol: "delphinidin-3-rutinoside",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "25442541",
  },
  {
    id: "1425",
    id_polifenol: "1499",
    polifenol: "4-((quinolin-4-yl)vinyl)catechol",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "27739445",
  },
  {
    id: "1426",
    id_polifenol: "1794",
    polifenol:
      "4-(3-hydroxy-4-methoxyphenyl)-3-(4-hydroxyphenyl)-1-(3,4,5-trimethoxyphenyl)azetidin-2-one",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "2",
    pmids: "22705646,23564200",
  },
  {
    id: "1427",
    id_polifenol: "2241",
    polifenol: "2,4,6-trihydroxybenzoic acid",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "2",
    pmids: "29075787,16365058",
  },
  {
    id: "1428",
    id_polifenol: "1058",
    polifenol: "cycloolivil",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "11078194",
  },
  {
    id: "1429",
    id_polifenol: "2529",
    polifenol: "casuariin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "25351676",
  },
  {
    id: "1430",
    id_polifenol: "2906",
    polifenol: "olsalazine",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "11007109",
  },
  {
    id: "1431",
    id_polifenol: "6722",
    polifenol:
      "3,4,11-trihydroxy-2-(hydroxymethyl)-8-(4-hydroxyphenyl)-3,4,4a,11b-tetrahydro-2H,10H-pyrano(2',3'-4,5)furo(3,2-g)chromen-10-one",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "16630115",
  },
  {
    id: "1432",
    id_polifenol: "5432",
    polifenol: "7-piperazinethylchrysin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "22948973",
  },
  {
    id: "1433",
    id_polifenol: "2891",
    polifenol: "amorfrutin B",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "26731300",
  },
  {
    id: "1434",
    id_polifenol: "7684",
    polifenol: "quercetin-5',8-disulfonate",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "22310237",
  },
  {
    id: "1435",
    id_polifenol: "6484",
    polifenol: "psi-baptigenin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "8242641",
  },
  {
    id: "1436",
    id_polifenol: "6391",
    polifenol: "LZ-207",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "26023926",
  },
  {
    id: "1437",
    id_polifenol: "2238",
    polifenol: "benzyl 2-hydroxy-3,6-dimethoxybenzoate",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "23958424",
  },
  {
    id: "1438",
    id_polifenol: "3753",
    polifenol: "benzyl-2,6-dimethoxybenzoate",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "23958424",
  },
  {
    id: "1439",
    id_polifenol: "7806",
    polifenol: "caeruleanone A",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "27280936",
  },
  {
    id: "1440",
    id_polifenol: "5277",
    polifenol: "dehydroglyasperin D",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "27051646",
  },
  {
    id: "1441",
    id_polifenol: "2636",
    polifenol: "lecanoric acid",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "28887754",
  },
  {
    id: "1442",
    id_polifenol: "1663",
    polifenol: "bis-dehydroxy-curcumin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "23326480",
  },
  {
    id: "1443",
    id_polifenol: "4411",
    polifenol: "5,3',4'-tridemethylnobiletin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "23894027",
  },
  {
    id: "1444",
    id_polifenol: "4844",
    polifenol: "3',5'-di-C-glucopyranosylphloretin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "26633321",
  },
  {
    id: "1445",
    id_polifenol: "5881",
    polifenol: "2',3,4,4'-tetrahydroxy-5-prenylchalcone",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "10418944",
  },
  {
    id: "1446",
    id_polifenol: "2271",
    polifenol: "lobarstin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "29538328",
  },
  {
    id: "1447",
    id_polifenol: "3622",
    polifenol: "3,3',4,5'-tetramethoxystilbene",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "18497974",
  },
  {
    id: "1448",
    id_polifenol: "664",
    polifenol: "4-benzyl-1-(3-hydroxyphenyl)piperzine",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "18037152",
  },
  {
    id: "1449",
    id_polifenol: "841",
    polifenol: "3-hydroxyphenylpropionic acid",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "28071050",
  },
  {
    id: "1450",
    id_polifenol: "845",
    polifenol: "1,7-bis(4'-hydroxyphenyl)-3-heptanol",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "25590368",
  },
  {
    id: "1451",
    id_polifenol: "3967",
    polifenol: "prolifenone A",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "17125240",
  },
  {
    id: "1452",
    id_polifenol: "3968",
    polifenol: "prolifenone B",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "17125240",
  },
  {
    id: "1453",
    id_polifenol: "3966",
    polifenol: "prolificin A",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "17125240",
  },
  {
    id: "1454",
    id_polifenol: "488",
    polifenol: "2-(2-hydroxyphenyl)benzothiazole",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "8201603",
  },
  {
    id: "1455",
    id_polifenol: "1635",
    polifenol: "FLLL-11 compound",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "19331692",
  },
  {
    id: "1456",
    id_polifenol: "3936",
    polifenol: "sideroxylonal C",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "24986654",
  },
  {
    id: "1457",
    id_polifenol: "7820",
    polifenol: "deguelin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "12460790",
  },
  {
    id: "1458",
    id_polifenol: "1437",
    polifenol: "4-hydroxy-3-((trimethylammonio)methyl)catechol",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "27192488",
  },
  {
    id: "1459",
    id_polifenol: "5677",
    polifenol: "2'-cysteinyl-epigallocatechin-3-gallate",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "20718469",
  },
  {
    id: "1460",
    id_polifenol: "5450",
    polifenol: "linderone A",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "23173924",
  },
  {
    id: "1461",
    id_polifenol: "4997",
    polifenol: "kaempferol 3-O-(2''-O-glucosyl)rutinoside",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "23453831",
  },
  {
    id: "1462",
    id_polifenol: "6196",
    polifenol: "7-hydroxy-6-methoxyflavanone",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "18440233",
  },
  {
    id: "1463",
    id_polifenol: "4175",
    polifenol: "3,5-dihydroxy-4-isopropylstilbene",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "23861102",
  },
  {
    id: "1464",
    id_polifenol: "7241",
    polifenol: "7-O-galloylsilybin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "23555889",
  },
  {
    id: "1465",
    id_polifenol: "1705",
    polifenol: "hylin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "20696583",
  },
  {
    id: "1466",
    id_polifenol: "4206",
    polifenol: "5-(2'-oxoheptadecyl)resorcinol",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "12562085",
  },
  {
    id: "1467",
    id_polifenol: "4207",
    polifenol: "5-(2'-oxononadecyl)resorcinol",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "12562085",
  },
  {
    id: "1468",
    id_polifenol: "4372",
    polifenol:
      "quercetin 3-O-alpha-rhamnopyranoside-7-O-beta-D-glucopyranosyl-(1-3)-alpha-L-rhamnopyranoside",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "7623025",
  },
  {
    id: "1469",
    id_polifenol: "6532",
    polifenol: "muscomin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "26147490",
  },
  {
    id: "1470",
    id_polifenol: "182",
    polifenol: "ISO-66",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "25050663",
  },
  {
    id: "1471",
    id_polifenol: "6551",
    polifenol: "8-isopentenylnaringenin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "20633549",
  },
  {
    id: "1472",
    id_polifenol: "5964",
    polifenol:
      "3-(3-oxo-3-(3,5,5,8,8-pentamethyl-5,6,7,8-tetrahydronaphthalen-2-yl)prop-1-enyl)benzonitrile",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "21041085",
  },
  {
    id: "1473",
    id_polifenol: "5571",
    polifenol: "guaiacylcatechinpyrylium",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "26304331",
  },
  {
    id: "1474",
    id_polifenol: "5572",
    polifenol: "syringylcatechinpyrylium",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "26304331",
  },
  {
    id: "1475",
    id_polifenol: "6827",
    polifenol: "mucronulatol",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "18538108",
  },
  {
    id: "1476",
    id_polifenol: "5238",
    polifenol: "isoglabratephrin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "27671298",
  },
  {
    id: "1477",
    id_polifenol: "1148",
    polifenol: "2-(1-phenyl-1H-benzo(d)imidazol-2-yl)phenol",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "28233680",
  },
  {
    id: "1478",
    id_polifenol: "6802",
    polifenol: "chryseriol",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "21716619",
  },
  {
    id: "1479",
    id_polifenol: "5290",
    polifenol: "(2'R)-4'-hydroxyemoroidocarpan",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "20804165",
  },
  {
    id: "1480",
    id_polifenol: "5292",
    polifenol: "pongavilleanine",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "20804165",
  },
  {
    id: "1481",
    id_polifenol: "5291",
    polifenol: "epipervilline",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "20804165",
  },
  {
    id: "1482",
    id_polifenol: "6972",
    polifenol: "aromadendrin 3-O-beta-D-glucopyranoside",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "28108382",
  },
  {
    id: "1483",
    id_polifenol: "736",
    polifenol: "1,2,4,5-tetrahydroxybenzene",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "28108382",
  },
  {
    id: "1484",
    id_polifenol: "5548",
    polifenol: "delphinidin 3-sambubioside",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "29407472",
  },
  {
    id: "1485",
    id_polifenol: "2801",
    polifenol: "2-hydroxybenzoic acid 3-nitrooxymethylphenyl ester",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "21664138",
  },
  {
    id: "1486",
    id_polifenol: "2386",
    polifenol: "4-O-galloylbergenin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "25794927",
  },
  {
    id: "1487",
    id_polifenol: "7484",
    polifenol: "3-O-kaempferol 4-O-(galloyl)-beta-D-glucoside",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "28539711",
  },
  {
    id: "1488",
    id_polifenol: "3487",
    polifenol: "4-nitroanisole",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "4053018",
  },
  {
    id: "1489",
    id_polifenol: "4287",
    polifenol: "3,5-dihydroxybenzyl alcohol",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "23054715",
  },
  {
    id: "1490",
    id_polifenol: "3996",
    polifenol: "uliginosin B",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "23669242",
  },
  {
    id: "1491",
    id_polifenol: "1664",
    polifenol: "(2E,4E)-1-(2-hydroxyphenyl)-5-phenylpenta-2,4-dien-1-one",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "26347954",
  },
  {
    id: "1492",
    id_polifenol: "4535",
    polifenol: "LM 985",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "3653209",
  },
  {
    id: "1493",
    id_polifenol: "4845",
    polifenol: "5,7,4'-trihydroxy-6,2',3'-trimethoxyflavone",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "12677524",
  },
  {
    id: "1494",
    id_polifenol: "4826",
    polifenol:
      "5,4'-dihydroxy-(3'',4''-dihydro-3'',4''-dihydroxy)-2'',2''-dimethylpyrano(5'',6''-7,8)flavone",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "19689125",
  },
  {
    id: "1495",
    id_polifenol: "4730",
    polifenol: "5-methoxy-6-methylflavan-7-ol",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "19689125",
  },
  {
    id: "1496",
    id_polifenol: "7836",
    polifenol: "erosone",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "24354192",
  },
  {
    id: "1497",
    id_polifenol: "3530",
    polifenol: "3',4-O-dimethylcedrusin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "29715541",
  },
  {
    id: "1498",
    id_polifenol: "1702",
    polifenol: "(10)-gingerdiol",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "23066935",
  },
  {
    id: "1499",
    id_polifenol: "3005",
    polifenol: "bis(2,3-dibromosalicyl)fumarate",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "25109257",
  },
  {
    id: "1500",
    id_polifenol: "6232",
    polifenol: "irisdichotin C",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "22142698",
  },
  {
    id: "1501",
    id_polifenol: "3288",
    polifenol: "phenyl allyl ether",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "17168588",
  },
  {
    id: "1502",
    id_polifenol: "7110",
    polifenol: "ombuin-3-O-glucopyranoside",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "28242546",
  },
  {
    id: "1503",
    id_polifenol: "2094",
    polifenol: "geranyl-O-acetylhydroquinone",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "14643448",
  },
  {
    id: "1504",
    id_polifenol: "6226",
    polifenol: "5,7,2'-trihydroxy-8,3'-diprenylflavanone",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "19952433",
  },
  {
    id: "1505",
    id_polifenol: "4924",
    polifenol: "6-methylapigenin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "25239551",
  },
  {
    id: "1506",
    id_polifenol: "7451",
    polifenol: "kaempferol-3-O-beta-D-(6''-O-p-coumaroyl)galactopyranoside",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "25351676",
  },
  {
    id: "1507",
    id_polifenol: "4690",
    polifenol: "kuwanon G",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "27879681",
  },
  {
    id: "1508",
    id_polifenol: "3036",
    polifenol:
      "O2-(acetylsalicyloxymethyl)-1-(pyrrolidin-1-yl)diazen-1-ium-1,2-diolate",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "20674154",
  },
  {
    id: "1509",
    id_polifenol: "4976",
    polifenol: "artobiloxanthone",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "20384315",
  },
  {
    id: "1510",
    id_polifenol: "646",
    polifenol: "Ro 25-6981",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "22510452",
  },
  {
    id: "1511",
    id_polifenol: "4183",
    polifenol: "resacetophenone",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "10920275",
  },
  {
    id: "1512",
    id_polifenol: "1118",
    polifenol: "4-hydroxyphenyl tert-butylnitrone",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "19886748",
  },
  {
    id: "1513",
    id_polifenol: "5458",
    polifenol: "(2R,4R)-2',4'-dihydroxy-5,7-dimethoxyflavan-4-ol",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "21121257",
  },
  {
    id: "1514",
    id_polifenol: "2833",
    polifenol: "3,5-dichlorosalicylic acid",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "21050889",
  },
  {
    id: "1515",
    id_polifenol: "1636",
    polifenol: "desmethoxycurcumin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "18274631",
  },
  {
    id: "1516",
    id_polifenol: "1637",
    polifenol: "bisdesmethoxycurcumin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "18274631",
  },
  {
    id: "1517",
    id_polifenol: "914",
    polifenol: "p-sulfonatocalix(4)arene",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "18597414",
  },
  {
    id: "1518",
    id_polifenol: "5359",
    polifenol: "boeravinone G",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "21625488",
  },
  {
    id: "1519",
    id_polifenol: "85",
    polifenol: "Hydroxybenzoate Ethers",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "15852493",
  },
  {
    id: "1520",
    id_polifenol: "4008",
    polifenol: "elliptophenone A",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "21338993",
  },
  {
    id: "1521",
    id_polifenol: "1587",
    polifenol: "4-methoxycarbonyl curcumin",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "24815764",
  },
  {
    id: "1522",
    id_polifenol: "2904",
    polifenol: "N-acetyl-5-aminosalicylic acid",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "10219835",
  },
  {
    id: "1523",
    id_polifenol: "1790",
    polifenol: "N,N'-bis(2-hydroxy-3-methoxybenzylidene)-1,2-diaminobenzene",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "22614449",
  },
  {
    id: "1524",
    id_polifenol: "1791",
    polifenol: "N,N'-bis(2-hydroxy-3-methoxybenzylidene)-1,3-diaminobenzene",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "22614449",
  },
  {
    id: "1525",
    id_polifenol: "7188",
    polifenol: "dosmalfate",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "12559383",
  },
  {
    id: "1526",
    id_polifenol: "5250",
    polifenol: "hypolaetin 4'-methyl ether 8-O-beta-D-glucuronide 2''-sulfate",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "14640528",
  },
  {
    id: "1527",
    id_polifenol: "5023",
    polifenol: "theograndin II",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "14640528",
  },
  {
    id: "1528",
    id_polifenol: "7911",
    polifenol: "rhuschalcone VI",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "12762790",
  },
  {
    id: "1529",
    id_polifenol: "6793",
    polifenol: "7-methoxyflavone",
    id_cancer: "15585",
    cancer: "Colorectal Cancer",
    quant: "1",
    pmids: "16868069",
  },
  {
    id: "1530",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "247",
    pmids:
      "28805696,25083589,29628889,26050647,29467859,24507925,17418981,23454208,22980865,20492175,26238746,29883784,25830055,27468464,23727915,9804172,21711112,20506293,15947208,23902763,26797785,22687635,25755690,26986176,24481824,24706622,23636231,15572301,28454469,15456784,22721615,29091869,25146759,26670842,25289772,29275301,10579870,28878321,19326946,28199969,27461104,21210297,25948105,26297431,27895312,19402641,25365293,17031514,28049093,22532078,23438826,27887793,26692948,28125432,27729209,21618507,21402146,27113311,28423703,24140887,29442032,16280456,22863938,29734739,28440400,28415048,26101063,22928834,17548900,29541888,27444692,27305771,21074525,24337484,16303243,20469635,27904686,18496814,27446443,25084411,25630105,28154877,20577025,22227970,26582127,28924370,23046062,9224209,17012224,29303970,29024631,18184547,12524154,28965117,20854805,27219898,23500080,25957189,19425186,29392841,25173561,10815012,16108826,15650394,26902401,25476160,21674787,27539140,27474067,21550230,22419427,21059620,23173924,25246059,14969337,17961621,28487966,23453831,27374881,25509294,18440233,27573346,19733932,28608828,25582488,22665077,19842135,19101886,28648644,20153296,17430639,26120234,15050731,27023497,26828287,29405784,29581932,28461245,29144597,26592500,16497287,1279187,27655216,18538589,24876151,24604573,28292015,25562804,27365992,27633248,25738754,28842850,29172259,21351299,29521106,25333250,15224346,24232740,28951762,27178637,24678980,20661829,21912610,29407472,24377638,25077464,16222712,23519250,15579072,28881718,26084155,20883688,19424582,17085048,24650056,26320438,16545824,26075219,26703544,26884726,26320439,27262066,17197231,19135038,21657076,17132915,25162013,26176582,29066885,26320443,21856323,15102949,28664315,26044862,25448439,24729227,27863301,27616072,28404902,16751978,21875046,29099046,17549417,21315788,21080070,21351454,22713941,29600977,29204733,28105464,3926336,27659390,29456686,28178217,12510833,23479391,26025855,17684411,25135771,26998077,29638061,28558874,28941682,8134418,21550553,18379113,28961040,22174562,11975496,18704264,27548149,25779384,21316425,29022361,25271983,24190493,25446044,1812215,29338226,26829483,23564766,21139272,28856944,27889540,8980395,28433747,16206043",
  },
  {
    id: "1531",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "228",
    pmids:
      "25977922,23224523,23085518,18794131,29608021,27026405,22507634,21973306,20372842,20878113,18701210,29174816,20627087,29882920,25542235,28861154,27106025,25595721,29429834,20615389,15142674,25118487,29094265,25910231,22483553,25963361,21538854,20651361,27431486,28038323,19181006,26498137,26460892,25813094,27525306,25917567,28928819,27628049,20638855,25444916,23985704,21810436,28187956,20127174,24445042,28991167,25847862,25451846,28587210,27424491,21504179,28218464,28198062,24651282,25374231,20606042,27889234,23943298,26459909,28322158,25646742,28182160,27305771,28853207,19826913,21874542,23600207,25960227,21858220,29328421,12781211,25392116,23784627,29456509,25716014,26370218,26537230,20686221,17240359,26521943,9208599,27266668,18414057,22266952,23485682,28660665,23127155,21070043,26309547,16521985,29080841,15650394,26902401,29674274,22489192,27049834,24835302,21484077,24445050,26124332,29368356,23524096,22890189,27228201,21199169,22811583,28618934,26656720,9252680,17137104,20606309,25891177,28435247,23091376,28677094,26643788,15883009,19477063,26059056,29501629,23696216,23059809,23030405,20025279,21567511,26255837,23807084,23888319,7656234,20077433,21315563,15807244,29065834,29545399,25912482,29201217,24865590,27293144,16572896,19283527,25541467,14691717,26593433,26397387,24094190,22156994,28067164,24788478,23739680,22204522,28270067,27597657,27671306,23534763,19368804,28115093,27497194,27040234,23701832,27894084,22929882,29239219,25499851,27585262,28980920,27381867,19671757,26085173,26995093,22679371,29512668,22189271,17197231,24531225,29881683,26547533,11688958,29448627,24840628,18001810,28443468,20727180,25981383,26808001,24101869,25573684,24044367,29138815,26515041,26332341,27034002,25068616,27843316,19359593,9619854,29863079,28731226,20426658,18462866,22232696,19793800,28925159,25300552,22126905,26703799,28737462,28573926,22559045,21519798,29731631,28231299,26593227,27716533,25374685,28117012,23164423,26238775,21054942,10374832,24212828,29953893,29408473,22820161,28130133,27888157,11905754,18664274,24939419",
  },
  {
    id: "1532",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "130",
    pmids:
      "23085518,24247527,27268146,28443025,17585882,19441815,17475222,28124838,24008975,27959445,26700423,29230104,19000662,29301413,29921475,21698198,18652887,24343902,17351649,9310136,27748367,24651282,27470574,24329111,9600345,19406223,25515619,22928834,22144737,16394628,25214119,16950787,15944151,22082235,18206665,16463383,25559244,9892181,20424128,17296806,25561311,25661371,28924370,28027428,25196850,19890716,15113942,25137576,25596736,22043989,17583686,29200719,27270317,11510478,26586942,22957077,22644961,26902401,23752101,27259219,19137550,10607735,18949374,22419427,15842148,20826787,26297476,9252680,23228413,25582488,17145898,12238566,28337113,27023497,18676773,23912706,7656234,26165362,20159951,23098466,28545532,24456610,12470903,29915082,9103268,28067164,16235994,28115093,7991611,22793503,15942655,15901989,23483060,19671757,9659588,12012004,11998565,28302224,8512247,26884726,17197231,9157981,9878691,22438067,21538848,28105248,17243704,26056816,22991037,27941678,19857070,15039912,19517063,11506822,19940992,22613332,21485870,22559045,22279681,12067577,9675322,25135771,8537983,19588362,27548149,23923070,17250449,24172305,24547772,28433747",
  },
  {
    id: "1533",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "104",
    pmids:
      "10935498,23813779,26124051,22454661,25598321,16328441,23434831,22466960,27693704,12869532,17916907,10667594,19255520,17183064,25573072,20719149,15956247,19147542,17715378,24766860,29073620,19027725,21575631,27620163,25948105,17904532,22367396,12409225,16945329,19147541,12124327,21328467,18996613,26931433,16162944,20606042,17600315,15037618,18343694,12054510,19000441,11166731,11483407,29952428,16463383,15767444,22438908,19383798,23892041,26498639,22057915,9934861,9407138,28629997,11781819,29100274,15763073,20806931,18193228,20854805,19584262,16911524,15210690,19568240,9421477,25292047,12726921,12676937,25769181,25238880,21641901,16300728,24664993,12204896,19305150,26918447,27499095,21472273,11585739,15138593,28748356,18358453,29108991,8971188,17476138,15471877,12907235,22126015,12087091,10098632,25531265,28487957,22086152,16009452,23306155,21412767,24464917,18175936,11891209,24351425,20464547,11454682,22359227,27248324",
  },
  {
    id: "1534",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "55",
    pmids:
      "19639378,24379139,28259980,14988404,22626855,9310136,21898109,22160570,11483407,12767922,10368806,27602162,25364470,15963258,27861885,24399305,26064333,11289112,17961621,9870925,20085293,26768552,18358453,7538048,1279187,8104437,22931124,9795970,9784250,21565896,20661829,11121866,15579072,21898124,12012004,17197231,15004974,21966475,9334814,8652271,11739876,15276495,9806743,15777086,24690154,10836210,26032169,23827485,17406801,9877171,26837765,21949717,25127153,11905754,8980395",
  },
  {
    id: "1535",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "91",
    pmids:
      "26050647,26238746,25830055,23727915,28495516,15456784,14988404,21499124,27461104,25997470,27887793,16280456,23342112,17548900,20469635,25630105,20577025,21111588,14688022,9224209,12524154,28965117,26974372,19731038,26164506,27704720,21267808,22419427,27260467,21306479,17137104,28808404,12476615,22200874,20577783,26609631,28648644,20153296,28337113,18617322,7656234,16497287,1279187,19097913,12672646,28528134,24678980,20661829,24377638,16222712,29399199,28881718,19424582,20886886,27232543,19135038,26807543,25015032,12391557,24649026,22438067,20162394,22358425,29606130,21425153,22334787,15039912,16700823,15777086,27980567,3926336,28178217,16619537,20731900,18057710,17684411,29285083,26069494,11885806,23569988,16707620,19099597,29022361,28778140,24190493,24797908,15618000,23564766,28856944,8980395,18664274",
  },
  {
    id: "1536",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "97",
    pmids:
      "29332333,17585882,27836540,23255902,25833196,24734098,24008975,29230104,15375156,26794417,23292117,8348114,24148818,24712372,24944597,9310136,24269590,26175166,24329111,18519674,20606042,9600345,19406223,29416619,22144737,23483203,16950787,22082235,18206665,16463383,25559244,9892181,23892041,20424128,22819551,25661371,24366444,12925310,15113942,27270317,11510478,26586942,10607735,21300025,21199169,22429326,20826787,28103535,22769244,19528461,27890776,17145898,12238566,24634598,20159951,12470903,21965273,23739680,16235994,25922640,26046674,15901989,11206275,12012004,11998565,24018658,8512247,29429153,8062257,9878691,22438067,15795102,9339552,10232066,24389406,15579485,27461468,29570987,11506822,23725836,10518005,21485870,10190556,12067577,9675322,10202397,25437343,7480211,16050805,24749396,19239017,24201298,17250449,10783312,20112129,9648240,18664274",
  },
  {
    id: "1537",
    id_polifenol: "2167",
    polifenol: "phenolic acid",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "76",
    pmids:
      "25381036,25083589,21973306,27492128,29883784,18701210,26434319,15142674,15572301,19065586,19181006,27375080,20606042,26432689,26758192,28960771,29197545,25933595,27833081,26987028,25539472,23712134,27489231,29890672,29303970,20686221,19731038,22419427,25368260,26841168,23453831,26765787,28709826,20025279,21567511,27348025,29581932,28694749,28292015,25562804,27365992,27597244,24678980,29407472,24377638,29351247,28316643,29523107,22628046,26839997,26703544,27262066,25162013,29066885,21048350,20162394,25576897,28105248,26056816,22713941,25685168,23994083,3926336,28178217,17511007,29638061,29609693,28941682,24243401,27548149,18087803,24190493,29710781,28777311,24797798,17516657",
  },
  {
    id: "1538",
    id_polifenol: "49",
    polifenol: "Aspirin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "58",
    pmids:
      "17418981,10964107,11093779,27573422,18425372,16463383,23475158,15746434,17342322,8911154,23766266,9744535,11196190,12447698,18358453,26368635,29545399,20887554,19908241,10678579,2823818,9163851,23799623,9850065,8898374,16618538,10493497,9163687,21840302,21658022,25990653,12576442,28533220,23363784,12044784,25659932,26810856,15869467,11195467,10029375,27554763,15179621,11494020,29260520,25388762,15639720,24331369,11696405,24958470,7111304,25505466,16864557,26464196,11166002,9823297,19806781,17535415,27186121",
  },
  {
    id: "1539",
    id_polifenol: "109",
    polifenol: "Catechin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "44",
    pmids:
      "23255902,19233505,8348114,24944597,9310136,22970031,20606042,9600345,19406223,22928834,22144737,9892181,20424128,20225763,25196850,20686221,12925310,27259219,10607735,21199169,23453831,28103535,26765787,28337113,7656234,24634598,24141365,14691717,29351247,29429153,28105248,26056816,9339552,24389406,29600977,10518005,29366947,7480211,8537983,19588362,18787784,25338140,20112129,11905754",
  },
  {
    id: "1540",
    id_polifenol: "125",
    polifenol: "Isoflavones",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "22",
    pmids:
      "22814678,29393465,19590197,21415528,24379139,26594764,27793905,29197545,27602162,9224209,23353737,27861885,18440233,20153296,20085293,21565896,20661829,15579072,27255112,26709479,24690154,28110438",
  },
  {
    id: "1541",
    id_polifenol: "110",
    polifenol: "Chalcones",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "74",
    pmids:
      "22543234,15236626,25078311,29575807,21263202,25061803,25682199,24046186,24747188,28634389,27810244,27317025,22721615,22634834,26615871,24332490,28878321,26878127,25313981,22177409,26874744,29857299,26859847,22386368,26448608,22115618,28737782,28011424,28494257,25353380,25743216,22771807,23533528,17424936,25368326,29207336,27138035,20926293,29660690,21240148,28922629,28774575,19883086,18440233,25582488,29589472,25499988,24372527,27217001,20888764,24232740,26021707,21984014,23834620,24675137,21721153,25783964,22668451,25276196,20620131,29308744,26019120,27770383,29032339,25128667,22358425,25771335,25442306,28344479,21053158,22071256,28778140,28371315,17516657",
  },
  {
    id: "1542",
    id_polifenol: "3089",
    polifenol: "1,1-diphenyl-2-picrylhydrazyl",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "62",
    pmids:
      "27492128,27468464,27733866,22210035,22928834,28960771,20469635,28803257,27524032,25539472,23712134,19595584,29890672,24649909,18720191,16029005,19731038,22419427,20548938,23173924,23453831,25753739,23892206,29287791,28709826,22115493,28337113,17430639,26120234,28376770,27348025,29581932,24389510,23841520,24678980,29407472,24377638,23519250,29523107,20397109,28704964,26320438,26839997,26320439,25162013,26320443,19418352,28105248,22037567,22713941,19857070,29476965,27601844,29638061,29609693,28941682,23569988,22885842,25271983,22420901,29710781,28777311",
  },
  {
    id: "1543",
    id_polifenol: "114",
    polifenol: "Apigenin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "33",
    pmids:
      "29883784,26573871,15947208,28125432,24048283,19000441,20469635,23354402,23996752,23485682,20428772,21550230,17961621,20153296,20025279,27348025,20937639,20661829,21912610,21984153,16222712,23519250,27232543,17132915,20162394,18596662,27616072,23682780,22732304,28761344,22272829,28856944,27889540",
  },
  {
    id: "1544",
    id_polifenol: "113",
    polifenol: "Flavones",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "28",
    pmids:
      "25854402,9804172,24289612,20658136,27787370,29734739,20469635,20577025,10537362,20854805,23485682,27400887,20153296,21473152,1279187,28464771,24604573,21351299,28839377,17404065,17363487,28521570,27601844,15165133,27470398,26922533,1812215,28331315",
  },
  {
    id: "1545",
    id_polifenol: "38",
    polifenol: "Gallic Acid",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "46",
    pmids:
      "27492128,20349925,10587295,28901260,26794080,29416619,22144737,24916702,25933595,19454506,26987028,23712134,29890672,27180204,29200719,21625953,19731038,27419630,23660987,19996305,28808404,21472273,22115493,27348025,29581932,11707653,27365992,23841520,20417267,27597244,24377638,25794927,29928970,29393902,22628046,17520829,19222998,28105248,19857070,25687014,21316425,27796908,27575479,29952096,23627273,24547772",
  },
  {
    id: "1546",
    id_polifenol: "117",
    polifenol: "Luteolin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "37",
    pmids:
      "23454208,29883784,21601631,24481824,21402146,24140887,24403290,20589534,21074525,20469635,17296806,25586525,22206675,16029005,24167130,27474067,26096576,25368260,20826787,28608828,20153296,26828287,27348025,21473152,20553912,21351299,24455713,22222766,20175233,27465923,21656353,20162394,26056816,25448439,23682780,27470398,28856944",
  },
  {
    id: "1547",
    id_polifenol: "1",
    polifenol: "Phenols",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "23",
    pmids:
      "28724260,16504517,27468464,29921475,27113311,29890672,19425186,3083823,22115493,27777383,11707653,25077464,22628046,9878691,28844931,27155809,19857070,3926336,2694156,11354311,25271983,19132942,24748532",
  },
  {
    id: "1548",
    id_polifenol: "105",
    polifenol: "Anthocyanins",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "18",
    pmids:
      "27959445,15975709,24124611,15680311,22659736,18339683,16618699,12925310,16277432,29172259,20432172,29407472,29351247,28105248,16139847,24243401,24758615,22420901",
  },
  {
    id: "1549",
    id_polifenol: "7235",
    polifenol: "silybin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "31",
    pmids:
      "29535810,16169542,21882257,24798868,19908243,15623648,28926892,21273642,17723180,25960639,18644994,27822066,18538589,22965008,12894553,15224346,21148748,27753543,23461975,29472856,24047698,16788158,19139021,21159609,26593227,28078913,26143275,23916468,25896445,16354587,29240674",
  },
  {
    id: "1550",
    id_polifenol: "129",
    polifenol: "Rotenone",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "22",
    pmids:
      "29538422,25674209,16990509,15650392,17477947,25364470,12821677,25522273,22847181,26343643,27814589,27015848,26085046,22204911,25934296,28968864,22037567,23479391,26025855,25779384,2614425,28110438",
  },
  {
    id: "1551",
    id_polifenol: "121",
    polifenol: "Kaempferols",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "27",
    pmids:
      "26323894,27461104,26297431,25365293,20469635,28924370,17012224,12942547,29200719,26974372,19731038,20632471,20548938,17961621,28608828,28337113,28098826,28694749,26181204,20162394,28105248,25920280,28178217,22512216,17684411,22272829,24190493",
  },
  {
    id: "1552",
    id_polifenol: "871",
    polifenol: "ABT-737",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "28",
    pmids:
      "28120212,27816990,25852302,27073162,18599488,18089817,25034785,17973573,16951189,27138804,21566062,19097992,19773376,22689920,23680104,20021437,23171055,17927446,28319809,28901294,23485022,29312548,24769731,25388762,23824742,27895791,21555370,28606806",
  },
  {
    id: "1553",
    id_polifenol: "6451",
    polifenol: "daidzein",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "3",
    pmids: "19639378,29869093,8980395",
  },
  {
    id: "1554",
    id_polifenol: "6065",
    polifenol: "baicalein",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "18",
    pmids:
      "29749481,24507925,20506293,28454469,25948105,25268843,28415048,21457722,29392841,21473152,27586635,24604573,22369883,20457505,21597696,29286114,26045664,22272829",
  },
  {
    id: "1555",
    id_polifenol: "7",
    polifenol: "Capsaicin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "12",
    pmids:
      "26255724,9461043,27599722,22735861,25283529,24926985,17214968,23747734,19418359,19413655,12628524,9137455",
  },
  {
    id: "1556",
    id_polifenol: "4634",
    polifenol: "alvocidib",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "20",
    pmids:
      "11368340,20638287,21575631,27787370,10810375,9639406,10537362,12566305,25695324,16108826,28176922,15069542,1279187,27324070,27001952,10896673,8895733,24913006,14667271,15110456",
  },
  {
    id: "1557",
    id_polifenol: "120",
    polifenol: "Flavonols",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "24",
    pmids:
      "27444344,27419887,26948085,26692948,22210035,24267912,20469635,21512242,14969337,18440233,26859114,25582488,7623025,20153296,23679992,29399199,16864455,20886886,21315788,22713941,24497035,27980567,28178217,8537983",
  },
  {
    id: "1558",
    id_polifenol: "4522",
    polifenol: "chrysin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "14",
    pmids:
      "24521149,21801359,23636231,26670842,22659738,20577025,28608828,27151585,21856323,15102949,17549417,26922533,24190493,28331315",
  },
  {
    id: "1559",
    id_polifenol: "123",
    polifenol: "Rutin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "16",
    pmids:
      "22144737,9224209,29287791,23679992,29581932,21473152,7656234,16497287,24876151,24455713,29523107,20886886,25920280,29476965,29638061,26829483",
  },
  {
    id: "1560",
    id_polifenol: "6062",
    polifenol: "naringenin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "17",
    pmids:
      "21877710,17031514,26582127,25957189,28352360,21674787,17376416,26655880,17961621,27348025,20669244,7656234,19135038,29534519,19318568,18787784,27889540",
  },
  {
    id: "1561",
    id_polifenol: "285",
    polifenol: "bisphenol A",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "2",
    pmids: "25312822,15777086",
  },
  {
    id: "1562",
    id_polifenol: "39",
    polifenol: "Hydrolyzable Tannins",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "6",
    pmids: "27468464,19731038,9252680,26120234,28292015,1431932",
  },
  {
    id: "1563",
    id_polifenol: "130",
    polifenol: "Proanthocyanidins",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "16",
    pmids:
      "17418981,15621344,24798688,22087318,18680102,26401377,16076082,20145019,10448908,28487966,19188152,21399574,26927375,29351247,20397109,27548149",
  },
  {
    id: "1564",
    id_polifenol: "35",
    polifenol: "Hydroquinones",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "10",
    pmids:
      "29061809,16504517,25826398,17964791,21912610,7991611,20117936,23876104,28459574,9230280",
  },
  {
    id: "1565",
    id_polifenol: "111",
    polifenol: "Flavanones",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "14",
    pmids:
      "21263202,22519916,17031514,15623648,17376416,26655880,25978595,21351299,16788158,16545824,24582402,28558874,21316425,26115572",
  },
  {
    id: "1566",
    id_polifenol: "4502",
    polifenol: "fisetin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "15",
    pmids:
      "25381036,29467859,26797785,19725538,26692948,21618507,28440400,26101063,27904686,25582488,20153296,28859099,26884726,21315788,24496750",
  },
  {
    id: "1567",
    id_polifenol: "6",
    polifenol: "Catechols",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "10",
    pmids:
      "27167001,28694749,7991611,23408432,27155809,11751421,25279998,29792433,15540942,9230280",
  },
  {
    id: "1568",
    id_polifenol: "25",
    polifenol: "Butylated Hydroxytoluene",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "32",
    pmids:
      "16041836,9865479,23453831,18345025,8395972,17477362,19672312,15606144,27250582,11403921,11830527,19359593,25035812,4049395,3332021,4053047,22139074,11696405,16533022,8236260,19657451,1773786,2050043,22006501,22002309,3742730,12716462,12460898,18597497,7281195,6873018,11246140",
  },
  {
    id: "1569",
    id_polifenol: "75",
    polifenol: "Butylated Hydroxyanisole",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "15",
    pmids:
      "21143894,17296806,25380641,25085901,19170071,23173924,23861102,22665077,8412213,24305654,3742730,10374832,12119125,7281195,23413972",
  },
  {
    id: "1570",
    id_polifenol: "15",
    polifenol: "Masoprocol",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "7",
    pmids: "20668019,16882662,27845352,10626810,8968067,9619854,12110314",
  },
  {
    id: "1571",
    id_polifenol: "6087",
    polifenol: "wogonin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "12",
    pmids:
      "20658136,18496814,21457722,24265759,22665077,24604573,29521106,20457505,28338770,17404065,21597696,28117202",
  },
  {
    id: "1572",
    id_polifenol: "4519",
    polifenol: "myricetin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "8",
    pmids:
      "19326946,27461104,19731038,24650056,27780135,28105248,3926336,28178217",
  },
  {
    id: "1573",
    id_polifenol: "4515",
    polifenol: "baicalin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "7",
    pmids: "20036231,21457722,27878245,24604573,20457505,21597696,27863301",
  },
  {
    id: "1574",
    id_polifenol: "4500",
    polifenol: "procyanidin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "9",
    pmids:
      "26365032,21925486,27658889,27289489,24141365,23483060,29643994,19418352,21780844",
  },
  {
    id: "1575",
    id_polifenol: "5608",
    polifenol: "epicatechin gallate",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "14",
    pmids:
      "27224248,8348114,9310136,9600345,19406223,22144737,12925310,10607735,16235994,25794927,12012004,1431932,10518005,7480211",
  },
  {
    id: "1576",
    id_polifenol: "1356",
    polifenol: "gingerol",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "6",
    pmids: "25813697,24282290,23066935,19877681,23964455,18449496",
  },
  {
    id: "1577",
    id_polifenol: "54",
    polifenol: "Salicylic Acid",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "2",
    pmids: "17329938,16618538",
  },
  {
    id: "1578",
    id_polifenol: "98",
    polifenol: "Propofol",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "9",
    pmids:
      "28076456,29402342,26666272,28426124,23155249,27687666,24510348,14570648,19702528",
  },
  {
    id: "1579",
    id_polifenol: "5607",
    polifenol: "gallocatechol",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "11",
    pmids:
      "8348114,9310136,9600345,26794080,19406223,25196850,12925310,10607735,27348025,10518005,7480211",
  },
  {
    id: "1580",
    id_polifenol: "5578",
    polifenol: "alpha-naphthoflavone",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "9",
    pmids:
      "4066758,3004505,12672646,9784250,12791542,11782366,12396873,21887816,14962508",
  },
  {
    id: "1581",
    id_polifenol: "44",
    polifenol: "Salicylates",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "2",
    pmids: "18425372,9163687",
  },
  {
    id: "1582",
    id_polifenol: "4559",
    polifenol: "theaflavin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "11",
    pmids:
      "9600345,26586942,10607735,16235994,15901989,16835502,9339552,12067577,10202397,16050805,17250449",
  },
  {
    id: "1583",
    id_polifenol: "5808",
    polifenol: "isoliquiritigenin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "4",
    pmids: "15236626,25368326,15050731,17516657",
  },
  {
    id: "1584",
    id_polifenol: "2344",
    polifenol: "methyl gallate",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "9",
    pmids:
      "29416619,22144737,28960771,21111588,28808404,19222998,7480211,27796908,28778140",
  },
  {
    id: "1585",
    id_polifenol: "4708",
    polifenol: "xanthohumol",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "3",
    pmids: "27317025,18087812,26664015",
  },
  {
    id: "1586",
    id_polifenol: "2284",
    polifenol: "rosmarinic acid",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "8",
    pmids:
      "29790547,24916702,19671757,12391557,23682780,29366947,29710781,24596623",
  },
  {
    id: "1587",
    id_polifenol: "112",
    polifenol: "Hesperidin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "8",
    pmids:
      "29138795,29200719,20883688,27729798,12510833,11689289,22174562,18704264",
  },
  {
    id: "1588",
    id_polifenol: "6455",
    polifenol: "nobiletin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "7",
    pmids: "26986176,19065586,18379194,29541888,19627003,26012256,24687742",
  },
  {
    id: "1589",
    id_polifenol: "10",
    polifenol: "Estrogens, Catechol",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "12791542",
  },
  {
    id: "1590",
    id_polifenol: "4513",
    polifenol: "galangin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "5",
    pmids: "26032076,29091869,21111588,20153296,24497035",
  },
  {
    id: "1591",
    id_polifenol: "6063",
    polifenol: "naringin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "7",
    pmids: "17031514,22144737,17376416,7656234,16497287,22732304,15618000",
  },
  {
    id: "1592",
    id_polifenol: "1380",
    polifenol: "shogaol",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "11",
    pmids:
      "25621970,19799425,24282290,22246389,24446736,29462602,29464796,23382939,23638641,19877681,18449496",
  },
  {
    id: "1593",
    id_polifenol: "2158",
    polifenol: "protocatechuic acid",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "6",
    pmids: "19601677,25356681,27492128,29366947,15165144,27575479",
  },
  {
    id: "1594",
    id_polifenol: "5489",
    polifenol: "delphinidin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "8",
    pmids:
      "27959445,24124611,15680311,22659736,18339683,12925310,25794985,22420901",
  },
  {
    id: "1595",
    id_polifenol: "6273",
    polifenol: "hesperetin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "5",
    pmids: "26582127,28537448,21473152,26502889,26546711",
  },
  {
    id: "1596",
    id_polifenol: "1613",
    polifenol: "demethoxycurcumin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "10",
    pmids:
      "25813094,26370218,21484077,25964547,29368356,17137104,22204522,28925159,25600535,25760774",
  },
  {
    id: "1597",
    id_polifenol: "93",
    polifenol: "Phloroglucinol",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "4",
    pmids: "29692000,25476160,29288028,28831795",
  },
  {
    id: "1598",
    id_polifenol: "6454",
    polifenol: "formononetin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "3",
    pmids: "25674209,28105248,17516657",
  },
  {
    id: "1599",
    id_polifenol: "81",
    polifenol: "Fenofibrate",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "2",
    pmids: "23625588,29760790",
  },
  {
    id: "1600",
    id_polifenol: "7550",
    polifenol: "3-methylquercetin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "8",
    pmids:
      "26238746,25854402,25755690,27461104,18617322,29399199,26056816,28178217",
  },
  {
    id: "1601",
    id_polifenol: "6461",
    polifenol: "acacetin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "7",
    pmids: "20492175,21210297,22665077,21473152,28859099,22732304,18087803",
  },
  {
    id: "1602",
    id_polifenol: "4253",
    polifenol:
      "5-(2,4-dihydroxy-5-isopropylphenyl)-4-(4-morpholin-4-ylmethylphenyl)isoxazole-3-carboxylic acid ethylamide",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "9",
    pmids:
      "26112442,25607753,25416789,21996088,26723875,23493311,22347438,28797845,22286776",
  },
  {
    id: "1603",
    id_polifenol: "1611",
    polifenol: "bis(4-hydroxycinnamoyl)methane",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "13",
    pmids:
      "25716561,25963361,25813094,21933103,26459909,26370218,21484077,29368356,17137104,28677094,26332341,28925159,26546528",
  },
  {
    id: "1604",
    id_polifenol: "107",
    polifenol: "beta-Naphthoflavone",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "7",
    pmids: "3004505,3011249,21912610,15072980,1458468,8412213,8565121",
  },
  {
    id: "1605",
    id_polifenol: "119",
    polifenol: "Silymarin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "3",
    pmids: "21711112,21591838,22709784",
  },
  {
    id: "1606",
    id_polifenol: "126",
    polifenol: "Coumestrol",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "29064398",
  },
  {
    id: "1607",
    id_polifenol: "55",
    polifenol: "Sodium Salicylate",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "2",
    pmids: "18425372,18358453",
  },
  {
    id: "1608",
    id_polifenol: "5806",
    polifenol: "butein",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "4",
    pmids: "23064245,24974831,24337484,25582488",
  },
  {
    id: "1609",
    id_polifenol: "108",
    polifenol: "Biflavonoids",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "7",
    pmids: "29921475,21915931,29190983,27292193,27838742,23944039,18379113",
  },
  {
    id: "1610",
    id_polifenol: "1558",
    polifenol: "capsazepine",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "2",
    pmids: "27150432,17214968",
  },
  {
    id: "1611",
    id_polifenol: "5509",
    polifenol: "cyanidin 3-O-glucoside",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "6",
    pmids: "15975709,15680311,16618699,16277432,29407472,16139847",
  },
  {
    id: "1612",
    id_polifenol: "969",
    polifenol: "3,4-dihydroxyphenacyl caffeate phenylpropanoid ester",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "7",
    pmids: "24944685,28744911,23892206,25156288,23302524,24596623,24748532",
  },
  {
    id: "1613",
    id_polifenol: "5844",
    polifenol: "4-dimethylamino-3',4'-dimethoxychalcone",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "27416926",
  },
  {
    id: "1614",
    id_polifenol: "6463",
    polifenol: "puerarin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "3",
    pmids: "29393465,26730946,28101568",
  },
  {
    id: "1615",
    id_polifenol: "5819",
    polifenol: "licochalcone A",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "3",
    pmids: "28805696,25149157,17424936",
  },
  {
    id: "1616",
    id_polifenol: "94",
    polifenol: "Phloretin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "4",
    pmids: "26503828,26633321,26692364,28445002",
  },
  {
    id: "1617",
    id_polifenol: "4560",
    polifenol: "icariin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "12575282",
  },
  {
    id: "1618",
    id_polifenol: "48",
    polifenol: "Anacardic Acids",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "5",
    pmids: "23314312,23128090,22941480,26768552,23955513",
  },
  {
    id: "1619",
    id_polifenol: "5488",
    polifenol: "cyanidin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "4",
    pmids: "15680311,22659736,12925310,22420901",
  },
  {
    id: "1620",
    id_polifenol: "4640",
    polifenol: "5,7-dihydroxy-6-methoxy-2-phenylchromen-4-one",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "3",
    pmids: "28472762,23500080,26741501",
  },
  {
    id: "1621",
    id_polifenol: "4537",
    polifenol: "flavone acetic acid",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "2",
    pmids: "11280751,21550553",
  },
  {
    id: "1622",
    id_polifenol: "2773",
    polifenol: "farnesylthiosalicylic acid",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "2",
    pmids: "20473860,17541036",
  },
  {
    id: "1623",
    id_polifenol: "1995",
    polifenol: "2-tert-butylhydroquinone",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "5",
    pmids: "29363720,23275004,22275372,25289770,24491735",
  },
  {
    id: "1624",
    id_polifenol: "1673",
    polifenol: "4-hydroxyestradiol",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "3",
    pmids: "12791542,17272310,21920623",
  },
  {
    id: "1625",
    id_polifenol: "7546",
    polifenol: "isoquercitrin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "20886886",
  },
  {
    id: "1626",
    id_polifenol: "6482",
    polifenol: "tangeretin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "2",
    pmids: "23926120,26569090",
  },
  {
    id: "1627",
    id_polifenol: "89",
    polifenol: "Vanillic Acid",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "4",
    pmids: "19368348,29890672,25753739,23126191",
  },
  {
    id: "1628",
    id_polifenol: "99",
    polifenol: "Pyrogallol",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "7",
    pmids: "19233505,19000662,18652887,25573293,28476594,18949374,28693293",
  },
  {
    id: "1629",
    id_polifenol: "452",
    polifenol: "acteoside",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "3",
    pmids: "28744911,25509294,25902336",
  },
  {
    id: "1630",
    id_polifenol: "1644",
    polifenol: "Cur1 compound",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "4",
    pmids: "27305771,29065834,24101869,28130133",
  },
  {
    id: "1631",
    id_polifenol: "100",
    polifenol: "Resorcinols",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "7",
    pmids: "21751842,24392814,25172420,9713491,23896275,20607650,24345447",
  },
  {
    id: "1632",
    id_polifenol: "5614",
    polifenol: "catechin gallate",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "2",
    pmids: "9600345,12925310",
  },
  {
    id: "1633",
    id_polifenol: "1866",
    polifenol: "4,6-dinitro-o-cresol",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "26452990",
  },
  {
    id: "1634",
    id_polifenol: "4486",
    polifenol: "amentoflavone",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "2",
    pmids: "28286104,28603761",
  },
  {
    id: "1635",
    id_polifenol: "5850",
    polifenol: "cardamonin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "24390014",
  },
  {
    id: "1636",
    id_polifenol: "118",
    polifenol: "Flavonolignans",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "6",
    pmids: "24798868,22965008,23461975,24047698,21875046,29240674",
  },
  {
    id: "1637",
    id_polifenol: "7541",
    polifenol: "taxifolin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "22272829",
  },
  {
    id: "1638",
    id_polifenol: "7544",
    polifenol: "quercitrin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "4",
    pmids: "14969337,25794927,27659390,28178217",
  },
  {
    id: "1639",
    id_polifenol: "60",
    polifenol: "2,4-Dinitrophenol",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "3",
    pmids: "18276104,8119778,23707353",
  },
  {
    id: "1640",
    id_polifenol: "300",
    polifenol: "rhodioloside",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "24944685",
  },
  {
    id: "1641",
    id_polifenol: "7912",
    polifenol: "7,9,2',4'-tetrahydroxy-8-isopentenyl-5-methoxychalcone",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "5",
    pmids: "26664015,27483224,29589472,26025855,22122667",
  },
  {
    id: "1642",
    id_polifenol: "6465",
    polifenol: "genistin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "8980395",
  },
  {
    id: "1643",
    id_polifenol: "350",
    polifenol: "nonylphenol",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "15777086",
  },
  {
    id: "1644",
    id_polifenol: "2475",
    polifenol: "6-O-galloylglucose",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "3",
    pmids: "9892181,12925310,24243401",
  },
  {
    id: "1645",
    id_polifenol: "92",
    polifenol: "Triclosan",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "2",
    pmids: "27133297,25329306",
  },
  {
    id: "1646",
    id_polifenol: "6097",
    polifenol: "8-prenylnaringenin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "18087812",
  },
  {
    id: "1647",
    id_polifenol: "2447",
    polifenol: "beta-penta-O-galloyl-glucose",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "2",
    pmids: "27196315,20599777",
  },
  {
    id: "1648",
    id_polifenol: "6068",
    polifenol: "pinocembrin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "20025279",
  },
  {
    id: "1649",
    id_polifenol: "1996",
    polifenol: "2,5-di-tert-butylhydroquinone",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "27677589",
  },
  {
    id: "1650",
    id_polifenol: "5071",
    polifenol: "icaritin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "2",
    pmids: "25135717,26079090",
  },
  {
    id: "1651",
    id_polifenol: "6576",
    polifenol: "5,7,4'-trihydroxyflavone",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "2",
    pmids: "21111588,20937639",
  },
  {
    id: "1652",
    id_polifenol: "4585",
    polifenol: "baohuoside I",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "3",
    pmids: "22687635,26859114,26644047",
  },
  {
    id: "1653",
    id_polifenol: "6086",
    polifenol: "liquiritigenin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "2",
    pmids: "22519916,25978595",
  },
  {
    id: "1654",
    id_polifenol: "1616",
    polifenol: "tetrahydrocurcumin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "2",
    pmids: "29094265,29436654",
  },
  {
    id: "1655",
    id_polifenol: "59",
    polifenol: "Dinitrophenols",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "2551660",
  },
  {
    id: "1656",
    id_polifenol: "4516",
    polifenol: "diosmetin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "2",
    pmids: "28414793,18596662",
  },
  {
    id: "1657",
    id_polifenol: "2328",
    polifenol: "syringic acid",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "2",
    pmids: "20707194,15165144",
  },
  {
    id: "1658",
    id_polifenol: "7296",
    polifenol: "dihydromyricetin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "3",
    pmids: "27539140,29039563,18787784",
  },
  {
    id: "1659",
    id_polifenol: "40",
    polifenol: "Propyl Gallate",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "27375080",
  },
  {
    id: "1660",
    id_polifenol: "36",
    polifenol: "Hydroxybenzoates",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "3",
    pmids: "26434319,25576897,23994083",
  },
  {
    id: "1661",
    id_polifenol: "7134",
    polifenol: "vitexin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "2",
    pmids: "27601844,12510833",
  },
  {
    id: "1662",
    id_polifenol: "6558",
    polifenol: "7,3'-dihydroxy-4'-methoxyisoflavone",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "26498639",
  },
  {
    id: "1663",
    id_polifenol: "5455",
    polifenol: "theaflavin-3,3'-digallate",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "23892041",
  },
  {
    id: "1664",
    id_polifenol: "2490",
    polifenol: "punicalagin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "2",
    pmids: "24949451,17243704",
  },
  {
    id: "1665",
    id_polifenol: "5815",
    polifenol: "dibenzoylmethane",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "19441815",
  },
  {
    id: "1666",
    id_polifenol: "5630",
    polifenol: "polyphenon E",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "6",
    pmids: "24343902,20192119,17145898,18676773,20112129,16533426",
  },
  {
    id: "1667",
    id_polifenol: "7547",
    polifenol: "hyperoside",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "4",
    pmids: "27419887,26948085,27470358,20469635",
  },
  {
    id: "1668",
    id_polifenol: "349",
    polifenol: "4-nitrophenol",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "2",
    pmids: "16128747,28646755",
  },
  {
    id: "1669",
    id_polifenol: "5495",
    polifenol: "malvidin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "4",
    pmids: "15680311,22659736,12925310,22420901",
  },
  {
    id: "1670",
    id_polifenol: "7141",
    polifenol: "apigetrin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "4",
    pmids: "20469635,24106661,18596662,16206043",
  },
  {
    id: "1671",
    id_polifenol: "637",
    polifenol: "glabridin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "2",
    pmids: "21059620,17516657",
  },
  {
    id: "1672",
    id_polifenol: "6301",
    polifenol: "3-methoxyflavone",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "2",
    pmids: "17715378,20854805",
  },
  {
    id: "1673",
    id_polifenol: "77",
    polifenol: "Bezafibrate",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "3",
    pmids: "10753637,26535062,24302581",
  },
  {
    id: "1674",
    id_polifenol: "1810",
    polifenol: "heminordihydroguaiaretic acid",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "2",
    pmids: "21107289,10626810",
  },
  {
    id: "1675",
    id_polifenol: "43",
    polifenol: "Parabens",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "29451980",
  },
  {
    id: "1676",
    id_polifenol: "6783",
    polifenol: "protoapigenone",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "6",
    pmids: "24300195,19630532,21912610,21657076,17622129,16206043",
  },
  {
    id: "1677",
    id_polifenol: "6477",
    polifenol: "hispidulin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "3",
    pmids: "10579870,23354402,16864455",
  },
  {
    id: "1678",
    id_polifenol: "7198",
    polifenol: "homoorientin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "3",
    pmids: "19791498,24455713,27601844",
  },
  {
    id: "1679",
    id_polifenol: "128",
    polifenol: "Pterocarpans",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "2",
    pmids: "18440233,28316643",
  },
  {
    id: "1680",
    id_polifenol: "7557",
    polifenol: "rhamnetin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "6",
    pmids: "23902763,25368260,14969337,23861102,16864455,20332453",
  },
  {
    id: "1681",
    id_polifenol: "103",
    polifenol: "Zeranol",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "2",
    pmids: "14676845,11859871",
  },
  {
    id: "1682",
    id_polifenol: "1353",
    polifenol: "protocatechualdehyde",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "2",
    pmids: "28920346,15165144",
  },
  {
    id: "1683",
    id_polifenol: "4501",
    polifenol: "tricin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "22272829",
  },
  {
    id: "1684",
    id_polifenol: "4883",
    polifenol: "flavokawain B",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "22729748",
  },
  {
    id: "1685",
    id_polifenol: "5496",
    polifenol: "pelargonidin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "2",
    pmids: "15680311,12925310",
  },
  {
    id: "1686",
    id_polifenol: "7853",
    polifenol: "Grape Seed Proanthocyanidins",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "10448908",
  },
  {
    id: "1687",
    id_polifenol: "4304",
    polifenol: "5-7-oxo-zeaenol",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "2",
    pmids: "17172402,27448221",
  },
  {
    id: "1688",
    id_polifenol: "7612",
    polifenol: "quercetin 3-O-glucuronide",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "4",
    pmids: "16280456,21267808,27260467,22211962",
  },
  {
    id: "1689",
    id_polifenol: "687",
    polifenol: "calix(4)arene",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "3",
    pmids: "28773504,29792682,27009430",
  },
  {
    id: "1690",
    id_polifenol: "5796",
    polifenol: "dihydrochalcone",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "26633321",
  },
  {
    id: "1691",
    id_polifenol: "6066",
    polifenol: "eriodictyol",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "25368260",
  },
  {
    id: "1692",
    id_polifenol: "2574",
    polifenol: "4-hydroxybenzoic acid",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "29352134",
  },
  {
    id: "1693",
    id_polifenol: "3019",
    polifenol: "nitroaspirin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "12438552",
  },
  {
    id: "1694",
    id_polifenol: "6452",
    polifenol: "chrysoeriol",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "3",
    pmids: "25368260,20162394,28856944",
  },
  {
    id: "1695",
    id_polifenol: "4480",
    polifenol: "myricitrin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "3",
    pmids: "27492128,19326946,25794927",
  },
  {
    id: "1696",
    id_polifenol: "5794",
    polifenol: "2'-hydroxychalcone",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "2",
    pmids: "22177409,24695783",
  },
  {
    id: "1697",
    id_polifenol: "7377",
    polifenol: "astragalin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "2",
    pmids: "28199969,19791498",
  },
  {
    id: "1698",
    id_polifenol: "4521",
    polifenol: "3-hydroxyflavone",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "3",
    pmids: "23438826,20577025,19140688",
  },
  {
    id: "1699",
    id_polifenol: "1672",
    polifenol: "B19 monocarbonyl curcumin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "4",
    pmids: "26891099,21504179,29655083,26255837",
  },
  {
    id: "1700",
    id_polifenol: "115",
    polifenol: "Diosmin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "27374881",
  },
  {
    id: "1701",
    id_polifenol: "87",
    polifenol: "Metoclopramide",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "4",
    pmids: "7746800,8417832,9208905,7670144",
  },
  {
    id: "1702",
    id_polifenol: "6554",
    polifenol: "tectorigenin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "25712668",
  },
  {
    id: "1703",
    id_polifenol: "4715",
    polifenol: "ampelopsin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "29442032",
  },
  {
    id: "1704",
    id_polifenol: "2448",
    polifenol: "ellagitannin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "26508552",
  },
  {
    id: "1705",
    id_polifenol: "7156",
    polifenol: "scutellarein",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "25246059",
  },
  {
    id: "1706",
    id_polifenol: "299",
    polifenol: "nitrophenylphosphate",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "16128747",
  },
  {
    id: "1707",
    id_polifenol: "5831",
    polifenol: "angoletin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "3",
    pmids: "25891177,15703376,17243725",
  },
  {
    id: "1708",
    id_polifenol: "6693",
    polifenol: "2',4',7-trihydroxyisoflavone",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "2",
    pmids: "20085293,11739876",
  },
  {
    id: "1709",
    id_polifenol: "2450",
    polifenol: "Geraniin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "2",
    pmids: "26169124,24289071",
  },
  {
    id: "1710",
    id_polifenol: "4565",
    polifenol: "morusin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "3",
    pmids: "29749480,25476160,28521570",
  },
  {
    id: "1711",
    id_polifenol: "6175",
    polifenol: "2'-hydroxyflavanone",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "3",
    pmids: "17031514,17376416,24832494",
  },
  {
    id: "1712",
    id_polifenol: "6112",
    polifenol: "alpinetin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "2",
    pmids: "21240148,26604699",
  },
  {
    id: "1713",
    id_polifenol: "6770",
    polifenol: "5-hydroxy-3,6,7,8,3',4'-hexamethoxyflavone",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "19065586",
  },
  {
    id: "1714",
    id_polifenol: "2283",
    polifenol: "depsidone",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "2",
    pmids: "22307935,24479775",
  },
  {
    id: "1715",
    id_polifenol: "6457",
    polifenol: "salvigenin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "21875046",
  },
  {
    id: "1716",
    id_polifenol: "1747",
    polifenol: "6-paradol",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "24282290",
  },
  {
    id: "1717",
    id_polifenol: "2697",
    polifenol: "4-trifluoromethylsalicylic acid",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "4",
    pmids: "27137757,22684020,12389735,22806905",
  },
  {
    id: "1718",
    id_polifenol: "5005",
    polifenol: "procyanidin B",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "29890672",
  },
  {
    id: "1719",
    id_polifenol: "12",
    polifenol: "Guaiacol",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "2",
    pmids: "15884858,24121236",
  },
  {
    id: "1720",
    id_polifenol: "2790",
    polifenol: "ginkgolic acid",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "3",
    pmids: "21751842,22380770,27177359",
  },
  {
    id: "1721",
    id_polifenol: "357",
    polifenol: "4-aminophenol",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "28646755",
  },
  {
    id: "1722",
    id_polifenol: "2343",
    polifenol: "ethyl gallate",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "28960771",
  },
  {
    id: "1723",
    id_polifenol: "704",
    polifenol: "trizol",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "26962302",
  },
  {
    id: "1724",
    id_polifenol: "84",
    polifenol: "Halogenated Diphenyl Ethers",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "25531265",
  },
  {
    id: "1725",
    id_polifenol: "6166",
    polifenol: "liquiritin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "24247527",
  },
  {
    id: "1726",
    id_polifenol: "4052",
    polifenol: "bis-(3-(3',5'-di-tert-butyl-4'-hydroxyphenyl)propyl)sulfide",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "3",
    pmids: "25276196,18926891,25752056",
  },
  {
    id: "1727",
    id_polifenol: "4578",
    polifenol: "5,7-dimethoxyflavone",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "17583686",
  },
  {
    id: "1728",
    id_polifenol: "9",
    polifenol: "1,2-Dihydroxybenzene-3,5-Disulfonic Acid Disodium Salt",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "28153500",
  },
  {
    id: "1729",
    id_polifenol: "6100",
    polifenol: "pinostrobin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "21240148",
  },
  {
    id: "1730",
    id_polifenol: "347",
    polifenol: "4-nitrophenyl",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "21801146",
  },
  {
    id: "1731",
    id_polifenol: "315",
    polifenol: "bakuchiol",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "20599920",
  },
  {
    id: "1732",
    id_polifenol: "1918",
    polifenol: "2,6-di-tert-butyl-4-(aminomethyl)phenol hydrochloride",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "23185274",
  },
  {
    id: "1733",
    id_polifenol: "5538",
    polifenol: "petunidin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "3",
    pmids: "15680311,22659736,22420901",
  },
  {
    id: "1734",
    id_polifenol: "5875",
    polifenol: "panduratin A",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "21441862",
  },
  {
    id: "1735",
    id_polifenol: "7199",
    polifenol: "luteolin-7-glucoside",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "3",
    pmids: "16029005,25630793,24455713",
  },
  {
    id: "1736",
    id_polifenol: "5885",
    polifenol: "2',4'-dihydroxy-6'-methoxy-3',5'-dimethylchalcone",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "15703376",
  },
  {
    id: "1737",
    id_polifenol: "5537",
    polifenol: "peonidin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "3",
    pmids: "22659736,12925310,22420901",
  },
  {
    id: "1738",
    id_polifenol: "7140",
    polifenol: "isovitexin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "19791498",
  },
  {
    id: "1739",
    id_polifenol: "7453",
    polifenol: "kaempferol-3-O-glucoside",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "2",
    pmids: "28199969,17084606",
  },
  {
    id: "1740",
    id_polifenol: "4573",
    polifenol: "3,3',4',5,6,7,8-heptamethoxyflavone",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "19065586",
  },
  {
    id: "1741",
    id_polifenol: "4981",
    polifenol: "jaceosidin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "2",
    pmids: "27729209,27262066",
  },
  {
    id: "1742",
    id_polifenol: "4639",
    polifenol: "aromadedrin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "2",
    pmids: "20162394,18787784",
  },
  {
    id: "1743",
    id_polifenol: "4782",
    polifenol: "kurarinone",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "2",
    pmids: "29628889,18184547",
  },
  {
    id: "1744",
    id_polifenol: "6497",
    polifenol: "isoflavanone",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "2",
    pmids: "18440233,22037567",
  },
  {
    id: "1745",
    id_polifenol: "7895",
    polifenol: "flavokawain A",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "26859847",
  },
  {
    id: "1746",
    id_polifenol: "4549",
    polifenol: "casticin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "24247269",
  },
  {
    id: "1747",
    id_polifenol: "4553",
    polifenol: "sulfuretin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "25582488",
  },
  {
    id: "1748",
    id_polifenol: "70",
    polifenol: "Sulfobromophthalein",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "20542559",
  },
  {
    id: "1749",
    id_polifenol: "5615",
    polifenol: "gallocatechin gallate",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "2",
    pmids: "22144737,12925310",
  },
  {
    id: "1750",
    id_polifenol: "6549",
    polifenol: "7-hydroxy-2',3',4',5',8-pentamethoxyisoflavan",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "2",
    pmids: "18440233,28110438",
  },
  {
    id: "1751",
    id_polifenol: "1662",
    polifenol: "BDMC-A",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "27889234",
  },
  {
    id: "1752",
    id_polifenol: "5858",
    polifenol: "isobavachalcone",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "21351454",
  },
  {
    id: "1753",
    id_polifenol: "5539",
    polifenol: "peonidin 3-glucoside",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "20432172",
  },
  {
    id: "1754",
    id_polifenol: "6008",
    polifenol: "millepachine",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "3",
    pmids: "22784822,23993668,28009925",
  },
  {
    id: "1755",
    id_polifenol: "4632",
    polifenol: "ginkgetin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "2",
    pmids: "27059688,29190983",
  },
  {
    id: "1756",
    id_polifenol: "5245",
    polifenol: "BF6-6 biflavone",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "2",
    pmids: "27059688,28839377",
  },
  {
    id: "1757",
    id_polifenol: "839",
    polifenol: "5-iodo-3-((3,5-dibromo-4-hydroxyphenyl)methylene)-2-indolinone",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "17318410",
  },
  {
    id: "1758",
    id_polifenol: "6819",
    polifenol: "luteolin-7-O-glucoside",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "20469635",
  },
  {
    id: "1759",
    id_polifenol: "6093",
    polifenol: "pinobanksin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "18389469",
  },
  {
    id: "1760",
    id_polifenol: "5542",
    polifenol: "delphinidin 3-O-glucopyranoside",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "29407472",
  },
  {
    id: "1761",
    id_polifenol: "7437",
    polifenol: "kaempferol-3-O-rutinoside",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "2",
    pmids: "23679992,21473152",
  },
  {
    id: "1762",
    id_polifenol: "1718",
    polifenol: "dihydroguaiaretic acid",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "3",
    pmids: "24689220,9619854,20332453",
  },
  {
    id: "1763",
    id_polifenol: "1237",
    polifenol: "2,4-bis(p-hydroxyphenyl)-2-butenal",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "2",
    pmids: "23082969,24009847",
  },
  {
    id: "1764",
    id_polifenol: "1106",
    polifenol: "1,1-bis(3'-indolyl)-1-(4-hydroxyphenyl)methane",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "2",
    pmids: "22081070,23892137",
  },
  {
    id: "1765",
    id_polifenol: "962",
    polifenol: "2,6-di-tert-butyl-4-methylphenol",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "5",
    pmids: "9865479,15606144,8236260,2050043,11246140",
  },
  {
    id: "1766",
    id_polifenol: "1934",
    polifenol: "2,6-di-tert-butyl-4-hydroxy-4-methyl-2,5-cyclohexadien-1-one",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "5",
    pmids: "16533022,8236260,1773786,2050043,11246140",
  },
  {
    id: "1767",
    id_polifenol: "6684",
    polifenol: "eupafolin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "25975517",
  },
  {
    id: "1768",
    id_polifenol: "2173",
    polifenol: "atranorin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "2",
    pmids: "25233603,28811522",
  },
  {
    id: "1769",
    id_polifenol: "1754",
    polifenol: "gigantol",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "6",
    pmids: "26339272,24844664,27651818,28844931,26733180,25685168",
  },
  {
    id: "1770",
    id_polifenol: "7590",
    polifenol: "quercetin-3-O-rutinoside",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "3",
    pmids: "20469635,27232543,28178217",
  },
  {
    id: "1771",
    id_polifenol: "444",
    polifenol: "2,4-di-tert-butylphenol",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "19471192",
  },
  {
    id: "1772",
    id_polifenol: "1629",
    polifenol: "bis-1,7-(2-hydroxyphenyl)-hepta-1,6-diene-3,5-dione",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "21070043",
  },
  {
    id: "1773",
    id_polifenol: "5063",
    polifenol: "4',7-dihydroxy-3'-methoxy-5'-prenylflavanone",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "29681982",
  },
  {
    id: "1774",
    id_polifenol: "6687",
    polifenol: "3'-dimethylaminoflavone",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "18720191",
  },
  {
    id: "1775",
    id_polifenol: "6459",
    polifenol: "genkwanin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "28961040",
  },
  {
    id: "1776",
    id_polifenol: "58",
    polifenol: "Nitrophenols",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "17875720",
  },
  {
    id: "1777",
    id_polifenol: "3386",
    polifenol: "2,2',4,4'-tetrabromodiphenyl ether",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "25531265",
  },
  {
    id: "1778",
    id_polifenol: "1883",
    polifenol: "2-amino-5-methylphenol",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "11335795",
  },
  {
    id: "1779",
    id_polifenol: "7290",
    polifenol: "5,2'-dihydroxy-7,8-dimethoxy-dihydroflavonol-3-O-acetate",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "25582488",
  },
  {
    id: "1780",
    id_polifenol: "4764",
    polifenol: "tectochrysin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "2",
    pmids: "25083589,19639783",
  },
  {
    id: "1781",
    id_polifenol: "6548",
    polifenol: "artocarpin flavonoid",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "2",
    pmids: "28423703,15165133",
  },
  {
    id: "1782",
    id_polifenol: "5101",
    polifenol: "isokaempferide",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "19101886",
  },
  {
    id: "1783",
    id_polifenol: "7614",
    polifenol: "quercetin 3-O-methyl ether",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "14568079",
  },
  {
    id: "1784",
    id_polifenol: "4608",
    polifenol: "artonin E",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "3",
    pmids: "23225436,23898063,15165133",
  },
  {
    id: "1785",
    id_polifenol: "5814",
    polifenol: "2',4'-dihydroxychalcone",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "19689125",
  },
  {
    id: "1786",
    id_polifenol: "52",
    polifenol: "Diflunisal",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "19515562",
  },
  {
    id: "1787",
    id_polifenol: "5536",
    polifenol: "prodelphinidin B-2 3'-O-gallate",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "15621344",
  },
  {
    id: "1788",
    id_polifenol: "526",
    polifenol: "liensinine",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "26811496",
  },
  {
    id: "1789",
    id_polifenol: "7427",
    polifenol: "kaempferol 3-O-rhamnoside",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "2",
    pmids: "17084606,14969337",
  },
  {
    id: "1790",
    id_polifenol: "5525",
    polifenol: "cyanidin 3-rutinoside",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "15975709",
  },
  {
    id: "1791",
    id_polifenol: "2339",
    polifenol: "3-O-methylgallic acid",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "19731038",
  },
  {
    id: "1792",
    id_polifenol: "1630",
    polifenol: "dimethoxycurcumin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "27381867",
  },
  {
    id: "1793",
    id_polifenol: "1492",
    polifenol: "hirsutenone",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "24290194",
  },
  {
    id: "1794",
    id_polifenol: "6711",
    polifenol: "3',4'-dimethoxyflavone",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "19033395",
  },
  {
    id: "1795",
    id_polifenol: "1811",
    polifenol: "terameprocol",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "21107289",
  },
  {
    id: "1796",
    id_polifenol: "4548",
    polifenol: "artemetin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "2",
    pmids: "8134418,11975496",
  },
  {
    id: "1797",
    id_polifenol: "2159",
    polifenol: "2,3-dihydroxybenzoic acid",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "29792433",
  },
  {
    id: "1798",
    id_polifenol: "7478",
    polifenol: "kaempferol-7-methyl ether",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "3",
    pmids: "14969337,16864455,14568079",
  },
  {
    id: "1799",
    id_polifenol: "5941",
    polifenol: "3-hydroxy-4,3',4',5'-tetramethoxychalcone",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "2",
    pmids: "20926293,19883086",
  },
  {
    id: "1800",
    id_polifenol: "5827",
    polifenol: "4'-methoxychalcone",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "24046186",
  },
  {
    id: "1801",
    id_polifenol: "6717",
    polifenol: "irigenin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "2",
    pmids: "19791498,27849000",
  },
  {
    id: "1802",
    id_polifenol: "6031",
    polifenol: "2',3'-dimethoxyflavanone",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "2",
    pmids: "28710570,21351299",
  },
  {
    id: "1803",
    id_polifenol: "3245",
    polifenol: "obovatol",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "27489231",
  },
  {
    id: "1804",
    id_polifenol: "7632",
    polifenol: "quercetin-3-O-beta-D-galactopyranoside",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "2",
    pmids: "27419887,26948085",
  },
  {
    id: "1805",
    id_polifenol: "2961",
    polifenol: "acetylsalicylic acid lysinate",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "22115493",
  },
  {
    id: "1806",
    id_polifenol: "7633",
    polifenol: "tamarixetin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "2",
    pmids: "29399199,26851174",
  },
  {
    id: "1807",
    id_polifenol: "1867",
    polifenol: "creosol",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "2",
    pmids: "25026266,20607650",
  },
  {
    id: "1808",
    id_polifenol: "72",
    polifenol: "Phenyl Ethers",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "25879502",
  },
  {
    id: "1809",
    id_polifenol: "3299",
    polifenol: "pentabromodiphenyl ether",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "25531265",
  },
  {
    id: "1810",
    id_polifenol: "7852",
    polifenol: "afzelin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "27659390",
  },
  {
    id: "1811",
    id_polifenol: "2474",
    polifenol: "vescalagin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "1431932",
  },
  {
    id: "1812",
    id_polifenol: "1869",
    polifenol: "4-cresol",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "25951809",
  },
  {
    id: "1813",
    id_polifenol: "418",
    polifenol: "thiophenol",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "2",
    pmids: "29550886,20117936",
  },
  {
    id: "1814",
    id_polifenol: "5945",
    polifenol: "2',5'-dimethoxychalcone",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "25855012",
  },
  {
    id: "1815",
    id_polifenol: "4073",
    polifenol: "myristicin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "3",
    pmids: "1423855,21472076,24596623",
  },
  {
    id: "1816",
    id_polifenol: "6508",
    polifenol: "prunetin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "29197545",
  },
  {
    id: "1817",
    id_polifenol: "5963",
    polifenol: "3,5,2',4'-tetrahydroxychalcone",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "23064245",
  },
  {
    id: "1818",
    id_polifenol: "7888",
    polifenol: "neoisoliquiritin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "24247527",
  },
  {
    id: "1819",
    id_polifenol: "4630",
    polifenol: "5,7,2',3'-tetrahydroxyflavone",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "21618507",
  },
  {
    id: "1820",
    id_polifenol: "2358",
    polifenol: "theaflavin digallate",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "9339552",
  },
  {
    id: "1821",
    id_polifenol: "1725",
    polifenol: "yakuchinone-A",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "19639783",
  },
  {
    id: "1822",
    id_polifenol: "4135",
    polifenol: "orcinol",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "2",
    pmids: "15921417,24797798",
  },
  {
    id: "1823",
    id_polifenol: "7879",
    polifenol: "4-hydroxyderricin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "21263202",
  },
  {
    id: "1824",
    id_polifenol: "6291",
    polifenol: "alpinumisoflavone",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "21415528",
  },
  {
    id: "1825",
    id_polifenol: "5992",
    polifenol:
      "3-(3-hydroxy-4-methoxyphenyl)-1-(3,4,5-trimethoxyphenyl)prop-2-en-1-one",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "3",
    pmids: "25682199,26448608,22771807",
  },
  {
    id: "1826",
    id_polifenol: "4103",
    polifenol: "gnetin H",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "25862967",
  },
  {
    id: "1827",
    id_polifenol: "7363",
    polifenol: "juglanin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "2",
    pmids: "29212196,28958938",
  },
  {
    id: "1828",
    id_polifenol: "4629",
    polifenol: "5,7,2'-trihydroxyflavone",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "29091869",
  },
  {
    id: "1829",
    id_polifenol: "6736",
    polifenol: "3'-demethylnobiletin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "3",
    pmids: "25765513,28154877,27219898",
  },
  {
    id: "1830",
    id_polifenol: "7657",
    polifenol: "quercetin 3'-sulfate",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "2",
    pmids: "21267808,27260467",
  },
  {
    id: "1831",
    id_polifenol: "4524",
    polifenol: "5-hydroxy-3',4',6,7-tetramethoxyflavone",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "24148842",
  },
  {
    id: "1832",
    id_polifenol: "4244",
    polifenol: "malabaricone A",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "26141757",
  },
  {
    id: "1833",
    id_polifenol: "5833",
    polifenol: "2',5'-dihydroxychalcone",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "17549417",
  },
  {
    id: "1834",
    id_polifenol: "4158",
    polifenol: "malabaricone C",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "24291689",
  },
  {
    id: "1835",
    id_polifenol: "6460",
    polifenol: "ipriflavone",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "9224209",
  },
  {
    id: "1836",
    id_polifenol: "46",
    polifenol: "Aminosalicylic Acid",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "28027428",
  },
  {
    id: "1837",
    id_polifenol: "2768",
    polifenol: "salophen",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "25450023",
  },
  {
    id: "1838",
    id_polifenol: "6968",
    polifenol: "5-hydroxy-6,7,8,4'-tetramethoxyflavone",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "21875046",
  },
  {
    id: "1839",
    id_polifenol: "5052",
    polifenol: "3-aminoflavone",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "2",
    pmids: "9784250,16012788",
  },
  {
    id: "1840",
    id_polifenol: "3336",
    polifenol:
      "N-hydroxy-5-ethoxymethyloxy-2-methyl-4-(4-phenoxybenzoyl)aminopentanamide",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "12384564",
  },
  {
    id: "1841",
    id_polifenol: "7810",
    polifenol: "rotenolone",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "20804165",
  },
  {
    id: "1842",
    id_polifenol: "5198",
    polifenol: "isosakuranetin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "21473152",
  },
  {
    id: "1843",
    id_polifenol: "5854",
    polifenol: "2'-hydroxy-3,4,3',4',6'-pentamethoxychalcone",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "2",
    pmids: "23438826,27483224",
  },
  {
    id: "1844",
    id_polifenol: "6898",
    polifenol: "barbigerone",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "2",
    pmids: "22814678,19590197",
  },
  {
    id: "1845",
    id_polifenol: "988",
    polifenol: "4'-O-methylnyasol",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "29158850",
  },
  {
    id: "1846",
    id_polifenol: "7823",
    polifenol: "tephrosin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "21061222",
  },
  {
    id: "1847",
    id_polifenol: "2472",
    polifenol: "sanguiin H 6",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "26508552",
  },
  {
    id: "1848",
    id_polifenol: "6654",
    polifenol: "5,2',4'-trihydroxy-6,7,5'-trimethoxyflavone",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "28110438",
  },
  {
    id: "1849",
    id_polifenol: "1649",
    polifenol: "1,5-bis(2-hydroxyphenyl)-1,4-pentadien-3-one",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "28038323",
  },
  {
    id: "1850",
    id_polifenol: "6847",
    polifenol: "3',4'-didemethylnobiletin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "2",
    pmids: "28154877,27219898",
  },
  {
    id: "1851",
    id_polifenol: "2334",
    polifenol: "leonurine",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "25856714",
  },
  {
    id: "1852",
    id_polifenol: "7641",
    polifenol: "quercetin-3'-O-beta-D-glucopyranoside",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "24938488",
  },
  {
    id: "1853",
    id_polifenol: "4482",
    polifenol: "peflavit",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "2",
    pmids: "20577025,9224209",
  },
  {
    id: "1854",
    id_polifenol: "4919",
    polifenol: "bavachinin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "24012108",
  },
  {
    id: "1855",
    id_polifenol: "7560",
    polifenol: "quercetin-3-O-neohesperidose",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "9224209",
  },
  {
    id: "1856",
    id_polifenol: "2401",
    polifenol: "2,3,5-trihydroxybenzoic acid",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "27419630",
  },
  {
    id: "1857",
    id_polifenol: "5557",
    polifenol: "cyanidin 3-galactoside",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "15680311",
  },
  {
    id: "1858",
    id_polifenol: "4820",
    polifenol: "3,7-dihydroxyflavone",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "29734739",
  },
  {
    id: "1859",
    id_polifenol: "1937",
    polifenol: "2-tert-butyl-4-methylphenol",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "3",
    pmids: "9865479,8236260,2050043",
  },
  {
    id: "1860",
    id_polifenol: "1932",
    polifenol: "3,5-di-tert-butyl-4-hydroxytoluene",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "22139074",
  },
  {
    id: "1861",
    id_polifenol: "7151",
    polifenol: "vicenin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "2",
    pmids: "23682780,22272829",
  },
  {
    id: "1862",
    id_polifenol: "1804",
    polifenol: "guaiacylglycerol-beta-coniferyl ether",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "2",
    pmids: "21473152,20162394",
  },
  {
    id: "1863",
    id_polifenol: "7229",
    polifenol: "silychristin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "29240674",
  },
  {
    id: "1864",
    id_polifenol: "184",
    polifenol: "trilobatin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "26633321",
  },
  {
    id: "1865",
    id_polifenol: "7531",
    polifenol: "7-O-geranylquercetin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "2",
    pmids: "28495516,27980567",
  },
  {
    id: "1866",
    id_polifenol: "935",
    polifenol: "oligonol",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "26865910",
  },
  {
    id: "1867",
    id_polifenol: "4689",
    polifenol: "5,3'-dihydroxy-3,6,7,8,4'-pentamethoxyflavone",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "7623025",
  },
  {
    id: "1868",
    id_polifenol: "6037",
    polifenol: "6-methoxyflavanone",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "28710570",
  },
  {
    id: "1869",
    id_polifenol: "5145",
    polifenol: "artonin B",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "23898063",
  },
  {
    id: "1870",
    id_polifenol: "4149",
    polifenol: "adipostatin A",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "21751842",
  },
  {
    id: "1871",
    id_polifenol: "1152",
    polifenol: "salvianolic acid",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "2",
    pmids: "25850281,28301605",
  },
  {
    id: "1872",
    id_polifenol: "5910",
    polifenol: "3'-formyl-4',6'-dihydroxy-2'-methoxy-5'-methylchalcone",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "17430639",
  },
  {
    id: "1873",
    id_polifenol: "7817",
    polifenol: "amorphigenin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "27978865",
  },
  {
    id: "1874",
    id_polifenol: "1161",
    polifenol: "phenyl acetate",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "28841191",
  },
  {
    id: "1875",
    id_polifenol: "5802",
    polifenol: "hesperidin methylchalcone",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "24046186",
  },
  {
    id: "1876",
    id_polifenol: "1348",
    polifenol: "urushiol",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "27667098",
  },
  {
    id: "1877",
    id_polifenol: "6464",
    polifenol: "cirsiliol",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "23902763",
  },
  {
    id: "1878",
    id_polifenol: "3628",
    polifenol: "1,1-bis(3'-indolyl)-1-(p-anisyl)methane",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "23892137",
  },
  {
    id: "1879",
    id_polifenol: "5974",
    polifenol: "4'-hydroxychalcone",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "22721615",
  },
  {
    id: "1880",
    id_polifenol: "1634",
    polifenol: "FLLL-12 compound",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "25917567",
  },
  {
    id: "1881",
    id_polifenol: "2531",
    polifenol: "sanguiin H-5",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "1431932",
  },
  {
    id: "1882",
    id_polifenol: "5143",
    polifenol: "fustin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "25582488",
  },
  {
    id: "1883",
    id_polifenol: "4822",
    polifenol: "irisolidone",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "19791498",
  },
  {
    id: "1884",
    id_polifenol: "4224",
    polifenol: "orsellinic acid",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "15921417",
  },
  {
    id: "1885",
    id_polifenol: "33",
    polifenol: "Dienestrol",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "19811643",
  },
  {
    id: "1886",
    id_polifenol: "2255",
    polifenol: "protocatechuic acid methyl ester",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "25539472",
  },
  {
    id: "1887",
    id_polifenol: "5996",
    polifenol: "3-(2-chlorophenyl)-1-(2,4-dihydroxyphenyl)prop-2-en-1-one",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "15165144",
  },
  {
    id: "1888",
    id_polifenol: "5284",
    polifenol: "didymin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "19733932",
  },
  {
    id: "1889",
    id_polifenol: "7210",
    polifenol: "luteolin-7-O-glucuronide",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "2",
    pmids: "24455713,29710781",
  },
  {
    id: "1890",
    id_polifenol: "4663",
    polifenol: "rhoifolin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "25509294",
  },
  {
    id: "1891",
    id_polifenol: "7457",
    polifenol: "kaempferol-7-O-alpha-L-rhamnopyranoside",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "16206043",
  },
  {
    id: "1892",
    id_polifenol: "4518",
    polifenol: "robinetin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "3926336",
  },
  {
    id: "1893",
    id_polifenol: "7230",
    polifenol: "silydianin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "29240674",
  },
  {
    id: "1894",
    id_polifenol: "7650",
    polifenol: "3,7-O-dimethylquercetin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "21473152",
  },
  {
    id: "1895",
    id_polifenol: "521",
    polifenol: "E 7010",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "8137285",
  },
  {
    id: "1896",
    id_polifenol: "2749",
    polifenol: "zinc 3,5-diisopropylsalicylate",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "17959272",
  },
  {
    id: "1897",
    id_polifenol: "460",
    polifenol: "suillin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "27174331",
  },
  {
    id: "1898",
    id_polifenol: "4102",
    polifenol: "ardisiphenol D",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "3",
    pmids: "21751842,24392814,22863707",
  },
  {
    id: "1899",
    id_polifenol: "1948",
    polifenol: "2,6-di-tert-butyl-4-benzoquinone",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "9865479",
  },
  {
    id: "1900",
    id_polifenol: "4334",
    polifenol: "acacetin-7-rutinoside",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "24117095",
  },
  {
    id: "1901",
    id_polifenol: "4203",
    polifenol: "methyl orsellinate",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "25233603",
  },
  {
    id: "1902",
    id_polifenol: "5320",
    polifenol: "xanthohumol D",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "18087812",
  },
  {
    id: "1903",
    id_polifenol: "4046",
    polifenol: "3-hydroxyphloretin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "26633321",
  },
  {
    id: "1904",
    id_polifenol: "1795",
    polifenol: "1,4-O-diferuloylsecoisolariciresinol",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "22700239",
  },
  {
    id: "1905",
    id_polifenol: "1410",
    polifenol: "entacapone",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "24148818",
  },
  {
    id: "1906",
    id_polifenol: "475",
    polifenol: "tolcapone",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "24148818",
  },
  {
    id: "1907",
    id_polifenol: "292",
    polifenol: "3-dimethylaminophenol",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "21801146",
  },
  {
    id: "1908",
    id_polifenol: "805",
    polifenol: "albaconol",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "15503351",
  },
  {
    id: "1909",
    id_polifenol: "7476",
    polifenol:
      "kaempferol-3-O-alpha-L-(2''-E-p-coumaroyl-4''-Z-p-coumaroyl)-rhamnoside",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "24290194",
  },
  {
    id: "1910",
    id_polifenol: "376",
    polifenol: "4-vinylphenol",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "18926891",
  },
  {
    id: "1911",
    id_polifenol: "1865",
    polifenol: "4-chloro-2-cresol",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "15066902",
  },
  {
    id: "1912",
    id_polifenol: "5648",
    polifenol: "4'-O-methylepigallocatechin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "26401377",
  },
  {
    id: "1913",
    id_polifenol: "5338",
    polifenol: "boeravinone B",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "24882730",
  },
  {
    id: "1914",
    id_polifenol: "1586",
    polifenol: "hydrazinobenzoylcurcumin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "24044367",
  },
  {
    id: "1915",
    id_polifenol: "7179",
    polifenol: "swertisin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "23453831",
  },
  {
    id: "1916",
    id_polifenol: "6309",
    polifenol: "dalspinosin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "27659390",
  },
  {
    id: "1917",
    id_polifenol: "308",
    polifenol: "coniferyl alcohol",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "19671757",
  },
  {
    id: "1918",
    id_polifenol: "6022",
    polifenol: "morachalcone A",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "21351454",
  },
  {
    id: "1919",
    id_polifenol: "5010",
    polifenol: "procyanidin C",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "24141365",
  },
  {
    id: "1920",
    id_polifenol: "6034",
    polifenol: "diplacone",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "28558874",
  },
  {
    id: "1921",
    id_polifenol: "6349",
    polifenol: "ME-344",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "27255112",
  },
  {
    id: "1922",
    id_polifenol: "4791",
    polifenol: "myricetin 3-O-(2'',3''-di-O-galloyl)rhamnopyranoside",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "25794927",
  },
  {
    id: "1923",
    id_polifenol: "1088",
    polifenol: "1-(3,5-dihydroxyphenyl)heptan-1-one",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "2",
    pmids: "26927613,19833361",
  },
  {
    id: "1924",
    id_polifenol: "1945",
    polifenol: "BHTOH-QM",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "2",
    pmids: "16533022,11246140",
  },
  {
    id: "1925",
    id_polifenol: "4072",
    polifenol: "elemicin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "24596623",
  },
  {
    id: "1926",
    id_polifenol: "6134",
    polifenol: "7,8-dihydroxyflavanone",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "14577694",
  },
  {
    id: "1927",
    id_polifenol: "5878",
    polifenol: "2',4'-dihydroxy-3'-methoxychalcone",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "24390014",
  },
  {
    id: "1928",
    id_polifenol: "7388",
    polifenol: "kaempferol-3-O-galactoside",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "2",
    pmids: "27444344,20469635",
  },
  {
    id: "1929",
    id_polifenol: "5175",
    polifenol: "5-allyl-7-gen-difluoromethylenechrysin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "21801359",
  },
  {
    id: "1930",
    id_polifenol: "4269",
    polifenol: "2-methoxy-4-hydroxy-6-pentadecyl-benzene-1-O-acetate",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "21751842",
  },
  {
    id: "1931",
    id_polifenol: "5382",
    polifenol: "6-prenylapigenin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "17511007",
  },
  {
    id: "1932",
    id_polifenol: "1648",
    polifenol: "(1E,4E)-1,5-bis(2-methoxyphenyl)penta-1,4-dien-3-one",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "29174816",
  },
  {
    id: "1933",
    id_polifenol: "4627",
    polifenol: "aciculatin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "22272829",
  },
  {
    id: "1934",
    id_polifenol: "3917",
    polifenol: "2,4-diacetylphloroglucinol",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "2",
    pmids: "26283170,26833196",
  },
  {
    id: "1935",
    id_polifenol: "7691",
    polifenol:
      "quercetin 3-O-alpha-l-(2,4-di-O-acetyl)rhamnopyranoside-7-O-alpha-L-rhamnopyranoside",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "29538422",
  },
  {
    id: "1936",
    id_polifenol: "5795",
    polifenol: "neohesperidin dihydrochalcone",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "24046186",
  },
  {
    id: "1937",
    id_polifenol: "4930",
    polifenol: "tetra-O-methylscutellarein",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "26569090",
  },
  {
    id: "1938",
    id_polifenol: "768",
    polifenol: "eupomatenoid 5",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "21391177",
  },
  {
    id: "1939",
    id_polifenol: "4196",
    polifenol: "ardisiphenol A",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "2",
    pmids: "24392814,22863707",
  },
  {
    id: "1940",
    id_polifenol: "2213",
    polifenol: "diffractaic acid",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "25233603",
  },
  {
    id: "1941",
    id_polifenol: "2716",
    polifenol: "ethyl salicylate",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "28270064",
  },
  {
    id: "1942",
    id_polifenol: "5123",
    polifenol: "flavonoid cycloartobiloxanthone",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "29275301",
  },
  {
    id: "1943",
    id_polifenol: "6785",
    polifenol: "3',4',7-trimethoxyflavone",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "28664315",
  },
  {
    id: "1944",
    id_polifenol: "2365",
    polifenol: "hamamelitannin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "10232066",
  },
  {
    id: "1945",
    id_polifenol: "5399",
    polifenol: "7,7''-dimethoxyagastisflavone",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "21915931",
  },
  {
    id: "1946",
    id_polifenol: "1491",
    polifenol: "nitrocatechol",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "24148818",
  },
  {
    id: "1947",
    id_polifenol: "1532",
    polifenol:
      "12-(3-methoxy-4-(methoxymethoxy) phenyl)-10-oxododec-8-enoic acid ethyl ester",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "2",
    pmids: "22246389,23638641",
  },
  {
    id: "1948",
    id_polifenol: "4252",
    polifenol: "4,6-diacetylresorcinol",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "22115618",
  },
  {
    id: "1949",
    id_polifenol: "7129",
    polifenol:
      "4-(5-acetyloxy-8,8-dimethyl-6-(3-methylbut-2-en-1-yl)-4-oxo-4,8-dihydropyrano(2,3-f)chromen-3-yl)-1,2-phenylene diacetate",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "27376493",
  },
  {
    id: "1950",
    id_polifenol: "7877",
    polifenol: "helichrysetin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "23533528",
  },
  {
    id: "1951",
    id_polifenol: "6853",
    polifenol: "3'-hydroxydaidzein",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "29869093",
  },
  {
    id: "1952",
    id_polifenol: "6683",
    polifenol: "5,7,4'-trihydroxy-3'-(3-hydroxy-3-methylbutyl)isoflavone",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "29197545",
  },
  {
    id: "1953",
    id_polifenol: "3255",
    polifenol: "6-phenoxyhex-1-ene",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "27849000",
  },
  {
    id: "1954",
    id_polifenol: "7195",
    polifenol: "6-hydroxyluteolin-7-O-glucoside",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "25509294",
  },
  {
    id: "1955",
    id_polifenol: "886",
    polifenol: "4-(2-hydroxyphenyl)but-3-en-2-one",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "28920346",
  },
  {
    id: "1956",
    id_polifenol: "2311",
    polifenol: "aspergillusidone A",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "22307935",
  },
  {
    id: "1957",
    id_polifenol: "5558",
    polifenol: "cyanidin 3-sambubioside",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "29407472",
  },
  {
    id: "1958",
    id_polifenol: "2394",
    polifenol: "methyl syringate",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "26969386",
  },
  {
    id: "1959",
    id_polifenol: "6003",
    polifenol: "boesenbergin A",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "22358425",
  },
  {
    id: "1960",
    id_polifenol: "1669",
    polifenol:
      "5-hydroxy-1-(4-hydroxy-3-methoxyphenyl)-7-(5-methylfuran-2-yl)hepta-1,4,6-trien-3-one",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "2",
    pmids: "23524096,27293144",
  },
  {
    id: "1961",
    id_polifenol: "6682",
    polifenol: "homoeriodictyol",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "25368260",
  },
  {
    id: "1962",
    id_polifenol: "7677",
    polifenol:
      "2-(3',4'-dihydroxyphenyl)-5,7-dihydroxy-3-(2'',6''-di-O-(3'''-(4-fluorophenylpropanoyl)))galactosyl-4H-chromen-4-one",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "25172420",
  },
  {
    id: "1963",
    id_polifenol: "5523",
    polifenol: "cinnamtannin A2",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "1431932",
  },
  {
    id: "1964",
    id_polifenol: "5140",
    polifenol: "5-hydroxy-6,7-dimethoxyflavone",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "21351299",
  },
  {
    id: "1965",
    id_polifenol: "7532",
    polifenol: "7-O-butylquercetin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "27980567",
  },
  {
    id: "1966",
    id_polifenol: "6229",
    polifenol: "2-hydroxynaringenin 4'-O-beta-D-glucopyranoside",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "2",
    pmids: "24938488,21316425",
  },
  {
    id: "1967",
    id_polifenol: "2095",
    polifenol: "farnesyl-O-acetylhydroquinone",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "14643448",
  },
  {
    id: "1968",
    id_polifenol: "2136",
    polifenol: "5-O-acetylhydroquinone",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "23876104",
  },
  {
    id: "1969",
    id_polifenol: "4992",
    polifenol: "acacetin-7-O-glucoside",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "22732304",
  },
  {
    id: "1970",
    id_polifenol: "5239",
    polifenol: "syringetin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "26044862",
  },
  {
    id: "1971",
    id_polifenol: "4095",
    polifenol: "1-(3,4,5-trihydroxyphenyl)nonan-1-one",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "19833361",
  },
  {
    id: "1972",
    id_polifenol: "6256",
    polifenol: "(2S)-3',4',5'-trimethoxyflavanone",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "11975496",
  },
  {
    id: "1973",
    id_polifenol: "4529",
    polifenol: "ganhuangenin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "16545824",
  },
  {
    id: "1974",
    id_polifenol: "4769",
    polifenol: "5'-methoxyhydnocarpin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "21875046",
  },
  {
    id: "1975",
    id_polifenol: "1502",
    polifenol: "artochamin H",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "15165133",
  },
  {
    id: "1976",
    id_polifenol: "1012",
    polifenol: "marennine",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "11281137",
  },
  {
    id: "1977",
    id_polifenol: "3384",
    polifenol:
      "7-(2-(2,2-difluoroethoxy)-3,5-di-tert-butylbenzene)-3-methylocta-2,4,6-trienoic acid",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "26554632",
  },
  {
    id: "1978",
    id_polifenol: "6241",
    polifenol: "5-hydroxy-7,4'-diacetyloxyflavanone-N-phenyl hydrazone",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "21877710",
  },
  {
    id: "1979",
    id_polifenol: "6307",
    polifenol: "gardenin B",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "23926120",
  },
  {
    id: "1980",
    id_polifenol: "4867",
    polifenol: "eucalyptin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "29692000",
  },
  {
    id: "1981",
    id_polifenol: "783",
    polifenol: "2,6-diprenyl-4-iodophenol",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "26594764",
  },
  {
    id: "1982",
    id_polifenol: "6880",
    polifenol: "5-hydroxy-3,7,8,3,4-pentamethoxyflavone",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "19065586",
  },
  {
    id: "1983",
    id_polifenol: "4844",
    polifenol: "3',5'-di-C-glucopyranosylphloretin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "26633321",
  },
  {
    id: "1984",
    id_polifenol: "6033",
    polifenol: "mimulone",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "25490748",
  },
  {
    id: "1985",
    id_polifenol: "4746",
    polifenol: "sophoflavescenol",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "22210035",
  },
  {
    id: "1986",
    id_polifenol: "1646",
    polifenol: "1,5-bis(2,3-dimethoxyphenyl)penta-1,4-dien-3-one",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "21504179",
  },
  {
    id: "1987",
    id_polifenol: "5018",
    polifenol: "propolin C",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "29681982",
  },
  {
    id: "1988",
    id_polifenol: "580",
    polifenol: "2,4-bis(4-hydroxybenzyl)phenol",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "24746225",
  },
  {
    id: "1989",
    id_polifenol: "5410",
    polifenol: "5,7-dihydoxyflavone",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "24916702",
  },
  {
    id: "1990",
    id_polifenol: "3198",
    polifenol: "7809 compound",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "28443496",
  },
  {
    id: "1991",
    id_polifenol: "154",
    polifenol: "triticumoside",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "26758192",
  },
  {
    id: "1992",
    id_polifenol: "7443",
    polifenol: "kaempferol 3-arabinoside",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "20469635",
  },
  {
    id: "1993",
    id_polifenol: "7572",
    polifenol: "guajavarin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "20469635",
  },
  {
    id: "1994",
    id_polifenol: "2001",
    polifenol: "mycotrienin II",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "21448188",
  },
  {
    id: "1995",
    id_polifenol: "1345",
    polifenol: "sonnerphenolic C",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "25933595",
  },
  {
    id: "1996",
    id_polifenol: "2872",
    polifenol: "norstictic acid",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "25233603",
  },
  {
    id: "1997",
    id_polifenol: "3967",
    polifenol: "prolifenone A",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "17125240",
  },
  {
    id: "1998",
    id_polifenol: "3968",
    polifenol: "prolifenone B",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "17125240",
  },
  {
    id: "1999",
    id_polifenol: "3966",
    polifenol: "prolificin A",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "17125240",
  },
  {
    id: "2000",
    id_polifenol: "3906",
    polifenol: "hyperforin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "21751836",
  },
  {
    id: "2001",
    id_polifenol: "1006",
    polifenol:
      "6-(4-((1E)-2-(3,5-dihydroxyphenyl)ethenyl)phenoxy)hexanoic acid",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "26666272",
  },
  {
    id: "2002",
    id_polifenol: "4539",
    polifenol: "ternatin (flavonoid)",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "10815012",
  },
  {
    id: "2003",
    id_polifenol: "4623",
    polifenol: "myricetin 3-O-glucuronide",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "19731038",
  },
  {
    id: "2004",
    id_polifenol: "3544",
    polifenol: "3-hydroxyanisole",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "28561221",
  },
  {
    id: "2005",
    id_polifenol: "905",
    polifenol: "brefelamide",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "27498705",
  },
  {
    id: "2006",
    id_polifenol: "5450",
    polifenol: "linderone A",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "23173924",
  },
  {
    id: "2007",
    id_polifenol: "4223",
    polifenol: "globosumone C",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "15921417",
  },
  {
    id: "2008",
    id_polifenol: "4997",
    polifenol: "kaempferol 3-O-(2''-O-glucosyl)rutinoside",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "23453831",
  },
  {
    id: "2009",
    id_polifenol: "7220",
    polifenol: "luteolin 3',7-di-O-glucoside",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "25509294",
  },
  {
    id: "2010",
    id_polifenol: "6196",
    polifenol: "7-hydroxy-6-methoxyflavanone",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "18440233",
  },
  {
    id: "2011",
    id_polifenol: "4175",
    polifenol: "3,5-dihydroxy-4-isopropylstilbene",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "23861102",
  },
  {
    id: "2012",
    id_polifenol: "2313",
    polifenol: "aspergillusidone C",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "22307935",
  },
  {
    id: "2013",
    id_polifenol: "1705",
    polifenol: "hylin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "20696583",
  },
  {
    id: "2014",
    id_polifenol: "4372",
    polifenol:
      "quercetin 3-O-alpha-rhamnopyranoside-7-O-beta-D-glucopyranosyl-(1-3)-alpha-L-rhamnopyranoside",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "7623025",
  },
  {
    id: "2015",
    id_polifenol: "4798",
    polifenol: "3',5-dihydroxy-3,4'5',7-tetramethoxyflavone",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "22115493",
  },
  {
    id: "2016",
    id_polifenol: "5456",
    polifenol: "4''-O-methyl-I3,II8-biapigenin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "17365688",
  },
  {
    id: "2017",
    id_polifenol: "6174",
    polifenol: "(2S)-8-formyl-5-hydroxy-7-methoxy-6-methylflavanone",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "17430639",
  },
  {
    id: "2018",
    id_polifenol: "7364",
    polifenol:
      "kaempferol-3-O-(2'(4-acetylrhamnopyranosyl)-3'-galactopyranosyl)robinobioside",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "23679992",
  },
  {
    id: "2019",
    id_polifenol: "3986",
    polifenol: "sinapyl acetate",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "21473152",
  },
  {
    id: "2020",
    id_polifenol: "7138",
    polifenol: "apigenin dimethylether",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "21473152",
  },
  {
    id: "2021",
    id_polifenol: "5886",
    polifenol: "3',4',5',3,4,5-hexamethoxy-chalcone",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "26255837",
  },
  {
    id: "2022",
    id_polifenol: "7282",
    polifenol: "hovenitin III",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "24938488",
  },
  {
    id: "2023",
    id_polifenol: "225",
    polifenol:
      "2-(4-(4-methoxyphenoxy)-1H-pyrazol-3-yl)-5-(p-tolylmethoxy)phenol",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "26517520",
  },
  {
    id: "2024",
    id_polifenol: "7755",
    polifenol: "7-difluoromethyl-5,4'-dimethoxygenistein",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "22931124",
  },
  {
    id: "2025",
    id_polifenol: "7808",
    polifenol: "mirabijalone E",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "24882730",
  },
  {
    id: "2026",
    id_polifenol: "5290",
    polifenol: "(2'R)-4'-hydroxyemoroidocarpan",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "20804165",
  },
  {
    id: "2027",
    id_polifenol: "5292",
    polifenol: "pongavilleanine",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "20804165",
  },
  {
    id: "2028",
    id_polifenol: "5291",
    polifenol: "epipervilline",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "20804165",
  },
  {
    id: "2029",
    id_polifenol: "532",
    polifenol: "osmanthuside H",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "20707194",
  },
  {
    id: "2030",
    id_polifenol: "619",
    polifenol: "2-(3-methyl-2-butenyl)-3,4,5-trimethoxyphenol",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "20707194",
  },
  {
    id: "2031",
    id_polifenol: "5548",
    polifenol: "delphinidin 3-sambubioside",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "29407472",
  },
  {
    id: "2032",
    id_polifenol: "2386",
    polifenol: "4-O-galloylbergenin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "25794927",
  },
  {
    id: "2033",
    id_polifenol: "2235",
    polifenol: "tschimgin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "23701832",
  },
  {
    id: "2034",
    id_polifenol: "7111",
    polifenol: "urgineanin A",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "23659371",
  },
  {
    id: "2035",
    id_polifenol: "4849",
    polifenol: "3',5,7-trihydoxy-3,4',5'-trimethoxyflavone",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "16864455",
  },
  {
    id: "2036",
    id_polifenol: "4855",
    polifenol: "5,7,3',4'-tetrahydroxy-3-methoxy flavone",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "16864455",
  },
  {
    id: "2037",
    id_polifenol: "4287",
    polifenol: "3,5-dihydroxybenzyl alcohol",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "23054715",
  },
  {
    id: "2038",
    id_polifenol: "4826",
    polifenol:
      "5,4'-dihydroxy-(3'',4''-dihydro-3'',4''-dihydroxy)-2'',2''-dimethylpyrano(5'',6''-7,8)flavone",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "19689125",
  },
  {
    id: "2039",
    id_polifenol: "4730",
    polifenol: "5-methoxy-6-methylflavan-7-ol",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "19689125",
  },
  {
    id: "2040",
    id_polifenol: "6185",
    polifenol: "5,7,2',6'-tetrahydroxy-6-lavandulylated-flavanone",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "16545824",
  },
  {
    id: "2041",
    id_polifenol: "6583",
    polifenol: "bolusanthol C",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "16545824",
  },
  {
    id: "2042",
    id_polifenol: "7439",
    polifenol: "kaempferol-3-beta-D-(6-O-trans-p-coumaroyl)glucopyranoside",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "27232543",
  },
  {
    id: "2043",
    id_polifenol: "1702",
    polifenol: "(10)-gingerdiol",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "23066935",
  },
  {
    id: "2044",
    id_polifenol: "5403",
    polifenol: "sinapyl alcohol 9-O-(E)-p-coumaroyl-4-O-beta-D-glucopyanoside",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "21657076",
  },
  {
    id: "2045",
    id_polifenol: "5459",
    polifenol:
      "5,7-dihydroxy-2-(1,2-isopropyldioxy-4-oxo-cyclohex-5-enyl)-chromen-4-one",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "21657076",
  },
  {
    id: "2046",
    id_polifenol: "6025",
    polifenol:
      "5-hydroxy-2-(1'-hydroxy-4'-oxo-cyclohex-2'-en-1'-yl)-6,7-dimethoxy-2,3-dihydro-4H-chromen-4-one",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "21657076",
  },
  {
    id: "2047",
    id_polifenol: "6719",
    polifenol: "pedalitin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "12391557",
  },
  {
    id: "2048",
    id_polifenol: "6220",
    polifenol:
      "(-)(2S)-5,6,7,3',5'-pentahydroxyflavanone-7-O-beta-D-glucopyranoside",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "20162394",
  },
  {
    id: "2049",
    id_polifenol: "2345",
    polifenol: "isobutyl gallate",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "19222998",
  },
  {
    id: "2050",
    id_polifenol: "6841",
    polifenol: "licoflavone C",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "28521570",
  },
  {
    id: "2051",
    id_polifenol: "873",
    polifenol: "antioxidant biofactor AOB",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "22991037",
  },
  {
    id: "2052",
    id_polifenol: "2094",
    polifenol: "geranyl-O-acetylhydroquinone",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "14643448",
  },
  {
    id: "2053",
    id_polifenol: "3170",
    polifenol: "oxisterigmatocystin D",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "29576058",
  },
  {
    id: "2054",
    id_polifenol: "2347",
    polifenol: "1,2,3,6-tetragalloylglucose",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "10232066",
  },
  {
    id: "2055",
    id_polifenol: "809",
    polifenol: "malvidin-3-O-glucoside-4 vinyl",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "29884360",
  },
  {
    id: "2056",
    id_polifenol: "4212",
    polifenol: "delta-viniferin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "29884360",
  },
  {
    id: "2057",
    id_polifenol: "3492",
    polifenol: "4-methyl anisole",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "21361279",
  },
  {
    id: "2058",
    id_polifenol: "5355",
    polifenol: "diplotrin C",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "21875046",
  },
  {
    id: "2059",
    id_polifenol: "5356",
    polifenol: "diplotasin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "21875046",
  },
  {
    id: "2060",
    id_polifenol: "5110",
    polifenol: "5,4'-dihydroxy-7,8,2',3'-tetramethoxyflavone",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "21875046",
  },
  {
    id: "2061",
    id_polifenol: "4691",
    polifenol: "kuwanon H",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "21351454",
  },
  {
    id: "2062",
    id_polifenol: "6245",
    polifenol: "ormosinol",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "22037567",
  },
  {
    id: "2063",
    id_polifenol: "6244",
    polifenol: "ormosinoside",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "22037567",
  },
  {
    id: "2064",
    id_polifenol: "6582",
    polifenol: "bolusanthol B",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "22037567",
  },
  {
    id: "2065",
    id_polifenol: "3324",
    polifenol: "1-(3,5-diiodo-4-(4'-methoxyphenoxy)phenyl)ethanone",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "9858656",
  },
  {
    id: "2066",
    id_polifenol: "2667",
    polifenol: "glycol salicylate",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "26937173",
  },
  {
    id: "2067",
    id_polifenol: "2496",
    polifenol: "sanguiin H 11",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "1431932",
  },
  {
    id: "2068",
    id_polifenol: "2351",
    polifenol: "1,3,4,5-tetra-O-galloylquinic acid",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "1431932",
  },
  {
    id: "2069",
    id_polifenol: "2481",
    polifenol: "furosin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "1431932",
  },
  {
    id: "2070",
    id_polifenol: "7857",
    polifenol: "cinnamtannin B-1",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "1431932",
  },
  {
    id: "2071",
    id_polifenol: "2371",
    polifenol: "eugeniin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "1431932",
  },
  {
    id: "2072",
    id_polifenol: "3241",
    polifenol: "ethericin B",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "25026266",
  },
  {
    id: "2073",
    id_polifenol: "5096",
    polifenol: "luteolin 7-O-glucoside 4''-sulfate",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "22272829",
  },
  {
    id: "2074",
    id_polifenol: "333",
    polifenol: "p-sec-amylphenol",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "20607650",
  },
  {
    id: "2075",
    id_polifenol: "4074",
    polifenol: "pyrogallol 1,3-dimethyl ether",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "25879502",
  },
  {
    id: "2076",
    id_polifenol: "4029",
    polifenol: "androforin A",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "22700239",
  },
  {
    id: "2077",
    id_polifenol: "4760",
    polifenol: "gnaphalin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "1812215",
  },
  {
    id: "2078",
    id_polifenol: "994",
    polifenol:
      "2-tridecyl-3-((2-tridecyl-3-acetoxy-4-methoxy-6-hydroxy)phenyl)-6-methoxy-1,4-benzoquinone",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "19833361",
  },
  {
    id: "2079",
    id_polifenol: "3410",
    polifenol:
      "methyl 3-(1-acetoxy-3-methylbutyl)-2-methoxy-6-(2- methoxy-4-methyl-6-(2-oxopropyl)phenoxy)benzoate",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "19833361",
  },
  {
    id: "2080",
    id_polifenol: "1089",
    polifenol: "1-(3,5-dihydroxyphenyl)pentadecan-1-one",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "19833361",
  },
  {
    id: "2081",
    id_polifenol: "6511",
    polifenol: "duartin",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "28110438",
  },
  {
    id: "2082",
    id_polifenol: "6516",
    polifenol: "8-methoxyvestitol",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "28110438",
  },
  {
    id: "2083",
    id_polifenol: "5317",
    polifenol:
      "5-hydroxy-6-methyl-7,4'-dimethoxyflavone-8-O-beta-D-glucopyranoside",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "21139272",
  },
  {
    id: "2084",
    id_polifenol: "2296",
    polifenol: "3-O-methylrosmarinic acid",
    id_cancer: "8865",
    cancer: "Lung Cancer",
    quant: "1",
    pmids: "24596623",
  },
  {
    id: "2085",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "224",
    pmids:
      "21376033,21256211,23382917,12706007,17065200,21743964,23300633,15313200,18359761,27537398,25499067,26870290,19693651,28628830,29767250,22928835,29097203,18008333,24285354,23769983,11532861,27838343,20838625,19509250,17473376,16678392,18726985,28555835,28811126,26476001,23265454,26788200,17031854,24859932,28725626,18337475,18455702,26805810,20596804,27476422,16636967,19031366,16563612,16964758,20456427,11059749,25408199,15131058,11591177,19548283,25445226,21468543,25630105,20574928,10953339,17132221,23645467,20718984,28810652,17237281,16140534,23359392,20530556,14715546,12618755,19633975,23434138,16835506,19778521,21887406,23318178,25771121,12738992,24971999,29542423,12032841,19737984,25655047,19768977,24018886,27569589,23675277,21674787,17457054,27483851,21905716,28107698,17176222,21161819,23173924,22768128,26189300,25150162,18922931,28178952,19172579,18974136,18725386,27207648,23350280,11790449,15173424,25243063,18240292,19298190,23431365,16898267,24859601,22065906,21528340,25957503,28462147,18292973,21541623,23673480,16271822,11053652,11170137,18538589,22693649,26059723,25798940,24692702,17218638,11346885,25285031,21351299,16234852,24232740,11341036,25060568,25860066,27533043,16111875,27606834,15386368,26676551,23738732,11142097,11006131,10377442,25446081,16600019,27919958,17475387,26810568,16645725,21803027,18655183,20648923,9492340,15637089,25342300,27039735,26084155,15899838,9538139,23293751,26569200,26610436,12419835,18806956,15586246,17085048,12386921,26320438,12429923,23615534,26320439,21657076,24824323,23615977,27016192,22993634,26320443,29402482,15584372,24930002,18955307,11238180,9581834,11573952,29375715,21166494,16230333,11814454,17638904,19468836,22952557,25164625,28599307,24729227,9622078,21080070,12036915,29898731,22096313,15685239,11931850,16314891,19007764,17125241,11134977,28403777,27981754,20158254,28886426,26954068,24080313,14690799,24962584,29447469,10325503,27262332,16111881,21214467,12819936,26052153,22260294,10325492,20088766,28359741,22571261,17637507",
  },
  {
    id: "2086",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "203",
    pmids:
      "22551677,17289836,27657825,17916240,18156803,26827161,17718901,18199714,17147887,25060817,23466486,26546056,12682902,16471035,21823017,24297639,23875250,29174816,16299382,11967955,12869308,29429834,28391715,23940701,17290611,27132804,15711178,28038323,23564771,21924245,18226269,16550606,26630272,22844370,28843521,19113979,21134073,23985704,22788991,17332930,14724571,26893768,15252141,29369461,12239622,17332326,25451846,28199187,18790744,27313760,25441423,25690296,27543391,21680704,27496212,12859962,16731771,15921770,22849866,20358476,26991801,27865863,16787365,21938566,22711297,12533677,18946510,22552297,26032092,28243065,16519151,19663790,29485738,26499200,16199533,11753638,17240359,15489213,28120490,18390174,26464676,17168675,26718024,24184124,20680030,20473900,14985701,23145775,12853969,28601720,16521985,18425340,26013662,22523587,19326431,18682687,27990666,28628644,19360344,21796654,15129424,19189304,27221847,25728027,19806380,29201078,24606484,25446255,23042094,23353183,10851300,17137104,26158541,20395211,24216994,16423986,25243063,17434257,17151092,29228771,16342680,29207190,17303007,11398177,25971429,24516867,21936051,24647337,26369539,22475723,23730903,24160991,27060762,24622734,28391351,24581747,19772879,22070051,26203689,26000396,26366279,19192720,17261774,27381082,15236356,16789753,22952749,29374713,26930039,19538771,25961334,12468631,16389264,21240460,18719366,28585133,28391184,21194250,25028336,24531225,28388523,28272691,27863661,18437538,24949215,25912409,20818481,25121735,22672984,26515041,24348813,24160816,26341135,29172709,29232190,21892919,22258452,28397161,26747522,20924967,16427289,29202102,25711533,23362941,12497104,20456930,22335582,20503397,21167595,14612489,16954429,11238188,10668477,19846921,27404761,20346654,25594891,27262332,28122302,20099188,20572274,23136625,21787756",
  },
  {
    id: "2087",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "158",
    pmids:
      "28718667,29460131,24377565,14612961,21948980,17931610,19857055,16475722,25284475,21497499,26471237,26115086,21209944,22567414,20838625,24607787,23456297,28811126,10773882,29301413,16550606,28709945,23441615,12559991,21134073,23805102,15327830,17522067,29039600,25917875,19301309,14633667,22945439,24329111,20522783,17331955,17363494,19661309,16203797,23092326,17050787,15161048,22593437,24804028,14981946,12840208,29518944,18946510,17998943,18584482,15713891,23285096,26331691,27186419,20718984,12393936,20002680,25604133,22114073,16835506,17168675,22076244,24491902,23657951,18317887,12237322,22743590,24836925,25962506,29065794,15383219,22552582,10624710,23042094,17499812,20623641,17332308,21177307,25243063,12025870,17936851,25214070,15011755,29563789,16425281,23710216,11756245,28495234,17705241,21538852,11829627,15134383,26155176,14743383,15113149,28169238,24726691,10328958,15327971,25272043,22405694,19577562,16519995,11142097,17174037,20924968,20648923,9414176,24867960,24039951,15661808,29466808,10232597,18479901,19856314,14718582,15652269,22110195,10861841,10766429,28951686,11504910,12597448,15574782,16387739,24072771,23629419,21742039,24314868,26317853,20628004,28742384,23862225,16005427,19526991,11931850,26747522,15523106,29256350,25711533,15528976,18641202,12840221,28509442,16613539,23041649,26180600,10668477,18977589,18468784,19588362,19670229,27262332,10769659,24172305,22666523,26214308,24547772",
  },
  {
    id: "2088",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "104",
    pmids:
      "24424889,21632028,16267013,17916240,16774937,21055460,17931610,16427044,22716951,28524116,24805814,9797142,10688043,24699278,12643788,18377872,12131363,19147541,20080742,20203690,12466969,11922392,10850453,20971737,11371939,14506750,29242151,12401798,14694442,11313866,12963547,11410519,12619033,16267018,16472761,17671214,15880419,16198100,19522739,15753383,16685402,12618755,15184882,26134113,20979115,23424616,11006085,15225759,19011039,15774218,12883736,14742313,14642090,12899525,16550001,16052512,10383151,22593802,27240591,28670368,27213581,18341625,16322288,11798872,11866977,22200661,15468165,24405819,15031672,17143532,15788644,17074207,12569372,27430422,25971429,9435505,18726116,18931557,28944626,12569550,28445005,26657209,16331603,22886216,25640606,15488643,12097262,11279018,15466214,17196171,18167127,19347904,16729971,17563746,14555984,20446247,12547723,22690216,12562385,10492251,12688676,28497076,17526768,23838318",
  },
  {
    id: "2089",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "225",
    pmids:
      "18818108,23936419,11374438,19091461,12792805,12000145,17951357,18687691,23554959,19101986,12514295,18413741,22788991,12368417,16499663,15661057,16489011,16166295,17252539,11245486,16964758,16203797,19433345,12840208,19632246,18507011,20658545,9203623,12114442,20309614,17132221,25655200,16198100,20564423,24504368,28810652,21071579,19373614,17332344,21062672,22843076,15489213,16433906,16309237,22495798,19885928,18565171,11006085,24184124,18339885,12115487,16673816,20138837,24167630,24641702,12416264,16772519,19097122,16640785,16434996,29901146,9137471,29456113,11074606,10050261,17947488,17468512,22928040,8529197,16011659,16651437,10693171,12441353,20395211,11790449,16601287,23431365,10811979,15955619,12468598,22065906,17615260,9806188,15297432,12481257,22484470,12391264,11234894,12496489,15527761,22098108,23267126,17182827,16925846,12112315,11170137,18431742,11911282,15256057,16652383,18718175,17676056,18425381,23135751,25931004,22452992,11525601,16372328,18512728,17142033,11341036,17201635,29282909,21637922,20553187,12566472,15486194,27198154,17304503,15179686,14734014,19443942,12485911,17601486,14534735,16365062,20673057,19263441,17156992,9921985,20952759,7872690,22494660,24373791,20404023,22126297,9492340,14565846,17297558,16299812,9730149,15833883,22993077,8497428,16725013,18852123,23870911,25991428,19351854,21480311,16643189,18625043,12270218,14755680,15584372,10766429,16689831,15546018,9636157,9506530,11003595,22021684,19638505,22798715,15342391,19127598,10460196,15042621,8878413,15315711,19292464,20859991,12732287,29480308,25831061,17212824,18814146,26341135,19022961,19846946,20332239,11052627,15026355,16728719,11931850,15523106,12213285,11315093,17186423,16774941,11880592,19469643,20097631,9811314,23362941,15113973,22953905,16507219,11368927,23999913,9798729,21603581,16197614,10693166,24038102,18483578,10361557,24871471,20551244,16808622,8058523,10325503,12899539,19670229,26298461,9465938,25592466,10325492,14666653,23824838,16513288,15201729,25362531,20668305,11295600",
  },
  {
    id: "2090",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "105",
    pmids:
      "25354548,24244355,22431435,27132804,18726985,28811126,28573252,26476001,23265454,21204621,17031854,18377872,11903689,18455702,15327830,20596804,21286663,22452782,27476422,23094058,16636967,16964758,20658310,12840208,16049707,21468543,23673431,25630105,27186419,20718984,20096292,28810652,14715546,21062672,21308698,15489213,28677813,29434932,19731038,25655047,24836925,20148354,17111826,12769521,17292933,15764345,17137104,25150162,26792689,20395211,18313772,11790449,16898267,24859601,28846663,21528340,27495232,12888923,25380086,12391264,16271822,26017621,26197788,18211028,28691182,24726691,11341036,26011145,29678660,26676551,11142097,16600019,27919958,22924393,17475387,16645725,22213289,18655183,17256902,15661808,28729398,21194250,12237244,15584372,10861841,11238180,19468836,22358425,25164625,26875690,24314868,26341135,19846946,29898731,15685239,15171697,16239064,28902204,19007764,25360648,15067354,11134977,24813683,24080313,24962584",
  },
  {
    id: "2091",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "111",
    pmids:
      "18818108,12918062,9751250,18225555,12894226,17931610,15764647,26471237,18348186,22505206,19326061,14759133,10773882,12559991,22788991,18942120,22452782,14633667,25441423,24329111,20522783,17363494,12175522,21182420,23447335,16203797,15161048,17998943,21468543,15358631,18584482,17593102,17564322,20718984,14991864,19139131,12393936,20002680,25604133,15489213,21067181,12237322,25655047,20971741,20729872,22552582,27786455,17499153,21633670,10624710,20623641,20395211,17332308,21177307,25243063,12025870,16425281,11228105,17705241,11170137,21538852,26155176,14743383,16786054,22070051,29468843,19137815,25272043,15633248,15386368,19577562,16519995,15386386,15455372,29147215,20924968,9414176,12840218,18359184,24867960,24039951,10739747,29466808,23615977,7585463,24971028,12597448,17046135,16387739,27234272,24072771,26654241,21676444,26317853,20628004,16005427,19846946,18324707,11931850,29256350,22098273,18641202,23041649,14612489,16954429,22802668,18977589,16817634,27262332,25592466,15201729",
  },
  {
    id: "2092",
    id_polifenol: "2167",
    polifenol: "phenolic acid",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "54",
    pmids:
      "25371595,21948980,20838625,17522067,21286663,19007765,27665471,19892808,25539472,25183268,17168675,28179945,17486636,29542423,19731038,19768977,24324518,21877948,27261177,27235722,24752205,28344475,21849094,21538852,7488239,18211028,15134383,26748997,24001836,15113149,23738732,17475387,26810568,28920447,26469183,28363853,26569200,26610436,22628046,23615534,22409255,15652269,19468836,26307544,23537598,19007764,23430955,28509442,28958561,27981754,20158254,26954068,21796577,27163852",
  },
  {
    id: "2093",
    id_polifenol: "49",
    polifenol: "Aspirin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "35",
    pmids:
      "16199534,28278500,17848598,23535188,29226720,11078056,28717171,7478432,15201807,19446546,28075470,11747987,14532966,23493387,19026633,20648923,25940306,12076251,17447067,11205285,18971789,19301305,15570007,12618325,12357301,14991868,26296974,29633296,16531064,26704566,14612489,10639187,17462298,16175586,27186121",
  },
  {
    id: "2094",
    id_polifenol: "109",
    polifenol: "Catechin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "42",
    pmids:
      "12918062,9751250,26975752,22505206,26805810,20574921,17331955,22626556,15358631,16835506,16474170,28911392,27226712,28798415,11228105,26059723,26155176,16786054,11142097,17475387,17827674,29466808,7585463,15584372,10861841,17046135,27234272,20628004,25230777,11931850,29256350,22098273,18641202,16613539,15546559,23041649,18941371,12533689,15938138,19588362,28379200,25338140",
  },
  {
    id: "2095",
    id_polifenol: "125",
    polifenol: "Isoflavones",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "118",
    pmids:
      "18818108,24359236,23936419,24231449,25734831,19091461,21803611,12792805,18687691,25301361,19101986,12514295,18413741,27088761,21134073,26638886,16489011,16166295,15845653,16964758,16203797,18220535,20309614,16198100,21914638,17332344,16433906,19885928,18565171,12115487,16673816,20138837,12111696,12416264,16640785,22207083,11074606,10050261,17947488,10693171,10811979,21605661,22065906,22805767,15297432,12481257,22484470,11234894,15527761,23267126,17374662,16925846,11170137,18425381,16372328,17142033,21637922,12566472,27198154,22357205,17304503,19443942,16365062,20673057,17156992,22494660,24373791,20404023,9492340,9730149,8497428,18852123,23870911,25991428,12270218,16353248,15584372,10766429,22412975,22021684,22798715,20391625,19127598,10460196,19373613,19292464,20332239,12242729,16774941,19141600,11880592,22953905,14656947,16507219,11368927,23999913,20158254,20503397,26954068,21603581,12518321,10693166,18236473,10668477,10361557,15938138,14664516,16808622,27823732,8058523,10325503,26298461,23824838,16513288,15115228,23136625,25362531,20668305",
  },
  {
    id: "2096",
    id_polifenol: "110",
    polifenol: "Chalcones",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "42",
    pmids:
      "26854643,28390228,27348972,22634834,26615871,25313981,27900636,22115618,20456427,28494257,21184149,25743216,21170936,10953339,29065840,16140534,20623631,22993307,26497688,16517140,28774575,20112340,23877542,20714300,26986925,29277717,27371926,23501110,20161998,20888764,24232740,29764864,23691159,25783964,22668451,28838697,26785306,27777009,22358425,19138519,29400468,22071256",
  },
  {
    id: "2097",
    id_polifenol: "3089",
    polifenol: "1,1-diphenyl-2-picrylhydrazyl",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "29",
    pmids:
      "12417027,23769983,27507083,28725626,26805810,22410248,23645467,25539472,23434138,28179945,29542423,19731038,21877948,20548938,23173924,23876231,28462147,24389510,17475387,27039735,26320438,23615534,26320439,27318296,24824323,26320443,20183253,26954068,27072985",
  },
  {
    id: "2098",
    id_polifenol: "114",
    polifenol: "Apigenin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "59",
    pmids:
      "24563225,18726972,15486995,26435478,14750216,24926787,19031366,16964758,19690196,25408199,15131058,19892808,26379052,17132221,23359392,15489213,12032841,19737984,16687488,27569589,17942463,17457054,28107698,20395211,18342637,18725386,11790449,18240292,23431365,22065906,12509912,16648554,18292973,16581776,16271822,22006862,11341036,19373605,24614817,24067903,23861346,9492340,26569200,26610436,29142311,27102611,11573952,16230333,26948964,17638904,27930986,25837279,29066975,16954429,10325503,22139534,25351792,10325492,26309896",
  },
  {
    id: "2099",
    id_polifenol: "113",
    polifenol: "Flavones",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "31",
    pmids:
      "24377565,27582546,18726972,28213961,16964758,26379052,29542423,17418982,9137471,18998472,22768128,18342637,18725386,18240292,25216351,22065906,21541623,21351299,22957647,21808878,24614817,24067903,23861346,7872690,9492340,15637089,17363487,27102611,24930002,17638904,22139534",
  },
  {
    id: "2100",
    id_polifenol: "38",
    polifenol: "Gallic Acid",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "30",
    pmids:
      "25371595,19589639,12127233,26805810,20574921,17331955,19543955,22593437,20162340,27665471,25183268,17172433,19731038,25712645,24836925,21503582,16474170,21887735,28344475,29468843,24726691,18445658,16220564,22628046,15652269,22110195,28951686,19468836,23537598,24547772",
  },
  {
    id: "2101",
    id_polifenol: "117",
    polifenol: "Luteolin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "32",
    pmids:
      "17065200,23300633,28362855,23066085,18008333,19509250,12127233,29867083,19690196,18946510,19139131,28810652,24971999,23675277,17942463,27307749,11790449,21528340,23065001,19837161,20558290,21351299,11341036,25272043,27919958,29142311,14718582,25023990,23066443,25837279,29066975,15744587",
  },
  {
    id: "2102",
    id_polifenol: "1",
    polifenol: "Phenols",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "20",
    pmids:
      "24339417,24804028,23645467,25917126,27483851,21843795,25313139,28950692,28462147,26369539,11142097,17295185,22628046,22409255,19053086,21597729,11023645,23629419,23430955,24016002",
  },
  {
    id: "2103",
    id_polifenol: "105",
    polifenol: "Anthocyanins",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "21",
    pmids:
      "24377565,18948740,21948980,27462923,23869191,17522067,20574921,18922932,26069256,24804028,23199305,26315029,27235722,18211028,25510742,15113149,16234852,16111875,23828497,28886426,28512306",
  },
  {
    id: "2104",
    id_polifenol: "7235",
    polifenol: "silybin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "66",
    pmids:
      "15486995,11532861,17389612,27405931,22820499,26522224,29755557,28042859,11059749,22514647,19778521,12866029,27261177,20428808,19578386,27207648,21139802,23555889,11896607,23260576,21507570,18435416,15076315,19966941,14965263,26516160,18538589,17341659,15476849,17938263,17916909,26748997,24692702,16205633,11346885,25285031,12429642,14504208,12479270,27533043,10377442,25446081,23115104,19147767,29147215,28756013,21546539,15899838,25294820,18253818,12386921,28391184,17230508,26087400,12429923,18006855,21166494,19047104,12036915,18798272,15523106,16637061,24615813,16954429,15124082,18701508",
  },
  {
    id: "2105",
    id_polifenol: "129",
    polifenol: "Rotenone",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "33",
    pmids:
      "24877026,12514295,22002081,12114442,12111696,12821677,24586439,18006827,15764812,17702527,15355852,12481257,26824323,20722506,16372328,24078461,14734014,12485911,22204911,9492340,17297558,22354391,9465945,20811696,22428931,12270218,12732287,15561720,16197614,11225734,10325503,9644064,10325492",
  },
  {
    id: "2106",
    id_polifenol: "121",
    polifenol: "Kaempferols",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "19",
    pmids:
      "21286663,16636967,16964758,12840208,18946510,21067181,19731038,20548938,24859601,28846663,16271822,18211028,11341036,17256902,23537598,11931850,16443360,10325503,10325492",
  },
  {
    id: "2107",
    id_polifenol: "871",
    polifenol: "ABT-737",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "17",
    pmids:
      "25333266,20058240,22080570,22490358,23341456,21084274,21566062,22903438,22179721,22241682,21949692,25215949,21555592,29188305,19737977,24058878,26088877",
  },
  {
    id: "2108",
    id_polifenol: "6451",
    polifenol: "daidzein",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "48",
    pmids:
      "19101986,26638886,17252539,16203797,12840208,19632246,20309614,17332344,16673816,24641702,12416264,9806188,12481257,23267126,16925846,17676056,11525601,16372328,21637922,12566472,17304503,16365062,17156992,24373791,20404023,22126297,16898868,9730149,22993077,8497428,23870911,22021684,22798715,10460196,19292464,12732287,25831061,11931850,20097631,22953905,11368927,26298461,25592466,10325492,23824838,16513288,25362531,20668305",
  },
  {
    id: "2109",
    id_polifenol: "6065",
    polifenol: "baicalein",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "25",
    pmids:
      "23066085,20227521,19031366,11980674,11591177,15489213,16638750,29285272,20395211,18974136,25957503,11053652,9199209,12874035,16330112,28448441,17443494,15897592,15586246,12421879,10861450,14669797,23523613,11931850,12533689",
  },
  {
    id: "2110",
    id_polifenol: "7",
    polifenol: "Capsaicin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "20",
    pmids:
      "27458171,16374544,26625315,26426257,17828457,19059400,16540674,24941670,27180305,26081756,25813723,27663071,18533110,21062154,15913603,21474332,15922855,25307418,19705615,16721555",
  },
  {
    id: "2111",
    id_polifenol: "4634",
    polifenol: "alvocidib",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "20",
    pmids:
      "22391209,20638287,12600435,10995888,21042745,25216351,21541623,15078984,25860066,16731754,15252147,20980437,9427698,12432259,28698547,11052627,9815683,11093360,16921509,12819936",
  },
  {
    id: "2112",
    id_polifenol: "120",
    polifenol: "Flavonols",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "16",
    pmids:
      "21743964,26493029,27476422,16636967,16964758,26622852,20574928,21161819,24859601,26017621,15113149,22742959,17475387,9492340,22789812,26052153",
  },
  {
    id: "2113",
    id_polifenol: "4522",
    polifenol: "chrysin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "8",
    pmids:
      "28213961,19031366,16964758,17237281,24324518,27151585,21808878,19470632",
  },
  {
    id: "2114",
    id_polifenol: "123",
    polifenol: "Rutin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "11",
    pmids:
      "28811126,12840208,18946510,16271822,24726691,11341036,26810568,22952557,23537598,28694767,27981754",
  },
  {
    id: "2115",
    id_polifenol: "6062",
    polifenol: "naringenin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "11",
    pmids:
      "27838343,16964758,21674787,11341036,27606834,26810568,20648923,20981458,24813683,16163823,16111881",
  },
  {
    id: "2116",
    id_polifenol: "285",
    polifenol: "bisphenol A",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "9",
    pmids:
      "29383186,28495207,25669987,15665279,18819937,12479269,18007998,23450760,17172422",
  },
  {
    id: "2117",
    id_polifenol: "39",
    polifenol: "Hydrolyzable Tannins",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "17",
    pmids:
      "24377565,20838625,28555835,10403559,26805810,19269999,15670892,11684320,17331955,18790750,19731038,27483851,23350280,28462147,25798940,23615534,26954068",
  },
  {
    id: "2118",
    id_polifenol: "130",
    polifenol: "Proanthocyanidins",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "14",
    pmids:
      "28781636,16835506,14742313,20626034,17176222,21161819,18663730,16399225,19172579,20502321,15113149,16234852,16111875,21205921",
  },
  {
    id: "2119",
    id_polifenol: "35",
    polifenol: "Hydroquinones",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "8",
    pmids:
      "24530478,21371263,21410406,17351106,9254898,9923964,15837761,20877240",
  },
  {
    id: "2120",
    id_polifenol: "111",
    polifenol: "Flavanones",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "10",
    pmids:
      "21790499,24324069,29264766,20428808,17341659,15476849,21351299,17475387,28539744,9492340",
  },
  {
    id: "2121",
    id_polifenol: "4502",
    polifenol: "fisetin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "14",
    pmids:
      "21743964,18359761,27476422,20574928,20530556,19633975,24770864,18922931,26017621,26235140,22789812,11931850,16314891,27765854",
  },
  {
    id: "2122",
    id_polifenol: "6",
    polifenol: "Catechols",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "2",
    pmids: "23408432,11931850",
  },
  {
    id: "2123",
    id_polifenol: "25",
    polifenol: "Butylated Hydroxytoluene",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "5",
    pmids: "19107848,11038234,29403961,27829607,14690799",
  },
  {
    id: "2124",
    id_polifenol: "75",
    polifenol: "Butylated Hydroxyanisole",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "3",
    pmids: "23173924,11038234,11156257",
  },
  {
    id: "2125",
    id_polifenol: "15",
    polifenol: "Masoprocol",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "10",
    pmids:
      "23066085,18491370,17645780,15350831,17486636,16638750,20937254,9806188,27863391,11931850",
  },
  {
    id: "2126",
    id_polifenol: "6087",
    polifenol: "wogonin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "6",
    pmids: "19031366,19438509,18377871,27196894,18202763,15897592",
  },
  {
    id: "2127",
    id_polifenol: "4519",
    polifenol: "myricetin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "7",
    pmids: "23265454,16636967,18946510,19731038,16271822,11341036,11931850",
  },
  {
    id: "2128",
    id_polifenol: "4515",
    polifenol: "baicalin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "9",
    pmids:
      "19031366,11746275,11591177,24496985,11502443,15714805,11053652,15586246,12350462",
  },
  {
    id: "2129",
    id_polifenol: "4500",
    polifenol: "procyanidin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "12",
    pmids:
      "29654773,28781636,17331955,12618755,17545043,16474170,19172579,28798415,10942529,21205921,12419835,18974423",
  },
  {
    id: "2130",
    id_polifenol: "5608",
    polifenol: "epicatechin gallate",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "7",
    pmids: "10624710,11228105,9414176,29466808,7585463,20628004,18641202",
  },
  {
    id: "2131",
    id_polifenol: "1356",
    polifenol: "gingerol",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "7",
    pmids: "24691500,28872603,21849094,18030663,17151092,23441614,24431413",
  },
  {
    id: "2132",
    id_polifenol: "54",
    polifenol: "Salicylic Acid",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "7",
    pmids: "21828260,22148584,22313179,7478432,20648923,18971789,24060830",
  },
  {
    id: "2133",
    id_polifenol: "98",
    polifenol: "Propofol",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "3",
    pmids: "29568752,28552345,25072260",
  },
  {
    id: "2134",
    id_polifenol: "5607",
    polifenol: "gallocatechol",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "8",
    pmids:
      "22505206,16636967,19172579,11228105,16786054,9414176,20628004,18641202",
  },
  {
    id: "2135",
    id_polifenol: "5578",
    polifenol: "alpha-naphthoflavone",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "10964100",
  },
  {
    id: "2136",
    id_polifenol: "44",
    polifenol: "Salicylates",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "3",
    pmids: "28717171,25940306,24867960",
  },
  {
    id: "2137",
    id_polifenol: "4559",
    polifenol: "theaflavin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "10",
    pmids:
      "10773882,23715786,10624710,17499812,17936851,26155176,14743383,17827674,16387739,18641202",
  },
  {
    id: "2138",
    id_polifenol: "5808",
    polifenol: "isoliquiritigenin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "9",
    pmids:
      "12706007,17473376,18824345,20456427,25365296,16517140,19298190,29277717,18202763",
  },
  {
    id: "2139",
    id_polifenol: "2344",
    polifenol: "methyl gallate",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "11",
    pmids:
      "26975752,25371595,17331955,15161048,20162340,20718984,16474170,16786054,29468843,17827674,11931850",
  },
  {
    id: "2140",
    id_polifenol: "4708",
    polifenol: "xanthohumol",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "9",
    pmids:
      "16678392,27338375,16563612,20944105,17726738,23434138,25771121,20161998,22952060",
  },
  {
    id: "2141",
    id_polifenol: "2284",
    polifenol: "rosmarinic acid",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "2",
    pmids: "20449663,26948964",
  },
  {
    id: "2142",
    id_polifenol: "112",
    polifenol: "Hesperidin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "2",
    pmids: "25499067,19548283",
  },
  {
    id: "2143",
    id_polifenol: "6455",
    polifenol: "nobiletin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "3",
    pmids: "22273151,25342300,17284254",
  },
  {
    id: "2144",
    id_polifenol: "10",
    polifenol: "Estrogens, Catechol",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "29654831",
  },
  {
    id: "2145",
    id_polifenol: "4513",
    polifenol: "galangin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "3",
    pmids: "29097203,19892808,24859601",
  },
  {
    id: "2146",
    id_polifenol: "6063",
    polifenol: "naringin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "25499067",
  },
  {
    id: "2147",
    id_polifenol: "1380",
    polifenol: "shogaol",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "4",
    pmids: "24691500,28872603,21849094,24431413",
  },
  {
    id: "2148",
    id_polifenol: "2158",
    polifenol: "protocatechuic acid",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "4",
    pmids: "19601677,24752205,22409255,25230777",
  },
  {
    id: "2149",
    id_polifenol: "5489",
    polifenol: "delphinidin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "6",
    pmids: "18948740,27390740,27462923,18922932,25991668,21067181",
  },
  {
    id: "2150",
    id_polifenol: "6273",
    polifenol: "hesperetin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "3",
    pmids: "22438130,23992001,28539744",
  },
  {
    id: "2151",
    id_polifenol: "1613",
    polifenol: "demethoxycurcumin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "4",
    pmids: "22849866,22552297,17137104,24348813",
  },
  {
    id: "2152",
    id_polifenol: "93",
    polifenol: "Phloroglucinol",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "3",
    pmids: "26826267,24041234,15844953",
  },
  {
    id: "2153",
    id_polifenol: "6454",
    polifenol: "formononetin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "8",
    pmids:
      "24359236,24666255,28038329,25301361,24761910,22328166,26916669,22633834",
  },
  {
    id: "2154",
    id_polifenol: "81",
    polifenol: "Fenofibrate",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "4",
    pmids: "23399562,29305864,21617875,25389904",
  },
  {
    id: "2155",
    id_polifenol: "7550",
    polifenol: "3-methylquercetin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "2",
    pmids: "28846663,23537598",
  },
  {
    id: "2156",
    id_polifenol: "6461",
    polifenol: "acacetin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "8",
    pmids:
      "19693651,24285354,22438130,15637089,26569200,26610436,16954429,21214467",
  },
  {
    id: "2157",
    id_polifenol: "4253",
    polifenol:
      "5-(2,4-dihydroxy-5-isopropylphenyl)-4-(4-morpholin-4-ylmethylphenyl)isoxazole-3-carboxylic acid ethylamide",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "6",
    pmids: "26112442,23358469,27526951,18413753,25072314,22573351",
  },
  {
    id: "2158",
    id_polifenol: "1611",
    polifenol: "bis(4-hydroxycinnamoyl)methane",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "3",
    pmids: "22849866,17137104,24348813",
  },
  {
    id: "2159",
    id_polifenol: "119",
    polifenol: "Silymarin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "6",
    pmids: "14965263,11170137,11006131,17548792,12386921,9581834",
  },
  {
    id: "2160",
    id_polifenol: "69",
    polifenol: "Phenolsulfonphthalein",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "3",
    pmids: "8549651,11023645,11870800",
  },
  {
    id: "2161",
    id_polifenol: "126",
    polifenol: "Coumestrol",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "5",
    pmids: "24768446,27431052,11525601,9492340,19007764",
  },
  {
    id: "2162",
    id_polifenol: "55",
    polifenol: "Sodium Salicylate",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "16402387",
  },
  {
    id: "2163",
    id_polifenol: "5806",
    polifenol: "butein",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "4",
    pmids: "20696233,21170936,22114764,20161998",
  },
  {
    id: "2164",
    id_polifenol: "108",
    polifenol: "Biflavonoids",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "3",
    pmids: "19147565,23523142,18380477",
  },
  {
    id: "2165",
    id_polifenol: "1558",
    polifenol: "capsazepine",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "9",
    pmids:
      "27458171,16374544,25481381,19059400,16271848,15913603,21474332,19908944,15548706",
  },
  {
    id: "2166",
    id_polifenol: "5509",
    polifenol: "cyanidin 3-O-glucoside",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "3",
    pmids: "28555835,23199305,18211028",
  },
  {
    id: "2167",
    id_polifenol: "969",
    polifenol: "3,4-dihydroxyphenacyl caffeate phenylpropanoid ester",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "17295185",
  },
  {
    id: "2168",
    id_polifenol: "5844",
    polifenol: "4-dimethylamino-3',4'-dimethoxychalcone",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "7",
    pmids: "12432255,21406729,16143308,16784892,12700652,11020350,9815772",
  },
  {
    id: "2169",
    id_polifenol: "5819",
    polifenol: "licochalcone A",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "6",
    pmids: "15313200,19711916,10953339,24944769,20161998,14755680",
  },
  {
    id: "2170",
    id_polifenol: "94",
    polifenol: "Phloretin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "20714300",
  },
  {
    id: "2171",
    id_polifenol: "48",
    polifenol: "Anacardic Acids",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "5",
    pmids: "23359208,28731173,26884865,21828260,28717171",
  },
  {
    id: "2172",
    id_polifenol: "5488",
    polifenol: "cyanidin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "2",
    pmids: "26315029,16443360",
  },
  {
    id: "2173",
    id_polifenol: "4640",
    polifenol: "5,7-dihydroxy-6-methoxy-2-phenylchromen-4-one",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "24637576",
  },
  {
    id: "2174",
    id_polifenol: "2773",
    polifenol: "farnesylthiosalicylic acid",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "2",
    pmids: "16780807,12569550",
  },
  {
    id: "2175",
    id_polifenol: "80",
    polifenol: "Clofibrate",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "2",
    pmids: "24247298,8759039",
  },
  {
    id: "2176",
    id_polifenol: "132",
    polifenol: "Equol",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "9",
    pmids:
      "27088761,26638886,22788991,21861338,12481257,16925846,16898868,21056663,16513288",
  },
  {
    id: "2177",
    id_polifenol: "1673",
    polifenol: "4-hydroxyestradiol",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "2",
    pmids: "26981862,29654831",
  },
  {
    id: "2178",
    id_polifenol: "7546",
    polifenol: "isoquercitrin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "16475722",
  },
  {
    id: "2179",
    id_polifenol: "6482",
    polifenol: "tangeretin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "29375715",
  },
  {
    id: "2180",
    id_polifenol: "89",
    polifenol: "Vanillic Acid",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "5",
    pmids: "12869308,27235722,24752205,26778604,27981754",
  },
  {
    id: "2181",
    id_polifenol: "99",
    polifenol: "Pyrogallol",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "2",
    pmids: "25371595,22409255",
  },
  {
    id: "2182",
    id_polifenol: "452",
    polifenol: "acteoside",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "2",
    pmids: "22944352,12533689",
  },
  {
    id: "2183",
    id_polifenol: "1644",
    polifenol: "Cur1 compound",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "2",
    pmids: "22849866,29201078",
  },
  {
    id: "2184",
    id_polifenol: "100",
    polifenol: "Resorcinols",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "3",
    pmids: "21751842,24392814,25482429",
  },
  {
    id: "2185",
    id_polifenol: "5614",
    polifenol: "catechin gallate",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "2",
    pmids: "26975752,24867960",
  },
  {
    id: "2186",
    id_polifenol: "4486",
    polifenol: "amentoflavone",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "16271822",
  },
  {
    id: "2187",
    id_polifenol: "5850",
    polifenol: "cardamonin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "3",
    pmids: "27900636,24514747,23691159",
  },
  {
    id: "2188",
    id_polifenol: "118",
    polifenol: "Flavonolignans",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "7",
    pmids: "17389612,22514647,23555889,23260576,18435416,15899838,18798272",
  },
  {
    id: "2189",
    id_polifenol: "7541",
    polifenol: "taxifolin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "2",
    pmids: "23382917,29402482",
  },
  {
    id: "2190",
    id_polifenol: "7544",
    polifenol: "quercitrin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "2",
    pmids: "23265454,16271822",
  },
  {
    id: "2191",
    id_polifenol: "60",
    polifenol: "2,4-Dinitrophenol",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "26950698",
  },
  {
    id: "2192",
    id_polifenol: "300",
    polifenol: "rhodioloside",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "27262332",
  },
  {
    id: "2193",
    id_polifenol: "7912",
    polifenol: "7,9,2',4'-tetrahydroxy-8-isopentenyl-5-methoxychalcone",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "3",
    pmids: "21790499,27338375,20944105",
  },
  {
    id: "2194",
    id_polifenol: "6465",
    polifenol: "genistin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "6",
    pmids: "9806188,20404023,9730149,15584372,12242729,22953905",
  },
  {
    id: "2195",
    id_polifenol: "350",
    polifenol: "nonylphenol",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "24908729",
  },
  {
    id: "2196",
    id_polifenol: "4767",
    polifenol: "flavan-3-ol",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "2",
    pmids: "26307544,18641202",
  },
  {
    id: "2197",
    id_polifenol: "2475",
    polifenol: "6-O-galloylglucose",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "3",
    pmids: "17331955,20623641,19721258",
  },
  {
    id: "2198",
    id_polifenol: "92",
    polifenol: "Triclosan",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "3",
    pmids: "25313139,25682003,28096238",
  },
  {
    id: "2199",
    id_polifenol: "6097",
    polifenol: "8-prenylnaringenin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "3",
    pmids: "16678392,17726738,25771121",
  },
  {
    id: "2200",
    id_polifenol: "2447",
    polifenol: "beta-penta-O-galloyl-glucose",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "9",
    pmids:
      "26805810,19269999,14963012,19825802,20599777,21048308,18790750,15105050,20809980",
  },
  {
    id: "2201",
    id_polifenol: "1996",
    polifenol: "2,5-di-tert-butylhydroquinone",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "7",
    pmids: "24849495,21232596,26014123,22845469,23898810,27188467,24495178",
  },
  {
    id: "2202",
    id_polifenol: "5071",
    polifenol: "icaritin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "3",
    pmids: "27537398,27207661,25908644",
  },
  {
    id: "2203",
    id_polifenol: "6576",
    polifenol: "5,7,4'-trihydroxyflavone",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "7",
    pmids: "29097203,14750216,25408199,16648554,18292973,22006862,25351792",
  },
  {
    id: "2204",
    id_polifenol: "4585",
    polifenol: "baohuoside I",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "2",
    pmids: "19289254,26052153",
  },
  {
    id: "2205",
    id_polifenol: "6625",
    polifenol: "phenoxodiol",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "6",
    pmids: "20564423,25400509,22357205,19209173,15922855,16507219",
  },
  {
    id: "2206",
    id_polifenol: "1616",
    polifenol: "tetrahydrocurcumin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "16787365",
  },
  {
    id: "2207",
    id_polifenol: "59",
    polifenol: "Dinitrophenols",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "19524545",
  },
  {
    id: "2208",
    id_polifenol: "4516",
    polifenol: "diosmetin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "29767250",
  },
  {
    id: "2209",
    id_polifenol: "102",
    polifenol: "Zearalenone",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "2",
    pmids: "28427036,29495557",
  },
  {
    id: "2210",
    id_polifenol: "7161",
    polifenol: "scutellarin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "3",
    pmids: "28458133,28737827,22944352",
  },
  {
    id: "2211",
    id_polifenol: "2328",
    polifenol: "syringic acid",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "26810568",
  },
  {
    id: "2212",
    id_polifenol: "36",
    polifenol: "Hydroxybenzoates",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "24752205",
  },
  {
    id: "2213",
    id_polifenol: "7134",
    polifenol: "vitexin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "27387399",
  },
  {
    id: "2214",
    id_polifenol: "4796",
    polifenol: "aminoflavone",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "15210858",
  },
  {
    id: "2215",
    id_polifenol: "5455",
    polifenol: "theaflavin-3,3'-digallate",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "14963012",
  },
  {
    id: "2216",
    id_polifenol: "2490",
    polifenol: "punicalagin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "4",
    pmids: "19919114,28709945,24804028,18468784",
  },
  {
    id: "2217",
    id_polifenol: "5815",
    polifenol: "dibenzoylmethane",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "6",
    pmids: "21924245,29595853,19706764,17595765,11867200,15352255",
  },
  {
    id: "2218",
    id_polifenol: "5630",
    polifenol: "polyphenon E",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "4",
    pmids: "20522783,24343359,25272043,24501325",
  },
  {
    id: "2219",
    id_polifenol: "7547",
    polifenol: "hyperoside",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "25354548",
  },
  {
    id: "2220",
    id_polifenol: "349",
    polifenol: "4-nitrophenol",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "2",
    pmids: "26780698,27318296",
  },
  {
    id: "2221",
    id_polifenol: "5495",
    polifenol: "malvidin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "20574921",
  },
  {
    id: "2222",
    id_polifenol: "7141",
    polifenol: "apigetrin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "2",
    pmids: "24106661,27981754",
  },
  {
    id: "2223",
    id_polifenol: "77",
    polifenol: "Bezafibrate",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "10753637",
  },
  {
    id: "2224",
    id_polifenol: "1810",
    polifenol: "heminordihydroguaiaretic acid",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "15958646",
  },
  {
    id: "2225",
    id_polifenol: "19",
    polifenol: "Pentachlorophenol",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "29596660",
  },
  {
    id: "2226",
    id_polifenol: "6783",
    polifenol: "protoapigenone",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "3",
    pmids: "21256211,18337475,21657076",
  },
  {
    id: "2227",
    id_polifenol: "6510",
    polifenol: "glycitein",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "8",
    pmids:
      "17252539,20309614,12416264,16372328,12566472,17304503,17156992,19373613",
  },
  {
    id: "2228",
    id_polifenol: "7198",
    polifenol: "homoorientin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "29542423",
  },
  {
    id: "2229",
    id_polifenol: "7557",
    polifenol: "rhamnetin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "23464460",
  },
  {
    id: "2230",
    id_polifenol: "6456",
    polifenol: "daidzin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "3",
    pmids: "20404023,9730149,22953905",
  },
  {
    id: "2231",
    id_polifenol: "1353",
    polifenol: "protocatechualdehyde",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "28920346",
  },
  {
    id: "2232",
    id_polifenol: "4501",
    polifenol: "tricin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "29447469",
  },
  {
    id: "2233",
    id_polifenol: "4883",
    polifenol: "flavokawain B",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "3",
    pmids: "27865863,20112340,22347450",
  },
  {
    id: "2234",
    id_polifenol: "5496",
    polifenol: "pelargonidin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "18211028",
  },
  {
    id: "2235",
    id_polifenol: "7853",
    polifenol: "Grape Seed Proanthocyanidins",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "3",
    pmids: "28781636,12419835,26308756",
  },
  {
    id: "2236",
    id_polifenol: "7612",
    polifenol: "quercetin 3-O-glucuronide",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "2",
    pmids: "26805810,23436427",
  },
  {
    id: "2237",
    id_polifenol: "7775",
    polifenol: "glyceollin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "3",
    pmids: "21513275,19263441,21336922",
  },
  {
    id: "2238",
    id_polifenol: "687",
    polifenol: "calix(4)arene",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "3",
    pmids: "22410248,26511099,28533751",
  },
  {
    id: "2239",
    id_polifenol: "5796",
    polifenol: "dihydrochalcone",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "4",
    pmids: "25682949,20403609,20714300,23501110",
  },
  {
    id: "2240",
    id_polifenol: "6066",
    polifenol: "eriodictyol",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "20648923",
  },
  {
    id: "2241",
    id_polifenol: "2574",
    polifenol: "4-hydroxybenzoic acid",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "3",
    pmids: "26549368,25230777,27981754",
  },
  {
    id: "2242",
    id_polifenol: "3019",
    polifenol: "nitroaspirin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "15201807",
  },
  {
    id: "2243",
    id_polifenol: "6452",
    polifenol: "chrysoeriol",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "22438130",
  },
  {
    id: "2244",
    id_polifenol: "713",
    polifenol:
      "3-(3-chloro-4-hydroxyphenylamino)-4-(4-nitrophenyl)-1H-pyrrole-2,5-dione",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "3",
    pmids: "24519956,17234760,25398830",
  },
  {
    id: "2245",
    id_polifenol: "4480",
    polifenol: "myricitrin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "2",
    pmids: "23265454,24813683",
  },
  {
    id: "2246",
    id_polifenol: "7377",
    polifenol: "astragalin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "4",
    pmids: "24748754,26805810,26569200,26610436",
  },
  {
    id: "2247",
    id_polifenol: "413",
    polifenol: "4-nonylphenol",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "26804032",
  },
  {
    id: "2248",
    id_polifenol: "3489",
    polifenol: "anethole",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "4",
    pmids: "24328151,28745237,24525130,27981754",
  },
  {
    id: "2249",
    id_polifenol: "1672",
    polifenol: "B19 monocarbonyl curcumin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "2",
    pmids: "24297639,27496212",
  },
  {
    id: "2250",
    id_polifenol: "115",
    polifenol: "Diosmin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "25499067",
  },
  {
    id: "2251",
    id_polifenol: "6554",
    polifenol: "tectorigenin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "4",
    pmids: "15538285,15845653,16237540,17913855",
  },
  {
    id: "2252",
    id_polifenol: "4715",
    polifenol: "ampelopsin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "2",
    pmids: "26189300,22693649",
  },
  {
    id: "2253",
    id_polifenol: "2448",
    polifenol: "ellagitannin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "3",
    pmids: "26805810,18202771,18479901",
  },
  {
    id: "2254",
    id_polifenol: "7156",
    polifenol: "scutellarein",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "2",
    pmids: "19031366,22944352",
  },
  {
    id: "2255",
    id_polifenol: "6800",
    polifenol: "3,6-dimethoxy-6'',6''-dimethylchromeno(2'',3''-7,8)flavone",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "4",
    pmids: "22273151,20456427,29264766,11225734",
  },
  {
    id: "2256",
    id_polifenol: "299",
    polifenol: "nitrophenylphosphate",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "6616477",
  },
  {
    id: "2257",
    id_polifenol: "6693",
    polifenol: "2',4',7-trihydroxyisoflavone",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "5",
    pmids: "12514295,18413741,9203623,22452992,15584372",
  },
  {
    id: "2258",
    id_polifenol: "4565",
    polifenol: "morusin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "3",
    pmids: "25628938,28401008,28599457",
  },
  {
    id: "2259",
    id_polifenol: "6175",
    polifenol: "2'-hydroxyflavanone",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "3",
    pmids: "24859932,24123015,19007764",
  },
  {
    id: "2260",
    id_polifenol: "2283",
    polifenol: "depsidone",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "3",
    pmids: "22063921,15386197,16163823",
  },
  {
    id: "2261",
    id_polifenol: "1747",
    polifenol: "6-paradol",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "3",
    pmids: "24691500,21849094,18030663",
  },
  {
    id: "2262",
    id_polifenol: "2697",
    polifenol: "4-trifluoromethylsalicylic acid",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "4",
    pmids: "19783927,26810568,16254462,11020285",
  },
  {
    id: "2263",
    id_polifenol: "5005",
    polifenol: "procyanidin B",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "4",
    pmids: "17331955,20162340,29537730,26308756",
  },
  {
    id: "2264",
    id_polifenol: "12",
    polifenol: "Guaiacol",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "14718582",
  },
  {
    id: "2265",
    id_polifenol: "7741",
    polifenol: "biochanin A",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "9622078",
  },
  {
    id: "2266",
    id_polifenol: "2790",
    polifenol: "ginkgolic acid",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "21751842",
  },
  {
    id: "2267",
    id_polifenol: "357",
    polifenol: "4-aminophenol",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "2",
    pmids: "12417027,16203149",
  },
  {
    id: "2268",
    id_polifenol: "2343",
    polifenol: "ethyl gallate",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "2",
    pmids: "12127233,29468843",
  },
  {
    id: "2269",
    id_polifenol: "4479",
    polifenol: "morin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "28599307",
  },
  {
    id: "2270",
    id_polifenol: "2364",
    polifenol: "theaflavine gallate",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "17827674",
  },
  {
    id: "2271",
    id_polifenol: "9",
    polifenol: "1,2-Dihydroxybenzene-3,5-Disulfonic Acid Disodium Salt",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "14678967",
  },
  {
    id: "2272",
    id_polifenol: "6100",
    polifenol: "pinostrobin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "22495442",
  },
  {
    id: "2273",
    id_polifenol: "5875",
    polifenol: "panduratin A",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "2",
    pmids: "16497706,22120630",
  },
  {
    id: "2274",
    id_polifenol: "4839",
    polifenol: "7-hydroxyflavone",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "17218638",
  },
  {
    id: "2275",
    id_polifenol: "1689",
    polifenol: "16-hydroxyestrone",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "2",
    pmids: "29654831,19022961",
  },
  {
    id: "2276",
    id_polifenol: "7140",
    polifenol: "isovitexin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "3",
    pmids: "29326585,29542423,27387399",
  },
  {
    id: "2277",
    id_polifenol: "1678",
    polifenol: "2-methoxyestrone",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "2",
    pmids: "29654831,19022961",
  },
  {
    id: "2278",
    id_polifenol: "7895",
    polifenol: "flavokawain A",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "26497688",
  },
  {
    id: "2279",
    id_polifenol: "3494",
    polifenol: "asarone",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "25383224",
  },
  {
    id: "2280",
    id_polifenol: "4549",
    polifenol: "casticin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "23464460",
  },
  {
    id: "2281",
    id_polifenol: "6453",
    polifenol: "cirsimaritin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "27938087",
  },
  {
    id: "2282",
    id_polifenol: "4553",
    polifenol: "sulfuretin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "23318178",
  },
  {
    id: "2283",
    id_polifenol: "1662",
    polifenol: "BDMC-A",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "22849866",
  },
  {
    id: "2284",
    id_polifenol: "826",
    polifenol: "4,4',4''-(4-propyl-((1)H)-pyrazole-1,3,5-triyl) tris-phenol",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "21248144",
  },
  {
    id: "2285",
    id_polifenol: "5858",
    polifenol: "isobavachalcone",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "20161998",
  },
  {
    id: "2286",
    id_polifenol: "5539",
    polifenol: "peonidin 3-glucoside",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "23199305",
  },
  {
    id: "2287",
    id_polifenol: "4632",
    polifenol: "ginkgetin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "2",
    pmids: "23523142,25611086",
  },
  {
    id: "2288",
    id_polifenol: "2504",
    polifenol: "pentagalloylglucose",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "2",
    pmids: "19825802,19721258",
  },
  {
    id: "2289",
    id_polifenol: "2",
    polifenol: "Aminophenols",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "4",
    pmids: "12417027,17092729,16203149,17955489",
  },
  {
    id: "2290",
    id_polifenol: "6819",
    polifenol: "luteolin-7-O-glucoside",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "27981754",
  },
  {
    id: "2291",
    id_polifenol: "4607",
    polifenol: "orientin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "29542423",
  },
  {
    id: "2292",
    id_polifenol: "6093",
    polifenol: "pinobanksin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "24324518",
  },
  {
    id: "2293",
    id_polifenol: "7239",
    polifenol: "isosilybin A",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "8",
    pmids:
      "17389612,22514647,20721970,18332867,18435416,16205633,15899838,18798272",
  },
  {
    id: "2294",
    id_polifenol: "4544",
    polifenol: "tiliroside",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "3",
    pmids: "17475387,26569200,26610436",
  },
  {
    id: "2295",
    id_polifenol: "7437",
    polifenol: "kaempferol-3-O-rutinoside",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "26810568",
  },
  {
    id: "2296",
    id_polifenol: "1675",
    polifenol: "catechol estrogen 3,4-quinone",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "23994691",
  },
  {
    id: "2297",
    id_polifenol: "2168",
    polifenol: "beta-resorcylic acid",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "21796577",
  },
  {
    id: "2298",
    id_polifenol: "2471",
    polifenol: "oenothein B",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "5",
    pmids: "10403559,23436427,23738732,16492533,28454190",
  },
  {
    id: "2299",
    id_polifenol: "7422",
    polifenol: "kaempferide",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "24859601",
  },
  {
    id: "2300",
    id_polifenol: "6684",
    polifenol: "eupafolin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "2",
    pmids: "27582546,24700667",
  },
  {
    id: "2301",
    id_polifenol: "2173",
    polifenol: "atranorin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "2",
    pmids: "22063921,28095330",
  },
  {
    id: "2302",
    id_polifenol: "5841",
    polifenol: "2',6'-dihydroxy-4'-methoxychalcone",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "2",
    pmids: "27900636,20714300",
  },
  {
    id: "2303",
    id_polifenol: "5063",
    polifenol: "4',7-dihydroxy-3'-methoxy-5'-prenylflavanone",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "17726738",
  },
  {
    id: "2304",
    id_polifenol: "1509",
    polifenol: "8-gingerol",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "2",
    pmids: "23441614,24431413",
  },
  {
    id: "2305",
    id_polifenol: "58",
    polifenol: "Nitrophenols",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "26780698",
  },
  {
    id: "2306",
    id_polifenol: "3606",
    polifenol:
      "5-(3-methoxy-4-((4-methoxybenzyl)oxy)benzyl)pyrimidine-2,4-diamine",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "24662052",
  },
  {
    id: "2307",
    id_polifenol: "818",
    polifenol: "4,4'-isopropylidene diphenol",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "2",
    pmids: "19053086,21892919",
  },
  {
    id: "2308",
    id_polifenol: "4558",
    polifenol: "2'-hydroxyflavone",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "2",
    pmids: "26235140,27765854",
  },
  {
    id: "2309",
    id_polifenol: "5814",
    polifenol: "2',4'-dihydroxychalcone",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "26788200",
  },
  {
    id: "2310",
    id_polifenol: "7169",
    polifenol: "apigenin-6,8-di-C-glycopyranoside",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "2",
    pmids: "21803027,28359741",
  },
  {
    id: "2311",
    id_polifenol: "7427",
    polifenol: "kaempferol 3-O-rhamnoside",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "25469259",
  },
  {
    id: "2312",
    id_polifenol: "5141",
    polifenol: "6-prenylnaringenin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "2",
    pmids: "16678392,17726738",
  },
  {
    id: "2313",
    id_polifenol: "2339",
    polifenol: "3-O-methylgallic acid",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "2",
    pmids: "19731038,25230777",
  },
  {
    id: "2314",
    id_polifenol: "1492",
    polifenol: "hirsutenone",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "25213146",
  },
  {
    id: "2315",
    id_polifenol: "4548",
    polifenol: "artemetin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "22429052",
  },
  {
    id: "2316",
    id_polifenol: "273",
    polifenol: "bis(4-nitrophenyl)phosphate",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "19339378",
  },
  {
    id: "2317",
    id_polifenol: "5941",
    polifenol: "3-hydroxy-4,3',4',5'-tetramethoxychalcone",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "28838697",
  },
  {
    id: "2318",
    id_polifenol: "5720",
    polifenol: "4,3',4',5'- tetramethoxychalcone",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "28838697",
  },
  {
    id: "2319",
    id_polifenol: "5827",
    polifenol: "4'-methoxychalcone",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "20623631",
  },
  {
    id: "2320",
    id_polifenol: "2336",
    polifenol: "octyl gallate",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "2",
    pmids: "29468843,27163852",
  },
  {
    id: "2321",
    id_polifenol: "6717",
    polifenol: "irigenin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "15538285",
  },
  {
    id: "2322",
    id_polifenol: "6031",
    polifenol: "2',3'-dimethoxyflavanone",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "2",
    pmids: "22495442,21351299",
  },
  {
    id: "2323",
    id_polifenol: "343",
    polifenol: "2,5-dichloro-4-bromophenol",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "15774218",
  },
  {
    id: "2324",
    id_polifenol: "3245",
    polifenol: "obovatol",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "2",
    pmids: "18241858,19834284",
  },
  {
    id: "2325",
    id_polifenol: "2484",
    polifenol: "chebulinic acid",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "12127233",
  },
  {
    id: "2326",
    id_polifenol: "72",
    polifenol: "Phenyl Ethers",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "25879502",
  },
  {
    id: "2327",
    id_polifenol: "7852",
    polifenol: "afzelin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "26622852",
  },
  {
    id: "2328",
    id_polifenol: "5616",
    polifenol: "epigallocatechin-3-(3''-O-methyl)gallate",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "20628004",
  },
  {
    id: "2329",
    id_polifenol: "418",
    polifenol: "thiophenol",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "28102565",
  },
  {
    id: "2330",
    id_polifenol: "1674",
    polifenol: "6-hydroxyestrogen 6-sulfate",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "19022961",
  },
  {
    id: "2331",
    id_polifenol: "858",
    polifenol: "2-(3-chloro-4-hydroxyphenyl)-2-(4-hydroxyphenyl)propane",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "2",
    pmids: "17955489,25991428",
  },
  {
    id: "2332",
    id_polifenol: "5945",
    polifenol: "2',5'-dimethoxychalcone",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "20199865",
  },
  {
    id: "2333",
    id_polifenol: "1451",
    polifenol: "hispolon",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "25842364",
  },
  {
    id: "2334",
    id_polifenol: "6587",
    polifenol: "glycitin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "20404023",
  },
  {
    id: "2335",
    id_polifenol: "6940",
    polifenol: "neobavaisoflavone",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "2",
    pmids: "24231449,21441621",
  },
  {
    id: "2336",
    id_polifenol: "6478",
    polifenol: "cirsilineol",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "22768128",
  },
  {
    id: "2337",
    id_polifenol: "5963",
    polifenol: "3,5,2',4'-tetrahydroxychalcone",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "21170936",
  },
  {
    id: "2338",
    id_polifenol: "996",
    polifenol: "2,3-difluoro phenol",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "2",
    pmids: "29466808,22672984",
  },
  {
    id: "2339",
    id_polifenol: "1262",
    polifenol: "4-dodecylaminophenol",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "2",
    pmids: "17092729,17955489",
  },
  {
    id: "2340",
    id_polifenol: "4630",
    polifenol: "5,7,2',3'-tetrahydroxyflavone",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "18359761",
  },
  {
    id: "2341",
    id_polifenol: "4135",
    polifenol: "orcinol",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "2",
    pmids: "26826267,21796577",
  },
  {
    id: "2342",
    id_polifenol: "5992",
    polifenol:
      "3-(3-hydroxy-4-methoxyphenyl)-1-(3,4,5-trimethoxyphenyl)prop-2-en-1-one",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "22993307",
  },
  {
    id: "2343",
    id_polifenol: "2332",
    polifenol: "lauryl gallate",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "11931850",
  },
  {
    id: "2344",
    id_polifenol: "4629",
    polifenol: "5,7,2'-trihydroxyflavone",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "16230333",
  },
  {
    id: "2345",
    id_polifenol: "2066",
    polifenol: "NSC 680410",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "16956884",
  },
  {
    id: "2346",
    id_polifenol: "4524",
    polifenol: "5-hydroxy-3',4',6,7-tetramethoxyflavone",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "2",
    pmids: "24148842,22429052",
  },
  {
    id: "2347",
    id_polifenol: "4158",
    polifenol: "malabaricone C",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "27072985",
  },
  {
    id: "2348",
    id_polifenol: "1796",
    polifenol: "(10)-shogaol",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "28872603",
  },
  {
    id: "2349",
    id_polifenol: "903",
    polifenol: "vineatrol",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "20522783",
  },
  {
    id: "2350",
    id_polifenol: "6803",
    polifenol: "isoscutellarein",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "2",
    pmids: "26569200,26610436",
  },
  {
    id: "2351",
    id_polifenol: "7810",
    polifenol: "rotenolone",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "20804165",
  },
  {
    id: "2352",
    id_polifenol: "6236",
    polifenol: "nymphaeol C",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "21790499",
  },
  {
    id: "2353",
    id_polifenol: "5854",
    polifenol: "2'-hydroxy-3,4,3',4',6'-pentamethoxychalcone",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "28428276",
  },
  {
    id: "2354",
    id_polifenol: "5500",
    polifenol: "pelargonidin-3-glucoside",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "2",
    pmids: "23199305,18211028",
  },
  {
    id: "2355",
    id_polifenol: "7726",
    polifenol: "troxerutin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "27016192",
  },
  {
    id: "2356",
    id_polifenol: "4588",
    polifenol: "breviscapine",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "28628830",
  },
  {
    id: "2357",
    id_polifenol: "4576",
    polifenol: "gossypetin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "2",
    pmids: "28671312,16220564",
  },
  {
    id: "2358",
    id_polifenol: "6952",
    polifenol: "isoangustone A",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "2",
    pmids: "23707764,20229524",
  },
  {
    id: "2359",
    id_polifenol: "689",
    polifenol: "3,4-dixydroxyphenylethanol elenolic acid",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "21805082",
  },
  {
    id: "2360",
    id_polifenol: "7352",
    polifenol: "3',4',5'-trimethoxyflavonol",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "3",
    pmids: "28760528,26017621,22789812",
  },
  {
    id: "2361",
    id_polifenol: "2242",
    polifenol: "atraric acid",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "4",
    pmids: "25203674,18627423,21796530,20965230",
  },
  {
    id: "2362",
    id_polifenol: "1649",
    polifenol: "1,5-bis(2-hydroxyphenyl)-1,4-pentadien-3-one",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "2",
    pmids: "28038323,25961334",
  },
  {
    id: "2363",
    id_polifenol: "5008",
    polifenol: "procyanidin B3",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "2",
    pmids: "29654773,20955177",
  },
  {
    id: "2364",
    id_polifenol: "3646",
    polifenol: "1,5-bis(2-methoxyphenyl)penta-1,4-dien-3-one",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "25961334",
  },
  {
    id: "2365",
    id_polifenol: "7641",
    polifenol: "quercetin-3'-O-beta-D-glucopyranoside",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "2",
    pmids: "26805810,24938488",
  },
  {
    id: "2366",
    id_polifenol: "4670",
    polifenol: "7,2',4',5'-tetramethoxyflavone",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "23464460",
  },
  {
    id: "2367",
    id_polifenol: "5557",
    polifenol: "cyanidin 3-galactoside",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "12769521",
  },
  {
    id: "2368",
    id_polifenol: "4986",
    polifenol:
      "5-hydroxy-7-methoxyflavone-(4' -O-8'')-5'',7''-dihydroxy-4'''-methoxyflavone",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "24930002",
  },
  {
    id: "2369",
    id_polifenol: "7803",
    polifenol: "LQB 118",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "2",
    pmids: "29105806,24794748",
  },
  {
    id: "2370",
    id_polifenol: "5551",
    polifenol: "procyanidin B2-3,3'-di-O-gallate",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "4",
    pmids: "17331955,28876465,25552257,24191894",
  },
  {
    id: "2371",
    id_polifenol: "6470",
    polifenol: "O-desmethylangolensin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "2",
    pmids: "16925846,16372328",
  },
  {
    id: "2372",
    id_polifenol: "2744",
    polifenol: "3,5-diisopropylsalicylic acid",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "22313179",
  },
  {
    id: "2373",
    id_polifenol: "7659",
    polifenol: "quercetin 7-rhamnoside",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "25798940",
  },
  {
    id: "2374",
    id_polifenol: "1804",
    polifenol: "guaiacylglycerol-beta-coniferyl ether",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "18656936",
  },
  {
    id: "2375",
    id_polifenol: "7229",
    polifenol: "silychristin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "2",
    pmids: "18435416,16205633",
  },
  {
    id: "2376",
    id_polifenol: "1658",
    polifenol: "3,5-bis(3,4,5-trimethoxybenzylidene)-1-methylpiperidine-4-one",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "29228771",
  },
  {
    id: "2377",
    id_polifenol: "1626",
    polifenol: "diacetylcurcumin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "26369539",
  },
  {
    id: "2378",
    id_polifenol: "6938",
    polifenol: "5,7,3'-trihydroxy-3,4'-dimethoxyflavone",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "29447469",
  },
  {
    id: "2379",
    id_polifenol: "1553",
    polifenol: "dihydrocapsaicin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "19705615",
  },
  {
    id: "2380",
    id_polifenol: "4712",
    polifenol: "morelloflavone",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "19147565",
  },
  {
    id: "2381",
    id_polifenol: "2491",
    polifenol: "punicalin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "19919114",
  },
  {
    id: "2382",
    id_polifenol: "6037",
    polifenol: "6-methoxyflavanone",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "24324518",
  },
  {
    id: "2383",
    id_polifenol: "4248",
    polifenol: "4-(6-hydroxy-2-naphthyl)-1,3-benzenediol",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "2",
    pmids: "21424121,24100602",
  },
  {
    id: "2384",
    id_polifenol: "4149",
    polifenol: "adipostatin A",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "21751842",
  },
  {
    id: "2385",
    id_polifenol: "142",
    polifenol: "1,5-bis(3-hydroxyphenyl)-1,4-pentadiene-3-one",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "2",
    pmids: "24297639,25690296",
  },
  {
    id: "2386",
    id_polifenol: "7817",
    polifenol: "amorphigenin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "17125241",
  },
  {
    id: "2387",
    id_polifenol: "1348",
    polifenol: "urushiol",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "27667098",
  },
  {
    id: "2388",
    id_polifenol: "322",
    polifenol: "N-methyl-4-aminophenol",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "2",
    pmids: "12417027,16203149",
  },
  {
    id: "2389",
    id_polifenol: "1782",
    polifenol: "6-dehydrogingerdione",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "28872603",
  },
  {
    id: "2390",
    id_polifenol: "5949",
    polifenol: "2,2'-dihydroxychalcone",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "16314891",
  },
  {
    id: "2391",
    id_polifenol: "2379",
    polifenol: "ethyl m-digallate",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "17331955",
  },
  {
    id: "2392",
    id_polifenol: "7027",
    polifenol: "chrysosplenol D",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "21469236",
  },
  {
    id: "2393",
    id_polifenol: "165",
    polifenol: "r2-viniferin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "26331691",
  },
  {
    id: "2394",
    id_polifenol: "2255",
    polifenol: "protocatechuic acid methyl ester",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "25539472",
  },
  {
    id: "2395",
    id_polifenol: "7210",
    polifenol: "luteolin-7-O-glucuronide",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "27387399",
  },
  {
    id: "2396",
    id_polifenol: "5006",
    polifenol: "procyanidin B1",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "16474170",
  },
  {
    id: "2397",
    id_polifenol: "7230",
    polifenol: "silydianin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "2",
    pmids: "18435416,16205633",
  },
  {
    id: "2398",
    id_polifenol: "7492",
    polifenol:
      "kaempferol 3-O-(3'',6''-di-O-E-p-coumaroyl)-beta-D-glucopyranoside",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "18211028",
  },
  {
    id: "2399",
    id_polifenol: "705",
    polifenol: "vitisin A",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "26111475",
  },
  {
    id: "2400",
    id_polifenol: "2607",
    polifenol: "amorfrutin A",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "26731300",
  },
  {
    id: "2401",
    id_polifenol: "4748",
    polifenol: "kazinol B",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "23447335",
  },
  {
    id: "2402",
    id_polifenol: "6626",
    polifenol: "cajanol",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "23420757",
  },
  {
    id: "2403",
    id_polifenol: "6789",
    polifenol:
      "5,7-dihydroxy-3-(3-hydroxy-4-methoxybenzyl)-6-methoxychroman-4-one",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "23420757",
  },
  {
    id: "2404",
    id_polifenol: "2550",
    polifenol: "urolithin C",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "3",
    pmids: "19919114,23436427,26307544",
  },
  {
    id: "2405",
    id_polifenol: "747",
    polifenol: "1,7-bis(4-hydroxyphenyl)-1,4,6-heptatrien-3-one",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "26827161",
  },
  {
    id: "2406",
    id_polifenol: "6664",
    polifenol: "8-hydroxydaidzein",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "16372328",
  },
  {
    id: "2407",
    id_polifenol: "4102",
    polifenol: "ardisiphenol D",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "2",
    pmids: "21751842,24392814",
  },
  {
    id: "2408",
    id_polifenol: "1423",
    polifenol: "Cancell",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "25284475",
  },
  {
    id: "2409",
    id_polifenol: "5046",
    polifenol: "4'-methoxyflavone",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "24930002",
  },
  {
    id: "2410",
    id_polifenol: "4203",
    polifenol: "methyl orsellinate",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "21796577",
  },
  {
    id: "2411",
    id_polifenol: "6143",
    polifenol: "5-(O-prenyl)naringenin-4',7-diacetate",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "16678392",
  },
  {
    id: "2412",
    id_polifenol: "5320",
    polifenol: "xanthohumol D",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "23434138",
  },
  {
    id: "2413",
    id_polifenol: "4046",
    polifenol: "3-hydroxyphloretin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "25230777",
  },
  {
    id: "2414",
    id_polifenol: "2420",
    polifenol: "epigallocatechin-3-O-(3''-O-methyl)-gallate",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "22452782",
  },
  {
    id: "2415",
    id_polifenol: "4901",
    polifenol: "myricetin 3-O-(4''-acetyl)rhamnopyranoside",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "16636967",
  },
  {
    id: "2416",
    id_polifenol: "4219",
    polifenol: "baeomycesic acid",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "21796577",
  },
  {
    id: "2417",
    id_polifenol: "1865",
    polifenol: "4-chloro-2-cresol",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "10797495",
  },
  {
    id: "2418",
    id_polifenol: "531",
    polifenol: "dehydrodiconiferyl alcohol",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "18656936",
  },
  {
    id: "2419",
    id_polifenol: "5648",
    polifenol: "4'-O-methylepigallocatechin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "2",
    pmids: "20628004,18641202",
  },
  {
    id: "2420",
    id_polifenol: "901",
    polifenol: "epicatechin dimer B2",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "21205921",
  },
  {
    id: "2421",
    id_polifenol: "1586",
    polifenol: "hydrazinobenzoylcurcumin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "25704883",
  },
  {
    id: "2422",
    id_polifenol: "5611",
    polifenol: "epiafzelechin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "25230777",
  },
  {
    id: "2423",
    id_polifenol: "2553",
    polifenol: "4-hydroxymercuribenzoate",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "9816319",
  },
  {
    id: "2424",
    id_polifenol: "5332",
    polifenol: "MHY336",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "21376033",
  },
  {
    id: "2425",
    id_polifenol: "2307",
    polifenol: "vicanicin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "22063921",
  },
  {
    id: "2426",
    id_polifenol: "2287",
    polifenol: "pannarin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "17075315",
  },
  {
    id: "2427",
    id_polifenol: "4269",
    polifenol: "2-methoxy-4-hydroxy-6-pentadecyl-benzene-1-O-acetate",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "21751842",
  },
  {
    id: "2428",
    id_polifenol: "1648",
    polifenol: "(1E,4E)-1,5-bis(2-methoxyphenyl)penta-1,4-dien-3-one",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "29174816",
  },
  {
    id: "2429",
    id_polifenol: "4196",
    polifenol: "ardisiphenol A",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "24392814",
  },
  {
    id: "2430",
    id_polifenol: "5730",
    polifenol: "2'-hydroxy-4-methylsulfonylchalcone",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "2",
    pmids: "25192452,23877542",
  },
  {
    id: "2431",
    id_polifenol: "3408",
    polifenol: "4-phenoxyphenol",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "24348813",
  },
  {
    id: "2432",
    id_polifenol: "5474",
    polifenol: "myricetin-3-O-galactopyranoside",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "16636967",
  },
  {
    id: "2433",
    id_polifenol: "2392",
    polifenol: "1,6-di-O-galloyl-beta-D-glucose",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "26805810",
  },
  {
    id: "2434",
    id_polifenol: "171",
    polifenol: "p-decylaminophenol",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "17092729",
  },
  {
    id: "2435",
    id_polifenol: "5724",
    polifenol: "3,2'-dihydroxy-4',6'-dimethoxychalcone",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "22495442",
  },
  {
    id: "2436",
    id_polifenol: "3623",
    polifenol: "1,1-dichloro-2-(4-methoxyphenyl)-3-phenylcyclopropane",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "18367102",
  },
  {
    id: "2437",
    id_polifenol: "7342",
    polifenol: "irisdichotin A",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "27476422",
  },
  {
    id: "2438",
    id_polifenol: "2464",
    polifenol: "camelliin B",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "11684320",
  },
  {
    id: "2439",
    id_polifenol: "4252",
    polifenol: "4,6-diacetylresorcinol",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "22115618",
  },
  {
    id: "2440",
    id_polifenol: "3798",
    polifenol: "n-hexyl vanillate",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "28920447",
  },
  {
    id: "2441",
    id_polifenol: "3383",
    polifenol:
      "(2-(2-(4-chlorobenzyloxy)phenoxy)ethyl)-(2-(2,6-dimethoxyphenoxy)ethyl)amine",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "2",
    pmids: "25481381,16302814",
  },
  {
    id: "2442",
    id_polifenol: "6853",
    polifenol: "3'-hydroxydaidzein",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "16372328",
  },
  {
    id: "2443",
    id_polifenol: "5901",
    polifenol: "2,4',6'-trihydroxy-3'-prenylchalcone",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "17726738",
  },
  {
    id: "2444",
    id_polifenol: "5846",
    polifenol: "2',6'-dihydroxy-4'-methoxydihydrochalcone",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "20714300",
  },
  {
    id: "2445",
    id_polifenol: "6683",
    polifenol: "5,7,4'-trihydroxy-3'-(3-hydroxy-3-methylbutyl)isoflavone",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "15938138",
  },
  {
    id: "2446",
    id_polifenol: "5863",
    polifenol: "nicolaioidesin C",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "22120630",
  },
  {
    id: "2447",
    id_polifenol: "886",
    polifenol: "4-(2-hydroxyphenyl)but-3-en-2-one",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "28920346",
  },
  {
    id: "2448",
    id_polifenol: "6314",
    polifenol: "2-(4-(dimethylamino)phenyl)-7,8-dihydroxy-4H-chromen-4-one",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "22768128",
  },
  {
    id: "2449",
    id_polifenol: "6003",
    polifenol: "boesenbergin A",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "22358425",
  },
  {
    id: "2450",
    id_polifenol: "2848",
    polifenol: "3-methoxysalicylic acid",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "2",
    pmids: "22313179,16024637",
  },
  {
    id: "2451",
    id_polifenol: "5523",
    polifenol: "cinnamtannin A2",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "28798415",
  },
  {
    id: "2452",
    id_polifenol: "5140",
    polifenol: "5-hydroxy-6,7-dimethoxyflavone",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "21351299",
  },
  {
    id: "2453",
    id_polifenol: "6957",
    polifenol: "6,6,8-triethyldesmosdumotin B",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "23293751",
  },
  {
    id: "2454",
    id_polifenol: "6229",
    polifenol: "2-hydroxynaringenin 4'-O-beta-D-glucopyranoside",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "24938488",
  },
  {
    id: "2455",
    id_polifenol: "23",
    polifenol: "Bromcresol Green",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "25462156",
  },
  {
    id: "2456",
    id_polifenol: "2095",
    polifenol: "farnesyl-O-acetylhydroquinone",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "14643448",
  },
  {
    id: "2457",
    id_polifenol: "20",
    polifenol: "Cresols",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "21227691",
  },
  {
    id: "2458",
    id_polifenol: "4531",
    polifenol: "skullcapflavone II",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "15897592",
  },
  {
    id: "2459",
    id_polifenol: "4523",
    polifenol: "hypolaetin-8-glucoside",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "2",
    pmids: "26569200,26610436",
  },
  {
    id: "2460",
    id_polifenol: "6429",
    polifenol: "7,4'-di-O-methylisoscutellarein",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "2",
    pmids: "26569200,26610436",
  },
  {
    id: "2461",
    id_polifenol: "7219",
    polifenol: "luteolin 7-O-(6''-O-acetylglucoside)",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "19292464",
  },
  {
    id: "2462",
    id_polifenol: "4775",
    polifenol: "I3,II8-binaringenin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "16163823",
  },
  {
    id: "2463",
    id_polifenol: "583",
    polifenol: "2-fluoro-4-nitrophenol",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "17351127",
  },
  {
    id: "2464",
    id_polifenol: "2891",
    polifenol: "amorfrutin B",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "26731300",
  },
  {
    id: "2465",
    id_polifenol: "6167",
    polifenol: "dichamanetin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "24324069",
  },
  {
    id: "2466",
    id_polifenol: "3636",
    polifenol:
      "2-phenyl-5-(pyrrolidin-1-yl)-1-(3,4,5-trimethoxybenzyl)-1H-benzimidazole",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "20649571",
  },
  {
    id: "2467",
    id_polifenol: "4705",
    polifenol: "eupalitin 3-O-galactopyranoside",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "26493029",
  },
  {
    id: "2468",
    id_polifenol: "278",
    polifenol: "2,4-dichlorophenol",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "16107550",
  },
  {
    id: "2469",
    id_polifenol: "3604",
    polifenol: "labedipinedilol A",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "19056458",
  },
  {
    id: "2470",
    id_polifenol: "408",
    polifenol: "2-bromo-(4-hydroxyphenyl)-1-propene",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "27174797",
  },
  {
    id: "2471",
    id_polifenol: "7676",
    polifenol: "quercetin-6-C-beta-D-glucopyranoside",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "26476001",
  },
  {
    id: "2472",
    id_polifenol: "5104",
    polifenol: "sudachitin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "22438130",
  },
  {
    id: "2473",
    id_polifenol: "2460",
    polifenol: "cornusiin B",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "26805810",
  },
  {
    id: "2474",
    id_polifenol: "2461",
    polifenol: "cornusiin A",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "26805810",
  },
  {
    id: "2475",
    id_polifenol: "1387",
    polifenol: "3-(pentadec-10-enyl)catechol",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "19007765",
  },
  {
    id: "2476",
    id_polifenol: "745",
    polifenol: "2,6-di-tert-butyl-4-(3-hydroxy-2,2-dimethylpropyl)phenol",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "28424220",
  },
  {
    id: "2477",
    id_polifenol: "3160",
    polifenol: "2,2'-oxybis(4-allyl-1-methoxybenzene)",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "28138251",
  },
  {
    id: "2478",
    id_polifenol: "5331",
    polifenol: "kazinol Q",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "23447335",
  },
  {
    id: "2479",
    id_polifenol: "808",
    polifenol: "4-(7-hydroxy-2,2,4-trimethyl-chroman-4-yl)benzene-1,3-diol",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "23447335",
  },
  {
    id: "2480",
    id_polifenol: "2926",
    polifenol:
      "4-(N-(4-cyclohexylbenzyl)-2-(N,2,4,6-tetramethylphenylsulfonamido)acetamido)-2-hydroxybenzoic acid",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "22148584",
  },
  {
    id: "2481",
    id_polifenol: "4623",
    polifenol: "myricetin 3-O-glucuronide",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "19731038",
  },
  {
    id: "2482",
    id_polifenol: "5450",
    polifenol: "linderone A",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "23173924",
  },
  {
    id: "2483",
    id_polifenol: "1473",
    polifenol: "isocordoin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "26213910",
  },
  {
    id: "2484",
    id_polifenol: "5731",
    polifenol: "4'-chloro-2'-hydroxy-4-methylsulfonylchalcone",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "23877542",
  },
  {
    id: "2485",
    id_polifenol: "5892",
    polifenol: "2',3'-dihydroxy-4',6'-dimethoxydihydrochalcone",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "20714300",
  },
  {
    id: "2486",
    id_polifenol: "7241",
    polifenol: "7-O-galloylsilybin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "23555889",
  },
  {
    id: "2487",
    id_polifenol: "2148",
    polifenol: "smenospondiol",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "24865416",
  },
  {
    id: "2488",
    id_polifenol: "7282",
    polifenol: "hovenitin III",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "24938488",
  },
  {
    id: "2489",
    id_polifenol: "5709",
    polifenol: "2'-hydroxy-2,4,4',5,6'-pentamethylchalcone",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "28428276",
  },
  {
    id: "2490",
    id_polifenol: "913",
    polifenol: "mahkoside A",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "23044367",
  },
  {
    id: "2491",
    id_polifenol: "6584",
    polifenol: "dihydrodaidzein",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "16372328",
  },
  {
    id: "2492",
    id_polifenol: "6635",
    polifenol: "6-hydroxydaidzein",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "16372328",
  },
  {
    id: "2493",
    id_polifenol: "3028",
    polifenol:
      "N-acetyl-S-(alpha-methyl-4-(2-methylpropyl)benzeneacetyl)cysteine 4-(nitrooxy)butyl ester",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "15201807",
  },
  {
    id: "2494",
    id_polifenol: "5290",
    polifenol: "(2'R)-4'-hydroxyemoroidocarpan",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "20804165",
  },
  {
    id: "2495",
    id_polifenol: "5292",
    polifenol: "pongavilleanine",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "20804165",
  },
  {
    id: "2496",
    id_polifenol: "5291",
    polifenol: "epipervilline",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "20804165",
  },
  {
    id: "2497",
    id_polifenol: "5702",
    polifenol: "ONO4140",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "24835034",
  },
  {
    id: "2498",
    id_polifenol: "1864",
    polifenol: "clofoctol",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "24903412",
  },
  {
    id: "2499",
    id_polifenol: "6885",
    polifenol: "fenzhimine B",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "26950610",
  },
  {
    id: "2500",
    id_polifenol: "4954",
    polifenol: "chrysoplenetin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "21469236",
  },
  {
    id: "2501",
    id_polifenol: "1591",
    polifenol: "cyclovalone",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "9538139",
  },
  {
    id: "2502",
    id_polifenol: "5638",
    polifenol: "Capsibiol-T",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "15922855",
  },
  {
    id: "2503",
    id_polifenol: "5403",
    polifenol: "sinapyl alcohol 9-O-(E)-p-coumaroyl-4-O-beta-D-glucopyanoside",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "21657076",
  },
  {
    id: "2504",
    id_polifenol: "5459",
    polifenol:
      "5,7-dihydroxy-2-(1,2-isopropyldioxy-4-oxo-cyclohex-5-enyl)-chromen-4-one",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "21657076",
  },
  {
    id: "2505",
    id_polifenol: "6025",
    polifenol:
      "5-hydroxy-2-(1'-hydroxy-4'-oxo-cyclohex-2'-en-1'-yl)-6,7-dimethoxy-2,3-dihydro-4H-chromen-4-one",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "21657076",
  },
  {
    id: "2506",
    id_polifenol: "4354",
    polifenol: "alopecurone A",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "27696895",
  },
  {
    id: "2507",
    id_polifenol: "174",
    polifenol:
      "2,2'-((ethane-1,2-diylbis(azanediyl))bis(ethane-1,1-diyl))diphenol",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "22056177",
  },
  {
    id: "2508",
    id_polifenol: "2094",
    polifenol: "geranyl-O-acetylhydroquinone",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "14643448",
  },
  {
    id: "2509",
    id_polifenol: "7896",
    polifenol: "cyclohexenyl chalcone",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "22120630",
  },
  {
    id: "2510",
    id_polifenol: "6631",
    polifenol: "fujiflavone P40",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "14656947",
  },
  {
    id: "2511",
    id_polifenol: "3913",
    polifenol: "1,3,5-trimethoxybenzene",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "20877240",
  },
  {
    id: "2512",
    id_polifenol: "6705",
    polifenol: "soy isoflavone aglycone",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "14664516",
  },
  {
    id: "2513",
    id_polifenol: "4074",
    polifenol: "pyrogallol 1,3-dimethyl ether",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "25879502",
  },
  {
    id: "2514",
    id_polifenol: "5392",
    polifenol: "amyrisin C",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "22260294",
  },
  {
    id: "2515",
    id_polifenol: "5391",
    polifenol: "amyrisin B",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "22260294",
  },
  {
    id: "2516",
    id_polifenol: "5390",
    polifenol: "amyrisin A",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "22260294",
  },
  {
    id: "2517",
    id_polifenol: "4920",
    polifenol: "isobavachin",
    id_cancer: "527",
    cancer: "Prostate Cancer",
    quant: "1",
    pmids: "28512306",
  },
  {
    id: "2518",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "201",
    pmids:
      "29579978,20561027,21491996,26416794,24398569,28259937,29423046,29883784,25175673,21872580,15881322,23859040,28110189,28955240,22407803,19885574,15909122,12866025,10579870,28849234,25337553,26547532,17197076,22526619,19994890,26958937,24528358,21741427,29698783,10418944,27760539,22449725,27113311,25034000,19139819,24354186,29063088,23210512,23975834,28385566,19719238,16248588,23973682,21074525,16140950,15725655,23773626,29926299,23317880,23137376,15163544,23645467,23337959,15214488,23722601,23201840,24095020,23434138,29303970,25840992,15800915,27920817,27876336,23686257,15586239,29425820,25771121,25554015,25173561,29389889,21954369,14754875,25892545,17176222,27745695,25186940,23173924,28694750,14969337,22768128,23453831,20923189,21298326,18974136,26408343,15173424,7543732,25582488,23159065,22083314,26404080,24168160,15139523,12094622,29373904,28287469,15996021,25931350,20633549,29442390,24099426,27064876,22870126,14614451,22849519,22135890,25223958,10443335,26963142,15221776,21351299,27664007,28825571,23435631,15274140,17227049,26045985,28951762,29403999,21964875,23442980,29552109,29348836,20309799,15452831,22906240,25331269,29244711,20648923,10919656,17381106,29076434,16131149,20429956,24660462,18806956,26646778,9163681,12358448,26344038,9215855,16545824,16540225,28496481,22300907,25359775,21657076,28626743,23504630,28930257,17636936,24824323,16369997,22142698,24930002,14645680,27669205,27279256,26434271,24729227,18351577,27059855,27616072,21875046,25239551,22685350,23842450,21075159,17347140,12002801,12780904,9018079,10654159,25421414,12718627,15203384,20384315,26901186,16365058,10851447,24818141,16314920,23479391,15237940,18375960,8108270,29217339,8134418,28122160,26593537,11975496,28029227,10851454,26234140,29338226,14640528,12762790,20939605,10851476,15051062,28539721",
  },
  {
    id: "2519",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "149",
    pmids:
      "29084689,18339878,22551677,27614381,15489172,22628241,11396178,24274397,21694723,8844727,21475877,15073046,23686430,24496855,27604683,11566484,22841393,19331178,27787644,18794115,27895783,25418925,15271854,20472336,27390600,29673545,12406558,27445823,18423603,15205359,23985704,23194063,16302093,26672603,25640947,24144778,12466962,24078402,23245566,21183341,27889234,17928719,28870897,25431425,20332435,20079215,10557090,28967875,19723094,15893313,15139522,21629182,25458791,28994313,14604899,17922140,16170359,29058812,22997162,19331692,29641445,16340194,12633846,20473900,25839235,9422331,28573788,19838927,25238234,21180609,15340658,17918158,29368356,29273065,17044774,16737669,15843753,24859389,25061290,29311914,26850372,29744415,23357628,18348204,12881017,26833194,24465712,15139523,24570592,26308760,29277765,12130688,29294495,27060762,24581747,27293144,21035530,24936217,15140256,21774804,22178266,24256565,27128654,22830632,26985708,28000198,22204522,23544170,19956394,23460897,21051827,25451013,24438326,16166455,23894315,20232614,17330230,25277658,23305919,26108778,22440624,15841493,25824783,26217691,26515041,20060305,26570985,24098980,23505424,28716495,27241019,24591829,27270752,27107900,26826259,9973206,24725028,27801454,27280934,23125222,20201417,23025432,29525163,29291882,27701049,28415431,27404761,27612787,23987403",
  },
  {
    id: "2520",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "125",
    pmids:
      "24970012,21437031,26303273,20561027,24274397,21391128,16448212,28294332,24478544,23093841,18367875,11481417,22216935,29673545,16797120,27038915,12819184,26310874,23996930,24518414,15936648,27603595,29137335,16524888,9600345,16248588,28870897,16508969,26902888,18262392,9095331,22218562,26118420,28787469,23201840,18852136,28090275,21467134,20682710,25952326,19035659,28870200,15759309,26577496,17192871,23650147,17651061,23752101,18522405,18061431,12902349,29337349,25815689,25188358,19426686,25582488,20694292,21627076,23159065,22083314,17542601,24168160,12094622,18029474,15860507,27538679,17999988,15308587,15790589,23859043,15113149,21035530,25857357,23476753,22178266,28494341,26984176,21058188,29241580,12430003,29920075,24359816,19753610,20648923,10919656,23460897,16131149,28937798,16540225,22300907,28009871,24324066,17330230,25038707,20730438,21736387,26056816,26842614,12880319,27760368,18351577,20836978,27103343,25239551,27957845,29258268,28987377,21075159,12002801,28124843,17442116,17378580,22919439,23319439,14760392,29217339,28531972,19527781,23827601,14640528,17348670,22887153,29391211,19127731,22417564",
  },
  {
    id: "2521",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "44",
    pmids:
      "12761477,27323826,15956247,22410117,17513607,21109980,12406558,12618885,16387404,16077033,11528371,22076613,27347133,19882352,16214385,25338635,12707033,17620438,25431425,19671676,24241351,15930183,14699482,25012123,19331159,15657353,11459290,20806931,18767967,24019108,10220499,11394874,15655524,16571666,18478925,16964382,17940558,24405819,24802235,23464396,10403776,12816758,24211581,12657625",
  },
  {
    id: "2522",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "42",
    pmids:
      "25871428,16329599,26469967,15488634,12767058,29202800,25880142,19994890,25401399,10753641,16379552,24504162,15548175,29849534,24564102,23973682,21639915,25128065,19909554,23686257,24886936,12684659,16789754,22815877,10408396,8574217,15896711,27942504,16254887,21115903,24390805,7875467,11506804,23476753,10367258,20211058,9215855,10762754,18225578,11052627,9018079,15967383",
  },
  {
    id: "2523",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "72",
    pmids:
      "24579782,22310237,27721177,1735617,24535669,21951556,25298669,28521254,23530649,15741050,20681654,19440933,15725655,18852136,27876336,23441618,17027136,26946942,29425820,15759309,29645049,25024815,16789754,20923189,29744415,22083314,21262328,25931350,29442390,18211028,15221776,21716619,26030791,23442980,17555822,22830632,27689975,25331269,29244711,22213289,26328486,12358448,26344038,9215855,20886886,27232543,26807543,25015032,27411085,20162394,22358425,26434271,28987377,26284613,29203747,9018079,17378580,15203384,28649063,20628003,12160900,25212146,8108270,29217339,28122160,24679058,24956844,10851454,28137512,14640528,17348670,20939605",
  },
  {
    id: "2524",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "46",
    pmids:
      "21622140,23741252,26303273,26278714,16797120,12819184,15814656,25123131,22566066,24518414,22101170,9600345,17928719,16508969,28967875,9095331,15139522,23201840,20361925,12925310,25024815,23525843,19726294,17616711,18586691,21866461,19744467,15139523,19578043,15860507,29723847,12642472,26003085,26241688,16157026,23476753,24256565,20682974,26785145,24359816,16620709,24324066,16204466,29203747,23319439,21479417",
  },
  {
    id: "2525",
    id_polifenol: "2167",
    polifenol: "phenolic acid",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "101",
    pmids:
      "26434289,29883784,29715635,22147441,25175673,18952370,22407803,28656311,27288921,15271854,22216935,22951040,28522265,23069328,27760539,16248588,29037704,28071050,29197545,23317880,23722601,21213408,29303970,27876336,17243699,25554015,29645049,29451783,18061431,29337349,25762472,26841168,23453831,18800807,27235722,17147415,20694292,22083314,28480370,28287469,25931350,23746754,27651811,17999988,22849519,18211028,15790589,25855928,15113149,23435631,27099438,25796013,24256565,26030791,19888728,21964875,28494341,23442980,26984176,21284384,27034599,29920075,25331269,29244711,26347954,21674867,22769426,16131149,22628046,26839997,16540225,28496481,23504630,28930257,17636936,25005945,29845279,21048350,27411085,25038707,20162394,21736387,26056816,26434271,23039105,27957845,23842450,22898370,16365058,24818141,23319439,25212146,29142435,28122160,26593537,28029227,16240020,18087817,17348670,20939605,19950996",
  },
  {
    id: "2526",
    id_polifenol: "49",
    polifenol: "Aspirin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "86",
    pmids:
      "12832097,29492489,23013454,18922898,12423325,12538492,20857911,20397022,16105666,16909598,20215502,21180609,22171135,20188076,28162289,26319435,28162291,10738133,18845080,21984018,19821510,26094902,7615821,29744415,23535188,20828891,18174252,16819585,16267095,11078056,22209714,15986848,10607736,18636671,14521608,15528453,9151799,22552812,17899765,15691389,14566053,17241873,15770215,29848978,21805049,8549662,16032431,15163551,9661890,20648923,22916316,27356773,16169935,26314861,10082138,18472019,26685215,11309281,21617874,12774850,19220658,28154202,9413930,21205744,28036129,21743961,20514409,21406194,18544566,27074574,20674154,21544484,16531064,22493349,11093808,10601615,11313997,23025432,8353834,26394025,25503930,17371277,20349206,10660094,19892664,15899787",
  },
  {
    id: "2527",
    id_polifenol: "109",
    polifenol: "Catechin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "58",
    pmids:
      "21622140,23741252,22404116,23225437,26278714,17764926,19994890,15814656,22566066,27671231,9600345,16206041,9095331,15139522,28787469,23201840,20361925,12925310,23441618,21432719,29337349,25861148,17616711,23453831,19370870,24168160,15860507,12642472,15308587,15790589,26467757,27093594,26673759,17227049,26030791,20682974,28108382,26785145,21535793,24359816,28216880,9215855,28930257,17168588,26056816,12880319,16204466,21061473,24520932,26855049,25212146,28122160,15938138,28029227,21479417,25338140,14640528,17348670",
  },
  {
    id: "2528",
    id_polifenol: "125",
    polifenol: "Isoflavones",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "22",
    pmids:
      "26469967,26215320,16379552,29849534,27473965,29197545,21147093,23686257,16789754,22815877,10408396,16254887,21115903,24390805,11506804,10443335,28264435,17662606,15938138,16240020,28110438,19950996",
  },
  {
    id: "2529",
    id_polifenol: "110",
    polifenol: "Chalcones",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "53",
    pmids:
      "28808400,25193463,27727127,22634834,26615871,18767861,26547532,26878127,22987398,25313981,28522265,26859847,10418944,29335212,22386368,26988802,23538439,23533528,22948604,29926299,29207336,29065840,23291120,24095020,21240148,23043766,28774575,27192488,25323033,28694750,23257665,25582488,28346873,24372527,23895019,21041085,26467757,24163734,21984014,17678632,24675137,22668451,28838697,17804245,25128667,22358425,10851447,28344479,20739102,21053158,10851454,17627575,28323527",
  },
  {
    id: "2530",
    id_polifenol: "3089",
    polifenol: "1,1-diphenyl-2-picrylhydrazyl",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "70",
    pmids:
      "21872580,22628260,28946185,27760539,16206041,28803257,23317880,23645467,21782712,18189352,23434138,21213408,27656608,24649909,25466198,25554015,28251112,21954369,20548938,23173924,25861148,23453831,25753739,23357628,22115493,25887035,22083314,15787435,21953995,29442390,29956560,24223502,24389510,19888728,21964875,27034599,25331269,29244711,21674867,26601580,20429956,12358448,28216880,26839997,19099401,28496481,22300907,23504630,17636936,25005945,22316295,24824323,21736387,12880319,21075159,28124843,23768340,22898370,28649063,23344192,24760050,25212146,16719495,28101119,29142435,28137512,14640528,20939605,28539721,22417564",
  },
  {
    id: "2531",
    id_polifenol: "114",
    polifenol: "Apigenin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "26",
    pmids:
      "29883784,23973682,22086925,23773626,29849451,15586239,12842827,25183275,21298326,7543732,22870126,24605779,27664007,21716619,29244711,25965143,27232543,20162394,27616072,28987377,26284613,15203384,28649063,22732304,29217339,22272829",
  },
  {
    id: "2532",
    id_polifenol: "113",
    polifenol: "Flavones",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "33",
    pmids:
      "28110189,15909122,12866025,26547532,28587286,22086925,27116119,15800915,14754875,17418982,16789754,22768128,21298326,7543732,28480370,25931350,18214853,22870126,22135890,10443335,21351299,15274140,15452831,25965143,28800661,10919656,17363487,24631140,24930002,14645680,17347140,27616468,16314920",
  },
  {
    id: "2533",
    id_polifenol: "38",
    polifenol: "Gallic Acid",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "45",
    pmids:
      "24579782,18952370,28521254,23996930,27671231,23975834,17928719,23201840,21213408,27876336,23441618,21954369,29645049,25861148,21627076,22115493,19370870,21953995,25855928,23435631,27099438,23442980,26984176,25794927,29393902,20429956,22628046,16540225,28930257,28009871,12880319,26434271,28124843,26151113,25212146,16719495,29217339,29142435,28122160,28029227,19527781,17348670,20939605,28539721,22417564",
  },
  {
    id: "2534",
    id_polifenol: "117",
    polifenol: "Luteolin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "24",
    pmids:
      "29579978,16901994,28791416,29883784,29434850,28110189,22269172,22449725,24354186,21074525,16140950,24761924,23441618,29645049,28391045,24099426,21351299,26385094,27034599,20162394,26056816,26284613,15203384,28539721",
  },
  {
    id: "2535",
    id_polifenol: "1",
    polifenol: "Phenols",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "29",
    pmids:
      "16504517,20561027,28656311,25469035,27113311,16524888,25658135,28071050,23645467,19420803,28251112,29451783,28384547,24786915,17577669,22115493,27651811,17999988,27643560,22628046,28496481,28844931,24376369,25239551,19615911,29142435,10851475,11354311,16240020",
  },
  {
    id: "2536",
    id_polifenol: "105",
    polifenol: "Anthocyanins",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "47",
    pmids:
      "22404116,19885574,23069328,23996930,15680311,23975834,16248588,29037704,21042741,12925310,16277432,23368921,17243699,20060025,17651061,29337349,25762472,18800807,26927179,27235722,17147415,12094622,18211028,14690795,15113149,21165577,21284384,22769426,17381106,23828497,16131149,25442541,12706854,28009871,17636936,27411085,25038707,21736387,23039105,16139847,10654159,17442116,26901186,16719495,10851454,17348670,10851476",
  },
  {
    id: "2537",
    id_polifenol: "7235",
    polifenol: "silybin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "12",
    pmids:
      "22555452,24528358,24440808,23210512,12943822,22086675,29031537,26404080,23599778,14614451,15993897,25846868",
  },
  {
    id: "2538",
    id_polifenol: "129",
    polifenol: "Rotenone",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "17",
    pmids:
      "25871428,24252341,27280936,26215320,27288921,25401399,25034000,19139819,11825660,12562089,24390805,16323058,19411865,24354192,15561720,23479391,28110438",
  },
  {
    id: "2539",
    id_polifenol: "121",
    polifenol: "Kaempferols",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "26",
    pmids:
      "24579782,25337585,1735617,25337553,27445823,24549175,23441618,17027136,29645049,27745695,20548938,25183275,23159065,18211028,18680719,26030791,22906240,29244711,16540225,20162394,29199082,22272829,24679058,24956844,14640528,15051062",
  },
  {
    id: "2540",
    id_polifenol: "871",
    polifenol: "ABT-737",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "6",
    pmids: "19088028,27780925,27461218,26870201,22179721,29278689",
  },
  {
    id: "2541",
    id_polifenol: "6451",
    polifenol: "daidzein",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "8",
    pmids:
      "21258042,16379552,29849534,15304310,23686257,16254887,24390805,11506804",
  },
  {
    id: "2542",
    id_polifenol: "6065",
    polifenol: "baicalein",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "13",
    pmids:
      "22992837,28259937,28110189,26398706,23337959,17027136,18974136,10443335,15008823,25577335,28448441,17880512,22272829",
  },
  {
    id: "2543",
    id_polifenol: "7",
    polifenol: "Capsaicin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "10",
    pmids:
      "18818525,19846903,15383218,23985252,21764279,24122993,19381455,17404062,27901346,1373965",
  },
  {
    id: "2544",
    id_polifenol: "4634",
    polifenol: "alvocidib",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "11",
    pmids:
      "12124325,10810375,16982769,12566305,28560460,21994185,11641415,14676132,21898150,26411032,11052627",
  },
  {
    id: "2545",
    id_polifenol: "120",
    polifenol: "Flavonols",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "35",
    pmids:
      "28107519,26434289,25337585,23925650,27073499,1735617,25337553,16248588,16317137,22888531,24549175,15027128,14969337,20923189,25582488,17147415,7623025,25887035,21262328,28480370,25931350,10443335,26467757,15113149,22742959,21674867,22769426,16131149,12358448,20886886,27411085,20628003,28101119,24679058,10851454",
  },
  {
    id: "2546",
    id_polifenol: "4522",
    polifenol: "chrysin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "15",
    pmids:
      "22948973,21195158,23973682,22086925,27116119,24019108,26404080,20056425,29294495,25223958,29244711,26347954,23504630,15203384,24956844",
  },
  {
    id: "2547",
    id_polifenol: "123",
    polifenol: "Rutin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "23",
    pmids:
      "26434289,27073499,1735617,15741050,21954369,25714885,23442980,23867787,25442541,20886886,28930257,26434271,28987377,23768340,28649063,16365058,24520932,15237940,8108270,28122160,28029227,20939605,12896910",
  },
  {
    id: "2548",
    id_polifenol: "6062",
    polifenol: "naringenin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "10",
    pmids:
      "19994890,23137376,15163544,25183275,20648923,9215855,16540225,12780904,23177257,15203384",
  },
  {
    id: "2549",
    id_polifenol: "285",
    polifenol: "bisphenol A",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "25119493",
  },
  {
    id: "2550",
    id_polifenol: "39",
    polifenol: "Hydrolyzable Tannins",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "20",
    pmids:
      "25906041,16448212,22387705,21532339,22216935,15936648,16248588,23317880,27656608,19035659,25554015,17192871,17147415,27651811,28825571,19888728,16131149,20429956,28626743,24818141",
  },
  {
    id: "2551",
    id_polifenol: "130",
    polifenol: "Proanthocyanidins",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "18",
    pmids:
      "23093841,22216935,29113217,25123131,19271284,17062697,19035659,15759309,26180579,17176222,29970694,17147415,15113149,28216880,16540225,28930257,28122160,28029227",
  },
  {
    id: "2552",
    id_polifenol: "35",
    polifenol: "Hydroquinones",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "11",
    pmids:
      "16504517,25826398,16756956,14718602,2113030,19420803,18180330,24786915,12139465,17722905,15867391",
  },
  {
    id: "2553",
    id_polifenol: "111",
    polifenol: "Flavanones",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "12",
    pmids:
      "26459308,24324069,10418944,15163544,15214488,24843190,23895019,10443335,21351299,20309799,16545824,23177257",
  },
  {
    id: "2554",
    id_polifenol: "4502",
    polifenol: "fisetin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "9",
    pmids:
      "29574877,19264955,20637980,16317137,25840992,24019108,25582488,10443335,20974518",
  },
  {
    id: "2555",
    id_polifenol: "6",
    polifenol: "Catechols",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "5",
    pmids: "28071050,24168160,27093594,20589861,29792433",
  },
  {
    id: "2556",
    id_polifenol: "25",
    polifenol: "Butylated Hydroxytoluene",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "5",
    pmids: "11090257,23453831,11161587,23442980,24760050",
  },
  {
    id: "2557",
    id_polifenol: "75",
    polifenol: "Butylated Hydroxyanisole",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "4",
    pmids: "26381601,23173924,10498754,12896910",
  },
  {
    id: "2558",
    id_polifenol: "15",
    polifenol: "Masoprocol",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "5",
    pmids: "18927292,20937254,15008823,15936596,17880512",
  },
  {
    id: "2559",
    id_polifenol: "6087",
    polifenol: "wogonin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "6",
    pmids: "22992837,18377871,22086925,23337959,25577335,16218664",
  },
  {
    id: "2560",
    id_polifenol: "4519",
    polifenol: "myricetin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "6",
    pmids: "29579978,29698783,23441618,10443335,12358448,15203384",
  },
  {
    id: "2561",
    id_polifenol: "4515",
    polifenol: "baicalin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "3",
    pmids: "26398706,23337959,23157964",
  },
  {
    id: "2562",
    id_polifenol: "4500",
    polifenol: "procyanidin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "11",
    pmids:
      "21713362,15139522,28787469,26180579,15139523,15790589,25005945,27411085,25212146,17094456,19127731",
  },
  {
    id: "2563",
    id_polifenol: "5608",
    polifenol: "epicatechin gallate",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "11",
    pmids:
      "23859040,17764926,9600345,23201840,12925310,15860507,15308587,25794927,16540225,17168588,25212146",
  },
  {
    id: "2564",
    id_polifenol: "1356",
    polifenol: "gingerol",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "10",
    pmids:
      "22719783,25157570,26046324,19531649,19255554,28065501,23066935,19877681,23322393,18449496",
  },
  {
    id: "2565",
    id_polifenol: "54",
    polifenol: "Salicylic Acid",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "13",
    pmids:
      "18203887,9990295,22313179,26319435,9540818,17241873,15163551,20648923,26314861,26685215,21617874,26763193,24520932",
  },
  {
    id: "2566",
    id_polifenol: "98",
    polifenol: "Propofol",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "6",
    pmids: "25502773,24244442,14679008,29569786,29614493,26669824",
  },
  {
    id: "2567",
    id_polifenol: "5607",
    polifenol: "gallocatechol",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "9",
    pmids:
      "9600345,9095331,23201840,12925310,19370870,15860507,12642472,29244711,12880319",
  },
  {
    id: "2568",
    id_polifenol: "44",
    polifenol: "Salicylates",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "7",
    pmids: "25024815,14634277,14521608,8566837,10082138,21617874,28036129",
  },
  {
    id: "2569",
    id_polifenol: "4559",
    polifenol: "theaflavin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "2",
    pmids: "9600345,17227049",
  },
  {
    id: "2570",
    id_polifenol: "5808",
    polifenol: "isoliquiritigenin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "3",
    pmids: "18767861,19994890,27539609",
  },
  {
    id: "2571",
    id_polifenol: "2344",
    polifenol: "methyl gallate",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "4",
    pmids: "25298669,19035659,25887035,17168588",
  },
  {
    id: "2572",
    id_polifenol: "4708",
    polifenol: "xanthohumol",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "4",
    pmids: "18087812,10418944,23434138,25771121",
  },
  {
    id: "2573",
    id_polifenol: "47",
    polifenol: "Mesalamine",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "18",
    pmids:
      "26896068,18544567,11518677,22435743,18976971,21180609,25024815,19821510,7920212,23843037,20054232,17981262,8566837,18495657,19220658,28036129,22493349,15899787",
  },
  {
    id: "2574",
    id_polifenol: "2284",
    polifenol: "rosmarinic acid",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "9",
    pmids:
      "29427084,25554015,22788364,18936204,21964875,25239551,22236574,28813148,28539721",
  },
  {
    id: "2575",
    id_polifenol: "112",
    polifenol: "Hesperidin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "5",
    pmids: "26459308,25632185,9163681,12718627,10962453",
  },
  {
    id: "2576",
    id_polifenol: "6455",
    polifenol: "nobiletin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "4",
    pmids: "17197076,29063088,15725655,18375960",
  },
  {
    id: "2577",
    id_polifenol: "4513",
    polifenol: "galangin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "4",
    pmids: "29579978,23925650,26347954,23504630",
  },
  {
    id: "2578",
    id_polifenol: "6063",
    polifenol: "naringin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "3",
    pmids: "26030791,23442980,22732304",
  },
  {
    id: "2579",
    id_polifenol: "1380",
    polifenol: "shogaol",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "12",
    pmids:
      "26119958,24786146,22246389,29464796,23382939,28641163,28503853,23638641,23435947,19877681,23322393,18449496",
  },
  {
    id: "2580",
    id_polifenol: "2158",
    polifenol: "protocatechuic acid",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "2",
    pmids: "25038707,28122160",
  },
  {
    id: "2581",
    id_polifenol: "5489",
    polifenol: "delphinidin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "8",
    pmids:
      "15680311,23975834,12925310,26927179,17381106,25442541,28009871,10851454",
  },
  {
    id: "2582",
    id_polifenol: "6273",
    polifenol: "hesperetin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "22142698",
  },
  {
    id: "2583",
    id_polifenol: "1613",
    polifenol: "demethoxycurcumin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "3",
    pmids: "21629182,29368356,22204522",
  },
  {
    id: "2584",
    id_polifenol: "93",
    polifenol: "Phloroglucinol",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "7",
    pmids: "24970012,21268086,26826267,25070748,22342146,24605779,23669242",
  },
  {
    id: "2585",
    id_polifenol: "6454",
    polifenol: "formononetin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "5",
    pmids: "19994890,19139819,22633834,16254887,28987377",
  },
  {
    id: "2586",
    id_polifenol: "81",
    polifenol: "Fenofibrate",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "3",
    pmids: "27193727,17631136,23438367",
  },
  {
    id: "2587",
    id_polifenol: "7550",
    polifenol: "3-methylquercetin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "5",
    pmids: "24398569,25186940,20923189,12358448,26056816",
  },
  {
    id: "2588",
    id_polifenol: "6461",
    polifenol: "acacetin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "2",
    pmids: "15203384,22732304",
  },
  {
    id: "2589",
    id_polifenol: "4253",
    polifenol:
      "5-(2,4-dihydroxy-5-isopropylphenyl)-4-(4-morpholin-4-ylmethylphenyl)isoxazole-3-carboxylic acid ethylamide",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "2",
    pmids: "25210794,19324279",
  },
  {
    id: "2590",
    id_polifenol: "1611",
    polifenol: "bis(4-hydroxycinnamoyl)methane",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "29368356",
  },
  {
    id: "2591",
    id_polifenol: "119",
    polifenol: "Silymarin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "3",
    pmids: "12943822,15993897,27616468",
  },
  {
    id: "2592",
    id_polifenol: "55",
    polifenol: "Sodium Salicylate",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "5",
    pmids: "14634277,14521608,10082138,11704643,15943902",
  },
  {
    id: "2593",
    id_polifenol: "5806",
    polifenol: "butein",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "3",
    pmids: "15214488,17977560,25582488",
  },
  {
    id: "2594",
    id_polifenol: "108",
    polifenol: "Biflavonoids",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "7",
    pmids: "27288921,21915931,24565962,20345100,29395979,29673161,12762790",
  },
  {
    id: "2595",
    id_polifenol: "1558",
    polifenol: "capsazepine",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "15383218",
  },
  {
    id: "2596",
    id_polifenol: "5509",
    polifenol: "cyanidin 3-O-glucoside",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "6",
    pmids: "15680311,29037704,16277432,18211028,16139847,19950996",
  },
  {
    id: "2597",
    id_polifenol: "969",
    polifenol: "3,4-dihydroxyphenacyl caffeate phenylpropanoid ester",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "3",
    pmids: "26546748,29246220,25466198",
  },
  {
    id: "2598",
    id_polifenol: "5844",
    polifenol: "4-dimethylamino-3',4'-dimethoxychalcone",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "4",
    pmids: "17603079,14986030,17585452,12657200",
  },
  {
    id: "2599",
    id_polifenol: "6463",
    polifenol: "puerarin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "4",
    pmids: "27445823,16055262,16254887,23089583",
  },
  {
    id: "2600",
    id_polifenol: "5819",
    polifenol: "licochalcone A",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "2",
    pmids: "24253317,24944769",
  },
  {
    id: "2601",
    id_polifenol: "94",
    polifenol: "Phloretin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "4",
    pmids: "18158826,26633321,16906425,27538679",
  },
  {
    id: "2602",
    id_polifenol: "48",
    polifenol: "Anacardic Acids",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "2",
    pmids: "23128090,22941480",
  },
  {
    id: "2603",
    id_polifenol: "5488",
    polifenol: "cyanidin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "7",
    pmids: "15680311,12925310,26927179,12094622,17381106,12706854,28009871",
  },
  {
    id: "2604",
    id_polifenol: "4640",
    polifenol: "5,7-dihydroxy-6-methoxy-2-phenylchromen-4-one",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "5",
    pmids: "22526619,26958937,22607196,25577335,23823704",
  },
  {
    id: "2605",
    id_polifenol: "4537",
    polifenol: "flavone acetic acid",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "4",
    pmids: "3665989,2394038,3179187,3814485",
  },
  {
    id: "2606",
    id_polifenol: "2773",
    polifenol: "farnesylthiosalicylic acid",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "3",
    pmids: "23370967,11839677,19372139",
  },
  {
    id: "2607",
    id_polifenol: "80",
    polifenol: "Clofibrate",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "27193727",
  },
  {
    id: "2608",
    id_polifenol: "132",
    polifenol: "Equol",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "28628136",
  },
  {
    id: "2609",
    id_polifenol: "1995",
    polifenol: "2-tert-butylhydroquinone",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "11239498",
  },
  {
    id: "2610",
    id_polifenol: "7546",
    polifenol: "isoquercitrin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "9",
    pmids:
      "27876336,15759309,29552109,22906240,20886886,25359775,26284613,28649063,24520932",
  },
  {
    id: "2611",
    id_polifenol: "6482",
    polifenol: "tangeretin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "3",
    pmids: "17197076,23137376,27616468",
  },
  {
    id: "2612",
    id_polifenol: "89",
    polifenol: "Vanillic Acid",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "5",
    pmids: "26546748,25753739,27235722,12898426,24956844",
  },
  {
    id: "2613",
    id_polifenol: "99",
    polifenol: "Pyrogallol",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "23442980",
  },
  {
    id: "2614",
    id_polifenol: "452",
    polifenol: "acteoside",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "3",
    pmids: "29886834,25282590,19099401",
  },
  {
    id: "2615",
    id_polifenol: "1644",
    polifenol: "Cur1 compound",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "2",
    pmids: "29273065,21051827",
  },
  {
    id: "2616",
    id_polifenol: "100",
    polifenol: "Resorcinols",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "2",
    pmids: "24784839,24605779",
  },
  {
    id: "2617",
    id_polifenol: "5614",
    polifenol: "catechin gallate",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "4",
    pmids: "9600345,23201840,12925310,17168588",
  },
  {
    id: "2618",
    id_polifenol: "4486",
    polifenol: "amentoflavone",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "2",
    pmids: "20345100,15787435",
  },
  {
    id: "2619",
    id_polifenol: "5850",
    polifenol: "cardamonin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "3",
    pmids: "29928339,23538439,27192488",
  },
  {
    id: "2620",
    id_polifenol: "118",
    polifenol: "Flavonolignans",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "3",
    pmids: "22555452,23054487,21875046",
  },
  {
    id: "2621",
    id_polifenol: "7541",
    polifenol: "taxifolin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "3",
    pmids: "15163544,17541156,22272829",
  },
  {
    id: "2622",
    id_polifenol: "7544",
    polifenol: "quercitrin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "6",
    pmids: "22888531,14969337,25887035,25794927,22906240,12880319",
  },
  {
    id: "2623",
    id_polifenol: "60",
    polifenol: "2,4-Dinitrophenol",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "2",
    pmids: "17227049,26276275",
  },
  {
    id: "2624",
    id_polifenol: "300",
    polifenol: "rhodioloside",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "29246220",
  },
  {
    id: "2625",
    id_polifenol: "7912",
    polifenol: "7,9,2',4'-tetrahydroxy-8-isopentenyl-5-methoxychalcone",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "26358281",
  },
  {
    id: "2626",
    id_polifenol: "6465",
    polifenol: "genistin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "11506804",
  },
  {
    id: "2627",
    id_polifenol: "4767",
    polifenol: "flavan-3-ol",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "29244711",
  },
  {
    id: "2628",
    id_polifenol: "2475",
    polifenol: "6-O-galloylglucose",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "3",
    pmids: "22387705,12925310,19888728",
  },
  {
    id: "2629",
    id_polifenol: "6097",
    polifenol: "8-prenylnaringenin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "3",
    pmids: "18087812,25771121,20633549",
  },
  {
    id: "2630",
    id_polifenol: "2447",
    polifenol: "beta-penta-O-galloyl-glucose",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "27196315",
  },
  {
    id: "2631",
    id_polifenol: "6068",
    polifenol: "pinocembrin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "8",
    pmids:
      "26459308,28385566,17186548,29244711,26347954,24660462,23504630,21973101",
  },
  {
    id: "2632",
    id_polifenol: "5071",
    polifenol: "icaritin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "2",
    pmids: "26427664,28103582",
  },
  {
    id: "2633",
    id_polifenol: "6086",
    polifenol: "liquiritigenin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "27920817",
  },
  {
    id: "2634",
    id_polifenol: "1616",
    polifenol: "tetrahydrocurcumin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "2",
    pmids: "15073046,24859389",
  },
  {
    id: "2635",
    id_polifenol: "7161",
    polifenol: "scutellarin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "5",
    pmids: "28458133,19661313,29389889,16218664,23399159",
  },
  {
    id: "2636",
    id_polifenol: "2328",
    polifenol: "syringic acid",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "2",
    pmids: "29645049,23442980",
  },
  {
    id: "2637",
    id_polifenol: "7296",
    polifenol: "dihydromyricetin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "12880319",
  },
  {
    id: "2638",
    id_polifenol: "7134",
    polifenol: "vitexin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "6",
    pmids: "29423046,21432719,29348836,28987377,26284613,28539721",
  },
  {
    id: "2639",
    id_polifenol: "6558",
    polifenol: "7,3'-dihydroxy-4'-methoxyisoflavone",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "2",
    pmids: "27393650,26215320",
  },
  {
    id: "2640",
    id_polifenol: "4525",
    polifenol: "eupatilin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "19260477",
  },
  {
    id: "2641",
    id_polifenol: "5455",
    polifenol: "theaflavin-3,3'-digallate",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "29200992",
  },
  {
    id: "2642",
    id_polifenol: "2490",
    polifenol: "punicalagin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "2",
    pmids: "16448212,15936648",
  },
  {
    id: "2643",
    id_polifenol: "5815",
    polifenol: "dibenzoylmethane",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "15073046",
  },
  {
    id: "2644",
    id_polifenol: "5630",
    polifenol: "polyphenon E",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "3",
    pmids: "15814656,17616711,21479417",
  },
  {
    id: "2645",
    id_polifenol: "7547",
    polifenol: "hyperoside",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "5",
    pmids: "27073499,29067453,27876336,15759309,12358448",
  },
  {
    id: "2646",
    id_polifenol: "349",
    polifenol: "4-nitrophenol",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "2",
    pmids: "4053018,22236574",
  },
  {
    id: "2647",
    id_polifenol: "5495",
    polifenol: "malvidin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "5",
    pmids: "15680311,12925310,26927179,17381106,17348670",
  },
  {
    id: "2648",
    id_polifenol: "7141",
    polifenol: "apigetrin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "2",
    pmids: "28649063,18087817",
  },
  {
    id: "2649",
    id_polifenol: "637",
    polifenol: "glabridin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "28522265",
  },
  {
    id: "2650",
    id_polifenol: "6301",
    polifenol: "3-methoxyflavone",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "16077033",
  },
  {
    id: "2651",
    id_polifenol: "77",
    polifenol: "Bezafibrate",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "3",
    pmids: "27193727,12009300,15892897",
  },
  {
    id: "2652",
    id_polifenol: "1810",
    polifenol: "heminordihydroguaiaretic acid",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "2",
    pmids: "15958646,15008823",
  },
  {
    id: "2653",
    id_polifenol: "43",
    polifenol: "Parabens",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "2",
    pmids: "29451980,23317013",
  },
  {
    id: "2654",
    id_polifenol: "6783",
    polifenol: "protoapigenone",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "21657076",
  },
  {
    id: "2655",
    id_polifenol: "6477",
    polifenol: "hispidulin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "3",
    pmids: "10579870,26045985,29200737",
  },
  {
    id: "2656",
    id_polifenol: "7198",
    polifenol: "homoorientin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "2",
    pmids: "26284613,28539721",
  },
  {
    id: "2657",
    id_polifenol: "128",
    polifenol: "Pterocarpans",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "2",
    pmids: "24252341,25034000",
  },
  {
    id: "2658",
    id_polifenol: "7557",
    polifenol: "rhamnetin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "3",
    pmids: "27721177,14969337,21716619",
  },
  {
    id: "2659",
    id_polifenol: "6456",
    polifenol: "daidzin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "2",
    pmids: "16254887,11506804",
  },
  {
    id: "2660",
    id_polifenol: "1353",
    polifenol: "protocatechualdehyde",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "27447597",
  },
  {
    id: "2661",
    id_polifenol: "4501",
    polifenol: "tricin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "2",
    pmids: "19934339,22272829",
  },
  {
    id: "2662",
    id_polifenol: "4883",
    polifenol: "flavokawain B",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "28103302",
  },
  {
    id: "2663",
    id_polifenol: "5496",
    polifenol: "pelargonidin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "6",
    pmids: "15680311,12925310,23441618,18800807,18211028,10851454",
  },
  {
    id: "2664",
    id_polifenol: "4304",
    polifenol: "5-7-oxo-zeaenol",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "22753724",
  },
  {
    id: "2665",
    id_polifenol: "7612",
    polifenol: "quercetin 3-O-glucuronide",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "14640528",
  },
  {
    id: "2666",
    id_polifenol: "687",
    polifenol: "calix(4)arene",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "3",
    pmids: "22997162,29393416,18597414",
  },
  {
    id: "2667",
    id_polifenol: "5796",
    polifenol: "dihydrochalcone",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "3",
    pmids: "26633321,24273860,12762790",
  },
  {
    id: "2668",
    id_polifenol: "6066",
    polifenol: "eriodictyol",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "2",
    pmids: "20648923,26344038",
  },
  {
    id: "2669",
    id_polifenol: "2574",
    polifenol: "4-hydroxybenzoic acid",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "22361689",
  },
  {
    id: "2670",
    id_polifenol: "3019",
    polifenol: "nitroaspirin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "3",
    pmids: "16105666,16169935,11309281",
  },
  {
    id: "2671",
    id_polifenol: "6452",
    polifenol: "chrysoeriol",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "2",
    pmids: "20162394,28987377",
  },
  {
    id: "2672",
    id_polifenol: "4480",
    polifenol: "myricitrin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "2",
    pmids: "25794927,12880319",
  },
  {
    id: "2673",
    id_polifenol: "5794",
    polifenol: "2'-hydroxychalcone",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "28694750",
  },
  {
    id: "2674",
    id_polifenol: "4521",
    polifenol: "3-hydroxyflavone",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "2",
    pmids: "16789754,10919656",
  },
  {
    id: "2675",
    id_polifenol: "3489",
    polifenol: "anethole",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "26514509",
  },
  {
    id: "2676",
    id_polifenol: "115",
    polifenol: "Diosmin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "3",
    pmids: "10443335,9163681,12718627",
  },
  {
    id: "2677",
    id_polifenol: "2014",
    polifenol: "erbstatin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "10367258",
  },
  {
    id: "2678",
    id_polifenol: "2448",
    polifenol: "ellagitannin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "3",
    pmids: "24077694,26634414,27270323",
  },
  {
    id: "2679",
    id_polifenol: "7156",
    polifenol: "scutellarein",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "3",
    pmids: "29457739,29389889,16218664",
  },
  {
    id: "2680",
    id_polifenol: "5831",
    polifenol: "angoletin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "5",
    pmids: "19259708,25882313,25183275,26434878,20232614",
  },
  {
    id: "2681",
    id_polifenol: "4565",
    polifenol: "morusin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "2",
    pmids: "18485277,26234140",
  },
  {
    id: "2682",
    id_polifenol: "885",
    polifenol: "oleocanthal",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "2",
    pmids: "28656311,17999988",
  },
  {
    id: "2683",
    id_polifenol: "6175",
    polifenol: "2'-hydroxyflavanone",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "2",
    pmids: "15163544,24832494",
  },
  {
    id: "2684",
    id_polifenol: "6112",
    polifenol: "alpinetin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "2",
    pmids: "28103302,21240148",
  },
  {
    id: "2685",
    id_polifenol: "6770",
    polifenol: "5-hydroxy-3,6,7,8,3',4'-hexamethoxyflavone",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "21462329",
  },
  {
    id: "2686",
    id_polifenol: "2283",
    polifenol: "depsidone",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "27102610",
  },
  {
    id: "2687",
    id_polifenol: "6457",
    polifenol: "salvigenin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "3",
    pmids: "25193463,29373904,21875046",
  },
  {
    id: "2688",
    id_polifenol: "1747",
    polifenol: "6-paradol",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "23435947",
  },
  {
    id: "2689",
    id_polifenol: "2697",
    polifenol: "4-trifluoromethylsalicylic acid",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "19783927",
  },
  {
    id: "2690",
    id_polifenol: "12",
    polifenol: "Guaiacol",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "24121236",
  },
  {
    id: "2691",
    id_polifenol: "7741",
    polifenol: "biochanin A",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "2",
    pmids: "21147093,21449913",
  },
  {
    id: "2692",
    id_polifenol: "704",
    polifenol: "trizol",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "16038031",
  },
  {
    id: "2693",
    id_polifenol: "4479",
    polifenol: "morin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "25421414",
  },
  {
    id: "2694",
    id_polifenol: "6100",
    polifenol: "pinostrobin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "2",
    pmids: "21240148,26347954",
  },
  {
    id: "2695",
    id_polifenol: "347",
    polifenol: "4-nitrophenyl",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "21801146",
  },
  {
    id: "2696",
    id_polifenol: "5538",
    polifenol: "petunidin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "4",
    pmids: "15680311,26927179,17381106,28009871",
  },
  {
    id: "2697",
    id_polifenol: "5875",
    polifenol: "panduratin A",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "2",
    pmids: "15971119,16497706",
  },
  {
    id: "2698",
    id_polifenol: "4839",
    polifenol: "7-hydroxyflavone",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "28587286",
  },
  {
    id: "2699",
    id_polifenol: "7199",
    polifenol: "luteolin-7-glucoside",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "2",
    pmids: "27876336,25630793",
  },
  {
    id: "2700",
    id_polifenol: "5885",
    polifenol: "2',4'-dihydroxy-6'-methoxy-3',5'-dimethylchalcone",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "25530783",
  },
  {
    id: "2701",
    id_polifenol: "5537",
    polifenol: "peonidin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "5",
    pmids: "12925310,26927179,17381106,28009871,17348670",
  },
  {
    id: "2702",
    id_polifenol: "7140",
    polifenol: "isovitexin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "28987377",
  },
  {
    id: "2703",
    id_polifenol: "7453",
    polifenol: "kaempferol-3-O-glucoside",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "17084606",
  },
  {
    id: "2704",
    id_polifenol: "4573",
    polifenol: "3,3',4',5,6,7,8-heptamethoxyflavone",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "19054677",
  },
  {
    id: "2705",
    id_polifenol: "4639",
    polifenol: "aromadedrin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "2",
    pmids: "23137376,20162394",
  },
  {
    id: "2706",
    id_polifenol: "7658",
    polifenol: "quercetin 3'-O-glucoside",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "29552109",
  },
  {
    id: "2707",
    id_polifenol: "6497",
    polifenol: "isoflavanone",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "24354192",
  },
  {
    id: "2708",
    id_polifenol: "7895",
    polifenol: "flavokawain A",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "2",
    pmids: "28808400,26859847",
  },
  {
    id: "2709",
    id_polifenol: "3494",
    polifenol: "asarone",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "2",
    pmids: "23244151,23357361",
  },
  {
    id: "2710",
    id_polifenol: "4549",
    polifenol: "casticin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "2",
    pmids: "15881322,24354186",
  },
  {
    id: "2711",
    id_polifenol: "4553",
    polifenol: "sulfuretin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "25582488",
  },
  {
    id: "2712",
    id_polifenol: "7880",
    polifenol: "xanthoangelol",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "18767861",
  },
  {
    id: "2713",
    id_polifenol: "5615",
    polifenol: "gallocatechin gallate",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "2",
    pmids: "23201840,12925310",
  },
  {
    id: "2714",
    id_polifenol: "6549",
    polifenol: "7-hydroxy-2',3',4',5',8-pentamethoxyisoflavan",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "28110438",
  },
  {
    id: "2715",
    id_polifenol: "1662",
    polifenol: "BDMC-A",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "27889234",
  },
  {
    id: "2716",
    id_polifenol: "5858",
    polifenol: "isobavachalcone",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "26547532",
  },
  {
    id: "2717",
    id_polifenol: "6008",
    polifenol: "millepachine",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "22784822",
  },
  {
    id: "2718",
    id_polifenol: "4632",
    polifenol: "ginkgetin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "28902363",
  },
  {
    id: "2719",
    id_polifenol: "839",
    polifenol: "5-iodo-3-((3,5-dibromo-4-hydroxyphenyl)methylene)-2-indolinone",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "17465197",
  },
  {
    id: "2720",
    id_polifenol: "2504",
    polifenol: "pentagalloylglucose",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "22216935",
  },
  {
    id: "2721",
    id_polifenol: "6819",
    polifenol: "luteolin-7-O-glucoside",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "27034599",
  },
  {
    id: "2722",
    id_polifenol: "2807",
    polifenol: "thiosalicylic acid",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "11055588",
  },
  {
    id: "2723",
    id_polifenol: "6093",
    polifenol: "pinobanksin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "26347954",
  },
  {
    id: "2724",
    id_polifenol: "5542",
    polifenol: "delphinidin 3-O-glucopyranoside",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "2",
    pmids: "29037704,25442541",
  },
  {
    id: "2725",
    id_polifenol: "7437",
    polifenol: "kaempferol-3-O-rutinoside",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "2",
    pmids: "21262328,28649063",
  },
  {
    id: "2726",
    id_polifenol: "1718",
    polifenol: "dihydroguaiaretic acid",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "24689220",
  },
  {
    id: "2727",
    id_polifenol: "1237",
    polifenol: "2,4-bis(p-hydroxyphenyl)-2-butenal",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "2",
    pmids: "24052407,26474284",
  },
  {
    id: "2728",
    id_polifenol: "2168",
    polifenol: "beta-resorcylic acid",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "24579782",
  },
  {
    id: "2729",
    id_polifenol: "1106",
    polifenol: "1,1-bis(3'-indolyl)-1-(4-hydroxyphenyl)methane",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "28418095",
  },
  {
    id: "2730",
    id_polifenol: "4703",
    polifenol: "eupatorin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "29373904",
  },
  {
    id: "2731",
    id_polifenol: "2173",
    polifenol: "atranorin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "2",
    pmids: "22285236,20837130",
  },
  {
    id: "2732",
    id_polifenol: "6680",
    polifenol: "6,7,4'-trihydroxyisoflavone",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "21258042",
  },
  {
    id: "2733",
    id_polifenol: "1754",
    polifenol: "gigantol",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "28844931",
  },
  {
    id: "2734",
    id_polifenol: "7590",
    polifenol: "quercetin-3-O-rutinoside",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "3",
    pmids: "26434289,21716619,27232543",
  },
  {
    id: "2735",
    id_polifenol: "444",
    polifenol: "2,4-di-tert-butylphenol",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "3",
    pmids: "23517721,24295787,19471192",
  },
  {
    id: "2736",
    id_polifenol: "1509",
    polifenol: "8-gingerol",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "28065501",
  },
  {
    id: "2737",
    id_polifenol: "6459",
    polifenol: "genkwanin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "26388189",
  },
  {
    id: "2738",
    id_polifenol: "57",
    polifenol: "2,6-Dichloroindophenol",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "8205540",
  },
  {
    id: "2739",
    id_polifenol: "58",
    polifenol: "Nitrophenols",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "17875720",
  },
  {
    id: "2740",
    id_polifenol: "1883",
    polifenol: "2-amino-5-methylphenol",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "28114318",
  },
  {
    id: "2741",
    id_polifenol: "7290",
    polifenol: "5,2'-dihydroxy-7,8-dimethoxy-dihydroflavonol-3-O-acetate",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "25582488",
  },
  {
    id: "2742",
    id_polifenol: "4764",
    polifenol: "tectochrysin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "2",
    pmids: "26347954,19639783",
  },
  {
    id: "2743",
    id_polifenol: "4558",
    polifenol: "2'-hydroxyflavone",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "2",
    pmids: "29574877,7543732",
  },
  {
    id: "2744",
    id_polifenol: "7614",
    polifenol: "quercetin 3-O-methyl ether",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "26344038",
  },
  {
    id: "2745",
    id_polifenol: "5814",
    polifenol: "2',4'-dihydroxychalcone",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "24660462",
  },
  {
    id: "2746",
    id_polifenol: "52",
    polifenol: "Diflunisal",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "11764005",
  },
  {
    id: "2747",
    id_polifenol: "5536",
    polifenol: "prodelphinidin B-2 3'-O-gallate",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "2",
    pmids: "29244711,28216880",
  },
  {
    id: "2748",
    id_polifenol: "7169",
    polifenol: "apigenin-6,8-di-C-glycopyranoside",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "29849451",
  },
  {
    id: "2749",
    id_polifenol: "7427",
    polifenol: "kaempferol 3-O-rhamnoside",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "2",
    pmids: "17084606,14969337",
  },
  {
    id: "2750",
    id_polifenol: "5525",
    polifenol: "cyanidin 3-rutinoside",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "24520932",
  },
  {
    id: "2751",
    id_polifenol: "2339",
    polifenol: "3-O-methylgallic acid",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "23319439",
  },
  {
    id: "2752",
    id_polifenol: "1630",
    polifenol: "dimethoxycurcumin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "28573788",
  },
  {
    id: "2753",
    id_polifenol: "4548",
    polifenol: "artemetin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "3",
    pmids: "24354186,8134418,11975496",
  },
  {
    id: "2754",
    id_polifenol: "3040",
    polifenol:
      "4-(3-thioxo-3H-1,2-dithiol-5-yl)phenyl 2-((4-(nitrooxy)butanoyl)oxy)benzoate",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "6",
    pmids: "28162289,26319435,28162291,22366248,22916316,26394025",
  },
  {
    id: "2755",
    id_polifenol: "2159",
    polifenol: "2,3-dihydroxybenzoic acid",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "29792433",
  },
  {
    id: "2756",
    id_polifenol: "7478",
    polifenol: "kaempferol-7-methyl ether",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "14969337",
  },
  {
    id: "2757",
    id_polifenol: "5941",
    polifenol: "3-hydroxy-4,3',4',5'-tetramethoxychalcone",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "28838697",
  },
  {
    id: "2758",
    id_polifenol: "5720",
    polifenol: "4,3',4',5'- tetramethoxychalcone",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "28838697",
  },
  {
    id: "2759",
    id_polifenol: "400",
    polifenol: "cardanol",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "26434878",
  },
  {
    id: "2760",
    id_polifenol: "5827",
    polifenol: "4'-methoxychalcone",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "25193463",
  },
  {
    id: "2761",
    id_polifenol: "5909",
    polifenol: "licochalcone E",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "28522265",
  },
  {
    id: "2762",
    id_polifenol: "6031",
    polifenol: "2',3'-dimethoxyflavanone",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "21351299",
  },
  {
    id: "2763",
    id_polifenol: "4263",
    polifenol: "amurensin G",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "24118446",
  },
  {
    id: "2764",
    id_polifenol: "74",
    polifenol: "Anethole Trithione",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "8339252",
  },
  {
    id: "2765",
    id_polifenol: "3245",
    polifenol: "obovatol",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "18241858",
  },
  {
    id: "2766",
    id_polifenol: "2961",
    polifenol: "acetylsalicylic acid lysinate",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "22115493",
  },
  {
    id: "2767",
    id_polifenol: "7633",
    polifenol: "tamarixetin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "2",
    pmids: "26851174,24956844",
  },
  {
    id: "2768",
    id_polifenol: "7197",
    polifenol: "6-hydroxyluteolin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "18852136",
  },
  {
    id: "2769",
    id_polifenol: "3299",
    polifenol: "pentabromodiphenyl ether",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "25908029",
  },
  {
    id: "2770",
    id_polifenol: "6786",
    polifenol: "8-hydroxy-3,4',5,6,7-pentamethoxyflavone",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "2",
    pmids: "21462329,19054677",
  },
  {
    id: "2771",
    id_polifenol: "18",
    polifenol: "Hexachlorophene",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "27521834",
  },
  {
    id: "2772",
    id_polifenol: "7518",
    polifenol: "quercetin-3-O-alpha-arabinofuranoside",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "12358448",
  },
  {
    id: "2773",
    id_polifenol: "7289",
    polifenol: "isorhamnetin 3-O-glucoside",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "2",
    pmids: "22888531,28649063",
  },
  {
    id: "2774",
    id_polifenol: "2474",
    polifenol: "vescalagin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "19888728",
  },
  {
    id: "2775",
    id_polifenol: "6633",
    polifenol: "pomiferin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "17662606",
  },
  {
    id: "2776",
    id_polifenol: "393",
    polifenol: "2,6-di-tert-butylphenol",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "27162479",
  },
  {
    id: "2777",
    id_polifenol: "5616",
    polifenol: "epigallocatechin-3-(3''-O-methyl)gallate",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "16204466",
  },
  {
    id: "2778",
    id_polifenol: "858",
    polifenol: "2-(3-chloro-4-hydroxyphenyl)-2-(4-hydroxyphenyl)propane",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "24843190",
  },
  {
    id: "2779",
    id_polifenol: "1451",
    polifenol: "hispolon",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "25842364",
  },
  {
    id: "2780",
    id_polifenol: "6940",
    polifenol: "neobavaisoflavone",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "24252341",
  },
  {
    id: "2781",
    id_polifenol: "6508",
    polifenol: "prunetin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "29197545",
  },
  {
    id: "2782",
    id_polifenol: "6478",
    polifenol: "cirsilineol",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "22768128",
  },
  {
    id: "2783",
    id_polifenol: "1725",
    polifenol: "yakuchinone-A",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "19639783",
  },
  {
    id: "2784",
    id_polifenol: "4135",
    polifenol: "orcinol",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "26826267",
  },
  {
    id: "2785",
    id_polifenol: "6291",
    polifenol: "alpinumisoflavone",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "27288921",
  },
  {
    id: "2786",
    id_polifenol: "4103",
    polifenol: "gnetin H",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "12135100",
  },
  {
    id: "2787",
    id_polifenol: "2290",
    polifenol: "lobaric acid",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "22628260",
  },
  {
    id: "2788",
    id_polifenol: "6736",
    polifenol: "3'-demethylnobiletin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "23894027",
  },
  {
    id: "2789",
    id_polifenol: "2517",
    polifenol: "casuarinin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "24697659",
  },
  {
    id: "2790",
    id_polifenol: "4524",
    polifenol: "5-hydroxy-3',4',6,7-tetramethoxyflavone",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "24148842",
  },
  {
    id: "2791",
    id_polifenol: "1796",
    polifenol: "(10)-shogaol",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "2",
    pmids: "24786146,23322393",
  },
  {
    id: "2792",
    id_polifenol: "6803",
    polifenol: "isoscutellarein",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "14640528",
  },
  {
    id: "2793",
    id_polifenol: "4579",
    polifenol: "hinokiflavone",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "29673161",
  },
  {
    id: "2794",
    id_polifenol: "2768",
    polifenol: "salophen",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "4",
    pmids: "19259708,28858483,28923384,20828884",
  },
  {
    id: "2795",
    id_polifenol: "6968",
    polifenol: "5-hydroxy-6,7,8,4'-tetramethoxyflavone",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "2",
    pmids: "21462329,21875046",
  },
  {
    id: "2796",
    id_polifenol: "7810",
    polifenol: "rotenolone",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "2",
    pmids: "23895019,24354192",
  },
  {
    id: "2797",
    id_polifenol: "6883",
    polifenol: "LYG 202",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "21491996",
  },
  {
    id: "2798",
    id_polifenol: "5791",
    polifenol: "metochalcone",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "25057485",
  },
  {
    id: "2799",
    id_polifenol: "5500",
    polifenol: "pelargonidin-3-glucoside",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "18211028",
  },
  {
    id: "2800",
    id_polifenol: "5436",
    polifenol: "herbacetin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "26676750",
  },
  {
    id: "2801",
    id_polifenol: "7823",
    polifenol: "tephrosin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "20056314",
  },
  {
    id: "2802",
    id_polifenol: "2472",
    polifenol: "sanguiin H 6",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "28101119",
  },
  {
    id: "2803",
    id_polifenol: "3362",
    polifenol: "bastadin 4",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "20102170",
  },
  {
    id: "2804",
    id_polifenol: "1204",
    polifenol: "2-isopropyl-5-methylphenol",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "27068261",
  },
  {
    id: "2805",
    id_polifenol: "4576",
    polifenol: "gossypetin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "24956844",
  },
  {
    id: "2806",
    id_polifenol: "6654",
    polifenol: "5,2',4'-trihydroxy-6,7,5'-trimethoxyflavone",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "28110438",
  },
  {
    id: "2807",
    id_polifenol: "689",
    polifenol: "3,4-dixydroxyphenylethanol elenolic acid",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "21805082",
  },
  {
    id: "2808",
    id_polifenol: "7352",
    polifenol: "3',4',5'-trimethoxyflavonol",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "20628003",
  },
  {
    id: "2809",
    id_polifenol: "6847",
    polifenol: "3',4'-didemethylnobiletin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "23894027",
  },
  {
    id: "2810",
    id_polifenol: "5167",
    polifenol: "6-hydroxyflavone",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "28587286",
  },
  {
    id: "2811",
    id_polifenol: "4919",
    polifenol: "bavachinin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "2",
    pmids: "29335212,10443335",
  },
  {
    id: "2812",
    id_polifenol: "6752",
    polifenol: "zapotin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "17516860",
  },
  {
    id: "2813",
    id_polifenol: "5557",
    polifenol: "cyanidin 3-galactoside",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "2",
    pmids: "15680311,12358448",
  },
  {
    id: "2814",
    id_polifenol: "4986",
    polifenol:
      "5-hydroxy-7-methoxyflavone-(4' -O-8'')-5'',7''-dihydroxy-4'''-methoxyflavone",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "24930002",
  },
  {
    id: "2815",
    id_polifenol: "6067",
    polifenol: "carthamidin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "16218664",
  },
  {
    id: "2816",
    id_polifenol: "1647",
    polifenol: "hexahydrocurcumin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "2",
    pmids: "22654430,22224285",
  },
  {
    id: "2817",
    id_polifenol: "2744",
    polifenol: "3,5-diisopropylsalicylic acid",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "22313179",
  },
  {
    id: "2818",
    id_polifenol: "7151",
    polifenol: "vicenin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "22272829",
  },
  {
    id: "2819",
    id_polifenol: "1804",
    polifenol: "guaiacylglycerol-beta-coniferyl ether",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "20162394",
  },
  {
    id: "2820",
    id_polifenol: "4152",
    polifenol: "quracol B",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "17627575",
  },
  {
    id: "2821",
    id_polifenol: "3435",
    polifenol: "N1-hydroxy-N8-(4-phenoxyphenyl)octanediamide",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "26043797",
  },
  {
    id: "2822",
    id_polifenol: "184",
    polifenol: "trilobatin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "26633321",
  },
  {
    id: "2823",
    id_polifenol: "1553",
    polifenol: "dihydrocapsaicin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "18818525",
  },
  {
    id: "2824",
    id_polifenol: "4712",
    polifenol: "morelloflavone",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "2",
    pmids: "20345100,15787435",
  },
  {
    id: "2825",
    id_polifenol: "5226",
    polifenol: "cudraflavone B",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "15051062",
  },
  {
    id: "2826",
    id_polifenol: "4689",
    polifenol: "5,3'-dihydroxy-3,6,7,8,4'-pentamethoxyflavone",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "7623025",
  },
  {
    id: "2827",
    id_polifenol: "3954",
    polifenol: "Aristoforin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "2",
    pmids: "27261575,23099482",
  },
  {
    id: "2828",
    id_polifenol: "5145",
    polifenol: "artonin B",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "20384315",
  },
  {
    id: "2829",
    id_polifenol: "1424",
    polifenol: "rooperol",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "20441051",
  },
  {
    id: "2830",
    id_polifenol: "4149",
    polifenol: "adipostatin A",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "2",
    pmids: "28472978,26434878",
  },
  {
    id: "2831",
    id_polifenol: "142",
    polifenol: "1,5-bis(3-hydroxyphenyl)-1,4-pentadiene-3-one",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "27801454",
  },
  {
    id: "2832",
    id_polifenol: "7817",
    polifenol: "amorphigenin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "27280936",
  },
  {
    id: "2833",
    id_polifenol: "4274",
    polifenol: "O 1602",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "22965195",
  },
  {
    id: "2834",
    id_polifenol: "3628",
    polifenol: "1,1-bis(3'-indolyl)-1-(p-anisyl)methane",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "17234778",
  },
  {
    id: "2835",
    id_polifenol: "1417",
    polifenol: "1,2-dihydroxy-4'-chlorobiphenyl",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "17681423",
  },
  {
    id: "2836",
    id_polifenol: "6830",
    polifenol: "artocarpesin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "2",
    pmids: "26547532,15051062",
  },
  {
    id: "2837",
    id_polifenol: "4597",
    polifenol: "5-hydroxyflavone",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "28587286",
  },
  {
    id: "2838",
    id_polifenol: "5143",
    polifenol: "fustin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "25582488",
  },
  {
    id: "2839",
    id_polifenol: "2379",
    polifenol: "ethyl m-digallate",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "29200992",
  },
  {
    id: "2840",
    id_polifenol: "4224",
    polifenol: "orsellinic acid",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "19795841",
  },
  {
    id: "2841",
    id_polifenol: "361",
    polifenol: "2-aminophenol",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "2",
    pmids: "28325143,17555822",
  },
  {
    id: "2842",
    id_polifenol: "5481",
    polifenol: "cyanidin-3-glycoside",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "17348670",
  },
  {
    id: "2843",
    id_polifenol: "4872",
    polifenol: "biapigenin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "2",
    pmids: "20345100,15787435",
  },
  {
    id: "2844",
    id_polifenol: "2760",
    polifenol: "2-methoxybenzoic acid",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "22361689",
  },
  {
    id: "2845",
    id_polifenol: "7492",
    polifenol:
      "kaempferol 3-O-(3'',6''-di-O-E-p-coumaroyl)-beta-D-glucopyranoside",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "18211028",
  },
  {
    id: "2846",
    id_polifenol: "2607",
    polifenol: "amorfrutin A",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "26731300",
  },
  {
    id: "2847",
    id_polifenol: "2422",
    polifenol: "ginnalin A",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "2",
    pmids: "29693091,22147441",
  },
  {
    id: "2848",
    id_polifenol: "4748",
    polifenol: "kazinol B",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "25394483",
  },
  {
    id: "2849",
    id_polifenol: "1948",
    polifenol: "2,6-di-tert-butyl-4-benzoquinone",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "23517721",
  },
  {
    id: "2850",
    id_polifenol: "2402",
    polifenol: "digalloylresveratrol",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "18952370",
  },
  {
    id: "2851",
    id_polifenol: "5046",
    polifenol: "4'-methoxyflavone",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "24930002",
  },
  {
    id: "2852",
    id_polifenol: "5177",
    polifenol: "glycyrol",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "25445757",
  },
  {
    id: "2853",
    id_polifenol: "4538",
    polifenol: "butrin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "2",
    pmids: "28390310,29403999",
  },
  {
    id: "2854",
    id_polifenol: "5320",
    polifenol: "xanthohumol D",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "2",
    pmids: "18087812,23434138",
  },
  {
    id: "2855",
    id_polifenol: "5933",
    polifenol: "licochalcone B",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "28522265",
  },
  {
    id: "2856",
    id_polifenol: "4046",
    polifenol: "3-hydroxyphloretin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "26633321",
  },
  {
    id: "2857",
    id_polifenol: "2959",
    polifenol: "(1'-ethoxy)ethyl 2-acetoxybenzoate",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "3",
    pmids: "29492489,21984018,20828891",
  },
  {
    id: "2858",
    id_polifenol: "1797",
    polifenol: "(8)-shogaol",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "2",
    pmids: "24786146,23322393",
  },
  {
    id: "2859",
    id_polifenol: "2924",
    polifenol: "2-methoxy-5-amino-N-hydroxybenzamide",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "22435743",
  },
  {
    id: "2860",
    id_polifenol: "292",
    polifenol: "3-dimethylaminophenol",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "21801146",
  },
  {
    id: "2861",
    id_polifenol: "2674",
    polifenol: "copper salicylate complex",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "10693173",
  },
  {
    id: "2862",
    id_polifenol: "5511",
    polifenol: "nasunin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "25442541",
  },
  {
    id: "2863",
    id_polifenol: "5409",
    polifenol: "5-hydroxy-7-methoxyflavone",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "27116119",
  },
  {
    id: "2864",
    id_polifenol: "7382",
    polifenol: "lespenefril",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "22888531",
  },
  {
    id: "2865",
    id_polifenol: "5119",
    polifenol: "isorhamnetin 3-O-rutinoside",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "27876336",
  },
  {
    id: "2866",
    id_polifenol: "7618",
    polifenol: "8-methoxyquercetin-3-O-glucosyl-(1'''-2'')-O-glucoside",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "12358448",
  },
  {
    id: "2867",
    id_polifenol: "7179",
    polifenol: "swertisin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "23453831",
  },
  {
    id: "2868",
    id_polifenol: "1781",
    polifenol: "CA 432",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "22705646",
  },
  {
    id: "2869",
    id_polifenol: "5843",
    polifenol: "rhuschalcone-1",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "2",
    pmids: "26408703,12762790",
  },
  {
    id: "2870",
    id_polifenol: "78",
    polifenol: "Clofenapate",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "12912864",
  },
  {
    id: "2871",
    id_polifenol: "4791",
    polifenol: "myricetin 3-O-(2'',3''-di-O-galloyl)rhamnopyranoside",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "25794927",
  },
  {
    id: "2872",
    id_polifenol: "7635",
    polifenol: "quercetin-3-O-alpha-L-rhamnopyranoside",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "12358448",
  },
  {
    id: "2873",
    id_polifenol: "2987",
    polifenol: "succinyldisalicylic acid",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "21617874",
  },
  {
    id: "2874",
    id_polifenol: "837",
    polifenol: "4-vinyl-2,6-dimethoxyphenol",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "15237940",
  },
  {
    id: "2875",
    id_polifenol: "4072",
    polifenol: "elemicin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "20958014",
  },
  {
    id: "2876",
    id_polifenol: "2307",
    polifenol: "vicanicin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "22628260",
  },
  {
    id: "2877",
    id_polifenol: "6340",
    polifenol: "cudraflavone C",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "28107519",
  },
  {
    id: "2878",
    id_polifenol: "5099",
    polifenol: "(2R,3S)-3',4',5,7-tetrahydroxyflavan-3-yl octadecanoate",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "21622140",
  },
  {
    id: "2879",
    id_polifenol: "5381",
    polifenol: "gancaonin Q",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "28522265",
  },
  {
    id: "2880",
    id_polifenol: "1648",
    polifenol: "(1E,4E)-1,5-bis(2-methoxyphenyl)penta-1,4-dien-3-one",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "20060305",
  },
  {
    id: "2881",
    id_polifenol: "4627",
    polifenol: "aciculatin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "22272829",
  },
  {
    id: "2882",
    id_polifenol: "768",
    polifenol: "eupomatenoid 5",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "21391177",
  },
  {
    id: "2883",
    id_polifenol: "2213",
    polifenol: "diffractaic acid",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "22628260",
  },
  {
    id: "2884",
    id_polifenol: "2716",
    polifenol: "ethyl salicylate",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "24520932",
  },
  {
    id: "2885",
    id_polifenol: "5123",
    polifenol: "flavonoid cycloartobiloxanthone",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "20384315",
  },
  {
    id: "2886",
    id_polifenol: "585",
    polifenol: "protosappanin A",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "26036624",
  },
  {
    id: "2887",
    id_polifenol: "6011",
    polifenol: "1-phenyl-3-(thiophen-2-yl)prop-2-en-1-one",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "22987398",
  },
  {
    id: "2888",
    id_polifenol: "2365",
    polifenol: "hamamelitannin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "22216935",
  },
  {
    id: "2889",
    id_polifenol: "5339",
    polifenol: "2S,3S-3,5,7,3',5'-pentahydroxyflavane",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "25298669",
  },
  {
    id: "2890",
    id_polifenol: "5340",
    polifenol: "2R,3R-3,5,6,7,8,4'-hexahydroxyflavane",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "25298669",
  },
  {
    id: "2891",
    id_polifenol: "4814",
    polifenol: "glabrol",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "28522265",
  },
  {
    id: "2892",
    id_polifenol: "6337",
    polifenol: "3-fluoro-5-hydroxy-7-acetoxyflavone",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "28587286",
  },
  {
    id: "2893",
    id_polifenol: "6992",
    polifenol:
      "2-(cis-1,2-dihydroxy 4-oxo-cyclohex-5-enyl)-5,7-dihydroxychromone",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "21741427",
  },
  {
    id: "2894",
    id_polifenol: "3032",
    polifenol: "phosphoaspirin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "18922898",
  },
  {
    id: "2895",
    id_polifenol: "5399",
    polifenol: "7,7''-dimethoxyagastisflavone",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "21915931",
  },
  {
    id: "2896",
    id_polifenol: "1532",
    polifenol:
      "12-(3-methoxy-4-(methoxymethoxy) phenyl)-10-oxododec-8-enoic acid ethyl ester",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "2",
    pmids: "22246389,23638641",
  },
  {
    id: "2897",
    id_polifenol: "4252",
    polifenol: "4,6-diacetylresorcinol",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "25796013",
  },
  {
    id: "2898",
    id_polifenol: "6737",
    polifenol: "4'-demethylnobiletin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "29063088",
  },
  {
    id: "2899",
    id_polifenol: "6292",
    polifenol: "tricin 4'-O-(threo-beta-guaiacylglyceryl) ether",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "23054487",
  },
  {
    id: "2900",
    id_polifenol: "6293",
    polifenol: "tricin 4'-O-(erythro-beta-guaiacylglyceryl) ether",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "23054487",
  },
  {
    id: "2901",
    id_polifenol: "7877",
    polifenol: "helichrysetin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "23533528",
  },
  {
    id: "2902",
    id_polifenol: "6683",
    polifenol: "5,7,4'-trihydroxy-3'-(3-hydroxy-3-methylbutyl)isoflavone",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "2",
    pmids: "29197545,15938138",
  },
  {
    id: "2903",
    id_polifenol: "4520",
    polifenol: "avicularin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "24956844",
  },
  {
    id: "2904",
    id_polifenol: "3994",
    polifenol: "4-geranyloxy-1-(2-methylbutanoyl)phloroglucinol",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "26358281",
  },
  {
    id: "2905",
    id_polifenol: "7574",
    polifenol: "quercimeritrin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "22906240",
  },
  {
    id: "2906",
    id_polifenol: "7561",
    polifenol: "3,7-dimethoxy-5,3',4'-trihydroxyflavone",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "27405734",
  },
  {
    id: "2907",
    id_polifenol: "941",
    polifenol: "caftaric acid",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "25554015",
  },
  {
    id: "2908",
    id_polifenol: "6314",
    polifenol: "2-(4-(dimethylamino)phenyl)-7,8-dihydroxy-4H-chromen-4-one",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "22768128",
  },
  {
    id: "2909",
    id_polifenol: "7201",
    polifenol: "luteolin 8-C-rhamnoside-7-O-rhamnoside",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "28539721",
  },
  {
    id: "2910",
    id_polifenol: "6003",
    polifenol: "boesenbergin A",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "22358425",
  },
  {
    id: "2911",
    id_polifenol: "5553",
    polifenol: "cyanidin 3-xylosylrutinoside",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "24520932",
  },
  {
    id: "2912",
    id_polifenol: "2848",
    polifenol: "3-methoxysalicylic acid",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "22313179",
  },
  {
    id: "2913",
    id_polifenol: "1669",
    polifenol:
      "5-hydroxy-1-(4-hydroxy-3-methoxyphenyl)-7-(5-methylfuran-2-yl)hepta-1,4,6-trien-3-one",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "27293144",
  },
  {
    id: "2914",
    id_polifenol: "5095",
    polifenol: "benzotropolone",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "28642033",
  },
  {
    id: "2915",
    id_polifenol: "5140",
    polifenol: "5-hydroxy-6,7-dimethoxyflavone",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "21351299",
  },
  {
    id: "2916",
    id_polifenol: "5642",
    polifenol: "4',4''-di-O-methyl-EGCG",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "16204466",
  },
  {
    id: "2917",
    id_polifenol: "7585",
    polifenol: "quercetin 7-O-glucopyranoside",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "28987377",
  },
  {
    id: "2918",
    id_polifenol: "5810",
    polifenol: "isobutrin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "29403999",
  },
  {
    id: "2919",
    id_polifenol: "4992",
    polifenol: "acacetin-7-O-glucoside",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "2",
    pmids: "21716619,22732304",
  },
  {
    id: "2920",
    id_polifenol: "4602",
    polifenol: "sigmoidin B",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "26344038",
  },
  {
    id: "2921",
    id_polifenol: "2743",
    polifenol: "salicylacyl glucuronide",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "11764005",
  },
  {
    id: "2922",
    id_polifenol: "7570",
    polifenol: "spiraeoside",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "29552109",
  },
  {
    id: "2923",
    id_polifenol: "3559",
    polifenol: "hierridin B",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "27589771",
  },
  {
    id: "2924",
    id_polifenol: "5899",
    polifenol: "2',4',6'-tris(methoxymethoxy) chalcone",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "17678632",
  },
  {
    id: "2925",
    id_polifenol: "6256",
    polifenol: "(2S)-3',4',5'-trimethoxyflavanone",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "11975496",
  },
  {
    id: "2926",
    id_polifenol: "7565",
    polifenol: "quercetin 3-sambubioside",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "25442541",
  },
  {
    id: "2927",
    id_polifenol: "5486",
    polifenol: "delphinidin-3-rutinoside",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "25442541",
  },
  {
    id: "2928",
    id_polifenol: "4529",
    polifenol: "ganhuangenin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "16545824",
  },
  {
    id: "2929",
    id_polifenol: "1794",
    polifenol:
      "4-(3-hydroxy-4-methoxyphenyl)-3-(4-hydroxyphenyl)-1-(3,4,5-trimethoxyphenyl)azetidin-2-one",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "2",
    pmids: "22705646,23564200",
  },
  {
    id: "2930",
    id_polifenol: "2241",
    polifenol: "2,4,6-trihydroxybenzoic acid",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "16365058",
  },
  {
    id: "2931",
    id_polifenol: "4769",
    polifenol: "5'-methoxyhydnocarpin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "21875046",
  },
  {
    id: "2932",
    id_polifenol: "5432",
    polifenol: "7-piperazinethylchrysin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "22948973",
  },
  {
    id: "2933",
    id_polifenol: "2891",
    polifenol: "amorfrutin B",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "26731300",
  },
  {
    id: "2934",
    id_polifenol: "6167",
    polifenol: "dichamanetin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "24324069",
  },
  {
    id: "2935",
    id_polifenol: "7684",
    polifenol: "quercetin-5',8-disulfonate",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "22310237",
  },
  {
    id: "2936",
    id_polifenol: "1919",
    polifenol: "MON 0585",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "27068261",
  },
  {
    id: "2937",
    id_polifenol: "408",
    polifenol: "2-bromo-(4-hydroxyphenyl)-1-propene",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "27174797",
  },
  {
    id: "2938",
    id_polifenol: "6331",
    polifenol: "sigmoidin H",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "24252341",
  },
  {
    id: "2939",
    id_polifenol: "7806",
    polifenol: "caeruleanone A",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "27280936",
  },
  {
    id: "2940",
    id_polifenol: "5277",
    polifenol: "dehydroglyasperin D",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "27051646",
  },
  {
    id: "2941",
    id_polifenol: "7899",
    polifenol: "isolespeol",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "18767861",
  },
  {
    id: "2942",
    id_polifenol: "5813",
    polifenol: "3,4,2',4'-tetrahydroxy-2-geranyldihydrochalcone",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "18767861",
  },
  {
    id: "2943",
    id_polifenol: "4411",
    polifenol: "5,3',4'-tridemethylnobiletin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "23894027",
  },
  {
    id: "2944",
    id_polifenol: "4844",
    polifenol: "3',5'-di-C-glucopyranosylphloretin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "26633321",
  },
  {
    id: "2945",
    id_polifenol: "6573",
    polifenol: "glisoflavanone",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "28522265",
  },
  {
    id: "2946",
    id_polifenol: "5297",
    polifenol: "semilicoisoflavone B",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "28522265",
  },
  {
    id: "2947",
    id_polifenol: "6136",
    polifenol: "5,7,3',5'-tetrahydroxyflavanone",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "19994890",
  },
  {
    id: "2948",
    id_polifenol: "5881",
    polifenol: "2',3,4,4'-tetrahydroxy-5-prenylchalcone",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "10418944",
  },
  {
    id: "2949",
    id_polifenol: "6515",
    polifenol: "sigmoidin I",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "25034000",
  },
  {
    id: "2950",
    id_polifenol: "841",
    polifenol: "3-hydroxyphenylpropionic acid",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "28071050",
  },
  {
    id: "2951",
    id_polifenol: "1635",
    polifenol: "FLLL-11 compound",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "19331692",
  },
  {
    id: "2952",
    id_polifenol: "7820",
    polifenol: "deguelin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "12460790",
  },
  {
    id: "2953",
    id_polifenol: "1437",
    polifenol: "4-hydroxy-3-((trimethylammonio)methyl)catechol",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "27192488",
  },
  {
    id: "2954",
    id_polifenol: "5450",
    polifenol: "linderone A",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "23173924",
  },
  {
    id: "2955",
    id_polifenol: "4997",
    polifenol: "kaempferol 3-O-(2''-O-glucosyl)rutinoside",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "23453831",
  },
  {
    id: "2956",
    id_polifenol: "1705",
    polifenol: "hylin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "20696583",
  },
  {
    id: "2957",
    id_polifenol: "4206",
    polifenol: "5-(2'-oxoheptadecyl)resorcinol",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "12562085",
  },
  {
    id: "2958",
    id_polifenol: "4207",
    polifenol: "5-(2'-oxononadecyl)resorcinol",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "12562085",
  },
  {
    id: "2959",
    id_polifenol: "4372",
    polifenol:
      "quercetin 3-O-alpha-rhamnopyranoside-7-O-beta-D-glucopyranosyl-(1-3)-alpha-L-rhamnopyranoside",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "7623025",
  },
  {
    id: "2960",
    id_polifenol: "4798",
    polifenol: "3',5-dihydroxy-3,4'5',7-tetramethoxyflavone",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "22115493",
  },
  {
    id: "2961",
    id_polifenol: "6551",
    polifenol: "8-isopentenylnaringenin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "20633549",
  },
  {
    id: "2962",
    id_polifenol: "5964",
    polifenol:
      "3-(3-oxo-3-(3,5,5,8,8-pentamethyl-5,6,7,8-tetrahydronaphthalen-2-yl)prop-1-enyl)benzonitrile",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "21041085",
  },
  {
    id: "2963",
    id_polifenol: "4674",
    polifenol: "phlobaphene",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "26467757",
  },
  {
    id: "2964",
    id_polifenol: "6802",
    polifenol: "chryseriol",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "21716619",
  },
  {
    id: "2965",
    id_polifenol: "6972",
    polifenol: "aromadendrin 3-O-beta-D-glucopyranoside",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "28108382",
  },
  {
    id: "2966",
    id_polifenol: "736",
    polifenol: "1,2,4,5-tetrahydroxybenzene",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "28108382",
  },
  {
    id: "2967",
    id_polifenol: "6223",
    polifenol:
      "5,4'-dihydroxy-2'-methoxy-6',6''-dimethypyrano-(2'',3'':7,8)-6-methyflavanone",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "20309799",
  },
  {
    id: "2968",
    id_polifenol: "6224",
    polifenol:
      "(2 S)-5,7,4'-trihydroxy-2'-methoxy-8,5'- di(3-methyl-2-butenyl)-6-methyflavanone",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "20309799",
  },
  {
    id: "2969",
    id_polifenol: "2386",
    polifenol: "4-O-galloylbergenin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "25794927",
  },
  {
    id: "2970",
    id_polifenol: "6885",
    polifenol: "fenzhimine B",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "26950610",
  },
  {
    id: "2971",
    id_polifenol: "3487",
    polifenol: "4-nitroanisole",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "4053018",
  },
  {
    id: "2972",
    id_polifenol: "5427",
    polifenol: "patriscabratine",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "22906240",
  },
  {
    id: "2973",
    id_polifenol: "4287",
    polifenol: "3,5-dihydroxybenzyl alcohol",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "23054715",
  },
  {
    id: "2974",
    id_polifenol: "3996",
    polifenol: "uliginosin B",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "23669242",
  },
  {
    id: "2975",
    id_polifenol: "1664",
    polifenol: "(2E,4E)-1-(2-hydroxyphenyl)-5-phenylpenta-2,4-dien-1-one",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "26347954",
  },
  {
    id: "2976",
    id_polifenol: "4609",
    polifenol: "4',7-dihydroxy-3-methoxy-5,6-dimethylflavone",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "28800661",
  },
  {
    id: "2977",
    id_polifenol: "7836",
    polifenol: "erosone",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "24354192",
  },
  {
    id: "2978",
    id_polifenol: "7606",
    polifenol: "quercetin pentaacetate",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "26344038",
  },
  {
    id: "2979",
    id_polifenol: "6185",
    polifenol: "5,7,2',6'-tetrahydroxy-6-lavandulylated-flavanone",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "16545824",
  },
  {
    id: "2980",
    id_polifenol: "6583",
    polifenol: "bolusanthol C",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "16545824",
  },
  {
    id: "2981",
    id_polifenol: "7439",
    polifenol: "kaempferol-3-beta-D-(6-O-trans-p-coumaroyl)glucopyranoside",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "27232543",
  },
  {
    id: "2982",
    id_polifenol: "1702",
    polifenol: "(10)-gingerdiol",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "23066935",
  },
  {
    id: "2983",
    id_polifenol: "5403",
    polifenol: "sinapyl alcohol 9-O-(E)-p-coumaroyl-4-O-beta-D-glucopyanoside",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "21657076",
  },
  {
    id: "2984",
    id_polifenol: "5459",
    polifenol:
      "5,7-dihydroxy-2-(1,2-isopropyldioxy-4-oxo-cyclohex-5-enyl)-chromen-4-one",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "21657076",
  },
  {
    id: "2985",
    id_polifenol: "6025",
    polifenol:
      "5-hydroxy-2-(1'-hydroxy-4'-oxo-cyclohex-2'-en-1'-yl)-6,7-dimethoxy-2,3-dihydro-4H-chromen-4-one",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "21657076",
  },
  {
    id: "2986",
    id_polifenol: "6220",
    polifenol:
      "(-)(2S)-5,6,7,3',5'-pentahydroxyflavanone-7-O-beta-D-glucopyranoside",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "20162394",
  },
  {
    id: "2987",
    id_polifenol: "6232",
    polifenol: "irisdichotin C",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "22142698",
  },
  {
    id: "2988",
    id_polifenol: "3288",
    polifenol: "phenyl allyl ether",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "17168588",
  },
  {
    id: "2989",
    id_polifenol: "6581",
    polifenol: "bolusanthol A",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "27604296",
  },
  {
    id: "2990",
    id_polifenol: "5355",
    polifenol: "diplotrin C",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "21875046",
  },
  {
    id: "2991",
    id_polifenol: "5356",
    polifenol: "diplotasin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "21875046",
  },
  {
    id: "2992",
    id_polifenol: "5110",
    polifenol: "5,4'-dihydroxy-7,8,2',3'-tetramethoxyflavone",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "21875046",
  },
  {
    id: "2993",
    id_polifenol: "2718",
    polifenol: "1,1,1-tris(5-methoxysalicylaldiminomethyl)ethane",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "28923384",
  },
  {
    id: "2994",
    id_polifenol: "4924",
    polifenol: "6-methylapigenin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "25239551",
  },
  {
    id: "2995",
    id_polifenol: "4989",
    polifenol: "6-C-methylluteolin 7-methyl ether",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "28987377",
  },
  {
    id: "2996",
    id_polifenol: "3061",
    polifenol: "orbicularin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "28987377",
  },
  {
    id: "2997",
    id_polifenol: "3036",
    polifenol:
      "O2-(acetylsalicyloxymethyl)-1-(pyrrolidin-1-yl)diazen-1-ium-1,2-diolate",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "20674154",
  },
  {
    id: "2998",
    id_polifenol: "652",
    polifenol: "2-O-methylpyrogallol",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "20958014",
  },
  {
    id: "2999",
    id_polifenol: "4976",
    polifenol: "artobiloxanthone",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "20384315",
  },
  {
    id: "3000",
    id_polifenol: "1118",
    polifenol: "4-hydroxyphenyl tert-butylnitrone",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "19886748",
  },
  {
    id: "3001",
    id_polifenol: "5096",
    polifenol: "luteolin 7-O-glucoside 4''-sulfate",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "22272829",
  },
  {
    id: "3002",
    id_polifenol: "914",
    polifenol: "p-sulfonatocalix(4)arene",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "18597414",
  },
  {
    id: "3003",
    id_polifenol: "4008",
    polifenol: "elliptophenone A",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "21338993",
  },
  {
    id: "3004",
    id_polifenol: "6942",
    polifenol: "mornigrol H",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "26234140",
  },
  {
    id: "3005",
    id_polifenol: "2934",
    polifenol:
      "5-amino-2-hydroxybenzoic acid 4-(5-thioxo-5H-(1,2)dithiol-3yl)phenyl ester",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "26995527",
  },
  {
    id: "3006",
    id_polifenol: "7104",
    polifenol: "7-hydroxyisoflavone",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "16240020",
  },
  {
    id: "3007",
    id_polifenol: "5250",
    polifenol: "hypolaetin 4'-methyl ether 8-O-beta-D-glucuronide 2''-sulfate",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "14640528",
  },
  {
    id: "3008",
    id_polifenol: "5023",
    polifenol: "theograndin II",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "14640528",
  },
  {
    id: "3009",
    id_polifenol: "6511",
    polifenol: "duartin",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "28110438",
  },
  {
    id: "3010",
    id_polifenol: "6516",
    polifenol: "8-methoxyvestitol",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "28110438",
  },
  {
    id: "3011",
    id_polifenol: "7911",
    polifenol: "rhuschalcone VI",
    id_cancer: "494",
    cancer: "Colon Cancer",
    quant: "1",
    pmids: "12762790",
  },
  {
    id: "3012",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "241",
    pmids:
      "24337903,27176768,24223706,20372819,27588401,26309548,28052097,29680738,26297979,25866363,17672346,24507925,23661153,24068521,25256427,21944925,28720813,10963959,26164795,20514473,28245170,25820747,28240161,23026832,25060910,27347080,27509965,20091746,29656183,28655996,23220614,24257119,29049999,19623560,18323654,21730822,21468539,27912880,28025124,26439681,24444546,20674374,28638884,26547532,24940817,19429375,27461104,16458870,23294370,26118776,15744083,19994890,25698902,19481059,25442273,21803068,18038912,29328481,20397728,22532078,27130644,10620351,21093431,15545229,27113311,15104235,29720833,25656992,25034000,23619285,26655407,26675844,28101238,17202857,17996228,21899551,24997323,24036141,28768515,15058208,18546141,21074525,27470413,28366538,16140950,21660680,23172681,25084411,28950682,29906537,22190452,16970933,27078842,23835921,25770930,26628295,14644660,24692698,19473757,29394494,24333668,24380421,21985227,19739098,19110045,28245756,22560876,25681471,29303970,26194866,21067180,22382861,26075245,26557713,18184547,12524154,22749133,25754378,24666416,27602097,23957358,26209062,26311153,27522262,9862414,29348766,29397094,27396915,25476160,19958256,21622138,27261613,24977707,22083996,27483851,19960539,26109775,28774308,17602653,26314304,19207037,24359777,20850954,22909797,15661813,22753749,17961621,28870197,26943884,23901654,15182386,26408343,17056790,28903343,23159065,19101886,17430639,21861846,29849733,23533482,23452983,28264020,17981005,22197970,28213269,22452660,26963142,24910406,25562804,24692702,29137246,17227049,29244256,27066046,14519939,28951762,29403999,29571134,23321314,28920615,29191453,17590382,27782823,29552109,21912610,29407472,28582635,23800391,23519250,25887417,17475387,20804824,23524937,24250510,26817239,16545824,26703544,21657076,18828600,26176582,21812646,24483948,24633846,17520098,27690627,16751978,19252325,19655416,25421414,21080643,28178217,19241580,27981754,26025855,21595573,28886426,29336118,23351147,18672886,21277955,25135771,26922854,27236067,22123201,27570096,28961040,25858705,26498482,25779384,25861749,26234140,24568488,25446044,27085357,28867797,23648796,24937759,15051062,16395655,16206043,21761841",
  },
  {
    id: "3013",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "95",
    pmids:
      "29495104,22292626,8844727,29616245,23821378,16820928,26409325,29901164,19181006,23070725,16880289,20438793,21514382,15367704,21901145,28991167,26458588,26633344,27999817,27234697,23886196,16685395,28494852,24692720,17922140,29899871,28963442,26452516,23216691,19112904,26873414,25728027,20824699,27895800,28721737,29599831,23357628,19956448,29501629,29552121,25622075,28338175,25268357,26707143,27165229,24314310,23225435,23036615,29753013,26051007,28281678,29766185,17261774,25302947,18161303,22222040,25565818,28399452,23808828,16543625,18395899,26987300,22189271,26319630,27528180,27368802,29901131,26247019,24508477,29625162,22440624,26346750,27354595,27626169,25068616,27758710,24313273,23245570,27107900,29703084,18305414,25621942,16151260,29730175,19122744,18720347,22776359,29541866,29969300,24399876,12208119,27150945,12628510,25113874,28648521",
  },
  {
    id: "3014",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "93",
    pmids:
      "25634350,26935808,24377565,18767070,25256427,20828598,28124838,27627922,24478544,23456297,17988825,11408926,19627199,16481065,19269153,29086902,15862030,28768515,23225439,27078842,24380421,26118420,26075245,23957358,28963442,29733262,22083996,28774308,29337349,29204075,28360012,23570787,9054642,24892721,15661813,22506400,28870197,25714249,25607726,17056790,12572356,1786398,23159065,29563789,29552121,23703900,24433880,23835774,23452983,12016986,28545532,29412913,20561930,23767410,23036615,21935971,26208293,27775667,18627786,28194107,23380202,25302947,27782823,12430003,23056433,15182480,15248026,27635343,15450404,15158750,19142982,22438067,28795692,15713052,17462537,27941678,28987377,19655416,19083497,21595573,29336118,25135771,28411462,16036370,21983092,29518033,27386358,27085357,28317281,24937759,29068700,21761841,22417564",
  },
  {
    id: "3015",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "61",
    pmids:
      "23741254,19148542,25683703,28722351,23123629,18989579,27107695,26316083,21621522,23707609,17107963,29656183,24247909,26851630,19773433,16458870,25447816,11533045,11030151,23354417,25002834,12906713,22761917,16925113,20014456,25338635,19000441,15659801,19428345,29695559,11981761,21738655,18822689,20806931,29800569,22314224,17272514,24520095,16533420,11279606,28572744,24168056,17526808,22543708,23630579,26640583,21241664,10912793,21507240,29436591,17483345,20937224,9624172,29620227,12592382,21952585,23942851,15627638,21391228,11050045,25572615",
  },
  {
    id: "3016",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "31",
    pmids:
      "23741254,24243709,24433534,18433075,16458870,14757171,19994890,21689630,29387674,28950682,14644660,11295047,16309237,29286617,12791511,29951358,17391909,12425726,17961621,15182386,11334858,9784250,25479735,18047476,18715236,25781341,26990534,8212077,16117624,24979758,26498482",
  },
  {
    id: "3017",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "88",
    pmids:
      "25820747,25009654,28822757,19623560,18323654,24940817,25896587,27461104,16458870,25298669,28521254,29371942,10620351,28508699,25619802,26675844,28768515,19838948,25947292,26628295,14644660,29394494,29899871,16963249,12524154,27602097,26311153,27522262,27347174,19958256,12508355,28774308,28360012,19207037,28870197,26943884,15182386,17056790,20577783,18074851,12969528,29163752,28264020,19097913,22197970,22452660,20561930,25529711,23767410,27066046,14519939,29747752,16968064,27041924,17475387,11259628,24250510,25454664,20886886,27232543,18828600,15450404,29901131,22438067,15713052,17520098,22358425,17462537,28987377,20651919,22335904,27067032,28649063,28178217,29781726,29336118,16117624,26922854,24699147,2571427,23184534,25098952,26189919,28778140,27085357,24797908,28317281,18276086",
  },
  {
    id: "3018",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "29",
    pmids:
      "12595758,16731755,24402647,29588626,16445947,22221825,16481065,19269153,15161008,26018505,29715531,17404067,26241688,11064004,21661094,24213313,15272226,23056433,26189955,14998086,15450404,15158750,22438067,24508477,29940201,19122744,16117624,18672886,18357659",
  },
  {
    id: "3019",
    id_polifenol: "2167",
    polifenol: "phenolic acid",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "64",
    pmids:
      "28656311,19181006,25447816,28522265,16276977,20397728,28768515,29197545,29906537,27078842,25554642,29303970,26194866,22382861,28179945,23957358,27396915,22083996,26109775,28774308,29337349,25762472,26841168,28870197,27235722,28480370,28338175,17404067,26925328,25562804,20561930,25529711,27066046,23993977,28920615,28194107,23380202,29407472,15272226,17475387,27412352,26817239,26703544,18828600,25005945,29901131,21812646,25576897,22253109,27712097,26075899,28178217,19241580,27981754,6704970,21595573,16036370,29142435,25098952,27085357,28858229,28317281,29710781,24937759",
  },
  {
    id: "3020",
    id_polifenol: "49",
    polifenol: "Aspirin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "24",
    pmids:
      "26899462,11981761,29408091,21617849,23153797,23726914,22322725,22179060,26918349,21722632,14636445,29925918,11401513,16132116,23741443,29286113,14729655,28959630,27441638,22799330,12452016,27236067,28857200,2571427",
  },
  {
    id: "3021",
    id_polifenol: "109",
    polifenol: "Catechin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "32",
    pmids:
      "16458870,19994890,19627199,29588626,28004224,16925113,23954456,28774308,29337349,28870197,1409492,11064004,17227049,27775667,28108382,20862963,28194107,23772110,17475387,26817239,28216880,21081808,15248026,18828600,12769668,17168588,23365670,15713052,18672886,26922854,25338140,28317281",
  },
  {
    id: "3022",
    id_polifenol: "125",
    polifenol: "Isoflavones",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "17",
    pmids:
      "23959101,14757171,15990314,27473965,29197545,28950682,27470322,12791511,17391909,15182386,19634327,29589762,18047476,26586395,18715236,23277536,28110438",
  },
  {
    id: "3023",
    id_polifenol: "110",
    polifenol: "Chalcones",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "53",
    pmids:
      "19875299,29197743,24629450,26854643,24466137,25078311,27594528,29852328,23891701,23471882,28852176,28038941,18767861,26547532,28522265,26874744,25442273,27744186,22386368,27017265,26907262,28011424,25353380,29655687,25743216,28111219,22948604,29335206,25461322,29740713,15806415,25323033,20043079,22902267,25618015,29589472,29135958,15666170,28346873,25499988,24372527,27217001,21816517,24675137,25276196,27777009,28242551,22358425,20739102,21053158,28778140,27085357,28323527",
  },
  {
    id: "3024",
    id_polifenol: "3089",
    polifenol: "1,1-diphenyl-2-picrylhydrazyl",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "73",
    pmids:
      "25213932,12417027,17294687,28458366,22354161,28946185,28508699,29086902,21899551,29771951,27148169,24380421,22382861,23870914,24649909,28179945,15884862,16029005,22083996,26109775,20548938,28360012,27649745,25753739,23892206,28763750,11297806,22074239,23357628,27343853,23703900,17430639,23452983,26925328,27066046,26929583,17590382,23380202,22701284,29407472,27765369,23519250,17475387,26373394,26817239,28216880,21382271,28074101,27793897,25005945,23927480,27399668,19418352,25659675,25969171,29196839,22037567,19655416,20633507,26809376,28649063,27601844,24760050,24699147,29142435,28587249,22885842,29155395,26369119,24157545,29710781,24937759,22417564",
  },
  {
    id: "3025",
    id_polifenol: "114",
    polifenol: "Apigenin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "37",
    pmids:
      "29680738,21756884,23224239,20514473,25820747,18038912,24048283,23537747,21899551,19000441,22086925,14644660,27137679,25554642,25299247,27522262,27203387,28360012,26314304,20850954,25183275,17961621,19830248,29137246,29191453,21912610,23519250,23563091,27232543,28408212,18596662,12643593,28987377,28649063,22732304,28962787,16395655",
  },
  {
    id: "3026",
    id_polifenol: "113",
    polifenol: "Flavones",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "26",
    pmids:
      "24377565,29962947,24257119,20674374,28240165,26547532,26528965,15990314,23537747,22086925,29771951,27400887,15182386,27503682,18074851,28480370,26222195,28839377,28800661,26578185,24631140,25522535,27601844,28411462,23648796,21761841",
  },
  {
    id: "3027",
    id_polifenol: "38",
    polifenol: "Gallic Acid",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "30",
    pmids:
      "28521254,28768515,27148169,15161008,28774308,28870197,25849560,20561930,25529711,23767410,27066046,27782823,21687936,26817239,22519870,21081808,15450404,17520829,12769668,21812646,28987363,22253109,16036370,29142435,25098952,27386358,28858229,27822913,23627273,22417564",
  },
  {
    id: "3028",
    id_polifenol: "117",
    polifenol: "Luteolin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "31",
    pmids:
      "24287949,25820747,29049999,21468539,16458870,17294687,20397728,21074525,16140950,17674423,14644660,24333668,19739098,22749133,27602097,29277460,16029005,24167130,28360012,26314304,27066046,14519939,20175233,26375549,12643593,29066296,19476336,28411462,27570096,29199881,18972039",
  },
  {
    id: "3029",
    id_polifenol: "1",
    polifenol: "Phenols",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "17",
    pmids:
      "28656311,15986412,27113311,15884862,27483851,21843795,23455189,19634327,26929583,27782823,15637092,18715236,28844931,21812646,25451576,29142435,20668399",
  },
  {
    id: "3030",
    id_polifenol: "105",
    polifenol: "Anthocyanins",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "17",
    pmids:
      "24377565,23419638,29086902,16970933,23735880,29337349,25762472,27235722,29800916,29407472,27146128,20967698,19241580,28886426,29518033,17227050,28317281",
  },
  {
    id: "3031",
    id_polifenol: "7235",
    polifenol: "silybin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "11",
    pmids:
      "18599034,29755557,27980577,27402681,18222181,24692702,27685914,17484885,27540518,26058448,29068700",
  },
  {
    id: "3032",
    id_polifenol: "129",
    polifenol: "Rotenone",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "14",
    pmids:
      "25034000,17671207,14695935,18945820,26213921,25448047,29402287,10490244,23180140,22037567,26025855,26498482,25779384,28110438",
  },
  {
    id: "3033",
    id_polifenol: "121",
    polifenol: "Kaempferols",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "21",
    pmids:
      "25820747,23591552,27461104,20397728,28508699,29771951,14644660,27602097,20548938,25183275,17961621,28870197,15182386,23159065,27066046,20707070,25371657,28178217,26922854,26189919,15051062",
  },
  {
    id: "3034",
    id_polifenol: "871",
    polifenol: "ABT-737",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "6",
    pmids: "25297967,20799354,26707143,29543705,27099439,23557083",
  },
  {
    id: "3035",
    id_polifenol: "6451",
    polifenol: "daidzein",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "8",
    pmids:
      "26178389,23959101,14644660,12791511,24487643,18047476,26498482,16401387",
  },
  {
    id: "3036",
    id_polifenol: "6065",
    polifenol: "baicalein",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "20",
    pmids:
      "29970718,24507925,22484589,28351032,27912880,16458870,21803068,23619285,24596136,14644660,26209062,15182386,27503682,19150384,29729190,28448441,11525598,26578185,7954360,29223854",
  },
  {
    id: "3037",
    id_polifenol: "7",
    polifenol: "Capsaicin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "10",
    pmids:
      "29152112,27043357,25255125,15190937,25997958,14695935,29188798,15272226,18991268,29338036",
  },
  {
    id: "3038",
    id_polifenol: "4634",
    polifenol: "alvocidib",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "5",
    pmids: "16820931,15715961,26603262,25986678,24851111",
  },
  {
    id: "3039",
    id_polifenol: "120",
    polifenol: "Flavonols",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "16",
    pmids:
      "26297979,22014228,24161691,24972246,22382861,19958256,15182386,23679992,28480370,23380202,17475387,20886886,7475916,16765054,19655416,28178217",
  },
  {
    id: "3040",
    id_polifenol: "4522",
    polifenol: "chrysin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "17",
    pmids:
      "24007917,27347080,24940817,21899551,27470413,22086925,25770930,14644660,27137679,27461522,23533482,23970349,20862963,23994249,26578185,25912556,24691159",
  },
  {
    id: "3041",
    id_polifenol: "123",
    polifenol: "Rutin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "18",
    pmids:
      "17294687,28004224,29204075,28360012,28870197,23679992,27066046,20578533,20862963,24250510,20886886,28628229,28987377,19655416,28649063,27981754,27085357,18276086",
  },
  {
    id: "3042",
    id_polifenol: "6062",
    polifenol: "naringenin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "20",
    pmids:
      "25866363,23661153,24940817,15744083,19994890,15545229,26675844,11530281,23172681,14644660,26194866,11800169,19960539,19067124,25183275,17961621,18074851,19830248,20862963,16117624",
  },
  {
    id: "3043",
    id_polifenol: "285",
    polifenol: "bisphenol A",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "4",
    pmids: "11530281,11800169,10854714,29128613",
  },
  {
    id: "3044",
    id_polifenol: "39",
    polifenol: "Hydrolyzable Tannins",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "7",
    pmids: "24377565,27483851,21319227,27775667,27782823,25887417,11277742",
  },
  {
    id: "3045",
    id_polifenol: "130",
    polifenol: "Proanthocyanidins",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "10",
    pmids:
      "29086902,16076082,25849560,28216880,21382271,22822675,24568488,16197968,24937759,18975262",
  },
  {
    id: "3046",
    id_polifenol: "35",
    polifenol: "Hydroquinones",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "7",
    pmids: "23088786,22753749,21912610,28398051,23093860,24997295,23648796",
  },
  {
    id: "3047",
    id_polifenol: "111",
    polifenol: "Flavanones",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "9",
    pmids:
      "23891701,23174316,25442273,26194866,18323457,20708932,10854714,17475387,16545824",
  },
  {
    id: "3048",
    id_polifenol: "4502",
    polifenol: "fisetin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "2",
    pmids: "28052097,27522262",
  },
  {
    id: "3049",
    id_polifenol: "6",
    polifenol: "Catechols",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "5",
    pmids: "29412913,22806963,28399452,26314862,29792433",
  },
  {
    id: "3050",
    id_polifenol: "25",
    polifenol: "Butylated Hydroxytoluene",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "11",
    pmids:
      "28768515,27148169,24263571,7586169,27829607,9851254,6873013,3554467,6704970,24760050,19657451",
  },
  {
    id: "3051",
    id_polifenol: "75",
    polifenol: "Butylated Hydroxyanisole",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "3",
    pmids: "19728331,16739127,23247010",
  },
  {
    id: "3052",
    id_polifenol: "15",
    polifenol: "Masoprocol",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "4",
    pmids: "19915704,27657032,10692565,10490244",
  },
  {
    id: "3053",
    id_polifenol: "6087",
    polifenol: "wogonin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "8",
    pmids:
      "23294370,22086925,17674423,23835921,24666416,26578185,23859016,28117202",
  },
  {
    id: "3054",
    id_polifenol: "4519",
    polifenol: "myricetin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "10",
    pmids:
      "20617691,23438827,27461104,28508699,14644660,23767410,29244256,27066046,21935971,28178217",
  },
  {
    id: "3055",
    id_polifenol: "4515",
    polifenol: "baicalin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "7",
    pmids: "26309548,22200845,21803068,25694047,24961104,26578185,7954360",
  },
  {
    id: "3056",
    id_polifenol: "4500",
    polifenol: "procyanidin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "8",
    pmids:
      "22312287,23380202,21081808,25005945,16828532,19418352,22227333,24568488",
  },
  {
    id: "3057",
    id_polifenol: "5608",
    polifenol: "epicatechin gallate",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "3",
    pmids: "19627199,17168588,28411462",
  },
  {
    id: "3058",
    id_polifenol: "1356",
    polifenol: "gingerol",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "6",
    pmids: "26101700,20521273,27399668,23964455,29393873,25658238",
  },
  {
    id: "3059",
    id_polifenol: "54",
    polifenol: "Salicylic Acid",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "5",
    pmids: "27824091,11278312,27163172,14729655,15271512",
  },
  {
    id: "3060",
    id_polifenol: "98",
    polifenol: "Propofol",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "3",
    pmids: "28565871,23742776,26666272",
  },
  {
    id: "3061",
    id_polifenol: "5607",
    polifenol: "gallocatechol",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "2",
    pmids: "17404067,27775667",
  },
  {
    id: "3062",
    id_polifenol: "5578",
    polifenol: "alpha-naphthoflavone",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "8",
    pmids:
      "1329656,22749133,12628515,9784250,12791542,12396873,16412531,3178871",
  },
  {
    id: "3063",
    id_polifenol: "4559",
    polifenol: "theaflavin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "2",
    pmids: "17227049,15248026",
  },
  {
    id: "3064",
    id_polifenol: "5808",
    polifenol: "isoliquiritigenin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "6",
    pmids: "18767861,19994890,26101703,16562858,29098824,23086355",
  },
  {
    id: "3065",
    id_polifenol: "2344",
    polifenol: "methyl gallate",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "6",
    pmids: "25298669,28004224,16481065,12769668,17168588,28778140",
  },
  {
    id: "3066",
    id_polifenol: "4708",
    polifenol: "xanthohumol",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "4",
    pmids: "26718026,20043079,17981005,17590382",
  },
  {
    id: "3067",
    id_polifenol: "2284",
    polifenol: "rosmarinic acid",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "6",
    pmids: "20397728,29864622,27422165,26075899,29710781,25455894",
  },
  {
    id: "3068",
    id_polifenol: "112",
    polifenol: "Hesperidin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "6",
    pmids: "20138977,19110045,26194866,24977707,26492105,29100031",
  },
  {
    id: "3069",
    id_polifenol: "6455",
    polifenol: "nobiletin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "3",
    pmids: "23537747,23818450,23321314",
  },
  {
    id: "3070",
    id_polifenol: "10",
    polifenol: "Estrogens, Catechol",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "2",
    pmids: "12119004,12791542",
  },
  {
    id: "3071",
    id_polifenol: "4513",
    polifenol: "galangin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "6",
    pmids: "25698902,24161691,14644660,28938520,29468851,26189919",
  },
  {
    id: "3072",
    id_polifenol: "6063",
    polifenol: "naringin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "4",
    pmids: "27509965,15744083,26194866,22732304",
  },
  {
    id: "3073",
    id_polifenol: "1380",
    polifenol: "shogaol",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "6",
    pmids: "22768104,29464796,26101062,20521273,27399668,29393873",
  },
  {
    id: "3074",
    id_polifenol: "2158",
    polifenol: "protocatechuic acid",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "6",
    pmids: "19601677,8504418,28987363,25061291,15165144,28317281",
  },
  {
    id: "3075",
    id_polifenol: "5489",
    polifenol: "delphinidin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "23419638",
  },
  {
    id: "3076",
    id_polifenol: "6273",
    polifenol: "hesperetin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "19830248",
  },
  {
    id: "3077",
    id_polifenol: "1613",
    polifenol: "demethoxycurcumin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "3",
    pmids: "20438793,26987300,25113874",
  },
  {
    id: "3078",
    id_polifenol: "93",
    polifenol: "Phloroglucinol",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "10",
    pmids:
      "27221859,24041234,23454824,25476160,22312287,27412352,28831795,22253109,27586698,28117734",
  },
  {
    id: "3079",
    id_polifenol: "6454",
    polifenol: "formononetin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "4",
    pmids: "19994890,19634327,28987377,29098824",
  },
  {
    id: "3080",
    id_polifenol: "81",
    polifenol: "Fenofibrate",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "5",
    pmids: "27757837,27193727,12498734,26155222,8524345",
  },
  {
    id: "3081",
    id_polifenol: "7550",
    polifenol: "3-methylquercetin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "8",
    pmids:
      "27461104,24972246,27522262,14519939,16765054,23724057,28178217,29468851",
  },
  {
    id: "3082",
    id_polifenol: "6461",
    polifenol: "acacetin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "6",
    pmids: "22196122,15104235,20804824,29066296,22732304,29098824",
  },
  {
    id: "3083",
    id_polifenol: "1611",
    polifenol: "bis(4-hydroxycinnamoyl)methane",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "4",
    pmids: "20438793,25537301,26987300,28177570",
  },
  {
    id: "3084",
    id_polifenol: "107",
    polifenol: "beta-Naphthoflavone",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "3",
    pmids: "21912610,1340765,22687991",
  },
  {
    id: "3085",
    id_polifenol: "119",
    polifenol: "Silymarin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "4",
    pmids: "19317806,9862414,19150384,26011349",
  },
  {
    id: "3086",
    id_polifenol: "5806",
    polifenol: "butein",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "4",
    pmids: "21770460,19643530,29777095,29670376",
  },
  {
    id: "3087",
    id_polifenol: "108",
    polifenol: "Biflavonoids",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "4",
    pmids: "21915931,25866543,23944039,26252201",
  },
  {
    id: "3088",
    id_polifenol: "5509",
    polifenol: "cyanidin 3-O-glucoside",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "4",
    pmids: "16970933,23735880,29800916,29407472",
  },
  {
    id: "3089",
    id_polifenol: "969",
    polifenol: "3,4-dihydroxyphenacyl caffeate phenylpropanoid ester",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "4",
    pmids: "28744911,27396915,23892206,22253109",
  },
  {
    id: "3090",
    id_polifenol: "5844",
    polifenol: "4-dimethylamino-3',4'-dimethoxychalcone",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "9862856",
  },
  {
    id: "3091",
    id_polifenol: "6463",
    polifenol: "puerarin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "2",
    pmids: "25364405,23277536",
  },
  {
    id: "3092",
    id_polifenol: "5819",
    polifenol: "licochalcone A",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "3",
    pmids: "24337903,24466137,27017265",
  },
  {
    id: "3093",
    id_polifenol: "94",
    polifenol: "Phloretin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "5",
    pmids: "25229655,18767070,19123483,26633321,14644660",
  },
  {
    id: "3094",
    id_polifenol: "4560",
    polifenol: "icariin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "2",
    pmids: "14756686,19938223",
  },
  {
    id: "3095",
    id_polifenol: "48",
    polifenol: "Anacardic Acids",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "4",
    pmids: "23128090,22941480,24853302,20655754",
  },
  {
    id: "3096",
    id_polifenol: "5488",
    polifenol: "cyanidin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "3",
    pmids: "23419638,29086902,28317281",
  },
  {
    id: "3097",
    id_polifenol: "4640",
    polifenol: "5,7-dihydroxy-6-methoxy-2-phenylchromen-4-one",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "11",
    pmids:
      "19626645,19100732,23612020,22196122,24637576,19473757,22560876,19585117,29571134,26259145,26578185",
  },
  {
    id: "3098",
    id_polifenol: "2773",
    polifenol: "farnesylthiosalicylic acid",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "5",
    pmids: "24848877,21621522,25043275,24300920,24435839",
  },
  {
    id: "3099",
    id_polifenol: "80",
    polifenol: "Clofibrate",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "11",
    pmids:
      "22619672,10200566,27193727,9013627,9674879,8625460,6873013,23811191,7745951,22008536,2860980",
  },
  {
    id: "3100",
    id_polifenol: "132",
    polifenol: "Equol",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "2",
    pmids: "24487643,29589762",
  },
  {
    id: "3101",
    id_polifenol: "1995",
    polifenol: "2-tert-butylhydroquinone",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "3",
    pmids: "23707609,22275372,26091733",
  },
  {
    id: "3102",
    id_polifenol: "1673",
    polifenol: "4-hydroxyestradiol",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "12791542",
  },
  {
    id: "3103",
    id_polifenol: "7546",
    polifenol: "isoquercitrin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "7",
    pmids: "18074851,21295105,29552109,20886886,21445586,29066296,28649063",
  },
  {
    id: "3104",
    id_polifenol: "6482",
    polifenol: "tangeretin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "23537747",
  },
  {
    id: "3105",
    id_polifenol: "89",
    polifenol: "Vanillic Acid",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "8",
    pmids:
      "25667964,28870197,25753739,27235722,29066296,23126191,27712097,27981754",
  },
  {
    id: "3106",
    id_polifenol: "99",
    polifenol: "Pyrogallol",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "27110278",
  },
  {
    id: "3107",
    id_polifenol: "452",
    polifenol: "acteoside",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "28744911",
  },
  {
    id: "3108",
    id_polifenol: "1644",
    polifenol: "Cur1 compound",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "3",
    pmids: "26458588,25622075,24399876",
  },
  {
    id: "3109",
    id_polifenol: "100",
    polifenol: "Resorcinols",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "28870197",
  },
  {
    id: "3110",
    id_polifenol: "5614",
    polifenol: "catechin gallate",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "4",
    pmids: "19627199,17404067,12769668,17168588",
  },
  {
    id: "3111",
    id_polifenol: "4486",
    polifenol: "amentoflavone",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "3",
    pmids: "27187341,29695559,29599330",
  },
  {
    id: "3112",
    id_polifenol: "5850",
    polifenol: "cardamonin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "2",
    pmids: "25442273,20862963",
  },
  {
    id: "3113",
    id_polifenol: "118",
    polifenol: "Flavonolignans",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "3",
    pmids: "27980577,25667964,27402681",
  },
  {
    id: "3114",
    id_polifenol: "7541",
    polifenol: "taxifolin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "3",
    pmids: "16458870,22253109,26922854",
  },
  {
    id: "3115",
    id_polifenol: "7544",
    polifenol: "quercitrin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "3",
    pmids: "27602097,28258038,28178217",
  },
  {
    id: "3116",
    id_polifenol: "60",
    polifenol: "2,4-Dinitrophenol",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "2",
    pmids: "17227049,27400479",
  },
  {
    id: "3117",
    id_polifenol: "7912",
    polifenol: "7,9,2',4'-tetrahydroxy-8-isopentenyl-5-methoxychalcone",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "4",
    pmids: "24641665,29589472,29468891,26025855",
  },
  {
    id: "3118",
    id_polifenol: "350",
    polifenol: "nonylphenol",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "3",
    pmids: "11530281,11800169,10854714",
  },
  {
    id: "3119",
    id_polifenol: "4767",
    polifenol: "flavan-3-ol",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "4",
    pmids: "21985227,22312287,23772110,23343084",
  },
  {
    id: "3120",
    id_polifenol: "2475",
    polifenol: "6-O-galloylglucose",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "27980577",
  },
  {
    id: "3121",
    id_polifenol: "92",
    polifenol: "Triclosan",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "26970259",
  },
  {
    id: "3122",
    id_polifenol: "2447",
    polifenol: "beta-penta-O-galloyl-glucose",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "2",
    pmids: "24389959,21319227",
  },
  {
    id: "3123",
    id_polifenol: "6068",
    polifenol: "pinocembrin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "2",
    pmids: "21899551,27509964",
  },
  {
    id: "3124",
    id_polifenol: "1996",
    polifenol: "2,5-di-tert-butylhydroquinone",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "2",
    pmids: "23707609,26091733",
  },
  {
    id: "3125",
    id_polifenol: "5071",
    polifenol: "icaritin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "2",
    pmids: "20560114,24145579",
  },
  {
    id: "3126",
    id_polifenol: "6576",
    polifenol: "5,7,4'-trihydroxyflavone",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "25698902",
  },
  {
    id: "3127",
    id_polifenol: "4585",
    polifenol: "baohuoside I",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "26118776",
  },
  {
    id: "3128",
    id_polifenol: "6086",
    polifenol: "liquiritigenin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "2",
    pmids: "24738081,29098824",
  },
  {
    id: "3129",
    id_polifenol: "1616",
    polifenol: "tetrahydrocurcumin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "18395899",
  },
  {
    id: "3130",
    id_polifenol: "4516",
    polifenol: "diosmetin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "10",
    pmids:
      "27176768,28240165,17294687,28101238,28245756,28101201,22749133,27522262,18596662,29066296",
  },
  {
    id: "3131",
    id_polifenol: "102",
    polifenol: "Zearalenone",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "11205083",
  },
  {
    id: "3132",
    id_polifenol: "7161",
    polifenol: "scutellarin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "4",
    pmids: "29962947,28458133,21899551,23192830",
  },
  {
    id: "3133",
    id_polifenol: "2328",
    polifenol: "syringic acid",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "6",
    pmids: "28870197,25529711,20707194,27775667,15165144,25098952",
  },
  {
    id: "3134",
    id_polifenol: "7296",
    polifenol: "dihydromyricetin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "7",
    pmids: "24223706,28240161,24444546,24002546,28974890,25391369,25110435",
  },
  {
    id: "3135",
    id_polifenol: "40",
    polifenol: "Propyl Gallate",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "2571427",
  },
  {
    id: "3136",
    id_polifenol: "36",
    polifenol: "Hydroxybenzoates",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "2",
    pmids: "25576897,16036370",
  },
  {
    id: "3137",
    id_polifenol: "7134",
    polifenol: "vitexin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "4",
    pmids: "27588401,17202857,28987377,27601844",
  },
  {
    id: "3138",
    id_polifenol: "6558",
    polifenol: "7,3'-dihydroxy-4'-methoxyisoflavone",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "2",
    pmids: "24455688,29098824",
  },
  {
    id: "3139",
    id_polifenol: "4525",
    polifenol: "eupatilin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "2",
    pmids: "29576713,27015669",
  },
  {
    id: "3140",
    id_polifenol: "5455",
    polifenol: "theaflavin-3,3'-digallate",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "15248026",
  },
  {
    id: "3141",
    id_polifenol: "2490",
    polifenol: "punicalagin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "2",
    pmids: "24393106,27386358",
  },
  {
    id: "3142",
    id_polifenol: "349",
    polifenol: "4-nitrophenol",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "28648600",
  },
  {
    id: "3143",
    id_polifenol: "5495",
    polifenol: "malvidin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "23419638",
  },
  {
    id: "3144",
    id_polifenol: "7141",
    polifenol: "apigetrin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "6",
    pmids: "21899551,18596662,28649063,27981754,24699147,16206043",
  },
  {
    id: "3145",
    id_polifenol: "637",
    polifenol: "glabridin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "5",
    pmids: "24806207,28522265,27002406,24641665,26586395",
  },
  {
    id: "3146",
    id_polifenol: "6301",
    polifenol: "3-methoxyflavone",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "17526808",
  },
  {
    id: "3147",
    id_polifenol: "77",
    polifenol: "Bezafibrate",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "27193727",
  },
  {
    id: "3148",
    id_polifenol: "1810",
    polifenol: "heminordihydroguaiaretic acid",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "27657032",
  },
  {
    id: "3149",
    id_polifenol: "19",
    polifenol: "Pentachlorophenol",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "5",
    pmids: "19463090,20429289,2860981,2881629,6577945",
  },
  {
    id: "3150",
    id_polifenol: "6783",
    polifenol: "protoapigenone",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "7",
    pmids: "26974964,22753749,21912610,21657076,17622129,23648796,16206043",
  },
  {
    id: "3151",
    id_polifenol: "6477",
    polifenol: "hispidulin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "3",
    pmids: "24068521,17674423,26209062",
  },
  {
    id: "3152",
    id_polifenol: "7198",
    polifenol: "homoorientin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "8",
    pmids:
      "24841907,23026832,23220614,27130644,24374571,27261613,21080643,27601844",
  },
  {
    id: "3153",
    id_polifenol: "128",
    polifenol: "Pterocarpans",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "25034000",
  },
  {
    id: "3154",
    id_polifenol: "7557",
    polifenol: "rhamnetin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "3",
    pmids: "28508699,27091611,26922854",
  },
  {
    id: "3155",
    id_polifenol: "1353",
    polifenol: "protocatechualdehyde",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "3",
    pmids: "25447816,11297806,15165144",
  },
  {
    id: "3156",
    id_polifenol: "4501",
    polifenol: "tricin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "2",
    pmids: "25667964,29066296",
  },
  {
    id: "3157",
    id_polifenol: "5496",
    polifenol: "pelargonidin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "3",
    pmids: "23419638,23735880,27146128",
  },
  {
    id: "3158",
    id_polifenol: "7853",
    polifenol: "Grape Seed Proanthocyanidins",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "16197968",
  },
  {
    id: "3159",
    id_polifenol: "7612",
    polifenol: "quercetin 3-O-glucuronide",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "2",
    pmids: "17294687,26922854",
  },
  {
    id: "3160",
    id_polifenol: "7775",
    polifenol: "glyceollin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "23573869",
  },
  {
    id: "3161",
    id_polifenol: "5796",
    polifenol: "dihydrochalcone",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "26633321",
  },
  {
    id: "3162",
    id_polifenol: "6066",
    polifenol: "eriodictyol",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "18074851",
  },
  {
    id: "3163",
    id_polifenol: "353",
    polifenol: "sesamol",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "11297806",
  },
  {
    id: "3164",
    id_polifenol: "2574",
    polifenol: "4-hydroxybenzoic acid",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "27981754",
  },
  {
    id: "3165",
    id_polifenol: "6452",
    polifenol: "chrysoeriol",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "28987377",
  },
  {
    id: "3166",
    id_polifenol: "680",
    polifenol: "xanthorrhizol",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "2",
    pmids: "17465228,22465013",
  },
  {
    id: "3167",
    id_polifenol: "713",
    polifenol:
      "3-(3-chloro-4-hydroxyphenylamino)-4-(4-nitrophenyl)-1H-pyrrole-2,5-dione",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "4",
    pmids: "15475000,15942663,20705954,23337568",
  },
  {
    id: "3168",
    id_polifenol: "5794",
    polifenol: "2'-hydroxychalcone",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "23174316",
  },
  {
    id: "3169",
    id_polifenol: "7377",
    polifenol: "astragalin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "3",
    pmids: "28654261,25348942,26922854",
  },
  {
    id: "3170",
    id_polifenol: "4521",
    polifenol: "3-hydroxyflavone",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "2",
    pmids: "15990314,25522535",
  },
  {
    id: "3171",
    id_polifenol: "3489",
    polifenol: "anethole",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "2",
    pmids: "26514509,27981754",
  },
  {
    id: "3172",
    id_polifenol: "97",
    polifenol: "Probucol",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "2",
    pmids: "2318380,9242962",
  },
  {
    id: "3173",
    id_polifenol: "115",
    polifenol: "Diosmin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "2",
    pmids: "14644660,23665045",
  },
  {
    id: "3174",
    id_polifenol: "6554",
    polifenol: "tectorigenin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "22553399",
  },
  {
    id: "3175",
    id_polifenol: "2448",
    polifenol: "ellagitannin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "19142982",
  },
  {
    id: "3176",
    id_polifenol: "299",
    polifenol: "nitrophenylphosphate",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "22553985",
  },
  {
    id: "3177",
    id_polifenol: "5831",
    polifenol: "angoletin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "5",
    pmids: "25773833,29397094,25183275,26434878,15703376",
  },
  {
    id: "3178",
    id_polifenol: "4565",
    polifenol: "morusin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "3",
    pmids: "28670112,25476160,26234140",
  },
  {
    id: "3179",
    id_polifenol: "885",
    polifenol: "oleocanthal",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "28656311",
  },
  {
    id: "3180",
    id_polifenol: "6175",
    polifenol: "2'-hydroxyflavanone",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "26629250",
  },
  {
    id: "3181",
    id_polifenol: "6112",
    polifenol: "alpinetin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "2",
    pmids: "25442273,20862963",
  },
  {
    id: "3182",
    id_polifenol: "896",
    polifenol: "polyphenon B",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "20828598",
  },
  {
    id: "3183",
    id_polifenol: "2283",
    polifenol: "depsidone",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "2",
    pmids: "22307935,27102610",
  },
  {
    id: "3184",
    id_polifenol: "711",
    polifenol: "ascochlorin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "2",
    pmids: "22433868,27765853",
  },
  {
    id: "3185",
    id_polifenol: "6457",
    polifenol: "salvigenin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "20804824",
  },
  {
    id: "3186",
    id_polifenol: "1747",
    polifenol: "6-paradol",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "2",
    pmids: "29393873,25658238",
  },
  {
    id: "3187",
    id_polifenol: "12",
    polifenol: "Guaiacol",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "24121236",
  },
  {
    id: "3188",
    id_polifenol: "7741",
    polifenol: "biochanin A",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "27470322",
  },
  {
    id: "3189",
    id_polifenol: "2790",
    polifenol: "ginkgolic acid",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "27934110",
  },
  {
    id: "3190",
    id_polifenol: "2454",
    polifenol: "corilagin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "26935808",
  },
  {
    id: "3191",
    id_polifenol: "357",
    polifenol: "4-aminophenol",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "3",
    pmids: "12417027,16203149,1643640",
  },
  {
    id: "3192",
    id_polifenol: "704",
    polifenol: "trizol",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "4",
    pmids: "26910068,29670840,17309779,18991936",
  },
  {
    id: "3193",
    id_polifenol: "84",
    polifenol: "Halogenated Diphenyl Ethers",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "17509781",
  },
  {
    id: "3194",
    id_polifenol: "4479",
    polifenol: "morin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "3",
    pmids: "26297979,28213269,25421414",
  },
  {
    id: "3195",
    id_polifenol: "2364",
    polifenol: "theaflavine gallate",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "15248026",
  },
  {
    id: "3196",
    id_polifenol: "4052",
    polifenol: "bis-(3-(3',5'-di-tert-butyl-4'-hydroxyphenyl)propyl)sulfide",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "2",
    pmids: "23452983,25276196",
  },
  {
    id: "3197",
    id_polifenol: "4578",
    polifenol: "5,7-dimethoxyflavone",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "15661813",
  },
  {
    id: "3198",
    id_polifenol: "9",
    polifenol: "1,2-Dihydroxybenzene-3,5-Disulfonic Acid Disodium Salt",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "19728331",
  },
  {
    id: "3199",
    id_polifenol: "6100",
    polifenol: "pinostrobin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "2",
    pmids: "25442273,20862963",
  },
  {
    id: "3200",
    id_polifenol: "6774",
    polifenol: "5,7-dihydroxy-6,3',4'-trimethoxyflavone",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "27015669",
  },
  {
    id: "3201",
    id_polifenol: "5538",
    polifenol: "petunidin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "23419638",
  },
  {
    id: "3202",
    id_polifenol: "7199",
    polifenol: "luteolin-7-glucoside",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "4",
    pmids: "17294687,21899551,16029005,21595573",
  },
  {
    id: "3203",
    id_polifenol: "1689",
    polifenol: "16-hydroxyestrone",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "19250210",
  },
  {
    id: "3204",
    id_polifenol: "5885",
    polifenol: "2',4'-dihydroxy-6'-methoxy-3',5'-dimethylchalcone",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "6",
    pmids: "25260543,23891701,15806415,15666170,15703376,15458771",
  },
  {
    id: "3205",
    id_polifenol: "5537",
    polifenol: "peonidin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "23419638",
  },
  {
    id: "3206",
    id_polifenol: "7140",
    polifenol: "isovitexin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "28987377",
  },
  {
    id: "3207",
    id_polifenol: "7453",
    polifenol: "kaempferol-3-O-glucoside",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "20707070",
  },
  {
    id: "3208",
    id_polifenol: "4573",
    polifenol: "3,3',4',5,6,7,8-heptamethoxyflavone",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "20862963",
  },
  {
    id: "3209",
    id_polifenol: "4981",
    polifenol: "jaceosidin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "27602097",
  },
  {
    id: "3210",
    id_polifenol: "4639",
    polifenol: "aromadedrin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "22253109",
  },
  {
    id: "3211",
    id_polifenol: "7658",
    polifenol: "quercetin 3'-O-glucoside",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "4",
    pmids: "24692698,25681471,26428271,29552109",
  },
  {
    id: "3212",
    id_polifenol: "4782",
    polifenol: "kurarinone",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "18184547",
  },
  {
    id: "3213",
    id_polifenol: "6497",
    polifenol: "isoflavanone",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "22037567",
  },
  {
    id: "3214",
    id_polifenol: "6453",
    polifenol: "cirsimaritin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "20804824",
  },
  {
    id: "3215",
    id_polifenol: "7880",
    polifenol: "xanthoangelol",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "18767861",
  },
  {
    id: "3216",
    id_polifenol: "70",
    polifenol: "Sulfobromophthalein",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "8738419",
  },
  {
    id: "3217",
    id_polifenol: "5615",
    polifenol: "gallocatechin gallate",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "2",
    pmids: "19627199,28987363",
  },
  {
    id: "3218",
    id_polifenol: "6549",
    polifenol: "7-hydroxy-2',3',4',5',8-pentamethoxyisoflavan",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "28110438",
  },
  {
    id: "3219",
    id_polifenol: "5858",
    polifenol: "isobavachalcone",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "26547532",
  },
  {
    id: "3220",
    id_polifenol: "5539",
    polifenol: "peonidin 3-glucoside",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "2",
    pmids: "16970933,29800916",
  },
  {
    id: "3221",
    id_polifenol: "6008",
    polifenol: "millepachine",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "2",
    pmids: "23471882,22784822",
  },
  {
    id: "3222",
    id_polifenol: "5245",
    polifenol: "BF6-6 biflavone",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "28839377",
  },
  {
    id: "3223",
    id_polifenol: "839",
    polifenol: "5-iodo-3-((3,5-dibromo-4-hydroxyphenyl)methylene)-2-indolinone",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "27670374",
  },
  {
    id: "3224",
    id_polifenol: "2504",
    polifenol: "pentagalloylglucose",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "21081808",
  },
  {
    id: "3225",
    id_polifenol: "792",
    polifenol: "octylphenol",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "10854714",
  },
  {
    id: "3226",
    id_polifenol: "2",
    polifenol: "Aminophenols",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "3",
    pmids: "12417027,17092729,16203149",
  },
  {
    id: "3227",
    id_polifenol: "6819",
    polifenol: "luteolin-7-O-glucoside",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "2",
    pmids: "24257119,27981754",
  },
  {
    id: "3228",
    id_polifenol: "4607",
    polifenol: "orientin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "27396915",
  },
  {
    id: "3229",
    id_polifenol: "7239",
    polifenol: "isosilybin A",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "17484885",
  },
  {
    id: "3230",
    id_polifenol: "6287",
    polifenol: "neohesperidin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "26194866",
  },
  {
    id: "3231",
    id_polifenol: "5542",
    polifenol: "delphinidin 3-O-glucopyranoside",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "29407472",
  },
  {
    id: "3232",
    id_polifenol: "4544",
    polifenol: "tiliroside",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "2",
    pmids: "26655407,17475387",
  },
  {
    id: "3233",
    id_polifenol: "7437",
    polifenol: "kaempferol-3-O-rutinoside",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "2",
    pmids: "23679992,28649063",
  },
  {
    id: "3234",
    id_polifenol: "5289",
    polifenol: "8-bromo-7-methoxychrysin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "4",
    pmids: "28369327,26935885,27461522,23970349",
  },
  {
    id: "3235",
    id_polifenol: "7422",
    polifenol: "kaempferide",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "29468851",
  },
  {
    id: "3236",
    id_polifenol: "3667",
    polifenol: "ciprofibrate",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "2",
    pmids: "9013627,2191770",
  },
  {
    id: "3237",
    id_polifenol: "4312",
    polifenol: "zearalenol",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "11205083",
  },
  {
    id: "3238",
    id_polifenol: "1934",
    polifenol: "2,6-di-tert-butyl-4-hydroxy-4-methyl-2,5-cyclohexadien-1-one",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "7586169",
  },
  {
    id: "3239",
    id_polifenol: "6684",
    polifenol: "eupafolin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "2",
    pmids: "28655996,22083996",
  },
  {
    id: "3240",
    id_polifenol: "1754",
    polifenol: "gigantol",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "2",
    pmids: "27959444,28844931",
  },
  {
    id: "3241",
    id_polifenol: "7590",
    polifenol: "quercetin-3-O-rutinoside",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "2",
    pmids: "27232543,28178217",
  },
  {
    id: "3242",
    id_polifenol: "444",
    polifenol: "2,4-di-tert-butylphenol",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "2318380",
  },
  {
    id: "3243",
    id_polifenol: "1629",
    polifenol: "bis-1,7-(2-hydroxyphenyl)-hepta-1,6-diene-3,5-dione",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "12208119",
  },
  {
    id: "3244",
    id_polifenol: "6687",
    polifenol: "3'-dimethylaminoflavone",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "2",
    pmids: "28638884,25113874",
  },
  {
    id: "3245",
    id_polifenol: "6459",
    polifenol: "genkwanin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "3",
    pmids: "20397728,22753749,28961040",
  },
  {
    id: "3246",
    id_polifenol: "3490",
    polifenol: "estragole",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "3",
    pmids: "19463090,21812646,20429289",
  },
  {
    id: "3247",
    id_polifenol: "3386",
    polifenol: "2,2',4,4'-tetrabromodiphenyl ether",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "21783961",
  },
  {
    id: "3248",
    id_polifenol: "529",
    polifenol: "4-octylphenol",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "2",
    pmids: "11530281,11800169",
  },
  {
    id: "3249",
    id_polifenol: "6548",
    polifenol: "artocarpin flavonoid",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "27064012",
  },
  {
    id: "3250",
    id_polifenol: "5101",
    polifenol: "isokaempferide",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "19101886",
  },
  {
    id: "3251",
    id_polifenol: "1585",
    polifenol: "curcumin glucuronide",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "18720347",
  },
  {
    id: "3252",
    id_polifenol: "52",
    polifenol: "Diflunisal",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "26695731",
  },
  {
    id: "3253",
    id_polifenol: "5536",
    polifenol: "prodelphinidin B-2 3'-O-gallate",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "28216880",
  },
  {
    id: "3254",
    id_polifenol: "526",
    polifenol: "liensinine",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "26811496",
  },
  {
    id: "3255",
    id_polifenol: "7885",
    polifenol: "hydroxysafflor yellow A",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "28966242",
  },
  {
    id: "3256",
    id_polifenol: "5525",
    polifenol: "cyanidin 3-rutinoside",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "29800916",
  },
  {
    id: "3257",
    id_polifenol: "4548",
    polifenol: "artemetin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "24633846",
  },
  {
    id: "3258",
    id_polifenol: "2159",
    polifenol: "2,3-dihydroxybenzoic acid",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "29792433",
  },
  {
    id: "3259",
    id_polifenol: "273",
    polifenol: "bis(4-nitrophenyl)phosphate",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "3383346",
  },
  {
    id: "3260",
    id_polifenol: "3661",
    polifenol: "2-tert-butyl-4-hydroxyanisole",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "2",
    pmids: "1340765,2860980",
  },
  {
    id: "3261",
    id_polifenol: "5941",
    polifenol: "3-hydroxy-4,3',4',5'-tetramethoxychalcone",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "19875299",
  },
  {
    id: "3262",
    id_polifenol: "5720",
    polifenol: "4,3',4',5'- tetramethoxychalcone",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "19875299",
  },
  {
    id: "3263",
    id_polifenol: "400",
    polifenol: "cardanol",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "26434878",
  },
  {
    id: "3264",
    id_polifenol: "2336",
    polifenol: "octyl gallate",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "2",
    pmids: "29288082,23835774",
  },
  {
    id: "3265",
    id_polifenol: "5909",
    polifenol: "licochalcone E",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "28522265",
  },
  {
    id: "3266",
    id_polifenol: "343",
    polifenol: "2,5-dichloro-4-bromophenol",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "11238185",
  },
  {
    id: "3267",
    id_polifenol: "2161",
    polifenol: "nifuroxazide",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "26154152",
  },
  {
    id: "3268",
    id_polifenol: "7632",
    polifenol: "quercetin-3-O-beta-D-galactopyranoside",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "18828600",
  },
  {
    id: "3269",
    id_polifenol: "7633",
    polifenol: "tamarixetin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "3",
    pmids: "26851174,22077457,16856484",
  },
  {
    id: "3270",
    id_polifenol: "72",
    polifenol: "Phenyl Ethers",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "2",
    pmids: "17509781,20593839",
  },
  {
    id: "3271",
    id_polifenol: "4161",
    polifenol: "3,5-dihydroxyphenylglycine",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "22706282",
  },
  {
    id: "3272",
    id_polifenol: "7518",
    polifenol: "quercetin-3-O-alpha-arabinofuranoside",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "2",
    pmids: "23767410,18828600",
  },
  {
    id: "3273",
    id_polifenol: "7289",
    polifenol: "isorhamnetin 3-O-glucoside",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "28649063",
  },
  {
    id: "3274",
    id_polifenol: "6508",
    polifenol: "prunetin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "29197545",
  },
  {
    id: "3275",
    id_polifenol: "5963",
    polifenol: "3,5,2',4'-tetrahydroxychalcone",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "21770460",
  },
  {
    id: "3276",
    id_polifenol: "1262",
    polifenol: "4-dodecylaminophenol",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "17092729",
  },
  {
    id: "3277",
    id_polifenol: "6647",
    polifenol: "6-methylflavone",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "22753749",
  },
  {
    id: "3278",
    id_polifenol: "4297",
    polifenol: "curvularin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "2",
    pmids: "23134667,26411029",
  },
  {
    id: "3279",
    id_polifenol: "4103",
    polifenol: "gnetin H",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "12135100",
  },
  {
    id: "3280",
    id_polifenol: "2332",
    polifenol: "lauryl gallate",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "23835774",
  },
  {
    id: "3281",
    id_polifenol: "2066",
    polifenol: "NSC 680410",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "19442148",
  },
  {
    id: "3282",
    id_polifenol: "4244",
    polifenol: "malabaricone A",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "26141757",
  },
  {
    id: "3283",
    id_polifenol: "1796",
    polifenol: "(10)-shogaol",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "29393873",
  },
  {
    id: "3284",
    id_polifenol: "903",
    polifenol: "vineatrol",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "18627786",
  },
  {
    id: "3285",
    id_polifenol: "5052",
    polifenol: "3-aminoflavone",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "9784250",
  },
  {
    id: "3286",
    id_polifenol: "3336",
    polifenol:
      "N-hydroxy-5-ethoxymethyloxy-2-methyl-4-(4-phenoxybenzoyl)aminopentanamide",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "12384564",
  },
  {
    id: "3287",
    id_polifenol: "6883",
    polifenol: "LYG 202",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "2",
    pmids: "19481059,22909797",
  },
  {
    id: "3288",
    id_polifenol: "5791",
    polifenol: "metochalcone",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "19875299",
  },
  {
    id: "3289",
    id_polifenol: "5854",
    polifenol: "2'-hydroxy-3,4,3',4',6'-pentamethoxychalcone",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "19875299",
  },
  {
    id: "3290",
    id_polifenol: "5436",
    polifenol: "herbacetin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "26297979",
  },
  {
    id: "3291",
    id_polifenol: "7726",
    polifenol: "troxerutin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "28628229",
  },
  {
    id: "3292",
    id_polifenol: "4298",
    polifenol: "dehydrocurvularin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "2",
    pmids: "23134667,26411029",
  },
  {
    id: "3293",
    id_polifenol: "4588",
    polifenol: "breviscapine",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "20091746",
  },
  {
    id: "3294",
    id_polifenol: "6654",
    polifenol: "5,2',4'-trihydroxy-6,7,5'-trimethoxyflavone",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "4",
    pmids: "27131317,27834930,29328481,28110438",
  },
  {
    id: "3295",
    id_polifenol: "696",
    polifenol: "2,2-bis(4-hydroxyphenyl)-1,1,1-trichloroethane",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "3",
    pmids: "11530281,11800169,10854714",
  },
  {
    id: "3296",
    id_polifenol: "7641",
    polifenol: "quercetin-3'-O-beta-D-glucopyranoside",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "2",
    pmids: "23767410,18828600",
  },
  {
    id: "3297",
    id_polifenol: "4919",
    polifenol: "bavachinin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "24012108",
  },
  {
    id: "3298",
    id_polifenol: "6752",
    polifenol: "zapotin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "17228877",
  },
  {
    id: "3299",
    id_polifenol: "5465",
    polifenol: "vitexin-2-O-xyloside",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "28283822",
  },
  {
    id: "3300",
    id_polifenol: "3058",
    polifenol: "2,5-dihydroxybenzoic acid",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "16036370",
  },
  {
    id: "3301",
    id_polifenol: "3566",
    polifenol: "K 7174",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "15328158",
  },
  {
    id: "3302",
    id_polifenol: "1961",
    polifenol: "tri-o-cresyl phosphate",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "15451303",
  },
  {
    id: "3303",
    id_polifenol: "1932",
    polifenol: "3,5-di-tert-butyl-4-hydroxytoluene",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "2860980",
  },
  {
    id: "3304",
    id_polifenol: "7151",
    polifenol: "vicenin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "27396915",
  },
  {
    id: "3305",
    id_polifenol: "1804",
    polifenol: "guaiacylglycerol-beta-coniferyl ether",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "22253109",
  },
  {
    id: "3306",
    id_polifenol: "5129",
    polifenol: "echinoside",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "3",
    pmids: "25062508,22012678,21726060",
  },
  {
    id: "3307",
    id_polifenol: "184",
    polifenol: "trilobatin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "2",
    pmids: "25229655,26633321",
  },
  {
    id: "3308",
    id_polifenol: "5701",
    polifenol: "2',4'-dihydroxy-3,4,5-trimethoxychalcone",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "19875299",
  },
  {
    id: "3309",
    id_polifenol: "5226",
    polifenol: "cudraflavone B",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "15051062",
  },
  {
    id: "3310",
    id_polifenol: "82",
    polifenol: "Gemfibrozil",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "23805127",
  },
  {
    id: "3311",
    id_polifenol: "4149",
    polifenol: "adipostatin A",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "26434878",
  },
  {
    id: "3312",
    id_polifenol: "5910",
    polifenol: "3'-formyl-4',6'-dihydroxy-2'-methoxy-5'-methylchalcone",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "2",
    pmids: "23891701,17430639",
  },
  {
    id: "3313",
    id_polifenol: "4274",
    polifenol: "O 1602",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "24355564",
  },
  {
    id: "3314",
    id_polifenol: "3605",
    polifenol: "lyoniresinol",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "2",
    pmids: "22253109,19950049",
  },
  {
    id: "3315",
    id_polifenol: "6464",
    polifenol: "cirsiliol",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "27566208",
  },
  {
    id: "3316",
    id_polifenol: "322",
    polifenol: "N-methyl-4-aminophenol",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "2",
    pmids: "12417027,16203149",
  },
  {
    id: "3317",
    id_polifenol: "6830",
    polifenol: "artocarpesin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "2",
    pmids: "26547532,15051062",
  },
  {
    id: "3318",
    id_polifenol: "7196",
    polifenol: "nepitrin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "20397728",
  },
  {
    id: "3319",
    id_polifenol: "2255",
    polifenol: "protocatechuic acid methyl ester",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "25061291",
  },
  {
    id: "3320",
    id_polifenol: "5996",
    polifenol: "3-(2-chlorophenyl)-1-(2,4-dihydroxyphenyl)prop-2-en-1-one",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "15165144",
  },
  {
    id: "3321",
    id_polifenol: "7014",
    polifenol: "3,4',7-trihydroxy-3'-methoxyflavone",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "27522262",
  },
  {
    id: "3322",
    id_polifenol: "7583",
    polifenol: "quercetin 3-O-glucopyranoside",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "26922854",
  },
  {
    id: "3323",
    id_polifenol: "7210",
    polifenol: "luteolin-7-O-glucuronide",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "29710781",
  },
  {
    id: "3324",
    id_polifenol: "559",
    polifenol: "squamosamide",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "21835169",
  },
  {
    id: "3325",
    id_polifenol: "5006",
    polifenol: "procyanidin B1",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "22227333",
  },
  {
    id: "3326",
    id_polifenol: "2760",
    polifenol: "2-methoxybenzoic acid",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "29600718",
  },
  {
    id: "3327",
    id_polifenol: "7457",
    polifenol: "kaempferol-7-O-alpha-L-rhamnopyranoside",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "16206043",
  },
  {
    id: "3328",
    id_polifenol: "2695",
    polifenol: "methyl salicylate",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "29973423",
  },
  {
    id: "3329",
    id_polifenol: "2486",
    polifenol: "1,3,6-tri-O-galloylglucopyranose",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "2",
    pmids: "19142982,21595573",
  },
  {
    id: "3330",
    id_polifenol: "2607",
    polifenol: "amorfrutin A",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "28879797",
  },
  {
    id: "3331",
    id_polifenol: "2090",
    polifenol: "10'(Z),13'(E),15'(E)-heptadecatrienylhydroquinone",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "23088786",
  },
  {
    id: "3332",
    id_polifenol: "6626",
    polifenol: "cajanol",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "21164560",
  },
  {
    id: "3333",
    id_polifenol: "460",
    polifenol: "suillin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "2",
    pmids: "24606477,19616521",
  },
  {
    id: "3334",
    id_polifenol: "6840",
    polifenol: "calycopterin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "25060910",
  },
  {
    id: "3335",
    id_polifenol: "4334",
    polifenol: "acacetin-7-rutinoside",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "19894512",
  },
  {
    id: "3336",
    id_polifenol: "4673",
    polifenol: "3,7-dimethoxyflavone",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "2",
    pmids: "21660448,28638884",
  },
  {
    id: "3337",
    id_polifenol: "4538",
    polifenol: "butrin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "29403999",
  },
  {
    id: "3338",
    id_polifenol: "6347",
    polifenol: "oroxylin A-7-O-glucuronide",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "29571134",
  },
  {
    id: "3339",
    id_polifenol: "5933",
    polifenol: "licochalcone B",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "28522265",
  },
  {
    id: "3340",
    id_polifenol: "4046",
    polifenol: "3-hydroxyphloretin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "26633321",
  },
  {
    id: "3341",
    id_polifenol: "1795",
    polifenol: "1,4-O-diferuloylsecoisolariciresinol",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "22700239",
  },
  {
    id: "3342",
    id_polifenol: "6118",
    polifenol:
      "rel-5-hydroxy-7,4'-dimethoxy-3' 'S-(2,4,5-trimethoxy-E-styryl)tetrahydrofuro(4' 'R,5' 'R:2,3)flavanonol",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "29039561",
  },
  {
    id: "3343",
    id_polifenol: "5120",
    polifenol: "diosmetin-7-O-xylopyranosyl-1-6-glucopyranoside",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "17294687",
  },
  {
    id: "3344",
    id_polifenol: "7209",
    polifenol: "luteolin 3'-glucuronide",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "20397728",
  },
  {
    id: "3345",
    id_polifenol: "1797",
    polifenol: "(8)-shogaol",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "29393873",
  },
  {
    id: "3346",
    id_polifenol: "7180",
    polifenol: "apigenin-8-C-beta-D-glucopyranoside",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "17202857",
  },
  {
    id: "3347",
    id_polifenol: "1410",
    polifenol: "entacapone",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "27522262",
  },
  {
    id: "3348",
    id_polifenol: "2458",
    polifenol: "glucogallin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "24389959",
  },
  {
    id: "3349",
    id_polifenol: "4220",
    polifenol: "1,3-dihydroxy-5-(tridec-4',7'-dienyl)benzene",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "17009393",
  },
  {
    id: "3350",
    id_polifenol: "4747",
    polifenol: "4'-bromoflavone",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "9973203",
  },
  {
    id: "3351",
    id_polifenol: "5338",
    polifenol: "boeravinone B",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "24882730",
  },
  {
    id: "3352",
    id_polifenol: "1383",
    polifenol: "neodymium pyrocatechin disulfonate",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "26314304",
  },
  {
    id: "3353",
    id_polifenol: "4718",
    polifenol: "5,6,7-trimethoxyflavone",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "27503682",
  },
  {
    id: "3354",
    id_polifenol: "2548",
    polifenol: "1,2,6-tri-O-galloyl-beta-D-glucopyranose",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "22506400",
  },
  {
    id: "3355",
    id_polifenol: "5611",
    polifenol: "epiafzelechin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "23772110",
  },
  {
    id: "3356",
    id_polifenol: "5549",
    polifenol: "luteolinidin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "17227050",
  },
  {
    id: "3357",
    id_polifenol: "5507",
    polifenol: "apigeninidin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "17227050",
  },
  {
    id: "3358",
    id_polifenol: "4714",
    polifenol: "epimedin C",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "16112786",
  },
  {
    id: "3359",
    id_polifenol: "78",
    polifenol: "Clofenapate",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "9298250",
  },
  {
    id: "3360",
    id_polifenol: "4791",
    polifenol: "myricetin 3-O-(2'',3''-di-O-galloyl)rhamnopyranoside",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "21595573",
  },
  {
    id: "3361",
    id_polifenol: "7635",
    polifenol: "quercetin-3-O-alpha-L-rhamnopyranoside",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "2",
    pmids: "24250510,26922854",
  },
  {
    id: "3362",
    id_polifenol: "4306",
    polifenol: "lasiodiplodin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "26230217",
  },
  {
    id: "3363",
    id_polifenol: "2987",
    polifenol: "succinyldisalicylic acid",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "24766798",
  },
  {
    id: "3364",
    id_polifenol: "5079",
    polifenol: "flavangenol",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "22227333",
  },
  {
    id: "3365",
    id_polifenol: "2285",
    polifenol: "lithospermic acid",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "26075899",
  },
  {
    id: "3366",
    id_polifenol: "6380",
    polifenol: "oroxin B",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "29720833",
  },
  {
    id: "3367",
    id_polifenol: "5718",
    polifenol: "4'-hydroxy-2',6'-dimethoxychalcone",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "2",
    pmids: "23891701,25442273",
  },
  {
    id: "3368",
    id_polifenol: "5381",
    polifenol: "gancaonin Q",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "28522265",
  },
  {
    id: "3369",
    id_polifenol: "5197",
    polifenol: "Ikarisoside A",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "16125732",
  },
  {
    id: "3370",
    id_polifenol: "4595",
    polifenol: "2-(2-phenylethyl)chromone",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "26784520",
  },
  {
    id: "3371",
    id_polifenol: "585",
    polifenol: "protosappanin A",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "26036624",
  },
  {
    id: "3372",
    id_polifenol: "5339",
    polifenol: "2S,3S-3,5,7,3',5'-pentahydroxyflavane",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "2",
    pmids: "25298669,21277955",
  },
  {
    id: "3373",
    id_polifenol: "5340",
    polifenol: "2R,3R-3,5,6,7,8,4'-hexahydroxyflavane",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "2",
    pmids: "25298669,21277955",
  },
  {
    id: "3374",
    id_polifenol: "4814",
    polifenol: "glabrol",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "28522265",
  },
  {
    id: "3375",
    id_polifenol: "171",
    polifenol: "p-decylaminophenol",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "17092729",
  },
  {
    id: "3376",
    id_polifenol: "5724",
    polifenol: "3,2'-dihydroxy-4',6'-dimethoxychalcone",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "25442273",
  },
  {
    id: "3377",
    id_polifenol: "2498",
    polifenol: "thonningianin A",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "26119846",
  },
  {
    id: "3378",
    id_polifenol: "6937",
    polifenol: "ladanein",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "20397728",
  },
  {
    id: "3379",
    id_polifenol: "7069",
    polifenol: "isoorientin-2''-O-arabinopyranosyl",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "27130644",
  },
  {
    id: "3380",
    id_polifenol: "5399",
    polifenol: "7,7''-dimethoxyagastisflavone",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "21915931",
  },
  {
    id: "3381",
    id_polifenol: "4157",
    polifenol: "bilobol",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "26622605",
  },
  {
    id: "3382",
    id_polifenol: "3167",
    polifenol: "4-(3,4,5-trimethoxyphenoxy)benzoic acid",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "2",
    pmids: "24692713,24406729",
  },
  {
    id: "3383",
    id_polifenol: "5157",
    polifenol: "kurarinol",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "24997323",
  },
  {
    id: "3384",
    id_polifenol: "3225",
    polifenol: "decabromobiphenyl ether",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "17509781",
  },
  {
    id: "3385",
    id_polifenol: "7485",
    polifenol:
      "kaempherol 3-O-beta-rhamnopyranosyl (1-6)-beta-D-glucopyranoside",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "2",
    pmids: "22014228,29901131",
  },
  {
    id: "3386",
    id_polifenol: "6292",
    polifenol: "tricin 4'-O-(threo-beta-guaiacylglyceryl) ether",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "25667964",
  },
  {
    id: "3387",
    id_polifenol: "6293",
    polifenol: "tricin 4'-O-(erythro-beta-guaiacylglyceryl) ether",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "25667964",
  },
  {
    id: "3388",
    id_polifenol: "6683",
    polifenol: "5,7,4'-trihydroxy-3'-(3-hydroxy-3-methylbutyl)isoflavone",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "29197545",
  },
  {
    id: "3389",
    id_polifenol: "4308",
    polifenol: "11-alpha-methoxycurvularin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "26411029",
  },
  {
    id: "3390",
    id_polifenol: "2311",
    polifenol: "aspergillusidone A",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "22307935",
  },
  {
    id: "3391",
    id_polifenol: "5558",
    polifenol: "cyanidin 3-sambubioside",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "29407472",
  },
  {
    id: "3392",
    id_polifenol: "6003",
    polifenol: "boesenbergin A",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "22358425",
  },
  {
    id: "3393",
    id_polifenol: "2546",
    polifenol: "1,3,4-tri-O-galloyl-6-O-caffeoyl-beta-D-glucopyranose",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "22506400",
  },
  {
    id: "3394",
    id_polifenol: "5140",
    polifenol: "5-hydroxy-6,7-dimethoxyflavone",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "27503682",
  },
  {
    id: "3395",
    id_polifenol: "6538",
    polifenol: "cirsimarin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "20804824",
  },
  {
    id: "3396",
    id_polifenol: "6193",
    polifenol: "naringenin-7-O-glucoside",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "18074851",
  },
  {
    id: "3397",
    id_polifenol: "7866",
    polifenol: "ephedrannin A",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "18975262",
  },
  {
    id: "3398",
    id_polifenol: "7859",
    polifenol: "ephedrannin B",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "18975262",
  },
  {
    id: "3399",
    id_polifenol: "2049",
    polifenol: "menahydroquinone-4",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "25416411",
  },
  {
    id: "3400",
    id_polifenol: "7585",
    polifenol: "quercetin 7-O-glucopyranoside",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "28987377",
  },
  {
    id: "3401",
    id_polifenol: "5810",
    polifenol: "isobutrin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "29403999",
  },
  {
    id: "3402",
    id_polifenol: "3549",
    polifenol: "ardisenone",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "20561930",
  },
  {
    id: "3403",
    id_polifenol: "7072",
    polifenol: "ophiopogonanone H",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "2",
    pmids: "14519939,21163470",
  },
  {
    id: "3404",
    id_polifenol: "5586",
    polifenol: "3',4'-dimethoxy-alpha-naphthoflavone",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "22553215",
  },
  {
    id: "3405",
    id_polifenol: "4992",
    polifenol: "acacetin-7-O-glucoside",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "22732304",
  },
  {
    id: "3406",
    id_polifenol: "7570",
    polifenol: "spiraeoside",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "29552109",
  },
  {
    id: "3407",
    id_polifenol: "904",
    polifenol: "afzelechin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "23772110",
  },
  {
    id: "3408",
    id_polifenol: "7642",
    polifenol: "quercetin-4'-O-beta-D-galactoside",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "20707070",
  },
  {
    id: "3409",
    id_polifenol: "3851",
    polifenol: "methyl triclosan",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "26970259",
  },
  {
    id: "3410",
    id_polifenol: "4529",
    polifenol: "ganhuangenin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "16545824",
  },
  {
    id: "3411",
    id_polifenol: "5479",
    polifenol: "cyanidin 3-O-glucopyranoside",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "28317281",
  },
  {
    id: "3412",
    id_polifenol: "6192",
    polifenol: "2',4'-dihydroxy-5'-(1'''-dimethylallyl)-6-prenylpinocembrin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "16395655",
  },
  {
    id: "3413",
    id_polifenol: "6543",
    polifenol: "euchrenone b10",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "19252325",
  },
  {
    id: "3414",
    id_polifenol: "5194",
    polifenol: "dorsilurin F",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "29066296",
  },
  {
    id: "3415",
    id_polifenol: "6970",
    polifenol: "5,7-dihydroxy-3-(3-hydroxy-4-methoxybenzyl)chroman-4-one",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "21163470",
  },
  {
    id: "3416",
    id_polifenol: "2060",
    polifenol: "2-(10-heptadecenyl)-1,4-hydroquinone",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "23088786",
  },
  {
    id: "3417",
    id_polifenol: "7067",
    polifenol: "III-10",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "26164795",
  },
  {
    id: "3418",
    id_polifenol: "7899",
    polifenol: "isolespeol",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "18767861",
  },
  {
    id: "3419",
    id_polifenol: "5813",
    polifenol: "3,4,2',4'-tetrahydroxy-2-geranyldihydrochalcone",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "18767861",
  },
  {
    id: "3420",
    id_polifenol: "2417",
    polifenol: "quercetin-3-O-(6''-galloyl) beta-D-galactopyranoside",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "26369427",
  },
  {
    id: "3421",
    id_polifenol: "4844",
    polifenol: "3',5'-di-C-glucopyranosylphloretin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "26633321",
  },
  {
    id: "3422",
    id_polifenol: "6573",
    polifenol: "glisoflavanone",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "28522265",
  },
  {
    id: "3423",
    id_polifenol: "5297",
    polifenol: "semilicoisoflavone B",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "28522265",
  },
  {
    id: "3424",
    id_polifenol: "6136",
    polifenol: "5,7,3',5'-tetrahydroxyflavanone",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "19994890",
  },
  {
    id: "3425",
    id_polifenol: "6982",
    polifenol: "DHF 18",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "21093431",
  },
  {
    id: "3426",
    id_polifenol: "6515",
    polifenol: "sigmoidin I",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "25034000",
  },
  {
    id: "3427",
    id_polifenol: "7897",
    polifenol: "3,4-methylenedioxy-3',4',5'-trimethoxy chalcone",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "26907262",
  },
  {
    id: "3428",
    id_polifenol: "847",
    polifenol: "xantocillin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "22822377",
  },
  {
    id: "3429",
    id_polifenol: "5286",
    polifenol:
      "5,4'-dihydroxy-7,8-((3''-hydroxy-4''-one)-2'',2''-dimethylpyrano)flavone",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "26655407",
  },
  {
    id: "3430",
    id_polifenol: "4407",
    polifenol: "8-C-(E-phenylethenyl)-norartocarpetin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "26675844",
  },
  {
    id: "3431",
    id_polifenol: "5349",
    polifenol:
      "5-hydroxy-8-methoxy-2-phenyl-7-(4-(pyrrolidin-1-yl)butoxy)4H-chromen-4-one",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "23835921",
  },
  {
    id: "3432",
    id_polifenol: "5362",
    polifenol: "afzelechin 5-O-beta-D-glucopyranoside",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "21985227",
  },
  {
    id: "3433",
    id_polifenol: "3906",
    polifenol: "hyperforin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "21751836",
  },
  {
    id: "3434",
    id_polifenol: "3004",
    polifenol: "aspirin, caffeine, codeine drug combination",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "22940450",
  },
  {
    id: "3435",
    id_polifenol: "1006",
    polifenol:
      "6-(4-((1E)-2-(3,5-dihydroxyphenyl)ethenyl)phenoxy)hexanoic acid",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "26666272",
  },
  {
    id: "3436",
    id_polifenol: "2313",
    polifenol: "aspergillusidone C",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "22307935",
  },
  {
    id: "3437",
    id_polifenol: "1402",
    polifenol: "2,4-dihydroxybenzylamine",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "11297806",
  },
  {
    id: "3438",
    id_polifenol: "4206",
    polifenol: "5-(2'-oxoheptadecyl)resorcinol",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "12562085",
  },
  {
    id: "3439",
    id_polifenol: "4207",
    polifenol: "5-(2'-oxononadecyl)resorcinol",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "12562085",
  },
  {
    id: "3440",
    id_polifenol: "3475",
    polifenol: "homoegonol",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "25795470",
  },
  {
    id: "3441",
    id_polifenol: "5456",
    polifenol: "4''-O-methyl-I3,II8-biapigenin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "17365688",
  },
  {
    id: "3442",
    id_polifenol: "6249",
    polifenol: "eriodictyol-3',7-dimethoxy-4'-O-beta-D-glucoside",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "18074851",
  },
  {
    id: "3443",
    id_polifenol: "7809",
    polifenol: "rotenoisin B",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "26213921",
  },
  {
    id: "3444",
    id_polifenol: "6174",
    polifenol: "(2S)-8-formyl-5-hydroxy-7-methoxy-6-methylflavanone",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "17430639",
  },
  {
    id: "3445",
    id_polifenol: "7364",
    polifenol:
      "kaempferol-3-O-(2'(4-acetylrhamnopyranosyl)-3'-galactopyranosyl)robinobioside",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "23679992",
  },
  {
    id: "3446",
    id_polifenol: "1592",
    polifenol: "EF25-(GSH)2",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "25268357",
  },
  {
    id: "3447",
    id_polifenol: "7740",
    polifenol: "8-methoxycoumestrol",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "19634327",
  },
  {
    id: "3448",
    id_polifenol: "1829",
    polifenol: "2-ethylhexyl 2,4-dichlorophenoxyacetate",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "26929583",
  },
  {
    id: "3449",
    id_polifenol: "7808",
    polifenol: "mirabijalone E",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "24882730",
  },
  {
    id: "3450",
    id_polifenol: "532",
    polifenol: "osmanthuside H",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "20707194",
  },
  {
    id: "3451",
    id_polifenol: "619",
    polifenol: "2-(3-methyl-2-butenyl)-3,4,5-trimethoxyphenol",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "20707194",
  },
  {
    id: "3452",
    id_polifenol: "7401",
    polifenol:
      "kaempferol-3-O-glucopyranoside-6''-(3-hydroxy-3-methyl glutarate)-7-O-glucopyranoside",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "16968064",
  },
  {
    id: "3453",
    id_polifenol: "770",
    polifenol:
      "3,5-dihydroxy-1-(3,4-dihydroxyphenyl)-7-(4-hydroxyphenyl)heptane",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "28258038",
  },
  {
    id: "3454",
    id_polifenol: "6972",
    polifenol: "aromadendrin 3-O-beta-D-glucopyranoside",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "28108382",
  },
  {
    id: "3455",
    id_polifenol: "736",
    polifenol: "1,2,4,5-tetrahydroxybenzene",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "28108382",
  },
  {
    id: "3456",
    id_polifenol: "2337",
    polifenol: "M3OMG",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "20862963",
  },
  {
    id: "3457",
    id_polifenol: "1923",
    polifenol: "2,6-di-tert-butyl-4-hydroxymethylphenol",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "7586169",
  },
  {
    id: "3458",
    id_polifenol: "5548",
    polifenol: "delphinidin 3-sambubioside",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "29407472",
  },
  {
    id: "3459",
    id_polifenol: "4818",
    polifenol: "C-glucosylflavone",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "20804824",
  },
  {
    id: "3460",
    id_polifenol: "7009",
    polifenol: "5-O-beta-D-glucopyranosyl cirsimaritin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "20804824",
  },
  {
    id: "3461",
    id_polifenol: "7010",
    polifenol: "5,4'-O-beta-D-diglucopyranosyl cirsimaritin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "20804824",
  },
  {
    id: "3462",
    id_polifenol: "4287",
    polifenol: "3,5-dihydroxybenzyl alcohol",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "23054715",
  },
  {
    id: "3463",
    id_polifenol: "4609",
    polifenol: "4',7-dihydroxy-3-methoxy-5,6-dimethylflavone",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "28800661",
  },
  {
    id: "3464",
    id_polifenol: "65",
    polifenol: "Picrates",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "26773872",
  },
  {
    id: "3465",
    id_polifenol: "7248",
    polifenol:
      "kaempferol 3-O-beta-D-glucopyranosyl-(1''-2')-O-alpha-L-arabinopyranoside",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "24250510",
  },
  {
    id: "3466",
    id_polifenol: "6185",
    polifenol: "5,7,2',6'-tetrahydroxy-6-lavandulylated-flavanone",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "16545824",
  },
  {
    id: "3467",
    id_polifenol: "6583",
    polifenol: "bolusanthol C",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "16545824",
  },
  {
    id: "3468",
    id_polifenol: "7439",
    polifenol: "kaempferol-3-beta-D-(6-O-trans-p-coumaroyl)glucopyranoside",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "27232543",
  },
  {
    id: "3469",
    id_polifenol: "6716",
    polifenol: "7-hydroxy-4'-methoxy-3'-prenylisoflavone",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "29468891",
  },
  {
    id: "3470",
    id_polifenol: "5403",
    polifenol: "sinapyl alcohol 9-O-(E)-p-coumaroyl-4-O-beta-D-glucopyanoside",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "21657076",
  },
  {
    id: "3471",
    id_polifenol: "5459",
    polifenol:
      "5,7-dihydroxy-2-(1,2-isopropyldioxy-4-oxo-cyclohex-5-enyl)-chromen-4-one",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "21657076",
  },
  {
    id: "3472",
    id_polifenol: "6025",
    polifenol:
      "5-hydroxy-2-(1'-hydroxy-4'-oxo-cyclohex-2'-en-1'-yl)-6,7-dimethoxy-2,3-dihydro-4H-chromen-4-one",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "21657076",
  },
  {
    id: "3473",
    id_polifenol: "1403",
    polifenol: "2,3-dihydroxybenzaldehyde",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "27002605",
  },
  {
    id: "3474",
    id_polifenol: "3288",
    polifenol: "phenyl allyl ether",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "17168588",
  },
  {
    id: "3475",
    id_polifenol: "2501",
    polifenol: "4,6-O-isoterchebuloylglucose",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "11277742",
  },
  {
    id: "3476",
    id_polifenol: "7052",
    polifenol: "(3S)-5-guaiacyl-3-hydroxypentanoic acid",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "22253109",
  },
  {
    id: "3477",
    id_polifenol: "6581",
    polifenol: "bolusanthol A",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "27604296",
  },
  {
    id: "3478",
    id_polifenol: "4343",
    polifenol: "3-cinnamoyltribuloside",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "25348942",
  },
  {
    id: "3479",
    id_polifenol: "4989",
    polifenol: "6-C-methylluteolin 7-methyl ether",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "28987377",
  },
  {
    id: "3480",
    id_polifenol: "3061",
    polifenol: "orbicularin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "28987377",
  },
  {
    id: "3481",
    id_polifenol: "6245",
    polifenol: "ormosinol",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "22037567",
  },
  {
    id: "3482",
    id_polifenol: "6244",
    polifenol: "ormosinoside",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "22037567",
  },
  {
    id: "3483",
    id_polifenol: "6582",
    polifenol: "bolusanthol B",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "22037567",
  },
  {
    id: "3484",
    id_polifenol: "7769",
    polifenol: "maackiapterocarpan B",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "19252325",
  },
  {
    id: "3485",
    id_polifenol: "4449",
    polifenol: "3'-hydroxydaphnodorin A",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "26252201",
  },
  {
    id: "3486",
    id_polifenol: "6507",
    polifenol: "afromosin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "29098824",
  },
  {
    id: "3487",
    id_polifenol: "7423",
    polifenol: "3-methylkaempferol",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "29098824",
  },
  {
    id: "3488",
    id_polifenol: "1399",
    polifenol: "KS I",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "29098824",
  },
  {
    id: "3489",
    id_polifenol: "7143",
    polifenol: "clerodendrin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "21595573",
  },
  {
    id: "3490",
    id_polifenol: "5341",
    polifenol: "2R,3R-3,5,6,7,8,3',5'-heptahydroxyflavane",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "21277955",
  },
  {
    id: "3491",
    id_polifenol: "3808",
    polifenol: "2-amino-6-hydroxy-3-methylbenzoic acid",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "24699147",
  },
  {
    id: "3492",
    id_polifenol: "4029",
    polifenol: "androforin A",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "22700239",
  },
  {
    id: "3493",
    id_polifenol: "6942",
    polifenol: "mornigrol H",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "26234140",
  },
  {
    id: "3494",
    id_polifenol: "6757",
    polifenol: "methylophiopogonanone B",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "21163470",
  },
  {
    id: "3495",
    id_polifenol: "7856",
    polifenol: "mahuannin A",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "18975262",
  },
  {
    id: "3496",
    id_polifenol: "7483",
    polifenol: "5,7,4'-trihydroxyflavan (2alpha-O-7, 4alpha-8) kaempferol",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "18975262",
  },
  {
    id: "3497",
    id_polifenol: "7849",
    polifenol: "geranin D",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "18975262",
  },
  {
    id: "3498",
    id_polifenol: "6511",
    polifenol: "duartin",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "28110438",
  },
  {
    id: "3499",
    id_polifenol: "6516",
    polifenol: "8-methoxyvestitol",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "28110438",
  },
  {
    id: "3500",
    id_polifenol: "3230",
    polifenol: "di-(4-aminophenyl)ether",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "2629100",
  },
  {
    id: "3501",
    id_polifenol: "7513",
    polifenol:
      "kaempferol-3-O-beta-D-glucopyranosyl-(1-3)-alpha-L-rhamnopyranosyl-(1-6)-(alpha-L-rhamnopyranosyl(1-2))-beta-D-galactopyranoside",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "21761841",
  },
  {
    id: "3502",
    id_polifenol: "7109",
    polifenol:
      "chrysoeriol 7-O-(glucuronopyranosyl-(1-2)-O-glucuronopyranoside)",
    id_cancer: "506",
    cancer: "Liver Cancer",
    quant: "1",
    pmids: "21761841",
  },
  {
    id: "3503",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "191",
    pmids:
      "20175127,10963959,24583196,26164795,23877923,29434799,21229608,27042290,25014747,21800276,16497434,22185222,21596135,24706622,8519648,25138434,20559509,12115492,25146759,25390937,18987588,26648539,21364669,26547532,17345086,8084211,24628411,23765509,18636546,9374422,15744083,25442273,18790751,29472583,12949627,26141760,20397728,24398107,18930780,27760539,16860949,21364620,22492309,21165570,26655407,25561222,19719238,23907072,25016375,27210480,16087636,24443427,29555410,27803764,25339540,22004952,28286420,25084411,25684472,25630105,20577025,10953339,25546119,16158945,8968050,24438177,25539720,21212562,29630880,23203111,26646850,24991123,16614396,24702030,19425186,22113421,21867607,25203554,15857606,25771121,25922642,26387984,19426688,17341037,19768977,27168755,21622138,24632069,10953322,29649138,10558914,27085528,26598918,15572302,15644950,10673981,18958421,25779644,25849845,19842135,25667616,15117547,17430639,16011286,28797929,12648504,29144597,23533482,23063980,11205247,23452983,22047698,19288403,15755510,25201038,12479854,26463658,27761061,25264679,17218638,21351299,25096193,20025993,19288491,26069485,24232740,23266730,11595883,24678980,22170774,11396188,21291361,22593249,10713480,29312799,28865123,19449452,17666852,20804824,17447850,15579072,8642556,29407975,19010542,17085048,17765212,25886879,10563845,19135038,27234147,27262321,25986578,29355456,20697976,11497257,17458941,15584372,27455661,17154505,24292576,29656660,15036470,17353006,19528493,22758641,25379467,21480518,25239551,21382914,9720608,21080070,18552875,23872129,29326123,8567688,26941541,16781454,21462089,17870050,15949701,22770910,20158254,21277955,25632469,28911385,27023504,16949716,16001171,29338226,27889540,17637507",
  },
  {
    id: "3504",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "124",
    pmids:
      "28071969,17201156,25577711,24716415,21793155,10518003,28875010,16820928,11312881,16538860,14555224,14637278,20576164,17198682,27504095,19331178,14530869,24528086,21924245,22443687,11756235,18396784,18187158,12684045,17096185,21325634,19224157,8941755,26232616,28807161,29088066,20857431,27889234,15161016,11163331,28322158,25240837,27473378,12684430,16445949,12718610,20599780,20728364,28439094,17240359,26521943,9617340,27857884,29172279,21658388,23127155,19228728,23145775,20600877,10403539,26802277,24278627,9744532,11216470,29391517,19055861,27221847,8950193,26893544,14666669,10969724,22510010,22356159,21928294,22013068,11731421,25891482,14627502,20025279,11237388,21480667,16964716,24798089,9764849,17671737,10517978,26815506,9112258,25272063,16008121,25310451,21859497,11795474,16309195,22593249,16490174,25979368,10025876,8142920,28036082,22812238,27588609,20232614,23624207,9349692,12649194,20032896,20423230,19084262,29232190,19127081,9619854,28210221,19723081,28199114,20924967,18462866,15864788,18076140,16781454,18499486,22335582,22390767,25080283,17448598,15281225,24522270,9771944,23389039",
  },
  {
    id: "3505",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "68",
    pmids:
      "24021570,28366708,29434799,10518003,17475222,21391128,25270015,16459021,12151351,22715906,18636546,18396784,19560862,10554885,24606444,18806962,27137366,22406996,19619938,15769601,23811288,24804028,19325839,11351279,22412883,24398169,19944671,20438634,16614396,21467134,25636891,23796248,10953322,27551472,15761374,20074931,23988898,1786398,15117547,12628501,9570354,24798089,23452983,26052936,15831084,22490328,22792417,26463658,21935971,15735102,12529996,21291361,22593249,16395705,25886879,9878691,12888656,17616210,29285220,17081606,15670891,22758641,25239551,26941541,13678404,25878716,16039555,24547772",
  },
  {
    id: "3506",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "47",
    pmids:
      "22953963,18031783,23813779,19343001,25383546,15922006,17052670,18706445,22172327,12963734,20232365,10523856,24965577,23550028,19100683,23948751,21336837,22293124,10712238,17161815,21935931,15274354,19428345,12231395,15291360,21360677,21853157,15183121,23395717,19825968,21892628,24901342,17137556,10403776,9613107,18358453,29964149,24514755,9679985,22525867,20371726,24330068,16497166,10368649,26884713,14576828,25817574",
  },
  {
    id: "3507",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "43",
    pmids:
      "11642314,12115492,8084211,9563884,18546268,7669726,7892284,7892286,22424954,9498488,2125038,10226522,15183121,18426648,7488237,24632069,8950193,10558914,9247600,9809987,18358453,7538048,25859554,17676056,17198876,7908888,15579072,14551814,8415125,17311236,21966475,17051411,17458941,15584372,8547662,18552875,10444167,18163589,25144547,25181960,16001171,7531365,11138960",
  },
  {
    id: "3508",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "66",
    pmids:
      "25293876,21229608,25354548,21596135,11200093,25138434,12115492,26648539,24173369,18636546,9374422,29472583,23530649,21165570,22685690,11520601,25339540,25630105,20577025,16158945,22412883,1625476,20438634,10072927,24702030,18426648,21867607,21138867,15857606,7488237,25922642,22613008,23796248,24632069,27551472,10558914,15572302,15644950,10673981,18958421,25849845,25201038,12479854,25096193,20025993,11595883,24678980,15735102,17555822,19449452,10563845,19135038,12391557,28188793,20697976,15584372,12888656,29285220,15670891,22758641,22446006,9720608,8567688,26941541,2833358,16001171",
  },
  {
    id: "3509",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "38",
    pmids:
      "16309196,12395181,10518003,12546725,18636546,10554885,18687687,24606444,18693020,15769601,16460233,19325839,12427485,11478767,20950636,19228728,9712707,25636891,19729850,14666669,23988898,12628501,11205247,14981928,28766684,12479362,11396188,22593249,10713480,15201978,9878691,21382914,12913695,14563487,28103249,1602241,24855377,22405976",
  },
  {
    id: "3510",
    id_polifenol: "2167",
    polifenol: "phenolic acid",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "51",
    pmids:
      "18031783,25294094,27492128,10518003,12502387,16459021,27288921,15826073,20397728,22899608,27760539,15796154,27210480,29389554,16445949,12718610,23203111,21213408,10226522,16614396,22634840,19768977,27168755,12214859,22353428,22510010,22356159,28709826,29938677,24024974,20025279,27348025,11551496,29338345,26052936,22792417,27761061,24678980,21291361,17949360,28036082,27262321,28746550,22274814,22253109,26941541,20158254,15281225,28911385,26797631,12538027",
  },
  {
    id: "3511",
    id_polifenol: "49",
    polifenol: "Aspirin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "12",
    pmids:
      "23896061,20835687,26774931,18358453,6575096,23874405,22916316,27270429,3049673,19101573,3020255,8381329",
  },
  {
    id: "3512",
    id_polifenol: "109",
    polifenol: "Catechin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "22",
    pmids:
      "25270015,18687687,15769601,16460233,19325839,17328920,27803764,12427485,16614396,9712707,21432719,15761374,3518597,14567448,12479362,20862963,15584372,17081606,16198231,14563487,20837083,25338140",
  },
  {
    id: "3513",
    id_polifenol: "125",
    polifenol: "Isoflavones",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "22",
    pmids:
      "11642314,26594764,18546268,7892284,7892286,22424954,26423865,10953322,15572302,17428663,10879475,15579072,8415125,17458941,15584372,29656660,22296272,24324516,18552875,18163589,20158254,28110438",
  },
  {
    id: "3514",
    id_polifenol: "110",
    polifenol: "Chalcones",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "46",
    pmids:
      "29335211,28610775,24583196,21263202,28038941,18702457,29715098,21703248,29620429,26547532,25442273,26141760,25016375,27210480,24494068,10953339,29065840,10226522,21816519,17459529,10953322,11814858,23257665,20637611,28526832,27371926,20796191,22047698,29792154,23524161,25264679,24232740,9591187,16675659,24675137,29715541,12479853,10956199,29656660,18293907,20594863,25091929,1099024,27251045,21053158,11213444",
  },
  {
    id: "3515",
    id_polifenol: "3089",
    polifenol: "1,1-diphenyl-2-picrylhydrazyl",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "42",
    pmids:
      "14672757,25446237,27492128,12417027,12502387,16459021,18987588,22196508,15826073,19230943,27760539,22210035,23907072,27803764,21213408,16614396,20548938,25753739,23892206,11297806,28709826,24024974,17430639,27348025,23452983,12865969,12530012,24678980,10879475,17474862,16177974,10563845,27262321,28746550,19418352,20120114,20183253,19084262,25379467,10499128,28482262,25878716",
  },
  {
    id: "3516",
    id_polifenol: "114",
    polifenol: "Apigenin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "30",
    pmids:
      "21364669,28427292,18636546,21364620,22617349,7892286,22004952,8968050,22084167,15857606,23796248,27551472,15572302,10673981,20025279,27348025,24605779,15132542,20025993,19288491,17154505,22274814,29285220,15036470,10499128,8567688,22732304,16781454,17870050,27889540",
  },
  {
    id: "3517",
    id_polifenol: "113",
    polifenol: "Flavones",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "37",
    pmids:
      "16393120,27353532,8519648,25390937,26547532,17345086,11551495,20658136,17363486,19723047,25561222,25016375,7892286,20577025,28294989,23160683,23481040,22353428,15572302,17950587,12718578,21351299,28839377,17404065,17363487,10956199,17458941,9516149,8567688,18178046,26488879,17870050,23756061,12828478,16001171,18237024,21556497",
  },
  {
    id: "3518",
    id_polifenol: "38",
    polifenol: "Gallic Acid",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "35",
    pmids:
      "21868525,22245431,27492128,27168690,20424615,22196508,28427292,18790533,19454506,29389554,9891488,21213408,16614396,22771367,27853333,11497272,25712645,14666669,24024974,22132974,27348025,11205247,14981928,16198604,11396188,22820028,28746550,25633333,22253109,10499128,21382914,26941541,15036124,11085375,24547772",
  },
  {
    id: "3519",
    id_polifenol: "117",
    polifenol: "Luteolin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "17",
    pmids:
      "27353532,11200093,18636546,20397728,16087636,29649138,28454264,22353428,15572302,27348025,17950587,29566277,21351299,22274814,15036470,10499128,29066296",
  },
  {
    id: "3520",
    id_polifenol: "1",
    polifenol: "Phenols",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "30",
    pmids:
      "16504517,25294094,18156402,22136251,24804028,25539720,19425186,15761374,22356159,26052936,21779655,11319278,20949584,23193056,2548717,16198604,22789709,28258688,17295185,17949360,9878691,10569638,28844931,10873580,19084262,25239551,803242,27023504,11354311,12538027",
  },
  {
    id: "3521",
    id_polifenol: "105",
    polifenol: "Anthocyanins",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "10",
    pmids:
      "15922006,12502387,15826073,12888907,20801663,27137366,24804028,27444805,21291361,17227050",
  },
  {
    id: "3522",
    id_polifenol: "7235",
    polifenol: "silybin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "2",
    pmids: "20543580,12649194",
  },
  {
    id: "3523",
    id_polifenol: "129",
    polifenol: "Rotenone",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "17",
    pmids:
      "11642314,27288921,9258337,23725013,15705792,27210480,12853461,26598918,29692266,17506948,28189086,177206,3756905,27486090,16781454,28110438,11138960",
  },
  {
    id: "3524",
    id_polifenol: "121",
    polifenol: "Kaempferols",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "16",
    pmids:
      "20397728,27803764,24702030,15857606,20548938,10673981,18958421,25779644,28865123,17447850,17765212,25239700,18552875,8567688,25371657,15949701",
  },
  {
    id: "3525",
    id_polifenol: "871",
    polifenol: "ABT-737",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "28",
    pmids:
      "28366708,19561125,19458629,21628457,23243017,16997913,24782462,26880588,25535900,25140305,23872707,21368833,20516119,26206337,19737541,22173547,20038799,25096193,17200714,21761401,21798596,24842334,26219338,21599608,25754349,22311987,20038611,25711460",
  },
  {
    id: "3526",
    id_polifenol: "6451",
    polifenol: "daidzein",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "8",
    pmids:
      "12115492,7892286,22424954,18426648,17676056,8142920,18552875,14585183",
  },
  {
    id: "3527",
    id_polifenol: "6065",
    polifenol: "baicalein",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "9",
    pmids:
      "27042290,16497434,28807161,17341037,15301706,12530012,28448441,15036470,29240303",
  },
  {
    id: "3528",
    id_polifenol: "7",
    polifenol: "Capsaicin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "8",
    pmids:
      "10518003,15313406,24765194,14871840,12718610,24870597,11216470,12214859",
  },
  {
    id: "3529",
    id_polifenol: "4634",
    polifenol: "alvocidib",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "20",
    pmids:
      "12021392,15385934,15150125,12533676,21484792,29370702,27363938,23767415,25914884,9427698,8895733,24495868,11311660,9516149,15383455,12960118,11093360,16322302,16248786,21556497",
  },
  {
    id: "3530",
    id_polifenol: "120",
    polifenol: "Flavonols",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "13",
    pmids:
      "25014747,23925650,17190444,22210035,25539720,29630880,28235426,14704326,7623025,28855870,25096193,16864455,17458941",
  },
  {
    id: "3531",
    id_polifenol: "4522",
    polifenol: "chrysin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "15",
    pmids:
      "20559509,15555556,18636546,28807161,27210480,20577025,23796248,15572302,23533482,12718578,12479854,20862963,21785114,16781454,17870050",
  },
  {
    id: "3532",
    id_polifenol: "123",
    polifenol: "Rutin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "13",
    pmids:
      "20015448,22685690,27803764,29389554,1625476,18958421,21254320,25714885,23153173,20862963,16198604,17447850,19010542",
  },
  {
    id: "3533",
    id_polifenol: "6062",
    polifenol: "naringenin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "13",
    pmids:
      "19124070,28427292,15744083,18930780,16860949,20192247,25667616,27348025,20862963,19135038,25239700,27538012,27889540",
  },
  {
    id: "3534",
    id_polifenol: "285",
    polifenol: "bisphenol A",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "2",
    pmids: "22446810,12538027",
  },
  {
    id: "3535",
    id_polifenol: "39",
    polifenol: "Hydrolyzable Tannins",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "10",
    pmids:
      "10403559,10554885,14769215,23203111,14757314,11497272,11205247,22490328,9591187,11396188",
  },
  {
    id: "3536",
    id_polifenol: "130",
    polifenol: "Proanthocyanidins",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "4",
    pmids: "22297751,27803764,22822675,9720608",
  },
  {
    id: "3537",
    id_polifenol: "35",
    polifenol: "Hydroquinones",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "8",
    pmids:
      "23088786,16504517,23288922,27307158,15571862,11131635,10368308,15690152",
  },
  {
    id: "3538",
    id_polifenol: "111",
    polifenol: "Flavanones",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "15",
    pmids:
      "24734951,21263202,25442273,26141760,25016375,28286420,20708932,10953322,15572302,20192247,21351299,24608571,27234147,23756061,17715491",
  },
  {
    id: "3539",
    id_polifenol: "4502",
    polifenol: "fisetin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "6",
    pmids: "25973292,15572302,18958421,28797929,20025993,8567688",
  },
  {
    id: "3540",
    id_polifenol: "6",
    polifenol: "Catechols",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "6",
    pmids: "19429311,26961313,8019435,14704326,25964542,11470755",
  },
  {
    id: "3541",
    id_polifenol: "25",
    polifenol: "Butylated Hydroxytoluene",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "3",
    pmids: "16857180,1933865,11432460",
  },
  {
    id: "3542",
    id_polifenol: "75",
    polifenol: "Butylated Hydroxyanisole",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "6",
    pmids: "18546268,12809360,11319278,21785114,11156257,9305611",
  },
  {
    id: "3543",
    id_polifenol: "15",
    polifenol: "Masoprocol",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "6",
    pmids: "3019899,20809257,14674625,9619854,12110314,2121330",
  },
  {
    id: "3544",
    id_polifenol: "6087",
    polifenol: "wogonin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "15",
    pmids:
      "16497434,20658136,18577379,28807161,19723047,25546119,25203554,18377421,16931628,17404065,27455661,24292576,15036470,23872129,29326123",
  },
  {
    id: "3545",
    id_polifenol: "4519",
    polifenol: "myricetin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "9",
    pmids:
      "15857606,10673981,18958421,27378425,20025993,21935971,17447850,27780135,21382914",
  },
  {
    id: "3546",
    id_polifenol: "4515",
    polifenol: "baicalin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "5",
    pmids: "16497434,11746275,23114120,12530012,29240303",
  },
  {
    id: "3547",
    id_polifenol: "4500",
    polifenol: "procyanidin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "4",
    pmids: "22297751,16828532,19418352,17616210",
  },
  {
    id: "3548",
    id_polifenol: "5608",
    polifenol: "epicatechin gallate",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "17081606",
  },
  {
    id: "3549",
    id_polifenol: "1356",
    polifenol: "gingerol",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "3",
    pmids: "10518003,10025876,15281225",
  },
  {
    id: "3550",
    id_polifenol: "54",
    polifenol: "Salicylic Acid",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "3",
    pmids: "22148584,18414055,8381329",
  },
  {
    id: "3551",
    id_polifenol: "98",
    polifenol: "Propofol",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "3",
    pmids: "23155237,24008596,15155335",
  },
  {
    id: "3552",
    id_polifenol: "5607",
    polifenol: "gallocatechol",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "3",
    pmids: "27803764,27348025,14563487",
  },
  {
    id: "3553",
    id_polifenol: "44",
    polifenol: "Salicylates",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "6",
    pmids: "16211252,12566069,16162967,17646662,8381329,7480156",
  },
  {
    id: "3554",
    id_polifenol: "4559",
    polifenol: "theaflavin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "22715906",
  },
  {
    id: "3555",
    id_polifenol: "5808",
    polifenol: "isoliquiritigenin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "4",
    pmids: "16158945,19110051,16675659,20023795",
  },
  {
    id: "3556",
    id_polifenol: "2344",
    polifenol: "methyl gallate",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "4",
    pmids: "18693020,19490839,19577552,11085375",
  },
  {
    id: "3557",
    id_polifenol: "4708",
    polifenol: "xanthohumol",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "4",
    pmids: "18952893,18790751,25771121,17823911",
  },
  {
    id: "3558",
    id_polifenol: "47",
    polifenol: "Mesalamine",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "15796154",
  },
  {
    id: "3559",
    id_polifenol: "2284",
    polifenol: "rosmarinic acid",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "10",
    pmids:
      "26476154,20397728,19619938,29932202,25636891,20449663,22593249,12391557,25239551,26797631",
  },
  {
    id: "3560",
    id_polifenol: "112",
    polifenol: "Hesperidin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "3",
    pmids: "19782062,26434864,21707429",
  },
  {
    id: "3561",
    id_polifenol: "6455",
    polifenol: "nobiletin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "4",
    pmids: "25164609,23106482,11216485,16606336",
  },
  {
    id: "3562",
    id_polifenol: "4513",
    polifenol: "galangin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "4",
    pmids: "23925650,23160683,15572302,12479854",
  },
  {
    id: "3563",
    id_polifenol: "6063",
    polifenol: "naringin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "2",
    pmids: "15744083,22732304",
  },
  {
    id: "3564",
    id_polifenol: "1380",
    polifenol: "shogaol",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "2",
    pmids: "24215632,29464796",
  },
  {
    id: "3565",
    id_polifenol: "2158",
    polifenol: "protocatechuic acid",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "3",
    pmids: "27492128,22792417,21291361",
  },
  {
    id: "3566",
    id_polifenol: "5489",
    polifenol: "delphinidin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "4",
    pmids: "12502387,12888907,20801663,27444805",
  },
  {
    id: "3567",
    id_polifenol: "6273",
    polifenol: "hesperetin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "20192247",
  },
  {
    id: "3568",
    id_polifenol: "1613",
    polifenol: "demethoxycurcumin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "2",
    pmids: "10969724,20032896",
  },
  {
    id: "3569",
    id_polifenol: "93",
    polifenol: "Phloroglucinol",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "8",
    pmids:
      "24041234,24605779,12061257,18539018,22253109,18556029,2236292,16791262",
  },
  {
    id: "3570",
    id_polifenol: "7550",
    polifenol: "3-methylquercetin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "3",
    pmids: "17447850,10563845,27150638",
  },
  {
    id: "3571",
    id_polifenol: "6461",
    polifenol: "acacetin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "7",
    pmids: "17345086,25203554,20804824,27455661,29066296,8567688,22732304",
  },
  {
    id: "3572",
    id_polifenol: "4253",
    polifenol:
      "5-(2,4-dihydroxy-5-isopropylphenyl)-4-(4-morpholin-4-ylmethylphenyl)isoxazole-3-carboxylic acid ethylamide",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "26112442",
  },
  {
    id: "3573",
    id_polifenol: "1611",
    polifenol: "bis(4-hydroxycinnamoyl)methane",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "2",
    pmids: "10969724,16008121",
  },
  {
    id: "3574",
    id_polifenol: "119",
    polifenol: "Silymarin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "3",
    pmids: "22532022,25849845,16949716",
  },
  {
    id: "3575",
    id_polifenol: "55",
    polifenol: "Sodium Salicylate",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "8",
    pmids:
      "16211252,15796154,12566069,18358453,15328418,17646662,8535405,24982346",
  },
  {
    id: "3576",
    id_polifenol: "5806",
    polifenol: "butein",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "3",
    pmids: "19560862,18806962,26676515",
  },
  {
    id: "3577",
    id_polifenol: "108",
    polifenol: "Biflavonoids",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "4",
    pmids: "26412425,27288921,12131922,18758121",
  },
  {
    id: "3578",
    id_polifenol: "969",
    polifenol: "3,4-dihydroxyphenacyl caffeate phenylpropanoid ester",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "4",
    pmids: "26376734,23892206,17295185,22253109",
  },
  {
    id: "3579",
    id_polifenol: "5844",
    polifenol: "4-dimethylamino-3',4'-dimethoxychalcone",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "3",
    pmids: "17442474,13677932,15072596",
  },
  {
    id: "3580",
    id_polifenol: "5819",
    polifenol: "licochalcone A",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "10953339",
  },
  {
    id: "3581",
    id_polifenol: "94",
    polifenol: "Phloretin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "7",
    pmids: "25229655,18158826,28427292,23907072,26646850,16906425,9458327",
  },
  {
    id: "3582",
    id_polifenol: "4560",
    polifenol: "icariin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "3",
    pmids: "14756686,29355456,10743057",
  },
  {
    id: "3583",
    id_polifenol: "48",
    polifenol: "Anacardic Acids",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "3",
    pmids: "18537201,25726174,24522270",
  },
  {
    id: "3584",
    id_polifenol: "5488",
    polifenol: "cyanidin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "3",
    pmids: "20801663,27444805,9720608",
  },
  {
    id: "3585",
    id_polifenol: "4640",
    polifenol: "5,7-dihydroxy-6-methoxy-2-phenylchromen-4-one",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "6",
    pmids: "19626645,29346508,10953322,27085528,12718578,15036470",
  },
  {
    id: "3586",
    id_polifenol: "4537",
    polifenol: "flavone acetic acid",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "6",
    pmids: "8313372,3351960,3653209,12392157,2370185,3422592",
  },
  {
    id: "3587",
    id_polifenol: "2773",
    polifenol: "farnesylthiosalicylic acid",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "19998334",
  },
  {
    id: "3588",
    id_polifenol: "80",
    polifenol: "Clofibrate",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "2",
    pmids: "2048221,1403680",
  },
  {
    id: "3589",
    id_polifenol: "1995",
    polifenol: "2-tert-butylhydroquinone",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "19158375",
  },
  {
    id: "3590",
    id_polifenol: "7546",
    polifenol: "isoquercitrin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "29066296",
  },
  {
    id: "3591",
    id_polifenol: "6482",
    polifenol: "tangeretin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "8519648",
  },
  {
    id: "3592",
    id_polifenol: "89",
    polifenol: "Vanillic Acid",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "5",
    pmids: "28427292,25667964,25753739,16198604,29066296",
  },
  {
    id: "3593",
    id_polifenol: "99",
    polifenol: "Pyrogallol",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "3",
    pmids: "12063567,10368308,21382914",
  },
  {
    id: "3594",
    id_polifenol: "452",
    polifenol: "acteoside",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "3",
    pmids: "20354949,23494816,22593249",
  },
  {
    id: "3595",
    id_polifenol: "1644",
    polifenol: "Cur1 compound",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "20857431",
  },
  {
    id: "3596",
    id_polifenol: "100",
    polifenol: "Resorcinols",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "2",
    pmids: "24494068,24605779",
  },
  {
    id: "3597",
    id_polifenol: "5614",
    polifenol: "catechin gallate",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "3",
    pmids: "12427485,17081606,28103249",
  },
  {
    id: "3598",
    id_polifenol: "1866",
    polifenol: "4,6-dinitro-o-cresol",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "3",
    pmids: "2553814,21306911,23064283",
  },
  {
    id: "3599",
    id_polifenol: "4486",
    polifenol: "amentoflavone",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "12131922",
  },
  {
    id: "3600",
    id_polifenol: "5850",
    polifenol: "cardamonin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "5",
    pmids: "25442273,11814858,9591187,20862963,12479853",
  },
  {
    id: "3601",
    id_polifenol: "118",
    polifenol: "Flavonolignans",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "2",
    pmids: "22532022,25667964",
  },
  {
    id: "3602",
    id_polifenol: "7541",
    polifenol: "taxifolin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "2",
    pmids: "20192247,22253109",
  },
  {
    id: "3603",
    id_polifenol: "60",
    polifenol: "2,4-Dinitrophenol",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "5",
    pmids: "19557357,19572256,28367714,21544360,2933415",
  },
  {
    id: "3604",
    id_polifenol: "7912",
    polifenol: "7,9,2',4'-tetrahydroxy-8-isopentenyl-5-methoxychalcone",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "3",
    pmids: "18952893,24901249,29627475",
  },
  {
    id: "3605",
    id_polifenol: "6465",
    polifenol: "genistin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "2",
    pmids: "15584372,22296272",
  },
  {
    id: "3606",
    id_polifenol: "350",
    polifenol: "nonylphenol",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "2",
    pmids: "27550319,20056579",
  },
  {
    id: "3607",
    id_polifenol: "2475",
    polifenol: "6-O-galloylglucose",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "3",
    pmids: "18693020,25633333,17081606",
  },
  {
    id: "3608",
    id_polifenol: "92",
    polifenol: "Triclosan",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "26204821",
  },
  {
    id: "3609",
    id_polifenol: "6097",
    polifenol: "8-prenylnaringenin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "3",
    pmids: "24443427,25771121,17715491",
  },
  {
    id: "3610",
    id_polifenol: "2447",
    polifenol: "beta-penta-O-galloyl-glucose",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "10554885",
  },
  {
    id: "3611",
    id_polifenol: "6068",
    polifenol: "pinocembrin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "20025279",
  },
  {
    id: "3612",
    id_polifenol: "1996",
    polifenol: "2,5-di-tert-butylhydroquinone",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "24079514",
  },
  {
    id: "3613",
    id_polifenol: "5071",
    polifenol: "icaritin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "23550021",
  },
  {
    id: "3614",
    id_polifenol: "6576",
    polifenol: "5,7,4'-trihydroxyflavone",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "23160683",
  },
  {
    id: "3615",
    id_polifenol: "6625",
    polifenol: "phenoxodiol",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "2",
    pmids: "17904534,19535345",
  },
  {
    id: "3616",
    id_polifenol: "6086",
    polifenol: "liquiritigenin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "27538012",
  },
  {
    id: "3617",
    id_polifenol: "1616",
    polifenol: "tetrahydrocurcumin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "2",
    pmids: "9617340,21928294",
  },
  {
    id: "3618",
    id_polifenol: "59",
    polifenol: "Dinitrophenols",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "9",
    pmids:
      "19572256,12970384,27679575,22586497,12865969,2897875,2933415,10582202,9001418",
  },
  {
    id: "3619",
    id_polifenol: "4516",
    polifenol: "diosmetin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "29066296",
  },
  {
    id: "3620",
    id_polifenol: "2328",
    polifenol: "syringic acid",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "2",
    pmids: "16198604,10879475",
  },
  {
    id: "3621",
    id_polifenol: "40",
    polifenol: "Propyl Gallate",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "2",
    pmids: "21112369,15036124",
  },
  {
    id: "3622",
    id_polifenol: "36",
    polifenol: "Hydroxybenzoates",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "3",
    pmids: "28427292,15796154,29389554",
  },
  {
    id: "3623",
    id_polifenol: "7134",
    polifenol: "vitexin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "2",
    pmids: "22941432,21432719",
  },
  {
    id: "3624",
    id_polifenol: "6558",
    polifenol: "7,3'-dihydroxy-4'-methoxyisoflavone",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "27210480",
  },
  {
    id: "3625",
    id_polifenol: "4796",
    polifenol: "aminoflavone",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "2",
    pmids: "22677031,24615985",
  },
  {
    id: "3626",
    id_polifenol: "4525",
    polifenol: "eupatilin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "2",
    pmids: "16393120,11551495",
  },
  {
    id: "3627",
    id_polifenol: "2490",
    polifenol: "punicalagin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "2",
    pmids: "24804028,19490839",
  },
  {
    id: "3628",
    id_polifenol: "5815",
    polifenol: "dibenzoylmethane",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "5",
    pmids: "21924245,15161016,10953322,17017982,9771944",
  },
  {
    id: "3629",
    id_polifenol: "7547",
    polifenol: "hyperoside",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "2",
    pmids: "25354548,24173369",
  },
  {
    id: "3630",
    id_polifenol: "5495",
    polifenol: "malvidin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "12502387",
  },
  {
    id: "3631",
    id_polifenol: "7141",
    polifenol: "apigetrin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "4",
    pmids: "22113421,24106661,21480518,17485840",
  },
  {
    id: "3632",
    id_polifenol: "637",
    polifenol: "glabridin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "24901249",
  },
  {
    id: "3633",
    id_polifenol: "6301",
    polifenol: "3-methoxyflavone",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "2",
    pmids: "22185222,23481040",
  },
  {
    id: "3634",
    id_polifenol: "77",
    polifenol: "Bezafibrate",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "3",
    pmids: "27493727,18923439,27347458",
  },
  {
    id: "3635",
    id_polifenol: "1810",
    polifenol: "heminordihydroguaiaretic acid",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "3",
    pmids: "9258337,15958646,17454637",
  },
  {
    id: "3636",
    id_polifenol: "6477",
    polifenol: "hispidulin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "16864455",
  },
  {
    id: "3637",
    id_polifenol: "6510",
    polifenol: "glycitein",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "2",
    pmids: "11642314,22296272",
  },
  {
    id: "3638",
    id_polifenol: "128",
    polifenol: "Pterocarpans",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "3",
    pmids: "27210480,28189086,29656660",
  },
  {
    id: "3639",
    id_polifenol: "7557",
    polifenol: "rhamnetin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "16864455",
  },
  {
    id: "3640",
    id_polifenol: "6456",
    polifenol: "daidzin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "24324516",
  },
  {
    id: "3641",
    id_polifenol: "1353",
    polifenol: "protocatechualdehyde",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "11297806",
  },
  {
    id: "3642",
    id_polifenol: "4501",
    polifenol: "tricin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "4",
    pmids: "24628411,25667964,29066296,16001171",
  },
  {
    id: "3643",
    id_polifenol: "4883",
    polifenol: "flavokawain B",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "2",
    pmids: "29715098,25641429",
  },
  {
    id: "3644",
    id_polifenol: "5496",
    polifenol: "pelargonidin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "2",
    pmids: "20801663,22405976",
  },
  {
    id: "3645",
    id_polifenol: "6066",
    polifenol: "eriodictyol",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "27538012",
  },
  {
    id: "3646",
    id_polifenol: "353",
    polifenol: "sesamol",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "2",
    pmids: "11297806,20510349",
  },
  {
    id: "3647",
    id_polifenol: "6452",
    polifenol: "chrysoeriol",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "2",
    pmids: "24628411,15132542",
  },
  {
    id: "3648",
    id_polifenol: "4480",
    polifenol: "myricitrin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "27492128",
  },
  {
    id: "3649",
    id_polifenol: "5794",
    polifenol: "2'-hydroxychalcone",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "2",
    pmids: "16781454,25091929",
  },
  {
    id: "3650",
    id_polifenol: "7377",
    polifenol: "astragalin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "18958421",
  },
  {
    id: "3651",
    id_polifenol: "4521",
    polifenol: "3-hydroxyflavone",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "3",
    pmids: "20577025,17870050,22770910",
  },
  {
    id: "3652",
    id_polifenol: "413",
    polifenol: "4-nonylphenol",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "27550319",
  },
  {
    id: "3653",
    id_polifenol: "3489",
    polifenol: "anethole",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "15313406",
  },
  {
    id: "3654",
    id_polifenol: "1672",
    polifenol: "B19 monocarbonyl curcumin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "28439094",
  },
  {
    id: "3655",
    id_polifenol: "6554",
    polifenol: "tectorigenin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "11642314",
  },
  {
    id: "3656",
    id_polifenol: "4715",
    polifenol: "ampelopsin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "2",
    pmids: "19280145,20428031",
  },
  {
    id: "3657",
    id_polifenol: "6800",
    polifenol: "3,6-dimethoxy-6'',6''-dimethylchromeno(2'',3''-7,8)flavone",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "23907072",
  },
  {
    id: "3658",
    id_polifenol: "5831",
    polifenol: "angoletin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "2",
    pmids: "20232614,17243725",
  },
  {
    id: "3659",
    id_polifenol: "6693",
    polifenol: "2',4',7-trihydroxyisoflavone",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "15584372",
  },
  {
    id: "3660",
    id_polifenol: "885",
    polifenol: "oleocanthal",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "27086914",
  },
  {
    id: "3661",
    id_polifenol: "6129",
    polifenol: "wogonoside",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "26387984",
  },
  {
    id: "3662",
    id_polifenol: "6175",
    polifenol: "2'-hydroxyflavanone",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "24734951",
  },
  {
    id: "3663",
    id_polifenol: "6112",
    polifenol: "alpinetin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "2",
    pmids: "25442273,20862963",
  },
  {
    id: "3664",
    id_polifenol: "6770",
    polifenol: "5-hydroxy-3,6,7,8,3',4'-hexamethoxyflavone",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "2",
    pmids: "17536822,17391969",
  },
  {
    id: "3665",
    id_polifenol: "2283",
    polifenol: "depsidone",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "2",
    pmids: "19230943,15386197",
  },
  {
    id: "3666",
    id_polifenol: "6457",
    polifenol: "salvigenin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "20804824",
  },
  {
    id: "3667",
    id_polifenol: "1747",
    polifenol: "6-paradol",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "4",
    pmids: "10518003,11551496,10025876,15281225",
  },
  {
    id: "3668",
    id_polifenol: "2697",
    polifenol: "4-trifluoromethylsalicylic acid",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "18951802",
  },
  {
    id: "3669",
    id_polifenol: "5005",
    polifenol: "procyanidin B",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "2",
    pmids: "12837490,16198231",
  },
  {
    id: "3670",
    id_polifenol: "12",
    polifenol: "Guaiacol",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "3",
    pmids: "15761374,22356159,19084262",
  },
  {
    id: "3671",
    id_polifenol: "2790",
    polifenol: "ginkgolic acid",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "22380770",
  },
  {
    id: "3672",
    id_polifenol: "357",
    polifenol: "4-aminophenol",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "2",
    pmids: "12417027,16203149",
  },
  {
    id: "3673",
    id_polifenol: "2343",
    polifenol: "ethyl gallate",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "23109891",
  },
  {
    id: "3674",
    id_polifenol: "704",
    polifenol: "trizol",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "18837321",
  },
  {
    id: "3675",
    id_polifenol: "2331",
    polifenol: "8-(N,N-diethylamino)octyl-3,4,5-trimethoxybenzoate",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "9398053",
  },
  {
    id: "3676",
    id_polifenol: "4052",
    polifenol: "bis-(3-(3',5'-di-tert-butyl-4'-hydroxyphenyl)propyl)sulfide",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "23452983",
  },
  {
    id: "3677",
    id_polifenol: "4578",
    polifenol: "5,7-dimethoxyflavone",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "3",
    pmids: "22185222,26704713,10563845",
  },
  {
    id: "3678",
    id_polifenol: "9",
    polifenol: "1,2-Dihydroxybenzene-3,5-Disulfonic Acid Disodium Salt",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "2",
    pmids: "29700286,18568337",
  },
  {
    id: "3679",
    id_polifenol: "6100",
    polifenol: "pinostrobin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "3",
    pmids: "25442273,22495442,20862963",
  },
  {
    id: "3680",
    id_polifenol: "347",
    polifenol: "4-nitrophenyl",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "2",
    pmids: "21801146,25445037",
  },
  {
    id: "3681",
    id_polifenol: "6774",
    polifenol: "5,7-dihydroxy-6,3',4'-trimethoxyflavone",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "2",
    pmids: "16393120,11551495",
  },
  {
    id: "3682",
    id_polifenol: "1918",
    polifenol: "2,6-di-tert-butyl-4-(aminomethyl)phenol hydrochloride",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "26774931",
  },
  {
    id: "3683",
    id_polifenol: "5875",
    polifenol: "panduratin A",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "22864999",
  },
  {
    id: "3684",
    id_polifenol: "4839",
    polifenol: "7-hydroxyflavone",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "2",
    pmids: "17218638,18552875",
  },
  {
    id: "3685",
    id_polifenol: "428",
    polifenol: "2,2'-bisphenol F",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "12888907",
  },
  {
    id: "3686",
    id_polifenol: "4573",
    polifenol: "3,3',4',5,6,7,8-heptamethoxyflavone",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "20862963",
  },
  {
    id: "3687",
    id_polifenol: "4639",
    polifenol: "aromadedrin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "22253109",
  },
  {
    id: "3688",
    id_polifenol: "3258",
    polifenol: "tesmilifene",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "2",
    pmids: "22390767,1930176",
  },
  {
    id: "3689",
    id_polifenol: "4549",
    polifenol: "casticin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "2",
    pmids: "16087636,12828478",
  },
  {
    id: "3690",
    id_polifenol: "6453",
    polifenol: "cirsimaritin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "2",
    pmids: "22004952,20804824",
  },
  {
    id: "3691",
    id_polifenol: "4553",
    polifenol: "sulfuretin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "22492309",
  },
  {
    id: "3692",
    id_polifenol: "70",
    polifenol: "Sulfobromophthalein",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "8914844",
  },
  {
    id: "3693",
    id_polifenol: "6549",
    polifenol: "7-hydroxy-2',3',4',5',8-pentamethoxyisoflavan",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "3",
    pmids: "27210480,10953322,28110438",
  },
  {
    id: "3694",
    id_polifenol: "1662",
    polifenol: "BDMC-A",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "27889234",
  },
  {
    id: "3695",
    id_polifenol: "5858",
    polifenol: "isobavachalcone",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "2",
    pmids: "26547532,29880605",
  },
  {
    id: "3696",
    id_polifenol: "6008",
    polifenol: "millepachine",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "22784822",
  },
  {
    id: "3697",
    id_polifenol: "4632",
    polifenol: "ginkgetin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "28902633",
  },
  {
    id: "3698",
    id_polifenol: "5245",
    polifenol: "BF6-6 biflavone",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "28839377",
  },
  {
    id: "3699",
    id_polifenol: "839",
    polifenol: "5-iodo-3-((3,5-dibromo-4-hydroxyphenyl)methylene)-2-indolinone",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "25817574",
  },
  {
    id: "3700",
    id_polifenol: "6076",
    polifenol: "vexibinol",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "23962443",
  },
  {
    id: "3701",
    id_polifenol: "2504",
    polifenol: "pentagalloylglucose",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "2",
    pmids: "14726525,12781329",
  },
  {
    id: "3702",
    id_polifenol: "2",
    polifenol: "Aminophenols",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "3",
    pmids: "12417027,17092729,16203149",
  },
  {
    id: "3703",
    id_polifenol: "6287",
    polifenol: "neohesperidin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "19782062",
  },
  {
    id: "3704",
    id_polifenol: "4544",
    polifenol: "tiliroside",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "2",
    pmids: "26655407,22593249",
  },
  {
    id: "3705",
    id_polifenol: "416",
    polifenol: "phenoxy radical",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "4",
    pmids: "20023915,11319278,10569638,17870050",
  },
  {
    id: "3706",
    id_polifenol: "1675",
    polifenol: "catechol estrogen 3,4-quinone",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "17169809",
  },
  {
    id: "3707",
    id_polifenol: "5289",
    polifenol: "8-bromo-7-methoxychrysin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "21785114",
  },
  {
    id: "3708",
    id_polifenol: "1718",
    polifenol: "dihydroguaiaretic acid",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "9619854",
  },
  {
    id: "3709",
    id_polifenol: "4703",
    polifenol: "eupatorin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "25390937",
  },
  {
    id: "3710",
    id_polifenol: "2471",
    polifenol: "oenothein B",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "10403559",
  },
  {
    id: "3711",
    id_polifenol: "7422",
    polifenol: "kaempferide",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "24443427",
  },
  {
    id: "3712",
    id_polifenol: "962",
    polifenol: "2,6-di-tert-butyl-4-methylphenol",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "2",
    pmids: "14704326,19084262",
  },
  {
    id: "3713",
    id_polifenol: "2173",
    polifenol: "atranorin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "20837130",
  },
  {
    id: "3714",
    id_polifenol: "1754",
    polifenol: "gigantol",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "28844931",
  },
  {
    id: "3715",
    id_polifenol: "5063",
    polifenol: "4',7-dihydroxy-3'-methoxy-5'-prenylflavanone",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "17715491",
  },
  {
    id: "3716",
    id_polifenol: "6687",
    polifenol: "3'-dimethylaminoflavone",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "3",
    pmids: "22185222,15571862,20594863",
  },
  {
    id: "3717",
    id_polifenol: "6459",
    polifenol: "genkwanin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "2",
    pmids: "20397728,22004952",
  },
  {
    id: "3718",
    id_polifenol: "529",
    polifenol: "4-octylphenol",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "20056579",
  },
  {
    id: "3719",
    id_polifenol: "1883",
    polifenol: "2-amino-5-methylphenol",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "11297267",
  },
  {
    id: "3720",
    id_polifenol: "5814",
    polifenol: "2',4'-dihydroxychalcone",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "11814858",
  },
  {
    id: "3721",
    id_polifenol: "5303",
    polifenol: "3,6-dihydroxyflavone",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "20840847",
  },
  {
    id: "3722",
    id_polifenol: "52",
    polifenol: "Diflunisal",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "26320814",
  },
  {
    id: "3723",
    id_polifenol: "1630",
    polifenol: "dimethoxycurcumin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "27588609",
  },
  {
    id: "3724",
    id_polifenol: "6711",
    polifenol: "3',4'-dimethoxyflavone",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "29630880",
  },
  {
    id: "3725",
    id_polifenol: "4548",
    polifenol: "artemetin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "16087636",
  },
  {
    id: "3726",
    id_polifenol: "3040",
    polifenol:
      "4-(3-thioxo-3H-1,2-dithiol-5-yl)phenyl 2-((4-(nitrooxy)butanoyl)oxy)benzoate",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "22916316",
  },
  {
    id: "3727",
    id_polifenol: "2159",
    polifenol: "2,3-dihydroxybenzoic acid",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "3",
    pmids: "3518597,19101573,8381329",
  },
  {
    id: "3728",
    id_polifenol: "7478",
    polifenol: "kaempferol-7-methyl ether",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "16864455",
  },
  {
    id: "3729",
    id_polifenol: "6555",
    polifenol: "tectoridin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "11642314",
  },
  {
    id: "3730",
    id_polifenol: "3944",
    polifenol: "myrtucommulone A",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "26386573",
  },
  {
    id: "3731",
    id_polifenol: "4082",
    polifenol: "3,3',4,4',5,5'-hexahydroxystilbene",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "3",
    pmids: "17065056,16982330,24398169",
  },
  {
    id: "3732",
    id_polifenol: "6031",
    polifenol: "2',3'-dimethoxyflavanone",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "2",
    pmids: "22495442,21351299",
  },
  {
    id: "3733",
    id_polifenol: "7149",
    polifenol: "5,7,4'-trimethylapigenin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "22185222",
  },
  {
    id: "3734",
    id_polifenol: "4263",
    polifenol: "amurensin G",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "2",
    pmids: "22483777,19280145",
  },
  {
    id: "3735",
    id_polifenol: "7778",
    polifenol: "medicarpin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "3",
    pmids: "24628411,27210480,26598918",
  },
  {
    id: "3736",
    id_polifenol: "7633",
    polifenol: "tamarixetin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "2",
    pmids: "23765509,26851174",
  },
  {
    id: "3737",
    id_polifenol: "4534",
    polifenol: "3,5,6-trihydroxy-4',7'-dimethoxyflavone",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "10499128",
  },
  {
    id: "3738",
    id_polifenol: "2484",
    polifenol: "chebulinic acid",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "14769215",
  },
  {
    id: "3739",
    id_polifenol: "1867",
    polifenol: "creosol",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "2",
    pmids: "27432798,11319278",
  },
  {
    id: "3740",
    id_polifenol: "6492",
    polifenol: "3(2H)-isoflavene",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "2",
    pmids: "17904534,19535345",
  },
  {
    id: "3741",
    id_polifenol: "6786",
    polifenol: "8-hydroxy-3,4',5,6,7-pentamethoxyflavone",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "17391969",
  },
  {
    id: "3742",
    id_polifenol: "5669",
    polifenol: "pro-F-EGCG2",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "19325839",
  },
  {
    id: "3743",
    id_polifenol: "393",
    polifenol: "2,6-di-tert-butylphenol",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "2",
    pmids: "22356159,19084262",
  },
  {
    id: "3744",
    id_polifenol: "418",
    polifenol: "thiophenol",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "8642556",
  },
  {
    id: "3745",
    id_polifenol: "1451",
    polifenol: "hispolon",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "26056942",
  },
  {
    id: "3746",
    id_polifenol: "6587",
    polifenol: "glycitin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "11642314",
  },
  {
    id: "3747",
    id_polifenol: "4073",
    polifenol: "myristicin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "21472076",
  },
  {
    id: "3748",
    id_polifenol: "1262",
    polifenol: "4-dodecylaminophenol",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "17092729",
  },
  {
    id: "3749",
    id_polifenol: "101",
    polifenol: "Hexylresorcinol",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "2796389",
  },
  {
    id: "3750",
    id_polifenol: "4675",
    polifenol: "3'-methoxy-4'-nitroflavone",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "17823287",
  },
  {
    id: "3751",
    id_polifenol: "6647",
    polifenol: "6-methylflavone",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "2",
    pmids: "23877923,8567688",
  },
  {
    id: "3752",
    id_polifenol: "4297",
    polifenol: "curvularin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "25913704",
  },
  {
    id: "3753",
    id_polifenol: "1725",
    polifenol: "yakuchinone-A",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "2",
    pmids: "10518003,10517978",
  },
  {
    id: "3754",
    id_polifenol: "7879",
    polifenol: "4-hydroxyderricin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "21263202",
  },
  {
    id: "3755",
    id_polifenol: "6291",
    polifenol: "alpinumisoflavone",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "27288921",
  },
  {
    id: "3756",
    id_polifenol: "6485",
    polifenol: "3',4',7-trihydroxyisoflavone",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "24324516",
  },
  {
    id: "3757",
    id_polifenol: "4103",
    polifenol: "gnetin H",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "2",
    pmids: "19280145,24832111",
  },
  {
    id: "3758",
    id_polifenol: "2332",
    polifenol: "lauryl gallate",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "11085375",
  },
  {
    id: "3759",
    id_polifenol: "2290",
    polifenol: "lobaric acid",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "2",
    pmids: "15549672,9504441",
  },
  {
    id: "3760",
    id_polifenol: "2066",
    polifenol: "NSC 680410",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "4",
    pmids: "16956884,12451475,20618971,12827297",
  },
  {
    id: "3761",
    id_polifenol: "4524",
    polifenol: "5-hydroxy-3',4',6,7-tetramethoxyflavone",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "2",
    pmids: "26704713,24148842",
  },
  {
    id: "3762",
    id_polifenol: "4244",
    polifenol: "malabaricone A",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "2",
    pmids: "26032963,26141757",
  },
  {
    id: "3763",
    id_polifenol: "4158",
    polifenol: "malabaricone C",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "29336005",
  },
  {
    id: "3764",
    id_polifenol: "4579",
    polifenol: "hinokiflavone",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "17311236",
  },
  {
    id: "3765",
    id_polifenol: "5791",
    polifenol: "metochalcone",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "2",
    pmids: "23524161,25057485",
  },
  {
    id: "3766",
    id_polifenol: "3362",
    polifenol: "bastadin 4",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "16520655",
  },
  {
    id: "3767",
    id_polifenol: "6654",
    polifenol: "5,2',4'-trihydroxy-6,7,5'-trimethoxyflavone",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "28110438",
  },
  {
    id: "3768",
    id_polifenol: "689",
    polifenol: "3,4-dixydroxyphenylethanol elenolic acid",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "21805082",
  },
  {
    id: "3769",
    id_polifenol: "3646",
    polifenol: "1,5-bis(2-methoxyphenyl)penta-1,4-dien-3-one",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "22709867",
  },
  {
    id: "3770",
    id_polifenol: "1821",
    polifenol: "2,4-D n-butyl ester",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "2",
    pmids: "17190444,22789709",
  },
  {
    id: "3771",
    id_polifenol: "4482",
    polifenol: "peflavit",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "20577025",
  },
  {
    id: "3772",
    id_polifenol: "7560",
    polifenol: "quercetin-3-O-neohesperidose",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "1625476",
  },
  {
    id: "3773",
    id_polifenol: "6752",
    polifenol: "zapotin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "2",
    pmids: "17228877,11497257",
  },
  {
    id: "3774",
    id_polifenol: "5465",
    polifenol: "vitexin-2-O-xyloside",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "27719921",
  },
  {
    id: "3775",
    id_polifenol: "7803",
    polifenol: "LQB 118",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "2",
    pmids: "24794748,29692266",
  },
  {
    id: "3776",
    id_polifenol: "3058",
    polifenol: "2,5-dihydroxybenzoic acid",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "17328533",
  },
  {
    id: "3777",
    id_polifenol: "4820",
    polifenol: "3,7-dihydroxyflavone",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "2",
    pmids: "15572302,18552875",
  },
  {
    id: "3778",
    id_polifenol: "6067",
    polifenol: "carthamidin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "24443427",
  },
  {
    id: "3779",
    id_polifenol: "1556",
    polifenol: "olvanil",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "10785541",
  },
  {
    id: "3780",
    id_polifenol: "1566",
    polifenol: "arvanil",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "10785541",
  },
  {
    id: "3781",
    id_polifenol: "1804",
    polifenol: "guaiacylglycerol-beta-coniferyl ether",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "22253109",
  },
  {
    id: "3782",
    id_polifenol: "184",
    polifenol: "trilobatin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "25229655",
  },
  {
    id: "3783",
    id_polifenol: "6938",
    polifenol: "5,7,3'-trihydroxy-3,4'-dimethoxyflavone",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "2",
    pmids: "20175127,21229608",
  },
  {
    id: "3784",
    id_polifenol: "4689",
    polifenol: "5,3'-dihydroxy-3,6,7,8,4'-pentamethoxyflavone",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "7623025",
  },
  {
    id: "3785",
    id_polifenol: "5145",
    polifenol: "artonin B",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "16923337",
  },
  {
    id: "3786",
    id_polifenol: "5910",
    polifenol: "3'-formyl-4',6'-dihydroxy-2'-methoxy-5'-methylchalcone",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "17430639",
  },
  {
    id: "3787",
    id_polifenol: "3605",
    polifenol: "lyoniresinol",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "22253109",
  },
  {
    id: "3788",
    id_polifenol: "322",
    polifenol: "N-methyl-4-aminophenol",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "3",
    pmids: "12417027,16203149,20023915",
  },
  {
    id: "3789",
    id_polifenol: "5974",
    polifenol: "4'-hydroxychalcone",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "21703248",
  },
  {
    id: "3790",
    id_polifenol: "1417",
    polifenol: "1,2-dihydroxy-4'-chlorobiphenyl",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "17681423",
  },
  {
    id: "3791",
    id_polifenol: "6830",
    polifenol: "artocarpesin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "26547532",
  },
  {
    id: "3792",
    id_polifenol: "2531",
    polifenol: "sanguiin H-5",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "19490839",
  },
  {
    id: "3793",
    id_polifenol: "2022",
    polifenol: "1,4-naphthohydroquinone",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "24368029",
  },
  {
    id: "3794",
    id_polifenol: "7196",
    polifenol: "nepitrin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "20397728",
  },
  {
    id: "3795",
    id_polifenol: "5143",
    polifenol: "fustin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "28103742",
  },
  {
    id: "3796",
    id_polifenol: "7204",
    polifenol: "5,7,3',4'-tetramethylluteolin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "12828478",
  },
  {
    id: "3797",
    id_polifenol: "1453",
    polifenol: "4-nerolidylcatechol",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "28644062",
  },
  {
    id: "3798",
    id_polifenol: "7027",
    polifenol: "chrysosplenol D",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "16087636",
  },
  {
    id: "3799",
    id_polifenol: "165",
    polifenol: "r2-viniferin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "19280145",
  },
  {
    id: "3800",
    id_polifenol: "361",
    polifenol: "2-aminophenol",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "17555822",
  },
  {
    id: "3801",
    id_polifenol: "5481",
    polifenol: "cyanidin-3-glycoside",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "22412883",
  },
  {
    id: "3802",
    id_polifenol: "5533",
    polifenol: "cyanidin-3-O-beta-glucopyranoside",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "16224184",
  },
  {
    id: "3803",
    id_polifenol: "1625",
    polifenol: "curcumin III",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "10969724",
  },
  {
    id: "3804",
    id_polifenol: "6766",
    polifenol: "glaziovianin A",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "2",
    pmids: "26423865,17428663",
  },
  {
    id: "3805",
    id_polifenol: "392",
    polifenol: "2-tert-butylphenol",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "2",
    pmids: "22356159,19084262",
  },
  {
    id: "3806",
    id_polifenol: "521",
    polifenol: "E 7010",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "2",
    pmids: "9654112,8137285",
  },
  {
    id: "3807",
    id_polifenol: "7492",
    polifenol:
      "kaempferol 3-O-(3'',6''-di-O-E-p-coumaroyl)-beta-D-glucopyranoside",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "22593249",
  },
  {
    id: "3808",
    id_polifenol: "1993",
    polifenol: "hydroxyhydroquinone",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "10368308",
  },
  {
    id: "3809",
    id_polifenol: "2486",
    polifenol: "1,3,6-tri-O-galloylglucopyranose",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "25633333",
  },
  {
    id: "3810",
    id_polifenol: "2607",
    polifenol: "amorfrutin A",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "29369787",
  },
  {
    id: "3811",
    id_polifenol: "2090",
    polifenol: "10'(Z),13'(E),15'(E)-heptadecatrienylhydroquinone",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "2",
    pmids: "23088786,25140305",
  },
  {
    id: "3812",
    id_polifenol: "6832",
    polifenol: "2'-nitroflavone",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "22555195",
  },
  {
    id: "3813",
    id_polifenol: "4195",
    polifenol: "climacostol",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "18723007",
  },
  {
    id: "3814",
    id_polifenol: "3371",
    polifenol:
      "5-(3-(3-(4-phenoxy-2-propylphenoxy)propoxy)phenyl)-2,4-thiazolidinedione",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "19671747",
  },
  {
    id: "3815",
    id_polifenol: "6109",
    polifenol: "sophoraflavanone A",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "23962443",
  },
  {
    id: "3816",
    id_polifenol: "6664",
    polifenol: "8-hydroxydaidzein",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "10879475",
  },
  {
    id: "3817",
    id_polifenol: "6164",
    polifenol: "euchrestaflavanone B",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "24443427",
  },
  {
    id: "3818",
    id_polifenol: "6704",
    polifenol: "4-hydroxylonchocarpin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "2",
    pmids: "21800276,29656660",
  },
  {
    id: "3819",
    id_polifenol: "1423",
    polifenol: "Cancell",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "22412883",
  },
  {
    id: "3820",
    id_polifenol: "2402",
    polifenol: "digalloylresveratrol",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "22132974",
  },
  {
    id: "3821",
    id_polifenol: "6686",
    polifenol: "3',5'-dimethoxyflavone",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "22185222",
  },
  {
    id: "3822",
    id_polifenol: "5046",
    polifenol: "4'-methoxyflavone",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "22185222",
  },
  {
    id: "3823",
    id_polifenol: "5792",
    polifenol: "4,4'-dihydroxychalcone",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "12479853",
  },
  {
    id: "3824",
    id_polifenol: "7209",
    polifenol: "luteolin 3'-glucuronide",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "20397728",
  },
  {
    id: "3825",
    id_polifenol: "1738",
    polifenol: "dehydroparadol",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "11551496",
  },
  {
    id: "3826",
    id_polifenol: "292",
    polifenol: "3-dimethylaminophenol",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "21801146",
  },
  {
    id: "3827",
    id_polifenol: "4219",
    polifenol: "baeomycesic acid",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "15549672",
  },
  {
    id: "3828",
    id_polifenol: "7066",
    polifenol: "diethyl flavon-7-yl phosphate",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "2",
    pmids: "22677031,24615985",
  },
  {
    id: "3829",
    id_polifenol: "2548",
    polifenol: "1,2,6-tri-O-galloyl-beta-D-glucopyranose",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "25633333",
  },
  {
    id: "3830",
    id_polifenol: "940",
    polifenol: "2-t-butyl-5-(4-t-butylphenyl)phenol",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "22356159",
  },
  {
    id: "3831",
    id_polifenol: "5549",
    polifenol: "luteolinidin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "17227050",
  },
  {
    id: "3832",
    id_polifenol: "5507",
    polifenol: "apigeninidin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "17227050",
  },
  {
    id: "3833",
    id_polifenol: "6349",
    polifenol: "ME-344",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "27391350",
  },
  {
    id: "3834",
    id_polifenol: "335",
    polifenol: "2,4,6-tri-tert-butylphenol",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "19084262",
  },
  {
    id: "3835",
    id_polifenol: "2423",
    polifenol: "ethyl O-beta-(6'-O-galloyl)-glucopyranoside",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "25633333",
  },
  {
    id: "3836",
    id_polifenol: "6152",
    polifenol: "5,7,4',5'',7'',3''',4'''-heptahydroxy(3-8'')biflavanone",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "18758121",
  },
  {
    id: "3837",
    id_polifenol: "4072",
    polifenol: "elemicin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "20958014",
  },
  {
    id: "3838",
    id_polifenol: "6134",
    polifenol: "7,8-dihydroxyflavanone",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "14577694",
  },
  {
    id: "3839",
    id_polifenol: "5099",
    polifenol: "(2R,3S)-3',4',5,7-tetrahydroxyflavan-3-yl octadecanoate",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "16460233",
  },
  {
    id: "3840",
    id_polifenol: "6562",
    polifenol: "6''-O-xylosyltectoridin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "11642314",
  },
  {
    id: "3841",
    id_polifenol: "6188",
    polifenol: "cudraflavanone A",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "2",
    pmids: "17704652,17613819",
  },
  {
    id: "3842",
    id_polifenol: "5718",
    polifenol: "4'-hydroxy-2',6'-dimethoxychalcone",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "25442273",
  },
  {
    id: "3843",
    id_polifenol: "5381",
    polifenol: "gancaonin Q",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "21800276",
  },
  {
    id: "3844",
    id_polifenol: "5382",
    polifenol: "6-prenylapigenin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "21800276",
  },
  {
    id: "3845",
    id_polifenol: "4999",
    polifenol: "6,8-diprenyleriodictyol",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "21800276",
  },
  {
    id: "3846",
    id_polifenol: "3917",
    polifenol: "2,4-diacetylphloroglucinol",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "26833196",
  },
  {
    id: "3847",
    id_polifenol: "768",
    polifenol: "eupomatenoid 5",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "21391177",
  },
  {
    id: "3848",
    id_polifenol: "7075",
    polifenol: "3,5,7,3',4'-pentamethoxyflavone",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "22185222",
  },
  {
    id: "3849",
    id_polifenol: "6674",
    polifenol: "5,6,2',3',6'-pentamethoxyflavone",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "22185222",
  },
  {
    id: "3850",
    id_polifenol: "4192",
    polifenol: "geoditin A",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "2",
    pmids: "20161972,22412813",
  },
  {
    id: "3851",
    id_polifenol: "4906",
    polifenol: "sophoranone",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "12115492",
  },
  {
    id: "3852",
    id_polifenol: "4595",
    polifenol: "2-(2-phenylethyl)chromone",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "26784520",
  },
  {
    id: "3853",
    id_polifenol: "6785",
    polifenol: "3',4',7-trimethoxyflavone",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "17345086",
  },
  {
    id: "3854",
    id_polifenol: "5339",
    polifenol: "2S,3S-3,5,7,3',5'-pentahydroxyflavane",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "21277955",
  },
  {
    id: "3855",
    id_polifenol: "5340",
    polifenol: "2R,3R-3,5,6,7,8,4'-hexahydroxyflavane",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "21277955",
  },
  {
    id: "3856",
    id_polifenol: "171",
    polifenol: "p-decylaminophenol",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "17092729",
  },
  {
    id: "3857",
    id_polifenol: "5724",
    polifenol: "3,2'-dihydroxy-4',6'-dimethoxychalcone",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "2",
    pmids: "25442273,22495442",
  },
  {
    id: "3858",
    id_polifenol: "6937",
    polifenol: "ladanein",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "20397728",
  },
  {
    id: "3859",
    id_polifenol: "7342",
    polifenol: "irisdichotin A",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "10499128",
  },
  {
    id: "3860",
    id_polifenol: "1337",
    polifenol: "3,3',4,4'-tetrahydroxystilbene",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "24398169",
  },
  {
    id: "3861",
    id_polifenol: "7699",
    polifenol:
      "quercetin-3-O-beta-D-apiofuranosyl-(1-2)-beta-D-galactopyranosyl-7-O-beta-D-glucopyranoside",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "22899608",
  },
  {
    id: "3862",
    id_polifenol: "3588",
    polifenol: "niranthin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "17054045",
  },
  {
    id: "3863",
    id_polifenol: "2626",
    polifenol: "sulfosalicylic acid",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "15796154",
  },
  {
    id: "3864",
    id_polifenol: "5602",
    polifenol: "meciadanol",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "17328920",
  },
  {
    id: "3865",
    id_polifenol: "4637",
    polifenol: "agathisflavone",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "12131922",
  },
  {
    id: "3866",
    id_polifenol: "3798",
    polifenol: "n-hexyl vanillate",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "23811288",
  },
  {
    id: "3867",
    id_polifenol: "6292",
    polifenol: "tricin 4'-O-(threo-beta-guaiacylglyceryl) ether",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "25667964",
  },
  {
    id: "3868",
    id_polifenol: "6293",
    polifenol: "tricin 4'-O-(erythro-beta-guaiacylglyceryl) ether",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "25667964",
  },
  {
    id: "3869",
    id_polifenol: "5115",
    polifenol: "vestitol",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "27210480",
  },
  {
    id: "3870",
    id_polifenol: "5116",
    polifenol: "betuletol 3-methyl ether",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "2",
    pmids: "19676104,16949071",
  },
  {
    id: "3871",
    id_polifenol: "5800",
    polifenol: "chalcone epoxide",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "21816519",
  },
  {
    id: "3872",
    id_polifenol: "7561",
    polifenol: "3,7-dimethoxy-5,3',4'-trihydroxyflavone",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "28294989",
  },
  {
    id: "3873",
    id_polifenol: "2229",
    polifenol: "gamma-resorcylic acid",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "18537201",
  },
  {
    id: "3874",
    id_polifenol: "3993",
    polifenol: "4-geranyloxy-1-(2-methylpropanoyl)phloroglucinol",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "29627475",
  },
  {
    id: "3875",
    id_polifenol: "2361",
    polifenol: "tellimagrandin I",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "14757314",
  },
  {
    id: "3876",
    id_polifenol: "2086",
    polifenol: "epoxyquinol A",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "16360644",
  },
  {
    id: "3877",
    id_polifenol: "6003",
    polifenol: "boesenbergin A",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "23432947",
  },
  {
    id: "3878",
    id_polifenol: "2848",
    polifenol: "3-methoxysalicylic acid",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "16024637",
  },
  {
    id: "3879",
    id_polifenol: "5140",
    polifenol: "5-hydroxy-6,7-dimethoxyflavone",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "21351299",
  },
  {
    id: "3880",
    id_polifenol: "6538",
    polifenol: "cirsimarin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "20804824",
  },
  {
    id: "3881",
    id_polifenol: "2095",
    polifenol: "farnesyl-O-acetylhydroquinone",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "14643448",
  },
  {
    id: "3882",
    id_polifenol: "1146",
    polifenol: "4-allyl-2-methoxy-6-(2-methylbut-3-en-2-yl)phenol",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "11319278",
  },
  {
    id: "3883",
    id_polifenol: "4612",
    polifenol: "pseudosemiglabrin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "24608571",
  },
  {
    id: "3884",
    id_polifenol: "4992",
    polifenol: "acacetin-7-O-glucoside",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "22732304",
  },
  {
    id: "3885",
    id_polifenol: "6918",
    polifenol: "6-hydroxygenistein-7-O-beta-D-glucopyranoside",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "10879475",
  },
  {
    id: "3886",
    id_polifenol: "3851",
    polifenol: "methyl triclosan",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "26204821",
  },
  {
    id: "3887",
    id_polifenol: "6913",
    polifenol: "6,2',4'-trimethoxyflavone",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "11497257",
  },
  {
    id: "3888",
    id_polifenol: "5998",
    polifenol: "17-methoxyl-7-hydroxy-benzene-furanchalcone",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "22700048",
  },
  {
    id: "3889",
    id_polifenol: "1058",
    polifenol: "cycloolivil",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "10499128",
  },
  {
    id: "3890",
    id_polifenol: "7408",
    polifenol: "kaempferol 3-O-neohesperidoside",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "10499128",
  },
  {
    id: "3891",
    id_polifenol: "4685",
    polifenol: "robustaflavone-7''-methyl ether",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "18758121",
  },
  {
    id: "3892",
    id_polifenol: "5194",
    polifenol: "dorsilurin F",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "29066296",
  },
  {
    id: "3893",
    id_polifenol: "3926",
    polifenol: "mallotojaponin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "2236292",
  },
  {
    id: "3894",
    id_polifenol: "3454",
    polifenol: "3,5-dibromo-2-(3,5-dibromo-2-methoxyphenoxy)phenol",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "2",
    pmids: "8567688,22709867",
  },
  {
    id: "3895",
    id_polifenol: "345",
    polifenol: "2,4,6-trichlorophenol",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "2796389",
  },
  {
    id: "3896",
    id_polifenol: "2060",
    polifenol: "2-(10-heptadecenyl)-1,4-hydroquinone",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "23088786",
  },
  {
    id: "3897",
    id_polifenol: "7067",
    polifenol: "III-10",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "26164795",
  },
  {
    id: "3898",
    id_polifenol: "4825",
    polifenol: "7,4'-dihydroxy-8-methylflavone",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "23877923",
  },
  {
    id: "3899",
    id_polifenol: "7054",
    polifenol: "2'-methoxy-6-methylflavone",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "23877923",
  },
  {
    id: "3900",
    id_polifenol: "6792",
    polifenol: "6,2'-dihydroxyflavone",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "20840847",
  },
  {
    id: "3901",
    id_polifenol: "783",
    polifenol: "2,6-diprenyl-4-iodophenol",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "26594764",
  },
  {
    id: "3902",
    id_polifenol: "1512",
    polifenol: "3-(8',11'-pentadecadienyl)catechol",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "19429311",
  },
  {
    id: "3903",
    id_polifenol: "4208",
    polifenol: "sorbicillin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "26189301",
  },
  {
    id: "3904",
    id_polifenol: "5001",
    polifenol: "dorsmanin F",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "26141760",
  },
  {
    id: "3905",
    id_polifenol: "5732",
    polifenol: "poinsettifolin B",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "26141760",
  },
  {
    id: "3906",
    id_polifenol: "6319",
    polifenol: "5,6-dihydroxy-7-prenyloxyflavone",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "24398107",
  },
  {
    id: "3907",
    id_polifenol: "6320",
    polifenol: "3-hydroxy-7-geranyloxyflavone",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "24398107",
  },
  {
    id: "3908",
    id_polifenol: "3440",
    polifenol: "acerogenin A",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "22899608",
  },
  {
    id: "3909",
    id_polifenol: "4746",
    polifenol: "sophoflavescenol",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "22210035",
  },
  {
    id: "3910",
    id_polifenol: "5286",
    polifenol:
      "5,4'-dihydroxy-7,8-((3''-hydroxy-4''-one)-2'',2''-dimethylpyrano)flavone",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "26655407",
  },
  {
    id: "3911",
    id_polifenol: "7136",
    polifenol: "apigenin 6,8-digalactoside",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "26180533",
  },
  {
    id: "3912",
    id_polifenol: "5372",
    polifenol: "penduletin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "16087636",
  },
  {
    id: "3913",
    id_polifenol: "2532",
    polifenol: "tannin 1-alpha-O-galloylpunicalagin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "19490839",
  },
  {
    id: "3914",
    id_polifenol: "6072",
    polifenol: "3'-prenylnaringenin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "24443427",
  },
  {
    id: "3915",
    id_polifenol: "3607",
    polifenol: "1-(3,.4-dimethoxyphenyl)-3,5-dodecenedione",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "15927254",
  },
  {
    id: "3916",
    id_polifenol: "1726",
    polifenol: "gingerdione",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "15927254",
  },
  {
    id: "3917",
    id_polifenol: "2926",
    polifenol:
      "4-(N-(4-cyclohexylbenzyl)-2-(N,2,4,6-tetramethylphenylsulfonamido)acetamido)-2-hydroxybenzoic acid",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "22148584",
  },
  {
    id: "3918",
    id_polifenol: "1394",
    polifenol: "nitecapone",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "8019435",
  },
  {
    id: "3919",
    id_polifenol: "3481",
    polifenol: "N-(1'-naphthyl)-3,4,5-trimethoxybenzohydrazide",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "25951294",
  },
  {
    id: "3920",
    id_polifenol: "7265",
    polifenol: "3',4'-dibenzyloxyflavonol",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "28235426",
  },
  {
    id: "3921",
    id_polifenol: "602",
    polifenol: "pyoluteorin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "25535900",
  },
  {
    id: "3922",
    id_polifenol: "1525",
    polifenol: "3-hydroxy-1-(4'-hydroxy-3'-methoxy-phenyl)-hexan-5-one",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "10953322",
  },
  {
    id: "3923",
    id_polifenol: "1402",
    polifenol: "2,4-dihydroxybenzylamine",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "11297806",
  },
  {
    id: "3924",
    id_polifenol: "1705",
    polifenol: "hylin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "20696583",
  },
  {
    id: "3925",
    id_polifenol: "4206",
    polifenol: "5-(2'-oxoheptadecyl)resorcinol",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "12562085",
  },
  {
    id: "3926",
    id_polifenol: "4207",
    polifenol: "5-(2'-oxononadecyl)resorcinol",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "12562085",
  },
  {
    id: "3927",
    id_polifenol: "4372",
    polifenol:
      "quercetin 3-O-alpha-rhamnopyranoside-7-O-beta-D-glucopyranosyl-(1-3)-alpha-L-rhamnopyranoside",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "7623025",
  },
  {
    id: "3928",
    id_polifenol: "3131",
    polifenol: "mycophenolic adenine dinucleotide",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "24269162",
  },
  {
    id: "3929",
    id_polifenol: "6174",
    polifenol: "(2S)-8-formyl-5-hydroxy-7-methoxy-6-methylflavanone",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "17430639",
  },
  {
    id: "3930",
    id_polifenol: "391",
    polifenol: "dinitrophenyl-bovine serum albumin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "25516374",
  },
  {
    id: "3931",
    id_polifenol: "1034",
    polifenol: "hericenone J",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "25306354",
  },
  {
    id: "3932",
    id_polifenol: "7082",
    polifenol: "ayanin diacetate",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "23063980",
  },
  {
    id: "3933",
    id_polifenol: "5959",
    polifenol:
      "(2E)-3-(2-naphtyl)-1-(3'-methoxy-4'-hydroxy-phenyl)-2-propen-1-one",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "20796191",
  },
  {
    id: "3934",
    id_polifenol: "4180",
    polifenol: "1-(2,6-dihydroxy-4-methoxyphenyl)hexan-1-one",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "10528134",
  },
  {
    id: "3935",
    id_polifenol: "650",
    polifenol: "(2,4,6-trihydroxyphenyl)-1-hexan-1-one",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "10528134",
  },
  {
    id: "3936",
    id_polifenol: "2734",
    polifenol: "Listerine",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "29777637",
  },
  {
    id: "3937",
    id_polifenol: "2337",
    polifenol: "M3OMG",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "20862963",
  },
  {
    id: "3938",
    id_polifenol: "7441",
    polifenol: "kaempferol-3-O-(6'',4''-di-p-coumaroyl)mannopyranoside",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "22593249",
  },
  {
    id: "3939",
    id_polifenol: "1588",
    polifenol:
      "2- ((4-hydroxy-3,5-dimethylphenyl)methylidene)-5-((3-methoxy-4,5-dimethylphenyl)methylidene)cyclopentan-1-one",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "28258688",
  },
  {
    id: "3940",
    id_polifenol: "4849",
    polifenol: "3',5,7-trihydoxy-3,4',5'-trimethoxyflavone",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "16864455",
  },
  {
    id: "3941",
    id_polifenol: "4855",
    polifenol: "5,7,3',4'-tetrahydroxy-3-methoxy flavone",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "16864455",
  },
  {
    id: "3942",
    id_polifenol: "4818",
    polifenol: "C-glucosylflavone",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "20804824",
  },
  {
    id: "3943",
    id_polifenol: "7009",
    polifenol: "5-O-beta-D-glucopyranosyl cirsimaritin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "20804824",
  },
  {
    id: "3944",
    id_polifenol: "7010",
    polifenol: "5,4'-O-beta-D-diglucopyranosyl cirsimaritin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "20804824",
  },
  {
    id: "3945",
    id_polifenol: "4535",
    polifenol: "LM 985",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "3653209",
  },
  {
    id: "3946",
    id_polifenol: "3530",
    polifenol: "3',4-O-dimethylcedrusin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "29715541",
  },
  {
    id: "3947",
    id_polifenol: "5829",
    polifenol: "1-phenyl-1,2-propanedione",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "29623853",
  },
  {
    id: "3948",
    id_polifenol: "6719",
    polifenol: "pedalitin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "12391557",
  },
  {
    id: "3949",
    id_polifenol: "7580",
    polifenol: "quercetin-3-(6''-galloyl)glucoside",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "25633333",
  },
  {
    id: "3950",
    id_polifenol: "3505",
    polifenol: "1,4-dimethoxybenzene",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "25239700",
  },
  {
    id: "3951",
    id_polifenol: "6471",
    polifenol: "dichotomitin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "29656660",
  },
  {
    id: "3952",
    id_polifenol: "6474",
    polifenol: "irisone B",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "29656660",
  },
  {
    id: "3953",
    id_polifenol: "6900",
    polifenol: "daidzein-7-O-beta-D-glucoside",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "22296272",
  },
  {
    id: "3954",
    id_polifenol: "2094",
    polifenol: "geranyl-O-acetylhydroquinone",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "14643448",
  },
  {
    id: "3955",
    id_polifenol: "7052",
    polifenol: "(3S)-5-guaiacyl-3-hydroxypentanoic acid",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "22253109",
  },
  {
    id: "3956",
    id_polifenol: "4924",
    polifenol: "6-methylapigenin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "25239551",
  },
  {
    id: "3957",
    id_polifenol: "2019",
    polifenol: "1,4-diacetoxy-2,3-dicyanobenzene",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "2486910",
  },
  {
    id: "3958",
    id_polifenol: "1051",
    polifenol: "yashabushidiol",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "19410455",
  },
  {
    id: "3959",
    id_polifenol: "652",
    polifenol: "2-O-methylpyrogallol",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "20958014",
  },
  {
    id: "3960",
    id_polifenol: "6867",
    polifenol: "echioidinin 2'-O-beta-D-(2''-O-acetyl)glucopyranoside",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "26488879",
  },
  {
    id: "3961",
    id_polifenol: "3121",
    polifenol: "ethyl O-(N-(4-carboxyphenyl)carbamoyl)mycophenolate",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "7274650",
  },
  {
    id: "3962",
    id_polifenol: "5837",
    polifenol: "2',3-dihydroxychalcone",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "16781454",
  },
  {
    id: "3963",
    id_polifenol: "5341",
    polifenol: "2R,3R-3,5,6,7,8,3',5'-heptahydroxyflavane",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "21277955",
  },
  {
    id: "3964",
    id_polifenol: "4348",
    polifenol:
      "(2R,3S)-guibourtinidol-3-O-alpha-D-apiofuranosyl-(1-6)-O-beta-D-glucopyranoside",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "27538012",
  },
  {
    id: "3965",
    id_polifenol: "5625",
    polifenol: "fisetinidol-(4alpha-8)catechin 3-gallate",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "27538012",
  },
  {
    id: "3966",
    id_polifenol: "5180",
    polifenol: "2,2'',3,3''-tetrahydrorobustaflavone 7,4',7''-trimethyl ether",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "18758121",
  },
  {
    id: "3967",
    id_polifenol: "6511",
    polifenol: "duartin",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "28110438",
  },
  {
    id: "3968",
    id_polifenol: "6516",
    polifenol: "8-methoxyvestitol",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "28110438",
  },
  {
    id: "3969",
    id_polifenol: "7488",
    polifenol: "palmatoside C",
    id_cancer: "559",
    cancer: "Leukemia",
    quant: "1",
    pmids: "21081856",
  },
  {
    id: "3970",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "179",
    pmids:
      "24337903,27176768,24223706,20372819,27588401,29680738,25866363,17672346,21199322,23661153,24068521,25256427,21944925,28720813,26164795,28245170,25820747,28240161,23026832,27347080,27509965,20091746,29656183,28655996,29049999,21730822,26439681,28638884,22138516,18978810,16458870,23294370,26118776,24587153,22526619,19994890,25698902,21803068,18038912,29328481,27130644,21093431,15545229,22684543,15104235,24127655,29720833,23619285,26675844,28101238,17202857,17996228,29481769,29541427,24997323,24036141,19719238,28768515,15058208,28366538,21660680,23172681,12617611,25084411,28950682,27078842,23835921,26628295,24692698,19473757,29394494,24333668,22687553,19110045,26180625,28245756,22560876,25681471,29303970,26194866,21067180,26075245,26557713,25915649,18184547,22749133,25754378,23957358,28336971,26209062,26311153,9862414,29348766,27396915,25476160,9381980,19958256,27261613,21674787,29636773,24977707,24632069,26109775,26314304,27013795,24359777,20850954,15661813,17961621,7887960,26943884,27766389,23901654,17056790,28903343,23159065,24717393,15924350,17430639,21861846,28560391,23452983,28726775,17981005,22452660,24910406,18980244,29382035,24692702,29137246,17227049,29191453,17590382,15713544,27782823,28177238,27488610,27685909,26084155,23293751,29407981,24250510,10625944,25720342,20558139,21328458,18828600,26176582,24676882,15735088,21812646,16054198,17520098,26104578,29175112,29541715,26520390,16751978,24124108,19655416,28747003,26792956,28178217,29749314,22287334,27981754,21595573,28886426,27236067,29179521,22123201,26929587,18379113,26845136,25779384,26919160,29735893,24568488,14510590",
  },
  {
    id: "3971",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "105",
    pmids:
      "19777212,24716979,29495104,22292626,18039573,28769986,8844727,29545895,20712901,26585812,29616245,23821378,23446753,12628514,26409325,29901164,16880289,20372861,22606206,21514382,21901145,28991167,26458588,28833603,26482853,27999817,29312546,22362715,26108226,27234697,23886196,28455219,20878089,18782044,24692720,17922140,25883212,29899871,18379992,20813175,23118928,28992682,26452516,28188823,23216691,25195681,25728027,27895800,28766664,19956448,29552121,25622075,28338175,25268357,9764849,26707143,27165229,21556896,14657599,24314310,23225435,25937435,29753013,25770771,28281678,29766185,17261774,25757271,18161303,29615146,20818158,25565818,23299930,23808828,16543625,18395899,25519685,22189271,29866017,18602917,29901131,24627632,24508477,26346750,27354595,25202424,26745072,21713389,26321746,21347788,23560895,25793208,28179291,29703084,18305414,26515460,24114697,16151260,29730175,22711176,22776359,10657978,24399876,25371072,22197969",
  },
  {
    id: "3972",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "72",
    pmids:
      "25634350,24839007,26935808,24377565,22676643,28769986,18767070,25256427,27627922,27478384,17988825,12594540,28868867,11408926,19627199,16481065,19269153,28833603,26482853,28768515,23225439,27078842,26075245,17583686,23957358,29204075,28075467,28501492,24892721,15661813,25714249,25607726,21888504,17056790,1786398,19073162,23159065,29552121,24433880,23835774,17317271,23452983,20561930,21935971,26208293,12143244,18627786,28194107,27782823,15248026,22754316,15158750,28795692,25927469,15713052,22496613,19655416,18629614,23642645,26446263,21595573,28130850,26929587,15161234,23530632,17465444,19588362,24511000,24172305,29068700,24985107,22521445",
  },
  {
    id: "3973",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "73",
    pmids:
      "23741254,19148542,25683703,28722351,18989579,27107695,26316083,21621522,28627696,17464209,29656183,24247909,26851630,25245054,17604322,19773433,17673346,23448150,16458870,11533045,23354417,25002834,12906713,20515942,22761917,16925113,20014456,12745093,15027120,16636681,15659801,29695559,11981761,21738655,18822689,29800569,22314224,17272514,24520095,16533420,11279606,28572744,24168056,17526808,12663499,22543708,23630579,19115422,26351820,29678550,21241664,20799280,26059188,23345412,21507240,15037655,21878748,29436591,17013836,28731137,26657209,17483345,20937224,29620227,21952585,23942851,21391228,28904859,21056072,11532983,11050045,25572615,28867541",
  },
  {
    id: "3974",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "45",
    pmids:
      "23741254,24243709,24433534,12628514,19497411,27597132,16458870,14757171,19994890,11108802,29541427,29387674,19842228,28950682,20574925,26180625,16309237,19617819,29286617,12791511,16924424,9381980,29951358,24632069,17391909,10470366,17961621,16425425,11334858,27656602,10484680,17006617,18047476,18847459,28926527,10625944,25781341,14968209,21078540,10330684,16054198,23621233,8212077,16117624,14510590",
  },
  {
    id: "3975",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "62",
    pmids:
      "25820747,25009654,28259895,12628514,16458870,28521254,25619802,17044776,26675844,28768515,19838948,26628295,29394494,29899871,16963249,20377179,26311153,29069736,9381980,19958256,12508355,24632069,27013795,10470366,7887960,26943884,17056790,26320505,29163752,9042300,22452660,18980244,20561930,23240061,29747752,9343925,24250510,10625944,29866017,18828600,29901131,21590187,15735088,16054198,15713052,17520098,22358425,17305494,23197198,24124108,20651919,22335904,27067032,28178217,16117624,23184534,27142812,16707620,28778140,24797908,18276086,16965672",
  },
  {
    id: "3976",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "46",
    pmids:
      "21199322,12595758,25370579,16731755,12628514,19360302,24465696,20514403,19558547,24402647,24127655,16445947,22221825,16481065,19269153,28389416,24033329,27349173,15087027,11525605,15161008,10996728,23863984,26018505,28423656,29715531,19020784,21538846,17317271,14981928,17404067,26241688,11064004,24213313,12143244,19003330,15272226,19003122,26189955,14998086,17905686,15158750,24508477,21372039,16117624,27507654",
  },
  {
    id: "3977",
    id_polifenol: "2167",
    polifenol: "phenolic acid",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "36",
    pmids:
      "28656311,16276977,28768515,12617611,27078842,25554642,29303970,26194866,23957358,27396915,26109775,27013795,27235722,21888504,26320505,28480370,28338175,17404067,20561930,28194107,15272226,27685909,27094513,18828600,29901131,21812646,22253109,29541715,26792956,28178217,27981754,6704970,21595573,3934671,12570342,15627257",
  },
  {
    id: "3978",
    id_polifenol: "49",
    polifenol: "Aspirin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "28",
    pmids:
      "12628514,9683177,11981761,29408091,21617849,22322725,12671717,22179060,23611778,25061736,21722632,23703473,29925918,12700412,12576442,23741443,29286113,14729655,28959630,12223145,22799330,12452016,27236067,28857200,14720322,28900541,12417048,26607439",
  },
  {
    id: "3979",
    id_polifenol: "109",
    polifenol: "Catechin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "31",
    pmids:
      "28350090,12628514,24465696,16458870,12594540,19994890,20514403,19627199,16925113,15087027,23954456,11525605,10996728,21538846,26320505,17317271,11064004,17227049,20862963,28194107,23772110,21081808,15248026,18828600,23365670,15713052,15570050,15161234,23530632,25789501,19588362",
  },
  {
    id: "3980",
    id_polifenol: "125",
    polifenol: "Isoflavones",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "14",
    pmids:
      "14757171,15990314,29541427,28950682,27470322,19617819,23353737,12791511,17391909,18047476,28926527,26586395,23621233,15072585",
  },
  {
    id: "3981",
    id_polifenol: "110",
    polifenol: "Chalcones",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "25",
    pmids:
      "19875299,24629450,26854643,24466137,28038941,26907262,29655687,25743216,25461322,15806415,20043079,26068427,15666170,25499988,23895019,27371926,28219046,25973027,28242551,22358425,29175112,26792956,26061105,20068129,28778140",
  },
  {
    id: "3982",
    id_polifenol: "3089",
    polifenol: "1,1-diphenyl-2-picrylhydrazyl",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "28",
    pmids:
      "25213932,12628514,12594540,22354161,29771951,16029005,26109775,29333382,23892206,22074239,27343853,17430639,23452983,23841520,26929583,17590382,20397109,23927480,27399668,19418352,25659675,25969171,22722977,19655416,27601844,29734113,29735893,29155395",
  },
  {
    id: "3983",
    id_polifenol: "114",
    polifenol: "Apigenin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "20",
    pmids:
      "29680738,21756884,25820747,24116276,18038912,21515330,23537747,22086925,25554642,27203387,26314304,20850954,17961621,15924350,19830248,29137246,29191453,23563091,28408212,12643593",
  },
  {
    id: "3984",
    id_polifenol: "113",
    polifenol: "Flavones",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "19",
    pmids:
      "24377565,28240165,15990314,23537747,28320429,22086925,29771951,22359269,15924350,28480370,28839377,27094513,24631140,10529006,28104392,21554863,25522535,26792956,27601844",
  },
  {
    id: "3985",
    id_polifenol: "38",
    polifenol: "Gallic Acid",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "22",
    pmids:
      "28350090,12594540,28521254,28768515,15161008,26320505,14981928,25849560,23841520,20561930,27782823,27685909,21687936,21081808,21812646,28987363,22253109,18629614,11256479,15161234,27822913,23627273",
  },
  {
    id: "3986",
    id_polifenol: "117",
    polifenol: "Luteolin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "15",
    pmids:
      "24287949,25820747,29049999,16458870,24333668,22749133,19342156,16029005,24167130,26314304,27013795,26375549,12643593,22902823,29199881",
  },
  {
    id: "3987",
    id_polifenol: "1",
    polifenol: "Phenols",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "13",
    pmids:
      "12628514,28656311,18571350,24880485,26929583,27782823,21812646,1725501,26792956,28130850,11256479,29735893,20668399",
  },
  {
    id: "3988",
    id_polifenol: "105",
    polifenol: "Anthocyanins",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "13",
    pmids:
      "24377565,15740068,18723493,27235722,21888504,19857058,29800916,21216582,22213170,28886426,21103079,22873220,18839539",
  },
  {
    id: "3989",
    id_polifenol: "7235",
    polifenol: "silybin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "16",
    pmids:
      "18978810,18599034,29755557,24386256,29782854,25834802,23260576,24692702,21328458,27685914,29866017,17484885,16076518,27540518,29179521,29068700",
  },
  {
    id: "3990",
    id_polifenol: "129",
    polifenol: "Rotenone",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "15",
    pmids:
      "12628514,21356207,17671207,20574925,26157141,29458170,18847459,26173068,25448047,29402287,26133123,23206332,24732427,25779384,15157275",
  },
  {
    id: "3991",
    id_polifenol: "121",
    polifenol: "Kaempferols",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "9",
    pmids:
      "25820747,29771951,27013795,17961621,23159065,20558139,28178217,28754304,15161234",
  },
  {
    id: "3992",
    id_polifenol: "871",
    polifenol: "ABT-737",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "9",
    pmids:
      "22609455,25297967,23284992,28486557,20647330,20799354,26707143,29543705,27099439",
  },
  {
    id: "3993",
    id_polifenol: "6451",
    polifenol: "daidzein",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "5",
    pmids: "24513878,12791511,24487643,18047476,16401387",
  },
  {
    id: "3994",
    id_polifenol: "6065",
    polifenol: "baicalein",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "22",
    pmids:
      "29970718,22484589,28351032,24039823,16458870,21803068,19724907,22684543,23619285,24596136,29481769,26548344,26209062,29039470,19150384,29729190,11525598,21597696,7954360,8275481,8869751,28747003",
  },
  {
    id: "3995",
    id_polifenol: "7",
    polifenol: "Capsaicin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "8",
    pmids:
      "29152112,27043357,22200406,15190937,24941670,29188798,15272226,9298712",
  },
  {
    id: "3996",
    id_polifenol: "4634",
    polifenol: "alvocidib",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "6",
    pmids: "16820931,15715961,26603262,29287727,25989942,24851111",
  },
  {
    id: "3997",
    id_polifenol: "120",
    polifenol: "Flavonols",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "14",
    pmids:
      "23925650,12594540,24161691,20377179,19958256,28480370,11351248,27094513,17905686,16765054,19655416,26792956,28178217,28130850",
  },
  {
    id: "3998",
    id_polifenol: "4522",
    polifenol: "chrysin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "10",
    pmids:
      "21199322,24431896,27347080,28320429,22086925,22687553,27461522,23970349,20862963,21554863",
  },
  {
    id: "3999",
    id_polifenol: "123",
    polifenol: "Rutin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "8",
    pmids:
      "29204075,20578533,20862963,24250510,28628229,19655416,27981754,18276086",
  },
  {
    id: "4000",
    id_polifenol: "6062",
    polifenol: "naringenin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "15",
    pmids:
      "25866363,23661153,19994890,15545229,26675844,23172681,26194866,18248513,11800169,21674787,17961621,19830248,20862963,26446263,16117624",
  },
  {
    id: "4001",
    id_polifenol: "285",
    polifenol: "bisphenol A",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "2",
    pmids: "11800169,10854714",
  },
  {
    id: "4002",
    id_polifenol: "39",
    polifenol: "Hydrolyzable Tannins",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "4",
    pmids: "24377565,21319227,27782823,26792956",
  },
  {
    id: "4003",
    id_polifenol: "130",
    polifenol: "Proanthocyanidins",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "4",
    pmids: "15870845,25849560,20397109,24568488",
  },
  {
    id: "4004",
    id_polifenol: "35",
    polifenol: "Hydroquinones",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "8",
    pmids:
      "23088786,19589234,15025504,26973386,23093860,11035251,3934671,24997295",
  },
  {
    id: "4005",
    id_polifenol: "111",
    polifenol: "Flavanones",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "5",
    pmids: "21790499,26194866,18323457,10854714,23895019",
  },
  {
    id: "4006",
    id_polifenol: "4502",
    polifenol: "fisetin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "4",
    pmids: "28560391,11351248,15735088,26682000",
  },
  {
    id: "4007",
    id_polifenol: "6",
    polifenol: "Catechols",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "2",
    pmids: "22129592,3934671",
  },
  {
    id: "4008",
    id_polifenol: "25",
    polifenol: "Butylated Hydroxytoluene",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "7",
    pmids: "21400508,28768515,9851254,6704970,19657451,12570342,3040652",
  },
  {
    id: "4009",
    id_polifenol: "75",
    polifenol: "Butylated Hydroxyanisole",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "6",
    pmids: "19728331,22922425,23271722,23247010,12570342,3040652",
  },
  {
    id: "4010",
    id_polifenol: "15",
    polifenol: "Masoprocol",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "5",
    pmids: "9683177,10692565,3476847,2804913,24648164",
  },
  {
    id: "4011",
    id_polifenol: "6087",
    polifenol: "wogonin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "7",
    pmids: "23294370,22086925,23835921,29439451,21597696,8275481,23859016",
  },
  {
    id: "4012",
    id_polifenol: "4519",
    polifenol: "myricetin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "5",
    pmids: "20617691,21935971,26104578,28178217,26919160",
  },
  {
    id: "4013",
    id_polifenol: "4515",
    polifenol: "baicalin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "6",
    pmids: "22200845,21803068,21597696,7954360,8275481,25700642",
  },
  {
    id: "4014",
    id_polifenol: "4500",
    polifenol: "procyanidin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "6",
    pmids: "12594540,21081808,16828532,19418352,22227333,24568488",
  },
  {
    id: "4015",
    id_polifenol: "5608",
    polifenol: "epicatechin gallate",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "6",
    pmids: "20514403,19627199,15087027,11525605,19003122,15161234",
  },
  {
    id: "4016",
    id_polifenol: "1356",
    polifenol: "gingerol",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "3",
    pmids: "20521273,27399668,23964455",
  },
  {
    id: "4017",
    id_polifenol: "54",
    polifenol: "Salicylic Acid",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "4",
    pmids: "28185215,27824091,27163172,14729655",
  },
  {
    id: "4018",
    id_polifenol: "98",
    polifenol: "Propofol",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "3",
    pmids: "28565871,23742776,25292173",
  },
  {
    id: "4019",
    id_polifenol: "5607",
    polifenol: "gallocatechol",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "3",
    pmids: "11525605,17404067,19003122",
  },
  {
    id: "4020",
    id_polifenol: "5578",
    polifenol: "alpha-naphthoflavone",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "13",
    pmids:
      "6406051,1329656,22749133,7669069,11849049,12791542,10529006,12396873,4027374,3030825,16412531,8637871,2492107",
  },
  {
    id: "4021",
    id_polifenol: "44",
    polifenol: "Salicylates",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "12700412",
  },
  {
    id: "4022",
    id_polifenol: "4559",
    polifenol: "theaflavin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "8",
    pmids:
      "27478384,11525605,10996728,17227049,19003122,15248026,25927469,23530632",
  },
  {
    id: "4023",
    id_polifenol: "5808",
    polifenol: "isoliquiritigenin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "8",
    pmids:
      "19994890,26101703,26159926,16562858,12762787,20068129,23624327,14510590",
  },
  {
    id: "4024",
    id_polifenol: "2344",
    polifenol: "methyl gallate",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "4",
    pmids: "28350090,19360302,16481065,28778140",
  },
  {
    id: "4025",
    id_polifenol: "4708",
    polifenol: "xanthohumol",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "4",
    pmids: "26718026,20043079,17981005,17590382",
  },
  {
    id: "4026",
    id_polifenol: "2284",
    polifenol: "rosmarinic acid",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "2",
    pmids: "29864622,25455894",
  },
  {
    id: "4027",
    id_polifenol: "112",
    polifenol: "Hesperidin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "6",
    pmids: "20138977,19110045,26194866,24977707,29100031,28130850",
  },
  {
    id: "4028",
    id_polifenol: "6455",
    polifenol: "nobiletin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "3",
    pmids: "23537747,22549898,23818450",
  },
  {
    id: "4029",
    id_polifenol: "10",
    polifenol: "Estrogens, Catechol",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "4",
    pmids: "12119004,12791542,22129592,3030825",
  },
  {
    id: "4030",
    id_polifenol: "4513",
    polifenol: "galangin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "4",
    pmids: "23925650,25698902,24161691,28938520",
  },
  {
    id: "4031",
    id_polifenol: "6063",
    polifenol: "naringin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "2",
    pmids: "27509965,26194866",
  },
  {
    id: "4032",
    id_polifenol: "1380",
    polifenol: "shogaol",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "6",
    pmids: "22768104,28110870,17263498,26101062,20521273,27399668",
  },
  {
    id: "4033",
    id_polifenol: "2158",
    polifenol: "protocatechuic acid",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "3",
    pmids: "8504418,28987363,15165144",
  },
  {
    id: "4034",
    id_polifenol: "5489",
    polifenol: "delphinidin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "2",
    pmids: "15740068,21103079",
  },
  {
    id: "4035",
    id_polifenol: "6273",
    polifenol: "hesperetin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "3",
    pmids: "19830248,26520390,27069325",
  },
  {
    id: "4036",
    id_polifenol: "93",
    polifenol: "Phloroglucinol",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "5",
    pmids: "28190473,27221859,23454824,25476160,22253109",
  },
  {
    id: "4037",
    id_polifenol: "6454",
    polifenol: "formononetin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "2",
    pmids: "19994890,28234915",
  },
  {
    id: "4038",
    id_polifenol: "81",
    polifenol: "Fenofibrate",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "5",
    pmids: "21514001,12498734,29134746,26155222,17118139",
  },
  {
    id: "4039",
    id_polifenol: "7550",
    polifenol: "3-methylquercetin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "2",
    pmids: "16765054,28178217",
  },
  {
    id: "4040",
    id_polifenol: "6461",
    polifenol: "acacetin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "2",
    pmids: "15104235,28336971",
  },
  {
    id: "4041",
    id_polifenol: "107",
    polifenol: "beta-Naphthoflavone",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "11",
    pmids:
      "27402199,21362431,15371557,10611146,2166952,1340765,3934671,22687991,3297657,15627257,27914986",
  },
  {
    id: "4042",
    id_polifenol: "119",
    polifenol: "Silymarin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "7",
    pmids: "19317806,9862414,19150384,26011349,21466434,24348760,18339886",
  },
  {
    id: "4043",
    id_polifenol: "55",
    polifenol: "Sodium Salicylate",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "2",
    pmids: "15289360,26415823",
  },
  {
    id: "4044",
    id_polifenol: "5806",
    polifenol: "butein",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "5",
    pmids: "21770460,20515942,29777095,29670376,21131551",
  },
  {
    id: "4045",
    id_polifenol: "108",
    polifenol: "Biflavonoids",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "3",
    pmids: "21915931,18379113,24304383",
  },
  {
    id: "4046",
    id_polifenol: "5509",
    polifenol: "cyanidin 3-O-glucoside",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "2",
    pmids: "29800916,24985107",
  },
  {
    id: "4047",
    id_polifenol: "969",
    polifenol: "3,4-dihydroxyphenacyl caffeate phenylpropanoid ester",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "3",
    pmids: "27396915,23892206,22253109",
  },
  {
    id: "4048",
    id_polifenol: "5844",
    polifenol: "4-dimethylamino-3',4'-dimethoxychalcone",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "9862856",
  },
  {
    id: "4049",
    id_polifenol: "6463",
    polifenol: "puerarin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "25364405",
  },
  {
    id: "4050",
    id_polifenol: "5819",
    polifenol: "licochalcone A",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "2",
    pmids: "24337903,24466137",
  },
  {
    id: "4051",
    id_polifenol: "94",
    polifenol: "Phloretin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "4",
    pmids: "18767070,19123483,26633321,29866017",
  },
  {
    id: "4052",
    id_polifenol: "4560",
    polifenol: "icariin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "3",
    pmids: "14756686,23975599,19938223",
  },
  {
    id: "4053",
    id_polifenol: "48",
    polifenol: "Anacardic Acids",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "2",
    pmids: "23128090,24853302",
  },
  {
    id: "4054",
    id_polifenol: "5488",
    polifenol: "cyanidin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "15740068",
  },
  {
    id: "4055",
    id_polifenol: "4640",
    polifenol: "5,7-dihydroxy-6-methoxy-2-phenylchromen-4-one",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "9",
    pmids:
      "19626645,19100732,23612020,22526619,19473757,22560876,28726775,19585117,26259145",
  },
  {
    id: "4056",
    id_polifenol: "2773",
    polifenol: "farnesylthiosalicylic acid",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "2",
    pmids: "24848877,21621522",
  },
  {
    id: "4057",
    id_polifenol: "80",
    polifenol: "Clofibrate",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "13",
    pmids:
      "10200566,23028936,9674879,9207284,8625460,2489351,8472324,12663131,12127257,17437637,23811191,2860980,1906850",
  },
  {
    id: "4058",
    id_polifenol: "132",
    polifenol: "Equol",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "24487643",
  },
  {
    id: "4059",
    id_polifenol: "1995",
    polifenol: "2-tert-butylhydroquinone",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "5",
    pmids: "22275372,2166952,20650352,3934671,15627257",
  },
  {
    id: "4060",
    id_polifenol: "1673",
    polifenol: "4-hydroxyestradiol",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "12791542",
  },
  {
    id: "4061",
    id_polifenol: "7546",
    polifenol: "isoquercitrin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "5",
    pmids: "23318833,24680176,23474136,24676882,20033131",
  },
  {
    id: "4062",
    id_polifenol: "6482",
    polifenol: "tangeretin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "2",
    pmids: "23537747,22549898",
  },
  {
    id: "4063",
    id_polifenol: "89",
    polifenol: "Vanillic Acid",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "2",
    pmids: "27235722,27981754",
  },
  {
    id: "4064",
    id_polifenol: "99",
    polifenol: "Pyrogallol",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "27110278",
  },
  {
    id: "4065",
    id_polifenol: "1644",
    polifenol: "Cur1 compound",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "4",
    pmids: "26458588,25622075,26745072,24399876",
  },
  {
    id: "4066",
    id_polifenol: "100",
    polifenol: "Resorcinols",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "3934671",
  },
  {
    id: "4067",
    id_polifenol: "5614",
    polifenol: "catechin gallate",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "2",
    pmids: "19627199,17404067",
  },
  {
    id: "4068",
    id_polifenol: "1866",
    polifenol: "4,6-dinitro-o-cresol",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "3",
    pmids: "1933868,23219601,22513143",
  },
  {
    id: "4069",
    id_polifenol: "4486",
    polifenol: "amentoflavone",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "3",
    pmids: "27187341,29695559,29599330",
  },
  {
    id: "4070",
    id_polifenol: "5850",
    polifenol: "cardamonin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "20862963",
  },
  {
    id: "4071",
    id_polifenol: "118",
    polifenol: "Flavonolignans",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "2",
    pmids: "23260576,16076518",
  },
  {
    id: "4072",
    id_polifenol: "7541",
    polifenol: "taxifolin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "3",
    pmids: "16458870,22253109,16076518",
  },
  {
    id: "4073",
    id_polifenol: "7544",
    polifenol: "quercitrin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "2",
    pmids: "28178217,24304383",
  },
  {
    id: "4074",
    id_polifenol: "60",
    polifenol: "2,4-Dinitrophenol",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "5",
    pmids: "17227049,6474574,6863398,27400479,7251682",
  },
  {
    id: "4075",
    id_polifenol: "7912",
    polifenol: "7,9,2',4'-tetrahydroxy-8-isopentenyl-5-methoxychalcone",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "2",
    pmids: "21790499,24641665",
  },
  {
    id: "4076",
    id_polifenol: "6465",
    polifenol: "genistin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "14968209",
  },
  {
    id: "4077",
    id_polifenol: "350",
    polifenol: "nonylphenol",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "3",
    pmids: "11800169,10854714,10330684",
  },
  {
    id: "4078",
    id_polifenol: "4767",
    polifenol: "flavan-3-ol",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "2",
    pmids: "23772110,23343084",
  },
  {
    id: "4079",
    id_polifenol: "92",
    polifenol: "Triclosan",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "29849464",
  },
  {
    id: "4080",
    id_polifenol: "2447",
    polifenol: "beta-penta-O-galloyl-glucose",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "2",
    pmids: "24389959,21319227",
  },
  {
    id: "4081",
    id_polifenol: "5071",
    polifenol: "icaritin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "4",
    pmids: "26376676,20560114,24278260,24145579",
  },
  {
    id: "4082",
    id_polifenol: "6576",
    polifenol: "5,7,4'-trihydroxyflavone",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "2",
    pmids: "25698902,15924350",
  },
  {
    id: "4083",
    id_polifenol: "4585",
    polifenol: "baohuoside I",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "26118776",
  },
  {
    id: "4084",
    id_polifenol: "6086",
    polifenol: "liquiritigenin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "24738081",
  },
  {
    id: "4085",
    id_polifenol: "1616",
    polifenol: "tetrahydrocurcumin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "2",
    pmids: "28766664,18395899",
  },
  {
    id: "4086",
    id_polifenol: "59",
    polifenol: "Dinitrophenols",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "7525592",
  },
  {
    id: "4087",
    id_polifenol: "4516",
    polifenol: "diosmetin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "7",
    pmids: "27176768,28240165,26847170,28101238,28245756,28101201,22749133",
  },
  {
    id: "4088",
    id_polifenol: "7161",
    polifenol: "scutellarin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "2",
    pmids: "28458133,23192830",
  },
  {
    id: "4089",
    id_polifenol: "2328",
    polifenol: "syringic acid",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "15165144",
  },
  {
    id: "4090",
    id_polifenol: "7296",
    polifenol: "dihydromyricetin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "8",
    pmids:
      "24223706,28240161,24002546,25915649,28974890,25391369,25110435,24717393",
  },
  {
    id: "4091",
    id_polifenol: "7134",
    polifenol: "vitexin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "4",
    pmids: "27588401,29328424,17202857,27601844",
  },
  {
    id: "4092",
    id_polifenol: "6558",
    polifenol: "7,3'-dihydroxy-4'-methoxyisoflavone",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "24455688",
  },
  {
    id: "4093",
    id_polifenol: "4525",
    polifenol: "eupatilin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "29576713",
  },
  {
    id: "4094",
    id_polifenol: "5455",
    polifenol: "theaflavin-3,3'-digallate",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "15248026",
  },
  {
    id: "4095",
    id_polifenol: "5815",
    polifenol: "dibenzoylmethane",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "18782044",
  },
  {
    id: "4096",
    id_polifenol: "349",
    polifenol: "4-nitrophenol",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "28648600",
  },
  {
    id: "4097",
    id_polifenol: "5495",
    polifenol: "malvidin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "2",
    pmids: "15740068,21888504",
  },
  {
    id: "4098",
    id_polifenol: "7141",
    polifenol: "apigetrin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "27981754",
  },
  {
    id: "4099",
    id_polifenol: "637",
    polifenol: "glabridin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "4",
    pmids: "24806207,27002406,24641665,26586395",
  },
  {
    id: "4100",
    id_polifenol: "6301",
    polifenol: "3-methoxyflavone",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "17526808",
  },
  {
    id: "4101",
    id_polifenol: "77",
    polifenol: "Bezafibrate",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "17118139",
  },
  {
    id: "4102",
    id_polifenol: "1810",
    polifenol: "heminordihydroguaiaretic acid",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "15958646",
  },
  {
    id: "4103",
    id_polifenol: "19",
    polifenol: "Pentachlorophenol",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "2881629",
  },
  {
    id: "4104",
    id_polifenol: "6783",
    polifenol: "protoapigenone",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "26974964",
  },
  {
    id: "4105",
    id_polifenol: "6477",
    polifenol: "hispidulin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "2",
    pmids: "24068521,26209062",
  },
  {
    id: "4106",
    id_polifenol: "6510",
    polifenol: "glycitein",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "14968209",
  },
  {
    id: "4107",
    id_polifenol: "7198",
    polifenol: "homoorientin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "5",
    pmids: "23026832,27130644,24374571,27261613,27601844",
  },
  {
    id: "4108",
    id_polifenol: "128",
    polifenol: "Pterocarpans",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "17964704",
  },
  {
    id: "4109",
    id_polifenol: "7557",
    polifenol: "rhamnetin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "27091611",
  },
  {
    id: "4110",
    id_polifenol: "103",
    polifenol: "Zeranol",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "3030825",
  },
  {
    id: "4111",
    id_polifenol: "1353",
    polifenol: "protocatechualdehyde",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "2",
    pmids: "29285297,15165144",
  },
  {
    id: "4112",
    id_polifenol: "4501",
    polifenol: "tricin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "22359269",
  },
  {
    id: "4113",
    id_polifenol: "5496",
    polifenol: "pelargonidin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "21888504",
  },
  {
    id: "4114",
    id_polifenol: "7775",
    polifenol: "glyceollin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "2",
    pmids: "24513878,23573869",
  },
  {
    id: "4115",
    id_polifenol: "5796",
    polifenol: "dihydrochalcone",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "26633321",
  },
  {
    id: "4116",
    id_polifenol: "6066",
    polifenol: "eriodictyol",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "12762787",
  },
  {
    id: "4117",
    id_polifenol: "2574",
    polifenol: "4-hydroxybenzoic acid",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "27981754",
  },
  {
    id: "4118",
    id_polifenol: "6452",
    polifenol: "chrysoeriol",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "14510590",
  },
  {
    id: "4119",
    id_polifenol: "680",
    polifenol: "xanthorrhizol",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "2",
    pmids: "17465228,22465013",
  },
  {
    id: "4120",
    id_polifenol: "713",
    polifenol:
      "3-(3-chloro-4-hydroxyphenylamino)-4-(4-nitrophenyl)-1H-pyrrole-2,5-dione",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "2",
    pmids: "15942663,18938143",
  },
  {
    id: "4121",
    id_polifenol: "7377",
    polifenol: "astragalin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "28654261",
  },
  {
    id: "4122",
    id_polifenol: "4521",
    polifenol: "3-hydroxyflavone",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "2",
    pmids: "15990314,25522535",
  },
  {
    id: "4123",
    id_polifenol: "3489",
    polifenol: "anethole",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "2",
    pmids: "26514509,27981754",
  },
  {
    id: "4124",
    id_polifenol: "115",
    polifenol: "Diosmin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "3",
    pmids: "22289577,23665045,29479636",
  },
  {
    id: "4125",
    id_polifenol: "87",
    polifenol: "Metoclopramide",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "16183854",
  },
  {
    id: "4126",
    id_polifenol: "6554",
    polifenol: "tectorigenin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "22553399",
  },
  {
    id: "4127",
    id_polifenol: "7156",
    polifenol: "scutellarein",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "28104392",
  },
  {
    id: "4128",
    id_polifenol: "299",
    polifenol: "nitrophenylphosphate",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "22553985",
  },
  {
    id: "4129",
    id_polifenol: "5831",
    polifenol: "angoletin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "25773833",
  },
  {
    id: "4130",
    id_polifenol: "4565",
    polifenol: "morusin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "3",
    pmids: "28670112,28599457,25476160",
  },
  {
    id: "4131",
    id_polifenol: "885",
    polifenol: "oleocanthal",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "2",
    pmids: "27259268,28656311",
  },
  {
    id: "4132",
    id_polifenol: "6175",
    polifenol: "2'-hydroxyflavanone",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "26629250",
  },
  {
    id: "4133",
    id_polifenol: "6112",
    polifenol: "alpinetin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "20862963",
  },
  {
    id: "4134",
    id_polifenol: "711",
    polifenol: "ascochlorin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "3",
    pmids: "25624051,22433868,27765853",
  },
  {
    id: "4135",
    id_polifenol: "6457",
    polifenol: "salvigenin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "29859020",
  },
  {
    id: "4136",
    id_polifenol: "12",
    polifenol: "Guaiacol",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "24121236",
  },
  {
    id: "4137",
    id_polifenol: "7741",
    polifenol: "biochanin A",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "27470322",
  },
  {
    id: "4138",
    id_polifenol: "2454",
    polifenol: "corilagin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "26935808",
  },
  {
    id: "4139",
    id_polifenol: "357",
    polifenol: "4-aminophenol",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "1643640",
  },
  {
    id: "4140",
    id_polifenol: "704",
    polifenol: "trizol",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "29670840",
  },
  {
    id: "4141",
    id_polifenol: "84",
    polifenol: "Halogenated Diphenyl Ethers",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "17509781",
  },
  {
    id: "4142",
    id_polifenol: "2364",
    polifenol: "theaflavine gallate",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "2",
    pmids: "19003122,15248026",
  },
  {
    id: "4143",
    id_polifenol: "4052",
    polifenol: "bis-(3-(3',5'-di-tert-butyl-4'-hydroxyphenyl)propyl)sulfide",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "23452983",
  },
  {
    id: "4144",
    id_polifenol: "4578",
    polifenol: "5,7-dimethoxyflavone",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "2",
    pmids: "17583686,15661813",
  },
  {
    id: "4145",
    id_polifenol: "9",
    polifenol: "1,2-Dihydroxybenzene-3,5-Disulfonic Acid Disodium Salt",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "19728331",
  },
  {
    id: "4146",
    id_polifenol: "6100",
    polifenol: "pinostrobin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "20862963",
  },
  {
    id: "4147",
    id_polifenol: "347",
    polifenol: "4-nitrophenyl",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "25198889",
  },
  {
    id: "4148",
    id_polifenol: "7199",
    polifenol: "luteolin-7-glucoside",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "2",
    pmids: "16029005,21595573",
  },
  {
    id: "4149",
    id_polifenol: "5885",
    polifenol: "2',4'-dihydroxy-6'-methoxy-3',5'-dimethylchalcone",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "4",
    pmids: "25260543,15806415,29626576,15666170",
  },
  {
    id: "4150",
    id_polifenol: "4573",
    polifenol: "3,3',4',5,6,7,8-heptamethoxyflavone",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "20862963",
  },
  {
    id: "4151",
    id_polifenol: "4639",
    polifenol: "aromadedrin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "22253109",
  },
  {
    id: "4152",
    id_polifenol: "7658",
    polifenol: "quercetin 3'-O-glucoside",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "3",
    pmids: "24692698,25681471,26428271",
  },
  {
    id: "4153",
    id_polifenol: "4782",
    polifenol: "kurarinone",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "18184547",
  },
  {
    id: "4154",
    id_polifenol: "6453",
    polifenol: "cirsimaritin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "21554863",
  },
  {
    id: "4155",
    id_polifenol: "4553",
    polifenol: "sulfuretin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "12762787",
  },
  {
    id: "4156",
    id_polifenol: "5615",
    polifenol: "gallocatechin gallate",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "2",
    pmids: "19627199,28987363",
  },
  {
    id: "4157",
    id_polifenol: "5539",
    polifenol: "peonidin 3-glucoside",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "29800916",
  },
  {
    id: "4158",
    id_polifenol: "5245",
    polifenol: "BF6-6 biflavone",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "28839377",
  },
  {
    id: "4159",
    id_polifenol: "2504",
    polifenol: "pentagalloylglucose",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "21081808",
  },
  {
    id: "4160",
    id_polifenol: "792",
    polifenol: "octylphenol",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "10854714",
  },
  {
    id: "4161",
    id_polifenol: "2",
    polifenol: "Aminophenols",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "2",
    pmids: "17092729,3934671",
  },
  {
    id: "4162",
    id_polifenol: "6819",
    polifenol: "luteolin-7-O-glucoside",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "2",
    pmids: "27981754,22902823",
  },
  {
    id: "4163",
    id_polifenol: "4607",
    polifenol: "orientin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "27396915",
  },
  {
    id: "4164",
    id_polifenol: "6093",
    polifenol: "pinobanksin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "28747003",
  },
  {
    id: "4165",
    id_polifenol: "7239",
    polifenol: "isosilybin A",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "17484885",
  },
  {
    id: "4166",
    id_polifenol: "6287",
    polifenol: "neohesperidin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "26194866",
  },
  {
    id: "4167",
    id_polifenol: "79",
    polifenol: "Clofibric Acid",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "2",
    pmids: "11485390,8472324",
  },
  {
    id: "4168",
    id_polifenol: "7437",
    polifenol: "kaempferol-3-O-rutinoside",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "27013795",
  },
  {
    id: "4169",
    id_polifenol: "5289",
    polifenol: "8-bromo-7-methoxychrysin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "6",
    pmids: "24431896,28369327,26935885,27461522,23970349,26845136",
  },
  {
    id: "4170",
    id_polifenol: "3667",
    polifenol: "ciprofibrate",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "3",
    pmids: "2191770,6692393,10523698",
  },
  {
    id: "4171",
    id_polifenol: "6684",
    polifenol: "eupafolin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "28655996",
  },
  {
    id: "4172",
    id_polifenol: "7590",
    polifenol: "quercetin-3-O-rutinoside",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "28178217",
  },
  {
    id: "4173",
    id_polifenol: "1716",
    polifenol: "zingerone",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "28110870",
  },
  {
    id: "4174",
    id_polifenol: "6687",
    polifenol: "3'-dimethylaminoflavone",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "28638884",
  },
  {
    id: "4175",
    id_polifenol: "3490",
    polifenol: "estragole",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "21812646",
  },
  {
    id: "4176",
    id_polifenol: "3386",
    polifenol: "2,2',4,4'-tetrabromodiphenyl ether",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "21783961",
  },
  {
    id: "4177",
    id_polifenol: "529",
    polifenol: "4-octylphenol",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "11800169",
  },
  {
    id: "4178",
    id_polifenol: "3662",
    polifenol: "3-tert-butyl-4-hydroxyanisole",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "6692393",
  },
  {
    id: "4179",
    id_polifenol: "818",
    polifenol: "4,4'-isopropylidene diphenol",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "3934671",
  },
  {
    id: "4180",
    id_polifenol: "6548",
    polifenol: "artocarpin flavonoid",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "27064012",
  },
  {
    id: "4181",
    id_polifenol: "52",
    polifenol: "Diflunisal",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "26695731",
  },
  {
    id: "4182",
    id_polifenol: "7885",
    polifenol: "hydroxysafflor yellow A",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "2",
    pmids: "28966242,25720342",
  },
  {
    id: "4183",
    id_polifenol: "5525",
    polifenol: "cyanidin 3-rutinoside",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "29800916",
  },
  {
    id: "4184",
    id_polifenol: "106",
    polifenol: "Benzoflavones",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "6406051",
  },
  {
    id: "4185",
    id_polifenol: "3661",
    polifenol: "2-tert-butyl-4-hydroxyanisole",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "4",
    pmids: "1340765,6692393,8269610,2860980",
  },
  {
    id: "4186",
    id_polifenol: "5941",
    polifenol: "3-hydroxy-4,3',4',5'-tetramethoxychalcone",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "19875299",
  },
  {
    id: "4187",
    id_polifenol: "5720",
    polifenol: "4,3',4',5'- tetramethoxychalcone",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "19875299",
  },
  {
    id: "4188",
    id_polifenol: "2336",
    polifenol: "octyl gallate",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "2",
    pmids: "29288082,23835774",
  },
  {
    id: "4189",
    id_polifenol: "343",
    polifenol: "2,5-dichloro-4-bromophenol",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "11238185",
  },
  {
    id: "4190",
    id_polifenol: "2161",
    polifenol: "nifuroxazide",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "2",
    pmids: "26154152,28498414",
  },
  {
    id: "4191",
    id_polifenol: "7632",
    polifenol: "quercetin-3-O-beta-D-galactopyranoside",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "18828600",
  },
  {
    id: "4192",
    id_polifenol: "72",
    polifenol: "Phenyl Ethers",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "17509781",
  },
  {
    id: "4193",
    id_polifenol: "472",
    polifenol: "isoacteoside",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "20161953",
  },
  {
    id: "4194",
    id_polifenol: "4161",
    polifenol: "3,5-dihydroxyphenylglycine",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "2",
    pmids: "22706282,28455267",
  },
  {
    id: "4195",
    id_polifenol: "7518",
    polifenol: "quercetin-3-O-alpha-arabinofuranoside",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "18828600",
  },
  {
    id: "4196",
    id_polifenol: "7736",
    polifenol: "7-monohydroxyethylrutoside",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "22287334",
  },
  {
    id: "4197",
    id_polifenol: "418",
    polifenol: "thiophenol",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "29550886",
  },
  {
    id: "4198",
    id_polifenol: "6587",
    polifenol: "glycitin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "14968209",
  },
  {
    id: "4199",
    id_polifenol: "5963",
    polifenol: "3,5,2',4'-tetrahydroxychalcone",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "21770460",
  },
  {
    id: "4200",
    id_polifenol: "1262",
    polifenol: "4-dodecylaminophenol",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "17092729",
  },
  {
    id: "4201",
    id_polifenol: "4103",
    polifenol: "gnetin H",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "12135100",
  },
  {
    id: "4202",
    id_polifenol: "2332",
    polifenol: "lauryl gallate",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "23835774",
  },
  {
    id: "4203",
    id_polifenol: "2066",
    polifenol: "NSC 680410",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "19442148",
  },
  {
    id: "4204",
    id_polifenol: "903",
    polifenol: "vineatrol",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "18627786",
  },
  {
    id: "4205",
    id_polifenol: "3336",
    polifenol:
      "N-hydroxy-5-ethoxymethyloxy-2-methyl-4-(4-phenoxybenzoyl)aminopentanamide",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "11856483",
  },
  {
    id: "4206",
    id_polifenol: "7810",
    polifenol: "rotenolone",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "23895019",
  },
  {
    id: "4207",
    id_polifenol: "6236",
    polifenol: "nymphaeol C",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "21790499",
  },
  {
    id: "4208",
    id_polifenol: "5791",
    polifenol: "metochalcone",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "19875299",
  },
  {
    id: "4209",
    id_polifenol: "5854",
    polifenol: "2'-hydroxy-3,4,3',4',6'-pentamethoxychalcone",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "2",
    pmids: "19875299,27300477",
  },
  {
    id: "4210",
    id_polifenol: "7726",
    polifenol: "troxerutin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "2",
    pmids: "27488610,28628229",
  },
  {
    id: "4211",
    id_polifenol: "4588",
    polifenol: "breviscapine",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "2",
    pmids: "20091746,28229971",
  },
  {
    id: "4212",
    id_polifenol: "6654",
    polifenol: "5,2',4'-trihydroxy-6,7,5'-trimethoxyflavone",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "3",
    pmids: "27131317,27834930,29328481",
  },
  {
    id: "4213",
    id_polifenol: "696",
    polifenol: "2,2-bis(4-hydroxyphenyl)-1,1,1-trichloroethane",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "2",
    pmids: "11800169,10854714",
  },
  {
    id: "4214",
    id_polifenol: "7641",
    polifenol: "quercetin-3'-O-beta-D-glucopyranoside",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "18828600",
  },
  {
    id: "4215",
    id_polifenol: "6752",
    polifenol: "zapotin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "17228877",
  },
  {
    id: "4216",
    id_polifenol: "5465",
    polifenol: "vitexin-2-O-xyloside",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "28283822",
  },
  {
    id: "4217",
    id_polifenol: "7050",
    polifenol: "3'-chloro-5,7-dimethoxyisoflavone",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "12762787",
  },
  {
    id: "4218",
    id_polifenol: "1961",
    polifenol: "tri-o-cresyl phosphate",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "15451303",
  },
  {
    id: "4219",
    id_polifenol: "1932",
    polifenol: "3,5-di-tert-butyl-4-hydroxytoluene",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "2860980",
  },
  {
    id: "4220",
    id_polifenol: "7151",
    polifenol: "vicenin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "27396915",
  },
  {
    id: "4221",
    id_polifenol: "1804",
    polifenol: "guaiacylglycerol-beta-coniferyl ether",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "22253109",
  },
  {
    id: "4222",
    id_polifenol: "5129",
    polifenol: "echinoside",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "21726060",
  },
  {
    id: "4223",
    id_polifenol: "184",
    polifenol: "trilobatin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "26633321",
  },
  {
    id: "4224",
    id_polifenol: "5701",
    polifenol: "2',4'-dihydroxy-3,4,5-trimethoxychalcone",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "19875299",
  },
  {
    id: "4225",
    id_polifenol: "5910",
    polifenol: "3'-formyl-4',6'-dihydroxy-2'-methoxy-5'-methylchalcone",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "17430639",
  },
  {
    id: "4226",
    id_polifenol: "1642",
    polifenol: "FLLL 32",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "2",
    pmids: "20712901,20818158",
  },
  {
    id: "4227",
    id_polifenol: "3605",
    polifenol: "lyoniresinol",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "2",
    pmids: "22253109,19950049",
  },
  {
    id: "4228",
    id_polifenol: "6464",
    polifenol: "cirsiliol",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "27566208",
  },
  {
    id: "4229",
    id_polifenol: "1417",
    polifenol: "1,2-dihydroxy-4'-chlorobiphenyl",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "15025504",
  },
  {
    id: "4230",
    id_polifenol: "5996",
    polifenol: "3-(2-chlorophenyl)-1-(2,4-dihydroxyphenyl)prop-2-en-1-one",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "15165144",
  },
  {
    id: "4231",
    id_polifenol: "559",
    polifenol: "squamosamide",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "21835169",
  },
  {
    id: "4232",
    id_polifenol: "5006",
    polifenol: "procyanidin B1",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "22227333",
  },
  {
    id: "4233",
    id_polifenol: "7650",
    polifenol: "3,7-O-dimethylquercetin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "14751306",
  },
  {
    id: "4234",
    id_polifenol: "7825",
    polifenol: "alpha-toxicarol",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "2",
    pmids: "14510590,14751306",
  },
  {
    id: "4235",
    id_polifenol: "2486",
    polifenol: "1,3,6-tri-O-galloylglucopyranose",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "21595573",
  },
  {
    id: "4236",
    id_polifenol: "2090",
    polifenol: "10'(Z),13'(E),15'(E)-heptadecatrienylhydroquinone",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "23088786",
  },
  {
    id: "4237",
    id_polifenol: "6626",
    polifenol: "cajanol",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "21164560",
  },
  {
    id: "4238",
    id_polifenol: "460",
    polifenol: "suillin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "2",
    pmids: "24606477,19616521",
  },
  {
    id: "4239",
    id_polifenol: "4673",
    polifenol: "3,7-dimethoxyflavone",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "2",
    pmids: "21660448,28638884",
  },
  {
    id: "4240",
    id_polifenol: "4046",
    polifenol: "3-hydroxyphloretin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "26633321",
  },
  {
    id: "4241",
    id_polifenol: "7180",
    polifenol: "apigenin-8-C-beta-D-glucopyranoside",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "17202857",
  },
  {
    id: "4242",
    id_polifenol: "2458",
    polifenol: "glucogallin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "24389959",
  },
  {
    id: "4243",
    id_polifenol: "4747",
    polifenol: "4'-bromoflavone",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "9973203",
  },
  {
    id: "4244",
    id_polifenol: "1383",
    polifenol: "neodymium pyrocatechin disulfonate",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "2",
    pmids: "26314304,21338235",
  },
  {
    id: "4245",
    id_polifenol: "6096",
    polifenol: "eriocitrin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "27766389",
  },
  {
    id: "4246",
    id_polifenol: "5611",
    polifenol: "epiafzelechin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "23772110",
  },
  {
    id: "4247",
    id_polifenol: "4714",
    polifenol: "epimedin C",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "16112786",
  },
  {
    id: "4248",
    id_polifenol: "78",
    polifenol: "Clofenapate",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "2",
    pmids: "9298250,8001222",
  },
  {
    id: "4249",
    id_polifenol: "4791",
    polifenol: "myricetin 3-O-(2'',3''-di-O-galloyl)rhamnopyranoside",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "21595573",
  },
  {
    id: "4250",
    id_polifenol: "7635",
    polifenol: "quercetin-3-O-alpha-L-rhamnopyranoside",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "24250510",
  },
  {
    id: "4251",
    id_polifenol: "2987",
    polifenol: "succinyldisalicylic acid",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "24766798",
  },
  {
    id: "4252",
    id_polifenol: "5079",
    polifenol: "flavangenol",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "22227333",
  },
  {
    id: "4253",
    id_polifenol: "6380",
    polifenol: "oroxin B",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "29720833",
  },
  {
    id: "4254",
    id_polifenol: "5197",
    polifenol: "Ikarisoside A",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "16125732",
  },
  {
    id: "4255",
    id_polifenol: "3408",
    polifenol: "4-phenoxyphenol",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "28531143",
  },
  {
    id: "4256",
    id_polifenol: "171",
    polifenol: "p-decylaminophenol",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "17092729",
  },
  {
    id: "4257",
    id_polifenol: "7069",
    polifenol: "isoorientin-2''-O-arabinopyranosyl",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "27130644",
  },
  {
    id: "4258",
    id_polifenol: "5399",
    polifenol: "7,7''-dimethoxyagastisflavone",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "21915931",
  },
  {
    id: "4259",
    id_polifenol: "4157",
    polifenol: "bilobol",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "26622605",
  },
  {
    id: "4260",
    id_polifenol: "5157",
    polifenol: "kurarinol",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "24997323",
  },
  {
    id: "4261",
    id_polifenol: "3225",
    polifenol: "decabromobiphenyl ether",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "17509781",
  },
  {
    id: "4262",
    id_polifenol: "7485",
    polifenol:
      "kaempherol 3-O-beta-rhamnopyranosyl (1-6)-beta-D-glucopyranoside",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "29901131",
  },
  {
    id: "4263",
    id_polifenol: "4716",
    polifenol: "5,4'-diamino-6,8,3'-trifluoroflavone",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "9191967",
  },
  {
    id: "4264",
    id_polifenol: "3691",
    polifenol: "2-(4-(2,2-dichlorocyclopropyl)phenoxy)propane",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "6692393",
  },
  {
    id: "4265",
    id_polifenol: "7779",
    polifenol: "cristacarpin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "17964704",
  },
  {
    id: "4266",
    id_polifenol: "6003",
    polifenol: "boesenbergin A",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "22358425",
  },
  {
    id: "4267",
    id_polifenol: "7568",
    polifenol: "7,3',4'-trimethylquercetin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "14751306",
  },
  {
    id: "4268",
    id_polifenol: "6957",
    polifenol: "6,6,8-triethyldesmosdumotin B",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "23293751",
  },
  {
    id: "4269",
    id_polifenol: "2049",
    polifenol: "menahydroquinone-4",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "2",
    pmids: "25416411,28943616",
  },
  {
    id: "4270",
    id_polifenol: "3549",
    polifenol: "ardisenone",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "20561930",
  },
  {
    id: "4271",
    id_polifenol: "904",
    polifenol: "afzelechin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "23772110",
  },
  {
    id: "4272",
    id_polifenol: "7592",
    polifenol: "5,7,3',4'-tetramethylquercetin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "14751306",
  },
  {
    id: "4273",
    id_polifenol: "7237",
    polifenol: "dehydrosilybin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "21328458",
  },
  {
    id: "4274",
    id_polifenol: "2060",
    polifenol: "2-(10-heptadecenyl)-1,4-hydroquinone",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "23088786",
  },
  {
    id: "4275",
    id_polifenol: "7067",
    polifenol: "III-10",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "26164795",
  },
  {
    id: "4276",
    id_polifenol: "2214",
    polifenol: "3-hexaprenyl-4-hydroxybenzoic acid",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "19589234",
  },
  {
    id: "4277",
    id_polifenol: "4844",
    polifenol: "3',5'-di-C-glucopyranosylphloretin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "26633321",
  },
  {
    id: "4278",
    id_polifenol: "6136",
    polifenol: "5,7,3',5'-tetrahydroxyflavanone",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "19994890",
  },
  {
    id: "4279",
    id_polifenol: "6982",
    polifenol: "DHF 18",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "21093431",
  },
  {
    id: "4280",
    id_polifenol: "7897",
    polifenol: "3,4-methylenedioxy-3',4',5'-trimethoxy chalcone",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "26907262",
  },
  {
    id: "4281",
    id_polifenol: "847",
    polifenol: "xantocillin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "22822377",
  },
  {
    id: "4282",
    id_polifenol: "4407",
    polifenol: "8-C-(E-phenylethenyl)-norartocarpetin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "26675844",
  },
  {
    id: "4283",
    id_polifenol: "5349",
    polifenol:
      "5-hydroxy-8-methoxy-2-phenyl-7-(4-(pyrrolidin-1-yl)butoxy)4H-chromen-4-one",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "23835921",
  },
  {
    id: "4284",
    id_polifenol: "3906",
    polifenol: "hyperforin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "21751836",
  },
  {
    id: "4285",
    id_polifenol: "3004",
    polifenol: "aspirin, caffeine, codeine drug combination",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "22940450",
  },
  {
    id: "4286",
    id_polifenol: "6090",
    polifenol: "dioclein",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "29039470",
  },
  {
    id: "4287",
    id_polifenol: "4206",
    polifenol: "5-(2'-oxoheptadecyl)resorcinol",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "12562085",
  },
  {
    id: "4288",
    id_polifenol: "4207",
    polifenol: "5-(2'-oxononadecyl)resorcinol",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "12562085",
  },
  {
    id: "4289",
    id_polifenol: "5456",
    polifenol: "4''-O-methyl-I3,II8-biapigenin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "17365688",
  },
  {
    id: "4290",
    id_polifenol: "6174",
    polifenol: "(2S)-8-formyl-5-hydroxy-7-methoxy-6-methylflavanone",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "17430639",
  },
  {
    id: "4291",
    id_polifenol: "1592",
    polifenol: "EF25-(GSH)2",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "25268357",
  },
  {
    id: "4292",
    id_polifenol: "7790",
    polifenol: "neorautenol",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "17964704",
  },
  {
    id: "4293",
    id_polifenol: "4898",
    polifenol: "corylin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "29382035",
  },
  {
    id: "4294",
    id_polifenol: "1829",
    polifenol: "2-ethylhexyl 2,4-dichlorophenoxyacetate",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "26929583",
  },
  {
    id: "4295",
    id_polifenol: "2337",
    polifenol: "M3OMG",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "20862963",
  },
  {
    id: "4296",
    id_polifenol: "7248",
    polifenol:
      "kaempferol 3-O-beta-D-glucopyranosyl-(1''-2')-O-alpha-L-arabinopyranoside",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "24250510",
  },
  {
    id: "4297",
    id_polifenol: "7052",
    polifenol: "(3S)-5-guaiacyl-3-hydroxypentanoic acid",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "22253109",
  },
  {
    id: "4298",
    id_polifenol: "3514",
    polifenol: "1'-hydroxy-2',3'-dehydroestragole",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "3016723",
  },
  {
    id: "4299",
    id_polifenol: "3121",
    polifenol: "ethyl O-(N-(4-carboxyphenyl)carbamoyl)mycophenolate",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "7274650",
  },
  {
    id: "4300",
    id_polifenol: "1118",
    polifenol: "4-hydroxyphenyl tert-butylnitrone",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "19886748",
  },
  {
    id: "4301",
    id_polifenol: "7143",
    polifenol: "clerodendrin",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "21595573",
  },
  {
    id: "4302",
    id_polifenol: "6638",
    polifenol: "5-methoxyxanthocercin A",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "12762787",
  },
  {
    id: "4303",
    id_polifenol: "3704",
    polifenol: "beta-diethylaminoethyl alpha-4-chlorophenoxyisobutyrate",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "85485",
  },
  {
    id: "4304",
    id_polifenol: "5019",
    polifenol: "(2S)-5-hydroxy-7-methoxy-8-((E)-3-oxo-1-butenyl)flavanone",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "14510590",
  },
  {
    id: "4305",
    id_polifenol: "4339",
    polifenol: "myricetin-3-O-rhamnoside (C7-O-C7) myricetin-3-O-rhamnoside",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "24304383",
  },
  {
    id: "4306",
    id_polifenol: "7653",
    polifenol: "quercetin 3-O-(6''-O-malonyl)glucoside",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "24985107",
  },
  {
    id: "4307",
    id_polifenol: "3230",
    polifenol: "di-(4-aminophenyl)ether",
    id_cancer: "230098",
    cancer: "Hepatocellular carcinoma",
    quant: "1",
    pmids: "2629100",
  },
  {
    id: "4308",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "103",
    pmids:
      "26119952,27019365,27414207,26113875,29421517,25242120,23502466,29223588,15947208,19903849,28763204,26315556,29142606,23570653,18430509,10418944,19838928,24612139,27426510,2257224,28571726,25522537,21660680,28286420,28950682,29734760,29070784,25845666,21244577,26893740,29587527,28436480,2131036,19447105,29512690,9081370,25771121,28934130,29438890,9381980,28587346,26098839,28482871,25405327,28912871,29761845,27585998,19172579,19005980,25776829,17063376,26345098,28111515,17285121,29324735,21625365,18974065,29844670,20459793,24885709,10353585,11595883,15913998,17357971,15746177,27039735,26084155,18097594,26320438,26320439,17197231,23768357,27279694,9815559,26320443,26434118,28119082,28599307,27616072,17071632,26520390,21246822,27904580,21351454,22866004,28588737,27814590,8808829,12510833,24818141,22837693,17326683,21584546,24359131,8482562,25870037,19725578,9563007,15043430,25855013,29564969,27045836,26255457",
  },
  {
    id: "4309",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "96",
    pmids:
      "26985864,16376585,17218783,22508043,20591475,19020741,17174384,18214481,26607901,16800992,25118487,23983610,28345465,22159410,20693500,21885917,25667441,12520734,22594559,19676105,19016748,19647363,25646742,23991988,24065177,22812232,11776634,28175963,20934509,15165116,24733049,26873414,22801507,24914015,27221847,27618095,27585998,25543980,14676209,19236381,28934730,23730903,20429876,21702507,27895754,24870723,28111949,21859497,11795474,23663277,25503135,25016976,27272792,25275041,23701832,24012589,19329324,29700289,17545551,12447990,23660215,23479219,26987300,17197231,22791660,27863439,16398441,22284780,19278222,28245646,29728868,25964558,29232190,23909128,21508356,26085082,27461697,24522815,18462866,25429431,26316750,22199293,23155250,24440402,21167595,24403514,29089332,29017913,28658642,22576113,9868158,28217982,20845461,26548708,26130461,29805775",
  },
  {
    id: "4310",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "31",
    pmids:
      "27540692,22508043,26119952,17475222,29301413,25667441,28868867,26530725,20682977,25522537,26893740,24565968,27951496,27270317,25931821,26648098,25498967,16741061,27618095,26851019,25927922,27787915,23967153,25663929,17197231,29301278,28856729,29714468,16556056,19588362,22576113",
  },
  {
    id: "4311",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "69",
    pmids:
      "23696862,22672985,19426671,11085518,22176685,15598681,21687949,15250250,17900261,15372629,17024969,21187340,10537288,15581951,15050414,29797601,24395385,22534171,26461347,12087097,22472210,22479527,28287251,12478895,21637924,22543706,19087521,20309937,26135903,11994371,21912264,18949358,11467775,19608641,20702723,20215102,27458161,19116446,10531373,12180971,11162898,25756515,28885729,15860581,21339740,10331740,21092551,10597250,24596063,18854640,14676209,12767518,15947112,26526982,22665040,19513623,17611702,16376882,29731988,26681060,29103028,29781537,21123455,23285101,10958792,12562385,22312289,20565902,15302591",
  },
  {
    id: "4312",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "59",
    pmids:
      "23229410,24604613,17234261,10200535,12730675,24959264,17291540,22447287,16353157,21801124,18514188,19732843,23438830,9102218,28950682,21340606,23933164,28627607,15161029,9381980,15634453,11835393,28003845,7945420,15893418,29743815,19005980,26407941,12948406,22549810,10702246,28111515,27076627,12899800,17048629,18687658,25503135,19025644,18155830,11753986,17197231,16398441,22284780,12094620,25165122,24379833,26504026,19487548,16507219,10533460,27908969,24403514,20099489,12163380,20019181,9563007,19364253,29088827,24716121",
  },
  {
    id: "4313",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "46",
    pmids:
      "26622357,8157359,23044718,27121110,24612139,2257224,25522537,23858960,25937243,2131036,28677813,9381980,7723587,24999622,27618095,14625852,19005980,25776829,28188387,24133573,9042300,27224244,29844670,26986492,10353585,11595883,25275041,25611565,29317830,9343925,12447990,16398441,22284780,28188793,23768357,26434118,26160305,25964558,28335466,21246822,27904580,24032269,21584546,8482562,9563007,17194528",
  },
  {
    id: "4314",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "30",
    pmids:
      "20368822,24452912,15350370,16594917,20682977,29576805,16818507,27270317,16402374,26648098,16741061,27618095,20126997,23476648,23333498,16786054,19113837,21698451,25927922,29256569,22284780,17487111,21508356,23155251,22199293,10518005,21903153,24403514,29017913,28961534",
  },
  {
    id: "4315",
    id_polifenol: "2167",
    polifenol: "phenolic acid",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "18",
    pmids:
      "29223588,22325591,20693500,29693189,26530725,28179945,25931821,7488239,24885709,24870723,25636863,25005945,21246822,28811233,24818141,21903153,22628042,26255457",
  },
  {
    id: "4316",
    id_polifenol: "49",
    polifenol: "Aspirin",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "30",
    pmids:
      "18196976,20404564,11801560,19621391,18575740,17760507,28356941,12383533,17593823,16376882,27638860,26353776,24155779,12648598,15254653,23483185,18606441,17037745,26316750,28679740,17545608,15456535,21735687,18158574,28264838,27347106,24932579,9102213,18302761,16497833",
  },
  {
    id: "4317",
    id_polifenol: "109",
    polifenol: "Catechin",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "9",
    pmids:
      "24452912,27470560,15380225,27224244,16786054,10518005,21903153,19588362,28961534",
  },
  {
    id: "4318",
    id_polifenol: "125",
    polifenol: "Isoflavones",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "20",
    pmids:
      "29552162,26325371,12730675,16353157,21801124,19472400,28950682,15893418,29761845,28111515,21677151,19025644,29660466,12094620,25165122,16507219,18482833,19364253,24716121,16784025",
  },
  {
    id: "4319",
    id_polifenol: "110",
    polifenol: "Chalcones",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "12",
    pmids:
      "25180593,26119952,27447570,25061803,10418944,28750204,28327308,7575989,15913998,28466786,19714673,28222316",
  },
  {
    id: "4320",
    id_polifenol: "3089",
    polifenol: "1,1-diphenyl-2-picrylhydrazyl",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "17",
    pmids:
      "28699489,26514745,28179945,29383946,26924226,26537084,27224244,24885709,27039735,26320438,26320439,25005945,23768357,27279694,26320443,27673552,27534135",
  },
  {
    id: "4321",
    id_polifenol: "114",
    polifenol: "Apigenin",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "15",
    pmids:
      "15947208,25544427,19447105,25405327,19005980,12703988,28443516,18974065,15746177,22284780,27616072,17071632,22837693,19725578,17149790",
  },
  {
    id: "4322",
    id_polifenol: "113",
    polifenol: "Flavones",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "12",
    pmids:
      "29039573,21893035,20734985,29904922,29808795,29383946,15913998,24772822,19714673,28119082,27814590,21556497",
  },
  {
    id: "4323",
    id_polifenol: "38",
    polifenol: "Gallic Acid",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "9",
    pmids:
      "29693189,26530725,24885709,25794927,25636863,25663929,27293459,21903153,23627273",
  },
  {
    id: "4324",
    id_polifenol: "117",
    polifenol: "Luteolin",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "6",
    pmids: "29808795,19005980,21959807,29173024,22284780,27198989",
  },
  {
    id: "4325",
    id_polifenol: "1",
    polifenol: "Phenols",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "13",
    pmids:
      "10926802,22465181,25522537,1955187,15205340,24885709,15461258,7604397,21216151,23772309,15297183,24900252,6254273",
  },
  {
    id: "4326",
    id_polifenol: "105",
    polifenol: "Anthocyanins",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "3",
    pmids: "26704080,28991298,28428026",
  },
  {
    id: "4327",
    id_polifenol: "7235",
    polifenol: "silybin",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "8",
    pmids:
      "26482609,23570653,28884602,28824426,28411546,9081370,18507063,14556934",
  },
  {
    id: "4328",
    id_polifenol: "129",
    polifenol: "Rotenone",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "9",
    pmids:
      "23027625,19732843,23438830,18006827,26288178,21158717,9264320,24858344,15043430",
  },
  {
    id: "4329",
    id_polifenol: "121",
    polifenol: "Kaempferols",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "10",
    pmids:
      "19838928,29734760,29070784,19005980,21625365,20459793,22284780,22866004,21927533,25870037",
  },
  {
    id: "4330",
    id_polifenol: "871",
    polifenol: "ABT-737",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "13",
    pmids:
      "24650799,27935869,23344663,24523919,25585174,18056200,27980105,23735052,27080533,29434898,25627260,24103422,21169413",
  },
  {
    id: "4331",
    id_polifenol: "6451",
    polifenol: "daidzein",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "9",
    pmids:
      "29512690,15161029,29743815,19738422,11566575,12094620,28654894,18482833,19509228",
  },
  {
    id: "4332",
    id_polifenol: "6065",
    polifenol: "baicalein",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "7",
    pmids: "28081631,27414207,23502466,25811965,27735841,25663929,22284780",
  },
  {
    id: "4333",
    id_polifenol: "7",
    polifenol: "Capsaicin",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "4",
    pmids: "25522537,27272792,25275041,18054183",
  },
  {
    id: "4334",
    id_polifenol: "4634",
    polifenol: "alvocidib",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "10",
    pmids:
      "24084453,12810657,18307904,15868376,25528169,25118834,21176562,12174876,15027863,21556497",
  },
  {
    id: "4335",
    id_polifenol: "120",
    polifenol: "Flavonols",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "7",
    pmids: "26788108,25776829,7623025,24885709,18097594,28119082,27045836",
  },
  {
    id: "4336",
    id_polifenol: "4522",
    polifenol: "chrysin",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "6",
    pmids: "28816359,26514745,29383946,26924226,26151347,27470961",
  },
  {
    id: "4337",
    id_polifenol: "123",
    polifenol: "Rutin",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "6",
    pmids: "2257224,2131036,19005980,23768357,21584546,29564969",
  },
  {
    id: "4338",
    id_polifenol: "285",
    polifenol: "bisphenol A",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "22",
    pmids:
      "23229410,22552626,23810794,29603059,24308608,28111160,23933164,24997338,29653259,22343039,21277958,26407941,18854640,22549810,12628303,23850738,15461258,21826169,25690688,28811233,29718440,28709040",
  },
  {
    id: "4339",
    id_polifenol: "39",
    polifenol: "Hydrolyzable Tannins",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "3",
    pmids: "24885709,29324311,24818141",
  },
  {
    id: "4340",
    id_polifenol: "130",
    polifenol: "Proanthocyanidins",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "6",
    pmids: "26539720,21922132,29576805,28529565,19172579,29256569",
  },
  {
    id: "4341",
    id_polifenol: "35",
    polifenol: "Hydroquinones",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "4",
    pmids: "15571862,29519737,12204477,16854066",
  },
  {
    id: "4342",
    id_polifenol: "111",
    polifenol: "Flavanones",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "7",
    pmids: "10418944,28286420,18507063,24710903,17127502,27089313,15787448",
  },
  {
    id: "4343",
    id_polifenol: "4502",
    polifenol: "fisetin",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "4",
    pmids: "27121110,29544480,28598107,28119082",
  },
  {
    id: "4344",
    id_polifenol: "6",
    polifenol: "Catechols",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "2",
    pmids: "24523750,25498967",
  },
  {
    id: "4345",
    id_polifenol: "25",
    polifenol: "Butylated Hydroxytoluene",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "27829607",
  },
  {
    id: "4346",
    id_polifenol: "75",
    polifenol: "Butylated Hydroxyanisole",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "6",
    pmids: "19325135,21143894,21556631,8751562,8616765,11156257",
  },
  {
    id: "4347",
    id_polifenol: "6087",
    polifenol: "wogonin",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "7",
    pmids: "24490490,12917023,21244577,29181409,20872277,29324735,22284780",
  },
  {
    id: "4348",
    id_polifenol: "4519",
    polifenol: "myricetin",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "4",
    pmids: "26113875,26782830,26315556,28588737",
  },
  {
    id: "4349",
    id_polifenol: "4515",
    polifenol: "baicalin",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "4",
    pmids: "23502466,29039573,28545442,25663929",
  },
  {
    id: "4350",
    id_polifenol: "4500",
    polifenol: "procyanidin",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "6",
    pmids: "27470560,19172579,23967153,20175642,25005945,27279694",
  },
  {
    id: "4351",
    id_polifenol: "5608",
    polifenol: "epicatechin gallate",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "3",
    pmids: "26648098,25794927,10518005",
  },
  {
    id: "4352",
    id_polifenol: "1356",
    polifenol: "gingerol",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "3",
    pmids: "18096028,18054183,18449496",
  },
  {
    id: "4353",
    id_polifenol: "54",
    polifenol: "Salicylic Acid",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "3",
    pmids: "22644854,22530891,18575740",
  },
  {
    id: "4354",
    id_polifenol: "98",
    polifenol: "Propofol",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "3",
    pmids: "25556276,27982283,23852894",
  },
  {
    id: "4355",
    id_polifenol: "5607",
    polifenol: "gallocatechol",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "3",
    pmids: "19172579,16786054,10518005",
  },
  {
    id: "4356",
    id_polifenol: "5578",
    polifenol: "alpha-naphthoflavone",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "2",
    pmids: "12093619,25516145",
  },
  {
    id: "4357",
    id_polifenol: "44",
    polifenol: "Salicylates",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "23483185",
  },
  {
    id: "4358",
    id_polifenol: "4559",
    polifenol: "theaflavin",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "3",
    pmids: "29048667,27082635,26851019",
  },
  {
    id: "4359",
    id_polifenol: "5808",
    polifenol: "isoliquiritigenin",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "3",
    pmids: "22963151,29606882,28934130",
  },
  {
    id: "4360",
    id_polifenol: "2344",
    polifenol: "methyl gallate",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "5",
    pmids: "15380225,25816079,16786054,17487111,21903153",
  },
  {
    id: "4361",
    id_polifenol: "4708",
    polifenol: "xanthohumol",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "3",
    pmids: "10418944,25771121,21616523",
  },
  {
    id: "4362",
    id_polifenol: "2284",
    polifenol: "rosmarinic acid",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "22325591",
  },
  {
    id: "4363",
    id_polifenol: "112",
    polifenol: "Hesperidin",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "5",
    pmids: "29142606,2257224,2131036,12510833,21584546",
  },
  {
    id: "4364",
    id_polifenol: "6455",
    polifenol: "nobiletin",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "3",
    pmids: "29635125,25845666,25663929",
  },
  {
    id: "4365",
    id_polifenol: "10",
    polifenol: "Estrogens, Catechol",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "15050414",
  },
  {
    id: "4366",
    id_polifenol: "4513",
    polifenol: "galangin",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "26113875",
  },
  {
    id: "4367",
    id_polifenol: "6063",
    polifenol: "naringin",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "5",
    pmids: "29456667,19005980,26345098,29928387,24710903",
  },
  {
    id: "4368",
    id_polifenol: "1380",
    polifenol: "shogaol",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "2",
    pmids: "18096028,18449496",
  },
  {
    id: "4369",
    id_polifenol: "2158",
    polifenol: "protocatechuic acid",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "28229391",
  },
  {
    id: "4370",
    id_polifenol: "5489",
    polifenol: "delphinidin",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "2",
    pmids: "26704080,29122484",
  },
  {
    id: "4371",
    id_polifenol: "6273",
    polifenol: "hesperetin",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "2",
    pmids: "2131036,26520390",
  },
  {
    id: "4372",
    id_polifenol: "1613",
    polifenol: "demethoxycurcumin",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "3",
    pmids: "28345465,26987300,9868158",
  },
  {
    id: "4373",
    id_polifenol: "93",
    polifenol: "Phloroglucinol",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "5",
    pmids: "23628508,20127665,23669242,23286240,15303262",
  },
  {
    id: "4374",
    id_polifenol: "6454",
    polifenol: "formononetin",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "2",
    pmids: "29761845,29660466",
  },
  {
    id: "4375",
    id_polifenol: "81",
    polifenol: "Fenofibrate",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "25341341",
  },
  {
    id: "4376",
    id_polifenol: "7550",
    polifenol: "3-methylquercetin",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "21246822",
  },
  {
    id: "4377",
    id_polifenol: "6461",
    polifenol: "acacetin",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "21893035",
  },
  {
    id: "4378",
    id_polifenol: "1611",
    polifenol: "bis(4-hydroxycinnamoyl)methane",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "4",
    pmids: "27349797,26987300,9868158,26548708",
  },
  {
    id: "4379",
    id_polifenol: "69",
    polifenol: "Phenolsulfonphthalein",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "2",
    pmids: "21541621,15737688",
  },
  {
    id: "4380",
    id_polifenol: "126",
    polifenol: "Coumestrol",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "26698565",
  },
  {
    id: "4381",
    id_polifenol: "5806",
    polifenol: "butein",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "2",
    pmids: "26119952,27121110",
  },
  {
    id: "4382",
    id_polifenol: "5509",
    polifenol: "cyanidin 3-O-glucoside",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "2",
    pmids: "22994001,28428026",
  },
  {
    id: "4383",
    id_polifenol: "969",
    polifenol: "3,4-dihydroxyphenacyl caffeate phenylpropanoid ester",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "23139124",
  },
  {
    id: "4384",
    id_polifenol: "5844",
    polifenol: "4-dimethylamino-3',4'-dimethoxychalcone",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "3",
    pmids: "18603835,11865194,10928117",
  },
  {
    id: "4385",
    id_polifenol: "5819",
    polifenol: "licochalcone A",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "2",
    pmids: "23921841,22465181",
  },
  {
    id: "4386",
    id_polifenol: "4560",
    polifenol: "icariin",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "25845681",
  },
  {
    id: "4387",
    id_polifenol: "48",
    polifenol: "Anacardic Acids",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "24921663",
  },
  {
    id: "4388",
    id_polifenol: "4537",
    polifenol: "flavone acetic acid",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "18097594",
  },
  {
    id: "4389",
    id_polifenol: "80",
    polifenol: "Clofibrate",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "2",
    pmids: "24247298,19426685",
  },
  {
    id: "4390",
    id_polifenol: "132",
    polifenol: "Equol",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "2",
    pmids: "11566575,28654894",
  },
  {
    id: "4391",
    id_polifenol: "1995",
    polifenol: "2-tert-butylhydroquinone",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "2",
    pmids: "20693500,26770651",
  },
  {
    id: "4392",
    id_polifenol: "1673",
    polifenol: "4-hydroxyestradiol",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "3",
    pmids: "12093619,23757313,23593315",
  },
  {
    id: "4393",
    id_polifenol: "7546",
    polifenol: "isoquercitrin",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "23768357",
  },
  {
    id: "4394",
    id_polifenol: "6482",
    polifenol: "tangeretin",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "2",
    pmids: "19903849,25663929",
  },
  {
    id: "4395",
    id_polifenol: "89",
    polifenol: "Vanillic Acid",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "26004731",
  },
  {
    id: "4396",
    id_polifenol: "1644",
    polifenol: "Cur1 compound",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "2",
    pmids: "23660215,28217982",
  },
  {
    id: "4397",
    id_polifenol: "5614",
    polifenol: "catechin gallate",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "21903153",
  },
  {
    id: "4398",
    id_polifenol: "4486",
    polifenol: "amentoflavone",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "2",
    pmids: "28286104,28942285",
  },
  {
    id: "4399",
    id_polifenol: "5850",
    polifenol: "cardamonin",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "4",
    pmids: "29456744,29772587,26393941,29445291",
  },
  {
    id: "4400",
    id_polifenol: "118",
    polifenol: "Flavonolignans",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "2",
    pmids: "23054487,23139124",
  },
  {
    id: "4401",
    id_polifenol: "7541",
    polifenol: "taxifolin",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "19005980",
  },
  {
    id: "4402",
    id_polifenol: "7544",
    polifenol: "quercitrin",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "2",
    pmids: "29438890,25794927",
  },
  {
    id: "4403",
    id_polifenol: "300",
    polifenol: "rhodioloside",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "29616120",
  },
  {
    id: "4404",
    id_polifenol: "7912",
    polifenol: "7,9,2',4'-tetrahydroxy-8-isopentenyl-5-methoxychalcone",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "17326683",
  },
  {
    id: "4405",
    id_polifenol: "6465",
    polifenol: "genistin",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "2",
    pmids: "17291540,28111515",
  },
  {
    id: "4406",
    id_polifenol: "350",
    polifenol: "nonylphenol",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "4",
    pmids: "22552626,26407941,18854640,25690688",
  },
  {
    id: "4407",
    id_polifenol: "4767",
    polifenol: "flavan-3-ol",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "2",
    pmids: "27470560,25776829",
  },
  {
    id: "4408",
    id_polifenol: "2475",
    polifenol: "6-O-galloylglucose",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "25816079",
  },
  {
    id: "4409",
    id_polifenol: "92",
    polifenol: "Triclosan",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "24835555",
  },
  {
    id: "4410",
    id_polifenol: "6097",
    polifenol: "8-prenylnaringenin",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "25771121",
  },
  {
    id: "4411",
    id_polifenol: "1996",
    polifenol: "2,5-di-tert-butylhydroquinone",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "29410730",
  },
  {
    id: "4412",
    id_polifenol: "5071",
    polifenol: "icaritin",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "29625193",
  },
  {
    id: "4413",
    id_polifenol: "6625",
    polifenol: "phenoxodiol",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "10",
    pmids:
      "15666998,12730675,16353157,17904534,29277787,19156549,17457041,16507219,19364253,16784025",
  },
  {
    id: "4414",
    id_polifenol: "6086",
    polifenol: "liquiritigenin",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "2",
    pmids: "28482871,28654894",
  },
  {
    id: "4415",
    id_polifenol: "7296",
    polifenol: "dihydromyricetin",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "28436480",
  },
  {
    id: "4416",
    id_polifenol: "7134",
    polifenol: "vitexin",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "3",
    pmids: "19671865,27387399,12510833",
  },
  {
    id: "4417",
    id_polifenol: "6558",
    polifenol: "7,3'-dihydroxy-4'-methoxyisoflavone",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "25672608",
  },
  {
    id: "4418",
    id_polifenol: "4796",
    polifenol: "aminoflavone",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "28326515",
  },
  {
    id: "4419",
    id_polifenol: "5455",
    polifenol: "theaflavin-3,3'-digallate",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "4",
    pmids: "27082635,26648098,26851019,29301278",
  },
  {
    id: "4420",
    id_polifenol: "2490",
    polifenol: "punicalagin",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "27540692",
  },
  {
    id: "4421",
    id_polifenol: "7547",
    polifenol: "hyperoside",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "28197632",
  },
  {
    id: "4422",
    id_polifenol: "19",
    polifenol: "Pentachlorophenol",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "7604397",
  },
  {
    id: "4423",
    id_polifenol: "6783",
    polifenol: "protoapigenone",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "18430509",
  },
  {
    id: "4424",
    id_polifenol: "6477",
    polifenol: "hispidulin",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "2",
    pmids: "20734985,28641489",
  },
  {
    id: "4425",
    id_polifenol: "7557",
    polifenol: "rhamnetin",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "27045836",
  },
  {
    id: "4426",
    id_polifenol: "1353",
    polifenol: "protocatechualdehyde",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "25320407",
  },
  {
    id: "4427",
    id_polifenol: "4304",
    polifenol: "5-7-oxo-zeaenol",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "2",
    pmids: "27764753,25277189",
  },
  {
    id: "4428",
    id_polifenol: "7775",
    polifenol: "glyceollin",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "3",
    pmids: "19797619,17145841,21336922",
  },
  {
    id: "4429",
    id_polifenol: "687",
    polifenol: "calix(4)arene",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "5",
    pmids: "19171382,20890536,26824462,28849826,27009430",
  },
  {
    id: "4430",
    id_polifenol: "5796",
    polifenol: "dihydrochalcone",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "28937626",
  },
  {
    id: "4431",
    id_polifenol: "2574",
    polifenol: "4-hydroxybenzoic acid",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "28229391",
  },
  {
    id: "4432",
    id_polifenol: "3019",
    polifenol: "nitroaspirin",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "17760507",
  },
  {
    id: "4433",
    id_polifenol: "6452",
    polifenol: "chrysoeriol",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "19833205",
  },
  {
    id: "4434",
    id_polifenol: "4480",
    polifenol: "myricitrin",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "2",
    pmids: "29438890,25794927",
  },
  {
    id: "4435",
    id_polifenol: "413",
    polifenol: "4-nonylphenol",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "3",
    pmids: "24308608,24278580,15461258",
  },
  {
    id: "4436",
    id_polifenol: "3489",
    polifenol: "anethole",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "23155250",
  },
  {
    id: "4437",
    id_polifenol: "1672",
    polifenol: "B19 monocarbonyl curcumin",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "23983610",
  },
  {
    id: "4438",
    id_polifenol: "2014",
    polifenol: "erbstatin",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "7591273",
  },
  {
    id: "4439",
    id_polifenol: "6554",
    polifenol: "tectorigenin",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "23027625",
  },
  {
    id: "4440",
    id_polifenol: "2450",
    polifenol: "Geraniin",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "28590547",
  },
  {
    id: "4441",
    id_polifenol: "4565",
    polifenol: "morusin",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "29421517",
  },
  {
    id: "4442",
    id_polifenol: "2697",
    polifenol: "4-trifluoromethylsalicylic acid",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "16254462",
  },
  {
    id: "4443",
    id_polifenol: "2454",
    polifenol: "corilagin",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "5",
    pmids: "28791374,23410205,28408846,29324311,29751073",
  },
  {
    id: "4444",
    id_polifenol: "357",
    polifenol: "4-aminophenol",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "2",
    pmids: "29714468,16712937",
  },
  {
    id: "4445",
    id_polifenol: "704",
    polifenol: "trizol",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "2",
    pmids: "15297183,15456535",
  },
  {
    id: "4446",
    id_polifenol: "84",
    polifenol: "Halogenated Diphenyl Ethers",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "2",
    pmids: "22472210,26988655",
  },
  {
    id: "4447",
    id_polifenol: "4479",
    polifenol: "morin",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "28599307",
  },
  {
    id: "4448",
    id_polifenol: "2364",
    polifenol: "theaflavine gallate",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "2",
    pmids: "29048667,26851019",
  },
  {
    id: "4449",
    id_polifenol: "4052",
    polifenol: "bis-(3-(3',5'-di-tert-butyl-4'-hydroxyphenyl)propyl)sulfide",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "2",
    pmids: "18214481,25752056",
  },
  {
    id: "4450",
    id_polifenol: "9",
    polifenol: "1,2-Dihydroxybenzene-3,5-Disulfonic Acid Disodium Salt",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "16763728",
  },
  {
    id: "4451",
    id_polifenol: "347",
    polifenol: "4-nitrophenyl",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "2",
    pmids: "26968704,24070612",
  },
  {
    id: "4452",
    id_polifenol: "7199",
    polifenol: "luteolin-7-glucoside",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "2",
    pmids: "26098839,25630793",
  },
  {
    id: "4453",
    id_polifenol: "5885",
    polifenol: "2',4'-dihydroxy-6'-methoxy-3',5'-dimethylchalcone",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "19242112",
  },
  {
    id: "4454",
    id_polifenol: "7140",
    polifenol: "isovitexin",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "27387399",
  },
  {
    id: "4455",
    id_polifenol: "4981",
    polifenol: "jaceosidin",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "18769496",
  },
  {
    id: "4456",
    id_polifenol: "4639",
    polifenol: "aromadedrin",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "21246822",
  },
  {
    id: "4457",
    id_polifenol: "3258",
    polifenol: "tesmilifene",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "2",
    pmids: "9414663,9071911",
  },
  {
    id: "4458",
    id_polifenol: "5615",
    polifenol: "gallocatechin gallate",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "21903153",
  },
  {
    id: "4459",
    id_polifenol: "826",
    polifenol: "4,4',4''-(4-propyl-((1)H)-pyrazole-1,3,5-triyl) tris-phenol",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "3",
    pmids: "23229410,23885094,24379833",
  },
  {
    id: "4460",
    id_polifenol: "5858",
    polifenol: "isobavachalcone",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "21351454",
  },
  {
    id: "4461",
    id_polifenol: "6008",
    polifenol: "millepachine",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "27447570",
  },
  {
    id: "4462",
    id_polifenol: "792",
    polifenol: "octylphenol",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "3",
    pmids: "22552626,18854640,27145024",
  },
  {
    id: "4463",
    id_polifenol: "2807",
    polifenol: "thiosalicylic acid",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "16515591",
  },
  {
    id: "4464",
    id_polifenol: "79",
    polifenol: "Clofibric Acid",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "2",
    pmids: "17431116,17786343",
  },
  {
    id: "4465",
    id_polifenol: "416",
    polifenol: "phenoxy radical",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "20023915",
  },
  {
    id: "4466",
    id_polifenol: "1675",
    polifenol: "catechol estrogen 3,4-quinone",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "23994691",
  },
  {
    id: "4467",
    id_polifenol: "5289",
    polifenol: "8-bromo-7-methoxychrysin",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "26151347",
  },
  {
    id: "4468",
    id_polifenol: "1718",
    polifenol: "dihydroguaiaretic acid",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "2",
    pmids: "28229391,19916529",
  },
  {
    id: "4469",
    id_polifenol: "1237",
    polifenol: "2,4-bis(p-hydroxyphenyl)-2-butenal",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "2",
    pmids: "28277616,24390815",
  },
  {
    id: "4470",
    id_polifenol: "7422",
    polifenol: "kaempferide",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "26345098",
  },
  {
    id: "4471",
    id_polifenol: "2173",
    polifenol: "atranorin",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "22285236",
  },
  {
    id: "4472",
    id_polifenol: "6687",
    polifenol: "3'-dimethylaminoflavone",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "15571862",
  },
  {
    id: "4473",
    id_polifenol: "3386",
    polifenol: "2,2',4,4'-tetrabromodiphenyl ether",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "26988655",
  },
  {
    id: "4474",
    id_polifenol: "7290",
    polifenol: "5,2'-dihydroxy-7,8-dimethoxy-dihydroflavonol-3-O-acetate",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "17326683",
  },
  {
    id: "4475",
    id_polifenol: "5101",
    polifenol: "isokaempferide",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "26345098",
  },
  {
    id: "4476",
    id_polifenol: "4608",
    polifenol: "artonin E",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "27019365",
  },
  {
    id: "4477",
    id_polifenol: "5536",
    polifenol: "prodelphinidin B-2 3'-O-gallate",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "28529565",
  },
  {
    id: "4478",
    id_polifenol: "1492",
    polifenol: "hirsutenone",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "2",
    pmids: "21120579,24247248",
  },
  {
    id: "4479",
    id_polifenol: "630",
    polifenol: "4-tert-octylphenol",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "2",
    pmids: "27145024,27534135",
  },
  {
    id: "4480",
    id_polifenol: "273",
    polifenol: "bis(4-nitrophenyl)phosphate",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "15205340",
  },
  {
    id: "4481",
    id_polifenol: "7478",
    polifenol: "kaempferol-7-methyl ether",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "27045836",
  },
  {
    id: "4482",
    id_polifenol: "5720",
    polifenol: "4,3',4',5'- tetramethoxychalcone",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "25180593",
  },
  {
    id: "4483",
    id_polifenol: "6031",
    polifenol: "2',3'-dimethoxyflavanone",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "15043430",
  },
  {
    id: "4484",
    id_polifenol: "7763",
    polifenol: "7-difluoromethoxyl-5,4'-di-n-octylgenistein",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "5",
    pmids: "24604613,24959264,22447287,28627607,29088827",
  },
  {
    id: "4485",
    id_polifenol: "4534",
    polifenol: "3,5,6-trihydroxy-4',7'-dimethoxyflavone",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "18769496",
  },
  {
    id: "4486",
    id_polifenol: "6492",
    polifenol: "3(2H)-isoflavene",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "17904534",
  },
  {
    id: "4487",
    id_polifenol: "72",
    polifenol: "Phenyl Ethers",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "25879502",
  },
  {
    id: "4488",
    id_polifenol: "3299",
    polifenol: "pentabromodiphenyl ether",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "22472210",
  },
  {
    id: "4489",
    id_polifenol: "6786",
    polifenol: "8-hydroxy-3,4',5,6,7-pentamethoxyflavone",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "26788108",
  },
  {
    id: "4490",
    id_polifenol: "7736",
    polifenol: "7-monohydroxyethylrutoside",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "3",
    pmids: "17063376,17285121,9815559",
  },
  {
    id: "4491",
    id_polifenol: "393",
    polifenol: "2,6-di-tert-butylphenol",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "21556631",
  },
  {
    id: "4492",
    id_polifenol: "418",
    polifenol: "thiophenol",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "20890536",
  },
  {
    id: "4493",
    id_polifenol: "2768",
    polifenol: "salophen",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "25450023",
  },
  {
    id: "4494",
    id_polifenol: "5052",
    polifenol: "3-aminoflavone",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "28326515",
  },
  {
    id: "4495",
    id_polifenol: "7810",
    polifenol: "rotenolone",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "2",
    pmids: "20804165,15043430",
  },
  {
    id: "4496",
    id_polifenol: "6236",
    polifenol: "nymphaeol C",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "15787448",
  },
  {
    id: "4497",
    id_polifenol: "3908",
    polifenol: "aspidin BB",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "23628508",
  },
  {
    id: "4498",
    id_polifenol: "988",
    polifenol: "4'-O-methylnyasol",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "28277616",
  },
  {
    id: "4499",
    id_polifenol: "5907",
    polifenol: "aspalathin",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "28937626",
  },
  {
    id: "4500",
    id_polifenol: "7823",
    polifenol: "tephrosin",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "15043430",
  },
  {
    id: "4501",
    id_polifenol: "2472",
    polifenol: "sanguiin H 6",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "26725849",
  },
  {
    id: "4502",
    id_polifenol: "7352",
    polifenol: "3',4',5'-trimethoxyflavonol",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "26788108",
  },
  {
    id: "4503",
    id_polifenol: "7560",
    polifenol: "quercetin-3-O-neohesperidose",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "2131036",
  },
  {
    id: "4504",
    id_polifenol: "6470",
    polifenol: "O-desmethylangolensin",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "11566575",
  },
  {
    id: "4505",
    id_polifenol: "409",
    polifenol: "tetrachlorodian",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "3",
    pmids: "28111160,29653259,28811233",
  },
  {
    id: "4506",
    id_polifenol: "4",
    polifenol: "Bithionol",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "4",
    pmids: "28086831,24495391,28931042,27058706",
  },
  {
    id: "4507",
    id_polifenol: "7249",
    polifenol: "rhamnazin",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "27045836",
  },
  {
    id: "4508",
    id_polifenol: "7659",
    polifenol: "quercetin 7-rhamnoside",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "29438890",
  },
  {
    id: "4509",
    id_polifenol: "3435",
    polifenol: "N1-hydroxy-N8-(4-phenoxyphenyl)octanediamide",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "20596669",
  },
  {
    id: "4510",
    id_polifenol: "4689",
    polifenol: "5,3'-dihydroxy-3,6,7,8,4'-pentamethoxyflavone",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "7623025",
  },
  {
    id: "4511",
    id_polifenol: "5145",
    polifenol: "artonin B",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "27019365",
  },
  {
    id: "4512",
    id_polifenol: "3605",
    polifenol: "lyoniresinol",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "29223588",
  },
  {
    id: "4513",
    id_polifenol: "322",
    polifenol: "N-methyl-4-aminophenol",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "20023915",
  },
  {
    id: "4514",
    id_polifenol: "2531",
    polifenol: "sanguiin H-5",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "26725849",
  },
  {
    id: "4515",
    id_polifenol: "7027",
    polifenol: "chrysosplenol D",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "21469236",
  },
  {
    id: "4516",
    id_polifenol: "7210",
    polifenol: "luteolin-7-O-glucuronide",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "27387399",
  },
  {
    id: "4517",
    id_polifenol: "7232",
    polifenol: "IdB 1016",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "14556934",
  },
  {
    id: "4518",
    id_polifenol: "16",
    polifenol: "Chlorophenols",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "7604397",
  },
  {
    id: "4519",
    id_polifenol: "1423",
    polifenol: "Cancell",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "29173024",
  },
  {
    id: "4520",
    id_polifenol: "4945",
    polifenol: "3,5,6,4'-tetrahydroxy-7-methoxyflavonoid",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "19833205",
  },
  {
    id: "4521",
    id_polifenol: "2458",
    polifenol: "glucogallin",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "21903153",
  },
  {
    id: "4522",
    id_polifenol: "5409",
    polifenol: "5-hydroxy-7-methoxyflavone",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "2131036",
  },
  {
    id: "4523",
    id_polifenol: "874",
    polifenol: "WAY 200070",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "28482871",
  },
  {
    id: "4524",
    id_polifenol: "5639",
    polifenol: "4-(S-cysteinyl)epicatechin 3-O-gallate",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "15380225",
  },
  {
    id: "4525",
    id_polifenol: "6022",
    polifenol: "morachalcone A",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "2",
    pmids: "21246822,21351454",
  },
  {
    id: "4526",
    id_polifenol: "6034",
    polifenol: "diplacone",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "17326683",
  },
  {
    id: "4527",
    id_polifenol: "4649",
    polifenol: "centaureidin",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "21995542",
  },
  {
    id: "4528",
    id_polifenol: "4791",
    polifenol: "myricetin 3-O-(2'',3''-di-O-galloyl)rhamnopyranoside",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "25794927",
  },
  {
    id: "4529",
    id_polifenol: "7542",
    polifenol: "pachypodol",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "27045836",
  },
  {
    id: "4530",
    id_polifenol: "5529",
    polifenol:
      "epicatechin-(4beta-8,2beta-O-7)-epicatechin-(4beta-8)-epicatechin",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "20175642",
  },
  {
    id: "4531",
    id_polifenol: "4306",
    polifenol: "lasiodiplodin",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "21480509",
  },
  {
    id: "4532",
    id_polifenol: "6773",
    polifenol: "5,7-dihydroxy-6,4'-dimethoxyflavone",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "24772822",
  },
  {
    id: "4533",
    id_polifenol: "1736",
    polifenol: "4-ethylguaiacol",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "25874627",
  },
  {
    id: "4534",
    id_polifenol: "5175",
    polifenol: "5-allyl-7-gen-difluoromethylenechrysin",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "18261306",
  },
  {
    id: "4535",
    id_polifenol: "618",
    polifenol: "1-(4'-hydroxyphenyl)butenone",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "28824426",
  },
  {
    id: "4536",
    id_polifenol: "2286",
    polifenol: "digallic acid",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "21903153",
  },
  {
    id: "4537",
    id_polifenol: "2392",
    polifenol: "1,6-di-O-galloyl-beta-D-glucose",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "21903153",
  },
  {
    id: "4538",
    id_polifenol: "1337",
    polifenol: "3,3',4,4'-tetrahydroxystilbene",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "26229578",
  },
  {
    id: "4539",
    id_polifenol: "3225",
    polifenol: "decabromobiphenyl ether",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "22472210",
  },
  {
    id: "4540",
    id_polifenol: "6292",
    polifenol: "tricin 4'-O-(threo-beta-guaiacylglyceryl) ether",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "23054487",
  },
  {
    id: "4541",
    id_polifenol: "6293",
    polifenol: "tricin 4'-O-(erythro-beta-guaiacylglyceryl) ether",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "23054487",
  },
  {
    id: "4542",
    id_polifenol: "5346",
    polifenol: "sideroxylin",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "29904922",
  },
  {
    id: "4543",
    id_polifenol: "2202",
    polifenol: "4-(2,6-dihydroxybenzoyl)-3-formyl-5-hydroxybenzoic acid",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "2071487",
  },
  {
    id: "4544",
    id_polifenol: "6543",
    polifenol: "euchrenone b10",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "21246822",
  },
  {
    id: "4545",
    id_polifenol: "4847",
    polifenol: "bonannione A",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "2",
    pmids: "17326683,15787448",
  },
  {
    id: "4546",
    id_polifenol: "7750",
    polifenol: "2'-hydroxy-genistein",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "29552162",
  },
  {
    id: "4547",
    id_polifenol: "6051",
    polifenol: "sanggenol L",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "26555861",
  },
  {
    id: "4548",
    id_polifenol: "5881",
    polifenol: "2',3,4,4'-tetrahydroxy-5-prenylchalcone",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "10418944",
  },
  {
    id: "4549",
    id_polifenol: "275",
    polifenol: "trichlorophene",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "28699489",
  },
  {
    id: "4550",
    id_polifenol: "7761",
    polifenol: "ITB 301",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "21340606",
  },
  {
    id: "4551",
    id_polifenol: "6795",
    polifenol: "6-amino-7-hydroxy-flavone",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "28326515",
  },
  {
    id: "4552",
    id_polifenol: "3941",
    polifenol: "erectquione B",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "20127665",
  },
  {
    id: "4553",
    id_polifenol: "1481",
    polifenol: "AGL 2592",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "12748499",
  },
  {
    id: "4554",
    id_polifenol: "4372",
    polifenol:
      "quercetin 3-O-alpha-rhamnopyranoside-7-O-beta-D-glucopyranosyl-(1-3)-alpha-L-rhamnopyranoside",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "7623025",
  },
  {
    id: "4555",
    id_polifenol: "7076",
    polifenol: "7-(O)-carboxymethyl daidzein N-t-Boc-hexylenediamine conjugate",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "19738422",
  },
  {
    id: "4556",
    id_polifenol: "5290",
    polifenol: "(2'R)-4'-hydroxyemoroidocarpan",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "20804165",
  },
  {
    id: "4557",
    id_polifenol: "5292",
    polifenol: "pongavilleanine",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "20804165",
  },
  {
    id: "4558",
    id_polifenol: "5291",
    polifenol: "epipervilline",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "20804165",
  },
  {
    id: "4559",
    id_polifenol: "2386",
    polifenol: "4-O-galloylbergenin",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "25794927",
  },
  {
    id: "4560",
    id_polifenol: "4954",
    polifenol: "chrysoplenetin",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "21469236",
  },
  {
    id: "4561",
    id_polifenol: "2235",
    polifenol: "tschimgin",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "23701832",
  },
  {
    id: "4562",
    id_polifenol: "7111",
    polifenol: "urgineanin A",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "23659371",
  },
  {
    id: "4563",
    id_polifenol: "4287",
    polifenol: "3,5-dihydroxybenzyl alcohol",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "23054715",
  },
  {
    id: "4564",
    id_polifenol: "3996",
    polifenol: "uliginosin B",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "23669242",
  },
  {
    id: "4565",
    id_polifenol: "5530",
    polifenol:
      "epicatechin-(4beta-8)-epicatechin-(4beta-8,2beta-O-7)-epicatechin-(4beta-8)-epicatechin",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "20175642",
  },
  {
    id: "4566",
    id_polifenol: "302",
    polifenol: "tetrachlorophenol",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "7604397",
  },
  {
    id: "4567",
    id_polifenol: "445",
    polifenol: "2,3,5-trichlorophenol",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "7604397",
  },
  {
    id: "4568",
    id_polifenol: "661",
    polifenol: "3,5-dichlorophenol",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "7604397",
  },
  {
    id: "4569",
    id_polifenol: "373",
    polifenol: "4-chlorophenol",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "7604397",
  },
  {
    id: "4570",
    id_polifenol: "3452",
    polifenol: "2,2',4,5'-tetrabromodiphenyl ether",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "26988655",
  },
  {
    id: "4571",
    id_polifenol: "4691",
    polifenol: "kuwanon H",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "21351454",
  },
  {
    id: "4572",
    id_polifenol: "5493",
    polifenol: "paeonin",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "25068201",
  },
  {
    id: "4573",
    id_polifenol: "6101",
    polifenol: "remangiflavanone A",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "17127502",
  },
  {
    id: "4574",
    id_polifenol: "4039",
    polifenol: "mallotojaponin B",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "23286240",
  },
  {
    id: "4575",
    id_polifenol: "2266",
    polifenol: "benzyl-2-beta-glucopyranosyloxybenzoate",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "22628042",
  },
  {
    id: "4576",
    id_polifenol: "4074",
    polifenol: "pyrogallol 1,3-dimethyl ether",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "25879502",
  },
  {
    id: "4577",
    id_polifenol: "6147",
    polifenol: "schizolaenone A",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "15787448",
  },
  {
    id: "4578",
    id_polifenol: "6148",
    polifenol: "schizolaenone B",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "15787448",
  },
  {
    id: "4579",
    id_polifenol: "6149",
    polifenol: "4'-O-methylbonannione A",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "15787448",
  },
  {
    id: "4580",
    id_polifenol: "5029",
    polifenol: "isomundulinol",
    id_cancer: "538",
    cancer: "Ovarian Cancer",
    quant: "1",
    pmids: "15043430",
  },
  {
    id: "4581",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "96",
    pmids:
      "28260058,10963959,25000190,24706622,23621210,20838625,21827495,29352974,25453494,22245252,24618693,23001390,23913940,23438826,26148186,24104352,29734739,28830513,28105189,22591439,19719238,23973682,24443427,29052399,25971889,20469635,28286420,24275163,15638088,28410220,26517521,27530117,23722601,26646850,21346776,27764752,25203554,25016296,29542423,11891088,27168755,21674787,27745695,23173924,14969337,18688565,18440233,22887049,10739098,22983392,29144597,25931350,10918203,24070738,27668542,26795272,21351299,29380243,25102117,11595883,24377461,22899374,17034658,26810568,24675012,8642556,11772931,27262066,20540768,23304254,15584372,10569809,26959747,16699821,27616072,22993618,17847709,9114752,18791269,19865514,15489212,21196432,11134977,28403777,27981754,21121257,11327532,26863880,24868862,27164914,15586237,26498482,1596889,1812215,12819936,19538057",
  },
  {
    id: "4582",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "79",
    pmids:
      "26573768,25262359,21627988,25725129,27502897,22899991,12473670,26116776,17885582,27106025,23940701,20576164,20596635,25730045,28926928,22045655,29208180,20030852,12678405,26537230,26305550,18493855,29312556,15044619,28167449,10969724,20525240,15999103,15221965,7656234,23341182,27192978,29426248,22448259,24036260,21989768,23359272,21859497,24255713,11795474,19368804,27040234,23701832,23495216,25747515,22915849,25268623,21088500,26085173,8142920,22189271,28639178,29790012,29039788,21084858,24349037,28882690,28403559,19779032,26597940,29869202,25742310,24881520,18462866,21830481,16722634,24423564,26334519,22335582,22080352,27280688,29195800,21730846,23967373,26864554,25243783,24746691,27565688,22609787",
  },
  {
    id: "4583",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "54",
    pmids:
      "17475222,25694272,20927579,20838625,25821561,17984116,25453494,20528747,17135264,28186123,28926928,18313195,19650861,20030852,28208804,24965756,21810170,12565170,11746506,22532866,22957077,15736313,29359608,25567208,27253407,20548792,17827407,15993843,10918203,7656234,25102117,21989768,27843913,12529996,26651028,18324763,28053887,26825069,29039788,24349037,19358568,21302360,21830481,9255591,11138532,21196432,27896891,10594754,27280688,27164914,29966007,24746691,12821280,22141580",
  },
  {
    id: "4584",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "35",
    pmids:
      "17251686,21482077,23370368,18706445,22120676,20232365,24466036,18068334,21637924,19383798,15657063,11888667,18089783,12851530,24448842,18540849,11918086,11781826,22328534,25727011,10640428,24778037,17181633,26699907,24116290,29125193,12455029,12387830,18826602,15389589,15581417,28586027,19724275,11997078,21624769",
  },
  {
    id: "4585",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "33",
    pmids:
      "25072850,29433671,12950722,12121829,7689614,23973682,7892284,12951063,10809772,7532663,16969510,28423510,12851530,16186104,12441353,10927861,7593207,8426092,25756279,11523549,7852370,19735546,8652271,15584372,9748142,11739876,9507517,9650564,10836210,26864554,26498482,9714343,23678808",
  },
  {
    id: "4586",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "42",
    pmids:
      "21827495,26148186,17135264,24506026,11467774,25971889,20469635,24275163,15638088,21472244,27764752,19731038,21090173,15736313,18688565,28373417,25931350,10918203,7656234,29380243,27843913,11595883,24377461,7650296,17034658,25747515,23949287,23919744,20540768,15584372,29606130,23556141,22993618,9114752,26018751,18791269,15489212,21196432,11134977,11327532,27433577,25464055",
  },
  {
    id: "4587",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "37",
    pmids:
      "27791197,21982776,16052524,21209554,26754091,24855338,28186123,19502799,24269590,19650861,20232120,24965756,14607278,20037825,11746506,11525605,8826614,20548792,24213313,16051220,15609335,23807168,11772931,29429153,18955299,29255416,27869750,20438353,26018751,25294877,26845066,1511409,21903153,7480211,28440509,26864554,10882869",
  },
  {
    id: "4588",
    id_polifenol: "2167",
    polifenol: "phenolic acid",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "36",
    pmids:
      "23939793,27492128,23958424,20838625,20044952,22899608,7907080,19007765,28659804,28960771,28208804,23722601,22634840,14758047,29542423,19731038,27168755,25931350,24130029,27668542,28222613,22899374,26810568,23265523,26839997,27262066,19615898,19865514,29556122,15489212,27981754,24802115,21121257,21903153,27164914,8433013",
  },
  {
    id: "4589",
    id_polifenol: "49",
    polifenol: "Aspirin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "18",
    pmids:
      "28636992,29196297,26774931,16507396,27615282,23874405,26699907,3343338,18849138,7653891,3921747,18971789,18175938,3020255,24492939,7326871,24932579,17673806",
  },
  {
    id: "4590",
    id_polifenol: "109",
    polifenol: "Catechin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "24",
    pmids:
      "25821561,21827495,11746506,11525605,21432719,8826614,17827407,7656234,16051220,18324763,25747515,28088004,21081808,9875442,29429153,18955299,15584372,29255416,27869750,21302360,20045947,15489212,21903153,7480211",
  },
  {
    id: "4591",
    id_polifenol: "125",
    polifenol: "Isoflavones",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "13",
    pmids:
      "12950722,7892284,10809772,19497419,18440233,26147490,11523549,25395701,27100701,15584372,9507517,25553084,27189479",
  },
  {
    id: "4592",
    id_polifenol: "110",
    polifenol: "Chalcones",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "23",
    pmids:
      "21263202,19155103,27727127,19483325,27224920,17424936,29065840,28750204,21816519,23043766,18440233,26951491,20709029,23895019,27217001,21752198,25594392,16055334,22076705,28344479,29753256,17627575,2362275",
  },
  {
    id: "4593",
    id_polifenol: "3089",
    polifenol: "1,1-diphenyl-2-picrylhydrazyl",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "23",
    pmids:
      "23939793,25446237,27492128,24070160,29191192,28960771,28208804,20469635,29771951,27148169,29542423,19731038,23173924,29790302,24130029,25250850,26839997,27168679,17936865,29196839,22339064,19865514,25464055",
  },
  {
    id: "4594",
    id_polifenol: "114",
    polifenol: "Apigenin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "10",
    pmids:
      "28260058,23973682,22086925,20469635,23354402,10918203,24070738,23898082,27616072,26864554",
  },
  {
    id: "4595",
    id_polifenol: "113",
    polifenol: "Flavones",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "12",
    pmids:
      "29734739,22086925,20469635,29771951,29542423,25931350,21351299,17363487,15165133,21121257,20811719,1812215",
  },
  {
    id: "4596",
    id_polifenol: "38",
    polifenol: "Gallic Acid",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "15",
    pmids:
      "27492128,28208804,27148169,19731038,20596665,21734530,24130029,11911262,21081808,27168679,17936865,15489212,28746057,24802115,21903153",
  },
  {
    id: "4597",
    id_polifenol: "117",
    polifenol: "Luteolin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "8",
    pmids:
      "23621210,20469635,22983392,26279214,21351299,22993618,15489212,26864554",
  },
  {
    id: "4598",
    id_polifenol: "1",
    polifenol: "Phenols",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "13",
    pmids:
      "16504517,27502897,28208804,6788955,28222613,2548717,11911262,27168679,21317816,22001498,24868862,27164914,9473785",
  },
  {
    id: "4599",
    id_polifenol: "105",
    polifenol: "Anthocyanins",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "6",
    pmids: "23869191,18767864,28680383,23265523,23890760,28468289",
  },
  {
    id: "4600",
    id_polifenol: "7235",
    polifenol: "silybin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "21703257",
  },
  {
    id: "4601",
    id_polifenol: "129",
    polifenol: "Rotenone",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "11",
    pmids:
      "25072850,12121829,18998398,29692266,27612957,28189086,29380243,9186779,25448047,26498482,2614425",
  },
  {
    id: "4602",
    id_polifenol: "121",
    polifenol: "Kaempferols",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "8",
    pmids:
      "25453494,29433671,23936765,20469635,29771951,19731038,29552787,27745695",
  },
  {
    id: "4603",
    id_polifenol: "871",
    polifenol: "ABT-737",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "19",
    pmids:
      "26116776,18987671,25350317,26204252,22214861,18807035,23213401,25215949,24608435,21555592,22173547,23152056,21897876,25624498,27086916,27829238,18949061,21893020,21915275",
  },
  {
    id: "4604",
    id_polifenol: "6451",
    polifenol: "daidzein",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "5",
    pmids: "25072850,12121829,8142920,9507517,26498482",
  },
  {
    id: "4605",
    id_polifenol: "6065",
    polifenol: "baicalein",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "4",
    pmids: "27530117,11434681,8869751,15489212",
  },
  {
    id: "4606",
    id_polifenol: "7",
    polifenol: "Capsaicin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "9",
    pmids:
      "22143933,12034025,29580868,11171586,24084605,25283529,26864554,28526335,22797854",
  },
  {
    id: "4607",
    id_polifenol: "4634",
    polifenol: "alvocidib",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "6",
    pmids: "27149123,21477078,29464063,9815683,11426645,12819936",
  },
  {
    id: "4608",
    id_polifenol: "120",
    polifenol: "Flavonols",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "8",
    pmids:
      "23925650,17190444,29029040,20469635,14969337,18440233,7623025,25931350",
  },
  {
    id: "4609",
    id_polifenol: "4522",
    polifenol: "chrysin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "7",
    pmids: "21170506,29352974,28105189,22591439,23973682,22086925,20811719",
  },
  {
    id: "4610",
    id_polifenol: "123",
    polifenol: "Rutin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "8",
    pmids:
      "21827495,28373417,7656234,7650296,26810568,27981754,25464055,9890672",
  },
  {
    id: "4611",
    id_polifenol: "6062",
    polifenol: "naringenin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "6",
    pmids: "21674787,7656234,26810568,16699821,24868862,20857432",
  },
  {
    id: "4612",
    id_polifenol: "285",
    polifenol: "bisphenol A",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "17594473",
  },
  {
    id: "4613",
    id_polifenol: "39",
    polifenol: "Hydrolyzable Tannins",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "7",
    pmids: "23939793,18435487,20838625,19731038,27253407,17827407,1431932",
  },
  {
    id: "4614",
    id_polifenol: "130",
    polifenol: "Proanthocyanidins",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "7",
    pmids: "21738696,14758047,26676402,25361006,26807314,25112437,26864554",
  },
  {
    id: "4615",
    id_polifenol: "35",
    polifenol: "Hydroquinones",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "11",
    pmids:
      "16504517,25826398,29562668,6768447,18507048,26795272,21317816,6253089,25132642,4031538,9473785",
  },
  {
    id: "4616",
    id_polifenol: "111",
    polifenol: "Flavanones",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "9",
    pmids:
      "29807112,21263202,28286420,25978595,23895019,15797607,21351299,19952433,21121257",
  },
  {
    id: "4617",
    id_polifenol: "4502",
    polifenol: "fisetin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "8",
    pmids:
      "25000190,24466036,26299806,26517521,21346776,25016296,24675012,26864554",
  },
  {
    id: "4618",
    id_polifenol: "6",
    polifenol: "Catechols",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "10",
    pmids:
      "23447437,28041801,6788955,24523750,1697512,1963166,8545743,23408432,2909284,8433013",
  },
  {
    id: "4619",
    id_polifenol: "25",
    polifenol: "Butylated Hydroxytoluene",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "3",
    pmids: "27148169,6634722,3742730",
  },
  {
    id: "4620",
    id_polifenol: "75",
    polifenol: "Butylated Hydroxyanisole",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "4",
    pmids: "12809360,23173924,6634722,3742730",
  },
  {
    id: "4621",
    id_polifenol: "15",
    polifenol: "Masoprocol",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "4",
    pmids: "11485827,16465258,19615898,8188530",
  },
  {
    id: "4622",
    id_polifenol: "6087",
    polifenol: "wogonin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "2",
    pmids: "22086925,25203554",
  },
  {
    id: "4623",
    id_polifenol: "4519",
    polifenol: "myricetin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "2",
    pmids: "19731038,15489212",
  },
  {
    id: "4624",
    id_polifenol: "4515",
    polifenol: "baicalin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "2",
    pmids: "9592193,9764846",
  },
  {
    id: "4625",
    id_polifenol: "4500",
    polifenol: "procyanidin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "3",
    pmids: "17827407,16051220,21081808",
  },
  {
    id: "4626",
    id_polifenol: "5608",
    polifenol: "epicatechin gallate",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "8",
    pmids:
      "25694272,11525605,8826614,18324763,18955299,19358568,1431932,7480211",
  },
  {
    id: "4627",
    id_polifenol: "1356",
    polifenol: "gingerol",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "3",
    pmids: "9137420,16081047,21792901",
  },
  {
    id: "4628",
    id_polifenol: "54",
    polifenol: "Salicylic Acid",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "3",
    pmids: "24652595,29541369,18971789",
  },
  {
    id: "4629",
    id_polifenol: "98",
    polifenol: "Propofol",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "22923370",
  },
  {
    id: "4630",
    id_polifenol: "5607",
    polifenol: "gallocatechol",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "4",
    pmids: "11525605,8826614,18955299,7480211",
  },
  {
    id: "4631",
    id_polifenol: "44",
    polifenol: "Salicylates",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "10882869",
  },
  {
    id: "4632",
    id_polifenol: "4559",
    polifenol: "theaflavin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "4",
    pmids: "17984116,20528747,11525605,11138532",
  },
  {
    id: "4633",
    id_polifenol: "5808",
    polifenol: "isoliquiritigenin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "4",
    pmids: "28410220,26951491,27461947,23304254",
  },
  {
    id: "4634",
    id_polifenol: "2344",
    polifenol: "methyl gallate",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "7",
    pmids: "23185648,28960771,19577552,10918203,16051220,21903153,7480211",
  },
  {
    id: "4635",
    id_polifenol: "4708",
    polifenol: "xanthohumol",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "18087812",
  },
  {
    id: "4636",
    id_polifenol: "2284",
    polifenol: "rosmarinic acid",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "2",
    pmids: "28222613,24692726",
  },
  {
    id: "4637",
    id_polifenol: "6455",
    polifenol: "nobiletin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "17617702",
  },
  {
    id: "4638",
    id_polifenol: "4513",
    polifenol: "galangin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "5",
    pmids: "23925650,23001390,22887049,17847709,26863880",
  },
  {
    id: "4639",
    id_polifenol: "6063",
    polifenol: "naringin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "3",
    pmids: "26476533,7656234,24868862",
  },
  {
    id: "4640",
    id_polifenol: "2158",
    polifenol: "protocatechuic acid",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "3",
    pmids: "27492128,20840540,28825660",
  },
  {
    id: "4641",
    id_polifenol: "5489",
    polifenol: "delphinidin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "26694325",
  },
  {
    id: "4642",
    id_polifenol: "6273",
    polifenol: "hesperetin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "2",
    pmids: "16699821,24868862",
  },
  {
    id: "4643",
    id_polifenol: "1613",
    polifenol: "demethoxycurcumin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "10969724",
  },
  {
    id: "4644",
    id_polifenol: "93",
    polifenol: "Phloroglucinol",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "2236292",
  },
  {
    id: "4645",
    id_polifenol: "81",
    polifenol: "Fenofibrate",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "26869992",
  },
  {
    id: "4646",
    id_polifenol: "7550",
    polifenol: "3-methylquercetin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "28373417",
  },
  {
    id: "4647",
    id_polifenol: "6461",
    polifenol: "acacetin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "2",
    pmids: "23913940,25203554",
  },
  {
    id: "4648",
    id_polifenol: "4253",
    polifenol:
      "5-(2,4-dihydroxy-5-isopropylphenyl)-4-(4-morpholin-4-ylmethylphenyl)isoxazole-3-carboxylic acid ethylamide",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "18413753",
  },
  {
    id: "4649",
    id_polifenol: "1611",
    polifenol: "bis(4-hydroxycinnamoyl)methane",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "10969724",
  },
  {
    id: "4650",
    id_polifenol: "119",
    polifenol: "Silymarin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "3",
    pmids: "25174976,21591838,20372777",
  },
  {
    id: "4651",
    id_polifenol: "126",
    polifenol: "Coumestrol",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "29064398",
  },
  {
    id: "4652",
    id_polifenol: "5806",
    polifenol: "butein",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "26694191",
  },
  {
    id: "4653",
    id_polifenol: "108",
    polifenol: "Biflavonoids",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "6",
    pmids: "17121913,28947953,29790302,19066129,21471210,18298378",
  },
  {
    id: "4654",
    id_polifenol: "1558",
    polifenol: "capsazepine",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "2",
    pmids: "28560396,24084605",
  },
  {
    id: "4655",
    id_polifenol: "5509",
    polifenol: "cyanidin 3-O-glucoside",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "8545743",
  },
  {
    id: "4656",
    id_polifenol: "5844",
    polifenol: "4-dimethylamino-3',4'-dimethoxychalcone",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "4",
    pmids: "22892845,16391862,11300496,10778963",
  },
  {
    id: "4657",
    id_polifenol: "5819",
    polifenol: "licochalcone A",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "2",
    pmids: "17424936,24944769",
  },
  {
    id: "4658",
    id_polifenol: "94",
    polifenol: "Phloretin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "3",
    pmids: "9570373,18158826,26646850",
  },
  {
    id: "4659",
    id_polifenol: "4560",
    polifenol: "icariin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "29245919",
  },
  {
    id: "4660",
    id_polifenol: "48",
    polifenol: "Anacardic Acids",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "2",
    pmids: "26001729,19995673",
  },
  {
    id: "4661",
    id_polifenol: "5488",
    polifenol: "cyanidin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "28468289",
  },
  {
    id: "4662",
    id_polifenol: "4640",
    polifenol: "5,7-dihydroxy-6-methoxy-2-phenylchromen-4-one",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "22245252",
  },
  {
    id: "4663",
    id_polifenol: "4537",
    polifenol: "flavone acetic acid",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "3",
    pmids: "9891222,3070530,1596889",
  },
  {
    id: "4664",
    id_polifenol: "2773",
    polifenol: "farnesylthiosalicylic acid",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "2",
    pmids: "11920610,10570191",
  },
  {
    id: "4665",
    id_polifenol: "80",
    polifenol: "Clofibrate",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "8759039",
  },
  {
    id: "4666",
    id_polifenol: "7546",
    polifenol: "isoquercitrin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "25464055",
  },
  {
    id: "4667",
    id_polifenol: "6482",
    polifenol: "tangeretin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "15489212",
  },
  {
    id: "4668",
    id_polifenol: "89",
    polifenol: "Vanillic Acid",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "27981754",
  },
  {
    id: "4669",
    id_polifenol: "452",
    polifenol: "acteoside",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "3",
    pmids: "29505920,11725977,12033512",
  },
  {
    id: "4670",
    id_polifenol: "1644",
    polifenol: "Cur1 compound",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "3",
    pmids: "27502897,29195800,24746691",
  },
  {
    id: "4671",
    id_polifenol: "5614",
    polifenol: "catechin gallate",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "2",
    pmids: "21903153,10882869",
  },
  {
    id: "4672",
    id_polifenol: "1866",
    polifenol: "4,6-dinitro-o-cresol",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "14977851",
  },
  {
    id: "4673",
    id_polifenol: "4486",
    polifenol: "amentoflavone",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "8",
    pmids:
      "28570563,22181979,29790302,17548797,19066129,21471210,18298378,18686102",
  },
  {
    id: "4674",
    id_polifenol: "7544",
    polifenol: "quercitrin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "2",
    pmids: "14969337,25464055",
  },
  {
    id: "4675",
    id_polifenol: "60",
    polifenol: "2,4-Dinitrophenol",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "2",
    pmids: "9186779,7074605",
  },
  {
    id: "4676",
    id_polifenol: "6465",
    polifenol: "genistin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "2",
    pmids: "15584372,23678808",
  },
  {
    id: "4677",
    id_polifenol: "350",
    polifenol: "nonylphenol",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "28168795",
  },
  {
    id: "4678",
    id_polifenol: "6097",
    polifenol: "8-prenylnaringenin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "2",
    pmids: "18087812,24443427",
  },
  {
    id: "4679",
    id_polifenol: "6068",
    polifenol: "pinocembrin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "29807112",
  },
  {
    id: "4680",
    id_polifenol: "4585",
    polifenol: "baohuoside I",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "4",
    pmids: "23368920,27418138,22743248,29260980",
  },
  {
    id: "4681",
    id_polifenol: "6086",
    polifenol: "liquiritigenin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "25978595",
  },
  {
    id: "4682",
    id_polifenol: "59",
    polifenol: "Dinitrophenols",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "21155627",
  },
  {
    id: "4683",
    id_polifenol: "2328",
    polifenol: "syringic acid",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "2",
    pmids: "23958424,26810568",
  },
  {
    id: "4684",
    id_polifenol: "7296",
    polifenol: "dihydromyricetin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "28482716",
  },
  {
    id: "4685",
    id_polifenol: "40",
    polifenol: "Propyl Gallate",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "10376975",
  },
  {
    id: "4686",
    id_polifenol: "7134",
    polifenol: "vitexin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "21432719",
  },
  {
    id: "4687",
    id_polifenol: "5815",
    polifenol: "dibenzoylmethane",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "2",
    pmids: "14572867,29753256",
  },
  {
    id: "4688",
    id_polifenol: "7547",
    polifenol: "hyperoside",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "2",
    pmids: "20469635,25464055",
  },
  {
    id: "4689",
    id_polifenol: "7141",
    polifenol: "apigetrin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "3",
    pmids: "20469635,28222613,27981754",
  },
  {
    id: "4690",
    id_polifenol: "637",
    polifenol: "glabridin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "26795272",
  },
  {
    id: "4691",
    id_polifenol: "77",
    polifenol: "Bezafibrate",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "10628360",
  },
  {
    id: "4692",
    id_polifenol: "1810",
    polifenol: "heminordihydroguaiaretic acid",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "19615898",
  },
  {
    id: "4693",
    id_polifenol: "6477",
    polifenol: "hispidulin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "23354402",
  },
  {
    id: "4694",
    id_polifenol: "7198",
    polifenol: "homoorientin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "29542423",
  },
  {
    id: "4695",
    id_polifenol: "128",
    polifenol: "Pterocarpans",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "4",
    pmids: "18440233,28189086,25395701,27189479",
  },
  {
    id: "4696",
    id_polifenol: "7557",
    polifenol: "rhamnetin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "14969337",
  },
  {
    id: "4697",
    id_polifenol: "5496",
    polifenol: "pelargonidin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "18688565",
  },
  {
    id: "4698",
    id_polifenol: "7775",
    polifenol: "glyceollin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "21336922",
  },
  {
    id: "4699",
    id_polifenol: "687",
    polifenol: "calix(4)arene",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "2",
    pmids: "23392775,20941591",
  },
  {
    id: "4700",
    id_polifenol: "5796",
    polifenol: "dihydrochalcone",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "2",
    pmids: "9570373,20715765",
  },
  {
    id: "4701",
    id_polifenol: "6066",
    polifenol: "eriodictyol",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "23936765",
  },
  {
    id: "4702",
    id_polifenol: "2574",
    polifenol: "4-hydroxybenzoic acid",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "27981754",
  },
  {
    id: "4703",
    id_polifenol: "3019",
    polifenol: "nitroaspirin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "29133913",
  },
  {
    id: "4704",
    id_polifenol: "6452",
    polifenol: "chrysoeriol",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "28222613",
  },
  {
    id: "4705",
    id_polifenol: "4480",
    polifenol: "myricitrin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "27492128",
  },
  {
    id: "4706",
    id_polifenol: "7377",
    polifenol: "astragalin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "28809055",
  },
  {
    id: "4707",
    id_polifenol: "4521",
    polifenol: "3-hydroxyflavone",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "23438826",
  },
  {
    id: "4708",
    id_polifenol: "3489",
    polifenol: "anethole",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "2",
    pmids: "28478313,27981754",
  },
  {
    id: "4709",
    id_polifenol: "115",
    polifenol: "Diosmin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "19538057",
  },
  {
    id: "4710",
    id_polifenol: "2014",
    polifenol: "erbstatin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "7585535",
  },
  {
    id: "4711",
    id_polifenol: "4715",
    polifenol: "ampelopsin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "2",
    pmids: "12703989,15620188",
  },
  {
    id: "4712",
    id_polifenol: "6800",
    polifenol: "3,6-dimethoxy-6'',6''-dimethylchromeno(2'',3''-7,8)flavone",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "29433671",
  },
  {
    id: "4713",
    id_polifenol: "6693",
    polifenol: "2',4',7-trihydroxyisoflavone",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "3",
    pmids: "25395701,15584372,11739876",
  },
  {
    id: "4714",
    id_polifenol: "2450",
    polifenol: "Geraniin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "18435487",
  },
  {
    id: "4715",
    id_polifenol: "885",
    polifenol: "oleocanthal",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "3",
    pmids: "27878290,27266366,29734791",
  },
  {
    id: "4716",
    id_polifenol: "2283",
    polifenol: "depsidone",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "2",
    pmids: "18721817,28012710",
  },
  {
    id: "4717",
    id_polifenol: "2697",
    polifenol: "4-trifluoromethylsalicylic acid",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "4",
    pmids: "23958424,26810568,11020285,23990753",
  },
  {
    id: "4718",
    id_polifenol: "5005",
    polifenol: "procyanidin B",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "17827407",
  },
  {
    id: "4719",
    id_polifenol: "357",
    polifenol: "4-aminophenol",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "7907080",
  },
  {
    id: "4720",
    id_polifenol: "2343",
    polifenol: "ethyl gallate",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "28960771",
  },
  {
    id: "4721",
    id_polifenol: "4479",
    polifenol: "morin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "27764752",
  },
  {
    id: "4722",
    id_polifenol: "9",
    polifenol: "1,2-Dihydroxybenzene-3,5-Disulfonic Acid Disodium Salt",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "2",
    pmids: "14678967,15580305",
  },
  {
    id: "4723",
    id_polifenol: "315",
    polifenol: "bakuchiol",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "25860949",
  },
  {
    id: "4724",
    id_polifenol: "1918",
    polifenol: "2,6-di-tert-butyl-4-(aminomethyl)phenol hydrochloride",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "26774931",
  },
  {
    id: "4725",
    id_polifenol: "5875",
    polifenol: "panduratin A",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "2",
    pmids: "29655680,25594392",
  },
  {
    id: "4726",
    id_polifenol: "7199",
    polifenol: "luteolin-7-glucoside",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "28222613",
  },
  {
    id: "4727",
    id_polifenol: "7140",
    polifenol: "isovitexin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "29542423",
  },
  {
    id: "4728",
    id_polifenol: "7453",
    polifenol: "kaempferol-3-O-glucoside",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "28809055",
  },
  {
    id: "4729",
    id_polifenol: "4981",
    polifenol: "jaceosidin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "27262066",
  },
  {
    id: "4730",
    id_polifenol: "7658",
    polifenol: "quercetin 3'-O-glucoside",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "15638088",
  },
  {
    id: "4731",
    id_polifenol: "3258",
    polifenol: "tesmilifene",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "2",
    pmids: "7909571,1617649",
  },
  {
    id: "4732",
    id_polifenol: "6497",
    polifenol: "isoflavanone",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "18440233",
  },
  {
    id: "4733",
    id_polifenol: "70",
    polifenol: "Sulfobromophthalein",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "3884476",
  },
  {
    id: "4734",
    id_polifenol: "5615",
    polifenol: "gallocatechin gallate",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "21903153",
  },
  {
    id: "4735",
    id_polifenol: "6549",
    polifenol: "7-hydroxy-2',3',4',5',8-pentamethoxyisoflavan",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "18440233",
  },
  {
    id: "4736",
    id_polifenol: "6008",
    polifenol: "millepachine",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "25341684",
  },
  {
    id: "4737",
    id_polifenol: "839",
    polifenol: "5-iodo-3-((3,5-dibromo-4-hydroxyphenyl)methylene)-2-indolinone",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "17251686",
  },
  {
    id: "4738",
    id_polifenol: "2504",
    polifenol: "pentagalloylglucose",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "2",
    pmids: "23185648,21081808",
  },
  {
    id: "4739",
    id_polifenol: "6819",
    polifenol: "luteolin-7-O-glucoside",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "2",
    pmids: "20469635,27981754",
  },
  {
    id: "4740",
    id_polifenol: "4607",
    polifenol: "orientin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "29542423",
  },
  {
    id: "4741",
    id_polifenol: "2807",
    polifenol: "thiosalicylic acid",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "2",
    pmids: "11920610,12535206",
  },
  {
    id: "4742",
    id_polifenol: "6287",
    polifenol: "neohesperidin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "24868862",
  },
  {
    id: "4743",
    id_polifenol: "7437",
    polifenol: "kaempferol-3-O-rutinoside",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "26810568",
  },
  {
    id: "4744",
    id_polifenol: "2168",
    polifenol: "beta-resorcylic acid",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "25574154",
  },
  {
    id: "4745",
    id_polifenol: "7422",
    polifenol: "kaempferide",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "24443427",
  },
  {
    id: "4746",
    id_polifenol: "6684",
    polifenol: "eupafolin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "15638088",
  },
  {
    id: "4747",
    id_polifenol: "2173",
    polifenol: "atranorin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "28012710",
  },
  {
    id: "4748",
    id_polifenol: "5532",
    polifenol: "malvidin-3-glucoside",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "23890760",
  },
  {
    id: "4749",
    id_polifenol: "7590",
    polifenol: "quercetin-3-O-rutinoside",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "20469635",
  },
  {
    id: "4750",
    id_polifenol: "5063",
    polifenol: "4',7-dihydroxy-3'-methoxy-5'-prenylflavanone",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "16516378",
  },
  {
    id: "4751",
    id_polifenol: "6687",
    polifenol: "3'-dimethylaminoflavone",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "29104051",
  },
  {
    id: "4752",
    id_polifenol: "57",
    polifenol: "2,6-Dichloroindophenol",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "2",
    pmids: "19394313,21034357",
  },
  {
    id: "4753",
    id_polifenol: "6548",
    polifenol: "artocarpin flavonoid",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "15165133",
  },
  {
    id: "4754",
    id_polifenol: "4698",
    polifenol: "sakuranetin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "29556122",
  },
  {
    id: "4755",
    id_polifenol: "4608",
    polifenol: "artonin E",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "15165133",
  },
  {
    id: "4756",
    id_polifenol: "5814",
    polifenol: "2',4'-dihydroxychalcone",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "19689125",
  },
  {
    id: "4757",
    id_polifenol: "7427",
    polifenol: "kaempferol 3-O-rhamnoside",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "14969337",
  },
  {
    id: "4758",
    id_polifenol: "2339",
    polifenol: "3-O-methylgallic acid",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "19731038",
  },
  {
    id: "4759",
    id_polifenol: "1492",
    polifenol: "hirsutenone",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "18958419",
  },
  {
    id: "4760",
    id_polifenol: "1811",
    polifenol: "terameprocol",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "2",
    pmids: "11485827,19615898",
  },
  {
    id: "4761",
    id_polifenol: "2159",
    polifenol: "2,3-dihydroxybenzoic acid",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "11725977",
  },
  {
    id: "4762",
    id_polifenol: "7478",
    polifenol: "kaempferol-7-methyl ether",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "14969337",
  },
  {
    id: "4763",
    id_polifenol: "400",
    polifenol: "cardanol",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "28627168",
  },
  {
    id: "4764",
    id_polifenol: "5827",
    polifenol: "4'-methoxychalcone",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "19483325",
  },
  {
    id: "4765",
    id_polifenol: "2336",
    polifenol: "octyl gallate",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "28746057",
  },
  {
    id: "4766",
    id_polifenol: "4082",
    polifenol: "3,3',4,4',5,5'-hexahydroxystilbene",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "19956188",
  },
  {
    id: "4767",
    id_polifenol: "6031",
    polifenol: "2',3'-dimethoxyflavanone",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "21351299",
  },
  {
    id: "4768",
    id_polifenol: "2161",
    polifenol: "nifuroxazide",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "2",
    pmids: "26830149,26503030",
  },
  {
    id: "4769",
    id_polifenol: "7197",
    polifenol: "6-hydroxyluteolin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "2",
    pmids: "17135264,15736313",
  },
  {
    id: "4770",
    id_polifenol: "472",
    polifenol: "isoacteoside",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "11725977",
  },
  {
    id: "4771",
    id_polifenol: "3665",
    polifenol: "3,5-di-tert-butyl-4-hydroxyanisole",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "14972018",
  },
  {
    id: "4772",
    id_polifenol: "3493",
    polifenol: "mequinol",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "2",
    pmids: "4031538,9473785",
  },
  {
    id: "4773",
    id_polifenol: "1364",
    polifenol: "4-methylcatechol",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "6788955",
  },
  {
    id: "4774",
    id_polifenol: "2474",
    polifenol: "vescalagin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "1431932",
  },
  {
    id: "4775",
    id_polifenol: "418",
    polifenol: "thiophenol",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "2",
    pmids: "8642556,19995673",
  },
  {
    id: "4776",
    id_polifenol: "858",
    polifenol: "2-(3-chloro-4-hydroxyphenyl)-2-(4-hydroxyphenyl)propane",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "22985957",
  },
  {
    id: "4777",
    id_polifenol: "5945",
    polifenol: "2',5'-dimethoxychalcone",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "19483325",
  },
  {
    id: "4778",
    id_polifenol: "1451",
    polifenol: "hispolon",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "26056942",
  },
  {
    id: "4779",
    id_polifenol: "6508",
    polifenol: "prunetin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "25395701",
  },
  {
    id: "4780",
    id_polifenol: "1725",
    polifenol: "yakuchinone-A",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "24070160",
  },
  {
    id: "4781",
    id_polifenol: "7879",
    polifenol: "4-hydroxyderricin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "21263202",
  },
  {
    id: "4782",
    id_polifenol: "7363",
    polifenol: "juglanin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "29620254",
  },
  {
    id: "4783",
    id_polifenol: "4524",
    polifenol: "5-hydroxy-3',4',6,7-tetramethoxyflavone",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "24148842",
  },
  {
    id: "4784",
    id_polifenol: "6642",
    polifenol: "6,7-dihydroxyflavone",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "27220989",
  },
  {
    id: "4785",
    id_polifenol: "4579",
    polifenol: "hinokiflavone",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "29790302",
  },
  {
    id: "4786",
    id_polifenol: "7810",
    polifenol: "rotenolone",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "23895019",
  },
  {
    id: "4787",
    id_polifenol: "5198",
    polifenol: "isosakuranetin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "29556122",
  },
  {
    id: "4788",
    id_polifenol: "5854",
    polifenol: "2'-hydroxy-3,4,3',4',6'-pentamethoxychalcone",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "23438826",
  },
  {
    id: "4789",
    id_polifenol: "6898",
    polifenol: "barbigerone",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "24528020",
  },
  {
    id: "4790",
    id_polifenol: "5436",
    polifenol: "herbacetin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "29029040",
  },
  {
    id: "4791",
    id_polifenol: "5065",
    polifenol: "3,5,6,7,8-pentahydroxy flavone",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "23543365",
  },
  {
    id: "4792",
    id_polifenol: "6952",
    polifenol: "isoangustone A",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "24104352",
  },
  {
    id: "4793",
    id_polifenol: "1821",
    polifenol: "2,4-D n-butyl ester",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "17190444",
  },
  {
    id: "4794",
    id_polifenol: "1772",
    polifenol: "3-hydroxy-4-methoxybenzaldehyde thiosemicarbazone",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "22797854",
  },
  {
    id: "4795",
    id_polifenol: "4482",
    polifenol: "peflavit",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "26148186",
  },
  {
    id: "4796",
    id_polifenol: "7803",
    polifenol: "LQB 118",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "2",
    pmids: "29692266,27189479",
  },
  {
    id: "4797",
    id_polifenol: "4820",
    polifenol: "3,7-dihydroxyflavone",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "29734739",
  },
  {
    id: "4798",
    id_polifenol: "4677",
    polifenol: "baohuoside II",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "29260980",
  },
  {
    id: "4799",
    id_polifenol: "6067",
    polifenol: "carthamidin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "24443427",
  },
  {
    id: "4800",
    id_polifenol: "1372",
    polifenol: "3-methylcatechol",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "6788955",
  },
  {
    id: "4801",
    id_polifenol: "7249",
    polifenol: "rhamnazin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "10739098",
  },
  {
    id: "4802",
    id_polifenol: "7050",
    polifenol: "3'-chloro-5,7-dimethoxyisoflavone",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "25395701",
  },
  {
    id: "4803",
    id_polifenol: "4303",
    polifenol: "hypothemycin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "25574154",
  },
  {
    id: "4804",
    id_polifenol: "4152",
    polifenol: "quracol B",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "17627575",
  },
  {
    id: "4805",
    id_polifenol: "1991",
    polifenol: "monobenzone",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "3",
    pmids: "21317816,25132642,20498710",
  },
  {
    id: "4806",
    id_polifenol: "4689",
    polifenol: "5,3'-dihydroxy-3,6,7,8,4'-pentamethoxyflavone",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "7623025",
  },
  {
    id: "4807",
    id_polifenol: "42",
    polifenol: "Pactamycin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "839556",
  },
  {
    id: "4808",
    id_polifenol: "1424",
    polifenol: "rooperol",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "8545743",
  },
  {
    id: "4809",
    id_polifenol: "82",
    polifenol: "Gemfibrozil",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "18092840",
  },
  {
    id: "4810",
    id_polifenol: "1152",
    polifenol: "salvianolic acid",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "20621088",
  },
  {
    id: "4811",
    id_polifenol: "322",
    polifenol: "N-methyl-4-aminophenol",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "29104051",
  },
  {
    id: "4812",
    id_polifenol: "1417",
    polifenol: "1,2-dihydroxy-4'-chlorobiphenyl",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "19184021",
  },
  {
    id: "4813",
    id_polifenol: "2531",
    polifenol: "sanguiin H-5",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "1431932",
  },
  {
    id: "4814",
    id_polifenol: "2022",
    polifenol: "1,4-naphthohydroquinone",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "22682920",
  },
  {
    id: "4815",
    id_polifenol: "1453",
    polifenol: "4-nerolidylcatechol",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "2",
    pmids: "22372875,19084293",
  },
  {
    id: "4816",
    id_polifenol: "4887",
    polifenol: "isoginkgetin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "17121913",
  },
  {
    id: "4817",
    id_polifenol: "361",
    polifenol: "2-aminophenol",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "2",
    pmids: "15944765,16777268",
  },
  {
    id: "4818",
    id_polifenol: "1625",
    polifenol: "curcumin III",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "10969724",
  },
  {
    id: "4819",
    id_polifenol: "6766",
    polifenol: "glaziovianin A",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "27100701",
  },
  {
    id: "4820",
    id_polifenol: "6247",
    polifenol: "6,4'-dihydroxy-7-methoxyflavanone",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "15797607",
  },
  {
    id: "4821",
    id_polifenol: "5680",
    polifenol: "3-O-(3,4,5-trimethoxybenzoyl)catechin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "21302360",
  },
  {
    id: "4822",
    id_polifenol: "7650",
    polifenol: "3,7-O-dimethylquercetin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "28373417",
  },
  {
    id: "4823",
    id_polifenol: "782",
    polifenol: "A-317491",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "28850427",
  },
  {
    id: "4824",
    id_polifenol: "4195",
    polifenol: "climacostol",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "27650755",
  },
  {
    id: "4825",
    id_polifenol: "6164",
    polifenol: "euchrestaflavanone B",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "24443427",
  },
  {
    id: "4826",
    id_polifenol: "4504",
    polifenol: "gossypin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "23543365",
  },
  {
    id: "4827",
    id_polifenol: "5320",
    polifenol: "xanthohumol D",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "18087812",
  },
  {
    id: "4828",
    id_polifenol: "5933",
    polifenol: "licochalcone B",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "29027311",
  },
  {
    id: "4829",
    id_polifenol: "2458",
    polifenol: "glucogallin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "21903153",
  },
  {
    id: "4830",
    id_polifenol: "7878",
    polifenol: "MDL 27048",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "2362275",
  },
  {
    id: "4831",
    id_polifenol: "658",
    polifenol: "N-propionyl-4-S-cysteaminylphenol",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "3",
    pmids: "22622238,20594194,23066648",
  },
  {
    id: "4832",
    id_polifenol: "5639",
    polifenol: "4-(S-cysteinyl)epicatechin 3-O-gallate",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "16051220",
  },
  {
    id: "4833",
    id_polifenol: "6309",
    polifenol: "dalspinosin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "18958419",
  },
  {
    id: "4834",
    id_polifenol: "5658",
    polifenol: "3-O-(3,4,5-trimethoxybenzoyl)epicatechin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "3",
    pmids: "18324763,19358568,21302360",
  },
  {
    id: "4835",
    id_polifenol: "7388",
    polifenol: "kaempferol-3-O-galactoside",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "20469635",
  },
  {
    id: "4836",
    id_polifenol: "2287",
    polifenol: "pannarin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "18721817",
  },
  {
    id: "4837",
    id_polifenol: "6340",
    polifenol: "cudraflavone C",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "28703746",
  },
  {
    id: "4838",
    id_polifenol: "4985",
    polifenol: "propolin B",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "16516378",
  },
  {
    id: "4839",
    id_polifenol: "4984",
    polifenol: "propolin A",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "16516378",
  },
  {
    id: "4840",
    id_polifenol: "618",
    polifenol: "1-(4'-hydroxyphenyl)butenone",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "19155103",
  },
  {
    id: "4841",
    id_polifenol: "768",
    polifenol: "eupomatenoid 5",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "21391177",
  },
  {
    id: "4842",
    id_polifenol: "4192",
    polifenol: "geoditin A",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "22412813",
  },
  {
    id: "4843",
    id_polifenol: "2286",
    polifenol: "digallic acid",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "21903153",
  },
  {
    id: "4844",
    id_polifenol: "2392",
    polifenol: "1,6-di-O-galloyl-beta-D-glucose",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "21903153",
  },
  {
    id: "4845",
    id_polifenol: "7699",
    polifenol:
      "quercetin-3-O-beta-D-apiofuranosyl-(1-2)-beta-D-galactopyranosyl-7-O-beta-D-glucopyranoside",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "22899608",
  },
  {
    id: "4846",
    id_polifenol: "5399",
    polifenol: "7,7''-dimethoxyagastisflavone",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "28947953",
  },
  {
    id: "4847",
    id_polifenol: "5800",
    polifenol: "chalcone epoxide",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "21816519",
  },
  {
    id: "4848",
    id_polifenol: "714",
    polifenol: "3-(4-hydroxyphenyl)propanol",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "11118049",
  },
  {
    id: "4849",
    id_polifenol: "3969",
    polifenol: "arzanol",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "28476462",
  },
  {
    id: "4850",
    id_polifenol: "5523",
    polifenol: "cinnamtannin A2",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "1431932",
  },
  {
    id: "4851",
    id_polifenol: "5140",
    polifenol: "5-hydroxy-6,7-dimethoxyflavone",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "21351299",
  },
  {
    id: "4852",
    id_polifenol: "7324",
    polifenol: "glycinol",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "15974577",
  },
  {
    id: "4853",
    id_polifenol: "7568",
    polifenol: "7,3',4'-trimethylquercetin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "28373417",
  },
  {
    id: "4854",
    id_polifenol: "2095",
    polifenol: "farnesyl-O-acetylhydroquinone",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "2",
    pmids: "18507048,14643448",
  },
  {
    id: "4855",
    id_polifenol: "2136",
    polifenol: "5-O-acetylhydroquinone",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "18507048",
  },
  {
    id: "4856",
    id_polifenol: "6327",
    polifenol: "6-methoxyflavone",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "27086008",
  },
  {
    id: "4857",
    id_polifenol: "4095",
    polifenol: "1-(3,4,5-trihydroxyphenyl)nonan-1-one",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "26235054",
  },
  {
    id: "4858",
    id_polifenol: "3926",
    polifenol: "mallotojaponin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "2236292",
  },
  {
    id: "4859",
    id_polifenol: "2906",
    polifenol: "olsalazine",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "4031538",
  },
  {
    id: "4860",
    id_polifenol: "1222",
    polifenol: "(E)-2-((benzo(d)thiazol-2-ylimino)methyl)-4-nitrophenol",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "29574239",
  },
  {
    id: "4861",
    id_polifenol: "1502",
    polifenol: "artochamin H",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "15165133",
  },
  {
    id: "4862",
    id_polifenol: "2238",
    polifenol: "benzyl 2-hydroxy-3,6-dimethoxybenzoate",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "23958424",
  },
  {
    id: "4863",
    id_polifenol: "3753",
    polifenol: "benzyl-2,6-dimethoxybenzoate",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "23958424",
  },
  {
    id: "4864",
    id_polifenol: "682",
    polifenol: "L 748,337",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "23907236",
  },
  {
    id: "4865",
    id_polifenol: "3440",
    polifenol: "acerogenin A",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "22899608",
  },
  {
    id: "4866",
    id_polifenol: "524",
    polifenol: "gamma-glutaminyl-4-hydroxy-3-iodobenzene",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "7907080",
  },
  {
    id: "4867",
    id_polifenol: "1387",
    polifenol: "3-(pentadec-10-enyl)catechol",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "19007765",
  },
  {
    id: "4868",
    id_polifenol: "6072",
    polifenol: "3'-prenylnaringenin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "24443427",
  },
  {
    id: "4869",
    id_polifenol: "5783",
    polifenol: "TUB099",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "27224920",
  },
  {
    id: "4870",
    id_polifenol: "7443",
    polifenol: "kaempferol 3-arabinoside",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "20469635",
  },
  {
    id: "4871",
    id_polifenol: "7572",
    polifenol: "guajavarin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "20469635",
  },
  {
    id: "4872",
    id_polifenol: "5934",
    polifenol: "licochalcone D",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "29565458",
  },
  {
    id: "4873",
    id_polifenol: "476",
    polifenol: "N-acetyl-4-S-cysteaminylphenol",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "11118049",
  },
  {
    id: "4874",
    id_polifenol: "3476",
    polifenol: "dehydrodieugenol B",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "28478313",
  },
  {
    id: "4875",
    id_polifenol: "3906",
    polifenol: "hyperforin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "21751836",
  },
  {
    id: "4876",
    id_polifenol: "1217",
    polifenol:
      "1-(5-(5-chloro-2-hydroxyphenyl)-3-(p-tolyl)-4,5-dihydro-1H-pyrazol-1-yl)ethanone",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "22985957",
  },
  {
    id: "4877",
    id_polifenol: "1218",
    polifenol:
      "1-(3-(4-chlorophenyl)-5-(3,5-dibromo-2-hydroxyphenyl)-4,5-dihydro-1H-pyrazol-1-yl)ethanone",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "22985957",
  },
  {
    id: "4878",
    id_polifenol: "4623",
    polifenol: "myricetin 3-O-glucuronide",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "19731038",
  },
  {
    id: "4879",
    id_polifenol: "5450",
    polifenol: "linderone A",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "23173924",
  },
  {
    id: "4880",
    id_polifenol: "771",
    polifenol: "3,5-dihydroxy-1,7-bis(3,4-dihydroxyphenyl)heptane",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "18958419",
  },
  {
    id: "4881",
    id_polifenol: "6196",
    polifenol: "7-hydroxy-6-methoxyflavanone",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "18440233",
  },
  {
    id: "4882",
    id_polifenol: "1705",
    polifenol: "hylin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "20696583",
  },
  {
    id: "4883",
    id_polifenol: "4372",
    polifenol:
      "quercetin 3-O-alpha-rhamnopyranoside-7-O-beta-D-glucopyranosyl-(1-3)-alpha-L-rhamnopyranoside",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "7623025",
  },
  {
    id: "4884",
    id_polifenol: "3475",
    polifenol: "homoegonol",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "25795470",
  },
  {
    id: "4885",
    id_polifenol: "6532",
    polifenol: "muscomin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "26147490",
  },
  {
    id: "4886",
    id_polifenol: "182",
    polifenol: "ISO-66",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "25050663",
  },
  {
    id: "4887",
    id_polifenol: "6768",
    polifenol:
      "chrysoeriol 7-O-(2'''-O-caffeoyl-beta-D-glucopyranosyl-(1-2)-beta-d-glucopyranoside)",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "28222613",
  },
  {
    id: "4888",
    id_polifenol: "2297",
    polifenol: "3'-O-beta-D-glucopyranosyl rosmarinic acid",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "28222613",
  },
  {
    id: "4889",
    id_polifenol: "2896",
    polifenol: "BP-1-102",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "29541369",
  },
  {
    id: "4890",
    id_polifenol: "2235",
    polifenol: "tschimgin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "23701832",
  },
  {
    id: "4891",
    id_polifenol: "7111",
    polifenol: "urgineanin A",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "23659371",
  },
  {
    id: "4892",
    id_polifenol: "4826",
    polifenol:
      "5,4'-dihydroxy-(3'',4''-dihydro-3'',4''-dihydroxy)-2'',2''-dimethylpyrano(5'',6''-7,8)flavone",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "19689125",
  },
  {
    id: "4893",
    id_polifenol: "4730",
    polifenol: "5-methoxy-6-methylflavan-7-ol",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "19689125",
  },
  {
    id: "4894",
    id_polifenol: "2094",
    polifenol: "geranyl-O-acetylhydroquinone",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "14643448",
  },
  {
    id: "4895",
    id_polifenol: "6226",
    polifenol: "5,7,2'-trihydroxy-8,3'-diprenylflavanone",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "19952433",
  },
  {
    id: "4896",
    id_polifenol: "1051",
    polifenol: "yashabushidiol",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "19410455",
  },
  {
    id: "4897",
    id_polifenol: "3121",
    polifenol: "ethyl O-(N-(4-carboxyphenyl)carbamoyl)mycophenolate",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "7274650",
  },
  {
    id: "4898",
    id_polifenol: "2496",
    polifenol: "sanguiin H 11",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "1431932",
  },
  {
    id: "4899",
    id_polifenol: "2351",
    polifenol: "1,3,4,5-tetra-O-galloylquinic acid",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "1431932",
  },
  {
    id: "4900",
    id_polifenol: "2481",
    polifenol: "furosin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "1431932",
  },
  {
    id: "4901",
    id_polifenol: "7857",
    polifenol: "cinnamtannin B-1",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "1431932",
  },
  {
    id: "4902",
    id_polifenol: "2371",
    polifenol: "eugeniin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "1431932",
  },
  {
    id: "4903",
    id_polifenol: "5458",
    polifenol: "(2R,4R)-2',4'-dihydroxy-5,7-dimethoxyflavan-4-ol",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "21121257",
  },
  {
    id: "4904",
    id_polifenol: "3315",
    polifenol: "haloprogin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "29185769",
  },
  {
    id: "4905",
    id_polifenol: "1360",
    polifenol: "4-isopropylcatechol",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "4031538",
  },
  {
    id: "4906",
    id_polifenol: "4760",
    polifenol: "gnaphalin",
    id_cancer: "521",
    cancer: "Melanoma",
    quant: "1",
    pmids: "1812215",
  },
  {
    id: "4907",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "74",
    pmids:
      "26918059,29039326,22194772,18603343,28531805,19457454,25981581,25502212,29408335,26572257,23441616,28182003,27461104,23254270,20471467,25625479,26201693,28241766,28454311,24647664,22619007,29464049,26165353,24707875,26893664,25638174,15686411,25333894,25109410,20600540,26112905,25500692,24988056,25998143,25084411,28693212,24380421,26428258,22184071,29693162,22750388,29054762,19606519,16011286,29125991,27681719,29399116,21291361,27853354,22906240,22458642,23251241,20648923,26084155,16545824,25132753,20157880,15298613,20811676,11749698,21246822,2298289,8443813,17587681,17404066,26060454,10665481,17612370,18956590,20368937,18158844,19891604,9860503,26604389",
  },
  {
    id: "4908",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "72",
    pmids:
      "11396178,25198898,23980364,28105222,28077837,19448398,26520440,27980427,25435973,15480428,26919110,26919094,19889077,28566729,27456358,22030090,26492225,28926094,28848967,15087019,28359291,29385675,28498433,24935585,18849546,26111180,27042000,29312505,14604899,28728293,28927092,21811763,25292057,25714022,25523120,29254150,26086416,9591190,27990666,26318057,23351961,28360932,28781948,26802648,29021018,25874494,28240011,14650061,25331984,26140520,29565326,25499851,29151957,28828709,22465177,19204190,28866205,9349692,7812955,7954412,1578097,27749102,29445279,27226186,17609337,1618892,12553052,29025645,26074474,25923809,25569625,9310263",
  },
  {
    id: "4909",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "47",
    pmids:
      "29039582,10470285,21673927,19889077,28868867,27338284,24329111,12688521,20600540,24935585,19881312,15904481,18636183,15791651,24380421,17530359,18423410,19890716,26286711,22750388,26177078,15870908,19077562,22211760,10073014,12470903,21277973,21291361,29450132,20648923,25132753,15248026,29552213,29485160,18188412,1614997,19690770,19857070,24283885,12067577,28411462,20020873,15565401,19588362,29705507,9860503,22016781",
  },
  {
    id: "4910",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "78",
    pmids:
      "24416349,15949415,24178240,19343001,17171453,16627221,12540563,22781708,17387271,23370368,23792588,11438494,22634261,17970088,16527552,21472268,23924923,15480428,26664023,16520550,20066900,24647664,21734448,28196062,11812003,14647439,25638174,22824956,11349065,22908970,21455558,21570392,16142414,12907645,24241351,25202402,17009395,18488712,12796363,22941376,15995627,15298620,22821546,21633597,25069788,19396019,24027750,17522976,19281788,29805580,28851073,16877520,16819299,11719466,16395716,15949338,27747355,20799280,22328534,26259977,25727011,28464378,26934554,10409643,16054131,15319299,12860278,15760920,24106166,15040019,23728938,17495535,16950763,24244023,19657566,28600569,20460732,28268166",
  },
  {
    id: "4911",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "23",
    pmids:
      "8242641,22969238,22887948,24053672,22207556,24297371,22289529,16142414,17009395,21556552,16395716,15188515,27444320,9398604,27279287,8297123,23659450,16338068,21541487,8443813,11936957,24573253,20355429",
  },
  {
    id: "4912",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "31",
    pmids:
      "29039326,28076833,27278820,27461104,24647664,26059439,26492225,22992727,26111180,28627240,26974372,22627971,21610320,22750388,26349981,22222411,22230496,29125991,27681719,28828709,25132753,12230128,25827070,12599752,21246822,2298289,19664387,27980567,20307524,28481232,17028789",
  },
  {
    id: "4913",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "30",
    pmids:
      "21344159,23337910,17696257,23884787,10470285,17451194,15161022,21866460,27338284,24329111,23900621,21633597,19145512,26286711,29137307,27781257,12470903,21277973,24738879,12230128,22258296,27447666,20506079,7743506,24283885,17550753,12067577,22283637,22969946,29705507",
  },
  {
    id: "4914",
    id_polifenol: "2167",
    polifenol: "phenolic acid",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "20",
    pmids:
      "29512739,17706603,20600540,14758047,21517098,15870908,19606519,19077562,21291361,22458642,26347954,20157880,7812955,21246822,25781635,20368937,9860503,26604389,29125621,23892112",
  },
  {
    id: "4915",
    id_polifenol: "49",
    polifenol: "Aspirin",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "37",
    pmids:
      "15579484,14699495,27565221,17253132,10027304,11532860,23554697,25542229,10889159,16865277,12910692,26486505,29142602,20648923,27430429,14750642,12606945,15986861,9561441,24748972,27899979,10220501,20858219,23384786,16859832,26639472,10404093,14529406,12781040,19673332,11109595,11163773,10472431,9102213,12792801,12973428,11191738",
  },
  {
    id: "4916",
    id_polifenol: "109",
    polifenol: "Catechin",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "17",
    pmids:
      "23337910,10470285,15161022,21673927,12688521,15904481,29137307,1813062,29450132,15248026,12230128,20506079,19197143,19588362,7898128,9860503,19162155",
  },
  {
    id: "4917",
    id_polifenol: "125",
    polifenol: "Isoflavones",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "9",
    pmids:
      "29552162,8242641,24053672,24297371,23659450,21541487,8443813,24573253,10625940",
  },
  {
    id: "4918",
    id_polifenol: "110",
    polifenol: "Chalcones",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "12",
    pmids:
      "28374157,29286170,27594528,28852176,28566729,8375934,24510324,9591187,16675659,8142919,8062211,19891604",
  },
  {
    id: "4919",
    id_polifenol: "3089",
    polifenol: "1,1-diphenyl-2-picrylhydrazyl",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "12",
    pmids:
      "24380421,20548938,23841520,19099401,12230128,29196839,19857070,21664924,28587249,19367677,20368937,23892112",
  },
  {
    id: "4920",
    id_polifenol: "114",
    polifenol: "Apigenin",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "4",
    pmids: "24805829,22184071,19830248,25132753",
  },
  {
    id: "4921",
    id_polifenol: "113",
    polifenol: "Flavones",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "15",
    pmids:
      "26918059,16393120,27761206,29372031,22076197,29607909,21473152,9815832,24631140,8443813,28628924,27684298,28411462,20538457,25821971",
  },
  {
    id: "4922",
    id_polifenol: "38",
    polifenol: "Gallic Acid",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "8",
    pmids:
      "23153558,20600540,29599323,22627971,15870908,19606519,23841520,19857070",
  },
  {
    id: "4923",
    id_polifenol: "117",
    polifenol: "Luteolin",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "16",
    pmids:
      "18398671,19589287,28182003,28789432,28241766,22938042,25638174,28655612,24988056,22184071,29054762,21473152,8443813,17587681,23648354,28411462",
  },
  {
    id: "4924",
    id_polifenol: "1",
    polifenol: "Phenols",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "7",
    pmids: "19077562,23455189,19857070,23069941,20419538,2011492,28464353",
  },
  {
    id: "4925",
    id_polifenol: "105",
    polifenol: "Anthocyanins",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "10",
    pmids:
      "15964118,25853103,23869191,23668609,26509161,21291361,20121190,27690088,22016781,29125621",
  },
  {
    id: "4926",
    id_polifenol: "7235",
    polifenol: "silybin",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "7",
    pmids: "25169527,19924065,29901126,22619007,29344204,22258296,29135096",
  },
  {
    id: "4927",
    id_polifenol: "129",
    polifenol: "Rotenone",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "29305260",
  },
  {
    id: "4928",
    id_polifenol: "121",
    polifenol: "Kaempferols",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "6",
    pmids: "27461104,25500692,26974372,20548938,22906240,12230128",
  },
  {
    id: "4929",
    id_polifenol: "871",
    polifenol: "ABT-737",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "3",
    pmids: "26893664,22971477,27374973",
  },
  {
    id: "4930",
    id_polifenol: "6451",
    polifenol: "daidzein",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "4",
    pmids: "8242641,23659450,21541487,8443813",
  },
  {
    id: "4931",
    id_polifenol: "6065",
    polifenol: "baicalein",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "8",
    pmids:
      "26918059,11532854,25502212,25333894,25109410,17522976,21473152,17587681",
  },
  {
    id: "4932",
    id_polifenol: "7",
    polifenol: "Capsaicin",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "16",
    pmids:
      "24337453,27715462,19734122,27271588,24743513,24682934,9461043,21932983,21735133,26434906,16419151,26140520,17292493,27226186,18594983,24049058",
  },
  {
    id: "4933",
    id_polifenol: "4634",
    polifenol: "alvocidib",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "10",
    pmids:
      "12813134,28560460,9815832,24851111,14676132,11093360,10665481,11426645,21678111,9748140",
  },
  {
    id: "4934",
    id_polifenol: "120",
    polifenol: "Flavonols",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "3",
    pmids: "29635130,27980567,9860503",
  },
  {
    id: "4935",
    id_polifenol: "4522",
    polifenol: "chrysin",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "8",
    pmids:
      "25625479,27761206,25875631,20878083,27151585,26347954,28628924,27684298",
  },
  {
    id: "4936",
    id_polifenol: "123",
    polifenol: "Rutin",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "2",
    pmids: "15870908,21473152",
  },
  {
    id: "4937",
    id_polifenol: "6062",
    polifenol: "naringenin",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "9",
    pmids:
      "26960693,26893664,22184071,16102728,19830248,20648923,20157880,18176909,28525714",
  },
  {
    id: "4938",
    id_polifenol: "285",
    polifenol: "bisphenol A",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "12824901",
  },
  {
    id: "4939",
    id_polifenol: "39",
    polifenol: "Hydrolyzable Tannins",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "3",
    pmids: "9591187,23069941,26604389",
  },
  {
    id: "4940",
    id_polifenol: "130",
    polifenol: "Proanthocyanidins",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "7",
    pmids: "26572257,12074978,14758047,10448908,20121190,10962138,15565401",
  },
  {
    id: "4941",
    id_polifenol: "35",
    polifenol: "Hydroquinones",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "2",
    pmids: "27271588,26973386",
  },
  {
    id: "4942",
    id_polifenol: "111",
    polifenol: "Flavanones",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "5",
    pmids: "26061993,26393583,15883006,16545824,23615464",
  },
  {
    id: "4943",
    id_polifenol: "4502",
    polifenol: "fisetin",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "3",
    pmids: "27254419,29805580,19606519",
  },
  {
    id: "4944",
    id_polifenol: "6",
    polifenol: "Catechols",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "9",
    pmids:
      "6771000,11470755,22147653,2678948,23890812,8330359,2752382,2347074,8243170",
  },
  {
    id: "4945",
    id_polifenol: "25",
    polifenol: "Butylated Hydroxytoluene",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "4",
    pmids: "24263571,19657451,2297758,23892112",
  },
  {
    id: "4946",
    id_polifenol: "75",
    polifenol: "Butylated Hydroxyanisole",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "7",
    pmids: "2678948,16360936,1703036,8339254,7940561,2591015,23892112",
  },
  {
    id: "4947",
    id_polifenol: "15",
    polifenol: "Masoprocol",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "4",
    pmids: "25521558,22308955,1551103,17894552",
  },
  {
    id: "4948",
    id_polifenol: "6087",
    polifenol: "wogonin",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "7",
    pmids: "25962106,18378261,20570612,23251389,28288821,24255573,29433678",
  },
  {
    id: "4949",
    id_polifenol: "4519",
    polifenol: "myricetin",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "2",
    pmids: "27461104,26112905",
  },
  {
    id: "4950",
    id_polifenol: "4515",
    polifenol: "baicalin",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "2",
    pmids: "29960296,17537603",
  },
  {
    id: "4951",
    id_polifenol: "4500",
    polifenol: "procyanidin",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "15138614",
  },
  {
    id: "4952",
    id_polifenol: "5608",
    polifenol: "epicatechin gallate",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "4",
    pmids: "23337910,10470285,12230128,28411462",
  },
  {
    id: "4953",
    id_polifenol: "1356",
    polifenol: "gingerol",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "4",
    pmids: "29512739,17706603,26403976,14666666",
  },
  {
    id: "4954",
    id_polifenol: "54",
    polifenol: "Salicylic Acid",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "2",
    pmids: "20648923,20355240",
  },
  {
    id: "4955",
    id_polifenol: "98",
    polifenol: "Propofol",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "4",
    pmids: "27840947,26214494,27173190,22516481",
  },
  {
    id: "4956",
    id_polifenol: "5607",
    polifenol: "gallocatechol",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "2",
    pmids: "10470285,12230128",
  },
  {
    id: "4957",
    id_polifenol: "4559",
    polifenol: "theaflavin",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "3",
    pmids: "15248026,12067577,21475988",
  },
  {
    id: "4958",
    id_polifenol: "5808",
    polifenol: "isoliquiritigenin",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "4",
    pmids: "26059439,11731922,27681719,16675659",
  },
  {
    id: "4959",
    id_polifenol: "2344",
    polifenol: "methyl gallate",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "9860503",
  },
  {
    id: "4960",
    id_polifenol: "2284",
    polifenol: "rosmarinic acid",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "2",
    pmids: "26056431,23421517",
  },
  {
    id: "4961",
    id_polifenol: "6455",
    polifenol: "nobiletin",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "5",
    pmids: "23441616,27428937,15298613,11749698,28948855",
  },
  {
    id: "4962",
    id_polifenol: "4513",
    polifenol: "galangin",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "3",
    pmids: "29039326,22142694,26347954",
  },
  {
    id: "4963",
    id_polifenol: "6063",
    polifenol: "naringin",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "26201693",
  },
  {
    id: "4964",
    id_polifenol: "1380",
    polifenol: "shogaol",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "17706603",
  },
  {
    id: "4965",
    id_polifenol: "2158",
    polifenol: "protocatechuic acid",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "7",
    pmids: "20600540,17304508,15870908,19606519,21291361,21916772,2347074",
  },
  {
    id: "4966",
    id_polifenol: "5489",
    polifenol: "delphinidin",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "15964118",
  },
  {
    id: "4967",
    id_polifenol: "6273",
    polifenol: "hesperetin",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "3",
    pmids: "25972151,21473152,19830248",
  },
  {
    id: "4968",
    id_polifenol: "1613",
    polifenol: "demethoxycurcumin",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "3",
    pmids: "9591190,22465177,7954412",
  },
  {
    id: "4969",
    id_polifenol: "93",
    polifenol: "Phloroglucinol",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "26845711",
  },
  {
    id: "4970",
    id_polifenol: "6454",
    polifenol: "formononetin",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "28038329",
  },
  {
    id: "4971",
    id_polifenol: "7550",
    polifenol: "3-methylquercetin",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "4",
    pmids: "27461104,22992727,25827070,21246822",
  },
  {
    id: "4972",
    id_polifenol: "6461",
    polifenol: "acacetin",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "3",
    pmids: "15686411,23251389,21473152",
  },
  {
    id: "4973",
    id_polifenol: "4253",
    polifenol:
      "5-(2,4-dihydroxy-5-isopropylphenyl)-4-(4-morpholin-4-ylmethylphenyl)isoxazole-3-carboxylic acid ethylamide",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "2",
    pmids: "21453385,23395886",
  },
  {
    id: "4974",
    id_polifenol: "1611",
    polifenol: "bis(4-hydroxycinnamoyl)methane",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "3",
    pmids: "25435973,9591190,7954412",
  },
  {
    id: "4975",
    id_polifenol: "55",
    polifenol: "Sodium Salicylate",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "16911681",
  },
  {
    id: "4976",
    id_polifenol: "5806",
    polifenol: "butein",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "19606519",
  },
  {
    id: "4977",
    id_polifenol: "1558",
    polifenol: "capsazepine",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "2",
    pmids: "27226186,28587230",
  },
  {
    id: "4978",
    id_polifenol: "5509",
    polifenol: "cyanidin 3-O-glucoside",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "3",
    pmids: "15964118,27690088,29125621",
  },
  {
    id: "4979",
    id_polifenol: "969",
    polifenol: "3,4-dihydroxyphenacyl caffeate phenylpropanoid ester",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "3",
    pmids: "12421475,11859459,28744911",
  },
  {
    id: "4980",
    id_polifenol: "5844",
    polifenol: "4-dimethylamino-3',4'-dimethoxychalcone",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "3",
    pmids: "15948252,14605879,15767780",
  },
  {
    id: "4981",
    id_polifenol: "6463",
    polifenol: "puerarin",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "2",
    pmids: "8242641,25434307",
  },
  {
    id: "4982",
    id_polifenol: "5819",
    polifenol: "licochalcone A",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "6",
    pmids: "29286170,25981581,21216524,28454311,25435618,8142919",
  },
  {
    id: "4983",
    id_polifenol: "4560",
    polifenol: "icariin",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "20307526",
  },
  {
    id: "4984",
    id_polifenol: "48",
    polifenol: "Anacardic Acids",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "25726174",
  },
  {
    id: "4985",
    id_polifenol: "5488",
    polifenol: "cyanidin",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "15964118",
  },
  {
    id: "4986",
    id_polifenol: "132",
    polifenol: "Equol",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "2",
    pmids: "27802587,26420965",
  },
  {
    id: "4987",
    id_polifenol: "7546",
    polifenol: "isoquercitrin",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "22906240",
  },
  {
    id: "4988",
    id_polifenol: "6482",
    polifenol: "tangeretin",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "2",
    pmids: "24573532,25998143",
  },
  {
    id: "4989",
    id_polifenol: "99",
    polifenol: "Pyrogallol",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "3",
    pmids: "18636183,12230128,22147653",
  },
  {
    id: "4990",
    id_polifenol: "452",
    polifenol: "acteoside",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "4",
    pmids: "11859459,28744911,11725977,19099401",
  },
  {
    id: "4991",
    id_polifenol: "1644",
    polifenol: "Cur1 compound",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "29025645",
  },
  {
    id: "4992",
    id_polifenol: "100",
    polifenol: "Resorcinols",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "2",
    pmids: "21751842,23415900",
  },
  {
    id: "4993",
    id_polifenol: "5850",
    polifenol: "cardamonin",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "9591187",
  },
  {
    id: "4994",
    id_polifenol: "7544",
    polifenol: "quercitrin",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "2",
    pmids: "29564971,22906240",
  },
  {
    id: "4995",
    id_polifenol: "300",
    polifenol: "rhodioloside",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "29749547",
  },
  {
    id: "4996",
    id_polifenol: "6465",
    polifenol: "genistin",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "8242641",
  },
  {
    id: "4997",
    id_polifenol: "4767",
    polifenol: "flavan-3-ol",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "12230128",
  },
  {
    id: "4998",
    id_polifenol: "2475",
    polifenol: "6-O-galloylglucose",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "12230128",
  },
  {
    id: "4999",
    id_polifenol: "6068",
    polifenol: "pinocembrin",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "26347954",
  },
  {
    id: "5000",
    id_polifenol: "1996",
    polifenol: "2,5-di-tert-butylhydroquinone",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "3",
    pmids: "26387654,27604137,23685796",
  },
  {
    id: "5001",
    id_polifenol: "6086",
    polifenol: "liquiritigenin",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "27681719",
  },
  {
    id: "5002",
    id_polifenol: "59",
    polifenol: "Dinitrophenols",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "22586497",
  },
  {
    id: "5003",
    id_polifenol: "7296",
    polifenol: "dihydromyricetin",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "26634523",
  },
  {
    id: "5004",
    id_polifenol: "40",
    polifenol: "Propyl Gallate",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "10376975",
  },
  {
    id: "5005",
    id_polifenol: "6558",
    polifenol: "7,3'-dihydroxy-4'-methoxyisoflavone",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "28368679",
  },
  {
    id: "5006",
    id_polifenol: "4525",
    polifenol: "eupatilin",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "6",
    pmids: "18603343,23292941,16393120,22076197,19281788,29693162",
  },
  {
    id: "5007",
    id_polifenol: "5455",
    polifenol: "theaflavin-3,3'-digallate",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "15248026",
  },
  {
    id: "5008",
    id_polifenol: "5630",
    polifenol: "polyphenon E",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "22258296",
  },
  {
    id: "5009",
    id_polifenol: "5495",
    polifenol: "malvidin",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "15964118",
  },
  {
    id: "5010",
    id_polifenol: "7141",
    polifenol: "apigetrin",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "29408335",
  },
  {
    id: "5011",
    id_polifenol: "637",
    polifenol: "glabridin",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "2",
    pmids: "27681719,29725429",
  },
  {
    id: "5012",
    id_polifenol: "6477",
    polifenol: "hispidulin",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "24159347",
  },
  {
    id: "5013",
    id_polifenol: "1353",
    polifenol: "protocatechualdehyde",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "2347074",
  },
  {
    id: "5014",
    id_polifenol: "4883",
    polifenol: "flavokawain B",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "28374157",
  },
  {
    id: "5015",
    id_polifenol: "5496",
    polifenol: "pelargonidin",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "15964118",
  },
  {
    id: "5016",
    id_polifenol: "7853",
    polifenol: "Grape Seed Proanthocyanidins",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "3",
    pmids: "12074978,10448908,10962138",
  },
  {
    id: "5017",
    id_polifenol: "6066",
    polifenol: "eriodictyol",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "2",
    pmids: "20648923,28525714",
  },
  {
    id: "5018",
    id_polifenol: "353",
    polifenol: "sesamol",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "2678948",
  },
  {
    id: "5019",
    id_polifenol: "3019",
    polifenol: "nitroaspirin",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "10220501",
  },
  {
    id: "5020",
    id_polifenol: "713",
    polifenol:
      "3-(3-chloro-4-hydroxyphenylamino)-4-(4-nitrophenyl)-1H-pyrrole-2,5-dione",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "16371352",
  },
  {
    id: "5021",
    id_polifenol: "7377",
    polifenol: "astragalin",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "27853354",
  },
  {
    id: "5022",
    id_polifenol: "1672",
    polifenol: "B19 monocarbonyl curcumin",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "29254150",
  },
  {
    id: "5023",
    id_polifenol: "115",
    polifenol: "Diosmin",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "25821971",
  },
  {
    id: "5024",
    id_polifenol: "87",
    polifenol: "Metoclopramide",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "1525396",
  },
  {
    id: "5025",
    id_polifenol: "6554",
    polifenol: "tectorigenin",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "22627971",
  },
  {
    id: "5026",
    id_polifenol: "7156",
    polifenol: "scutellarein",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "29464049",
  },
  {
    id: "5027",
    id_polifenol: "5831",
    polifenol: "angoletin",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "7",
    pmids: "28374157,12824901,15767780,22458642,15298613,2011492,17243725",
  },
  {
    id: "5028",
    id_polifenol: "4565",
    polifenol: "morusin",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "28915664",
  },
  {
    id: "5029",
    id_polifenol: "6175",
    polifenol: "2'-hydroxyflavanone",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "26629250",
  },
  {
    id: "5030",
    id_polifenol: "6112",
    polifenol: "alpinetin",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "23254270",
  },
  {
    id: "5031",
    id_polifenol: "896",
    polifenol: "polyphenon B",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "2",
    pmids: "17530359,20020873",
  },
  {
    id: "5032",
    id_polifenol: "6770",
    polifenol: "5-hydroxy-3,6,7,8,3',4'-hexamethoxyflavone",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "3",
    pmids: "26671739,15298613,11749698",
  },
  {
    id: "5033",
    id_polifenol: "6457",
    polifenol: "salvigenin",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "2",
    pmids: "26428258,17404066",
  },
  {
    id: "5034",
    id_polifenol: "7741",
    polifenol: "biochanin A",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "21541487",
  },
  {
    id: "5035",
    id_polifenol: "2790",
    polifenol: "ginkgolic acid",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "21751842",
  },
  {
    id: "5036",
    id_polifenol: "2364",
    polifenol: "theaflavine gallate",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "15248026",
  },
  {
    id: "5037",
    id_polifenol: "6166",
    polifenol: "liquiritin",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "3",
    pmids: "28715876,29048624,27681719",
  },
  {
    id: "5038",
    id_polifenol: "4052",
    polifenol: "bis-(3-(3',5'-di-tert-butyl-4'-hydroxyphenyl)propyl)sulfide",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "12421475",
  },
  {
    id: "5039",
    id_polifenol: "6100",
    polifenol: "pinostrobin",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "26347954",
  },
  {
    id: "5040",
    id_polifenol: "6774",
    polifenol: "5,7-dihydroxy-6,3',4'-trimethoxyflavone",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "3",
    pmids: "18603343,23292941,16393120",
  },
  {
    id: "5041",
    id_polifenol: "315",
    polifenol: "bakuchiol",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "2",
    pmids: "28990045,27685910",
  },
  {
    id: "5042",
    id_polifenol: "5537",
    polifenol: "peonidin",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "15964118",
  },
  {
    id: "5043",
    id_polifenol: "7453",
    polifenol: "kaempferol-3-O-glucoside",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "17084606",
  },
  {
    id: "5044",
    id_polifenol: "4639",
    polifenol: "aromadedrin",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "2",
    pmids: "21246822,18176909",
  },
  {
    id: "5045",
    id_polifenol: "4782",
    polifenol: "kurarinone",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "25524636",
  },
  {
    id: "5046",
    id_polifenol: "3494",
    polifenol: "asarone",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "26502896",
  },
  {
    id: "5047",
    id_polifenol: "6453",
    polifenol: "cirsimaritin",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "22184071",
  },
  {
    id: "5048",
    id_polifenol: "4553",
    polifenol: "sulfuretin",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "19606519",
  },
  {
    id: "5049",
    id_polifenol: "5615",
    polifenol: "gallocatechin gallate",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "12230128",
  },
  {
    id: "5050",
    id_polifenol: "5858",
    polifenol: "isobavachalcone",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "26893622",
  },
  {
    id: "5051",
    id_polifenol: "5539",
    polifenol: "peonidin 3-glucoside",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "15964118",
  },
  {
    id: "5052",
    id_polifenol: "6093",
    polifenol: "pinobanksin",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "26347954",
  },
  {
    id: "5053",
    id_polifenol: "6287",
    polifenol: "neohesperidin",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "19367677",
  },
  {
    id: "5054",
    id_polifenol: "7437",
    polifenol: "kaempferol-3-O-rutinoside",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "21473152",
  },
  {
    id: "5055",
    id_polifenol: "1718",
    polifenol: "dihydroguaiaretic acid",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "2",
    pmids: "25765830,19916529",
  },
  {
    id: "5056",
    id_polifenol: "5532",
    polifenol: "malvidin-3-glucoside",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "15964118",
  },
  {
    id: "5057",
    id_polifenol: "1509",
    polifenol: "8-gingerol",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "14666666",
  },
  {
    id: "5058",
    id_polifenol: "4764",
    polifenol: "tectochrysin",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "26347954",
  },
  {
    id: "5059",
    id_polifenol: "4558",
    polifenol: "2'-hydroxyflavone",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "22184071",
  },
  {
    id: "5060",
    id_polifenol: "5101",
    polifenol: "isokaempferide",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "22184071",
  },
  {
    id: "5061",
    id_polifenol: "5814",
    polifenol: "2',4'-dihydroxychalcone",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "2",
    pmids: "19457454,20471467",
  },
  {
    id: "5062",
    id_polifenol: "7885",
    polifenol: "hydroxysafflor yellow A",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "29417935",
  },
  {
    id: "5063",
    id_polifenol: "7427",
    polifenol: "kaempferol 3-O-rhamnoside",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "17084606",
  },
  {
    id: "5064",
    id_polifenol: "1492",
    polifenol: "hirsutenone",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "18958419",
  },
  {
    id: "5065",
    id_polifenol: "2159",
    polifenol: "2,3-dihydroxybenzoic acid",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "11725977",
  },
  {
    id: "5066",
    id_polifenol: "6555",
    polifenol: "tectoridin",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "22627971",
  },
  {
    id: "5067",
    id_polifenol: "400",
    polifenol: "cardanol",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "22458642",
  },
  {
    id: "5068",
    id_polifenol: "6717",
    polifenol: "irigenin",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "2",
    pmids: "29305260,22627971",
  },
  {
    id: "5069",
    id_polifenol: "7763",
    polifenol: "7-difluoromethoxyl-5,4'-di-n-octylgenistein",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "2",
    pmids: "22969238,27279287",
  },
  {
    id: "5070",
    id_polifenol: "7149",
    polifenol: "5,7,4'-trimethylapigenin",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "17404066",
  },
  {
    id: "5071",
    id_polifenol: "4574",
    polifenol: "sinensetin",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "21710752",
  },
  {
    id: "5072",
    id_polifenol: "472",
    polifenol: "isoacteoside",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "2",
    pmids: "12421475,11725977",
  },
  {
    id: "5073",
    id_polifenol: "7518",
    polifenol: "quercetin-3-O-alpha-arabinofuranoside",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "29635130",
  },
  {
    id: "5074",
    id_polifenol: "1451",
    polifenol: "hispolon",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "26056942",
  },
  {
    id: "5075",
    id_polifenol: "6478",
    polifenol: "cirsilineol",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "26428258",
  },
  {
    id: "5076",
    id_polifenol: "7888",
    polifenol: "neoisoliquiritin",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "25435618",
  },
  {
    id: "5077",
    id_polifenol: "4630",
    polifenol: "5,7,2',3'-tetrahydroxyflavone",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "24988056",
  },
  {
    id: "5078",
    id_polifenol: "6647",
    polifenol: "6-methylflavone",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "27853354",
  },
  {
    id: "5079",
    id_polifenol: "2358",
    polifenol: "theaflavin digallate",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "10470285",
  },
  {
    id: "5080",
    id_polifenol: "5198",
    polifenol: "isosakuranetin",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "21473152",
  },
  {
    id: "5081",
    id_polifenol: "5500",
    polifenol: "pelargonidin-3-glucoside",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "15964118",
  },
  {
    id: "5082",
    id_polifenol: "7726",
    polifenol: "troxerutin",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "28531805",
  },
  {
    id: "5083",
    id_polifenol: "1649",
    polifenol: "1,5-bis(2-hydroxyphenyl)-1,4-pentadien-3-one",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "28360932",
  },
  {
    id: "5084",
    id_polifenol: "2401",
    polifenol: "2,3,5-trihydroxybenzoic acid",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "29599323",
  },
  {
    id: "5085",
    id_polifenol: "4986",
    polifenol:
      "5-hydroxy-7-methoxyflavone-(4' -O-8'')-5'',7''-dihydroxy-4'''-methoxyflavone",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "15686411",
  },
  {
    id: "5086",
    id_polifenol: "1372",
    polifenol: "3-methylcatechol",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "2678948",
  },
  {
    id: "5087",
    id_polifenol: "6616",
    polifenol: "xanthomicrol",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "22184071",
  },
  {
    id: "5088",
    id_polifenol: "7564",
    polifenol: "camelliaside B",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "22627971",
  },
  {
    id: "5089",
    id_polifenol: "1804",
    polifenol: "guaiacylglycerol-beta-coniferyl ether",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "21473152",
  },
  {
    id: "5090",
    id_polifenol: "3435",
    polifenol: "N1-hydroxy-N8-(4-phenoxyphenyl)octanediamide",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "26043797",
  },
  {
    id: "5091",
    id_polifenol: "7531",
    polifenol: "7-O-geranylquercetin",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "2",
    pmids: "28076833,27980567",
  },
  {
    id: "5092",
    id_polifenol: "4149",
    polifenol: "adipostatin A",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "21751842",
  },
  {
    id: "5093",
    id_polifenol: "4754",
    polifenol: "poncirin",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "2",
    pmids: "26393583,23615464",
  },
  {
    id: "5094",
    id_polifenol: "1348",
    polifenol: "urushiol",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "25337543",
  },
  {
    id: "5095",
    id_polifenol: "7027",
    polifenol: "chrysosplenol D",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "21469236",
  },
  {
    id: "5096",
    id_polifenol: "5533",
    polifenol: "cyanidin-3-O-beta-glucopyranoside",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "20121190",
  },
  {
    id: "5097",
    id_polifenol: "1625",
    polifenol: "curcumin III",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "1578097",
  },
  {
    id: "5098",
    id_polifenol: "7583",
    polifenol: "quercetin 3-O-glucopyranoside",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "20121190",
  },
  {
    id: "5099",
    id_polifenol: "7650",
    polifenol: "3,7-O-dimethylquercetin",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "21473152",
  },
  {
    id: "5100",
    id_polifenol: "521",
    polifenol: "E 7010",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "2",
    pmids: "9654112,8137285",
  },
  {
    id: "5101",
    id_polifenol: "1993",
    polifenol: "hydroxyhydroquinone",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "2347074",
  },
  {
    id: "5102",
    id_polifenol: "2749",
    polifenol: "zinc 3,5-diisopropylsalicylate",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "17959272",
  },
  {
    id: "5103",
    id_polifenol: "4102",
    polifenol: "ardisiphenol D",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "21751842",
  },
  {
    id: "5104",
    id_polifenol: "6840",
    polifenol: "calycopterin",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "22184071",
  },
  {
    id: "5105",
    id_polifenol: "1624",
    polifenol: "hydrazinocurcumin",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "27890795",
  },
  {
    id: "5106",
    id_polifenol: "5804",
    polifenol: "sofalcone",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "2",
    pmids: "9479645,26840084",
  },
  {
    id: "5107",
    id_polifenol: "7435",
    polifenol: "kaempferol-3-O-(2,3-di-O-acetyl-alpha-l-rhamnopyranoside)",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "27853354",
  },
  {
    id: "5108",
    id_polifenol: "7914",
    polifenol: "4',7-dihydroxy-3,4-dihydroisoflavone",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "28525714",
  },
  {
    id: "5109",
    id_polifenol: "7047",
    polifenol: "irisflorentin",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "22627971",
  },
  {
    id: "5110",
    id_polifenol: "6309",
    polifenol: "dalspinosin",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "18958419",
  },
  {
    id: "5111",
    id_polifenol: "6022",
    polifenol: "morachalcone A",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "21246822",
  },
  {
    id: "5112",
    id_polifenol: "837",
    polifenol: "4-vinyl-2,6-dimethoxyphenol",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "2",
    pmids: "23761819,25781635",
  },
  {
    id: "5113",
    id_polifenol: "4269",
    polifenol: "2-methoxy-4-hydroxy-6-pentadecyl-benzene-1-O-acetate",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "21751842",
  },
  {
    id: "5114",
    id_polifenol: "4595",
    polifenol: "2-(2-phenylethyl)chromone",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "26784520",
  },
  {
    id: "5115",
    id_polifenol: "5154",
    polifenol: "5,7-dihydroxy-8-nitrochrysin",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "20878083",
  },
  {
    id: "5116",
    id_polifenol: "4520",
    polifenol: "avicularin",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "29635130",
  },
  {
    id: "5117",
    id_polifenol: "7574",
    polifenol: "quercimeritrin",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "22906240",
  },
  {
    id: "5118",
    id_polifenol: "6682",
    polifenol: "homoeriodictyol",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "28525714",
  },
  {
    id: "5119",
    id_polifenol: "7532",
    polifenol: "7-O-butylquercetin",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "27980567",
  },
  {
    id: "5120",
    id_polifenol: "6327",
    polifenol: "6-methoxyflavone",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "27086008",
  },
  {
    id: "5121",
    id_polifenol: "4529",
    polifenol: "ganhuangenin",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "16545824",
  },
  {
    id: "5122",
    id_polifenol: "5479",
    polifenol: "cyanidin 3-O-glucopyranoside",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "20121190",
  },
  {
    id: "5123",
    id_polifenol: "6543",
    polifenol: "euchrenone b10",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "21246822",
  },
  {
    id: "5124",
    id_polifenol: "7750",
    polifenol: "2'-hydroxy-genistein",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "29552162",
  },
  {
    id: "5125",
    id_polifenol: "6484",
    polifenol: "psi-baptigenin",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "8242641",
  },
  {
    id: "5126",
    id_polifenol: "3469",
    polifenol: "pestheic acid",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "24114206",
  },
  {
    id: "5127",
    id_polifenol: "4323",
    polifenol: "pannokin C",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "24074554",
  },
  {
    id: "5128",
    id_polifenol: "6591",
    polifenol: "irilin A",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "22627971",
  },
  {
    id: "5129",
    id_polifenol: "771",
    polifenol: "3,5-dihydroxy-1,7-bis(3,4-dihydroxyphenyl)heptane",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "18958419",
  },
  {
    id: "5130",
    id_polifenol: "3986",
    polifenol: "sinapyl acetate",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "21473152",
  },
  {
    id: "5131",
    id_polifenol: "7138",
    polifenol: "apigenin dimethylether",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "21473152",
  },
  {
    id: "5132",
    id_polifenol: "913",
    polifenol: "mahkoside A",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "23044367",
  },
  {
    id: "5133",
    id_polifenol: "4954",
    polifenol: "chrysoplenetin",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "21469236",
  },
  {
    id: "5134",
    id_polifenol: "5427",
    polifenol: "patriscabratine",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "22906240",
  },
  {
    id: "5135",
    id_polifenol: "1664",
    polifenol: "(2E,4E)-1-(2-hydroxyphenyl)-5-phenylpenta-2,4-dien-1-one",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "26347954",
  },
  {
    id: "5136",
    id_polifenol: "5822",
    polifenol: "3'-methyl-3-hydroxychalcone",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "8142919",
  },
  {
    id: "5137",
    id_polifenol: "6185",
    polifenol: "5,7,2',6'-tetrahydroxy-6-lavandulylated-flavanone",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "16545824",
  },
  {
    id: "5138",
    id_polifenol: "6583",
    polifenol: "bolusanthol C",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "16545824",
  },
  {
    id: "5139",
    id_polifenol: "7559",
    polifenol:
      "quercetin 3-O-alpha-rhamnopyranosyl-(1-2)-beta-galactopyranoside",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "20121190",
  },
  {
    id: "5140",
    id_polifenol: "2405",
    polifenol: "pungen C",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "20419538",
  },
  {
    id: "5141",
    id_polifenol: "4900",
    polifenol: "ayanin",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "20307524",
  },
  {
    id: "5142",
    id_polifenol: "7861",
    polifenol: "gravinol",
    id_cancer: "500",
    cancer: "Gastric Cancer",
    quant: "1",
    pmids: "15565401",
  },
  {
    id: "5143",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "62",
    pmids:
      "28052097,22246103,27838343,23943362,19670328,28003763,26138287,29848706,21087351,26397991,24707875,27477310,29433670,19142175,23871783,17643301,21676539,18953257,21196331,18570926,24438177,18404646,26180625,26606169,17196098,29039524,19919125,28768932,27175782,22884073,22227579,23453831,21227456,17430639,21796625,29796442,20664924,29770817,26298457,25434366,28152014,12168845,18640131,17967505,19424582,19278301,27935659,21443429,23000892,28930257,20307087,23140288,24729227,22622510,26193251,21190854,23479391,17305535,28122160,28029227,27037021,16001171",
  },
  {
    id: "5144",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "117",
    pmids:
      "22551677,29081818,19724924,25256401,24324975,20538607,27572503,19384191,18784349,18347134,27738325,23985704,23194063,28535906,29512729,28991167,16628653,25451846,20121547,28789415,19395473,28322158,12807725,17643301,21347286,27725901,21697760,26129848,25883212,19003584,28165402,21272158,21484797,27035865,17440100,27845899,26166196,17201164,23563640,14607648,26348467,27133426,19196508,21904657,23704793,9918209,26302089,18049840,25685909,22890189,24366050,28067673,21116627,20428806,27936114,27094172,9252680,16985059,17671691,29107110,27330528,29157028,22108826,23794119,19401701,25497868,25072100,28259961,28123853,22322899,20388782,17882652,18640131,29048549,22685460,16507392,26177391,20394536,21295962,27401816,17439648,22895897,28365185,24224124,21312196,26691217,28008233,28137215,24851881,28059418,20818481,27696400,22637745,29759562,28236692,27438851,28493710,20597137,16141719,23933177,24023285,26709750,19528445,20647339,29421571,23007664,25493374,22725697,22107757,26561365,21386635,29271302,26037703,26440757,28106283,17900536,23552468",
  },
  {
    id: "5145",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "52",
    pmids:
      "27669292,21596068,27572503,15705601,21241417,19082499,27738325,29512729,21031621,20952510,27725901,21196331,21678400,18841326,29854071,28165402,27521217,23704793,11920648,29879629,27936114,10624710,9252680,21796625,29796442,27974694,22116673,20664924,23684930,26165362,28137273,28259961,26651028,15462182,17439648,27253410,25898131,23613993,22190076,27485636,9591194,12131770,14519826,20647339,26395574,15281219,19588362,19012035,24463158,18580440,29705506,9436857",
  },
  {
    id: "5146",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "61",
    pmids:
      "16868480,26138072,11745456,12794242,11876253,22967941,23017243,24297112,27914516,14598883,12947332,9175881,22652796,14707447,15028947,23569426,21613217,15805288,10972974,16773182,19618718,16209712,16105664,17353198,12359775,17054996,27473919,11039477,25880226,11401480,27435925,18550701,27216977,24301926,15896303,25961376,12014623,16637058,10220513,10781373,26718740,17638924,15289335,15492268,25847529,12105858,10585578,12481421,22441995,20397262,19062038,11358848,17671195,28944626,19509115,10433520,26439801,11286473,28595260,15855823,25575964",
  },
  {
    id: "5147",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "50",
    pmids:
      "11745456,23834147,24479798,12947332,15211111,17079479,14707447,16258364,16209712,18026817,16546962,21463919,16284950,29433670,12495471,21503965,26180625,15097869,15257099,16204081,11920648,22884073,23140286,14697287,16789737,17131310,16061678,16475211,25202045,19358273,17922126,20354770,27429851,9867251,11741179,17275032,10433520,19025644,15015587,27485636,28137215,10424789,27696400,27534919,12657953,20824697,25493374,15281219,27696401,16001171",
  },
  {
    id: "5148",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "30",
    pmids:
      "29026320,19208367,25017900,27477310,23635652,11520601,24368982,21196331,26109002,27521217,11920648,17234771,24312717,21796625,20664924,28137273,12168845,27253410,19424582,21443429,20617020,23000892,28137215,26284537,17592224,25493374,28122160,15281219,16001171,10541449",
  },
  {
    id: "5149",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "32",
    pmids:
      "21318151,15375156,15705601,22583593,21241417,23135610,17569628,19082499,23711146,26225138,25017900,17981559,22497997,10624710,19438225,22367292,21796625,22971992,27694793,29186186,16817635,21295962,26246802,21787753,28137215,9591194,24798568,12131770,25493374,28507327,27251159,10541449",
  },
  {
    id: "5150",
    id_polifenol: "2167",
    polifenol: "phenolic acid",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "15",
    pmids:
      "17066513,23943362,23563640,29879629,23453831,29048549,20510328,27935659,21443429,28930257,26193251,17592224,28122160,28029227,24463158",
  },
  {
    id: "5151",
    id_polifenol: "49",
    polifenol: "Aspirin",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "28",
    pmids:
      "19966835,22025561,26056043,18805632,11801560,29780561,22552812,23019409,10631359,27903583,22494617,26301084,15861417,16699954,11238189,16042578,17488476,19101573,11180079,27138793,23007664,26879926,25846752,16618778,12905826,19880966,24520038,26294325",
  },
  {
    id: "5152",
    id_polifenol: "109",
    polifenol: "Catechin",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "22",
    pmids:
      "21241417,26225138,25017900,22497997,23453831,19438225,27694793,29796442,17574044,24432976,20617020,28930257,22190076,24516636,22622510,9591194,14519826,25431153,28122160,28029227,27251159,19588362",
  },
  {
    id: "5153",
    id_polifenol: "125",
    polifenol: "Isoflavones",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "15",
    pmids:
      "26138287,16258364,16546962,16789737,20124483,24201306,16061678,25202045,18640131,25242818,21295962,19278301,19025644,24224124,19654291",
  },
  {
    id: "5154",
    id_polifenol: "110",
    polifenol: "Chalcones",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "11",
    pmids:
      "26211581,24308485,27810244,26615871,29121426,8375934,28011424,28099006,27371926,21778460,27558673",
  },
  {
    id: "5155",
    id_polifenol: "3089",
    polifenol: "1,1-diphenyl-2-picrylhydrazyl",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "4",
    pmids: "19919125,23453831,17430639,29611204",
  },
  {
    id: "5156",
    id_polifenol: "114",
    polifenol: "Apigenin",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "15",
    pmids:
      "23943362,22889981,24148603,19142175,18953257,18404646,17196098,22227579,21227456,28152014,17967505,21443429,17671722,26197535,25493374",
  },
  {
    id: "5157",
    id_polifenol: "113",
    polifenol: "Flavones",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "11",
    pmids:
      "26527884,29026320,28915595,28003763,26606169,29286098,27563398,20307087,26410998,16001171,23411198",
  },
  {
    id: "5158",
    id_polifenol: "38",
    polifenol: "Gallic Acid",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "8",
    pmids:
      "22739044,24325191,23943154,22132974,27935659,28930257,28122160,28029227",
  },
  {
    id: "5159",
    id_polifenol: "117",
    polifenol: "Luteolin",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "9",
    pmids:
      "26527884,22825765,28003763,23871783,29770817,25237909,12168845,29286098,21443429",
  },
  {
    id: "5160",
    id_polifenol: "1",
    polifenol: "Phenols",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "3",
    pmids: "22739044,24339417,24424498",
  },
  {
    id: "5161",
    id_polifenol: "105",
    polifenol: "Anthocyanins",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "2",
    pmids: "27485636,26476633",
  },
  {
    id: "5162",
    id_polifenol: "7235",
    polifenol: "silybin",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "7",
    pmids: "26349994,29805688,21954330,23022268,26510913,28885916,17305535",
  },
  {
    id: "5163",
    id_polifenol: "129",
    polifenol: "Rotenone",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "5",
    pmids: "22946344,16284950,10424789,12657953,23479391",
  },
  {
    id: "5164",
    id_polifenol: "121",
    polifenol: "Kaempferols",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "3",
    pmids: "18570926,27175782,25053822",
  },
  {
    id: "5165",
    id_polifenol: "871",
    polifenol: "ABT-737",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "7",
    pmids: "27562715,27387230,26506422,18413764,29278689,24316551,25749177",
  },
  {
    id: "5166",
    id_polifenol: "6451",
    polifenol: "daidzein",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "15040033",
  },
  {
    id: "5167",
    id_polifenol: "6065",
    polifenol: "baicalein",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "13",
    pmids:
      "29749481,21596068,12481414,28915595,10600514,29039524,29552186,29697746,29155449,7954360,23140288,27553814,27037021",
  },
  {
    id: "5168",
    id_polifenol: "7",
    polifenol: "Capsaicin",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "11",
    pmids:
      "24419059,23781265,23255891,25869100,22530568,24941670,25963558,19002586,21647434,28089829,28665321",
  },
  {
    id: "5169",
    id_polifenol: "4634",
    polifenol: "alvocidib",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "11489836",
  },
  {
    id: "5170",
    id_polifenol: "120",
    polifenol: "Flavonols",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "24511002",
  },
  {
    id: "5171",
    id_polifenol: "123",
    polifenol: "Rutin",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "7",
    pmids: "19919125,11920648,29611204,27935659,28930257,28122160,28029227",
  },
  {
    id: "5172",
    id_polifenol: "6062",
    polifenol: "naringenin",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "4",
    pmids: "27838343,29346059,23300530,18176909",
  },
  {
    id: "5173",
    id_polifenol: "39",
    polifenol: "Hydrolyzable Tannins",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "3",
    pmids: "9252680,20510328,15462182",
  },
  {
    id: "5174",
    id_polifenol: "130",
    polifenol: "Proanthocyanidins",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "7",
    pmids: "22905202,26277505,25652374,28930257,22902508,28122160,28029227",
  },
  {
    id: "5175",
    id_polifenol: "35",
    polifenol: "Hydroquinones",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "4",
    pmids: "14500388,21156818,15240547,22984577",
  },
  {
    id: "5176",
    id_polifenol: "111",
    polifenol: "Flavanones",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "3",
    pmids: "28914822,19572611,26410998",
  },
  {
    id: "5177",
    id_polifenol: "4502",
    polifenol: "fisetin",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "3",
    pmids: "28052097,19670328,29848706",
  },
  {
    id: "5178",
    id_polifenol: "6",
    polifenol: "Catechols",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "26305900",
  },
  {
    id: "5179",
    id_polifenol: "25",
    polifenol: "Butylated Hydroxytoluene",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "6",
    pmids: "11062701,16201853,23453831,28885916,6347683,10541449",
  },
  {
    id: "5180",
    id_polifenol: "75",
    polifenol: "Butylated Hydroxyanisole",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "3",
    pmids: "11768272,28885916,10541449",
  },
  {
    id: "5181",
    id_polifenol: "15",
    polifenol: "Masoprocol",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "3",
    pmids: "11953870,12481414,12110314",
  },
  {
    id: "5182",
    id_polifenol: "6087",
    polifenol: "wogonin",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "3",
    pmids: "21596068,28105213,18829980",
  },
  {
    id: "5183",
    id_polifenol: "4519",
    polifenol: "myricetin",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "2",
    pmids: "24511002,21676539",
  },
  {
    id: "5184",
    id_polifenol: "4515",
    polifenol: "baicalin",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "2",
    pmids: "21596068,7954360",
  },
  {
    id: "5185",
    id_polifenol: "4500",
    polifenol: "procyanidin",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "24325191",
  },
  {
    id: "5186",
    id_polifenol: "5608",
    polifenol: "epicatechin gallate",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "3",
    pmids: "21241417,10624710,27251159",
  },
  {
    id: "5187",
    id_polifenol: "1356",
    polifenol: "gingerol",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "3",
    pmids: "17066513,24204396,25961833",
  },
  {
    id: "5188",
    id_polifenol: "54",
    polifenol: "Salicylic Acid",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "28370884",
  },
  {
    id: "5189",
    id_polifenol: "98",
    polifenol: "Propofol",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "4",
    pmids: "26214431,27986626,27829997,24023491",
  },
  {
    id: "5190",
    id_polifenol: "44",
    polifenol: "Salicylates",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "4",
    pmids: "29942156,10210643,10631359,28958848",
  },
  {
    id: "5191",
    id_polifenol: "4559",
    polifenol: "theaflavin",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "3",
    pmids: "10624710,14519826,10541449",
  },
  {
    id: "5192",
    id_polifenol: "2344",
    polifenol: "methyl gallate",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "24798568",
  },
  {
    id: "5193",
    id_polifenol: "4708",
    polifenol: "xanthohumol",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "3",
    pmids: "26211581,29121426,25887885",
  },
  {
    id: "5194",
    id_polifenol: "2284",
    polifenol: "rosmarinic acid",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "26364660",
  },
  {
    id: "5195",
    id_polifenol: "112",
    polifenol: "Hesperidin",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "2",
    pmids: "19919125,29346059",
  },
  {
    id: "5196",
    id_polifenol: "1380",
    polifenol: "shogaol",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "2",
    pmids: "25961833,24424498",
  },
  {
    id: "5197",
    id_polifenol: "2158",
    polifenol: "protocatechuic acid",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "28122160",
  },
  {
    id: "5198",
    id_polifenol: "5489",
    polifenol: "delphinidin",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "27485636",
  },
  {
    id: "5199",
    id_polifenol: "6273",
    polifenol: "hesperetin",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "29346059",
  },
  {
    id: "5200",
    id_polifenol: "81",
    polifenol: "Fenofibrate",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "2",
    pmids: "26850851,28733879",
  },
  {
    id: "5201",
    id_polifenol: "4253",
    polifenol:
      "5-(2,4-dihydroxy-5-isopropylphenyl)-4-(4-morpholin-4-ylmethylphenyl)isoxazole-3-carboxylic acid ethylamide",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "2",
    pmids: "25389454,22753713",
  },
  {
    id: "5202",
    id_polifenol: "1611",
    polifenol: "bis(4-hydroxycinnamoyl)methane",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "27845899",
  },
  {
    id: "5203",
    id_polifenol: "119",
    polifenol: "Silymarin",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "17305535",
  },
  {
    id: "5204",
    id_polifenol: "69",
    polifenol: "Phenolsulfonphthalein",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "10198257",
  },
  {
    id: "5205",
    id_polifenol: "126",
    polifenol: "Coumestrol",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "2",
    pmids: "17275032,10424789",
  },
  {
    id: "5206",
    id_polifenol: "55",
    polifenol: "Sodium Salicylate",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "3",
    pmids: "10210643,10631359,26415823",
  },
  {
    id: "5207",
    id_polifenol: "5806",
    polifenol: "butein",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "20699088",
  },
  {
    id: "5208",
    id_polifenol: "5844",
    polifenol: "4-dimethylamino-3',4'-dimethoxychalcone",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "12794752",
  },
  {
    id: "5209",
    id_polifenol: "5819",
    polifenol: "licochalcone A",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "24253317",
  },
  {
    id: "5210",
    id_polifenol: "48",
    polifenol: "Anacardic Acids",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "29463243",
  },
  {
    id: "5211",
    id_polifenol: "2773",
    polifenol: "farnesylthiosalicylic acid",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "5",
    pmids: "22419113,11839677,24204197,18374183,20528225",
  },
  {
    id: "5212",
    id_polifenol: "80",
    polifenol: "Clofibrate",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "29059162",
  },
  {
    id: "5213",
    id_polifenol: "132",
    polifenol: "Equol",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "10424789",
  },
  {
    id: "5214",
    id_polifenol: "1995",
    polifenol: "2-tert-butylhydroquinone",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "2",
    pmids: "27750041,23108405",
  },
  {
    id: "5215",
    id_polifenol: "7546",
    polifenol: "isoquercitrin",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "25434366",
  },
  {
    id: "5216",
    id_polifenol: "100",
    polifenol: "Resorcinols",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "2",
    pmids: "21751842,24392814",
  },
  {
    id: "5217",
    id_polifenol: "5614",
    polifenol: "catechin gallate",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "2",
    pmids: "21241417,22497997",
  },
  {
    id: "5218",
    id_polifenol: "300",
    polifenol: "rhodioloside",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "23672050",
  },
  {
    id: "5219",
    id_polifenol: "1996",
    polifenol: "2,5-di-tert-butylhydroquinone",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "25540678",
  },
  {
    id: "5220",
    id_polifenol: "4585",
    polifenol: "baohuoside I",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "23672050",
  },
  {
    id: "5221",
    id_polifenol: "6625",
    polifenol: "phenoxodiol",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "19278301",
  },
  {
    id: "5222",
    id_polifenol: "2490",
    polifenol: "punicalagin",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "20510328",
  },
  {
    id: "5223",
    id_polifenol: "7547",
    polifenol: "hyperoside",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "2",
    pmids: "27459118,26676634",
  },
  {
    id: "5224",
    id_polifenol: "1810",
    polifenol: "heminordihydroguaiaretic acid",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "10600514",
  },
  {
    id: "5225",
    id_polifenol: "19",
    polifenol: "Pentachlorophenol",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "28962326",
  },
  {
    id: "5226",
    id_polifenol: "6477",
    polifenol: "hispidulin",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "21087351",
  },
  {
    id: "5227",
    id_polifenol: "7198",
    polifenol: "homoorientin",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "28003763",
  },
  {
    id: "5228",
    id_polifenol: "6456",
    polifenol: "daidzin",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "15281219",
  },
  {
    id: "5229",
    id_polifenol: "4501",
    polifenol: "tricin",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "2",
    pmids: "16001171,23411198",
  },
  {
    id: "5230",
    id_polifenol: "7853",
    polifenol: "Grape Seed Proanthocyanidins",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "2",
    pmids: "24325191,25652374",
  },
  {
    id: "5231",
    id_polifenol: "5796",
    polifenol: "dihydrochalcone",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "2",
    pmids: "26298457,24431013",
  },
  {
    id: "5232",
    id_polifenol: "353",
    polifenol: "sesamol",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "22076497",
  },
  {
    id: "5233",
    id_polifenol: "3019",
    polifenol: "nitroaspirin",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "4",
    pmids: "12438552,23019409,17956352,29133913",
  },
  {
    id: "5234",
    id_polifenol: "6452",
    polifenol: "chrysoeriol",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "29454280",
  },
  {
    id: "5235",
    id_polifenol: "713",
    polifenol:
      "3-(3-chloro-4-hydroxyphenylamino)-4-(4-nitrophenyl)-1H-pyrrole-2,5-dione",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "25869100",
  },
  {
    id: "5236",
    id_polifenol: "4565",
    polifenol: "morusin",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "26646273",
  },
  {
    id: "5237",
    id_polifenol: "6112",
    polifenol: "alpinetin",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "22246103",
  },
  {
    id: "5238",
    id_polifenol: "7741",
    polifenol: "biochanin A",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "21449913",
  },
  {
    id: "5239",
    id_polifenol: "2790",
    polifenol: "ginkgolic acid",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "2",
    pmids: "25895130,21751842",
  },
  {
    id: "5240",
    id_polifenol: "84",
    polifenol: "Halogenated Diphenyl Ethers",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "27449332",
  },
  {
    id: "5241",
    id_polifenol: "9",
    polifenol: "1,2-Dihydroxybenzene-3,5-Disulfonic Acid Disodium Salt",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "2",
    pmids: "16763728,15580305",
  },
  {
    id: "5242",
    id_polifenol: "1918",
    polifenol: "2,6-di-tert-butyl-4-(aminomethyl)phenol hydrochloride",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "3",
    pmids: "17960583,20452611,22609401",
  },
  {
    id: "5243",
    id_polifenol: "5875",
    polifenol: "panduratin A",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "17896818",
  },
  {
    id: "5244",
    id_polifenol: "4639",
    polifenol: "aromadedrin",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "18176909",
  },
  {
    id: "5245",
    id_polifenol: "7658",
    polifenol: "quercetin 3'-O-glucoside",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "2",
    pmids: "26820381,26109002",
  },
  {
    id: "5246",
    id_polifenol: "6287",
    polifenol: "neohesperidin",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "19919125",
  },
  {
    id: "5247",
    id_polifenol: "5542",
    polifenol: "delphinidin 3-O-glucopyranoside",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "27485636",
  },
  {
    id: "5248",
    id_polifenol: "1106",
    polifenol: "1,1-bis(3'-indolyl)-1-(4-hydroxyphenyl)methane",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "4",
    pmids: "24515801,20660371,25099012,28418095",
  },
  {
    id: "5249",
    id_polifenol: "5841",
    polifenol: "2',6'-dihydroxy-4'-methoxychalcone",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "17896818",
  },
  {
    id: "5250",
    id_polifenol: "5063",
    polifenol: "4',7-dihydroxy-3'-methoxy-5'-prenylflavanone",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "28914822",
  },
  {
    id: "5251",
    id_polifenol: "3606",
    polifenol:
      "5-(3-methoxy-4-((4-methoxybenzyl)oxy)benzyl)pyrimidine-2,4-diamine",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "28092668",
  },
  {
    id: "5252",
    id_polifenol: "5814",
    polifenol: "2',4'-dihydroxychalcone",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "19689125",
  },
  {
    id: "5253",
    id_polifenol: "2159",
    polifenol: "2,3-dihydroxybenzoic acid",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "19101573",
  },
  {
    id: "5254",
    id_polifenol: "6492",
    polifenol: "3(2H)-isoflavene",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "21666438",
  },
  {
    id: "5255",
    id_polifenol: "18",
    polifenol: "Hexachlorophene",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "21196815",
  },
  {
    id: "5256",
    id_polifenol: "5963",
    polifenol: "3,5,2',4'-tetrahydroxychalcone",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "20699088",
  },
  {
    id: "5257",
    id_polifenol: "1262",
    polifenol: "4-dodecylaminophenol",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "22440084",
  },
  {
    id: "5258",
    id_polifenol: "4135",
    polifenol: "orcinol",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "12487331",
  },
  {
    id: "5259",
    id_polifenol: "2290",
    polifenol: "lobaric acid",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "15549672",
  },
  {
    id: "5260",
    id_polifenol: "4629",
    polifenol: "5,7,2'-trihydroxyflavone",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "22889981",
  },
  {
    id: "5261",
    id_polifenol: "1961",
    polifenol: "tri-o-cresyl phosphate",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "15451303",
  },
  {
    id: "5262",
    id_polifenol: "4149",
    polifenol: "adipostatin A",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "21751842",
  },
  {
    id: "5263",
    id_polifenol: "5910",
    polifenol: "3'-formyl-4',6'-dihydroxy-2'-methoxy-5'-methylchalcone",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "17430639",
  },
  {
    id: "5264",
    id_polifenol: "1642",
    polifenol: "FLLL 32",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "26887043",
  },
  {
    id: "5265",
    id_polifenol: "4274",
    polifenol: "O 1602",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "24355564",
  },
  {
    id: "5266",
    id_polifenol: "1161",
    polifenol: "phenyl acetate",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "28353633",
  },
  {
    id: "5267",
    id_polifenol: "3628",
    polifenol: "1,1-bis(3'-indolyl)-1-(p-anisyl)methane",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "19584258",
  },
  {
    id: "5268",
    id_polifenol: "1634",
    polifenol: "FLLL-12 compound",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "19384191",
  },
  {
    id: "5269",
    id_polifenol: "7027",
    polifenol: "chrysosplenol D",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "21469236",
  },
  {
    id: "5270",
    id_polifenol: "4224",
    polifenol: "orsellinic acid",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "21226488",
  },
  {
    id: "5271",
    id_polifenol: "2760",
    polifenol: "2-methoxybenzoic acid",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "24216090",
  },
  {
    id: "5272",
    id_polifenol: "329",
    polifenol: "2,6-dichloro-4-nitrophenol",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "8055652",
  },
  {
    id: "5273",
    id_polifenol: "4102",
    polifenol: "ardisiphenol D",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "2",
    pmids: "21751842,24392814",
  },
  {
    id: "5274",
    id_polifenol: "2402",
    polifenol: "digalloylresveratrol",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "2",
    pmids: "23943154,22132974",
  },
  {
    id: "5275",
    id_polifenol: "4203",
    polifenol: "methyl orsellinate",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "12487331",
  },
  {
    id: "5276",
    id_polifenol: "4219",
    polifenol: "baeomycesic acid",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "15549672",
  },
  {
    id: "5277",
    id_polifenol: "5409",
    polifenol: "5-hydroxy-7-methoxyflavone",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "26197535",
  },
  {
    id: "5278",
    id_polifenol: "6153",
    polifenol: "narirutin",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "29346059",
  },
  {
    id: "5279",
    id_polifenol: "7179",
    polifenol: "swertisin",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "23453831",
  },
  {
    id: "5280",
    id_polifenol: "1088",
    polifenol: "1-(3,5-dihydroxyphenyl)heptan-1-one",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "26927613",
  },
  {
    id: "5281",
    id_polifenol: "1736",
    polifenol: "4-ethylguaiacol",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "28353633",
  },
  {
    id: "5282",
    id_polifenol: "4269",
    polifenol: "2-methoxy-4-hydroxy-6-pentadecyl-benzene-1-O-acetate",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "21751842",
  },
  {
    id: "5283",
    id_polifenol: "4196",
    polifenol: "ardisiphenol A",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "24392814",
  },
  {
    id: "5284",
    id_polifenol: "5800",
    polifenol: "chalcone epoxide",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "20726006",
  },
  {
    id: "5285",
    id_polifenol: "7574",
    polifenol: "quercimeritrin",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "26109002",
  },
  {
    id: "5286",
    id_polifenol: "5863",
    polifenol: "nicolaioidesin C",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "28099006",
  },
  {
    id: "5287",
    id_polifenol: "7779",
    polifenol: "cristacarpin",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "27246693",
  },
  {
    id: "5288",
    id_polifenol: "6881",
    polifenol: "triphendiol",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "2",
    pmids: "21666438,19278301",
  },
  {
    id: "5289",
    id_polifenol: "4602",
    polifenol: "sigmoidin B",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "28914822",
  },
  {
    id: "5290",
    id_polifenol: "5899",
    polifenol: "2',4',6'-tris(methoxymethoxy) chalcone",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "21778460",
  },
  {
    id: "5291",
    id_polifenol: "799",
    polifenol: "calix(6)arene",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "23872419",
  },
  {
    id: "5292",
    id_polifenol: "4120",
    polifenol: "STA-12-8666",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "27779106",
  },
  {
    id: "5293",
    id_polifenol: "3939",
    polifenol: "IC 261",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "18203806",
  },
  {
    id: "5294",
    id_polifenol: "7873",
    polifenol: "isopanduratin A1",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "28099006",
  },
  {
    id: "5295",
    id_polifenol: "4997",
    polifenol: "kaempferol 3-O-(2''-O-glucosyl)rutinoside",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "23453831",
  },
  {
    id: "5296",
    id_polifenol: "6174",
    polifenol: "(2S)-8-formyl-5-hydroxy-7-methoxy-6-methylflavanone",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "17430639",
  },
  {
    id: "5297",
    id_polifenol: "3045",
    polifenol: "3-O-(2'-acetoxy)benzoyl-2-glucopyranose",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "22494617",
  },
  {
    id: "5298",
    id_polifenol: "4954",
    polifenol: "chrysoplenetin",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "21469236",
  },
  {
    id: "5299",
    id_polifenol: "4826",
    polifenol:
      "5,4'-dihydroxy-(3'',4''-dihydro-3'',4''-dihydroxy)-2'',2''-dimethylpyrano(5'',6''-7,8)flavone",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "19689125",
  },
  {
    id: "5300",
    id_polifenol: "4730",
    polifenol: "5-methoxy-6-methylflavan-7-ol",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "19689125",
  },
  {
    id: "5301",
    id_polifenol: "3405",
    polifenol: "3,4,5-tribromo-6-methoxy-2-(2',4'-dibromophenoxy)phenol",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "27449332",
  },
  {
    id: "5302",
    id_polifenol: "570",
    polifenol: "3,5-dibromo-2-(2,4-dibromophenoxy)phenol",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "27449332",
  },
  {
    id: "5303",
    id_polifenol: "5261",
    polifenol: "(2R,3R)-3,5-dihydroxy-7-methoxyflavanone 3-(2-methyl)butyrate",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "20307087",
  },
  {
    id: "5304",
    id_polifenol: "5260",
    polifenol:
      "(7''R)-8-(1-(4'-hydroxy-3'-methoxyphenyl)prop-2-en-1-yl)chrysin",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "20307087",
  },
  {
    id: "5305",
    id_polifenol: "5259",
    polifenol:
      "(7''R)-8-(1-(4'-hydroxy-3'-methoxyphenyl)prop-2-en-1-yl)galangin",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "20307087",
  },
  {
    id: "5306",
    id_polifenol: "5862",
    polifenol: "nicolaioidesin B",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "17896818",
  },
  {
    id: "5307",
    id_polifenol: "6239",
    polifenol:
      "(2R,3R)-6-(1-(4'-hydroxy-3'-methoxyphenyl)prop-2-en-1-yl)pinobanksin",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "21881271",
  },
  {
    id: "5308",
    id_polifenol: "6240",
    polifenol:
      "(2R,3R)-6-(1-(4'-hydroxy-3'-methoxyphenyl)prop-2-en-1-yl)pinobanksin 3-acetate",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "21881271",
  },
  {
    id: "5309",
    id_polifenol: "2934",
    polifenol:
      "5-amino-2-hydroxybenzoic acid 4-(5-thioxo-5H-(1,2)dithiol-3yl)phenyl ester",
    id_cancer: "507",
    cancer: "Pancreatic Cancer",
    quant: "1",
    pmids: "26995527",
  },
  {
    id: "5310",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "119",
    pmids:
      "26297979,26023926,22759961,12065710,16497434,17977562,28554870,26639663,24093108,25146759,22138516,25799286,16137700,26998046,26330757,26805810,22239491,20397728,27351825,25913928,15537821,18930780,23762124,16949556,27347031,29258000,29459717,24348728,22928834,22070850,26171782,10086329,28545670,22193240,18295200,26336580,19686724,25414768,22234339,17182007,23435946,22400806,24969548,15659838,28101184,11731918,21319773,20546946,23612420,24916321,22083996,28774308,22419427,27713960,26327408,23453831,23460110,24679441,26171689,20522970,29725354,29846389,24417898,22303922,25053100,28461245,26801102,27206337,16702314,26236111,27097427,25026504,28197210,29382154,21810460,25340513,20450988,23442980,23735482,23506988,29660467,20804824,27648736,25612451,27261558,29951107,26344038,28753918,19135038,15974445,25027933,28350048,21104603,18603770,24681039,26546527,26081168,28256654,22137267,29389569,14654167,24397781,23536316,29497376,11543732,20576412,21353543,10771202,29725269,27160577,28928906,21296144,11791668,25821823,25840808,28067837,24260470,26692456,25746403",
  },
  {
    id: "5311",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "36",
    pmids:
      "24716415,15073046,12628514,27504095,22443687,22197802,27933995,25998190,17158886,25502175,15351317,29246079,27473378,20372820,28098433,22356159,25891482,19188055,29028430,17052672,17436566,24741294,16715036,16309195,27381602,26457790,21842651,21989712,18302884,21071447,16313712,28263565,27405665,19744468,22687757,25490740",
  },
  {
    id: "5312",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "39",
    pmids:
      "12433185,17451540,22928834,29465116,10644043,18509698,24127072,26586942,11558561,23394584,20718469,9868178,22083996,28774308,29337349,22419427,15761374,22611435,27190746,24979133,21372424,21810460,27381602,23506988,27257341,19157828,29903983,19202285,28942652,27009373,24877688,21485870,14572610,27867403,11020457,29663159,15135313,24195750,25490740",
  },
  {
    id: "5313",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "31",
    pmids:
      "22842465,9092580,19778233,28983588,10712238,18566751,15351317,19473344,21842421,19801662,21963496,23820591,12867430,11360925,11369514,9815112,10850941,9852105,12028827,10453032,29285098,10029520,12504894,12509925,16497166,25684183,23872072,23302779,10068590,11997234,25662684",
  },
  {
    id: "5314",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "21",
    pmids:
      "9092580,12628514,16271352,12858016,28192731,16434028,23820591,21946955,16254887,20798528,23300870,10811015,20460704,28257665,15456640,10771202,9811314,29761425,8769628,15630251,25127153",
  },
  {
    id: "5315",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "41",
    pmids:
      "22759961,12628514,26171782,22245632,10086329,28545670,16434028,11731918,28774308,22419427,27178629,29725354,26801102,21810460,25340513,23442980,26098998,23735482,26634045,26457790,27648736,26344038,24660615,19135038,15974445,18603770,24681039,26546527,26081168,22358425,29497376,11543732,23727892,21353543,27076745,28928906,25580686,11020457,29567277,24260470,24195750",
  },
  {
    id: "5316",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "16",
    pmids:
      "12628514,12433185,17451540,10644043,22819551,28545670,26586942,20718469,9868178,28766684,16997910,24953562,15974445,21485870,24749396,15630251",
  },
  {
    id: "5317",
    id_polifenol: "2167",
    polifenol: "phenolic acid",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "43",
    pmids:
      "22343417,19183880,20397728,22070850,29465116,24641487,23352929,20138247,23435946,22083996,28774308,29337349,16309673,22419427,27713960,15288590,29784301,23453831,22356159,27190746,28694749,28962351,27463712,20102205,20478352,25340513,23442980,26098998,19500975,28534588,24681039,26546527,26081168,29389569,20951562,21071447,23750815,14624630,23727892,27160577,29432856,25840808,29710781",
  },
  {
    id: "5318",
    id_polifenol: "49",
    polifenol: "Aspirin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "15",
    pmids:
      "12628514,17010317,15746434,29285098,26794215,12576442,19117331,27886112,28959630,28036129,24418973,23918470,17328244,12451498,21640980",
  },
  {
    id: "5319",
    id_polifenol: "109",
    polifenol: "Catechin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "13",
    pmids:
      "12628514,26805810,22928834,29465116,23394584,28774308,29337349,15761374,23453831,16997910,15974445,26546527,26081168",
  },
  {
    id: "5320",
    id_polifenol: "125",
    polifenol: "Isoflavones",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "14",
    pmids:
      "21415528,16271352,21147093,28192731,23597450,21946955,16254887,21735273,27904045,25184943,23300870,24324516,20460704,15456640",
  },
  {
    id: "5321",
    id_polifenol: "110",
    polifenol: "Chalcones",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "16",
    pmids:
      "22155221,21268076,23727179,15642415,19183880,29199487,27469142,29630947,16650843,25414768,16183703,26068427,25258510,24369884,22358425,29518899",
  },
  {
    id: "5322",
    id_polifenol: "3089",
    polifenol: "1,1-diphenyl-2-picrylhydrazyl",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "36",
    pmids:
      "29933606,12628514,26805810,17294687,22210035,20527891,22928834,22070850,19107823,29771951,23867243,25990850,22083996,22419427,28583007,23453831,25753739,28376770,25978952,12865969,17436566,29216958,29382154,21810460,23506988,26546527,26237121,17936865,28581877,21989712,19627218,16182479,29725269,28482262,27748923,29710781",
  },
  {
    id: "5323",
    id_polifenol: "114",
    polifenol: "Apigenin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "7",
    pmids: "16750176,18038911,19686724,24979133,26098998,15974445,22137267",
  },
  {
    id: "5324",
    id_polifenol: "113",
    polifenol: "Flavones",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "11",
    pmids:
      "16750176,29758489,23131135,29771951,28294989,23160683,24979133,16702314,27057196,22137267,26712724",
  },
  {
    id: "5325",
    id_polifenol: "38",
    polifenol: "Gallic Acid",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "16",
    pmids:
      "16919832,26805810,26412258,22070850,29465116,28774308,26417317,23442980,29957472,17936865,27916090,27076745,29263630,27867403,29567277,24195750",
  },
  {
    id: "5326",
    id_polifenol: "117",
    polifenol: "Luteolin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "16",
    pmids:
      "17977562,17294687,20397728,24503036,21513709,28274893,28101184,23460110,29725354,25933972,16702314,26236111,26098998,15974445,24681039,22137267",
  },
  {
    id: "5327",
    id_polifenol: "1",
    polifenol: "Phenols",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "15",
    pmids:
      "12628514,29201203,24916321,24786915,15761374,22356159,28962351,20102205,27196881,28008813,25792646,24681039,28659738,17727652,15272403",
  },
  {
    id: "5328",
    id_polifenol: "105",
    polifenol: "Anthocyanins",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "11",
    pmids:
      "28989571,28812425,29337349,29093336,26509161,26028086,21735273,24565673,26023864,25079118,28137607",
  },
  {
    id: "5329",
    id_polifenol: "7235",
    polifenol: "silybin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "6",
    pmids: "25032222,29459717,21898547,23115104,28350048,10771202",
  },
  {
    id: "5330",
    id_polifenol: "129",
    polifenol: "Rotenone",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "5",
    pmids: "12628514,16434028,22401764,29906494,29658572",
  },
  {
    id: "5331",
    id_polifenol: "121",
    polifenol: "Kaempferols",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "14",
    pmids:
      "20397728,29771951,16434028,11731918,29725354,29846389,28694749,19500975,22524841,21353543,24200240,25580686,29567277,28067837",
  },
  {
    id: "5332",
    id_polifenol: "871",
    polifenol: "ABT-737",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "26024774",
  },
  {
    id: "5333",
    id_polifenol: "6451",
    polifenol: "daidzein",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "10",
    pmids:
      "29933606,16271352,28545670,28192731,16434028,21946955,16254887,25184943,28257665,15456640",
  },
  {
    id: "5334",
    id_polifenol: "6065",
    polifenol: "baicalein",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "6",
    pmids: "16497434,27347031,23246826,17182007,24161485,21296144",
  },
  {
    id: "5335",
    id_polifenol: "7",
    polifenol: "Capsaicin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "2",
    pmids: "15304360,25603234",
  },
  {
    id: "5336",
    id_polifenol: "4634",
    polifenol: "alvocidib",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "21204955",
  },
  {
    id: "5337",
    id_polifenol: "120",
    polifenol: "Flavonols",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "10",
    pmids:
      "26297979,29470957,22210035,29480383,28192731,16434028,24417898,24524902,18603770,25580686",
  },
  {
    id: "5338",
    id_polifenol: "4522",
    polifenol: "chrysin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "5",
    pmids: "24979133,16702314,15974445,23536316,28067837",
  },
  {
    id: "5339",
    id_polifenol: "123",
    polifenol: "Rutin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "14",
    pmids:
      "17294687,22070850,23867243,29846389,24417898,26801102,23442980,26634045,24681039,28942652,23750815,29432856,28928906,24195750",
  },
  {
    id: "5340",
    id_polifenol: "6062",
    polifenol: "naringenin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "7",
    pmids: "18930780,12017334,28753918,19135038,15974445,24681039,23727892",
  },
  {
    id: "5341",
    id_polifenol: "39",
    polifenol: "Hydrolyzable Tannins",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "3",
    pmids: "26805810,29263630,23727252",
  },
  {
    id: "5342",
    id_polifenol: "130",
    polifenol: "Proanthocyanidins",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "3",
    pmids: "11558561,20939997,21735273",
  },
  {
    id: "5343",
    id_polifenol: "35",
    polifenol: "Hydroquinones",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "24786915",
  },
  {
    id: "5344",
    id_polifenol: "111",
    polifenol: "Flavanones",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "5",
    pmids: "18057724,26994999,12017334,28428136,27529198",
  },
  {
    id: "5345",
    id_polifenol: "4502",
    polifenol: "fisetin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "8",
    pmids:
      "29758489,22239491,28545670,26336580,25973292,22234339,24524902,15974445",
  },
  {
    id: "5346",
    id_polifenol: "6",
    polifenol: "Catechols",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "28694749",
  },
  {
    id: "5347",
    id_polifenol: "25",
    polifenol: "Butylated Hydroxytoluene",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "5",
    pmids: "23453831,23442980,27196881,25792646,1933865",
  },
  {
    id: "5348",
    id_polifenol: "75",
    polifenol: "Butylated Hydroxyanisole",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "2",
    pmids: "26381601,25792646",
  },
  {
    id: "5349",
    id_polifenol: "15",
    polifenol: "Masoprocol",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "19133137",
  },
  {
    id: "5350",
    id_polifenol: "6087",
    polifenol: "wogonin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "9",
    pmids:
      "24901054,16497434,25913928,16949556,23246826,23219337,26712724,11791668,12451498",
  },
  {
    id: "5351",
    id_polifenol: "4519",
    polifenol: "myricetin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "5",
    pmids: "22795564,28808377,26098998,27068250,24681039",
  },
  {
    id: "5352",
    id_polifenol: "4515",
    polifenol: "baicalin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "5",
    pmids: "16497434,23246826,25239813,18191816,21296144",
  },
  {
    id: "5353",
    id_polifenol: "4500",
    polifenol: "procyanidin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "24260615",
  },
  {
    id: "5354",
    id_polifenol: "5608",
    polifenol: "epicatechin gallate",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "28545670",
  },
  {
    id: "5355",
    id_polifenol: "1356",
    polifenol: "gingerol",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "29508185",
  },
  {
    id: "5356",
    id_polifenol: "54",
    polifenol: "Salicylic Acid",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "3",
    pmids: "23352929,22292506,21555977",
  },
  {
    id: "5357",
    id_polifenol: "98",
    polifenol: "Propofol",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "4",
    pmids: "24008596,21408125,26614998,29073894",
  },
  {
    id: "5358",
    id_polifenol: "5607",
    polifenol: "gallocatechol",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "15974445",
  },
  {
    id: "5359",
    id_polifenol: "5578",
    polifenol: "alpha-naphthoflavone",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "22837390",
  },
  {
    id: "5360",
    id_polifenol: "44",
    polifenol: "Salicylates",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "28036129",
  },
  {
    id: "5361",
    id_polifenol: "4559",
    polifenol: "theaflavin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "5",
    pmids: "12433185,10644043,26586942,14723964,27871911",
  },
  {
    id: "5362",
    id_polifenol: "5808",
    polifenol: "isoliquiritigenin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "4",
    pmids: "18295200,27097427,25026504,19169644",
  },
  {
    id: "5363",
    id_polifenol: "2344",
    polifenol: "methyl gallate",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "29465116",
  },
  {
    id: "5364",
    id_polifenol: "4708",
    polifenol: "xanthohumol",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "19634869",
  },
  {
    id: "5365",
    id_polifenol: "47",
    polifenol: "Mesalamine",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "28036129",
  },
  {
    id: "5366",
    id_polifenol: "2284",
    polifenol: "rosmarinic acid",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "4",
    pmids: "20397728,23514231,28659738,29710781",
  },
  {
    id: "5367",
    id_polifenol: "112",
    polifenol: "Hesperidin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "3",
    pmids: "28753918,28942652,23750815",
  },
  {
    id: "5368",
    id_polifenol: "6455",
    polifenol: "nobiletin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "4",
    pmids: "11016629,28892456,11216485,16606336",
  },
  {
    id: "5369",
    id_polifenol: "4513",
    polifenol: "galangin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "3",
    pmids: "23160683,15974445,25580686",
  },
  {
    id: "5370",
    id_polifenol: "6063",
    polifenol: "naringin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "6",
    pmids: "16137700,23442980,28753918,24681039,28942652,23750815",
  },
  {
    id: "5371",
    id_polifenol: "1380",
    polifenol: "shogaol",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "23899529",
  },
  {
    id: "5372",
    id_polifenol: "2158",
    polifenol: "protocatechuic acid",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "3",
    pmids: "28587764,27013799,25446641",
  },
  {
    id: "5373",
    id_polifenol: "6273",
    polifenol: "hesperetin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "5",
    pmids: "26994999,12017334,28428136,17436566,28942652",
  },
  {
    id: "5374",
    id_polifenol: "1613",
    polifenol: "demethoxycurcumin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "18449507",
  },
  {
    id: "5375",
    id_polifenol: "93",
    polifenol: "Phloroglucinol",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "4",
    pmids: "21963823,22981504,20667461,25183272",
  },
  {
    id: "5376",
    id_polifenol: "6454",
    polifenol: "formononetin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "2",
    pmids: "16254887,15456640",
  },
  {
    id: "5377",
    id_polifenol: "81",
    polifenol: "Fenofibrate",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "18356826",
  },
  {
    id: "5378",
    id_polifenol: "7550",
    polifenol: "3-methylquercetin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "2",
    pmids: "25799286,25821823",
  },
  {
    id: "5379",
    id_polifenol: "6461",
    polifenol: "acacetin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "7",
    pmids: "24901054,25913928,16949556,24979133,20804824,21619922,26712724",
  },
  {
    id: "5380",
    id_polifenol: "1611",
    polifenol: "bis(4-hydroxycinnamoyl)methane",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "2",
    pmids: "18449507,19188055",
  },
  {
    id: "5381",
    id_polifenol: "119",
    polifenol: "Silymarin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "12065710",
  },
  {
    id: "5382",
    id_polifenol: "126",
    polifenol: "Coumestrol",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "28192731",
  },
  {
    id: "5383",
    id_polifenol: "55",
    polifenol: "Sodium Salicylate",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "17010317",
  },
  {
    id: "5384",
    id_polifenol: "5806",
    polifenol: "butein",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "3",
    pmids: "15351711,21372424,24877688",
  },
  {
    id: "5385",
    id_polifenol: "108",
    polifenol: "Biflavonoids",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "4",
    pmids: "22416643,16651732,10588517,29673161",
  },
  {
    id: "5386",
    id_polifenol: "5509",
    polifenol: "cyanidin 3-O-glucoside",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "3",
    pmids: "16309673,24565673,26023864",
  },
  {
    id: "5387",
    id_polifenol: "969",
    polifenol: "3,4-dihydroxyphenacyl caffeate phenylpropanoid ester",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "2",
    pmids: "29660467,27013799",
  },
  {
    id: "5388",
    id_polifenol: "6463",
    polifenol: "puerarin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "4",
    pmids: "16254887,22401764,27904045,28937704",
  },
  {
    id: "5389",
    id_polifenol: "5819",
    polifenol: "licochalcone A",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "2",
    pmids: "23708096,22400806",
  },
  {
    id: "5390",
    id_polifenol: "94",
    polifenol: "Phloretin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "2",
    pmids: "25229655,25929446",
  },
  {
    id: "5391",
    id_polifenol: "4560",
    polifenol: "icariin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "5",
    pmids: "20347053,20686223,20519138,24969548,19526759",
  },
  {
    id: "5392",
    id_polifenol: "5488",
    polifenol: "cyanidin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "26023864",
  },
  {
    id: "5393",
    id_polifenol: "4640",
    polifenol: "5,7-dihydroxy-6-methoxy-2-phenylchromen-4-one",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "5",
    pmids: "27347031,25247252,22949302,24161485,26712724",
  },
  {
    id: "5394",
    id_polifenol: "132",
    polifenol: "Equol",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "16288994",
  },
  {
    id: "5395",
    id_polifenol: "1995",
    polifenol: "2-tert-butylhydroquinone",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "24092518",
  },
  {
    id: "5396",
    id_polifenol: "6482",
    polifenol: "tangeretin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "23750815",
  },
  {
    id: "5397",
    id_polifenol: "89",
    polifenol: "Vanillic Acid",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "5",
    pmids: "25667964,25753739,28257665,25446641,23727892",
  },
  {
    id: "5398",
    id_polifenol: "99",
    polifenol: "Pyrogallol",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "2",
    pmids: "28476594,23442980",
  },
  {
    id: "5399",
    id_polifenol: "452",
    polifenol: "acteoside",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "2",
    pmids: "26453510,24324641",
  },
  {
    id: "5400",
    id_polifenol: "100",
    polifenol: "Resorcinols",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "18761814",
  },
  {
    id: "5401",
    id_polifenol: "1866",
    polifenol: "4,6-dinitro-o-cresol",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "12637578",
  },
  {
    id: "5402",
    id_polifenol: "4486",
    polifenol: "amentoflavone",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "2",
    pmids: "22245632,27178629",
  },
  {
    id: "5403",
    id_polifenol: "5850",
    polifenol: "cardamonin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "3",
    pmids: "21830094,16650843,16183703",
  },
  {
    id: "5404",
    id_polifenol: "118",
    polifenol: "Flavonolignans",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "2",
    pmids: "21898547,25667964",
  },
  {
    id: "5405",
    id_polifenol: "7544",
    polifenol: "quercitrin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "26801102",
  },
  {
    id: "5406",
    id_polifenol: "300",
    polifenol: "rhodioloside",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "27834881",
  },
  {
    id: "5407",
    id_polifenol: "7912",
    polifenol: "7,9,2',4'-tetrahydroxy-8-isopentenyl-5-methoxychalcone",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "25027933",
  },
  {
    id: "5408",
    id_polifenol: "4767",
    polifenol: "flavan-3-ol",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "11558561",
  },
  {
    id: "5409",
    id_polifenol: "2475",
    polifenol: "6-O-galloylglucose",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "11558561",
  },
  {
    id: "5410",
    id_polifenol: "92",
    polifenol: "Triclosan",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "15288590",
  },
  {
    id: "5411",
    id_polifenol: "6097",
    polifenol: "8-prenylnaringenin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "19686724",
  },
  {
    id: "5412",
    id_polifenol: "2447",
    polifenol: "beta-penta-O-galloyl-glucose",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "2",
    pmids: "26805810,10644043",
  },
  {
    id: "5413",
    id_polifenol: "6068",
    polifenol: "pinocembrin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "21830094",
  },
  {
    id: "5414",
    id_polifenol: "6576",
    polifenol: "5,7,4'-trihydroxyflavone",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "23160683",
  },
  {
    id: "5415",
    id_polifenol: "6086",
    polifenol: "liquiritigenin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "3",
    pmids: "23246826,22809034,23727892",
  },
  {
    id: "5416",
    id_polifenol: "1616",
    polifenol: "tetrahydrocurcumin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "3",
    pmids: "15073046,25502175,20372820",
  },
  {
    id: "5417",
    id_polifenol: "59",
    polifenol: "Dinitrophenols",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "2",
    pmids: "27679575,12865969",
  },
  {
    id: "5418",
    id_polifenol: "4516",
    polifenol: "diosmetin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "17294687",
  },
  {
    id: "5419",
    id_polifenol: "2328",
    polifenol: "syringic acid",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "4",
    pmids: "29465116,23442980,25821492,24200240",
  },
  {
    id: "5420",
    id_polifenol: "7296",
    polifenol: "dihydromyricetin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "26171689",
  },
  {
    id: "5421",
    id_polifenol: "40",
    polifenol: "Propyl Gallate",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "21112369",
  },
  {
    id: "5422",
    id_polifenol: "36",
    polifenol: "Hydroxybenzoates",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "29382154",
  },
  {
    id: "5423",
    id_polifenol: "5455",
    polifenol: "theaflavin-3,3'-digallate",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "3",
    pmids: "12433185,10644043,27871911",
  },
  {
    id: "5424",
    id_polifenol: "2490",
    polifenol: "punicalagin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "24473904",
  },
  {
    id: "5425",
    id_polifenol: "5815",
    polifenol: "dibenzoylmethane",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "15073046",
  },
  {
    id: "5426",
    id_polifenol: "637",
    polifenol: "glabridin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "2",
    pmids: "15537821,16354764",
  },
  {
    id: "5427",
    id_polifenol: "6301",
    polifenol: "3-methoxyflavone",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "18725283",
  },
  {
    id: "5428",
    id_polifenol: "1810",
    polifenol: "heminordihydroguaiaretic acid",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "19133137",
  },
  {
    id: "5429",
    id_polifenol: "6477",
    polifenol: "hispidulin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "2",
    pmids: "24417898,29200737",
  },
  {
    id: "5430",
    id_polifenol: "7198",
    polifenol: "homoorientin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "3",
    pmids: "28243356,28928906,26692456",
  },
  {
    id: "5431",
    id_polifenol: "128",
    polifenol: "Pterocarpans",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "26241494",
  },
  {
    id: "5432",
    id_polifenol: "7557",
    polifenol: "rhamnetin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "24397781",
  },
  {
    id: "5433",
    id_polifenol: "6456",
    polifenol: "daidzin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "2",
    pmids: "16254887,24324516",
  },
  {
    id: "5434",
    id_polifenol: "1353",
    polifenol: "protocatechualdehyde",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "23506988",
  },
  {
    id: "5435",
    id_polifenol: "4501",
    polifenol: "tricin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "2",
    pmids: "25667964,25671061",
  },
  {
    id: "5436",
    id_polifenol: "7853",
    polifenol: "Grape Seed Proanthocyanidins",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "26708200",
  },
  {
    id: "5437",
    id_polifenol: "4304",
    polifenol: "5-7-oxo-zeaenol",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "20014292",
  },
  {
    id: "5438",
    id_polifenol: "7612",
    polifenol: "quercetin 3-O-glucuronide",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "2",
    pmids: "26805810,17294687",
  },
  {
    id: "5439",
    id_polifenol: "7775",
    polifenol: "glyceollin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "22246209",
  },
  {
    id: "5440",
    id_polifenol: "5796",
    polifenol: "dihydrochalcone",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "15642415",
  },
  {
    id: "5441",
    id_polifenol: "6066",
    polifenol: "eriodictyol",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "2",
    pmids: "26344038,26081168",
  },
  {
    id: "5442",
    id_polifenol: "353",
    polifenol: "sesamol",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "19939906",
  },
  {
    id: "5443",
    id_polifenol: "3019",
    polifenol: "nitroaspirin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "23918470",
  },
  {
    id: "5444",
    id_polifenol: "6452",
    polifenol: "chrysoeriol",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "22137267",
  },
  {
    id: "5445",
    id_polifenol: "680",
    polifenol: "xanthorrhizol",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "12086400",
  },
  {
    id: "5446",
    id_polifenol: "5794",
    polifenol: "2'-hydroxychalcone",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "3",
    pmids: "15041472,15642415,16650843",
  },
  {
    id: "5447",
    id_polifenol: "7377",
    polifenol: "astragalin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "3",
    pmids: "26805810,19500975,21353543",
  },
  {
    id: "5448",
    id_polifenol: "1672",
    polifenol: "B19 monocarbonyl curcumin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "24741294",
  },
  {
    id: "5449",
    id_polifenol: "4715",
    polifenol: "ampelopsin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "22193240",
  },
  {
    id: "5450",
    id_polifenol: "2448",
    polifenol: "ellagitannin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "26805810",
  },
  {
    id: "5451",
    id_polifenol: "7156",
    polifenol: "scutellarein",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "26330757",
  },
  {
    id: "5452",
    id_polifenol: "2450",
    polifenol: "Geraniin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "10644043",
  },
  {
    id: "5453",
    id_polifenol: "6129",
    polifenol: "wogonoside",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "23612420",
  },
  {
    id: "5454",
    id_polifenol: "6112",
    polifenol: "alpinetin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "2",
    pmids: "21830094,27321991",
  },
  {
    id: "5455",
    id_polifenol: "6770",
    polifenol: "5-hydroxy-3,6,7,8,3',4'-hexamethoxyflavone",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "24481726",
  },
  {
    id: "5456",
    id_polifenol: "2283",
    polifenol: "depsidone",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "2",
    pmids: "15386197,24041314",
  },
  {
    id: "5457",
    id_polifenol: "711",
    polifenol: "ascochlorin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "2",
    pmids: "26399466,28207754",
  },
  {
    id: "5458",
    id_polifenol: "6457",
    polifenol: "salvigenin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "2",
    pmids: "20804824,21375325",
  },
  {
    id: "5459",
    id_polifenol: "2697",
    polifenol: "4-trifluoromethylsalicylic acid",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "18951802",
  },
  {
    id: "5460",
    id_polifenol: "12",
    polifenol: "Guaiacol",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "3",
    pmids: "15761374,22356159,17436566",
  },
  {
    id: "5461",
    id_polifenol: "7741",
    polifenol: "biochanin A",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "2",
    pmids: "21147093,21946955",
  },
  {
    id: "5462",
    id_polifenol: "2343",
    polifenol: "ethyl gallate",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "2",
    pmids: "26417317,26081168",
  },
  {
    id: "5463",
    id_polifenol: "4479",
    polifenol: "morin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "2",
    pmids: "26297979,14654167",
  },
  {
    id: "5464",
    id_polifenol: "2364",
    polifenol: "theaflavine gallate",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "2",
    pmids: "12433185,10644043",
  },
  {
    id: "5465",
    id_polifenol: "4578",
    polifenol: "5,7-dimethoxyflavone",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "2",
    pmids: "26704713,21251970",
  },
  {
    id: "5466",
    id_polifenol: "6100",
    polifenol: "pinostrobin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "3",
    pmids: "22495442,24680612,20576412",
  },
  {
    id: "5467",
    id_polifenol: "347",
    polifenol: "4-nitrophenyl",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "28801098",
  },
  {
    id: "5468",
    id_polifenol: "5875",
    polifenol: "panduratin A",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "2",
    pmids: "15971119,16497706",
  },
  {
    id: "5469",
    id_polifenol: "7199",
    polifenol: "luteolin-7-glucoside",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "2",
    pmids: "17294687,23750815",
  },
  {
    id: "5470",
    id_polifenol: "7140",
    polifenol: "isovitexin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "3",
    pmids: "15965085,20576412,28928906",
  },
  {
    id: "5471",
    id_polifenol: "428",
    polifenol: "2,2'-bisphenol F",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "14723964",
  },
  {
    id: "5472",
    id_polifenol: "7453",
    polifenol: "kaempferol-3-O-glucoside",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "29470957",
  },
  {
    id: "5473",
    id_polifenol: "1678",
    polifenol: "2-methoxyestrone",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "16619269",
  },
  {
    id: "5474",
    id_polifenol: "4639",
    polifenol: "aromadedrin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "25821492",
  },
  {
    id: "5475",
    id_polifenol: "4782",
    polifenol: "kurarinone",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "20522970",
  },
  {
    id: "5476",
    id_polifenol: "7895",
    polifenol: "flavokawain A",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "23727179",
  },
  {
    id: "5477",
    id_polifenol: "6453",
    polifenol: "cirsimaritin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "3",
    pmids: "28554870,20804824,21375325",
  },
  {
    id: "5478",
    id_polifenol: "4553",
    polifenol: "sulfuretin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "2",
    pmids: "20546946,20450988",
  },
  {
    id: "5479",
    id_polifenol: "7880",
    polifenol: "xanthoangelol",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "24369884",
  },
  {
    id: "5480",
    id_polifenol: "6549",
    polifenol: "7-hydroxy-2',3',4',5',8-pentamethoxyisoflavan",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "15537821",
  },
  {
    id: "5481",
    id_polifenol: "4632",
    polifenol: "ginkgetin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "10588517",
  },
  {
    id: "5482",
    id_polifenol: "839",
    polifenol: "5-iodo-3-((3,5-dibromo-4-hydroxyphenyl)methylene)-2-indolinone",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "19801662",
  },
  {
    id: "5483",
    id_polifenol: "6076",
    polifenol: "vexibinol",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "4",
    pmids: "27111520,27351825,24007739,12017334",
  },
  {
    id: "5484",
    id_polifenol: "4607",
    polifenol: "orientin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "2",
    pmids: "28197210,28928906",
  },
  {
    id: "5485",
    id_polifenol: "6287",
    polifenol: "neohesperidin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "2",
    pmids: "28753918,28942652",
  },
  {
    id: "5486",
    id_polifenol: "4544",
    polifenol: "tiliroside",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "27347085",
  },
  {
    id: "5487",
    id_polifenol: "7437",
    polifenol: "kaempferol-3-O-rutinoside",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "28096884",
  },
  {
    id: "5488",
    id_polifenol: "7422",
    polifenol: "kaempferide",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "25580686",
  },
  {
    id: "5489",
    id_polifenol: "962",
    polifenol: "2,6-di-tert-butyl-4-methylphenol",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "25792646",
  },
  {
    id: "5490",
    id_polifenol: "6684",
    polifenol: "eupafolin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "22083996",
  },
  {
    id: "5491",
    id_polifenol: "5532",
    polifenol: "malvidin-3-glucoside",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "24565673",
  },
  {
    id: "5492",
    id_polifenol: "1754",
    polifenol: "gigantol",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "16924582",
  },
  {
    id: "5493",
    id_polifenol: "7590",
    polifenol: "quercetin-3-O-rutinoside",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "28096884",
  },
  {
    id: "5494",
    id_polifenol: "5841",
    polifenol: "2',6'-dihydroxy-4'-methoxychalcone",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "3",
    pmids: "15041472,16650843,16183703",
  },
  {
    id: "5495",
    id_polifenol: "5063",
    polifenol: "4',7-dihydroxy-3'-methoxy-5'-prenylflavanone",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "12017334",
  },
  {
    id: "5496",
    id_polifenol: "6459",
    polifenol: "genkwanin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "20397728",
  },
  {
    id: "5497",
    id_polifenol: "7290",
    polifenol: "5,2'-dihydroxy-7,8-dimethoxy-dihydroflavonol-3-O-acetate",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "25569518",
  },
  {
    id: "5498",
    id_polifenol: "4764",
    polifenol: "tectochrysin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "28980448",
  },
  {
    id: "5499",
    id_polifenol: "6548",
    polifenol: "artocarpin flavonoid",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "27463712",
  },
  {
    id: "5500",
    id_polifenol: "7614",
    polifenol: "quercetin 3-O-methyl ether",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "2",
    pmids: "11731918,26344038",
  },
  {
    id: "5501",
    id_polifenol: "5303",
    polifenol: "3,6-dihydroxyflavone",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "25165860",
  },
  {
    id: "5502",
    id_polifenol: "5536",
    polifenol: "prodelphinidin B-2 3'-O-gallate",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "2",
    pmids: "11558561,27867403",
  },
  {
    id: "5503",
    id_polifenol: "5525",
    polifenol: "cyanidin 3-rutinoside",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "2",
    pmids: "16309673,26023864",
  },
  {
    id: "5504",
    id_polifenol: "1492",
    polifenol: "hirsutenone",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "28458348",
  },
  {
    id: "5505",
    id_polifenol: "1811",
    polifenol: "terameprocol",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "19133137",
  },
  {
    id: "5506",
    id_polifenol: "3040",
    polifenol:
      "4-(3-thioxo-3H-1,2-dithiol-5-yl)phenyl 2-((4-(nitrooxy)butanoyl)oxy)benzoate",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "23918470",
  },
  {
    id: "5507",
    id_polifenol: "273",
    polifenol: "bis(4-nitrophenyl)phosphate",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "9417127",
  },
  {
    id: "5508",
    id_polifenol: "2868",
    polifenol: "3-hydroxy-4-prenyl-5-methoxystilbene-2-carboxylic acid",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "20576412",
  },
  {
    id: "5509",
    id_polifenol: "5909",
    polifenol: "licochalcone E",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "23708096",
  },
  {
    id: "5510",
    id_polifenol: "6031",
    polifenol: "2',3'-dimethoxyflavanone",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "22495442",
  },
  {
    id: "5511",
    id_polifenol: "7149",
    polifenol: "5,7,4'-trimethylapigenin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "21251970",
  },
  {
    id: "5512",
    id_polifenol: "3245",
    polifenol: "obovatol",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "18241858",
  },
  {
    id: "5513",
    id_polifenol: "1867",
    polifenol: "creosol",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "17436566",
  },
  {
    id: "5514",
    id_polifenol: "1364",
    polifenol: "4-methylcatechol",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "24417898",
  },
  {
    id: "5515",
    id_polifenol: "7289",
    polifenol: "isorhamnetin 3-O-glucoside",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "19627218",
  },
  {
    id: "5516",
    id_polifenol: "6633",
    polifenol: "pomiferin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "20022253",
  },
  {
    id: "5517",
    id_polifenol: "393",
    polifenol: "2,6-di-tert-butylphenol",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "22356159",
  },
  {
    id: "5518",
    id_polifenol: "1869",
    polifenol: "4-cresol",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "28962351",
  },
  {
    id: "5519",
    id_polifenol: "5945",
    polifenol: "2',5'-dimethoxychalcone",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "17320246",
  },
  {
    id: "5520",
    id_polifenol: "6508",
    polifenol: "prunetin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "23597450",
  },
  {
    id: "5521",
    id_polifenol: "7888",
    polifenol: "neoisoliquiritin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "18295200",
  },
  {
    id: "5522",
    id_polifenol: "7879",
    polifenol: "4-hydroxyderricin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "24369884",
  },
  {
    id: "5523",
    id_polifenol: "6291",
    polifenol: "alpinumisoflavone",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "21415528",
  },
  {
    id: "5524",
    id_polifenol: "6485",
    polifenol: "3',4',7-trihydroxyisoflavone",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "24324516",
  },
  {
    id: "5525",
    id_polifenol: "5697",
    polifenol:
      "3-(3,4-dimethoxyphenyl)-1-(5-hydroxy-2,2-dimethyl-2H-chromen-6-yl)prop-2-en-1-one",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "24135236",
  },
  {
    id: "5526",
    id_polifenol: "4103",
    polifenol: "gnetin H",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "27196294",
  },
  {
    id: "5527",
    id_polifenol: "2517",
    polifenol: "casuarinin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "10644043",
  },
  {
    id: "5528",
    id_polifenol: "4524",
    polifenol: "5-hydroxy-3',4',6,7-tetramethoxyflavone",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "2",
    pmids: "26704713,18725283",
  },
  {
    id: "5529",
    id_polifenol: "2338",
    polifenol: "3,5-dihydroxy-4-methoxybenzoic acid",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "2",
    pmids: "16919832,23727892",
  },
  {
    id: "5530",
    id_polifenol: "5833",
    polifenol: "2',5'-dihydroxychalcone",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "15642415",
  },
  {
    id: "5531",
    id_polifenol: "4158",
    polifenol: "malabaricone C",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "22343417",
  },
  {
    id: "5532",
    id_polifenol: "4579",
    polifenol: "hinokiflavone",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "29673161",
  },
  {
    id: "5533",
    id_polifenol: "5436",
    polifenol: "herbacetin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "26297979",
  },
  {
    id: "5534",
    id_polifenol: "1204",
    polifenol: "2-isopropyl-5-methylphenol",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "26819495",
  },
  {
    id: "5535",
    id_polifenol: "7641",
    polifenol: "quercetin-3'-O-beta-D-glucopyranoside",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "26805810",
  },
  {
    id: "5536",
    id_polifenol: "7560",
    polifenol: "quercetin-3-O-neohesperidose",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "25978952",
  },
  {
    id: "5537",
    id_polifenol: "1647",
    polifenol: "hexahydrocurcumin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "25502175",
  },
  {
    id: "5538",
    id_polifenol: "184",
    polifenol: "trilobatin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "2",
    pmids: "25229655,25053100",
  },
  {
    id: "5539",
    id_polifenol: "5701",
    polifenol: "2',4'-dihydroxy-3,4,5-trimethoxychalcone",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "29199487",
  },
  {
    id: "5540",
    id_polifenol: "5226",
    polifenol: "cudraflavone B",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "2",
    pmids: "23762124,21319773",
  },
  {
    id: "5541",
    id_polifenol: "935",
    polifenol: "oligonol",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "23394584",
  },
  {
    id: "5542",
    id_polifenol: "5910",
    polifenol: "3'-formyl-4',6'-dihydroxy-2'-methoxy-5'-methylchalcone",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "21268076",
  },
  {
    id: "5543",
    id_polifenol: "4754",
    polifenol: "poncirin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "18057724",
  },
  {
    id: "5544",
    id_polifenol: "3605",
    polifenol: "lyoniresinol",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "25821492",
  },
  {
    id: "5545",
    id_polifenol: "7280",
    polifenol: "astilbin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "25569518",
  },
  {
    id: "5546",
    id_polifenol: "1782",
    polifenol: "6-dehydrogingerdione",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "25162585",
  },
  {
    id: "5547",
    id_polifenol: "7196",
    polifenol: "nepitrin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "20397728",
  },
  {
    id: "5548",
    id_polifenol: "7204",
    polifenol: "5,7,3',4'-tetramethylluteolin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "21251970",
  },
  {
    id: "5549",
    id_polifenol: "4053",
    polifenol: "succinobucol",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "25598420",
  },
  {
    id: "5550",
    id_polifenol: "2255",
    polifenol: "protocatechuic acid methyl ester",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "28587764",
  },
  {
    id: "5551",
    id_polifenol: "7210",
    polifenol: "luteolin-7-O-glucuronide",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "29710781",
  },
  {
    id: "5552",
    id_polifenol: "4663",
    polifenol: "rhoifolin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "2",
    pmids: "28753918,28942652",
  },
  {
    id: "5553",
    id_polifenol: "392",
    polifenol: "2-tert-butylphenol",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "22356159",
  },
  {
    id: "5554",
    id_polifenol: "4872",
    polifenol: "biapigenin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "16651730",
  },
  {
    id: "5555",
    id_polifenol: "286",
    polifenol: "butylphen",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "25059213",
  },
  {
    id: "5556",
    id_polifenol: "7457",
    polifenol: "kaempferol-7-O-alpha-L-rhamnopyranoside",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "23727892",
  },
  {
    id: "5557",
    id_polifenol: "2695",
    polifenol: "methyl salicylate",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "2",
    pmids: "21555977,27886112",
  },
  {
    id: "5558",
    id_polifenol: "705",
    polifenol: "vitisin A",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "2",
    pmids: "19135555,24558484",
  },
  {
    id: "5559",
    id_polifenol: "6109",
    polifenol: "sophoraflavanone A",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "12017334",
  },
  {
    id: "5560",
    id_polifenol: "6664",
    polifenol: "8-hydroxydaidzein",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "29933606",
  },
  {
    id: "5561",
    id_polifenol: "6164",
    polifenol: "euchrestaflavanone B",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "12017334",
  },
  {
    id: "5562",
    id_polifenol: "5120",
    polifenol: "diosmetin-7-O-xylopyranosyl-1-6-glucopyranoside",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "17294687",
  },
  {
    id: "5563",
    id_polifenol: "7209",
    polifenol: "luteolin 3'-glucuronide",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "20397728",
  },
  {
    id: "5564",
    id_polifenol: "5647",
    polifenol: "peracetylated epigallocatechin-3-gallate",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "16997910",
  },
  {
    id: "5565",
    id_polifenol: "4945",
    polifenol: "3,5,6,4'-tetrahydroxy-7-methoxyflavonoid",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "21251970",
  },
  {
    id: "5566",
    id_polifenol: "805",
    polifenol: "albaconol",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "18761814",
  },
  {
    id: "5567",
    id_polifenol: "4526",
    polifenol: "kolaviron",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "22416643",
  },
  {
    id: "5568",
    id_polifenol: "5511",
    polifenol: "nasunin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "28812425",
  },
  {
    id: "5569",
    id_polifenol: "5716",
    polifenol: "1,3-bis-(2-hydroxy-phenyl)-propenone",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "27469142",
  },
  {
    id: "5570",
    id_polifenol: "4899",
    polifenol: "bavachin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "20361957",
  },
  {
    id: "5571",
    id_polifenol: "4718",
    polifenol: "5,6,7-trimethoxyflavone",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "24161485",
  },
  {
    id: "5572",
    id_polifenol: "7179",
    polifenol: "swertisin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "2",
    pmids: "23453831,26692456",
  },
  {
    id: "5573",
    id_polifenol: "6096",
    polifenol: "eriocitrin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "2",
    pmids: "28753918,28942652",
  },
  {
    id: "5574",
    id_polifenol: "940",
    polifenol: "2-t-butyl-5-(4-t-butylphenyl)phenol",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "22356159",
  },
  {
    id: "5575",
    id_polifenol: "6022",
    polifenol: "morachalcone A",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "27463712",
  },
  {
    id: "5576",
    id_polifenol: "335",
    polifenol: "2,4,6-tri-tert-butylphenol",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "25792646",
  },
  {
    id: "5577",
    id_polifenol: "4575",
    polifenol: "orobol",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "21312307",
  },
  {
    id: "5578",
    id_polifenol: "4306",
    polifenol: "lasiodiplodin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "25821492",
  },
  {
    id: "5579",
    id_polifenol: "6134",
    polifenol: "7,8-dihydroxyflavanone",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "27529198",
  },
  {
    id: "5580",
    id_polifenol: "5878",
    polifenol: "2',4'-dihydroxy-3'-methoxychalcone",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "15041472",
  },
  {
    id: "5581",
    id_polifenol: "5986",
    polifenol: "2'-hydroxy-4',6'-dimethoxy-3'-methylchalcone",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "2",
    pmids: "22155221,21104603",
  },
  {
    id: "5582",
    id_polifenol: "5801",
    polifenol: "2'-hydroxy-4-methoxychalcone",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "15041472",
  },
  {
    id: "5583",
    id_polifenol: "3917",
    polifenol: "2,4-diacetylphloroglucinol",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "26283170",
  },
  {
    id: "5584",
    id_polifenol: "7691",
    polifenol:
      "quercetin 3-O-alpha-l-(2,4-di-O-acetyl)rhamnopyranoside-7-O-alpha-L-rhamnopyranoside",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "29382154",
  },
  {
    id: "5585",
    id_polifenol: "5197",
    polifenol: "Ikarisoside A",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "18929556",
  },
  {
    id: "5586",
    id_polifenol: "3057",
    polifenol: "flavoglaucin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "25535073",
  },
  {
    id: "5587",
    id_polifenol: "6011",
    polifenol: "1-phenyl-3-(thiophen-2-yl)prop-2-en-1-one",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "25414768",
  },
  {
    id: "5588",
    id_polifenol: "2392",
    polifenol: "1,6-di-O-galloyl-beta-D-glucose",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "26805810",
  },
  {
    id: "5589",
    id_polifenol: "5724",
    polifenol: "3,2'-dihydroxy-4',6'-dimethoxychalcone",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "22495442",
  },
  {
    id: "5590",
    id_polifenol: "6937",
    polifenol: "ladanein",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "20397728",
  },
  {
    id: "5591",
    id_polifenol: "6292",
    polifenol: "tricin 4'-O-(threo-beta-guaiacylglyceryl) ether",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "25667964",
  },
  {
    id: "5592",
    id_polifenol: "6293",
    polifenol: "tricin 4'-O-(erythro-beta-guaiacylglyceryl) ether",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "25667964",
  },
  {
    id: "5593",
    id_polifenol: "7561",
    polifenol: "3,7-dimethoxy-5,3',4'-trihydroxyflavone",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "28294989",
  },
  {
    id: "5594",
    id_polifenol: "6912",
    polifenol: "8-prenylapigenin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "19686724",
  },
  {
    id: "5595",
    id_polifenol: "2521",
    polifenol: "1,2,4-tri-O-galloyl-3,6-hexahydroxydiphenoylglucose",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "24473904",
  },
  {
    id: "5596",
    id_polifenol: "2394",
    polifenol: "methyl syringate",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "28257665",
  },
  {
    id: "5597",
    id_polifenol: "5077",
    polifenol: "5,6,3',5'-tetramethoxy-7,4'-hydroxyflavone",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "15659838",
  },
  {
    id: "5598",
    id_polifenol: "6003",
    polifenol: "boesenbergin A",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "22358425",
  },
  {
    id: "5599",
    id_polifenol: "5095",
    polifenol: "benzotropolone",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "14723964",
  },
  {
    id: "5600",
    id_polifenol: "6538",
    polifenol: "cirsimarin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "2",
    pmids: "29689498,20804824",
  },
  {
    id: "5601",
    id_polifenol: "7866",
    polifenol: "ephedrannin A",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "20939997",
  },
  {
    id: "5602",
    id_polifenol: "7859",
    polifenol: "ephedrannin B",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "20939997",
  },
  {
    id: "5603",
    id_polifenol: "4950",
    polifenol: "5,7,2'-trihydroxy-6,8-dimethoxyflavone",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "26712724",
  },
  {
    id: "5604",
    id_polifenol: "4602",
    polifenol: "sigmoidin B",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "26344038",
  },
  {
    id: "5605",
    id_polifenol: "976",
    polifenol: "Vaticanol B",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "17475668",
  },
  {
    id: "5606",
    id_polifenol: "4531",
    polifenol: "skullcapflavone II",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "26712724",
  },
  {
    id: "5607",
    id_polifenol: "7651",
    polifenol: "quercetin 3-O-(2''-galloyl)glucopyranoside",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "27648736",
  },
  {
    id: "5608",
    id_polifenol: "5486",
    polifenol: "delphinidin-3-rutinoside",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "24565673",
  },
  {
    id: "5609",
    id_polifenol: "4529",
    polifenol: "ganhuangenin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "26712724",
  },
  {
    id: "5610",
    id_polifenol: "6219",
    polifenol: "neoeriocitrin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "28942652",
  },
  {
    id: "5611",
    id_polifenol: "3384",
    polifenol:
      "7-(2-(2,2-difluoroethoxy)-3,5-di-tert-butylbenzene)-3-methylocta-2,4,6-trienoic acid",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "26554632",
  },
  {
    id: "5612",
    id_polifenol: "6391",
    polifenol: "LZ-207",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "26023926",
  },
  {
    id: "5613",
    id_polifenol: "5968",
    polifenol: "4'-hydroxy-2,4-dimethoxychalcone",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "15041472",
  },
  {
    id: "5614",
    id_polifenol: "1652",
    polifenol: "3,5-bis(2-pyridinylmethylidene)-4-piperidone",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "22197802",
  },
  {
    id: "5615",
    id_polifenol: "2460",
    polifenol: "cornusiin B",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "26805810",
  },
  {
    id: "5616",
    id_polifenol: "2461",
    polifenol: "cornusiin A",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "26805810",
  },
  {
    id: "5617",
    id_polifenol: "7900",
    polifenol:
      "1-(2-methoxy-4,6-bis(methoxymethoxy)phenyl)-3-(3-nitrophenyl)prop-2-en-1-one",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "19183880",
  },
  {
    id: "5618",
    id_polifenol: "4746",
    polifenol: "sophoflavescenol",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "22210035",
  },
  {
    id: "5619",
    id_polifenol: "7136",
    polifenol: "apigenin 6,8-digalactoside",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "26180533",
  },
  {
    id: "5620",
    id_polifenol: "633",
    polifenol: "dihydroconiferyl alcohol",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "25747981",
  },
  {
    id: "5621",
    id_polifenol: "4923",
    polifenol: "saxifragin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "26171782",
  },
  {
    id: "5622",
    id_polifenol: "7851",
    polifenol: "proanthocyanidin A2",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "24641487",
  },
  {
    id: "5623",
    id_polifenol: "1165",
    polifenol: "RSVA314",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "22909341",
  },
  {
    id: "5624",
    id_polifenol: "1166",
    polifenol: "RSVA405",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "22909341",
  },
  {
    id: "5625",
    id_polifenol: "4811",
    polifenol: "isotrifoliol",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "28192731",
  },
  {
    id: "5626",
    id_polifenol: "1628",
    polifenol: "monoacetylcurcumin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "20372820",
  },
  {
    id: "5627",
    id_polifenol: "6969",
    polifenol:
      "3,5-dihydroxy-4'-methoxy-6',6'-dimethyl-4',5'-dihydropyrano(2',3'-7,8)flavone",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "20686223",
  },
  {
    id: "5628",
    id_polifenol: "5677",
    polifenol: "2'-cysteinyl-epigallocatechin-3-gallate",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "20718469",
  },
  {
    id: "5629",
    id_polifenol: "6741",
    polifenol: "genistein 7-(6-deoxytalopyranoside)",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "19214388",
  },
  {
    id: "5630",
    id_polifenol: "4997",
    polifenol: "kaempferol 3-O-(2''-O-glucosyl)rutinoside",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "23453831",
  },
  {
    id: "5631",
    id_polifenol: "2605",
    polifenol: "methyl salicylate 2-O-lactoside",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "22292506",
  },
  {
    id: "5632",
    id_polifenol: "5956",
    polifenol: "kuraridin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "20522970",
  },
  {
    id: "5633",
    id_polifenol: "676",
    polifenol: "hinokiresinol",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "17291735",
  },
  {
    id: "5634",
    id_polifenol: "4763",
    polifenol: "bilobetin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "10588517",
  },
  {
    id: "5635",
    id_polifenol: "4717",
    polifenol: "cycloheterophyllin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "27463712",
  },
  {
    id: "5636",
    id_polifenol: "4368",
    polifenol: "LFG-500",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "27206337",
  },
  {
    id: "5637",
    id_polifenol: "1112",
    polifenol: "rheosmin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "20478352",
  },
  {
    id: "5638",
    id_polifenol: "76",
    polifenol: "Fibric Acids",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "11208679",
  },
  {
    id: "5639",
    id_polifenol: "1798",
    polifenol: "12-dehydrogingerdione",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "23027684",
  },
  {
    id: "5640",
    id_polifenol: "4818",
    polifenol: "C-glucosylflavone",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "20804824",
  },
  {
    id: "5641",
    id_polifenol: "7009",
    polifenol: "5-O-beta-D-glucopyranosyl cirsimaritin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "20804824",
  },
  {
    id: "5642",
    id_polifenol: "7010",
    polifenol: "5,4'-O-beta-D-diglucopyranosyl cirsimaritin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "20804824",
  },
  {
    id: "5643",
    id_polifenol: "7606",
    polifenol: "quercetin pentaacetate",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "26344038",
  },
  {
    id: "5644",
    id_polifenol: "7155",
    polifenol: "saponarin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "27455313",
  },
  {
    id: "5645",
    id_polifenol: "7194",
    polifenol: "veronicastroside",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "28942652",
  },
  {
    id: "5646",
    id_polifenol: "4511",
    polifenol: "5-hydroxy-7,8-dimethoxyflavone",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "26712724",
  },
  {
    id: "5647",
    id_polifenol: "4681",
    polifenol: "5,7,4'-trihydroxy-8-methoxyflavone",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "26712724",
  },
  {
    id: "5648",
    id_polifenol: "1500",
    polifenol: "allylpyrocatechol",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "27856937",
  },
  {
    id: "5649",
    id_polifenol: "5240",
    polifenol: "swertiajaponin",
    id_cancer: "568",
    cancer: "Acute Monocytic Leukemia",
    quant: "1",
    pmids: "26692456",
  },
  {
    id: "5650",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "84",
    pmids:
      "25256786,23621210,15572301,29861773,20215519,19956833,23913940,21330379,26148186,24325618,21538580,23969487,26590114,15792956,23888052,21500970,12874003,16044407,29031211,20599768,21112745,28899779,15769122,22204275,26876613,1899810,21282043,9642119,26518900,23210776,18404597,6427052,26795272,25102117,12230878,28489194,26712788,28962868,19138980,9066634,27266882,10753220,29864953,27221774,8402584,28664315,26081168,29049844,24675422,26520390,17847709,9114752,9106644,15685239,27906147,1318792,26196716,28039793,23983093,3926336,10799745,26724949,20450170,28974022,11597783,2766409,12429970,29050978,15037894,23545178,26863880,27164914,26682379,15586237,25779384,19830264,24587411,8899846,26802941,24120900,16019129,16599267,29793322,19538057",
  },
  {
    id: "5651",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "59",
    pmids:
      "25262359,27502897,17885582,28618944,22841393,29208180,22498762,20336681,17148446,29103764,14985701,11237176,9744532,11370761,17273730,23710286,27094403,28167449,19212627,15999103,22888366,18206126,25027711,23341182,9764849,27819148,24402549,19277688,8538195,7954373,11231886,27488950,3139287,26862088,21088500,28736282,28639178,21215629,21773589,29016221,24349037,1578097,18484534,20153563,25742310,21493306,9215864,23316365,26638207,1423891,22080352,17569219,25623080,29195800,10657978,26864554,23386626,19531956,29258053",
  },
  {
    id: "5652",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "77",
    pmids:
      "10078934,25694272,25821561,17984116,20206613,24329111,19661309,15944151,10493515,17493734,25137576,27094403,15769122,25710724,29359608,19556852,20015867,27706097,16982614,11511526,23210776,18404597,28983752,11216482,8538195,25102117,10328958,2032222,23475480,21887248,16317135,9414176,24096034,28053887,1617628,10786933,9878691,9886579,11809367,16173528,26056816,17234229,27528586,24349037,7665919,1417700,16336097,17289350,1614997,17049833,22932898,23210792,21798853,29046052,19020550,15715508,9255591,17019718,19747801,11138532,28974022,17382466,2912593,12871030,15037894,27714264,27164914,26682379,17261341,25244914,9919616,17254040,3141040,28432719,16019129,12821280,16599267",
  },
  {
    id: "5653",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "31",
    pmids:
      "10336426,12615364,10602506,17513607,11439356,24466036,11896587,26507164,17404396,25834353,16044407,11245472,16921490,10781582,12014647,15363595,15292961,12460732,17181633,8758915,11179516,11279232,16302268,11895866,12387830,21995813,12477973,11278279,19724275,28785074,17054908",
  },
  {
    id: "5654",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "8",
    pmids:
      "21378167,7884564,21620532,9744550,12765243,26864554,22767648,15842837",
  },
  {
    id: "5655",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "31",
    pmids:
      "20551291,22139441,26148186,24353828,23684917,11759294,21282043,18404597,26712788,28962868,19138980,2544313,27415000,6413085,26081168,20153563,9114752,26018751,15685239,23210792,6418445,3926336,11597783,277730,23545178,22369932,2553289,3128399,3141040,29793322,15842837",
  },
  {
    id: "5656",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "48",
    pmids:
      "10078934,23385063,20206613,24329111,18519674,10493515,29103764,11759294,15375010,26943640,15938647,23950896,19556852,20015867,11511526,21209038,11216482,8538195,16211268,25843776,17436577,23475480,16051220,15609335,9414176,24096034,1617628,10786933,9878691,9886579,11809367,17234229,7665919,12205293,21042803,17049833,26018751,21470043,21798853,15670948,12871030,18463684,28440509,26864554,10048310,24201298,11174086,10882869",
  },
  {
    id: "5657",
    id_polifenol: "2167",
    polifenol: "phenolic acid",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "33",
    pmids:
      "23939793,15572301,19174152,27468232,22634840,15769122,15288590,11551496,24130029,20026373,11231886,19481070,28489194,26712788,3139287,26204672,9719454,26056816,27528586,26081168,8269619,9585067,4002673,27906147,3926336,19861506,15037894,27164914,1934290,3141040,28432719,16019129,29793322",
  },
  {
    id: "5658",
    id_polifenol: "49",
    polifenol: "Aspirin",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "11",
    pmids:
      "14699495,9092536,9334204,10678579,9472093,14750642,21773589,12496056,11905657,19892664,21778329",
  },
  {
    id: "5659",
    id_polifenol: "109",
    polifenol: "Catechin",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "25",
    pmids:
      "25821561,20206613,16536584,10493515,15769122,21209038,6427052,23874895,23475480,16051220,1617628,21544350,9886579,11809367,21559587,26056816,8402584,26081168,7665919,21042803,8073090,7653998,12871030,9494559,11174086",
  },
  {
    id: "5660",
    id_polifenol: "125",
    polifenol: "Isoflavones",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "3",
    pmids: "10773411,21378167,9459174",
  },
  {
    id: "5661",
    id_polifenol: "110",
    polifenol: "Chalcones",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "8",
    pmids:
      "20512474,25710724,1899810,22700224,22344908,8142919,25594392,29753256",
  },
  {
    id: "5662",
    id_polifenol: "3089",
    polifenol: "1,1-diphenyl-2-picrylhydrazyl",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "17",
    pmids:
      "23939793,24070160,29191192,22354161,27468232,22074239,21126077,24130029,28489194,28704964,23474096,28008248,22339064,28039793,29887909,27143883,29793322",
  },
  {
    id: "5663",
    id_polifenol: "114",
    polifenol: "Apigenin",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "14",
    pmids:
      "21538580,23969487,28191273,16044407,21112745,26876613,16982614,19277688,9066634,24830944,26864554,8899846,26802941,24120900",
  },
  {
    id: "5664",
    id_polifenol: "113",
    polifenol: "Flavones",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "5",
    pmids: "27573489,1318792,10799745,7139549,24587411",
  },
  {
    id: "5665",
    id_polifenol: "38",
    polifenol: "Gallic Acid",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "14",
    pmids:
      "19174152,28962387,20596665,15769122,21734530,24130029,2032222,28489194,24444547,21544350,1417700,7653998,1592533,9494559",
  },
  {
    id: "5666",
    id_polifenol: "117",
    polifenol: "Luteolin",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "8",
    pmids:
      "23621210,20215519,21330379,21112745,27266882,26056816,26864554,24587411",
  },
  {
    id: "5667",
    id_polifenol: "1",
    polifenol: "Phenols",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "19",
    pmids:
      "27502897,27468232,2032222,26204672,29864953,9878691,18179621,1417700,4002673,26196716,3926336,29887909,11520941,2046689,27164914,7055797,3128399,3141040,3486036",
  },
  {
    id: "5668",
    id_polifenol: "105",
    polifenol: "Anthocyanins",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "15",
    pmids:
      "19174152,20096264,16902416,21501596,16618699,29031211,14514663,23210776,19320737,22821773,29235191,15455341,25062774,15493960,28468289",
  },
  {
    id: "5669",
    id_polifenol: "7235",
    polifenol: "silybin",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "22",
    pmids:
      "15792956,25492239,11759294,23359305,16731746,14555614,23210776,15033902,11895866,15894701,16928834,26447614,22118157,29049844,17689055,22166495,17409458,16076518,26097804,27729375,16084079,27414401",
  },
  {
    id: "5670",
    id_polifenol: "129",
    polifenol: "Rotenone",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "3",
    pmids: "10773411,25779384,27311994",
  },
  {
    id: "5671",
    id_polifenol: "121",
    polifenol: "Kaempferols",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "7",
    pmids: "26473154,24994661,23936765,17804722,20599768,6427052,26712788",
  },
  {
    id: "5672",
    id_polifenol: "871",
    polifenol: "ABT-737",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "2",
    pmids: "26204252,29957081",
  },
  {
    id: "5673",
    id_polifenol: "6451",
    polifenol: "daidzein",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "3",
    pmids: "21378167,21620532,27143883",
  },
  {
    id: "5674",
    id_polifenol: "6065",
    polifenol: "baicalein",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "6",
    pmids: "23108957,12874003,22204275,20153563,10578486,29258053",
  },
  {
    id: "5675",
    id_polifenol: "7",
    polifenol: "Capsaicin",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "5",
    pmids: "20660715,29580868,28551094,26864554,25846502",
  },
  {
    id: "5676",
    id_polifenol: "120",
    polifenol: "Flavonols",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "6",
    pmids: "24511002,29029040,24994661,21793847,22700224,24675422",
  },
  {
    id: "5677",
    id_polifenol: "4522",
    polifenol: "chrysin",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "3",
    pmids: "24169959,23888052,29050978",
  },
  {
    id: "5678",
    id_polifenol: "123",
    polifenol: "Rutin",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "5",
    pmids: "18404597,28489194,28962868,23210792,16599267",
  },
  {
    id: "5679",
    id_polifenol: "6062",
    polifenol: "naringenin",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "3",
    pmids: "25256786,28039793,26154512",
  },
  {
    id: "5680",
    id_polifenol: "285",
    polifenol: "bisphenol A",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "12765243",
  },
  {
    id: "5681",
    id_polifenol: "39",
    polifenol: "Hydrolyzable Tannins",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "15",
    pmids:
      "23939793,22227193,28489194,21541586,21544350,21559587,8402584,8073090,27906147,7653998,15455341,15493960,1592533,10965522,9494559",
  },
  {
    id: "5682",
    id_polifenol: "130",
    polifenol: "Proanthocyanidins",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "20",
    pmids:
      "17981597,28781636,22749965,26676402,26807314,21541586,21544350,28548949,21559587,19158151,7653998,26991736,20947490,25112437,17382466,15987716,20143255,26864554,28412456,29258053",
  },
  {
    id: "5683",
    id_polifenol: "35",
    polifenol: "Hydroquinones",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "3",
    pmids: "12727023,26795272,3105120",
  },
  {
    id: "5684",
    id_polifenol: "111",
    polifenol: "Flavanones",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "4",
    pmids: "22700224,22344908,11790450,27816646",
  },
  {
    id: "5685",
    id_polifenol: "4502",
    polifenol: "fisetin",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "7",
    pmids: "24466036,26590114,20637980,6427052,25169110,29049844,26864554",
  },
  {
    id: "5686",
    id_polifenol: "6",
    polifenol: "Catechols",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "11751421",
  },
  {
    id: "5687",
    id_polifenol: "25",
    polifenol: "Butylated Hydroxytoluene",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "10",
    pmids:
      "6427052,8758915,7748479,7598004,404033,6347683,2498483,8532709,7430707,8200081",
  },
  {
    id: "5688",
    id_polifenol: "75",
    polifenol: "Butylated Hydroxyanisole",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "10",
    pmids:
      "17121845,6427052,1991991,6394592,3011305,7748479,8269619,7598004,6385617,404033",
  },
  {
    id: "5689",
    id_polifenol: "15",
    polifenol: "Masoprocol",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "4",
    pmids: "12112316,2514267,19861506,2553289",
  },
  {
    id: "5690",
    id_polifenol: "4519",
    polifenol: "myricetin",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "8",
    pmids:
      "25256786,24511002,20339252,21793847,18632659,27221774,3926336,3128399",
  },
  {
    id: "5691",
    id_polifenol: "4515",
    polifenol: "baicalin",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "3",
    pmids: "18711771,28385077,24292572",
  },
  {
    id: "5692",
    id_polifenol: "4500",
    polifenol: "procyanidin",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "4",
    pmids: "28781636,16051220,8402584,8073090",
  },
  {
    id: "5693",
    id_polifenol: "5608",
    polifenol: "epicatechin gallate",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "4",
    pmids: "25694272,10493515,9414176,7665919",
  },
  {
    id: "5694",
    id_polifenol: "1356",
    polifenol: "gingerol",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "5",
    pmids: "15630166,20336681,19481070,9719454,19629484",
  },
  {
    id: "5695",
    id_polifenol: "54",
    polifenol: "Salicylic Acid",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "2",
    pmids: "17962965,20832250",
  },
  {
    id: "5696",
    id_polifenol: "5607",
    polifenol: "gallocatechol",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "3",
    pmids: "10493515,9414176,7665919",
  },
  {
    id: "5697",
    id_polifenol: "5578",
    polifenol: "alpha-naphthoflavone",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "7",
    pmids: "11849049,3011305,11219836,6406052,6802491,407010,277730",
  },
  {
    id: "5698",
    id_polifenol: "44",
    polifenol: "Salicylates",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "3",
    pmids: "9092536,23075132,10882869",
  },
  {
    id: "5699",
    id_polifenol: "4559",
    polifenol: "theaflavin",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "6",
    pmids: "17984116,10493515,19556852,11216482,10786933,11138532",
  },
  {
    id: "5700",
    id_polifenol: "5808",
    polifenol: "isoliquiritigenin",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "1899810",
  },
  {
    id: "5701",
    id_polifenol: "2344",
    polifenol: "methyl gallate",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "4",
    pmids: "10493515,28962387,16982614,16051220",
  },
  {
    id: "5702",
    id_polifenol: "2284",
    polifenol: "rosmarinic acid",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "2",
    pmids: "22439433,27528586",
  },
  {
    id: "5703",
    id_polifenol: "112",
    polifenol: "Hesperidin",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "2",
    pmids: "21984511,27816646",
  },
  {
    id: "5704",
    id_polifenol: "6455",
    polifenol: "nobiletin",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "2",
    pmids: "18820286,11016629",
  },
  {
    id: "5705",
    id_polifenol: "4513",
    polifenol: "galangin",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "4",
    pmids: "24675422,17847709,28039793,26863880",
  },
  {
    id: "5706",
    id_polifenol: "6063",
    polifenol: "naringin",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "21500970",
  },
  {
    id: "5707",
    id_polifenol: "1380",
    polifenol: "shogaol",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "20336681",
  },
  {
    id: "5708",
    id_polifenol: "2158",
    polifenol: "protocatechuic acid",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "3",
    pmids: "28825660,20026373,9585067",
  },
  {
    id: "5709",
    id_polifenol: "5489",
    polifenol: "delphinidin",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "4",
    pmids: "19174152,16902416,14514663,15493960",
  },
  {
    id: "5710",
    id_polifenol: "6273",
    polifenol: "hesperetin",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "3",
    pmids: "26518900,26520390,21620532",
  },
  {
    id: "5711",
    id_polifenol: "1613",
    polifenol: "demethoxycurcumin",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "3",
    pmids: "28618944,28586041,27094403",
  },
  {
    id: "5712",
    id_polifenol: "93",
    polifenol: "Phloroglucinol",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "22700224",
  },
  {
    id: "5713",
    id_polifenol: "7550",
    polifenol: "3-methylquercetin",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "2",
    pmids: "21330379,26056816",
  },
  {
    id: "5714",
    id_polifenol: "6461",
    polifenol: "acacetin",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "23913940",
  },
  {
    id: "5715",
    id_polifenol: "1611",
    polifenol: "bis(4-hydroxycinnamoyl)methane",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "27094403",
  },
  {
    id: "5716",
    id_polifenol: "107",
    polifenol: "beta-Naphthoflavone",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "407010",
  },
  {
    id: "5717",
    id_polifenol: "119",
    polifenol: "Silymarin",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "8",
    pmids:
      "17996674,10491326,15033902,12230878,17548792,10753220,17289350,20372777",
  },
  {
    id: "5718",
    id_polifenol: "126",
    polifenol: "Coumestrol",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "2",
    pmids: "12765243,15842837",
  },
  {
    id: "5719",
    id_polifenol: "55",
    polifenol: "Sodium Salicylate",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "2",
    pmids: "9334204,12496056",
  },
  {
    id: "5720",
    id_polifenol: "5806",
    polifenol: "butein",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "2",
    pmids: "26694191,2553289",
  },
  {
    id: "5721",
    id_polifenol: "108",
    polifenol: "Biflavonoids",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "2",
    pmids: "29627441,26724949",
  },
  {
    id: "5722",
    id_polifenol: "5509",
    polifenol: "cyanidin 3-O-glucoside",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "5",
    pmids: "21501596,16618699,29031211,29231728,25062774",
  },
  {
    id: "5723",
    id_polifenol: "969",
    polifenol: "3,4-dihydroxyphenacyl caffeate phenylpropanoid ester",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "19830264",
  },
  {
    id: "5724",
    id_polifenol: "5819",
    polifenol: "licochalcone A",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "3",
    pmids: "24944769,25710724,8142919",
  },
  {
    id: "5725",
    id_polifenol: "94",
    polifenol: "Phloretin",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "25929446",
  },
  {
    id: "5726",
    id_polifenol: "4560",
    polifenol: "icariin",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "2",
    pmids: "23807305,26507164",
  },
  {
    id: "5727",
    id_polifenol: "5488",
    polifenol: "cyanidin",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "3",
    pmids: "20096264,15493960,28468289",
  },
  {
    id: "5728",
    id_polifenol: "80",
    polifenol: "Clofibrate",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "2",
    pmids: "9013627,8625460",
  },
  {
    id: "5729",
    id_polifenol: "1995",
    polifenol: "2-tert-butylhydroquinone",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "2",
    pmids: "16455194,22476201",
  },
  {
    id: "5730",
    id_polifenol: "6482",
    polifenol: "tangeretin",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "21126077",
  },
  {
    id: "5731",
    id_polifenol: "99",
    polifenol: "Pyrogallol",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "21620532",
  },
  {
    id: "5732",
    id_polifenol: "452",
    polifenol: "acteoside",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "3",
    pmids: "18404597,23210792,25244914",
  },
  {
    id: "5733",
    id_polifenol: "1644",
    polifenol: "Cur1 compound",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "4",
    pmids: "27502897,27488950,25623080,29195800",
  },
  {
    id: "5734",
    id_polifenol: "100",
    polifenol: "Resorcinols",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "2",
    pmids: "12727023,19393233",
  },
  {
    id: "5735",
    id_polifenol: "5614",
    polifenol: "catechin gallate",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "10882869",
  },
  {
    id: "5736",
    id_polifenol: "4486",
    polifenol: "amentoflavone",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "2",
    pmids: "29627441,26724949",
  },
  {
    id: "5737",
    id_polifenol: "118",
    polifenol: "Flavonolignans",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "4",
    pmids: "22118157,17689055,16076518,27414401",
  },
  {
    id: "5738",
    id_polifenol: "7541",
    polifenol: "taxifolin",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "3",
    pmids: "28714938,22805054,16076518",
  },
  {
    id: "5739",
    id_polifenol: "7544",
    polifenol: "quercitrin",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "2",
    pmids: "19956833,23545178",
  },
  {
    id: "5740",
    id_polifenol: "300",
    polifenol: "rhodioloside",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "2",
    pmids: "27028995,29693192",
  },
  {
    id: "5741",
    id_polifenol: "7912",
    polifenol: "7,9,2',4'-tetrahydroxy-8-isopentenyl-5-methoxychalcone",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "20512474",
  },
  {
    id: "5742",
    id_polifenol: "2475",
    polifenol: "6-O-galloylglucose",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "10493515",
  },
  {
    id: "5743",
    id_polifenol: "92",
    polifenol: "Triclosan",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "15288590",
  },
  {
    id: "5744",
    id_polifenol: "6068",
    polifenol: "pinocembrin",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "28039793",
  },
  {
    id: "5745",
    id_polifenol: "6576",
    polifenol: "5,7,4'-trihydroxyflavone",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "28191273",
  },
  {
    id: "5746",
    id_polifenol: "4585",
    polifenol: "baohuoside I",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "23807305",
  },
  {
    id: "5747",
    id_polifenol: "1616",
    polifenol: "tetrahydrocurcumin",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "2",
    pmids: "11237176,11370761",
  },
  {
    id: "5748",
    id_polifenol: "2328",
    polifenol: "syringic acid",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "29886055",
  },
  {
    id: "5749",
    id_polifenol: "40",
    polifenol: "Propyl Gallate",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "2",
    pmids: "6427052,1592533",
  },
  {
    id: "5750",
    id_polifenol: "4525",
    polifenol: "eupatilin",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "2",
    pmids: "27573489,28899779",
  },
  {
    id: "5751",
    id_polifenol: "5455",
    polifenol: "theaflavin-3,3'-digallate",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "2",
    pmids: "10493515,11511526",
  },
  {
    id: "5752",
    id_polifenol: "2490",
    polifenol: "punicalagin",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "15493960",
  },
  {
    id: "5753",
    id_polifenol: "5815",
    polifenol: "dibenzoylmethane",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "2",
    pmids: "21773589,29753256",
  },
  {
    id: "5754",
    id_polifenol: "637",
    polifenol: "glabridin",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "2",
    pmids: "26795272,21737643",
  },
  {
    id: "5755",
    id_polifenol: "77",
    polifenol: "Bezafibrate",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "11108658",
  },
  {
    id: "5756",
    id_polifenol: "1810",
    polifenol: "heminordihydroguaiaretic acid",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "2514267",
  },
  {
    id: "5757",
    id_polifenol: "19",
    polifenol: "Pentachlorophenol",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "2",
    pmids: "18951944,12669308",
  },
  {
    id: "5758",
    id_polifenol: "7198",
    polifenol: "homoorientin",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "22933394",
  },
  {
    id: "5759",
    id_polifenol: "6456",
    polifenol: "daidzin",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "9459174",
  },
  {
    id: "5760",
    id_polifenol: "5496",
    polifenol: "pelargonidin",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "15493960",
  },
  {
    id: "5761",
    id_polifenol: "7853",
    polifenol: "Grape Seed Proanthocyanidins",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "2",
    pmids: "28781636,15987716",
  },
  {
    id: "5762",
    id_polifenol: "6066",
    polifenol: "eriodictyol",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "2",
    pmids: "23936765,26081168",
  },
  {
    id: "5763",
    id_polifenol: "353",
    polifenol: "sesamol",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "27539478",
  },
  {
    id: "5764",
    id_polifenol: "7377",
    polifenol: "astragalin",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "2",
    pmids: "28809055,29298652",
  },
  {
    id: "5765",
    id_polifenol: "115",
    polifenol: "Diosmin",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "2",
    pmids: "28862211,19538057",
  },
  {
    id: "5766",
    id_polifenol: "885",
    polifenol: "oleocanthal",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "2",
    pmids: "29959992,27266366",
  },
  {
    id: "5767",
    id_polifenol: "6770",
    polifenol: "5-hydroxy-3,6,7,8,3',4'-hexamethoxyflavone",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "17962218",
  },
  {
    id: "5768",
    id_polifenol: "2283",
    polifenol: "depsidone",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "18721817",
  },
  {
    id: "5769",
    id_polifenol: "1747",
    polifenol: "6-paradol",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "11551496",
  },
  {
    id: "5770",
    id_polifenol: "2343",
    polifenol: "ethyl gallate",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "26081168",
  },
  {
    id: "5771",
    id_polifenol: "2331",
    polifenol: "8-(N,N-diethylamino)octyl-3,4,5-trimethoxybenzoate",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "8529201",
  },
  {
    id: "5772",
    id_polifenol: "2364",
    polifenol: "theaflavine gallate",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "10493515",
  },
  {
    id: "5773",
    id_polifenol: "6166",
    polifenol: "liquiritin",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "29901082",
  },
  {
    id: "5774",
    id_polifenol: "1687",
    polifenol: "2-hydroxyestrone",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "3105120",
  },
  {
    id: "5775",
    id_polifenol: "6774",
    polifenol: "5,7-dihydroxy-6,3',4'-trimethoxyflavone",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "28899779",
  },
  {
    id: "5776",
    id_polifenol: "315",
    polifenol: "bakuchiol",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "26910280",
  },
  {
    id: "5777",
    id_polifenol: "5875",
    polifenol: "panduratin A",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "25594392",
  },
  {
    id: "5778",
    id_polifenol: "5537",
    polifenol: "peonidin",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "14514663",
  },
  {
    id: "5779",
    id_polifenol: "428",
    polifenol: "2,2'-bisphenol F",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "14514663",
  },
  {
    id: "5780",
    id_polifenol: "7453",
    polifenol: "kaempferol-3-O-glucoside",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "28809055",
  },
  {
    id: "5781",
    id_polifenol: "4573",
    polifenol: "3,3',4',5,6,7,8-heptamethoxyflavone",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "10799745",
  },
  {
    id: "5782",
    id_polifenol: "4981",
    polifenol: "jaceosidin",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "29861773",
  },
  {
    id: "5783",
    id_polifenol: "7880",
    polifenol: "xanthoangelol",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "22344908",
  },
  {
    id: "5784",
    id_polifenol: "4607",
    polifenol: "orientin",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "22933394",
  },
  {
    id: "5785",
    id_polifenol: "416",
    polifenol: "phenoxy radical",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "8532709",
  },
  {
    id: "5786",
    id_polifenol: "2693",
    polifenol: "copper bis(3,5-diisopropylsalicylate)",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "3",
    pmids: "7748479,7598004,1934290",
  },
  {
    id: "5787",
    id_polifenol: "3667",
    polifenol: "ciprofibrate",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "9013627",
  },
  {
    id: "5788",
    id_polifenol: "1754",
    polifenol: "gigantol",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "24844664",
  },
  {
    id: "5789",
    id_polifenol: "529",
    polifenol: "4-octylphenol",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "12117780",
  },
  {
    id: "5790",
    id_polifenol: "7614",
    polifenol: "quercetin 3-O-methyl ether",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "2",
    pmids: "22139441,11597783",
  },
  {
    id: "5791",
    id_polifenol: "1585",
    polifenol: "curcumin glucuronide",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "2",
    pmids: "11237176,11370761",
  },
  {
    id: "5792",
    id_polifenol: "5141",
    polifenol: "6-prenylnaringenin",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "22700224",
  },
  {
    id: "5793",
    id_polifenol: "106",
    polifenol: "Benzoflavones",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "407010",
  },
  {
    id: "5794",
    id_polifenol: "2161",
    polifenol: "nifuroxazide",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "26503030",
  },
  {
    id: "5795",
    id_polifenol: "472",
    polifenol: "isoacteoside",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "25244914",
  },
  {
    id: "5796",
    id_polifenol: "2026",
    polifenol: "phenylhydroquinone",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "7681543",
  },
  {
    id: "5797",
    id_polifenol: "4630",
    polifenol: "5,7,2',3'-tetrahydroxyflavone",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "1318792",
  },
  {
    id: "5798",
    id_polifenol: "1725",
    polifenol: "yakuchinone-A",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "2",
    pmids: "24070160,12201673",
  },
  {
    id: "5799",
    id_polifenol: "7879",
    polifenol: "4-hydroxyderricin",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "22344908",
  },
  {
    id: "5800",
    id_polifenol: "6485",
    polifenol: "3',4',7-trihydroxyisoflavone",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "2",
    pmids: "21378167,27143883",
  },
  {
    id: "5801",
    id_polifenol: "7363",
    polifenol: "juglanin",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "29620254",
  },
  {
    id: "5802",
    id_polifenol: "2290",
    polifenol: "lobaric acid",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "27169822",
  },
  {
    id: "5803",
    id_polifenol: "2517",
    polifenol: "casuarinin",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "22227193",
  },
  {
    id: "5804",
    id_polifenol: "4524",
    polifenol: "5-hydroxy-3',4',6,7-tetramethoxyflavone",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "24148842",
  },
  {
    id: "5805",
    id_polifenol: "2338",
    polifenol: "3,5-dihydroxy-4-methoxybenzoic acid",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "21620532",
  },
  {
    id: "5806",
    id_polifenol: "6642",
    polifenol: "6,7-dihydroxyflavone",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "27220989",
  },
  {
    id: "5807",
    id_polifenol: "811",
    polifenol: "squaraine",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "2",
    pmids: "28330805,18653354",
  },
  {
    id: "5808",
    id_polifenol: "5436",
    polifenol: "herbacetin",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "29029040",
  },
  {
    id: "5809",
    id_polifenol: "6847",
    polifenol: "3',4'-didemethylnobiletin",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "18820286",
  },
  {
    id: "5810",
    id_polifenol: "4482",
    polifenol: "peflavit",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "26148186",
  },
  {
    id: "5811",
    id_polifenol: "4152",
    polifenol: "quracol B",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "10773411",
  },
  {
    id: "5812",
    id_polifenol: "2491",
    polifenol: "punicalin",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "15493960",
  },
  {
    id: "5813",
    id_polifenol: "82",
    polifenol: "Gemfibrozil",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "18092840",
  },
  {
    id: "5814",
    id_polifenol: "1152",
    polifenol: "salvianolic acid",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "27528586",
  },
  {
    id: "5815",
    id_polifenol: "6464",
    polifenol: "cirsiliol",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "27566208",
  },
  {
    id: "5816",
    id_polifenol: "1453",
    polifenol: "4-nerolidylcatechol",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "16613496",
  },
  {
    id: "5817",
    id_polifenol: "2007",
    polifenol: "2,3,5,6-tetrachlorohydroquinone",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "2",
    pmids: "18951944,12669308",
  },
  {
    id: "5818",
    id_polifenol: "1625",
    polifenol: "curcumin III",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "1578097",
  },
  {
    id: "5819",
    id_polifenol: "4518",
    polifenol: "robinetin",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "3926336",
  },
  {
    id: "5820",
    id_polifenol: "7650",
    polifenol: "3,7-O-dimethylquercetin",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "28962868",
  },
  {
    id: "5821",
    id_polifenol: "7825",
    polifenol: "alpha-toxicarol",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "2",
    pmids: "14765285,15229812",
  },
  {
    id: "5822",
    id_polifenol: "2749",
    polifenol: "zinc 3,5-diisopropylsalicylate",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "1934290",
  },
  {
    id: "5823",
    id_polifenol: "2794",
    polifenol: "salazinic acid",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "19199230",
  },
  {
    id: "5824",
    id_polifenol: "5933",
    polifenol: "licochalcone B",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "29027311",
  },
  {
    id: "5825",
    id_polifenol: "7209",
    polifenol: "luteolin 3'-glucuronide",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "27528586",
  },
  {
    id: "5826",
    id_polifenol: "1738",
    polifenol: "dehydroparadol",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "11551496",
  },
  {
    id: "5827",
    id_polifenol: "5647",
    polifenol: "peracetylated epigallocatechin-3-gallate",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "23385063",
  },
  {
    id: "5828",
    id_polifenol: "3537",
    polifenol: "1,2,4,5-tetramethoxybenzene",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "27355819",
  },
  {
    id: "5829",
    id_polifenol: "1021",
    polifenol: "bis(3,5-diiodo-2,4,6-trihydroxyphenyl)squaraine",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "18653354",
  },
  {
    id: "5830",
    id_polifenol: "5639",
    polifenol: "4-(S-cysteinyl)epicatechin 3-O-gallate",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "16051220",
  },
  {
    id: "5831",
    id_polifenol: "5079",
    polifenol: "flavangenol",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "20497364",
  },
  {
    id: "5832",
    id_polifenol: "2287",
    polifenol: "pannarin",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "18721817",
  },
  {
    id: "5833",
    id_polifenol: "6340",
    polifenol: "cudraflavone C",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "28703746",
  },
  {
    id: "5834",
    id_polifenol: "3057",
    polifenol: "flavoglaucin",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "20460698",
  },
  {
    id: "5835",
    id_polifenol: "6785",
    polifenol: "3',4',7-trimethoxyflavone",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "28664315",
  },
  {
    id: "5836",
    id_polifenol: "3802",
    polifenol: "kutkin",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "11406836",
  },
  {
    id: "5837",
    id_polifenol: "5602",
    polifenol: "meciadanol",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "20206613",
  },
  {
    id: "5838",
    id_polifenol: "7649",
    polifenol: "quercetin 3-O-beta-(2''-galloyl)-rhamnopyranoside",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "23684917",
  },
  {
    id: "5839",
    id_polifenol: "4781",
    polifenol: "2'-methoxykurarinone",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "20883179",
  },
  {
    id: "5840",
    id_polifenol: "2192",
    polifenol: "evernic acid",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "19199230",
  },
  {
    id: "5841",
    id_polifenol: "2737",
    polifenol: "homosalate",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "11333184",
  },
  {
    id: "5842",
    id_polifenol: "5904",
    polifenol: "2',4'-dimethoxy-6'-hydroxychalcone",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "26277982",
  },
  {
    id: "5843",
    id_polifenol: "6308",
    polifenol: "69407 compound",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "24169959",
  },
  {
    id: "5844",
    id_polifenol: "7487",
    polifenol: "5-deoxykaempferol",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "20233901",
  },
  {
    id: "5845",
    id_polifenol: "1212",
    polifenol: "oleacein",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "29959992",
  },
  {
    id: "5846",
    id_polifenol: "4028",
    polifenol: "5-deprenyllupulonol C",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "22700224",
  },
  {
    id: "5847",
    id_polifenol: "5984",
    polifenol: "2'',3''-dihydro-4,3''-dihydroxyderricin",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "22344908",
  },
  {
    id: "5848",
    id_polifenol: "5985",
    polifenol: "6'',7''-dihydro-7''-hydroxyxanthoangelol F",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "22344908",
  },
  {
    id: "5849",
    id_polifenol: "4878",
    polifenol: "amorilin",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "11790450",
  },
  {
    id: "5850",
    id_polifenol: "4877",
    polifenol: "lupinifolin",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "11790450",
  },
  {
    id: "5851",
    id_polifenol: "5822",
    polifenol: "3'-methyl-3-hydroxychalcone",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "8142919",
  },
  {
    id: "5852",
    id_polifenol: "7016",
    polifenol: "5,2',5'-trihydroxy-7-methoxyflavone",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "1318792",
  },
  {
    id: "5853",
    id_polifenol: "1815",
    polifenol: "clorophene",
    id_cancer: "618",
    cancer: "Skin Neoplasms",
    quant: "1",
    pmids: "10416269",
  },
  {
    id: "5854",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "85",
    pmids:
      "25132405,22689083,28720813,24214831,25175673,21207227,10319943,26102991,20674374,18454316,22138516,15670616,15828450,21330379,20397191,29554655,15545229,22684543,20655656,23975834,29641917,20538032,29710517,25962638,29749427,26841303,18616524,29926299,22227008,19194971,19935879,27551764,24333668,22574207,12724357,19768977,11891088,9381980,15135307,27013795,22768128,24574320,21298326,16158939,12094622,25931350,15117815,28292015,24910406,10353585,29191453,10331966,24196280,28582635,22458642,15579072,12027739,23524937,10625944,26817239,19838923,11321439,2068000,17132915,25379883,28132882,29375715,16054198,12584164,17587681,10660092,9831487,26196716,15225578,8051728,21294050,27236067,18379113,11550075,15083379,15185748,9563007,24959911,24937759,21971105",
  },
  {
    id: "5855",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "65",
    pmids:
      "21757545,24806432,21308734,28077837,23946781,19317462,21810436,18593918,23673810,12216086,19035461,28496336,29289889,26983360,16685395,21617861,25433549,28157708,12718610,29058812,25229239,25260874,20813175,25292057,23147641,15738001,15476675,19212627,16960658,20590660,17671691,15090070,27313684,19137819,19191010,29237458,15601554,25072100,12007574,12167476,19236381,24482695,21556896,24094190,29753013,25091588,27792193,29565326,23808828,23247073,21317920,24223665,21388972,28110063,29039788,24044367,26745072,19058955,28417445,29421571,20702493,26391597,23136625,26066035,26663801",
  },
  {
    id: "5856",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "52",
    pmids:
      "25625511,29751678,17258915,27658723,27535497,28868867,15482646,28496336,23858727,22057492,20083895,23110507,19944671,22871396,12964000,25260874,12452018,26762586,26211165,12053219,11518657,26297476,24966947,16905260,15649637,12094622,23912706,24051122,28545532,15756018,18543609,17202688,20482276,9414176,15901989,21317920,17120615,25379883,24691968,10766429,25930965,29039788,21687829,12131770,21078381,17378580,18629614,16860979,17261341,23771133,24937759,22160170",
  },
  {
    id: "5857",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "37",
    pmids:
      "23288142,22689083,24806432,14614450,26851630,24163404,17715378,22396784,17473185,19816982,10850453,26881937,22479527,24241351,16077199,12883736,24520095,10753939,15831676,11162898,15289335,12014647,10436007,17306610,11585739,14742319,12372346,21216934,28487957,20535544,22564552,10910078,12527913,18167127,12477973,21455573,12562385",
  },
  {
    id: "5858",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "32",
    pmids:
      "18818108,10319943,19497411,15274313,15828450,21571909,20574925,11295047,16969510,10753939,22256742,9381980,12948406,16475211,15833870,17202688,15579072,15528307,26201192,10625944,7812935,21541487,10766429,16054198,20821227,9831487,19469643,15113973,10533460,15507846,12163380,9563007",
  },
  {
    id: "5859",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "40",
    pmids:
      "15828450,14767529,29371942,19953944,19764559,19194971,15611226,12724357,9381980,29609590,15135307,27013795,16158939,27495232,9434777,25931350,9042300,17936464,23715526,24682729,10353585,23918355,15325736,10331966,17202688,10625944,21498475,25411067,16054198,24470266,9831487,17378580,8051728,21294050,18007090,17693959,15185748,9563007,24959911,21971105",
  },
  {
    id: "5860",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "33",
    pmids:
      "18818108,25625511,29751678,16731755,17902053,15706060,15482646,19189648,22057492,12960141,12053219,23553645,28051030,17499153,24966947,22769244,19020784,15649637,14769544,14981928,18351130,15756018,17202688,9414176,15901989,25195259,24915354,21687829,12131770,20973802,16050805,25405445,15142676",
  },
  {
    id: "5861",
    id_polifenol: "2167",
    polifenol: "phenolic acid",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "24",
    pmids:
      "25933717,24528072,25175673,23946781,26841303,18616524,25933595,21328179,22227008,12718610,25554642,16077199,14758047,19768977,27013795,20647029,25931350,28292015,28316643,22458642,26817239,19838923,21600977,24937759",
  },
  {
    id: "5862",
    id_polifenol: "49",
    polifenol: "Aspirin",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "25",
    pmids:
      "28636992,16596229,15036249,23611778,10607736,23874405,25061736,12396127,23703473,23019409,8625297,16444599,7653891,29152088,16818512,11180079,21743961,9521170,12452016,27236067,16618778,16751928,9102213,9823297,580932",
  },
  {
    id: "5863",
    id_polifenol: "109",
    polifenol: "Catechin",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "11",
    pmids:
      "15706060,19189648,23110507,23553645,15649637,14769544,18351130,26817239,2068000,24915354,9831487",
  },
  {
    id: "5864",
    id_polifenol: "125",
    polifenol: "Isoflavones",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "14",
    pmids:
      "18818108,21532751,15274313,15828450,27470322,29589762,15833870,15579072,21541487,10766429,20821227,14656947,15958052,23136625",
  },
  {
    id: "5865",
    id_polifenol: "110",
    polifenol: "Chalcones",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "16",
    pmids:
      "25061803,18702457,24629239,29655687,29926299,21240148,15806415,20043079,23764122,26068427,29200721,9313866,15666170,19072214,12614877,29138024",
  },
  {
    id: "5866",
    id_polifenol: "3089",
    polifenol: "1,1-diphenyl-2-picrylhydrazyl",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "10",
    pmids:
      "22354161,11297806,22074239,29337321,18473475,26817239,29476965,28482262,24959911,24937759",
  },
  {
    id: "5867",
    id_polifenol: "114",
    polifenol: "Apigenin",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "10",
    pmids:
      "10319943,15670616,29685955,25554642,27378243,16077199,21298326,29191453,17132915,29604587",
  },
  {
    id: "5868",
    id_polifenol: "113",
    polifenol: "Flavones",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "9",
    pmids:
      "26102991,20674374,20397191,20647029,22768128,21298326,25931350,29604587,9831487",
  },
  {
    id: "5869",
    id_polifenol: "38",
    polifenol: "Gallic Acid",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "11",
    pmids:
      "25933717,24528072,23975834,28672814,25933595,20564478,14981928,21299246,26817239,18629614,1576722",
  },
  {
    id: "5870",
    id_polifenol: "117",
    polifenol: "Luteolin",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "12",
    pmids:
      "10319943,22938042,21330379,20655656,24333668,27378243,23145121,15135307,27013795,16158939,29968360,17587681",
  },
  {
    id: "5871",
    id_polifenol: "1",
    polifenol: "Phenols",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "9",
    pmids:
      "16504517,20647029,17936464,24482695,18473475,29367668,20170382,26196716,7295822",
  },
  {
    id: "5872",
    id_polifenol: "105",
    polifenol: "Anthocyanins",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "3",
    pmids: "23975834,18616524,12094622",
  },
  {
    id: "5873",
    id_polifenol: "7235",
    polifenol: "silybin",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "9",
    pmids:
      "26142316,29755557,21898547,19908243,22170400,24574320,15117815,18644994,10660092",
  },
  {
    id: "5874",
    id_polifenol: "129",
    polifenol: "Rotenone",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "3",
    pmids: "12187333,10597238,20574925",
  },
  {
    id: "5875",
    id_polifenol: "121",
    polifenol: "Kaempferols",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "5",
    pmids: "10319943,15828450,20083895,16077199,27013795",
  },
  {
    id: "5876",
    id_polifenol: "871",
    polifenol: "ABT-737",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "27099439",
  },
  {
    id: "5877",
    id_polifenol: "6451",
    polifenol: "daidzein",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "6",
    pmids: "15828450,21258042,7812935,21541487,20821227,9831487",
  },
  {
    id: "5878",
    id_polifenol: "6065",
    polifenol: "baicalein",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "7",
    pmids: "25132405,22684543,29710517,16638750,8275481,14669797,17587681",
  },
  {
    id: "5879",
    id_polifenol: "7",
    polifenol: "Capsaicin",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "8",
    pmids:
      "21859781,15706060,27180305,12718610,28644386,28008282,22462738,11941450",
  },
  {
    id: "5880",
    id_polifenol: "4634",
    polifenol: "alvocidib",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "5",
    pmids: "26603262,23908594,24851111,24518598,27965750",
  },
  {
    id: "5881",
    id_polifenol: "120",
    polifenol: "Flavonols",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "7",
    pmids: "15828450,19194971,16077199,15027128,20647029,25931350,12584164",
  },
  {
    id: "5882",
    id_polifenol: "4522",
    polifenol: "chrysin",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "5",
    pmids: "10319943,18560226,22574207,15519155,9831487",
  },
  {
    id: "5883",
    id_polifenol: "123",
    polifenol: "Rutin",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "4",
    pmids: "20578533,29476965,9831487,8051728",
  },
  {
    id: "5884",
    id_polifenol: "6062",
    polifenol: "naringenin",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "2",
    pmids: "15545229,15185748",
  },
  {
    id: "5885",
    id_polifenol: "285",
    polifenol: "bisphenol A",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "14709801",
  },
  {
    id: "5886",
    id_polifenol: "39",
    polifenol: "Hydrolyzable Tannins",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "8",
    pmids:
      "10403559,12529981,11684320,29641917,16338066,28292015,20170382,1576722",
  },
  {
    id: "5887",
    id_polifenol: "130",
    polifenol: "Proanthocyanidins",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "3",
    pmids: "14758047,16597645,24937759",
  },
  {
    id: "5888",
    id_polifenol: "35",
    polifenol: "Hydroquinones",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "6",
    pmids: "16504517,15706060,3191161,18351130,16444599,11941450",
  },
  {
    id: "5889",
    id_polifenol: "4502",
    polifenol: "fisetin",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "4",
    pmids: "29749427,27551764,25520114,24297333",
  },
  {
    id: "5890",
    id_polifenol: "6",
    polifenol: "Catechols",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "2",
    pmids: "2678948,26147830",
  },
  {
    id: "5891",
    id_polifenol: "25",
    polifenol: "Butylated Hydroxytoluene",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "5",
    pmids: "3191161,18473475,7748479,7598004,3742730",
  },
  {
    id: "5892",
    id_polifenol: "75",
    polifenol: "Butylated Hydroxyanisole",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "6",
    pmids: "7748479,2678948,7598004,8339254,3742730,2591015",
  },
  {
    id: "5893",
    id_polifenol: "15",
    polifenol: "Masoprocol",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "4",
    pmids: "8747792,16638750,12396127,17667599",
  },
  {
    id: "5894",
    id_polifenol: "6087",
    polifenol: "wogonin",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "5",
    pmids: "22689083,21207227,19935879,8275481,23859016",
  },
  {
    id: "5895",
    id_polifenol: "4515",
    polifenol: "baicalin",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "4",
    pmids: "25132405,29554655,20036231,8275481",
  },
  {
    id: "5896",
    id_polifenol: "4500",
    polifenol: "procyanidin",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "2",
    pmids: "16828532,17603274",
  },
  {
    id: "5897",
    id_polifenol: "5608",
    polifenol: "epicatechin gallate",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "4",
    pmids: "15649637,17202688,9414176,24915354",
  },
  {
    id: "5898",
    id_polifenol: "1356",
    polifenol: "gingerol",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "28315687",
  },
  {
    id: "5899",
    id_polifenol: "98",
    polifenol: "Propofol",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "2",
    pmids: "25292173,27855373",
  },
  {
    id: "5900",
    id_polifenol: "5607",
    polifenol: "gallocatechol",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "5",
    pmids: "15649637,17202688,9414176,24915354,15142676",
  },
  {
    id: "5901",
    id_polifenol: "5578",
    polifenol: "alpha-naphthoflavone",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "3",
    pmids: "6802491,9831487,15797623",
  },
  {
    id: "5902",
    id_polifenol: "44",
    polifenol: "Salicylates",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "2",
    pmids: "16596229,8625297",
  },
  {
    id: "5903",
    id_polifenol: "4559",
    polifenol: "theaflavin",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "3",
    pmids: "18454316,15901989,16050805",
  },
  {
    id: "5904",
    id_polifenol: "5808",
    polifenol: "isoliquiritigenin",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "2",
    pmids: "24214831,19536869",
  },
  {
    id: "5905",
    id_polifenol: "2344",
    polifenol: "methyl gallate",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "3",
    pmids: "12960141,23110507,24966947",
  },
  {
    id: "5906",
    id_polifenol: "4708",
    polifenol: "xanthohumol",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "20043079",
  },
  {
    id: "5907",
    id_polifenol: "47",
    polifenol: "Mesalamine",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "28120908",
  },
  {
    id: "5908",
    id_polifenol: "2284",
    polifenol: "rosmarinic acid",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "2",
    pmids: "20449663,20170382",
  },
  {
    id: "5909",
    id_polifenol: "112",
    polifenol: "Hesperidin",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "29100031",
  },
  {
    id: "5910",
    id_polifenol: "6455",
    polifenol: "nobiletin",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "4",
    pmids: "25563790,20538032,23818450,26012256",
  },
  {
    id: "5911",
    id_polifenol: "10",
    polifenol: "Estrogens, Catechol",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "16287077",
  },
  {
    id: "5912",
    id_polifenol: "4513",
    polifenol: "galangin",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "29491062",
  },
  {
    id: "5913",
    id_polifenol: "5489",
    polifenol: "delphinidin",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "23975834",
  },
  {
    id: "5914",
    id_polifenol: "6273",
    polifenol: "hesperetin",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "21165578",
  },
  {
    id: "5915",
    id_polifenol: "1613",
    polifenol: "demethoxycurcumin",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "2",
    pmids: "15476675,15090070",
  },
  {
    id: "5916",
    id_polifenol: "93",
    polifenol: "Phloroglucinol",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "2236292",
  },
  {
    id: "5917",
    id_polifenol: "6454",
    polifenol: "formononetin",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "3",
    pmids: "24666255,29534504,26916669",
  },
  {
    id: "5918",
    id_polifenol: "81",
    polifenol: "Fenofibrate",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "2",
    pmids: "27757837,27183907",
  },
  {
    id: "5919",
    id_polifenol: "7550",
    polifenol: "3-methylquercetin",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "21330379",
  },
  {
    id: "5920",
    id_polifenol: "4253",
    polifenol:
      "5-(2,4-dihydroxy-5-isopropylphenyl)-4-(4-morpholin-4-ylmethylphenyl)isoxazole-3-carboxylic acid ethylamide",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "28982310",
  },
  {
    id: "5921",
    id_polifenol: "1611",
    polifenol: "bis(4-hydroxycinnamoyl)methane",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "2",
    pmids: "25433549,15090070",
  },
  {
    id: "5922",
    id_polifenol: "107",
    polifenol: "beta-Naphthoflavone",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "4",
    pmids: "24163404,16596229,9831487,1458468",
  },
  {
    id: "5923",
    id_polifenol: "119",
    polifenol: "Silymarin",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "3",
    pmids: "19317806,24030447,10660092",
  },
  {
    id: "5924",
    id_polifenol: "69",
    polifenol: "Phenolsulfonphthalein",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "2",
    pmids: "2783381,21422595",
  },
  {
    id: "5925",
    id_polifenol: "126",
    polifenol: "Coumestrol",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "26698565",
  },
  {
    id: "5926",
    id_polifenol: "5806",
    polifenol: "butein",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "25962638",
  },
  {
    id: "5927",
    id_polifenol: "108",
    polifenol: "Biflavonoids",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "3",
    pmids: "12131922,22271084,18379113",
  },
  {
    id: "5928",
    id_polifenol: "1558",
    polifenol: "capsazepine",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "22462738",
  },
  {
    id: "5929",
    id_polifenol: "5509",
    polifenol: "cyanidin 3-O-glucoside",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "18616524",
  },
  {
    id: "5930",
    id_polifenol: "969",
    polifenol: "3,4-dihydroxyphenacyl caffeate phenylpropanoid ester",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "28744911",
  },
  {
    id: "5931",
    id_polifenol: "5844",
    polifenol: "4-dimethylamino-3',4'-dimethoxychalcone",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "11138460",
  },
  {
    id: "5932",
    id_polifenol: "6463",
    polifenol: "puerarin",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "25364405",
  },
  {
    id: "5933",
    id_polifenol: "94",
    polifenol: "Phloretin",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "2",
    pmids: "25229655,28132882",
  },
  {
    id: "5934",
    id_polifenol: "48",
    polifenol: "Anacardic Acids",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "2",
    pmids: "28934859,26911844",
  },
  {
    id: "5935",
    id_polifenol: "5488",
    polifenol: "cyanidin",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "12094622",
  },
  {
    id: "5936",
    id_polifenol: "4640",
    polifenol: "5,7-dihydroxy-6-methoxy-2-phenylchromen-4-one",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "19585117",
  },
  {
    id: "5937",
    id_polifenol: "4537",
    polifenol: "flavone acetic acid",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "2790784",
  },
  {
    id: "5938",
    id_polifenol: "2773",
    polifenol: "farnesylthiosalicylic acid",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "20473860",
  },
  {
    id: "5939",
    id_polifenol: "80",
    polifenol: "Clofibrate",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "2",
    pmids: "12203367,8625460",
  },
  {
    id: "5940",
    id_polifenol: "132",
    polifenol: "Equol",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "29589762",
  },
  {
    id: "5941",
    id_polifenol: "1673",
    polifenol: "4-hydroxyestradiol",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "16287077",
  },
  {
    id: "5942",
    id_polifenol: "6482",
    polifenol: "tangeretin",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "4",
    pmids: "20538032,11675933,29375715,25151216",
  },
  {
    id: "5943",
    id_polifenol: "89",
    polifenol: "Vanillic Acid",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "24528072",
  },
  {
    id: "5944",
    id_polifenol: "99",
    polifenol: "Pyrogallol",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "26841303",
  },
  {
    id: "5945",
    id_polifenol: "452",
    polifenol: "acteoside",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "28744911",
  },
  {
    id: "5946",
    id_polifenol: "1644",
    polifenol: "Cur1 compound",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "2",
    pmids: "19137819,26745072",
  },
  {
    id: "5947",
    id_polifenol: "5614",
    polifenol: "catechin gallate",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "15649637",
  },
  {
    id: "5948",
    id_polifenol: "1866",
    polifenol: "4,6-dinitro-o-cresol",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "23219601",
  },
  {
    id: "5949",
    id_polifenol: "4486",
    polifenol: "amentoflavone",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "12131922",
  },
  {
    id: "5950",
    id_polifenol: "5850",
    polifenol: "cardamonin",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "29048425",
  },
  {
    id: "5951",
    id_polifenol: "118",
    polifenol: "Flavonolignans",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "21898547",
  },
  {
    id: "5952",
    id_polifenol: "7541",
    polifenol: "taxifolin",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "25379883",
  },
  {
    id: "5953",
    id_polifenol: "7912",
    polifenol: "7,9,2',4'-tetrahydroxy-8-isopentenyl-5-methoxychalcone",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "12614877",
  },
  {
    id: "5954",
    id_polifenol: "6465",
    polifenol: "genistin",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "20821227",
  },
  {
    id: "5955",
    id_polifenol: "350",
    polifenol: "nonylphenol",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "15958052",
  },
  {
    id: "5956",
    id_polifenol: "6097",
    polifenol: "8-prenylnaringenin",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "11675933",
  },
  {
    id: "5957",
    id_polifenol: "1996",
    polifenol: "2,5-di-tert-butylhydroquinone",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "28846107",
  },
  {
    id: "5958",
    id_polifenol: "6576",
    polifenol: "5,7,4'-trihydroxyflavone",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "29491062",
  },
  {
    id: "5959",
    id_polifenol: "6625",
    polifenol: "phenoxodiol",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "15833870",
  },
  {
    id: "5960",
    id_polifenol: "6086",
    polifenol: "liquiritigenin",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "24738081",
  },
  {
    id: "5961",
    id_polifenol: "1616",
    polifenol: "tetrahydrocurcumin",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "16960658",
  },
  {
    id: "5962",
    id_polifenol: "7296",
    polifenol: "dihydromyricetin",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "29039563",
  },
  {
    id: "5963",
    id_polifenol: "40",
    polifenol: "Propyl Gallate",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "9570287",
  },
  {
    id: "5964",
    id_polifenol: "36",
    polifenol: "Hydroxybenzoates",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "19282185",
  },
  {
    id: "5965",
    id_polifenol: "6558",
    polifenol: "7,3'-dihydroxy-4'-methoxyisoflavone",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "29966979",
  },
  {
    id: "5966",
    id_polifenol: "349",
    polifenol: "4-nitrophenol",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "28646755",
  },
  {
    id: "5967",
    id_polifenol: "6301",
    polifenol: "3-methoxyflavone",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "17715378",
  },
  {
    id: "5968",
    id_polifenol: "1810",
    polifenol: "heminordihydroguaiaretic acid",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "8747792",
  },
  {
    id: "5969",
    id_polifenol: "6783",
    polifenol: "protoapigenone",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "26974964",
  },
  {
    id: "5970",
    id_polifenol: "128",
    polifenol: "Pterocarpans",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "28316643",
  },
  {
    id: "5971",
    id_polifenol: "6456",
    polifenol: "daidzin",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "20821227",
  },
  {
    id: "5972",
    id_polifenol: "1353",
    polifenol: "protocatechualdehyde",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "2",
    pmids: "29285297,11297806",
  },
  {
    id: "5973",
    id_polifenol: "4883",
    polifenol: "flavokawain B",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "23764122",
  },
  {
    id: "5974",
    id_polifenol: "4304",
    polifenol: "5-7-oxo-zeaenol",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "17172402",
  },
  {
    id: "5975",
    id_polifenol: "353",
    polifenol: "sesamol",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "2",
    pmids: "11297806,2678948",
  },
  {
    id: "5976",
    id_polifenol: "3019",
    polifenol: "nitroaspirin",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "2",
    pmids: "23019409,16818512",
  },
  {
    id: "5977",
    id_polifenol: "413",
    polifenol: "4-nonylphenol",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "14709801",
  },
  {
    id: "5978",
    id_polifenol: "115",
    polifenol: "Diosmin",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "22289577",
  },
  {
    id: "5979",
    id_polifenol: "87",
    polifenol: "Metoclopramide",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "8417832",
  },
  {
    id: "5980",
    id_polifenol: "2014",
    polifenol: "erbstatin",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "18855573",
  },
  {
    id: "5981",
    id_polifenol: "5831",
    polifenol: "angoletin",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "2",
    pmids: "19259708,22458642",
  },
  {
    id: "5982",
    id_polifenol: "885",
    polifenol: "oleocanthal",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "21328179",
  },
  {
    id: "5983",
    id_polifenol: "6112",
    polifenol: "alpinetin",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "21240148",
  },
  {
    id: "5984",
    id_polifenol: "896",
    polifenol: "polyphenon B",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "4",
    pmids: "17258915,16905260,18543609,17120615",
  },
  {
    id: "5985",
    id_polifenol: "711",
    polifenol: "ascochlorin",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "2",
    pmids: "22109717,18057697",
  },
  {
    id: "5986",
    id_polifenol: "7741",
    polifenol: "biochanin A",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "3",
    pmids: "27470322,21541487,9831487",
  },
  {
    id: "5987",
    id_polifenol: "357",
    polifenol: "4-aminophenol",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "28646755",
  },
  {
    id: "5988",
    id_polifenol: "4479",
    polifenol: "morin",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "12584164",
  },
  {
    id: "5989",
    id_polifenol: "1687",
    polifenol: "2-hydroxyestrone",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "28454423",
  },
  {
    id: "5990",
    id_polifenol: "6100",
    polifenol: "pinostrobin",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "2",
    pmids: "21240148,11321439",
  },
  {
    id: "5991",
    id_polifenol: "6774",
    polifenol: "5,7-dihydroxy-6,3',4'-trimethoxyflavone",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "22227008",
  },
  {
    id: "5992",
    id_polifenol: "315",
    polifenol: "bakuchiol",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "26910280",
  },
  {
    id: "5993",
    id_polifenol: "4839",
    polifenol: "7-hydroxyflavone",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "22574207",
  },
  {
    id: "5994",
    id_polifenol: "5885",
    polifenol: "2',4'-dihydroxy-6'-methoxy-3',5'-dimethylchalcone",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "3",
    pmids: "15806415,15666170,16038525",
  },
  {
    id: "5995",
    id_polifenol: "428",
    polifenol: "2,2'-bisphenol F",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "25433549",
  },
  {
    id: "5996",
    id_polifenol: "4639",
    polifenol: "aromadedrin",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "25379883",
  },
  {
    id: "5997",
    id_polifenol: "6497",
    polifenol: "isoflavanone",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "2",
    pmids: "15274313,12614877",
  },
  {
    id: "5998",
    id_polifenol: "5615",
    polifenol: "gallocatechin gallate",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "17202688",
  },
  {
    id: "5999",
    id_polifenol: "1662",
    polifenol: "BDMC-A",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "25433549",
  },
  {
    id: "6000",
    id_polifenol: "826",
    polifenol: "4,4',4''-(4-propyl-((1)H)-pyrazole-1,3,5-triyl) tris-phenol",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "23236424",
  },
  {
    id: "6001",
    id_polifenol: "7437",
    polifenol: "kaempferol-3-O-rutinoside",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "27013795",
  },
  {
    id: "6002",
    id_polifenol: "4703",
    polifenol: "eupatorin",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "22227008",
  },
  {
    id: "6003",
    id_polifenol: "2471",
    polifenol: "oenothein B",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "10403559",
  },
  {
    id: "6004",
    id_polifenol: "2693",
    polifenol: "copper bis(3,5-diisopropylsalicylate)",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "2",
    pmids: "7748479,7598004",
  },
  {
    id: "6005",
    id_polifenol: "6684",
    polifenol: "eupafolin",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "20397191",
  },
  {
    id: "6006",
    id_polifenol: "2173",
    polifenol: "atranorin",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "2",
    pmids: "25233603,26969521",
  },
  {
    id: "6007",
    id_polifenol: "6680",
    polifenol: "6,7,4'-trihydroxyisoflavone",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "21258042",
  },
  {
    id: "6008",
    id_polifenol: "444",
    polifenol: "2,4-di-tert-butylphenol",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "19471192",
  },
  {
    id: "6009",
    id_polifenol: "1509",
    polifenol: "8-gingerol",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "28315687",
  },
  {
    id: "6010",
    id_polifenol: "1883",
    polifenol: "2-amino-5-methylphenol",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "11081459",
  },
  {
    id: "6011",
    id_polifenol: "3606",
    polifenol:
      "5-(3-methoxy-4-((4-methoxybenzyl)oxy)benzyl)pyrimidine-2,4-diamine",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "23995783",
  },
  {
    id: "6012",
    id_polifenol: "52",
    polifenol: "Diflunisal",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "21573528",
  },
  {
    id: "6013",
    id_polifenol: "1492",
    polifenol: "hirsutenone",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "21120579",
  },
  {
    id: "6014",
    id_polifenol: "1811",
    polifenol: "terameprocol",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "17667599",
  },
  {
    id: "6015",
    id_polifenol: "400",
    polifenol: "cardanol",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "2",
    pmids: "28934859,22458642",
  },
  {
    id: "6016",
    id_polifenol: "5909",
    polifenol: "licochalcone E",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "23625311",
  },
  {
    id: "6017",
    id_polifenol: "2484",
    polifenol: "chebulinic acid",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "16338066",
  },
  {
    id: "6018",
    id_polifenol: "1867",
    polifenol: "creosol",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "25026266",
  },
  {
    id: "6019",
    id_polifenol: "4574",
    polifenol: "sinensetin",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "20538032",
  },
  {
    id: "6020",
    id_polifenol: "6786",
    polifenol: "8-hydroxy-3,4',5,6,7-pentamethoxyflavone",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "20538032",
  },
  {
    id: "6021",
    id_polifenol: "2026",
    polifenol: "phenylhydroquinone",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "10334203",
  },
  {
    id: "6022",
    id_polifenol: "6478",
    polifenol: "cirsilineol",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "22768128",
  },
  {
    id: "6023",
    id_polifenol: "5697",
    polifenol:
      "3-(3,4-dimethoxyphenyl)-1-(5-hydroxy-2,2-dimethyl-2H-chromen-6-yl)prop-2-en-1-one",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "27658723",
  },
  {
    id: "6024",
    id_polifenol: "6803",
    polifenol: "isoscutellarein",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "20538032",
  },
  {
    id: "6025",
    id_polifenol: "4579",
    polifenol: "hinokiflavone",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "22271084",
  },
  {
    id: "6026",
    id_polifenol: "2768",
    polifenol: "salophen",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "2",
    pmids: "19259708,25495038",
  },
  {
    id: "6027",
    id_polifenol: "1204",
    polifenol: "2-isopropyl-5-methylphenol",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "18473475",
  },
  {
    id: "6028",
    id_polifenol: "2401",
    polifenol: "2,3,5-trihydroxybenzoic acid",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "28672814",
  },
  {
    id: "6029",
    id_polifenol: "1372",
    polifenol: "3-methylcatechol",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "2678948",
  },
  {
    id: "6030",
    id_polifenol: "3435",
    polifenol: "N1-hydroxy-N8-(4-phenoxyphenyl)octanediamide",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "20596669",
  },
  {
    id: "6031",
    id_polifenol: "184",
    polifenol: "trilobatin",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "25229655",
  },
  {
    id: "6032",
    id_polifenol: "6330",
    polifenol: "5,6,2',3',4'-pentamethoxyflavone",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "25151216",
  },
  {
    id: "6033",
    id_polifenol: "2760",
    polifenol: "2-methoxybenzoic acid",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "29600718",
  },
  {
    id: "6034",
    id_polifenol: "521",
    polifenol: "E 7010",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "9654112",
  },
  {
    id: "6035",
    id_polifenol: "2607",
    polifenol: "amorfrutin A",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "28879797",
  },
  {
    id: "6036",
    id_polifenol: "4203",
    polifenol: "methyl orsellinate",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "25233603",
  },
  {
    id: "6037",
    id_polifenol: "5178",
    polifenol: "Flavin7",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "25930965",
  },
  {
    id: "6038",
    id_polifenol: "7066",
    polifenol: "diethyl flavon-7-yl phosphate",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "22574207",
  },
  {
    id: "6039",
    id_polifenol: "1586",
    polifenol: "hydrazinobenzoylcurcumin",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "24044367",
  },
  {
    id: "6040",
    id_polifenol: "1781",
    polifenol: "CA 432",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "21369694",
  },
  {
    id: "6041",
    id_polifenol: "78",
    polifenol: "Clofenapate",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "9298250",
  },
  {
    id: "6042",
    id_polifenol: "2213",
    polifenol: "diffractaic acid",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "25233603",
  },
  {
    id: "6043",
    id_polifenol: "2498",
    polifenol: "thonningianin A",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "26119846",
  },
  {
    id: "6044",
    id_polifenol: "2464",
    polifenol: "camelliin B",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "11684320",
  },
  {
    id: "6045",
    id_polifenol: "4637",
    polifenol: "agathisflavone",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "12131922",
  },
  {
    id: "6046",
    id_polifenol: "7877",
    polifenol: "helichrysetin",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "29200721",
  },
  {
    id: "6047",
    id_polifenol: "499",
    polifenol: "Sunphenon",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "10331966",
  },
  {
    id: "6048",
    id_polifenol: "3969",
    polifenol: "arzanol",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "28476462",
  },
  {
    id: "6049",
    id_polifenol: "2361",
    polifenol: "tellimagrandin I",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "16338066",
  },
  {
    id: "6050",
    id_polifenol: "6314",
    polifenol: "2-(4-(dimethylamino)phenyl)-7,8-dihydroxy-4H-chromen-4-one",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "22768128",
  },
  {
    id: "6051",
    id_polifenol: "2049",
    polifenol: "menahydroquinone-4",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "28943616",
  },
  {
    id: "6052",
    id_polifenol: "6327",
    polifenol: "6-methoxyflavone",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "27086008",
  },
  {
    id: "6053",
    id_polifenol: "1794",
    polifenol:
      "4-(3-hydroxy-4-methoxyphenyl)-3-(4-hydroxyphenyl)-1-(3,4,5-trimethoxyphenyl)azetidin-2-one",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "23564200",
  },
  {
    id: "6054",
    id_polifenol: "984",
    polifenol: "tapentadol",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "24917026",
  },
  {
    id: "6055",
    id_polifenol: "3926",
    polifenol: "mallotojaponin",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "2236292",
  },
  {
    id: "6056",
    id_polifenol: "1816",
    polifenol: "4-(2,4-dichlorophenoxy)butyric acid",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "24163404",
  },
  {
    id: "6057",
    id_polifenol: "4379",
    polifenol:
      "2-(piperidinoethoxyphenyl)-3-(4-hydroxyphenyl)-2H-benzo(b)pyran",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "25144715",
  },
  {
    id: "6058",
    id_polifenol: "6643",
    polifenol: "osajin",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "21532751",
  },
  {
    id: "6059",
    id_polifenol: "1345",
    polifenol: "sonnerphenolic C",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "25933595",
  },
  {
    id: "6060",
    id_polifenol: "2872",
    polifenol: "norstictic acid",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "25233603",
  },
  {
    id: "6061",
    id_polifenol: "1402",
    polifenol: "2,4-dihydroxybenzylamine",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "11297806",
  },
  {
    id: "6062",
    id_polifenol: "4360",
    polifenol: "tatariside G",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "25076146",
  },
  {
    id: "6063",
    id_polifenol: "1474",
    polifenol: "myxochelin B",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "19282185",
  },
  {
    id: "6064",
    id_polifenol: "2063",
    polifenol: "4-hydroxy-2-phenylphenol",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "10334203",
  },
  {
    id: "6065",
    id_polifenol: "615",
    polifenol: "2-allylphenol",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "29367668",
  },
  {
    id: "6066",
    id_polifenol: "4896",
    polifenol: "3-O-(2-methylbutyroyl)pinobanksin",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "12027739",
  },
  {
    id: "6067",
    id_polifenol: "4897",
    polifenol: "6-cinnamylchrysin",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "12027739",
  },
  {
    id: "6068",
    id_polifenol: "6631",
    polifenol: "fujiflavone P40",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "14656947",
  },
  {
    id: "6069",
    id_polifenol: "3241",
    polifenol: "ethericin B",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "25026266",
  },
  {
    id: "6070",
    id_polifenol: "4140",
    polifenol: "olivetol",
    id_cancer: "3224",
    cancer: "Carcinoma",
    quant: "1",
    pmids: "9875457",
  },
  {
    id: "6071",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "71",
    pmids:
      "28805696,25083589,29628889,27184816,29467859,15246561,22980865,25830055,23727915,23902763,26797785,22687635,25755690,26986176,27752089,29275301,21210297,25948105,26297431,29632297,23438826,27887793,26692948,21618507,21402146,28423703,25860498,29734739,17548900,27444692,27904686,22227970,23371323,22552526,29614624,9224209,29024631,23500080,29392841,28440514,28035396,27539140,21059620,23173924,28487966,19733932,22665077,28648644,17266043,25738754,29752123,27039735,25944486,26320438,26884726,26320439,27262066,29495431,26320443,21856323,28404902,16751978,20166210,29600977,28178217,23479391,21550553,18465538,12819936,26976141,19474164",
  },
  {
    id: "6072",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "71",
    pmids:
      "25169542,23224523,24938356,27026405,21973306,26351877,24083709,16005433,28861154,25963361,16685393,20651361,27431486,26498137,24293118,26531053,24156374,27628049,25667441,25444916,21810436,28187956,20127174,28991167,25847862,21493726,27424491,12807725,21858220,29328421,25716014,24512728,22189907,18414057,28660665,16521985,25683568,29674274,24835302,21484077,24445050,27221847,21199169,28618934,28420097,26656720,17137104,28435247,28677094,15883009,27908756,19477063,21567511,23730903,29201217,27645308,16572896,19283527,24094190,23739680,27671306,25578635,28980920,21472350,28443468,26332341,27301194,22126905,28231299,28117012,28130133",
  },
  {
    id: "6073",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "26",
    pmids:
      "27829129,24247527,27268146,28443025,24008975,29230104,25845434,25667441,24343902,27748367,27470574,16394628,19638461,25661371,22043989,29200719,27270317,27259219,29054984,23912706,24456610,16235994,28302224,26884726,27485636,28105248",
  },
  {
    id: "6074",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "49",
    pmids:
      "25598321,22466960,23707609,27693704,25889897,19147542,16570272,24766860,21575631,27620163,29749533,25948105,15767261,28900483,29328374,26931433,21762625,26881937,17600315,15037618,22438908,12181740,9407138,29100274,23233127,25769181,25238880,24664993,18942115,12204896,29524402,19305150,26918447,15138593,17476138,15471877,26922319,27180173,10098632,29901173,16009452,23306155,17143528,21412767,21698152,24351425,28904859,22359227,27248324",
  },
  {
    id: "6075",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "20",
    pmids:
      "10226546,22160570,10368806,27029077,25364470,9588219,19460433,29321496,19288574,8104437,9795970,11121866,21966475,9334814,8652271,27485636,11052627,27696403,15276495,17406801",
  },
  {
    id: "6076",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "15",
    pmids:
      "25830055,23727915,28495516,27887793,17548900,21396480,9224209,28420097,17137104,28648644,26807543,22358425,28178217,16619537,29285083",
  },
  {
    id: "6077",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "19",
    pmids:
      "29332333,24734098,24008975,29230104,25845434,23292117,24712372,24944597,24269590,19638461,25661371,27270317,21199169,24634598,23739680,16235994,26046674,23725836,10783312",
  },
  {
    id: "6078",
    id_polifenol: "2167",
    polifenol: "phenolic acid",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "14",
    pmids:
      "25381036,25083589,21973306,27375080,21493726,26758192,27489231,20647029,21567511,27597244,27262066,28105248,28178217,24243401",
  },
  {
    id: "6079",
    id_polifenol: "49",
    polifenol: "Aspirin",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "9",
    pmids:
      "19628293,11093779,29421569,17342322,9615719,12576442,26810856,15639720,24958470",
  },
  {
    id: "6080",
    id_polifenol: "109",
    polifenol: "Catechin",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "7",
    pmids: "19233505,24944597,27259219,21199169,24634598,28105248,29600977",
  },
  {
    id: "6081",
    id_polifenol: "125",
    polifenol: "Isoflavones",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "5",
    pmids: "22814678,29393465,21325978,27793905,9224209",
  },
  {
    id: "6082",
    id_polifenol: "110",
    polifenol: "Chalcones",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "16",
    pmids:
      "15236626,22019186,24747188,23554101,27317025,26878127,28737782,28494257,25368326,29065840,26021707,24312796,19714673,27770383,22358425,20594863",
  },
  {
    id: "6083",
    id_polifenol: "3089",
    polifenol: "1,1-diphenyl-2-picrylhydrazyl",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "8",
    pmids:
      "18720191,20548938,23173924,27039735,26320438,26320439,26320443,28105248",
  },
  {
    id: "6084",
    id_polifenol: "114",
    polifenol: "Apigenin",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "2",
    pmids: "27752089,24926787",
  },
  {
    id: "6085",
    id_polifenol: "113",
    polifenol: "Flavones",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "8",
    pmids:
      "29734739,17363486,10537362,29487530,29116937,20647029,17363487,19714673",
  },
  {
    id: "6086",
    id_polifenol: "38",
    polifenol: "Gallic Acid",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "5",
    pmids: "29200719,27419630,27597244,29928970,28105248",
  },
  {
    id: "6087",
    id_polifenol: "117",
    polifenol: "Luteolin",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "13",
    pmids:
      "29393891,21601631,24747074,22803372,21402146,25586525,22552526,22206675,28035396,26096576,17583406,24471765,27465923",
  },
  {
    id: "6088",
    id_polifenol: "1",
    polifenol: "Phenols",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "2",
    pmids: "20647029,27777383",
  },
  {
    id: "6089",
    id_polifenol: "105",
    polifenol: "Anthocyanins",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "5",
    pmids: "24124611,22659736,27485636,28105248,24243401",
  },
  {
    id: "6090",
    id_polifenol: "7235",
    polifenol: "silybin",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "12",
    pmids:
      "19908243,28440514,28926892,25960639,22965008,12894553,27753543,23461975,29472856,24047698,25944486,23916468",
  },
  {
    id: "6091",
    id_polifenol: "129",
    polifenol: "Rotenone",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "5",
    pmids: "25674209,25364470,12821677,25522273,23479391",
  },
  {
    id: "6092",
    id_polifenol: "121",
    polifenol: "Kaempferols",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "10",
    pmids:
      "26323894,26297431,25000464,29200719,20548938,17583406,29752123,26181204,28105248,28178217",
  },
  {
    id: "6093",
    id_polifenol: "871",
    polifenol: "ABT-737",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "13",
    pmids:
      "27816990,25034785,17973573,18362892,27138804,19773376,25139387,28319809,22006676,23485022,29312548,27247353,17688235",
  },
  {
    id: "6094",
    id_polifenol: "6065",
    polifenol: "baicalein",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "5",
    pmids: "17050058,25948105,29614624,29392841,27586635",
  },
  {
    id: "6095",
    id_polifenol: "7",
    polifenol: "Capsaicin",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "2",
    pmids: "24444609,24926985",
  },
  {
    id: "6096",
    id_polifenol: "4634",
    polifenol: "alvocidib",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "16",
    pmids:
      "11368340,21575631,10537362,12566305,10375610,16982772,27001952,8895733,10788588,17145885,11052627,15217973,16432172,18465538,12819936,11410495",
  },
  {
    id: "6097",
    id_polifenol: "120",
    polifenol: "Flavonols",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "9",
    pmids:
      "27444344,26948085,26692948,24267912,20647029,17583406,26859114,7623025,28178217",
  },
  {
    id: "6098",
    id_polifenol: "4522",
    polifenol: "chrysin",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "5",
    pmids: "21801359,29116937,27151585,17266043,21856323",
  },
  {
    id: "6099",
    id_polifenol: "123",
    polifenol: "Rutin",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "9224209",
  },
  {
    id: "6100",
    id_polifenol: "6062",
    polifenol: "naringenin",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "2",
    pmids: "21877710,20669244",
  },
  {
    id: "6101",
    id_polifenol: "39",
    polifenol: "Hydrolyzable Tannins",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "15746577",
  },
  {
    id: "6102",
    id_polifenol: "130",
    polifenol: "Proanthocyanidins",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "7",
    pmids: "15621344,24798688,22087318,18680102,20145019,28487966,19188152",
  },
  {
    id: "6103",
    id_polifenol: "35",
    polifenol: "Hydroquinones",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "3",
    pmids: "26630137,15571862,28459574",
  },
  {
    id: "6104",
    id_polifenol: "111",
    polifenol: "Flavanones",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "22019186",
  },
  {
    id: "6105",
    id_polifenol: "4502",
    polifenol: "fisetin",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "9",
    pmids:
      "25381036,29467859,26797785,26692948,21618507,27904686,28859099,26884726,29495431",
  },
  {
    id: "6106",
    id_polifenol: "25",
    polifenol: "Butylated Hydroxytoluene",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "2",
    pmids: "18345025,19672312",
  },
  {
    id: "6107",
    id_polifenol: "75",
    polifenol: "Butylated Hydroxyanisole",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "5",
    pmids: "24747074,21143894,23371323,23173924,22665077",
  },
  {
    id: "6108",
    id_polifenol: "15",
    polifenol: "Masoprocol",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "4",
    pmids: "20668019,16882662,27845352,10626810",
  },
  {
    id: "6109",
    id_polifenol: "6087",
    polifenol: "wogonin",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "4",
    pmids: "23371323,22665077,17266043,28338770",
  },
  {
    id: "6110",
    id_polifenol: "4519",
    polifenol: "myricetin",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "2",
    pmids: "28105248,28178217",
  },
  {
    id: "6111",
    id_polifenol: "4515",
    polifenol: "baicalin",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "29632297",
  },
  {
    id: "6112",
    id_polifenol: "5608",
    polifenol: "epicatechin gallate",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "16235994",
  },
  {
    id: "6113",
    id_polifenol: "1356",
    polifenol: "gingerol",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "2",
    pmids: "24282290,27645308",
  },
  {
    id: "6114",
    id_polifenol: "54",
    polifenol: "Salicylic Acid",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "25000464",
  },
  {
    id: "6115",
    id_polifenol: "98",
    polifenol: "Propofol",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "28426124",
  },
  {
    id: "6116",
    id_polifenol: "5607",
    polifenol: "gallocatechol",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "25000464",
  },
  {
    id: "6117",
    id_polifenol: "4559",
    polifenol: "theaflavin",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "16235994",
  },
  {
    id: "6118",
    id_polifenol: "5808",
    polifenol: "isoliquiritigenin",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "2",
    pmids: "15236626,25368326",
  },
  {
    id: "6119",
    id_polifenol: "4708",
    polifenol: "xanthohumol",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "2",
    pmids: "27317025,26664015",
  },
  {
    id: "6120",
    id_polifenol: "112",
    polifenol: "Hesperidin",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "4",
    pmids: "29138795,25860498,29200719,29604270",
  },
  {
    id: "6121",
    id_polifenol: "6455",
    polifenol: "nobiletin",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "2",
    pmids: "26986176,24687742",
  },
  {
    id: "6122",
    id_polifenol: "1380",
    polifenol: "shogaol",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "4",
    pmids: "19799425,24282290,29462602,27645308",
  },
  {
    id: "6123",
    id_polifenol: "2158",
    polifenol: "protocatechuic acid",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "2",
    pmids: "25356681,25000464",
  },
  {
    id: "6124",
    id_polifenol: "5489",
    polifenol: "delphinidin",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "3",
    pmids: "24124611,22659736,27485636",
  },
  {
    id: "6125",
    id_polifenol: "1613",
    polifenol: "demethoxycurcumin",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "3",
    pmids: "21484077,17137104,25760774",
  },
  {
    id: "6126",
    id_polifenol: "6454",
    polifenol: "formononetin",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "2",
    pmids: "25674209,28105248",
  },
  {
    id: "6127",
    id_polifenol: "7550",
    polifenol: "3-methylquercetin",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "2",
    pmids: "25755690,28178217",
  },
  {
    id: "6128",
    id_polifenol: "6461",
    polifenol: "acacetin",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "4",
    pmids: "15246561,21210297,22665077,28859099",
  },
  {
    id: "6129",
    id_polifenol: "4253",
    polifenol:
      "5-(2,4-dihydroxy-5-isopropylphenyl)-4-(4-morpholin-4-ylmethylphenyl)isoxazole-3-carboxylic acid ethylamide",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "7",
    pmids: "25607753,25416789,21996088,26723875,23493311,28797845,26870271",
  },
  {
    id: "6130",
    id_polifenol: "1611",
    polifenol: "bis(4-hydroxycinnamoyl)methane",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "7",
    pmids: "25716561,25963361,21933103,21484077,17137104,28677094,26332341",
  },
  {
    id: "6131",
    id_polifenol: "107",
    polifenol: "beta-Naphthoflavone",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "3011249",
  },
  {
    id: "6132",
    id_polifenol: "55",
    polifenol: "Sodium Salicylate",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "26415823",
  },
  {
    id: "6133",
    id_polifenol: "5806",
    polifenol: "butein",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "24974831",
  },
  {
    id: "6134",
    id_polifenol: "108",
    polifenol: "Biflavonoids",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "2",
    pmids: "29190983,27838742",
  },
  {
    id: "6135",
    id_polifenol: "969",
    polifenol: "3,4-dihydroxyphenacyl caffeate phenylpropanoid ester",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "23302524",
  },
  {
    id: "6136",
    id_polifenol: "5844",
    polifenol: "4-dimethylamino-3',4'-dimethoxychalcone",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "11138460",
  },
  {
    id: "6137",
    id_polifenol: "6463",
    polifenol: "puerarin",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "2",
    pmids: "29393465,28101568",
  },
  {
    id: "6138",
    id_polifenol: "5819",
    polifenol: "licochalcone A",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "2",
    pmids: "28805696,27184816",
  },
  {
    id: "6139",
    id_polifenol: "94",
    polifenol: "Phloretin",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "2",
    pmids: "26503828,26692364",
  },
  {
    id: "6140",
    id_polifenol: "5488",
    polifenol: "cyanidin",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "22659736",
  },
  {
    id: "6141",
    id_polifenol: "4640",
    polifenol: "5,7-dihydroxy-6-methoxy-2-phenylchromen-4-one",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "2",
    pmids: "28472762,23500080",
  },
  {
    id: "6142",
    id_polifenol: "4537",
    polifenol: "flavone acetic acid",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "2",
    pmids: "20166210,21550553",
  },
  {
    id: "6143",
    id_polifenol: "2773",
    polifenol: "farnesylthiosalicylic acid",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "2",
    pmids: "20473860,18374183",
  },
  {
    id: "6144",
    id_polifenol: "1995",
    polifenol: "2-tert-butylhydroquinone",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "2",
    pmids: "23707609,29363720",
  },
  {
    id: "6145",
    id_polifenol: "6482",
    polifenol: "tangeretin",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "2",
    pmids: "23926120,26569090",
  },
  {
    id: "6146",
    id_polifenol: "99",
    polifenol: "Pyrogallol",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "19233505",
  },
  {
    id: "6147",
    id_polifenol: "1644",
    polifenol: "Cur1 compound",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "28130133",
  },
  {
    id: "6148",
    id_polifenol: "100",
    polifenol: "Resorcinols",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "3",
    pmids: "24392814,29202402,24345447",
  },
  {
    id: "6149",
    id_polifenol: "118",
    polifenol: "Flavonolignans",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "3",
    pmids: "22965008,23461975,24047698",
  },
  {
    id: "6150",
    id_polifenol: "7544",
    polifenol: "quercitrin",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "2",
    pmids: "25193878,28178217",
  },
  {
    id: "6151",
    id_polifenol: "7912",
    polifenol: "7,9,2',4'-tetrahydroxy-8-isopentenyl-5-methoxychalcone",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "26664015",
  },
  {
    id: "6152",
    id_polifenol: "2475",
    polifenol: "6-O-galloylglucose",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "24243401",
  },
  {
    id: "6153",
    id_polifenol: "92",
    polifenol: "Triclosan",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "27133297",
  },
  {
    id: "6154",
    id_polifenol: "1996",
    polifenol: "2,5-di-tert-butylhydroquinone",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "23707609",
  },
  {
    id: "6155",
    id_polifenol: "5071",
    polifenol: "icaritin",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "25135717",
  },
  {
    id: "6156",
    id_polifenol: "4585",
    polifenol: "baohuoside I",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "4",
    pmids: "22687635,26859114,29260980,26644047",
  },
  {
    id: "6157",
    id_polifenol: "1616",
    polifenol: "tetrahydrocurcumin",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "29436654",
  },
  {
    id: "6158",
    id_polifenol: "7161",
    polifenol: "scutellarin",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "29487530",
  },
  {
    id: "6159",
    id_polifenol: "2328",
    polifenol: "syringic acid",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "25000464",
  },
  {
    id: "6160",
    id_polifenol: "7296",
    polifenol: "dihydromyricetin",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "27539140",
  },
  {
    id: "6161",
    id_polifenol: "40",
    polifenol: "Propyl Gallate",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "27375080",
  },
  {
    id: "6162",
    id_polifenol: "5630",
    polifenol: "polyphenon E",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "24343902",
  },
  {
    id: "6163",
    id_polifenol: "7547",
    polifenol: "hyperoside",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "26948085",
  },
  {
    id: "6164",
    id_polifenol: "5495",
    polifenol: "malvidin",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "22659736",
  },
  {
    id: "6165",
    id_polifenol: "637",
    polifenol: "glabridin",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "21059620",
  },
  {
    id: "6166",
    id_polifenol: "77",
    polifenol: "Bezafibrate",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "24302581",
  },
  {
    id: "6167",
    id_polifenol: "1810",
    polifenol: "heminordihydroguaiaretic acid",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "2",
    pmids: "21107289,10626810",
  },
  {
    id: "6168",
    id_polifenol: "7557",
    polifenol: "rhamnetin",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "23902763",
  },
  {
    id: "6169",
    id_polifenol: "4883",
    polifenol: "flavokawain B",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "22729748",
  },
  {
    id: "6170",
    id_polifenol: "2574",
    polifenol: "4-hydroxybenzoic acid",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "22384985",
  },
  {
    id: "6171",
    id_polifenol: "3019",
    polifenol: "nitroaspirin",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "19628293",
  },
  {
    id: "6172",
    id_polifenol: "4521",
    polifenol: "3-hydroxyflavone",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "23438826",
  },
  {
    id: "6173",
    id_polifenol: "1672",
    polifenol: "B19 monocarbonyl curcumin",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "2",
    pmids: "24156374,22189907",
  },
  {
    id: "6174",
    id_polifenol: "4715",
    polifenol: "ampelopsin",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "27299463",
  },
  {
    id: "6175",
    id_polifenol: "6800",
    polifenol: "3,6-dimethoxy-6'',6''-dimethylchromeno(2'',3''-7,8)flavone",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "28285685",
  },
  {
    id: "6176",
    id_polifenol: "1747",
    polifenol: "6-paradol",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "24282290",
  },
  {
    id: "6177",
    id_polifenol: "2697",
    polifenol: "4-trifluoromethylsalicylic acid",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "3",
    pmids: "27137757,22684020,22806905",
  },
  {
    id: "6178",
    id_polifenol: "12",
    polifenol: "Guaiacol",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "24121236",
  },
  {
    id: "6179",
    id_polifenol: "6166",
    polifenol: "liquiritin",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "24247527",
  },
  {
    id: "6180",
    id_polifenol: "9",
    polifenol: "1,2-Dihydroxybenzene-3,5-Disulfonic Acid Disodium Salt",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "2",
    pmids: "24496038,28153500",
  },
  {
    id: "6181",
    id_polifenol: "315",
    polifenol: "bakuchiol",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "20599920",
  },
  {
    id: "6182",
    id_polifenol: "1918",
    polifenol: "2,6-di-tert-butyl-4-(aminomethyl)phenol hydrochloride",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "2",
    pmids: "23185274,17688235",
  },
  {
    id: "6183",
    id_polifenol: "5538",
    polifenol: "petunidin",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "22659736",
  },
  {
    id: "6184",
    id_polifenol: "5875",
    polifenol: "panduratin A",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "2",
    pmids: "21441862,23887718",
  },
  {
    id: "6185",
    id_polifenol: "4839",
    polifenol: "7-hydroxyflavone",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "29116937",
  },
  {
    id: "6186",
    id_polifenol: "5537",
    polifenol: "peonidin",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "22659736",
  },
  {
    id: "6187",
    id_polifenol: "4981",
    polifenol: "jaceosidin",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "27262066",
  },
  {
    id: "6188",
    id_polifenol: "4639",
    polifenol: "aromadedrin",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "25000464",
  },
  {
    id: "6189",
    id_polifenol: "4782",
    polifenol: "kurarinone",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "29628889",
  },
  {
    id: "6190",
    id_polifenol: "4632",
    polifenol: "ginkgetin",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "29190983",
  },
  {
    id: "6191",
    id_polifenol: "2807",
    polifenol: "thiosalicylic acid",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "18475878",
  },
  {
    id: "6192",
    id_polifenol: "5542",
    polifenol: "delphinidin 3-O-glucopyranoside",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "27485636",
  },
  {
    id: "6193",
    id_polifenol: "4544",
    polifenol: "tiliroside",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "25000464",
  },
  {
    id: "6194",
    id_polifenol: "1237",
    polifenol: "2,4-bis(p-hydroxyphenyl)-2-butenal",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "23082969",
  },
  {
    id: "6195",
    id_polifenol: "1754",
    polifenol: "gigantol",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "2",
    pmids: "24844664,27651818",
  },
  {
    id: "6196",
    id_polifenol: "7590",
    polifenol: "quercetin-3-O-rutinoside",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "28178217",
  },
  {
    id: "6197",
    id_polifenol: "1629",
    polifenol: "bis-1,7-(2-hydroxyphenyl)-hepta-1,6-diene-3,5-dione",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "27908756",
  },
  {
    id: "6198",
    id_polifenol: "6687",
    polifenol: "3'-dimethylaminoflavone",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "3",
    pmids: "15571862,18720191,20594863",
  },
  {
    id: "6199",
    id_polifenol: "4764",
    polifenol: "tectochrysin",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "25083589",
  },
  {
    id: "6200",
    id_polifenol: "4558",
    polifenol: "2'-hydroxyflavone",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "29116937",
  },
  {
    id: "6201",
    id_polifenol: "6548",
    polifenol: "artocarpin flavonoid",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "28423703",
  },
  {
    id: "6202",
    id_polifenol: "5536",
    polifenol: "prodelphinidin B-2 3'-O-gallate",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "15621344",
  },
  {
    id: "6203",
    id_polifenol: "2339",
    polifenol: "3-O-methylgallic acid",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "25000464",
  },
  {
    id: "6204",
    id_polifenol: "1492",
    polifenol: "hirsutenone",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "24290194",
  },
  {
    id: "6205",
    id_polifenol: "1811",
    polifenol: "terameprocol",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "21107289",
  },
  {
    id: "6206",
    id_polifenol: "343",
    polifenol: "2,5-dichloro-4-bromophenol",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "16835747",
  },
  {
    id: "6207",
    id_polifenol: "3245",
    polifenol: "obovatol",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "27489231",
  },
  {
    id: "6208",
    id_polifenol: "7632",
    polifenol: "quercetin-3-O-beta-D-galactopyranoside",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "26948085",
  },
  {
    id: "6209",
    id_polifenol: "5945",
    polifenol: "2',5'-dimethoxychalcone",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "25855012",
  },
  {
    id: "6210",
    id_polifenol: "7888",
    polifenol: "neoisoliquiritin",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "24247527",
  },
  {
    id: "6211",
    id_polifenol: "4630",
    polifenol: "5,7,2',3'-tetrahydroxyflavone",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "2",
    pmids: "22803372,21618507",
  },
  {
    id: "6212",
    id_polifenol: "4135",
    polifenol: "orcinol",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "15921417",
  },
  {
    id: "6213",
    id_polifenol: "7363",
    polifenol: "juglanin",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "29212196",
  },
  {
    id: "6214",
    id_polifenol: "2517",
    polifenol: "casuarinin",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "15746577",
  },
  {
    id: "6215",
    id_polifenol: "2066",
    polifenol: "NSC 680410",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "20618971",
  },
  {
    id: "6216",
    id_polifenol: "6460",
    polifenol: "ipriflavone",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "9224209",
  },
  {
    id: "6217",
    id_polifenol: "5052",
    polifenol: "3-aminoflavone",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "2",
    pmids: "15324749,16012788",
  },
  {
    id: "6218",
    id_polifenol: "3336",
    polifenol:
      "N-hydroxy-5-ethoxymethyloxy-2-methyl-4-(4-phenoxybenzoyl)aminopentanamide",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "12516105",
  },
  {
    id: "6219",
    id_polifenol: "5854",
    polifenol: "2'-hydroxy-3,4,3',4',6'-pentamethoxychalcone",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "23438826",
  },
  {
    id: "6220",
    id_polifenol: "6898",
    polifenol: "barbigerone",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "22814678",
  },
  {
    id: "6221",
    id_polifenol: "5436",
    polifenol: "herbacetin",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "26976141",
  },
  {
    id: "6222",
    id_polifenol: "988",
    polifenol: "4'-O-methylnyasol",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "29158850",
  },
  {
    id: "6223",
    id_polifenol: "7823",
    polifenol: "tephrosin",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "21061222",
  },
  {
    id: "6224",
    id_polifenol: "4588",
    polifenol: "breviscapine",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "28229971",
  },
  {
    id: "6225",
    id_polifenol: "3646",
    polifenol: "1,5-bis(2-methoxyphenyl)penta-1,4-dien-3-one",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "2",
    pmids: "24156374,22189907",
  },
  {
    id: "6226",
    id_polifenol: "2334",
    polifenol: "leonurine",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "25856714",
  },
  {
    id: "6227",
    id_polifenol: "7641",
    polifenol: "quercetin-3'-O-beta-D-glucopyranoside",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "24938488",
  },
  {
    id: "6228",
    id_polifenol: "4482",
    polifenol: "peflavit",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "2",
    pmids: "9224209,25122774",
  },
  {
    id: "6229",
    id_polifenol: "7560",
    polifenol: "quercetin-3-O-neohesperidose",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "9224209",
  },
  {
    id: "6230",
    id_polifenol: "2401",
    polifenol: "2,3,5-trihydroxybenzoic acid",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "27419630",
  },
  {
    id: "6231",
    id_polifenol: "4820",
    polifenol: "3,7-dihydroxyflavone",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "29734739",
  },
  {
    id: "6232",
    id_polifenol: "4677",
    polifenol: "baohuoside II",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "29260980",
  },
  {
    id: "6233",
    id_polifenol: "7531",
    polifenol: "7-O-geranylquercetin",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "28495516",
  },
  {
    id: "6234",
    id_polifenol: "4689",
    polifenol: "5,3'-dihydroxy-3,6,7,8,4'-pentamethoxyflavone",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "7623025",
  },
  {
    id: "6235",
    id_polifenol: "6464",
    polifenol: "cirsiliol",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "23902763",
  },
  {
    id: "6236",
    id_polifenol: "4224",
    polifenol: "orsellinic acid",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "15921417",
  },
  {
    id: "6237",
    id_polifenol: "361",
    polifenol: "2-aminophenol",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "16777268",
  },
  {
    id: "6238",
    id_polifenol: "5284",
    polifenol: "didymin",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "19733932",
  },
  {
    id: "6239",
    id_polifenol: "2760",
    polifenol: "2-methoxybenzoic acid",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "16281305",
  },
  {
    id: "6240",
    id_polifenol: "4102",
    polifenol: "ardisiphenol D",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "2",
    pmids: "24392814,22863707",
  },
  {
    id: "6241",
    id_polifenol: "7476",
    polifenol:
      "kaempferol-3-O-alpha-L-(2''-E-p-coumaroyl-4''-Z-p-coumaroyl)-rhamnoside",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "24290194",
  },
  {
    id: "6242",
    id_polifenol: "1586",
    polifenol: "hydrazinobenzoylcurcumin",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "25683568",
  },
  {
    id: "6243",
    id_polifenol: "7388",
    polifenol: "kaempferol-3-O-galactoside",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "27444344",
  },
  {
    id: "6244",
    id_polifenol: "5175",
    polifenol: "5-allyl-7-gen-difluoromethylenechrysin",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "21801359",
  },
  {
    id: "6245",
    id_polifenol: "4930",
    polifenol: "tetra-O-methylscutellarein",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "26569090",
  },
  {
    id: "6246",
    id_polifenol: "4196",
    polifenol: "ardisiphenol A",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "2",
    pmids: "24392814,22863707",
  },
  {
    id: "6247",
    id_polifenol: "2716",
    polifenol: "ethyl salicylate",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "28270064",
  },
  {
    id: "6248",
    id_polifenol: "5123",
    polifenol: "flavonoid cycloartobiloxanthone",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "29275301",
  },
  {
    id: "6249",
    id_polifenol: "6337",
    polifenol: "3-fluoro-5-hydroxy-7-acetoxyflavone",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "29116937",
  },
  {
    id: "6250",
    id_polifenol: "6003",
    polifenol: "boesenbergin A",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "22358425",
  },
  {
    id: "6251",
    id_polifenol: "6229",
    polifenol: "2-hydroxynaringenin 4'-O-beta-D-glucopyranoside",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "24938488",
  },
  {
    id: "6252",
    id_polifenol: "6241",
    polifenol: "5-hydroxy-7,4'-diacetyloxyflavanone-N-phenyl hydrazone",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "21877710",
  },
  {
    id: "6253",
    id_polifenol: "6307",
    polifenol: "gardenin B",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "23926120",
  },
  {
    id: "6254",
    id_polifenol: "6020",
    polifenol: "2'-hydroxy-4',5'-dimethoxychalcone",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "23554101",
  },
  {
    id: "6255",
    id_polifenol: "5589",
    polifenol: "catechin-7-O-xyloside",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "24213951",
  },
  {
    id: "6256",
    id_polifenol: "3632",
    polifenol:
      "4-(4-methoxyphenyl)-5-(3,4,5-trimethoxyphenyl)-1H-pyrazol-3-amine",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "20352291",
  },
  {
    id: "6257",
    id_polifenol: "154",
    polifenol: "triticumoside",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "26758192",
  },
  {
    id: "6258",
    id_polifenol: "3906",
    polifenol: "hyperforin",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "21751836",
  },
  {
    id: "6259",
    id_polifenol: "5450",
    polifenol: "linderone A",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "23173924",
  },
  {
    id: "6260",
    id_polifenol: "4223",
    polifenol: "globosumone C",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "15921417",
  },
  {
    id: "6261",
    id_polifenol: "4372",
    polifenol:
      "quercetin 3-O-alpha-rhamnopyranoside-7-O-beta-D-glucopyranosyl-(1-3)-alpha-L-rhamnopyranoside",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "7623025",
  },
  {
    id: "6262",
    id_polifenol: "7282",
    polifenol: "hovenitin III",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "24938488",
  },
  {
    id: "6263",
    id_polifenol: "225",
    polifenol:
      "2-(4-(4-methoxyphenoxy)-1H-pyrazol-3-yl)-5-(p-tolylmethoxy)phenol",
    id_cancer: "230100",
    cancer: "Non-Small-Cell Lung Carcinoma",
    quant: "1",
    pmids: "26517520",
  },
  {
    id: "6264",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "78",
    pmids:
      "22056764,17672346,19135124,24477342,26514505,25981581,24214831,16579729,23955116,26276130,18343026,22721615,22407803,27461104,21179373,22532078,25174821,22449725,28835320,27113311,20858478,29175387,29641917,26847268,28757593,23510470,25962638,27356910,27470413,25084411,16970933,28689916,23046062,25295671,27602097,22574207,25554015,29420562,28013431,29436891,28808394,25053074,23350280,22083314,17430639,28258039,28557449,23533482,26345098,28292015,24534539,19639540,28277581,25035860,17034658,23519250,26703544,25379883,24824323,15886524,29513789,28282293,25338977,18078919,25379467,19252325,17587681,10660092,16817652,28853026,27035097,28178217,19212101,28893230,29638061,18379113,27153984,15185748",
  },
  {
    id: "6265",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "72",
    pmids:
      "25198898,23980364,29174816,29094265,28038323,16550606,27456358,15120608,28409156,25786122,26633344,15118344,16526022,19502749,29771044,25433549,27042000,23234806,25292057,15590651,23147641,24246195,26873414,25308441,26132907,27261574,27094172,23351961,23513724,18348204,24738327,28684765,23600205,25780454,19191010,15879598,22273695,29490752,26802648,29021018,24581747,29581972,25628937,21061268,26735343,27235709,26947919,25961334,26262768,23874455,26837852,24531225,21317920,24223665,18252805,22266528,15514944,20941532,26515041,21138650,19058955,29556774,22372871,20924967,25621942,29323877,29651963,23140290,26249606,26924283,26524183,25708980",
  },
  {
    id: "6266",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "44",
    pmids:
      "21776820,19784583,28124838,24478544,25988128,16550606,28868867,23351413,28208804,25196850,20482751,26586942,22743590,11741744,29568369,18061431,27606689,27261574,19540331,16190622,14751158,19271153,26177078,22083314,28337113,15879598,23174518,22019724,16554116,27235709,23056433,29160133,21317920,20686382,25379883,15158750,18252805,19723063,26059022,28925878,17243704,26554336,21485870,18412361",
  },
  {
    id: "6267",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "17",
    pmids:
      "21702500,17251686,23707609,14536030,26942921,17473185,25289059,28196062,15118344,22472210,16142414,11461094,17009395,29125193,19654571,25797437,18851783",
  },
  {
    id: "6268",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "14",
    pmids:
      "18388472,27467006,24053672,22289529,16142414,17009395,26201192,25991428,28925878,21138650,28853026,23056046,11518614,24068499",
  },
  {
    id: "6269",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "34",
    pmids:
      "27470402,27461104,25298669,20858478,19953944,28757593,23510470,26974372,27602097,15611226,18476622,12476615,22083314,28337113,26320505,28557449,22222411,24682729,21732360,27689975,28277581,17034658,25015032,21480807,23849943,27411085,23241588,28282293,24470266,27295129,28178217,11885806,17693959,15185748",
  },
  {
    id: "6270",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "24",
    pmids:
      "21776820,19784583,16731755,25988128,23348740,21609393,26586942,14751158,28769014,12742577,28612587,20951799,19784588,23056433,15201978,26501251,20686382,15158750,28031235,29180927,26554336,16817652,21485870,20934473",
  },
  {
    id: "6271",
    id_polifenol: "2167",
    polifenol: "phenolic acid",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "33",
    pmids:
      "27470359,26514505,24528072,22407803,28208804,25933595,25539472,21213408,25554015,18061431,20647029,19540331,25053074,22083314,26320505,28480370,27651811,28292015,26925328,28222613,25035860,16554116,27034599,26839997,26703544,26501251,27411085,29513789,24711053,28178217,28893230,29638061,27153984",
  },
  {
    id: "6272",
    id_polifenol: "49",
    polifenol: "Aspirin",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "5",
    pmids: "29805582,23475158,23600205,16444599,26142152",
  },
  {
    id: "6273",
    id_polifenol: "109",
    polifenol: "Catechin",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "13",
    pmids:
      "21967781,25196850,28769014,28337113,26320505,12742577,22468171,25035860,19723063,29513789,28282293,26167832,19212101",
  },
  {
    id: "6274",
    id_polifenol: "125",
    polifenol: "Isoflavones",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "7",
    pmids: "22914566,27467006,24053672,24272199,23867903,25973307,25991428",
  },
  {
    id: "6275",
    id_polifenol: "110",
    polifenol: "Chalcones",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "18",
    pmids:
      "27273962,25462255,25019692,22721615,24638227,25313981,21186794,23353745,8375934,25353380,23501110,27217001,23834620,23314048,24675137,21071221,20211228,2362275",
  },
  {
    id: "6276",
    id_polifenol: "3089",
    polifenol: "1,1-diphenyl-2-picrylhydrazyl",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "45",
    pmids:
      "22628260,29191192,22196508,22354161,28946185,23351413,28699489,25074702,28208804,27524032,27148169,25539472,21213408,25554015,28763750,25053074,23876231,22074239,26924226,25887035,22083314,28337113,17430639,28376770,29956560,26925328,23841520,27973724,23174518,25035860,23519250,27034599,26453450,26839997,26501251,26142508,24824323,18078919,25379467,26449529,29476965,28893230,29638061,21664924,27153984",
  },
  {
    id: "6277",
    id_polifenol: "114",
    polifenol: "Apigenin",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "11",
    pmids:
      "16579729,24048283,28191273,28757593,27356910,17359940,25299247,12509912,19830248,23519250,28526810",
  },
  {
    id: "6278",
    id_polifenol: "113",
    polifenol: "Flavones",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "9",
    pmids:
      "25019692,18640498,15658870,20647029,28480370,21473152,28800661,27563398,27917658",
  },
  {
    id: "6279",
    id_polifenol: "38",
    polifenol: "Gallic Acid",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "22",
    pmids:
      "24528072,22196508,24843386,25074702,28208804,25933595,27148169,21621599,21213408,20197077,28035417,19540331,26320505,23841520,25035860,28031235,21480807,26059022,29513789,11256479,26151908,23627273",
  },
  {
    id: "6280",
    id_polifenol: "117",
    polifenol: "Luteolin",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "11",
    pmids:
      "24477342,16579729,28789432,22449725,27602097,21473152,28277581,27034599,20175233,29066296,17587681",
  },
  {
    id: "6281",
    id_polifenol: "1",
    polifenol: "Phenols",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "12",
    pmids:
      "21167897,27113311,28208804,28384547,20647029,27651811,28222613,17203231,20170382,16817652,11256479,18412361",
  },
  {
    id: "6282",
    id_polifenol: "105",
    polifenol: "Anthocyanins",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "5",
    pmids: "16970933,25053074,20121190,27411085,18412361",
  },
  {
    id: "6283",
    id_polifenol: "7235",
    polifenol: "silybin",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "10660092",
  },
  {
    id: "6284",
    id_polifenol: "129",
    polifenol: "Rotenone",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "4",
    pmids: "10597238,25973307,23227042,9264320",
  },
  {
    id: "6285",
    id_polifenol: "121",
    polifenol: "Kaempferols",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "7",
    pmids: "27461104,26974372,27602097,28337113,28258039,24711053,28178217",
  },
  {
    id: "6286",
    id_polifenol: "871",
    polifenol: "ABT-737",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "23285061",
  },
  {
    id: "6287",
    id_polifenol: "6451",
    polifenol: "daidzein",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "22914566",
  },
  {
    id: "6288",
    id_polifenol: "6065",
    polifenol: "baicalein",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "4",
    pmids: "28835320,29175387,21473152,17587681",
  },
  {
    id: "6289",
    id_polifenol: "7",
    polifenol: "Capsaicin",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "25864613",
  },
  {
    id: "6290",
    id_polifenol: "4634",
    polifenol: "alvocidib",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "3",
    pmids: "18640498,12460995,15023361",
  },
  {
    id: "6291",
    id_polifenol: "120",
    polifenol: "Flavonols",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "8",
    pmids:
      "22014228,20647029,25887035,28480370,26794656,27411085,17616894,28178217",
  },
  {
    id: "6292",
    id_polifenol: "4522",
    polifenol: "chrysin",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "4",
    pmids: "27470413,22574207,26924226,23533482",
  },
  {
    id: "6293",
    id_polifenol: "123",
    polifenol: "Rutin",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "7",
    pmids: "28757593,19540331,21473152,24711053,29476965,27035097,29638061",
  },
  {
    id: "6294",
    id_polifenol: "6062",
    polifenol: "naringenin",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "6",
    pmids: "22056764,28757593,19830248,20234972,27538012,15185748",
  },
  {
    id: "6295",
    id_polifenol: "285",
    polifenol: "bisphenol A",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "2",
    pmids: "25797437,11518614",
  },
  {
    id: "6296",
    id_polifenol: "39",
    polifenol: "Hydrolyzable Tannins",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "9",
    pmids:
      "11684320,29641917,25554015,23350280,27651811,28292015,20170382,18412361,27153984",
  },
  {
    id: "6297",
    id_polifenol: "130",
    polifenol: "Proanthocyanidins",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "4",
    pmids: "25187959,26501251,20121190,18975262",
  },
  {
    id: "6298",
    id_polifenol: "35",
    polifenol: "Hydroquinones",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "3",
    pmids: "16444599,28398051,11412089",
  },
  {
    id: "6299",
    id_polifenol: "111",
    polifenol: "Flavanones",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "2",
    pmids: "25019692,18078919",
  },
  {
    id: "6300",
    id_polifenol: "6",
    polifenol: "Catechols",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "4",
    pmids: "26961313,28838694,6771000,28905618",
  },
  {
    id: "6301",
    id_polifenol: "25",
    polifenol: "Butylated Hydroxytoluene",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "3",
    pmids: "27148169,19540331,26997648",
  },
  {
    id: "6302",
    id_polifenol: "75",
    polifenol: "Butylated Hydroxyanisole",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "2",
    pmids: "26381601,21113647",
  },
  {
    id: "6303",
    id_polifenol: "15",
    polifenol: "Masoprocol",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "22870140",
  },
  {
    id: "6304",
    id_polifenol: "6087",
    polifenol: "wogonin",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "2",
    pmids: "23955116,29433678",
  },
  {
    id: "6305",
    id_polifenol: "4519",
    polifenol: "myricetin",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "5",
    pmids: "27461104,28757593,25972998,26794656,28178217",
  },
  {
    id: "6306",
    id_polifenol: "4515",
    polifenol: "baicalin",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "3",
    pmids: "25561931,29610452,28417913",
  },
  {
    id: "6307",
    id_polifenol: "4500",
    polifenol: "procyanidin",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "3",
    pmids: "27411085,17603274,18412361",
  },
  {
    id: "6308",
    id_polifenol: "1356",
    polifenol: "gingerol",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "4",
    pmids: "28230361,26621832,26749462,23964455",
  },
  {
    id: "6309",
    id_polifenol: "54",
    polifenol: "Salicylic Acid",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "27163172",
  },
  {
    id: "6310",
    id_polifenol: "98",
    polifenol: "Propofol",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "4",
    pmids: "26523512,26666272,29436891,12127688",
  },
  {
    id: "6311",
    id_polifenol: "5607",
    polifenol: "gallocatechol",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "3",
    pmids: "25196850,28769014,26501251",
  },
  {
    id: "6312",
    id_polifenol: "5578",
    polifenol: "alpha-naphthoflavone",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "2",
    pmids: "29274324,15797623",
  },
  {
    id: "6313",
    id_polifenol: "4559",
    polifenol: "theaflavin",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "2",
    pmids: "21776820,26586942",
  },
  {
    id: "6314",
    id_polifenol: "5808",
    polifenol: "isoliquiritigenin",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "3",
    pmids: "24214831,19536869,29098824",
  },
  {
    id: "6315",
    id_polifenol: "2344",
    polifenol: "methyl gallate",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "2",
    pmids: "25298669,25887035",
  },
  {
    id: "6316",
    id_polifenol: "2284",
    polifenol: "rosmarinic acid",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "3",
    pmids: "25554015,28222613,20170382",
  },
  {
    id: "6317",
    id_polifenol: "4513",
    polifenol: "galangin",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "28757593",
  },
  {
    id: "6318",
    id_polifenol: "6063",
    polifenol: "naringin",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "2",
    pmids: "25174821,26345098",
  },
  {
    id: "6319",
    id_polifenol: "1380",
    polifenol: "shogaol",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "3",
    pmids: "27470359,29464796,23435947",
  },
  {
    id: "6320",
    id_polifenol: "2158",
    polifenol: "protocatechuic acid",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "23737666",
  },
  {
    id: "6321",
    id_polifenol: "6273",
    polifenol: "hesperetin",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "2",
    pmids: "21473152,19830248",
  },
  {
    id: "6322",
    id_polifenol: "1613",
    polifenol: "demethoxycurcumin",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "23513724",
  },
  {
    id: "6323",
    id_polifenol: "93",
    polifenol: "Phloroglucinol",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "2",
    pmids: "24986654,2236292",
  },
  {
    id: "6324",
    id_polifenol: "6454",
    polifenol: "formononetin",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "4",
    pmids: "24272199,23867903,22633834,29098824",
  },
  {
    id: "6325",
    id_polifenol: "7550",
    polifenol: "3-methylquercetin",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "2",
    pmids: "27461104,28178217",
  },
  {
    id: "6326",
    id_polifenol: "6461",
    polifenol: "acacetin",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "3",
    pmids: "21473152,29066296,29098824",
  },
  {
    id: "6327",
    id_polifenol: "1611",
    polifenol: "bis(4-hydroxycinnamoyl)methane",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "25433549",
  },
  {
    id: "6328",
    id_polifenol: "107",
    polifenol: "beta-Naphthoflavone",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "1340765",
  },
  {
    id: "6329",
    id_polifenol: "119",
    polifenol: "Silymarin",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "10660092",
  },
  {
    id: "6330",
    id_polifenol: "69",
    polifenol: "Phenolsulfonphthalein",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "17203231",
  },
  {
    id: "6331",
    id_polifenol: "126",
    polifenol: "Coumestrol",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "2",
    pmids: "20623010,11518614",
  },
  {
    id: "6332",
    id_polifenol: "5806",
    polifenol: "butein",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "2",
    pmids: "26310353,25962638",
  },
  {
    id: "6333",
    id_polifenol: "108",
    polifenol: "Biflavonoids",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "4",
    pmids: "21663495,24565962,24716136,18379113",
  },
  {
    id: "6334",
    id_polifenol: "5509",
    polifenol: "cyanidin 3-O-glucoside",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "16970933",
  },
  {
    id: "6335",
    id_polifenol: "969",
    polifenol: "3,4-dihydroxyphenacyl caffeate phenylpropanoid ester",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "2",
    pmids: "21480807,25156288",
  },
  {
    id: "6336",
    id_polifenol: "5819",
    polifenol: "licochalcone A",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "25981581",
  },
  {
    id: "6337",
    id_polifenol: "94",
    polifenol: "Phloretin",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "28757593",
  },
  {
    id: "6338",
    id_polifenol: "4560",
    polifenol: "icariin",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "20307526",
  },
  {
    id: "6339",
    id_polifenol: "48",
    polifenol: "Anacardic Acids",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "2",
    pmids: "23128090,22941480",
  },
  {
    id: "6340",
    id_polifenol: "5488",
    polifenol: "cyanidin",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "26586108",
  },
  {
    id: "6341",
    id_polifenol: "4640",
    polifenol: "5,7-dihydroxy-6-methoxy-2-phenylchromen-4-one",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "19135124",
  },
  {
    id: "6342",
    id_polifenol: "2773",
    polifenol: "farnesylthiosalicylic acid",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "23370967",
  },
  {
    id: "6343",
    id_polifenol: "1995",
    polifenol: "2-tert-butylhydroquinone",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "23707609",
  },
  {
    id: "6344",
    id_polifenol: "7546",
    polifenol: "isoquercitrin",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "3",
    pmids: "28013431,28557449,29066296",
  },
  {
    id: "6345",
    id_polifenol: "89",
    polifenol: "Vanillic Acid",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "2",
    pmids: "24528072,29066296",
  },
  {
    id: "6346",
    id_polifenol: "99",
    polifenol: "Pyrogallol",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "28575975",
  },
  {
    id: "6347",
    id_polifenol: "452",
    polifenol: "acteoside",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "2",
    pmids: "11725977,21480807",
  },
  {
    id: "6348",
    id_polifenol: "100",
    polifenol: "Resorcinols",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "25172420",
  },
  {
    id: "6349",
    id_polifenol: "1866",
    polifenol: "4,6-dinitro-o-cresol",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "21306911",
  },
  {
    id: "6350",
    id_polifenol: "4486",
    polifenol: "amentoflavone",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "21663495",
  },
  {
    id: "6351",
    id_polifenol: "7541",
    polifenol: "taxifolin",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "25379883",
  },
  {
    id: "6352",
    id_polifenol: "7544",
    polifenol: "quercitrin",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "4",
    pmids: "27602097,25887035,28557449,28178217",
  },
  {
    id: "6353",
    id_polifenol: "300",
    polifenol: "rhodioloside",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "29749547",
  },
  {
    id: "6354",
    id_polifenol: "4767",
    polifenol: "flavan-3-ol",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "26501251",
  },
  {
    id: "6355",
    id_polifenol: "1996",
    polifenol: "2,5-di-tert-butylhydroquinone",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "23707609",
  },
  {
    id: "6356",
    id_polifenol: "6576",
    polifenol: "5,7,4'-trihydroxyflavone",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "28191273",
  },
  {
    id: "6357",
    id_polifenol: "6086",
    polifenol: "liquiritigenin",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "2",
    pmids: "29098824,27538012",
  },
  {
    id: "6358",
    id_polifenol: "1616",
    polifenol: "tetrahydrocurcumin",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "29094265",
  },
  {
    id: "6359",
    id_polifenol: "4516",
    polifenol: "diosmetin",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "29066296",
  },
  {
    id: "6360",
    id_polifenol: "6558",
    polifenol: "7,3'-dihydroxy-4'-methoxyisoflavone",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "29098824",
  },
  {
    id: "6361",
    id_polifenol: "4796",
    polifenol: "aminoflavone",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "8784443",
  },
  {
    id: "6362",
    id_polifenol: "2490",
    polifenol: "punicalagin",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "17243704",
  },
  {
    id: "6363",
    id_polifenol: "349",
    polifenol: "4-nitrophenol",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "28076823",
  },
  {
    id: "6364",
    id_polifenol: "7141",
    polifenol: "apigetrin",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "28222613",
  },
  {
    id: "6365",
    id_polifenol: "6301",
    polifenol: "3-methoxyflavone",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "15118344",
  },
  {
    id: "6366",
    id_polifenol: "1810",
    polifenol: "heminordihydroguaiaretic acid",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "22870140",
  },
  {
    id: "6367",
    id_polifenol: "1353",
    polifenol: "protocatechualdehyde",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "27999546",
  },
  {
    id: "6368",
    id_polifenol: "4501",
    polifenol: "tricin",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "29066296",
  },
  {
    id: "6369",
    id_polifenol: "4304",
    polifenol: "5-7-oxo-zeaenol",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "28430599",
  },
  {
    id: "6370",
    id_polifenol: "5796",
    polifenol: "dihydrochalcone",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "2",
    pmids: "23501110,20715765",
  },
  {
    id: "6371",
    id_polifenol: "6066",
    polifenol: "eriodictyol",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "27538012",
  },
  {
    id: "6372",
    id_polifenol: "6452",
    polifenol: "chrysoeriol",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "28222613",
  },
  {
    id: "6373",
    id_polifenol: "680",
    polifenol: "xanthorrhizol",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "16158967",
  },
  {
    id: "6374",
    id_polifenol: "7377",
    polifenol: "astragalin",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "25348942",
  },
  {
    id: "6375",
    id_polifenol: "413",
    polifenol: "4-nonylphenol",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "11518614",
  },
  {
    id: "6376",
    id_polifenol: "1672",
    polifenol: "B19 monocarbonyl curcumin",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "28409156",
  },
  {
    id: "6377",
    id_polifenol: "2014",
    polifenol: "erbstatin",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "18855573",
  },
  {
    id: "6378",
    id_polifenol: "6800",
    polifenol: "3,6-dimethoxy-6'',6''-dimethylchromeno(2'',3''-7,8)flavone",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "27235709",
  },
  {
    id: "6379",
    id_polifenol: "6112",
    polifenol: "alpinetin",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "29436891",
  },
  {
    id: "6380",
    id_polifenol: "2283",
    polifenol: "depsidone",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "27102610",
  },
  {
    id: "6381",
    id_polifenol: "1747",
    polifenol: "6-paradol",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "23435947",
  },
  {
    id: "6382",
    id_polifenol: "12",
    polifenol: "Guaiacol",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "24121236",
  },
  {
    id: "6383",
    id_polifenol: "2790",
    polifenol: "ginkgolic acid",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "2",
    pmids: "20948210,19627005",
  },
  {
    id: "6384",
    id_polifenol: "704",
    polifenol: "trizol",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "25441985",
  },
  {
    id: "6385",
    id_polifenol: "84",
    polifenol: "Halogenated Diphenyl Ethers",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "22472210",
  },
  {
    id: "6386",
    id_polifenol: "4479",
    polifenol: "morin",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "28689916",
  },
  {
    id: "6387",
    id_polifenol: "6100",
    polifenol: "pinostrobin",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "3",
    pmids: "17448115,29420562,27603115",
  },
  {
    id: "6388",
    id_polifenol: "6774",
    polifenol: "5,7-dihydroxy-6,3',4'-trimethoxyflavone",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "18957174",
  },
  {
    id: "6389",
    id_polifenol: "315",
    polifenol: "bakuchiol",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "23302649",
  },
  {
    id: "6390",
    id_polifenol: "4839",
    polifenol: "7-hydroxyflavone",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "2",
    pmids: "22574207,28605048",
  },
  {
    id: "6391",
    id_polifenol: "7199",
    polifenol: "luteolin-7-glucoside",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "28222613",
  },
  {
    id: "6392",
    id_polifenol: "428",
    polifenol: "2,2'-bisphenol F",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "25433549",
  },
  {
    id: "6393",
    id_polifenol: "7453",
    polifenol: "kaempferol-3-O-glucoside",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "18343026",
  },
  {
    id: "6394",
    id_polifenol: "4981",
    polifenol: "jaceosidin",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "3",
    pmids: "25295671,27602097,15814270",
  },
  {
    id: "6395",
    id_polifenol: "4639",
    polifenol: "aromadedrin",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "2",
    pmids: "11374975,25379883",
  },
  {
    id: "6396",
    id_polifenol: "3494",
    polifenol: "asarone",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "2",
    pmids: "26502896,25383224",
  },
  {
    id: "6397",
    id_polifenol: "6453",
    polifenol: "cirsimaritin",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "27938087",
  },
  {
    id: "6398",
    id_polifenol: "1662",
    polifenol: "BDMC-A",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "2",
    pmids: "25433549,23513724",
  },
  {
    id: "6399",
    id_polifenol: "5539",
    polifenol: "peonidin 3-glucoside",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "16970933",
  },
  {
    id: "6400",
    id_polifenol: "839",
    polifenol: "5-iodo-3-((3,5-dibromo-4-hydroxyphenyl)methylene)-2-indolinone",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "17251686",
  },
  {
    id: "6401",
    id_polifenol: "6819",
    polifenol: "luteolin-7-O-glucoside",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "27034599",
  },
  {
    id: "6402",
    id_polifenol: "7437",
    polifenol: "kaempferol-3-O-rutinoside",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "2",
    pmids: "21473152,24711053",
  },
  {
    id: "6403",
    id_polifenol: "1237",
    polifenol: "2,4-bis(p-hydroxyphenyl)-2-butenal",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "23163851",
  },
  {
    id: "6404",
    id_polifenol: "7422",
    polifenol: "kaempferide",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "26345098",
  },
  {
    id: "6405",
    id_polifenol: "2173",
    polifenol: "atranorin",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "2",
    pmids: "25233603,20837130",
  },
  {
    id: "6406",
    id_polifenol: "7590",
    polifenol: "quercetin-3-O-rutinoside",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "28178217",
  },
  {
    id: "6407",
    id_polifenol: "6687",
    polifenol: "3'-dimethylaminoflavone",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "20148235",
  },
  {
    id: "6408",
    id_polifenol: "3490",
    polifenol: "estragole",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "25789792",
  },
  {
    id: "6409",
    id_polifenol: "529",
    polifenol: "4-octylphenol",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "11518614",
  },
  {
    id: "6410",
    id_polifenol: "5101",
    polifenol: "isokaempferide",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "26345098",
  },
  {
    id: "6411",
    id_polifenol: "5814",
    polifenol: "2',4'-dihydroxychalcone",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "19689125",
  },
  {
    id: "6412",
    id_polifenol: "526",
    polifenol: "liensinine",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "26811496",
  },
  {
    id: "6413",
    id_polifenol: "7885",
    polifenol: "hydroxysafflor yellow A",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "29417935",
  },
  {
    id: "6414",
    id_polifenol: "2159",
    polifenol: "2,3-dihydroxybenzoic acid",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "11725977",
  },
  {
    id: "6415",
    id_polifenol: "2169",
    polifenol: "ethyl protocatechuate",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "18799519",
  },
  {
    id: "6416",
    id_polifenol: "3661",
    polifenol: "2-tert-butyl-4-hydroxyanisole",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "1340765",
  },
  {
    id: "6417",
    id_polifenol: "2868",
    polifenol: "3-hydroxy-4-prenyl-5-methoxystilbene-2-carboxylic acid",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "27603115",
  },
  {
    id: "6418",
    id_polifenol: "4534",
    polifenol: "3,5,6-trihydroxy-4',7'-dimethoxyflavone",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "15814270",
  },
  {
    id: "6419",
    id_polifenol: "72",
    polifenol: "Phenyl Ethers",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "19795843",
  },
  {
    id: "6420",
    id_polifenol: "472",
    polifenol: "isoacteoside",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "11725977",
  },
  {
    id: "6421",
    id_polifenol: "3299",
    polifenol: "pentabromodiphenyl ether",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "22472210",
  },
  {
    id: "6422",
    id_polifenol: "3665",
    polifenol: "3,5-di-tert-butyl-4-hydroxyanisole",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "21480807",
  },
  {
    id: "6423",
    id_polifenol: "6633",
    polifenol: "pomiferin",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "28864041",
  },
  {
    id: "6424",
    id_polifenol: "858",
    polifenol: "2-(3-chloro-4-hydroxyphenyl)-2-(4-hydroxyphenyl)propane",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "2",
    pmids: "27273962,25991428",
  },
  {
    id: "6425",
    id_polifenol: "6478",
    polifenol: "cirsilineol",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "2",
    pmids: "18957174,25295671",
  },
  {
    id: "6426",
    id_polifenol: "4297",
    polifenol: "curvularin",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "25913704",
  },
  {
    id: "6427",
    id_polifenol: "6485",
    polifenol: "3',4',7-trihydroxyisoflavone",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "22914566",
  },
  {
    id: "6428",
    id_polifenol: "2290",
    polifenol: "lobaric acid",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "2",
    pmids: "22628260,29538328",
  },
  {
    id: "6429",
    id_polifenol: "2768",
    polifenol: "salophen",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "25450023",
  },
  {
    id: "6430",
    id_polifenol: "5198",
    polifenol: "isosakuranetin",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "21473152",
  },
  {
    id: "6431",
    id_polifenol: "5791",
    polifenol: "metochalcone",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "25057485",
  },
  {
    id: "6432",
    id_polifenol: "988",
    polifenol: "4'-O-methylnyasol",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "28511296",
  },
  {
    id: "6433",
    id_polifenol: "2242",
    polifenol: "atraric acid",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "23098219",
  },
  {
    id: "6434",
    id_polifenol: "1649",
    polifenol: "1,5-bis(2-hydroxyphenyl)-1,4-pentadien-3-one",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "2",
    pmids: "28038323,25961334",
  },
  {
    id: "6435",
    id_polifenol: "3646",
    polifenol: "1,5-bis(2-methoxyphenyl)penta-1,4-dien-3-one",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "25961334",
  },
  {
    id: "6436",
    id_polifenol: "4919",
    polifenol: "bavachinin",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "2",
    pmids: "24012108,23302649",
  },
  {
    id: "6437",
    id_polifenol: "6752",
    polifenol: "zapotin",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "26847268",
  },
  {
    id: "6438",
    id_polifenol: "2401",
    polifenol: "2,3,5-trihydroxybenzoic acid",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "24843386",
  },
  {
    id: "6439",
    id_polifenol: "7249",
    polifenol: "rhamnazin",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "29117727",
  },
  {
    id: "6440",
    id_polifenol: "7659",
    polifenol: "quercetin 7-rhamnoside",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "24711053",
  },
  {
    id: "6441",
    id_polifenol: "1804",
    polifenol: "guaiacylglycerol-beta-coniferyl ether",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "21473152",
  },
  {
    id: "6442",
    id_polifenol: "5910",
    polifenol: "3'-formyl-4',6'-dihydroxy-2'-methoxy-5'-methylchalcone",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "17430639",
  },
  {
    id: "6443",
    id_polifenol: "142",
    polifenol: "1,5-bis(3-hydroxyphenyl)-1,4-pentadiene-3-one",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "26132907",
  },
  {
    id: "6444",
    id_polifenol: "5974",
    polifenol: "4'-hydroxychalcone",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "22721615",
  },
  {
    id: "6445",
    id_polifenol: "1417",
    polifenol: "1,2-dihydroxy-4'-chlorobiphenyl",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "17681423",
  },
  {
    id: "6446",
    id_polifenol: "5143",
    polifenol: "fustin",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "28103742",
  },
  {
    id: "6447",
    id_polifenol: "5533",
    polifenol: "cyanidin-3-O-beta-glucopyranoside",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "20121190",
  },
  {
    id: "6448",
    id_polifenol: "2255",
    polifenol: "protocatechuic acid methyl ester",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "25539472",
  },
  {
    id: "6449",
    id_polifenol: "7583",
    polifenol: "quercetin 3-O-glucopyranoside",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "20121190",
  },
  {
    id: "6450",
    id_polifenol: "7650",
    polifenol: "3,7-O-dimethylquercetin",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "21473152",
  },
  {
    id: "6451",
    id_polifenol: "16",
    polifenol: "Chlorophenols",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "24973716",
  },
  {
    id: "6452",
    id_polifenol: "4203",
    polifenol: "methyl orsellinate",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "25233603",
  },
  {
    id: "6453",
    id_polifenol: "7878",
    polifenol: "MDL 27048",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "2362275",
  },
  {
    id: "6454",
    id_polifenol: "7382",
    polifenol: "lespenefril",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "23211658",
  },
  {
    id: "6455",
    id_polifenol: "7066",
    polifenol: "diethyl flavon-7-yl phosphate",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "22574207",
  },
  {
    id: "6456",
    id_polifenol: "1640",
    polifenol: "2,6-bis-4-(hydroxy-3-methoxybenzylidene)cyclohexanone",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "29556774",
  },
  {
    id: "6457",
    id_polifenol: "381",
    polifenol: "4-bromophenol",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "24895493",
  },
  {
    id: "6458",
    id_polifenol: "6349",
    polifenol: "ME-344",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "25973307",
  },
  {
    id: "6459",
    id_polifenol: "4649",
    polifenol: "centaureidin",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "19639540",
  },
  {
    id: "6460",
    id_polifenol: "2307",
    polifenol: "vicanicin",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "22628260",
  },
  {
    id: "6461",
    id_polifenol: "6124",
    polifenol: "3-hydroxyflavanone",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "22056764",
  },
  {
    id: "6462",
    id_polifenol: "1648",
    polifenol: "(1E,4E)-1,5-bis(2-methoxyphenyl)penta-1,4-dien-3-one",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "29174816",
  },
  {
    id: "6463",
    id_polifenol: "1541",
    polifenol: "3-hydroxybakuchiol",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "23302649",
  },
  {
    id: "6464",
    id_polifenol: "6325",
    polifenol:
      "7-(4-(bis-(2-hydroxyethyl)amino)butoxy)-5-hydroxy-8-methoxy-2-phenylchromen-4-one",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "26276130",
  },
  {
    id: "6465",
    id_polifenol: "2213",
    polifenol: "diffractaic acid",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "2",
    pmids: "22628260,25233603",
  },
  {
    id: "6466",
    id_polifenol: "5103",
    polifenol: "abyssinone II",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "25019692",
  },
  {
    id: "6467",
    id_polifenol: "5707",
    polifenol:
      "ethyl 8-sec-butyl-2-oxo-6-(3-oxo-3-p-tolylprop-1-enyl)-2H-chromene-3-carboxylate",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "24638227",
  },
  {
    id: "6468",
    id_polifenol: "5339",
    polifenol: "2S,3S-3,5,7,3',5'-pentahydroxyflavane",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "25298669",
  },
  {
    id: "6469",
    id_polifenol: "5340",
    polifenol: "2R,3R-3,5,6,7,8,4'-hexahydroxyflavane",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "25298669",
  },
  {
    id: "6470",
    id_polifenol: "5042",
    polifenol:
      "I-3, II-3, I-5, II-5, I-7, II-7, I-4', II-4'-octahydroxy (I-2', II-2') biflavone",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "24716136",
  },
  {
    id: "6471",
    id_polifenol: "2464",
    polifenol: "camelliin B",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "11684320",
  },
  {
    id: "6472",
    id_polifenol: "3225",
    polifenol: "decabromobiphenyl ether",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "22472210",
  },
  {
    id: "6473",
    id_polifenol: "7485",
    polifenol:
      "kaempherol 3-O-beta-rhamnopyranosyl (1-6)-beta-D-glucopyranoside",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "22014228",
  },
  {
    id: "6474",
    id_polifenol: "7129",
    polifenol:
      "4-(5-acetyloxy-8,8-dimethyl-6-(3-methylbut-2-en-1-yl)-4-oxo-4,8-dihydropyrano(2,3-f)chromen-3-yl)-1,2-phenylene diacetate",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "27376493",
  },
  {
    id: "6475",
    id_polifenol: "5116",
    polifenol: "betuletol 3-methyl ether",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "16949071",
  },
  {
    id: "6476",
    id_polifenol: "4498",
    polifenol: "tanacin",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "19639540",
  },
  {
    id: "6477",
    id_polifenol: "941",
    polifenol: "caftaric acid",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "25554015",
  },
  {
    id: "6478",
    id_polifenol: "2206",
    polifenol: "alpha-resorcylic acid",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "29151072",
  },
  {
    id: "6479",
    id_polifenol: "7677",
    polifenol:
      "2-(3',4'-dihydroxyphenyl)-5,7-dihydroxy-3-(2'',6''-di-O-(3'''-(4-fluorophenylpropanoyl)))galactosyl-4H-chromen-4-one",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "25172420",
  },
  {
    id: "6480",
    id_polifenol: "7866",
    polifenol: "ephedrannin A",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "18975262",
  },
  {
    id: "6481",
    id_polifenol: "7859",
    polifenol: "ephedrannin B",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "18975262",
  },
  {
    id: "6482",
    id_polifenol: "1978",
    polifenol: "subereaphenol C",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "25812033",
  },
  {
    id: "6483",
    id_polifenol: "5479",
    polifenol: "cyanidin 3-O-glucopyranoside",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "20121190",
  },
  {
    id: "6484",
    id_polifenol: "6192",
    polifenol: "2',4'-dihydroxy-5'-(1'''-dimethylallyl)-6-prenylpinocembrin",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "18078919",
  },
  {
    id: "6485",
    id_polifenol: "6543",
    polifenol: "euchrenone b10",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "19252325",
  },
  {
    id: "6486",
    id_polifenol: "5194",
    polifenol: "dorsilurin F",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "29066296",
  },
  {
    id: "6487",
    id_polifenol: "3926",
    polifenol: "mallotojaponin",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "2236292",
  },
  {
    id: "6488",
    id_polifenol: "5216",
    polifenol: "abyssinone I",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "25019692",
  },
  {
    id: "6489",
    id_polifenol: "2271",
    polifenol: "lobarstin",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "29538328",
  },
  {
    id: "6490",
    id_polifenol: "275",
    polifenol: "trichlorophene",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "28699489",
  },
  {
    id: "6491",
    id_polifenol: "6502",
    polifenol: "pallidiflorin",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "23867903",
  },
  {
    id: "6492",
    id_polifenol: "1345",
    polifenol: "sonnerphenolic C",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "25933595",
  },
  {
    id: "6493",
    id_polifenol: "2872",
    polifenol: "norstictic acid",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "25233603",
  },
  {
    id: "6494",
    id_polifenol: "3906",
    polifenol: "hyperforin",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "21751836",
  },
  {
    id: "6495",
    id_polifenol: "3936",
    polifenol: "sideroxylonal C",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "24986654",
  },
  {
    id: "6496",
    id_polifenol: "7086",
    polifenol: "5,7,3',5'-tetrahydroxy-6,4'-dimethoxyflavone",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "25295671",
  },
  {
    id: "6497",
    id_polifenol: "1535",
    polifenol: "4-((4-hydroxyphenylimino)methyl)benzene-1,2-diol",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "28356012",
  },
  {
    id: "6498",
    id_polifenol: "1006",
    polifenol:
      "6-(4-((1E)-2-(3,5-dihydroxyphenyl)ethenyl)phenoxy)hexanoic acid",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "26666272",
  },
  {
    id: "6499",
    id_polifenol: "1999",
    polifenol: "2,3-dicyanohydroquinone",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "28838694",
  },
  {
    id: "6500",
    id_polifenol: "1473",
    polifenol: "isocordoin",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "26213910",
  },
  {
    id: "6501",
    id_polifenol: "3475",
    polifenol: "homoegonol",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "25795470",
  },
  {
    id: "6502",
    id_polifenol: "6174",
    polifenol: "(2S)-8-formyl-5-hydroxy-7-methoxy-6-methylflavanone",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "17430639",
  },
  {
    id: "6503",
    id_polifenol: "3986",
    polifenol: "sinapyl acetate",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "21473152",
  },
  {
    id: "6504",
    id_polifenol: "7138",
    polifenol: "apigenin dimethylether",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "21473152",
  },
  {
    id: "6505",
    id_polifenol: "4686",
    polifenol: "podocarpusflavone A",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "24716136",
  },
  {
    id: "6506",
    id_polifenol: "6768",
    polifenol:
      "chrysoeriol 7-O-(2'''-O-caffeoyl-beta-D-glucopyranosyl-(1-2)-beta-d-glucopyranoside)",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "28222613",
  },
  {
    id: "6507",
    id_polifenol: "2297",
    polifenol: "3'-O-beta-D-glucopyranosyl rosmarinic acid",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "28222613",
  },
  {
    id: "6508",
    id_polifenol: "4097",
    polifenol:
      "2-(2,4-dihydroxyphenyl)-3-formyl-4-hydroxy-6-methoxy-5-(3-methylbuten-2-yl)benzofuran",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "15579325",
  },
  {
    id: "6509",
    id_polifenol: "4609",
    polifenol: "4',7-dihydroxy-3-methoxy-5,6-dimethylflavone",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "28800661",
  },
  {
    id: "6510",
    id_polifenol: "1221",
    polifenol: "(E)-2-((benzo(d)thiazol-2-ylimino)methyl)-4-chlorophenol",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "24895493",
  },
  {
    id: "6511",
    id_polifenol: "4826",
    polifenol:
      "5,4'-dihydroxy-(3'',4''-dihydro-3'',4''-dihydroxy)-2'',2''-dimethylpyrano(5'',6''-7,8)flavone",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "19689125",
  },
  {
    id: "6512",
    id_polifenol: "4730",
    polifenol: "5-methoxy-6-methylflavan-7-ol",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "19689125",
  },
  {
    id: "6513",
    id_polifenol: "5524",
    polifenol: "proanthocyanidin B3",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "26501251",
  },
  {
    id: "6514",
    id_polifenol: "7559",
    polifenol:
      "quercetin 3-O-alpha-rhamnopyranosyl-(1-2)-beta-galactopyranoside",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "20121190",
  },
  {
    id: "6515",
    id_polifenol: "6121",
    polifenol:
      "2-5'-(-1''',1'''-dimethylallyl)-8-(3'',3''-dimethylallyl)-2'-methoxy-4',5,7-tetrahydroxyflavanone",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "23302649",
  },
  {
    id: "6516",
    id_polifenol: "4550",
    polifenol: "5,7-dimethoxy-4'-hydroxyflavone",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "28605048",
  },
  {
    id: "6517",
    id_polifenol: "3298",
    polifenol: "olifen",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "8708746",
  },
  {
    id: "6518",
    id_polifenol: "4343",
    polifenol: "3-cinnamoyltribuloside",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "25348942",
  },
  {
    id: "6519",
    id_polifenol: "7769",
    polifenol: "maackiapterocarpan B",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "19252325",
  },
  {
    id: "6520",
    id_polifenol: "6507",
    polifenol: "afromosin",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "29098824",
  },
  {
    id: "6521",
    id_polifenol: "7423",
    polifenol: "3-methylkaempferol",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "29098824",
  },
  {
    id: "6522",
    id_polifenol: "1399",
    polifenol: "KS I",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "29098824",
  },
  {
    id: "6523",
    id_polifenol: "4348",
    polifenol:
      "(2R,3S)-guibourtinidol-3-O-alpha-D-apiofuranosyl-(1-6)-O-beta-D-glucopyranoside",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "27538012",
  },
  {
    id: "6524",
    id_polifenol: "5625",
    polifenol: "fisetinidol-(4alpha-8)catechin 3-gallate",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "27538012",
  },
  {
    id: "6525",
    id_polifenol: "5953",
    polifenol: "morachalcone B",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "20211228",
  },
  {
    id: "6526",
    id_polifenol: "7856",
    polifenol: "mahuannin A",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "18975262",
  },
  {
    id: "6527",
    id_polifenol: "7483",
    polifenol: "5,7,4'-trihydroxyflavan (2alpha-O-7, 4alpha-8) kaempferol",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "18975262",
  },
  {
    id: "6528",
    id_polifenol: "7849",
    polifenol: "geranin D",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "18975262",
  },
  {
    id: "6529",
    id_polifenol: "3413",
    polifenol: "terricollene C",
    id_cancer: "540",
    cancer: "Cervical Cancer",
    quant: "1",
    pmids: "19795843",
  },
  {
    id: "6530",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "70",
    pmids:
      "27823633,27586822,23266503,25902740,29702405,23292685,16458870,25625479,24587153,25453494,27860196,29471888,22853317,25638174,24976450,27444692,26970256,25971889,21196331,29048641,26517521,23359392,28965117,25203554,29392841,26238204,27143851,23497967,22887049,21298326,15173424,20730632,18538589,22693649,24910406,25738754,29172259,27664007,26045985,16234852,24705371,25446081,16222712,29928143,16645725,23815868,2068000,24676882,17638904,16699821,26044862,23991004,21748601,18187256,29316796,8808829,11134977,22287334,21777476,27236067,2434441,24594241,8482562,25544650,29271940,18374420,23564766,29181405,27834134,8128490",
  },
  {
    id: "6531",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "59",
    pmids:
      "27268651,29495104,22771723,24938356,25725129,15252836,22522053,21711158,16243823,20127174,29512729,28587210,26482853,29424316,29312546,20030852,12678405,29228308,19228728,17569211,17594054,9563850,22489823,25349216,15129424,27384261,26036622,24570592,17310108,23287774,14657599,26815506,29766185,27597657,23162792,23452621,27091625,22284780,26942057,24840628,25979230,26799714,29533631,29869202,22583425,20647339,24156030,27468716,21777476,29264822,27609747,25252466,23597195,29624265,20737283,24592727,12628510,27515884,29890744",
  },
  {
    id: "6532",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "51",
    pmids:
      "22856131,22676643,27658723,26115086,29532526,27478384,25453494,20442318,29512729,20522783,26482853,29424316,22144737,20030852,21196331,22871396,15476848,11746506,29228308,26408414,22532866,19294520,16305349,17310108,23098466,26773801,16449979,15756018,12054484,19544670,26473769,27912881,17202688,7991611,17070989,11998565,23167379,11504910,18537723,24278338,10202393,20647339,27999314,27609747,28954885,24592727,29271940,22084729,24984103,23242008,29890744",
  },
  {
    id: "6533",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "38",
    pmids:
      "14614450,12704791,23708383,14598883,22120676,16458870,16520550,21328467,25638174,24732598,11686329,16636681,11339819,21570392,10197638,18161870,11781819,20506523,16550001,22543708,15031672,27499095,12481421,15001985,15743030,28487957,24434427,27752996,21394501,11861279,18826602,20398401,19576658,17505812,28904859,25330185,28529569,22282250",
  },
  {
    id: "6534",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "36",
    pmids:
      "16458870,27231938,19842228,8784471,20309614,17640171,18339885,9692192,16452247,8603368,15105043,20730632,15754008,16912569,17202688,23452621,11753986,19351854,22284780,15315711,23013480,17212824,21787627,10355749,9507517,23621233,15498380,15833874,21603581,25749878,27609747,23597195,28587155,20737283,24592727,9195288",
  },
  {
    id: "6535",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "28",
    pmids:
      "27823633,16458870,23094058,25971889,21196331,28965117,19294520,23497967,27495232,22842551,24165931,15325736,23152886,17202688,16222712,16645725,28799743,22284780,28188793,23991004,26018751,11134977,2434441,27609747,8482562,20737283,23564766,8128490",
  },
  {
    id: "6536",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "40",
    pmids:
      "24337301,20522783,23348740,22144737,20232120,23526965,11746506,17940513,19228728,21633670,21388137,24081390,25888278,12742577,16449979,24213313,15756018,12054484,19544670,17202688,28755734,11998565,22284780,18955299,22258296,12801907,26018751,28600977,26845066,20714789,17657175,10202393,9600118,27609747,23597195,28587155,20737283,23657153,28954885,17366537",
  },
  {
    id: "6537",
    id_polifenol: "2167",
    polifenol: "phenolic acid",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "2",
    pmids: "27573001,23242008",
  },
  {
    id: "6538",
    id_polifenol: "49",
    polifenol: "Aspirin",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "33",
    pmids:
      "22333315,20654727,7545088,12894587,14563940,10678579,14532966,18849138,17665043,18811671,26202947,21076843,23741443,26459390,27074574,18260128,27554763,15179621,10581086,19799610,17392172,15639720,15282642,24331369,22799330,27236067,17612047,29265902,28488110,27762101,29707148,137074,26607439",
  },
  {
    id: "6539",
    id_polifenol: "109",
    polifenol: "Catechin",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "15",
    pmids:
      "16458870,22144737,11746506,19294520,24081390,12742577,24141365,23236742,16449979,17070989,28755734,2068000,18955299,12801907,20045947",
  },
  {
    id: "6540",
    id_polifenol: "125",
    polifenol: "Isoflavones",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "15",
    pmids:
      "20309614,17640171,16452247,12115517,15105043,15754008,23272911,22412975,23013480,18537723,9507517,23621233,12242729,21603581,25749878",
  },
  {
    id: "6541",
    id_polifenol: "110",
    polifenol: "Chalcones",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "7",
    pmids: "24466137,26602275,25466202,24121102,15114497,18418697,29271940",
  },
  {
    id: "6542",
    id_polifenol: "3089",
    polifenol: "1,1-diphenyl-2-picrylhydrazyl",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "27683258",
  },
  {
    id: "6543",
    id_polifenol: "114",
    polifenol: "Apigenin",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "9",
    pmids:
      "26970256,23359392,21298326,27664007,16222712,22284780,17638904,20737283,25351792",
  },
  {
    id: "6544",
    id_polifenol: "113",
    polifenol: "Flavones",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "4",
    pmids: "26855338,21298326,23815868,17638904",
  },
  {
    id: "6545",
    id_polifenol: "38",
    polifenol: "Gallic Acid",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "3",
    pmids: "22144737,20955699,28746057",
  },
  {
    id: "6546",
    id_polifenol: "117",
    polifenol: "Luteolin",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "7",
    pmids: "23172826,16458870,25638174,29928143,22284780,23991004,18187256",
  },
  {
    id: "6547",
    id_polifenol: "1",
    polifenol: "Phenols",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "4",
    pmids: "24918476,25317974,12124773,10891119",
  },
  {
    id: "6548",
    id_polifenol: "105",
    polifenol: "Anthocyanins",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "8",
    pmids:
      "24666969,15975709,16618699,23864892,18767864,18504707,29172259,16234852",
  },
  {
    id: "6549",
    id_polifenol: "7235",
    polifenol: "silybin",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "15",
    pmids:
      "29875662,25172795,18538589,28401485,20089365,24705371,25446081,29472856,22258296,23830941,19047104,29250169,21777476,28713159,20737283",
  },
  {
    id: "6550",
    id_polifenol: "129",
    polifenol: "Rotenone",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "4",
    pmids: "26157141,10951577,25934296,2831981",
  },
  {
    id: "6551",
    id_polifenol: "121",
    polifenol: "Kaempferols",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "6",
    pmids: "25453494,27231938,22284780,24278338,25053822,28587155",
  },
  {
    id: "6552",
    id_polifenol: "871",
    polifenol: "ABT-737",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "3",
    pmids: "23832737,24036132,25690034",
  },
  {
    id: "6553",
    id_polifenol: "6451",
    polifenol: "daidzein",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "5",
    pmids: "20309614,15105043,16912569,9507517,25749878",
  },
  {
    id: "6554",
    id_polifenol: "6065",
    polifenol: "baicalein",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "9",
    pmids:
      "23266503,22484589,16458870,29048641,29392841,27143851,17070989,22284780,14669797",
  },
  {
    id: "6555",
    id_polifenol: "7",
    polifenol: "Capsaicin",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "4",
    pmids: "16583263,25736062,20737283,18499282",
  },
  {
    id: "6556",
    id_polifenol: "4634",
    polifenol: "alvocidib",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "4",
    pmids: "23576573,29805751,16921509,20737283",
  },
  {
    id: "6557",
    id_polifenol: "120",
    polifenol: "Flavonols",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "3",
    pmids: "23279849,18504707,17182824",
  },
  {
    id: "6558",
    id_polifenol: "4522",
    polifenol: "chrysin",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "3",
    pmids: "25625479,25875631,25914235",
  },
  {
    id: "6559",
    id_polifenol: "123",
    polifenol: "Rutin",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "3",
    pmids: "22144737,18187256,9890672",
  },
  {
    id: "6560",
    id_polifenol: "6062",
    polifenol: "naringenin",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "4",
    pmids: "27036297,16699821,21748601,19318568",
  },
  {
    id: "6561",
    id_polifenol: "39",
    polifenol: "Hydrolyzable Tannins",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "2",
    pmids: "27852125,23242008",
  },
  {
    id: "6562",
    id_polifenol: "130",
    polifenol: "Proanthocyanidins",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "3",
    pmids: "18504707,16234852,17182824",
  },
  {
    id: "6563",
    id_polifenol: "35",
    polifenol: "Hydroquinones",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "7991611",
  },
  {
    id: "6564",
    id_polifenol: "111",
    polifenol: "Flavanones",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "25978595",
  },
  {
    id: "6565",
    id_polifenol: "4502",
    polifenol: "fisetin",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "3",
    pmids: "26517521,20737283,8128490",
  },
  {
    id: "6566",
    id_polifenol: "6",
    polifenol: "Catechols",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "7991611",
  },
  {
    id: "6567",
    id_polifenol: "15",
    polifenol: "Masoprocol",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "3",
    pmids: "20654727,12740643,27863391",
  },
  {
    id: "6568",
    id_polifenol: "6087",
    polifenol: "wogonin",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "7",
    pmids: "24976450,28774312,25203554,23219337,28606135,22284780,21777476",
  },
  {
    id: "6569",
    id_polifenol: "4519",
    polifenol: "myricetin",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "29532526",
  },
  {
    id: "6570",
    id_polifenol: "4515",
    polifenol: "baicalin",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "3",
    pmids: "20036231,9764846,23157964",
  },
  {
    id: "6571",
    id_polifenol: "4500",
    polifenol: "procyanidin",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "24141365",
  },
  {
    id: "6572",
    id_polifenol: "5608",
    polifenol: "epicatechin gallate",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "5",
    pmids: "27224248,22144737,16449979,17202688,18955299",
  },
  {
    id: "6573",
    id_polifenol: "1356",
    polifenol: "gingerol",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "2",
    pmids: "24962868,16081047",
  },
  {
    id: "6574",
    id_polifenol: "54",
    polifenol: "Salicylic Acid",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "20089365",
  },
  {
    id: "6575",
    id_polifenol: "98",
    polifenol: "Propofol",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "7",
    pmids: "23742776,23155249,29805673,24510348,26669824,14570648,26111684",
  },
  {
    id: "6576",
    id_polifenol: "5607",
    polifenol: "gallocatechol",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "7",
    pmids: "16449979,17202688,17070989,28755734,18955299,27609747,17366537",
  },
  {
    id: "6577",
    id_polifenol: "4559",
    polifenol: "theaflavin",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "2",
    pmids: "27478384,19544670",
  },
  {
    id: "6578",
    id_polifenol: "5808",
    polifenol: "isoliquiritigenin",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "2",
    pmids: "26734591,27609747",
  },
  {
    id: "6579",
    id_polifenol: "2344",
    polifenol: "methyl gallate",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "22144737",
  },
  {
    id: "6580",
    id_polifenol: "112",
    polifenol: "Hesperidin",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "25632185",
  },
  {
    id: "6581",
    id_polifenol: "6455",
    polifenol: "nobiletin",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "4",
    pmids: "22853317,22549898,18053806,26012256",
  },
  {
    id: "6582",
    id_polifenol: "10",
    polifenol: "Estrogens, Catechol",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "8128490",
  },
  {
    id: "6583",
    id_polifenol: "4513",
    polifenol: "galangin",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "22887049",
  },
  {
    id: "6584",
    id_polifenol: "6063",
    polifenol: "naringin",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "22144737",
  },
  {
    id: "6585",
    id_polifenol: "1380",
    polifenol: "shogaol",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "5",
    pmids: "25621970,28110870,24962868,23417847,27609747",
  },
  {
    id: "6586",
    id_polifenol: "2158",
    polifenol: "protocatechuic acid",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "28266966",
  },
  {
    id: "6587",
    id_polifenol: "6273",
    polifenol: "hesperetin",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "16699821",
  },
  {
    id: "6588",
    id_polifenol: "93",
    polifenol: "Phloroglucinol",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "25843036",
  },
  {
    id: "6589",
    id_polifenol: "6461",
    polifenol: "acacetin",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "25203554",
  },
  {
    id: "6590",
    id_polifenol: "4253",
    polifenol:
      "5-(2,4-dihydroxy-5-isopropylphenyl)-4-(4-morpholin-4-ylmethylphenyl)isoxazole-3-carboxylic acid ethylamide",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "18413753",
  },
  {
    id: "6591",
    id_polifenol: "119",
    polifenol: "Silymarin",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "21466434",
  },
  {
    id: "6592",
    id_polifenol: "126",
    polifenol: "Coumestrol",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "15105043",
  },
  {
    id: "6593",
    id_polifenol: "5806",
    polifenol: "butein",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "2",
    pmids: "25137351,20737283",
  },
  {
    id: "6594",
    id_polifenol: "108",
    polifenol: "Biflavonoids",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "28947953",
  },
  {
    id: "6595",
    id_polifenol: "5509",
    polifenol: "cyanidin 3-O-glucoside",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "2",
    pmids: "15975709,16618699",
  },
  {
    id: "6596",
    id_polifenol: "969",
    polifenol: "3,4-dihydroxyphenacyl caffeate phenylpropanoid ester",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "21978886",
  },
  {
    id: "6597",
    id_polifenol: "6463",
    polifenol: "puerarin",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "19852298",
  },
  {
    id: "6598",
    id_polifenol: "5819",
    polifenol: "licochalcone A",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "3",
    pmids: "24466137,20383690,24789273",
  },
  {
    id: "6599",
    id_polifenol: "4640",
    polifenol: "5,7-dihydroxy-6-methoxy-2-phenylchromen-4-one",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "26741501",
  },
  {
    id: "6600",
    id_polifenol: "4537",
    polifenol: "flavone acetic acid",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "2",
    pmids: "9891222,11280751",
  },
  {
    id: "6601",
    id_polifenol: "2773",
    polifenol: "farnesylthiosalicylic acid",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "17699784",
  },
  {
    id: "6602",
    id_polifenol: "132",
    polifenol: "Equol",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "2",
    pmids: "15105043,25749878",
  },
  {
    id: "6603",
    id_polifenol: "1995",
    polifenol: "2-tert-butylhydroquinone",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "14502842",
  },
  {
    id: "6604",
    id_polifenol: "1673",
    polifenol: "4-hydroxyestradiol",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "2",
    pmids: "14630092,8128490",
  },
  {
    id: "6605",
    id_polifenol: "7546",
    polifenol: "isoquercitrin",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "24676882",
  },
  {
    id: "6606",
    id_polifenol: "6482",
    polifenol: "tangeretin",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "22549898",
  },
  {
    id: "6607",
    id_polifenol: "452",
    polifenol: "acteoside",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "29886834",
  },
  {
    id: "6608",
    id_polifenol: "5614",
    polifenol: "catechin gallate",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "2",
    pmids: "19544670,20737283",
  },
  {
    id: "6609",
    id_polifenol: "1866",
    polifenol: "4,6-dinitro-o-cresol",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "29137219",
  },
  {
    id: "6610",
    id_polifenol: "4486",
    polifenol: "amentoflavone",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "2",
    pmids: "17548797,18686102",
  },
  {
    id: "6611",
    id_polifenol: "5850",
    polifenol: "cardamonin",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "26855338",
  },
  {
    id: "6612",
    id_polifenol: "7541",
    polifenol: "taxifolin",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "16458870",
  },
  {
    id: "6613",
    id_polifenol: "300",
    polifenol: "rhodioloside",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "21978886",
  },
  {
    id: "6614",
    id_polifenol: "7912",
    polifenol: "7,9,2',4'-tetrahydroxy-8-isopentenyl-5-methoxychalcone",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "24641665",
  },
  {
    id: "6615",
    id_polifenol: "6465",
    polifenol: "genistin",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "2",
    pmids: "16452247,12242729",
  },
  {
    id: "6616",
    id_polifenol: "2475",
    polifenol: "6-O-galloylglucose",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "2",
    pmids: "16449979,12801907",
  },
  {
    id: "6617",
    id_polifenol: "2447",
    polifenol: "beta-penta-O-galloyl-glucose",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "2",
    pmids: "15105050,21289371",
  },
  {
    id: "6618",
    id_polifenol: "6576",
    polifenol: "5,7,4'-trihydroxyflavone",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "25351792",
  },
  {
    id: "6619",
    id_polifenol: "6086",
    polifenol: "liquiritigenin",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "2",
    pmids: "29471888,25978595",
  },
  {
    id: "6620",
    id_polifenol: "36",
    polifenol: "Hydroxybenzoates",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "19282185",
  },
  {
    id: "6621",
    id_polifenol: "7134",
    polifenol: "vitexin",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "27834134",
  },
  {
    id: "6622",
    id_polifenol: "5630",
    polifenol: "polyphenon E",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "2",
    pmids: "20522783,22258296",
  },
  {
    id: "6623",
    id_polifenol: "7547",
    polifenol: "hyperoside",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "27459118",
  },
  {
    id: "6624",
    id_polifenol: "637",
    polifenol: "glabridin",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "24641665",
  },
  {
    id: "6625",
    id_polifenol: "1810",
    polifenol: "heminordihydroguaiaretic acid",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "15725809",
  },
  {
    id: "6626",
    id_polifenol: "6477",
    polifenol: "hispidulin",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "26045985",
  },
  {
    id: "6627",
    id_polifenol: "6510",
    polifenol: "glycitein",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "2",
    pmids: "20309614,15105043",
  },
  {
    id: "6628",
    id_polifenol: "1353",
    polifenol: "protocatechualdehyde",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "29285297",
  },
  {
    id: "6629",
    id_polifenol: "4501",
    polifenol: "tricin",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "29483221",
  },
  {
    id: "6630",
    id_polifenol: "7612",
    polifenol: "quercetin 3-O-glucuronide",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "22211962",
  },
  {
    id: "6631",
    id_polifenol: "4715",
    polifenol: "ampelopsin",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "3",
    pmids: "22693649,12703989,15620188",
  },
  {
    id: "6632",
    id_polifenol: "4565",
    polifenol: "morusin",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "2",
    pmids: "26646273,23543150",
  },
  {
    id: "6633",
    id_polifenol: "885",
    polifenol: "oleocanthal",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "27878290",
  },
  {
    id: "6634",
    id_polifenol: "6129",
    polifenol: "wogonoside",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "28774312",
  },
  {
    id: "6635",
    id_polifenol: "896",
    polifenol: "polyphenon B",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "17070989",
  },
  {
    id: "6636",
    id_polifenol: "6770",
    polifenol: "5-hydroxy-3,6,7,8,3',4'-hexamethoxyflavone",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "18053806",
  },
  {
    id: "6637",
    id_polifenol: "2283",
    polifenol: "depsidone",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "26744260",
  },
  {
    id: "6638",
    id_polifenol: "2790",
    polifenol: "ginkgolic acid",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "27177359",
  },
  {
    id: "6639",
    id_polifenol: "4479",
    polifenol: "morin",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "23279849",
  },
  {
    id: "6640",
    id_polifenol: "4052",
    polifenol: "bis-(3-(3',5'-di-tert-butyl-4'-hydroxyphenyl)propyl)sulfide",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "10891119",
  },
  {
    id: "6641",
    id_polifenol: "1687",
    polifenol: "2-hydroxyestrone",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "1614394",
  },
  {
    id: "6642",
    id_polifenol: "315",
    polifenol: "bakuchiol",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "23302649",
  },
  {
    id: "6643",
    id_polifenol: "1689",
    polifenol: "16-hydroxyestrone",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "14630092",
  },
  {
    id: "6644",
    id_polifenol: "11",
    polifenol: "Hydroxyestrones",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "1614394",
  },
  {
    id: "6645",
    id_polifenol: "4573",
    polifenol: "3,3',4',5,6,7,8-heptamethoxyflavone",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "18053806",
  },
  {
    id: "6646",
    id_polifenol: "1678",
    polifenol: "2-methoxyestrone",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "20492690",
  },
  {
    id: "6647",
    id_polifenol: "3258",
    polifenol: "tesmilifene",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "1617649",
  },
  {
    id: "6648",
    id_polifenol: "7895",
    polifenol: "flavokawain A",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "24121102",
  },
  {
    id: "6649",
    id_polifenol: "4553",
    polifenol: "sulfuretin",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "23292685",
  },
  {
    id: "6650",
    id_polifenol: "7880",
    polifenol: "xanthoangelol",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "2",
    pmids: "12845685,15114497",
  },
  {
    id: "6651",
    id_polifenol: "70",
    polifenol: "Sulfobromophthalein",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "2",
    pmids: "3884476,20410058",
  },
  {
    id: "6652",
    id_polifenol: "5615",
    polifenol: "gallocatechin gallate",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "2",
    pmids: "22144737,17202688",
  },
  {
    id: "6653",
    id_polifenol: "4632",
    polifenol: "ginkgetin",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "27059688",
  },
  {
    id: "6654",
    id_polifenol: "5245",
    polifenol: "BF6-6 biflavone",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "27059688",
  },
  {
    id: "6655",
    id_polifenol: "839",
    polifenol: "5-iodo-3-((3,5-dibromo-4-hydroxyphenyl)methylene)-2-indolinone",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "23172826",
  },
  {
    id: "6656",
    id_polifenol: "1716",
    polifenol: "zingerone",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "28110870",
  },
  {
    id: "6657",
    id_polifenol: "1509",
    polifenol: "8-gingerol",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "24962868",
  },
  {
    id: "6658",
    id_polifenol: "52",
    polifenol: "Diflunisal",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "21573528",
  },
  {
    id: "6659",
    id_polifenol: "7885",
    polifenol: "hydroxysafflor yellow A",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "28966242",
  },
  {
    id: "6660",
    id_polifenol: "5525",
    polifenol: "cyanidin 3-rutinoside",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "15975709",
  },
  {
    id: "6661",
    id_polifenol: "2169",
    polifenol: "ethyl protocatechuate",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "28266966",
  },
  {
    id: "6662",
    id_polifenol: "2336",
    polifenol: "octyl gallate",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "28746057",
  },
  {
    id: "6663",
    id_polifenol: "2868",
    polifenol: "3-hydroxy-4-prenyl-5-methoxystilbene-2-carboxylic acid",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "25925965",
  },
  {
    id: "6664",
    id_polifenol: "2161",
    polifenol: "nifuroxazide",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "3",
    pmids: "26830149,28055016,25811798",
  },
  {
    id: "6665",
    id_polifenol: "7736",
    polifenol: "7-monohydroxyethylrutoside",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "22287334",
  },
  {
    id: "6666",
    id_polifenol: "4297",
    polifenol: "curvularin",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "23134667",
  },
  {
    id: "6667",
    id_polifenol: "7879",
    polifenol: "4-hydroxyderricin",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "15114497",
  },
  {
    id: "6668",
    id_polifenol: "5697",
    polifenol:
      "3-(3,4-dimethoxyphenyl)-1-(5-hydroxy-2,2-dimethyl-2H-chromen-6-yl)prop-2-en-1-one",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "27658723",
  },
  {
    id: "6669",
    id_polifenol: "6460",
    polifenol: "ipriflavone",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "12115517",
  },
  {
    id: "6670",
    id_polifenol: "903",
    polifenol: "vineatrol",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "20522783",
  },
  {
    id: "6671",
    id_polifenol: "3336",
    polifenol:
      "N-hydroxy-5-ethoxymethyloxy-2-methyl-4-(4-phenoxybenzoyl)aminopentanamide",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "11856483",
  },
  {
    id: "6672",
    id_polifenol: "4298",
    polifenol: "dehydrocurvularin",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "23134667",
  },
  {
    id: "6673",
    id_polifenol: "4919",
    polifenol: "bavachinin",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "23302649",
  },
  {
    id: "6674",
    id_polifenol: "6470",
    polifenol: "O-desmethylangolensin",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "15105043",
  },
  {
    id: "6675",
    id_polifenol: "5129",
    polifenol: "echinoside",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "21726060",
  },
  {
    id: "6676",
    id_polifenol: "1152",
    polifenol: "salvianolic acid",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "20621088",
  },
  {
    id: "6677",
    id_polifenol: "3608",
    polifenol:
      "5-(5-ethyl-2-hydroxy-4-methoxyphenyl)-4-(4-methoxyphenyl)isoxazole",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "16234246",
  },
  {
    id: "6678",
    id_polifenol: "4053",
    polifenol: "succinobucol",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "26711864",
  },
  {
    id: "6679",
    id_polifenol: "5680",
    polifenol: "3-O-(3,4,5-trimethoxybenzoyl)catechin",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "27054335",
  },
  {
    id: "6680",
    id_polifenol: "376",
    polifenol: "4-vinylphenol",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "29777274",
  },
  {
    id: "6681",
    id_polifenol: "5010",
    polifenol: "procyanidin C",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "24141365",
  },
  {
    id: "6682",
    id_polifenol: "2987",
    polifenol: "succinyldisalicylic acid",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "24766798",
  },
  {
    id: "6683",
    id_polifenol: "1468",
    polifenol: "plantamajoside",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "26674531",
  },
  {
    id: "6684",
    id_polifenol: "1671",
    polifenol: "pentagamavunon-0",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "27268651",
  },
  {
    id: "6685",
    id_polifenol: "1541",
    polifenol: "3-hydroxybakuchiol",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "23302649",
  },
  {
    id: "6686",
    id_polifenol: "5994",
    polifenol: "2-hydroxy-3',5,5'-trimethoxychalcone",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "26602275",
  },
  {
    id: "6687",
    id_polifenol: "5399",
    polifenol: "7,7''-dimethoxyagastisflavone",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "28947953",
  },
  {
    id: "6688",
    id_polifenol: "4678",
    polifenol: "natsudaidain",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "18053806",
  },
  {
    id: "6689",
    id_polifenol: "5239",
    polifenol: "syringetin",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "26044862",
  },
  {
    id: "6690",
    id_polifenol: "67",
    polifenol: "Phenolphthaleins",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "3620717",
  },
  {
    id: "6691",
    id_polifenol: "509",
    polifenol: "cassigarol A",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "11062699",
  },
  {
    id: "6692",
    id_polifenol: "182",
    polifenol: "ISO-66",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "25050663",
  },
  {
    id: "6693",
    id_polifenol: "1474",
    polifenol: "myxochelin B",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "19282185",
  },
  {
    id: "6694",
    id_polifenol: "1167",
    polifenol: "NSC668394",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "21706056",
  },
  {
    id: "6695",
    id_polifenol: "6121",
    polifenol:
      "2-5'-(-1''',1'''-dimethylallyl)-8-(3'',3''-dimethylallyl)-2'-methoxy-4',5,7-tetrahydroxyflavanone",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "23302649",
  },
  {
    id: "6696",
    id_polifenol: "3114",
    polifenol: "phenolphthalein glucuronide",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "3620717",
  },
  {
    id: "6697",
    id_polifenol: "2667",
    polifenol: "glycol salicylate",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "26937173",
  },
  {
    id: "6698",
    id_polifenol: "7773",
    polifenol: "inermin",
    id_cancer: "10000",
    cancer: "Neoplasm Metastasis",
    quant: "1",
    pmids: "27683258",
  },
  {
    id: "6699",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "80",
    pmids:
      "22056335,22616882,27630565,25192075,20674374,28167484,22526619,24398107,23438826,10418944,20826149,7923555,11588896,29734739,23975834,19082476,26878784,29749427,21660680,28950682,19705844,29422966,22743247,29303970,27761071,15969450,19666078,12724357,24125835,27641938,27168755,21104029,29968480,19601638,27013795,23173924,25053074,15173424,20626003,25855962,10739098,19424633,22906313,22209285,27392941,23664836,11850210,29083228,19639540,11502892,28582635,25887417,22186328,29491628,27039735,26320438,26158795,26320439,27262066,3482545,28132882,11795395,26320443,26893687,27374079,21166494,28718725,28695656,29656660,27541567,19194970,9239522,21400027,16777995,28178217,29607788,23238426,29962921,25544650,9167997",
  },
  {
    id: "6700",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "44",
    pmids:
      "9215611,29138806,28152473,9831541,12718610,23040919,25826489,25253691,26350251,9591190,15210154,24377502,26413251,17555831,25031701,29732970,24738327,14511655,23287774,27293144,27610163,29336533,27306423,25882494,16648566,24034496,28724427,28236692,29881406,27779649,25014638,28420987,29516756,28738425,29048630,21479462,22390767,27301171,29441997,25863259,25553436,19516890,25900098,29486375",
  },
  {
    id: "6701",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "18",
    pmids:
      "22353783,20013881,19082476,25196850,17555831,20669365,18607509,27231728,28839265,24772933,29083228,27610163,20482276,26158795,28926932,26036628,25930965,28718725",
  },
  {
    id: "6702",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "28",
    pmids:
      "18252963,27819344,9642218,25447816,20203690,27589474,15231676,17160024,11149601,11911959,11710832,9388270,12839332,12231395,15922332,22128158,18534028,11910048,11463858,28560447,21350004,9545345,11359772,29371916,12082091,16740736,16239258,19578757",
  },
  {
    id: "6703",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "41",
    pmids:
      "18252963,7819137,17295235,9831541,28950682,16309237,19932626,29899271,9848511,23379261,17234721,17482226,21783722,14511655,20574927,16596234,11502892,16870006,24812910,26081033,29955703,20127002,11795395,15729618,14720368,21958026,20455703,21693041,23871935,23541764,19079905,16777995,16399773,11577007,16619504,25493176,15833874,12899539,25190728,9167997,19325924",
  },
  {
    id: "6704",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "30",
    pmids:
      "21042744,7923555,25983116,24407148,12724357,27641938,22289578,21104029,27013795,28808404,17482226,22842551,26259240,17172819,27224244,18607509,27392941,16596234,23664836,27041924,11502892,3482545,18456490,21693041,20447470,21400027,16777995,28178217,20600213,21371568",
  },
  {
    id: "6705",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "16",
    pmids:
      "17575143,17483343,15367686,27231728,23664836,28839265,24772933,26225796,23638734,18813800,29955703,7585463,22307971,14600287,25372613,14600840",
  },
  {
    id: "6706",
    id_polifenol: "2167",
    polifenol: "phenolic acid",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "20",
    pmids:
      "22868134,27288921,25447816,17958397,19082476,23712134,12718610,29303970,27168755,28803117,27013795,25053074,28480370,22906313,7887982,27651811,23265523,27262066,28695656,28178217",
  },
  {
    id: "6707",
    id_polifenol: "49",
    polifenol: "Aspirin",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "16",
    pmids:
      "18425372,22081376,20857911,10652584,20457246,22179060,29106390,17290354,26530254,11746823,25867761,25659932,24923427,26673874,16493264,25085874",
  },
  {
    id: "6708",
    id_polifenol: "109",
    polifenol: "Catechin",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "15",
    pmids:
      "17483343,25196850,29278988,23142797,27224244,18607509,23638734,7585463,22307971,21882252,14600287,25372613,23352646,22045026,14600840",
  },
  {
    id: "6709",
    id_polifenol: "125",
    polifenol: "Isoflavones",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "27",
    pmids:
      "17295235,28950682,21284537,9848511,23379261,19322027,14511655,14618609,20574927,16870006,9696881,11850205,21958026,20455703,29656660,23871935,19079905,26432036,16399773,11577007,16619504,25493176,25553084,10498753,25190728,11795443,9168894",
  },
  {
    id: "6710",
    id_polifenol: "110",
    polifenol: "Chalcones",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "11",
    pmids:
      "28335434,27819344,22634834,10418944,25743216,21170936,28627468,24211632,29792154,25276196,29656660",
  },
  {
    id: "6711",
    id_polifenol: "3089",
    polifenol: "1,1-diphenyl-2-picrylhydrazyl",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "18",
    pmids:
      "22628260,22210035,23712134,24649909,24125835,22289578,28803117,23173924,25053074,29956560,27224244,27039735,26320438,26320439,26142508,26320443,29476965,29887909",
  },
  {
    id: "6712",
    id_polifenol: "114",
    polifenol: "Apigenin",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "9",
    pmids:
      "11588896,16357145,19666078,28803117,17482226,22209285,17437270,22569706,28441391",
  },
  {
    id: "6713",
    id_polifenol: "113",
    polifenol: "Flavones",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "12",
    pmids:
      "20674374,29734739,29667279,22743247,19666078,28480370,11850210,9696881,29955703,11850205,17261771,15165133",
  },
  {
    id: "6714",
    id_polifenol: "38",
    polifenol: "Gallic Acid",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "6",
    pmids: "23975834,23712134,27226907,22289578,28808404,27231728",
  },
  {
    id: "6715",
    id_polifenol: "117",
    polifenol: "Luteolin",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "7",
    pmids: "22926442,20811693,22799344,25851346,27013795,26672742,19424633",
  },
  {
    id: "6716",
    id_polifenol: "1",
    polifenol: "Phenols",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "13",
    pmids:
      "19082476,24339417,22221539,27651811,11097223,15115406,22254082,19194970,3695475,1995907,29887909,15720121,9168894",
  },
  {
    id: "6717",
    id_polifenol: "105",
    polifenol: "Anthocyanins",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "7",
    pmids: "23975834,26069256,27388461,25053074,23828497,23265523,22812448",
  },
  {
    id: "6718",
    id_polifenol: "7235",
    polifenol: "silybin",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "3",
    pmids: "24377502,22526491,21166494",
  },
  {
    id: "6719",
    id_polifenol: "129",
    polifenol: "Rotenone",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "9",
    pmids:
      "27288921,23245650,21785662,9831541,19091749,21284537,21875114,22428931,10498753",
  },
  {
    id: "6720",
    id_polifenol: "121",
    polifenol: "Kaempferols",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "4",
    pmids: "14603522,26878784,27013795,28178217",
  },
  {
    id: "6721",
    id_polifenol: "871",
    polifenol: "ABT-737",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "5",
    pmids: "25215949,20876285,26015514,21768359,23845444",
  },
  {
    id: "6722",
    id_polifenol: "6451",
    polifenol: "daidzein",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "10",
    pmids:
      "9848511,20574927,16870006,20127002,20455703,22217331,26432036,16399773,25190728,9168894",
  },
  {
    id: "6723",
    id_polifenol: "6065",
    polifenol: "baicalein",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "2",
    pmids: "29667279,19666078",
  },
  {
    id: "6724",
    id_polifenol: "7",
    polifenol: "Capsaicin",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "2",
    pmids: "22226932,12718610",
  },
  {
    id: "6725",
    id_polifenol: "4634",
    polifenol: "alvocidib",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "6",
    pmids: "26924736,16951203,15640956,14767524,8895733,12174876",
  },
  {
    id: "6726",
    id_polifenol: "120",
    polifenol: "Flavonols",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "5",
    pmids: "22210035,24125835,28803117,28480370,28178217",
  },
  {
    id: "6727",
    id_polifenol: "4522",
    polifenol: "chrysin",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "4",
    pmids: "28398698,27761071,19666078,17482226",
  },
  {
    id: "6728",
    id_polifenol: "123",
    polifenol: "Rutin",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "3",
    pmids: "7923555,29083228,29476965",
  },
  {
    id: "6729",
    id_polifenol: "6062",
    polifenol: "naringenin",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "4",
    pmids: "25192075,29968480,17482226,22209285",
  },
  {
    id: "6730",
    id_polifenol: "285",
    polifenol: "bisphenol A",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "8",
    pmids:
      "18252963,18544561,22132214,11485868,16931338,19796866,26241069,18381411",
  },
  {
    id: "6731",
    id_polifenol: "39",
    polifenol: "Hydrolyzable Tannins",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "5",
    pmids: "22906313,27651811,25887417,22186328,29607788",
  },
  {
    id: "6732",
    id_polifenol: "130",
    polifenol: "Proanthocyanidins",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "2",
    pmids: "20146248,11759289",
  },
  {
    id: "6733",
    id_polifenol: "35",
    polifenol: "Hydroquinones",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "2",
    pmids: "16756956,7887982",
  },
  {
    id: "6734",
    id_polifenol: "111",
    polifenol: "Flavanones",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "3",
    pmids: "25192075,10418944,28398698",
  },
  {
    id: "6735",
    id_polifenol: "4502",
    polifenol: "fisetin",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "29749427",
  },
  {
    id: "6736",
    id_polifenol: "6",
    polifenol: "Catechols",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "7",
    pmids: "23437041,7887982,15499624,1963166,6284766,8654195,9219504",
  },
  {
    id: "6737",
    id_polifenol: "75",
    polifenol: "Butylated Hydroxyanisole",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "5",
    pmids: "23173924,23697596,23027624,8375015,19526586",
  },
  {
    id: "6738",
    id_polifenol: "15",
    polifenol: "Masoprocol",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "2",
    pmids: "23053656,12616597",
  },
  {
    id: "6739",
    id_polifenol: "6087",
    polifenol: "wogonin",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "2",
    pmids: "22513472,28774312",
  },
  {
    id: "6740",
    id_polifenol: "4519",
    polifenol: "myricetin",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "2",
    pmids: "16216908,28178217",
  },
  {
    id: "6741",
    id_polifenol: "4500",
    polifenol: "procyanidin",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "23626391",
  },
  {
    id: "6742",
    id_polifenol: "5608",
    polifenol: "epicatechin gallate",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "4",
    pmids: "7585463,22307971,14600287,14600840",
  },
  {
    id: "6743",
    id_polifenol: "54",
    polifenol: "Salicylic Acid",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "11850210",
  },
  {
    id: "6744",
    id_polifenol: "5607",
    polifenol: "gallocatechol",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "2",
    pmids: "25196850,14600840",
  },
  {
    id: "6745",
    id_polifenol: "5578",
    polifenol: "alpha-naphthoflavone",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "5",
    pmids: "25781201,29955703,19406931,26715507,6265068",
  },
  {
    id: "6746",
    id_polifenol: "44",
    polifenol: "Salicylates",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "2",
    pmids: "18425372,10652584",
  },
  {
    id: "6747",
    id_polifenol: "5808",
    polifenol: "isoliquiritigenin",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "2",
    pmids: "21693041,28615942",
  },
  {
    id: "6748",
    id_polifenol: "2344",
    polifenol: "methyl gallate",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "28808404",
  },
  {
    id: "6749",
    id_polifenol: "4708",
    polifenol: "xanthohumol",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "2",
    pmids: "10418944,29422966",
  },
  {
    id: "6750",
    id_polifenol: "2284",
    polifenol: "rosmarinic acid",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "26075250",
  },
  {
    id: "6751",
    id_polifenol: "112",
    polifenol: "Hesperidin",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "23690228",
  },
  {
    id: "6752",
    id_polifenol: "6455",
    polifenol: "nobiletin",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "22743247",
  },
  {
    id: "6753",
    id_polifenol: "10",
    polifenol: "Estrogens, Catechol",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "5",
    pmids: "17575138,14623547,18379081,20600213,19250200",
  },
  {
    id: "6754",
    id_polifenol: "2158",
    polifenol: "protocatechuic acid",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "11097223",
  },
  {
    id: "6755",
    id_polifenol: "5489",
    polifenol: "delphinidin",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "23975834",
  },
  {
    id: "6756",
    id_polifenol: "6273",
    polifenol: "hesperetin",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "2",
    pmids: "22209285,23238426",
  },
  {
    id: "6757",
    id_polifenol: "1613",
    polifenol: "demethoxycurcumin",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "9591190",
  },
  {
    id: "6758",
    id_polifenol: "81",
    polifenol: "Fenofibrate",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "2",
    pmids: "20868670,16525649",
  },
  {
    id: "6759",
    id_polifenol: "7550",
    polifenol: "3-methylquercetin",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "28178217",
  },
  {
    id: "6760",
    id_polifenol: "6461",
    polifenol: "acacetin",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "3",
    pmids: "22743247,19666078,19601638",
  },
  {
    id: "6761",
    id_polifenol: "4253",
    polifenol:
      "5-(2,4-dihydroxy-5-isopropylphenyl)-4-(4-morpholin-4-ylmethylphenyl)isoxazole-3-carboxylic acid ethylamide",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "4",
    pmids: "25721082,18413753,18430202,24280702",
  },
  {
    id: "6762",
    id_polifenol: "1611",
    polifenol: "bis(4-hydroxycinnamoyl)methane",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "9591190",
  },
  {
    id: "6763",
    id_polifenol: "107",
    polifenol: "beta-Naphthoflavone",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "2",
    pmids: "8375015,6265068",
  },
  {
    id: "6764",
    id_polifenol: "69",
    polifenol: "Phenolsulfonphthalein",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "3",
    pmids: "2706828,2785242,2783381",
  },
  {
    id: "6765",
    id_polifenol: "55",
    polifenol: "Sodium Salicylate",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "18425372",
  },
  {
    id: "6766",
    id_polifenol: "5806",
    polifenol: "butein",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "3",
    pmids: "20699088,20826149,21170936",
  },
  {
    id: "6767",
    id_polifenol: "108",
    polifenol: "Biflavonoids",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "27288921",
  },
  {
    id: "6768",
    id_polifenol: "94",
    polifenol: "Phloretin",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "5",
    pmids: "25229655,19723092,16906425,26259240,28132882",
  },
  {
    id: "6769",
    id_polifenol: "48",
    polifenol: "Anacardic Acids",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "24648416",
  },
  {
    id: "6770",
    id_polifenol: "4640",
    polifenol: "5,7-dihydroxy-6-methoxy-2-phenylchromen-4-one",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "2",
    pmids: "22526619,25855962",
  },
  {
    id: "6771",
    id_polifenol: "2773",
    polifenol: "farnesylthiosalicylic acid",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "3",
    pmids: "18637482,16113100,12790788",
  },
  {
    id: "6772",
    id_polifenol: "132",
    polifenol: "Equol",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "3",
    pmids: "22217331,27323858,16399773",
  },
  {
    id: "6773",
    id_polifenol: "1673",
    polifenol: "4-hydroxyestradiol",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "4",
    pmids: "20090883,15499624,16213115,29290975",
  },
  {
    id: "6774",
    id_polifenol: "89",
    polifenol: "Vanillic Acid",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "11097223",
  },
  {
    id: "6775",
    id_polifenol: "452",
    polifenol: "acteoside",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "22289578",
  },
  {
    id: "6776",
    id_polifenol: "5614",
    polifenol: "catechin gallate",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "14600840",
  },
  {
    id: "6777",
    id_polifenol: "1866",
    polifenol: "4,6-dinitro-o-cresol",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "2",
    pmids: "29137219,2820475",
  },
  {
    id: "6778",
    id_polifenol: "7541",
    polifenol: "taxifolin",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "29491628",
  },
  {
    id: "6779",
    id_polifenol: "7544",
    polifenol: "quercitrin",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "28178217",
  },
  {
    id: "6780",
    id_polifenol: "7912",
    polifenol: "7,9,2',4'-tetrahydroxy-8-isopentenyl-5-methoxychalcone",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "21831037",
  },
  {
    id: "6781",
    id_polifenol: "6465",
    polifenol: "genistin",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "3",
    pmids: "14618609,24812910,11577007",
  },
  {
    id: "6782",
    id_polifenol: "92",
    polifenol: "Triclosan",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "3",
    pmids: "26878784,24684733,20932229",
  },
  {
    id: "6783",
    id_polifenol: "6097",
    polifenol: "8-prenylnaringenin",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "23541764",
  },
  {
    id: "6784",
    id_polifenol: "6625",
    polifenol: "phenoxodiol",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "26432036",
  },
  {
    id: "6785",
    id_polifenol: "4516",
    polifenol: "diosmetin",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "19424633",
  },
  {
    id: "6786",
    id_polifenol: "102",
    polifenol: "Zearalenone",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "3",
    pmids: "27311894,11205083,22145580",
  },
  {
    id: "6787",
    id_polifenol: "36",
    polifenol: "Hydroxybenzoates",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "2",
    pmids: "26854920,22744862",
  },
  {
    id: "6788",
    id_polifenol: "4796",
    polifenol: "aminoflavone",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "3",
    pmids: "15210858,26996297,15115406",
  },
  {
    id: "6789",
    id_polifenol: "637",
    polifenol: "glabridin",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "2",
    pmids: "20626003,11059763",
  },
  {
    id: "6790",
    id_polifenol: "6301",
    polifenol: "3-methoxyflavone",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "18544561",
  },
  {
    id: "6791",
    id_polifenol: "43",
    polifenol: "Parabens",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "2",
    pmids: "22744862,20932229",
  },
  {
    id: "6792",
    id_polifenol: "6783",
    polifenol: "protoapigenone",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "2",
    pmids: "24721328,25455158",
  },
  {
    id: "6793",
    id_polifenol: "7198",
    polifenol: "homoorientin",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "27630565",
  },
  {
    id: "6794",
    id_polifenol: "128",
    polifenol: "Pterocarpans",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "29656660",
  },
  {
    id: "6795",
    id_polifenol: "6456",
    polifenol: "daidzin",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "27592281",
  },
  {
    id: "6796",
    id_polifenol: "103",
    polifenol: "Zeranol",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "4",
    pmids: "27220457,22113133,17900592,15569208",
  },
  {
    id: "6797",
    id_polifenol: "1353",
    polifenol: "protocatechualdehyde",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "25447816",
  },
  {
    id: "6798",
    id_polifenol: "4501",
    polifenol: "tricin",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "11097223",
  },
  {
    id: "6799",
    id_polifenol: "7853",
    polifenol: "Grape Seed Proanthocyanidins",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "2",
    pmids: "20146248,11759289",
  },
  {
    id: "6800",
    id_polifenol: "4304",
    polifenol: "5-7-oxo-zeaenol",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "25557171",
  },
  {
    id: "6801",
    id_polifenol: "4521",
    polifenol: "3-hydroxyflavone",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "23438826",
  },
  {
    id: "6802",
    id_polifenol: "413",
    polifenol: "4-nonylphenol",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "9831541",
  },
  {
    id: "6803",
    id_polifenol: "4715",
    polifenol: "ampelopsin",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "24861637",
  },
  {
    id: "6804",
    id_polifenol: "7156",
    polifenol: "scutellarein",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "19666078",
  },
  {
    id: "6805",
    id_polifenol: "6800",
    polifenol: "3,6-dimethoxy-6'',6''-dimethylchromeno(2'',3''-7,8)flavone",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "17900592",
  },
  {
    id: "6806",
    id_polifenol: "885",
    polifenol: "oleocanthal",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "27258622",
  },
  {
    id: "6807",
    id_polifenol: "6129",
    polifenol: "wogonoside",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "28774312",
  },
  {
    id: "6808",
    id_polifenol: "2283",
    polifenol: "depsidone",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "28959637",
  },
  {
    id: "6809",
    id_polifenol: "2697",
    polifenol: "4-trifluoromethylsalicylic acid",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "26537079",
  },
  {
    id: "6810",
    id_polifenol: "12",
    polifenol: "Guaiacol",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "2",
    pmids: "24121236,8375015",
  },
  {
    id: "6811",
    id_polifenol: "2790",
    polifenol: "ginkgolic acid",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "22380770",
  },
  {
    id: "6812",
    id_polifenol: "84",
    polifenol: "Halogenated Diphenyl Ethers",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "27589474",
  },
  {
    id: "6813",
    id_polifenol: "4052",
    polifenol: "bis-(3-(3',5'-di-tert-butyl-4'-hydroxyphenyl)propyl)sulfide",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "25276196",
  },
  {
    id: "6814",
    id_polifenol: "6100",
    polifenol: "pinostrobin",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "2",
    pmids: "27603115,20064598",
  },
  {
    id: "6815",
    id_polifenol: "1918",
    polifenol: "2,6-di-tert-butyl-4-(aminomethyl)phenol hydrochloride",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "23845444",
  },
  {
    id: "6816",
    id_polifenol: "11",
    polifenol: "Hydroxyestrones",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "2",
    pmids: "12094629,16213115",
  },
  {
    id: "6817",
    id_polifenol: "4981",
    polifenol: "jaceosidin",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "27262066",
  },
  {
    id: "6818",
    id_polifenol: "1678",
    polifenol: "2-methoxyestrone",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "11034086",
  },
  {
    id: "6819",
    id_polifenol: "2573",
    polifenol: "butylparaben",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "22744862",
  },
  {
    id: "6820",
    id_polifenol: "3258",
    polifenol: "tesmilifene",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "2",
    pmids: "19118039,22390767",
  },
  {
    id: "6821",
    id_polifenol: "4782",
    polifenol: "kurarinone",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "21831037",
  },
  {
    id: "6822",
    id_polifenol: "7895",
    polifenol: "flavokawain A",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "28335434",
  },
  {
    id: "6823",
    id_polifenol: "6549",
    polifenol: "7-hydroxy-2',3',4',5',8-pentamethoxyisoflavan",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "2",
    pmids: "20626003,11059763",
  },
  {
    id: "6824",
    id_polifenol: "6076",
    polifenol: "vexibinol",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "21831037",
  },
  {
    id: "6825",
    id_polifenol: "792",
    polifenol: "octylphenol",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "24684733",
  },
  {
    id: "6826",
    id_polifenol: "4607",
    polifenol: "orientin",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "27630565",
  },
  {
    id: "6827",
    id_polifenol: "2807",
    polifenol: "thiosalicylic acid",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "27422196",
  },
  {
    id: "6828",
    id_polifenol: "6093",
    polifenol: "pinobanksin",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "25192075",
  },
  {
    id: "6829",
    id_polifenol: "5542",
    polifenol: "delphinidin 3-O-glucopyranoside",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "27388461",
  },
  {
    id: "6830",
    id_polifenol: "2571",
    polifenol: "methylparaben",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "22744862",
  },
  {
    id: "6831",
    id_polifenol: "7437",
    polifenol: "kaempferol-3-O-rutinoside",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "27013795",
  },
  {
    id: "6832",
    id_polifenol: "1675",
    polifenol: "catechol estrogen 3,4-quinone",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "28154783",
  },
  {
    id: "6833",
    id_polifenol: "4703",
    polifenol: "eupatorin",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "19601638",
  },
  {
    id: "6834",
    id_polifenol: "4312",
    polifenol: "zearalenol",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "2",
    pmids: "27311894,11205083",
  },
  {
    id: "6835",
    id_polifenol: "7590",
    polifenol: "quercetin-3-O-rutinoside",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "28178217",
  },
  {
    id: "6836",
    id_polifenol: "6459",
    polifenol: "genkwanin",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "19666078",
  },
  {
    id: "6837",
    id_polifenol: "58",
    polifenol: "Nitrophenols",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "18439640",
  },
  {
    id: "6838",
    id_polifenol: "3386",
    polifenol: "2,2',4,4'-tetrabromodiphenyl ether",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "27589474",
  },
  {
    id: "6839",
    id_polifenol: "529",
    polifenol: "4-octylphenol",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "9831541",
  },
  {
    id: "6840",
    id_polifenol: "2565",
    polifenol: "propylparaben",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "22744862",
  },
  {
    id: "6841",
    id_polifenol: "6548",
    polifenol: "artocarpin flavonoid",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "15165133",
  },
  {
    id: "6842",
    id_polifenol: "4608",
    polifenol: "artonin E",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "15165133",
  },
  {
    id: "6843",
    id_polifenol: "5303",
    polifenol: "3,6-dihydroxyflavone",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "2",
    pmids: "22616882,28870206",
  },
  {
    id: "6844",
    id_polifenol: "52",
    polifenol: "Diflunisal",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "15115406",
  },
  {
    id: "6845",
    id_polifenol: "630",
    polifenol: "4-tert-octylphenol",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "23219593",
  },
  {
    id: "6846",
    id_polifenol: "1688",
    polifenol: "4-hydroxyestrone",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "12094629",
  },
  {
    id: "6847",
    id_polifenol: "2868",
    polifenol: "3-hydroxy-4-prenyl-5-methoxystilbene-2-carboxylic acid",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "2",
    pmids: "26365581,27603115",
  },
  {
    id: "6848",
    id_polifenol: "6492",
    polifenol: "3(2H)-isoflavene",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "26432036",
  },
  {
    id: "6849",
    id_polifenol: "4574",
    polifenol: "sinensetin",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "19666078",
  },
  {
    id: "6850",
    id_polifenol: "7197",
    polifenol: "6-hydroxyluteolin",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "19666078",
  },
  {
    id: "6851",
    id_polifenol: "3665",
    polifenol: "3,5-di-tert-butyl-4-hydroxyanisole",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "22289578",
  },
  {
    id: "6852",
    id_polifenol: "5669",
    polifenol: "pro-F-EGCG2",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "17483343",
  },
  {
    id: "6853",
    id_polifenol: "418",
    polifenol: "thiophenol",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "29550886",
  },
  {
    id: "6854",
    id_polifenol: "5963",
    polifenol: "3,5,2',4'-tetrahydroxychalcone",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "2",
    pmids: "20699088,21170936",
  },
  {
    id: "6855",
    id_polifenol: "996",
    polifenol: "2,3-difluoro phenol",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "15115406",
  },
  {
    id: "6856",
    id_polifenol: "6291",
    polifenol: "alpinumisoflavone",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "2",
    pmids: "27288921,19091749",
  },
  {
    id: "6857",
    id_polifenol: "2290",
    polifenol: "lobaric acid",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "22628260",
  },
  {
    id: "6858",
    id_polifenol: "2768",
    polifenol: "salophen",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "28858483",
  },
  {
    id: "6859",
    id_polifenol: "5854",
    polifenol: "2'-hydroxy-3,4,3',4',6'-pentamethoxychalcone",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "23438826",
  },
  {
    id: "6860",
    id_polifenol: "7560",
    polifenol: "quercetin-3-O-neohesperidose",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "7923555",
  },
  {
    id: "6861",
    id_polifenol: "4820",
    polifenol: "3,7-dihydroxyflavone",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "29734739",
  },
  {
    id: "6862",
    id_polifenol: "7249",
    polifenol: "rhamnazin",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "10739098",
  },
  {
    id: "6863",
    id_polifenol: "1932",
    polifenol: "3,5-di-tert-butyl-4-hydroxytoluene",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "7887982",
  },
  {
    id: "6864",
    id_polifenol: "184",
    polifenol: "trilobatin",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "25229655",
  },
  {
    id: "6865",
    id_polifenol: "4689",
    polifenol: "5,3'-dihydroxy-3,6,7,8,4'-pentamethoxyflavone",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "20944143",
  },
  {
    id: "6866",
    id_polifenol: "6464",
    polifenol: "cirsiliol",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "19601638",
  },
  {
    id: "6867",
    id_polifenol: "4224",
    polifenol: "orsellinic acid",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "19795841",
  },
  {
    id: "6868",
    id_polifenol: "5284",
    polifenol: "didymin",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "26893687",
  },
  {
    id: "6869",
    id_polifenol: "7355",
    polifenol: "broussoflavonol B",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "25203051",
  },
  {
    id: "6870",
    id_polifenol: "6704",
    polifenol: "4-hydroxylonchocarpin",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "29656660",
  },
  {
    id: "6871",
    id_polifenol: "6537",
    polifenol: "daidzein-4'-O-sulfate",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "9168894",
  },
  {
    id: "6872",
    id_polifenol: "2794",
    polifenol: "salazinic acid",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "19199230",
  },
  {
    id: "6873",
    id_polifenol: "376",
    polifenol: "4-vinylphenol",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "26053458",
  },
  {
    id: "6874",
    id_polifenol: "5178",
    polifenol: "Flavin7",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "25930965",
  },
  {
    id: "6875",
    id_polifenol: "90",
    polifenol: "Mexiletine",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "25011475",
  },
  {
    id: "6876",
    id_polifenol: "4584",
    polifenol: "baohuosu",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "15729618",
  },
  {
    id: "6877",
    id_polifenol: "1781",
    polifenol: "CA 432",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "23232969",
  },
  {
    id: "6878",
    id_polifenol: "4649",
    polifenol: "centaureidin",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "19639540",
  },
  {
    id: "6879",
    id_polifenol: "2307",
    polifenol: "vicanicin",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "22628260",
  },
  {
    id: "6880",
    id_polifenol: "2213",
    polifenol: "diffractaic acid",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "22628260",
  },
  {
    id: "6881",
    id_polifenol: "2311",
    polifenol: "aspergillusidone A",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "28959637",
  },
  {
    id: "6882",
    id_polifenol: "4498",
    polifenol: "tanacin",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "19639540",
  },
  {
    id: "6883",
    id_polifenol: "13",
    polifenol: "Guaifenesin",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "21184665",
  },
  {
    id: "6884",
    id_polifenol: "1669",
    polifenol:
      "5-hydroxy-1-(4-hydroxy-3-methoxyphenyl)-7-(5-methylfuran-2-yl)hepta-1,4,6-trien-3-one",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "27293144",
  },
  {
    id: "6885",
    id_polifenol: "586",
    polifenol: "1-(4-hydroxyphenyl)-1,2-diphenyl-1-butene",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "11485868",
  },
  {
    id: "6886",
    id_polifenol: "665",
    polifenol: "2,6-difluorophenol",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "15115406",
  },
  {
    id: "6887",
    id_polifenol: "2192",
    polifenol: "evernic acid",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "19199230",
  },
  {
    id: "6888",
    id_polifenol: "2038",
    polifenol: "2,5-diaziridinylhydroquinone",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "8375015",
  },
  {
    id: "6889",
    id_polifenol: "1502",
    polifenol: "artochamin H",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "15165133",
  },
  {
    id: "6890",
    id_polifenol: "4034",
    polifenol: "moronone",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "23245650",
  },
  {
    id: "6891",
    id_polifenol: "6319",
    polifenol: "5,6-dihydroxy-7-prenyloxyflavone",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "24398107",
  },
  {
    id: "6892",
    id_polifenol: "6320",
    polifenol: "3-hydroxy-7-geranyloxyflavone",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "24398107",
  },
  {
    id: "6893",
    id_polifenol: "5881",
    polifenol: "2',3,4,4'-tetrahydroxy-5-prenylchalcone",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "10418944",
  },
  {
    id: "6894",
    id_polifenol: "4746",
    polifenol: "sophoflavescenol",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "22210035",
  },
  {
    id: "6895",
    id_polifenol: "6699",
    polifenol: "4'-O-methylalpinumisoflavone",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "19091749",
  },
  {
    id: "6896",
    id_polifenol: "4310",
    polifenol: "desmethyl-lasiodiplodin",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "23764760",
  },
  {
    id: "6897",
    id_polifenol: "5020",
    polifenol: "griffonianone D",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "21284537",
  },
  {
    id: "6898",
    id_polifenol: "5450",
    polifenol: "linderone A",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "23173924",
  },
  {
    id: "6899",
    id_polifenol: "1856",
    polifenol: "4-nitro-3-cresol",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "18439640",
  },
  {
    id: "6900",
    id_polifenol: "849",
    polifenol: "4-nitro-3-phenylphenol",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "18439640",
  },
  {
    id: "6901",
    id_polifenol: "5227",
    polifenol: "breviflavone A",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "15729618",
  },
  {
    id: "6902",
    id_polifenol: "6471",
    polifenol: "dichotomitin",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "29656660",
  },
  {
    id: "6903",
    id_polifenol: "6474",
    polifenol: "irisone B",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "29656660",
  },
  {
    id: "6904",
    id_polifenol: "694",
    polifenol: "4,4'-bis(2,6-di-tert-butylphenol)",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "23052471",
  },
  {
    id: "6905",
    id_polifenol: "1140",
    polifenol: "4-(((2-(benzyloxy)phenyl)methyl)amino)phenol",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "1995907",
  },
  {
    id: "6906",
    id_polifenol: "6536",
    polifenol: "daidzein-7,4'-di-O-sulfate",
    id_cancer: "486",
    cancer: "Hereditary Breast and Ovarian Cancer Syndrome",
    quant: "1",
    pmids: "9168894",
  },
  {
    id: "6907",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "53",
    pmids:
      "25450235,23881456,25256786,29861773,17345086,15194215,23969487,29312520,18362328,17637178,29433670,17936716,16303243,25522537,23888052,16158945,16573383,16044407,17436582,16108826,23110223,15905203,14649542,10953322,25263279,16469309,22204275,23497967,24456004,10769666,29212198,10928101,9642119,11205247,22047698,29023018,11131648,26712788,11396188,19639540,27815461,27266882,11573952,9111212,29145848,12584164,16833018,20463691,10823708,25869317,12112286,15586237,22484495",
  },
  {
    id: "6908",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "57",
    pmids:
      "21887696,27566085,25400722,12483537,24503718,21427908,15161016,17637178,25044209,11396189,29751146,29456509,28791378,25229239,27765374,17341208,22554995,19212627,12151348,14666669,26036622,10928101,15883009,20160040,26273408,23874481,12572355,28782139,24628271,29651934,9525275,29605808,25450696,21294671,15692547,25628937,22562377,23107022,26735343,21086748,18234541,26862088,20387230,22624612,23247073,21317920,21215629,28618017,25573684,22393291,28607603,19058955,21493306,23116961,23316365,23386626,23541947",
  },
  {
    id: "6909",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "55",
    pmids:
      "29681859,17258915,19784583,25109417,17984116,29039600,10775421,29381815,10223207,18848748,10964666,23707351,25100434,17637178,25522537,17530359,16573383,9328839,10509743,11237170,28167973,15905203,27200496,10953322,25263279,18248951,25329972,22923287,20160040,18665171,28983752,27177287,16158935,11131648,22827697,23174518,16140980,12529996,27815461,10211549,25104086,9414176,29160133,18336807,21317920,15537824,15517917,23210792,24278338,11138532,10823708,20020873,10594754,22590920,22084729",
  },
  {
    id: "6910",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "35",
    pmids:
      "17251686,22627996,22863969,12700650,22086183,27693704,16761963,15643499,15879678,16407847,22799384,14675139,16044407,14696113,9845123,28356980,12014647,10645003,15880954,17306610,29137391,12372346,15806152,9652746,27032574,11606383,11895866,18234541,24464917,28849149,12477973,20103886,22359227,10424744,17011457",
  },
  {
    id: "6911",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "15",
    pmids:
      "10198224,15274313,15194215,10639578,29433670,10362102,24456004,10928101,18955325,10453436,19959278,17311236,10397456,17193282,12708500",
  },
  {
    id: "6912",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "20",
    pmids:
      "23618529,17637178,25522537,16158945,16573383,15611226,11759294,22289578,14649542,23497967,10928101,29142391,26712788,23152886,10211549,21480807,29145848,23210792,10697569,26622865",
  },
  {
    id: "6913",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "45",
    pmids:
      "16309196,19784583,14676829,10775421,29381815,10223207,10964666,23707351,21391127,11396189,25721086,18546267,10782489,9328839,10509743,15161008,11759294,25759589,27200496,25329972,22923287,21388137,23950896,14666669,24456004,18665171,11205247,14981928,23874481,27177287,21209038,11131648,22827697,9525275,16140980,11396188,16390465,9414176,15537824,12205293,15517917,12375264,26933999,23541947,25405445",
  },
  {
    id: "6914",
    id_polifenol: "2167",
    polifenol: "phenolic acid",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "10",
    pmids:
      "29845251,29374707,15890233,10928101,19481070,26712788,24711053,29145848,28679629,10697569",
  },
  {
    id: "6915",
    id_polifenol: "49",
    polifenol: "Aspirin",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "12",
    pmids:
      "19633925,14696113,20116423,29349624,10678579,16336399,7653891,18058818,19999807,9823297,26189229,15821352",
  },
  {
    id: "6916",
    id_polifenol: "109",
    polifenol: "Catechin",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "11",
    pmids:
      "17045795,19233505,18848748,25329972,21480506,15145696,29142391,21209038,22827697,25310126,24604315",
  },
  {
    id: "6917",
    id_polifenol: "125",
    polifenol: "Isoflavones",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "7",
    pmids: "15274313,15990314,10639578,23587260,10953322,28962471,18955325",
  },
  {
    id: "6918",
    id_polifenol: "110",
    polifenol: "Chalcones",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "10",
    pmids:
      "21543203,28928824,28314269,10953322,29212198,22047698,29158524,16833018,12112286,17627575",
  },
  {
    id: "6919",
    id_polifenol: "3089",
    polifenol: "1,1-diphenyl-2-picrylhydrazyl",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "4",
    pmids: "22289578,23174518,16177974,29145848",
  },
  {
    id: "6920",
    id_polifenol: "114",
    polifenol: "Apigenin",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "6",
    pmids: "23969487,16044407,28547940,15132542,11573952,28526810",
  },
  {
    id: "6921",
    id_polifenol: "113",
    polifenol: "Flavones",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "11",
    pmids:
      "17345086,12457721,15990314,17637178,17936716,23160683,28962471,10769666,9829756,15165133,12112286",
  },
  {
    id: "6922",
    id_polifenol: "38",
    polifenol: "Gallic Acid",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "16",
    pmids:
      "21081858,10587295,11396189,10782489,21164042,9891488,24859325,28962387,15161008,22289578,14666669,11205247,14981928,22827697,11396188,21480807",
  },
  {
    id: "6923",
    id_polifenol: "117",
    polifenol: "Luteolin",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "5",
    pmids: "18362328,23110223,16469309,27266882,20463691",
  },
  {
    id: "6924",
    id_polifenol: "1",
    polifenol: "Phenols",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "5",
    pmids: "25522537,26850788,11724365,11319278,11520941",
  },
  {
    id: "6925",
    id_polifenol: "7235",
    polifenol: "silybin",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "7",
    pmids: "18998509,11759294,22861160,16498067,11895866,29472856,27414401",
  },
  {
    id: "6926",
    id_polifenol: "129",
    polifenol: "Rotenone",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "24456004",
  },
  {
    id: "6927",
    id_polifenol: "121",
    polifenol: "Kaempferols",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "6",
    pmids: "26831667,24994661,23936765,26712788,24711053,24278338",
  },
  {
    id: "6928",
    id_polifenol: "871",
    polifenol: "ABT-737",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "2",
    pmids: "26009874,23274910",
  },
  {
    id: "6929",
    id_polifenol: "6451",
    polifenol: "daidzein",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "2",
    pmids: "10639578,18955325",
  },
  {
    id: "6930",
    id_polifenol: "6065",
    polifenol: "baicalein",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "4",
    pmids: "19558494,15194215,22204275,16417464",
  },
  {
    id: "6931",
    id_polifenol: "7",
    polifenol: "Capsaicin",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "6",
    pmids: "22665354,24434067,25522537,16043290,24524628,16942952",
  },
  {
    id: "6932",
    id_polifenol: "4634",
    polifenol: "alvocidib",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "4",
    pmids: "12457721,16108826,9829756,27324070",
  },
  {
    id: "6933",
    id_polifenol: "120",
    polifenol: "Flavonols",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "4",
    pmids: "29029040,24994661,10769666,12584164",
  },
  {
    id: "6934",
    id_polifenol: "4522",
    polifenol: "chrysin",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "2",
    pmids: "29681859,23888052",
  },
  {
    id: "6935",
    id_polifenol: "123",
    polifenol: "Rutin",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "4",
    pmids: "29142391,20578533,24711053,23210792",
  },
  {
    id: "6936",
    id_polifenol: "6062",
    polifenol: "naringenin",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "4",
    pmids: "25256786,17936716,15043407,10823708",
  },
  {
    id: "6937",
    id_polifenol: "285",
    polifenol: "bisphenol A",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "28466560",
  },
  {
    id: "6938",
    id_polifenol: "39",
    polifenol: "Hydrolyzable Tannins",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "9",
    pmids:
      "11396189,10782489,17436582,11237170,25263279,10769666,11205247,11396188,1431932",
  },
  {
    id: "6939",
    id_polifenol: "130",
    polifenol: "Proanthocyanidins",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "8",
    pmids:
      "17981597,28781636,23050025,22749965,29039443,18955355,22435612,10823708",
  },
  {
    id: "6940",
    id_polifenol: "35",
    polifenol: "Hydroquinones",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "3",
    pmids: "23239856,24778711,22984577",
  },
  {
    id: "6941",
    id_polifenol: "111",
    polifenol: "Flavanones",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "2",
    pmids: "10953322,12112286",
  },
  {
    id: "6942",
    id_polifenol: "4502",
    polifenol: "fisetin",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "29312520",
  },
  {
    id: "6943",
    id_polifenol: "6",
    polifenol: "Catechols",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "4",
    pmids: "26408695,6771000,25202069,26147830",
  },
  {
    id: "6944",
    id_polifenol: "25",
    polifenol: "Butylated Hydroxytoluene",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "12839980",
  },
  {
    id: "6945",
    id_polifenol: "75",
    polifenol: "Butylated Hydroxyanisole",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "4",
    pmids: "16407847,11319278,1703036,3136944",
  },
  {
    id: "6946",
    id_polifenol: "15",
    polifenol: "Masoprocol",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "2",
    pmids: "20668019,2105358",
  },
  {
    id: "6947",
    id_polifenol: "4519",
    polifenol: "myricetin",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "25256786",
  },
  {
    id: "6948",
    id_polifenol: "4500",
    polifenol: "procyanidin",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "3",
    pmids: "28781636,22103929,10823708",
  },
  {
    id: "6949",
    id_polifenol: "5608",
    polifenol: "epicatechin gallate",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "6",
    pmids: "17045795,21480506,11131648,22827697,9414176,1431932",
  },
  {
    id: "6950",
    id_polifenol: "1356",
    polifenol: "gingerol",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "19481070",
  },
  {
    id: "6951",
    id_polifenol: "98",
    polifenol: "Propofol",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "23155237",
  },
  {
    id: "6952",
    id_polifenol: "5607",
    polifenol: "gallocatechol",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "3",
    pmids: "11131648,22827697,9414176",
  },
  {
    id: "6953",
    id_polifenol: "4559",
    polifenol: "theaflavin",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "3",
    pmids: "17984116,10223207,11138532",
  },
  {
    id: "6954",
    id_polifenol: "5808",
    polifenol: "isoliquiritigenin",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "4",
    pmids: "16158945,25580586,29212198,28203317",
  },
  {
    id: "6955",
    id_polifenol: "2344",
    polifenol: "methyl gallate",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "28962387",
  },
  {
    id: "6956",
    id_polifenol: "2284",
    polifenol: "rosmarinic acid",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "2",
    pmids: "22439433,22126613",
  },
  {
    id: "6957",
    id_polifenol: "112",
    polifenol: "Hesperidin",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "9111212",
  },
  {
    id: "6958",
    id_polifenol: "10",
    polifenol: "Estrogens, Catechol",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "28018158",
  },
  {
    id: "6959",
    id_polifenol: "4513",
    polifenol: "galangin",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "3",
    pmids: "25450235,28677816,23160683",
  },
  {
    id: "6960",
    id_polifenol: "1380",
    polifenol: "shogaol",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "2",
    pmids: "29287195,26840796",
  },
  {
    id: "6961",
    id_polifenol: "2158",
    polifenol: "protocatechuic acid",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "14728590",
  },
  {
    id: "6962",
    id_polifenol: "1613",
    polifenol: "demethoxycurcumin",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "28586041",
  },
  {
    id: "6963",
    id_polifenol: "93",
    polifenol: "Phloroglucinol",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "15844953",
  },
  {
    id: "6964",
    id_polifenol: "6454",
    polifenol: "formononetin",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "24604315",
  },
  {
    id: "6965",
    id_polifenol: "81",
    polifenol: "Fenofibrate",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "2",
    pmids: "25545733,21081159",
  },
  {
    id: "6966",
    id_polifenol: "6461",
    polifenol: "acacetin",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "2",
    pmids: "26099663,17345086",
  },
  {
    id: "6967",
    id_polifenol: "4253",
    polifenol:
      "5-(2,4-dihydroxy-5-isopropylphenyl)-4-(4-morpholin-4-ylmethylphenyl)isoxazole-3-carboxylic acid ethylamide",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "2",
    pmids: "21508365,23016912",
  },
  {
    id: "6968",
    id_polifenol: "107",
    polifenol: "beta-Naphthoflavone",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "25218365",
  },
  {
    id: "6969",
    id_polifenol: "119",
    polifenol: "Silymarin",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "10491326",
  },
  {
    id: "6970",
    id_polifenol: "1558",
    polifenol: "capsazepine",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "3",
    pmids: "24434067,16043290,18455478",
  },
  {
    id: "6971",
    id_polifenol: "969",
    polifenol: "3,4-dihydroxyphenacyl caffeate phenylpropanoid ester",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "21480807",
  },
  {
    id: "6972",
    id_polifenol: "5819",
    polifenol: "licochalcone A",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "24691971",
  },
  {
    id: "6973",
    id_polifenol: "4560",
    polifenol: "icariin",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "23807305",
  },
  {
    id: "6974",
    id_polifenol: "4640",
    polifenol: "5,7-dihydroxy-6-methoxy-2-phenylchromen-4-one",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "10953322",
  },
  {
    id: "6975",
    id_polifenol: "2773",
    polifenol: "farnesylthiosalicylic acid",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "19372139",
  },
  {
    id: "6976",
    id_polifenol: "99",
    polifenol: "Pyrogallol",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "19233505",
  },
  {
    id: "6977",
    id_polifenol: "452",
    polifenol: "acteoside",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "4",
    pmids: "29536537,22289578,21480807,23210792",
  },
  {
    id: "6978",
    id_polifenol: "1866",
    polifenol: "4,6-dinitro-o-cresol",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "29088714",
  },
  {
    id: "6979",
    id_polifenol: "118",
    polifenol: "Flavonolignans",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "27414401",
  },
  {
    id: "6980",
    id_polifenol: "6068",
    polifenol: "pinocembrin",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "28547940",
  },
  {
    id: "6981",
    id_polifenol: "5071",
    polifenol: "icaritin",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "27889233",
  },
  {
    id: "6982",
    id_polifenol: "6576",
    polifenol: "5,7,4'-trihydroxyflavone",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "23160683",
  },
  {
    id: "6983",
    id_polifenol: "4585",
    polifenol: "baohuoside I",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "23807305",
  },
  {
    id: "6984",
    id_polifenol: "102",
    polifenol: "Zearalenone",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "27311894",
  },
  {
    id: "6985",
    id_polifenol: "7161",
    polifenol: "scutellarin",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "3",
    pmids: "23546449,20878105,23536878",
  },
  {
    id: "6986",
    id_polifenol: "2328",
    polifenol: "syringic acid",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "28671029",
  },
  {
    id: "6987",
    id_polifenol: "40",
    polifenol: "Propyl Gallate",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "24604315",
  },
  {
    id: "6988",
    id_polifenol: "5455",
    polifenol: "theaflavin-3,3'-digallate",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "3",
    pmids: "10223207,18248951,22827697",
  },
  {
    id: "6989",
    id_polifenol: "5815",
    polifenol: "dibenzoylmethane",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "3",
    pmids: "15161016,10953322,12112286",
  },
  {
    id: "6990",
    id_polifenol: "7547",
    polifenol: "hyperoside",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "28789450",
  },
  {
    id: "6991",
    id_polifenol: "128",
    polifenol: "Pterocarpans",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "12112286",
  },
  {
    id: "6992",
    id_polifenol: "4883",
    polifenol: "flavokawain B",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "21543203",
  },
  {
    id: "6993",
    id_polifenol: "7853",
    polifenol: "Grape Seed Proanthocyanidins",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "28781636",
  },
  {
    id: "6994",
    id_polifenol: "6066",
    polifenol: "eriodictyol",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "23936765",
  },
  {
    id: "6995",
    id_polifenol: "6452",
    polifenol: "chrysoeriol",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "15132542",
  },
  {
    id: "6996",
    id_polifenol: "680",
    polifenol: "xanthorrhizol",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "22627996",
  },
  {
    id: "6997",
    id_polifenol: "4521",
    polifenol: "3-hydroxyflavone",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "2",
    pmids: "15990314,10769666",
  },
  {
    id: "6998",
    id_polifenol: "97",
    polifenol: "Probucol",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "10622533",
  },
  {
    id: "6999",
    id_polifenol: "115",
    polifenol: "Diosmin",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "9111212",
  },
  {
    id: "7000",
    id_polifenol: "87",
    polifenol: "Metoclopramide",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "7670144",
  },
  {
    id: "7001",
    id_polifenol: "2014",
    polifenol: "erbstatin",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "7585535",
  },
  {
    id: "7002",
    id_polifenol: "299",
    polifenol: "nitrophenylphosphate",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "6293548",
  },
  {
    id: "7003",
    id_polifenol: "885",
    polifenol: "oleocanthal",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "29959992",
  },
  {
    id: "7004",
    id_polifenol: "896",
    polifenol: "polyphenon B",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "3",
    pmids: "17258915,17530359,20020873",
  },
  {
    id: "7005",
    id_polifenol: "711",
    polifenol: "ascochlorin",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "22109717",
  },
  {
    id: "7006",
    id_polifenol: "6457",
    polifenol: "salvigenin",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "15043407",
  },
  {
    id: "7007",
    id_polifenol: "1747",
    polifenol: "6-paradol",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "2",
    pmids: "11809529,23803090",
  },
  {
    id: "7008",
    id_polifenol: "2343",
    polifenol: "ethyl gallate",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "2",
    pmids: "25104086,28679629",
  },
  {
    id: "7009",
    id_polifenol: "4479",
    polifenol: "morin",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "12584164",
  },
  {
    id: "7010",
    id_polifenol: "2364",
    polifenol: "theaflavine gallate",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "10223207",
  },
  {
    id: "7011",
    id_polifenol: "4578",
    polifenol: "5,7-dimethoxyflavone",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "2",
    pmids: "17637178,15905203",
  },
  {
    id: "7012",
    id_polifenol: "4981",
    polifenol: "jaceosidin",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "29861773",
  },
  {
    id: "7013",
    id_polifenol: "6497",
    polifenol: "isoflavanone",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "15274313",
  },
  {
    id: "7014",
    id_polifenol: "5615",
    polifenol: "gallocatechin gallate",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "16140980",
  },
  {
    id: "7015",
    id_polifenol: "6549",
    polifenol: "7-hydroxy-2',3',4',5',8-pentamethoxyisoflavan",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "10953322",
  },
  {
    id: "7016",
    id_polifenol: "5858",
    polifenol: "isobavachalcone",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "28928824",
  },
  {
    id: "7017",
    id_polifenol: "839",
    polifenol: "5-iodo-3-((3,5-dibromo-4-hydroxyphenyl)methylene)-2-indolinone",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "17251686",
  },
  {
    id: "7018",
    id_polifenol: "4544",
    polifenol: "tiliroside",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "16833018",
  },
  {
    id: "7019",
    id_polifenol: "416",
    polifenol: "phenoxy radical",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "11319278",
  },
  {
    id: "7020",
    id_polifenol: "7437",
    polifenol: "kaempferol-3-O-rutinoside",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "2",
    pmids: "24711053,16833018",
  },
  {
    id: "7021",
    id_polifenol: "1237",
    polifenol: "2,4-bis(p-hydroxyphenyl)-2-butenal",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "24423061",
  },
  {
    id: "7022",
    id_polifenol: "2471",
    polifenol: "oenothein B",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "10782489",
  },
  {
    id: "7023",
    id_polifenol: "2693",
    polifenol: "copper bis(3,5-diisopropylsalicylate)",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "8513442",
  },
  {
    id: "7024",
    id_polifenol: "4312",
    polifenol: "zearalenol",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "27311894",
  },
  {
    id: "7025",
    id_polifenol: "444",
    polifenol: "2,4-di-tert-butylphenol",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "19471192",
  },
  {
    id: "7026",
    id_polifenol: "1883",
    polifenol: "2-amino-5-methylphenol",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "3",
    pmids: "11335795,22841366,8862728",
  },
  {
    id: "7027",
    id_polifenol: "6548",
    polifenol: "artocarpin flavonoid",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "15165133",
  },
  {
    id: "7028",
    id_polifenol: "4608",
    polifenol: "artonin E",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "15165133",
  },
  {
    id: "7029",
    id_polifenol: "6711",
    polifenol: "3',4'-dimethoxyflavone",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "2",
    pmids: "17637178,15905203",
  },
  {
    id: "7030",
    id_polifenol: "1811",
    polifenol: "terameprocol",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "18311658",
  },
  {
    id: "7031",
    id_polifenol: "2169",
    polifenol: "ethyl protocatechuate",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "25232961",
  },
  {
    id: "7032",
    id_polifenol: "5909",
    polifenol: "licochalcone E",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "28521469",
  },
  {
    id: "7033",
    id_polifenol: "7149",
    polifenol: "5,7,4'-trimethylapigenin",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "17637178",
  },
  {
    id: "7034",
    id_polifenol: "3245",
    polifenol: "obovatol",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "29845251",
  },
  {
    id: "7035",
    id_polifenol: "1867",
    polifenol: "creosol",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "11319278",
  },
  {
    id: "7036",
    id_polifenol: "4505",
    polifenol: "pycnogenols",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "26798196",
  },
  {
    id: "7037",
    id_polifenol: "3665",
    polifenol: "3,5-di-tert-butyl-4-hydroxyanisole",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "2",
    pmids: "22289578,21480807",
  },
  {
    id: "7038",
    id_polifenol: "2474",
    polifenol: "vescalagin",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "1431932",
  },
  {
    id: "7039",
    id_polifenol: "101",
    polifenol: "Hexylresorcinol",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "3",
    pmids: "23427012,22664654,21424127",
  },
  {
    id: "7040",
    id_polifenol: "4524",
    polifenol: "5-hydroxy-3',4',6,7-tetramethoxyflavone",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "24148842",
  },
  {
    id: "7041",
    id_polifenol: "4244",
    polifenol: "malabaricone A",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "19471882",
  },
  {
    id: "7042",
    id_polifenol: "6642",
    polifenol: "6,7-dihydroxyflavone",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "25434704",
  },
  {
    id: "7043",
    id_polifenol: "4579",
    polifenol: "hinokiflavone",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "2",
    pmids: "17311236,17193282",
  },
  {
    id: "7044",
    id_polifenol: "3336",
    polifenol:
      "N-hydroxy-5-ethoxymethyloxy-2-methyl-4-(4-phenoxybenzoyl)aminopentanamide",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "12516105",
  },
  {
    id: "7045",
    id_polifenol: "5436",
    polifenol: "herbacetin",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "29029040",
  },
  {
    id: "7046",
    id_polifenol: "7659",
    polifenol: "quercetin 7-rhamnoside",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "24711053",
  },
  {
    id: "7047",
    id_polifenol: "4152",
    polifenol: "quracol B",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "17627575",
  },
  {
    id: "7048",
    id_polifenol: "5226",
    polifenol: "cudraflavone B",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "23881456",
  },
  {
    id: "7049",
    id_polifenol: "935",
    polifenol: "oligonol",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "18848748",
  },
  {
    id: "7050",
    id_polifenol: "82",
    polifenol: "Gemfibrozil",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "18092840",
  },
  {
    id: "7051",
    id_polifenol: "2531",
    polifenol: "sanguiin H-5",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "1431932",
  },
  {
    id: "7052",
    id_polifenol: "521",
    polifenol: "E 7010",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "9654112",
  },
  {
    id: "7053",
    id_polifenol: "2749",
    polifenol: "zinc 3,5-diisopropylsalicylate",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "3136944",
  },
  {
    id: "7054",
    id_polifenol: "6789",
    polifenol:
      "5,7-dihydroxy-3-(3-hydroxy-4-methoxybenzyl)-6-methoxychroman-4-one",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "23587260",
  },
  {
    id: "7055",
    id_polifenol: "4195",
    polifenol: "climacostol",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "18723007",
  },
  {
    id: "7056",
    id_polifenol: "4673",
    polifenol: "3,7-dimethoxyflavone",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "17637178",
  },
  {
    id: "7057",
    id_polifenol: "5933",
    polifenol: "licochalcone B",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "2",
    pmids: "29027311,26847145",
  },
  {
    id: "7058",
    id_polifenol: "1738",
    polifenol: "dehydroparadol",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "11809529",
  },
  {
    id: "7059",
    id_polifenol: "6071",
    polifenol: "7-hydroxyflavanone",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "17936716",
  },
  {
    id: "7060",
    id_polifenol: "7878",
    polifenol: "MDL 27048",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "28314269",
  },
  {
    id: "7061",
    id_polifenol: "4649",
    polifenol: "centaureidin",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "19639540",
  },
  {
    id: "7062",
    id_polifenol: "6785",
    polifenol: "3',4',7-trimethoxyflavone",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "17345086",
  },
  {
    id: "7063",
    id_polifenol: "4770",
    polifenol: "3-bromo-6-methyl-2'-hydroxy flavone",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "14696113",
  },
  {
    id: "7064",
    id_polifenol: "2464",
    polifenol: "camelliin B",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "11237170",
  },
  {
    id: "7065",
    id_polifenol: "4517",
    polifenol: "primetin",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "25434704",
  },
  {
    id: "7066",
    id_polifenol: "4498",
    polifenol: "tanacin",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "19639540",
  },
  {
    id: "7067",
    id_polifenol: "1494",
    polifenol: "cinchonain Ib",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "10823708",
  },
  {
    id: "7068",
    id_polifenol: "5523",
    polifenol: "cinnamtannin A2",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "1431932",
  },
  {
    id: "7069",
    id_polifenol: "1146",
    polifenol: "4-allyl-2-methoxy-6-(2-methylbut-3-en-2-yl)phenol",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "11319278",
  },
  {
    id: "7070",
    id_polifenol: "4848",
    polifenol: "4'-hydroxy-7-methoxyflavan",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "19471882",
  },
  {
    id: "7071",
    id_polifenol: "1502",
    polifenol: "artochamin H",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "15165133",
  },
  {
    id: "7072",
    id_polifenol: "1212",
    polifenol: "oleacein",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "29959992",
  },
  {
    id: "7073",
    id_polifenol: "1525",
    polifenol: "3-hydroxy-1-(4'-hydroxy-3'-methoxy-phenyl)-hexan-5-one",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "10953322",
  },
  {
    id: "7074",
    id_polifenol: "2734",
    polifenol: "Listerine",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "29777637",
  },
  {
    id: "7075",
    id_polifenol: "6689",
    polifenol: "scutellarin-7-O-glucuronide",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "23536878",
  },
  {
    id: "7076",
    id_polifenol: "5085",
    polifenol: "myristinin D",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "19471882",
  },
  {
    id: "7077",
    id_polifenol: "5075",
    polifenol: "myristinin A",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "19471882",
  },
  {
    id: "7078",
    id_polifenol: "5903",
    polifenol: "2',4'-dihydroxy-3'-(2-hydroxybenzyl)-6'-methoxychalcone",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "16833018",
  },
  {
    id: "7079",
    id_polifenol: "2496",
    polifenol: "sanguiin H 11",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "1431932",
  },
  {
    id: "7080",
    id_polifenol: "2351",
    polifenol: "1,3,4,5-tetra-O-galloylquinic acid",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "1431932",
  },
  {
    id: "7081",
    id_polifenol: "2481",
    polifenol: "furosin",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "1431932",
  },
  {
    id: "7082",
    id_polifenol: "7857",
    polifenol: "cinnamtannin B-1",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "1431932",
  },
  {
    id: "7083",
    id_polifenol: "2371",
    polifenol: "eugeniin",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "1431932",
  },
  {
    id: "7084",
    id_polifenol: "575",
    polifenol: "BE 23372M",
    id_cancer: "3240",
    cancer: "Squamous Cell Carcinoma",
    quant: "1",
    pmids: "8175480",
  },
  {
    id: "7085",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "65",
    pmids:
      "20971066,26557705,28393257,28950661,17876051,28528183,23229626,26345416,29215574,19001439,29662304,21501525,28560001,22394507,19263218,26547532,21867678,27673410,19894226,22949836,23677714,29886836,29734739,24370662,29730415,28286420,26245494,28927111,29770114,26042698,27125297,19398149,16914050,28293765,17176222,25481090,18948169,26471408,29774119,27468969,28665345,16619521,24970553,22471459,26454746,26474590,15332496,26573275,21969006,28860810,25136570,26075219,29747239,27262066,26512639,28930257,25409926,29656660,28602979,25239551,27171480,28287477,28122160,28029227,29181405",
  },
  {
    id: "7086",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "72",
    pmids:
      "23545262,21775121,20712901,20596601,23192708,25542408,18316600,20087857,22910273,26239619,16416600,25792385,16777101,27757851,23621850,27592626,26364505,20840775,24183537,25883212,17562168,21138870,28676971,17594054,29368356,25542083,17596214,20615395,28420097,29340361,24220325,21040711,28627598,27819521,22991922,28260885,24531649,27293144,29180881,28096969,21193839,22204522,26763536,25091588,24793792,26391485,27482284,27354801,28160777,25489242,22944718,21215629,29088758,29346317,24142484,22923060,28989041,25202424,22192169,28210221,27461692,25462134,29969678,25158647,29359011,27956075,27543754,27699139,23891772,26637846,28575990,29081729",
  },
  {
    id: "7087",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "26",
    pmids:
      "23545262,11853893,26345416,29215574,27064011,24338484,23955573,19131542,25173233,11305413,21810170,21138870,29522834,10198059,14647974,22426504,21503893,27649384,26498391,19190249,27354801,23407460,29346317,25239551,16458188,29359011",
  },
  {
    id: "7088",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "27",
    pmids:
      "26138072,28393231,12796404,23448150,23232806,29546069,19435873,19934343,17210246,16391870,22497886,25012123,11078722,18346464,19158403,12134900,26179613,26059188,21029458,17108064,10806212,15016831,15047712,22077956,23261760,18317690,16730650",
  },
  {
    id: "7089",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "15",
    pmids:
      "19894226,29685705,22736505,16598420,14647974,7538048,11523680,9572397,19356600,18847459,20177775,8652271,8971836,26260013,25382637",
  },
  {
    id: "7090",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "21",
    pmids:
      "28528183,24902789,22394507,21867678,29730415,27039073,28676971,28420097,25481090,27468969,16619521,26454746,15332496,29627902,17555822,28860810,26512639,29030990,28122160,27956075,12562100",
  },
  {
    id: "7091",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "19",
    pmids:
      "11853893,19894226,24338484,16412397,25173233,11305413,22429326,29407769,17942911,21479441,14647974,23807168,19190249,17070879,28112361,21257259,21903153,18267120,27956075",
  },
  {
    id: "7092",
    id_polifenol: "2167",
    polifenol: "phenolic acid",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "5",
    pmids: "27262066,28930257,21903153,28122160,28029227",
  },
  {
    id: "7093",
    id_polifenol: "49",
    polifenol: "Aspirin",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "6",
    pmids: "19595669,23230963,27098175,21956205,27602398,29885857",
  },
  {
    id: "7094",
    id_polifenol: "109",
    polifenol: "Catechin",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "10",
    pmids:
      "11853893,28004224,29407769,26284809,26467757,26512639,28930257,21903153,28122160,28029227",
  },
  {
    id: "7095",
    id_polifenol: "125",
    polifenol: "Isoflavones",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "6",
    pmids: "19429088,22736505,16598420,25501542,20177775,29656660",
  },
  {
    id: "7096",
    id_polifenol: "110",
    polifenol: "Chalcones",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "14",
    pmids:
      "20971066,26547532,28737782,28774575,24527179,27822587,26467757,24134853,29715541,22335538,29656660,17070879,21696954,27012433",
  },
  {
    id: "7097",
    id_polifenol: "3089",
    polifenol: "1,1-diphenyl-2-picrylhydrazyl",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "3",
    pmids: "29215574,28803257,28287477",
  },
  {
    id: "7098",
    id_polifenol: "114",
    polifenol: "Apigenin",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "8",
    pmids:
      "29215574,19894226,22318540,15336944,27468969,22614258,22923060,27956075",
  },
  {
    id: "7099",
    id_polifenol: "113",
    polifenol: "Flavones",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "8",
    pmids:
      "29215574,26547532,20698539,29734739,12589031,27400887,28665345,21556497",
  },
  {
    id: "7100",
    id_polifenol: "38",
    polifenol: "Gallic Acid",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "7",
    pmids: "20553913,25646699,26284809,28930257,21903153,28122160,28029227",
  },
  {
    id: "7101",
    id_polifenol: "117",
    polifenol: "Luteolin",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "9",
    pmids:
      "28393257,23677714,29730415,28927111,26471408,26573275,28977853,25409926,22923060",
  },
  {
    id: "7102",
    id_polifenol: "1",
    polifenol: "Phenols",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "2",
    pmids: "21779655,25239551",
  },
  {
    id: "7103",
    id_polifenol: "105",
    polifenol: "Anthocyanins",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "7",
    pmids: "26187071,29336479,28867321,29774119,27649384,16823770,28287477",
  },
  {
    id: "7104",
    id_polifenol: "7235",
    polifenol: "silybin",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "7",
    pmids: "29780826,21501525,19263218,26471408,26573275,21969006,25750273",
  },
  {
    id: "7105",
    id_polifenol: "129",
    polifenol: "Rotenone",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "8",
    pmids:
      "24252341,28644886,18032788,22120717,27325206,26297045,28816233,18847459",
  },
  {
    id: "7106",
    id_polifenol: "121",
    polifenol: "Kaempferols",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "3",
    pmids: "17876051,19001439,25239700",
  },
  {
    id: "7107",
    id_polifenol: "871",
    polifenol: "ABT-737",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "10",
    pmids:
      "27777286,23190604,22249262,18663354,25482928,27779684,25762636,23965755,25586056,27494880",
  },
  {
    id: "7108",
    id_polifenol: "6451",
    polifenol: "daidzein",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "19429088",
  },
  {
    id: "7109",
    id_polifenol: "6065",
    polifenol: "baicalein",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "29215574",
  },
  {
    id: "7110",
    id_polifenol: "7",
    polifenol: "Capsaicin",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "4",
    pmids: "18405923,27748914,26682421,26351174",
  },
  {
    id: "7111",
    id_polifenol: "4634",
    polifenol: "alvocidib",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "8",
    pmids:
      "22391209,16053697,12589031,12734434,8895733,24886624,27171480,21556497",
  },
  {
    id: "7112",
    id_polifenol: "120",
    polifenol: "Flavonols",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "2",
    pmids: "26467757,12562100",
  },
  {
    id: "7113",
    id_polifenol: "4522",
    polifenol: "chrysin",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "3",
    pmids: "29662304,23445763,22923060",
  },
  {
    id: "7114",
    id_polifenol: "123",
    polifenol: "Rutin",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "7",
    pmids: "27673410,28004224,28293765,25785932,28930257,28122160,28029227",
  },
  {
    id: "7115",
    id_polifenol: "6062",
    polifenol: "naringenin",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "3",
    pmids: "27468969,28665345,25239700",
  },
  {
    id: "7116",
    id_polifenol: "130",
    polifenol: "Proanthocyanidins",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "6",
    pmids: "27388765,17176222,26512639,28930257,28122160,28029227",
  },
  {
    id: "7117",
    id_polifenol: "111",
    polifenol: "Flavanones",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "2",
    pmids: "28286420,28665345",
  },
  {
    id: "7118",
    id_polifenol: "4502",
    polifenol: "fisetin",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "2",
    pmids: "27673410,27956075",
  },
  {
    id: "7119",
    id_polifenol: "6",
    polifenol: "Catechols",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "25964542",
  },
  {
    id: "7120",
    id_polifenol: "15",
    polifenol: "Masoprocol",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "4",
    pmids: "17377739,17415525,16516855,28504686",
  },
  {
    id: "7121",
    id_polifenol: "6087",
    polifenol: "wogonin",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "3",
    pmids: "22846543,22949836,23872260",
  },
  {
    id: "7122",
    id_polifenol: "4519",
    polifenol: "myricetin",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "3",
    pmids: "27673410,29886836,19398149",
  },
  {
    id: "7123",
    id_polifenol: "4500",
    polifenol: "procyanidin",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "2",
    pmids: "19167369,29156717",
  },
  {
    id: "7124",
    id_polifenol: "5608",
    polifenol: "epicatechin gallate",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "29346317",
  },
  {
    id: "7125",
    id_polifenol: "1356",
    polifenol: "gingerol",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "25034532",
  },
  {
    id: "7126",
    id_polifenol: "98",
    polifenol: "Propofol",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "23155237",
  },
  {
    id: "7127",
    id_polifenol: "5607",
    polifenol: "gallocatechol",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "19894226",
  },
  {
    id: "7128",
    id_polifenol: "5808",
    polifenol: "isoliquiritigenin",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "3",
    pmids: "23229626,26722447,21696954",
  },
  {
    id: "7129",
    id_polifenol: "2344",
    polifenol: "methyl gallate",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "4",
    pmids: "28004224,18948169,10198059,21903153",
  },
  {
    id: "7130",
    id_polifenol: "4708",
    polifenol: "xanthohumol",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "5",
    pmids: "27487563,22407755,28665345,23407460,29747239",
  },
  {
    id: "7131",
    id_polifenol: "2284",
    polifenol: "rosmarinic acid",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "2",
    pmids: "29627902,25239551",
  },
  {
    id: "7132",
    id_polifenol: "6455",
    polifenol: "nobiletin",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "2",
    pmids: "26560814,28339056",
  },
  {
    id: "7133",
    id_polifenol: "4513",
    polifenol: "galangin",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "27956075",
  },
  {
    id: "7134",
    id_polifenol: "6063",
    polifenol: "naringin",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "2",
    pmids: "27125297,26474590",
  },
  {
    id: "7135",
    id_polifenol: "2158",
    polifenol: "protocatechuic acid",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "28122160",
  },
  {
    id: "7136",
    id_polifenol: "5489",
    polifenol: "delphinidin",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "3",
    pmids: "26187071,27649384,16823770",
  },
  {
    id: "7137",
    id_polifenol: "1613",
    polifenol: "demethoxycurcumin",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "5",
    pmids: "27757851,29368356,25877753,22204522,29575236",
  },
  {
    id: "7138",
    id_polifenol: "93",
    polifenol: "Phloroglucinol",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "2",
    pmids: "22819448,12061257",
  },
  {
    id: "7139",
    id_polifenol: "81",
    polifenol: "Fenofibrate",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "7",
    pmids: "25566967,22732497,25332241,20569465,26869992,25645911,26172294",
  },
  {
    id: "7140",
    id_polifenol: "7550",
    polifenol: "3-methylquercetin",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "29730415",
  },
  {
    id: "7141",
    id_polifenol: "4253",
    polifenol:
      "5-(2,4-dihydroxy-5-isopropylphenyl)-4-(4-morpholin-4-ylmethylphenyl)isoxazole-3-carboxylic acid ethylamide",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "6",
    pmids: "27224913,20457619,18413753,28424411,19324279,22286776",
  },
  {
    id: "7142",
    id_polifenol: "1611",
    polifenol: "bis(4-hydroxycinnamoyl)methane",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "29368356",
  },
  {
    id: "7143",
    id_polifenol: "69",
    polifenol: "Phenolsulfonphthalein",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "16438662",
  },
  {
    id: "7144",
    id_polifenol: "5806",
    polifenol: "butein",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "26150336",
  },
  {
    id: "7145",
    id_polifenol: "108",
    polifenol: "Biflavonoids",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "22271084",
  },
  {
    id: "7146",
    id_polifenol: "5509",
    polifenol: "cyanidin 3-O-glucoside",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "28867321",
  },
  {
    id: "7147",
    id_polifenol: "969",
    polifenol: "3,4-dihydroxyphenacyl caffeate phenylpropanoid ester",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "21696954",
  },
  {
    id: "7148",
    id_polifenol: "5844",
    polifenol: "4-dimethylamino-3',4'-dimethoxychalcone",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "17699104",
  },
  {
    id: "7149",
    id_polifenol: "5819",
    polifenol: "licochalcone A",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "28593138",
  },
  {
    id: "7150",
    id_polifenol: "4560",
    polifenol: "icariin",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "3",
    pmids: "26356761,25577511,25384619",
  },
  {
    id: "7151",
    id_polifenol: "5488",
    polifenol: "cyanidin",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "2",
    pmids: "27649384,16823770",
  },
  {
    id: "7152",
    id_polifenol: "2773",
    polifenol: "farnesylthiosalicylic acid",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "19072665",
  },
  {
    id: "7153",
    id_polifenol: "80",
    polifenol: "Clofibrate",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "8759039",
  },
  {
    id: "7154",
    id_polifenol: "452",
    polifenol: "acteoside",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "2",
    pmids: "29961065,26743778",
  },
  {
    id: "7155",
    id_polifenol: "1644",
    polifenol: "Cur1 compound",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "25158647",
  },
  {
    id: "7156",
    id_polifenol: "5614",
    polifenol: "catechin gallate",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "3",
    pmids: "24508804,29407769,21903153",
  },
  {
    id: "7157",
    id_polifenol: "1866",
    polifenol: "4,6-dinitro-o-cresol",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "25521208",
  },
  {
    id: "7158",
    id_polifenol: "5850",
    polifenol: "cardamonin",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "2",
    pmids: "26150336,27956075",
  },
  {
    id: "7159",
    id_polifenol: "118",
    polifenol: "Flavonolignans",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "29780826",
  },
  {
    id: "7160",
    id_polifenol: "7544",
    polifenol: "quercitrin",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "12562100",
  },
  {
    id: "7161",
    id_polifenol: "60",
    polifenol: "2,4-Dinitrophenol",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "25521208",
  },
  {
    id: "7162",
    id_polifenol: "7912",
    polifenol: "7,9,2',4'-tetrahydroxy-8-isopentenyl-5-methoxychalcone",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "27487563",
  },
  {
    id: "7163",
    id_polifenol: "4767",
    polifenol: "flavan-3-ol",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "26284809",
  },
  {
    id: "7164",
    id_polifenol: "2475",
    polifenol: "6-O-galloylglucose",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "29407769",
  },
  {
    id: "7165",
    id_polifenol: "6097",
    polifenol: "8-prenylnaringenin",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "28665345",
  },
  {
    id: "7166",
    id_polifenol: "2447",
    polifenol: "beta-penta-O-galloyl-glucose",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "24508804",
  },
  {
    id: "7167",
    id_polifenol: "1996",
    polifenol: "2,5-di-tert-butylhydroquinone",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "25106108",
  },
  {
    id: "7168",
    id_polifenol: "5071",
    polifenol: "icaritin",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "3",
    pmids: "27904667,26356761,25577511",
  },
  {
    id: "7169",
    id_polifenol: "4585",
    polifenol: "baohuoside I",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "28560001",
  },
  {
    id: "7170",
    id_polifenol: "6625",
    polifenol: "phenoxodiol",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "28408225",
  },
  {
    id: "7171",
    id_polifenol: "7134",
    polifenol: "vitexin",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "29328424",
  },
  {
    id: "7172",
    id_polifenol: "6558",
    polifenol: "7,3'-dihydroxy-4'-methoxyisoflavone",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "26955262",
  },
  {
    id: "7173",
    id_polifenol: "5495",
    polifenol: "malvidin",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "27649384",
  },
  {
    id: "7174",
    id_polifenol: "77",
    polifenol: "Bezafibrate",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "2",
    pmids: "15800711,15806154",
  },
  {
    id: "7175",
    id_polifenol: "1810",
    polifenol: "heminordihydroguaiaretic acid",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "23299390",
  },
  {
    id: "7176",
    id_polifenol: "6477",
    polifenol: "hispidulin",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "20698539",
  },
  {
    id: "7177",
    id_polifenol: "128",
    polifenol: "Pterocarpans",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "2",
    pmids: "24252341,29656660",
  },
  {
    id: "7178",
    id_polifenol: "5496",
    polifenol: "pelargonidin",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "27649384",
  },
  {
    id: "7179",
    id_polifenol: "687",
    polifenol: "calix(4)arene",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "28533751",
  },
  {
    id: "7180",
    id_polifenol: "97",
    polifenol: "Probucol",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "25399650",
  },
  {
    id: "7181",
    id_polifenol: "4565",
    polifenol: "morusin",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "2",
    pmids: "25557841,26829656",
  },
  {
    id: "7182",
    id_polifenol: "6129",
    polifenol: "wogonoside",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "24970553",
  },
  {
    id: "7183",
    id_polifenol: "711",
    polifenol: "ascochlorin",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "28569433",
  },
  {
    id: "7184",
    id_polifenol: "5005",
    polifenol: "procyanidin B",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "12837490",
  },
  {
    id: "7185",
    id_polifenol: "7741",
    polifenol: "biochanin A",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "25501542",
  },
  {
    id: "7186",
    id_polifenol: "2454",
    polifenol: "corilagin",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "28474573",
  },
  {
    id: "7187",
    id_polifenol: "704",
    polifenol: "trizol",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "2",
    pmids: "27039073,16796906",
  },
  {
    id: "7188",
    id_polifenol: "347",
    polifenol: "4-nitrophenyl",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "2",
    pmids: "22564383,16504513",
  },
  {
    id: "7189",
    id_polifenol: "5538",
    polifenol: "petunidin",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "2",
    pmids: "27649384,16823770",
  },
  {
    id: "7190",
    id_polifenol: "428",
    polifenol: "2,2'-bisphenol F",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "3",
    pmids: "29215574,22564383,16823770",
  },
  {
    id: "7191",
    id_polifenol: "4981",
    polifenol: "jaceosidin",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "2",
    pmids: "22471459,27262066",
  },
  {
    id: "7192",
    id_polifenol: "3258",
    polifenol: "tesmilifene",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "26112237",
  },
  {
    id: "7193",
    id_polifenol: "3494",
    polifenol: "asarone",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "4",
    pmids: "29547514,29751524,28776671,26263057",
  },
  {
    id: "7194",
    id_polifenol: "5615",
    polifenol: "gallocatechin gallate",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "2",
    pmids: "29407769,21903153",
  },
  {
    id: "7195",
    id_polifenol: "5858",
    polifenol: "isobavachalcone",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "26547532",
  },
  {
    id: "7196",
    id_polifenol: "5289",
    polifenol: "8-bromo-7-methoxychrysin",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "22923060",
  },
  {
    id: "7197",
    id_polifenol: "5063",
    polifenol: "4',7-dihydroxy-3'-methoxy-5'-prenylflavanone",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "17685631",
  },
  {
    id: "7198",
    id_polifenol: "58",
    polifenol: "Nitrophenols",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "17875720",
  },
  {
    id: "7199",
    id_polifenol: "6548",
    polifenol: "artocarpin flavonoid",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "29770114",
  },
  {
    id: "7200",
    id_polifenol: "6492",
    polifenol: "3(2H)-isoflavene",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "28408225",
  },
  {
    id: "7201",
    id_polifenol: "3493",
    polifenol: "mequinol",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "17070879",
  },
  {
    id: "7202",
    id_polifenol: "6940",
    polifenol: "neobavaisoflavone",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "24252341",
  },
  {
    id: "7203",
    id_polifenol: "2066",
    polifenol: "NSC 680410",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "12451475",
  },
  {
    id: "7204",
    id_polifenol: "4579",
    polifenol: "hinokiflavone",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "22271084",
  },
  {
    id: "7205",
    id_polifenol: "6236",
    polifenol: "nymphaeol C",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "17685631",
  },
  {
    id: "7206",
    id_polifenol: "7641",
    polifenol: "quercetin-3'-O-beta-D-glucopyranoside",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "24938488",
  },
  {
    id: "7207",
    id_polifenol: "3058",
    polifenol: "2,5-dihydroxybenzoic acid",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "29885857",
  },
  {
    id: "7208",
    id_polifenol: "4820",
    polifenol: "3,7-dihydroxyflavone",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "29734739",
  },
  {
    id: "7209",
    id_polifenol: "21",
    polifenol: "Bisacodyl",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "3",
    pmids: "26270679,28109792,29930759",
  },
  {
    id: "7210",
    id_polifenol: "1553",
    polifenol: "dihydrocapsaicin",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "27748914",
  },
  {
    id: "7211",
    id_polifenol: "82",
    polifenol: "Gemfibrozil",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "15800711",
  },
  {
    id: "7212",
    id_polifenol: "1642",
    polifenol: "FLLL 32",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "20712901",
  },
  {
    id: "7213",
    id_polifenol: "6830",
    polifenol: "artocarpesin",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "26547532",
  },
  {
    id: "7214",
    id_polifenol: "361",
    polifenol: "2-aminophenol",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "17555822",
  },
  {
    id: "7215",
    id_polifenol: "16",
    polifenol: "Chlorophenols",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "17085958",
  },
  {
    id: "7216",
    id_polifenol: "2607",
    polifenol: "amorfrutin A",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "29369787",
  },
  {
    id: "7217",
    id_polifenol: "3371",
    polifenol:
      "5-(3-(3-(4-phenoxy-2-propylphenoxy)propoxy)phenyl)-2,4-thiazolidinedione",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "19671747",
  },
  {
    id: "7218",
    id_polifenol: "6704",
    polifenol: "4-hydroxylonchocarpin",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "2",
    pmids: "29656660,17070879",
  },
  {
    id: "7219",
    id_polifenol: "5528",
    polifenol: "petunidin-3-glucoside",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "29336479",
  },
  {
    id: "7220",
    id_polifenol: "2458",
    polifenol: "glucogallin",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "21903153",
  },
  {
    id: "7221",
    id_polifenol: "4072",
    polifenol: "elemicin",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "20958014",
  },
  {
    id: "7222",
    id_polifenol: "2286",
    polifenol: "digallic acid",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "21903153",
  },
  {
    id: "7223",
    id_polifenol: "2392",
    polifenol: "1,6-di-O-galloyl-beta-D-glucose",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "21903153",
  },
  {
    id: "7224",
    id_polifenol: "6187",
    polifenol: "propolin G",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "2",
    pmids: "21530633,17685631",
  },
  {
    id: "7225",
    id_polifenol: "4498",
    polifenol: "tanacin",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "27319121",
  },
  {
    id: "7226",
    id_polifenol: "1669",
    polifenol:
      "5-hydroxy-1-(4-hydroxy-3-methoxyphenyl)-7-(5-methylfuran-2-yl)hepta-1,4,6-trien-3-one",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "27293144",
  },
  {
    id: "7227",
    id_polifenol: "7324",
    polifenol: "glycinol",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "15974577",
  },
  {
    id: "7228",
    id_polifenol: "6229",
    polifenol: "2-hydroxynaringenin 4'-O-beta-D-glucopyranoside",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "24938488",
  },
  {
    id: "7229",
    id_polifenol: "1912",
    polifenol: "dihydroxydiphenyl-pyridyl methane",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "2",
    pmids: "26270679,29930759",
  },
  {
    id: "7230",
    id_polifenol: "5955",
    polifenol: "4'-acetoamido-4-hydroxychalcone",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "20971066",
  },
  {
    id: "7231",
    id_polifenol: "6318",
    polifenol: "2',3',4'-trihydroxyflavone",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "29215574",
  },
  {
    id: "7232",
    id_polifenol: "6331",
    polifenol: "sigmoidin H",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "24252341",
  },
  {
    id: "7233",
    id_polifenol: "4033",
    polifenol: "2,4-bis(4-fluorophenylacetyl)phloroglucinol",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "22819448",
  },
  {
    id: "7234",
    id_polifenol: "2537",
    polifenol: "granatin B",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "27725877",
  },
  {
    id: "7235",
    id_polifenol: "5454",
    polifenol: "achyrobichalcone",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "29730415",
  },
  {
    id: "7236",
    id_polifenol: "7282",
    polifenol: "hovenitin III",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "24938488",
  },
  {
    id: "7237",
    id_polifenol: "4674",
    polifenol: "phlobaphene",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "26467757",
  },
  {
    id: "7238",
    id_polifenol: "3468",
    polifenol:
      "5-(2-hydroxybenzylidene)-2-((4-phenoxyphenyl)imino)thiazolidin-4-one",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "23877018",
  },
  {
    id: "7239",
    id_polifenol: "3530",
    polifenol: "3',4-O-dimethylcedrusin",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "29715541",
  },
  {
    id: "7240",
    id_polifenol: "3505",
    polifenol: "1,4-dimethoxybenzene",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "25239700",
  },
  {
    id: "7241",
    id_polifenol: "6471",
    polifenol: "dichotomitin",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "29656660",
  },
  {
    id: "7242",
    id_polifenol: "6474",
    polifenol: "irisone B",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "29656660",
  },
  {
    id: "7243",
    id_polifenol: "4924",
    polifenol: "6-methylapigenin",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "25239551",
  },
  {
    id: "7244",
    id_polifenol: "652",
    polifenol: "2-O-methylpyrogallol",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "20958014",
  },
  {
    id: "7245",
    id_polifenol: "1118",
    polifenol: "4-hydroxyphenyl tert-butylnitrone",
    id_cancer: "603",
    cancer: "Glioblastoma",
    quant: "1",
    pmids: "19886748",
  },
  {
    id: "7246",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "57",
    pmids:
      "20971066,28950661,23546290,17876051,25213258,23229626,28858735,29437915,19001439,21501525,28560001,25527158,19263218,27461104,21867678,16702307,27729209,22949836,19031366,15869744,27622606,17530176,29730415,26245494,29115634,22426819,17804742,29770114,18322795,19398149,16914050,28153636,18971417,24632069,25481090,29251326,18948169,23369170,28665345,24970553,26454746,26474590,15332496,16917212,20467782,22057676,21969006,26569200,26610436,26075219,29747239,27262066,26512639,23768357,24144774,28602979,19865514",
  },
  {
    id: "7247",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "58",
    pmids:
      "28806703,22454662,21775121,27106025,26046466,27878252,26956814,18316600,20087857,27373979,16702307,16416600,17395690,25792385,16777101,25349781,27757851,20411591,23621850,27592626,20840775,24165291,28660665,21138870,17594054,17596214,20615395,28627598,27819521,29588587,28260885,29545399,21988497,19368804,27354801,21492457,20089354,15073579,29582250,21215629,27680947,22923060,25202424,22192169,20924967,28848349,21847493,25172633,28472690,29126958,27956075,24623647,23219677,27699139,23891772,29869524,28575990,29081729",
  },
  {
    id: "7248",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "19",
    pmids:
      "20358478,27064011,24338484,23955573,19131542,25173233,11305413,21138870,28153636,25070040,21481687,27649384,23747884,28595835,24239092,27354801,19496785,25172633,23219677",
  },
  {
    id: "7249",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "19",
    pmids:
      "26138072,10749152,17651887,9593944,29546069,19435873,20015475,11191629,21896192,12134900,25934569,21029458,15016831,15047712,22077956,23261760,15827141,25470344,18317690",
  },
  {
    id: "7250",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "11",
    pmids:
      "16702307,18357397,7552306,24632069,25384233,16598420,11523680,19356600,20177775,21553345,19639205",
  },
  {
    id: "7251",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "25",
    pmids:
      "27461104,21867678,17643826,22275840,29730415,22426819,27039073,18322795,29069736,28153636,18971417,25070040,24632069,25481090,23529952,23369170,26454746,15332496,16917212,29627902,24911084,26512639,19496785,23768357,27956075",
  },
  {
    id: "7252",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "10",
    pmids:
      "25221872,24338484,25173233,11305413,28969057,17942911,21479441,18581255,29570984,27956075",
  },
  {
    id: "7253",
    id_polifenol: "2167",
    polifenol: "phenolic acid",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "6",
    pmids: "25619640,29786770,26569200,26610436,27262066,19865514",
  },
  {
    id: "7254",
    id_polifenol: "49",
    polifenol: "Aspirin",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "8",
    pmids:
      "29545399,21324923,21956205,7562004,1506857,29885857,21720709,15481559",
  },
  {
    id: "7255",
    id_polifenol: "109",
    polifenol: "Catechin",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "5",
    pmids: "15992376,29306210,18581255,26512639,28595721",
  },
  {
    id: "7256",
    id_polifenol: "125",
    polifenol: "Isoflavones",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "6",
    pmids: "24231449,19429088,25384233,16598420,25501542,20177775",
  },
  {
    id: "7257",
    id_polifenol: "110",
    polifenol: "Chalcones",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "9",
    pmids:
      "20971066,25461314,17530176,22209415,27822587,20709029,29308744,27012433,21872616",
  },
  {
    id: "7258",
    id_polifenol: "3089",
    polifenol: "1,1-diphenyl-2-picrylhydrazyl",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "2",
    pmids: "23768357,19865514",
  },
  {
    id: "7259",
    id_polifenol: "114",
    polifenol: "Apigenin",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "11",
    pmids:
      "16702307,22318540,19031366,27622606,28381178,26569200,26610436,22614258,24144774,22923060,27956075",
  },
  {
    id: "7260",
    id_polifenol: "113",
    polifenol: "Flavones",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "4",
    pmids: "27582546,18640498,12589031,28665345",
  },
  {
    id: "7261",
    id_polifenol: "38",
    polifenol: "Gallic Acid",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "2",
    pmids: "20553913,25646699",
  },
  {
    id: "7262",
    id_polifenol: "117",
    polifenol: "Luteolin",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "3",
    pmids: "29730415,28977853,22923060",
  },
  {
    id: "7263",
    id_polifenol: "1",
    polifenol: "Phenols",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "4",
    pmids: "29306210,27163884,26136201,19467309",
  },
  {
    id: "7264",
    id_polifenol: "105",
    polifenol: "Anthocyanins",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "2",
    pmids: "29336479,27649384",
  },
  {
    id: "7265",
    id_polifenol: "7235",
    polifenol: "silybin",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "6",
    pmids: "21501525,19263218,14614320,17804742,21969006,25750273",
  },
  {
    id: "7266",
    id_polifenol: "129",
    polifenol: "Rotenone",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "6",
    pmids: "22745676,26261519,22120717,28816233,15248896,2734366",
  },
  {
    id: "7267",
    id_polifenol: "121",
    polifenol: "Kaempferols",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "4",
    pmids: "17876051,19001439,27461104,16702307",
  },
  {
    id: "7268",
    id_polifenol: "871",
    polifenol: "ABT-737",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "9",
    pmids:
      "25375379,28120212,27777286,26585571,18663354,25482928,25762636,25586056,27494880",
  },
  {
    id: "7269",
    id_polifenol: "6451",
    polifenol: "daidzein",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "1",
    pmids: "19429088",
  },
  {
    id: "7270",
    id_polifenol: "6065",
    polifenol: "baicalein",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "5",
    pmids: "24587321,25268843,19031366,25447764,25968345",
  },
  {
    id: "7271",
    id_polifenol: "7",
    polifenol: "Capsaicin",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "5",
    pmids: "19939880,18405923,27748914,26682421,26351174",
  },
  {
    id: "7272",
    id_polifenol: "4634",
    polifenol: "alvocidib",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "9",
    pmids:
      "16053697,18640498,12589031,14712094,15166614,19180667,12734434,15252147,16319534",
  },
  {
    id: "7273",
    id_polifenol: "120",
    polifenol: "Flavonols",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "1",
    pmids: "26788108",
  },
  {
    id: "7274",
    id_polifenol: "4522",
    polifenol: "chrysin",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "5",
    pmids: "16702307,19031366,15869744,26537082,22923060",
  },
  {
    id: "7275",
    id_polifenol: "123",
    polifenol: "Rutin",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "3",
    pmids: "16702307,25785932,23768357",
  },
  {
    id: "7276",
    id_polifenol: "6062",
    polifenol: "naringenin",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "3",
    pmids: "20717707,28665345,20932960",
  },
  {
    id: "7277",
    id_polifenol: "130",
    polifenol: "Proanthocyanidins",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "1",
    pmids: "26512639",
  },
  {
    id: "7278",
    id_polifenol: "111",
    polifenol: "Flavanones",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "2",
    pmids: "28665345,20932960",
  },
  {
    id: "7279",
    id_polifenol: "4502",
    polifenol: "fisetin",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "2",
    pmids: "25527158,27956075",
  },
  {
    id: "7280",
    id_polifenol: "6",
    polifenol: "Catechols",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "1",
    pmids: "24523750",
  },
  {
    id: "7281",
    id_polifenol: "25",
    polifenol: "Butylated Hydroxytoluene",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "1",
    pmids: "6634722",
  },
  {
    id: "7282",
    id_polifenol: "75",
    polifenol: "Butylated Hydroxyanisole",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "2",
    pmids: "6634722,26302663",
  },
  {
    id: "7283",
    id_polifenol: "15",
    polifenol: "Masoprocol",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "7",
    pmids: "17377739,17415525,18232056,20809257,24454929,16516855,28504686",
  },
  {
    id: "7284",
    id_polifenol: "6087",
    polifenol: "wogonin",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "5",
    pmids: "22949836,19031366,23872260,20467782,22057676",
  },
  {
    id: "7285",
    id_polifenol: "4519",
    polifenol: "myricetin",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "2",
    pmids: "27461104,19398149",
  },
  {
    id: "7286",
    id_polifenol: "4515",
    polifenol: "baicalin",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "2",
    pmids: "19031366,23648293",
  },
  {
    id: "7287",
    id_polifenol: "4500",
    polifenol: "procyanidin",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "2",
    pmids: "19167369,29156717",
  },
  {
    id: "7288",
    id_polifenol: "1356",
    polifenol: "gingerol",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "2",
    pmids: "25619640,25221872",
  },
  {
    id: "7289",
    id_polifenol: "54",
    polifenol: "Salicylic Acid",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "1",
    pmids: "7562004",
  },
  {
    id: "7290",
    id_polifenol: "98",
    polifenol: "Propofol",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "1",
    pmids: "29928428",
  },
  {
    id: "7291",
    id_polifenol: "44",
    polifenol: "Salicylates",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "1",
    pmids: "16211252",
  },
  {
    id: "7292",
    id_polifenol: "5808",
    polifenol: "isoliquiritigenin",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "3",
    pmids: "23229626,26722447,29251326",
  },
  {
    id: "7293",
    id_polifenol: "2344",
    polifenol: "methyl gallate",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "2",
    pmids: "23562553,18948169",
  },
  {
    id: "7294",
    id_polifenol: "4708",
    polifenol: "xanthohumol",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "4",
    pmids: "27487563,22407755,28665345,29747239",
  },
  {
    id: "7295",
    id_polifenol: "47",
    polifenol: "Mesalamine",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "1",
    pmids: "19457125",
  },
  {
    id: "7296",
    id_polifenol: "2284",
    polifenol: "rosmarinic acid",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "1",
    pmids: "29627902",
  },
  {
    id: "7297",
    id_polifenol: "6455",
    polifenol: "nobiletin",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "3",
    pmids: "26560814,23546290,28339056",
  },
  {
    id: "7298",
    id_polifenol: "4513",
    polifenol: "galangin",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "2",
    pmids: "29115634,27956075",
  },
  {
    id: "7299",
    id_polifenol: "6063",
    polifenol: "naringin",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "2",
    pmids: "16702307,26474590",
  },
  {
    id: "7300",
    id_polifenol: "1380",
    polifenol: "shogaol",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "1",
    pmids: "25619640",
  },
  {
    id: "7301",
    id_polifenol: "5489",
    polifenol: "delphinidin",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "1",
    pmids: "27649384",
  },
  {
    id: "7302",
    id_polifenol: "1613",
    polifenol: "demethoxycurcumin",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "6",
    pmids: "22454662,28591733,27757851,25877753,27680947,29575236",
  },
  {
    id: "7303",
    id_polifenol: "93",
    polifenol: "Phloroglucinol",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "2",
    pmids: "22819448,23669242",
  },
  {
    id: "7304",
    id_polifenol: "6454",
    polifenol: "formononetin",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "2",
    pmids: "29848900,26261519",
  },
  {
    id: "7305",
    id_polifenol: "81",
    polifenol: "Fenofibrate",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "3",
    pmids: "25566967,20569465,29760790",
  },
  {
    id: "7306",
    id_polifenol: "7550",
    polifenol: "3-methylquercetin",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "2",
    pmids: "27461104,29730415",
  },
  {
    id: "7307",
    id_polifenol: "6461",
    polifenol: "acacetin",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "2",
    pmids: "26569200,26610436",
  },
  {
    id: "7308",
    id_polifenol: "1611",
    polifenol: "bis(4-hydroxycinnamoyl)methane",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "1",
    pmids: "27680947",
  },
  {
    id: "7309",
    id_polifenol: "55",
    polifenol: "Sodium Salicylate",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "1",
    pmids: "16211252",
  },
  {
    id: "7310",
    id_polifenol: "108",
    polifenol: "Biflavonoids",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "1",
    pmids: "22271084",
  },
  {
    id: "7311",
    id_polifenol: "5844",
    polifenol: "4-dimethylamino-3',4'-dimethoxychalcone",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "5",
    pmids: "12496285,10749152,12629150,14530312,15313191",
  },
  {
    id: "7312",
    id_polifenol: "5819",
    polifenol: "licochalcone A",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "1",
    pmids: "28593138",
  },
  {
    id: "7313",
    id_polifenol: "5488",
    polifenol: "cyanidin",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "1",
    pmids: "27649384",
  },
  {
    id: "7314",
    id_polifenol: "4640",
    polifenol: "5,7-dihydroxy-6-methoxy-2-phenylchromen-4-one",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "2",
    pmids: "25213258,29793319",
  },
  {
    id: "7315",
    id_polifenol: "2773",
    polifenol: "farnesylthiosalicylic acid",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "1",
    pmids: "22323550",
  },
  {
    id: "7316",
    id_polifenol: "80",
    polifenol: "Clofibrate",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "1",
    pmids: "1403680",
  },
  {
    id: "7317",
    id_polifenol: "7546",
    polifenol: "isoquercitrin",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "1",
    pmids: "23768357",
  },
  {
    id: "7318",
    id_polifenol: "452",
    polifenol: "acteoside",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "1",
    pmids: "26743778",
  },
  {
    id: "7319",
    id_polifenol: "1644",
    polifenol: "Cur1 compound",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "2",
    pmids: "21988497,28848349",
  },
  {
    id: "7320",
    id_polifenol: "5850",
    polifenol: "cardamonin",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "1",
    pmids: "27956075",
  },
  {
    id: "7321",
    id_polifenol: "60",
    polifenol: "2,4-Dinitrophenol",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "2",
    pmids: "3468375,26950698",
  },
  {
    id: "7322",
    id_polifenol: "300",
    polifenol: "rhodioloside",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "1",
    pmids: "24255575",
  },
  {
    id: "7323",
    id_polifenol: "7912",
    polifenol: "7,9,2',4'-tetrahydroxy-8-isopentenyl-5-methoxychalcone",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "1",
    pmids: "27487563",
  },
  {
    id: "7324",
    id_polifenol: "6097",
    polifenol: "8-prenylnaringenin",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "1",
    pmids: "28665345",
  },
  {
    id: "7325",
    id_polifenol: "5071",
    polifenol: "icaritin",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "1",
    pmids: "27904667",
  },
  {
    id: "7326",
    id_polifenol: "6576",
    polifenol: "5,7,4'-trihydroxyflavone",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "2",
    pmids: "27622606,29115634",
  },
  {
    id: "7327",
    id_polifenol: "4585",
    polifenol: "baohuoside I",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "1",
    pmids: "28560001",
  },
  {
    id: "7328",
    id_polifenol: "6086",
    polifenol: "liquiritigenin",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "1",
    pmids: "25351348",
  },
  {
    id: "7329",
    id_polifenol: "59",
    polifenol: "Dinitrophenols",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "1",
    pmids: "3468375",
  },
  {
    id: "7330",
    id_polifenol: "5495",
    polifenol: "malvidin",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "1",
    pmids: "27649384",
  },
  {
    id: "7331",
    id_polifenol: "5496",
    polifenol: "pelargonidin",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "1",
    pmids: "27649384",
  },
  {
    id: "7332",
    id_polifenol: "7377",
    polifenol: "astragalin",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "2",
    pmids: "26569200,26610436",
  },
  {
    id: "7333",
    id_polifenol: "97",
    polifenol: "Probucol",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "1",
    pmids: "25399650",
  },
  {
    id: "7334",
    id_polifenol: "7156",
    polifenol: "scutellarein",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "1",
    pmids: "19031366",
  },
  {
    id: "7335",
    id_polifenol: "2450",
    polifenol: "Geraniin",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "1",
    pmids: "28374108",
  },
  {
    id: "7336",
    id_polifenol: "4565",
    polifenol: "morusin",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "1",
    pmids: "26829656",
  },
  {
    id: "7337",
    id_polifenol: "6129",
    polifenol: "wogonoside",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "1",
    pmids: "24970553",
  },
  {
    id: "7338",
    id_polifenol: "6112",
    polifenol: "alpinetin",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "1",
    pmids: "26768745",
  },
  {
    id: "7339",
    id_polifenol: "711",
    polifenol: "ascochlorin",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "1",
    pmids: "28569433",
  },
  {
    id: "7340",
    id_polifenol: "7741",
    polifenol: "biochanin A",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "1",
    pmids: "25501542",
  },
  {
    id: "7341",
    id_polifenol: "2454",
    polifenol: "corilagin",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "1",
    pmids: "28474573",
  },
  {
    id: "7342",
    id_polifenol: "704",
    polifenol: "trizol",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "1",
    pmids: "27039073",
  },
  {
    id: "7343",
    id_polifenol: "347",
    polifenol: "4-nitrophenyl",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "1",
    pmids: "22564383",
  },
  {
    id: "7344",
    id_polifenol: "5538",
    polifenol: "petunidin",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "1",
    pmids: "27649384",
  },
  {
    id: "7345",
    id_polifenol: "428",
    polifenol: "2,2'-bisphenol F",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "1",
    pmids: "22564383",
  },
  {
    id: "7346",
    id_polifenol: "4981",
    polifenol: "jaceosidin",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "2",
    pmids: "27729209,27262066",
  },
  {
    id: "7347",
    id_polifenol: "3258",
    polifenol: "tesmilifene",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "1",
    pmids: "26112237",
  },
  {
    id: "7348",
    id_polifenol: "3494",
    polifenol: "asarone",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "4",
    pmids: "29547514,29751524,28776671,28380412",
  },
  {
    id: "7349",
    id_polifenol: "4544",
    polifenol: "tiliroside",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "2",
    pmids: "26569200,26610436",
  },
  {
    id: "7350",
    id_polifenol: "5289",
    polifenol: "8-bromo-7-methoxychrysin",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "1",
    pmids: "22923060",
  },
  {
    id: "7351",
    id_polifenol: "6684",
    polifenol: "eupafolin",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "1",
    pmids: "27582546",
  },
  {
    id: "7352",
    id_polifenol: "5063",
    polifenol: "4',7-dihydroxy-3'-methoxy-5'-prenylflavanone",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "1",
    pmids: "17685631",
  },
  {
    id: "7353",
    id_polifenol: "58",
    polifenol: "Nitrophenols",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "1",
    pmids: "17875720",
  },
  {
    id: "7354",
    id_polifenol: "3490",
    polifenol: "estragole",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "1",
    pmids: "24980711",
  },
  {
    id: "7355",
    id_polifenol: "3606",
    polifenol:
      "5-(3-methoxy-4-((4-methoxybenzyl)oxy)benzyl)pyrimidine-2,4-diamine",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "1",
    pmids: "22957741",
  },
  {
    id: "7356",
    id_polifenol: "818",
    polifenol: "4,4'-isopropylidene diphenol",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "1",
    pmids: "19467309",
  },
  {
    id: "7357",
    id_polifenol: "6548",
    polifenol: "artocarpin flavonoid",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "1",
    pmids: "29770114",
  },
  {
    id: "7358",
    id_polifenol: "1811",
    polifenol: "terameprocol",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "1",
    pmids: "18311658",
  },
  {
    id: "7359",
    id_polifenol: "6786",
    polifenol: "8-hydroxy-3,4',5,6,7-pentamethoxyflavone",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "1",
    pmids: "26788108",
  },
  {
    id: "7360",
    id_polifenol: "6633",
    polifenol: "pomiferin",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "1",
    pmids: "23929619",
  },
  {
    id: "7361",
    id_polifenol: "6940",
    polifenol: "neobavaisoflavone",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "1",
    pmids: "24231449",
  },
  {
    id: "7362",
    id_polifenol: "4135",
    polifenol: "orcinol",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "1",
    pmids: "15921417",
  },
  {
    id: "7363",
    id_polifenol: "4103",
    polifenol: "gnetin H",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "1",
    pmids: "12135100",
  },
  {
    id: "7364",
    id_polifenol: "6803",
    polifenol: "isoscutellarein",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "2",
    pmids: "26569200,26610436",
  },
  {
    id: "7365",
    id_polifenol: "4579",
    polifenol: "hinokiflavone",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "1",
    pmids: "22271084",
  },
  {
    id: "7366",
    id_polifenol: "6236",
    polifenol: "nymphaeol C",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "1",
    pmids: "17685631",
  },
  {
    id: "7367",
    id_polifenol: "7352",
    polifenol: "3',4',5'-trimethoxyflavonol",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "1",
    pmids: "26788108",
  },
  {
    id: "7368",
    id_polifenol: "3058",
    polifenol: "2,5-dihydroxybenzoic acid",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "1",
    pmids: "29885857",
  },
  {
    id: "7369",
    id_polifenol: "1566",
    polifenol: "arvanil",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "1",
    pmids: "22820645",
  },
  {
    id: "7370",
    id_polifenol: "4152",
    polifenol: "quracol B",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "1",
    pmids: "26190864",
  },
  {
    id: "7371",
    id_polifenol: "1553",
    polifenol: "dihydrocapsaicin",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "1",
    pmids: "27748914",
  },
  {
    id: "7372",
    id_polifenol: "4224",
    polifenol: "orsellinic acid",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "1",
    pmids: "15921417",
  },
  {
    id: "7373",
    id_polifenol: "4334",
    polifenol: "acacetin-7-rutinoside",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "1",
    pmids: "28858735",
  },
  {
    id: "7374",
    id_polifenol: "6347",
    polifenol: "oroxylin A-7-O-glucuronide",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "1",
    pmids: "29793319",
  },
  {
    id: "7375",
    id_polifenol: "5528",
    polifenol: "petunidin-3-glucoside",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "1",
    pmids: "29336479",
  },
  {
    id: "7376",
    id_polifenol: "6187",
    polifenol: "propolin G",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "2",
    pmids: "21530633,17685631",
  },
  {
    id: "7377",
    id_polifenol: "4523",
    polifenol: "hypolaetin-8-glucoside",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "2",
    pmids: "26569200,26610436",
  },
  {
    id: "7378",
    id_polifenol: "6429",
    polifenol: "7,4'-di-O-methylisoscutellarein",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "2",
    pmids: "26569200,26610436",
  },
  {
    id: "7379",
    id_polifenol: "2174",
    polifenol: "3,5-ditert-butyl-4-hydroxy-(2,4-ditert-butylphenyl)benzoate",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "1",
    pmids: "10604659",
  },
  {
    id: "7380",
    id_polifenol: "583",
    polifenol: "2-fluoro-4-nitrophenol",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "1",
    pmids: "16916713",
  },
  {
    id: "7381",
    id_polifenol: "5955",
    polifenol: "4'-acetoamido-4-hydroxychalcone",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "1",
    pmids: "20971066",
  },
  {
    id: "7382",
    id_polifenol: "4033",
    polifenol: "2,4-bis(4-fluorophenylacetyl)phloroglucinol",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "1",
    pmids: "22819448",
  },
  {
    id: "7383",
    id_polifenol: "2537",
    polifenol: "granatin B",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "1",
    pmids: "27725877",
  },
  {
    id: "7384",
    id_polifenol: "5454",
    polifenol: "achyrobichalcone",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "1",
    pmids: "29730415",
  },
  {
    id: "7385",
    id_polifenol: "4223",
    polifenol: "globosumone C",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "1",
    pmids: "15921417",
  },
  {
    id: "7386",
    id_polifenol: "3468",
    polifenol:
      "5-(2-hydroxybenzylidene)-2-((4-phenoxyphenyl)imino)thiazolidin-4-one",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "1",
    pmids: "23877018",
  },
  {
    id: "7387",
    id_polifenol: "3996",
    polifenol: "uliginosin B",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "1",
    pmids: "23669242",
  },
  {
    id: "7388",
    id_polifenol: "4540",
    polifenol: "hydroxygenkwanin",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "1",
    pmids: "24144774",
  },
  {
    id: "7389",
    id_polifenol: "1893",
    polifenol: "2,6-diformyl-4-methylphenol",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "1",
    pmids: "18037489",
  },
  {
    id: "7390",
    id_polifenol: "1273",
    polifenol: "Silar (3M)",
    id_cancer: "607",
    cancer: "Glioma",
    quant: "1",
    pmids: "29576738",
  },
  {
    id: "7391",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "30",
    pmids:
      "21054790,27571890,18025287,24646039,23573134,24012496,29422113,26838546,28464411,18296682,16720314,25859163,22128260,24991123,24700700,24284390,21777131,12914542,15117815,21220495,27177091,22137869,27711848,24705371,19194970,28278502,28791405,29363820,11237105,28414916",
  },
  {
    id: "7392",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "41",
    pmids:
      "29147235,28286973,21757545,22771723,29901071,18342436,18593936,25667441,28870814,25170806,28705118,28693289,27564099,16596191,16696321,19682434,16520656,15810596,26718024,19903839,28849163,23152782,20407012,21836020,17363495,26776764,26027129,11547120,19860939,22189739,29281876,28259934,26516945,26191140,28272691,23356235,28981096,23642399,17465196,11201293,28579805",
  },
  {
    id: "7393",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "25",
    pmids:
      "18381677,19729851,28592119,25667441,28615100,29552308,28040581,24329111,28693289,16596191,27186419,21743966,27748855,25482719,25572695,18840529,19860939,28178690,20362526,16304905,28141864,18544457,22386766,19588362,29936451",
  },
  {
    id: "7394",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "15",
    pmids:
      "20198313,18468578,18825409,18296682,16891461,23128598,11980898,29581781,12851530,18726116,23217386,26149761,24606459,19424573,28534984",
  },
  {
    id: "7395",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "14",
    pmids:
      "18025287,15611796,15627483,16951199,23365634,12851530,10656454,25940704,16452247,9823337,11287753,9269996,9833772,17465217",
  },
  {
    id: "7396",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "13",
    pmids:
      "18025287,27186419,16720314,22128260,27373212,29082699,29069736,22137869,29019431,27711848,16304905,27149655,28414916",
  },
  {
    id: "7397",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "18",
    pmids:
      "29042941,19729851,21782236,29552308,28040581,24329111,21743966,17266926,17348027,14769544,28098863,27391608,18544457,22941057,24220494,12913695,21683410,23260235",
  },
  {
    id: "7398",
    id_polifenol: "2167",
    polifenol: "phenolic acid",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "3",
    pmids: "6704970,24973092,23738328",
  },
  {
    id: "7399",
    id_polifenol: "49",
    polifenol: "Aspirin",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "6",
    pmids: "15342406,4044826,6832096,3130357,19892664,16118353",
  },
  {
    id: "7400",
    id_polifenol: "109",
    polifenol: "Catechin",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "10",
    pmids:
      "18025287,19729851,26731576,25482719,14769544,15145695,18544457,21683410,15546559,19588362",
  },
  {
    id: "7401",
    id_polifenol: "125",
    polifenol: "Isoflavones",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "10",
    pmids:
      "27268915,15611796,15627483,16951199,23365634,10656454,16452247,9823337,9833772,11435074",
  },
  {
    id: "7402",
    id_polifenol: "110",
    polifenol: "Chalcones",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "10",
    pmids:
      "24989010,26036640,17845507,21908193,15833884,19138991,28870684,24121102,27318274,24123014",
  },
  {
    id: "7403",
    id_polifenol: "3089",
    polifenol: "1,1-diphenyl-2-picrylhydrazyl",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "1",
    pmids: "18720191",
  },
  {
    id: "7404",
    id_polifenol: "114",
    polifenol: "Apigenin",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "5",
    pmids: "23724790,28464411,25859163,29945448,21777131",
  },
  {
    id: "7405",
    id_polifenol: "113",
    polifenol: "Flavones",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "3",
    pmids: "29805643,21777131,16309238",
  },
  {
    id: "7406",
    id_polifenol: "38",
    polifenol: "Gallic Acid",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "3",
    pmids: "29567231,20564478,16304905",
  },
  {
    id: "7407",
    id_polifenol: "117",
    polifenol: "Luteolin",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "3",
    pmids: "24820279,12680237,21777131",
  },
  {
    id: "7408",
    id_polifenol: "1",
    polifenol: "Phenols",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "7",
    pmids: "27748855,19420803,24918476,28229968,26516945,19194970,7055797",
  },
  {
    id: "7409",
    id_polifenol: "105",
    polifenol: "Anthocyanins",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "2",
    pmids: "29429260,24743948",
  },
  {
    id: "7410",
    id_polifenol: "7235",
    polifenol: "silybin",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "12",
    pmids:
      "24012496,23555889,28229968,15117815,21220495,18172282,24705371,14651997,29190895,18089718,28791405,29363820",
  },
  {
    id: "7411",
    id_polifenol: "121",
    polifenol: "Kaempferols",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "3",
    pmids: "24700700,24284390,28278502",
  },
  {
    id: "7412",
    id_polifenol: "871",
    polifenol: "ABT-737",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "3",
    pmids: "26397392,26100943,25885284",
  },
  {
    id: "7413",
    id_polifenol: "6451",
    polifenol: "daidzein",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "3",
    pmids: "27268915,10656454,9823337",
  },
  {
    id: "7414",
    id_polifenol: "6065",
    polifenol: "baicalein",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "7",
    pmids: "27571890,18025287,23573134,23064738,27735841,15161019,10840124",
  },
  {
    id: "7415",
    id_polifenol: "7",
    polifenol: "Capsaicin",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "12",
    pmids:
      "27367652,20646592,26648574,25220876,27775662,27367032,15595419,19592070,23580156,22462738,21789052,22797854",
  },
  {
    id: "7416",
    id_polifenol: "4634",
    polifenol: "alvocidib",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "2",
    pmids: "10367753,16309238",
  },
  {
    id: "7417",
    id_polifenol: "120",
    polifenol: "Flavonols",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "2",
    pmids: "27765366,26496799",
  },
  {
    id: "7418",
    id_polifenol: "4522",
    polifenol: "chrysin",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "1",
    pmids: "29805643",
  },
  {
    id: "7419",
    id_polifenol: "123",
    polifenol: "Rutin",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "2",
    pmids: "18025287,16304905",
  },
  {
    id: "7420",
    id_polifenol: "6062",
    polifenol: "naringenin",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "1",
    pmids: "25017119",
  },
  {
    id: "7421",
    id_polifenol: "130",
    polifenol: "Proanthocyanidins",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "1",
    pmids: "22393334",
  },
  {
    id: "7422",
    id_polifenol: "35",
    polifenol: "Hydroquinones",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "3",
    pmids: "19420803,21612160,17105440",
  },
  {
    id: "7423",
    id_polifenol: "111",
    polifenol: "Flavanones",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "2",
    pmids: "14651997,24123014",
  },
  {
    id: "7424",
    id_polifenol: "4502",
    polifenol: "fisetin",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "3",
    pmids: "21054790,24646039,28824336",
  },
  {
    id: "7425",
    id_polifenol: "25",
    polifenol: "Butylated Hydroxytoluene",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "1",
    pmids: "6704970",
  },
  {
    id: "7426",
    id_polifenol: "75",
    polifenol: "Butylated Hydroxyanisole",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "1",
    pmids: "11085355",
  },
  {
    id: "7427",
    id_polifenol: "15",
    polifenol: "Masoprocol",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "1",
    pmids: "18794123",
  },
  {
    id: "7428",
    id_polifenol: "6087",
    polifenol: "wogonin",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "1",
    pmids: "10840124",
  },
  {
    id: "7429",
    id_polifenol: "4519",
    polifenol: "myricetin",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "2",
    pmids: "22482362,27711848",
  },
  {
    id: "7430",
    id_polifenol: "4515",
    polifenol: "baicalin",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "3",
    pmids: "23354080,18025287,10840124",
  },
  {
    id: "7431",
    id_polifenol: "4500",
    polifenol: "procyanidin",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "1",
    pmids: "27467005",
  },
  {
    id: "7432",
    id_polifenol: "5608",
    polifenol: "epicatechin gallate",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "2",
    pmids: "19729851,18544457",
  },
  {
    id: "7433",
    id_polifenol: "1356",
    polifenol: "gingerol",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "1",
    pmids: "16878317",
  },
  {
    id: "7434",
    id_polifenol: "5578",
    polifenol: "alpha-naphthoflavone",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "1",
    pmids: "23033491",
  },
  {
    id: "7435",
    id_polifenol: "5808",
    polifenol: "isoliquiritigenin",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "2",
    pmids: "28693160,28870684",
  },
  {
    id: "7436",
    id_polifenol: "10",
    polifenol: "Estrogens, Catechol",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "1",
    pmids: "28018158",
  },
  {
    id: "7437",
    id_polifenol: "6063",
    polifenol: "naringin",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "2",
    pmids: "18296682,29019431",
  },
  {
    id: "7438",
    id_polifenol: "1380",
    polifenol: "shogaol",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "1",
    pmids: "16878317",
  },
  {
    id: "7439",
    id_polifenol: "93",
    polifenol: "Phloroglucinol",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "2",
    pmids: "21158429,19754119",
  },
  {
    id: "7440",
    id_polifenol: "6454",
    polifenol: "formononetin",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "1",
    pmids: "28139790",
  },
  {
    id: "7441",
    id_polifenol: "7550",
    polifenol: "3-methylquercetin",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "1",
    pmids: "27711848",
  },
  {
    id: "7442",
    id_polifenol: "4253",
    polifenol:
      "5-(2,4-dihydroxy-5-isopropylphenyl)-4-(4-morpholin-4-ylmethylphenyl)isoxazole-3-carboxylic acid ethylamide",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "1",
    pmids: "23401075",
  },
  {
    id: "7443",
    id_polifenol: "1611",
    polifenol: "bis(4-hydroxycinnamoyl)methane",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "1",
    pmids: "28579805",
  },
  {
    id: "7444",
    id_polifenol: "107",
    polifenol: "beta-Naphthoflavone",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "1",
    pmids: "27318274",
  },
  {
    id: "7445",
    id_polifenol: "5806",
    polifenol: "butein",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "2",
    pmids: "18472007,26598915",
  },
  {
    id: "7446",
    id_polifenol: "1558",
    polifenol: "capsazepine",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "3",
    pmids: "26648574,19592070,22462738",
  },
  {
    id: "7447",
    id_polifenol: "5844",
    polifenol: "4-dimethylamino-3',4'-dimethoxychalcone",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "1",
    pmids: "15514684",
  },
  {
    id: "7448",
    id_polifenol: "6463",
    polifenol: "puerarin",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "2",
    pmids: "29375709,29422113",
  },
  {
    id: "7449",
    id_polifenol: "5819",
    polifenol: "licochalcone A",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "3",
    pmids: "23936805,26397392,27221781",
  },
  {
    id: "7450",
    id_polifenol: "94",
    polifenol: "Phloretin",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "2",
    pmids: "8297149,8297148",
  },
  {
    id: "7451",
    id_polifenol: "1995",
    polifenol: "2-tert-butylhydroquinone",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "1",
    pmids: "16014739",
  },
  {
    id: "7452",
    id_polifenol: "7546",
    polifenol: "isoquercitrin",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "3",
    pmids: "29741444,28948276,27177091",
  },
  {
    id: "7453",
    id_polifenol: "1644",
    polifenol: "Cur1 compound",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "1",
    pmids: "29281876",
  },
  {
    id: "7454",
    id_polifenol: "100",
    polifenol: "Resorcinols",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "1",
    pmids: "24784839",
  },
  {
    id: "7455",
    id_polifenol: "118",
    polifenol: "Flavonolignans",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "1",
    pmids: "23555889",
  },
  {
    id: "7456",
    id_polifenol: "300",
    polifenol: "rhodioloside",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "1",
    pmids: "21520297",
  },
  {
    id: "7457",
    id_polifenol: "6465",
    polifenol: "genistin",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "2",
    pmids: "16452247,9823337",
  },
  {
    id: "7458",
    id_polifenol: "1996",
    polifenol: "2,5-di-tert-butylhydroquinone",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "1",
    pmids: "16014739",
  },
  {
    id: "7459",
    id_polifenol: "5071",
    polifenol: "icaritin",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "1",
    pmids: "26496799",
  },
  {
    id: "7460",
    id_polifenol: "6576",
    polifenol: "5,7,4'-trihydroxyflavone",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "1",
    pmids: "23724790",
  },
  {
    id: "7461",
    id_polifenol: "7134",
    polifenol: "vitexin",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "1",
    pmids: "28464411",
  },
  {
    id: "7462",
    id_polifenol: "5815",
    polifenol: "dibenzoylmethane",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "1",
    pmids: "17017982",
  },
  {
    id: "7463",
    id_polifenol: "5630",
    polifenol: "polyphenon E",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "2",
    pmids: "24220494,21683410",
  },
  {
    id: "7464",
    id_polifenol: "7547",
    polifenol: "hyperoside",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "1",
    pmids: "27711848",
  },
  {
    id: "7465",
    id_polifenol: "1810",
    polifenol: "heminordihydroguaiaretic acid",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "1",
    pmids: "15161019",
  },
  {
    id: "7466",
    id_polifenol: "7853",
    polifenol: "Grape Seed Proanthocyanidins",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "1",
    pmids: "27467005",
  },
  {
    id: "7467",
    id_polifenol: "4715",
    polifenol: "ampelopsin",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "1",
    pmids: "22241170",
  },
  {
    id: "7468",
    id_polifenol: "299",
    polifenol: "nitrophenylphosphate",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "1",
    pmids: "16520656",
  },
  {
    id: "7469",
    id_polifenol: "6175",
    polifenol: "2'-hydroxyflavanone",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "1",
    pmids: "24606737",
  },
  {
    id: "7470",
    id_polifenol: "896",
    polifenol: "polyphenon B",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "2",
    pmids: "19729851,18544457",
  },
  {
    id: "7471",
    id_polifenol: "357",
    polifenol: "4-aminophenol",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "1",
    pmids: "8425184",
  },
  {
    id: "7472",
    id_polifenol: "7658",
    polifenol: "quercetin 3'-O-glucoside",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "1",
    pmids: "27711848",
  },
  {
    id: "7473",
    id_polifenol: "7895",
    polifenol: "flavokawain A",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "4",
    pmids: "15833884,19138991,24121102,27318274",
  },
  {
    id: "7474",
    id_polifenol: "6687",
    polifenol: "3'-dimethylaminoflavone",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "1",
    pmids: "18720191",
  },
  {
    id: "7475",
    id_polifenol: "3944",
    polifenol: "myrtucommulone A",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "3",
    pmids: "26054707,26718217,26334623",
  },
  {
    id: "7476",
    id_polifenol: "2026",
    polifenol: "phenylhydroquinone",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "1",
    pmids: "26919225",
  },
  {
    id: "7477",
    id_polifenol: "5945",
    polifenol: "2',5'-dimethoxychalcone",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "2",
    pmids: "24989010,20199865",
  },
  {
    id: "7478",
    id_polifenol: "1451",
    polifenol: "hispolon",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "1",
    pmids: "26056942",
  },
  {
    id: "7479",
    id_polifenol: "5963",
    polifenol: "3,5,2',4'-tetrahydroxychalcone",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "1",
    pmids: "26598915",
  },
  {
    id: "7480",
    id_polifenol: "6460",
    polifenol: "ipriflavone",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "1",
    pmids: "16951199",
  },
  {
    id: "7481",
    id_polifenol: "1772",
    polifenol: "3-hydroxy-4-methoxybenzaldehyde thiosemicarbazone",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "5",
    pmids: "21782236,15161019,10840124,9823337,22797854",
  },
  {
    id: "7482",
    id_polifenol: "6752",
    polifenol: "zapotin",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "1",
    pmids: "17228877",
  },
  {
    id: "7483",
    id_polifenol: "5465",
    polifenol: "vitexin-2-O-xyloside",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "2",
    pmids: "28464411,27812566",
  },
  {
    id: "7484",
    id_polifenol: "1626",
    polifenol: "diacetylcurcumin",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "1",
    pmids: "26516945",
  },
  {
    id: "7485",
    id_polifenol: "4748",
    polifenol: "kazinol B",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "1",
    pmids: "27765366",
  },
  {
    id: "7486",
    id_polifenol: "292",
    polifenol: "3-dimethylaminophenol",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "1",
    pmids: "24973092",
  },
  {
    id: "7487",
    id_polifenol: "585",
    polifenol: "protosappanin A",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "1",
    pmids: "26036624",
  },
  {
    id: "7488",
    id_polifenol: "7133",
    polifenol: "vitexin rhamnoside",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "1",
    pmids: "28464411",
  },
  {
    id: "7489",
    id_polifenol: "1656",
    polifenol: "curcumin-valine",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "2",
    pmids: "16696321,16520656",
  },
  {
    id: "7490",
    id_polifenol: "23",
    polifenol: "Bromcresol Green",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "1",
    pmids: "7091387",
  },
  {
    id: "7491",
    id_polifenol: "7241",
    polifenol: "7-O-galloylsilybin",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "1",
    pmids: "23555889",
  },
  {
    id: "7492",
    id_polifenol: "809",
    polifenol: "malvidin-3-O-glucoside-4 vinyl",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "1",
    pmids: "29884360",
  },
  {
    id: "7493",
    id_polifenol: "4212",
    polifenol: "delta-viniferin",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "1",
    pmids: "29884360",
  },
  {
    id: "7494",
    id_polifenol: "1893",
    polifenol: "2,6-diformyl-4-methylphenol",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "1",
    pmids: "18037489",
  },
  {
    id: "7495",
    id_polifenol: "30",
    polifenol: "Tolterodine Tartrate",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "1",
    pmids: "10193658",
  },
  {
    id: "7496",
    id_polifenol: "1887",
    polifenol: "5-hydroxymethyl tolterodine",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "1",
    pmids: "10193658",
  },
  {
    id: "7497",
    id_polifenol: "2109",
    polifenol: "2,3-dimethylhydroquinone",
    id_cancer: "524",
    cancer: "Bladder Cancer",
    quant: "1",
    pmids: "24973092",
  },
  {
    id: "7498",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "28",
    pmids:
      "22246103,23943362,19670328,26138287,29848706,26397991,29433670,19142175,23871783,18570926,24438177,15135307,22227579,23453831,21227456,16158939,29796442,12168845,17967505,24573487,27935659,28930257,23140288,24729227,22622510,20729081,28122160,28029227",
  },
  {
    id: "7499",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "54",
    pmids:
      "24324975,27572503,23985704,29512729,25451846,19395473,21697760,26129848,19003584,21484797,27845899,17201164,26348467,27133426,21904657,9918209,26302089,18049840,24366050,28067673,21116627,27936114,9252680,29107110,27330528,23794119,19401701,25497868,23547842,17882652,29048549,22685460,16507392,26177391,20394536,28365185,24224124,28137215,22637745,26515041,27438851,23933177,20729081,19528445,29421571,23007664,22725697,22107757,26561365,29271302,26037703,26440757,28106283,23552468",
  },
  {
    id: "7500",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "23",
    pmids:
      "27572503,21241417,19082499,29512729,21031621,18841326,29854071,27521217,29879629,27936114,10624710,9252680,29796442,27974694,22116673,28137273,15462182,27253410,25898131,23613993,22190076,12131770,26395574",
  },
  {
    id: "7501",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "31",
    pmids:
      "11876253,22967941,12947332,9175881,15028947,21613217,15805288,10972974,16773182,16209712,16904205,16105664,17353198,11039477,25880226,27435925,24301926,12014623,10220513,10781373,26718740,17638924,25847529,12105858,16091975,10585578,12481421,22441995,20397262,19062038,10433520",
  },
  {
    id: "7502",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "23",
    pmids:
      "12947332,15211111,17079479,16258364,16209712,18026817,16546962,21463919,16284950,29433670,21503965,15097869,16789737,16061678,16475211,25202045,19358273,9867251,10433520,15015587,28137215,10424789,27696401",
  },
  {
    id: "7503",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "13",
    pmids:
      "25017900,23635652,27521217,15135307,17234771,24312717,16158939,28137273,12168845,24573487,27253410,28137215,28122160",
  },
  {
    id: "7504",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "18",
    pmids:
      "21318151,22583593,21241417,23135610,19082499,26225138,25017900,17981559,22497997,10624710,19438225,26246802,21787753,28137215,24798568,12131770,28507327,27251159",
  },
  {
    id: "7505",
    id_polifenol: "2167",
    polifenol: "phenolic acid",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "10",
    pmids:
      "23943362,29879629,23453831,28222613,29048549,27935659,28930257,20729081,28122160,28029227",
  },
  {
    id: "7506",
    id_polifenol: "49",
    polifenol: "Aspirin",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "13",
    pmids:
      "26056043,18805632,28162289,18174252,23019409,21805049,26301084,16699954,11238189,18472019,11180079,23007664,25846752",
  },
  {
    id: "7507",
    id_polifenol: "109",
    polifenol: "Catechin",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "15",
    pmids:
      "21241417,26225138,25017900,22497997,23453831,19438225,29796442,24573487,28930257,22190076,24516636,22622510,28122160,28029227,27251159",
  },
  {
    id: "7508",
    id_polifenol: "125",
    polifenol: "Isoflavones",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "7",
    pmids: "26138287,16258364,16546962,16789737,16061678,25202045,24224124",
  },
  {
    id: "7509",
    id_polifenol: "110",
    polifenol: "Chalcones",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "7",
    pmids: "26211581,29121426,27371926,25783964,26845133,27558673,20729081",
  },
  {
    id: "7510",
    id_polifenol: "3089",
    polifenol: "1,1-diphenyl-2-picrylhydrazyl",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "1",
    pmids: "23453831",
  },
  {
    id: "7511",
    id_polifenol: "114",
    polifenol: "Apigenin",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "6",
    pmids: "23943362,22889981,19142175,22227579,21227456,17967505",
  },
  {
    id: "7512",
    id_polifenol: "113",
    polifenol: "Flavones",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "2",
    pmids: "28915595,26845133",
  },
  {
    id: "7513",
    id_polifenol: "38",
    polifenol: "Gallic Acid",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "8",
    pmids:
      "22739044,24325191,23943154,22132974,27935659,28930257,28122160,28029227",
  },
  {
    id: "7514",
    id_polifenol: "117",
    polifenol: "Luteolin",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "5",
    pmids: "22825765,23871783,15135307,16158939,12168845",
  },
  {
    id: "7515",
    id_polifenol: "1",
    polifenol: "Phenols",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "2",
    pmids: "22739044,28222613",
  },
  {
    id: "7516",
    id_polifenol: "105",
    polifenol: "Anthocyanins",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "1",
    pmids: "26476633",
  },
  {
    id: "7517",
    id_polifenol: "7235",
    polifenol: "silybin",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "3",
    pmids: "21954330,23022268,26510913",
  },
  {
    id: "7518",
    id_polifenol: "129",
    polifenol: "Rotenone",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "3",
    pmids: "22946344,16284950,10424789",
  },
  {
    id: "7519",
    id_polifenol: "121",
    polifenol: "Kaempferols",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "1",
    pmids: "18570926",
  },
  {
    id: "7520",
    id_polifenol: "871",
    polifenol: "ABT-737",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "3",
    pmids: "26506422,24316551,25749177",
  },
  {
    id: "7521",
    id_polifenol: "6451",
    polifenol: "daidzein",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "1",
    pmids: "15040033",
  },
  {
    id: "7522",
    id_polifenol: "6065",
    polifenol: "baicalein",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "6",
    pmids: "12481414,28915595,10600514,29155449,7954360,23140288",
  },
  {
    id: "7523",
    id_polifenol: "7",
    polifenol: "Capsaicin",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "6",
    pmids: "24419059,22530568,25963558,19002586,21647434,28089829",
  },
  {
    id: "7524",
    id_polifenol: "4634",
    polifenol: "alvocidib",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "1",
    pmids: "29370702",
  },
  {
    id: "7525",
    id_polifenol: "123",
    polifenol: "Rutin",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "4",
    pmids: "27935659,28930257,28122160,28029227",
  },
  {
    id: "7526",
    id_polifenol: "39",
    polifenol: "Hydrolyzable Tannins",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "2",
    pmids: "9252680,15462182",
  },
  {
    id: "7527",
    id_polifenol: "130",
    polifenol: "Proanthocyanidins",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "7",
    pmids: "22905202,26277505,25652374,28930257,22902508,28122160,28029227",
  },
  {
    id: "7528",
    id_polifenol: "35",
    polifenol: "Hydroquinones",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "3",
    pmids: "21156818,15240547,22984577",
  },
  {
    id: "7529",
    id_polifenol: "111",
    polifenol: "Flavanones",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "1",
    pmids: "28914822",
  },
  {
    id: "7530",
    id_polifenol: "4502",
    polifenol: "fisetin",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "2",
    pmids: "19670328,29848706",
  },
  {
    id: "7531",
    id_polifenol: "25",
    polifenol: "Butylated Hydroxytoluene",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "1",
    pmids: "23453831",
  },
  {
    id: "7532",
    id_polifenol: "75",
    polifenol: "Butylated Hydroxyanisole",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "1",
    pmids: "11768272",
  },
  {
    id: "7533",
    id_polifenol: "15",
    polifenol: "Masoprocol",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "2",
    pmids: "12481414,12110314",
  },
  {
    id: "7534",
    id_polifenol: "4515",
    polifenol: "baicalin",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "1",
    pmids: "7954360",
  },
  {
    id: "7535",
    id_polifenol: "4500",
    polifenol: "procyanidin",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "1",
    pmids: "24325191",
  },
  {
    id: "7536",
    id_polifenol: "5608",
    polifenol: "epicatechin gallate",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "3",
    pmids: "21241417,10624710,27251159",
  },
  {
    id: "7537",
    id_polifenol: "98",
    polifenol: "Propofol",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "1",
    pmids: "27986626",
  },
  {
    id: "7538",
    id_polifenol: "44",
    polifenol: "Salicylates",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "2",
    pmids: "29942156,10210643",
  },
  {
    id: "7539",
    id_polifenol: "4559",
    polifenol: "theaflavin",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "1",
    pmids: "10624710",
  },
  {
    id: "7540",
    id_polifenol: "2344",
    polifenol: "methyl gallate",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "1",
    pmids: "24798568",
  },
  {
    id: "7541",
    id_polifenol: "4708",
    polifenol: "xanthohumol",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "3",
    pmids: "26211581,29121426,25887885",
  },
  {
    id: "7542",
    id_polifenol: "2284",
    polifenol: "rosmarinic acid",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "1",
    pmids: "28222613",
  },
  {
    id: "7543",
    id_polifenol: "2158",
    polifenol: "protocatechuic acid",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "1",
    pmids: "28122160",
  },
  {
    id: "7544",
    id_polifenol: "93",
    polifenol: "Phloroglucinol",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "1",
    pmids: "24041234",
  },
  {
    id: "7545",
    id_polifenol: "7550",
    polifenol: "3-methylquercetin",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "1",
    pmids: "24573487",
  },
  {
    id: "7546",
    id_polifenol: "1611",
    polifenol: "bis(4-hydroxycinnamoyl)methane",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "1",
    pmids: "27845899",
  },
  {
    id: "7547",
    id_polifenol: "107",
    polifenol: "beta-Naphthoflavone",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "1",
    pmids: "26845133",
  },
  {
    id: "7548",
    id_polifenol: "69",
    polifenol: "Phenolsulfonphthalein",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "1",
    pmids: "10198257",
  },
  {
    id: "7549",
    id_polifenol: "126",
    polifenol: "Coumestrol",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "1",
    pmids: "10424789",
  },
  {
    id: "7550",
    id_polifenol: "55",
    polifenol: "Sodium Salicylate",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "1",
    pmids: "10210643",
  },
  {
    id: "7551",
    id_polifenol: "5844",
    polifenol: "4-dimethylamino-3',4'-dimethoxychalcone",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "1",
    pmids: "12794752",
  },
  {
    id: "7552",
    id_polifenol: "4537",
    polifenol: "flavone acetic acid",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "1",
    pmids: "3546183",
  },
  {
    id: "7553",
    id_polifenol: "2773",
    polifenol: "farnesylthiosalicylic acid",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "1",
    pmids: "24204197",
  },
  {
    id: "7554",
    id_polifenol: "132",
    polifenol: "Equol",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "1",
    pmids: "10424789",
  },
  {
    id: "7555",
    id_polifenol: "1995",
    polifenol: "2-tert-butylhydroquinone",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "2",
    pmids: "27750041,23108405",
  },
  {
    id: "7556",
    id_polifenol: "5614",
    polifenol: "catechin gallate",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "2",
    pmids: "21241417,22497997",
  },
  {
    id: "7557",
    id_polifenol: "1996",
    polifenol: "2,5-di-tert-butylhydroquinone",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "1",
    pmids: "25540678",
  },
  {
    id: "7558",
    id_polifenol: "7547",
    polifenol: "hyperoside",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "1",
    pmids: "27459118",
  },
  {
    id: "7559",
    id_polifenol: "7141",
    polifenol: "apigetrin",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "1",
    pmids: "28222613",
  },
  {
    id: "7560",
    id_polifenol: "1810",
    polifenol: "heminordihydroguaiaretic acid",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "1",
    pmids: "10600514",
  },
  {
    id: "7561",
    id_polifenol: "19",
    polifenol: "Pentachlorophenol",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "1",
    pmids: "28962326",
  },
  {
    id: "7562",
    id_polifenol: "7853",
    polifenol: "Grape Seed Proanthocyanidins",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "2",
    pmids: "24325191,25652374",
  },
  {
    id: "7563",
    id_polifenol: "3019",
    polifenol: "nitroaspirin",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "2",
    pmids: "12438552,23019409",
  },
  {
    id: "7564",
    id_polifenol: "6452",
    polifenol: "chrysoeriol",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "1",
    pmids: "28222613",
  },
  {
    id: "7565",
    id_polifenol: "5794",
    polifenol: "2'-hydroxychalcone",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "1",
    pmids: "20729081",
  },
  {
    id: "7566",
    id_polifenol: "6112",
    polifenol: "alpinetin",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "1",
    pmids: "22246103",
  },
  {
    id: "7567",
    id_polifenol: "9",
    polifenol: "1,2-Dihydroxybenzene-3,5-Disulfonic Acid Disodium Salt",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "2",
    pmids: "16763728,15580305",
  },
  {
    id: "7568",
    id_polifenol: "7199",
    polifenol: "luteolin-7-glucoside",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "1",
    pmids: "28222613",
  },
  {
    id: "7569",
    id_polifenol: "1106",
    polifenol: "1,1-bis(3'-indolyl)-1-(4-hydroxyphenyl)methane",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "1",
    pmids: "28418095",
  },
  {
    id: "7570",
    id_polifenol: "5063",
    polifenol: "4',7-dihydroxy-3'-methoxy-5'-prenylflavanone",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "1",
    pmids: "28914822",
  },
  {
    id: "7571",
    id_polifenol: "3606",
    polifenol:
      "5-(3-methoxy-4-((4-methoxybenzyl)oxy)benzyl)pyrimidine-2,4-diamine",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "2",
    pmids: "23995783,28092668",
  },
  {
    id: "7572",
    id_polifenol: "1811",
    polifenol: "terameprocol",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "1",
    pmids: "24080463",
  },
  {
    id: "7573",
    id_polifenol: "3040",
    polifenol:
      "4-(3-thioxo-3H-1,2-dithiol-5-yl)phenyl 2-((4-(nitrooxy)butanoyl)oxy)benzoate",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "1",
    pmids: "28162289",
  },
  {
    id: "7574",
    id_polifenol: "6492",
    polifenol: "3(2H)-isoflavene",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "1",
    pmids: "21666438",
  },
  {
    id: "7575",
    id_polifenol: "996",
    polifenol: "2,3-difluoro phenol",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "1",
    pmids: "20729081",
  },
  {
    id: "7576",
    id_polifenol: "1262",
    polifenol: "4-dodecylaminophenol",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "1",
    pmids: "22440084",
  },
  {
    id: "7577",
    id_polifenol: "4629",
    polifenol: "5,7,2'-trihydroxyflavone",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "1",
    pmids: "22889981",
  },
  {
    id: "7578",
    id_polifenol: "1161",
    polifenol: "phenyl acetate",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "1",
    pmids: "28353633",
  },
  {
    id: "7579",
    id_polifenol: "2402",
    polifenol: "digalloylresveratrol",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "2",
    pmids: "23943154,22132974",
  },
  {
    id: "7580",
    id_polifenol: "7179",
    polifenol: "swertisin",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "1",
    pmids: "23453831",
  },
  {
    id: "7581",
    id_polifenol: "1736",
    polifenol: "4-ethylguaiacol",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "1",
    pmids: "28353633",
  },
  {
    id: "7582",
    id_polifenol: "5800",
    polifenol: "chalcone epoxide",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "1",
    pmids: "20726006",
  },
  {
    id: "7583",
    id_polifenol: "1527",
    polifenol:
      "3-(4-chlorophenyl)adamantane-1-carboxylic acid 3,4-dihydroxybenzylamide",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "1",
    pmids: "20473784",
  },
  {
    id: "7584",
    id_polifenol: "6881",
    polifenol: "triphendiol",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "1",
    pmids: "21666438",
  },
  {
    id: "7585",
    id_polifenol: "4602",
    polifenol: "sigmoidin B",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "1",
    pmids: "28914822",
  },
  {
    id: "7586",
    id_polifenol: "4120",
    polifenol: "STA-12-8666",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "1",
    pmids: "27779106",
  },
  {
    id: "7587",
    id_polifenol: "3939",
    polifenol: "IC 261",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "1",
    pmids: "18203806",
  },
  {
    id: "7588",
    id_polifenol: "4997",
    polifenol: "kaempferol 3-O-(2''-O-glucosyl)rutinoside",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "1",
    pmids: "23453831",
  },
  {
    id: "7589",
    id_polifenol: "6768",
    polifenol:
      "chrysoeriol 7-O-(2'''-O-caffeoyl-beta-D-glucopyranosyl-(1-2)-beta-d-glucopyranoside)",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "1",
    pmids: "28222613",
  },
  {
    id: "7590",
    id_polifenol: "2297",
    polifenol: "3'-O-beta-D-glucopyranosyl rosmarinic acid",
    id_cancer: "20423",
    cancer: "Carcinoma, Pancreatic Ductal",
    quant: "1",
    pmids: "28222613",
  },
  {
    id: "7591",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "25",
    pmids:
      "19326946,20397191,18331776,21104029,28694750,19358271,18440233,20626003,15996021,20633549,27365992,28528091,15386368,10050869,25887417,18097594,9163681,21515353,26351625,21121257,11827069,29607788,26998077,12216075,19573959",
  },
  {
    id: "7592",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "26",
    pmids:
      "23726918,29369461,22253518,17201164,27936114,20395211,22484638,16507392,15160995,23936796,23162792,28027539,20668306,17330230,23233214,7812955,18437538,7954412,19359593,19058955,23266210,9973206,8681447,22194218,8635149,12543061",
  },
  {
    id: "7593",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "28",
    pmids:
      "15907368,17415784,19000662,18652887,27314273,23351413,22744336,25196850,25005957,18949374,27936114,17145898,24456610,29156563,14743383,23174518,16554116,28323438,15942655,20482276,21515353,17330230,11504910,15574782,17893236,19690770,19934341,8697942",
  },
  {
    id: "7594",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "13",
    pmids:
      "18041768,22454661,15081869,18479896,15805288,16904205,16911524,11585739,16009452,20446247,17505812,20464547,11675405",
  },
  {
    id: "7595",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "16",
    pmids:
      "26352862,9848511,17468512,20395211,17615260,11583294,17601486,21958026,10424789,9288778,7884554,12668277,11880592,10760831,15498380,16118406",
  },
  {
    id: "7596",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "10",
    pmids:
      "18331776,21104029,20395211,29156563,28528091,21515353,26351625,8681447,20628003,16118406",
  },
  {
    id: "7597",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "13",
    pmids:
      "15907368,22253518,20518072,10974202,20395211,22769244,17145898,14743383,15386368,12840218,11206275,17893236,29732447",
  },
  {
    id: "7598",
    id_polifenol: "2167",
    polifenol: "phenolic acid",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "6",
    pmids: "27365992,16554116,21515353,7812955,14640548,21121257",
  },
  {
    id: "7599",
    id_polifenol: "49",
    polifenol: "Aspirin",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "27",
    pmids:
      "18805632,16865277,16267095,22209714,19534809,23019409,18751381,9163851,10493497,22122360,12044784,21182493,15570007,11180079,14743889,27554763,11494020,10601615,8353834,16266236,29135091,16175586,24932579,26464196,24605249,9823297,22896036",
  },
  {
    id: "7600",
    id_polifenol: "109",
    polifenol: "Catechin",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "7",
    pmids: "19147768,16536584,25196850,10974202,15145696,17893236,11921198",
  },
  {
    id: "7601",
    id_polifenol: "125",
    polifenol: "Isoflavones",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "8",
    pmids:
      "26352862,9848511,18440233,21958026,12668277,11880592,18936203,19573959",
  },
  {
    id: "7602",
    id_polifenol: "110",
    polifenol: "Chalcones",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "5",
    pmids: "22634834,26497688,28694750,18440233,11853176",
  },
  {
    id: "7603",
    id_polifenol: "3089",
    polifenol: "1,1-diphenyl-2-picrylhydrazyl",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "5",
    pmids: "24658418,23351413,23174518,15160995,19418352",
  },
  {
    id: "7604",
    id_polifenol: "114",
    polifenol: "Apigenin",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "9",
    pmids:
      "18331776,20395211,24067903,21515353,23898082,28526810,9829537,11827069,16118406",
  },
  {
    id: "7605",
    id_polifenol: "113",
    polifenol: "Flavones",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "6",
    pmids: "20397191,18331776,19358271,24067903,21121257,3778803",
  },
  {
    id: "7606",
    id_polifenol: "38",
    polifenol: "Gallic Acid",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "6",
    pmids: "10587295,26514503,27365992,18445658,16707268,14640548",
  },
  {
    id: "7607",
    id_polifenol: "117",
    polifenol: "Luteolin",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "1",
    pmids: "18331776",
  },
  {
    id: "7608",
    id_polifenol: "1",
    polifenol: "Phenols",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "3",
    pmids: "24658418,3083823,14640548",
  },
  {
    id: "7609",
    id_polifenol: "105",
    polifenol: "Anthocyanins",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "2",
    pmids: "27314273,23199305",
  },
  {
    id: "7610",
    id_polifenol: "7235",
    polifenol: "silybin",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "6",
    pmids: "21273642,23599778,18006855,19047104,16637061,18701508",
  },
  {
    id: "7611",
    id_polifenol: "129",
    polifenol: "Rotenone",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "3",
    pmids: "18998398,26085046,10424789",
  },
  {
    id: "7612",
    id_polifenol: "121",
    polifenol: "Kaempferols",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "4",
    pmids: "18331776,28528091,21515353,16118406",
  },
  {
    id: "7613",
    id_polifenol: "871",
    polifenol: "ABT-737",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "1",
    pmids: "24739394",
  },
  {
    id: "7614",
    id_polifenol: "6451",
    polifenol: "daidzein",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "2",
    pmids: "9848511,16118406",
  },
  {
    id: "7615",
    id_polifenol: "6065",
    polifenol: "baicalein",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "1",
    pmids: "20395211",
  },
  {
    id: "7616",
    id_polifenol: "120",
    polifenol: "Flavonols",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "5",
    pmids: "18331776,21512242,18440233,18097594,20628003",
  },
  {
    id: "7617",
    id_polifenol: "4522",
    polifenol: "chrysin",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "2",
    pmids: "18331776,21515353",
  },
  {
    id: "7618",
    id_polifenol: "123",
    polifenol: "Rutin",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "1",
    pmids: "8741796",
  },
  {
    id: "7619",
    id_polifenol: "6062",
    polifenol: "naringenin",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "2",
    pmids: "27538012,16118406",
  },
  {
    id: "7620",
    id_polifenol: "39",
    polifenol: "Hydrolyzable Tannins",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "2",
    pmids: "25887417,29607788",
  },
  {
    id: "7621",
    id_polifenol: "35",
    polifenol: "Hydroquinones",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "1",
    pmids: "23333614",
  },
  {
    id: "7622",
    id_polifenol: "111",
    polifenol: "Flavanones",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "2",
    pmids: "24843190,21121257",
  },
  {
    id: "7623",
    id_polifenol: "6",
    polifenol: "Catechols",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "3",
    pmids: "23777606,6284766,8330359",
  },
  {
    id: "7624",
    id_polifenol: "25",
    polifenol: "Butylated Hydroxytoluene",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "1",
    pmids: "19359593",
  },
  {
    id: "7625",
    id_polifenol: "15",
    polifenol: "Masoprocol",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "4",
    pmids: "20668019,18610748,20023240,8760145",
  },
  {
    id: "7626",
    id_polifenol: "4519",
    polifenol: "myricetin",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "3",
    pmids: "19326946,18331776,28528091",
  },
  {
    id: "7627",
    id_polifenol: "4515",
    polifenol: "baicalin",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "1",
    pmids: "25195133",
  },
  {
    id: "7628",
    id_polifenol: "4500",
    polifenol: "procyanidin",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "2",
    pmids: "16820885,19418352",
  },
  {
    id: "7629",
    id_polifenol: "1356",
    polifenol: "gingerol",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "1",
    pmids: "25813697",
  },
  {
    id: "7630",
    id_polifenol: "98",
    polifenol: "Propofol",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "1",
    pmids: "24596379",
  },
  {
    id: "7631",
    id_polifenol: "5607",
    polifenol: "gallocatechol",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "1",
    pmids: "25196850",
  },
  {
    id: "7632",
    id_polifenol: "4559",
    polifenol: "theaflavin",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "1",
    pmids: "14743383",
  },
  {
    id: "7633",
    id_polifenol: "5808",
    polifenol: "isoliquiritigenin",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "1",
    pmids: "11853176",
  },
  {
    id: "7634",
    id_polifenol: "2344",
    polifenol: "methyl gallate",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "1",
    pmids: "16707268",
  },
  {
    id: "7635",
    id_polifenol: "4708",
    polifenol: "xanthohumol",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "1",
    pmids: "22952060",
  },
  {
    id: "7636",
    id_polifenol: "2284",
    polifenol: "rosmarinic acid",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "1",
    pmids: "20449663",
  },
  {
    id: "7637",
    id_polifenol: "112",
    polifenol: "Hesperidin",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "1",
    pmids: "9163681",
  },
  {
    id: "7638",
    id_polifenol: "4513",
    polifenol: "galangin",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "1",
    pmids: "21515353",
  },
  {
    id: "7639",
    id_polifenol: "1380",
    polifenol: "shogaol",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "1",
    pmids: "22224671",
  },
  {
    id: "7640",
    id_polifenol: "1613",
    polifenol: "demethoxycurcumin",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "1",
    pmids: "7954412",
  },
  {
    id: "7641",
    id_polifenol: "1611",
    polifenol: "bis(4-hydroxycinnamoyl)methane",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "2",
    pmids: "7954412,12543061",
  },
  {
    id: "7642",
    id_polifenol: "107",
    polifenol: "beta-Naphthoflavone",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "1",
    pmids: "12894530",
  },
  {
    id: "7643",
    id_polifenol: "119",
    polifenol: "Silymarin",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "2",
    pmids: "22709784,12216075",
  },
  {
    id: "7644",
    id_polifenol: "126",
    polifenol: "Coumestrol",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "2",
    pmids: "10424789,16118406",
  },
  {
    id: "7645",
    id_polifenol: "5509",
    polifenol: "cyanidin 3-O-glucoside",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "1",
    pmids: "23199305",
  },
  {
    id: "7646",
    id_polifenol: "5844",
    polifenol: "4-dimethylamino-3',4'-dimethoxychalcone",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "1",
    pmids: "11138460",
  },
  {
    id: "7647",
    id_polifenol: "94",
    polifenol: "Phloretin",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "3",
    pmids: "8297149,133724,8297148",
  },
  {
    id: "7648",
    id_polifenol: "4537",
    polifenol: "flavone acetic acid",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "3",
    pmids: "18097594,3546183,3179187",
  },
  {
    id: "7649",
    id_polifenol: "132",
    polifenol: "Equol",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "2",
    pmids: "10424789,16118406",
  },
  {
    id: "7650",
    id_polifenol: "6482",
    polifenol: "tangeretin",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "1",
    pmids: "10050869",
  },
  {
    id: "7651",
    id_polifenol: "89",
    polifenol: "Vanillic Acid",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "1",
    pmids: "15854801",
  },
  {
    id: "7652",
    id_polifenol: "99",
    polifenol: "Pyrogallol",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "3",
    pmids: "19000662,18652887,18949374",
  },
  {
    id: "7653",
    id_polifenol: "1866",
    polifenol: "4,6-dinitro-o-cresol",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "1",
    pmids: "26452990",
  },
  {
    id: "7654",
    id_polifenol: "60",
    polifenol: "2,4-Dinitrophenol",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "1",
    pmids: "18276104",
  },
  {
    id: "7655",
    id_polifenol: "92",
    polifenol: "Triclosan",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "1",
    pmids: "15358634",
  },
  {
    id: "7656",
    id_polifenol: "6097",
    polifenol: "8-prenylnaringenin",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "1",
    pmids: "20633549",
  },
  {
    id: "7657",
    id_polifenol: "6068",
    polifenol: "pinocembrin",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "1",
    pmids: "21515353",
  },
  {
    id: "7658",
    id_polifenol: "5071",
    polifenol: "icaritin",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "1",
    pmids: "27207661",
  },
  {
    id: "7659",
    id_polifenol: "6625",
    polifenol: "phenoxodiol",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "1",
    pmids: "20518072",
  },
  {
    id: "7660",
    id_polifenol: "6086",
    polifenol: "liquiritigenin",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "1",
    pmids: "27538012",
  },
  {
    id: "7661",
    id_polifenol: "5815",
    polifenol: "dibenzoylmethane",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "1",
    pmids: "19706764",
  },
  {
    id: "7662",
    id_polifenol: "5630",
    polifenol: "polyphenon E",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "6",
    pmids: "19147768,17145898,17484049,28323438,17893236,24501325",
  },
  {
    id: "7663",
    id_polifenol: "637",
    polifenol: "glabridin",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "1",
    pmids: "20626003",
  },
  {
    id: "7664",
    id_polifenol: "6301",
    polifenol: "3-methoxyflavone",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "1",
    pmids: "15081869",
  },
  {
    id: "7665",
    id_polifenol: "1810",
    polifenol: "heminordihydroguaiaretic acid",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "1",
    pmids: "15725809",
  },
  {
    id: "7666",
    id_polifenol: "128",
    polifenol: "Pterocarpans",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "1",
    pmids: "18440233",
  },
  {
    id: "7667",
    id_polifenol: "4501",
    polifenol: "tricin",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "1",
    pmids: "19934339",
  },
  {
    id: "7668",
    id_polifenol: "6066",
    polifenol: "eriodictyol",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "1",
    pmids: "27538012",
  },
  {
    id: "7669",
    id_polifenol: "3019",
    polifenol: "nitroaspirin",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "1",
    pmids: "23019409",
  },
  {
    id: "7670",
    id_polifenol: "4480",
    polifenol: "myricitrin",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "1",
    pmids: "19326946",
  },
  {
    id: "7671",
    id_polifenol: "5794",
    polifenol: "2'-hydroxychalcone",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "1",
    pmids: "28694750",
  },
  {
    id: "7672",
    id_polifenol: "115",
    polifenol: "Diosmin",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "1",
    pmids: "9163681",
  },
  {
    id: "7673",
    id_polifenol: "87",
    polifenol: "Metoclopramide",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "1",
    pmids: "8417832",
  },
  {
    id: "7674",
    id_polifenol: "896",
    polifenol: "polyphenon B",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "1",
    pmids: "17415784",
  },
  {
    id: "7675",
    id_polifenol: "6100",
    polifenol: "pinostrobin",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "1",
    pmids: "27603115",
  },
  {
    id: "7676",
    id_polifenol: "428",
    polifenol: "2,2'-bisphenol F",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "1",
    pmids: "23333614",
  },
  {
    id: "7677",
    id_polifenol: "6497",
    polifenol: "isoflavanone",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "1",
    pmids: "18440233",
  },
  {
    id: "7678",
    id_polifenol: "7895",
    polifenol: "flavokawain A",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "1",
    pmids: "26497688",
  },
  {
    id: "7679",
    id_polifenol: "6549",
    polifenol: "7-hydroxy-2',3',4',5',8-pentamethoxyisoflavan",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "2",
    pmids: "18440233,20626003",
  },
  {
    id: "7680",
    id_polifenol: "1662",
    polifenol: "BDMC-A",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "1",
    pmids: "12543061",
  },
  {
    id: "7681",
    id_polifenol: "5539",
    polifenol: "peonidin 3-glucoside",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "1",
    pmids: "23199305",
  },
  {
    id: "7682",
    id_polifenol: "839",
    polifenol: "5-iodo-3-((3,5-dibromo-4-hydroxyphenyl)methylene)-2-indolinone",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "1",
    pmids: "27670374",
  },
  {
    id: "7683",
    id_polifenol: "6684",
    polifenol: "eupafolin",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "1",
    pmids: "20397191",
  },
  {
    id: "7684",
    id_polifenol: "1629",
    polifenol: "bis-1,7-(2-hydroxyphenyl)-hepta-1,6-diene-3,5-dione",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "1",
    pmids: "12543061",
  },
  {
    id: "7685",
    id_polifenol: "1883",
    polifenol: "2-amino-5-methylphenol",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "1",
    pmids: "11335795",
  },
  {
    id: "7686",
    id_polifenol: "4764",
    polifenol: "tectochrysin",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "1",
    pmids: "21515353",
  },
  {
    id: "7687",
    id_polifenol: "52",
    polifenol: "Diflunisal",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "1",
    pmids: "11764005",
  },
  {
    id: "7688",
    id_polifenol: "2868",
    polifenol: "3-hydroxy-4-prenyl-5-methoxystilbene-2-carboxylic acid",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "1",
    pmids: "27603115",
  },
  {
    id: "7689",
    id_polifenol: "74",
    polifenol: "Anethole Trithione",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "1",
    pmids: "8339252",
  },
  {
    id: "7690",
    id_polifenol: "858",
    polifenol: "2-(3-chloro-4-hydroxyphenyl)-2-(4-hydroxyphenyl)propane",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "1",
    pmids: "24843190",
  },
  {
    id: "7691",
    id_polifenol: "2290",
    polifenol: "lobaric acid",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "1",
    pmids: "29538328",
  },
  {
    id: "7692",
    id_polifenol: "3336",
    polifenol:
      "N-hydroxy-5-ethoxymethyloxy-2-methyl-4-(4-phenoxybenzoyl)aminopentanamide",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "1",
    pmids: "12516105",
  },
  {
    id: "7693",
    id_polifenol: "5500",
    polifenol: "pelargonidin-3-glucoside",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "1",
    pmids: "23199305",
  },
  {
    id: "7694",
    id_polifenol: "1994",
    polifenol: "duroquinol",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "3",
    pmids: "23777606,18610748,23333614",
  },
  {
    id: "7695",
    id_polifenol: "7352",
    polifenol: "3',4',5'-trimethoxyflavonol",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "1",
    pmids: "20628003",
  },
  {
    id: "7696",
    id_polifenol: "7817",
    polifenol: "amorphigenin",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "1",
    pmids: "27978865",
  },
  {
    id: "7697",
    id_polifenol: "521",
    polifenol: "E 7010",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "1",
    pmids: "9654112",
  },
  {
    id: "7698",
    id_polifenol: "6832",
    polifenol: "2'-nitroflavone",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "1",
    pmids: "19358271",
  },
  {
    id: "7699",
    id_polifenol: "1865",
    polifenol: "4-chloro-2-cresol",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "1",
    pmids: "15066902",
  },
  {
    id: "7700",
    id_polifenol: "1505",
    polifenol: "hydroxytyrosyl acetate",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "1",
    pmids: "23452288",
  },
  {
    id: "7701",
    id_polifenol: "1781",
    polifenol: "CA 432",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "1",
    pmids: "22705646",
  },
  {
    id: "7702",
    id_polifenol: "1541",
    polifenol: "3-hydroxybakuchiol",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "1",
    pmids: "23777606",
  },
  {
    id: "7703",
    id_polifenol: "3623",
    polifenol: "1,1-dichloro-2-(4-methoxyphenyl)-3-phenylcyclopropane",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "1",
    pmids: "18367102",
  },
  {
    id: "7704",
    id_polifenol: "1527",
    polifenol:
      "3-(4-chlorophenyl)adamantane-1-carboxylic acid 3,4-dihydroxybenzylamide",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "1",
    pmids: "20473784",
  },
  {
    id: "7705",
    id_polifenol: "2743",
    polifenol: "salicylacyl glucuronide",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "1",
    pmids: "11764005",
  },
  {
    id: "7706",
    id_polifenol: "3559",
    polifenol: "hierridin B",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "1",
    pmids: "27589771",
  },
  {
    id: "7707",
    id_polifenol: "1794",
    polifenol:
      "4-(3-hydroxy-4-methoxyphenyl)-3-(4-hydroxyphenyl)-1-(3,4,5-trimethoxyphenyl)azetidin-2-one",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "1",
    pmids: "22705646",
  },
  {
    id: "7708",
    id_polifenol: "2036",
    polifenol: "1-O-hexyl-2,3,5-trimethylhydroquinone",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "1",
    pmids: "11921198",
  },
  {
    id: "7709",
    id_polifenol: "3384",
    polifenol:
      "7-(2-(2,2-difluoroethoxy)-3,5-di-tert-butylbenzene)-3-methylocta-2,4,6-trienoic acid",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "1",
    pmids: "26554632",
  },
  {
    id: "7710",
    id_polifenol: "2271",
    polifenol: "lobarstin",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "1",
    pmids: "29538328",
  },
  {
    id: "7711",
    id_polifenol: "895",
    polifenol: "4-mercaptophenol",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "1",
    pmids: "24658418",
  },
  {
    id: "7712",
    id_polifenol: "4650",
    polifenol: "dibutyltin 3-hydroxyflavone",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "1",
    pmids: "24658418",
  },
  {
    id: "7713",
    id_polifenol: "6196",
    polifenol: "7-hydroxy-6-methoxyflavanone",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "1",
    pmids: "18440233",
  },
  {
    id: "7714",
    id_polifenol: "6551",
    polifenol: "8-isopentenylnaringenin",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "1",
    pmids: "20633549",
  },
  {
    id: "7715",
    id_polifenol: "4097",
    polifenol:
      "2-(2,4-dihydroxyphenyl)-3-formyl-4-hydroxy-6-methoxy-5-(3-methylbuten-2-yl)benzofuran",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "1",
    pmids: "15579325",
  },
  {
    id: "7716",
    id_polifenol: "2335",
    polifenol: "n-butyl gallate",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "1",
    pmids: "16707268",
  },
  {
    id: "7717",
    id_polifenol: "5458",
    polifenol: "(2R,4R)-2',4'-dihydroxy-5,7-dimethoxyflavan-4-ol",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "1",
    pmids: "21121257",
  },
  {
    id: "7718",
    id_polifenol: "4348",
    polifenol:
      "(2R,3S)-guibourtinidol-3-O-alpha-D-apiofuranosyl-(1-6)-O-beta-D-glucopyranoside",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "1",
    pmids: "27538012",
  },
  {
    id: "7719",
    id_polifenol: "5625",
    polifenol: "fisetinidol-(4alpha-8)catechin 3-gallate",
    id_cancer: "1274",
    cancer: "Adenocarcinoma",
    quant: "1",
    pmids: "27538012",
  },
  {
    id: "7720",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "30",
    pmids:
      "25740014,22507272,24459422,21762691,16427264,15657348,29089232,25304968,23562653,28286420,23613861,23722601,18279803,28173812,23350280,22020376,22245810,23321314,16988947,28930257,24633846,24070601,27616072,28187004,23771516,24902844,24594241,27786308,28122160,28029227",
  },
  {
    id: "7721",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "24",
    pmids:
      "22798207,21229292,15161054,28702620,28145533,21903608,18282757,19501152,24183537,25179440,22886017,22890189,22284765,20525240,26158541,17435663,21704149,24622734,19368804,22222040,25882494,20924967,29495296,20930270",
  },
  {
    id: "7722",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "20",
    pmids:
      "26539626,27064011,27598154,26454217,22259050,23192662,24051122,15478178,28794411,26474288,27374085,26056816,28900743,16085186,21401048,20930270,28965580,25364251,27786308,22254017",
  },
  {
    id: "7723",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "16",
    pmids:
      "15695523,12966153,12439598,12902325,17945434,20798496,18196969,16930595,19223550,22582395,26454217,19077250,18263590,14670183,17080406,27752996",
  },
  {
    id: "7724",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "13",
    pmids:
      "9667736,17905565,22227334,19813266,24205354,19505441,22468231,19540207,16988947,1942938,1668058,19540315,22960751",
  },
  {
    id: "7725",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "7",
    pmids: "28860751,26197788,28914791,17680992,23771516,28122160,18756631",
  },
  {
    id: "7726",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "12",
    pmids:
      "22507272,25452172,21909813,18282757,23192662,16988947,23807168,15272226,15478178,22498172,25364251,17366537",
  },
  {
    id: "7727",
    id_polifenol: "2167",
    polifenol: "phenolic acid",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "9",
    pmids:
      "23722601,17486636,26925328,15272226,28930257,26056816,27786308,28122160,28029227",
  },
  {
    id: "7728",
    id_polifenol: "49",
    polifenol: "Aspirin",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "3",
    pmids: "16388830,12466023,23918470",
  },
  {
    id: "7729",
    id_polifenol: "109",
    polifenol: "Catechin",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "9",
    pmids:
      "21909813,28794411,27374085,28930257,26056816,28900743,23322899,28122160,28029227",
  },
  {
    id: "7730",
    id_polifenol: "125",
    polifenol: "Isoflavones",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "6",
    pmids: "17905565,25661352,22227334,19813266,23587260,26432036",
  },
  {
    id: "7731",
    id_polifenol: "110",
    polifenol: "Chalcones",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "8",
    pmids:
      "27423479,8375934,25743216,24494068,25201534,3021829,18379052,28371315",
  },
  {
    id: "7732",
    id_polifenol: "3089",
    polifenol: "1,1-diphenyl-2-picrylhydrazyl",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "3",
    pmids: "26925328,25250850,25364251",
  },
  {
    id: "7733",
    id_polifenol: "114",
    polifenol: "Apigenin",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "9",
    pmids:
      "15657348,25304968,19695221,23562653,15336944,23317647,16988947,27616072,23941992",
  },
  {
    id: "7734",
    id_polifenol: "38",
    polifenol: "Gallic Acid",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "4",
    pmids: "27598154,28930257,28122160,28029227",
  },
  {
    id: "7735",
    id_polifenol: "117",
    polifenol: "Luteolin",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "3",
    pmids: "21762691,24831243,26056816",
  },
  {
    id: "7736",
    id_polifenol: "1",
    polifenol: "Phenols",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "2",
    pmids: "28875231,6788955",
  },
  {
    id: "7737",
    id_polifenol: "105",
    polifenol: "Anthocyanins",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "2",
    pmids: "28173812,23828497",
  },
  {
    id: "7738",
    id_polifenol: "7235",
    polifenol: "silybin",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "2",
    pmids: "22717697,23548635",
  },
  {
    id: "7739",
    id_polifenol: "129",
    polifenol: "Rotenone",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "6",
    pmids: "17671207,9186779,21352099,28244639,22319455,23874855",
  },
  {
    id: "7740",
    id_polifenol: "871",
    polifenol: "ABT-737",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "7",
    pmids: "23341456,24556687,19556859,25756510,22006676,19893570,26874859",
  },
  {
    id: "7741",
    id_polifenol: "6451",
    polifenol: "daidzein",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "2",
    pmids: "17905565,26432036",
  },
  {
    id: "7742",
    id_polifenol: "6065",
    polifenol: "baicalein",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "1",
    pmids: "25447764",
  },
  {
    id: "7743",
    id_polifenol: "7",
    polifenol: "Capsaicin",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "3",
    pmids: "12086397,15272226,18991268",
  },
  {
    id: "7744",
    id_polifenol: "4634",
    polifenol: "alvocidib",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "3",
    pmids: "12115498,15623656,18473913",
  },
  {
    id: "7745",
    id_polifenol: "123",
    polifenol: "Rutin",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "5",
    pmids: "24459422,28930257,28408800,28122160,28029227",
  },
  {
    id: "7746",
    id_polifenol: "6062",
    polifenol: "naringenin",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "2",
    pmids: "22459762,29411263",
  },
  {
    id: "7747",
    id_polifenol: "285",
    polifenol: "bisphenol A",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "5",
    pmids: "27366082,19956873,25966062,19361625,21256730",
  },
  {
    id: "7748",
    id_polifenol: "39",
    polifenol: "Hydrolyzable Tannins",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "2",
    pmids: "23350280,29621196",
  },
  {
    id: "7749",
    id_polifenol: "130",
    polifenol: "Proanthocyanidins",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "4",
    pmids: "28930257,29621196,28122160,28029227",
  },
  {
    id: "7750",
    id_polifenol: "111",
    polifenol: "Flavanones",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "3",
    pmids: "28286420,25201534,29411263",
  },
  {
    id: "7751",
    id_polifenol: "4502",
    polifenol: "fisetin",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "2",
    pmids: "18279803,25364251",
  },
  {
    id: "7752",
    id_polifenol: "6",
    polifenol: "Catechols",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "3",
    pmids: "6788955,18499097,6771000",
  },
  {
    id: "7753",
    id_polifenol: "25",
    polifenol: "Butylated Hydroxytoluene",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "1",
    pmids: "6634722",
  },
  {
    id: "7754",
    id_polifenol: "75",
    polifenol: "Butylated Hydroxyanisole",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "1",
    pmids: "6634722",
  },
  {
    id: "7755",
    id_polifenol: "15",
    polifenol: "Masoprocol",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "2",
    pmids: "17486636,16465258",
  },
  {
    id: "7756",
    id_polifenol: "6087",
    polifenol: "wogonin",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "1",
    pmids: "25740014",
  },
  {
    id: "7757",
    id_polifenol: "5607",
    polifenol: "gallocatechol",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "3",
    pmids: "23192662,16988947,17366537",
  },
  {
    id: "7758",
    id_polifenol: "44",
    polifenol: "Salicylates",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "2",
    pmids: "26093909,7480156",
  },
  {
    id: "7759",
    id_polifenol: "4708",
    polifenol: "xanthohumol",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "1",
    pmids: "24070601",
  },
  {
    id: "7760",
    id_polifenol: "2284",
    polifenol: "rosmarinic acid",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "2",
    pmids: "29932202,23414442",
  },
  {
    id: "7761",
    id_polifenol: "6455",
    polifenol: "nobiletin",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "2",
    pmids: "18282757,23321314",
  },
  {
    id: "7762",
    id_polifenol: "1380",
    polifenol: "shogaol",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "1",
    pmids: "21598039",
  },
  {
    id: "7763",
    id_polifenol: "2158",
    polifenol: "protocatechuic acid",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "1",
    pmids: "28122160",
  },
  {
    id: "7764",
    id_polifenol: "6454",
    polifenol: "formononetin",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "1",
    pmids: "22633834",
  },
  {
    id: "7765",
    id_polifenol: "81",
    polifenol: "Fenofibrate",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "1",
    pmids: "25839662",
  },
  {
    id: "7766",
    id_polifenol: "7550",
    polifenol: "3-methylquercetin",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "1",
    pmids: "26056816",
  },
  {
    id: "7767",
    id_polifenol: "6461",
    polifenol: "acacetin",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "1",
    pmids: "29089232",
  },
  {
    id: "7768",
    id_polifenol: "5806",
    polifenol: "butein",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "1",
    pmids: "22245810",
  },
  {
    id: "7769",
    id_polifenol: "1558",
    polifenol: "capsazepine",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "2",
    pmids: "17855475,26482371",
  },
  {
    id: "7770",
    id_polifenol: "5819",
    polifenol: "licochalcone A",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "1",
    pmids: "28970010",
  },
  {
    id: "7771",
    id_polifenol: "94",
    polifenol: "Phloretin",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "2",
    pmids: "27158628,33341",
  },
  {
    id: "7772",
    id_polifenol: "48",
    polifenol: "Anacardic Acids",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "1",
    pmids: "28647884",
  },
  {
    id: "7773",
    id_polifenol: "2773",
    polifenol: "farnesylthiosalicylic acid",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "2",
    pmids: "19998334,15958613",
  },
  {
    id: "7774",
    id_polifenol: "6482",
    polifenol: "tangeretin",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "1",
    pmids: "18282757",
  },
  {
    id: "7775",
    id_polifenol: "99",
    polifenol: "Pyrogallol",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "2",
    pmids: "15795449,2353937",
  },
  {
    id: "7776",
    id_polifenol: "100",
    polifenol: "Resorcinols",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "1",
    pmids: "24494068",
  },
  {
    id: "7777",
    id_polifenol: "60",
    polifenol: "2,4-Dinitrophenol",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "1",
    pmids: "9186779",
  },
  {
    id: "7778",
    id_polifenol: "300",
    polifenol: "rhodioloside",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "1",
    pmids: "26563497",
  },
  {
    id: "7779",
    id_polifenol: "350",
    polifenol: "nonylphenol",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "1",
    pmids: "27366082",
  },
  {
    id: "7780",
    id_polifenol: "4767",
    polifenol: "flavan-3-ol",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "1",
    pmids: "29621196",
  },
  {
    id: "7781",
    id_polifenol: "6097",
    polifenol: "8-prenylnaringenin",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "1",
    pmids: "24070601",
  },
  {
    id: "7782",
    id_polifenol: "6068",
    polifenol: "pinocembrin",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "1",
    pmids: "28084593",
  },
  {
    id: "7783",
    id_polifenol: "6625",
    polifenol: "phenoxodiol",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "2",
    pmids: "28408225,26432036",
  },
  {
    id: "7784",
    id_polifenol: "5815",
    polifenol: "dibenzoylmethane",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "1",
    pmids: "21704149",
  },
  {
    id: "7785",
    id_polifenol: "5630",
    polifenol: "polyphenon E",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "1",
    pmids: "23322899",
  },
  {
    id: "7786",
    id_polifenol: "637",
    polifenol: "glabridin",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "1",
    pmids: "28970010",
  },
  {
    id: "7787",
    id_polifenol: "6301",
    polifenol: "3-methoxyflavone",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "1",
    pmids: "12966153",
  },
  {
    id: "7788",
    id_polifenol: "4501",
    polifenol: "tricin",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "1",
    pmids: "22085682",
  },
  {
    id: "7789",
    id_polifenol: "4304",
    polifenol: "5-7-oxo-zeaenol",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "1",
    pmids: "23700229",
  },
  {
    id: "7790",
    id_polifenol: "3019",
    polifenol: "nitroaspirin",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "1",
    pmids: "23918470",
  },
  {
    id: "7791",
    id_polifenol: "713",
    polifenol:
      "3-(3-chloro-4-hydroxyphenylamino)-4-(4-nitrophenyl)-1H-pyrrole-2,5-dione",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "2",
    pmids: "18624766,21161565",
  },
  {
    id: "7792",
    id_polifenol: "87",
    polifenol: "Metoclopramide",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "1",
    pmids: "1969134",
  },
  {
    id: "7793",
    id_polifenol: "2014",
    polifenol: "erbstatin",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "1",
    pmids: "1668058",
  },
  {
    id: "7794",
    id_polifenol: "6800",
    polifenol: "3,6-dimethoxy-6'',6''-dimethylchromeno(2'',3''-7,8)flavone",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "1",
    pmids: "25839662",
  },
  {
    id: "7795",
    id_polifenol: "6693",
    polifenol: "2',4',7-trihydroxyisoflavone",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "1",
    pmids: "17905565",
  },
  {
    id: "7796",
    id_polifenol: "896",
    polifenol: "polyphenon B",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "1",
    pmids: "23322899",
  },
  {
    id: "7797",
    id_polifenol: "2331",
    polifenol: "8-(N,N-diethylamino)octyl-3,4,5-trimethoxybenzoate",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "1",
    pmids: "7598686",
  },
  {
    id: "7798",
    id_polifenol: "84",
    polifenol: "Halogenated Diphenyl Ethers",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "1",
    pmids: "25784559",
  },
  {
    id: "7799",
    id_polifenol: "6166",
    polifenol: "liquiritin",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "1",
    pmids: "28970010",
  },
  {
    id: "7800",
    id_polifenol: "7880",
    polifenol: "xanthoangelol",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "1",
    pmids: "18379052",
  },
  {
    id: "7801",
    id_polifenol: "3386",
    polifenol: "2,2',4,4'-tetrabromodiphenyl ether",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "1",
    pmids: "25784559",
  },
  {
    id: "7802",
    id_polifenol: "4548",
    polifenol: "artemetin",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "1",
    pmids: "24633846",
  },
  {
    id: "7803",
    id_polifenol: "3040",
    polifenol:
      "4-(3-thioxo-3H-1,2-dithiol-5-yl)phenyl 2-((4-(nitrooxy)butanoyl)oxy)benzoate",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "1",
    pmids: "23918470",
  },
  {
    id: "7804",
    id_polifenol: "2159",
    polifenol: "2,3-dihydroxybenzoic acid",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "1",
    pmids: "2720651",
  },
  {
    id: "7805",
    id_polifenol: "6492",
    polifenol: "3(2H)-isoflavene",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "2",
    pmids: "28408225,26432036",
  },
  {
    id: "7806",
    id_polifenol: "3299",
    polifenol: "pentabromodiphenyl ether",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "1",
    pmids: "25784559",
  },
  {
    id: "7807",
    id_polifenol: "1364",
    polifenol: "4-methylcatechol",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "2",
    pmids: "6788955,18499097",
  },
  {
    id: "7808",
    id_polifenol: "2474",
    polifenol: "vescalagin",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "1",
    pmids: "29928967",
  },
  {
    id: "7809",
    id_polifenol: "1262",
    polifenol: "4-dodecylaminophenol",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "2",
    pmids: "28927789,20580487",
  },
  {
    id: "7810",
    id_polifenol: "7888",
    polifenol: "neoisoliquiritin",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "1",
    pmids: "28970010",
  },
  {
    id: "7811",
    id_polifenol: "6460",
    polifenol: "ipriflavone",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "1",
    pmids: "24084576",
  },
  {
    id: "7812",
    id_polifenol: "1796",
    polifenol: "(10)-shogaol",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "1",
    pmids: "21598039",
  },
  {
    id: "7813",
    id_polifenol: "1372",
    polifenol: "3-methylcatechol",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "2",
    pmids: "6788955,18499097",
  },
  {
    id: "7814",
    id_polifenol: "5284",
    polifenol: "didymin",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "1",
    pmids: "28187004",
  },
  {
    id: "7815",
    id_polifenol: "2607",
    polifenol: "amorfrutin A",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "1",
    pmids: "29369787",
  },
  {
    id: "7816",
    id_polifenol: "6789",
    polifenol:
      "5,7-dihydroxy-3-(3-hydroxy-4-methoxybenzyl)-6-methoxychroman-4-one",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "1",
    pmids: "23587260",
  },
  {
    id: "7817",
    id_polifenol: "475",
    polifenol: "tolcapone",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "1",
    pmids: "28429453",
  },
  {
    id: "7818",
    id_polifenol: "171",
    polifenol: "p-decylaminophenol",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "1",
    pmids: "28927789",
  },
  {
    id: "7819",
    id_polifenol: "6992",
    polifenol:
      "2-(cis-1,2-dihydroxy 4-oxo-cyclohex-5-enyl)-5,7-dihydroxychromone",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "1",
    pmids: "22020376",
  },
  {
    id: "7820",
    id_polifenol: "1559",
    polifenol: "N-(4-O-glycerol-3-methoxybenzyl)nonivamide",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "1",
    pmids: "17855475",
  },
  {
    id: "7821",
    id_polifenol: "1378",
    polifenol: "tert-butylcatechol",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "1",
    pmids: "18499097",
  },
  {
    id: "7822",
    id_polifenol: "2251",
    polifenol: "3,4-dihydroxybenzoate",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "1",
    pmids: "22944173",
  },
  {
    id: "7823",
    id_polifenol: "7006",
    polifenol:
      "3-(2,3-dihydroxy-4-methoxyphenyl)-8-(3,7-dimethylocta-2,6-dienyl)-5,7-dihydroxy-2,3-dihydrochromen-4-one",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "1",
    pmids: "29411263",
  },
  {
    id: "7824",
    id_polifenol: "95",
    polifenol: "Polyphloretin Phosphate",
    id_cancer: "612",
    cancer: "Neuroblastoma",
    quant: "1",
    pmids: "33341",
  },
  {
    id: "7825",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "32",
    pmids:
      "23266503,22263786,25119583,18078968,20564475,21805050,16497434,25618603,23066961,29257319,23708932,27860196,16213662,20038829,17202857,23760674,23645467,28965117,24971999,24125835,24233155,27600294,26189300,18097692,27999608,27056897,28539711,28201973,24311870,26434118,27696106,23564766",
  },
  {
    id: "7826",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "23",
    pmids:
      "23959480,22521131,24229684,22201757,21443800,19730790,24247158,22009832,27231954,29966255,22205968,23356739,29303982,19137819,29237458,29187453,26005346,29623828,21839055,26987435,24380633,24453488,28031891",
  },
  {
    id: "7827",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "7",
    pmids: "16797629,26499783,22743590,18097692,21878663,29475441,17848746",
  },
  {
    id: "7828",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "18",
    pmids:
      "16814113,25869769,29305928,24805814,12439598,29410403,20080742,20589721,29345412,19496172,12883736,18481201,12082091,24536031,19661304,28904859,21508279,22282250",
  },
  {
    id: "7829",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "13",
    pmids:
      "22263786,18078968,20038829,25586304,16491457,18955141,12680249,17266178,28125641,23013480,10533460,24690154,23951199",
  },
  {
    id: "7830",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "8",
    pmids:
      "18078968,21805050,28965117,18955141,28539711,26434118,18302187,23564766",
  },
  {
    id: "7831",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "8",
    pmids:
      "26499783,25510179,16756080,24190483,29475441,15643507,26748399,22641358",
  },
  {
    id: "7832",
    id_polifenol: "2167",
    polifenol: "phenolic acid",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "6",
    pmids: "27158383,28356015,22521131,21443800,22634840,27999608",
  },
  {
    id: "7833",
    id_polifenol: "49",
    polifenol: "Aspirin",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "3",
    pmids: "26202947,12576442,7691402",
  },
  {
    id: "7834",
    id_polifenol: "109",
    polifenol: "Catechin",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "1",
    pmids: "29800908",
  },
  {
    id: "7835",
    id_polifenol: "125",
    polifenol: "Isoflavones",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "8",
    pmids:
      "25170541,29305928,18822283,18606492,25973307,28125641,23013480,24690154",
  },
  {
    id: "7836",
    id_polifenol: "110",
    polifenol: "Chalcones",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "3",
    pmids: "23764122,26141763,26294168",
  },
  {
    id: "7837",
    id_polifenol: "3089",
    polifenol: "1,1-diphenyl-2-picrylhydrazyl",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "3",
    pmids: "23645467,24125835,27999608",
  },
  {
    id: "7838",
    id_polifenol: "114",
    polifenol: "Apigenin",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "2",
    pmids: "23066961,26035210",
  },
  {
    id: "7839",
    id_polifenol: "113",
    polifenol: "Flavones",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "3",
    pmids: "29845278,28379900,21573491",
  },
  {
    id: "7840",
    id_polifenol: "38",
    polifenol: "Gallic Acid",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "3",
    pmids: "22849560,12127233,22387266",
  },
  {
    id: "7841",
    id_polifenol: "117",
    polifenol: "Luteolin",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "3",
    pmids: "12127233,24971999,28539711",
  },
  {
    id: "7842",
    id_polifenol: "1",
    polifenol: "Phenols",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "3",
    pmids: "28728976,28356015,23645467",
  },
  {
    id: "7843",
    id_polifenol: "105",
    polifenol: "Anthocyanins",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "2",
    pmids: "29451351,22992992",
  },
  {
    id: "7844",
    id_polifenol: "7235",
    polifenol: "silybin",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "2",
    pmids: "29068478,24233155",
  },
  {
    id: "7845",
    id_polifenol: "129",
    polifenol: "Rotenone",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "5",
    pmids: "25586304,17239409,25973307,11331019,15561720",
  },
  {
    id: "7846",
    id_polifenol: "121",
    polifenol: "Kaempferols",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "3",
    pmids: "20564475,23708932,28539711",
  },
  {
    id: "7847",
    id_polifenol: "871",
    polifenol: "ABT-737",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "1",
    pmids: "28849162",
  },
  {
    id: "7848",
    id_polifenol: "6451",
    polifenol: "daidzein",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "3",
    pmids: "26178389,16491457,17266178",
  },
  {
    id: "7849",
    id_polifenol: "6065",
    polifenol: "baicalein",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "7",
    pmids: "23266503,29845278,16497434,25618603,29156780,24846187,25744840",
  },
  {
    id: "7850",
    id_polifenol: "7",
    polifenol: "Capsaicin",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "4",
    pmids: "29048662,24142063,27446273,24005536",
  },
  {
    id: "7851",
    id_polifenol: "4634",
    polifenol: "alvocidib",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "4",
    pmids: "16982772,15069542,17520676,29805751",
  },
  {
    id: "7852",
    id_polifenol: "120",
    polifenol: "Flavonols",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "1",
    pmids: "24125835",
  },
  {
    id: "7853",
    id_polifenol: "4522",
    polifenol: "chrysin",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "2",
    pmids: "23760674,27696106",
  },
  {
    id: "7854",
    id_polifenol: "123",
    polifenol: "Rutin",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "1",
    pmids: "28539711",
  },
  {
    id: "7855",
    id_polifenol: "6062",
    polifenol: "naringenin",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "1",
    pmids: "11800169",
  },
  {
    id: "7856",
    id_polifenol: "285",
    polifenol: "bisphenol A",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "2",
    pmids: "11800169,10854714",
  },
  {
    id: "7857",
    id_polifenol: "111",
    polifenol: "Flavanones",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "2",
    pmids: "24734951,10854714",
  },
  {
    id: "7858",
    id_polifenol: "4502",
    polifenol: "fisetin",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "2",
    pmids: "16213662,29270805",
  },
  {
    id: "7859",
    id_polifenol: "6087",
    polifenol: "wogonin",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "4",
    pmids: "16497434,21573491,23219337,28606135",
  },
  {
    id: "7860",
    id_polifenol: "4519",
    polifenol: "myricetin",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "2",
    pmids: "15982670,29663365",
  },
  {
    id: "7861",
    id_polifenol: "4515",
    polifenol: "baicalin",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "2",
    pmids: "16497434,28379900",
  },
  {
    id: "7862",
    id_polifenol: "1356",
    polifenol: "gingerol",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "2",
    pmids: "25330949,25923459",
  },
  {
    id: "7863",
    id_polifenol: "98",
    polifenol: "Propofol",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "4",
    pmids: "27097968,24762226,12127688,29940605",
  },
  {
    id: "7864",
    id_polifenol: "2344",
    polifenol: "methyl gallate",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "1",
    pmids: "26707422",
  },
  {
    id: "7865",
    id_polifenol: "112",
    polifenol: "Hesperidin",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "2",
    pmids: "18097692,28539711",
  },
  {
    id: "7866",
    id_polifenol: "6455",
    polifenol: "nobiletin",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "1",
    pmids: "27144433",
  },
  {
    id: "7867",
    id_polifenol: "4513",
    polifenol: "galangin",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "1",
    pmids: "27840963",
  },
  {
    id: "7868",
    id_polifenol: "2158",
    polifenol: "protocatechuic acid",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "1",
    pmids: "16213662",
  },
  {
    id: "7869",
    id_polifenol: "5489",
    polifenol: "delphinidin",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "1",
    pmids: "29451351",
  },
  {
    id: "7870",
    id_polifenol: "93",
    polifenol: "Phloroglucinol",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "1",
    pmids: "27243922",
  },
  {
    id: "7871",
    id_polifenol: "6454",
    polifenol: "formononetin",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "4",
    pmids: "26381132,25170541,17135037,26916669",
  },
  {
    id: "7872",
    id_polifenol: "7550",
    polifenol: "3-methylquercetin",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "1",
    pmids: "28539711",
  },
  {
    id: "7873",
    id_polifenol: "6461",
    polifenol: "acacetin",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "2",
    pmids: "21573491,28539711",
  },
  {
    id: "7874",
    id_polifenol: "4253",
    polifenol:
      "5-(2,4-dihydroxy-5-isopropylphenyl)-4-(4-morpholin-4-ylmethylphenyl)isoxazole-3-carboxylic acid ethylamide",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "1",
    pmids: "23538447",
  },
  {
    id: "7875",
    id_polifenol: "126",
    polifenol: "Coumestrol",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "1",
    pmids: "16491457",
  },
  {
    id: "7876",
    id_polifenol: "5806",
    polifenol: "butein",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "1",
    pmids: "16213662",
  },
  {
    id: "7877",
    id_polifenol: "1558",
    polifenol: "capsazepine",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "2",
    pmids: "28560396,16243435",
  },
  {
    id: "7878",
    id_polifenol: "94",
    polifenol: "Phloretin",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "1",
    pmids: "25310823",
  },
  {
    id: "7879",
    id_polifenol: "4560",
    polifenol: "icariin",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "2",
    pmids: "25747987,29425587",
  },
  {
    id: "7880",
    id_polifenol: "4537",
    polifenol: "flavone acetic acid",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "3",
    pmids: "3546183,2370185,3422592",
  },
  {
    id: "7881",
    id_polifenol: "80",
    polifenol: "Clofibrate",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "1",
    pmids: "1403680",
  },
  {
    id: "7882",
    id_polifenol: "1673",
    polifenol: "4-hydroxyestradiol",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "1",
    pmids: "17014383",
  },
  {
    id: "7883",
    id_polifenol: "7546",
    polifenol: "isoquercitrin",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "1",
    pmids: "28539711",
  },
  {
    id: "7884",
    id_polifenol: "1644",
    polifenol: "Cur1 compound",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "2",
    pmids: "24247158,19137819",
  },
  {
    id: "7885",
    id_polifenol: "1866",
    polifenol: "4,6-dinitro-o-cresol",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "1",
    pmids: "29088714",
  },
  {
    id: "7886",
    id_polifenol: "7541",
    polifenol: "taxifolin",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "1",
    pmids: "29257319",
  },
  {
    id: "7887",
    id_polifenol: "7544",
    polifenol: "quercitrin",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "1",
    pmids: "28539711",
  },
  {
    id: "7888",
    id_polifenol: "300",
    polifenol: "rhodioloside",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "1",
    pmids: "24583784",
  },
  {
    id: "7889",
    id_polifenol: "350",
    polifenol: "nonylphenol",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "2",
    pmids: "11800169,10854714",
  },
  {
    id: "7890",
    id_polifenol: "5071",
    polifenol: "icaritin",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "1",
    pmids: "29425587",
  },
  {
    id: "7891",
    id_polifenol: "4585",
    polifenol: "baohuoside I",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "5",
    pmids: "25119583,28621234,29425587,27056897,17980359",
  },
  {
    id: "7892",
    id_polifenol: "1616",
    polifenol: "tetrahydrocurcumin",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "1",
    pmids: "29207631",
  },
  {
    id: "7893",
    id_polifenol: "7134",
    polifenol: "vitexin",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "1",
    pmids: "17202857",
  },
  {
    id: "7894",
    id_polifenol: "6558",
    polifenol: "7,3'-dihydroxy-4'-methoxyisoflavone",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "3",
    pmids: "25170541,24797937,29966979",
  },
  {
    id: "7895",
    id_polifenol: "4525",
    polifenol: "eupatilin",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "1",
    pmids: "26622880",
  },
  {
    id: "7896",
    id_polifenol: "4883",
    polifenol: "flavokawain B",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "1",
    pmids: "23764122",
  },
  {
    id: "7897",
    id_polifenol: "6066",
    polifenol: "eriodictyol",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "1",
    pmids: "28539711",
  },
  {
    id: "7898",
    id_polifenol: "4521",
    polifenol: "3-hydroxyflavone",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "1",
    pmids: "27600294",
  },
  {
    id: "7899",
    id_polifenol: "2014",
    polifenol: "erbstatin",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "1",
    pmids: "25190293",
  },
  {
    id: "7900",
    id_polifenol: "6554",
    polifenol: "tectorigenin",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "1",
    pmids: "26991068",
  },
  {
    id: "7901",
    id_polifenol: "4715",
    polifenol: "ampelopsin",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "1",
    pmids: "26189300",
  },
  {
    id: "7902",
    id_polifenol: "2450",
    polifenol: "Geraniin",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "1",
    pmids: "28704237",
  },
  {
    id: "7903",
    id_polifenol: "6129",
    polifenol: "wogonoside",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "1",
    pmids: "25755693",
  },
  {
    id: "7904",
    id_polifenol: "6175",
    polifenol: "2'-hydroxyflavanone",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "1",
    pmids: "24734951",
  },
  {
    id: "7905",
    id_polifenol: "711",
    polifenol: "ascochlorin",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "1",
    pmids: "19253369",
  },
  {
    id: "7906",
    id_polifenol: "2343",
    polifenol: "ethyl gallate",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "1",
    pmids: "12127233",
  },
  {
    id: "7907",
    id_polifenol: "704",
    polifenol: "trizol",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "1",
    pmids: "22843292",
  },
  {
    id: "7908",
    id_polifenol: "6774",
    polifenol: "5,7-dihydroxy-6,3',4'-trimethoxyflavone",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "1",
    pmids: "26622880",
  },
  {
    id: "7909",
    id_polifenol: "7453",
    polifenol: "kaempferol-3-O-glucoside",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "1",
    pmids: "28539711",
  },
  {
    id: "7910",
    id_polifenol: "1678",
    polifenol: "2-methoxyestrone",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "1",
    pmids: "11856647",
  },
  {
    id: "7911",
    id_polifenol: "4553",
    polifenol: "sulfuretin",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "1",
    pmids: "16213662",
  },
  {
    id: "7912",
    id_polifenol: "7880",
    polifenol: "xanthoangelol",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "1",
    pmids: "26141763",
  },
  {
    id: "7913",
    id_polifenol: "4632",
    polifenol: "ginkgetin",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "1",
    pmids: "26573608",
  },
  {
    id: "7914",
    id_polifenol: "792",
    polifenol: "octylphenol",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "1",
    pmids: "10854714",
  },
  {
    id: "7915",
    id_polifenol: "529",
    polifenol: "4-octylphenol",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "1",
    pmids: "11800169",
  },
  {
    id: "7916",
    id_polifenol: "7427",
    polifenol: "kaempferol 3-O-rhamnoside",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "1",
    pmids: "28539711",
  },
  {
    id: "7917",
    id_polifenol: "2484",
    polifenol: "chebulinic acid",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "1",
    pmids: "12127233",
  },
  {
    id: "7918",
    id_polifenol: "7879",
    polifenol: "4-hydroxyderricin",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "1",
    pmids: "26141763",
  },
  {
    id: "7919",
    id_polifenol: "6291",
    polifenol: "alpinumisoflavone",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "1",
    pmids: "22079771",
  },
  {
    id: "7920",
    id_polifenol: "4103",
    polifenol: "gnetin H",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "1",
    pmids: "25862967",
  },
  {
    id: "7921",
    id_polifenol: "2332",
    polifenol: "lauryl gallate",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "1",
    pmids: "26707422",
  },
  {
    id: "7922",
    id_polifenol: "3908",
    polifenol: "aspidin BB",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "1",
    pmids: "26181229",
  },
  {
    id: "7923",
    id_polifenol: "696",
    polifenol: "2,2-bis(4-hydroxyphenyl)-1,1,1-trichloroethane",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "2",
    pmids: "11800169,10854714",
  },
  {
    id: "7924",
    id_polifenol: "5143",
    polifenol: "fustin",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "1",
    pmids: "16213662",
  },
  {
    id: "7925",
    id_polifenol: "355",
    polifenol: "4-hydroxy-5-nitrophenyl acetic acid",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "1",
    pmids: "20432232",
  },
  {
    id: "7926",
    id_polifenol: "7180",
    polifenol: "apigenin-8-C-beta-D-glucopyranoside",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "1",
    pmids: "17202857",
  },
  {
    id: "7927",
    id_polifenol: "6349",
    polifenol: "ME-344",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "1",
    pmids: "25973307",
  },
  {
    id: "7928",
    id_polifenol: "3409",
    polifenol: "dihydroptychantol A",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "1",
    pmids: "21185854",
  },
  {
    id: "7929",
    id_polifenol: "7642",
    polifenol: "quercetin-4'-O-beta-D-galactoside",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "1",
    pmids: "28539711",
  },
  {
    id: "7930",
    id_polifenol: "1879",
    polifenol: "2-nitro-4-cresol",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "1",
    pmids: "28728976",
  },
  {
    id: "7931",
    id_polifenol: "6839",
    polifenol:
      "3',4'-dichloro-3-(3,4-dichlorophenylacetyl)-2,4,6-trihydroxydeoxybenzoin",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "1",
    pmids: "18822283",
  },
  {
    id: "7932",
    id_polifenol: "5212",
    polifenol: "icarisid B",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "1",
    pmids: "28621234",
  },
  {
    id: "7933",
    id_polifenol: "6837",
    polifenol: "7-hydroxy-3',4'-benzoisoflavone",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "1",
    pmids: "18606492",
  },
  {
    id: "7934",
    id_polifenol: "7484",
    polifenol: "3-O-kaempferol 4-O-(galloyl)-beta-D-glucoside",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "1",
    pmids: "28539711",
  },
  {
    id: "7935",
    id_polifenol: "4564",
    polifenol: "abyssinone V",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "1",
    pmids: "22079771",
  },
  {
    id: "7936",
    id_polifenol: "1167",
    polifenol: "NSC668394",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "1",
    pmids: "21706056",
  },
  {
    id: "7937",
    id_polifenol: "7685",
    polifenol: "quercetin 7-O-6''-(E-caffeoyl)-beta-D-glucopyranoside",
    id_cancer: "593",
    cancer: "Osteosarcoma",
    quant: "1",
    pmids: "24583784",
  },
  {
    id: "7938",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "599",
    cancer: "Brain Tumor",
    quant: "24",
    pmids:
      "17876051,28858735,28560001,19894226,15213223,22949836,29886836,28286420,15163544,27125297,16914050,25481090,26471408,27468969,16619521,26454746,26474590,20467782,26573275,20730632,29747239,27171480,8482562,12699068",
  },
  {
    id: "7939",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "599",
    cancer: "Brain Tumor",
    quant: "52",
    pmids:
      "21775121,21501498,16102725,23192708,25542408,27878252,23846485,22910273,16646663,25792385,16777101,20411591,26364505,17562168,21138870,25542083,17596214,22890189,20615395,20332461,29340361,28627598,27819521,29588587,21989768,21859497,21193839,26763536,24793792,19368804,21492457,28160777,25489242,22944718,26942057,29088758,29346317,24851881,24142484,25202424,22192169,25462134,28848349,21847493,29359011,28472690,27699139,21915101,23891772,24975030,24961640,26066035",
  },
  {
    id: "7940",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "599",
    cancer: "Brain Tumor",
    quant: "16",
    pmids:
      "23955573,11305413,27951496,21138870,29522834,14769133,22259050,21481687,22426504,14587030,21989768,19496785,29346317,19225784,29359011,27781151",
  },
  {
    id: "7941",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "599",
    cancer: "Brain Tumor",
    quant: "7",
    pmids: "23232806,9458349,22582395,19737348,12134900,21029458,12485835",
  },
  {
    id: "7942",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "599",
    cancer: "Brain Tumor",
    quant: "13",
    pmids:
      "19894226,20309614,22736505,16598420,20730632,11023825,17304503,20177775,28877739,8971836,15833874,21553345,21758003",
  },
  {
    id: "7943",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "599",
    cancer: "Brain Tumor",
    quant: "9",
    pmids:
      "17643826,25481090,27468969,16619521,26454746,19244381,19496785,29030990,8482562",
  },
  {
    id: "7944",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "599",
    cancer: "Brain Tumor",
    quant: "9",
    pmids:
      "19894226,11305413,16715350,14769133,14587030,28112361,18267120,24855377,17366537",
  },
  {
    id: "7945",
    id_polifenol: "49",
    polifenol: "Aspirin",
    id_cancer: "599",
    cancer: "Brain Tumor",
    quant: "1",
    pmids: "15481559",
  },
  {
    id: "7946",
    id_polifenol: "109",
    polifenol: "Catechin",
    id_cancer: "599",
    cancer: "Brain Tumor",
    quant: "3",
    pmids: "15992376,29306210,22506983",
  },
  {
    id: "7947",
    id_polifenol: "125",
    polifenol: "Isoflavones",
    id_cancer: "599",
    cancer: "Brain Tumor",
    quant: "6",
    pmids: "20309614,22736505,16598420,17304503,20177775,21758003",
  },
  {
    id: "7948",
    id_polifenol: "110",
    polifenol: "Chalcones",
    id_cancer: "599",
    cancer: "Brain Tumor",
    quant: "2",
    pmids: "22713877,24961640",
  },
  {
    id: "7949",
    id_polifenol: "114",
    polifenol: "Apigenin",
    id_cancer: "599",
    cancer: "Brain Tumor",
    quant: "3",
    pmids: "19894226,15213223,27468969",
  },
  {
    id: "7950",
    id_polifenol: "113",
    polifenol: "Flavones",
    id_cancer: "599",
    cancer: "Brain Tumor",
    quant: "1",
    pmids: "20698539",
  },
  {
    id: "7951",
    id_polifenol: "38",
    polifenol: "Gallic Acid",
    id_cancer: "599",
    cancer: "Brain Tumor",
    quant: "2",
    pmids: "20553913,25646699",
  },
  {
    id: "7952",
    id_polifenol: "117",
    polifenol: "Luteolin",
    id_cancer: "599",
    cancer: "Brain Tumor",
    quant: "3",
    pmids: "26471408,24831243,26573275",
  },
  {
    id: "7953",
    id_polifenol: "1",
    polifenol: "Phenols",
    id_cancer: "599",
    cancer: "Brain Tumor",
    quant: "1",
    pmids: "29306210",
  },
  {
    id: "7954",
    id_polifenol: "105",
    polifenol: "Anthocyanins",
    id_cancer: "599",
    cancer: "Brain Tumor",
    quant: "2",
    pmids: "26187071,23828497",
  },
  {
    id: "7955",
    id_polifenol: "7235",
    polifenol: "silybin",
    id_cancer: "599",
    cancer: "Brain Tumor",
    quant: "3",
    pmids: "26471408,26573275,25750273",
  },
  {
    id: "7956",
    id_polifenol: "129",
    polifenol: "Rotenone",
    id_cancer: "599",
    cancer: "Brain Tumor",
    quant: "6",
    pmids: "19633536,22745676,19737348,26297045,28877739,2734366",
  },
  {
    id: "7957",
    id_polifenol: "121",
    polifenol: "Kaempferols",
    id_cancer: "599",
    cancer: "Brain Tumor",
    quant: "2",
    pmids: "17876051,19244381",
  },
  {
    id: "7958",
    id_polifenol: "871",
    polifenol: "ABT-737",
    id_cancer: "599",
    cancer: "Brain Tumor",
    quant: "6",
    pmids: "21880625,22249262,26585571,27779684,25762636,23861345",
  },
  {
    id: "7959",
    id_polifenol: "6451",
    polifenol: "daidzein",
    id_cancer: "599",
    cancer: "Brain Tumor",
    quant: "3",
    pmids: "20309614,17304503,28877739",
  },
  {
    id: "7960",
    id_polifenol: "6065",
    polifenol: "baicalein",
    id_cancer: "599",
    cancer: "Brain Tumor",
    quant: "2",
    pmids: "25968345,20656985",
  },
  {
    id: "7961",
    id_polifenol: "7",
    polifenol: "Capsaicin",
    id_cancer: "599",
    cancer: "Brain Tumor",
    quant: "2",
    pmids: "27748914,16583263",
  },
  {
    id: "7962",
    id_polifenol: "4634",
    polifenol: "alvocidib",
    id_cancer: "599",
    cancer: "Brain Tumor",
    quant: "2",
    pmids: "21885916,27171480",
  },
  {
    id: "7963",
    id_polifenol: "120",
    polifenol: "Flavonols",
    id_cancer: "599",
    cancer: "Brain Tumor",
    quant: "1",
    pmids: "19244381",
  },
  {
    id: "7964",
    id_polifenol: "123",
    polifenol: "Rutin",
    id_cancer: "599",
    cancer: "Brain Tumor",
    quant: "1",
    pmids: "25785932",
  },
  {
    id: "7965",
    id_polifenol: "6062",
    polifenol: "naringenin",
    id_cancer: "599",
    cancer: "Brain Tumor",
    quant: "2",
    pmids: "15163544,27468969",
  },
  {
    id: "7966",
    id_polifenol: "130",
    polifenol: "Proanthocyanidins",
    id_cancer: "599",
    cancer: "Brain Tumor",
    quant: "1",
    pmids: "27388765",
  },
  {
    id: "7967",
    id_polifenol: "111",
    polifenol: "Flavanones",
    id_cancer: "599",
    cancer: "Brain Tumor",
    quant: "2",
    pmids: "28286420,15163544",
  },
  {
    id: "7968",
    id_polifenol: "25",
    polifenol: "Butylated Hydroxytoluene",
    id_cancer: "599",
    cancer: "Brain Tumor",
    quant: "1",
    pmids: "22139074",
  },
  {
    id: "7969",
    id_polifenol: "6087",
    polifenol: "wogonin",
    id_cancer: "599",
    cancer: "Brain Tumor",
    quant: "3",
    pmids: "22949836,23872260,20467782",
  },
  {
    id: "7970",
    id_polifenol: "4519",
    polifenol: "myricetin",
    id_cancer: "599",
    cancer: "Brain Tumor",
    quant: "2",
    pmids: "29886836,19244381",
  },
  {
    id: "7971",
    id_polifenol: "4515",
    polifenol: "baicalin",
    id_cancer: "599",
    cancer: "Brain Tumor",
    quant: "1",
    pmids: "9764846",
  },
  {
    id: "7972",
    id_polifenol: "5608",
    polifenol: "epicatechin gallate",
    id_cancer: "599",
    cancer: "Brain Tumor",
    quant: "1",
    pmids: "29346317",
  },
  {
    id: "7973",
    id_polifenol: "5607",
    polifenol: "gallocatechol",
    id_cancer: "599",
    cancer: "Brain Tumor",
    quant: "2",
    pmids: "19894226,17366537",
  },
  {
    id: "7974",
    id_polifenol: "4708",
    polifenol: "xanthohumol",
    id_cancer: "599",
    cancer: "Brain Tumor",
    quant: "1",
    pmids: "29747239",
  },
  {
    id: "7975",
    id_polifenol: "47",
    polifenol: "Mesalamine",
    id_cancer: "599",
    cancer: "Brain Tumor",
    quant: "1",
    pmids: "19457125",
  },
  {
    id: "7976",
    id_polifenol: "6063",
    polifenol: "naringin",
    id_cancer: "599",
    cancer: "Brain Tumor",
    quant: "2",
    pmids: "27125297,26474590",
  },
  {
    id: "7977",
    id_polifenol: "1380",
    polifenol: "shogaol",
    id_cancer: "599",
    cancer: "Brain Tumor",
    quant: "1",
    pmids: "20656985",
  },
  {
    id: "7978",
    id_polifenol: "5489",
    polifenol: "delphinidin",
    id_cancer: "599",
    cancer: "Brain Tumor",
    quant: "1",
    pmids: "26187071",
  },
  {
    id: "7979",
    id_polifenol: "81",
    polifenol: "Fenofibrate",
    id_cancer: "599",
    cancer: "Brain Tumor",
    quant: "3",
    pmids: "20569465,21081159,19801103",
  },
  {
    id: "7980",
    id_polifenol: "4253",
    polifenol:
      "5-(2,4-dihydroxy-5-isopropylphenyl)-4-(4-morpholin-4-ylmethylphenyl)isoxazole-3-carboxylic acid ethylamide",
    id_cancer: "599",
    cancer: "Brain Tumor",
    quant: "1",
    pmids: "28424411",
  },
  {
    id: "7981",
    id_polifenol: "107",
    polifenol: "beta-Naphthoflavone",
    id_cancer: "599",
    cancer: "Brain Tumor",
    quant: "1",
    pmids: "22975028",
  },
  {
    id: "7982",
    id_polifenol: "5844",
    polifenol: "4-dimethylamino-3',4'-dimethoxychalcone",
    id_cancer: "599",
    cancer: "Brain Tumor",
    quant: "2",
    pmids: "19633536,15313191",
  },
  {
    id: "7983",
    id_polifenol: "5819",
    polifenol: "licochalcone A",
    id_cancer: "599",
    cancer: "Brain Tumor",
    quant: "1",
    pmids: "28593138",
  },
  {
    id: "7984",
    id_polifenol: "4560",
    polifenol: "icariin",
    id_cancer: "599",
    cancer: "Brain Tumor",
    quant: "1",
    pmids: "27188746",
  },
  {
    id: "7985",
    id_polifenol: "48",
    polifenol: "Anacardic Acids",
    id_cancer: "599",
    cancer: "Brain Tumor",
    quant: "1",
    pmids: "21275565",
  },
  {
    id: "7986",
    id_polifenol: "2773",
    polifenol: "farnesylthiosalicylic acid",
    id_cancer: "599",
    cancer: "Brain Tumor",
    quant: "2",
    pmids: "22323550,19072665",
  },
  {
    id: "7987",
    id_polifenol: "1995",
    polifenol: "2-tert-butylhydroquinone",
    id_cancer: "599",
    cancer: "Brain Tumor",
    quant: "1",
    pmids: "14502842",
  },
  {
    id: "7988",
    id_polifenol: "452",
    polifenol: "acteoside",
    id_cancer: "599",
    cancer: "Brain Tumor",
    quant: "1",
    pmids: "26743778",
  },
  {
    id: "7989",
    id_polifenol: "1644",
    polifenol: "Cur1 compound",
    id_cancer: "599",
    cancer: "Brain Tumor",
    quant: "1",
    pmids: "28848349",
  },
  {
    id: "7990",
    id_polifenol: "7541",
    polifenol: "taxifolin",
    id_cancer: "599",
    cancer: "Brain Tumor",
    quant: "1",
    pmids: "15163544",
  },
  {
    id: "7991",
    id_polifenol: "60",
    polifenol: "2,4-Dinitrophenol",
    id_cancer: "599",
    cancer: "Brain Tumor",
    quant: "1",
    pmids: "3468375",
  },
  {
    id: "7992",
    id_polifenol: "1996",
    polifenol: "2,5-di-tert-butylhydroquinone",
    id_cancer: "599",
    cancer: "Brain Tumor",
    quant: "1",
    pmids: "25106108",
  },
  {
    id: "7993",
    id_polifenol: "4585",
    polifenol: "baohuoside I",
    id_cancer: "599",
    cancer: "Brain Tumor",
    quant: "1",
    pmids: "28560001",
  },
  {
    id: "7994",
    id_polifenol: "6086",
    polifenol: "liquiritigenin",
    id_cancer: "599",
    cancer: "Brain Tumor",
    quant: "1",
    pmids: "25351348",
  },
  {
    id: "7995",
    id_polifenol: "59",
    polifenol: "Dinitrophenols",
    id_cancer: "599",
    cancer: "Brain Tumor",
    quant: "1",
    pmids: "3468375",
  },
  {
    id: "7996",
    id_polifenol: "7134",
    polifenol: "vitexin",
    id_cancer: "599",
    cancer: "Brain Tumor",
    quant: "1",
    pmids: "29328424",
  },
  {
    id: "7997",
    id_polifenol: "5630",
    polifenol: "polyphenon E",
    id_cancer: "599",
    cancer: "Brain Tumor",
    quant: "1",
    pmids: "22506983",
  },
  {
    id: "7998",
    id_polifenol: "19",
    polifenol: "Pentachlorophenol",
    id_cancer: "599",
    cancer: "Brain Tumor",
    quant: "1",
    pmids: "16007644",
  },
  {
    id: "7999",
    id_polifenol: "6477",
    polifenol: "hispidulin",
    id_cancer: "599",
    cancer: "Brain Tumor",
    quant: "1",
    pmids: "20698539",
  },
  {
    id: "8000",
    id_polifenol: "6510",
    polifenol: "glycitein",
    id_cancer: "599",
    cancer: "Brain Tumor",
    quant: "2",
    pmids: "20309614,17304503",
  },
  {
    id: "8001",
    id_polifenol: "6175",
    polifenol: "2'-hydroxyflavanone",
    id_cancer: "599",
    cancer: "Brain Tumor",
    quant: "1",
    pmids: "15163544",
  },
  {
    id: "8002",
    id_polifenol: "711",
    polifenol: "ascochlorin",
    id_cancer: "599",
    cancer: "Brain Tumor",
    quant: "1",
    pmids: "28569433",
  },
  {
    id: "8003",
    id_polifenol: "4052",
    polifenol: "bis-(3-(3',5'-di-tert-butyl-4'-hydroxyphenyl)propyl)sulfide",
    id_cancer: "599",
    cancer: "Brain Tumor",
    quant: "1",
    pmids: "24961640",
  },
  {
    id: "8004",
    id_polifenol: "3494",
    polifenol: "asarone",
    id_cancer: "599",
    cancer: "Brain Tumor",
    quant: "3",
    pmids: "28776671,28380412,26263057",
  },
  {
    id: "8005",
    id_polifenol: "7880",
    polifenol: "xanthoangelol",
    id_cancer: "599",
    cancer: "Brain Tumor",
    quant: "1",
    pmids: "12845685",
  },
  {
    id: "8006",
    id_polifenol: "4632",
    polifenol: "ginkgetin",
    id_cancer: "599",
    cancer: "Brain Tumor",
    quant: "1",
    pmids: "25821199",
  },
  {
    id: "8007",
    id_polifenol: "5245",
    polifenol: "BF6-6 biflavone",
    id_cancer: "599",
    cancer: "Brain Tumor",
    quant: "1",
    pmids: "25821199",
  },
  {
    id: "8008",
    id_polifenol: "5063",
    polifenol: "4',7-dihydroxy-3'-methoxy-5'-prenylflavanone",
    id_cancer: "599",
    cancer: "Brain Tumor",
    quant: "1",
    pmids: "17685631",
  },
  {
    id: "8009",
    id_polifenol: "6633",
    polifenol: "pomiferin",
    id_cancer: "599",
    cancer: "Brain Tumor",
    quant: "1",
    pmids: "23929619",
  },
  {
    id: "8010",
    id_polifenol: "2066",
    polifenol: "NSC 680410",
    id_cancer: "599",
    cancer: "Brain Tumor",
    quant: "1",
    pmids: "12451475",
  },
  {
    id: "8011",
    id_polifenol: "6236",
    polifenol: "nymphaeol C",
    id_cancer: "599",
    cancer: "Brain Tumor",
    quant: "1",
    pmids: "17685631",
  },
  {
    id: "8012",
    id_polifenol: "1932",
    polifenol: "3,5-di-tert-butyl-4-hydroxytoluene",
    id_cancer: "599",
    cancer: "Brain Tumor",
    quant: "1",
    pmids: "22139074",
  },
  {
    id: "8013",
    id_polifenol: "21",
    polifenol: "Bisacodyl",
    id_cancer: "599",
    cancer: "Brain Tumor",
    quant: "3",
    pmids: "26270679,28109792,29930759",
  },
  {
    id: "8014",
    id_polifenol: "1553",
    polifenol: "dihydrocapsaicin",
    id_cancer: "599",
    cancer: "Brain Tumor",
    quant: "1",
    pmids: "27748914",
  },
  {
    id: "8015",
    id_polifenol: "4334",
    polifenol: "acacetin-7-rutinoside",
    id_cancer: "599",
    cancer: "Brain Tumor",
    quant: "1",
    pmids: "28858735",
  },
  {
    id: "8016",
    id_polifenol: "6187",
    polifenol: "propolin G",
    id_cancer: "599",
    cancer: "Brain Tumor",
    quant: "2",
    pmids: "21530633,17685631",
  },
  {
    id: "8017",
    id_polifenol: "1912",
    polifenol: "dihydroxydiphenyl-pyridyl methane",
    id_cancer: "599",
    cancer: "Brain Tumor",
    quant: "2",
    pmids: "26270679,29930759",
  },
  {
    id: "8018",
    id_polifenol: "3468",
    polifenol:
      "5-(2-hydroxybenzylidene)-2-((4-phenoxyphenyl)imino)thiazolidin-4-one",
    id_cancer: "599",
    cancer: "Brain Tumor",
    quant: "1",
    pmids: "23877018",
  },
  {
    id: "8019",
    id_polifenol: "1273",
    polifenol: "Silar (3M)",
    id_cancer: "599",
    cancer: "Brain Tumor",
    quant: "1",
    pmids: "29576738",
  },
  {
    id: "8020",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "26",
    pmids:
      "27038396,22185222,23769983,24269256,15744083,25084411,28693212,23046062,25658812,28962438,9373241,15796199,27023497,26100136,9741302,17218638,26838254,21953709,29513299,16169200,26941541,25378270,18956590,28332451,18465538,17637507",
  },
  {
    id: "8021",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "22",
    pmids:
      "28071969,16129047,29080451,23603894,10527691,22841393,16687078,17182546,17240359,27857884,19053882,21831045,24932681,24613204,21859497,15541495,25860911,20534395,19127081,20924967,18462866,9771944",
  },
  {
    id: "8022",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "15",
    pmids:
      "27038396,11312805,23372833,10227148,24074358,10761539,15781612,21467134,27023497,16158935,16395705,9414176,27028800,26941541,25378270",
  },
  {
    id: "8023",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "7",
    pmids: "12801933,21336837,11390183,19825968,11867691,24514755,20371726",
  },
  {
    id: "8024",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "8",
    pmids: "24269256,18546268,9929743,9373241,14707277,7538048,9650447,7585648",
  },
  {
    id: "8025",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "14",
    pmids:
      "24269256,9929743,10761539,25658812,21138867,28962438,9373241,26328486,16169200,26941541,25378270,7254225,2833358,28481232",
  },
  {
    id: "8026",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "7",
    pmids: "29267216,11312805,10227148,15781612,25925964,24064951,9414176",
  },
  {
    id: "8027",
    id_polifenol: "2167",
    polifenol: "phenolic acid",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "1",
    pmids: "26941541",
  },
  {
    id: "8028",
    id_polifenol: "49",
    polifenol: "Aspirin",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "8",
    pmids:
      "10964107,7534663,22011910,3049673,27553975,22421408,18608871,22104368",
  },
  {
    id: "8029",
    id_polifenol: "109",
    polifenol: "Catechin",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "3",
    pmids: "10227148,24074358,15781612",
  },
  {
    id: "8030",
    id_polifenol: "125",
    polifenol: "Isoflavones",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "1",
    pmids: "18546268",
  },
  {
    id: "8031",
    id_polifenol: "110",
    polifenol: "Chalcones",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "4",
    pmids: "22981919,21396744,16675659,21752198",
  },
  {
    id: "8032",
    id_polifenol: "3089",
    polifenol: "1,1-diphenyl-2-picrylhydrazyl",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "4",
    pmids: "23769983,24074358,16919261,16182479",
  },
  {
    id: "8033",
    id_polifenol: "114",
    polifenol: "Apigenin",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "1",
    pmids: "24895203",
  },
  {
    id: "8034",
    id_polifenol: "113",
    polifenol: "Flavones",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "6",
    pmids: "24269256,29805643,9373241,23481040,24895203,9516149",
  },
  {
    id: "8035",
    id_polifenol: "38",
    polifenol: "Gallic Acid",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "3",
    pmids: "11911262,26941541,25378270",
  },
  {
    id: "8036",
    id_polifenol: "117",
    polifenol: "Luteolin",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "2",
    pmids: "26100136,24895203",
  },
  {
    id: "8037",
    id_polifenol: "1",
    polifenol: "Phenols",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "3",
    pmids: "24074358,11911262,10851475",
  },
  {
    id: "8038",
    id_polifenol: "105",
    polifenol: "Anthocyanins",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "1",
    pmids: "23368921",
  },
  {
    id: "8039",
    id_polifenol: "7235",
    polifenol: "silybin",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "1",
    pmids: "24269256",
  },
  {
    id: "8040",
    id_polifenol: "129",
    polifenol: "Rotenone",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "1",
    pmids: "15796199",
  },
  {
    id: "8041",
    id_polifenol: "121",
    polifenol: "Kaempferols",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "4",
    pmids: "15796199,26100136,16169200,25378270",
  },
  {
    id: "8042",
    id_polifenol: "871",
    polifenol: "ABT-737",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "17",
    pmids:
      "17097560,16951189,21398407,23872707,24809353,22173547,27689327,17200714,18085673,23966420,16023593,19060243,24842334,17692808,23341542,22685289,22814621",
  },
  {
    id: "8043",
    id_polifenol: "6065",
    polifenol: "baicalein",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "2",
    pmids: "28560420,24895203",
  },
  {
    id: "8044",
    id_polifenol: "4634",
    polifenol: "alvocidib",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "8",
    pmids:
      "25623777,9373241,19535344,12533676,9516149,17101070,11426645,18465538",
  },
  {
    id: "8045",
    id_polifenol: "120",
    polifenol: "Flavonols",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "2",
    pmids: "24269256,16169200",
  },
  {
    id: "8046",
    id_polifenol: "4522",
    polifenol: "chrysin",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "3",
    pmids: "29805643,15796199,24895203",
  },
  {
    id: "8047",
    id_polifenol: "123",
    polifenol: "Rutin",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "2",
    pmids: "21953709,8741796",
  },
  {
    id: "8048",
    id_polifenol: "6062",
    polifenol: "naringenin",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "3",
    pmids: "15744083,26100136,26838254",
  },
  {
    id: "8049",
    id_polifenol: "35",
    polifenol: "Hydroquinones",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "1",
    pmids: "29421518",
  },
  {
    id: "8050",
    id_polifenol: "111",
    polifenol: "Flavanones",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "1",
    pmids: "24734951",
  },
  {
    id: "8051",
    id_polifenol: "4502",
    polifenol: "fisetin",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "1",
    pmids: "28962438",
  },
  {
    id: "8052",
    id_polifenol: "75",
    polifenol: "Butylated Hydroxyanisole",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "1",
    pmids: "18546268",
  },
  {
    id: "8053",
    id_polifenol: "6087",
    polifenol: "wogonin",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "3",
    pmids: "22359456,28222771,24895203",
  },
  {
    id: "8054",
    id_polifenol: "4519",
    polifenol: "myricetin",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "2",
    pmids: "28962438,16169200",
  },
  {
    id: "8055",
    id_polifenol: "4515",
    polifenol: "baicalin",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "1",
    pmids: "17007926",
  },
  {
    id: "8056",
    id_polifenol: "5608",
    polifenol: "epicatechin gallate",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "1",
    pmids: "9414176",
  },
  {
    id: "8057",
    id_polifenol: "1356",
    polifenol: "gingerol",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "1",
    pmids: "16709450",
  },
  {
    id: "8058",
    id_polifenol: "5607",
    polifenol: "gallocatechol",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "3",
    pmids: "24074358,15796199,9414176",
  },
  {
    id: "8059",
    id_polifenol: "5578",
    polifenol: "alpha-naphthoflavone",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "1",
    pmids: "10593590",
  },
  {
    id: "8060",
    id_polifenol: "44",
    polifenol: "Salicylates",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "2",
    pmids: "7534663,7480156",
  },
  {
    id: "8061",
    id_polifenol: "4559",
    polifenol: "theaflavin",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "2",
    pmids: "11312805,10227148",
  },
  {
    id: "8062",
    id_polifenol: "5808",
    polifenol: "isoliquiritigenin",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "1",
    pmids: "16675659",
  },
  {
    id: "8063",
    id_polifenol: "4708",
    polifenol: "xanthohumol",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "2",
    pmids: "16144030,19634869",
  },
  {
    id: "8064",
    id_polifenol: "47",
    polifenol: "Mesalamine",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "1",
    pmids: "11587223",
  },
  {
    id: "8065",
    id_polifenol: "112",
    polifenol: "Hesperidin",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "1",
    pmids: "18387509",
  },
  {
    id: "8066",
    id_polifenol: "6455",
    polifenol: "nobiletin",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "1",
    pmids: "27840933",
  },
  {
    id: "8067",
    id_polifenol: "4513",
    polifenol: "galangin",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "1",
    pmids: "16169200",
  },
  {
    id: "8068",
    id_polifenol: "6063",
    polifenol: "naringin",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "1",
    pmids: "15744083",
  },
  {
    id: "8069",
    id_polifenol: "1380",
    polifenol: "shogaol",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "2",
    pmids: "24215632,16709450",
  },
  {
    id: "8070",
    id_polifenol: "6273",
    polifenol: "hesperetin",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "1",
    pmids: "26100136",
  },
  {
    id: "8071",
    id_polifenol: "93",
    polifenol: "Phloroglucinol",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "2",
    pmids: "21998731,18539018",
  },
  {
    id: "8072",
    id_polifenol: "6454",
    polifenol: "formononetin",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "1",
    pmids: "15796199",
  },
  {
    id: "8073",
    id_polifenol: "55",
    polifenol: "Sodium Salicylate",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "2",
    pmids: "11960340,22011910",
  },
  {
    id: "8074",
    id_polifenol: "5806",
    polifenol: "butein",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "1",
    pmids: "23064245",
  },
  {
    id: "8075",
    id_polifenol: "5844",
    polifenol: "4-dimethylamino-3',4'-dimethoxychalcone",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "2",
    pmids: "13677932,12794752",
  },
  {
    id: "8076",
    id_polifenol: "4537",
    polifenol: "flavone acetic acid",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "2",
    pmids: "3665989,3422592",
  },
  {
    id: "8077",
    id_polifenol: "7546",
    polifenol: "isoquercitrin",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "1",
    pmids: "25378270",
  },
  {
    id: "8078",
    id_polifenol: "1644",
    polifenol: "Cur1 compound",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "1",
    pmids: "15541495",
  },
  {
    id: "8079",
    id_polifenol: "7541",
    polifenol: "taxifolin",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "1",
    pmids: "26100136",
  },
  {
    id: "8080",
    id_polifenol: "7912",
    polifenol: "7,9,2',4'-tetrahydroxy-8-isopentenyl-5-methoxychalcone",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "1",
    pmids: "24901249",
  },
  {
    id: "8081",
    id_polifenol: "5071",
    polifenol: "icaritin",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "1",
    pmids: "23550021",
  },
  {
    id: "8082",
    id_polifenol: "59",
    polifenol: "Dinitrophenols",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "2",
    pmids: "6995553,832275",
  },
  {
    id: "8083",
    id_polifenol: "5455",
    polifenol: "theaflavin-3,3'-digallate",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "1",
    pmids: "11312805",
  },
  {
    id: "8084",
    id_polifenol: "5815",
    polifenol: "dibenzoylmethane",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "1",
    pmids: "9771944",
  },
  {
    id: "8085",
    id_polifenol: "637",
    polifenol: "glabridin",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "1",
    pmids: "24901249",
  },
  {
    id: "8086",
    id_polifenol: "6301",
    polifenol: "3-methoxyflavone",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "2",
    pmids: "22185222,23481040",
  },
  {
    id: "8087",
    id_polifenol: "1353",
    polifenol: "protocatechualdehyde",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "2",
    pmids: "15878704,19023807",
  },
  {
    id: "8088",
    id_polifenol: "97",
    polifenol: "Probucol",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "2",
    pmids: "14617690,12893683",
  },
  {
    id: "8089",
    id_polifenol: "6800",
    polifenol: "3,6-dimethoxy-6'',6''-dimethylchromeno(2'',3''-7,8)flavone",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "1",
    pmids: "16919261",
  },
  {
    id: "8090",
    id_polifenol: "6175",
    polifenol: "2'-hydroxyflavanone",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "1",
    pmids: "24734951",
  },
  {
    id: "8091",
    id_polifenol: "5005",
    polifenol: "procyanidin B",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "1",
    pmids: "12837490",
  },
  {
    id: "8092",
    id_polifenol: "704",
    polifenol: "trizol",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "1",
    pmids: "22282239",
  },
  {
    id: "8093",
    id_polifenol: "2331",
    polifenol: "8-(N,N-diethylamino)octyl-3,4,5-trimethoxybenzoate",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "1",
    pmids: "3131117",
  },
  {
    id: "8094",
    id_polifenol: "2364",
    polifenol: "theaflavine gallate",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "1",
    pmids: "11312805",
  },
  {
    id: "8095",
    id_polifenol: "4578",
    polifenol: "5,7-dimethoxyflavone",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "1",
    pmids: "22185222",
  },
  {
    id: "8096",
    id_polifenol: "315",
    polifenol: "bakuchiol",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "1",
    pmids: "28990045",
  },
  {
    id: "8097",
    id_polifenol: "4839",
    polifenol: "7-hydroxyflavone",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "1",
    pmids: "17218638",
  },
  {
    id: "8098",
    id_polifenol: "4639",
    polifenol: "aromadedrin",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "1",
    pmids: "26838254",
  },
  {
    id: "8099",
    id_polifenol: "4549",
    polifenol: "casticin",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "1",
    pmids: "9741302",
  },
  {
    id: "8100",
    id_polifenol: "6687",
    polifenol: "3'-dimethylaminoflavone",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "1",
    pmids: "22185222",
  },
  {
    id: "8101",
    id_polifenol: "1509",
    polifenol: "8-gingerol",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "1",
    pmids: "16709450",
  },
  {
    id: "8102",
    id_polifenol: "7614",
    polifenol: "quercetin 3-O-methyl ether",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "1",
    pmids: "27038396",
  },
  {
    id: "8103",
    id_polifenol: "343",
    polifenol: "2,5-dichloro-4-bromophenol",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "1",
    pmids: "15876794",
  },
  {
    id: "8104",
    id_polifenol: "7149",
    polifenol: "5,7,4'-trimethylapigenin",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "1",
    pmids: "22185222",
  },
  {
    id: "8105",
    id_polifenol: "5963",
    polifenol: "3,5,2',4'-tetrahydroxychalcone",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "1",
    pmids: "23064245",
  },
  {
    id: "8106",
    id_polifenol: "4675",
    polifenol: "3'-methoxy-4'-nitroflavone",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "1",
    pmids: "17823287",
  },
  {
    id: "8107",
    id_polifenol: "2358",
    polifenol: "theaflavin digallate",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "1",
    pmids: "10227148",
  },
  {
    id: "8108",
    id_polifenol: "2066",
    polifenol: "NSC 680410",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "1",
    pmids: "12451475",
  },
  {
    id: "8109",
    id_polifenol: "2334",
    polifenol: "leonurine",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "1",
    pmids: "22326051",
  },
  {
    id: "8110",
    id_polifenol: "5465",
    polifenol: "vitexin-2-O-xyloside",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "1",
    pmids: "27719921",
  },
  {
    id: "8111",
    id_polifenol: "7659",
    polifenol: "quercetin 7-rhamnoside",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "1",
    pmids: "25378270",
  },
  {
    id: "8112",
    id_polifenol: "7817",
    polifenol: "amorphigenin",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "1",
    pmids: "15796199",
  },
  {
    id: "8113",
    id_polifenol: "5802",
    polifenol: "hesperidin methylchalcone",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "1",
    pmids: "18387509",
  },
  {
    id: "8114",
    id_polifenol: "815",
    polifenol: "theasinensin A",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "2",
    pmids: "11312805,10227148",
  },
  {
    id: "8115",
    id_polifenol: "2022",
    polifenol: "1,4-naphthohydroquinone",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "1",
    pmids: "24368029",
  },
  {
    id: "8116",
    id_polifenol: "4053",
    polifenol: "succinobucol",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "1",
    pmids: "14617690",
  },
  {
    id: "8117",
    id_polifenol: "4473",
    polifenol: "robinin",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "1",
    pmids: "15796199",
  },
  {
    id: "8118",
    id_polifenol: "6164",
    polifenol: "euchrestaflavanone B",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "1",
    pmids: "16408697",
  },
  {
    id: "8119",
    id_polifenol: "6686",
    polifenol: "3',5'-dimethoxyflavone",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "1",
    pmids: "22185222",
  },
  {
    id: "8120",
    id_polifenol: "5046",
    polifenol: "4'-methoxyflavone",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "1",
    pmids: "22185222",
  },
  {
    id: "8121",
    id_polifenol: "6380",
    polifenol: "oroxin B",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "1",
    pmids: "26253462",
  },
  {
    id: "8122",
    id_polifenol: "7075",
    polifenol: "3,5,7,3',4'-pentamethoxyflavone",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "1",
    pmids: "22185222",
  },
  {
    id: "8123",
    id_polifenol: "6674",
    polifenol: "5,6,2',3',6'-pentamethoxyflavone",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "1",
    pmids: "22185222",
  },
  {
    id: "8124",
    id_polifenol: "3588",
    polifenol: "niranthin",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "1",
    pmids: "29427163",
  },
  {
    id: "8125",
    id_polifenol: "5116",
    polifenol: "betuletol 3-methyl ether",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "1",
    pmids: "19676104",
  },
  {
    id: "8126",
    id_polifenol: "5276",
    polifenol: "enzogenol",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "1",
    pmids: "24074358",
  },
  {
    id: "8127",
    id_polifenol: "499",
    polifenol: "Sunphenon",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "1",
    pmids: "24074358",
  },
  {
    id: "8128",
    id_polifenol: "2086",
    polifenol: "epoxyquinol A",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "1",
    pmids: "16360644",
  },
  {
    id: "8129",
    id_polifenol: "2983",
    polifenol: "dimethylaminoethyl acetylsalicylate",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "1",
    pmids: "7534663",
  },
  {
    id: "8130",
    id_polifenol: "4612",
    polifenol: "pseudosemiglabrin",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "1",
    pmids: "27553975",
  },
  {
    id: "8131",
    id_polifenol: "3160",
    polifenol: "2,2'-oxybis(4-allyl-1-methoxybenzene)",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "1",
    pmids: "28138251",
  },
  {
    id: "8132",
    id_polifenol: "3121",
    polifenol: "ethyl O-(N-(4-carboxyphenyl)carbamoyl)mycophenolate",
    id_cancer: "577",
    cancer: "Lymphoma",
    quant: "1",
    pmids: "7274650",
  },
  {
    id: "8133",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "9999",
    cancer: "Neoplasm Invasiveness",
    quant: "26",
    pmids:
      "25866363,23940799,20514473,28003763,16458870,20596804,28125432,23677714,11588896,26245494,27530117,22847135,19737984,27600294,27207648,15117815,25285031,15523693,27919958,16645725,2068000,9581517,16097445,8808829,24366437,26397139",
  },
  {
    id: "8134",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "9999",
    cancer: "Neoplasm Invasiveness",
    quant: "18",
    pmids:
      "21627988,15750784,27572503,14642080,28165402,23563640,24531649,21836020,22448259,25628937,27229723,24840628,23489691,16081279,22637745,28417445,26723514,23136625",
  },
  {
    id: "8135",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "9999",
    cancer: "Neoplasm Invasiveness",
    quant: "26",
    pmids:
      "27658723,27572503,23441615,24606444,24338484,24099118,28165402,23228413,17936851,18665171,24851878,26773801,11807163,11500915,17202688,27229723,16081279,20362526,16387739,17696725,16458188,11846837,9710326,23771133,9436857,23242008",
  },
  {
    id: "8136",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "9999",
    cancer: "Neoplasm Invasiveness",
    quant: "22",
    pmids:
      "27829223,18027151,15372629,16458870,14500381,22479527,27840956,21570392,11981761,25555875,18822689,16170669,21147512,10389762,18345028,10912793,14993222,14692651,21671179,19424573,18851783,12688676",
  },
  {
    id: "8137",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "9999",
    cancer: "Neoplasm Invasiveness",
    quant: "10",
    pmids:
      "24433534,16458870,16499663,8598314,15105043,17202688,7812935,10355749,9165017,10544927",
  },
  {
    id: "8138",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "9999",
    cancer: "Neoplasm Invasiveness",
    quant: "9",
    pmids:
      "29026320,16458870,20596804,21306479,17202688,27919958,16645725,16097445,24366437",
  },
  {
    id: "8139",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "9999",
    cancer: "Neoplasm Invasiveness",
    quant: "15",
    pmids:
      "23337910,24606444,24338484,17878996,19139131,21609393,18632202,18665171,17404067,11500915,17202688,16387739,16317158,11846837,18357659",
  },
  {
    id: "8140",
    id_polifenol: "2167",
    polifenol: "phenolic acid",
    id_cancer: "9999",
    cancer: "Neoplasm Invasiveness",
    quant: "5",
    pmids: "23563640,26542239,17404067,24366437,23242008",
  },
  {
    id: "8141",
    id_polifenol: "49",
    polifenol: "Aspirin",
    id_cancer: "9999",
    cancer: "Neoplasm Invasiveness",
    quant: "9",
    pmids:
      "29805582,11981761,10811139,12894587,24418973,15179621,25846752,16991207,29519806",
  },
  {
    id: "8142",
    id_polifenol: "109",
    polifenol: "Catechin",
    id_cancer: "9999",
    cancer: "Neoplasm Invasiveness",
    quant: "5",
    pmids: "23337910,16458870,2068000,15207729,24366437",
  },
  {
    id: "8143",
    id_polifenol: "125",
    polifenol: "Isoflavones",
    id_cancer: "9999",
    cancer: "Neoplasm Invasiveness",
    quant: "3",
    pmids: "15845653,15105043,23136625",
  },
  {
    id: "8144",
    id_polifenol: "110",
    polifenol: "Chalcones",
    id_cancer: "9999",
    cancer: "Neoplasm Invasiveness",
    quant: "1",
    pmids: "26500049",
  },
  {
    id: "8145",
    id_polifenol: "114",
    polifenol: "Apigenin",
    id_cancer: "9999",
    cancer: "Neoplasm Invasiveness",
    quant: "9",
    pmids:
      "20514473,26435478,28125432,11588896,19737984,10389762,15523693,26397139,25351792",
  },
  {
    id: "8146",
    id_polifenol: "113",
    polifenol: "Flavones",
    id_cancer: "9999",
    cancer: "Neoplasm Invasiveness",
    quant: "4",
    pmids: "29026320,28003763,29667279,16097445",
  },
  {
    id: "8147",
    id_polifenol: "38",
    polifenol: "Gallic Acid",
    id_cancer: "9999",
    cancer: "Neoplasm Invasiveness",
    quant: "2",
    pmids: "24099118,20553913",
  },
  {
    id: "8148",
    id_polifenol: "117",
    polifenol: "Luteolin",
    id_cancer: "9999",
    cancer: "Neoplasm Invasiveness",
    quant: "6",
    pmids: "28003763,16458870,23677714,19139131,27919958,16097445",
  },
  {
    id: "8149",
    id_polifenol: "105",
    polifenol: "Anthocyanins",
    id_cancer: "9999",
    cancer: "Neoplasm Invasiveness",
    quant: "3",
    pmids: "25000305,22659736,21165577",
  },
  {
    id: "8150",
    id_polifenol: "7235",
    polifenol: "silybin",
    id_cancer: "9999",
    cancer: "Neoplasm Invasiveness",
    quant: "9",
    pmids:
      "16169542,27207648,18345028,11896607,15117815,25285031,18089718,26087400,16637061",
  },
  {
    id: "8151",
    id_polifenol: "129",
    polifenol: "Rotenone",
    id_cancer: "9999",
    cancer: "Neoplasm Invasiveness",
    quant: "2",
    pmids: "21356207,23023137",
  },
  {
    id: "8152",
    id_polifenol: "6451",
    polifenol: "daidzein",
    id_cancer: "9999",
    cancer: "Neoplasm Invasiveness",
    quant: "2",
    pmids: "15105043,7812935",
  },
  {
    id: "8153",
    id_polifenol: "6065",
    polifenol: "baicalein",
    id_cancer: "9999",
    cancer: "Neoplasm Invasiveness",
    quant: "3",
    pmids: "16458870,29667279,27530117",
  },
  {
    id: "8154",
    id_polifenol: "7",
    polifenol: "Capsaicin",
    id_cancer: "9999",
    cancer: "Neoplasm Invasiveness",
    quant: "2",
    pmids: "21462327,19002586",
  },
  {
    id: "8155",
    id_polifenol: "120",
    polifenol: "Flavonols",
    id_cancer: "9999",
    cancer: "Neoplasm Invasiveness",
    quant: "2",
    pmids: "16097445,24366437",
  },
  {
    id: "8156",
    id_polifenol: "4522",
    polifenol: "chrysin",
    id_cancer: "9999",
    cancer: "Neoplasm Invasiveness",
    quant: "1",
    pmids: "25875631",
  },
  {
    id: "8157",
    id_polifenol: "6062",
    polifenol: "naringenin",
    id_cancer: "9999",
    cancer: "Neoplasm Invasiveness",
    quant: "2",
    pmids: "25866363,23300530",
  },
  {
    id: "8158",
    id_polifenol: "285",
    polifenol: "bisphenol A",
    id_cancer: "9999",
    cancer: "Neoplasm Invasiveness",
    quant: "1",
    pmids: "27279583",
  },
  {
    id: "8159",
    id_polifenol: "39",
    polifenol: "Hydrolyzable Tannins",
    id_cancer: "9999",
    cancer: "Neoplasm Invasiveness",
    quant: "1",
    pmids: "23242008",
  },
  {
    id: "8160",
    id_polifenol: "4502",
    polifenol: "fisetin",
    id_cancer: "9999",
    cancer: "Neoplasm Invasiveness",
    quant: "2",
    pmids: "23940799,24099040",
  },
  {
    id: "8161",
    id_polifenol: "6",
    polifenol: "Catechols",
    id_cancer: "9999",
    cancer: "Neoplasm Invasiveness",
    quant: "1",
    pmids: "15499624",
  },
  {
    id: "8162",
    id_polifenol: "15",
    polifenol: "Masoprocol",
    id_cancer: "9999",
    cancer: "Neoplasm Invasiveness",
    quant: "2",
    pmids: "16882662,24454929",
  },
  {
    id: "8163",
    id_polifenol: "6087",
    polifenol: "wogonin",
    id_cancer: "9999",
    cancer: "Neoplasm Invasiveness",
    quant: "2",
    pmids: "28774312,28606135",
  },
  {
    id: "8164",
    id_polifenol: "4500",
    polifenol: "procyanidin",
    id_cancer: "9999",
    cancer: "Neoplasm Invasiveness",
    quant: "3",
    pmids: "24099118,10914742,24366437",
  },
  {
    id: "8165",
    id_polifenol: "5608",
    polifenol: "epicatechin gallate",
    id_cancer: "9999",
    cancer: "Neoplasm Invasiveness",
    quant: "2",
    pmids: "23337910,17202688",
  },
  {
    id: "8166",
    id_polifenol: "98",
    polifenol: "Propofol",
    id_cancer: "9999",
    cancer: "Neoplasm Invasiveness",
    quant: "3",
    pmids: "23742776,21611862,17979673",
  },
  {
    id: "8167",
    id_polifenol: "5607",
    polifenol: "gallocatechol",
    id_cancer: "9999",
    cancer: "Neoplasm Invasiveness",
    quant: "2",
    pmids: "17404067,17202688",
  },
  {
    id: "8168",
    id_polifenol: "44",
    polifenol: "Salicylates",
    id_cancer: "9999",
    cancer: "Neoplasm Invasiveness",
    quant: "1",
    pmids: "10811139",
  },
  {
    id: "8169",
    id_polifenol: "4559",
    polifenol: "theaflavin",
    id_cancer: "9999",
    cancer: "Neoplasm Invasiveness",
    quant: "3",
    pmids: "23715786,17936851,16387739",
  },
  {
    id: "8170",
    id_polifenol: "2284",
    polifenol: "rosmarinic acid",
    id_cancer: "9999",
    cancer: "Neoplasm Invasiveness",
    quant: "1",
    pmids: "26542239",
  },
  {
    id: "8171",
    id_polifenol: "6063",
    polifenol: "naringin",
    id_cancer: "9999",
    cancer: "Neoplasm Invasiveness",
    quant: "1",
    pmids: "22847135",
  },
  {
    id: "8172",
    id_polifenol: "2158",
    polifenol: "protocatechuic acid",
    id_cancer: "9999",
    cancer: "Neoplasm Invasiveness",
    quant: "1",
    pmids: "19601677",
  },
  {
    id: "8173",
    id_polifenol: "5489",
    polifenol: "delphinidin",
    id_cancer: "9999",
    cancer: "Neoplasm Invasiveness",
    quant: "3",
    pmids: "25000305,22659736,9581517",
  },
  {
    id: "8174",
    id_polifenol: "6454",
    polifenol: "formononetin",
    id_cancer: "9999",
    cancer: "Neoplasm Invasiveness",
    quant: "1",
    pmids: "23023137",
  },
  {
    id: "8175",
    id_polifenol: "126",
    polifenol: "Coumestrol",
    id_cancer: "9999",
    cancer: "Neoplasm Invasiveness",
    quant: "1",
    pmids: "15105043",
  },
  {
    id: "8176",
    id_polifenol: "55",
    polifenol: "Sodium Salicylate",
    id_cancer: "9999",
    cancer: "Neoplasm Invasiveness",
    quant: "2",
    pmids: "10811139,16991207",
  },
  {
    id: "8177",
    id_polifenol: "1558",
    polifenol: "capsazepine",
    id_cancer: "9999",
    cancer: "Neoplasm Invasiveness",
    quant: "1",
    pmids: "21089054",
  },
  {
    id: "8178",
    id_polifenol: "969",
    polifenol: "3,4-dihydroxyphenacyl caffeate phenylpropanoid ester",
    id_cancer: "9999",
    cancer: "Neoplasm Invasiveness",
    quant: "1",
    pmids: "24944685",
  },
  {
    id: "8179",
    id_polifenol: "5488",
    polifenol: "cyanidin",
    id_cancer: "9999",
    cancer: "Neoplasm Invasiveness",
    quant: "1",
    pmids: "22659736",
  },
  {
    id: "8180",
    id_polifenol: "4640",
    polifenol: "5,7-dihydroxy-6-methoxy-2-phenylchromen-4-one",
    id_cancer: "9999",
    cancer: "Neoplasm Invasiveness",
    quant: "1",
    pmids: "26741501",
  },
  {
    id: "8181",
    id_polifenol: "132",
    polifenol: "Equol",
    id_cancer: "9999",
    cancer: "Neoplasm Invasiveness",
    quant: "1",
    pmids: "15105043",
  },
  {
    id: "8182",
    id_polifenol: "1673",
    polifenol: "4-hydroxyestradiol",
    id_cancer: "9999",
    cancer: "Neoplasm Invasiveness",
    quant: "1",
    pmids: "15499624",
  },
  {
    id: "8183",
    id_polifenol: "452",
    polifenol: "acteoside",
    id_cancer: "9999",
    cancer: "Neoplasm Invasiveness",
    quant: "1",
    pmids: "21089054",
  },
  {
    id: "8184",
    id_polifenol: "5614",
    polifenol: "catechin gallate",
    id_cancer: "9999",
    cancer: "Neoplasm Invasiveness",
    quant: "1",
    pmids: "17404067",
  },
  {
    id: "8185",
    id_polifenol: "7541",
    polifenol: "taxifolin",
    id_cancer: "9999",
    cancer: "Neoplasm Invasiveness",
    quant: "1",
    pmids: "16458870",
  },
  {
    id: "8186",
    id_polifenol: "300",
    polifenol: "rhodioloside",
    id_cancer: "9999",
    cancer: "Neoplasm Invasiveness",
    quant: "2",
    pmids: "24944685,29115408",
  },
  {
    id: "8187",
    id_polifenol: "6576",
    polifenol: "5,7,4'-trihydroxyflavone",
    id_cancer: "9999",
    cancer: "Neoplasm Invasiveness",
    quant: "2",
    pmids: "15523693,25351792",
  },
  {
    id: "8188",
    id_polifenol: "59",
    polifenol: "Dinitrophenols",
    id_cancer: "9999",
    cancer: "Neoplasm Invasiveness",
    quant: "1",
    pmids: "21155627",
  },
  {
    id: "8189",
    id_polifenol: "5630",
    polifenol: "polyphenon E",
    id_cancer: "9999",
    cancer: "Neoplasm Invasiveness",
    quant: "1",
    pmids: "17484049",
  },
  {
    id: "8190",
    id_polifenol: "5495",
    polifenol: "malvidin",
    id_cancer: "9999",
    cancer: "Neoplasm Invasiveness",
    quant: "1",
    pmids: "22659736",
  },
  {
    id: "8191",
    id_polifenol: "6510",
    polifenol: "glycitein",
    id_cancer: "9999",
    cancer: "Neoplasm Invasiveness",
    quant: "1",
    pmids: "15105043",
  },
  {
    id: "8192",
    id_polifenol: "7198",
    polifenol: "homoorientin",
    id_cancer: "9999",
    cancer: "Neoplasm Invasiveness",
    quant: "1",
    pmids: "28003763",
  },
  {
    id: "8193",
    id_polifenol: "4521",
    polifenol: "3-hydroxyflavone",
    id_cancer: "9999",
    cancer: "Neoplasm Invasiveness",
    quant: "1",
    pmids: "27600294",
  },
  {
    id: "8194",
    id_polifenol: "3489",
    polifenol: "anethole",
    id_cancer: "9999",
    cancer: "Neoplasm Invasiveness",
    quant: "1",
    pmids: "24525130",
  },
  {
    id: "8195",
    id_polifenol: "6554",
    polifenol: "tectorigenin",
    id_cancer: "9999",
    cancer: "Neoplasm Invasiveness",
    quant: "1",
    pmids: "15845653",
  },
  {
    id: "8196",
    id_polifenol: "4565",
    polifenol: "morusin",
    id_cancer: "9999",
    cancer: "Neoplasm Invasiveness",
    quant: "1",
    pmids: "29749480",
  },
  {
    id: "8197",
    id_polifenol: "6129",
    polifenol: "wogonoside",
    id_cancer: "9999",
    cancer: "Neoplasm Invasiveness",
    quant: "1",
    pmids: "28774312",
  },
  {
    id: "8198",
    id_polifenol: "5538",
    polifenol: "petunidin",
    id_cancer: "9999",
    cancer: "Neoplasm Invasiveness",
    quant: "1",
    pmids: "22659736",
  },
  {
    id: "8199",
    id_polifenol: "5537",
    polifenol: "peonidin",
    id_cancer: "9999",
    cancer: "Neoplasm Invasiveness",
    quant: "1",
    pmids: "22659736",
  },
  {
    id: "8200",
    id_polifenol: "5615",
    polifenol: "gallocatechin gallate",
    id_cancer: "9999",
    cancer: "Neoplasm Invasiveness",
    quant: "1",
    pmids: "17202688",
  },
  {
    id: "8201",
    id_polifenol: "1492",
    polifenol: "hirsutenone",
    id_cancer: "9999",
    cancer: "Neoplasm Invasiveness",
    quant: "1",
    pmids: "16380122",
  },
  {
    id: "8202",
    id_polifenol: "106",
    polifenol: "Benzoflavones",
    id_cancer: "9999",
    cancer: "Neoplasm Invasiveness",
    quant: "1",
    pmids: "27150634",
  },
  {
    id: "8203",
    id_polifenol: "5616",
    polifenol: "epigallocatechin-3-(3''-O-methyl)gallate",
    id_cancer: "9999",
    cancer: "Neoplasm Invasiveness",
    quant: "1",
    pmids: "26542239",
  },
  {
    id: "8204",
    id_polifenol: "5697",
    polifenol:
      "3-(3,4-dimethoxyphenyl)-1-(5-hydroxy-2,2-dimethyl-2H-chromen-6-yl)prop-2-en-1-one",
    id_cancer: "9999",
    cancer: "Neoplasm Invasiveness",
    quant: "1",
    pmids: "27658723",
  },
  {
    id: "8205",
    id_polifenol: "3336",
    polifenol:
      "N-hydroxy-5-ethoxymethyloxy-2-methyl-4-(4-phenoxybenzoyl)aminopentanamide",
    id_cancer: "9999",
    cancer: "Neoplasm Invasiveness",
    quant: "2",
    pmids: "12516105,16701099",
  },
  {
    id: "8206",
    id_polifenol: "6470",
    polifenol: "O-desmethylangolensin",
    id_cancer: "9999",
    cancer: "Neoplasm Invasiveness",
    quant: "1",
    pmids: "15105043",
  },
  {
    id: "8207",
    id_polifenol: "1424",
    polifenol: "rooperol",
    id_cancer: "9999",
    cancer: "Neoplasm Invasiveness",
    quant: "1",
    pmids: "10690646",
  },
  {
    id: "8208",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "16",
    pmids:
      "10963959,29275301,18790751,25264278,16087636,20420897,24991123,27168755,29649138,23934681,22047698,26475120,11809535,25886879,28808383,22770910",
  },
  {
    id: "8209",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "23",
    pmids:
      "24716415,28875010,26567619,27504095,22443687,20183254,11756235,15809436,25998190,21595920,20728364,23704793,28420097,26893544,16849521,27190933,26116834,27050372,27489587,24858458,19723087,12649194,1578097",
  },
  {
    id: "8210",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "14",
    pmids:
      "12151351,25536607,15749663,23796248,23704793,27551472,12628501,26052936,26870993,16395705,26365556,25886879,29285220,17081606",
  },
  {
    id: "8211",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "13",
    pmids:
      "26138072,23948751,21935931,21360677,12851530,19825968,28639894,20372853,29964149,24514755,26884713,14576828,15374955",
  },
  {
    id: "8212",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "7",
    pmids: "15353126,2125038,18426648,12851530,17311236,8547662,11573937",
  },
  {
    id: "8213",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "7",
    pmids: "18426648,23796248,27551472,28420097,11809535,28188793,29285220",
  },
  {
    id: "8214",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "6",
    pmids: "24481129,25536607,15749663,19200260,12628501,15201978",
  },
  {
    id: "8215",
    id_polifenol: "2167",
    polifenol: "phenolic acid",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "7",
    pmids: "15809436,6944240,27168755,27348025,26052936,28746550,22253109",
  },
  {
    id: "8216",
    id_polifenol: "49",
    polifenol: "Aspirin",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "2",
    pmids: "8911154,26774931",
  },
  {
    id: "8217",
    id_polifenol: "109",
    polifenol: "Catechin",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "4",
    pmids: "15749663,19200260,17081606,28808383",
  },
  {
    id: "8218",
    id_polifenol: "125",
    polifenol: "Isoflavones",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "1",
    pmids: "17637197",
  },
  {
    id: "8219",
    id_polifenol: "110",
    polifenol: "Chalcones",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "5",
    pmids: "29715098,17459529,23257665,22047698,12479853",
  },
  {
    id: "8220",
    id_polifenol: "3089",
    polifenol: "1,1-diphenyl-2-picrylhydrazyl",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "3",
    pmids: "27348025,26827534,28746550",
  },
  {
    id: "8221",
    id_polifenol: "114",
    polifenol: "Apigenin",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "4",
    pmids: "23796248,27551472,27348025,29285220",
  },
  {
    id: "8222",
    id_polifenol: "113",
    polifenol: "Flavones",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "5",
    pmids: "15809436,17604209,29412683,29328378,11809535",
  },
  {
    id: "8223",
    id_polifenol: "38",
    polifenol: "Gallic Acid",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "7",
    pmids: "22245431,27168690,11497272,27348025,9252655,28746550,22253109",
  },
  {
    id: "8224",
    id_polifenol: "117",
    polifenol: "Luteolin",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "3",
    pmids: "16087636,29649138,27348025",
  },
  {
    id: "8225",
    id_polifenol: "1",
    polifenol: "Phenols",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "7",
    pmids: "26299825,25268519,26052936,26827534,21097707,23517011,18178523",
  },
  {
    id: "8226",
    id_polifenol: "7235",
    polifenol: "silybin",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "4",
    pmids: "29805688,29782854,26148599,12649194",
  },
  {
    id: "8227",
    id_polifenol: "129",
    polifenol: "Rotenone",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "1",
    pmids: "3756905",
  },
  {
    id: "8228",
    id_polifenol: "871",
    polifenol: "ABT-737",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "6",
    pmids: "17097560,23243017,20818182,20038799,24842334,25461257",
  },
  {
    id: "8229",
    id_polifenol: "6451",
    polifenol: "daidzein",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "1",
    pmids: "18426648",
  },
  {
    id: "8230",
    id_polifenol: "6065",
    polifenol: "baicalein",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "1",
    pmids: "29328378",
  },
  {
    id: "8231",
    id_polifenol: "7",
    polifenol: "Capsaicin",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "3",
    pmids: "14871840,24870597,19116139",
  },
  {
    id: "8232",
    id_polifenol: "4634",
    polifenol: "alvocidib",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "6",
    pmids: "12021392,12533676,23767415,23825534,21110323,16322302",
  },
  {
    id: "8233",
    id_polifenol: "120",
    polifenol: "Flavonols",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "1",
    pmids: "28808383",
  },
  {
    id: "8234",
    id_polifenol: "4522",
    polifenol: "chrysin",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "1",
    pmids: "23796248",
  },
  {
    id: "8235",
    id_polifenol: "123",
    polifenol: "Rutin",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "1",
    pmids: "23351440",
  },
  {
    id: "8236",
    id_polifenol: "6062",
    polifenol: "naringenin",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "2",
    pmids: "27348025,27538012",
  },
  {
    id: "8237",
    id_polifenol: "39",
    polifenol: "Hydrolyzable Tannins",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "1",
    pmids: "11497272",
  },
  {
    id: "8238",
    id_polifenol: "130",
    polifenol: "Proanthocyanidins",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "1",
    pmids: "10448908",
  },
  {
    id: "8239",
    id_polifenol: "35",
    polifenol: "Hydroquinones",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "1",
    pmids: "18178523",
  },
  {
    id: "8240",
    id_polifenol: "4502",
    polifenol: "fisetin",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "1",
    pmids: "25973292",
  },
  {
    id: "8241",
    id_polifenol: "6",
    polifenol: "Catechols",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "2",
    pmids: "24523750,18178523",
  },
  {
    id: "8242",
    id_polifenol: "75",
    polifenol: "Butylated Hydroxyanisole",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "2",
    pmids: "11959917,9305611",
  },
  {
    id: "8243",
    id_polifenol: "6087",
    polifenol: "wogonin",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "2",
    pmids: "28105213,25264278",
  },
  {
    id: "8244",
    id_polifenol: "5608",
    polifenol: "epicatechin gallate",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "1",
    pmids: "17081606",
  },
  {
    id: "8245",
    id_polifenol: "1356",
    polifenol: "gingerol",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "1",
    pmids: "24378438",
  },
  {
    id: "8246",
    id_polifenol: "54",
    polifenol: "Salicylic Acid",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "1",
    pmids: "18414055",
  },
  {
    id: "8247",
    id_polifenol: "98",
    polifenol: "Propofol",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "1",
    pmids: "28962554",
  },
  {
    id: "8248",
    id_polifenol: "5607",
    polifenol: "gallocatechol",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "1",
    pmids: "27348025",
  },
  {
    id: "8249",
    id_polifenol: "44",
    polifenol: "Salicylates",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "1",
    pmids: "16162967",
  },
  {
    id: "8250",
    id_polifenol: "2344",
    polifenol: "methyl gallate",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "1",
    pmids: "9252655",
  },
  {
    id: "8251",
    id_polifenol: "4708",
    polifenol: "xanthohumol",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "2",
    pmids: "18790751,17823911",
  },
  {
    id: "8252",
    id_polifenol: "2284",
    polifenol: "rosmarinic acid",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "1",
    pmids: "20449663",
  },
  {
    id: "8253",
    id_polifenol: "112",
    polifenol: "Hesperidin",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "1",
    pmids: "26148599",
  },
  {
    id: "8254",
    id_polifenol: "6455",
    polifenol: "nobiletin",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "3",
    pmids: "25164609,26690473,11098080",
  },
  {
    id: "8255",
    id_polifenol: "93",
    polifenol: "Phloroglucinol",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "3",
    pmids: "21376709,17701591,22253109",
  },
  {
    id: "8256",
    id_polifenol: "81",
    polifenol: "Fenofibrate",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "1",
    pmids: "26718439",
  },
  {
    id: "8257",
    id_polifenol: "55",
    polifenol: "Sodium Salicylate",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "1",
    pmids: "15328418",
  },
  {
    id: "8258",
    id_polifenol: "5806",
    polifenol: "butein",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "1",
    pmids: "26676515",
  },
  {
    id: "8259",
    id_polifenol: "969",
    polifenol: "3,4-dihydroxyphenacyl caffeate phenylpropanoid ester",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "1",
    pmids: "22253109",
  },
  {
    id: "8260",
    id_polifenol: "5844",
    polifenol: "4-dimethylamino-3',4'-dimethoxychalcone",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "1",
    pmids: "13677932",
  },
  {
    id: "8261",
    id_polifenol: "94",
    polifenol: "Phloretin",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "1",
    pmids: "25229655",
  },
  {
    id: "8262",
    id_polifenol: "4560",
    polifenol: "icariin",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "1",
    pmids: "24895574",
  },
  {
    id: "8263",
    id_polifenol: "4640",
    polifenol: "5,7-dihydroxy-6-methoxy-2-phenylchromen-4-one",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "2",
    pmids: "29346508,23934681",
  },
  {
    id: "8264",
    id_polifenol: "6482",
    polifenol: "tangeretin",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "1",
    pmids: "11098080",
  },
  {
    id: "8265",
    id_polifenol: "5614",
    polifenol: "catechin gallate",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "1",
    pmids: "17081606",
  },
  {
    id: "8266",
    id_polifenol: "5850",
    polifenol: "cardamonin",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "1",
    pmids: "12479853",
  },
  {
    id: "8267",
    id_polifenol: "7541",
    polifenol: "taxifolin",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "1",
    pmids: "22253109",
  },
  {
    id: "8268",
    id_polifenol: "4767",
    polifenol: "flavan-3-ol",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "1",
    pmids: "28808383",
  },
  {
    id: "8269",
    id_polifenol: "2475",
    polifenol: "6-O-galloylglucose",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "1",
    pmids: "17081606",
  },
  {
    id: "8270",
    id_polifenol: "1996",
    polifenol: "2,5-di-tert-butylhydroquinone",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "1",
    pmids: "24079514",
  },
  {
    id: "8271",
    id_polifenol: "5071",
    polifenol: "icaritin",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "1",
    pmids: "24895574",
  },
  {
    id: "8272",
    id_polifenol: "4585",
    polifenol: "baohuoside I",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "1",
    pmids: "22493659",
  },
  {
    id: "8273",
    id_polifenol: "6625",
    polifenol: "phenoxodiol",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "1",
    pmids: "19535345",
  },
  {
    id: "8274",
    id_polifenol: "6086",
    polifenol: "liquiritigenin",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "1",
    pmids: "27538012",
  },
  {
    id: "8275",
    id_polifenol: "4516",
    polifenol: "diosmetin",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "1",
    pmids: "29412683",
  },
  {
    id: "8276",
    id_polifenol: "40",
    polifenol: "Propyl Gallate",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "1",
    pmids: "6944240",
  },
  {
    id: "8277",
    id_polifenol: "77",
    polifenol: "Bezafibrate",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "3",
    pmids: "27493727,19158949,27347458",
  },
  {
    id: "8278",
    id_polifenol: "4883",
    polifenol: "flavokawain B",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "1",
    pmids: "29715098",
  },
  {
    id: "8279",
    id_polifenol: "7853",
    polifenol: "Grape Seed Proanthocyanidins",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "1",
    pmids: "10448908",
  },
  {
    id: "8280",
    id_polifenol: "6066",
    polifenol: "eriodictyol",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "1",
    pmids: "27538012",
  },
  {
    id: "8281",
    id_polifenol: "4521",
    polifenol: "3-hydroxyflavone",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "1",
    pmids: "22770910",
  },
  {
    id: "8282",
    id_polifenol: "2448",
    polifenol: "ellagitannin",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "1",
    pmids: "27060359",
  },
  {
    id: "8283",
    id_polifenol: "5831",
    polifenol: "angoletin",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "1",
    pmids: "17243725",
  },
  {
    id: "8284",
    id_polifenol: "6129",
    polifenol: "wogonoside",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "1",
    pmids: "27941168",
  },
  {
    id: "8285",
    id_polifenol: "12",
    polifenol: "Guaiacol",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "1",
    pmids: "6944240",
  },
  {
    id: "8286",
    id_polifenol: "1918",
    polifenol: "2,6-di-tert-butyl-4-(aminomethyl)phenol hydrochloride",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "1",
    pmids: "26774931",
  },
  {
    id: "8287",
    id_polifenol: "4573",
    polifenol: "3,3',4',5,6,7,8-heptamethoxyflavone",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "1",
    pmids: "11098080",
  },
  {
    id: "8288",
    id_polifenol: "4639",
    polifenol: "aromadedrin",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "1",
    pmids: "22253109",
  },
  {
    id: "8289",
    id_polifenol: "4549",
    polifenol: "casticin",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "1",
    pmids: "16087636",
  },
  {
    id: "8290",
    id_polifenol: "5858",
    polifenol: "isobavachalcone",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "1",
    pmids: "29880605",
  },
  {
    id: "8291",
    id_polifenol: "416",
    polifenol: "phenoxy radical",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "1",
    pmids: "21097707",
  },
  {
    id: "8292",
    id_polifenol: "1237",
    polifenol: "2,4-bis(p-hydroxyphenyl)-2-butenal",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "1",
    pmids: "24423061",
  },
  {
    id: "8293",
    id_polifenol: "4548",
    polifenol: "artemetin",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "1",
    pmids: "16087636",
  },
  {
    id: "8294",
    id_polifenol: "4263",
    polifenol: "amurensin G",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "1",
    pmids: "26157347",
  },
  {
    id: "8295",
    id_polifenol: "7778",
    polifenol: "medicarpin",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "1",
    pmids: "25321472",
  },
  {
    id: "8296",
    id_polifenol: "6492",
    polifenol: "3(2H)-isoflavene",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "1",
    pmids: "19535345",
  },
  {
    id: "8297",
    id_polifenol: "4574",
    polifenol: "sinensetin",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "1",
    pmids: "26690473",
  },
  {
    id: "8298",
    id_polifenol: "4579",
    polifenol: "hinokiflavone",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "1",
    pmids: "17311236",
  },
  {
    id: "8299",
    id_polifenol: "1804",
    polifenol: "guaiacylglycerol-beta-coniferyl ether",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "1",
    pmids: "22253109",
  },
  {
    id: "8300",
    id_polifenol: "184",
    polifenol: "trilobatin",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "1",
    pmids: "25229655",
  },
  {
    id: "8301",
    id_polifenol: "5802",
    polifenol: "hesperidin methylchalcone",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "1",
    pmids: "26148599",
  },
  {
    id: "8302",
    id_polifenol: "3605",
    polifenol: "lyoniresinol",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "1",
    pmids: "22253109",
  },
  {
    id: "8303",
    id_polifenol: "7027",
    polifenol: "chrysosplenol D",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "1",
    pmids: "16087636",
  },
  {
    id: "8304",
    id_polifenol: "1625",
    polifenol: "curcumin III",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "1",
    pmids: "1578097",
  },
  {
    id: "8305",
    id_polifenol: "7457",
    polifenol: "kaempferol-7-O-alpha-L-rhamnopyranoside",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "1",
    pmids: "26475120",
  },
  {
    id: "8306",
    id_polifenol: "5792",
    polifenol: "4,4'-dihydroxychalcone",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "1",
    pmids: "12479853",
  },
  {
    id: "8307",
    id_polifenol: "5123",
    polifenol: "flavonoid cycloartobiloxanthone",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "1",
    pmids: "29275301",
  },
  {
    id: "8308",
    id_polifenol: "5116",
    polifenol: "betuletol 3-methyl ether",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "1",
    pmids: "19676104",
  },
  {
    id: "8309",
    id_polifenol: "7666",
    polifenol: "3,3',4',5,7-pentamethylquercetin",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "1",
    pmids: "11809535",
  },
  {
    id: "8310",
    id_polifenol: "5372",
    polifenol: "penduletin",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "1",
    pmids: "16087636",
  },
  {
    id: "8311",
    id_polifenol: "1906",
    polifenol: "4-amino-2-hydroxytoluene",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "1",
    pmids: "6944240",
  },
  {
    id: "8312",
    id_polifenol: "3906",
    polifenol: "hyperforin",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "1",
    pmids: "21751836",
  },
  {
    id: "8313",
    id_polifenol: "7383",
    polifenol: "kaempferol-3-O-arabinofuranoside-7-O-rhamnopyranoside",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "1",
    pmids: "26475120",
  },
  {
    id: "8314",
    id_polifenol: "7052",
    polifenol: "(3S)-5-guaiacyl-3-hydroxypentanoic acid",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "1",
    pmids: "22253109",
  },
  {
    id: "8315",
    id_polifenol: "4568",
    polifenol: "umuhengerin",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "1",
    pmids: "26690473",
  },
  {
    id: "8316",
    id_polifenol: "4348",
    polifenol:
      "(2R,3S)-guibourtinidol-3-O-alpha-D-apiofuranosyl-(1-6)-O-beta-D-glucopyranoside",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "1",
    pmids: "27538012",
  },
  {
    id: "8317",
    id_polifenol: "5625",
    polifenol: "fisetinidol-(4alpha-8)catechin 3-gallate",
    id_cancer: "572",
    cancer: "Leukemia Myeloid",
    quant: "1",
    pmids: "27538012",
  },
  {
    id: "8318",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "525",
    cancer: "Kidney (Renal Cell) Cancer",
    quant: "25",
    pmids:
      "26725939,29119970,24324713,28744400,26323996,24940817,19429375,27035542,28423637,27729209,25260394,28924370,25884331,24530290,21674787,21298326,10739098,21574189,23321314,24196280,20558139,17587681,10660092,8051728,28469971",
  },
  {
    id: "8319",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "525",
    cancer: "Kidney (Renal Cell) Cancer",
    quant: "13",
    pmids:
      "29849119,24743574,22899991,27259310,21109950,12216086,28810535,27234697,12533677,28358339,19212627,29581972,23162792",
  },
  {
    id: "8320",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "525",
    cancer: "Kidney (Renal Cell) Cancer",
    quant: "4",
    pmids: "28924370,12452018,22532866,10211943",
  },
  {
    id: "8321",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "525",
    cancer: "Kidney (Renal Cell) Cancer",
    quant: "18",
    pmids:
      "28328292,18027151,29241073,18949358,22728770,19951697,11562428,10436007,10389762,16952706,27556517,21574189,21878748,21813464,16729971,15389589,15581417,18000741",
  },
  {
    id: "8322",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "525",
    cancer: "Kidney (Renal Cell) Cancer",
    quant: "13",
    pmids:
      "19221000,9731487,16123571,7774881,23591200,9572397,15151998,9178817,14693050,22347428,17212824,23189187,17465217",
  },
  {
    id: "8323",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "525",
    cancer: "Kidney (Renal Cell) Cancer",
    quant: "5",
    pmids: "24940817,27621033,29163752,26261493,8051728",
  },
  {
    id: "8324",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "525",
    cancer: "Kidney (Renal Cell) Cancer",
    quant: "7",
    pmids: "25539708,19212621,24335094,19020731,27073430,19020784,15272226",
  },
  {
    id: "8325",
    id_polifenol: "2167",
    polifenol: "phenolic acid",
    id_cancer: "525",
    cancer: "Kidney (Renal Cell) Cancer",
    quant: "5",
    pmids: "25619640,27375080,23569726,15272226,23265523",
  },
  {
    id: "8326",
    id_polifenol: "49",
    polifenol: "Aspirin",
    id_cancer: "525",
    cancer: "Kidney (Renal Cell) Cancer",
    quant: "4",
    pmids: "29792865,27343037,26594113,24692722",
  },
  {
    id: "8327",
    id_polifenol: "109",
    polifenol: "Catechin",
    id_cancer: "525",
    cancer: "Kidney (Renal Cell) Cancer",
    quant: "4",
    pmids: "19212621,19020731,22468171,10211943",
  },
  {
    id: "8328",
    id_polifenol: "125",
    polifenol: "Isoflavones",
    id_cancer: "525",
    cancer: "Kidney (Renal Cell) Cancer",
    quant: "1",
    pmids: "19221000",
  },
  {
    id: "8329",
    id_polifenol: "110",
    polifenol: "Chalcones",
    id_cancer: "525",
    cancer: "Kidney (Renal Cell) Cancer",
    quant: "4",
    pmids: "21115246,26497688,24372527,24121102",
  },
  {
    id: "8330",
    id_polifenol: "3089",
    polifenol: "1,1-diphenyl-2-picrylhydrazyl",
    id_cancer: "525",
    cancer: "Kidney (Renal Cell) Cancer",
    quant: "2",
    pmids: "29956560,22701284",
  },
  {
    id: "8331",
    id_polifenol: "114",
    polifenol: "Apigenin",
    id_cancer: "525",
    cancer: "Kidney (Renal Cell) Cancer",
    quant: "3",
    pmids: "28423637,10389762,21298326",
  },
  {
    id: "8332",
    id_polifenol: "113",
    polifenol: "Flavones",
    id_cancer: "525",
    cancer: "Kidney (Renal Cell) Cancer",
    quant: "2",
    pmids: "27582546,21298326",
  },
  {
    id: "8333",
    id_polifenol: "38",
    polifenol: "Gallic Acid",
    id_cancer: "525",
    cancer: "Kidney (Renal Cell) Cancer",
    quant: "1",
    pmids: "28672814",
  },
  {
    id: "8334",
    id_polifenol: "117",
    polifenol: "Luteolin",
    id_cancer: "525",
    cancer: "Kidney (Renal Cell) Cancer",
    quant: "3",
    pmids: "24530290,23476679,17587681",
  },
  {
    id: "8335",
    id_polifenol: "1",
    polifenol: "Phenols",
    id_cancer: "525",
    cancer: "Kidney (Renal Cell) Cancer",
    quant: "2",
    pmids: "23455189,46258",
  },
  {
    id: "8336",
    id_polifenol: "105",
    polifenol: "Anthocyanins",
    id_cancer: "525",
    cancer: "Kidney (Renal Cell) Cancer",
    quant: "2",
    pmids: "29742507,23265523",
  },
  {
    id: "8337",
    id_polifenol: "7235",
    polifenol: "silybin",
    id_cancer: "525",
    cancer: "Kidney (Renal Cell) Cancer",
    quant: "6",
    pmids: "18723275,26323996,25884331,19908243,21574189,10660092",
  },
  {
    id: "8338",
    id_polifenol: "129",
    polifenol: "Rotenone",
    id_cancer: "525",
    cancer: "Kidney (Renal Cell) Cancer",
    quant: "1",
    pmids: "27246978",
  },
  {
    id: "8339",
    id_polifenol: "121",
    polifenol: "Kaempferols",
    id_cancer: "525",
    cancer: "Kidney (Renal Cell) Cancer",
    quant: "2",
    pmids: "28924370,20558139",
  },
  {
    id: "8340",
    id_polifenol: "871",
    polifenol: "ABT-737",
    id_cancer: "525",
    cancer: "Kidney (Renal Cell) Cancer",
    quant: "6",
    pmids: "25375379,28120212,23832737,21084274,29792865,27178823",
  },
  {
    id: "8341",
    id_polifenol: "6065",
    polifenol: "baicalein",
    id_cancer: "525",
    cancer: "Kidney (Renal Cell) Cancer",
    quant: "4",
    pmids: "14654968,25228536,21597696,17587681",
  },
  {
    id: "8342",
    id_polifenol: "7",
    polifenol: "Capsaicin",
    id_cancer: "525",
    cancer: "Kidney (Renal Cell) Cancer",
    quant: "2",
    pmids: "27729033,15272226",
  },
  {
    id: "8343",
    id_polifenol: "4634",
    polifenol: "alvocidib",
    id_cancer: "525",
    cancer: "Kidney (Renal Cell) Cancer",
    quant: "1",
    pmids: "10810375",
  },
  {
    id: "8344",
    id_polifenol: "4522",
    polifenol: "chrysin",
    id_cancer: "525",
    cancer: "Kidney (Renal Cell) Cancer",
    quant: "1",
    pmids: "24940817",
  },
  {
    id: "8345",
    id_polifenol: "123",
    polifenol: "Rutin",
    id_cancer: "525",
    cancer: "Kidney (Renal Cell) Cancer",
    quant: "1",
    pmids: "8051728",
  },
  {
    id: "8346",
    id_polifenol: "6062",
    polifenol: "naringenin",
    id_cancer: "525",
    cancer: "Kidney (Renal Cell) Cancer",
    quant: "2",
    pmids: "24940817,21674787",
  },
  {
    id: "8347",
    id_polifenol: "35",
    polifenol: "Hydroquinones",
    id_cancer: "525",
    cancer: "Kidney (Renal Cell) Cancer",
    quant: "4",
    pmids: "17000671,11398196,14587099,8578103",
  },
  {
    id: "8348",
    id_polifenol: "111",
    polifenol: "Flavanones",
    id_cancer: "525",
    cancer: "Kidney (Renal Cell) Cancer",
    quant: "1",
    pmids: "24843190",
  },
  {
    id: "8349",
    id_polifenol: "4502",
    polifenol: "fisetin",
    id_cancer: "525",
    cancer: "Kidney (Renal Cell) Cancer",
    quant: "1",
    pmids: "28767099",
  },
  {
    id: "8350",
    id_polifenol: "6",
    polifenol: "Catechols",
    id_cancer: "525",
    cancer: "Kidney (Renal Cell) Cancer",
    quant: "2",
    pmids: "3009986,3032410",
  },
  {
    id: "8351",
    id_polifenol: "15",
    polifenol: "Masoprocol",
    id_cancer: "525",
    cancer: "Kidney (Renal Cell) Cancer",
    quant: "1",
    pmids: "8747792",
  },
  {
    id: "8352",
    id_polifenol: "6087",
    polifenol: "wogonin",
    id_cancer: "525",
    cancer: "Kidney (Renal Cell) Cancer",
    quant: "2",
    pmids: "25228536,21597696",
  },
  {
    id: "8353",
    id_polifenol: "4515",
    polifenol: "baicalin",
    id_cancer: "525",
    cancer: "Kidney (Renal Cell) Cancer",
    quant: "2",
    pmids: "25228536,21597696",
  },
  {
    id: "8354",
    id_polifenol: "1356",
    polifenol: "gingerol",
    id_cancer: "525",
    cancer: "Kidney (Renal Cell) Cancer",
    quant: "3",
    pmids: "25619640,21792901,16878317",
  },
  {
    id: "8355",
    id_polifenol: "54",
    polifenol: "Salicylic Acid",
    id_cancer: "525",
    cancer: "Kidney (Renal Cell) Cancer",
    quant: "1",
    pmids: "23569726",
  },
  {
    id: "8356",
    id_polifenol: "5578",
    polifenol: "alpha-naphthoflavone",
    id_cancer: "525",
    cancer: "Kidney (Renal Cell) Cancer",
    quant: "1",
    pmids: "3030825",
  },
  {
    id: "8357",
    id_polifenol: "6455",
    polifenol: "nobiletin",
    id_cancer: "525",
    cancer: "Kidney (Renal Cell) Cancer",
    quant: "1",
    pmids: "23321314",
  },
  {
    id: "8358",
    id_polifenol: "10",
    polifenol: "Estrogens, Catechol",
    id_cancer: "525",
    cancer: "Kidney (Renal Cell) Cancer",
    quant: "4",
    pmids: "3009986,3030825,3032410,3769051",
  },
  {
    id: "8359",
    id_polifenol: "4513",
    polifenol: "galangin",
    id_cancer: "525",
    cancer: "Kidney (Renal Cell) Cancer",
    quant: "2",
    pmids: "26725939,27035542",
  },
  {
    id: "8360",
    id_polifenol: "1380",
    polifenol: "shogaol",
    id_cancer: "525",
    cancer: "Kidney (Renal Cell) Cancer",
    quant: "2",
    pmids: "25619640,16878317",
  },
  {
    id: "8361",
    id_polifenol: "107",
    polifenol: "beta-Naphthoflavone",
    id_cancer: "525",
    cancer: "Kidney (Renal Cell) Cancer",
    quant: "1",
    pmids: "3011249",
  },
  {
    id: "8362",
    id_polifenol: "119",
    polifenol: "Silymarin",
    id_cancer: "525",
    cancer: "Kidney (Renal Cell) Cancer",
    quant: "2",
    pmids: "24127286,10660092",
  },
  {
    id: "8363",
    id_polifenol: "1558",
    polifenol: "capsazepine",
    id_cancer: "525",
    cancer: "Kidney (Renal Cell) Cancer",
    quant: "1",
    pmids: "27729033",
  },
  {
    id: "8364",
    id_polifenol: "5844",
    polifenol: "4-dimethylamino-3',4'-dimethoxychalcone",
    id_cancer: "525",
    cancer: "Kidney (Renal Cell) Cancer",
    quant: "2",
    pmids: "8895553,20389170",
  },
  {
    id: "8365",
    id_polifenol: "4560",
    polifenol: "icariin",
    id_cancer: "525",
    cancer: "Kidney (Renal Cell) Cancer",
    quant: "1",
    pmids: "25577511",
  },
  {
    id: "8366",
    id_polifenol: "5488",
    polifenol: "cyanidin",
    id_cancer: "525",
    cancer: "Kidney (Renal Cell) Cancer",
    quant: "1",
    pmids: "29742507",
  },
  {
    id: "8367",
    id_polifenol: "4537",
    polifenol: "flavone acetic acid",
    id_cancer: "525",
    cancer: "Kidney (Renal Cell) Cancer",
    quant: "2",
    pmids: "7674335,3070530",
  },
  {
    id: "8368",
    id_polifenol: "1673",
    polifenol: "4-hydroxyestradiol",
    id_cancer: "525",
    cancer: "Kidney (Renal Cell) Cancer",
    quant: "2",
    pmids: "22159223,3009986",
  },
  {
    id: "8369",
    id_polifenol: "300",
    polifenol: "rhodioloside",
    id_cancer: "525",
    cancer: "Kidney (Renal Cell) Cancer",
    quant: "1",
    pmids: "27314291",
  },
  {
    id: "8370",
    id_polifenol: "5071",
    polifenol: "icaritin",
    id_cancer: "525",
    cancer: "Kidney (Renal Cell) Cancer",
    quant: "2",
    pmids: "24324713,25577511",
  },
  {
    id: "8371",
    id_polifenol: "40",
    polifenol: "Propyl Gallate",
    id_cancer: "525",
    cancer: "Kidney (Renal Cell) Cancer",
    quant: "1",
    pmids: "27375080",
  },
  {
    id: "8372",
    id_polifenol: "4796",
    polifenol: "aminoflavone",
    id_cancer: "525",
    cancer: "Kidney (Renal Cell) Cancer",
    quant: "2",
    pmids: "28471540,15017268",
  },
  {
    id: "8373",
    id_polifenol: "4525",
    polifenol: "eupatilin",
    id_cancer: "525",
    cancer: "Kidney (Renal Cell) Cancer",
    quant: "1",
    pmids: "27698876",
  },
  {
    id: "8374",
    id_polifenol: "1810",
    polifenol: "heminordihydroguaiaretic acid",
    id_cancer: "525",
    cancer: "Kidney (Renal Cell) Cancer",
    quant: "2",
    pmids: "8747792,15725809",
  },
  {
    id: "8375",
    id_polifenol: "6477",
    polifenol: "hispidulin",
    id_cancer: "525",
    cancer: "Kidney (Renal Cell) Cancer",
    quant: "3",
    pmids: "29119970,28744400,25260394",
  },
  {
    id: "8376",
    id_polifenol: "103",
    polifenol: "Zeranol",
    id_cancer: "525",
    cancer: "Kidney (Renal Cell) Cancer",
    quant: "1",
    pmids: "3030825",
  },
  {
    id: "8377",
    id_polifenol: "4501",
    polifenol: "tricin",
    id_cancer: "525",
    cancer: "Kidney (Renal Cell) Cancer",
    quant: "1",
    pmids: "19934339",
  },
  {
    id: "8378",
    id_polifenol: "97",
    polifenol: "Probucol",
    id_cancer: "525",
    cancer: "Kidney (Renal Cell) Cancer",
    quant: "1",
    pmids: "17487455",
  },
  {
    id: "8379",
    id_polifenol: "6129",
    polifenol: "wogonoside",
    id_cancer: "525",
    cancer: "Kidney (Renal Cell) Cancer",
    quant: "1",
    pmids: "25228536",
  },
  {
    id: "8380",
    id_polifenol: "6175",
    polifenol: "2'-hydroxyflavanone",
    id_cancer: "525",
    cancer: "Kidney (Renal Cell) Cancer",
    quant: "1",
    pmids: "21304051",
  },
  {
    id: "8381",
    id_polifenol: "896",
    polifenol: "polyphenon B",
    id_cancer: "525",
    cancer: "Kidney (Renal Cell) Cancer",
    quant: "1",
    pmids: "10211943",
  },
  {
    id: "8382",
    id_polifenol: "711",
    polifenol: "ascochlorin",
    id_cancer: "525",
    cancer: "Kidney (Renal Cell) Cancer",
    quant: "1",
    pmids: "15863510",
  },
  {
    id: "8383",
    id_polifenol: "2790",
    polifenol: "ginkgolic acid",
    id_cancer: "525",
    cancer: "Kidney (Renal Cell) Cancer",
    quant: "1",
    pmids: "20948210",
  },
  {
    id: "8384",
    id_polifenol: "6166",
    polifenol: "liquiritin",
    id_cancer: "525",
    cancer: "Kidney (Renal Cell) Cancer",
    quant: "1",
    pmids: "25228536",
  },
  {
    id: "8385",
    id_polifenol: "4981",
    polifenol: "jaceosidin",
    id_cancer: "525",
    cancer: "Kidney (Renal Cell) Cancer",
    quant: "1",
    pmids: "27729209",
  },
  {
    id: "8386",
    id_polifenol: "7895",
    polifenol: "flavokawain A",
    id_cancer: "525",
    cancer: "Kidney (Renal Cell) Cancer",
    quant: "2",
    pmids: "26497688,24121102",
  },
  {
    id: "8387",
    id_polifenol: "2168",
    polifenol: "beta-resorcylic acid",
    id_cancer: "525",
    cancer: "Kidney (Renal Cell) Cancer",
    quant: "1",
    pmids: "20623569",
  },
  {
    id: "8388",
    id_polifenol: "1106",
    polifenol: "1,1-bis(3'-indolyl)-1-(4-hydroxyphenyl)methane",
    id_cancer: "525",
    cancer: "Kidney (Renal Cell) Cancer",
    quant: "1",
    pmids: "26035713",
  },
  {
    id: "8389",
    id_polifenol: "6684",
    polifenol: "eupafolin",
    id_cancer: "525",
    cancer: "Kidney (Renal Cell) Cancer",
    quant: "1",
    pmids: "27582546",
  },
  {
    id: "8390",
    id_polifenol: "1629",
    polifenol: "bis-1,7-(2-hydroxyphenyl)-hepta-1,6-diene-3,5-dione",
    id_cancer: "525",
    cancer: "Kidney (Renal Cell) Cancer",
    quant: "1",
    pmids: "28358339",
  },
  {
    id: "8391",
    id_polifenol: "4161",
    polifenol: "3,5-dihydroxyphenylglycine",
    id_cancer: "525",
    cancer: "Kidney (Renal Cell) Cancer",
    quant: "1",
    pmids: "22706282",
  },
  {
    id: "8392",
    id_polifenol: "2034",
    polifenol: "2,3,5-(triglutathion-S-yl)hydroquinone",
    id_cancer: "525",
    cancer: "Kidney (Renal Cell) Cancer",
    quant: "4",
    pmids: "21693435,21813464,11398196,14587099",
  },
  {
    id: "8393",
    id_polifenol: "858",
    polifenol: "2-(3-chloro-4-hydroxyphenyl)-2-(4-hydroxyphenyl)propane",
    id_cancer: "525",
    cancer: "Kidney (Renal Cell) Cancer",
    quant: "1",
    pmids: "24843190",
  },
  {
    id: "8394",
    id_polifenol: "6291",
    polifenol: "alpinumisoflavone",
    id_cancer: "525",
    cancer: "Kidney (Renal Cell) Cancer",
    quant: "1",
    pmids: "28469971",
  },
  {
    id: "8395",
    id_polifenol: "3336",
    polifenol:
      "N-hydroxy-5-ethoxymethyloxy-2-methyl-4-(4-phenoxybenzoyl)aminopentanamide",
    id_cancer: "525",
    cancer: "Kidney (Renal Cell) Cancer",
    quant: "1",
    pmids: "11911256",
  },
  {
    id: "8396",
    id_polifenol: "2401",
    polifenol: "2,3,5-trihydroxybenzoic acid",
    id_cancer: "525",
    cancer: "Kidney (Renal Cell) Cancer",
    quant: "1",
    pmids: "28672814",
  },
  {
    id: "8397",
    id_polifenol: "7249",
    polifenol: "rhamnazin",
    id_cancer: "525",
    cancer: "Kidney (Renal Cell) Cancer",
    quant: "1",
    pmids: "10739098",
  },
  {
    id: "8398",
    id_polifenol: "4303",
    polifenol: "hypothemycin",
    id_cancer: "525",
    cancer: "Kidney (Renal Cell) Cancer",
    quant: "1",
    pmids: "20623569",
  },
  {
    id: "8399",
    id_polifenol: "4220",
    polifenol: "1,3-dihydroxy-5-(tridec-4',7'-dienyl)benzene",
    id_cancer: "525",
    cancer: "Kidney (Renal Cell) Cancer",
    quant: "1",
    pmids: "17009393",
  },
  {
    id: "8400",
    id_polifenol: "1527",
    polifenol:
      "3-(4-chlorophenyl)adamantane-1-carboxylic acid 3,4-dihydroxybenzylamide",
    id_cancer: "525",
    cancer: "Kidney (Renal Cell) Cancer",
    quant: "1",
    pmids: "22970244",
  },
  {
    id: "8401",
    id_polifenol: "4229",
    polifenol: "7-oxozeanol",
    id_cancer: "525",
    cancer: "Kidney (Renal Cell) Cancer",
    quant: "1",
    pmids: "25261726",
  },
  {
    id: "8402",
    id_polifenol: "5456",
    polifenol: "4''-O-methyl-I3,II8-biapigenin",
    id_cancer: "525",
    cancer: "Kidney (Renal Cell) Cancer",
    quant: "1",
    pmids: "17365688",
  },
  {
    id: "8403",
    id_polifenol: "3293",
    polifenol: "phenetole",
    id_cancer: "525",
    cancer: "Kidney (Renal Cell) Cancer",
    quant: "1",
    pmids: "23051149",
  },
  {
    id: "8404",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "23",
    pmids:
      "27814565,18343026,29471006,27035542,24647664,27470413,28504248,18019427,27803454,28924370,21871644,23194824,25554015,16021489,29506627,29412798,29593788,26158795,29513789,18089721,9364471,28469971,8128490",
  },
  {
    id: "8405",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "18",
    pmids:
      "15987718,8844727,27259310,27496212,28810535,15893313,16021489,27221847,17052672,22101212,23848205,23386399,29848101,27270752,29278208,22642894,22300367,12628510",
  },
  {
    id: "8406",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "5",
    pmids: "28924370,29204075,23174518,26158795,11435174",
  },
  {
    id: "8407",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "13",
    pmids:
      "24508476,28328292,24647664,27313717,25012123,19298253,12883736,16952706,21878748,21813464,28390675,20398401,14973144",
  },
  {
    id: "8408",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "12",
    pmids:
      "19221000,14612383,8555246,19298253,7774881,23591200,9178817,14693050,10873031,22347428,17212824,23189187",
  },
  {
    id: "8409",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "8",
    pmids:
      "24173369,24647664,28504248,27803454,16021489,29593788,26261493,8128490",
  },
  {
    id: "8410",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "2",
    pmids: "29468843,15736408",
  },
  {
    id: "8411",
    id_polifenol: "2167",
    polifenol: "phenolic acid",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "9",
    pmids:
      "28356015,19883717,21871644,25554015,9591191,29506627,29412798,26839997,29513789",
  },
  {
    id: "8412",
    id_polifenol: "49",
    polifenol: "Aspirin",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "2",
    pmids: "2912548,24692722",
  },
  {
    id: "8413",
    id_polifenol: "109",
    polifenol: "Catechin",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "3",
    pmids: "29278988,29513789,15736408",
  },
  {
    id: "8414",
    id_polifenol: "125",
    polifenol: "Isoflavones",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "1",
    pmids: "19221000",
  },
  {
    id: "8415",
    id_polifenol: "110",
    polifenol: "Chalcones",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "4",
    pmids: "27814565,26068427,20594863,11213444",
  },
  {
    id: "8416",
    id_polifenol: "3089",
    polifenol: "1,1-diphenyl-2-picrylhydrazyl",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "7",
    pmids: "19883717,28699489,21871644,25554015,23174518,26742030,26839997",
  },
  {
    id: "8417",
    id_polifenol: "113",
    polifenol: "Flavones",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "4",
    pmids: "27814565,12065765,2736717,17363487",
  },
  {
    id: "8418",
    id_polifenol: "38",
    polifenol: "Gallic Acid",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "3",
    pmids: "29468843,29513789,29161651",
  },
  {
    id: "8419",
    id_polifenol: "1",
    polifenol: "Phenols",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "3",
    pmids: "28356015,25410727,20949584",
  },
  {
    id: "8420",
    id_polifenol: "7235",
    polifenol: "silybin",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "2",
    pmids: "18723275,24615813",
  },
  {
    id: "8421",
    id_polifenol: "121",
    polifenol: "Kaempferols",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "1",
    pmids: "28924370",
  },
  {
    id: "8422",
    id_polifenol: "871",
    polifenol: "ABT-737",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "2",
    pmids: "23832737,27178823",
  },
  {
    id: "8423",
    id_polifenol: "7",
    polifenol: "Capsaicin",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "2",
    pmids: "27729033,25929448",
  },
  {
    id: "8424",
    id_polifenol: "4634",
    polifenol: "alvocidib",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "1",
    pmids: "11093360",
  },
  {
    id: "8425",
    id_polifenol: "120",
    polifenol: "Flavonols",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "1",
    pmids: "7623025",
  },
  {
    id: "8426",
    id_polifenol: "4522",
    polifenol: "chrysin",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "4",
    pmids: "27470413,23194824,27403965,19470632",
  },
  {
    id: "8427",
    id_polifenol: "123",
    polifenol: "Rutin",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "2",
    pmids: "29204075,26742030",
  },
  {
    id: "8428",
    id_polifenol: "6062",
    polifenol: "naringenin",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "2",
    pmids: "21871644,22642894",
  },
  {
    id: "8429",
    id_polifenol: "39",
    polifenol: "Hydrolyzable Tannins",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "2",
    pmids: "25554015,11435174",
  },
  {
    id: "8430",
    id_polifenol: "35",
    polifenol: "Hydroquinones",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "4",
    pmids: "15571862,21374823,9502392,8578103",
  },
  {
    id: "8431",
    id_polifenol: "111",
    polifenol: "Flavanones",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "1",
    pmids: "21871644",
  },
  {
    id: "8432",
    id_polifenol: "4502",
    polifenol: "fisetin",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "2",
    pmids: "26682000,8128490",
  },
  {
    id: "8433",
    id_polifenol: "6",
    polifenol: "Catechols",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "5",
    pmids: "25964542,3009986,8381068,9683193,11511178",
  },
  {
    id: "8434",
    id_polifenol: "25",
    polifenol: "Butylated Hydroxytoluene",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "2",
    pmids: "16041836,9305529",
  },
  {
    id: "8435",
    id_polifenol: "75",
    polifenol: "Butylated Hydroxyanisole",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "3",
    pmids: "10914493,9305529,21627363",
  },
  {
    id: "8436",
    id_polifenol: "6087",
    polifenol: "wogonin",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "1",
    pmids: "22260968",
  },
  {
    id: "8437",
    id_polifenol: "4500",
    polifenol: "procyanidin",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "1",
    pmids: "16828532",
  },
  {
    id: "8438",
    id_polifenol: "5578",
    polifenol: "alpha-naphthoflavone",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "6",
    pmids: "12065765,22485252,2736717,14994278,3030825,6477123",
  },
  {
    id: "8439",
    id_polifenol: "2344",
    polifenol: "methyl gallate",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "1",
    pmids: "29468843",
  },
  {
    id: "8440",
    id_polifenol: "47",
    polifenol: "Mesalamine",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "1",
    pmids: "19737563",
  },
  {
    id: "8441",
    id_polifenol: "2284",
    polifenol: "rosmarinic acid",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "1",
    pmids: "25554015",
  },
  {
    id: "8442",
    id_polifenol: "112",
    polifenol: "Hesperidin",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "1",
    pmids: "26551080",
  },
  {
    id: "8443",
    id_polifenol: "10",
    polifenol: "Estrogens, Catechol",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "9",
    pmids:
      "3009986,1691052,3030825,8381068,1386303,9683193,11511178,8128490,3769051",
  },
  {
    id: "8444",
    id_polifenol: "4513",
    polifenol: "galangin",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "1",
    pmids: "27035542",
  },
  {
    id: "8445",
    id_polifenol: "2158",
    polifenol: "protocatechuic acid",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "1",
    pmids: "9591191",
  },
  {
    id: "8446",
    id_polifenol: "93",
    polifenol: "Phloroglucinol",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "1",
    pmids: "17976995",
  },
  {
    id: "8447",
    id_polifenol: "7550",
    polifenol: "3-methylquercetin",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "1",
    pmids: "27803454",
  },
  {
    id: "8448",
    id_polifenol: "107",
    polifenol: "beta-Naphthoflavone",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "1",
    pmids: "27914986",
  },
  {
    id: "8449",
    id_polifenol: "119",
    polifenol: "Silymarin",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "1",
    pmids: "19590824",
  },
  {
    id: "8450",
    id_polifenol: "1558",
    polifenol: "capsazepine",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "1",
    pmids: "27729033",
  },
  {
    id: "8451",
    id_polifenol: "969",
    polifenol: "3,4-dihydroxyphenacyl caffeate phenylpropanoid ester",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "1",
    pmids: "21871644",
  },
  {
    id: "8452",
    id_polifenol: "94",
    polifenol: "Phloretin",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "1",
    pmids: "21871644",
  },
  {
    id: "8453",
    id_polifenol: "48",
    polifenol: "Anacardic Acids",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "1",
    pmids: "26911844",
  },
  {
    id: "8454",
    id_polifenol: "4537",
    polifenol: "flavone acetic acid",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "6",
    pmids: "2117482,2253233,1689611,2667786,3258894,1477076",
  },
  {
    id: "8455",
    id_polifenol: "80",
    polifenol: "Clofibrate",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "1",
    pmids: "1906850",
  },
  {
    id: "8456",
    id_polifenol: "1673",
    polifenol: "4-hydroxyestradiol",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "5",
    pmids: "22159223,3009986,8381068,7671246,8128490",
  },
  {
    id: "8457",
    id_polifenol: "452",
    polifenol: "acteoside",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "1",
    pmids: "21871644",
  },
  {
    id: "8458",
    id_polifenol: "1866",
    polifenol: "4,6-dinitro-o-cresol",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "1",
    pmids: "18019427",
  },
  {
    id: "8459",
    id_polifenol: "118",
    polifenol: "Flavonolignans",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "1",
    pmids: "19590824",
  },
  {
    id: "8460",
    id_polifenol: "60",
    polifenol: "2,4-Dinitrophenol",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "1",
    pmids: "25925410",
  },
  {
    id: "8461",
    id_polifenol: "7912",
    polifenol: "7,9,2',4'-tetrahydroxy-8-isopentenyl-5-methoxychalcone",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "1",
    pmids: "27814565",
  },
  {
    id: "8462",
    id_polifenol: "2447",
    polifenol: "beta-penta-O-galloyl-glucose",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "1",
    pmids: "22172427",
  },
  {
    id: "8463",
    id_polifenol: "4796",
    polifenol: "aminoflavone",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "3",
    pmids: "12065765,28471540,22485252",
  },
  {
    id: "8464",
    id_polifenol: "4525",
    polifenol: "eupatilin",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "1",
    pmids: "27698876",
  },
  {
    id: "8465",
    id_polifenol: "7547",
    polifenol: "hyperoside",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "1",
    pmids: "24173369",
  },
  {
    id: "8466",
    id_polifenol: "349",
    polifenol: "4-nitrophenol",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "1",
    pmids: "25925410",
  },
  {
    id: "8467",
    id_polifenol: "103",
    polifenol: "Zeranol",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "1",
    pmids: "3030825",
  },
  {
    id: "8468",
    id_polifenol: "687",
    polifenol: "calix(4)arene",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "1",
    pmids: "26824462",
  },
  {
    id: "8469",
    id_polifenol: "713",
    polifenol:
      "3-(3-chloro-4-hydroxyphenylamino)-4-(4-nitrophenyl)-1H-pyrrole-2,5-dione",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "1",
    pmids: "23337568",
  },
  {
    id: "8470",
    id_polifenol: "1672",
    polifenol: "B19 monocarbonyl curcumin",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "1",
    pmids: "27496212",
  },
  {
    id: "8471",
    id_polifenol: "6175",
    polifenol: "2'-hydroxyflavanone",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "1",
    pmids: "21304051",
  },
  {
    id: "8472",
    id_polifenol: "357",
    polifenol: "4-aminophenol",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "1",
    pmids: "2912548",
  },
  {
    id: "8473",
    id_polifenol: "2343",
    polifenol: "ethyl gallate",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "1",
    pmids: "29468843",
  },
  {
    id: "8474",
    id_polifenol: "347",
    polifenol: "4-nitrophenyl",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "1",
    pmids: "21790129",
  },
  {
    id: "8475",
    id_polifenol: "7453",
    polifenol: "kaempferol-3-O-glucoside",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "1",
    pmids: "18343026",
  },
  {
    id: "8476",
    id_polifenol: "11",
    polifenol: "Hydroxyestrones",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "1",
    pmids: "7671246",
  },
  {
    id: "8477",
    id_polifenol: "4639",
    polifenol: "aromadedrin",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "1",
    pmids: "21871644",
  },
  {
    id: "8478",
    id_polifenol: "839",
    polifenol: "5-iodo-3-((3,5-dibromo-4-hydroxyphenyl)methylene)-2-indolinone",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "1",
    pmids: "26100670",
  },
  {
    id: "8479",
    id_polifenol: "1675",
    polifenol: "catechol estrogen 3,4-quinone",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "1",
    pmids: "11511178",
  },
  {
    id: "8480",
    id_polifenol: "3667",
    polifenol: "ciprofibrate",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "1",
    pmids: "2636030",
  },
  {
    id: "8481",
    id_polifenol: "1934",
    polifenol: "2,6-di-tert-butyl-4-hydroxy-4-methyl-2,5-cyclohexadien-1-one",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "1",
    pmids: "1691052",
  },
  {
    id: "8482",
    id_polifenol: "6687",
    polifenol: "3'-dimethylaminoflavone",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "2",
    pmids: "15571862,20594863",
  },
  {
    id: "8483",
    id_polifenol: "4698",
    polifenol: "sakuranetin",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "1",
    pmids: "21871644",
  },
  {
    id: "8484",
    id_polifenol: "2336",
    polifenol: "octyl gallate",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "1",
    pmids: "29468843",
  },
  {
    id: "8485",
    id_polifenol: "2034",
    polifenol: "2,3,5-(triglutathion-S-yl)hydroquinone",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "3",
    pmids: "21693435,21813464,12110509",
  },
  {
    id: "8486",
    id_polifenol: "6291",
    polifenol: "alpinumisoflavone",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "1",
    pmids: "28469971",
  },
  {
    id: "8487",
    id_polifenol: "4689",
    polifenol: "5,3'-dihydroxy-3,6,7,8,4'-pentamethoxyflavone",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "1",
    pmids: "7623025",
  },
  {
    id: "8488",
    id_polifenol: "4274",
    polifenol: "O 1602",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "1",
    pmids: "24355564",
  },
  {
    id: "8489",
    id_polifenol: "7280",
    polifenol: "astilbin",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "1",
    pmids: "29471006",
  },
  {
    id: "8490",
    id_polifenol: "4663",
    polifenol: "rhoifolin",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "1",
    pmids: "29506627",
  },
  {
    id: "8491",
    id_polifenol: "2924",
    polifenol: "2-methoxy-5-amino-N-hydroxybenzamide",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "1",
    pmids: "19737563",
  },
  {
    id: "8492",
    id_polifenol: "5178",
    polifenol: "Flavin7",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "1",
    pmids: "18019427",
  },
  {
    id: "8493",
    id_polifenol: "3917",
    polifenol: "2,4-diacetylphloroglucinol",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "1",
    pmids: "26833196",
  },
  {
    id: "8494",
    id_polifenol: "7195",
    polifenol: "6-hydroxyluteolin-7-O-glucoside",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "1",
    pmids: "21871644",
  },
  {
    id: "8495",
    id_polifenol: "941",
    polifenol: "caftaric acid",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "1",
    pmids: "25554015",
  },
  {
    id: "8496",
    id_polifenol: "1527",
    polifenol:
      "3-(4-chlorophenyl)adamantane-1-carboxylic acid 3,4-dihydroxybenzylamide",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "1",
    pmids: "20473784",
  },
  {
    id: "8497",
    id_polifenol: "2037",
    polifenol: "dephostatin",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "1",
    pmids: "14973144",
  },
  {
    id: "8498",
    id_polifenol: "5773",
    polifenol: "paratocarpin E",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "1",
    pmids: "27814565",
  },
  {
    id: "8499",
    id_polifenol: "275",
    polifenol: "trichlorophene",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "1",
    pmids: "28699489",
  },
  {
    id: "8500",
    id_polifenol: "1165",
    polifenol: "RSVA314",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "1",
    pmids: "22909341",
  },
  {
    id: "8501",
    id_polifenol: "1166",
    polifenol: "RSVA405",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "1",
    pmids: "22909341",
  },
  {
    id: "8502",
    id_polifenol: "6127",
    polifenol: "5-hydroxyflavanone-7-O-glucoside",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "1",
    pmids: "21871644",
  },
  {
    id: "8503",
    id_polifenol: "6214",
    polifenol: "2S-3',4',7,8-tetrahydroxyflavanone",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "1",
    pmids: "21871644",
  },
  {
    id: "8504",
    id_polifenol: "6162",
    polifenol: "(2R)-eriodictyol 7,4'-di-O-beta-D-glucopyranoside",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "1",
    pmids: "21871644",
  },
  {
    id: "8505",
    id_polifenol: "1535",
    polifenol: "4-((4-hydroxyphenylimino)methyl)benzene-1,2-diol",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "1",
    pmids: "28356012",
  },
  {
    id: "8506",
    id_polifenol: "4372",
    polifenol:
      "quercetin 3-O-alpha-rhamnopyranoside-7-O-beta-D-glucopyranosyl-(1-3)-alpha-L-rhamnopyranoside",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "1",
    pmids: "7623025",
  },
  {
    id: "8507",
    id_polifenol: "3929",
    polifenol: "euglobal In 1",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "1",
    pmids: "17976995",
  },
  {
    id: "8508",
    id_polifenol: "91",
    polifenol: "Phenetidine",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "1",
    pmids: "2912548",
  },
  {
    id: "8509",
    id_polifenol: "2188",
    polifenol: "3-fluoro-4-hydroxybenzoate",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "1",
    pmids: "27836974",
  },
  {
    id: "8510",
    id_polifenol: "4722",
    polifenol: "3,6-dichloro-2'-isopropyloxy-4'-methylflavone",
    id_cancer: "532",
    cancer: "Kidney Tumors",
    quant: "1",
    pmids: "9364471",
  },
  {
    id: "8511",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "551",
    cancer: "Mouth Cancer",
    quant: "22",
    pmids:
      "29663662,21963806,29102932,16158945,15905203,15769122,10953322,25263279,22432688,29212198,11205247,24907761,29207110,11396188,27266882,22993634,24439916,25521342,12584164,10823708,10363173,23898061",
  },
  {
    id: "8512",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "551",
    cancer: "Mouth Cancer",
    quant: "20",
    pmids:
      "10697534,15161016,28791378,25229239,27765374,23163860,22554995,14666669,26036622,25051199,28782139,29332583,20127863,28618017,11062735,29107813,23116961,25932049,10657978,23541947",
  },
  {
    id: "8513",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "551",
    cancer: "Mouth Cancer",
    quant: "32",
    pmids:
      "15816520,12820420,12004708,29039600,24329111,18053169,14569057,12553041,15905203,15769122,27200496,10953322,25263279,18248951,11911242,22923287,15649637,12954803,10624709,18336807,26133268,17004901,10823708,10363173,16098960,19588362,16859662,23771133,22084729,11435174,21481006,18259952",
  },
  {
    id: "8514",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "551",
    cancer: "Mouth Cancer",
    quant: "9",
    pmids:
      "16697418,15879678,19157822,23163860,11606383,21317023,10424744,28693294,25330185",
  },
  {
    id: "8515",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "551",
    cancer: "Mouth Cancer",
    quant: "2",
    pmids: "22432688,11724333",
  },
  {
    id: "8516",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "551",
    cancer: "Mouth Cancer",
    quant: "5",
    pmids: "19585476,16158945,27510965,29928342,29332583",
  },
  {
    id: "8517",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "551",
    cancer: "Mouth Cancer",
    quant: "24",
    pmids:
      "16309196,15816520,10697534,24249144,12004708,24329111,25721086,10628398,14569057,15161008,21292466,27200496,11911242,22923287,14666669,17196232,15649637,11205247,15538715,12954803,29332583,11396188,11062735,23541947",
  },
  {
    id: "8518",
    id_polifenol: "2167",
    polifenol: "phenolic acid",
    id_cancer: "551",
    cancer: "Mouth Cancer",
    quant: "5",
    pmids: "15769122,29332583,28679629,14704856,23898061",
  },
  {
    id: "8519",
    id_polifenol: "49",
    polifenol: "Aspirin",
    id_cancer: "551",
    cancer: "Mouth Cancer",
    quant: "5",
    pmids: "17191809,12807728,14674624,26919242,10874015",
  },
  {
    id: "8520",
    id_polifenol: "109",
    polifenol: "Catechin",
    id_cancer: "551",
    cancer: "Mouth Cancer",
    quant: "8",
    pmids:
      "24249144,12553041,15769122,15649637,1486850,19588362,7898128,29651001",
  },
  {
    id: "8521",
    id_polifenol: "125",
    polifenol: "Isoflavones",
    id_cancer: "551",
    cancer: "Mouth Cancer",
    quant: "5",
    pmids: "26423865,10953322,28962471,22432688,11724333",
  },
  {
    id: "8522",
    id_polifenol: "110",
    polifenol: "Chalcones",
    id_cancer: "551",
    cancer: "Mouth Cancer",
    quant: "5",
    pmids: "22115332,22324429,10953322,29212198,23898061",
  },
  {
    id: "8523",
    id_polifenol: "3089",
    polifenol: "1,1-diphenyl-2-picrylhydrazyl",
    id_cancer: "551",
    cancer: "Mouth Cancer",
    quant: "2",
    pmids: "25197631,22908592",
  },
  {
    id: "8524",
    id_polifenol: "114",
    polifenol: "Apigenin",
    id_cancer: "551",
    cancer: "Mouth Cancer",
    quant: "2",
    pmids: "24439916,21970806",
  },
  {
    id: "8525",
    id_polifenol: "113",
    polifenol: "Flavones",
    id_cancer: "551",
    cancer: "Mouth Cancer",
    quant: "1",
    pmids: "28962471",
  },
  {
    id: "8526",
    id_polifenol: "38",
    polifenol: "Gallic Acid",
    id_cancer: "551",
    cancer: "Mouth Cancer",
    quant: "12",
    pmids:
      "29033852,26851027,10697534,21164042,24859325,15161008,11497272,15769122,14666669,11205247,11396188,11062735",
  },
  {
    id: "8527",
    id_polifenol: "117",
    polifenol: "Luteolin",
    id_cancer: "551",
    cancer: "Mouth Cancer",
    quant: "1",
    pmids: "27266882",
  },
  {
    id: "8528",
    id_polifenol: "1",
    polifenol: "Phenols",
    id_cancer: "551",
    cancer: "Mouth Cancer",
    quant: "3",
    pmids: "24337492,11724365,11319278",
  },
  {
    id: "8529",
    id_polifenol: "7235",
    polifenol: "silybin",
    id_cancer: "551",
    cancer: "Mouth Cancer",
    quant: "1",
    pmids: "24907761",
  },
  {
    id: "8530",
    id_polifenol: "121",
    polifenol: "Kaempferols",
    id_cancer: "551",
    cancer: "Mouth Cancer",
    quant: "2",
    pmids: "19585476,24439916",
  },
  {
    id: "8531",
    id_polifenol: "871",
    polifenol: "ABT-737",
    id_cancer: "551",
    cancer: "Mouth Cancer",
    quant: "1",
    pmids: "26447615",
  },
  {
    id: "8532",
    id_polifenol: "6451",
    polifenol: "daidzein",
    id_cancer: "551",
    cancer: "Mouth Cancer",
    quant: "1",
    pmids: "22432688",
  },
  {
    id: "8533",
    id_polifenol: "7",
    polifenol: "Capsaicin",
    id_cancer: "551",
    cancer: "Mouth Cancer",
    quant: "1",
    pmids: "16942952",
  },
  {
    id: "8534",
    id_polifenol: "120",
    polifenol: "Flavonols",
    id_cancer: "551",
    cancer: "Mouth Cancer",
    quant: "1",
    pmids: "12584164",
  },
  {
    id: "8535",
    id_polifenol: "6062",
    polifenol: "naringenin",
    id_cancer: "551",
    cancer: "Mouth Cancer",
    quant: "1",
    pmids: "10823708",
  },
  {
    id: "8536",
    id_polifenol: "39",
    polifenol: "Hydrolyzable Tannins",
    id_cancer: "551",
    cancer: "Mouth Cancer",
    quant: "6",
    pmids: "11497272,25263279,11205247,11396188,10363173,11435174",
  },
  {
    id: "8537",
    id_polifenol: "130",
    polifenol: "Proanthocyanidins",
    id_cancer: "551",
    cancer: "Mouth Cancer",
    quant: "3",
    pmids: "22432688,22435612,10823708",
  },
  {
    id: "8538",
    id_polifenol: "35",
    polifenol: "Hydroquinones",
    id_cancer: "551",
    cancer: "Mouth Cancer",
    quant: "1",
    pmids: "11131635",
  },
  {
    id: "8539",
    id_polifenol: "111",
    polifenol: "Flavanones",
    id_cancer: "551",
    cancer: "Mouth Cancer",
    quant: "2",
    pmids: "10953322,23898061",
  },
  {
    id: "8540",
    id_polifenol: "4502",
    polifenol: "fisetin",
    id_cancer: "551",
    cancer: "Mouth Cancer",
    quant: "2",
    pmids: "29102932,23030699",
  },
  {
    id: "8541",
    id_polifenol: "75",
    polifenol: "Butylated Hydroxyanisole",
    id_cancer: "551",
    cancer: "Mouth Cancer",
    quant: "1",
    pmids: "11319278",
  },
  {
    id: "8542",
    id_polifenol: "4500",
    polifenol: "procyanidin",
    id_cancer: "551",
    cancer: "Mouth Cancer",
    quant: "1",
    pmids: "10823708",
  },
  {
    id: "8543",
    id_polifenol: "5608",
    polifenol: "epicatechin gallate",
    id_cancer: "551",
    cancer: "Mouth Cancer",
    quant: "1",
    pmids: "15649637",
  },
  {
    id: "8544",
    id_polifenol: "98",
    polifenol: "Propofol",
    id_cancer: "551",
    cancer: "Mouth Cancer",
    quant: "1",
    pmids: "23155237",
  },
  {
    id: "8545",
    id_polifenol: "5607",
    polifenol: "gallocatechol",
    id_cancer: "551",
    cancer: "Mouth Cancer",
    quant: "1",
    pmids: "15649637",
  },
  {
    id: "8546",
    id_polifenol: "5578",
    polifenol: "alpha-naphthoflavone",
    id_cancer: "551",
    cancer: "Mouth Cancer",
    quant: "2",
    pmids: "25051199,26919242",
  },
  {
    id: "8547",
    id_polifenol: "5808",
    polifenol: "isoliquiritigenin",
    id_cancer: "551",
    cancer: "Mouth Cancer",
    quant: "4",
    pmids: "16158945,25580586,29212198,23898061",
  },
  {
    id: "8548",
    id_polifenol: "2284",
    polifenol: "rosmarinic acid",
    id_cancer: "551",
    cancer: "Mouth Cancer",
    quant: "1",
    pmids: "22126613",
  },
  {
    id: "8549",
    id_polifenol: "1380",
    polifenol: "shogaol",
    id_cancer: "551",
    cancer: "Mouth Cancer",
    quant: "1",
    pmids: "26840796",
  },
  {
    id: "8550",
    id_polifenol: "2158",
    polifenol: "protocatechuic acid",
    id_cancer: "551",
    cancer: "Mouth Cancer",
    quant: "1",
    pmids: "8162581",
  },
  {
    id: "8551",
    id_polifenol: "81",
    polifenol: "Fenofibrate",
    id_cancer: "551",
    cancer: "Mouth Cancer",
    quant: "3",
    pmids: "28453233,27313493,21081159",
  },
  {
    id: "8552",
    id_polifenol: "5819",
    polifenol: "licochalcone A",
    id_cancer: "551",
    cancer: "Mouth Cancer",
    quant: "1",
    pmids: "24337492",
  },
  {
    id: "8553",
    id_polifenol: "4640",
    polifenol: "5,7-dihydroxy-6-methoxy-2-phenylchromen-4-one",
    id_cancer: "551",
    cancer: "Mouth Cancer",
    quant: "1",
    pmids: "10953322",
  },
  {
    id: "8554",
    id_polifenol: "452",
    polifenol: "acteoside",
    id_cancer: "551",
    cancer: "Mouth Cancer",
    quant: "1",
    pmids: "29536537",
  },
  {
    id: "8555",
    id_polifenol: "5614",
    polifenol: "catechin gallate",
    id_cancer: "551",
    cancer: "Mouth Cancer",
    quant: "1",
    pmids: "15649637",
  },
  {
    id: "8556",
    id_polifenol: "5455",
    polifenol: "theaflavin-3,3'-digallate",
    id_cancer: "551",
    cancer: "Mouth Cancer",
    quant: "1",
    pmids: "18248951",
  },
  {
    id: "8557",
    id_polifenol: "5815",
    polifenol: "dibenzoylmethane",
    id_cancer: "551",
    cancer: "Mouth Cancer",
    quant: "2",
    pmids: "15161016,10953322",
  },
  {
    id: "8558",
    id_polifenol: "5630",
    polifenol: "polyphenon E",
    id_cancer: "551",
    cancer: "Mouth Cancer",
    quant: "2",
    pmids: "17004901,16098960",
  },
  {
    id: "8559",
    id_polifenol: "7141",
    polifenol: "apigetrin",
    id_cancer: "551",
    cancer: "Mouth Cancer",
    quant: "1",
    pmids: "24106661",
  },
  {
    id: "8560",
    id_polifenol: "637",
    polifenol: "glabridin",
    id_cancer: "551",
    cancer: "Mouth Cancer",
    quant: "1",
    pmids: "29663662",
  },
  {
    id: "8561",
    id_polifenol: "6510",
    polifenol: "glycitein",
    id_cancer: "551",
    cancer: "Mouth Cancer",
    quant: "1",
    pmids: "22432688",
  },
  {
    id: "8562",
    id_polifenol: "4883",
    polifenol: "flavokawain B",
    id_cancer: "551",
    cancer: "Mouth Cancer",
    quant: "2",
    pmids: "22115332,22324429",
  },
  {
    id: "8563",
    id_polifenol: "896",
    polifenol: "polyphenon B",
    id_cancer: "551",
    cancer: "Mouth Cancer",
    quant: "4",
    pmids: "18053169,17004901,16098960,18259952",
  },
  {
    id: "8564",
    id_polifenol: "2343",
    polifenol: "ethyl gallate",
    id_cancer: "551",
    cancer: "Mouth Cancer",
    quant: "1",
    pmids: "28679629",
  },
  {
    id: "8565",
    id_polifenol: "4479",
    polifenol: "morin",
    id_cancer: "551",
    cancer: "Mouth Cancer",
    quant: "1",
    pmids: "12584164",
  },
  {
    id: "8566",
    id_polifenol: "6166",
    polifenol: "liquiritin",
    id_cancer: "551",
    cancer: "Mouth Cancer",
    quant: "1",
    pmids: "23898061",
  },
  {
    id: "8567",
    id_polifenol: "4578",
    polifenol: "5,7-dimethoxyflavone",
    id_cancer: "551",
    cancer: "Mouth Cancer",
    quant: "1",
    pmids: "15905203",
  },
  {
    id: "8568",
    id_polifenol: "6549",
    polifenol: "7-hydroxy-2',3',4',5',8-pentamethoxyisoflavan",
    id_cancer: "551",
    cancer: "Mouth Cancer",
    quant: "1",
    pmids: "10953322",
  },
  {
    id: "8569",
    id_polifenol: "416",
    polifenol: "phenoxy radical",
    id_cancer: "551",
    cancer: "Mouth Cancer",
    quant: "2",
    pmids: "11319278,11689156",
  },
  {
    id: "8570",
    id_polifenol: "444",
    polifenol: "2,4-di-tert-butylphenol",
    id_cancer: "551",
    cancer: "Mouth Cancer",
    quant: "1",
    pmids: "11689156",
  },
  {
    id: "8571",
    id_polifenol: "6711",
    polifenol: "3',4'-dimethoxyflavone",
    id_cancer: "551",
    cancer: "Mouth Cancer",
    quant: "1",
    pmids: "15905203",
  },
  {
    id: "8572",
    id_polifenol: "5909",
    polifenol: "licochalcone E",
    id_cancer: "551",
    cancer: "Mouth Cancer",
    quant: "1",
    pmids: "28521469",
  },
  {
    id: "8573",
    id_polifenol: "1867",
    polifenol: "creosol",
    id_cancer: "551",
    cancer: "Mouth Cancer",
    quant: "1",
    pmids: "11319278",
  },
  {
    id: "8574",
    id_polifenol: "4161",
    polifenol: "3,5-dihydroxyphenylglycine",
    id_cancer: "551",
    cancer: "Mouth Cancer",
    quant: "1",
    pmids: "24236200",
  },
  {
    id: "8575",
    id_polifenol: "7888",
    polifenol: "neoisoliquiritin",
    id_cancer: "551",
    cancer: "Mouth Cancer",
    quant: "1",
    pmids: "23898061",
  },
  {
    id: "8576",
    id_polifenol: "5809",
    polifenol: "sappanchalcone",
    id_cancer: "551",
    cancer: "Mouth Cancer",
    quant: "1",
    pmids: "21963806",
  },
  {
    id: "8577",
    id_polifenol: "3605",
    polifenol: "lyoniresinol",
    id_cancer: "551",
    cancer: "Mouth Cancer",
    quant: "1",
    pmids: "19950049",
  },
  {
    id: "8578",
    id_polifenol: "6766",
    polifenol: "glaziovianin A",
    id_cancer: "551",
    cancer: "Mouth Cancer",
    quant: "1",
    pmids: "26423865",
  },
  {
    id: "8579",
    id_polifenol: "7492",
    polifenol:
      "kaempferol 3-O-(3'',6''-di-O-E-p-coumaroyl)-beta-D-glucopyranoside",
    id_cancer: "551",
    cancer: "Mouth Cancer",
    quant: "1",
    pmids: "27982513",
  },
  {
    id: "8580",
    id_polifenol: "1159",
    polifenol: "2-(5-(3-fluorophenyl)-1H-pyrazol-3-yl)-5-methylphenol",
    id_cancer: "551",
    cancer: "Mouth Cancer",
    quant: "1",
    pmids: "28693294",
  },
  {
    id: "8581",
    id_polifenol: "335",
    polifenol: "2,4,6-tri-tert-butylphenol",
    id_cancer: "551",
    cancer: "Mouth Cancer",
    quant: "1",
    pmids: "11689156",
  },
  {
    id: "8582",
    id_polifenol: "1494",
    polifenol: "cinchonain Ib",
    id_cancer: "551",
    cancer: "Mouth Cancer",
    quant: "1",
    pmids: "10823708",
  },
  {
    id: "8583",
    id_polifenol: "1146",
    polifenol: "4-allyl-2-methoxy-6-(2-methylbut-3-en-2-yl)phenol",
    id_cancer: "551",
    cancer: "Mouth Cancer",
    quant: "1",
    pmids: "11319278",
  },
  {
    id: "8584",
    id_polifenol: "1525",
    polifenol: "3-hydroxy-1-(4'-hydroxy-3'-methoxy-phenyl)-hexan-5-one",
    id_cancer: "551",
    cancer: "Mouth Cancer",
    quant: "1",
    pmids: "10953322",
  },
  {
    id: "8585",
    id_polifenol: "1151",
    polifenol: "3,3',5,5'-tetra-tert-butyl-biphenyl-4,4'-diol",
    id_cancer: "551",
    cancer: "Mouth Cancer",
    quant: "1",
    pmids: "11689156",
  },
  {
    id: "8586",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "14",
    pmids:
      "21993665,20450969,15744083,25016375,18546141,20577025,15857606,25554015,29389889,20693966,23533482,22933043,29312799,17475387",
  },
  {
    id: "8587",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "12",
    pmids:
      "16502262,24528086,21924245,11522452,23415873,16648563,17927689,23486648,27857884,16843665,24798089,27318188",
  },
  {
    id: "8588",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "12",
    pmids:
      "11588135,14612961,11312805,19325839,11351279,22412883,24398169,17477351,20074931,15011755,25263976,24798089",
  },
  {
    id: "8589",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "5",
    pmids: "24394624,20101459,12963734,27114702,21901168",
  },
  {
    id: "8590",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "5",
    pmids: "8217365,18546268,8207961,12552999,15581598",
  },
  {
    id: "8591",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "9",
    pmids:
      "28573252,22685690,20577025,22412883,15857606,22613008,20693966,17475387,29606130",
  },
  {
    id: "8592",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "6",
    pmids: "11312805,19325839,17477351,25263976,29622866,10573539",
  },
  {
    id: "8593",
    id_polifenol: "2167",
    polifenol: "phenolic acid",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "3",
    pmids: "29642867,25554015,17475387",
  },
  {
    id: "8594",
    id_polifenol: "49",
    polifenol: "Aspirin",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "6",
    pmids: "23896061,20835687,23166597,20188076,12076251,15869467",
  },
  {
    id: "8595",
    id_polifenol: "109",
    polifenol: "Catechin",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "4",
    pmids: "19325839,17015253,17475387,10573539",
  },
  {
    id: "8596",
    id_polifenol: "125",
    polifenol: "Isoflavones",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "4",
    pmids: "18546268,12552999,15770547,15581598",
  },
  {
    id: "8597",
    id_polifenol: "110",
    polifenol: "Chalcones",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "10",
    pmids:
      "18702457,20450969,25016375,21816519,15110849,23257665,28526832,20668838,26019120,16828254",
  },
  {
    id: "8598",
    id_polifenol: "3089",
    polifenol: "1,1-diphenyl-2-picrylhydrazyl",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "4",
    pmids: "25554015,25753739,29329229,17475387",
  },
  {
    id: "8599",
    id_polifenol: "114",
    polifenol: "Apigenin",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "2",
    pmids: "27378243,15857606",
  },
  {
    id: "8600",
    id_polifenol: "113",
    polifenol: "Flavones",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "4",
    pmids: "20658136,25016375,20577025,18237024",
  },
  {
    id: "8601",
    id_polifenol: "38",
    polifenol: "Gallic Acid",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "4",
    pmids: "29642867,27168690,26794080,27853333",
  },
  {
    id: "8602",
    id_polifenol: "117",
    polifenol: "Luteolin",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "1",
    pmids: "27378243",
  },
  {
    id: "8603",
    id_polifenol: "1",
    polifenol: "Phenols",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "1",
    pmids: "9952372",
  },
  {
    id: "8604",
    id_polifenol: "129",
    polifenol: "Rotenone",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "2",
    pmids: "20510253,27486090",
  },
  {
    id: "8605",
    id_polifenol: "121",
    polifenol: "Kaempferols",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "2",
    pmids: "15857606,25246735",
  },
  {
    id: "8606",
    id_polifenol: "871",
    polifenol: "ABT-737",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "2",
    pmids: "21368833,21608150",
  },
  {
    id: "8607",
    id_polifenol: "6451",
    polifenol: "daidzein",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "3",
    pmids: "12552999,15770547,15581598",
  },
  {
    id: "8608",
    id_polifenol: "4634",
    polifenol: "alvocidib",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "4",
    pmids: "15385934,12669310,25914884,9427698",
  },
  {
    id: "8609",
    id_polifenol: "120",
    polifenol: "Flavonols",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "1",
    pmids: "17475387",
  },
  {
    id: "8610",
    id_polifenol: "4522",
    polifenol: "chrysin",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "3",
    pmids: "20577025,23533482,21785114",
  },
  {
    id: "8611",
    id_polifenol: "123",
    polifenol: "Rutin",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "1",
    pmids: "22685690",
  },
  {
    id: "8612",
    id_polifenol: "6062",
    polifenol: "naringenin",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "2",
    pmids: "15744083,22933043",
  },
  {
    id: "8613",
    id_polifenol: "39",
    polifenol: "Hydrolyzable Tannins",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "1",
    pmids: "25554015",
  },
  {
    id: "8614",
    id_polifenol: "111",
    polifenol: "Flavanones",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "2",
    pmids: "25016375,17475387",
  },
  {
    id: "8615",
    id_polifenol: "75",
    polifenol: "Butylated Hydroxyanisole",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "4",
    pmids: "8870842,18546268,12809360,21785114",
  },
  {
    id: "8616",
    id_polifenol: "15",
    polifenol: "Masoprocol",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "1",
    pmids: "17645780",
  },
  {
    id: "8617",
    id_polifenol: "6087",
    polifenol: "wogonin",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "1",
    pmids: "20658136",
  },
  {
    id: "8618",
    id_polifenol: "4519",
    polifenol: "myricetin",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "1",
    pmids: "15857606",
  },
  {
    id: "8619",
    id_polifenol: "4500",
    polifenol: "procyanidin",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "1",
    pmids: "19591805",
  },
  {
    id: "8620",
    id_polifenol: "5608",
    polifenol: "epicatechin gallate",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "1",
    pmids: "17477351",
  },
  {
    id: "8621",
    id_polifenol: "98",
    polifenol: "Propofol",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "1",
    pmids: "21749860",
  },
  {
    id: "8622",
    id_polifenol: "5607",
    polifenol: "gallocatechol",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "1",
    pmids: "26794080",
  },
  {
    id: "8623",
    id_polifenol: "44",
    polifenol: "Salicylates",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "1",
    pmids: "16432837",
  },
  {
    id: "8624",
    id_polifenol: "4559",
    polifenol: "theaflavin",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "2",
    pmids: "11312805,19812686",
  },
  {
    id: "8625",
    id_polifenol: "5808",
    polifenol: "isoliquiritigenin",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "1",
    pmids: "20668838",
  },
  {
    id: "8626",
    id_polifenol: "2344",
    polifenol: "methyl gallate",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "1",
    pmids: "11588135",
  },
  {
    id: "8627",
    id_polifenol: "47",
    polifenol: "Mesalamine",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "1",
    pmids: "11054378",
  },
  {
    id: "8628",
    id_polifenol: "2284",
    polifenol: "rosmarinic acid",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "3",
    pmids: "12898421,25554015,25141946",
  },
  {
    id: "8629",
    id_polifenol: "6455",
    polifenol: "nobiletin",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "1",
    pmids: "26690473",
  },
  {
    id: "8630",
    id_polifenol: "6063",
    polifenol: "naringin",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "1",
    pmids: "15744083",
  },
  {
    id: "8631",
    id_polifenol: "1380",
    polifenol: "shogaol",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "1",
    pmids: "24215632",
  },
  {
    id: "8632",
    id_polifenol: "93",
    polifenol: "Phloroglucinol",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "1",
    pmids: "27867229",
  },
  {
    id: "8633",
    id_polifenol: "81",
    polifenol: "Fenofibrate",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "1",
    pmids: "20417710",
  },
  {
    id: "8634",
    id_polifenol: "6461",
    polifenol: "acacetin",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "1",
    pmids: "21993665",
  },
  {
    id: "8635",
    id_polifenol: "119",
    polifenol: "Silymarin",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "1",
    pmids: "19782083",
  },
  {
    id: "8636",
    id_polifenol: "126",
    polifenol: "Coumestrol",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "1",
    pmids: "15770547",
  },
  {
    id: "8637",
    id_polifenol: "5844",
    polifenol: "4-dimethylamino-3',4'-dimethoxychalcone",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "8",
    pmids:
      "14634280,17442474,14530312,16364925,19464056,15072596,12794752,15313191",
  },
  {
    id: "8638",
    id_polifenol: "4537",
    polifenol: "flavone acetic acid",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "1",
    pmids: "12392157",
  },
  {
    id: "8639",
    id_polifenol: "1995",
    polifenol: "2-tert-butylhydroquinone",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "2",
    pmids: "19158375,28280124",
  },
  {
    id: "8640",
    id_polifenol: "89",
    polifenol: "Vanillic Acid",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "2",
    pmids: "29642867,25753739",
  },
  {
    id: "8641",
    id_polifenol: "7912",
    polifenol: "7,9,2',4'-tetrahydroxy-8-isopentenyl-5-methoxychalcone",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "1",
    pmids: "15770547",
  },
  {
    id: "8642",
    id_polifenol: "6097",
    polifenol: "8-prenylnaringenin",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "1",
    pmids: "22933043",
  },
  {
    id: "8643",
    id_polifenol: "7161",
    polifenol: "scutellarin",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "1",
    pmids: "29389889",
  },
  {
    id: "8644",
    id_polifenol: "36",
    polifenol: "Hydroxybenzoates",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "1",
    pmids: "29642867",
  },
  {
    id: "8645",
    id_polifenol: "5455",
    polifenol: "theaflavin-3,3'-digallate",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "1",
    pmids: "11312805",
  },
  {
    id: "8646",
    id_polifenol: "5815",
    polifenol: "dibenzoylmethane",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "1",
    pmids: "21924245",
  },
  {
    id: "8647",
    id_polifenol: "6510",
    polifenol: "glycitein",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "1",
    pmids: "12552999",
  },
  {
    id: "8648",
    id_polifenol: "128",
    polifenol: "Pterocarpans",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "1",
    pmids: "15770547",
  },
  {
    id: "8649",
    id_polifenol: "4521",
    polifenol: "3-hydroxyflavone",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "1",
    pmids: "20577025",
  },
  {
    id: "8650",
    id_polifenol: "7156",
    polifenol: "scutellarein",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "1",
    pmids: "29389889",
  },
  {
    id: "8651",
    id_polifenol: "6129",
    polifenol: "wogonoside",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "1",
    pmids: "27941168",
  },
  {
    id: "8652",
    id_polifenol: "2364",
    polifenol: "theaflavine gallate",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "1",
    pmids: "11312805",
  },
  {
    id: "8653",
    id_polifenol: "6100",
    polifenol: "pinostrobin",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "1",
    pmids: "20064598",
  },
  {
    id: "8654",
    id_polifenol: "2504",
    polifenol: "pentagalloylglucose",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "1",
    pmids: "14726525",
  },
  {
    id: "8655",
    id_polifenol: "4544",
    polifenol: "tiliroside",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "1",
    pmids: "17475387",
  },
  {
    id: "8656",
    id_polifenol: "5289",
    polifenol: "8-bromo-7-methoxychrysin",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "1",
    pmids: "21785114",
  },
  {
    id: "8657",
    id_polifenol: "2173",
    polifenol: "atranorin",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "1",
    pmids: "20837130",
  },
  {
    id: "8658",
    id_polifenol: "4082",
    polifenol: "3,3',4,4',5,5'-hexahydroxystilbene",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "1",
    pmids: "24398169",
  },
  {
    id: "8659",
    id_polifenol: "4574",
    polifenol: "sinensetin",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "1",
    pmids: "26690473",
  },
  {
    id: "8660",
    id_polifenol: "5669",
    polifenol: "pro-F-EGCG2",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "2",
    pmids: "19325839,17477351",
  },
  {
    id: "8661",
    id_polifenol: "2290",
    polifenol: "lobaric acid",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "1",
    pmids: "15549672",
  },
  {
    id: "8662",
    id_polifenol: "2066",
    polifenol: "NSC 680410",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "1",
    pmids: "12451475",
  },
  {
    id: "8663",
    id_polifenol: "46",
    polifenol: "Aminosalicylic Acid",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "1",
    pmids: "11054378",
  },
  {
    id: "8664",
    id_polifenol: "4482",
    polifenol: "peflavit",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "1",
    pmids: "20577025",
  },
  {
    id: "8665",
    id_polifenol: "815",
    polifenol: "theasinensin A",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "1",
    pmids: "11312805",
  },
  {
    id: "8666",
    id_polifenol: "3608",
    polifenol:
      "5-(5-ethyl-2-hydroxy-4-methoxyphenyl)-4-(4-methoxyphenyl)isoxazole",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "1",
    pmids: "25573372",
  },
  {
    id: "8667",
    id_polifenol: "1453",
    polifenol: "4-nerolidylcatechol",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "1",
    pmids: "28644062",
  },
  {
    id: "8668",
    id_polifenol: "4224",
    polifenol: "orsellinic acid",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "1",
    pmids: "19795841",
  },
  {
    id: "8669",
    id_polifenol: "5481",
    polifenol: "cyanidin-3-glycoside",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "1",
    pmids: "22412883",
  },
  {
    id: "8670",
    id_polifenol: "1423",
    polifenol: "Cancell",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "1",
    pmids: "22412883",
  },
  {
    id: "8671",
    id_polifenol: "5177",
    polifenol: "glycyrol",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "1",
    pmids: "20717871",
  },
  {
    id: "8672",
    id_polifenol: "4219",
    polifenol: "baeomycesic acid",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "1",
    pmids: "15549672",
  },
  {
    id: "8673",
    id_polifenol: "5178",
    polifenol: "Flavin7",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "1",
    pmids: "18597584",
  },
  {
    id: "8674",
    id_polifenol: "5639",
    polifenol: "4-(S-cysteinyl)epicatechin 3-O-gallate",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "1",
    pmids: "17477351",
  },
  {
    id: "8675",
    id_polifenol: "3564",
    polifenol: "2-(4'-methoxybenzylidene)-1-benzosuberone",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "1",
    pmids: "20450969",
  },
  {
    id: "8676",
    id_polifenol: "1337",
    polifenol: "3,3',4,4'-tetrahydroxystilbene",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "1",
    pmids: "24398169",
  },
  {
    id: "8677",
    id_polifenol: "5800",
    polifenol: "chalcone epoxide",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "1",
    pmids: "21816519",
  },
  {
    id: "8678",
    id_polifenol: "941",
    polifenol: "caftaric acid",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "1",
    pmids: "25554015",
  },
  {
    id: "8679",
    id_polifenol: "870",
    polifenol: "thiacalix(4)arene",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "1",
    pmids: "25735932",
  },
  {
    id: "8680",
    id_polifenol: "7783",
    polifenol: "bitucarpin A",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "1",
    pmids: "15770547",
  },
  {
    id: "8681",
    id_polifenol: "6154",
    polifenol: "4'-hydroxywogonin",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "1",
    pmids: "29397820",
  },
  {
    id: "8682",
    id_polifenol: "4206",
    polifenol: "5-(2'-oxoheptadecyl)resorcinol",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "1",
    pmids: "12562085",
  },
  {
    id: "8683",
    id_polifenol: "4207",
    polifenol: "5-(2'-oxononadecyl)resorcinol",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "1",
    pmids: "12562085",
  },
  {
    id: "8684",
    id_polifenol: "7784",
    polifenol: "erybraedin C",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "1",
    pmids: "15770547",
  },
  {
    id: "8685",
    id_polifenol: "6817",
    polifenol: "8-prenyldaidzein",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "1",
    pmids: "15770547",
  },
  {
    id: "8686",
    id_polifenol: "6656",
    polifenol: "bidwillon B",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "1",
    pmids: "15770547",
  },
  {
    id: "8687",
    id_polifenol: "5829",
    polifenol: "1-phenyl-1,2-propanedione",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "1",
    pmids: "29623853",
  },
  {
    id: "8688",
    id_polifenol: "2019",
    polifenol: "1,4-diacetoxy-2,3-dicyanobenzene",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "1",
    pmids: "2486910",
  },
  {
    id: "8689",
    id_polifenol: "4568",
    polifenol: "umuhengerin",
    id_cancer: "561",
    cancer: "Acute T-Lymphocytic Leukemia",
    quant: "1",
    pmids: "26690473",
  },
  {
    id: "8690",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "587",
    cancer: "Multiple Myeloma",
    quant: "13",
    pmids:
      "25810454,19653143,21172343,27329589,27703527,18633129,21824109,24397597,24460272,26735336,17197231,29179521,18465538",
  },
  {
    id: "8691",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "587",
    cancer: "Multiple Myeloma",
    quant: "21",
    pmids:
      "20712901,21275460,28322158,23784627,26521943,19383353,22012631,19756599,21859497,17197231,22791660,20726007,25517601,20818481,29085185,29719770,22795543,20924967,20055098,22335582,19505187",
  },
  {
    id: "8692",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "587",
    cancer: "Multiple Myeloma",
    quant: "14",
    pmids:
      "28751723,17475222,23521677,22673012,22257159,22012631,25824377,21824109,16115949,22351658,19190249,17197231,29047025,26863418",
  },
  {
    id: "8693",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "587",
    cancer: "Multiple Myeloma",
    quant: "6",
    pmids: "23813779,25982794,23308050,11872747,15389589,15581417",
  },
  {
    id: "8694",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "587",
    cancer: "Multiple Myeloma",
    quant: "4",
    pmids: "26718793,17197231,14530593,19505187",
  },
  {
    id: "8695",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "587",
    cancer: "Multiple Myeloma",
    quant: "6",
    pmids: "27329589,28677813,18633129,21090173,24397597,14530593",
  },
  {
    id: "8696",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "587",
    cancer: "Multiple Myeloma",
    quant: "12",
    pmids:
      "20011976,28751723,26264277,22257159,29687868,25824377,16115949,19190249,15201978,24798859,14530593,19505187",
  },
  {
    id: "8697",
    id_polifenol: "2167",
    polifenol: "phenolic acid",
    id_cancer: "587",
    cancer: "Multiple Myeloma",
    quant: "4",
    pmids: "23958424,23521677,25466029,24642698",
  },
  {
    id: "8698",
    id_polifenol: "49",
    polifenol: "Aspirin",
    id_cancer: "587",
    cancer: "Multiple Myeloma",
    quant: "6",
    pmids: "14961568,28356941,24766194,21159364,17488476,18608871",
  },
  {
    id: "8699",
    id_polifenol: "109",
    polifenol: "Catechin",
    id_cancer: "587",
    cancer: "Multiple Myeloma",
    quant: "1",
    pmids: "16115949",
  },
  {
    id: "8700",
    id_polifenol: "125",
    polifenol: "Isoflavones",
    id_cancer: "587",
    cancer: "Multiple Myeloma",
    quant: "1",
    pmids: "29857127",
  },
  {
    id: "8701",
    id_polifenol: "110",
    polifenol: "Chalcones",
    id_cancer: "587",
    cancer: "Multiple Myeloma",
    quant: "4",
    pmids: "19103760,22824846,21170936,23691159",
  },
  {
    id: "8702",
    id_polifenol: "3089",
    polifenol: "1,1-diphenyl-2-picrylhydrazyl",
    id_cancer: "587",
    cancer: "Multiple Myeloma",
    quant: "1",
    pmids: "17936865",
  },
  {
    id: "8703",
    id_polifenol: "114",
    polifenol: "Apigenin",
    id_cancer: "587",
    cancer: "Multiple Myeloma",
    quant: "6",
    pmids: "25810454,19653143,19576743,27930986,14530593,26863418",
  },
  {
    id: "8704",
    id_polifenol: "113",
    polifenol: "Flavones",
    id_cancer: "587",
    cancer: "Multiple Myeloma",
    quant: "2",
    pmids: "25810454,21816954",
  },
  {
    id: "8705",
    id_polifenol: "38",
    polifenol: "Gallic Acid",
    id_cancer: "587",
    cancer: "Multiple Myeloma",
    quant: "2",
    pmids: "17936865,24642698",
  },
  {
    id: "8706",
    id_polifenol: "117",
    polifenol: "Luteolin",
    id_cancer: "587",
    cancer: "Multiple Myeloma",
    quant: "4",
    pmids: "25810454,19653143,19576743,26863418",
  },
  {
    id: "8707",
    id_polifenol: "7235",
    polifenol: "silybin",
    id_cancer: "587",
    cancer: "Multiple Myeloma",
    quant: "2",
    pmids: "26936429,29179521",
  },
  {
    id: "8708",
    id_polifenol: "129",
    polifenol: "Rotenone",
    id_cancer: "587",
    cancer: "Multiple Myeloma",
    quant: "3",
    pmids: "12821677,23547759,7867713",
  },
  {
    id: "8709",
    id_polifenol: "871",
    polifenol: "ABT-737",
    id_cancer: "587",
    cancer: "Multiple Myeloma",
    quant: "11",
    pmids:
      "25122609,17460700,21159606,25008202,24030150,17255285,17200714,25181509,26939706,21659544,18451170",
  },
  {
    id: "8710",
    id_polifenol: "6451",
    polifenol: "daidzein",
    id_cancer: "587",
    cancer: "Multiple Myeloma",
    quant: "1",
    pmids: "14530593",
  },
  {
    id: "8711",
    id_polifenol: "6065",
    polifenol: "baicalein",
    id_cancer: "587",
    cancer: "Multiple Myeloma",
    quant: "5",
    pmids: "25810454,29039470,24460272,19576743,24468191",
  },
  {
    id: "8712",
    id_polifenol: "7",
    polifenol: "Capsaicin",
    id_cancer: "587",
    cancer: "Multiple Myeloma",
    quant: "1",
    pmids: "25929448",
  },
  {
    id: "8713",
    id_polifenol: "4634",
    polifenol: "alvocidib",
    id_cancer: "587",
    cancer: "Multiple Myeloma",
    quant: "6",
    pmids: "22964485,22558078,17187253,19509251,22512551,18465538",
  },
  {
    id: "8714",
    id_polifenol: "120",
    polifenol: "Flavonols",
    id_cancer: "587",
    cancer: "Multiple Myeloma",
    quant: "1",
    pmids: "23279849",
  },
  {
    id: "8715",
    id_polifenol: "4522",
    polifenol: "chrysin",
    id_cancer: "587",
    cancer: "Multiple Myeloma",
    quant: "3",
    pmids: "25810454,19653143,19576743",
  },
  {
    id: "8716",
    id_polifenol: "35",
    polifenol: "Hydroquinones",
    id_cancer: "587",
    cancer: "Multiple Myeloma",
    quant: "1",
    pmids: "17090671",
  },
  {
    id: "8717",
    id_polifenol: "4502",
    polifenol: "fisetin",
    id_cancer: "587",
    cancer: "Multiple Myeloma",
    quant: "1",
    pmids: "26863418",
  },
  {
    id: "8718",
    id_polifenol: "75",
    polifenol: "Butylated Hydroxyanisole",
    id_cancer: "587",
    cancer: "Multiple Myeloma",
    quant: "1",
    pmids: "19279006",
  },
  {
    id: "8719",
    id_polifenol: "15",
    polifenol: "Masoprocol",
    id_cancer: "587",
    cancer: "Multiple Myeloma",
    quant: "1",
    pmids: "18794123",
  },
  {
    id: "8720",
    id_polifenol: "6087",
    polifenol: "wogonin",
    id_cancer: "587",
    cancer: "Multiple Myeloma",
    quant: "4",
    pmids: "23142241,24460272,19576743,26735336",
  },
  {
    id: "8721",
    id_polifenol: "4519",
    polifenol: "myricetin",
    id_cancer: "587",
    cancer: "Multiple Myeloma",
    quant: "1",
    pmids: "18633129",
  },
  {
    id: "8722",
    id_polifenol: "4515",
    polifenol: "baicalin",
    id_cancer: "587",
    cancer: "Multiple Myeloma",
    quant: "2",
    pmids: "17007926,24460272",
  },
  {
    id: "8723",
    id_polifenol: "54",
    polifenol: "Salicylic Acid",
    id_cancer: "587",
    cancer: "Multiple Myeloma",
    quant: "2",
    pmids: "21618433,21788134",
  },
  {
    id: "8724",
    id_polifenol: "4559",
    polifenol: "theaflavin",
    id_cancer: "587",
    cancer: "Multiple Myeloma",
    quant: "1",
    pmids: "22351658",
  },
  {
    id: "8725",
    id_polifenol: "5808",
    polifenol: "isoliquiritigenin",
    id_cancer: "587",
    cancer: "Multiple Myeloma",
    quant: "1",
    pmids: "22648519",
  },
  {
    id: "8726",
    id_polifenol: "4708",
    polifenol: "xanthohumol",
    id_cancer: "587",
    cancer: "Multiple Myeloma",
    quant: "1",
    pmids: "18952893",
  },
  {
    id: "8727",
    id_polifenol: "4513",
    polifenol: "galangin",
    id_cancer: "587",
    cancer: "Multiple Myeloma",
    quant: "1",
    pmids: "26863418",
  },
  {
    id: "8728",
    id_polifenol: "1613",
    polifenol: "demethoxycurcumin",
    id_cancer: "587",
    cancer: "Multiple Myeloma",
    quant: "1",
    pmids: "29719770",
  },
  {
    id: "8729",
    id_polifenol: "6454",
    polifenol: "formononetin",
    id_cancer: "587",
    cancer: "Multiple Myeloma",
    quant: "1",
    pmids: "29857127",
  },
  {
    id: "8730",
    id_polifenol: "4253",
    polifenol:
      "5-(2,4-dihydroxy-5-isopropylphenyl)-4-(4-morpholin-4-ylmethylphenyl)isoxazole-3-carboxylic acid ethylamide",
    id_cancer: "587",
    cancer: "Multiple Myeloma",
    quant: "2",
    pmids: "23065523,20028416",
  },
  {
    id: "8731",
    id_polifenol: "5806",
    polifenol: "butein",
    id_cancer: "587",
    cancer: "Multiple Myeloma",
    quant: "3",
    pmids: "20699088,19103760,21170936",
  },
  {
    id: "8732",
    id_polifenol: "5844",
    polifenol: "4-dimethylamino-3',4'-dimethoxychalcone",
    id_cancer: "587",
    cancer: "Multiple Myeloma",
    quant: "2",
    pmids: "10580567,14634280",
  },
  {
    id: "8733",
    id_polifenol: "48",
    polifenol: "Anacardic Acids",
    id_cancer: "587",
    cancer: "Multiple Myeloma",
    quant: "2",
    pmids: "24853302,21757697",
  },
  {
    id: "8734",
    id_polifenol: "1995",
    polifenol: "2-tert-butylhydroquinone",
    id_cancer: "587",
    cancer: "Multiple Myeloma",
    quant: "1",
    pmids: "16014739",
  },
  {
    id: "8735",
    id_polifenol: "100",
    polifenol: "Resorcinols",
    id_cancer: "587",
    cancer: "Multiple Myeloma",
    quant: "1",
    pmids: "23896275",
  },
  {
    id: "8736",
    id_polifenol: "5850",
    polifenol: "cardamonin",
    id_cancer: "587",
    cancer: "Multiple Myeloma",
    quant: "1",
    pmids: "23691159",
  },
  {
    id: "8737",
    id_polifenol: "7912",
    polifenol: "7,9,2',4'-tetrahydroxy-8-isopentenyl-5-methoxychalcone",
    id_cancer: "587",
    cancer: "Multiple Myeloma",
    quant: "1",
    pmids: "18952893",
  },
  {
    id: "8738",
    id_polifenol: "1996",
    polifenol: "2,5-di-tert-butylhydroquinone",
    id_cancer: "587",
    cancer: "Multiple Myeloma",
    quant: "1",
    pmids: "16014739",
  },
  {
    id: "8739",
    id_polifenol: "5071",
    polifenol: "icaritin",
    id_cancer: "587",
    cancer: "Multiple Myeloma",
    quant: "1",
    pmids: "25865044",
  },
  {
    id: "8740",
    id_polifenol: "4585",
    polifenol: "baohuoside I",
    id_cancer: "587",
    cancer: "Multiple Myeloma",
    quant: "2",
    pmids: "21172343,29260980",
  },
  {
    id: "8741",
    id_polifenol: "1616",
    polifenol: "tetrahydrocurcumin",
    id_cancer: "587",
    cancer: "Multiple Myeloma",
    quant: "1",
    pmids: "29719770",
  },
  {
    id: "8742",
    id_polifenol: "2328",
    polifenol: "syringic acid",
    id_cancer: "587",
    cancer: "Multiple Myeloma",
    quant: "1",
    pmids: "23958424",
  },
  {
    id: "8743",
    id_polifenol: "5455",
    polifenol: "theaflavin-3,3'-digallate",
    id_cancer: "587",
    cancer: "Multiple Myeloma",
    quant: "1",
    pmids: "24371212",
  },
  {
    id: "8744",
    id_polifenol: "4304",
    polifenol: "5-7-oxo-zeaenol",
    id_cancer: "587",
    cancer: "Multiple Myeloma",
    quant: "1",
    pmids: "26227222",
  },
  {
    id: "8745",
    id_polifenol: "3019",
    polifenol: "nitroaspirin",
    id_cancer: "587",
    cancer: "Multiple Myeloma",
    quant: "1",
    pmids: "25609078",
  },
  {
    id: "8746",
    id_polifenol: "713",
    polifenol:
      "3-(3-chloro-4-hydroxyphenylamino)-4-(4-nitrophenyl)-1H-pyrrole-2,5-dione",
    id_cancer: "587",
    cancer: "Multiple Myeloma",
    quant: "1",
    pmids: "20920357",
  },
  {
    id: "8747",
    id_polifenol: "7156",
    polifenol: "scutellarein",
    id_cancer: "587",
    cancer: "Multiple Myeloma",
    quant: "1",
    pmids: "25810454",
  },
  {
    id: "8748",
    id_polifenol: "885",
    polifenol: "oleocanthal",
    id_cancer: "587",
    cancer: "Multiple Myeloma",
    quant: "1",
    pmids: "23521677",
  },
  {
    id: "8749",
    id_polifenol: "6129",
    polifenol: "wogonoside",
    id_cancer: "587",
    cancer: "Multiple Myeloma",
    quant: "1",
    pmids: "24460272",
  },
  {
    id: "8750",
    id_polifenol: "2697",
    polifenol: "4-trifluoromethylsalicylic acid",
    id_cancer: "587",
    cancer: "Multiple Myeloma",
    quant: "1",
    pmids: "23958424",
  },
  {
    id: "8751",
    id_polifenol: "2790",
    polifenol: "ginkgolic acid",
    id_cancer: "587",
    cancer: "Multiple Myeloma",
    quant: "1",
    pmids: "28208828",
  },
  {
    id: "8752",
    id_polifenol: "4479",
    polifenol: "morin",
    id_cancer: "587",
    cancer: "Multiple Myeloma",
    quant: "1",
    pmids: "23279849",
  },
  {
    id: "8753",
    id_polifenol: "5858",
    polifenol: "isobavachalcone",
    id_cancer: "587",
    cancer: "Multiple Myeloma",
    quant: "1",
    pmids: "22824846",
  },
  {
    id: "8754",
    id_polifenol: "6076",
    polifenol: "vexibinol",
    id_cancer: "587",
    cancer: "Multiple Myeloma",
    quant: "1",
    pmids: "23962443",
  },
  {
    id: "8755",
    id_polifenol: "5963",
    polifenol: "3,5,2',4'-tetrahydroxychalcone",
    id_cancer: "587",
    cancer: "Multiple Myeloma",
    quant: "2",
    pmids: "20699088,21170936",
  },
  {
    id: "8756",
    id_polifenol: "4677",
    polifenol: "baohuoside II",
    id_cancer: "587",
    cancer: "Multiple Myeloma",
    quant: "1",
    pmids: "29260980",
  },
  {
    id: "8757",
    id_polifenol: "3566",
    polifenol: "K 7174",
    id_cancer: "587",
    cancer: "Multiple Myeloma",
    quant: "2",
    pmids: "23878197,23593271",
  },
  {
    id: "8758",
    id_polifenol: "4689",
    polifenol: "5,3'-dihydroxy-3,6,7,8,4'-pentamethoxyflavone",
    id_cancer: "587",
    cancer: "Multiple Myeloma",
    quant: "1",
    pmids: "21816954",
  },
  {
    id: "8759",
    id_polifenol: "1642",
    polifenol: "FLLL 32",
    id_cancer: "587",
    cancer: "Multiple Myeloma",
    quant: "1",
    pmids: "20712901",
  },
  {
    id: "8760",
    id_polifenol: "6109",
    polifenol: "sophoraflavanone A",
    id_cancer: "587",
    cancer: "Multiple Myeloma",
    quant: "1",
    pmids: "23962443",
  },
  {
    id: "8761",
    id_polifenol: "4899",
    polifenol: "bavachin",
    id_cancer: "587",
    cancer: "Multiple Myeloma",
    quant: "1",
    pmids: "29477912",
  },
  {
    id: "8762",
    id_polifenol: "3029",
    polifenol: "NCX 4040",
    id_cancer: "587",
    cancer: "Multiple Myeloma",
    quant: "1",
    pmids: "25609078",
  },
  {
    id: "8763",
    id_polifenol: "6325",
    polifenol:
      "7-(4-(bis-(2-hydroxyethyl)amino)butoxy)-5-hydroxy-8-methoxy-2-phenylchromen-4-one",
    id_cancer: "587",
    cancer: "Multiple Myeloma",
    quant: "1",
    pmids: "27703527",
  },
  {
    id: "8764",
    id_polifenol: "2238",
    polifenol: "benzyl 2-hydroxy-3,6-dimethoxybenzoate",
    id_cancer: "587",
    cancer: "Multiple Myeloma",
    quant: "1",
    pmids: "23958424",
  },
  {
    id: "8765",
    id_polifenol: "3753",
    polifenol: "benzyl-2,6-dimethoxybenzoate",
    id_cancer: "587",
    cancer: "Multiple Myeloma",
    quant: "1",
    pmids: "23958424",
  },
  {
    id: "8766",
    id_polifenol: "6090",
    polifenol: "dioclein",
    id_cancer: "587",
    cancer: "Multiple Myeloma",
    quant: "1",
    pmids: "29039470",
  },
  {
    id: "8767",
    id_polifenol: "1614",
    polifenol: "curcumin 4,4'-diacetate",
    id_cancer: "587",
    cancer: "Multiple Myeloma",
    quant: "1",
    pmids: "29719770",
  },
  {
    id: "8768",
    id_polifenol: "6761",
    polifenol: "P276-00",
    id_cancer: "587",
    cancer: "Multiple Myeloma",
    quant: "1",
    pmids: "22512551",
  },
  {
    id: "8769",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "522",
    cancer: "Retinoblastoma",
    quant: "19",
    pmids:
      "25450235,28628830,25337553,20655656,18362328,28927086,23888052,22820424,29136761,24572052,10699950,17457054,23452983,15579072,21849051,12429923,10493518,25379883,16515531",
  },
  {
    id: "8770",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "522",
    cancer: "Retinoblastoma",
    quant: "17",
    pmids:
      "18156803,12483537,23761708,24550143,17240359,23950593,18450960,15738001,22489823,22470431,22510010,25495096,28420213,19895312,29901131,25749195,21730846",
  },
  {
    id: "8771",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "522",
    cancer: "Retinoblastoma",
    quant: "5",
    pmids: "11481417,20002680,23452983,26900409,25379883",
  },
  {
    id: "8772",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "522",
    cancer: "Retinoblastoma",
    quant: "15",
    pmids:
      "12851702,17513607,11533045,10537288,23948751,11241756,9652748,10910097,10714766,16322252,15138593,29067463,17143528,9679985,12547723",
  },
  {
    id: "8773",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "522",
    cancer: "Retinoblastoma",
    quant: "4",
    pmids: "28706438,9168007,15579072,25749195",
  },
  {
    id: "8774",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "522",
    cancer: "Retinoblastoma",
    quant: "5",
    pmids: "29237430,14767529,16049707,28927086,29901131",
  },
  {
    id: "8775",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "522",
    cancer: "Retinoblastoma",
    quant: "5",
    pmids: "20368822,20002680,9702540,11811957,25749195",
  },
  {
    id: "8776",
    id_polifenol: "2167",
    polifenol: "phenolic acid",
    id_cancer: "522",
    cancer: "Retinoblastoma",
    quant: "4",
    pmids: "23950593,22510010,25495096,29901131",
  },
  {
    id: "8777",
    id_polifenol: "49",
    polifenol: "Aspirin",
    id_cancer: "522",
    cancer: "Retinoblastoma",
    quant: "1",
    pmids: "8631005",
  },
  {
    id: "8778",
    id_polifenol: "109",
    polifenol: "Catechin",
    id_cancer: "522",
    cancer: "Retinoblastoma",
    quant: "1",
    pmids: "19147768",
  },
  {
    id: "8779",
    id_polifenol: "125",
    polifenol: "Isoflavones",
    id_cancer: "522",
    cancer: "Retinoblastoma",
    quant: "1",
    pmids: "15579072",
  },
  {
    id: "8780",
    id_polifenol: "3089",
    polifenol: "1,1-diphenyl-2-picrylhydrazyl",
    id_cancer: "522",
    cancer: "Retinoblastoma",
    quant: "2",
    pmids: "23452983,21849051",
  },
  {
    id: "8781",
    id_polifenol: "114",
    polifenol: "Apigenin",
    id_cancer: "522",
    cancer: "Retinoblastoma",
    quant: "5",
    pmids: "11299771,10699950,17457054,16648554,25965143",
  },
  {
    id: "8782",
    id_polifenol: "113",
    polifenol: "Flavones",
    id_cancer: "522",
    cancer: "Retinoblastoma",
    quant: "5",
    pmids: "17363486,10537362,12589031,22957647,25965143",
  },
  {
    id: "8783",
    id_polifenol: "38",
    polifenol: "Gallic Acid",
    id_cancer: "522",
    cancer: "Retinoblastoma",
    quant: "1",
    pmids: "21130856",
  },
  {
    id: "8784",
    id_polifenol: "117",
    polifenol: "Luteolin",
    id_cancer: "522",
    cancer: "Retinoblastoma",
    quant: "4",
    pmids: "16901994,20655656,18362328,25749195",
  },
  {
    id: "8785",
    id_polifenol: "1",
    polifenol: "Phenols",
    id_cancer: "522",
    cancer: "Retinoblastoma",
    quant: "1",
    pmids: "21849051",
  },
  {
    id: "8786",
    id_polifenol: "7235",
    polifenol: "silybin",
    id_cancer: "522",
    cancer: "Retinoblastoma",
    quant: "4",
    pmids: "19638451,12479270,23530816,12429923",
  },
  {
    id: "8787",
    id_polifenol: "129",
    polifenol: "Rotenone",
    id_cancer: "522",
    cancer: "Retinoblastoma",
    quant: "1",
    pmids: "29345333",
  },
  {
    id: "8788",
    id_polifenol: "121",
    polifenol: "Kaempferols",
    id_cancer: "522",
    cancer: "Retinoblastoma",
    quant: "1",
    pmids: "25337553",
  },
  {
    id: "8789",
    id_polifenol: "871",
    polifenol: "ABT-737",
    id_cancer: "522",
    cancer: "Retinoblastoma",
    quant: "1",
    pmids: "21955141",
  },
  {
    id: "8790",
    id_polifenol: "6065",
    polifenol: "baicalein",
    id_cancer: "522",
    cancer: "Retinoblastoma",
    quant: "2",
    pmids: "11980674,22820424",
  },
  {
    id: "8791",
    id_polifenol: "7",
    polifenol: "Capsaicin",
    id_cancer: "522",
    cancer: "Retinoblastoma",
    quant: "2",
    pmids: "14744780,22182671",
  },
  {
    id: "8792",
    id_polifenol: "4634",
    polifenol: "alvocidib",
    id_cancer: "522",
    cancer: "Retinoblastoma",
    quant: "20",
    pmids:
      "10537362,24572052,23908594,12589031,14612540,28176922,11641415,12669310,19174488,15078984,15868376,15867383,10493518,12839951,20663931,14667271,11823715,11426645,12030783,26053278",
  },
  {
    id: "8793",
    id_polifenol: "120",
    polifenol: "Flavonols",
    id_cancer: "522",
    cancer: "Retinoblastoma",
    quant: "3",
    pmids: "29237430,25337553,16317137",
  },
  {
    id: "8794",
    id_polifenol: "4522",
    polifenol: "chrysin",
    id_cancer: "522",
    cancer: "Retinoblastoma",
    quant: "1",
    pmids: "23888052",
  },
  {
    id: "8795",
    id_polifenol: "285",
    polifenol: "bisphenol A",
    id_cancer: "522",
    cancer: "Retinoblastoma",
    quant: "1",
    pmids: "19654912",
  },
  {
    id: "8796",
    id_polifenol: "4502",
    polifenol: "fisetin",
    id_cancer: "522",
    cancer: "Retinoblastoma",
    quant: "1",
    pmids: "16317137",
  },
  {
    id: "8797",
    id_polifenol: "6",
    polifenol: "Catechols",
    id_cancer: "522",
    cancer: "Retinoblastoma",
    quant: "1",
    pmids: "2909284",
  },
  {
    id: "8798",
    id_polifenol: "25",
    polifenol: "Butylated Hydroxytoluene",
    id_cancer: "522",
    cancer: "Retinoblastoma",
    quant: "2",
    pmids: "11403921,1933865",
  },
  {
    id: "8799",
    id_polifenol: "4500",
    polifenol: "procyanidin",
    id_cancer: "522",
    cancer: "Retinoblastoma",
    quant: "1",
    pmids: "15827326",
  },
  {
    id: "8800",
    id_polifenol: "1356",
    polifenol: "gingerol",
    id_cancer: "522",
    cancer: "Retinoblastoma",
    quant: "1",
    pmids: "29615601",
  },
  {
    id: "8801",
    id_polifenol: "44",
    polifenol: "Salicylates",
    id_cancer: "522",
    cancer: "Retinoblastoma",
    quant: "1",
    pmids: "12851702",
  },
  {
    id: "8802",
    id_polifenol: "4513",
    polifenol: "galangin",
    id_cancer: "522",
    cancer: "Retinoblastoma",
    quant: "2",
    pmids: "25450235,29136761",
  },
  {
    id: "8803",
    id_polifenol: "1611",
    polifenol: "bis(4-hydroxycinnamoyl)methane",
    id_cancer: "522",
    cancer: "Retinoblastoma",
    quant: "1",
    pmids: "23950593",
  },
  {
    id: "8804",
    id_polifenol: "55",
    polifenol: "Sodium Salicylate",
    id_cancer: "522",
    cancer: "Retinoblastoma",
    quant: "1",
    pmids: "12851702",
  },
  {
    id: "8805",
    id_polifenol: "108",
    polifenol: "Biflavonoids",
    id_cancer: "522",
    cancer: "Retinoblastoma",
    quant: "1",
    pmids: "21663495",
  },
  {
    id: "8806",
    id_polifenol: "6463",
    polifenol: "puerarin",
    id_cancer: "522",
    cancer: "Retinoblastoma",
    quant: "1",
    pmids: "29345333",
  },
  {
    id: "8807",
    id_polifenol: "2773",
    polifenol: "farnesylthiosalicylic acid",
    id_cancer: "522",
    cancer: "Retinoblastoma",
    quant: "2",
    pmids: "11920610,15958613",
  },
  {
    id: "8808",
    id_polifenol: "1644",
    polifenol: "Cur1 compound",
    id_cancer: "522",
    cancer: "Retinoblastoma",
    quant: "1",
    pmids: "22470431",
  },
  {
    id: "8809",
    id_polifenol: "4486",
    polifenol: "amentoflavone",
    id_cancer: "522",
    cancer: "Retinoblastoma",
    quant: "1",
    pmids: "21663495",
  },
  {
    id: "8810",
    id_polifenol: "7541",
    polifenol: "taxifolin",
    id_cancer: "522",
    cancer: "Retinoblastoma",
    quant: "1",
    pmids: "25379883",
  },
  {
    id: "8811",
    id_polifenol: "92",
    polifenol: "Triclosan",
    id_cancer: "522",
    cancer: "Retinoblastoma",
    quant: "3",
    pmids: "23816424,23181152,22151915",
  },
  {
    id: "8812",
    id_polifenol: "6576",
    polifenol: "5,7,4'-trihydroxyflavone",
    id_cancer: "522",
    cancer: "Retinoblastoma",
    quant: "2",
    pmids: "29136761,16648554",
  },
  {
    id: "8813",
    id_polifenol: "102",
    polifenol: "Zearalenone",
    id_cancer: "522",
    cancer: "Retinoblastoma",
    quant: "2",
    pmids: "11241756,9168007",
  },
  {
    id: "8814",
    id_polifenol: "5815",
    polifenol: "dibenzoylmethane",
    id_cancer: "522",
    cancer: "Retinoblastoma",
    quant: "1",
    pmids: "19706764",
  },
  {
    id: "8815",
    id_polifenol: "5630",
    polifenol: "polyphenon E",
    id_cancer: "522",
    cancer: "Retinoblastoma",
    quant: "1",
    pmids: "19147768",
  },
  {
    id: "8816",
    id_polifenol: "4052",
    polifenol: "bis-(3-(3',5'-di-tert-butyl-4'-hydroxyphenyl)propyl)sulfide",
    id_cancer: "522",
    cancer: "Retinoblastoma",
    quant: "2",
    pmids: "22661892,23452983",
  },
  {
    id: "8817",
    id_polifenol: "1689",
    polifenol: "16-hydroxyestrone",
    id_cancer: "522",
    cancer: "Retinoblastoma",
    quant: "1",
    pmids: "11719282",
  },
  {
    id: "8818",
    id_polifenol: "4639",
    polifenol: "aromadedrin",
    id_cancer: "522",
    cancer: "Retinoblastoma",
    quant: "1",
    pmids: "25379883",
  },
  {
    id: "8819",
    id_polifenol: "2807",
    polifenol: "thiosalicylic acid",
    id_cancer: "522",
    cancer: "Retinoblastoma",
    quant: "1",
    pmids: "11920610",
  },
  {
    id: "8820",
    id_polifenol: "3245",
    polifenol: "obovatol",
    id_cancer: "522",
    cancer: "Retinoblastoma",
    quant: "1",
    pmids: "21811927",
  },
  {
    id: "8821",
    id_polifenol: "2066",
    polifenol: "NSC 680410",
    id_cancer: "522",
    cancer: "Retinoblastoma",
    quant: "1",
    pmids: "16956884",
  },
  {
    id: "8822",
    id_polifenol: "4588",
    polifenol: "breviscapine",
    id_cancer: "522",
    cancer: "Retinoblastoma",
    quant: "1",
    pmids: "28628830",
  },
  {
    id: "8823",
    id_polifenol: "5065",
    polifenol: "3,5,6,7,8-pentahydroxy flavone",
    id_cancer: "522",
    cancer: "Retinoblastoma",
    quant: "1",
    pmids: "23543365",
  },
  {
    id: "8824",
    id_polifenol: "2242",
    polifenol: "atraric acid",
    id_cancer: "522",
    cancer: "Retinoblastoma",
    quant: "1",
    pmids: "25203674",
  },
  {
    id: "8825",
    id_polifenol: "559",
    polifenol: "squamosamide",
    id_cancer: "522",
    cancer: "Retinoblastoma",
    quant: "1",
    pmids: "21835169",
  },
  {
    id: "8826",
    id_polifenol: "4504",
    polifenol: "gossypin",
    id_cancer: "522",
    cancer: "Retinoblastoma",
    quant: "1",
    pmids: "23543365",
  },
  {
    id: "8827",
    id_polifenol: "4714",
    polifenol: "epimedin C",
    id_cancer: "522",
    cancer: "Retinoblastoma",
    quant: "1",
    pmids: "16112786",
  },
  {
    id: "8828",
    id_polifenol: "7485",
    polifenol:
      "kaempherol 3-O-beta-rhamnopyranosyl (1-6)-beta-D-glucopyranoside",
    id_cancer: "522",
    cancer: "Retinoblastoma",
    quant: "1",
    pmids: "29901131",
  },
  {
    id: "8829",
    id_polifenol: "799",
    polifenol: "calix(6)arene",
    id_cancer: "522",
    cancer: "Retinoblastoma",
    quant: "1",
    pmids: "23872419",
  },
  {
    id: "8830",
    id_polifenol: "5277",
    polifenol: "dehydroglyasperin D",
    id_cancer: "522",
    cancer: "Retinoblastoma",
    quant: "1",
    pmids: "27051646",
  },
  {
    id: "8831",
    id_polifenol: "3449",
    polifenol: "3-(4-bromo-phenoxy)-4,5-dihydroxybenzoic acid-methyl ester",
    id_cancer: "522",
    cancer: "Retinoblastoma",
    quant: "1",
    pmids: "21811927",
  },
  {
    id: "8832",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "21",
    pmids:
      "23877923,8519648,8084211,9374422,24398107,16158945,22113421,19768977,22184071,24632069,10953322,25779644,15117547,11205247,12479854,11396188,28865123,25579544,17765212,15949701,25632469",
  },
  {
    id: "8833",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "12",
    pmids:
      "17201156,10518003,18187158,11216470,8950193,14666669,21928294,10517978,9112258,16309195,10025876,19084262",
  },
  {
    id: "8834",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "12",
    pmids:
      "10518003,21391128,25270015,16484533,25636891,15749663,17570133,10953322,15117547,9570354,26052936,15248026",
  },
  {
    id: "8835",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "9",
    pmids:
      "22953963,16445569,15922006,16930595,25983101,16924673,20799280,22525867,25817574",
  },
  {
    id: "8836",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "7",
    pmids: "11642314,8084211,24632069,8950193,21966475,8547662,25144547",
  },
  {
    id: "8837",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "4",
    pmids: "9374422,16158945,24632069,12479854",
  },
  {
    id: "8838",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "14",
    pmids:
      "16309196,10518003,26022158,20950636,25636891,15749663,17570133,14666669,28103535,11205247,14981928,28766684,11396188,1602241",
  },
  {
    id: "8839",
    id_polifenol: "2167",
    polifenol: "phenolic acid",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "8",
    pmids:
      "10518003,25183268,19768977,12214859,28709826,11551496,26052936,28746550",
  },
  {
    id: "8840",
    id_polifenol: "109",
    polifenol: "Catechin",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "5",
    pmids: "25270015,15749663,17570133,28103535,15248026",
  },
  {
    id: "8841",
    id_polifenol: "125",
    polifenol: "Isoflavones",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "3",
    pmids: "11642314,10953322,10879475",
  },
  {
    id: "8842",
    id_polifenol: "110",
    polifenol: "Chalcones",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "2",
    pmids: "10953322,3021829",
  },
  {
    id: "8843",
    id_polifenol: "3089",
    polifenol: "1,1-diphenyl-2-picrylhydrazyl",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "7",
    pmids: "14672757,23892206,28709826,10879475,16177974,28746550,19084262",
  },
  {
    id: "8844",
    id_polifenol: "114",
    polifenol: "Apigenin",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "1",
    pmids: "22184071",
  },
  {
    id: "8845",
    id_polifenol: "113",
    polifenol: "Flavones",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "5",
    pmids: "16393120,8519648,11551495,17363486,17363487",
  },
  {
    id: "8846",
    id_polifenol: "38",
    polifenol: "Gallic Acid",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "9",
    pmids:
      "21868525,11456129,9891488,25183268,14666669,11205247,14981928,11396188,28746550",
  },
  {
    id: "8847",
    id_polifenol: "117",
    polifenol: "Luteolin",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "2",
    pmids: "22184071,21620995",
  },
  {
    id: "8848",
    id_polifenol: "1",
    polifenol: "Phenols",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "6",
    pmids: "16484533,18156402,26052936,11319278,19084262,21620995",
  },
  {
    id: "8849",
    id_polifenol: "105",
    polifenol: "Anthocyanins",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "2",
    pmids: "15922006,12888907",
  },
  {
    id: "8850",
    id_polifenol: "129",
    polifenol: "Rotenone",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "2",
    pmids: "11642314,29095437",
  },
  {
    id: "8851",
    id_polifenol: "121",
    polifenol: "Kaempferols",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "4",
    pmids: "25779644,28865123,17765212,15949701",
  },
  {
    id: "8852",
    id_polifenol: "6065",
    polifenol: "baicalein",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "1",
    pmids: "26050549",
  },
  {
    id: "8853",
    id_polifenol: "7",
    polifenol: "Capsaicin",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "3",
    pmids: "10518003,11216470,12214859",
  },
  {
    id: "8854",
    id_polifenol: "4634",
    polifenol: "alvocidib",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "1",
    pmids: "20638287",
  },
  {
    id: "8855",
    id_polifenol: "120",
    polifenol: "Flavonols",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "1",
    pmids: "14704326",
  },
  {
    id: "8856",
    id_polifenol: "4522",
    polifenol: "chrysin",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "2",
    pmids: "12479854,21785114",
  },
  {
    id: "8857",
    id_polifenol: "123",
    polifenol: "Rutin",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "1",
    pmids: "20015448",
  },
  {
    id: "8858",
    id_polifenol: "6062",
    polifenol: "naringenin",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "1",
    pmids: "22184071",
  },
  {
    id: "8859",
    id_polifenol: "39",
    polifenol: "Hydrolyzable Tannins",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "2",
    pmids: "11205247,11396188",
  },
  {
    id: "8860",
    id_polifenol: "35",
    polifenol: "Hydroquinones",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "1",
    pmids: "11131635",
  },
  {
    id: "8861",
    id_polifenol: "111",
    polifenol: "Flavanones",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "1",
    pmids: "10953322",
  },
  {
    id: "8862",
    id_polifenol: "6",
    polifenol: "Catechols",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "1",
    pmids: "14704326",
  },
  {
    id: "8863",
    id_polifenol: "25",
    polifenol: "Butylated Hydroxytoluene",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "1",
    pmids: "1933865",
  },
  {
    id: "8864",
    id_polifenol: "75",
    polifenol: "Butylated Hydroxyanisole",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "6",
    pmids: "25572414,19279006,11319278,21785114,11156257,9305611",
  },
  {
    id: "8865",
    id_polifenol: "6087",
    polifenol: "wogonin",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "1",
    pmids: "18377421",
  },
  {
    id: "8866",
    id_polifenol: "4515",
    polifenol: "baicalin",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "1",
    pmids: "11746275",
  },
  {
    id: "8867",
    id_polifenol: "1356",
    polifenol: "gingerol",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "2",
    pmids: "10518003,10025876",
  },
  {
    id: "8868",
    id_polifenol: "4559",
    polifenol: "theaflavin",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "1",
    pmids: "15248026",
  },
  {
    id: "8869",
    id_polifenol: "5808",
    polifenol: "isoliquiritigenin",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "1",
    pmids: "16158945",
  },
  {
    id: "8870",
    id_polifenol: "2344",
    polifenol: "methyl gallate",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "1",
    pmids: "19490839",
  },
  {
    id: "8871",
    id_polifenol: "2284",
    polifenol: "rosmarinic acid",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "1",
    pmids: "25636891",
  },
  {
    id: "8872",
    id_polifenol: "4513",
    polifenol: "galangin",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "1",
    pmids: "12479854",
  },
  {
    id: "8873",
    id_polifenol: "5489",
    polifenol: "delphinidin",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "1",
    pmids: "12888907",
  },
  {
    id: "8874",
    id_polifenol: "969",
    polifenol: "3,4-dihydroxyphenacyl caffeate phenylpropanoid ester",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "1",
    pmids: "23892206",
  },
  {
    id: "8875",
    id_polifenol: "4560",
    polifenol: "icariin",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "1",
    pmids: "10743057",
  },
  {
    id: "8876",
    id_polifenol: "48",
    polifenol: "Anacardic Acids",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "1",
    pmids: "29487199",
  },
  {
    id: "8877",
    id_polifenol: "4640",
    polifenol: "5,7-dihydroxy-6-methoxy-2-phenylchromen-4-one",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "1",
    pmids: "10953322",
  },
  {
    id: "8878",
    id_polifenol: "1995",
    polifenol: "2-tert-butylhydroquinone",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "1",
    pmids: "16014739",
  },
  {
    id: "8879",
    id_polifenol: "6482",
    polifenol: "tangeretin",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "1",
    pmids: "8519648",
  },
  {
    id: "8880",
    id_polifenol: "1866",
    polifenol: "4,6-dinitro-o-cresol",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "1",
    pmids: "21306911",
  },
  {
    id: "8881",
    id_polifenol: "7912",
    polifenol: "7,9,2',4'-tetrahydroxy-8-isopentenyl-5-methoxychalcone",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "1",
    pmids: "24901249",
  },
  {
    id: "8882",
    id_polifenol: "1996",
    polifenol: "2,5-di-tert-butylhydroquinone",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "1",
    pmids: "16014739",
  },
  {
    id: "8883",
    id_polifenol: "1616",
    polifenol: "tetrahydrocurcumin",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "1",
    pmids: "21928294",
  },
  {
    id: "8884",
    id_polifenol: "2328",
    polifenol: "syringic acid",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "1",
    pmids: "10879475",
  },
  {
    id: "8885",
    id_polifenol: "4525",
    polifenol: "eupatilin",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "2",
    pmids: "16393120,11551495",
  },
  {
    id: "8886",
    id_polifenol: "5455",
    polifenol: "theaflavin-3,3'-digallate",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "1",
    pmids: "15248026",
  },
  {
    id: "8887",
    id_polifenol: "2490",
    polifenol: "punicalagin",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "1",
    pmids: "19490839",
  },
  {
    id: "8888",
    id_polifenol: "5815",
    polifenol: "dibenzoylmethane",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "1",
    pmids: "10953322",
  },
  {
    id: "8889",
    id_polifenol: "7141",
    polifenol: "apigetrin",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "3",
    pmids: "22113421,24106661,17485840",
  },
  {
    id: "8890",
    id_polifenol: "637",
    polifenol: "glabridin",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "1",
    pmids: "24901249",
  },
  {
    id: "8891",
    id_polifenol: "6510",
    polifenol: "glycitein",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "1",
    pmids: "11642314",
  },
  {
    id: "8892",
    id_polifenol: "6554",
    polifenol: "tectorigenin",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "1",
    pmids: "11642314",
  },
  {
    id: "8893",
    id_polifenol: "1747",
    polifenol: "6-paradol",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "3",
    pmids: "10518003,11551496,10025876",
  },
  {
    id: "8894",
    id_polifenol: "12",
    polifenol: "Guaiacol",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "1",
    pmids: "19084262",
  },
  {
    id: "8895",
    id_polifenol: "2343",
    polifenol: "ethyl gallate",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "1",
    pmids: "23109891",
  },
  {
    id: "8896",
    id_polifenol: "2331",
    polifenol: "8-(N,N-diethylamino)octyl-3,4,5-trimethoxybenzoate",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "1",
    pmids: "9398053",
  },
  {
    id: "8897",
    id_polifenol: "2364",
    polifenol: "theaflavine gallate",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "1",
    pmids: "15248026",
  },
  {
    id: "8898",
    id_polifenol: "6774",
    polifenol: "5,7-dihydroxy-6,3',4'-trimethoxyflavone",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "2",
    pmids: "16393120,11551495",
  },
  {
    id: "8899",
    id_polifenol: "428",
    polifenol: "2,2'-bisphenol F",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "1",
    pmids: "12888907",
  },
  {
    id: "8900",
    id_polifenol: "6453",
    polifenol: "cirsimaritin",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "1",
    pmids: "22184071",
  },
  {
    id: "8901",
    id_polifenol: "6549",
    polifenol: "7-hydroxy-2',3',4',5',8-pentamethoxyisoflavan",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "1",
    pmids: "10953322",
  },
  {
    id: "8902",
    id_polifenol: "839",
    polifenol: "5-iodo-3-((3,5-dibromo-4-hydroxyphenyl)methylene)-2-indolinone",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "1",
    pmids: "25817574",
  },
  {
    id: "8903",
    id_polifenol: "416",
    polifenol: "phenoxy radical",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "1",
    pmids: "11319278",
  },
  {
    id: "8904",
    id_polifenol: "5289",
    polifenol: "8-bromo-7-methoxychrysin",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "1",
    pmids: "21785114",
  },
  {
    id: "8905",
    id_polifenol: "962",
    polifenol: "2,6-di-tert-butyl-4-methylphenol",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "2",
    pmids: "14704326,19084262",
  },
  {
    id: "8906",
    id_polifenol: "4558",
    polifenol: "2'-hydroxyflavone",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "1",
    pmids: "22184071",
  },
  {
    id: "8907",
    id_polifenol: "5101",
    polifenol: "isokaempferide",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "1",
    pmids: "22184071",
  },
  {
    id: "8908",
    id_polifenol: "6555",
    polifenol: "tectoridin",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "1",
    pmids: "11642314",
  },
  {
    id: "8909",
    id_polifenol: "4082",
    polifenol: "3,3',4,4',5,5'-hexahydroxystilbene",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "2",
    pmids: "17065056,16982330",
  },
  {
    id: "8910",
    id_polifenol: "1867",
    polifenol: "creosol",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "2",
    pmids: "27432798,11319278",
  },
  {
    id: "8911",
    id_polifenol: "393",
    polifenol: "2,6-di-tert-butylphenol",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "1",
    pmids: "19084262",
  },
  {
    id: "8912",
    id_polifenol: "6587",
    polifenol: "glycitin",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "1",
    pmids: "11642314",
  },
  {
    id: "8913",
    id_polifenol: "6647",
    polifenol: "6-methylflavone",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "1",
    pmids: "23877923",
  },
  {
    id: "8914",
    id_polifenol: "1725",
    polifenol: "yakuchinone-A",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "3",
    pmids: "10518003,12201673,10517978",
  },
  {
    id: "8915",
    id_polifenol: "5791",
    polifenol: "metochalcone",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "1",
    pmids: "25057485",
  },
  {
    id: "8916",
    id_polifenol: "689",
    polifenol: "3,4-dixydroxyphenylethanol elenolic acid",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "1",
    pmids: "16484533",
  },
  {
    id: "8917",
    id_polifenol: "6752",
    polifenol: "zapotin",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "1",
    pmids: "17228877",
  },
  {
    id: "8918",
    id_polifenol: "6616",
    polifenol: "xanthomicrol",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "1",
    pmids: "22184071",
  },
  {
    id: "8919",
    id_polifenol: "2531",
    polifenol: "sanguiin H-5",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "1",
    pmids: "19490839",
  },
  {
    id: "8920",
    id_polifenol: "392",
    polifenol: "2-tert-butylphenol",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "1",
    pmids: "19084262",
  },
  {
    id: "8921",
    id_polifenol: "4195",
    polifenol: "climacostol",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "1",
    pmids: "18723007",
  },
  {
    id: "8922",
    id_polifenol: "6664",
    polifenol: "8-hydroxydaidzein",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "1",
    pmids: "10879475",
  },
  {
    id: "8923",
    id_polifenol: "6840",
    polifenol: "calycopterin",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "1",
    pmids: "22184071",
  },
  {
    id: "8924",
    id_polifenol: "1738",
    polifenol: "dehydroparadol",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "1",
    pmids: "11551496",
  },
  {
    id: "8925",
    id_polifenol: "335",
    polifenol: "2,4,6-tri-tert-butylphenol",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "1",
    pmids: "19084262",
  },
  {
    id: "8926",
    id_polifenol: "6562",
    polifenol: "6''-O-xylosyltectoridin",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "1",
    pmids: "11642314",
  },
  {
    id: "8927",
    id_polifenol: "2376",
    polifenol: "3,4-methylenedioxyphenyl 3,4,5-trihydroxybenzoate",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "1",
    pmids: "11456129",
  },
  {
    id: "8928",
    id_polifenol: "1146",
    polifenol: "4-allyl-2-methoxy-6-(2-methylbut-3-en-2-yl)phenol",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "1",
    pmids: "11319278",
  },
  {
    id: "8929",
    id_polifenol: "6918",
    polifenol: "6-hydroxygenistein-7-O-beta-D-glucopyranoside",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "1",
    pmids: "10879475",
  },
  {
    id: "8930",
    id_polifenol: "4825",
    polifenol: "7,4'-dihydroxy-8-methylflavone",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "1",
    pmids: "23877923",
  },
  {
    id: "8931",
    id_polifenol: "7054",
    polifenol: "2'-methoxy-6-methylflavone",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "1",
    pmids: "23877923",
  },
  {
    id: "8932",
    id_polifenol: "6319",
    polifenol: "5,6-dihydroxy-7-prenyloxyflavone",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "1",
    pmids: "24398107",
  },
  {
    id: "8933",
    id_polifenol: "6320",
    polifenol: "3-hydroxy-7-geranyloxyflavone",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "1",
    pmids: "24398107",
  },
  {
    id: "8934",
    id_polifenol: "2532",
    polifenol: "tannin 1-alpha-O-galloylpunicalagin",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "1",
    pmids: "19490839",
  },
  {
    id: "8935",
    id_polifenol: "3607",
    polifenol: "1-(3,.4-dimethoxyphenyl)-3,5-dodecenedione",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "1",
    pmids: "15927254",
  },
  {
    id: "8936",
    id_polifenol: "1726",
    polifenol: "gingerdione",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "1",
    pmids: "15927254",
  },
  {
    id: "8937",
    id_polifenol: "2377",
    polifenol: "3,4-methylenedioxyphenyl 3,4,5--trihydroxythiobenzoate",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "1",
    pmids: "11456129",
  },
  {
    id: "8938",
    id_polifenol: "1525",
    polifenol: "3-hydroxy-1-(4'-hydroxy-3'-methoxy-phenyl)-hexan-5-one",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "1",
    pmids: "10953322",
  },
  {
    id: "8939",
    id_polifenol: "1034",
    polifenol: "hericenone J",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "1",
    pmids: "25306354",
  },
  {
    id: "8940",
    id_polifenol: "2734",
    polifenol: "Listerine",
    id_cancer: "15825",
    cancer: "Leukemia, Promyelocytic, Acute",
    quant: "1",
    pmids: "29777637",
  },
  {
    id: "8941",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "541",
    cancer: "Endometrial Cancer",
    quant: "13",
    pmids:
      "21554918,27708238,23274058,29665555,26989859,29693162,16019205,19250196,19007764,8808829,23479390,21568892,25346613",
  },
  {
    id: "8942",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "541",
    cancer: "Endometrial Cancer",
    quant: "10",
    pmids:
      "28402926,20235152,19823063,26622667,17590421,11506814,20038303,15340658,23305490,28457934",
  },
  {
    id: "8943",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "541",
    cancer: "Endometrial Cancer",
    quant: "5",
    pmids: "22959059,12469199,12964000,28467979,21878663",
  },
  {
    id: "8944",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "541",
    cancer: "Endometrial Cancer",
    quant: "13",
    pmids:
      "29285074,14645498,23274058,29328374,18097584,21912264,22662154,25068805,29067463,21781587,16239258,17991320,21671179",
  },
  {
    id: "8945",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "541",
    cancer: "Endometrial Cancer",
    quant: "21",
    pmids:
      "23580227,29636868,21281625,17051425,19549922,12840226,15528307,23513474,11753986,19733663,23216111,24379833,18980187,14691461,24473144,19371625,21612459,18437911,15968319,23019147,16705744",
  },
  {
    id: "8946",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "541",
    cancer: "Endometrial Cancer",
    quant: "5",
    pmids: "12469199,11506814,19250196,19007764,25346613",
  },
  {
    id: "8947",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "541",
    cancer: "Endometrial Cancer",
    quant: "4",
    pmids: "22959059,22923012,29024813,19321194",
  },
  {
    id: "8948",
    id_polifenol: "2167",
    polifenol: "phenolic acid",
    id_cancer: "541",
    cancer: "Endometrial Cancer",
    quant: "2",
    pmids: "28552912,19007764",
  },
  {
    id: "8949",
    id_polifenol: "49",
    polifenol: "Aspirin",
    id_cancer: "541",
    cancer: "Endometrial Cancer",
    quant: "6",
    pmids: "15546508,11239649,17316360,10714217,9736731,18045204",
  },
  {
    id: "8950",
    id_polifenol: "125",
    polifenol: "Isoflavones",
    id_cancer: "541",
    cancer: "Endometrial Cancer",
    quant: "9",
    pmids:
      "19874114,16773531,29636868,17659312,23216111,24473144,19250196,21612459,22464681",
  },
  {
    id: "8951",
    id_polifenol: "110",
    polifenol: "Chalcones",
    id_cancer: "541",
    cancer: "Endometrial Cancer",
    quant: "1",
    pmids: "23874474",
  },
  {
    id: "8952",
    id_polifenol: "114",
    polifenol: "Apigenin",
    id_cancer: "541",
    cancer: "Endometrial Cancer",
    quant: "1",
    pmids: "15931582",
  },
  {
    id: "8953",
    id_polifenol: "1",
    polifenol: "Phenols",
    id_cancer: "541",
    cancer: "Endometrial Cancer",
    quant: "6",
    pmids: "10926802,15205340,6592168,12870885,12788426,15720121",
  },
  {
    id: "8954",
    id_polifenol: "105",
    polifenol: "Anthocyanins",
    id_cancer: "541",
    cancer: "Endometrial Cancer",
    quant: "1",
    pmids: "26395027",
  },
  {
    id: "8955",
    id_polifenol: "129",
    polifenol: "Rotenone",
    id_cancer: "541",
    cancer: "Endometrial Cancer",
    quant: "2",
    pmids: "16773531,12840226",
  },
  {
    id: "8956",
    id_polifenol: "6451",
    polifenol: "daidzein",
    id_cancer: "541",
    cancer: "Endometrial Cancer",
    quant: "3",
    pmids: "16773531,23513474,23216111",
  },
  {
    id: "8957",
    id_polifenol: "6062",
    polifenol: "naringenin",
    id_cancer: "541",
    cancer: "Endometrial Cancer",
    quant: "1",
    pmids: "19733663",
  },
  {
    id: "8958",
    id_polifenol: "285",
    polifenol: "bisphenol A",
    id_cancer: "541",
    cancer: "Endometrial Cancer",
    quant: "5",
    pmids: "26546977,16029874,18980187,19371625,23019147",
  },
  {
    id: "8959",
    id_polifenol: "6",
    polifenol: "Catechols",
    id_cancer: "541",
    cancer: "Endometrial Cancer",
    quant: "7",
    pmids: "10813650,10649967,18566989,12870885,19158089,11743747,25346613",
  },
  {
    id: "8960",
    id_polifenol: "54",
    polifenol: "Salicylic Acid",
    id_cancer: "541",
    cancer: "Endometrial Cancer",
    quant: "1",
    pmids: "18045204",
  },
  {
    id: "8961",
    id_polifenol: "98",
    polifenol: "Propofol",
    id_cancer: "541",
    cancer: "Endometrial Cancer",
    quant: "1",
    pmids: "29490000",
  },
  {
    id: "8962",
    id_polifenol: "5578",
    polifenol: "alpha-naphthoflavone",
    id_cancer: "541",
    cancer: "Endometrial Cancer",
    quant: "2",
    pmids: "10619402,12127040",
  },
  {
    id: "8963",
    id_polifenol: "44",
    polifenol: "Salicylates",
    id_cancer: "541",
    cancer: "Endometrial Cancer",
    quant: "1",
    pmids: "8939643",
  },
  {
    id: "8964",
    id_polifenol: "5808",
    polifenol: "isoliquiritigenin",
    id_cancer: "541",
    cancer: "Endometrial Cancer",
    quant: "2",
    pmids: "27708238,23874474",
  },
  {
    id: "8965",
    id_polifenol: "2344",
    polifenol: "methyl gallate",
    id_cancer: "541",
    cancer: "Endometrial Cancer",
    quant: "1",
    pmids: "22923012",
  },
  {
    id: "8966",
    id_polifenol: "4708",
    polifenol: "xanthohumol",
    id_cancer: "541",
    cancer: "Endometrial Cancer",
    quant: "2",
    pmids: "16019205,23874474",
  },
  {
    id: "8967",
    id_polifenol: "112",
    polifenol: "Hesperidin",
    id_cancer: "541",
    cancer: "Endometrial Cancer",
    quant: "1",
    pmids: "29665555",
  },
  {
    id: "8968",
    id_polifenol: "10",
    polifenol: "Estrogens, Catechol",
    id_cancer: "541",
    cancer: "Endometrial Cancer",
    quant: "5",
    pmids: "18089588,10813650,18566989,12870885,12810635",
  },
  {
    id: "8969",
    id_polifenol: "2158",
    polifenol: "protocatechuic acid",
    id_cancer: "541",
    cancer: "Endometrial Cancer",
    quant: "1",
    pmids: "28229391",
  },
  {
    id: "8970",
    id_polifenol: "93",
    polifenol: "Phloroglucinol",
    id_cancer: "541",
    cancer: "Endometrial Cancer",
    quant: "1",
    pmids: "22464681",
  },
  {
    id: "8971",
    id_polifenol: "6454",
    polifenol: "formononetin",
    id_cancer: "541",
    cancer: "Endometrial Cancer",
    quant: "1",
    pmids: "16773531",
  },
  {
    id: "8972",
    id_polifenol: "81",
    polifenol: "Fenofibrate",
    id_cancer: "541",
    cancer: "Endometrial Cancer",
    quant: "2",
    pmids: "16569247,15299082",
  },
  {
    id: "8973",
    id_polifenol: "4253",
    polifenol:
      "5-(2,4-dihydroxy-5-isopropylphenyl)-4-(4-morpholin-4-ylmethylphenyl)isoxazole-3-carboxylic acid ethylamide",
    id_cancer: "541",
    cancer: "Endometrial Cancer",
    quant: "1",
    pmids: "26604096",
  },
  {
    id: "8974",
    id_polifenol: "107",
    polifenol: "beta-Naphthoflavone",
    id_cancer: "541",
    cancer: "Endometrial Cancer",
    quant: "1",
    pmids: "10619402",
  },
  {
    id: "8975",
    id_polifenol: "69",
    polifenol: "Phenolsulfonphthalein",
    id_cancer: "541",
    cancer: "Endometrial Cancer",
    quant: "2",
    pmids: "2706624,21541621",
  },
  {
    id: "8976",
    id_polifenol: "126",
    polifenol: "Coumestrol",
    id_cancer: "541",
    cancer: "Endometrial Cancer",
    quant: "1",
    pmids: "19007764",
  },
  {
    id: "8977",
    id_polifenol: "969",
    polifenol: "3,4-dihydroxyphenacyl caffeate phenylpropanoid ester",
    id_cancer: "541",
    cancer: "Endometrial Cancer",
    quant: "1",
    pmids: "16198557",
  },
  {
    id: "8978",
    id_polifenol: "2773",
    polifenol: "farnesylthiosalicylic acid",
    id_cancer: "541",
    cancer: "Endometrial Cancer",
    quant: "1",
    pmids: "23530112",
  },
  {
    id: "8979",
    id_polifenol: "1673",
    polifenol: "4-hydroxyestradiol",
    id_cancer: "541",
    cancer: "Endometrial Cancer",
    quant: "2",
    pmids: "21344307,18566989",
  },
  {
    id: "8980",
    id_polifenol: "452",
    polifenol: "acteoside",
    id_cancer: "541",
    cancer: "Endometrial Cancer",
    quant: "1",
    pmids: "16198557",
  },
  {
    id: "8981",
    id_polifenol: "1866",
    polifenol: "4,6-dinitro-o-cresol",
    id_cancer: "541",
    cancer: "Endometrial Cancer",
    quant: "1",
    pmids: "1933868",
  },
  {
    id: "8982",
    id_polifenol: "6097",
    polifenol: "8-prenylnaringenin",
    id_cancer: "541",
    cancer: "Endometrial Cancer",
    quant: "3",
    pmids: "16019205,19733663,23874474",
  },
  {
    id: "8983",
    id_polifenol: "5071",
    polifenol: "icaritin",
    id_cancer: "541",
    cancer: "Endometrial Cancer",
    quant: "1",
    pmids: "21408143",
  },
  {
    id: "8984",
    id_polifenol: "6086",
    polifenol: "liquiritigenin",
    id_cancer: "541",
    cancer: "Endometrial Cancer",
    quant: "1",
    pmids: "23874474",
  },
  {
    id: "8985",
    id_polifenol: "102",
    polifenol: "Zearalenone",
    id_cancer: "541",
    cancer: "Endometrial Cancer",
    quant: "1",
    pmids: "19371625",
  },
  {
    id: "8986",
    id_polifenol: "4525",
    polifenol: "eupatilin",
    id_cancer: "541",
    cancer: "Endometrial Cancer",
    quant: "2",
    pmids: "21554918,29693162",
  },
  {
    id: "8987",
    id_polifenol: "637",
    polifenol: "glabridin",
    id_cancer: "541",
    cancer: "Endometrial Cancer",
    quant: "2",
    pmids: "26594762,25816349",
  },
  {
    id: "8988",
    id_polifenol: "7557",
    polifenol: "rhamnetin",
    id_cancer: "541",
    cancer: "Endometrial Cancer",
    quant: "1",
    pmids: "12870885",
  },
  {
    id: "8989",
    id_polifenol: "2574",
    polifenol: "4-hydroxybenzoic acid",
    id_cancer: "541",
    cancer: "Endometrial Cancer",
    quant: "1",
    pmids: "28229391",
  },
  {
    id: "8990",
    id_polifenol: "6554",
    polifenol: "tectorigenin",
    id_cancer: "541",
    cancer: "Endometrial Cancer",
    quant: "1",
    pmids: "15931582",
  },
  {
    id: "8991",
    id_polifenol: "6175",
    polifenol: "2'-hydroxyflavanone",
    id_cancer: "541",
    cancer: "Endometrial Cancer",
    quant: "1",
    pmids: "19007764",
  },
  {
    id: "8992",
    id_polifenol: "2697",
    polifenol: "4-trifluoromethylsalicylic acid",
    id_cancer: "541",
    cancer: "Endometrial Cancer",
    quant: "1",
    pmids: "28552912",
  },
  {
    id: "8993",
    id_polifenol: "315",
    polifenol: "bakuchiol",
    id_cancer: "541",
    cancer: "Endometrial Cancer",
    quant: "1",
    pmids: "26419930",
  },
  {
    id: "8994",
    id_polifenol: "1689",
    polifenol: "16-hydroxyestrone",
    id_cancer: "541",
    cancer: "Endometrial Cancer",
    quant: "1",
    pmids: "21600284",
  },
  {
    id: "8995",
    id_polifenol: "4981",
    polifenol: "jaceosidin",
    id_cancer: "541",
    cancer: "Endometrial Cancer",
    quant: "1",
    pmids: "23274058",
  },
  {
    id: "8996",
    id_polifenol: "6549",
    polifenol: "7-hydroxy-2',3',4',5',8-pentamethoxyisoflavan",
    id_cancer: "541",
    cancer: "Endometrial Cancer",
    quant: "1",
    pmids: "25816349",
  },
  {
    id: "8997",
    id_polifenol: "826",
    polifenol: "4,4',4''-(4-propyl-((1)H)-pyrazole-1,3,5-triyl) tris-phenol",
    id_cancer: "541",
    cancer: "Endometrial Cancer",
    quant: "1",
    pmids: "24379833",
  },
  {
    id: "8998",
    id_polifenol: "1718",
    polifenol: "dihydroguaiaretic acid",
    id_cancer: "541",
    cancer: "Endometrial Cancer",
    quant: "1",
    pmids: "28229391",
  },
  {
    id: "8999",
    id_polifenol: "52",
    polifenol: "Diflunisal",
    id_cancer: "541",
    cancer: "Endometrial Cancer",
    quant: "1",
    pmids: "19515562",
  },
  {
    id: "9000",
    id_polifenol: "5141",
    polifenol: "6-prenylnaringenin",
    id_cancer: "541",
    cancer: "Endometrial Cancer",
    quant: "1",
    pmids: "16019205",
  },
  {
    id: "9001",
    id_polifenol: "273",
    polifenol: "bis(4-nitrophenyl)phosphate",
    id_cancer: "541",
    cancer: "Endometrial Cancer",
    quant: "1",
    pmids: "15205340",
  },
  {
    id: "9002",
    id_polifenol: "1688",
    polifenol: "4-hydroxyestrone",
    id_cancer: "541",
    cancer: "Endometrial Cancer",
    quant: "1",
    pmids: "10813650",
  },
  {
    id: "9003",
    id_polifenol: "6717",
    polifenol: "irigenin",
    id_cancer: "541",
    cancer: "Endometrial Cancer",
    quant: "1",
    pmids: "15931582",
  },
  {
    id: "9004",
    id_polifenol: "5669",
    polifenol: "pro-F-EGCG2",
    id_cancer: "541",
    cancer: "Endometrial Cancer",
    quant: "1",
    pmids: "29024813",
  },
  {
    id: "9005",
    id_polifenol: "1674",
    polifenol: "6-hydroxyestrogen 6-sulfate",
    id_cancer: "541",
    cancer: "Endometrial Cancer",
    quant: "1",
    pmids: "25437045",
  },
  {
    id: "9006",
    id_polifenol: "4899",
    polifenol: "bavachin",
    id_cancer: "541",
    cancer: "Endometrial Cancer",
    quant: "1",
    pmids: "26419930",
  },
  {
    id: "9007",
    id_polifenol: "6595",
    polifenol: "eurycarpin B",
    id_cancer: "541",
    cancer: "Endometrial Cancer",
    quant: "1",
    pmids: "19874114",
  },
  {
    id: "9008",
    id_polifenol: "5586",
    polifenol: "3',4'-dimethoxy-alpha-naphthoflavone",
    id_cancer: "541",
    cancer: "Endometrial Cancer",
    quant: "1",
    pmids: "22235307",
  },
  {
    id: "9009",
    id_polifenol: "7751",
    polifenol: "8-(1,1-dimethylallyl)genistein",
    id_cancer: "541",
    cancer: "Endometrial Cancer",
    quant: "1",
    pmids: "19733663",
  },
  {
    id: "9010",
    id_polifenol: "6119",
    polifenol: "6-(1,1-dimethylallyl)naringenin",
    id_cancer: "541",
    cancer: "Endometrial Cancer",
    quant: "1",
    pmids: "19733663",
  },
  {
    id: "9011",
    id_polifenol: "4379",
    polifenol:
      "2-(piperidinoethoxyphenyl)-3-(4-hydroxyphenyl)-2H-benzo(b)pyran",
    id_cancer: "541",
    cancer: "Endometrial Cancer",
    quant: "1",
    pmids: "25144715",
  },
  {
    id: "9012",
    id_polifenol: "6743",
    polifenol: "scandenone",
    id_cancer: "541",
    cancer: "Endometrial Cancer",
    quant: "1",
    pmids: "19874114",
  },
  {
    id: "9013",
    id_polifenol: "5447",
    polifenol: "7-methoxyophioglonin",
    id_cancer: "541",
    cancer: "Endometrial Cancer",
    quant: "1",
    pmids: "23479390",
  },
  {
    id: "9014",
    id_polifenol: "2666",
    polifenol: "3,5-diiodosalicylic acid",
    id_cancer: "541",
    cancer: "Endometrial Cancer",
    quant: "1",
    pmids: "18045204",
  },
  {
    id: "9015",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "17",
    pmids:
      "15881322,11861377,24707875,8277312,15252145,11891088,16091005,18440233,23902346,8688318,27056897,7954363,18715546,9581517,27081750,21121257,2434441",
  },
  {
    id: "9016",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "8",
    pmids:
      "15358181,10747850,16547158,18495463,27618095,18565284,29255221,23108412",
  },
  {
    id: "9017",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "8",
    pmids:
      "23229870,22286230,19331173,10794635,15823585,27618095,28462492,16458188",
  },
  {
    id: "9018",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "12",
    pmids:
      "17251686,22695858,27035160,11121417,15905960,16547158,17570321,16550001,17341207,11805108,11238032,19661304",
  },
  {
    id: "9019",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "4",
    pmids: "16186104,9580637,12903810,9572397",
  },
  {
    id: "9020",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "7",
    pmids: "27618095,23902346,8688318,27191500,7954363,2386981,2434441",
  },
  {
    id: "9021",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "7",
    pmids: "20963498,10794635,15823585,27618095,12643642,12832446,12480918",
  },
  {
    id: "9022",
    id_polifenol: "2167",
    polifenol: "phenolic acid",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "3",
    pmids: "19922491,24969892,21121257",
  },
  {
    id: "9023",
    id_polifenol: "49",
    polifenol: "Aspirin",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "6",
    pmids: "19922491,11196190,25963543,22122360,19117331,21182493",
  },
  {
    id: "9024",
    id_polifenol: "109",
    polifenol: "Catechin",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "4",
    pmids: "20963498,10794635,7954363,25625225",
  },
  {
    id: "9025",
    id_polifenol: "125",
    polifenol: "Isoflavones",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "1",
    pmids: "18440233",
  },
  {
    id: "9026",
    id_polifenol: "110",
    polifenol: "Chalcones",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "1",
    pmids: "18440233",
  },
  {
    id: "9027",
    id_polifenol: "3089",
    polifenol: "1,1-diphenyl-2-picrylhydrazyl",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "1",
    pmids: "10967477",
  },
  {
    id: "9028",
    id_polifenol: "114",
    polifenol: "Apigenin",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "1",
    pmids: "27191500",
  },
  {
    id: "9029",
    id_polifenol: "113",
    polifenol: "Flavones",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "2",
    pmids: "10794635,21121257",
  },
  {
    id: "9030",
    id_polifenol: "38",
    polifenol: "Gallic Acid",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "2",
    pmids: "24413695,24956509",
  },
  {
    id: "9031",
    id_polifenol: "117",
    polifenol: "Luteolin",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "1",
    pmids: "7954363",
  },
  {
    id: "9032",
    id_polifenol: "1",
    polifenol: "Phenols",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "3",
    pmids: "19922491,21664138,28282121",
  },
  {
    id: "9033",
    id_polifenol: "105",
    polifenol: "Anthocyanins",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "1",
    pmids: "24413695",
  },
  {
    id: "9034",
    id_polifenol: "129",
    polifenol: "Rotenone",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "1",
    pmids: "2614425",
  },
  {
    id: "9035",
    id_polifenol: "6065",
    polifenol: "baicalein",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "1",
    pmids: "8869751",
  },
  {
    id: "9036",
    id_polifenol: "7",
    polifenol: "Capsaicin",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "2",
    pmids: "21462327,17881535",
  },
  {
    id: "9037",
    id_polifenol: "120",
    polifenol: "Flavonols",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "2",
    pmids: "10794635,18440233",
  },
  {
    id: "9038",
    id_polifenol: "123",
    polifenol: "Rutin",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "1",
    pmids: "7954363",
  },
  {
    id: "9039",
    id_polifenol: "39",
    polifenol: "Hydrolyzable Tannins",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "1",
    pmids: "15823585",
  },
  {
    id: "9040",
    id_polifenol: "130",
    polifenol: "Proanthocyanidins",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "1",
    pmids: "24969892",
  },
  {
    id: "9041",
    id_polifenol: "35",
    polifenol: "Hydroquinones",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "2",
    pmids: "3191161,1515551",
  },
  {
    id: "9042",
    id_polifenol: "111",
    polifenol: "Flavanones",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "1",
    pmids: "21121257",
  },
  {
    id: "9043",
    id_polifenol: "4502",
    polifenol: "fisetin",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "1",
    pmids: "24099040",
  },
  {
    id: "9044",
    id_polifenol: "6",
    polifenol: "Catechols",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "1",
    pmids: "24523750",
  },
  {
    id: "9045",
    id_polifenol: "25",
    polifenol: "Butylated Hydroxytoluene",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "5",
    pmids: "10588948,8152351,3191161,1515551,1522759",
  },
  {
    id: "9046",
    id_polifenol: "75",
    polifenol: "Butylated Hydroxyanisole",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "8",
    pmids: "10588948,8152351,19170071,9730893,1515551,1522759,9565639,16083851",
  },
  {
    id: "9047",
    id_polifenol: "15",
    polifenol: "Masoprocol",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "1",
    pmids: "12740643",
  },
  {
    id: "9048",
    id_polifenol: "5608",
    polifenol: "epicatechin gallate",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "1",
    pmids: "10794635",
  },
  {
    id: "9049",
    id_polifenol: "54",
    polifenol: "Salicylic Acid",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "2",
    pmids: "2940193,2940192",
  },
  {
    id: "9050",
    id_polifenol: "98",
    polifenol: "Propofol",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "1",
    pmids: "12127688",
  },
  {
    id: "9051",
    id_polifenol: "5607",
    polifenol: "gallocatechol",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "1",
    pmids: "10794635",
  },
  {
    id: "9052",
    id_polifenol: "44",
    polifenol: "Salicylates",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "1",
    pmids: "16872361",
  },
  {
    id: "9053",
    id_polifenol: "4559",
    polifenol: "theaflavin",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "1",
    pmids: "10794635",
  },
  {
    id: "9054",
    id_polifenol: "2344",
    polifenol: "methyl gallate",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "1",
    pmids: "10794635",
  },
  {
    id: "9055",
    id_polifenol: "4708",
    polifenol: "xanthohumol",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "1",
    pmids: "15723722",
  },
  {
    id: "9056",
    id_polifenol: "6455",
    polifenol: "nobiletin",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "3",
    pmids: "11861377,18053806,15252145",
  },
  {
    id: "9057",
    id_polifenol: "5489",
    polifenol: "delphinidin",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "2",
    pmids: "24413695,9581517",
  },
  {
    id: "9058",
    id_polifenol: "1613",
    polifenol: "demethoxycurcumin",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "1",
    pmids: "18495463",
  },
  {
    id: "9059",
    id_polifenol: "93",
    polifenol: "Phloroglucinol",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "1",
    pmids: "20667461",
  },
  {
    id: "9060",
    id_polifenol: "7550",
    polifenol: "3-methylquercetin",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "1",
    pmids: "18715546",
  },
  {
    id: "9061",
    id_polifenol: "1611",
    polifenol: "bis(4-hydroxycinnamoyl)methane",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "1",
    pmids: "18495463",
  },
  {
    id: "9062",
    id_polifenol: "108",
    polifenol: "Biflavonoids",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "2",
    pmids: "29968167,17121913",
  },
  {
    id: "9063",
    id_polifenol: "1558",
    polifenol: "capsazepine",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "1",
    pmids: "21089054",
  },
  {
    id: "9064",
    id_polifenol: "969",
    polifenol: "3,4-dihydroxyphenacyl caffeate phenylpropanoid ester",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "1",
    pmids: "21978886",
  },
  {
    id: "9065",
    id_polifenol: "4537",
    polifenol: "flavone acetic acid",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "1",
    pmids: "1735673",
  },
  {
    id: "9066",
    id_polifenol: "2773",
    polifenol: "farnesylthiosalicylic acid",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "1",
    pmids: "17699784",
  },
  {
    id: "9067",
    id_polifenol: "7546",
    polifenol: "isoquercitrin",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "1",
    pmids: "18715546",
  },
  {
    id: "9068",
    id_polifenol: "452",
    polifenol: "acteoside",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "1",
    pmids: "21089054",
  },
  {
    id: "9069",
    id_polifenol: "5850",
    polifenol: "cardamonin",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "1",
    pmids: "23201552",
  },
  {
    id: "9070",
    id_polifenol: "7541",
    polifenol: "taxifolin",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "1",
    pmids: "25625225",
  },
  {
    id: "9071",
    id_polifenol: "300",
    polifenol: "rhodioloside",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "1",
    pmids: "21978886",
  },
  {
    id: "9072",
    id_polifenol: "2475",
    polifenol: "6-O-galloylglucose",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "1",
    pmids: "15823585",
  },
  {
    id: "9073",
    id_polifenol: "2447",
    polifenol: "beta-penta-O-galloyl-glucose",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "1",
    pmids: "15105050",
  },
  {
    id: "9074",
    id_polifenol: "4585",
    polifenol: "baohuoside I",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "1",
    pmids: "27056897",
  },
  {
    id: "9075",
    id_polifenol: "1616",
    polifenol: "tetrahydrocurcumin",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "1",
    pmids: "18565284",
  },
  {
    id: "9076",
    id_polifenol: "40",
    polifenol: "Propyl Gallate",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "1",
    pmids: "1515551",
  },
  {
    id: "9077",
    id_polifenol: "36",
    polifenol: "Hydroxybenzoates",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "1",
    pmids: "23847403",
  },
  {
    id: "9078",
    id_polifenol: "128",
    polifenol: "Pterocarpans",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "1",
    pmids: "18440233",
  },
  {
    id: "9079",
    id_polifenol: "3489",
    polifenol: "anethole",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "1",
    pmids: "21212515",
  },
  {
    id: "9080",
    id_polifenol: "87",
    polifenol: "Metoclopramide",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "1",
    pmids: "16183854",
  },
  {
    id: "9081",
    id_polifenol: "2014",
    polifenol: "erbstatin",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "1",
    pmids: "9580637",
  },
  {
    id: "9082",
    id_polifenol: "7156",
    polifenol: "scutellarein",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "1",
    pmids: "25394920",
  },
  {
    id: "9083",
    id_polifenol: "6112",
    polifenol: "alpinetin",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "1",
    pmids: "23201552",
  },
  {
    id: "9084",
    id_polifenol: "6770",
    polifenol: "5-hydroxy-3,6,7,8,3',4'-hexamethoxyflavone",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "1",
    pmids: "18053806",
  },
  {
    id: "9085",
    id_polifenol: "2697",
    polifenol: "4-trifluoromethylsalicylic acid",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "1",
    pmids: "21811429",
  },
  {
    id: "9086",
    id_polifenol: "4573",
    polifenol: "3,3',4',5,6,7,8-heptamethoxyflavone",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "1",
    pmids: "18053806",
  },
  {
    id: "9087",
    id_polifenol: "3258",
    polifenol: "tesmilifene",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "2",
    pmids: "7909571,1617649",
  },
  {
    id: "9088",
    id_polifenol: "6497",
    polifenol: "isoflavanone",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "1",
    pmids: "18440233",
  },
  {
    id: "9089",
    id_polifenol: "4549",
    polifenol: "casticin",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "1",
    pmids: "15881322",
  },
  {
    id: "9090",
    id_polifenol: "6549",
    polifenol: "7-hydroxy-2',3',4',5',8-pentamethoxyisoflavan",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "1",
    pmids: "18440233",
  },
  {
    id: "9091",
    id_polifenol: "5245",
    polifenol: "BF6-6 biflavone",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "1",
    pmids: "29968167",
  },
  {
    id: "9092",
    id_polifenol: "839",
    polifenol: "5-iodo-3-((3,5-dibromo-4-hydroxyphenyl)methylene)-2-indolinone",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "1",
    pmids: "17251686",
  },
  {
    id: "9093",
    id_polifenol: "5542",
    polifenol: "delphinidin 3-O-glucopyranoside",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "1",
    pmids: "24413695",
  },
  {
    id: "9094",
    id_polifenol: "5814",
    polifenol: "2',4'-dihydroxychalcone",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "1",
    pmids: "19689125",
  },
  {
    id: "9095",
    id_polifenol: "3091",
    polifenol: "picric acid",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "1",
    pmids: "3571978",
  },
  {
    id: "9096",
    id_polifenol: "393",
    polifenol: "2,6-di-tert-butylphenol",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "1",
    pmids: "1515551",
  },
  {
    id: "9097",
    id_polifenol: "5616",
    polifenol: "epigallocatechin-3-(3''-O-methyl)gallate",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "1",
    pmids: "12643642",
  },
  {
    id: "9098",
    id_polifenol: "1262",
    polifenol: "4-dodecylaminophenol",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "1",
    pmids: "23953690",
  },
  {
    id: "9099",
    id_polifenol: "2358",
    polifenol: "theaflavin digallate",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "1",
    pmids: "10794635",
  },
  {
    id: "9100",
    id_polifenol: "811",
    polifenol: "squaraine",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "1",
    pmids: "26942626",
  },
  {
    id: "9101",
    id_polifenol: "5500",
    polifenol: "pelargonidin-3-glucoside",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "1",
    pmids: "24413695",
  },
  {
    id: "9102",
    id_polifenol: "4887",
    polifenol: "isoginkgetin",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "1",
    pmids: "17121913",
  },
  {
    id: "9103",
    id_polifenol: "521",
    polifenol: "E 7010",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "1",
    pmids: "8137285",
  },
  {
    id: "9104",
    id_polifenol: "782",
    polifenol: "A-317491",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "1",
    pmids: "19765404",
  },
  {
    id: "9105",
    id_polifenol: "2458",
    polifenol: "glucogallin",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "1",
    pmids: "9160354",
  },
  {
    id: "9106",
    id_polifenol: "3029",
    polifenol: "NCX 4040",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "1",
    pmids: "21664138",
  },
  {
    id: "9107",
    id_polifenol: "1781",
    polifenol: "CA 432",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "1",
    pmids: "22705646",
  },
  {
    id: "9108",
    id_polifenol: "5042",
    polifenol:
      "I-3, II-3, I-5, II-5, I-7, II-7, I-4', II-4'-octahydroxy (I-2', II-2') biflavone",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "1",
    pmids: "29968167",
  },
  {
    id: "9109",
    id_polifenol: "4987",
    polifenol:
      "5-hydroxy-7-methoxyflavone-(4' -O-8'')-4''',5'',7''-trihydroxyflavone",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "1",
    pmids: "15252145",
  },
  {
    id: "9110",
    id_polifenol: "714",
    polifenol: "3-(4-hydroxyphenyl)propanol",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "1",
    pmids: "11118049",
  },
  {
    id: "9111",
    id_polifenol: "4678",
    polifenol: "natsudaidain",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "1",
    pmids: "18053806",
  },
  {
    id: "9112",
    id_polifenol: "2521",
    polifenol: "1,2,4-tri-O-galloyl-3,6-hexahydroxydiphenoylglucose",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "1",
    pmids: "15823585",
  },
  {
    id: "9113",
    id_polifenol: "1794",
    polifenol:
      "4-(3-hydroxy-4-methoxyphenyl)-3-(4-hydroxyphenyl)-1-(3,4,5-trimethoxyphenyl)azetidin-2-one",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "1",
    pmids: "22705646",
  },
  {
    id: "9114",
    id_polifenol: "476",
    polifenol: "N-acetyl-4-S-cysteaminylphenol",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "1",
    pmids: "11118049",
  },
  {
    id: "9115",
    id_polifenol: "1704",
    polifenol:
      "3-(3-hydroxy-4-methoxyphenyl)-4-(3,4,5-trimethoxyphenyl)-1,2,5-selenadiazole",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "1",
    pmids: "25529822",
  },
  {
    id: "9116",
    id_polifenol: "6341",
    polifenol: "sideritoflavone",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "1",
    pmids: "8277312",
  },
  {
    id: "9117",
    id_polifenol: "6196",
    polifenol: "7-hydroxy-6-methoxyflavanone",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "1",
    pmids: "18440233",
  },
  {
    id: "9118",
    id_polifenol: "2831",
    polifenol: "calcium salicylate",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "1",
    pmids: "16872361",
  },
  {
    id: "9119",
    id_polifenol: "2801",
    polifenol: "2-hydroxybenzoic acid 3-nitrooxymethylphenyl ester",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "1",
    pmids: "21664138",
  },
  {
    id: "9120",
    id_polifenol: "4826",
    polifenol:
      "5,4'-dihydroxy-(3'',4''-dihydro-3'',4''-dihydroxy)-2'',2''-dimethylpyrano(5'',6''-7,8)flavone",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "1",
    pmids: "19689125",
  },
  {
    id: "9121",
    id_polifenol: "4730",
    polifenol: "5-methoxy-6-methylflavan-7-ol",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "1",
    pmids: "19689125",
  },
  {
    id: "9122",
    id_polifenol: "971",
    polifenol: "3-(2-(7-methoxybenzo(d)(1,3)dioxol-5-yl)ethyl)phenol",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "1",
    pmids: "17516577",
  },
  {
    id: "9123",
    id_polifenol: "5458",
    polifenol: "(2R,4R)-2',4'-dihydroxy-5,7-dimethoxyflavan-4-ol",
    id_cancer: "6176",
    cancer: "Fibrosarcoma",
    quant: "1",
    pmids: "21121257",
  },
  {
    id: "9124",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "230101",
    cancer: "Small cell lung cancer",
    quant: "11",
    pmids:
      "28983599,26238746,21596135,29614624,9224209,27633248,25738754,15202555,16833018,7997472,22750816",
  },
  {
    id: "9125",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "230101",
    cancer: "Small cell lung cancer",
    quant: "6",
    pmids: "21711158,22662257,28187956,12149148,16572896,25573684",
  },
  {
    id: "9126",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "230101",
    cancer: "Small cell lung cancer",
    quant: "4",
    pmids: "17585882,23098466,28545532,17243704",
  },
  {
    id: "9127",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "230101",
    cancer: "Small cell lung cancer",
    quant: "9",
    pmids:
      "10667594,19956885,15037618,11753643,11768610,10910097,9421477,8971188,15471877",
  },
  {
    id: "9128",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "230101",
    cancer: "Small cell lung cancer",
    quant: "10",
    pmids:
      "24379139,8797601,7945406,10072259,24399305,22452992,19212674,8652271,11052627,10533460",
  },
  {
    id: "9129",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "230101",
    cancer: "Small cell lung cancer",
    quant: "3",
    pmids: "26238746,21596135,9224209",
  },
  {
    id: "9130",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "230101",
    cancer: "Small cell lung cancer",
    quant: "2",
    pmids: "17585882,10783312",
  },
  {
    id: "9131",
    id_polifenol: "2167",
    polifenol: "phenolic acid",
    id_cancer: "230101",
    cancer: "Small cell lung cancer",
    quant: "2",
    pmids: "26987028,23712134",
  },
  {
    id: "9132",
    id_polifenol: "49",
    polifenol: "Aspirin",
    id_cancer: "230101",
    cancer: "Small cell lung cancer",
    quant: "3",
    pmids: "17191809,26810856,9823297",
  },
  {
    id: "9133",
    id_polifenol: "125",
    polifenol: "Isoflavones",
    id_cancer: "230101",
    cancer: "Small cell lung cancer",
    quant: "2",
    pmids: "24379139,9224209",
  },
  {
    id: "9134",
    id_polifenol: "110",
    polifenol: "Chalcones",
    id_cancer: "230101",
    cancer: "Small cell lung cancer",
    quant: "2",
    pmids: "15202555,16833018",
  },
  {
    id: "9135",
    id_polifenol: "3089",
    polifenol: "1,1-diphenyl-2-picrylhydrazyl",
    id_cancer: "230101",
    cancer: "Small cell lung cancer",
    quant: "2",
    pmids: "23712134,22908592",
  },
  {
    id: "9136",
    id_polifenol: "114",
    polifenol: "Apigenin",
    id_cancer: "230101",
    cancer: "Small cell lung cancer",
    quant: "2",
    pmids: "24926787,27932755",
  },
  {
    id: "9137",
    id_polifenol: "113",
    polifenol: "Flavones",
    id_cancer: "230101",
    cancer: "Small cell lung cancer",
    quant: "2",
    pmids: "15202555,7997472",
  },
  {
    id: "9138",
    id_polifenol: "38",
    polifenol: "Gallic Acid",
    id_cancer: "230101",
    cancer: "Small cell lung cancer",
    quant: "2",
    pmids: "26987028,23712134",
  },
  {
    id: "9139",
    id_polifenol: "117",
    polifenol: "Luteolin",
    id_cancer: "230101",
    cancer: "Small cell lung cancer",
    quant: "2",
    pmids: "25586525,15202555",
  },
  {
    id: "9140",
    id_polifenol: "1",
    polifenol: "Phenols",
    id_cancer: "230101",
    cancer: "Small cell lung cancer",
    quant: "1",
    pmids: "12375879",
  },
  {
    id: "9141",
    id_polifenol: "7235",
    polifenol: "silybin",
    id_cancer: "230101",
    cancer: "Small cell lung cancer",
    quant: "2",
    pmids: "12894553,24047698",
  },
  {
    id: "9142",
    id_polifenol: "871",
    polifenol: "ABT-737",
    id_cancer: "230101",
    cancer: "Small cell lung cancer",
    quant: "23",
    pmids:
      "17097560,23452820,15902208,16951189,28987383,22448988,21393866,22821746,22173547,20732961,24036132,18085673,17283153,19372561,26575826,27197306,18381439,27247353,17173063,17508927,18841882,24614082,18451170",
  },
  {
    id: "9143",
    id_polifenol: "6451",
    polifenol: "daidzein",
    id_cancer: "230101",
    cancer: "Small cell lung cancer",
    quant: "1",
    pmids: "24490836",
  },
  {
    id: "9144",
    id_polifenol: "6065",
    polifenol: "baicalein",
    id_cancer: "230101",
    cancer: "Small cell lung cancer",
    quant: "1",
    pmids: "29614624",
  },
  {
    id: "9145",
    id_polifenol: "7",
    polifenol: "Capsaicin",
    id_cancer: "230101",
    cancer: "Small cell lung cancer",
    quant: "5",
    pmids: "20421925,24878626,28104436,27196129,24926985",
  },
  {
    id: "9146",
    id_polifenol: "4634",
    polifenol: "alvocidib",
    id_cancer: "230101",
    cancer: "Small cell lung cancer",
    quant: "4",
    pmids: "14555534,19174488,11052627,11562277",
  },
  {
    id: "9147",
    id_polifenol: "120",
    polifenol: "Flavonols",
    id_cancer: "230101",
    cancer: "Small cell lung cancer",
    quant: "2",
    pmids: "24267912,7623025",
  },
  {
    id: "9148",
    id_polifenol: "4522",
    polifenol: "chrysin",
    id_cancer: "230101",
    cancer: "Small cell lung cancer",
    quant: "1",
    pmids: "28983599",
  },
  {
    id: "9149",
    id_polifenol: "123",
    polifenol: "Rutin",
    id_cancer: "230101",
    cancer: "Small cell lung cancer",
    quant: "3",
    pmids: "15450951,9224209,23153173",
  },
  {
    id: "9150",
    id_polifenol: "35",
    polifenol: "Hydroquinones",
    id_cancer: "230101",
    cancer: "Small cell lung cancer",
    quant: "1",
    pmids: "28697309",
  },
  {
    id: "9151",
    id_polifenol: "111",
    polifenol: "Flavanones",
    id_cancer: "230101",
    cancer: "Small cell lung cancer",
    quant: "2",
    pmids: "15202555,27311018",
  },
  {
    id: "9152",
    id_polifenol: "4502",
    polifenol: "fisetin",
    id_cancer: "230101",
    cancer: "Small cell lung cancer",
    quant: "1",
    pmids: "23030699",
  },
  {
    id: "9153",
    id_polifenol: "6",
    polifenol: "Catechols",
    id_cancer: "230101",
    cancer: "Small cell lung cancer",
    quant: "1",
    pmids: "12375879",
  },
  {
    id: "9154",
    id_polifenol: "75",
    polifenol: "Butylated Hydroxyanisole",
    id_cancer: "230101",
    cancer: "Small cell lung cancer",
    quant: "3",
    pmids: "28983599,25572414,19170071",
  },
  {
    id: "9155",
    id_polifenol: "15",
    polifenol: "Masoprocol",
    id_cancer: "230101",
    cancer: "Small cell lung cancer",
    quant: "1",
    pmids: "12375879",
  },
  {
    id: "9156",
    id_polifenol: "4515",
    polifenol: "baicalin",
    id_cancer: "230101",
    cancer: "Small cell lung cancer",
    quant: "1",
    pmids: "28983599",
  },
  {
    id: "9157",
    id_polifenol: "1356",
    polifenol: "gingerol",
    id_cancer: "230101",
    cancer: "Small cell lung cancer",
    quant: "1",
    pmids: "25518296",
  },
  {
    id: "9158",
    id_polifenol: "98",
    polifenol: "Propofol",
    id_cancer: "230101",
    cancer: "Small cell lung cancer",
    quant: "2",
    pmids: "25502773,23155249",
  },
  {
    id: "9159",
    id_polifenol: "5808",
    polifenol: "isoliquiritigenin",
    id_cancer: "230101",
    cancer: "Small cell lung cancer",
    quant: "1",
    pmids: "22750816",
  },
  {
    id: "9160",
    id_polifenol: "1380",
    polifenol: "shogaol",
    id_cancer: "230101",
    cancer: "Small cell lung cancer",
    quant: "1",
    pmids: "25518296",
  },
  {
    id: "9161",
    id_polifenol: "6454",
    polifenol: "formononetin",
    id_cancer: "230101",
    cancer: "Small cell lung cancer",
    quant: "1",
    pmids: "22750816",
  },
  {
    id: "9162",
    id_polifenol: "7550",
    polifenol: "3-methylquercetin",
    id_cancer: "230101",
    cancer: "Small cell lung cancer",
    quant: "1",
    pmids: "26238746",
  },
  {
    id: "9163",
    id_polifenol: "6461",
    polifenol: "acacetin",
    id_cancer: "230101",
    cancer: "Small cell lung cancer",
    quant: "1",
    pmids: "15202555",
  },
  {
    id: "9164",
    id_polifenol: "4253",
    polifenol:
      "5-(2,4-dihydroxy-5-isopropylphenyl)-4-(4-morpholin-4-ylmethylphenyl)isoxazole-3-carboxylic acid ethylamide",
    id_cancer: "230101",
    cancer: "Small cell lung cancer",
    quant: "1",
    pmids: "28987383",
  },
  {
    id: "9165",
    id_polifenol: "89",
    polifenol: "Vanillic Acid",
    id_cancer: "230101",
    cancer: "Small cell lung cancer",
    quant: "1",
    pmids: "18277603",
  },
  {
    id: "9166",
    id_polifenol: "118",
    polifenol: "Flavonolignans",
    id_cancer: "230101",
    cancer: "Small cell lung cancer",
    quant: "1",
    pmids: "24047698",
  },
  {
    id: "9167",
    id_polifenol: "6465",
    polifenol: "genistin",
    id_cancer: "230101",
    cancer: "Small cell lung cancer",
    quant: "1",
    pmids: "24490836",
  },
  {
    id: "9168",
    id_polifenol: "6086",
    polifenol: "liquiritigenin",
    id_cancer: "230101",
    cancer: "Small cell lung cancer",
    quant: "1",
    pmids: "22750816",
  },
  {
    id: "9169",
    id_polifenol: "2490",
    polifenol: "punicalagin",
    id_cancer: "230101",
    cancer: "Small cell lung cancer",
    quant: "1",
    pmids: "17243704",
  },
  {
    id: "9170",
    id_polifenol: "7547",
    polifenol: "hyperoside",
    id_cancer: "230101",
    cancer: "Small cell lung cancer",
    quant: "1",
    pmids: "28901459",
  },
  {
    id: "9171",
    id_polifenol: "87",
    polifenol: "Metoclopramide",
    id_cancer: "230101",
    cancer: "Small cell lung cancer",
    quant: "1",
    pmids: "8012964",
  },
  {
    id: "9172",
    id_polifenol: "2014",
    polifenol: "erbstatin",
    id_cancer: "230101",
    cancer: "Small cell lung cancer",
    quant: "1",
    pmids: "9457072",
  },
  {
    id: "9173",
    id_polifenol: "6693",
    polifenol: "2',4',7-trihydroxyisoflavone",
    id_cancer: "230101",
    cancer: "Small cell lung cancer",
    quant: "1",
    pmids: "22452992",
  },
  {
    id: "9174",
    id_polifenol: "6100",
    polifenol: "pinostrobin",
    id_cancer: "230101",
    cancer: "Small cell lung cancer",
    quant: "1",
    pmids: "20064598",
  },
  {
    id: "9175",
    id_polifenol: "4981",
    polifenol: "jaceosidin",
    id_cancer: "230101",
    cancer: "Small cell lung cancer",
    quant: "1",
    pmids: "7997472",
  },
  {
    id: "9176",
    id_polifenol: "4544",
    polifenol: "tiliroside",
    id_cancer: "230101",
    cancer: "Small cell lung cancer",
    quant: "1",
    pmids: "16833018",
  },
  {
    id: "9177",
    id_polifenol: "7437",
    polifenol: "kaempferol-3-O-rutinoside",
    id_cancer: "230101",
    cancer: "Small cell lung cancer",
    quant: "1",
    pmids: "16833018",
  },
  {
    id: "9178",
    id_polifenol: "5941",
    polifenol: "3-hydroxy-4,3',4',5'-tetramethoxychalcone",
    id_cancer: "230101",
    cancer: "Small cell lung cancer",
    quant: "1",
    pmids: "15202555",
  },
  {
    id: "9179",
    id_polifenol: "6031",
    polifenol: "2',3'-dimethoxyflavanone",
    id_cancer: "230101",
    cancer: "Small cell lung cancer",
    quant: "1",
    pmids: "15202555",
  },
  {
    id: "9180",
    id_polifenol: "4073",
    polifenol: "myristicin",
    id_cancer: "230101",
    cancer: "Small cell lung cancer",
    quant: "1",
    pmids: "25518296",
  },
  {
    id: "9181",
    id_polifenol: "7888",
    polifenol: "neoisoliquiritin",
    id_cancer: "230101",
    cancer: "Small cell lung cancer",
    quant: "1",
    pmids: "22750816",
  },
  {
    id: "9182",
    id_polifenol: "4244",
    polifenol: "malabaricone A",
    id_cancer: "230101",
    cancer: "Small cell lung cancer",
    quant: "1",
    pmids: "19471882",
  },
  {
    id: "9183",
    id_polifenol: "6460",
    polifenol: "ipriflavone",
    id_cancer: "230101",
    cancer: "Small cell lung cancer",
    quant: "1",
    pmids: "9224209",
  },
  {
    id: "9184",
    id_polifenol: "5198",
    polifenol: "isosakuranetin",
    id_cancer: "230101",
    cancer: "Small cell lung cancer",
    quant: "1",
    pmids: "15202555",
  },
  {
    id: "9185",
    id_polifenol: "4482",
    polifenol: "peflavit",
    id_cancer: "230101",
    cancer: "Small cell lung cancer",
    quant: "1",
    pmids: "9224209",
  },
  {
    id: "9186",
    id_polifenol: "7560",
    polifenol: "quercetin-3-O-neohesperidose",
    id_cancer: "230101",
    cancer: "Small cell lung cancer",
    quant: "1",
    pmids: "9224209",
  },
  {
    id: "9187",
    id_polifenol: "1556",
    polifenol: "olvanil",
    id_cancer: "230101",
    cancer: "Small cell lung cancer",
    quant: "1",
    pmids: "27196129",
  },
  {
    id: "9188",
    id_polifenol: "1566",
    polifenol: "arvanil",
    id_cancer: "230101",
    cancer: "Small cell lung cancer",
    quant: "1",
    pmids: "27196129",
  },
  {
    id: "9189",
    id_polifenol: "5701",
    polifenol: "2',4'-dihydroxy-3,4,5-trimethoxychalcone",
    id_cancer: "230101",
    cancer: "Small cell lung cancer",
    quant: "1",
    pmids: "15202555",
  },
  {
    id: "9190",
    id_polifenol: "4689",
    polifenol: "5,3'-dihydroxy-3,6,7,8,4'-pentamethoxyflavone",
    id_cancer: "230101",
    cancer: "Small cell lung cancer",
    quant: "1",
    pmids: "7623025",
  },
  {
    id: "9191",
    id_polifenol: "6247",
    polifenol: "6,4'-dihydroxy-7-methoxyflavanone",
    id_cancer: "230101",
    cancer: "Small cell lung cancer",
    quant: "1",
    pmids: "15202555",
  },
  {
    id: "9192",
    id_polifenol: "460",
    polifenol: "suillin",
    id_cancer: "230101",
    cancer: "Small cell lung cancer",
    quant: "1",
    pmids: "27174331",
  },
  {
    id: "9193",
    id_polifenol: "6256",
    polifenol: "(2S)-3',4',5'-trimethoxyflavanone",
    id_cancer: "230101",
    cancer: "Small cell lung cancer",
    quant: "1",
    pmids: "15202555",
  },
  {
    id: "9194",
    id_polifenol: "4848",
    polifenol: "4'-hydroxy-7-methoxyflavan",
    id_cancer: "230101",
    cancer: "Small cell lung cancer",
    quant: "1",
    pmids: "19471882",
  },
  {
    id: "9195",
    id_polifenol: "7184",
    polifenol: "scutellarein tetramethyl ether",
    id_cancer: "230101",
    cancer: "Small cell lung cancer",
    quant: "1",
    pmids: "12375879",
  },
  {
    id: "9196",
    id_polifenol: "4372",
    polifenol:
      "quercetin 3-O-alpha-rhamnopyranoside-7-O-beta-D-glucopyranosyl-(1-3)-alpha-L-rhamnopyranoside",
    id_cancer: "230101",
    cancer: "Small cell lung cancer",
    quant: "1",
    pmids: "7623025",
  },
  {
    id: "9197",
    id_polifenol: "6125",
    polifenol: "5,6,7,4'-tetramethoxyflavanone",
    id_cancer: "230101",
    cancer: "Small cell lung cancer",
    quant: "1",
    pmids: "15202555",
  },
  {
    id: "9198",
    id_polifenol: "5085",
    polifenol: "myristinin D",
    id_cancer: "230101",
    cancer: "Small cell lung cancer",
    quant: "1",
    pmids: "19471882",
  },
  {
    id: "9199",
    id_polifenol: "5075",
    polifenol: "myristinin A",
    id_cancer: "230101",
    cancer: "Small cell lung cancer",
    quant: "1",
    pmids: "19471882",
  },
  {
    id: "9200",
    id_polifenol: "5903",
    polifenol: "2',4'-dihydroxy-3'-(2-hydroxybenzyl)-6'-methoxychalcone",
    id_cancer: "230101",
    cancer: "Small cell lung cancer",
    quant: "1",
    pmids: "16833018",
  },
  {
    id: "9201",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "563",
    cancer: "Acute Myeloid Leukemia",
    quant: "8",
    pmids:
      "25138434,28286420,27329589,23934681,27085528,27262321,28808383,29179521",
  },
  {
    id: "9202",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "563",
    cancer: "Acute Myeloid Leukemia",
    quant: "16",
    pmids:
      "28875010,26496980,17096185,21595920,28807161,11163331,12718610,26893544,23457487,25310451,27489587,28489348,25695860,24858458,19127081,23078406",
  },
  {
    id: "9203",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "563",
    cancer: "Acute Myeloid Leukemia",
    quant: "5",
    pmids: "26870993,28765039,26365556,25663548,23078406",
  },
  {
    id: "9204",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "563",
    cancer: "Acute Myeloid Leukemia",
    quant: "12",
    pmids:
      "21336837,17161815,23395717,19825968,27180173,20372853,24514755,9679985,26884713,14576828,15374955,25817574",
  },
  {
    id: "9205",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "563",
    cancer: "Acute Myeloid Leukemia",
    quant: "4",
    pmids: "21340606,18426648,25859554,17198876",
  },
  {
    id: "9206",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "563",
    cancer: "Acute Myeloid Leukemia",
    quant: "4",
    pmids: "25138434,27329589,18426648,25695860",
  },
  {
    id: "9207",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "563",
    cancer: "Acute Myeloid Leukemia",
    quant: "3",
    pmids: "28766684,25663548,28098879",
  },
  {
    id: "9208",
    id_polifenol: "2167",
    polifenol: "phenolic acid",
    id_cancer: "563",
    cancer: "Acute Myeloid Leukemia",
    quant: "3",
    pmids: "29883944,12718610,27262321",
  },
  {
    id: "9209",
    id_polifenol: "109",
    polifenol: "Catechin",
    id_cancer: "563",
    cancer: "Acute Myeloid Leukemia",
    quant: "3",
    pmids: "28808383,23078406,20837083",
  },
  {
    id: "9210",
    id_polifenol: "110",
    polifenol: "Chalcones",
    id_cancer: "563",
    cancer: "Acute Myeloid Leukemia",
    quant: "1",
    pmids: "29715098",
  },
  {
    id: "9211",
    id_polifenol: "3089",
    polifenol: "1,1-diphenyl-2-picrylhydrazyl",
    id_cancer: "563",
    cancer: "Acute Myeloid Leukemia",
    quant: "1",
    pmids: "27262321",
  },
  {
    id: "9212",
    id_polifenol: "114",
    polifenol: "Apigenin",
    id_cancer: "563",
    cancer: "Acute Myeloid Leukemia",
    quant: "1",
    pmids: "24895203",
  },
  {
    id: "9213",
    id_polifenol: "113",
    polifenol: "Flavones",
    id_cancer: "563",
    cancer: "Acute Myeloid Leukemia",
    quant: "3",
    pmids: "23481040,29412683,24895203",
  },
  {
    id: "9214",
    id_polifenol: "38",
    polifenol: "Gallic Acid",
    id_cancer: "563",
    cancer: "Acute Myeloid Leukemia",
    quant: "2",
    pmids: "29883944,18790533",
  },
  {
    id: "9215",
    id_polifenol: "117",
    polifenol: "Luteolin",
    id_cancer: "563",
    cancer: "Acute Myeloid Leukemia",
    quant: "1",
    pmids: "24895203",
  },
  {
    id: "9216",
    id_polifenol: "1",
    polifenol: "Phenols",
    id_cancer: "563",
    cancer: "Acute Myeloid Leukemia",
    quant: "3",
    pmids: "26299825,25268519,21097707",
  },
  {
    id: "9217",
    id_polifenol: "7235",
    polifenol: "silybin",
    id_cancer: "563",
    cancer: "Acute Myeloid Leukemia",
    quant: "3",
    pmids: "20543580,26148599,29179521",
  },
  {
    id: "9218",
    id_polifenol: "871",
    polifenol: "ABT-737",
    id_cancer: "563",
    cancer: "Acute Myeloid Leukemia",
    quant: "8",
    pmids:
      "19458629,17097560,23243017,26206337,26045609,24824212,24842334,25461257",
  },
  {
    id: "9219",
    id_polifenol: "6451",
    polifenol: "daidzein",
    id_cancer: "563",
    cancer: "Acute Myeloid Leukemia",
    quant: "1",
    pmids: "18426648",
  },
  {
    id: "9220",
    id_polifenol: "6065",
    polifenol: "baicalein",
    id_cancer: "563",
    cancer: "Acute Myeloid Leukemia",
    quant: "3",
    pmids: "28807161,24895203,29240303",
  },
  {
    id: "9221",
    id_polifenol: "7",
    polifenol: "Capsaicin",
    id_cancer: "563",
    cancer: "Acute Myeloid Leukemia",
    quant: "1",
    pmids: "12718610",
  },
  {
    id: "9222",
    id_polifenol: "4634",
    polifenol: "alvocidib",
    id_cancer: "563",
    cancer: "Acute Myeloid Leukemia",
    quant: "6",
    pmids: "23767415,25914884,24102143,21110323,12960118,22948151",
  },
  {
    id: "9223",
    id_polifenol: "120",
    polifenol: "Flavonols",
    id_cancer: "563",
    cancer: "Acute Myeloid Leukemia",
    quant: "1",
    pmids: "28808383",
  },
  {
    id: "9224",
    id_polifenol: "4522",
    polifenol: "chrysin",
    id_cancer: "563",
    cancer: "Acute Myeloid Leukemia",
    quant: "2",
    pmids: "28807161,24895203",
  },
  {
    id: "9225",
    id_polifenol: "6062",
    polifenol: "naringenin",
    id_cancer: "563",
    cancer: "Acute Myeloid Leukemia",
    quant: "1",
    pmids: "26496980",
  },
  {
    id: "9226",
    id_polifenol: "35",
    polifenol: "Hydroquinones",
    id_cancer: "563",
    cancer: "Acute Myeloid Leukemia",
    quant: "1",
    pmids: "17166200",
  },
  {
    id: "9227",
    id_polifenol: "111",
    polifenol: "Flavanones",
    id_cancer: "563",
    cancer: "Acute Myeloid Leukemia",
    quant: "1",
    pmids: "28286420",
  },
  {
    id: "9228",
    id_polifenol: "6087",
    polifenol: "wogonin",
    id_cancer: "563",
    cancer: "Acute Myeloid Leukemia",
    quant: "2",
    pmids: "28807161,24895203",
  },
  {
    id: "9229",
    id_polifenol: "4515",
    polifenol: "baicalin",
    id_cancer: "563",
    cancer: "Acute Myeloid Leukemia",
    quant: "2",
    pmids: "11746275,29240303",
  },
  {
    id: "9230",
    id_polifenol: "54",
    polifenol: "Salicylic Acid",
    id_cancer: "563",
    cancer: "Acute Myeloid Leukemia",
    quant: "2",
    pmids: "22148584,18414055",
  },
  {
    id: "9231",
    id_polifenol: "112",
    polifenol: "Hesperidin",
    id_cancer: "563",
    cancer: "Acute Myeloid Leukemia",
    quant: "1",
    pmids: "26148599",
  },
  {
    id: "9232",
    id_polifenol: "6455",
    polifenol: "nobiletin",
    id_cancer: "563",
    cancer: "Acute Myeloid Leukemia",
    quant: "1",
    pmids: "25164609",
  },
  {
    id: "9233",
    id_polifenol: "93",
    polifenol: "Phloroglucinol",
    id_cancer: "563",
    cancer: "Acute Myeloid Leukemia",
    quant: "1",
    pmids: "21998731",
  },
  {
    id: "9234",
    id_polifenol: "4253",
    polifenol:
      "5-(2,4-dihydroxy-5-isopropylphenyl)-4-(4-morpholin-4-ylmethylphenyl)isoxazole-3-carboxylic acid ethylamide",
    id_cancer: "563",
    cancer: "Acute Myeloid Leukemia",
    quant: "2",
    pmids: "23356405,26748184",
  },
  {
    id: "9235",
    id_polifenol: "5844",
    polifenol: "4-dimethylamino-3',4'-dimethoxychalcone",
    id_cancer: "563",
    cancer: "Acute Myeloid Leukemia",
    quant: "1",
    pmids: "10089914",
  },
  {
    id: "9236",
    id_polifenol: "48",
    polifenol: "Anacardic Acids",
    id_cancer: "563",
    cancer: "Acute Myeloid Leukemia",
    quant: "2",
    pmids: "24910433,29487199",
  },
  {
    id: "9237",
    id_polifenol: "4640",
    polifenol: "5,7-dihydroxy-6-methoxy-2-phenylchromen-4-one",
    id_cancer: "563",
    cancer: "Acute Myeloid Leukemia",
    quant: "3",
    pmids: "29346508,23934681,27085528",
  },
  {
    id: "9238",
    id_polifenol: "1644",
    polifenol: "Cur1 compound",
    id_cancer: "563",
    cancer: "Acute Myeloid Leukemia",
    quant: "1",
    pmids: "28489348",
  },
  {
    id: "9239",
    id_polifenol: "7912",
    polifenol: "7,9,2',4'-tetrahydroxy-8-isopentenyl-5-methoxychalcone",
    id_cancer: "563",
    cancer: "Acute Myeloid Leukemia",
    quant: "1",
    pmids: "24901249",
  },
  {
    id: "9240",
    id_polifenol: "4767",
    polifenol: "flavan-3-ol",
    id_cancer: "563",
    cancer: "Acute Myeloid Leukemia",
    quant: "1",
    pmids: "28808383",
  },
  {
    id: "9241",
    id_polifenol: "1996",
    polifenol: "2,5-di-tert-butylhydroquinone",
    id_cancer: "563",
    cancer: "Acute Myeloid Leukemia",
    quant: "1",
    pmids: "24079514",
  },
  {
    id: "9242",
    id_polifenol: "5071",
    polifenol: "icaritin",
    id_cancer: "563",
    cancer: "Acute Myeloid Leukemia",
    quant: "1",
    pmids: "23550021",
  },
  {
    id: "9243",
    id_polifenol: "4585",
    polifenol: "baohuoside I",
    id_cancer: "563",
    cancer: "Acute Myeloid Leukemia",
    quant: "1",
    pmids: "22493659",
  },
  {
    id: "9244",
    id_polifenol: "6625",
    polifenol: "phenoxodiol",
    id_cancer: "563",
    cancer: "Acute Myeloid Leukemia",
    quant: "1",
    pmids: "19535345",
  },
  {
    id: "9245",
    id_polifenol: "59",
    polifenol: "Dinitrophenols",
    id_cancer: "563",
    cancer: "Acute Myeloid Leukemia",
    quant: "1",
    pmids: "9001418",
  },
  {
    id: "9246",
    id_polifenol: "4516",
    polifenol: "diosmetin",
    id_cancer: "563",
    cancer: "Acute Myeloid Leukemia",
    quant: "1",
    pmids: "29412683",
  },
  {
    id: "9247",
    id_polifenol: "637",
    polifenol: "glabridin",
    id_cancer: "563",
    cancer: "Acute Myeloid Leukemia",
    quant: "1",
    pmids: "24901249",
  },
  {
    id: "9248",
    id_polifenol: "6301",
    polifenol: "3-methoxyflavone",
    id_cancer: "563",
    cancer: "Acute Myeloid Leukemia",
    quant: "1",
    pmids: "23481040",
  },
  {
    id: "9249",
    id_polifenol: "77",
    polifenol: "Bezafibrate",
    id_cancer: "563",
    cancer: "Acute Myeloid Leukemia",
    quant: "2",
    pmids: "27493727,19158949",
  },
  {
    id: "9250",
    id_polifenol: "1810",
    polifenol: "heminordihydroguaiaretic acid",
    id_cancer: "563",
    cancer: "Acute Myeloid Leukemia",
    quant: "1",
    pmids: "17454637",
  },
  {
    id: "9251",
    id_polifenol: "1353",
    polifenol: "protocatechualdehyde",
    id_cancer: "563",
    cancer: "Acute Myeloid Leukemia",
    quant: "1",
    pmids: "28920346",
  },
  {
    id: "9252",
    id_polifenol: "4883",
    polifenol: "flavokawain B",
    id_cancer: "563",
    cancer: "Acute Myeloid Leukemia",
    quant: "1",
    pmids: "29715098",
  },
  {
    id: "9253",
    id_polifenol: "2014",
    polifenol: "erbstatin",
    id_cancer: "563",
    cancer: "Acute Myeloid Leukemia",
    quant: "1",
    pmids: "18855573",
  },
  {
    id: "9254",
    id_polifenol: "6129",
    polifenol: "wogonoside",
    id_cancer: "563",
    cancer: "Acute Myeloid Leukemia",
    quant: "1",
    pmids: "29377576",
  },
  {
    id: "9255",
    id_polifenol: "5858",
    polifenol: "isobavachalcone",
    id_cancer: "563",
    cancer: "Acute Myeloid Leukemia",
    quant: "1",
    pmids: "29880605",
  },
  {
    id: "9256",
    id_polifenol: "839",
    polifenol: "5-iodo-3-((3,5-dibromo-4-hydroxyphenyl)methylene)-2-indolinone",
    id_cancer: "563",
    cancer: "Acute Myeloid Leukemia",
    quant: "1",
    pmids: "25817574",
  },
  {
    id: "9257",
    id_polifenol: "416",
    polifenol: "phenoxy radical",
    id_cancer: "563",
    cancer: "Acute Myeloid Leukemia",
    quant: "1",
    pmids: "21097707",
  },
  {
    id: "9258",
    id_polifenol: "6492",
    polifenol: "3(2H)-isoflavene",
    id_cancer: "563",
    cancer: "Acute Myeloid Leukemia",
    quant: "1",
    pmids: "19535345",
  },
  {
    id: "9259",
    id_polifenol: "5802",
    polifenol: "hesperidin methylchalcone",
    id_cancer: "563",
    cancer: "Acute Myeloid Leukemia",
    quant: "1",
    pmids: "26148599",
  },
  {
    id: "9260",
    id_polifenol: "1453",
    polifenol: "4-nerolidylcatechol",
    id_cancer: "563",
    cancer: "Acute Myeloid Leukemia",
    quant: "1",
    pmids: "19084293",
  },
  {
    id: "9261",
    id_polifenol: "6349",
    polifenol: "ME-344",
    id_cancer: "563",
    cancer: "Acute Myeloid Leukemia",
    quant: "1",
    pmids: "27391350",
  },
  {
    id: "9262",
    id_polifenol: "886",
    polifenol: "4-(2-hydroxyphenyl)but-3-en-2-one",
    id_cancer: "563",
    cancer: "Acute Myeloid Leukemia",
    quant: "1",
    pmids: "28920346",
  },
  {
    id: "9263",
    id_polifenol: "2926",
    polifenol:
      "4-(N-(4-cyclohexylbenzyl)-2-(N,2,4,6-tetramethylphenylsulfonamido)acetamido)-2-hydroxybenzoic acid",
    id_cancer: "563",
    cancer: "Acute Myeloid Leukemia",
    quant: "1",
    pmids: "22148584",
  },
  {
    id: "9264",
    id_polifenol: "7761",
    polifenol: "ITB 301",
    id_cancer: "563",
    cancer: "Acute Myeloid Leukemia",
    quant: "1",
    pmids: "21340606",
  },
  {
    id: "9265",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "547",
    cancer: "Head and Neck Cancer",
    quant: "8",
    pmids:
      "25450235,24477342,27544755,17936716,26517526,23980682,26520390,12819936",
  },
  {
    id: "9266",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "547",
    cancer: "Head and Neck Cancer",
    quant: "33",
    pmids:
      "15252836,25910231,16642480,21576562,25767602,28881600,28409156,19655336,26511491,26505786,28649799,17240359,24675768,25296980,21299897,16203793,20937593,24628271,29651934,29332583,9482545,22624612,27219631,22441776,24851881,26469832,21821700,20851953,18462866,22583425,24177052,29788875,29602908",
  },
  {
    id: "9267",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "547",
    cancer: "Head and Neck Cancer",
    quant: "15",
    pmids:
      "17475222,19784583,27550943,27670669,25296980,29054984,22923287,21299897,27886147,27633858,25306067,16611409,22441776,26469832,23242008",
  },
  {
    id: "9268",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "547",
    cancer: "Head and Neck Cancer",
    quant: "5",
    pmids: "15643499,21896192,15389589,15581417,24351425",
  },
  {
    id: "9269",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "547",
    cancer: "Head and Neck Cancer",
    quant: "4",
    pmids: "11751518,10639578,15077059,29602908",
  },
  {
    id: "9270",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "547",
    cancer: "Head and Neck Cancer",
    quant: "7",
    pmids: "16082193,27510965,29332583,23556141,22300659,22422628,26622865",
  },
  {
    id: "9271",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "547",
    cancer: "Head and Neck Cancer",
    quant: "8",
    pmids:
      "19784583,25860284,23017582,12960141,22923287,27765354,27886147,29332583",
  },
  {
    id: "9272",
    id_polifenol: "2167",
    polifenol: "phenolic acid",
    id_cancer: "547",
    cancer: "Head and Neck Cancer",
    quant: "3",
    pmids: "25306067,29332583,23242008",
  },
  {
    id: "9273",
    id_polifenol: "49",
    polifenol: "Aspirin",
    id_cancer: "547",
    cancer: "Head and Neck Cancer",
    quant: "2",
    pmids: "20654727,28057599",
  },
  {
    id: "9274",
    id_polifenol: "109",
    polifenol: "Catechin",
    id_cancer: "547",
    cancer: "Head and Neck Cancer",
    quant: "1",
    pmids: "17045795",
  },
  {
    id: "9275",
    id_polifenol: "125",
    polifenol: "Isoflavones",
    id_cancer: "547",
    cancer: "Head and Neck Cancer",
    quant: "2",
    pmids: "10639578,15077059",
  },
  {
    id: "9276",
    id_polifenol: "3089",
    polifenol: "1,1-diphenyl-2-picrylhydrazyl",
    id_cancer: "547",
    cancer: "Head and Neck Cancer",
    quant: "1",
    pmids: "27673552",
  },
  {
    id: "9277",
    id_polifenol: "114",
    polifenol: "Apigenin",
    id_cancer: "547",
    cancer: "Head and Neck Cancer",
    quant: "5",
    pmids: "22554915,28547940,23980682,29604587,22300659",
  },
  {
    id: "9278",
    id_polifenol: "113",
    polifenol: "Flavones",
    id_cancer: "547",
    cancer: "Head and Neck Cancer",
    quant: "3",
    pmids: "17936716,22554915,29604587",
  },
  {
    id: "9279",
    id_polifenol: "117",
    polifenol: "Luteolin",
    id_cancer: "547",
    cancer: "Head and Neck Cancer",
    quant: "4",
    pmids: "24477342,24403290,26517526,29602908",
  },
  {
    id: "9280",
    id_polifenol: "129",
    polifenol: "Rotenone",
    id_cancer: "547",
    cancer: "Head and Neck Cancer",
    quant: "1",
    pmids: "15077059",
  },
  {
    id: "9281",
    id_polifenol: "121",
    polifenol: "Kaempferols",
    id_cancer: "547",
    cancer: "Head and Neck Cancer",
    quant: "1",
    pmids: "22300659",
  },
  {
    id: "9282",
    id_polifenol: "871",
    polifenol: "ABT-737",
    id_cancer: "547",
    cancer: "Head and Neck Cancer",
    quant: "1",
    pmids: "26934442",
  },
  {
    id: "9283",
    id_polifenol: "6451",
    polifenol: "daidzein",
    id_cancer: "547",
    cancer: "Head and Neck Cancer",
    quant: "1",
    pmids: "10639578",
  },
  {
    id: "9284",
    id_polifenol: "4634",
    polifenol: "alvocidib",
    id_cancer: "547",
    cancer: "Head and Neck Cancer",
    quant: "4",
    pmids: "9802881,29899842,11093360,12819936",
  },
  {
    id: "9285",
    id_polifenol: "120",
    polifenol: "Flavonols",
    id_cancer: "547",
    cancer: "Head and Neck Cancer",
    quant: "2",
    pmids: "26794656,22300659",
  },
  {
    id: "9286",
    id_polifenol: "6062",
    polifenol: "naringenin",
    id_cancer: "547",
    cancer: "Head and Neck Cancer",
    quant: "1",
    pmids: "17936716",
  },
  {
    id: "9287",
    id_polifenol: "39",
    polifenol: "Hydrolyzable Tannins",
    id_cancer: "547",
    cancer: "Head and Neck Cancer",
    quant: "1",
    pmids: "23242008",
  },
  {
    id: "9288",
    id_polifenol: "130",
    polifenol: "Proanthocyanidins",
    id_cancer: "547",
    cancer: "Head and Neck Cancer",
    quant: "3",
    pmids: "27886147,22188922,21311213",
  },
  {
    id: "9289",
    id_polifenol: "4502",
    polifenol: "fisetin",
    id_cancer: "547",
    cancer: "Head and Neck Cancer",
    quant: "1",
    pmids: "22300659",
  },
  {
    id: "9290",
    id_polifenol: "15",
    polifenol: "Masoprocol",
    id_cancer: "547",
    cancer: "Head and Neck Cancer",
    quant: "2",
    pmids: "20654727,9482545",
  },
  {
    id: "9291",
    id_polifenol: "6087",
    polifenol: "wogonin",
    id_cancer: "547",
    cancer: "Head and Neck Cancer",
    quant: "1",
    pmids: "27544755",
  },
  {
    id: "9292",
    id_polifenol: "4519",
    polifenol: "myricetin",
    id_cancer: "547",
    cancer: "Head and Neck Cancer",
    quant: "2",
    pmids: "26794656,22300659",
  },
  {
    id: "9293",
    id_polifenol: "5608",
    polifenol: "epicatechin gallate",
    id_cancer: "547",
    cancer: "Head and Neck Cancer",
    quant: "1",
    pmids: "17045795",
  },
  {
    id: "9294",
    id_polifenol: "1356",
    polifenol: "gingerol",
    id_cancer: "547",
    cancer: "Head and Neck Cancer",
    quant: "1",
    pmids: "29168275",
  },
  {
    id: "9295",
    id_polifenol: "2344",
    polifenol: "methyl gallate",
    id_cancer: "547",
    cancer: "Head and Neck Cancer",
    quant: "1",
    pmids: "12960141",
  },
  {
    id: "9296",
    id_polifenol: "4513",
    polifenol: "galangin",
    id_cancer: "547",
    cancer: "Head and Neck Cancer",
    quant: "2",
    pmids: "25450235,22300659",
  },
  {
    id: "9297",
    id_polifenol: "1380",
    polifenol: "shogaol",
    id_cancer: "547",
    cancer: "Head and Neck Cancer",
    quant: "1",
    pmids: "29168275",
  },
  {
    id: "9298",
    id_polifenol: "6273",
    polifenol: "hesperetin",
    id_cancer: "547",
    cancer: "Head and Neck Cancer",
    quant: "1",
    pmids: "26520390",
  },
  {
    id: "9299",
    id_polifenol: "81",
    polifenol: "Fenofibrate",
    id_cancer: "547",
    cancer: "Head and Neck Cancer",
    quant: "1",
    pmids: "28179297",
  },
  {
    id: "9300",
    id_polifenol: "7550",
    polifenol: "3-methylquercetin",
    id_cancer: "547",
    cancer: "Head and Neck Cancer",
    quant: "1",
    pmids: "22300659",
  },
  {
    id: "9301",
    id_polifenol: "4253",
    polifenol:
      "5-(2,4-dihydroxy-5-isopropylphenyl)-4-(4-morpholin-4-ylmethylphenyl)isoxazole-3-carboxylic acid ethylamide",
    id_cancer: "547",
    cancer: "Head and Neck Cancer",
    quant: "1",
    pmids: "28143445",
  },
  {
    id: "9302",
    id_polifenol: "55",
    polifenol: "Sodium Salicylate",
    id_cancer: "547",
    cancer: "Head and Neck Cancer",
    quant: "1",
    pmids: "11813903",
  },
  {
    id: "9303",
    id_polifenol: "5844",
    polifenol: "4-dimethylamino-3',4'-dimethoxychalcone",
    id_cancer: "547",
    cancer: "Head and Neck Cancer",
    quant: "2",
    pmids: "16543918,10389908",
  },
  {
    id: "9304",
    id_polifenol: "6068",
    polifenol: "pinocembrin",
    id_cancer: "547",
    cancer: "Head and Neck Cancer",
    quant: "1",
    pmids: "28547940",
  },
  {
    id: "9305",
    id_polifenol: "7296",
    polifenol: "dihydromyricetin",
    id_cancer: "547",
    cancer: "Head and Neck Cancer",
    quant: "1",
    pmids: "27474168",
  },
  {
    id: "9306",
    id_polifenol: "7557",
    polifenol: "rhamnetin",
    id_cancer: "547",
    cancer: "Head and Neck Cancer",
    quant: "1",
    pmids: "22300659",
  },
  {
    id: "9307",
    id_polifenol: "687",
    polifenol: "calix(4)arene",
    id_cancer: "547",
    cancer: "Head and Neck Cancer",
    quant: "1",
    pmids: "23392775",
  },
  {
    id: "9308",
    id_polifenol: "1672",
    polifenol: "B19 monocarbonyl curcumin",
    id_cancer: "547",
    cancer: "Head and Neck Cancer",
    quant: "1",
    pmids: "28409156",
  },
  {
    id: "9309",
    id_polifenol: "6693",
    polifenol: "2',4',7-trihydroxyisoflavone",
    id_cancer: "547",
    cancer: "Head and Neck Cancer",
    quant: "1",
    pmids: "11751518",
  },
  {
    id: "9310",
    id_polifenol: "3662",
    polifenol: "3-tert-butyl-4-hydroxyanisole",
    id_cancer: "547",
    cancer: "Head and Neck Cancer",
    quant: "1",
    pmids: "17404501",
  },
  {
    id: "9311",
    id_polifenol: "106",
    polifenol: "Benzoflavones",
    id_cancer: "547",
    cancer: "Head and Neck Cancer",
    quant: "1",
    pmids: "27150634",
  },
  {
    id: "9312",
    id_polifenol: "5697",
    polifenol:
      "3-(3,4-dimethoxyphenyl)-1-(5-hydroxy-2,2-dimethyl-2H-chromen-6-yl)prop-2-en-1-one",
    id_cancer: "547",
    cancer: "Head and Neck Cancer",
    quant: "1",
    pmids: "27550943",
  },
  {
    id: "9313",
    id_polifenol: "42",
    polifenol: "Pactamycin",
    id_cancer: "547",
    cancer: "Head and Neck Cancer",
    quant: "1",
    pmids: "25938491",
  },
  {
    id: "9314",
    id_polifenol: "1642",
    polifenol: "FLLL 32",
    id_cancer: "547",
    cancer: "Head and Neck Cancer",
    quant: "1",
    pmids: "21576562",
  },
  {
    id: "9315",
    id_polifenol: "1634",
    polifenol: "FLLL-12 compound",
    id_cancer: "547",
    cancer: "Head and Neck Cancer",
    quant: "1",
    pmids: "26511491",
  },
  {
    id: "9316",
    id_polifenol: "7014",
    polifenol: "3,4',7-trihydroxy-3'-methoxyflavone",
    id_cancer: "547",
    cancer: "Head and Neck Cancer",
    quant: "1",
    pmids: "22300659",
  },
  {
    id: "9317",
    id_polifenol: "1159",
    polifenol: "2-(5-(3-fluorophenyl)-1H-pyrazol-3-yl)-5-methylphenol",
    id_cancer: "547",
    cancer: "Head and Neck Cancer",
    quant: "1",
    pmids: "27550943",
  },
  {
    id: "9318",
    id_polifenol: "6071",
    polifenol: "7-hydroxyflavanone",
    id_cancer: "547",
    cancer: "Head and Neck Cancer",
    quant: "1",
    pmids: "17936716",
  },
  {
    id: "9319",
    id_polifenol: "2556",
    polifenol: "cranomycin",
    id_cancer: "547",
    cancer: "Head and Neck Cancer",
    quant: "1",
    pmids: "25938491",
  },
  {
    id: "9320",
    id_polifenol: "7306",
    polifenol: "7,3'-dihydroxyflavonol",
    id_cancer: "547",
    cancer: "Head and Neck Cancer",
    quant: "1",
    pmids: "22300659",
  },
  {
    id: "9321",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "498",
    cancer: "Esophageal Cancer",
    quant: "12",
    pmids:
      "24940817,25084411,21785828,25192723,29693162,25788859,17368593,25436288,26622901,28042498,26520390,16530937",
  },
  {
    id: "9322",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "498",
    cancer: "Esophageal Cancer",
    quant: "8",
    pmids:
      "29424917,22363450,28566729,25640947,23192861,26037398,22253518,22316666",
  },
  {
    id: "9323",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "498",
    cancer: "Esophageal Cancer",
    quant: "9",
    pmids:
      "14633667,19073162,9103268,16140980,21538848,16800771,9759559,22279681,29966007",
  },
  {
    id: "9324",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "498",
    cancer: "Esophageal Cancer",
    quant: "11",
    pmids:
      "16627221,15081869,15718251,15161032,16480952,23892041,10763823,15375172,17306610,27188603,11297525",
  },
  {
    id: "9325",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "498",
    cancer: "Esophageal Cancer",
    quant: "2",
    pmids: "11316564,8603368",
  },
  {
    id: "9326",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "498",
    cancer: "Esophageal Cancer",
    quant: "4",
    pmids: "24940817,23226792,25374189,16800771",
  },
  {
    id: "9327",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "498",
    cancer: "Esophageal Cancer",
    quant: "7",
    pmids: "28943954,28964574,14633667,23892041,28693288,22253518,16140980",
  },
  {
    id: "9328",
    id_polifenol: "49",
    polifenol: "Aspirin",
    id_cancer: "498",
    cancer: "Esophageal Cancer",
    quant: "6",
    pmids: "10868686,11922545,19534809,18197933,18058818,24605249",
  },
  {
    id: "9329",
    id_polifenol: "109",
    polifenol: "Catechin",
    id_cancer: "498",
    cancer: "Esophageal Cancer",
    quant: "2",
    pmids: "15145696,15464031",
  },
  {
    id: "9330",
    id_polifenol: "125",
    polifenol: "Isoflavones",
    id_cancer: "498",
    cancer: "Esophageal Cancer",
    quant: "3",
    pmids: "14687509,25189132,28325828",
  },
  {
    id: "9331",
    id_polifenol: "110",
    polifenol: "Chalcones",
    id_cancer: "498",
    cancer: "Esophageal Cancer",
    quant: "1",
    pmids: "28566729",
  },
  {
    id: "9332",
    id_polifenol: "3089",
    polifenol: "1,1-diphenyl-2-picrylhydrazyl",
    id_cancer: "498",
    cancer: "Esophageal Cancer",
    quant: "1",
    pmids: "27928516",
  },
  {
    id: "9333",
    id_polifenol: "114",
    polifenol: "Apigenin",
    id_cancer: "498",
    cancer: "Esophageal Cancer",
    quant: "1",
    pmids: "26435325",
  },
  {
    id: "9334",
    id_polifenol: "113",
    polifenol: "Flavones",
    id_cancer: "498",
    cancer: "Esophageal Cancer",
    quant: "3",
    pmids: "23420294,9829756,15569374",
  },
  {
    id: "9335",
    id_polifenol: "38",
    polifenol: "Gallic Acid",
    id_cancer: "498",
    cancer: "Esophageal Cancer",
    quant: "2",
    pmids: "17273761,9759559",
  },
  {
    id: "9336",
    id_polifenol: "117",
    polifenol: "Luteolin",
    id_cancer: "498",
    cancer: "Esophageal Cancer",
    quant: "1",
    pmids: "28460467",
  },
  {
    id: "9337",
    id_polifenol: "1",
    polifenol: "Phenols",
    id_cancer: "498",
    cancer: "Esophageal Cancer",
    quant: "1",
    pmids: "3191485",
  },
  {
    id: "9338",
    id_polifenol: "105",
    polifenol: "Anthocyanins",
    id_cancer: "498",
    cancer: "Esophageal Cancer",
    quant: "4",
    pmids: "26603620,16800771,24667581,28553369",
  },
  {
    id: "9339",
    id_polifenol: "7235",
    polifenol: "silybin",
    id_cancer: "498",
    cancer: "Esophageal Cancer",
    quant: "1",
    pmids: "26568207",
  },
  {
    id: "9340",
    id_polifenol: "121",
    polifenol: "Kaempferols",
    id_cancer: "498",
    cancer: "Esophageal Cancer",
    quant: "2",
    pmids: "21678497,16800771",
  },
  {
    id: "9341",
    id_polifenol: "6451",
    polifenol: "daidzein",
    id_cancer: "498",
    cancer: "Esophageal Cancer",
    quant: "1",
    pmids: "28325828",
  },
  {
    id: "9342",
    id_polifenol: "6065",
    polifenol: "baicalein",
    id_cancer: "498",
    cancer: "Esophageal Cancer",
    quant: "1",
    pmids: "23420294",
  },
  {
    id: "9343",
    id_polifenol: "4634",
    polifenol: "alvocidib",
    id_cancer: "498",
    cancer: "Esophageal Cancer",
    quant: "6",
    pmids: "23833659,12771887,16905211,9829756,15569374,17097874",
  },
  {
    id: "9344",
    id_polifenol: "120",
    polifenol: "Flavonols",
    id_cancer: "498",
    cancer: "Esophageal Cancer",
    quant: "1",
    pmids: "28667862",
  },
  {
    id: "9345",
    id_polifenol: "4522",
    polifenol: "chrysin",
    id_cancer: "498",
    cancer: "Esophageal Cancer",
    quant: "1",
    pmids: "24940817",
  },
  {
    id: "9346",
    id_polifenol: "6062",
    polifenol: "naringenin",
    id_cancer: "498",
    cancer: "Esophageal Cancer",
    quant: "1",
    pmids: "24940817",
  },
  {
    id: "9347",
    id_polifenol: "39",
    polifenol: "Hydrolyzable Tannins",
    id_cancer: "498",
    cancer: "Esophageal Cancer",
    quant: "1",
    pmids: "9759559",
  },
  {
    id: "9348",
    id_polifenol: "130",
    polifenol: "Proanthocyanidins",
    id_cancer: "498",
    cancer: "Esophageal Cancer",
    quant: "1",
    pmids: "18211022",
  },
  {
    id: "9349",
    id_polifenol: "6",
    polifenol: "Catechols",
    id_cancer: "498",
    cancer: "Esophageal Cancer",
    quant: "1",
    pmids: "12153764",
  },
  {
    id: "9350",
    id_polifenol: "4519",
    polifenol: "myricetin",
    id_cancer: "498",
    cancer: "Esophageal Cancer",
    quant: "2",
    pmids: "25192723,25788859",
  },
  {
    id: "9351",
    id_polifenol: "2158",
    polifenol: "protocatechuic acid",
    id_cancer: "498",
    cancer: "Esophageal Cancer",
    quant: "2",
    pmids: "26603620,24667581",
  },
  {
    id: "9352",
    id_polifenol: "6273",
    polifenol: "hesperetin",
    id_cancer: "498",
    cancer: "Esophageal Cancer",
    quant: "2",
    pmids: "26449828,26520390",
  },
  {
    id: "9353",
    id_polifenol: "81",
    polifenol: "Fenofibrate",
    id_cancer: "498",
    cancer: "Esophageal Cancer",
    quant: "1",
    pmids: "25712601",
  },
  {
    id: "9354",
    id_polifenol: "7550",
    polifenol: "3-methylquercetin",
    id_cancer: "498",
    cancer: "Esophageal Cancer",
    quant: "1",
    pmids: "17368593",
  },
  {
    id: "9355",
    id_polifenol: "4253",
    polifenol:
      "5-(2,4-dihydroxy-5-isopropylphenyl)-4-(4-morpholin-4-ylmethylphenyl)isoxazole-3-carboxylic acid ethylamide",
    id_cancer: "498",
    cancer: "Esophageal Cancer",
    quant: "1",
    pmids: "23064324",
  },
  {
    id: "9356",
    id_polifenol: "55",
    polifenol: "Sodium Salicylate",
    id_cancer: "498",
    cancer: "Esophageal Cancer",
    quant: "1",
    pmids: "19435811",
  },
  {
    id: "9357",
    id_polifenol: "6463",
    polifenol: "puerarin",
    id_cancer: "498",
    cancer: "Esophageal Cancer",
    quant: "1",
    pmids: "25189132",
  },
  {
    id: "9358",
    id_polifenol: "5819",
    polifenol: "licochalcone A",
    id_cancer: "498",
    cancer: "Esophageal Cancer",
    quant: "1",
    pmids: "25436288",
  },
  {
    id: "9359",
    id_polifenol: "94",
    polifenol: "Phloretin",
    id_cancer: "498",
    cancer: "Esophageal Cancer",
    quant: "1",
    pmids: "29151915",
  },
  {
    id: "9360",
    id_polifenol: "4560",
    polifenol: "icariin",
    id_cancer: "498",
    cancer: "Esophageal Cancer",
    quant: "2",
    pmids: "28667862,26892033",
  },
  {
    id: "9361",
    id_polifenol: "1866",
    polifenol: "4,6-dinitro-o-cresol",
    id_cancer: "498",
    cancer: "Esophageal Cancer",
    quant: "1",
    pmids: "29088714",
  },
  {
    id: "9362",
    id_polifenol: "4585",
    polifenol: "baohuoside I",
    id_cancer: "498",
    cancer: "Esophageal Cancer",
    quant: "1",
    pmids: "21785828",
  },
  {
    id: "9363",
    id_polifenol: "102",
    polifenol: "Zearalenone",
    id_cancer: "498",
    cancer: "Esophageal Cancer",
    quant: "1",
    pmids: "21683775",
  },
  {
    id: "9364",
    id_polifenol: "40",
    polifenol: "Propyl Gallate",
    id_cancer: "498",
    cancer: "Esophageal Cancer",
    quant: "1",
    pmids: "9759559",
  },
  {
    id: "9365",
    id_polifenol: "7134",
    polifenol: "vitexin",
    id_cancer: "498",
    cancer: "Esophageal Cancer",
    quant: "1",
    pmids: "29328424",
  },
  {
    id: "9366",
    id_polifenol: "4525",
    polifenol: "eupatilin",
    id_cancer: "498",
    cancer: "Esophageal Cancer",
    quant: "1",
    pmids: "29693162",
  },
  {
    id: "9367",
    id_polifenol: "5455",
    polifenol: "theaflavin-3,3'-digallate",
    id_cancer: "498",
    cancer: "Esophageal Cancer",
    quant: "1",
    pmids: "23892041",
  },
  {
    id: "9368",
    id_polifenol: "5630",
    polifenol: "polyphenon E",
    id_cancer: "498",
    cancer: "Esophageal Cancer",
    quant: "1",
    pmids: "20192119",
  },
  {
    id: "9369",
    id_polifenol: "6301",
    polifenol: "3-methoxyflavone",
    id_cancer: "498",
    cancer: "Esophageal Cancer",
    quant: "1",
    pmids: "15081869",
  },
  {
    id: "9370",
    id_polifenol: "4578",
    polifenol: "5,7-dimethoxyflavone",
    id_cancer: "498",
    cancer: "Esophageal Cancer",
    quant: "1",
    pmids: "16530937",
  },
  {
    id: "9371",
    id_polifenol: "9",
    polifenol: "1,2-Dihydroxybenzene-3,5-Disulfonic Acid Disodium Salt",
    id_cancer: "498",
    cancer: "Esophageal Cancer",
    quant: "1",
    pmids: "20920876",
  },
  {
    id: "9372",
    id_polifenol: "1918",
    polifenol: "2,6-di-tert-butyl-4-(aminomethyl)phenol hydrochloride",
    id_cancer: "498",
    cancer: "Esophageal Cancer",
    quant: "1",
    pmids: "27188603",
  },
  {
    id: "9373",
    id_polifenol: "5615",
    polifenol: "gallocatechin gallate",
    id_cancer: "498",
    cancer: "Esophageal Cancer",
    quant: "1",
    pmids: "16140980",
  },
  {
    id: "9374",
    id_polifenol: "4607",
    polifenol: "orientin",
    id_cancer: "498",
    cancer: "Esophageal Cancer",
    quant: "1",
    pmids: "26622901",
  },
  {
    id: "9375",
    id_polifenol: "6680",
    polifenol: "6,7,4'-trihydroxyisoflavone",
    id_cancer: "498",
    cancer: "Esophageal Cancer",
    quant: "1",
    pmids: "28325828",
  },
  {
    id: "9376",
    id_polifenol: "4698",
    polifenol: "sakuranetin",
    id_cancer: "498",
    cancer: "Esophageal Cancer",
    quant: "1",
    pmids: "25076224",
  },
  {
    id: "9377",
    id_polifenol: "6711",
    polifenol: "3',4'-dimethoxyflavone",
    id_cancer: "498",
    cancer: "Esophageal Cancer",
    quant: "1",
    pmids: "16530937",
  },
  {
    id: "9378",
    id_polifenol: "2169",
    polifenol: "ethyl protocatechuate",
    id_cancer: "498",
    cancer: "Esophageal Cancer",
    quant: "2",
    pmids: "26934124,25232961",
  },
  {
    id: "9379",
    id_polifenol: "6291",
    polifenol: "alpinumisoflavone",
    id_cancer: "498",
    cancer: "Esophageal Cancer",
    quant: "1",
    pmids: "28042498",
  },
  {
    id: "9380",
    id_polifenol: "4677",
    polifenol: "baohuoside II",
    id_cancer: "498",
    cancer: "Esophageal Cancer",
    quant: "1",
    pmids: "21785828",
  },
  {
    id: "9381",
    id_polifenol: "7913",
    polifenol: "davidigenin",
    id_cancer: "498",
    cancer: "Esophageal Cancer",
    quant: "1",
    pmids: "25076224",
  },
  {
    id: "9382",
    id_polifenol: "556",
    polifenol: "alpha-guaiaconic acid",
    id_cancer: "498",
    cancer: "Esophageal Cancer",
    quant: "1",
    pmids: "7691764",
  },
  {
    id: "9383",
    id_polifenol: "913",
    polifenol: "mahkoside A",
    id_cancer: "498",
    cancer: "Esophageal Cancer",
    quant: "1",
    pmids: "23044367",
  },
  {
    id: "9384",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "6579",
    cancer: "Gastrointestinal Neoplasms",
    quant: "7",
    pmids: "25203554,16413414,19638489,9018079,23197449,19135109,27262332",
  },
  {
    id: "9385",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "6579",
    cancer: "Gastrointestinal Neoplasms",
    quant: "18",
    pmids:
      "18339878,11396178,17000667,26318057,17431105,25622075,26308760,29245915,11221833,18462866,26651248,17569217,15501961,26366338,20155625,12869420,21386635,27262332",
  },
  {
    id: "9386",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "6579",
    cancer: "Gastrointestinal Neoplasms",
    quant: "12",
    pmids:
      "12819184,16413414,15308587,29125219,23475480,11998565,21687829,19323893,17442116,19588362,27262332,18850155",
  },
  {
    id: "9387",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "6579",
    cancer: "Gastrointestinal Neoplasms",
    quant: "8",
    pmids:
      "27347133,22824956,18592268,25012123,15298620,19281788,24106166,11228545",
  },
  {
    id: "9388",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "6579",
    cancer: "Gastrointestinal Neoplasms",
    quant: "3",
    pmids: "9018079,26651248,25322458",
  },
  {
    id: "9389",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "6579",
    cancer: "Gastrointestinal Neoplasms",
    quant: "4",
    pmids: "12934110,26328486,9018079,12869420",
  },
  {
    id: "9390",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "6579",
    cancer: "Gastrointestinal Neoplasms",
    quant: "9",
    pmids:
      "26278714,12819184,23475480,11998565,21687829,20506079,27262332,2503469,21615871",
  },
  {
    id: "9391",
    id_polifenol: "2167",
    polifenol: "phenolic acid",
    id_cancer: "6579",
    cancer: "Gastrointestinal Neoplasms",
    quant: "2",
    pmids: "29066408,18850155",
  },
  {
    id: "9392",
    id_polifenol: "49",
    polifenol: "Aspirin",
    id_cancer: "6579",
    cancer: "Gastrointestinal Neoplasms",
    quant: "13",
    pmids:
      "16596229,10868686,27638860,12606945,15188000,12671901,14529406,11166002,9102213,12792801,12171603,9823297,16493264",
  },
  {
    id: "9393",
    id_polifenol: "109",
    polifenol: "Catechin",
    id_cancer: "6579",
    cancer: "Gastrointestinal Neoplasms",
    quant: "7",
    pmids: "26278714,16413414,15308587,23475480,15464031,20506079,19588362",
  },
  {
    id: "9394",
    id_polifenol: "125",
    polifenol: "Isoflavones",
    id_cancer: "6579",
    cancer: "Gastrointestinal Neoplasms",
    quant: "1",
    pmids: "25322458",
  },
  {
    id: "9395",
    id_polifenol: "114",
    polifenol: "Apigenin",
    id_cancer: "6579",
    cancer: "Gastrointestinal Neoplasms",
    quant: "2",
    pmids: "19638489,23197449",
  },
  {
    id: "9396",
    id_polifenol: "113",
    polifenol: "Flavones",
    id_cancer: "6579",
    cancer: "Gastrointestinal Neoplasms",
    quant: "4",
    pmids: "19638489,24631140,12869420,7139549",
  },
  {
    id: "9397",
    id_polifenol: "1",
    polifenol: "Phenols",
    id_cancer: "6579",
    cancer: "Gastrointestinal Neoplasms",
    quant: "1",
    pmids: "19638489",
  },
  {
    id: "9398",
    id_polifenol: "105",
    polifenol: "Anthocyanins",
    id_cancer: "6579",
    cancer: "Gastrointestinal Neoplasms",
    quant: "4",
    pmids: "18327700,17442116,18816259,22331709",
  },
  {
    id: "9399",
    id_polifenol: "7",
    polifenol: "Capsaicin",
    id_cancer: "6579",
    cancer: "Gastrointestinal Neoplasms",
    quant: "3",
    pmids: "26651248,16431906,1373965",
  },
  {
    id: "9400",
    id_polifenol: "4634",
    polifenol: "alvocidib",
    id_cancer: "6579",
    cancer: "Gastrointestinal Neoplasms",
    quant: "4",
    pmids: "11489836,14676132,26651248,11093360",
  },
  {
    id: "9401",
    id_polifenol: "6062",
    polifenol: "naringenin",
    id_cancer: "6579",
    cancer: "Gastrointestinal Neoplasms",
    quant: "1",
    pmids: "18176909",
  },
  {
    id: "9402",
    id_polifenol: "285",
    polifenol: "bisphenol A",
    id_cancer: "6579",
    cancer: "Gastrointestinal Neoplasms",
    quant: "2",
    pmids: "25534675,29066408",
  },
  {
    id: "9403",
    id_polifenol: "6",
    polifenol: "Catechols",
    id_cancer: "6579",
    cancer: "Gastrointestinal Neoplasms",
    quant: "1",
    pmids: "8243170",
  },
  {
    id: "9404",
    id_polifenol: "15",
    polifenol: "Masoprocol",
    id_cancer: "6579",
    cancer: "Gastrointestinal Neoplasms",
    quant: "1",
    pmids: "1551103",
  },
  {
    id: "9405",
    id_polifenol: "6087",
    polifenol: "wogonin",
    id_cancer: "6579",
    cancer: "Gastrointestinal Neoplasms",
    quant: "1",
    pmids: "25203554",
  },
  {
    id: "9406",
    id_polifenol: "5608",
    polifenol: "epicatechin gallate",
    id_cancer: "6579",
    cancer: "Gastrointestinal Neoplasms",
    quant: "1",
    pmids: "15308587",
  },
  {
    id: "9407",
    id_polifenol: "1356",
    polifenol: "gingerol",
    id_cancer: "6579",
    cancer: "Gastrointestinal Neoplasms",
    quant: "2",
    pmids: "26651248,25838819",
  },
  {
    id: "9408",
    id_polifenol: "54",
    polifenol: "Salicylic Acid",
    id_cancer: "6579",
    cancer: "Gastrointestinal Neoplasms",
    quant: "1",
    pmids: "11472246",
  },
  {
    id: "9409",
    id_polifenol: "44",
    polifenol: "Salicylates",
    id_cancer: "6579",
    cancer: "Gastrointestinal Neoplasms",
    quant: "1",
    pmids: "16596229",
  },
  {
    id: "9410",
    id_polifenol: "1380",
    polifenol: "shogaol",
    id_cancer: "6579",
    cancer: "Gastrointestinal Neoplasms",
    quant: "1",
    pmids: "25838819",
  },
  {
    id: "9411",
    id_polifenol: "6273",
    polifenol: "hesperetin",
    id_cancer: "6579",
    cancer: "Gastrointestinal Neoplasms",
    quant: "1",
    pmids: "16413414",
  },
  {
    id: "9412",
    id_polifenol: "6461",
    polifenol: "acacetin",
    id_cancer: "6579",
    cancer: "Gastrointestinal Neoplasms",
    quant: "1",
    pmids: "25203554",
  },
  {
    id: "9413",
    id_polifenol: "107",
    polifenol: "beta-Naphthoflavone",
    id_cancer: "6579",
    cancer: "Gastrointestinal Neoplasms",
    quant: "1",
    pmids: "16596229",
  },
  {
    id: "9414",
    id_polifenol: "119",
    polifenol: "Silymarin",
    id_cancer: "6579",
    cancer: "Gastrointestinal Neoplasms",
    quant: "1",
    pmids: "25609004",
  },
  {
    id: "9415",
    id_polifenol: "69",
    polifenol: "Phenolsulfonphthalein",
    id_cancer: "6579",
    cancer: "Gastrointestinal Neoplasms",
    quant: "1",
    pmids: "9831078",
  },
  {
    id: "9416",
    id_polifenol: "5509",
    polifenol: "cyanidin 3-O-glucoside",
    id_cancer: "6579",
    cancer: "Gastrointestinal Neoplasms",
    quant: "1",
    pmids: "18327700",
  },
  {
    id: "9417",
    id_polifenol: "4640",
    polifenol: "5,7-dihydroxy-6-methoxy-2-phenylchromen-4-one",
    id_cancer: "6579",
    cancer: "Gastrointestinal Neoplasms",
    quant: "1",
    pmids: "23823704",
  },
  {
    id: "9418",
    id_polifenol: "1644",
    polifenol: "Cur1 compound",
    id_cancer: "6579",
    cancer: "Gastrointestinal Neoplasms",
    quant: "1",
    pmids: "25622075",
  },
  {
    id: "9419",
    id_polifenol: "100",
    polifenol: "Resorcinols",
    id_cancer: "6579",
    cancer: "Gastrointestinal Neoplasms",
    quant: "2",
    pmids: "21751842,24392814",
  },
  {
    id: "9420",
    id_polifenol: "300",
    polifenol: "rhodioloside",
    id_cancer: "6579",
    cancer: "Gastrointestinal Neoplasms",
    quant: "1",
    pmids: "27262332",
  },
  {
    id: "9421",
    id_polifenol: "6576",
    polifenol: "5,7,4'-trihydroxyflavone",
    id_cancer: "6579",
    cancer: "Gastrointestinal Neoplasms",
    quant: "2",
    pmids: "19638489,23197449",
  },
  {
    id: "9422",
    id_polifenol: "1616",
    polifenol: "tetrahydrocurcumin",
    id_cancer: "6579",
    cancer: "Gastrointestinal Neoplasms",
    quant: "1",
    pmids: "11221833",
  },
  {
    id: "9423",
    id_polifenol: "4525",
    polifenol: "eupatilin",
    id_cancer: "6579",
    cancer: "Gastrointestinal Neoplasms",
    quant: "1",
    pmids: "19281788",
  },
  {
    id: "9424",
    id_polifenol: "5815",
    polifenol: "dibenzoylmethane",
    id_cancer: "6579",
    cancer: "Gastrointestinal Neoplasms",
    quant: "1",
    pmids: "17942926",
  },
  {
    id: "9425",
    id_polifenol: "349",
    polifenol: "4-nitrophenol",
    id_cancer: "6579",
    cancer: "Gastrointestinal Neoplasms",
    quant: "1",
    pmids: "12869420",
  },
  {
    id: "9426",
    id_polifenol: "77",
    polifenol: "Bezafibrate",
    id_cancer: "6579",
    cancer: "Gastrointestinal Neoplasms",
    quant: "1",
    pmids: "19884989",
  },
  {
    id: "9427",
    id_polifenol: "4501",
    polifenol: "tricin",
    id_cancer: "6579",
    cancer: "Gastrointestinal Neoplasms",
    quant: "1",
    pmids: "19638489",
  },
  {
    id: "9428",
    id_polifenol: "713",
    polifenol:
      "3-(3-chloro-4-hydroxyphenylamino)-4-(4-nitrophenyl)-1H-pyrrole-2,5-dione",
    id_cancer: "6579",
    cancer: "Gastrointestinal Neoplasms",
    quant: "1",
    pmids: "25398830",
  },
  {
    id: "9429",
    id_polifenol: "2790",
    polifenol: "ginkgolic acid",
    id_cancer: "6579",
    cancer: "Gastrointestinal Neoplasms",
    quant: "1",
    pmids: "21751842",
  },
  {
    id: "9430",
    id_polifenol: "4639",
    polifenol: "aromadedrin",
    id_cancer: "6579",
    cancer: "Gastrointestinal Neoplasms",
    quant: "1",
    pmids: "18176909",
  },
  {
    id: "9431",
    id_polifenol: "1585",
    polifenol: "curcumin glucuronide",
    id_cancer: "6579",
    cancer: "Gastrointestinal Neoplasms",
    quant: "1",
    pmids: "11221833",
  },
  {
    id: "9432",
    id_polifenol: "4082",
    polifenol: "3,3',4,4',5,5'-hexahydroxystilbene",
    id_cancer: "6579",
    cancer: "Gastrointestinal Neoplasms",
    quant: "1",
    pmids: "24240809",
  },
  {
    id: "9433",
    id_polifenol: "903",
    polifenol: "vineatrol",
    id_cancer: "6579",
    cancer: "Gastrointestinal Neoplasms",
    quant: "1",
    pmids: "29125219",
  },
  {
    id: "9434",
    id_polifenol: "4579",
    polifenol: "hinokiflavone",
    id_cancer: "6579",
    cancer: "Gastrointestinal Neoplasms",
    quant: "1",
    pmids: "23197449",
  },
  {
    id: "9435",
    id_polifenol: "1647",
    polifenol: "hexahydrocurcumin",
    id_cancer: "6579",
    cancer: "Gastrointestinal Neoplasms",
    quant: "1",
    pmids: "11221833",
  },
  {
    id: "9436",
    id_polifenol: "4149",
    polifenol: "adipostatin A",
    id_cancer: "6579",
    cancer: "Gastrointestinal Neoplasms",
    quant: "1",
    pmids: "21751842",
  },
  {
    id: "9437",
    id_polifenol: "4102",
    polifenol: "ardisiphenol D",
    id_cancer: "6579",
    cancer: "Gastrointestinal Neoplasms",
    quant: "2",
    pmids: "21751842,24392814",
  },
  {
    id: "9438",
    id_polifenol: "5053",
    polifenol: "5,7,3',4',5'-pentamethoxyflavone",
    id_cancer: "6579",
    cancer: "Gastrointestinal Neoplasms",
    quant: "1",
    pmids: "19638489",
  },
  {
    id: "9439",
    id_polifenol: "901",
    polifenol: "epicatechin dimer B2",
    id_cancer: "6579",
    cancer: "Gastrointestinal Neoplasms",
    quant: "1",
    pmids: "16413414",
  },
  {
    id: "9440",
    id_polifenol: "4269",
    polifenol: "2-methoxy-4-hydroxy-6-pentadecyl-benzene-1-O-acetate",
    id_cancer: "6579",
    cancer: "Gastrointestinal Neoplasms",
    quant: "1",
    pmids: "21751842",
  },
  {
    id: "9441",
    id_polifenol: "4196",
    polifenol: "ardisiphenol A",
    id_cancer: "6579",
    cancer: "Gastrointestinal Neoplasms",
    quant: "1",
    pmids: "24392814",
  },
  {
    id: "9442",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "597",
    cancer: "Sarcoma",
    quant: "16",
    pmids:
      "22223344,10963959,15713899,15744083,19481059,22809037,18184547,26546450,21245867,23350280,19288403,27056897,24991101,16054198,24133614,7990501",
  },
  {
    id: "9443",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "597",
    cancer: "Sarcoma",
    quant: "9",
    pmids:
      "8844727,22522053,21109950,24814288,22469857,23437333,18813811,29039788,18462866",
  },
  {
    id: "9444",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "597",
    cancer: "Sarcoma",
    quant: "3",
    pmids: "9095331,27793678,29039788",
  },
  {
    id: "9445",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "597",
    cancer: "Sarcoma",
    quant: "4",
    pmids: "15713899,17464209,18481201,11238032",
  },
  {
    id: "9446",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "597",
    cancer: "Sarcoma",
    quant: "8",
    pmids:
      "26026076,26922091,28720470,12903810,12898416,24991101,16054198,10533460",
  },
  {
    id: "9447",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "597",
    cancer: "Sarcoma",
    quant: "3",
    pmids: "23645742,16054198,27016467",
  },
  {
    id: "9448",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "597",
    cancer: "Sarcoma",
    quant: "5",
    pmids: "24190483,9095331,15172120,26501251,22641358",
  },
  {
    id: "9449",
    id_polifenol: "2167",
    polifenol: "phenolic acid",
    id_cancer: "597",
    cancer: "Sarcoma",
    quant: "1",
    pmids: "26501251",
  },
  {
    id: "9450",
    id_polifenol: "49",
    polifenol: "Aspirin",
    id_cancer: "597",
    cancer: "Sarcoma",
    quant: "4",
    pmids: "7653891,27698862,23483185,137074",
  },
  {
    id: "9451",
    id_polifenol: "109",
    polifenol: "Catechin",
    id_cancer: "597",
    cancer: "Sarcoma",
    quant: "2",
    pmids: "9095331,24991101",
  },
  {
    id: "9452",
    id_polifenol: "125",
    polifenol: "Isoflavones",
    id_cancer: "597",
    cancer: "Sarcoma",
    quant: "1",
    pmids: "15990314",
  },
  {
    id: "9453",
    id_polifenol: "110",
    polifenol: "Chalcones",
    id_cancer: "597",
    cancer: "Sarcoma",
    quant: "2",
    pmids: "22223344,11148027",
  },
  {
    id: "9454",
    id_polifenol: "3089",
    polifenol: "1,1-diphenyl-2-picrylhydrazyl",
    id_cancer: "597",
    cancer: "Sarcoma",
    quant: "4",
    pmids: "19107823,28803257,26546450,26501251",
  },
  {
    id: "9455",
    id_polifenol: "113",
    polifenol: "Flavones",
    id_cancer: "597",
    cancer: "Sarcoma",
    quant: "2",
    pmids: "15990314,29116937",
  },
  {
    id: "9456",
    id_polifenol: "38",
    polifenol: "Gallic Acid",
    id_cancer: "597",
    cancer: "Sarcoma",
    quant: "3",
    pmids: "26546450,16707268,25633333",
  },
  {
    id: "9457",
    id_polifenol: "117",
    polifenol: "Luteolin",
    id_cancer: "597",
    cancer: "Sarcoma",
    quant: "2",
    pmids: "20600535,24991101",
  },
  {
    id: "9458",
    id_polifenol: "1",
    polifenol: "Phenols",
    id_cancer: "597",
    cancer: "Sarcoma",
    quant: "4",
    pmids: "26546450,29367668,803242,19869465",
  },
  {
    id: "9459",
    id_polifenol: "105",
    polifenol: "Anthocyanins",
    id_cancer: "597",
    cancer: "Sarcoma",
    quant: "1",
    pmids: "24133614",
  },
  {
    id: "9460",
    id_polifenol: "7235",
    polifenol: "silybin",
    id_cancer: "597",
    cancer: "Sarcoma",
    quant: "1",
    pmids: "24991101",
  },
  {
    id: "9461",
    id_polifenol: "129",
    polifenol: "Rotenone",
    id_cancer: "597",
    cancer: "Sarcoma",
    quant: "1",
    pmids: "12898416",
  },
  {
    id: "9462",
    id_polifenol: "871",
    polifenol: "ABT-737",
    id_cancer: "597",
    cancer: "Sarcoma",
    quant: "2",
    pmids: "27822137,29484109",
  },
  {
    id: "9463",
    id_polifenol: "6451",
    polifenol: "daidzein",
    id_cancer: "597",
    cancer: "Sarcoma",
    quant: "1",
    pmids: "28720470",
  },
  {
    id: "9464",
    id_polifenol: "7",
    polifenol: "Capsaicin",
    id_cancer: "597",
    cancer: "Sarcoma",
    quant: "1",
    pmids: "25242356",
  },
  {
    id: "9465",
    id_polifenol: "4634",
    polifenol: "alvocidib",
    id_cancer: "597",
    cancer: "Sarcoma",
    quant: "1",
    pmids: "23576573",
  },
  {
    id: "9466",
    id_polifenol: "4522",
    polifenol: "chrysin",
    id_cancer: "597",
    cancer: "Sarcoma",
    quant: "1",
    pmids: "29116937",
  },
  {
    id: "9467",
    id_polifenol: "6062",
    polifenol: "naringenin",
    id_cancer: "597",
    cancer: "Sarcoma",
    quant: "1",
    pmids: "15744083",
  },
  {
    id: "9468",
    id_polifenol: "39",
    polifenol: "Hydrolyzable Tannins",
    id_cancer: "597",
    cancer: "Sarcoma",
    quant: "1",
    pmids: "23350280",
  },
  {
    id: "9469",
    id_polifenol: "130",
    polifenol: "Proanthocyanidins",
    id_cancer: "597",
    cancer: "Sarcoma",
    quant: "4",
    pmids: "16076082,15870845,15914329,26501251",
  },
  {
    id: "9470",
    id_polifenol: "35",
    polifenol: "Hydroquinones",
    id_cancer: "597",
    cancer: "Sarcoma",
    quant: "1",
    pmids: "3191161",
  },
  {
    id: "9471",
    id_polifenol: "4502",
    polifenol: "fisetin",
    id_cancer: "597",
    cancer: "Sarcoma",
    quant: "1",
    pmids: "24991101",
  },
  {
    id: "9472",
    id_polifenol: "25",
    polifenol: "Butylated Hydroxytoluene",
    id_cancer: "597",
    cancer: "Sarcoma",
    quant: "1",
    pmids: "3191161",
  },
  {
    id: "9473",
    id_polifenol: "6087",
    polifenol: "wogonin",
    id_cancer: "597",
    cancer: "Sarcoma",
    quant: "1",
    pmids: "16755005",
  },
  {
    id: "9474",
    id_polifenol: "4519",
    polifenol: "myricetin",
    id_cancer: "597",
    cancer: "Sarcoma",
    quant: "1",
    pmids: "15713899",
  },
  {
    id: "9475",
    id_polifenol: "1356",
    polifenol: "gingerol",
    id_cancer: "597",
    cancer: "Sarcoma",
    quant: "2",
    pmids: "25330949,24382184",
  },
  {
    id: "9476",
    id_polifenol: "5607",
    polifenol: "gallocatechol",
    id_cancer: "597",
    cancer: "Sarcoma",
    quant: "2",
    pmids: "9095331,26501251",
  },
  {
    id: "9477",
    id_polifenol: "44",
    polifenol: "Salicylates",
    id_cancer: "597",
    cancer: "Sarcoma",
    quant: "1",
    pmids: "23483185",
  },
  {
    id: "9478",
    id_polifenol: "5808",
    polifenol: "isoliquiritigenin",
    id_cancer: "597",
    cancer: "Sarcoma",
    quant: "1",
    pmids: "23624327",
  },
  {
    id: "9479",
    id_polifenol: "2344",
    polifenol: "methyl gallate",
    id_cancer: "597",
    cancer: "Sarcoma",
    quant: "1",
    pmids: "16707268",
  },
  {
    id: "9480",
    id_polifenol: "4708",
    polifenol: "xanthohumol",
    id_cancer: "597",
    cancer: "Sarcoma",
    quant: "1",
    pmids: "22223344",
  },
  {
    id: "9481",
    id_polifenol: "6063",
    polifenol: "naringin",
    id_cancer: "597",
    cancer: "Sarcoma",
    quant: "1",
    pmids: "15744083",
  },
  {
    id: "9482",
    id_polifenol: "7550",
    polifenol: "3-methylquercetin",
    id_cancer: "597",
    cancer: "Sarcoma",
    quant: "1",
    pmids: "24991101",
  },
  {
    id: "9483",
    id_polifenol: "4253",
    polifenol:
      "5-(2,4-dihydroxy-5-isopropylphenyl)-4-(4-morpholin-4-ylmethylphenyl)isoxazole-3-carboxylic acid ethylamide",
    id_cancer: "597",
    cancer: "Sarcoma",
    quant: "3",
    pmids: "23538447,26225840,22810956",
  },
  {
    id: "9484",
    id_polifenol: "107",
    polifenol: "beta-Naphthoflavone",
    id_cancer: "597",
    cancer: "Sarcoma",
    quant: "1",
    pmids: "24991101",
  },
  {
    id: "9485",
    id_polifenol: "126",
    polifenol: "Coumestrol",
    id_cancer: "597",
    cancer: "Sarcoma",
    quant: "1",
    pmids: "24991101",
  },
  {
    id: "9486",
    id_polifenol: "5850",
    polifenol: "cardamonin",
    id_cancer: "597",
    cancer: "Sarcoma",
    quant: "1",
    pmids: "23201552",
  },
  {
    id: "9487",
    id_polifenol: "300",
    polifenol: "rhodioloside",
    id_cancer: "597",
    cancer: "Sarcoma",
    quant: "1",
    pmids: "18683537",
  },
  {
    id: "9488",
    id_polifenol: "4767",
    polifenol: "flavan-3-ol",
    id_cancer: "597",
    cancer: "Sarcoma",
    quant: "1",
    pmids: "26501251",
  },
  {
    id: "9489",
    id_polifenol: "2475",
    polifenol: "6-O-galloylglucose",
    id_cancer: "597",
    cancer: "Sarcoma",
    quant: "1",
    pmids: "25633333",
  },
  {
    id: "9490",
    id_polifenol: "4585",
    polifenol: "baohuoside I",
    id_cancer: "597",
    cancer: "Sarcoma",
    quant: "1",
    pmids: "27056897",
  },
  {
    id: "9491",
    id_polifenol: "59",
    polifenol: "Dinitrophenols",
    id_cancer: "597",
    cancer: "Sarcoma",
    quant: "1",
    pmids: "6325878",
  },
  {
    id: "9492",
    id_polifenol: "7134",
    polifenol: "vitexin",
    id_cancer: "597",
    cancer: "Sarcoma",
    quant: "1",
    pmids: "27387399",
  },
  {
    id: "9493",
    id_polifenol: "4480",
    polifenol: "myricitrin",
    id_cancer: "597",
    cancer: "Sarcoma",
    quant: "1",
    pmids: "15713899",
  },
  {
    id: "9494",
    id_polifenol: "4521",
    polifenol: "3-hydroxyflavone",
    id_cancer: "597",
    cancer: "Sarcoma",
    quant: "1",
    pmids: "15990314",
  },
  {
    id: "9495",
    id_polifenol: "87",
    polifenol: "Metoclopramide",
    id_cancer: "597",
    cancer: "Sarcoma",
    quant: "1",
    pmids: "9208905",
  },
  {
    id: "9496",
    id_polifenol: "6112",
    polifenol: "alpinetin",
    id_cancer: "597",
    cancer: "Sarcoma",
    quant: "1",
    pmids: "23201552",
  },
  {
    id: "9497",
    id_polifenol: "2697",
    polifenol: "4-trifluoromethylsalicylic acid",
    id_cancer: "597",
    cancer: "Sarcoma",
    quant: "1",
    pmids: "21811429",
  },
  {
    id: "9498",
    id_polifenol: "4839",
    polifenol: "7-hydroxyflavone",
    id_cancer: "597",
    cancer: "Sarcoma",
    quant: "1",
    pmids: "29116937",
  },
  {
    id: "9499",
    id_polifenol: "7140",
    polifenol: "isovitexin",
    id_cancer: "597",
    cancer: "Sarcoma",
    quant: "1",
    pmids: "27387399",
  },
  {
    id: "9500",
    id_polifenol: "4782",
    polifenol: "kurarinone",
    id_cancer: "597",
    cancer: "Sarcoma",
    quant: "1",
    pmids: "18184547",
  },
  {
    id: "9501",
    id_polifenol: "70",
    polifenol: "Sulfobromophthalein",
    id_cancer: "597",
    cancer: "Sarcoma",
    quant: "1",
    pmids: "3884476",
  },
  {
    id: "9502",
    id_polifenol: "3606",
    polifenol:
      "5-(3-methoxy-4-((4-methoxybenzyl)oxy)benzyl)pyrimidine-2,4-diamine",
    id_cancer: "597",
    cancer: "Sarcoma",
    quant: "1",
    pmids: "18434589",
  },
  {
    id: "9503",
    id_polifenol: "4558",
    polifenol: "2'-hydroxyflavone",
    id_cancer: "597",
    cancer: "Sarcoma",
    quant: "1",
    pmids: "29116937",
  },
  {
    id: "9504",
    id_polifenol: "6555",
    polifenol: "tectoridin",
    id_cancer: "597",
    cancer: "Sarcoma",
    quant: "1",
    pmids: "12898416",
  },
  {
    id: "9505",
    id_polifenol: "7736",
    polifenol: "7-monohydroxyethylrutoside",
    id_cancer: "597",
    cancer: "Sarcoma",
    quant: "1",
    pmids: "21245867",
  },
  {
    id: "9506",
    id_polifenol: "6883",
    polifenol: "LYG 202",
    id_cancer: "597",
    cancer: "Sarcoma",
    quant: "1",
    pmids: "19481059",
  },
  {
    id: "9507",
    id_polifenol: "7210",
    polifenol: "luteolin-7-O-glucuronide",
    id_cancer: "597",
    cancer: "Sarcoma",
    quant: "1",
    pmids: "27387399",
  },
  {
    id: "9508",
    id_polifenol: "521",
    polifenol: "E 7010",
    id_cancer: "597",
    cancer: "Sarcoma",
    quant: "1",
    pmids: "9654112",
  },
  {
    id: "9509",
    id_polifenol: "2486",
    polifenol: "1,3,6-tri-O-galloylglucopyranose",
    id_cancer: "597",
    cancer: "Sarcoma",
    quant: "1",
    pmids: "25633333",
  },
  {
    id: "9510",
    id_polifenol: "2080",
    polifenol: "2-methoxy-1,4-hydroquinone",
    id_cancer: "597",
    cancer: "Sarcoma",
    quant: "1",
    pmids: "17627574",
  },
  {
    id: "9511",
    id_polifenol: "2548",
    polifenol: "1,2,6-tri-O-galloyl-beta-D-glucopyranose",
    id_cancer: "597",
    cancer: "Sarcoma",
    quant: "1",
    pmids: "25633333",
  },
  {
    id: "9512",
    id_polifenol: "2423",
    polifenol: "ethyl O-beta-(6'-O-galloyl)-glucopyranoside",
    id_cancer: "597",
    cancer: "Sarcoma",
    quant: "1",
    pmids: "25633333",
  },
  {
    id: "9513",
    id_polifenol: "5801",
    polifenol: "2'-hydroxy-4-methoxychalcone",
    id_cancer: "597",
    cancer: "Sarcoma",
    quant: "1",
    pmids: "16651739",
  },
  {
    id: "9514",
    id_polifenol: "3802",
    polifenol: "kutkin",
    id_cancer: "597",
    cancer: "Sarcoma",
    quant: "1",
    pmids: "11406836",
  },
  {
    id: "9515",
    id_polifenol: "6337",
    polifenol: "3-fluoro-5-hydroxy-7-acetoxyflavone",
    id_cancer: "597",
    cancer: "Sarcoma",
    quant: "1",
    pmids: "29116937",
  },
  {
    id: "9516",
    id_polifenol: "976",
    polifenol: "Vaticanol B",
    id_cancer: "597",
    cancer: "Sarcoma",
    quant: "1",
    pmids: "14696625",
  },
  {
    id: "9517",
    id_polifenol: "4848",
    polifenol: "4'-hydroxy-7-methoxyflavan",
    id_cancer: "597",
    cancer: "Sarcoma",
    quant: "1",
    pmids: "11558618",
  },
  {
    id: "9518",
    id_polifenol: "7702",
    polifenol: "7-mono-O-(beta-hydroxyethyl)rutoside",
    id_cancer: "597",
    cancer: "Sarcoma",
    quant: "1",
    pmids: "21245867",
  },
  {
    id: "9519",
    id_polifenol: "615",
    polifenol: "2-allylphenol",
    id_cancer: "597",
    cancer: "Sarcoma",
    quant: "1",
    pmids: "29367668",
  },
  {
    id: "9520",
    id_polifenol: "2335",
    polifenol: "n-butyl gallate",
    id_cancer: "597",
    cancer: "Sarcoma",
    quant: "1",
    pmids: "16707268",
  },
  {
    id: "9521",
    id_polifenol: "5524",
    polifenol: "proanthocyanidin B3",
    id_cancer: "597",
    cancer: "Sarcoma",
    quant: "1",
    pmids: "26501251",
  },
  {
    id: "9522",
    id_polifenol: "7580",
    polifenol: "quercetin-3-(6''-galloyl)glucoside",
    id_cancer: "597",
    cancer: "Sarcoma",
    quant: "1",
    pmids: "25633333",
  },
  {
    id: "9523",
    id_polifenol: "3121",
    polifenol: "ethyl O-(N-(4-carboxyphenyl)carbamoyl)mycophenolate",
    id_cancer: "597",
    cancer: "Sarcoma",
    quant: "1",
    pmids: "7274650",
  },
  {
    id: "9524",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "519",
    cancer: "Thyroid Cancer",
    quant: "13",
    pmids:
      "10319943,10628390,26292725,26461378,15080787,21571321,28622440,24400871,26365817,21745527,8924586,26397139,14757968",
  },
  {
    id: "9525",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "519",
    cancer: "Thyroid Cancer",
    quant: "13",
    pmids:
      "24910117,29901626,28265769,26442630,26299635,26826337,21272158,29197967,25349216,23561205,29448931,29688429,26109883",
  },
  {
    id: "9526",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "519",
    cancer: "Thyroid Cancer",
    quant: "3",
    pmids: "25634350,21738342,24508987",
  },
  {
    id: "9527",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "519",
    cancer: "Thyroid Cancer",
    quant: "9",
    pmids:
      "17174366,17709622,12519884,12056817,15378648,11238488,16153436,16835357,15240638",
  },
  {
    id: "9528",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "519",
    cancer: "Thyroid Cancer",
    quant: "11",
    pmids:
      "10319943,23143780,21738342,29197967,29516914,8528355,16835357,8216254,15240638,7760657,7858744",
  },
  {
    id: "9529",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "519",
    cancer: "Thyroid Cancer",
    quant: "6",
    pmids: "27057371,21738342,26461378,26660542,26769848,8924586",
  },
  {
    id: "9530",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "519",
    cancer: "Thyroid Cancer",
    quant: "3",
    pmids: "21725973,29197967,23553645",
  },
  {
    id: "9531",
    id_polifenol: "2167",
    polifenol: "phenolic acid",
    id_cancer: "519",
    cancer: "Thyroid Cancer",
    quant: "1",
    pmids: "28622440",
  },
  {
    id: "9532",
    id_polifenol: "109",
    polifenol: "Catechin",
    id_cancer: "519",
    cancer: "Thyroid Cancer",
    quant: "2",
    pmids: "21725973,23553645",
  },
  {
    id: "9533",
    id_polifenol: "125",
    polifenol: "Isoflavones",
    id_cancer: "519",
    cancer: "Thyroid Cancer",
    quant: "2",
    pmids: "22799572,21600982",
  },
  {
    id: "9534",
    id_polifenol: "110",
    polifenol: "Chalcones",
    id_cancer: "519",
    cancer: "Thyroid Cancer",
    quant: "1",
    pmids: "29908094",
  },
  {
    id: "9535",
    id_polifenol: "3089",
    polifenol: "1,1-diphenyl-2-picrylhydrazyl",
    id_cancer: "519",
    cancer: "Thyroid Cancer",
    quant: "1",
    pmids: "28622440",
  },
  {
    id: "9536",
    id_polifenol: "114",
    polifenol: "Apigenin",
    id_cancer: "519",
    cancer: "Thyroid Cancer",
    quant: "8",
    pmids:
      "10319943,11299771,10628390,23376608,26292725,15080787,24400871,26397139",
  },
  {
    id: "9537",
    id_polifenol: "117",
    polifenol: "Luteolin",
    id_cancer: "519",
    cancer: "Thyroid Cancer",
    quant: "4",
    pmids: "10319943,10628390,15080787,14757968",
  },
  {
    id: "9538",
    id_polifenol: "1",
    polifenol: "Phenols",
    id_cancer: "519",
    cancer: "Thyroid Cancer",
    quant: "1",
    pmids: "27592355",
  },
  {
    id: "9539",
    id_polifenol: "105",
    polifenol: "Anthocyanins",
    id_cancer: "519",
    cancer: "Thyroid Cancer",
    quant: "1",
    pmids: "29699632",
  },
  {
    id: "9540",
    id_polifenol: "121",
    polifenol: "Kaempferols",
    id_cancer: "519",
    cancer: "Thyroid Cancer",
    quant: "5",
    pmids: "10319943,21738342,15080787,8924586,14757968",
  },
  {
    id: "9541",
    id_polifenol: "871",
    polifenol: "ABT-737",
    id_cancer: "519",
    cancer: "Thyroid Cancer",
    quant: "3",
    pmids: "28259821,27042160,26849668",
  },
  {
    id: "9542",
    id_polifenol: "6451",
    polifenol: "daidzein",
    id_cancer: "519",
    cancer: "Thyroid Cancer",
    quant: "2",
    pmids: "22799572,21600982",
  },
  {
    id: "9543",
    id_polifenol: "7",
    polifenol: "Capsaicin",
    id_cancer: "519",
    cancer: "Thyroid Cancer",
    quant: "1",
    pmids: "29185571",
  },
  {
    id: "9544",
    id_polifenol: "120",
    polifenol: "Flavonols",
    id_cancer: "519",
    cancer: "Thyroid Cancer",
    quant: "2",
    pmids: "28373432,28463801",
  },
  {
    id: "9545",
    id_polifenol: "4522",
    polifenol: "chrysin",
    id_cancer: "519",
    cancer: "Thyroid Cancer",
    quant: "4",
    pmids: "10319943,22991264,21571321,26392173",
  },
  {
    id: "9546",
    id_polifenol: "6062",
    polifenol: "naringenin",
    id_cancer: "519",
    cancer: "Thyroid Cancer",
    quant: "1",
    pmids: "8924586",
  },
  {
    id: "9547",
    id_polifenol: "285",
    polifenol: "bisphenol A",
    id_cancer: "519",
    cancer: "Thyroid Cancer",
    quant: "1",
    pmids: "28882636",
  },
  {
    id: "9548",
    id_polifenol: "39",
    polifenol: "Hydrolyzable Tannins",
    id_cancer: "519",
    cancer: "Thyroid Cancer",
    quant: "1",
    pmids: "28622440",
  },
  {
    id: "9549",
    id_polifenol: "4502",
    polifenol: "fisetin",
    id_cancer: "519",
    cancer: "Thyroid Cancer",
    quant: "1",
    pmids: "8924586",
  },
  {
    id: "9550",
    id_polifenol: "25",
    polifenol: "Butylated Hydroxytoluene",
    id_cancer: "519",
    cancer: "Thyroid Cancer",
    quant: "6",
    pmids: "11062701,28265769,21400508,25074669,10730887,24152827",
  },
  {
    id: "9551",
    id_polifenol: "4519",
    polifenol: "myricetin",
    id_cancer: "519",
    cancer: "Thyroid Cancer",
    quant: "6",
    pmids: "28373432,28463801,15080787,8924586,14757968,16537683",
  },
  {
    id: "9552",
    id_polifenol: "98",
    polifenol: "Propofol",
    id_cancer: "519",
    cancer: "Thyroid Cancer",
    quant: "1",
    pmids: "23446140",
  },
  {
    id: "9553",
    id_polifenol: "4559",
    polifenol: "theaflavin",
    id_cancer: "519",
    cancer: "Thyroid Cancer",
    quant: "1",
    pmids: "23329180",
  },
  {
    id: "9554",
    id_polifenol: "4708",
    polifenol: "xanthohumol",
    id_cancer: "519",
    cancer: "Thyroid Cancer",
    quant: "1",
    pmids: "20226902",
  },
  {
    id: "9555",
    id_polifenol: "6063",
    polifenol: "naringin",
    id_cancer: "519",
    cancer: "Thyroid Cancer",
    quant: "1",
    pmids: "8924586",
  },
  {
    id: "9556",
    id_polifenol: "6273",
    polifenol: "hesperetin",
    id_cancer: "519",
    cancer: "Thyroid Cancer",
    quant: "1",
    pmids: "24419754",
  },
  {
    id: "9557",
    id_polifenol: "4253",
    polifenol:
      "5-(2,4-dihydroxy-5-isopropylphenyl)-4-(4-morpholin-4-ylmethylphenyl)isoxazole-3-carboxylic acid ethylamide",
    id_cancer: "519",
    cancer: "Thyroid Cancer",
    quant: "2",
    pmids: "28412368,28982310",
  },
  {
    id: "9558",
    id_polifenol: "48",
    polifenol: "Anacardic Acids",
    id_cancer: "519",
    cancer: "Thyroid Cancer",
    quant: "1",
    pmids: "29383121",
  },
  {
    id: "9559",
    id_polifenol: "2773",
    polifenol: "farnesylthiosalicylic acid",
    id_cancer: "519",
    cancer: "Thyroid Cancer",
    quant: "2",
    pmids: "20473860,20682656",
  },
  {
    id: "9560",
    id_polifenol: "100",
    polifenol: "Resorcinols",
    id_cancer: "519",
    cancer: "Thyroid Cancer",
    quant: "3",
    pmids: "21738342,26392173,8924586",
  },
  {
    id: "9561",
    id_polifenol: "2490",
    polifenol: "punicalagin",
    id_cancer: "519",
    cancer: "Thyroid Cancer",
    quant: "1",
    pmids: "29677534",
  },
  {
    id: "9562",
    id_polifenol: "6301",
    polifenol: "3-methoxyflavone",
    id_cancer: "519",
    cancer: "Thyroid Cancer",
    quant: "1",
    pmids: "16835357",
  },
  {
    id: "9563",
    id_polifenol: "4883",
    polifenol: "flavokawain B",
    id_cancer: "519",
    cancer: "Thyroid Cancer",
    quant: "1",
    pmids: "29908094",
  },
  {
    id: "9564",
    id_polifenol: "4304",
    polifenol: "5-7-oxo-zeaenol",
    id_cancer: "519",
    cancer: "Thyroid Cancer",
    quant: "1",
    pmids: "26823762",
  },
  {
    id: "9565",
    id_polifenol: "7741",
    polifenol: "biochanin A",
    id_cancer: "519",
    cancer: "Thyroid Cancer",
    quant: "1",
    pmids: "8924586",
  },
  {
    id: "9566",
    id_polifenol: "1918",
    polifenol: "2,6-di-tert-butyl-4-(aminomethyl)phenol hydrochloride",
    id_cancer: "519",
    cancer: "Thyroid Cancer",
    quant: "1",
    pmids: "17848408",
  },
  {
    id: "9567",
    id_polifenol: "1638",
    polifenol: "1,7-bis(4-hydroxyphenyl)-1,6-heptadiene-3,5-dione",
    id_cancer: "519",
    cancer: "Thyroid Cancer",
    quant: "1",
    pmids: "26826337",
  },
  {
    id: "9568",
    id_polifenol: "4887",
    polifenol: "isoginkgetin",
    id_cancer: "519",
    cancer: "Thyroid Cancer",
    quant: "1",
    pmids: "26678222",
  },
  {
    id: "9569",
    id_polifenol: "1781",
    polifenol: "CA 432",
    id_cancer: "519",
    cancer: "Thyroid Cancer",
    quant: "1",
    pmids: "22705646",
  },
  {
    id: "9570",
    id_polifenol: "4566",
    polifenol: "3-methyl-4',6-dihydroxy-3',5'-dibromoflavone",
    id_cancer: "519",
    cancer: "Thyroid Cancer",
    quant: "2",
    pmids: "15080787,14757968",
  },
  {
    id: "9571",
    id_polifenol: "1794",
    polifenol:
      "4-(3-hydroxy-4-methoxyphenyl)-3-(4-hydroxyphenyl)-1-(3,4,5-trimethoxyphenyl)azetidin-2-one",
    id_cancer: "519",
    cancer: "Thyroid Cancer",
    quant: "1",
    pmids: "22705646",
  },
  {
    id: "9572",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "230105",
    cancer: "Adenomatous Polyposis Colus",
    quant: "7",
    pmids: "26572257,20709524,21406604,15231453,16898869,17472461,21649465",
  },
  {
    id: "9573",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "230105",
    cancer: "Adenomatous Polyposis Colus",
    quant: "11",
    pmids:
      "22280307,15893313,15340658,22830632,10729246,10783313,17342335,17612053,12086402,22953026,17900536",
  },
  {
    id: "9574",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "230105",
    cancer: "Adenomatous Polyposis Colus",
    quant: "4",
    pmids: "25352148,22280307,29156563,29125219",
  },
  {
    id: "9575",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "230105",
    cancer: "Adenomatous Polyposis Colus",
    quant: "5",
    pmids: "26910375,24532317,24390805,12880558,15579483",
  },
  {
    id: "9576",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "230105",
    cancer: "Adenomatous Polyposis Colus",
    quant: "3",
    pmids: "29156563,22830632,10783313",
  },
  {
    id: "9577",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "230105",
    cancer: "Adenomatous Polyposis Colus",
    quant: "5",
    pmids: "25352148,15729621,19288003,17342335,25222193",
  },
  {
    id: "9578",
    id_polifenol: "2167",
    polifenol: "phenolic acid",
    id_cancer: "230105",
    cancer: "Adenomatous Polyposis Colus",
    quant: "1",
    pmids: "10783313",
  },
  {
    id: "9579",
    id_polifenol: "49",
    polifenol: "Aspirin",
    id_cancer: "230105",
    cancer: "Adenomatous Polyposis Colus",
    quant: "34",
    pmids:
      "7615821,10678579,9399670,22916316,19415698,17488476,24516128,14743889,8538196,15188000,10029375,24613833,16531064,8631005,14649330,12885487,17612053,22122764,12086402,15992053,12810952,10668484,21158711,10917070,20508278,15309515,9706142,11566043,11301836,15252926,8646953,14640056,26304465,10472428",
  },
  {
    id: "9580",
    id_polifenol: "109",
    polifenol: "Catechin",
    id_cancer: "230105",
    cancer: "Adenomatous Polyposis Colus",
    quant: "1",
    pmids: "15231453",
  },
  {
    id: "9581",
    id_polifenol: "125",
    polifenol: "Isoflavones",
    id_cancer: "230105",
    cancer: "Adenomatous Polyposis Colus",
    quant: "1",
    pmids: "24390805",
  },
  {
    id: "9582",
    id_polifenol: "110",
    polifenol: "Chalcones",
    id_cancer: "230105",
    cancer: "Adenomatous Polyposis Colus",
    quant: "1",
    pmids: "23538439",
  },
  {
    id: "9583",
    id_polifenol: "3089",
    polifenol: "1,1-diphenyl-2-picrylhydrazyl",
    id_cancer: "230105",
    cancer: "Adenomatous Polyposis Colus",
    quant: "1",
    pmids: "27231890",
  },
  {
    id: "9584",
    id_polifenol: "114",
    polifenol: "Apigenin",
    id_cancer: "230105",
    cancer: "Adenomatous Polyposis Colus",
    quant: "4",
    pmids: "20709524,17620292,15231453,16898869",
  },
  {
    id: "9585",
    id_polifenol: "113",
    polifenol: "Flavones",
    id_cancer: "230105",
    cancer: "Adenomatous Polyposis Colus",
    quant: "2",
    pmids: "20709524,21649465",
  },
  {
    id: "9586",
    id_polifenol: "1",
    polifenol: "Phenols",
    id_cancer: "230105",
    cancer: "Adenomatous Polyposis Colus",
    quant: "2",
    pmids: "12880558,9879919",
  },
  {
    id: "9587",
    id_polifenol: "105",
    polifenol: "Anthocyanins",
    id_cancer: "230105",
    cancer: "Adenomatous Polyposis Colus",
    quant: "1",
    pmids: "24666969",
  },
  {
    id: "9588",
    id_polifenol: "129",
    polifenol: "Rotenone",
    id_cancer: "230105",
    cancer: "Adenomatous Polyposis Colus",
    quant: "1",
    pmids: "24390805",
  },
  {
    id: "9589",
    id_polifenol: "6451",
    polifenol: "daidzein",
    id_cancer: "230105",
    cancer: "Adenomatous Polyposis Colus",
    quant: "1",
    pmids: "24390805",
  },
  {
    id: "9590",
    id_polifenol: "7",
    polifenol: "Capsaicin",
    id_cancer: "230105",
    cancer: "Adenomatous Polyposis Colus",
    quant: "1",
    pmids: "25869100",
  },
  {
    id: "9591",
    id_polifenol: "4634",
    polifenol: "alvocidib",
    id_cancer: "230105",
    cancer: "Adenomatous Polyposis Colus",
    quant: "1",
    pmids: "16982769",
  },
  {
    id: "9592",
    id_polifenol: "123",
    polifenol: "Rutin",
    id_cancer: "230105",
    cancer: "Adenomatous Polyposis Colus",
    quant: "1",
    pmids: "10783313",
  },
  {
    id: "9593",
    id_polifenol: "6062",
    polifenol: "naringenin",
    id_cancer: "230105",
    cancer: "Adenomatous Polyposis Colus",
    quant: "1",
    pmids: "15231453",
  },
  {
    id: "9594",
    id_polifenol: "130",
    polifenol: "Proanthocyanidins",
    id_cancer: "230105",
    cancer: "Adenomatous Polyposis Colus",
    quant: "1",
    pmids: "26572257",
  },
  {
    id: "9595",
    id_polifenol: "35",
    polifenol: "Hydroquinones",
    id_cancer: "230105",
    cancer: "Adenomatous Polyposis Colus",
    quant: "1",
    pmids: "8578103",
  },
  {
    id: "9596",
    id_polifenol: "111",
    polifenol: "Flavanones",
    id_cancer: "230105",
    cancer: "Adenomatous Polyposis Colus",
    quant: "1",
    pmids: "15231453",
  },
  {
    id: "9597",
    id_polifenol: "6",
    polifenol: "Catechols",
    id_cancer: "230105",
    cancer: "Adenomatous Polyposis Colus",
    quant: "2",
    pmids: "20417221,8330359",
  },
  {
    id: "9598",
    id_polifenol: "75",
    polifenol: "Butylated Hydroxyanisole",
    id_cancer: "230105",
    cancer: "Adenomatous Polyposis Colus",
    quant: "1",
    pmids: "7127277",
  },
  {
    id: "9599",
    id_polifenol: "1356",
    polifenol: "gingerol",
    id_cancer: "230105",
    cancer: "Adenomatous Polyposis Colus",
    quant: "1",
    pmids: "29350052",
  },
  {
    id: "9600",
    id_polifenol: "5607",
    polifenol: "gallocatechol",
    id_cancer: "230105",
    cancer: "Adenomatous Polyposis Colus",
    quant: "1",
    pmids: "15729621",
  },
  {
    id: "9601",
    id_polifenol: "44",
    polifenol: "Salicylates",
    id_cancer: "230105",
    cancer: "Adenomatous Polyposis Colus",
    quant: "1",
    pmids: "24516128",
  },
  {
    id: "9602",
    id_polifenol: "47",
    polifenol: "Mesalamine",
    id_cancer: "230105",
    cancer: "Adenomatous Polyposis Colus",
    quant: "3",
    pmids: "7920212,16728434,26304465",
  },
  {
    id: "9603",
    id_polifenol: "112",
    polifenol: "Hesperidin",
    id_cancer: "230105",
    cancer: "Adenomatous Polyposis Colus",
    quant: "1",
    pmids: "15231453",
  },
  {
    id: "9604",
    id_polifenol: "6455",
    polifenol: "nobiletin",
    id_cancer: "230105",
    cancer: "Adenomatous Polyposis Colus",
    quant: "1",
    pmids: "17472461",
  },
  {
    id: "9605",
    id_polifenol: "4513",
    polifenol: "galangin",
    id_cancer: "230105",
    cancer: "Adenomatous Polyposis Colus",
    quant: "1",
    pmids: "21406604",
  },
  {
    id: "9606",
    id_polifenol: "6063",
    polifenol: "naringin",
    id_cancer: "230105",
    cancer: "Adenomatous Polyposis Colus",
    quant: "1",
    pmids: "15231453",
  },
  {
    id: "9607",
    id_polifenol: "5489",
    polifenol: "delphinidin",
    id_cancer: "230105",
    cancer: "Adenomatous Polyposis Colus",
    quant: "1",
    pmids: "27390740",
  },
  {
    id: "9608",
    id_polifenol: "6273",
    polifenol: "hesperetin",
    id_cancer: "230105",
    cancer: "Adenomatous Polyposis Colus",
    quant: "1",
    pmids: "15231453",
  },
  {
    id: "9609",
    id_polifenol: "119",
    polifenol: "Silymarin",
    id_cancer: "230105",
    cancer: "Adenomatous Polyposis Colus",
    quant: "1",
    pmids: "19945967",
  },
  {
    id: "9610",
    id_polifenol: "126",
    polifenol: "Coumestrol",
    id_cancer: "230105",
    cancer: "Adenomatous Polyposis Colus",
    quant: "1",
    pmids: "15579483",
  },
  {
    id: "9611",
    id_polifenol: "6482",
    polifenol: "tangeretin",
    id_cancer: "230105",
    cancer: "Adenomatous Polyposis Colus",
    quant: "1",
    pmids: "17472461",
  },
  {
    id: "9612",
    id_polifenol: "5850",
    polifenol: "cardamonin",
    id_cancer: "230105",
    cancer: "Adenomatous Polyposis Colus",
    quant: "1",
    pmids: "23538439",
  },
  {
    id: "9613",
    id_polifenol: "102",
    polifenol: "Zearalenone",
    id_cancer: "230105",
    cancer: "Adenomatous Polyposis Colus",
    quant: "1",
    pmids: "12880558",
  },
  {
    id: "9614",
    id_polifenol: "5815",
    polifenol: "dibenzoylmethane",
    id_cancer: "230105",
    cancer: "Adenomatous Polyposis Colus",
    quant: "1",
    pmids: "17942926",
  },
  {
    id: "9615",
    id_polifenol: "77",
    polifenol: "Bezafibrate",
    id_cancer: "230105",
    cancer: "Adenomatous Polyposis Colus",
    quant: "1",
    pmids: "16606335",
  },
  {
    id: "9616",
    id_polifenol: "713",
    polifenol:
      "3-(3-chloro-4-hydroxyphenylamino)-4-(4-nitrophenyl)-1H-pyrrole-2,5-dione",
    id_cancer: "230105",
    cancer: "Adenomatous Polyposis Colus",
    quant: "2",
    pmids: "25869100,17697341",
  },
  {
    id: "9617",
    id_polifenol: "4573",
    polifenol: "3,3',4',5,6,7,8-heptamethoxyflavone",
    id_cancer: "230105",
    cancer: "Adenomatous Polyposis Colus",
    quant: "1",
    pmids: "17472461",
  },
  {
    id: "9618",
    id_polifenol: "6459",
    polifenol: "genkwanin",
    id_cancer: "230105",
    cancer: "Adenomatous Polyposis Colus",
    quant: "1",
    pmids: "26388189",
  },
  {
    id: "9619",
    id_polifenol: "3040",
    polifenol:
      "4-(3-thioxo-3H-1,2-dithiol-5-yl)phenyl 2-((4-(nitrooxy)butanoyl)oxy)benzoate",
    id_cancer: "230105",
    cancer: "Adenomatous Polyposis Colus",
    quant: "1",
    pmids: "22916316",
  },
  {
    id: "9620",
    id_polifenol: "18",
    polifenol: "Hexachlorophene",
    id_cancer: "230105",
    cancer: "Adenomatous Polyposis Colus",
    quant: "1",
    pmids: "16735606",
  },
  {
    id: "9621",
    id_polifenol: "996",
    polifenol: "2,3-difluoro phenol",
    id_cancer: "230105",
    cancer: "Adenomatous Polyposis Colus",
    quant: "1",
    pmids: "17342335",
  },
  {
    id: "9622",
    id_polifenol: "903",
    polifenol: "vineatrol",
    id_cancer: "230105",
    cancer: "Adenomatous Polyposis Colus",
    quant: "1",
    pmids: "29125219",
  },
  {
    id: "9623",
    id_polifenol: "4670",
    polifenol: "7,2',4',5'-tetramethoxyflavone",
    id_cancer: "230105",
    cancer: "Adenomatous Polyposis Colus",
    quant: "1",
    pmids: "17472461",
  },
  {
    id: "9624",
    id_polifenol: "3608",
    polifenol:
      "5-(5-ethyl-2-hydroxy-4-methoxyphenyl)-4-(4-methoxyphenyl)isoxazole",
    id_cancer: "230105",
    cancer: "Adenomatous Polyposis Colus",
    quant: "1",
    pmids: "17915194",
  },
  {
    id: "9625",
    id_polifenol: "5804",
    polifenol: "sofalcone",
    id_cancer: "230105",
    cancer: "Adenomatous Polyposis Colus",
    quant: "1",
    pmids: "26840084",
  },
  {
    id: "9626",
    id_polifenol: "3282",
    polifenol: "N-hydroxy-N-(1-(4-(phenylmethoxy)phenyl)ethyl)-acetamide",
    id_cancer: "230105",
    cancer: "Adenomatous Polyposis Colus",
    quant: "1",
    pmids: "10857857",
  },
  {
    id: "9627",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "3233",
    cancer: "Carcinoma, Ehrlich Tumor",
    quant: "16",
    pmids:
      "23350280,23023566,38832,20013318,22434356,22085276,15595,24014915,21812646,6211417,192316,24653555,26929584,26351625,27122252,7990501",
  },
  {
    id: "9628",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "3233",
    cancer: "Carcinoma, Ehrlich Tumor",
    quant: "5",
    pmids: "21114990,12359244,22642894,22194218,27546165",
  },
  {
    id: "9629",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "3233",
    cancer: "Carcinoma, Ehrlich Tumor",
    quant: "11",
    pmids:
      "23357370,26586942,11880178,11311209,23023566,26310506,10475615,9609384,11198223,27906144,24426067",
  },
  {
    id: "9630",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "3233",
    cancer: "Carcinoma, Ehrlich Tumor",
    quant: "3",
    pmids: "24216289,11311209,12202953",
  },
  {
    id: "9631",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "3233",
    cancer: "Carcinoma, Ehrlich Tumor",
    quant: "1",
    pmids: "20631251",
  },
  {
    id: "9632",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "3233",
    cancer: "Carcinoma, Ehrlich Tumor",
    quant: "15",
    pmids:
      "23570524,16054317,23023566,38832,16358785,20013318,16432761,15595,6211417,6219995,192316,26351625,6244093,17412551,1767017",
  },
  {
    id: "9633",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "3233",
    cancer: "Carcinoma, Ehrlich Tumor",
    quant: "4",
    pmids: "23357370,26586942,26310506,9609384",
  },
  {
    id: "9634",
    id_polifenol: "2167",
    polifenol: "phenolic acid",
    id_cancer: "3233",
    cancer: "Carcinoma, Ehrlich Tumor",
    quant: "7",
    pmids: "25933717,27495835,28807853,23023566,24014915,21812646,27122252",
  },
  {
    id: "9635",
    id_polifenol: "49",
    polifenol: "Aspirin",
    id_cancer: "3233",
    cancer: "Carcinoma, Ehrlich Tumor",
    quant: "1",
    pmids: "18540848",
  },
  {
    id: "9636",
    id_polifenol: "109",
    polifenol: "Catechin",
    id_cancer: "3233",
    cancer: "Carcinoma, Ehrlich Tumor",
    quant: "3",
    pmids: "23570524,28807853,9609384",
  },
  {
    id: "9637",
    id_polifenol: "110",
    polifenol: "Chalcones",
    id_cancer: "3233",
    cancer: "Carcinoma, Ehrlich Tumor",
    quant: "3",
    pmids: "26615871,24647375,22647291",
  },
  {
    id: "9638",
    id_polifenol: "3089",
    polifenol: "1,1-diphenyl-2-picrylhydrazyl",
    id_cancer: "3233",
    cancer: "Carcinoma, Ehrlich Tumor",
    quant: "6",
    pmids: "28927062,26194826,24647375,24653555,24161850,27122252",
  },
  {
    id: "9639",
    id_polifenol: "113",
    polifenol: "Flavones",
    id_cancer: "3233",
    cancer: "Carcinoma, Ehrlich Tumor",
    quant: "1",
    pmids: "6244093",
  },
  {
    id: "9640",
    id_polifenol: "38",
    polifenol: "Gallic Acid",
    id_cancer: "3233",
    cancer: "Carcinoma, Ehrlich Tumor",
    quant: "7",
    pmids: "25933717,27495835,28807853,23023566,24403651,19222998,21812646",
  },
  {
    id: "9641",
    id_polifenol: "117",
    polifenol: "Luteolin",
    id_cancer: "3233",
    cancer: "Carcinoma, Ehrlich Tumor",
    quant: "1",
    pmids: "26929584",
  },
  {
    id: "9642",
    id_polifenol: "1",
    polifenol: "Phenols",
    id_cancer: "3233",
    cancer: "Carcinoma, Ehrlich Tumor",
    quant: "7",
    pmids: "23570524,21812646,2303318,1793747,18582932,2261879,8768787",
  },
  {
    id: "9643",
    id_polifenol: "129",
    polifenol: "Rotenone",
    id_cancer: "3233",
    cancer: "Carcinoma, Ehrlich Tumor",
    quant: "8",
    pmids: "29692266,177206,1000513,8348950,7867713,7559791,8615647,7809976",
  },
  {
    id: "9644",
    id_polifenol: "121",
    polifenol: "Kaempferols",
    id_cancer: "3233",
    cancer: "Carcinoma, Ehrlich Tumor",
    quant: "2",
    pmids: "23023566,24653555",
  },
  {
    id: "9645",
    id_polifenol: "120",
    polifenol: "Flavonols",
    id_cancer: "3233",
    cancer: "Carcinoma, Ehrlich Tumor",
    quant: "1",
    pmids: "23570524",
  },
  {
    id: "9646",
    id_polifenol: "4522",
    polifenol: "chrysin",
    id_cancer: "3233",
    cancer: "Carcinoma, Ehrlich Tumor",
    quant: "1",
    pmids: "16054317",
  },
  {
    id: "9647",
    id_polifenol: "123",
    polifenol: "Rutin",
    id_cancer: "3233",
    cancer: "Carcinoma, Ehrlich Tumor",
    quant: "1",
    pmids: "24403651",
  },
  {
    id: "9648",
    id_polifenol: "6062",
    polifenol: "naringenin",
    id_cancer: "3233",
    cancer: "Carcinoma, Ehrlich Tumor",
    quant: "2",
    pmids: "16054317,22642894",
  },
  {
    id: "9649",
    id_polifenol: "39",
    polifenol: "Hydrolyzable Tannins",
    id_cancer: "3233",
    cancer: "Carcinoma, Ehrlich Tumor",
    quant: "2",
    pmids: "23350280,24014915",
  },
  {
    id: "9650",
    id_polifenol: "35",
    polifenol: "Hydroquinones",
    id_cancer: "3233",
    cancer: "Carcinoma, Ehrlich Tumor",
    quant: "1",
    pmids: "3191161",
  },
  {
    id: "9651",
    id_polifenol: "25",
    polifenol: "Butylated Hydroxytoluene",
    id_cancer: "3233",
    cancer: "Carcinoma, Ehrlich Tumor",
    quant: "1",
    pmids: "3191161",
  },
  {
    id: "9652",
    id_polifenol: "75",
    polifenol: "Butylated Hydroxyanisole",
    id_cancer: "3233",
    cancer: "Carcinoma, Ehrlich Tumor",
    quant: "2",
    pmids: "2876731,16432761",
  },
  {
    id: "9653",
    id_polifenol: "6087",
    polifenol: "wogonin",
    id_cancer: "3233",
    cancer: "Carcinoma, Ehrlich Tumor",
    quant: "1",
    pmids: "29689288",
  },
  {
    id: "9654",
    id_polifenol: "4519",
    polifenol: "myricetin",
    id_cancer: "3233",
    cancer: "Carcinoma, Ehrlich Tumor",
    quant: "1",
    pmids: "23570524",
  },
  {
    id: "9655",
    id_polifenol: "5608",
    polifenol: "epicatechin gallate",
    id_cancer: "3233",
    cancer: "Carcinoma, Ehrlich Tumor",
    quant: "2",
    pmids: "28807853,9609384",
  },
  {
    id: "9656",
    id_polifenol: "5607",
    polifenol: "gallocatechol",
    id_cancer: "3233",
    cancer: "Carcinoma, Ehrlich Tumor",
    quant: "6",
    pmids: "23570524,28807853,11880178,11311209,10475615,9609384",
  },
  {
    id: "9657",
    id_polifenol: "4559",
    polifenol: "theaflavin",
    id_cancer: "3233",
    cancer: "Carcinoma, Ehrlich Tumor",
    quant: "1",
    pmids: "26586942",
  },
  {
    id: "9658",
    id_polifenol: "2344",
    polifenol: "methyl gallate",
    id_cancer: "3233",
    cancer: "Carcinoma, Ehrlich Tumor",
    quant: "1",
    pmids: "19222998",
  },
  {
    id: "9659",
    id_polifenol: "47",
    polifenol: "Mesalamine",
    id_cancer: "3233",
    cancer: "Carcinoma, Ehrlich Tumor",
    quant: "1",
    pmids: "18540848",
  },
  {
    id: "9660",
    id_polifenol: "112",
    polifenol: "Hesperidin",
    id_cancer: "3233",
    cancer: "Carcinoma, Ehrlich Tumor",
    quant: "1",
    pmids: "29481770",
  },
  {
    id: "9661",
    id_polifenol: "4513",
    polifenol: "galangin",
    id_cancer: "3233",
    cancer: "Carcinoma, Ehrlich Tumor",
    quant: "1",
    pmids: "22434356",
  },
  {
    id: "9662",
    id_polifenol: "6063",
    polifenol: "naringin",
    id_cancer: "3233",
    cancer: "Carcinoma, Ehrlich Tumor",
    quant: "3",
    pmids: "29497294,20013318,17412551",
  },
  {
    id: "9663",
    id_polifenol: "7550",
    polifenol: "3-methylquercetin",
    id_cancer: "3233",
    cancer: "Carcinoma, Ehrlich Tumor",
    quant: "1",
    pmids: "24653555",
  },
  {
    id: "9664",
    id_polifenol: "108",
    polifenol: "Biflavonoids",
    id_cancer: "3233",
    cancer: "Carcinoma, Ehrlich Tumor",
    quant: "1",
    pmids: "18038762",
  },
  {
    id: "9665",
    id_polifenol: "89",
    polifenol: "Vanillic Acid",
    id_cancer: "3233",
    cancer: "Carcinoma, Ehrlich Tumor",
    quant: "1",
    pmids: "28807853",
  },
  {
    id: "9666",
    id_polifenol: "4486",
    polifenol: "amentoflavone",
    id_cancer: "3233",
    cancer: "Carcinoma, Ehrlich Tumor",
    quant: "1",
    pmids: "18038762",
  },
  {
    id: "9667",
    id_polifenol: "7541",
    polifenol: "taxifolin",
    id_cancer: "3233",
    cancer: "Carcinoma, Ehrlich Tumor",
    quant: "1",
    pmids: "16358785",
  },
  {
    id: "9668",
    id_polifenol: "7544",
    polifenol: "quercitrin",
    id_cancer: "3233",
    cancer: "Carcinoma, Ehrlich Tumor",
    quant: "1",
    pmids: "24653555",
  },
  {
    id: "9669",
    id_polifenol: "60",
    polifenol: "2,4-Dinitrophenol",
    id_cancer: "3233",
    cancer: "Carcinoma, Ehrlich Tumor",
    quant: "2",
    pmids: "1053515,7559791",
  },
  {
    id: "9670",
    id_polifenol: "4767",
    polifenol: "flavan-3-ol",
    id_cancer: "3233",
    cancer: "Carcinoma, Ehrlich Tumor",
    quant: "1",
    pmids: "23570524",
  },
  {
    id: "9671",
    id_polifenol: "59",
    polifenol: "Dinitrophenols",
    id_cancer: "3233",
    cancer: "Carcinoma, Ehrlich Tumor",
    quant: "2",
    pmids: "6155994,170904",
  },
  {
    id: "9672",
    id_polifenol: "2574",
    polifenol: "4-hydroxybenzoic acid",
    id_cancer: "3233",
    cancer: "Carcinoma, Ehrlich Tumor",
    quant: "1",
    pmids: "28807853",
  },
  {
    id: "9673",
    id_polifenol: "6452",
    polifenol: "chrysoeriol",
    id_cancer: "3233",
    cancer: "Carcinoma, Ehrlich Tumor",
    quant: "1",
    pmids: "24653555",
  },
  {
    id: "9674",
    id_polifenol: "299",
    polifenol: "nitrophenylphosphate",
    id_cancer: "3233",
    cancer: "Carcinoma, Ehrlich Tumor",
    quant: "2",
    pmids: "3021233,6293548",
  },
  {
    id: "9675",
    id_polifenol: "7199",
    polifenol: "luteolin-7-glucoside",
    id_cancer: "3233",
    cancer: "Carcinoma, Ehrlich Tumor",
    quant: "1",
    pmids: "24653555",
  },
  {
    id: "9676",
    id_polifenol: "70",
    polifenol: "Sulfobromophthalein",
    id_cancer: "3233",
    cancer: "Carcinoma, Ehrlich Tumor",
    quant: "1",
    pmids: "6193686",
  },
  {
    id: "9677",
    id_polifenol: "6093",
    polifenol: "pinobanksin",
    id_cancer: "3233",
    cancer: "Carcinoma, Ehrlich Tumor",
    quant: "1",
    pmids: "22434356",
  },
  {
    id: "9678",
    id_polifenol: "3490",
    polifenol: "estragole",
    id_cancer: "3233",
    cancer: "Carcinoma, Ehrlich Tumor",
    quant: "1",
    pmids: "21812646",
  },
  {
    id: "9679",
    id_polifenol: "1994",
    polifenol: "duroquinol",
    id_cancer: "3233",
    cancer: "Carcinoma, Ehrlich Tumor",
    quant: "1",
    pmids: "6227286",
  },
  {
    id: "9680",
    id_polifenol: "5065",
    polifenol: "3,5,6,7,8-pentahydroxy flavone",
    id_cancer: "3233",
    cancer: "Carcinoma, Ehrlich Tumor",
    quant: "1",
    pmids: "192316",
  },
  {
    id: "9681",
    id_polifenol: "7803",
    polifenol: "LQB 118",
    id_cancer: "3233",
    cancer: "Carcinoma, Ehrlich Tumor",
    quant: "1",
    pmids: "29692266",
  },
  {
    id: "9682",
    id_polifenol: "7690",
    polifenol: "isorhamnetin-3-O-galactoside",
    id_cancer: "3233",
    cancer: "Carcinoma, Ehrlich Tumor",
    quant: "1",
    pmids: "24653555",
  },
  {
    id: "9683",
    id_polifenol: "2080",
    polifenol: "2-methoxy-1,4-hydroquinone",
    id_cancer: "3233",
    cancer: "Carcinoma, Ehrlich Tumor",
    quant: "1",
    pmids: "17627574",
  },
  {
    id: "9684",
    id_polifenol: "3802",
    polifenol: "kutkin",
    id_cancer: "3233",
    cancer: "Carcinoma, Ehrlich Tumor",
    quant: "1",
    pmids: "11406836",
  },
  {
    id: "9685",
    id_polifenol: "2345",
    polifenol: "isobutyl gallate",
    id_cancer: "3233",
    cancer: "Carcinoma, Ehrlich Tumor",
    quant: "1",
    pmids: "19222998",
  },
  {
    id: "9686",
    id_polifenol: "5763",
    polifenol: "lophirone C",
    id_cancer: "3233",
    cancer: "Carcinoma, Ehrlich Tumor",
    quant: "1",
    pmids: "24647375",
  },
  {
    id: "9687",
    id_polifenol: "3121",
    polifenol: "ethyl O-(N-(4-carboxyphenyl)carbamoyl)mycophenolate",
    id_cancer: "3233",
    cancer: "Carcinoma, Ehrlich Tumor",
    quant: "1",
    pmids: "7274650",
  },
  {
    id: "9688",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "558",
    cancer: "Hematologic Neoplasms",
    quant: "8",
    pmids:
      "27329589,21445621,23203111,21824109,26923122,28865123,17197231,26163601",
  },
  {
    id: "9689",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "558",
    cancer: "Hematologic Neoplasms",
    quant: "9",
    pmids:
      "26496980,28322158,16188398,17197231,18076140,26709750,22292765,24522270,19505187",
  },
  {
    id: "9690",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "558",
    cancer: "Hematologic Neoplasms",
    quant: "9",
    pmids:
      "23521677,12151351,21824109,16253769,26870993,26923122,28807562,17197231,22292765",
  },
  {
    id: "9691",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "558",
    cancer: "Hematologic Neoplasms",
    quant: "6",
    pmids: "23792588,27114702,21853157,23685456,17137556,26059188",
  },
  {
    id: "9692",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "558",
    cancer: "Hematologic Neoplasms",
    quant: "5",
    pmids: "15883821,17197231,21541487,22292765,19505187",
  },
  {
    id: "9693",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "558",
    cancer: "Hematologic Neoplasms",
    quant: "4",
    pmids: "25293876,27329589,29069736,22292765",
  },
  {
    id: "9694",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "558",
    cancer: "Hematologic Neoplasms",
    quant: "3",
    pmids: "28103249,22292765,19505187",
  },
  {
    id: "9695",
    id_polifenol: "2167",
    polifenol: "phenolic acid",
    id_cancer: "558",
    cancer: "Hematologic Neoplasms",
    quant: "3",
    pmids: "23521677,23203111,26923122",
  },
  {
    id: "9696",
    id_polifenol: "49",
    polifenol: "Aspirin",
    id_cancer: "558",
    cancer: "Hematologic Neoplasms",
    quant: "1",
    pmids: "18608871",
  },
  {
    id: "9697",
    id_polifenol: "125",
    polifenol: "Isoflavones",
    id_cancer: "558",
    cancer: "Hematologic Neoplasms",
    quant: "1",
    pmids: "21541487",
  },
  {
    id: "9698",
    id_polifenol: "110",
    polifenol: "Chalcones",
    id_cancer: "558",
    cancer: "Hematologic Neoplasms",
    quant: "2",
    pmids: "28610775,26269760",
  },
  {
    id: "9699",
    id_polifenol: "114",
    polifenol: "Apigenin",
    id_cancer: "558",
    cancer: "Hematologic Neoplasms",
    quant: "1",
    pmids: "22292765",
  },
  {
    id: "9700",
    id_polifenol: "113",
    polifenol: "Flavones",
    id_cancer: "558",
    cancer: "Hematologic Neoplasms",
    quant: "1",
    pmids: "9516149",
  },
  {
    id: "9701",
    id_polifenol: "117",
    polifenol: "Luteolin",
    id_cancer: "558",
    cancer: "Hematologic Neoplasms",
    quant: "1",
    pmids: "22292765",
  },
  {
    id: "9702",
    id_polifenol: "1",
    polifenol: "Phenols",
    id_cancer: "558",
    cancer: "Hematologic Neoplasms",
    quant: "1",
    pmids: "29367668",
  },
  {
    id: "9703",
    id_polifenol: "7235",
    polifenol: "silybin",
    id_cancer: "558",
    cancer: "Hematologic Neoplasms",
    quant: "2",
    pmids: "26516160,26148599",
  },
  {
    id: "9704",
    id_polifenol: "129",
    polifenol: "Rotenone",
    id_cancer: "558",
    cancer: "Hematologic Neoplasms",
    quant: "1",
    pmids: "15883821",
  },
  {
    id: "9705",
    id_polifenol: "121",
    polifenol: "Kaempferols",
    id_cancer: "558",
    cancer: "Hematologic Neoplasms",
    quant: "1",
    pmids: "28865123",
  },
  {
    id: "9706",
    id_polifenol: "871",
    polifenol: "ABT-737",
    id_cancer: "558",
    cancer: "Hematologic Neoplasms",
    quant: "9",
    pmids:
      "28038464,24030150,19022681,20038799,19060243,26088877,22311987,18841882,24614082",
  },
  {
    id: "9707",
    id_polifenol: "6451",
    polifenol: "daidzein",
    id_cancer: "558",
    cancer: "Hematologic Neoplasms",
    quant: "1",
    pmids: "21541487",
  },
  {
    id: "9708",
    id_polifenol: "4634",
    polifenol: "alvocidib",
    id_cancer: "558",
    cancer: "Hematologic Neoplasms",
    quant: "7",
    pmids: "26924736,19370178,25866220,11960328,25914884,9427698,9516149",
  },
  {
    id: "9709",
    id_polifenol: "4522",
    polifenol: "chrysin",
    id_cancer: "558",
    cancer: "Hematologic Neoplasms",
    quant: "2",
    pmids: "15555556,22292765",
  },
  {
    id: "9710",
    id_polifenol: "6062",
    polifenol: "naringenin",
    id_cancer: "558",
    cancer: "Hematologic Neoplasms",
    quant: "1",
    pmids: "26496980",
  },
  {
    id: "9711",
    id_polifenol: "39",
    polifenol: "Hydrolyzable Tannins",
    id_cancer: "558",
    cancer: "Hematologic Neoplasms",
    quant: "1",
    pmids: "23203111",
  },
  {
    id: "9712",
    id_polifenol: "35",
    polifenol: "Hydroquinones",
    id_cancer: "558",
    cancer: "Hematologic Neoplasms",
    quant: "1",
    pmids: "27515134",
  },
  {
    id: "9713",
    id_polifenol: "111",
    polifenol: "Flavanones",
    id_cancer: "558",
    cancer: "Hematologic Neoplasms",
    quant: "1",
    pmids: "21445621",
  },
  {
    id: "9714",
    id_polifenol: "6087",
    polifenol: "wogonin",
    id_cancer: "558",
    cancer: "Hematologic Neoplasms",
    quant: "1",
    pmids: "18070986",
  },
  {
    id: "9715",
    id_polifenol: "4515",
    polifenol: "baicalin",
    id_cancer: "558",
    cancer: "Hematologic Neoplasms",
    quant: "1",
    pmids: "17007926",
  },
  {
    id: "9716",
    id_polifenol: "5808",
    polifenol: "isoliquiritigenin",
    id_cancer: "558",
    cancer: "Hematologic Neoplasms",
    quant: "1",
    pmids: "22648519",
  },
  {
    id: "9717",
    id_polifenol: "2344",
    polifenol: "methyl gallate",
    id_cancer: "558",
    cancer: "Hematologic Neoplasms",
    quant: "1",
    pmids: "21048105",
  },
  {
    id: "9718",
    id_polifenol: "4708",
    polifenol: "xanthohumol",
    id_cancer: "558",
    cancer: "Hematologic Neoplasms",
    quant: "1",
    pmids: "17823911",
  },
  {
    id: "9719",
    id_polifenol: "112",
    polifenol: "Hesperidin",
    id_cancer: "558",
    cancer: "Hematologic Neoplasms",
    quant: "2",
    pmids: "21445621,26148599",
  },
  {
    id: "9720",
    id_polifenol: "1380",
    polifenol: "shogaol",
    id_cancer: "558",
    cancer: "Hematologic Neoplasms",
    quant: "1",
    pmids: "24215632",
  },
  {
    id: "9721",
    id_polifenol: "93",
    polifenol: "Phloroglucinol",
    id_cancer: "558",
    cancer: "Hematologic Neoplasms",
    quant: "1",
    pmids: "16791262",
  },
  {
    id: "9722",
    id_polifenol: "55",
    polifenol: "Sodium Salicylate",
    id_cancer: "558",
    cancer: "Hematologic Neoplasms",
    quant: "1",
    pmids: "24692721",
  },
  {
    id: "9723",
    id_polifenol: "48",
    polifenol: "Anacardic Acids",
    id_cancer: "558",
    cancer: "Hematologic Neoplasms",
    quant: "1",
    pmids: "24522270",
  },
  {
    id: "9724",
    id_polifenol: "2773",
    polifenol: "farnesylthiosalicylic acid",
    id_cancer: "558",
    cancer: "Hematologic Neoplasms",
    quant: "1",
    pmids: "18374183",
  },
  {
    id: "9725",
    id_polifenol: "5614",
    polifenol: "catechin gallate",
    id_cancer: "558",
    cancer: "Hematologic Neoplasms",
    quant: "1",
    pmids: "28103249",
  },
  {
    id: "9726",
    id_polifenol: "7912",
    polifenol: "7,9,2',4'-tetrahydroxy-8-isopentenyl-5-methoxychalcone",
    id_cancer: "558",
    cancer: "Hematologic Neoplasms",
    quant: "1",
    pmids: "21831037",
  },
  {
    id: "9727",
    id_polifenol: "5071",
    polifenol: "icaritin",
    id_cancer: "558",
    cancer: "Hematologic Neoplasms",
    quant: "1",
    pmids: "25887673",
  },
  {
    id: "9728",
    id_polifenol: "5455",
    polifenol: "theaflavin-3,3'-digallate",
    id_cancer: "558",
    cancer: "Hematologic Neoplasms",
    quant: "1",
    pmids: "24371212",
  },
  {
    id: "9729",
    id_polifenol: "2014",
    polifenol: "erbstatin",
    id_cancer: "558",
    cancer: "Hematologic Neoplasms",
    quant: "1",
    pmids: "18855573",
  },
  {
    id: "9730",
    id_polifenol: "299",
    polifenol: "nitrophenylphosphate",
    id_cancer: "558",
    cancer: "Hematologic Neoplasms",
    quant: "1",
    pmids: "6163825",
  },
  {
    id: "9731",
    id_polifenol: "885",
    polifenol: "oleocanthal",
    id_cancer: "558",
    cancer: "Hematologic Neoplasms",
    quant: "1",
    pmids: "23521677",
  },
  {
    id: "9732",
    id_polifenol: "7741",
    polifenol: "biochanin A",
    id_cancer: "558",
    cancer: "Hematologic Neoplasms",
    quant: "1",
    pmids: "21541487",
  },
  {
    id: "9733",
    id_polifenol: "2790",
    polifenol: "ginkgolic acid",
    id_cancer: "558",
    cancer: "Hematologic Neoplasms",
    quant: "1",
    pmids: "28208828",
  },
  {
    id: "9734",
    id_polifenol: "4782",
    polifenol: "kurarinone",
    id_cancer: "558",
    cancer: "Hematologic Neoplasms",
    quant: "1",
    pmids: "21831037",
  },
  {
    id: "9735",
    id_polifenol: "6076",
    polifenol: "vexibinol",
    id_cancer: "558",
    cancer: "Hematologic Neoplasms",
    quant: "1",
    pmids: "21831037",
  },
  {
    id: "9736",
    id_polifenol: "3566",
    polifenol: "K 7174",
    id_cancer: "558",
    cancer: "Hematologic Neoplasms",
    quant: "1",
    pmids: "23593271",
  },
  {
    id: "9737",
    id_polifenol: "5802",
    polifenol: "hesperidin methylchalcone",
    id_cancer: "558",
    cancer: "Hematologic Neoplasms",
    quant: "1",
    pmids: "26148599",
  },
  {
    id: "9738",
    id_polifenol: "4121",
    polifenol: "CPUY201112",
    id_cancer: "558",
    cancer: "Hematologic Neoplasms",
    quant: "1",
    pmids: "26743233",
  },
  {
    id: "9739",
    id_polifenol: "615",
    polifenol: "2-allylphenol",
    id_cancer: "558",
    cancer: "Hematologic Neoplasms",
    quant: "1",
    pmids: "29367668",
  },
  {
    id: "9740",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "546",
    cancer: "Vulvar Cancer",
    quant: "16",
    pmids:
      "21330379,10556937,25522537,22426819,25295671,16108826,22204275,9642119,22583931,19639540,28277581,28930257,24824323,26196716,28122160,28029227",
  },
  {
    id: "9741",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "546",
    cancer: "Vulvar Cancer",
    quant: "9",
    pmids:
      "28618944,19035461,19655336,25044209,24578676,27819148,29605808,21215629,25068616",
  },
  {
    id: "9742",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "546",
    cancer: "Vulvar Cancer",
    quant: "10",
    pmids:
      "17984116,10775421,10223207,10964666,25522537,9328839,10509743,22583931,9414176,27485636",
  },
  {
    id: "9743",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "546",
    cancer: "Vulvar Cancer",
    quant: "2",
    pmids: "14696113,10436007",
  },
  {
    id: "9744",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "546",
    cancer: "Vulvar Cancer",
    quant: "4",
    pmids: "17101324,8201603,10463775,27485636",
  },
  {
    id: "9745",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "546",
    cancer: "Vulvar Cancer",
    quant: "6",
    pmids: "10556937,25522537,8201603,22426819,28277581,28122160",
  },
  {
    id: "9746",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "546",
    cancer: "Vulvar Cancer",
    quant: "8",
    pmids:
      "10775421,10223207,10964666,9328839,10509743,21209038,9414176,29157036",
  },
  {
    id: "9747",
    id_polifenol: "2167",
    polifenol: "phenolic acid",
    id_cancer: "546",
    cancer: "Vulvar Cancer",
    quant: "5",
    pmids: "28222613,19481070,28930257,28122160,28029227",
  },
  {
    id: "9748",
    id_polifenol: "49",
    polifenol: "Aspirin",
    id_cancer: "546",
    cancer: "Vulvar Cancer",
    quant: "1",
    pmids: "14696113",
  },
  {
    id: "9749",
    id_polifenol: "109",
    polifenol: "Catechin",
    id_cancer: "546",
    cancer: "Vulvar Cancer",
    quant: "4",
    pmids: "21209038,28930257,28122160,28029227",
  },
  {
    id: "9750",
    id_polifenol: "125",
    polifenol: "Isoflavones",
    id_cancer: "546",
    cancer: "Vulvar Cancer",
    quant: "1",
    pmids: "22583931",
  },
  {
    id: "9751",
    id_polifenol: "110",
    polifenol: "Chalcones",
    id_cancer: "546",
    cancer: "Vulvar Cancer",
    quant: "1",
    pmids: "17627575",
  },
  {
    id: "9752",
    id_polifenol: "3089",
    polifenol: "1,1-diphenyl-2-picrylhydrazyl",
    id_cancer: "546",
    cancer: "Vulvar Cancer",
    quant: "4",
    pmids: "22354161,27148169,22074239,24824323",
  },
  {
    id: "9753",
    id_polifenol: "114",
    polifenol: "Apigenin",
    id_cancer: "546",
    cancer: "Vulvar Cancer",
    quant: "1",
    pmids: "24671394",
  },
  {
    id: "9754",
    id_polifenol: "38",
    polifenol: "Gallic Acid",
    id_cancer: "546",
    cancer: "Vulvar Cancer",
    quant: "5",
    pmids: "27148169,28962387,28930257,28122160,28029227",
  },
  {
    id: "9755",
    id_polifenol: "117",
    polifenol: "Luteolin",
    id_cancer: "546",
    cancer: "Vulvar Cancer",
    quant: "4",
    pmids: "21330379,10556937,28277581,24671394",
  },
  {
    id: "9756",
    id_polifenol: "1",
    polifenol: "Phenols",
    id_cancer: "546",
    cancer: "Vulvar Cancer",
    quant: "3",
    pmids: "25522537,28222613,26196716",
  },
  {
    id: "9757",
    id_polifenol: "105",
    polifenol: "Anthocyanins",
    id_cancer: "546",
    cancer: "Vulvar Cancer",
    quant: "2",
    pmids: "11262056,27485636",
  },
  {
    id: "9758",
    id_polifenol: "121",
    polifenol: "Kaempferols",
    id_cancer: "546",
    cancer: "Vulvar Cancer",
    quant: "1",
    pmids: "19435896",
  },
  {
    id: "9759",
    id_polifenol: "6065",
    polifenol: "baicalein",
    id_cancer: "546",
    cancer: "Vulvar Cancer",
    quant: "3",
    pmids: "19558494,22204275,12874035",
  },
  {
    id: "9760",
    id_polifenol: "7",
    polifenol: "Capsaicin",
    id_cancer: "546",
    cancer: "Vulvar Cancer",
    quant: "2",
    pmids: "20660715,25522537",
  },
  {
    id: "9761",
    id_polifenol: "4634",
    polifenol: "alvocidib",
    id_cancer: "546",
    cancer: "Vulvar Cancer",
    quant: "2",
    pmids: "16108826,28560460",
  },
  {
    id: "9762",
    id_polifenol: "123",
    polifenol: "Rutin",
    id_cancer: "546",
    cancer: "Vulvar Cancer",
    quant: "3",
    pmids: "28930257,28122160,28029227",
  },
  {
    id: "9763",
    id_polifenol: "130",
    polifenol: "Proanthocyanidins",
    id_cancer: "546",
    cancer: "Vulvar Cancer",
    quant: "3",
    pmids: "28930257,28122160,28029227",
  },
  {
    id: "9764",
    id_polifenol: "35",
    polifenol: "Hydroquinones",
    id_cancer: "546",
    cancer: "Vulvar Cancer",
    quant: "1",
    pmids: "29562668",
  },
  {
    id: "9765",
    id_polifenol: "25",
    polifenol: "Butylated Hydroxytoluene",
    id_cancer: "546",
    cancer: "Vulvar Cancer",
    quant: "1",
    pmids: "27148169",
  },
  {
    id: "9766",
    id_polifenol: "5608",
    polifenol: "epicatechin gallate",
    id_cancer: "546",
    cancer: "Vulvar Cancer",
    quant: "1",
    pmids: "9414176",
  },
  {
    id: "9767",
    id_polifenol: "1356",
    polifenol: "gingerol",
    id_cancer: "546",
    cancer: "Vulvar Cancer",
    quant: "1",
    pmids: "19481070",
  },
  {
    id: "9768",
    id_polifenol: "5607",
    polifenol: "gallocatechol",
    id_cancer: "546",
    cancer: "Vulvar Cancer",
    quant: "1",
    pmids: "9414176",
  },
  {
    id: "9769",
    id_polifenol: "4559",
    polifenol: "theaflavin",
    id_cancer: "546",
    cancer: "Vulvar Cancer",
    quant: "2",
    pmids: "17984116,10223207",
  },
  {
    id: "9770",
    id_polifenol: "2344",
    polifenol: "methyl gallate",
    id_cancer: "546",
    cancer: "Vulvar Cancer",
    quant: "1",
    pmids: "28962387",
  },
  {
    id: "9771",
    id_polifenol: "2284",
    polifenol: "rosmarinic acid",
    id_cancer: "546",
    cancer: "Vulvar Cancer",
    quant: "2",
    pmids: "28222613,24671394",
  },
  {
    id: "9772",
    id_polifenol: "2158",
    polifenol: "protocatechuic acid",
    id_cancer: "546",
    cancer: "Vulvar Cancer",
    quant: "1",
    pmids: "28122160",
  },
  {
    id: "9773",
    id_polifenol: "5489",
    polifenol: "delphinidin",
    id_cancer: "546",
    cancer: "Vulvar Cancer",
    quant: "3",
    pmids: "11262056,19653223,27485636",
  },
  {
    id: "9774",
    id_polifenol: "1613",
    polifenol: "demethoxycurcumin",
    id_cancer: "546",
    cancer: "Vulvar Cancer",
    quant: "1",
    pmids: "28618944",
  },
  {
    id: "9775",
    id_polifenol: "7550",
    polifenol: "3-methylquercetin",
    id_cancer: "546",
    cancer: "Vulvar Cancer",
    quant: "1",
    pmids: "21330379",
  },
  {
    id: "9776",
    id_polifenol: "4560",
    polifenol: "icariin",
    id_cancer: "546",
    cancer: "Vulvar Cancer",
    quant: "1",
    pmids: "23807305",
  },
  {
    id: "9777",
    id_polifenol: "5488",
    polifenol: "cyanidin",
    id_cancer: "546",
    cancer: "Vulvar Cancer",
    quant: "1",
    pmids: "11262056",
  },
  {
    id: "9778",
    id_polifenol: "2773",
    polifenol: "farnesylthiosalicylic acid",
    id_cancer: "546",
    cancer: "Vulvar Cancer",
    quant: "1",
    pmids: "19372139",
  },
  {
    id: "9779",
    id_polifenol: "4585",
    polifenol: "baohuoside I",
    id_cancer: "546",
    cancer: "Vulvar Cancer",
    quant: "1",
    pmids: "23807305",
  },
  {
    id: "9780",
    id_polifenol: "5455",
    polifenol: "theaflavin-3,3'-digallate",
    id_cancer: "546",
    cancer: "Vulvar Cancer",
    quant: "1",
    pmids: "10223207",
  },
  {
    id: "9781",
    id_polifenol: "5495",
    polifenol: "malvidin",
    id_cancer: "546",
    cancer: "Vulvar Cancer",
    quant: "1",
    pmids: "11262056",
  },
  {
    id: "9782",
    id_polifenol: "7141",
    polifenol: "apigetrin",
    id_cancer: "546",
    cancer: "Vulvar Cancer",
    quant: "1",
    pmids: "28222613",
  },
  {
    id: "9783",
    id_polifenol: "6452",
    polifenol: "chrysoeriol",
    id_cancer: "546",
    cancer: "Vulvar Cancer",
    quant: "1",
    pmids: "28222613",
  },
  {
    id: "9784",
    id_polifenol: "7377",
    polifenol: "astragalin",
    id_cancer: "546",
    cancer: "Vulvar Cancer",
    quant: "1",
    pmids: "25348942",
  },
  {
    id: "9785",
    id_polifenol: "115",
    polifenol: "Diosmin",
    id_cancer: "546",
    cancer: "Vulvar Cancer",
    quant: "1",
    pmids: "28862211",
  },
  {
    id: "9786",
    id_polifenol: "2014",
    polifenol: "erbstatin",
    id_cancer: "546",
    cancer: "Vulvar Cancer",
    quant: "3",
    pmids: "10463775,17978516,7585535",
  },
  {
    id: "9787",
    id_polifenol: "299",
    polifenol: "nitrophenylphosphate",
    id_cancer: "546",
    cancer: "Vulvar Cancer",
    quant: "1",
    pmids: "6293548",
  },
  {
    id: "9788",
    id_polifenol: "2364",
    polifenol: "theaflavine gallate",
    id_cancer: "546",
    cancer: "Vulvar Cancer",
    quant: "1",
    pmids: "10223207",
  },
  {
    id: "9789",
    id_polifenol: "7199",
    polifenol: "luteolin-7-glucoside",
    id_cancer: "546",
    cancer: "Vulvar Cancer",
    quant: "1",
    pmids: "28222613",
  },
  {
    id: "9790",
    id_polifenol: "4981",
    polifenol: "jaceosidin",
    id_cancer: "546",
    cancer: "Vulvar Cancer",
    quant: "1",
    pmids: "25295671",
  },
  {
    id: "9791",
    id_polifenol: "5542",
    polifenol: "delphinidin 3-O-glucopyranoside",
    id_cancer: "546",
    cancer: "Vulvar Cancer",
    quant: "1",
    pmids: "27485636",
  },
  {
    id: "9792",
    id_polifenol: "5532",
    polifenol: "malvidin-3-glucoside",
    id_cancer: "546",
    cancer: "Vulvar Cancer",
    quant: "1",
    pmids: "11262056",
  },
  {
    id: "9793",
    id_polifenol: "6478",
    polifenol: "cirsilineol",
    id_cancer: "546",
    cancer: "Vulvar Cancer",
    quant: "1",
    pmids: "25295671",
  },
  {
    id: "9794",
    id_polifenol: "4524",
    polifenol: "5-hydroxy-3',4',6,7-tetramethoxyflavone",
    id_cancer: "546",
    cancer: "Vulvar Cancer",
    quant: "1",
    pmids: "24148842",
  },
  {
    id: "9795",
    id_polifenol: "903",
    polifenol: "vineatrol",
    id_cancer: "546",
    cancer: "Vulvar Cancer",
    quant: "1",
    pmids: "23157192",
  },
  {
    id: "9796",
    id_polifenol: "3362",
    polifenol: "bastadin 4",
    id_cancer: "546",
    cancer: "Vulvar Cancer",
    quant: "1",
    pmids: "16520655",
  },
  {
    id: "9797",
    id_polifenol: "5557",
    polifenol: "cyanidin 3-galactoside",
    id_cancer: "546",
    cancer: "Vulvar Cancer",
    quant: "1",
    pmids: "11262056",
  },
  {
    id: "9798",
    id_polifenol: "4152",
    polifenol: "quracol B",
    id_cancer: "546",
    cancer: "Vulvar Cancer",
    quant: "1",
    pmids: "17627575",
  },
  {
    id: "9799",
    id_polifenol: "165",
    polifenol: "r2-viniferin",
    id_cancer: "546",
    cancer: "Vulvar Cancer",
    quant: "1",
    pmids: "23157192",
  },
  {
    id: "9800",
    id_polifenol: "4195",
    polifenol: "climacostol",
    id_cancer: "546",
    cancer: "Vulvar Cancer",
    quant: "1",
    pmids: "18723007",
  },
  {
    id: "9801",
    id_polifenol: "2794",
    polifenol: "salazinic acid",
    id_cancer: "546",
    cancer: "Vulvar Cancer",
    quant: "1",
    pmids: "19199230",
  },
  {
    id: "9802",
    id_polifenol: "4649",
    polifenol: "centaureidin",
    id_cancer: "546",
    cancer: "Vulvar Cancer",
    quant: "1",
    pmids: "19639540",
  },
  {
    id: "9803",
    id_polifenol: "4770",
    polifenol: "3-bromo-6-methyl-2'-hydroxy flavone",
    id_cancer: "546",
    cancer: "Vulvar Cancer",
    quant: "1",
    pmids: "14696113",
  },
  {
    id: "9804",
    id_polifenol: "5116",
    polifenol: "betuletol 3-methyl ether",
    id_cancer: "546",
    cancer: "Vulvar Cancer",
    quant: "1",
    pmids: "16949071",
  },
  {
    id: "9805",
    id_polifenol: "4498",
    polifenol: "tanacin",
    id_cancer: "546",
    cancer: "Vulvar Cancer",
    quant: "1",
    pmids: "19639540",
  },
  {
    id: "9806",
    id_polifenol: "2192",
    polifenol: "evernic acid",
    id_cancer: "546",
    cancer: "Vulvar Cancer",
    quant: "1",
    pmids: "19199230",
  },
  {
    id: "9807",
    id_polifenol: "488",
    polifenol: "2-(2-hydroxyphenyl)benzothiazole",
    id_cancer: "546",
    cancer: "Vulvar Cancer",
    quant: "1",
    pmids: "8201603",
  },
  {
    id: "9808",
    id_polifenol: "7086",
    polifenol: "5,7,3',5'-tetrahydroxy-6,4'-dimethoxyflavone",
    id_cancer: "546",
    cancer: "Vulvar Cancer",
    quant: "1",
    pmids: "25295671",
  },
  {
    id: "9809",
    id_polifenol: "7915",
    polifenol: "6-methoxyequol",
    id_cancer: "546",
    cancer: "Vulvar Cancer",
    quant: "1",
    pmids: "22583931",
  },
  {
    id: "9810",
    id_polifenol: "6768",
    polifenol:
      "chrysoeriol 7-O-(2'''-O-caffeoyl-beta-D-glucopyranosyl-(1-2)-beta-d-glucopyranoside)",
    id_cancer: "546",
    cancer: "Vulvar Cancer",
    quant: "1",
    pmids: "28222613",
  },
  {
    id: "9811",
    id_polifenol: "2297",
    polifenol: "3'-O-beta-D-glucopyranosyl rosmarinic acid",
    id_cancer: "546",
    cancer: "Vulvar Cancer",
    quant: "1",
    pmids: "28222613",
  },
  {
    id: "9812",
    id_polifenol: "4343",
    polifenol: "3-cinnamoyltribuloside",
    id_cancer: "546",
    cancer: "Vulvar Cancer",
    quant: "1",
    pmids: "25348942",
  },
  {
    id: "9813",
    id_polifenol: "575",
    polifenol: "BE 23372M",
    id_cancer: "546",
    cancer: "Vulvar Cancer",
    quant: "1",
    pmids: "8175480",
  },
  {
    id: "9814",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "560",
    cancer: "Acute Lymphoblastic Leukemia",
    quant: "5",
    pmids: "22593249,29312799,29407975,20404022,18465538",
  },
  {
    id: "9815",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "560",
    cancer: "Acute Lymphoblastic Leukemia",
    quant: "10",
    pmids:
      "28807161,19055861,26815506,27318188,22593249,21386967,25979368,22791660,16141719,23389039",
  },
  {
    id: "9816",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "560",
    cancer: "Acute Lymphoblastic Leukemia",
    quant: "5",
    pmids: "28366708,22412883,22593249,25929783,28499732",
  },
  {
    id: "9817",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "560",
    cancer: "Acute Lymphoblastic Leukemia",
    quant: "4",
    pmids: "12963734,19428345,10510467,14576828",
  },
  {
    id: "9818",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "560",
    cancer: "Acute Lymphoblastic Leukemia",
    quant: "3",
    pmids: "11410520,15179686,15546018",
  },
  {
    id: "9819",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "560",
    cancer: "Acute Lymphoblastic Leukemia",
    quant: "4",
    pmids: "22412883,1625476,28677813,20404022",
  },
  {
    id: "9820",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "560",
    cancer: "Acute Lymphoblastic Leukemia",
    quant: "2",
    pmids: "22593249,29622866",
  },
  {
    id: "9821",
    id_polifenol: "2167",
    polifenol: "phenolic acid",
    id_cancer: "560",
    cancer: "Acute Lymphoblastic Leukemia",
    quant: "1",
    pmids: "14640548",
  },
  {
    id: "9822",
    id_polifenol: "49",
    polifenol: "Aspirin",
    id_cancer: "560",
    cancer: "Acute Lymphoblastic Leukemia",
    quant: "2",
    pmids: "25061812,18608871",
  },
  {
    id: "9823",
    id_polifenol: "109",
    polifenol: "Catechin",
    id_cancer: "560",
    cancer: "Acute Lymphoblastic Leukemia",
    quant: "1",
    pmids: "20404022",
  },
  {
    id: "9824",
    id_polifenol: "110",
    polifenol: "Chalcones",
    id_cancer: "560",
    cancer: "Acute Lymphoblastic Leukemia",
    quant: "5",
    pmids: "23257665,23895019,20796191,23524161,16828254",
  },
  {
    id: "9825",
    id_polifenol: "3089",
    polifenol: "1,1-diphenyl-2-picrylhydrazyl",
    id_cancer: "560",
    cancer: "Acute Lymphoblastic Leukemia",
    quant: "1",
    pmids: "17294687",
  },
  {
    id: "9826",
    id_polifenol: "38",
    polifenol: "Gallic Acid",
    id_cancer: "560",
    cancer: "Acute Lymphoblastic Leukemia",
    quant: "3",
    pmids: "27168690,27853333,14640548",
  },
  {
    id: "9827",
    id_polifenol: "117",
    polifenol: "Luteolin",
    id_cancer: "560",
    cancer: "Acute Lymphoblastic Leukemia",
    quant: "1",
    pmids: "17294687",
  },
  {
    id: "9828",
    id_polifenol: "1",
    polifenol: "Phenols",
    id_cancer: "560",
    cancer: "Acute Lymphoblastic Leukemia",
    quant: "2",
    pmids: "14640548,2632259",
  },
  {
    id: "9829",
    id_polifenol: "129",
    polifenol: "Rotenone",
    id_cancer: "560",
    cancer: "Acute Lymphoblastic Leukemia",
    quant: "1",
    pmids: "27486090",
  },
  {
    id: "9830",
    id_polifenol: "871",
    polifenol: "ABT-737",
    id_cancer: "560",
    cancer: "Acute Lymphoblastic Leukemia",
    quant: "7",
    pmids: "28366708,18056841,21798596,23788110,25754349,20038611,18451170",
  },
  {
    id: "9831",
    id_polifenol: "6065",
    polifenol: "baicalein",
    id_cancer: "560",
    cancer: "Acute Lymphoblastic Leukemia",
    quant: "1",
    pmids: "28807161",
  },
  {
    id: "9832",
    id_polifenol: "4634",
    polifenol: "alvocidib",
    id_cancer: "560",
    cancer: "Acute Lymphoblastic Leukemia",
    quant: "4",
    pmids: "25914884,12960118,16322302,18465538",
  },
  {
    id: "9833",
    id_polifenol: "120",
    polifenol: "Flavonols",
    id_cancer: "560",
    cancer: "Acute Lymphoblastic Leukemia",
    quant: "1",
    pmids: "20404022",
  },
  {
    id: "9834",
    id_polifenol: "4522",
    polifenol: "chrysin",
    id_cancer: "560",
    cancer: "Acute Lymphoblastic Leukemia",
    quant: "1",
    pmids: "28807161",
  },
  {
    id: "9835",
    id_polifenol: "123",
    polifenol: "Rutin",
    id_cancer: "560",
    cancer: "Acute Lymphoblastic Leukemia",
    quant: "2",
    pmids: "17294687,1625476",
  },
  {
    id: "9836",
    id_polifenol: "111",
    polifenol: "Flavanones",
    id_cancer: "560",
    cancer: "Acute Lymphoblastic Leukemia",
    quant: "1",
    pmids: "23895019",
  },
  {
    id: "9837",
    id_polifenol: "6087",
    polifenol: "wogonin",
    id_cancer: "560",
    cancer: "Acute Lymphoblastic Leukemia",
    quant: "1",
    pmids: "28807161",
  },
  {
    id: "9838",
    id_polifenol: "4515",
    polifenol: "baicalin",
    id_cancer: "560",
    cancer: "Acute Lymphoblastic Leukemia",
    quant: "1",
    pmids: "17007926",
  },
  {
    id: "9839",
    id_polifenol: "4500",
    polifenol: "procyanidin",
    id_cancer: "560",
    cancer: "Acute Lymphoblastic Leukemia",
    quant: "1",
    pmids: "20404022",
  },
  {
    id: "9840",
    id_polifenol: "2284",
    polifenol: "rosmarinic acid",
    id_cancer: "560",
    cancer: "Acute Lymphoblastic Leukemia",
    quant: "2",
    pmids: "26476154,22593249",
  },
  {
    id: "9841",
    id_polifenol: "112",
    polifenol: "Hesperidin",
    id_cancer: "560",
    cancer: "Acute Lymphoblastic Leukemia",
    quant: "1",
    pmids: "26434864",
  },
  {
    id: "9842",
    id_polifenol: "69",
    polifenol: "Phenolsulfonphthalein",
    id_cancer: "560",
    cancer: "Acute Lymphoblastic Leukemia",
    quant: "1",
    pmids: "2632259",
  },
  {
    id: "9843",
    id_polifenol: "55",
    polifenol: "Sodium Salicylate",
    id_cancer: "560",
    cancer: "Acute Lymphoblastic Leukemia",
    quant: "1",
    pmids: "11960340",
  },
  {
    id: "9844",
    id_polifenol: "452",
    polifenol: "acteoside",
    id_cancer: "560",
    cancer: "Acute Lymphoblastic Leukemia",
    quant: "1",
    pmids: "22593249",
  },
  {
    id: "9845",
    id_polifenol: "6625",
    polifenol: "phenoxodiol",
    id_cancer: "560",
    cancer: "Acute Lymphoblastic Leukemia",
    quant: "1",
    pmids: "19535345",
  },
  {
    id: "9846",
    id_polifenol: "4516",
    polifenol: "diosmetin",
    id_cancer: "560",
    cancer: "Acute Lymphoblastic Leukemia",
    quant: "1",
    pmids: "17294687",
  },
  {
    id: "9847",
    id_polifenol: "4883",
    polifenol: "flavokawain B",
    id_cancer: "560",
    cancer: "Acute Lymphoblastic Leukemia",
    quant: "1",
    pmids: "25641429",
  },
  {
    id: "9848",
    id_polifenol: "7612",
    polifenol: "quercetin 3-O-glucuronide",
    id_cancer: "560",
    cancer: "Acute Lymphoblastic Leukemia",
    quant: "1",
    pmids: "17294687",
  },
  {
    id: "9849",
    id_polifenol: "6129",
    polifenol: "wogonoside",
    id_cancer: "560",
    cancer: "Acute Lymphoblastic Leukemia",
    quant: "1",
    pmids: "27941168",
  },
  {
    id: "9850",
    id_polifenol: "347",
    polifenol: "4-nitrophenyl",
    id_cancer: "560",
    cancer: "Acute Lymphoblastic Leukemia",
    quant: "1",
    pmids: "21542133",
  },
  {
    id: "9851",
    id_polifenol: "7199",
    polifenol: "luteolin-7-glucoside",
    id_cancer: "560",
    cancer: "Acute Lymphoblastic Leukemia",
    quant: "1",
    pmids: "17294687",
  },
  {
    id: "9852",
    id_polifenol: "4544",
    polifenol: "tiliroside",
    id_cancer: "560",
    cancer: "Acute Lymphoblastic Leukemia",
    quant: "1",
    pmids: "22593249",
  },
  {
    id: "9853",
    id_polifenol: "4263",
    polifenol: "amurensin G",
    id_cancer: "560",
    cancer: "Acute Lymphoblastic Leukemia",
    quant: "1",
    pmids: "26416354",
  },
  {
    id: "9854",
    id_polifenol: "6492",
    polifenol: "3(2H)-isoflavene",
    id_cancer: "560",
    cancer: "Acute Lymphoblastic Leukemia",
    quant: "1",
    pmids: "19535345",
  },
  {
    id: "9855",
    id_polifenol: "2026",
    polifenol: "phenylhydroquinone",
    id_cancer: "560",
    cancer: "Acute Lymphoblastic Leukemia",
    quant: "1",
    pmids: "20471090",
  },
  {
    id: "9856",
    id_polifenol: "2066",
    polifenol: "NSC 680410",
    id_cancer: "560",
    cancer: "Acute Lymphoblastic Leukemia",
    quant: "1",
    pmids: "12827297",
  },
  {
    id: "9857",
    id_polifenol: "4244",
    polifenol: "malabaricone A",
    id_cancer: "560",
    cancer: "Acute Lymphoblastic Leukemia",
    quant: "1",
    pmids: "26032963",
  },
  {
    id: "9858",
    id_polifenol: "7810",
    polifenol: "rotenolone",
    id_cancer: "560",
    cancer: "Acute Lymphoblastic Leukemia",
    quant: "1",
    pmids: "23895019",
  },
  {
    id: "9859",
    id_polifenol: "5791",
    polifenol: "metochalcone",
    id_cancer: "560",
    cancer: "Acute Lymphoblastic Leukemia",
    quant: "1",
    pmids: "23524161",
  },
  {
    id: "9860",
    id_polifenol: "7560",
    polifenol: "quercetin-3-O-neohesperidose",
    id_cancer: "560",
    cancer: "Acute Lymphoblastic Leukemia",
    quant: "1",
    pmids: "1625476",
  },
  {
    id: "9861",
    id_polifenol: "5145",
    polifenol: "artonin B",
    id_cancer: "560",
    cancer: "Acute Lymphoblastic Leukemia",
    quant: "1",
    pmids: "16923337",
  },
  {
    id: "9862",
    id_polifenol: "5481",
    polifenol: "cyanidin-3-glycoside",
    id_cancer: "560",
    cancer: "Acute Lymphoblastic Leukemia",
    quant: "1",
    pmids: "22412883",
  },
  {
    id: "9863",
    id_polifenol: "7492",
    polifenol:
      "kaempferol 3-O-(3'',6''-di-O-E-p-coumaroyl)-beta-D-glucopyranoside",
    id_cancer: "560",
    cancer: "Acute Lymphoblastic Leukemia",
    quant: "1",
    pmids: "22593249",
  },
  {
    id: "9864",
    id_polifenol: "1423",
    polifenol: "Cancell",
    id_cancer: "560",
    cancer: "Acute Lymphoblastic Leukemia",
    quant: "1",
    pmids: "22412883",
  },
  {
    id: "9865",
    id_polifenol: "5120",
    polifenol: "diosmetin-7-O-xylopyranosyl-1-6-glucopyranoside",
    id_cancer: "560",
    cancer: "Acute Lymphoblastic Leukemia",
    quant: "1",
    pmids: "17294687",
  },
  {
    id: "9866",
    id_polifenol: "1781",
    polifenol: "CA 432",
    id_cancer: "560",
    cancer: "Acute Lymphoblastic Leukemia",
    quant: "1",
    pmids: "22705646",
  },
  {
    id: "9867",
    id_polifenol: "1794",
    polifenol:
      "4-(3-hydroxy-4-methoxyphenyl)-3-(4-hydroxyphenyl)-1-(3,4,5-trimethoxyphenyl)azetidin-2-one",
    id_cancer: "560",
    cancer: "Acute Lymphoblastic Leukemia",
    quant: "1",
    pmids: "22705646",
  },
  {
    id: "9868",
    id_polifenol: "3481",
    polifenol: "N-(1'-naphthyl)-3,4,5-trimethoxybenzohydrazide",
    id_cancer: "560",
    cancer: "Acute Lymphoblastic Leukemia",
    quant: "1",
    pmids: "25951294",
  },
  {
    id: "9869",
    id_polifenol: "6154",
    polifenol: "4'-hydroxywogonin",
    id_cancer: "560",
    cancer: "Acute Lymphoblastic Leukemia",
    quant: "1",
    pmids: "29397820",
  },
  {
    id: "9870",
    id_polifenol: "5959",
    polifenol:
      "(2E)-3-(2-naphtyl)-1-(3'-methoxy-4'-hydroxy-phenyl)-2-propen-1-one",
    id_cancer: "560",
    cancer: "Acute Lymphoblastic Leukemia",
    quant: "1",
    pmids: "20796191",
  },
  {
    id: "9871",
    id_polifenol: "7441",
    polifenol: "kaempferol-3-O-(6'',4''-di-p-coumaroyl)mannopyranoside",
    id_cancer: "560",
    cancer: "Acute Lymphoblastic Leukemia",
    quant: "1",
    pmids: "22593249",
  },
  {
    id: "9872",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "11804",
    cancer: "Precancerous Conditions",
    quant: "12",
    pmids:
      "22735354,20547166,10563845,25796713,9111212,19087425,24124108,19914226,15831530,8910908,14510590,9863273",
  },
  {
    id: "9873",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "11804",
    cancer: "Precancerous Conditions",
    quant: "10",
    pmids:
      "27261574,15476851,15501252,18496811,15514944,22172229,15831530,14612489,9863273,9589436",
  },
  {
    id: "9874",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "11804",
    cancer: "Precancerous Conditions",
    quant: "14",
    pmids:
      "18061431,27261574,10624709,25796713,11138532,22715065,12712701,22279681,24511000,23923070,17250449,24172305,23859035,28094544",
  },
  {
    id: "9875",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "11804",
    cancer: "Precancerous Conditions",
    quant: "2",
    pmids: "16571666,21056072",
  },
  {
    id: "9876",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "11804",
    cancer: "Precancerous Conditions",
    quant: "1",
    pmids: "14510590",
  },
  {
    id: "9877",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "11804",
    cancer: "Precancerous Conditions",
    quant: "6",
    pmids: "10563845,24124108,19914226,16700823,15831530,8910908",
  },
  {
    id: "9878",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "11804",
    cancer: "Precancerous Conditions",
    quant: "8",
    pmids:
      "22320717,21538846,15476851,15579485,14612489,17250449,29290650,25674420",
  },
  {
    id: "9879",
    id_polifenol: "2167",
    polifenol: "phenolic acid",
    id_cancer: "11804",
    cancer: "Precancerous Conditions",
    quant: "3",
    pmids: "18061431,25796713,9863273",
  },
  {
    id: "9880",
    id_polifenol: "49",
    polifenol: "Aspirin",
    id_cancer: "11804",
    cancer: "Precancerous Conditions",
    quant: "6",
    pmids: "11911254,21076843,14612489,17612047,26726119,17535415",
  },
  {
    id: "9881",
    id_polifenol: "109",
    polifenol: "Catechin",
    id_cancer: "11804",
    cancer: "Precancerous Conditions",
    quant: "4",
    pmids: "22320717,21538846,25789501,25674420",
  },
  {
    id: "9882",
    id_polifenol: "125",
    polifenol: "Isoflavones",
    id_cancer: "11804",
    cancer: "Precancerous Conditions",
    quant: "1",
    pmids: "15476851",
  },
  {
    id: "9883",
    id_polifenol: "3089",
    polifenol: "1,1-diphenyl-2-picrylhydrazyl",
    id_cancer: "11804",
    cancer: "Precancerous Conditions",
    quant: "2",
    pmids: "10563845,10499128",
  },
  {
    id: "9884",
    id_polifenol: "114",
    polifenol: "Apigenin",
    id_cancer: "11804",
    cancer: "Precancerous Conditions",
    quant: "2",
    pmids: "15476851,10499128",
  },
  {
    id: "9885",
    id_polifenol: "113",
    polifenol: "Flavones",
    id_cancer: "11804",
    cancer: "Precancerous Conditions",
    quant: "2",
    pmids: "21554863,8910908",
  },
  {
    id: "9886",
    id_polifenol: "38",
    polifenol: "Gallic Acid",
    id_cancer: "11804",
    cancer: "Precancerous Conditions",
    quant: "1",
    pmids: "10499128",
  },
  {
    id: "9887",
    id_polifenol: "117",
    polifenol: "Luteolin",
    id_cancer: "11804",
    cancer: "Precancerous Conditions",
    quant: "1",
    pmids: "10499128",
  },
  {
    id: "9888",
    id_polifenol: "105",
    polifenol: "Anthocyanins",
    id_cancer: "11804",
    cancer: "Precancerous Conditions",
    quant: "2",
    pmids: "24667581,28553369",
  },
  {
    id: "9889",
    id_polifenol: "7235",
    polifenol: "silybin",
    id_cancer: "11804",
    cancer: "Precancerous Conditions",
    quant: "1",
    pmids: "22735354",
  },
  {
    id: "9890",
    id_polifenol: "129",
    polifenol: "Rotenone",
    id_cancer: "11804",
    cancer: "Precancerous Conditions",
    quant: "1",
    pmids: "10211940",
  },
  {
    id: "9891",
    id_polifenol: "7",
    polifenol: "Capsaicin",
    id_cancer: "11804",
    cancer: "Precancerous Conditions",
    quant: "1",
    pmids: "29155087",
  },
  {
    id: "9892",
    id_polifenol: "4522",
    polifenol: "chrysin",
    id_cancer: "11804",
    cancer: "Precancerous Conditions",
    quant: "3",
    pmids: "27403965,21554863,19914226",
  },
  {
    id: "9893",
    id_polifenol: "123",
    polifenol: "Rutin",
    id_cancer: "11804",
    cancer: "Precancerous Conditions",
    quant: "1",
    pmids: "15831530",
  },
  {
    id: "9894",
    id_polifenol: "6062",
    polifenol: "naringenin",
    id_cancer: "11804",
    cancer: "Precancerous Conditions",
    quant: "1",
    pmids: "29345053",
  },
  {
    id: "9895",
    id_polifenol: "111",
    polifenol: "Flavanones",
    id_cancer: "11804",
    cancer: "Precancerous Conditions",
    quant: "1",
    pmids: "8910908",
  },
  {
    id: "9896",
    id_polifenol: "6",
    polifenol: "Catechols",
    id_cancer: "11804",
    cancer: "Precancerous Conditions",
    quant: "1",
    pmids: "23890812",
  },
  {
    id: "9897",
    id_polifenol: "75",
    polifenol: "Butylated Hydroxyanisole",
    id_cancer: "11804",
    cancer: "Precancerous Conditions",
    quant: "2",
    pmids: "3136944,2591015",
  },
  {
    id: "9898",
    id_polifenol: "4559",
    polifenol: "theaflavin",
    id_cancer: "11804",
    cancer: "Precancerous Conditions",
    quant: "2",
    pmids: "11138532,17250449",
  },
  {
    id: "9899",
    id_polifenol: "5808",
    polifenol: "isoliquiritigenin",
    id_cancer: "11804",
    cancer: "Precancerous Conditions",
    quant: "1",
    pmids: "14510590",
  },
  {
    id: "9900",
    id_polifenol: "4708",
    polifenol: "xanthohumol",
    id_cancer: "11804",
    cancer: "Precancerous Conditions",
    quant: "1",
    pmids: "20547166",
  },
  {
    id: "9901",
    id_polifenol: "112",
    polifenol: "Hesperidin",
    id_cancer: "11804",
    cancer: "Precancerous Conditions",
    quant: "1",
    pmids: "9111212",
  },
  {
    id: "9902",
    id_polifenol: "6455",
    polifenol: "nobiletin",
    id_cancer: "11804",
    cancer: "Precancerous Conditions",
    quant: "1",
    pmids: "19914226",
  },
  {
    id: "9903",
    id_polifenol: "2158",
    polifenol: "protocatechuic acid",
    id_cancer: "11804",
    cancer: "Precancerous Conditions",
    quant: "1",
    pmids: "24667581",
  },
  {
    id: "9904",
    id_polifenol: "7550",
    polifenol: "3-methylquercetin",
    id_cancer: "11804",
    cancer: "Precancerous Conditions",
    quant: "1",
    pmids: "10563845",
  },
  {
    id: "9905",
    id_polifenol: "107",
    polifenol: "beta-Naphthoflavone",
    id_cancer: "11804",
    cancer: "Precancerous Conditions",
    quant: "1",
    pmids: "20045035",
  },
  {
    id: "9906",
    id_polifenol: "80",
    polifenol: "Clofibrate",
    id_cancer: "11804",
    cancer: "Precancerous Conditions",
    quant: "2",
    pmids: "21214675,1906850",
  },
  {
    id: "9907",
    id_polifenol: "7546",
    polifenol: "isoquercitrin",
    id_cancer: "11804",
    cancer: "Precancerous Conditions",
    quant: "2",
    pmids: "24680176,20045035",
  },
  {
    id: "9908",
    id_polifenol: "6482",
    polifenol: "tangeretin",
    id_cancer: "11804",
    cancer: "Precancerous Conditions",
    quant: "1",
    pmids: "8910908",
  },
  {
    id: "9909",
    id_polifenol: "6452",
    polifenol: "chrysoeriol",
    id_cancer: "11804",
    cancer: "Precancerous Conditions",
    quant: "1",
    pmids: "14510590",
  },
  {
    id: "9910",
    id_polifenol: "7377",
    polifenol: "astragalin",
    id_cancer: "11804",
    cancer: "Precancerous Conditions",
    quant: "1",
    pmids: "29298652",
  },
  {
    id: "9911",
    id_polifenol: "115",
    polifenol: "Diosmin",
    id_cancer: "11804",
    cancer: "Precancerous Conditions",
    quant: "1",
    pmids: "9111212",
  },
  {
    id: "9912",
    id_polifenol: "4578",
    polifenol: "5,7-dimethoxyflavone",
    id_cancer: "11804",
    cancer: "Precancerous Conditions",
    quant: "1",
    pmids: "10563845",
  },
  {
    id: "9913",
    id_polifenol: "6453",
    polifenol: "cirsimaritin",
    id_cancer: "11804",
    cancer: "Precancerous Conditions",
    quant: "1",
    pmids: "21554863",
  },
  {
    id: "9914",
    id_polifenol: "79",
    polifenol: "Clofibric Acid",
    id_cancer: "11804",
    cancer: "Precancerous Conditions",
    quant: "1",
    pmids: "21214675",
  },
  {
    id: "9915",
    id_polifenol: "4534",
    polifenol: "3,5,6-trihydroxy-4',7'-dimethoxyflavone",
    id_cancer: "11804",
    cancer: "Precancerous Conditions",
    quant: "1",
    pmids: "10499128",
  },
  {
    id: "9916",
    id_polifenol: "21",
    polifenol: "Bisacodyl",
    id_cancer: "11804",
    cancer: "Precancerous Conditions",
    quant: "1",
    pmids: "16716974",
  },
  {
    id: "9917",
    id_polifenol: "1638",
    polifenol: "1,7-bis(4-hydroxyphenyl)-1,6-heptadiene-3,5-dione",
    id_cancer: "11804",
    cancer: "Precancerous Conditions",
    quant: "1",
    pmids: "15501252",
  },
  {
    id: "9918",
    id_polifenol: "7825",
    polifenol: "alpha-toxicarol",
    id_cancer: "11804",
    cancer: "Precancerous Conditions",
    quant: "1",
    pmids: "14510590",
  },
  {
    id: "9919",
    id_polifenol: "2749",
    polifenol: "zinc 3,5-diisopropylsalicylate",
    id_cancer: "11804",
    cancer: "Precancerous Conditions",
    quant: "1",
    pmids: "3136944",
  },
  {
    id: "9920",
    id_polifenol: "1640",
    polifenol: "2,6-bis-4-(hydroxy-3-methoxybenzylidene)cyclohexanone",
    id_cancer: "11804",
    cancer: "Precancerous Conditions",
    quant: "1",
    pmids: "15501252",
  },
  {
    id: "9921",
    id_polifenol: "7342",
    polifenol: "irisdichotin A",
    id_cancer: "11804",
    cancer: "Precancerous Conditions",
    quant: "1",
    pmids: "10499128",
  },
  {
    id: "9922",
    id_polifenol: "1058",
    polifenol: "cycloolivil",
    id_cancer: "11804",
    cancer: "Precancerous Conditions",
    quant: "1",
    pmids: "10499128",
  },
  {
    id: "9923",
    id_polifenol: "7408",
    polifenol: "kaempferol 3-O-neohesperidoside",
    id_cancer: "11804",
    cancer: "Precancerous Conditions",
    quant: "1",
    pmids: "10499128",
  },
  {
    id: "9924",
    id_polifenol: "6553",
    polifenol: "munetone",
    id_cancer: "11804",
    cancer: "Precancerous Conditions",
    quant: "1",
    pmids: "10211940",
  },
  {
    id: "9925",
    id_polifenol: "1589",
    polifenol: "2,6-bis(3,5-dimethoxybenzylidene)cyclohexanone",
    id_cancer: "11804",
    cancer: "Precancerous Conditions",
    quant: "1",
    pmids: "15501252",
  },
  {
    id: "9926",
    id_polifenol: "3704",
    polifenol: "beta-diethylaminoethyl alpha-4-chlorophenoxyisobutyrate",
    id_cancer: "11804",
    cancer: "Precancerous Conditions",
    quant: "1",
    pmids: "85485",
  },
  {
    id: "9927",
    id_polifenol: "5019",
    polifenol: "(2S)-5-hydroxy-7-methoxy-8-((E)-3-oxo-1-butenyl)flavanone",
    id_cancer: "11804",
    cancer: "Precancerous Conditions",
    quant: "1",
    pmids: "14510590",
  },
  {
    id: "9928",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "230102",
    cancer: "Lewis Lung Carcinoma",
    quant: "10",
    pmids:
      "17031514,17178377,29048641,18184547,18440233,24959081,19373604,21840301,21121257,23380621",
  },
  {
    id: "9929",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "230102",
    cancer: "Lewis Lung Carcinoma",
    quant: "6",
    pmids: "22507634,27497194,11688958,27843316,20426658,22232696",
  },
  {
    id: "9930",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "230102",
    cancer: "Lewis Lung Carcinoma",
    quant: "5",
    pmids: "22144737,16573384,10624708,22613332,29959821",
  },
  {
    id: "9931",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "230102",
    cancer: "Lewis Lung Carcinoma",
    quant: "2",
    pmids: "14993222,12592384",
  },
  {
    id: "9932",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "230102",
    cancer: "Lewis Lung Carcinoma",
    quant: "2",
    pmids: "12898416,9195288",
  },
  {
    id: "9933",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "230102",
    cancer: "Lewis Lung Carcinoma",
    quant: "1",
    pmids: "19373604",
  },
  {
    id: "9934",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "230102",
    cancer: "Lewis Lung Carcinoma",
    quant: "3",
    pmids: "22144737,9339552,10232066",
  },
  {
    id: "9935",
    id_polifenol: "2167",
    polifenol: "phenolic acid",
    id_cancer: "230102",
    cancer: "Lewis Lung Carcinoma",
    quant: "1",
    pmids: "21121257",
  },
  {
    id: "9936",
    id_polifenol: "49",
    polifenol: "Aspirin",
    id_cancer: "230102",
    cancer: "Lewis Lung Carcinoma",
    quant: "5",
    pmids: "14563940,8269984,19799610,15639720,24331369",
  },
  {
    id: "9937",
    id_polifenol: "109",
    polifenol: "Catechin",
    id_cancer: "230102",
    cancer: "Lewis Lung Carcinoma",
    quant: "2",
    pmids: "22144737,9339552",
  },
  {
    id: "9938",
    id_polifenol: "125",
    polifenol: "Isoflavones",
    id_cancer: "230102",
    cancer: "Lewis Lung Carcinoma",
    quant: "1",
    pmids: "18440233",
  },
  {
    id: "9939",
    id_polifenol: "110",
    polifenol: "Chalcones",
    id_cancer: "230102",
    cancer: "Lewis Lung Carcinoma",
    quant: "4",
    pmids: "25996501,12620662,18440233,15114497",
  },
  {
    id: "9940",
    id_polifenol: "3089",
    polifenol: "1,1-diphenyl-2-picrylhydrazyl",
    id_cancer: "230102",
    cancer: "Lewis Lung Carcinoma",
    quant: "1",
    pmids: "22210035",
  },
  {
    id: "9941",
    id_polifenol: "114",
    polifenol: "Apigenin",
    id_cancer: "230102",
    cancer: "Lewis Lung Carcinoma",
    quant: "1",
    pmids: "19373604",
  },
  {
    id: "9942",
    id_polifenol: "113",
    polifenol: "Flavones",
    id_cancer: "230102",
    cancer: "Lewis Lung Carcinoma",
    quant: "3",
    pmids: "25854402,17363487,21121257",
  },
  {
    id: "9943",
    id_polifenol: "38",
    polifenol: "Gallic Acid",
    id_cancer: "230102",
    cancer: "Lewis Lung Carcinoma",
    quant: "2",
    pmids: "22144737,27575479",
  },
  {
    id: "9944",
    id_polifenol: "117",
    polifenol: "Luteolin",
    id_cancer: "230102",
    cancer: "Lewis Lung Carcinoma",
    quant: "4",
    pmids: "17384257,17410645,26766793,19373604",
  },
  {
    id: "9945",
    id_polifenol: "1",
    polifenol: "Phenols",
    id_cancer: "230102",
    cancer: "Lewis Lung Carcinoma",
    quant: "1",
    pmids: "2548717",
  },
  {
    id: "9946",
    id_polifenol: "105",
    polifenol: "Anthocyanins",
    id_cancer: "230102",
    cancer: "Lewis Lung Carcinoma",
    quant: "2",
    pmids: "16573384,20432172",
  },
  {
    id: "9947",
    id_polifenol: "7235",
    polifenol: "silybin",
    id_cancer: "230102",
    cancer: "Lewis Lung Carcinoma",
    quant: "1",
    pmids: "16498067",
  },
  {
    id: "9948",
    id_polifenol: "129",
    polifenol: "Rotenone",
    id_cancer: "230102",
    cancer: "Lewis Lung Carcinoma",
    quant: "1",
    pmids: "12898416",
  },
  {
    id: "9949",
    id_polifenol: "121",
    polifenol: "Kaempferols",
    id_cancer: "230102",
    cancer: "Lewis Lung Carcinoma",
    quant: "1",
    pmids: "19373604",
  },
  {
    id: "9950",
    id_polifenol: "6065",
    polifenol: "baicalein",
    id_cancer: "230102",
    cancer: "Lewis Lung Carcinoma",
    quant: "2",
    pmids: "29048641,19373604",
  },
  {
    id: "9951",
    id_polifenol: "120",
    polifenol: "Flavonols",
    id_cancer: "230102",
    cancer: "Lewis Lung Carcinoma",
    quant: "2",
    pmids: "22210035,18440233",
  },
  {
    id: "9952",
    id_polifenol: "123",
    polifenol: "Rutin",
    id_cancer: "230102",
    cancer: "Lewis Lung Carcinoma",
    quant: "1",
    pmids: "22144737",
  },
  {
    id: "9953",
    id_polifenol: "6062",
    polifenol: "naringenin",
    id_cancer: "230102",
    cancer: "Lewis Lung Carcinoma",
    quant: "2",
    pmids: "17031514,17376416",
  },
  {
    id: "9954",
    id_polifenol: "111",
    polifenol: "Flavanones",
    id_cancer: "230102",
    cancer: "Lewis Lung Carcinoma",
    quant: "4",
    pmids: "17031514,17376416,19952433,21121257",
  },
  {
    id: "9955",
    id_polifenol: "4502",
    polifenol: "fisetin",
    id_cancer: "230102",
    cancer: "Lewis Lung Carcinoma",
    quant: "3",
    pmids: "19373604,21840301,23380621",
  },
  {
    id: "9956",
    id_polifenol: "25",
    polifenol: "Butylated Hydroxytoluene",
    id_cancer: "230102",
    cancer: "Lewis Lung Carcinoma",
    quant: "1",
    pmids: "27250582",
  },
  {
    id: "9957",
    id_polifenol: "15",
    polifenol: "Masoprocol",
    id_cancer: "230102",
    cancer: "Lewis Lung Carcinoma",
    quant: "1",
    pmids: "8269984",
  },
  {
    id: "9958",
    id_polifenol: "5608",
    polifenol: "epicatechin gallate",
    id_cancer: "230102",
    cancer: "Lewis Lung Carcinoma",
    quant: "1",
    pmids: "22144737",
  },
  {
    id: "9959",
    id_polifenol: "4559",
    polifenol: "theaflavin",
    id_cancer: "230102",
    cancer: "Lewis Lung Carcinoma",
    quant: "1",
    pmids: "9339552",
  },
  {
    id: "9960",
    id_polifenol: "2344",
    polifenol: "methyl gallate",
    id_cancer: "230102",
    cancer: "Lewis Lung Carcinoma",
    quant: "1",
    pmids: "22144737",
  },
  {
    id: "9961",
    id_polifenol: "6455",
    polifenol: "nobiletin",
    id_cancer: "230102",
    cancer: "Lewis Lung Carcinoma",
    quant: "1",
    pmids: "19627003",
  },
  {
    id: "9962",
    id_polifenol: "4513",
    polifenol: "galangin",
    id_cancer: "230102",
    cancer: "Lewis Lung Carcinoma",
    quant: "1",
    pmids: "19373604",
  },
  {
    id: "9963",
    id_polifenol: "6063",
    polifenol: "naringin",
    id_cancer: "230102",
    cancer: "Lewis Lung Carcinoma",
    quant: "3",
    pmids: "17031514,22144737,17376416",
  },
  {
    id: "9964",
    id_polifenol: "2158",
    polifenol: "protocatechuic acid",
    id_cancer: "230102",
    cancer: "Lewis Lung Carcinoma",
    quant: "1",
    pmids: "27575479",
  },
  {
    id: "9965",
    id_polifenol: "93",
    polifenol: "Phloroglucinol",
    id_cancer: "230102",
    cancer: "Lewis Lung Carcinoma",
    quant: "1",
    pmids: "22496756",
  },
  {
    id: "9966",
    id_polifenol: "7550",
    polifenol: "3-methylquercetin",
    id_cancer: "230102",
    cancer: "Lewis Lung Carcinoma",
    quant: "1",
    pmids: "25854402",
  },
  {
    id: "9967",
    id_polifenol: "6461",
    polifenol: "acacetin",
    id_cancer: "230102",
    cancer: "Lewis Lung Carcinoma",
    quant: "1",
    pmids: "19373604",
  },
  {
    id: "9968",
    id_polifenol: "5509",
    polifenol: "cyanidin 3-O-glucoside",
    id_cancer: "230102",
    cancer: "Lewis Lung Carcinoma",
    quant: "1",
    pmids: "16573384",
  },
  {
    id: "9969",
    id_polifenol: "969",
    polifenol: "3,4-dihydroxyphenacyl caffeate phenylpropanoid ester",
    id_cancer: "230102",
    cancer: "Lewis Lung Carcinoma",
    quant: "1",
    pmids: "27493875",
  },
  {
    id: "9970",
    id_polifenol: "4537",
    polifenol: "flavone acetic acid",
    id_cancer: "230102",
    cancer: "Lewis Lung Carcinoma",
    quant: "1",
    pmids: "3351960",
  },
  {
    id: "9971",
    id_polifenol: "5850",
    polifenol: "cardamonin",
    id_cancer: "230102",
    cancer: "Lewis Lung Carcinoma",
    quant: "1",
    pmids: "25996501",
  },
  {
    id: "9972",
    id_polifenol: "60",
    polifenol: "2,4-Dinitrophenol",
    id_cancer: "230102",
    cancer: "Lewis Lung Carcinoma",
    quant: "1",
    pmids: "8260750",
  },
  {
    id: "9973",
    id_polifenol: "300",
    polifenol: "rhodioloside",
    id_cancer: "230102",
    cancer: "Lewis Lung Carcinoma",
    quant: "1",
    pmids: "27493875",
  },
  {
    id: "9974",
    id_polifenol: "2447",
    polifenol: "beta-penta-O-galloyl-glucose",
    id_cancer: "230102",
    cancer: "Lewis Lung Carcinoma",
    quant: "1",
    pmids: "15845650",
  },
  {
    id: "9975",
    id_polifenol: "128",
    polifenol: "Pterocarpans",
    id_cancer: "230102",
    cancer: "Lewis Lung Carcinoma",
    quant: "1",
    pmids: "18440233",
  },
  {
    id: "9976",
    id_polifenol: "7557",
    polifenol: "rhamnetin",
    id_cancer: "230102",
    cancer: "Lewis Lung Carcinoma",
    quant: "1",
    pmids: "19373604",
  },
  {
    id: "9977",
    id_polifenol: "4304",
    polifenol: "5-7-oxo-zeaenol",
    id_cancer: "230102",
    cancer: "Lewis Lung Carcinoma",
    quant: "1",
    pmids: "26931406",
  },
  {
    id: "9978",
    id_polifenol: "7775",
    polifenol: "glyceollin",
    id_cancer: "230102",
    cancer: "Lewis Lung Carcinoma",
    quant: "1",
    pmids: "23229497",
  },
  {
    id: "9979",
    id_polifenol: "4521",
    polifenol: "3-hydroxyflavone",
    id_cancer: "230102",
    cancer: "Lewis Lung Carcinoma",
    quant: "1",
    pmids: "19373604",
  },
  {
    id: "9980",
    id_polifenol: "6175",
    polifenol: "2'-hydroxyflavanone",
    id_cancer: "230102",
    cancer: "Lewis Lung Carcinoma",
    quant: "2",
    pmids: "17031514,17376416",
  },
  {
    id: "9981",
    id_polifenol: "315",
    polifenol: "bakuchiol",
    id_cancer: "230102",
    cancer: "Lewis Lung Carcinoma",
    quant: "1",
    pmids: "23302649",
  },
  {
    id: "9982",
    id_polifenol: "4782",
    polifenol: "kurarinone",
    id_cancer: "230102",
    cancer: "Lewis Lung Carcinoma",
    quant: "1",
    pmids: "18184547",
  },
  {
    id: "9983",
    id_polifenol: "6497",
    polifenol: "isoflavanone",
    id_cancer: "230102",
    cancer: "Lewis Lung Carcinoma",
    quant: "1",
    pmids: "18440233",
  },
  {
    id: "9984",
    id_polifenol: "7880",
    polifenol: "xanthoangelol",
    id_cancer: "230102",
    cancer: "Lewis Lung Carcinoma",
    quant: "1",
    pmids: "15114497",
  },
  {
    id: "9985",
    id_polifenol: "5615",
    polifenol: "gallocatechin gallate",
    id_cancer: "230102",
    cancer: "Lewis Lung Carcinoma",
    quant: "1",
    pmids: "22144737",
  },
  {
    id: "9986",
    id_polifenol: "6549",
    polifenol: "7-hydroxy-2',3',4',5',8-pentamethoxyisoflavan",
    id_cancer: "230102",
    cancer: "Lewis Lung Carcinoma",
    quant: "1",
    pmids: "18440233",
  },
  {
    id: "9987",
    id_polifenol: "5539",
    polifenol: "peonidin 3-glucoside",
    id_cancer: "230102",
    cancer: "Lewis Lung Carcinoma",
    quant: "2",
    pmids: "16573384,20432172",
  },
  {
    id: "9988",
    id_polifenol: "6555",
    polifenol: "tectoridin",
    id_cancer: "230102",
    cancer: "Lewis Lung Carcinoma",
    quant: "1",
    pmids: "12898416",
  },
  {
    id: "9989",
    id_polifenol: "2358",
    polifenol: "theaflavin digallate",
    id_cancer: "230102",
    cancer: "Lewis Lung Carcinoma",
    quant: "1",
    pmids: "9339552",
  },
  {
    id: "9990",
    id_polifenol: "7879",
    polifenol: "4-hydroxyderricin",
    id_cancer: "230102",
    cancer: "Lewis Lung Carcinoma",
    quant: "1",
    pmids: "15114497",
  },
  {
    id: "9991",
    id_polifenol: "5833",
    polifenol: "2',5'-dihydroxychalcone",
    id_cancer: "230102",
    cancer: "Lewis Lung Carcinoma",
    quant: "1",
    pmids: "12620662",
  },
  {
    id: "9992",
    id_polifenol: "4919",
    polifenol: "bavachinin",
    id_cancer: "230102",
    cancer: "Lewis Lung Carcinoma",
    quant: "1",
    pmids: "23302649",
  },
  {
    id: "9993",
    id_polifenol: "7014",
    polifenol: "3,4',7-trihydroxy-3'-methoxyflavone",
    id_cancer: "230102",
    cancer: "Lewis Lung Carcinoma",
    quant: "1",
    pmids: "21840301",
  },
  {
    id: "9994",
    id_polifenol: "521",
    polifenol: "E 7010",
    id_cancer: "230102",
    cancer: "Lewis Lung Carcinoma",
    quant: "1",
    pmids: "8137285",
  },
  {
    id: "9995",
    id_polifenol: "5801",
    polifenol: "2'-hydroxy-4-methoxychalcone",
    id_cancer: "230102",
    cancer: "Lewis Lung Carcinoma",
    quant: "1",
    pmids: "16651739",
  },
  {
    id: "9996",
    id_polifenol: "1541",
    polifenol: "3-hydroxybakuchiol",
    id_cancer: "230102",
    cancer: "Lewis Lung Carcinoma",
    quant: "1",
    pmids: "23302649",
  },
  {
    id: "9997",
    id_polifenol: "2365",
    polifenol: "hamamelitannin",
    id_cancer: "230102",
    cancer: "Lewis Lung Carcinoma",
    quant: "1",
    pmids: "10232066",
  },
  {
    id: "9998",
    id_polifenol: "4508",
    polifenol: "3',4'-dihydroxyflavone",
    id_cancer: "230102",
    cancer: "Lewis Lung Carcinoma",
    quant: "1",
    pmids: "19373604",
  },
  {
    id: "9999",
    id_polifenol: "4848",
    polifenol: "4'-hydroxy-7-methoxyflavan",
    id_cancer: "230102",
    cancer: "Lewis Lung Carcinoma",
    quant: "1",
    pmids: "11558618",
  },
  {
    id: "10000",
    id_polifenol: "4746",
    polifenol: "sophoflavescenol",
    id_cancer: "230102",
    cancer: "Lewis Lung Carcinoma",
    quant: "1",
    pmids: "22210035",
  },
  {
    id: "10001",
    id_polifenol: "509",
    polifenol: "cassigarol A",
    id_cancer: "230102",
    cancer: "Lewis Lung Carcinoma",
    quant: "1",
    pmids: "11062699",
  },
  {
    id: "10002",
    id_polifenol: "6196",
    polifenol: "7-hydroxy-6-methoxyflavanone",
    id_cancer: "230102",
    cancer: "Lewis Lung Carcinoma",
    quant: "1",
    pmids: "18440233",
  },
  {
    id: "10003",
    id_polifenol: "6121",
    polifenol:
      "2-5'-(-1''',1'''-dimethylallyl)-8-(3'',3''-dimethylallyl)-2'-methoxy-4',5,7-tetrahydroxyflavanone",
    id_cancer: "230102",
    cancer: "Lewis Lung Carcinoma",
    quant: "1",
    pmids: "23302649",
  },
  {
    id: "10004",
    id_polifenol: "6226",
    polifenol: "5,7,2'-trihydroxy-8,3'-diprenylflavanone",
    id_cancer: "230102",
    cancer: "Lewis Lung Carcinoma",
    quant: "1",
    pmids: "19952433",
  },
  {
    id: "10005",
    id_polifenol: "2347",
    polifenol: "1,2,3,6-tetragalloylglucose",
    id_cancer: "230102",
    cancer: "Lewis Lung Carcinoma",
    quant: "1",
    pmids: "10232066",
  },
  {
    id: "10006",
    id_polifenol: "2667",
    polifenol: "glycol salicylate",
    id_cancer: "230102",
    cancer: "Lewis Lung Carcinoma",
    quant: "1",
    pmids: "26937173",
  },
  {
    id: "10007",
    id_polifenol: "3121",
    polifenol: "ethyl O-(N-(4-carboxyphenyl)carbamoyl)mycophenolate",
    id_cancer: "230102",
    cancer: "Lewis Lung Carcinoma",
    quant: "1",
    pmids: "7274650",
  },
  {
    id: "10008",
    id_polifenol: "5458",
    polifenol: "(2R,4R)-2',4'-dihydroxy-5,7-dimethoxyflavan-4-ol",
    id_cancer: "230102",
    cancer: "Lewis Lung Carcinoma",
    quant: "1",
    pmids: "21121257",
  },
  {
    id: "10009",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "3232",
    cancer: "Ductal Carcinoma",
    quant: "3",
    pmids: "19371773,9492340,18835421",
  },
  {
    id: "10010",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "3232",
    cancer: "Ductal Carcinoma",
    quant: "2",
    pmids: "24607787,27535497",
  },
  {
    id: "10011",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "3232",
    cancer: "Ductal Carcinoma",
    quant: "9",
    pmids:
      "11149601,9652748,11911959,12839332,12479366,22576740,9545345,25961241,20947540",
  },
  {
    id: "10012",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "3232",
    cancer: "Ductal Carcinoma",
    quant: "9",
    pmids:
      "11506505,9679118,18026817,8784471,12079141,9492340,10523716,17369015,23019147",
  },
  {
    id: "10013",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "3232",
    cancer: "Ductal Carcinoma",
    quant: "2",
    pmids: "16720324,29787277",
  },
  {
    id: "10014",
    id_polifenol: "2167",
    polifenol: "phenolic acid",
    id_cancer: "3232",
    cancer: "Ductal Carcinoma",
    quant: "1",
    pmids: "15787436",
  },
  {
    id: "10015",
    id_polifenol: "49",
    polifenol: "Aspirin",
    id_cancer: "3232",
    cancer: "Ductal Carcinoma",
    quant: "2",
    pmids: "10652584,11180079",
  },
  {
    id: "10016",
    id_polifenol: "125",
    polifenol: "Isoflavones",
    id_cancer: "3232",
    cancer: "Ductal Carcinoma",
    quant: "4",
    pmids: "24355881,9492340,12199376,15958052",
  },
  {
    id: "10017",
    id_polifenol: "110",
    polifenol: "Chalcones",
    id_cancer: "3232",
    cancer: "Ductal Carcinoma",
    quant: "2",
    pmids: "15986430,24211632",
  },
  {
    id: "10018",
    id_polifenol: "114",
    polifenol: "Apigenin",
    id_cancer: "3232",
    cancer: "Ductal Carcinoma",
    quant: "2",
    pmids: "9492340,20551847",
  },
  {
    id: "10019",
    id_polifenol: "113",
    polifenol: "Flavones",
    id_cancer: "3232",
    cancer: "Ductal Carcinoma",
    quant: "2",
    pmids: "9492340,20551847",
  },
  {
    id: "10020",
    id_polifenol: "1",
    polifenol: "Phenols",
    id_cancer: "3232",
    cancer: "Ductal Carcinoma",
    quant: "4",
    pmids: "25410727,8603401,2441761,3593365",
  },
  {
    id: "10021",
    id_polifenol: "7235",
    polifenol: "silybin",
    id_cancer: "3232",
    cancer: "Ductal Carcinoma",
    quant: "2",
    pmids: "22820499,27644625",
  },
  {
    id: "10022",
    id_polifenol: "129",
    polifenol: "Rotenone",
    id_cancer: "3232",
    cancer: "Ductal Carcinoma",
    quant: "1",
    pmids: "9492340",
  },
  {
    id: "10023",
    id_polifenol: "121",
    polifenol: "Kaempferols",
    id_cancer: "3232",
    cancer: "Ductal Carcinoma",
    quant: "1",
    pmids: "20846786",
  },
  {
    id: "10024",
    id_polifenol: "6451",
    polifenol: "daidzein",
    id_cancer: "3232",
    cancer: "Ductal Carcinoma",
    quant: "3",
    pmids: "17719612,12199376,10523716",
  },
  {
    id: "10025",
    id_polifenol: "4634",
    polifenol: "alvocidib",
    id_cancer: "3232",
    cancer: "Ductal Carcinoma",
    quant: "2",
    pmids: "12479366,15756030",
  },
  {
    id: "10026",
    id_polifenol: "120",
    polifenol: "Flavonols",
    id_cancer: "3232",
    cancer: "Ductal Carcinoma",
    quant: "1",
    pmids: "9492340",
  },
  {
    id: "10027",
    id_polifenol: "4522",
    polifenol: "chrysin",
    id_cancer: "3232",
    cancer: "Ductal Carcinoma",
    quant: "1",
    pmids: "25987033",
  },
  {
    id: "10028",
    id_polifenol: "285",
    polifenol: "bisphenol A",
    id_cancer: "3232",
    cancer: "Ductal Carcinoma",
    quant: "3",
    pmids: "12628303,17369015,23019147",
  },
  {
    id: "10029",
    id_polifenol: "111",
    polifenol: "Flavanones",
    id_cancer: "3232",
    cancer: "Ductal Carcinoma",
    quant: "2",
    pmids: "25216378,9492340",
  },
  {
    id: "10030",
    id_polifenol: "4502",
    polifenol: "fisetin",
    id_cancer: "3232",
    cancer: "Ductal Carcinoma",
    quant: "1",
    pmids: "18835421",
  },
  {
    id: "10031",
    id_polifenol: "4515",
    polifenol: "baicalin",
    id_cancer: "3232",
    cancer: "Ductal Carcinoma",
    quant: "1",
    pmids: "15586243",
  },
  {
    id: "10032",
    id_polifenol: "44",
    polifenol: "Salicylates",
    id_cancer: "3232",
    cancer: "Ductal Carcinoma",
    quant: "1",
    pmids: "10652584",
  },
  {
    id: "10033",
    id_polifenol: "4708",
    polifenol: "xanthohumol",
    id_cancer: "3232",
    cancer: "Ductal Carcinoma",
    quant: "1",
    pmids: "15986430",
  },
  {
    id: "10034",
    id_polifenol: "6273",
    polifenol: "hesperetin",
    id_cancer: "3232",
    cancer: "Ductal Carcinoma",
    quant: "1",
    pmids: "17719612",
  },
  {
    id: "10035",
    id_polifenol: "6454",
    polifenol: "formononetin",
    id_cancer: "3232",
    cancer: "Ductal Carcinoma",
    quant: "1",
    pmids: "24355881",
  },
  {
    id: "10036",
    id_polifenol: "69",
    polifenol: "Phenolsulfonphthalein",
    id_cancer: "3232",
    cancer: "Ductal Carcinoma",
    quant: "3",
    pmids: "8049131,24652746,3593365",
  },
  {
    id: "10037",
    id_polifenol: "126",
    polifenol: "Coumestrol",
    id_cancer: "3232",
    cancer: "Ductal Carcinoma",
    quant: "3",
    pmids: "9679118,9492340,10523716",
  },
  {
    id: "10038",
    id_polifenol: "108",
    polifenol: "Biflavonoids",
    id_cancer: "3232",
    cancer: "Ductal Carcinoma",
    quant: "1",
    pmids: "29085516",
  },
  {
    id: "10039",
    id_polifenol: "60",
    polifenol: "2,4-Dinitrophenol",
    id_cancer: "3232",
    cancer: "Ductal Carcinoma",
    quant: "1",
    pmids: "6246118",
  },
  {
    id: "10040",
    id_polifenol: "7912",
    polifenol: "7,9,2',4'-tetrahydroxy-8-isopentenyl-5-methoxychalcone",
    id_cancer: "3232",
    cancer: "Ductal Carcinoma",
    quant: "1",
    pmids: "15986430",
  },
  {
    id: "10041",
    id_polifenol: "350",
    polifenol: "nonylphenol",
    id_cancer: "3232",
    cancer: "Ductal Carcinoma",
    quant: "2",
    pmids: "17369015,15958052",
  },
  {
    id: "10042",
    id_polifenol: "4516",
    polifenol: "diosmetin",
    id_cancer: "3232",
    cancer: "Ductal Carcinoma",
    quant: "1",
    pmids: "18835421",
  },
  {
    id: "10043",
    id_polifenol: "102",
    polifenol: "Zearalenone",
    id_cancer: "3232",
    cancer: "Ductal Carcinoma",
    quant: "1",
    pmids: "9679118",
  },
  {
    id: "10044",
    id_polifenol: "7161",
    polifenol: "scutellarin",
    id_cancer: "3232",
    cancer: "Ductal Carcinoma",
    quant: "1",
    pmids: "15586243",
  },
  {
    id: "10045",
    id_polifenol: "36",
    polifenol: "Hydroxybenzoates",
    id_cancer: "3232",
    cancer: "Ductal Carcinoma",
    quant: "1",
    pmids: "24652746",
  },
  {
    id: "10046",
    id_polifenol: "6558",
    polifenol: "7,3'-dihydroxy-4'-methoxyisoflavone",
    id_cancer: "3232",
    cancer: "Ductal Carcinoma",
    quant: "2",
    pmids: "24618835,24355881",
  },
  {
    id: "10047",
    id_polifenol: "43",
    polifenol: "Parabens",
    id_cancer: "3232",
    cancer: "Ductal Carcinoma",
    quant: "1",
    pmids: "24652746",
  },
  {
    id: "10048",
    id_polifenol: "6452",
    polifenol: "chrysoeriol",
    id_cancer: "3232",
    cancer: "Ductal Carcinoma",
    quant: "1",
    pmids: "18835421",
  },
  {
    id: "10049",
    id_polifenol: "6554",
    polifenol: "tectorigenin",
    id_cancer: "3232",
    cancer: "Ductal Carcinoma",
    quant: "1",
    pmids: "15787436",
  },
  {
    id: "10050",
    id_polifenol: "7156",
    polifenol: "scutellarein",
    id_cancer: "3232",
    cancer: "Ductal Carcinoma",
    quant: "1",
    pmids: "18835421",
  },
  {
    id: "10051",
    id_polifenol: "885",
    polifenol: "oleocanthal",
    id_cancer: "3232",
    cancer: "Ductal Carcinoma",
    quant: "1",
    pmids: "28625568",
  },
  {
    id: "10052",
    id_polifenol: "6112",
    polifenol: "alpinetin",
    id_cancer: "3232",
    cancer: "Ductal Carcinoma",
    quant: "1",
    pmids: "17719612",
  },
  {
    id: "10053",
    id_polifenol: "2697",
    polifenol: "4-trifluoromethylsalicylic acid",
    id_cancer: "3232",
    cancer: "Ductal Carcinoma",
    quant: "1",
    pmids: "16254462",
  },
  {
    id: "10054",
    id_polifenol: "315",
    polifenol: "bakuchiol",
    id_cancer: "3232",
    cancer: "Ductal Carcinoma",
    quant: "1",
    pmids: "21355211",
  },
  {
    id: "10055",
    id_polifenol: "11",
    polifenol: "Hydroxyestrones",
    id_cancer: "3232",
    cancer: "Ductal Carcinoma",
    quant: "1",
    pmids: "12094629",
  },
  {
    id: "10056",
    id_polifenol: "1678",
    polifenol: "2-methoxyestrone",
    id_cancer: "3232",
    cancer: "Ductal Carcinoma",
    quant: "1",
    pmids: "15994956",
  },
  {
    id: "10057",
    id_polifenol: "2573",
    polifenol: "butylparaben",
    id_cancer: "3232",
    cancer: "Ductal Carcinoma",
    quant: "1",
    pmids: "24652746",
  },
  {
    id: "10058",
    id_polifenol: "4632",
    polifenol: "ginkgetin",
    id_cancer: "3232",
    cancer: "Ductal Carcinoma",
    quant: "1",
    pmids: "29085516",
  },
  {
    id: "10059",
    id_polifenol: "2571",
    polifenol: "methylparaben",
    id_cancer: "3232",
    cancer: "Ductal Carcinoma",
    quant: "1",
    pmids: "24652746",
  },
  {
    id: "10060",
    id_polifenol: "6459",
    polifenol: "genkwanin",
    id_cancer: "3232",
    cancer: "Ductal Carcinoma",
    quant: "1",
    pmids: "18835421",
  },
  {
    id: "10061",
    id_polifenol: "2565",
    polifenol: "propylparaben",
    id_cancer: "3232",
    cancer: "Ductal Carcinoma",
    quant: "1",
    pmids: "24652746",
  },
  {
    id: "10062",
    id_polifenol: "1688",
    polifenol: "4-hydroxyestrone",
    id_cancer: "3232",
    cancer: "Ductal Carcinoma",
    quant: "1",
    pmids: "12094629",
  },
  {
    id: "10063",
    id_polifenol: "6555",
    polifenol: "tectoridin",
    id_cancer: "3232",
    cancer: "Ductal Carcinoma",
    quant: "1",
    pmids: "15787436",
  },
  {
    id: "10064",
    id_polifenol: "6717",
    polifenol: "irigenin",
    id_cancer: "3232",
    cancer: "Ductal Carcinoma",
    quant: "1",
    pmids: "15787436",
  },
  {
    id: "10065",
    id_polifenol: "4584",
    polifenol: "baohuosu",
    id_cancer: "3232",
    cancer: "Ductal Carcinoma",
    quant: "1",
    pmids: "19371773",
  },
  {
    id: "10066",
    id_polifenol: "7047",
    polifenol: "irisflorentin",
    id_cancer: "3232",
    cancer: "Ductal Carcinoma",
    quant: "1",
    pmids: "15787436",
  },
  {
    id: "10067",
    id_polifenol: "874",
    polifenol: "WAY 200070",
    id_cancer: "3232",
    cancer: "Ductal Carcinoma",
    quant: "1",
    pmids: "23907354",
  },
  {
    id: "10068",
    id_polifenol: "4803",
    polifenol: "iriflophenone 2-O-glucopyranoside",
    id_cancer: "3232",
    cancer: "Ductal Carcinoma",
    quant: "1",
    pmids: "15787436",
  },
  {
    id: "10069",
    id_polifenol: "4653",
    polifenol: "4',7-dihydroxyflavone",
    id_cancer: "3232",
    cancer: "Ductal Carcinoma",
    quant: "1",
    pmids: "18835421",
  },
  {
    id: "10070",
    id_polifenol: "6912",
    polifenol: "8-prenylapigenin",
    id_cancer: "3232",
    cancer: "Ductal Carcinoma",
    quant: "1",
    pmids: "19371773",
  },
  {
    id: "10071",
    id_polifenol: "6899",
    polifenol: "isocannflavin B",
    id_cancer: "3232",
    cancer: "Ductal Carcinoma",
    quant: "1",
    pmids: "19371773",
  },
  {
    id: "10072",
    id_polifenol: "7325",
    polifenol: "3-hydroxy-kenusanone B",
    id_cancer: "3232",
    cancer: "Ductal Carcinoma",
    quant: "1",
    pmids: "17719612",
  },
  {
    id: "10073",
    id_polifenol: "6513",
    polifenol: "sophorol",
    id_cancer: "3232",
    cancer: "Ductal Carcinoma",
    quant: "1",
    pmids: "17719612",
  },
  {
    id: "10074",
    id_polifenol: "5195",
    polifenol: "3'-O-methylorobol",
    id_cancer: "3232",
    cancer: "Ductal Carcinoma",
    quant: "1",
    pmids: "17719612",
  },
  {
    id: "10075",
    id_polifenol: "7281",
    polifenol: "hovenitin I",
    id_cancer: "3232",
    cancer: "Ductal Carcinoma",
    quant: "1",
    pmids: "17719612",
  },
  {
    id: "10076",
    id_polifenol: "3737",
    polifenol: "4-anisic acid",
    id_cancer: "3232",
    cancer: "Ductal Carcinoma",
    quant: "1",
    pmids: "17719612",
  },
  {
    id: "10077",
    id_polifenol: "864",
    polifenol: "belalloside A",
    id_cancer: "3232",
    cancer: "Ductal Carcinoma",
    quant: "1",
    pmids: "15787436",
  },
  {
    id: "10078",
    id_polifenol: "865",
    polifenol: "belalloside B",
    id_cancer: "3232",
    cancer: "Ductal Carcinoma",
    quant: "1",
    pmids: "15787436",
  },
  {
    id: "10079",
    id_polifenol: "866",
    polifenol: "belamphenone",
    id_cancer: "3232",
    cancer: "Ductal Carcinoma",
    quant: "1",
    pmids: "15787436",
  },
  {
    id: "10080",
    id_polifenol: "6589",
    polifenol: "irilin D",
    id_cancer: "3232",
    cancer: "Ductal Carcinoma",
    quant: "1",
    pmids: "15787436",
  },
  {
    id: "10081",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "18122",
    cancer: "Cholangiocarcinoma",
    quant: "3",
    pmids: "24038588,26943884,26794001",
  },
  {
    id: "10082",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "18122",
    cancer: "Cholangiocarcinoma",
    quant: "8",
    pmids:
      "27825763,27571770,21325634,21272158,20824699,20510329,20420820,22448640",
  },
  {
    id: "10083",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "18122",
    cancer: "Cholangiocarcinoma",
    quant: "4",
    pmids: "26935808,19226332,20458282,17069924",
  },
  {
    id: "10084",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "18122",
    cancer: "Cholangiocarcinoma",
    quant: "5",
    pmids: "20101459,10534331,23494562,11910351,12717393",
  },
  {
    id: "10085",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "18122",
    cancer: "Cholangiocarcinoma",
    quant: "1",
    pmids: "29693152",
  },
  {
    id: "10086",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "18122",
    cancer: "Cholangiocarcinoma",
    quant: "2",
    pmids: "24038588,26943884",
  },
  {
    id: "10087",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "18122",
    cancer: "Cholangiocarcinoma",
    quant: "5",
    pmids: "26278714,23864881,24038588,28053547,19226332",
  },
  {
    id: "10088",
    id_polifenol: "49",
    polifenol: "Aspirin",
    id_cancer: "18122",
    cancer: "Cholangiocarcinoma",
    quant: "2",
    pmids: "29172284,21076843",
  },
  {
    id: "10089",
    id_polifenol: "109",
    polifenol: "Catechin",
    id_cancer: "18122",
    cancer: "Cholangiocarcinoma",
    quant: "2",
    pmids: "26278714,19226332",
  },
  {
    id: "10090",
    id_polifenol: "114",
    polifenol: "Apigenin",
    id_cancer: "18122",
    cancer: "Cholangiocarcinoma",
    quant: "2",
    pmids: "28943950,26312563",
  },
  {
    id: "10091",
    id_polifenol: "38",
    polifenol: "Gallic Acid",
    id_cancer: "18122",
    cancer: "Cholangiocarcinoma",
    quant: "1",
    pmids: "26514503",
  },
  {
    id: "10092",
    id_polifenol: "117",
    polifenol: "Luteolin",
    id_cancer: "18122",
    cancer: "Cholangiocarcinoma",
    quant: "1",
    pmids: "29518609",
  },
  {
    id: "10093",
    id_polifenol: "105",
    polifenol: "Anthocyanins",
    id_cancer: "18122",
    cancer: "Cholangiocarcinoma",
    quant: "1",
    pmids: "29512768",
  },
  {
    id: "10094",
    id_polifenol: "871",
    polifenol: "ABT-737",
    id_cancer: "18122",
    cancer: "Cholangiocarcinoma",
    quant: "1",
    pmids: "20473610",
  },
  {
    id: "10095",
    id_polifenol: "6065",
    polifenol: "baicalein",
    id_cancer: "18122",
    cancer: "Cholangiocarcinoma",
    quant: "1",
    pmids: "8275481",
  },
  {
    id: "10096",
    id_polifenol: "7",
    polifenol: "Capsaicin",
    id_cancer: "18122",
    cancer: "Cholangiocarcinoma",
    quant: "3",
    pmids: "25217963,25933112,24748170",
  },
  {
    id: "10097",
    id_polifenol: "4634",
    polifenol: "alvocidib",
    id_cancer: "18122",
    cancer: "Cholangiocarcinoma",
    quant: "1",
    pmids: "15150106",
  },
  {
    id: "10098",
    id_polifenol: "6087",
    polifenol: "wogonin",
    id_cancer: "18122",
    cancer: "Cholangiocarcinoma",
    quant: "1",
    pmids: "8275481",
  },
  {
    id: "10099",
    id_polifenol: "4515",
    polifenol: "baicalin",
    id_cancer: "18122",
    cancer: "Cholangiocarcinoma",
    quant: "1",
    pmids: "8275481",
  },
  {
    id: "10100",
    id_polifenol: "4708",
    polifenol: "xanthohumol",
    id_cancer: "18122",
    cancer: "Cholangiocarcinoma",
    quant: "2",
    pmids: "26794001,23480764",
  },
  {
    id: "10101",
    id_polifenol: "4253",
    polifenol:
      "5-(2,4-dihydroxy-5-isopropylphenyl)-4-(4-morpholin-4-ylmethylphenyl)isoxazole-3-carboxylic acid ethylamide",
    id_cancer: "18122",
    cancer: "Cholangiocarcinoma",
    quant: "3",
    pmids: "24796583,26141945,22810956",
  },
  {
    id: "10102",
    id_polifenol: "5844",
    polifenol: "4-dimethylamino-3',4'-dimethoxychalcone",
    id_cancer: "18122",
    cancer: "Cholangiocarcinoma",
    quant: "1",
    pmids: "11870367",
  },
  {
    id: "10103",
    id_polifenol: "2454",
    polifenol: "corilagin",
    id_cancer: "18122",
    cancer: "Cholangiocarcinoma",
    quant: "1",
    pmids: "26935808",
  },
  {
    id: "10104",
    id_polifenol: "1262",
    polifenol: "4-dodecylaminophenol",
    id_cancer: "18122",
    cancer: "Cholangiocarcinoma",
    quant: "1",
    pmids: "22440084",
  },
  {
    id: "10105",
    id_polifenol: "6464",
    polifenol: "cirsiliol",
    id_cancer: "18122",
    cancer: "Cholangiocarcinoma",
    quant: "1",
    pmids: "27566208",
  },
  {
    id: "10106",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "15814",
    cancer: "Leukemia, T-Cell",
    quant: "12",
    pmids:
      "21993665,8519648,8084211,18300387,27210480,15969450,15857606,22933043,16458258,25688010,29326123,21462089",
  },
  {
    id: "10107",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "15814",
    cancer: "Leukemia, T-Cell",
    quant: "4",
    pmids: "16106398,21924245,27857884,16458258",
  },
  {
    id: "10108",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "15814",
    cancer: "Leukemia, T-Cell",
    quant: "9",
    pmids:
      "14612961,11312805,24606444,27748367,15161048,10744042,27551472,17477351,15011755",
  },
  {
    id: "10109",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "15814",
    cancer: "Leukemia, T-Cell",
    quant: "2",
    pmids: "24394624,21901168",
  },
  {
    id: "10110",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "15814",
    cancer: "Leukemia, T-Cell",
    quant: "5",
    pmids: "8217365,8084211,1889460,8207961,10453436",
  },
  {
    id: "10111",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "15814",
    cancer: "Leukemia, T-Cell",
    quant: "2",
    pmids: "15857606,27551472",
  },
  {
    id: "10112",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "15814",
    cancer: "Leukemia, T-Cell",
    quant: "6",
    pmids: "11312805,18687687,24606444,15161048,10744042,17477351",
  },
  {
    id: "10113",
    id_polifenol: "2167",
    polifenol: "phenolic acid",
    id_cancer: "15814",
    cancer: "Leukemia, T-Cell",
    quant: "1",
    pmids: "27210480",
  },
  {
    id: "10114",
    id_polifenol: "49",
    polifenol: "Aspirin",
    id_cancer: "15814",
    cancer: "Leukemia, T-Cell",
    quant: "1",
    pmids: "20188076",
  },
  {
    id: "10115",
    id_polifenol: "109",
    polifenol: "Catechin",
    id_cancer: "15814",
    cancer: "Leukemia, T-Cell",
    quant: "1",
    pmids: "18687687",
  },
  {
    id: "10116",
    id_polifenol: "125",
    polifenol: "Isoflavones",
    id_cancer: "15814",
    cancer: "Leukemia, T-Cell",
    quant: "1",
    pmids: "15770547",
  },
  {
    id: "10117",
    id_polifenol: "110",
    polifenol: "Chalcones",
    id_cancer: "15814",
    cancer: "Leukemia, T-Cell",
    quant: "2",
    pmids: "27210480,25688010",
  },
  {
    id: "10118",
    id_polifenol: "114",
    polifenol: "Apigenin",
    id_cancer: "15814",
    cancer: "Leukemia, T-Cell",
    quant: "4",
    pmids: "18300387,15857606,27551472,24895203",
  },
  {
    id: "10119",
    id_polifenol: "113",
    polifenol: "Flavones",
    id_cancer: "15814",
    cancer: "Leukemia, T-Cell",
    quant: "2",
    pmids: "8519648,24895203",
  },
  {
    id: "10120",
    id_polifenol: "38",
    polifenol: "Gallic Acid",
    id_cancer: "15814",
    cancer: "Leukemia, T-Cell",
    quant: "1",
    pmids: "11497272",
  },
  {
    id: "10121",
    id_polifenol: "117",
    polifenol: "Luteolin",
    id_cancer: "15814",
    cancer: "Leukemia, T-Cell",
    quant: "1",
    pmids: "24895203",
  },
  {
    id: "10122",
    id_polifenol: "129",
    polifenol: "Rotenone",
    id_cancer: "15814",
    cancer: "Leukemia, T-Cell",
    quant: "1",
    pmids: "27210480",
  },
  {
    id: "10123",
    id_polifenol: "121",
    polifenol: "Kaempferols",
    id_cancer: "15814",
    cancer: "Leukemia, T-Cell",
    quant: "1",
    pmids: "15857606",
  },
  {
    id: "10124",
    id_polifenol: "6451",
    polifenol: "daidzein",
    id_cancer: "15814",
    cancer: "Leukemia, T-Cell",
    quant: "1",
    pmids: "15770547",
  },
  {
    id: "10125",
    id_polifenol: "6065",
    polifenol: "baicalein",
    id_cancer: "15814",
    cancer: "Leukemia, T-Cell",
    quant: "1",
    pmids: "24895203",
  },
  {
    id: "10126",
    id_polifenol: "4634",
    polifenol: "alvocidib",
    id_cancer: "15814",
    cancer: "Leukemia, T-Cell",
    quant: "1",
    pmids: "15383455",
  },
  {
    id: "10127",
    id_polifenol: "4522",
    polifenol: "chrysin",
    id_cancer: "15814",
    cancer: "Leukemia, T-Cell",
    quant: "2",
    pmids: "27210480,24895203",
  },
  {
    id: "10128",
    id_polifenol: "6062",
    polifenol: "naringenin",
    id_cancer: "15814",
    cancer: "Leukemia, T-Cell",
    quant: "1",
    pmids: "22933043",
  },
  {
    id: "10129",
    id_polifenol: "39",
    polifenol: "Hydrolyzable Tannins",
    id_cancer: "15814",
    cancer: "Leukemia, T-Cell",
    quant: "1",
    pmids: "11497272",
  },
  {
    id: "10130",
    id_polifenol: "15",
    polifenol: "Masoprocol",
    id_cancer: "15814",
    cancer: "Leukemia, T-Cell",
    quant: "1",
    pmids: "17645780",
  },
  {
    id: "10131",
    id_polifenol: "6087",
    polifenol: "wogonin",
    id_cancer: "15814",
    cancer: "Leukemia, T-Cell",
    quant: "3",
    pmids: "18070986,24895203,29326123",
  },
  {
    id: "10132",
    id_polifenol: "4519",
    polifenol: "myricetin",
    id_cancer: "15814",
    cancer: "Leukemia, T-Cell",
    quant: "1",
    pmids: "15857606",
  },
  {
    id: "10133",
    id_polifenol: "5608",
    polifenol: "epicatechin gallate",
    id_cancer: "15814",
    cancer: "Leukemia, T-Cell",
    quant: "1",
    pmids: "17477351",
  },
  {
    id: "10134",
    id_polifenol: "4559",
    polifenol: "theaflavin",
    id_cancer: "15814",
    cancer: "Leukemia, T-Cell",
    quant: "1",
    pmids: "11312805",
  },
  {
    id: "10135",
    id_polifenol: "2344",
    polifenol: "methyl gallate",
    id_cancer: "15814",
    cancer: "Leukemia, T-Cell",
    quant: "1",
    pmids: "15161048",
  },
  {
    id: "10136",
    id_polifenol: "4708",
    polifenol: "xanthohumol",
    id_cancer: "15814",
    cancer: "Leukemia, T-Cell",
    quant: "1",
    pmids: "25688010",
  },
  {
    id: "10137",
    id_polifenol: "6461",
    polifenol: "acacetin",
    id_cancer: "15814",
    cancer: "Leukemia, T-Cell",
    quant: "1",
    pmids: "21993665",
  },
  {
    id: "10138",
    id_polifenol: "126",
    polifenol: "Coumestrol",
    id_cancer: "15814",
    cancer: "Leukemia, T-Cell",
    quant: "1",
    pmids: "15770547",
  },
  {
    id: "10139",
    id_polifenol: "4560",
    polifenol: "icariin",
    id_cancer: "15814",
    cancer: "Leukemia, T-Cell",
    quant: "1",
    pmids: "14756686",
  },
  {
    id: "10140",
    id_polifenol: "80",
    polifenol: "Clofibrate",
    id_cancer: "15814",
    cancer: "Leukemia, T-Cell",
    quant: "1",
    pmids: "23028936",
  },
  {
    id: "10141",
    id_polifenol: "6482",
    polifenol: "tangeretin",
    id_cancer: "15814",
    cancer: "Leukemia, T-Cell",
    quant: "1",
    pmids: "8519648",
  },
  {
    id: "10142",
    id_polifenol: "7912",
    polifenol: "7,9,2',4'-tetrahydroxy-8-isopentenyl-5-methoxychalcone",
    id_cancer: "15814",
    cancer: "Leukemia, T-Cell",
    quant: "2",
    pmids: "15770547,25688010",
  },
  {
    id: "10143",
    id_polifenol: "6097",
    polifenol: "8-prenylnaringenin",
    id_cancer: "15814",
    cancer: "Leukemia, T-Cell",
    quant: "1",
    pmids: "22933043",
  },
  {
    id: "10144",
    id_polifenol: "6558",
    polifenol: "7,3'-dihydroxy-4'-methoxyisoflavone",
    id_cancer: "15814",
    cancer: "Leukemia, T-Cell",
    quant: "1",
    pmids: "27210480",
  },
  {
    id: "10145",
    id_polifenol: "5455",
    polifenol: "theaflavin-3,3'-digallate",
    id_cancer: "15814",
    cancer: "Leukemia, T-Cell",
    quant: "1",
    pmids: "11312805",
  },
  {
    id: "10146",
    id_polifenol: "5815",
    polifenol: "dibenzoylmethane",
    id_cancer: "15814",
    cancer: "Leukemia, T-Cell",
    quant: "1",
    pmids: "21924245",
  },
  {
    id: "10147",
    id_polifenol: "77",
    polifenol: "Bezafibrate",
    id_cancer: "15814",
    cancer: "Leukemia, T-Cell",
    quant: "1",
    pmids: "27347458",
  },
  {
    id: "10148",
    id_polifenol: "128",
    polifenol: "Pterocarpans",
    id_cancer: "15814",
    cancer: "Leukemia, T-Cell",
    quant: "2",
    pmids: "27210480,15770547",
  },
  {
    id: "10149",
    id_polifenol: "2364",
    polifenol: "theaflavine gallate",
    id_cancer: "15814",
    cancer: "Leukemia, T-Cell",
    quant: "1",
    pmids: "11312805",
  },
  {
    id: "10150",
    id_polifenol: "6549",
    polifenol: "7-hydroxy-2',3',4',5',8-pentamethoxyisoflavan",
    id_cancer: "15814",
    cancer: "Leukemia, T-Cell",
    quant: "1",
    pmids: "27210480",
  },
  {
    id: "10151",
    id_polifenol: "7778",
    polifenol: "medicarpin",
    id_cancer: "15814",
    cancer: "Leukemia, T-Cell",
    quant: "1",
    pmids: "27210480",
  },
  {
    id: "10152",
    id_polifenol: "5669",
    polifenol: "pro-F-EGCG2",
    id_cancer: "15814",
    cancer: "Leukemia, T-Cell",
    quant: "1",
    pmids: "17477351",
  },
  {
    id: "10153",
    id_polifenol: "2290",
    polifenol: "lobaric acid",
    id_cancer: "15814",
    cancer: "Leukemia, T-Cell",
    quant: "1",
    pmids: "15549672",
  },
  {
    id: "10154",
    id_polifenol: "815",
    polifenol: "theasinensin A",
    id_cancer: "15814",
    cancer: "Leukemia, T-Cell",
    quant: "1",
    pmids: "11312805",
  },
  {
    id: "10155",
    id_polifenol: "4219",
    polifenol: "baeomycesic acid",
    id_cancer: "15814",
    cancer: "Leukemia, T-Cell",
    quant: "1",
    pmids: "15549672",
  },
  {
    id: "10156",
    id_polifenol: "5639",
    polifenol: "4-(S-cysteinyl)epicatechin 3-O-gallate",
    id_cancer: "15814",
    cancer: "Leukemia, T-Cell",
    quant: "1",
    pmids: "17477351",
  },
  {
    id: "10157",
    id_polifenol: "5115",
    polifenol: "vestitol",
    id_cancer: "15814",
    cancer: "Leukemia, T-Cell",
    quant: "1",
    pmids: "27210480",
  },
  {
    id: "10158",
    id_polifenol: "870",
    polifenol: "thiacalix(4)arene",
    id_cancer: "15814",
    cancer: "Leukemia, T-Cell",
    quant: "1",
    pmids: "25735932",
  },
  {
    id: "10159",
    id_polifenol: "7783",
    polifenol: "bitucarpin A",
    id_cancer: "15814",
    cancer: "Leukemia, T-Cell",
    quant: "1",
    pmids: "15770547",
  },
  {
    id: "10160",
    id_polifenol: "4206",
    polifenol: "5-(2'-oxoheptadecyl)resorcinol",
    id_cancer: "15814",
    cancer: "Leukemia, T-Cell",
    quant: "1",
    pmids: "12562085",
  },
  {
    id: "10161",
    id_polifenol: "4207",
    polifenol: "5-(2'-oxononadecyl)resorcinol",
    id_cancer: "15814",
    cancer: "Leukemia, T-Cell",
    quant: "1",
    pmids: "12562085",
  },
  {
    id: "10162",
    id_polifenol: "7784",
    polifenol: "erybraedin C",
    id_cancer: "15814",
    cancer: "Leukemia, T-Cell",
    quant: "1",
    pmids: "15770547",
  },
  {
    id: "10163",
    id_polifenol: "6817",
    polifenol: "8-prenyldaidzein",
    id_cancer: "15814",
    cancer: "Leukemia, T-Cell",
    quant: "1",
    pmids: "15770547",
  },
  {
    id: "10164",
    id_polifenol: "6656",
    polifenol: "bidwillon B",
    id_cancer: "15814",
    cancer: "Leukemia, T-Cell",
    quant: "1",
    pmids: "15770547",
  },
  {
    id: "10165",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "515",
    cancer: "Pheochromocytoma",
    quant: "7",
    pmids: "28498401,24631255,17202857,25428606,22135890,23670213,24175656",
  },
  {
    id: "10166",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "515",
    cancer: "Pheochromocytoma",
    quant: "2",
    pmids: "29777940,22248534",
  },
  {
    id: "10167",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "515",
    cancer: "Pheochromocytoma",
    quant: "4",
    pmids: "29278807,18837911,21183323,11747313",
  },
  {
    id: "10168",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "515",
    cancer: "Pheochromocytoma",
    quant: "3",
    pmids: "12231395,11168372,8978506",
  },
  {
    id: "10169",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "515",
    cancer: "Pheochromocytoma",
    quant: "4",
    pmids: "1527065,19003112,29600624,28396216",
  },
  {
    id: "10170",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "515",
    cancer: "Pheochromocytoma",
    quant: "2",
    pmids: "22919443,23670213",
  },
  {
    id: "10171",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "515",
    cancer: "Pheochromocytoma",
    quant: "3",
    pmids: "25452172,18837911,11747313",
  },
  {
    id: "10172",
    id_polifenol: "2167",
    polifenol: "phenolic acid",
    id_cancer: "515",
    cancer: "Pheochromocytoma",
    quant: "2",
    pmids: "18066115,22248534",
  },
  {
    id: "10173",
    id_polifenol: "109",
    polifenol: "Catechin",
    id_cancer: "515",
    cancer: "Pheochromocytoma",
    quant: "3",
    pmids: "12135191,18837911,11747313",
  },
  {
    id: "10174",
    id_polifenol: "125",
    polifenol: "Isoflavones",
    id_cancer: "515",
    cancer: "Pheochromocytoma",
    quant: "2",
    pmids: "29600624,19003217",
  },
  {
    id: "10175",
    id_polifenol: "3089",
    polifenol: "1,1-diphenyl-2-picrylhydrazyl",
    id_cancer: "515",
    cancer: "Pheochromocytoma",
    quant: "1",
    pmids: "22248534",
  },
  {
    id: "10176",
    id_polifenol: "114",
    polifenol: "Apigenin",
    id_cancer: "515",
    cancer: "Pheochromocytoma",
    quant: "2",
    pmids: "24398405,28396216",
  },
  {
    id: "10177",
    id_polifenol: "113",
    polifenol: "Flavones",
    id_cancer: "515",
    cancer: "Pheochromocytoma",
    quant: "2",
    pmids: "21473152,22135890",
  },
  {
    id: "10178",
    id_polifenol: "117",
    polifenol: "Luteolin",
    id_cancer: "515",
    cancer: "Pheochromocytoma",
    quant: "4",
    pmids: "28498401,21473152,24175656,20139605",
  },
  {
    id: "10179",
    id_polifenol: "7235",
    polifenol: "silybin",
    id_cancer: "515",
    cancer: "Pheochromocytoma",
    quant: "1",
    pmids: "21568648",
  },
  {
    id: "10180",
    id_polifenol: "129",
    polifenol: "Rotenone",
    id_cancer: "515",
    cancer: "Pheochromocytoma",
    quant: "1",
    pmids: "24858057",
  },
  {
    id: "10181",
    id_polifenol: "121",
    polifenol: "Kaempferols",
    id_cancer: "515",
    cancer: "Pheochromocytoma",
    quant: "2",
    pmids: "24175656,20139605",
  },
  {
    id: "10182",
    id_polifenol: "6451",
    polifenol: "daidzein",
    id_cancer: "515",
    cancer: "Pheochromocytoma",
    quant: "1",
    pmids: "28396216",
  },
  {
    id: "10183",
    id_polifenol: "6065",
    polifenol: "baicalein",
    id_cancer: "515",
    cancer: "Pheochromocytoma",
    quant: "2",
    pmids: "24631255,21473152",
  },
  {
    id: "10184",
    id_polifenol: "7",
    polifenol: "Capsaicin",
    id_cancer: "515",
    cancer: "Pheochromocytoma",
    quant: "1",
    pmids: "24337105",
  },
  {
    id: "10185",
    id_polifenol: "120",
    polifenol: "Flavonols",
    id_cancer: "515",
    cancer: "Pheochromocytoma",
    quant: "1",
    pmids: "25428606",
  },
  {
    id: "10186",
    id_polifenol: "123",
    polifenol: "Rutin",
    id_cancer: "515",
    cancer: "Pheochromocytoma",
    quant: "2",
    pmids: "21473152,23670213",
  },
  {
    id: "10187",
    id_polifenol: "4502",
    polifenol: "fisetin",
    id_cancer: "515",
    cancer: "Pheochromocytoma",
    quant: "1",
    pmids: "25428606",
  },
  {
    id: "10188",
    id_polifenol: "75",
    polifenol: "Butylated Hydroxyanisole",
    id_cancer: "515",
    cancer: "Pheochromocytoma",
    quant: "1",
    pmids: "19170071",
  },
  {
    id: "10189",
    id_polifenol: "4519",
    polifenol: "myricetin",
    id_cancer: "515",
    cancer: "Pheochromocytoma",
    quant: "1",
    pmids: "29278807",
  },
  {
    id: "10190",
    id_polifenol: "4515",
    polifenol: "baicalin",
    id_cancer: "515",
    cancer: "Pheochromocytoma",
    quant: "1",
    pmids: "22800826",
  },
  {
    id: "10191",
    id_polifenol: "5608",
    polifenol: "epicatechin gallate",
    id_cancer: "515",
    cancer: "Pheochromocytoma",
    quant: "1",
    pmids: "11747313",
  },
  {
    id: "10192",
    id_polifenol: "1356",
    polifenol: "gingerol",
    id_cancer: "515",
    cancer: "Pheochromocytoma",
    quant: "1",
    pmids: "22248534",
  },
  {
    id: "10193",
    id_polifenol: "98",
    polifenol: "Propofol",
    id_cancer: "515",
    cancer: "Pheochromocytoma",
    quant: "2",
    pmids: "29565198,11991087",
  },
  {
    id: "10194",
    id_polifenol: "5607",
    polifenol: "gallocatechol",
    id_cancer: "515",
    cancer: "Pheochromocytoma",
    quant: "1",
    pmids: "11747313",
  },
  {
    id: "10195",
    id_polifenol: "2344",
    polifenol: "methyl gallate",
    id_cancer: "515",
    cancer: "Pheochromocytoma",
    quant: "1",
    pmids: "11747313",
  },
  {
    id: "10196",
    id_polifenol: "1380",
    polifenol: "shogaol",
    id_cancer: "515",
    cancer: "Pheochromocytoma",
    quant: "1",
    pmids: "22248534",
  },
  {
    id: "10197",
    id_polifenol: "6273",
    polifenol: "hesperetin",
    id_cancer: "515",
    cancer: "Pheochromocytoma",
    quant: "1",
    pmids: "21473152",
  },
  {
    id: "10198",
    id_polifenol: "6461",
    polifenol: "acacetin",
    id_cancer: "515",
    cancer: "Pheochromocytoma",
    quant: "1",
    pmids: "21473152",
  },
  {
    id: "10199",
    id_polifenol: "4253",
    polifenol:
      "5-(2,4-dihydroxy-5-isopropylphenyl)-4-(4-morpholin-4-ylmethylphenyl)isoxazole-3-carboxylic acid ethylamide",
    id_cancer: "515",
    cancer: "Pheochromocytoma",
    quant: "1",
    pmids: "28458565",
  },
  {
    id: "10200",
    id_polifenol: "126",
    polifenol: "Coumestrol",
    id_cancer: "515",
    cancer: "Pheochromocytoma",
    quant: "1",
    pmids: "28396216",
  },
  {
    id: "10201",
    id_polifenol: "6463",
    polifenol: "puerarin",
    id_cancer: "515",
    cancer: "Pheochromocytoma",
    quant: "1",
    pmids: "28673004",
  },
  {
    id: "10202",
    id_polifenol: "99",
    polifenol: "Pyrogallol",
    id_cancer: "515",
    cancer: "Pheochromocytoma",
    quant: "1",
    pmids: "2353937",
  },
  {
    id: "10203",
    id_polifenol: "7541",
    polifenol: "taxifolin",
    id_cancer: "515",
    cancer: "Pheochromocytoma",
    quant: "1",
    pmids: "25476842",
  },
  {
    id: "10204",
    id_polifenol: "4767",
    polifenol: "flavan-3-ol",
    id_cancer: "515",
    cancer: "Pheochromocytoma",
    quant: "1",
    pmids: "21183323",
  },
  {
    id: "10205",
    id_polifenol: "6625",
    polifenol: "phenoxodiol",
    id_cancer: "515",
    cancer: "Pheochromocytoma",
    quant: "1",
    pmids: "17672914",
  },
  {
    id: "10206",
    id_polifenol: "6086",
    polifenol: "liquiritigenin",
    id_cancer: "515",
    cancer: "Pheochromocytoma",
    quant: "1",
    pmids: "28396216",
  },
  {
    id: "10207",
    id_polifenol: "102",
    polifenol: "Zearalenone",
    id_cancer: "515",
    cancer: "Pheochromocytoma",
    quant: "1",
    pmids: "28396216",
  },
  {
    id: "10208",
    id_polifenol: "7134",
    polifenol: "vitexin",
    id_cancer: "515",
    cancer: "Pheochromocytoma",
    quant: "1",
    pmids: "17202857",
  },
  {
    id: "10209",
    id_polifenol: "6456",
    polifenol: "daidzin",
    id_cancer: "515",
    cancer: "Pheochromocytoma",
    quant: "1",
    pmids: "19003112",
  },
  {
    id: "10210",
    id_polifenol: "87",
    polifenol: "Metoclopramide",
    id_cancer: "515",
    cancer: "Pheochromocytoma",
    quant: "1",
    pmids: "18948374",
  },
  {
    id: "10211",
    id_polifenol: "2331",
    polifenol: "8-(N,N-diethylamino)octyl-3,4,5-trimethoxybenzoate",
    id_cancer: "515",
    cancer: "Pheochromocytoma",
    quant: "1",
    pmids: "12372699",
  },
  {
    id: "10212",
    id_polifenol: "3494",
    polifenol: "asarone",
    id_cancer: "515",
    cancer: "Pheochromocytoma",
    quant: "1",
    pmids: "17634042",
  },
  {
    id: "10213",
    id_polifenol: "7437",
    polifenol: "kaempferol-3-O-rutinoside",
    id_cancer: "515",
    cancer: "Pheochromocytoma",
    quant: "1",
    pmids: "21473152",
  },
  {
    id: "10214",
    id_polifenol: "5198",
    polifenol: "isosakuranetin",
    id_cancer: "515",
    cancer: "Pheochromocytoma",
    quant: "1",
    pmids: "21473152",
  },
  {
    id: "10215",
    id_polifenol: "1961",
    polifenol: "tri-o-cresyl phosphate",
    id_cancer: "515",
    cancer: "Pheochromocytoma",
    quant: "1",
    pmids: "9788582",
  },
  {
    id: "10216",
    id_polifenol: "1804",
    polifenol: "guaiacylglycerol-beta-coniferyl ether",
    id_cancer: "515",
    cancer: "Pheochromocytoma",
    quant: "1",
    pmids: "21473152",
  },
  {
    id: "10217",
    id_polifenol: "4224",
    polifenol: "orsellinic acid",
    id_cancer: "515",
    cancer: "Pheochromocytoma",
    quant: "1",
    pmids: "18066115",
  },
  {
    id: "10218",
    id_polifenol: "7650",
    polifenol: "3,7-O-dimethylquercetin",
    id_cancer: "515",
    cancer: "Pheochromocytoma",
    quant: "1",
    pmids: "21473152",
  },
  {
    id: "10219",
    id_polifenol: "7180",
    polifenol: "apigenin-8-C-beta-D-glucopyranoside",
    id_cancer: "515",
    cancer: "Pheochromocytoma",
    quant: "1",
    pmids: "17202857",
  },
  {
    id: "10220",
    id_polifenol: "3986",
    polifenol: "sinapyl acetate",
    id_cancer: "515",
    cancer: "Pheochromocytoma",
    quant: "1",
    pmids: "21473152",
  },
  {
    id: "10221",
    id_polifenol: "7138",
    polifenol: "apigenin dimethylether",
    id_cancer: "515",
    cancer: "Pheochromocytoma",
    quant: "1",
    pmids: "21473152",
  },
  {
    id: "10222",
    id_polifenol: "6577",
    polifenol: "8-methoxy-5,6,4'-trihydroxyisoflavone-7-O-glucopyranoside",
    id_cancer: "515",
    cancer: "Pheochromocytoma",
    quant: "1",
    pmids: "19003217",
  },
  {
    id: "10223",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "591",
    cancer: "Bone Cancer",
    quant: "4",
    pmids: "23266503,24975661,25247855,23564766",
  },
  {
    id: "10224",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "591",
    cancer: "Bone Cancer",
    quant: "7",
    pmids: "26005346,22751853,22795543,24453488,28031891,27874279,12213462",
  },
  {
    id: "10225",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "591",
    cancer: "Bone Cancer",
    quant: "2",
    pmids: "21328612,25936406",
  },
  {
    id: "10226",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "591",
    cancer: "Bone Cancer",
    quant: "2",
    pmids: "18481201,22466127",
  },
  {
    id: "10227",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "591",
    cancer: "Bone Cancer",
    quant: "3",
    pmids: "16651437,15256057,28125641",
  },
  {
    id: "10228",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "591",
    cancer: "Bone Cancer",
    quant: "1",
    pmids: "23564766",
  },
  {
    id: "10229",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "591",
    cancer: "Bone Cancer",
    quant: "1",
    pmids: "21328612",
  },
  {
    id: "10230",
    id_polifenol: "109",
    polifenol: "Catechin",
    id_cancer: "591",
    cancer: "Bone Cancer",
    quant: "1",
    pmids: "29800908",
  },
  {
    id: "10231",
    id_polifenol: "125",
    polifenol: "Isoflavones",
    id_cancer: "591",
    cancer: "Bone Cancer",
    quant: "3",
    pmids: "18822283,12115517,28125641",
  },
  {
    id: "10232",
    id_polifenol: "110",
    polifenol: "Chalcones",
    id_cancer: "591",
    cancer: "Bone Cancer",
    quant: "1",
    pmids: "26294168",
  },
  {
    id: "10233",
    id_polifenol: "114",
    polifenol: "Apigenin",
    id_cancer: "591",
    cancer: "Bone Cancer",
    quant: "1",
    pmids: "26035210",
  },
  {
    id: "10234",
    id_polifenol: "1",
    polifenol: "Phenols",
    id_cancer: "591",
    cancer: "Bone Cancer",
    quant: "1",
    pmids: "28728976",
  },
  {
    id: "10235",
    id_polifenol: "105",
    polifenol: "Anthocyanins",
    id_cancer: "591",
    cancer: "Bone Cancer",
    quant: "1",
    pmids: "26069256",
  },
  {
    id: "10236",
    id_polifenol: "129",
    polifenol: "Rotenone",
    id_cancer: "591",
    cancer: "Bone Cancer",
    quant: "1",
    pmids: "12730670",
  },
  {
    id: "10237",
    id_polifenol: "6065",
    polifenol: "baicalein",
    id_cancer: "591",
    cancer: "Bone Cancer",
    quant: "2",
    pmids: "23266503,29156780",
  },
  {
    id: "10238",
    id_polifenol: "7",
    polifenol: "Capsaicin",
    id_cancer: "591",
    cancer: "Bone Cancer",
    quant: "3",
    pmids: "24142063,22570364,23518609",
  },
  {
    id: "10239",
    id_polifenol: "4634",
    polifenol: "alvocidib",
    id_cancer: "591",
    cancer: "Bone Cancer",
    quant: "2",
    pmids: "17520676,29805751",
  },
  {
    id: "10240",
    id_polifenol: "6087",
    polifenol: "wogonin",
    id_cancer: "591",
    cancer: "Bone Cancer",
    quant: "1",
    pmids: "28606135",
  },
  {
    id: "10241",
    id_polifenol: "4519",
    polifenol: "myricetin",
    id_cancer: "591",
    cancer: "Bone Cancer",
    quant: "1",
    pmids: "29663365",
  },
  {
    id: "10242",
    id_polifenol: "6063",
    polifenol: "naringin",
    id_cancer: "591",
    cancer: "Bone Cancer",
    quant: "1",
    pmids: "24975661",
  },
  {
    id: "10243",
    id_polifenol: "93",
    polifenol: "Phloroglucinol",
    id_cancer: "591",
    cancer: "Bone Cancer",
    quant: "1",
    pmids: "20067774",
  },
  {
    id: "10244",
    id_polifenol: "4253",
    polifenol:
      "5-(2,4-dihydroxy-5-isopropylphenyl)-4-(4-morpholin-4-ylmethylphenyl)isoxazole-3-carboxylic acid ethylamide",
    id_cancer: "591",
    cancer: "Bone Cancer",
    quant: "1",
    pmids: "23538447",
  },
  {
    id: "10245",
    id_polifenol: "1558",
    polifenol: "capsazepine",
    id_cancer: "591",
    cancer: "Bone Cancer",
    quant: "1",
    pmids: "16243435",
  },
  {
    id: "10246",
    id_polifenol: "1673",
    polifenol: "4-hydroxyestradiol",
    id_cancer: "591",
    cancer: "Bone Cancer",
    quant: "1",
    pmids: "17014383",
  },
  {
    id: "10247",
    id_polifenol: "4525",
    polifenol: "eupatilin",
    id_cancer: "591",
    cancer: "Bone Cancer",
    quant: "1",
    pmids: "26622880",
  },
  {
    id: "10248",
    id_polifenol: "2014",
    polifenol: "erbstatin",
    id_cancer: "591",
    cancer: "Bone Cancer",
    quant: "1",
    pmids: "25190293",
  },
  {
    id: "10249",
    id_polifenol: "6129",
    polifenol: "wogonoside",
    id_cancer: "591",
    cancer: "Bone Cancer",
    quant: "1",
    pmids: "25755693",
  },
  {
    id: "10250",
    id_polifenol: "2343",
    polifenol: "ethyl gallate",
    id_cancer: "591",
    cancer: "Bone Cancer",
    quant: "1",
    pmids: "25043389",
  },
  {
    id: "10251",
    id_polifenol: "6774",
    polifenol: "5,7-dihydroxy-6,3',4'-trimethoxyflavone",
    id_cancer: "591",
    cancer: "Bone Cancer",
    quant: "1",
    pmids: "26622880",
  },
  {
    id: "10252",
    id_polifenol: "6460",
    polifenol: "ipriflavone",
    id_cancer: "591",
    cancer: "Bone Cancer",
    quant: "1",
    pmids: "12115517",
  },
  {
    id: "10253",
    id_polifenol: "984",
    polifenol: "tapentadol",
    id_cancer: "591",
    cancer: "Bone Cancer",
    quant: "1",
    pmids: "24965165",
  },
  {
    id: "10254",
    id_polifenol: "1879",
    polifenol: "2-nitro-4-cresol",
    id_cancer: "591",
    cancer: "Bone Cancer",
    quant: "1",
    pmids: "28728976",
  },
  {
    id: "10255",
    id_polifenol: "6839",
    polifenol:
      "3',4'-dichloro-3-(3,4-dichlorophenylacetyl)-2,4,6-trihydroxydeoxybenzoin",
    id_cancer: "591",
    cancer: "Bone Cancer",
    quant: "1",
    pmids: "18822283",
  },
  {
    id: "10256",
    id_polifenol: "3997",
    polifenol: "2,4-bis(2-fluorophenylacetyl)phloroglucinol",
    id_cancer: "591",
    cancer: "Bone Cancer",
    quant: "1",
    pmids: "20067774",
  },
  {
    id: "10257",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "8141",
    cancer: "Intestinal Neoplasms",
    quant: "4",
    pmids: "12085217,17472461,11827069,24949441",
  },
  {
    id: "10258",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "8141",
    cancer: "Intestinal Neoplasms",
    quant: "6",
    pmids: "24733049,22830632,20153625,10729246,10783313,27831561",
  },
  {
    id: "10259",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "8141",
    cancer: "Intestinal Neoplasms",
    quant: "6",
    pmids: "24329111,12628509,20153625,11506822,27831561,22279681",
  },
  {
    id: "10260",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "8141",
    cancer: "Intestinal Neoplasms",
    quant: "3",
    pmids: "20957335,10760831,23672582",
  },
  {
    id: "10261",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "8141",
    cancer: "Intestinal Neoplasms",
    quant: "3",
    pmids: "12085217,22830632,10783313",
  },
  {
    id: "10262",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "8141",
    cancer: "Intestinal Neoplasms",
    quant: "9",
    pmids:
      "24329111,16288056,12085217,18549879,12628509,11206275,24914720,18625293,11506822",
  },
  {
    id: "10263",
    id_polifenol: "2167",
    polifenol: "phenolic acid",
    id_cancer: "8141",
    cancer: "Intestinal Neoplasms",
    quant: "3",
    pmids: "12085217,26347954,10783313",
  },
  {
    id: "10264",
    id_polifenol: "49",
    polifenol: "Aspirin",
    id_cancer: "8141",
    cancer: "Intestinal Neoplasms",
    quant: "11",
    pmids:
      "15528453,9151799,16141240,10853036,24516128,11745453,15992053,10668484,12171603,10883057,26304465",
  },
  {
    id: "10265",
    id_polifenol: "109",
    polifenol: "Catechin",
    id_cancer: "8141",
    cancer: "Intestinal Neoplasms",
    quant: "6",
    pmids: "16288056,12085217,18549879,24914720,18625293,11196148",
  },
  {
    id: "10266",
    id_polifenol: "114",
    polifenol: "Apigenin",
    id_cancer: "8141",
    cancer: "Intestinal Neoplasms",
    quant: "1",
    pmids: "11827069",
  },
  {
    id: "10267",
    id_polifenol: "38",
    polifenol: "Gallic Acid",
    id_cancer: "8141",
    cancer: "Intestinal Neoplasms",
    quant: "1",
    pmids: "12085217",
  },
  {
    id: "10268",
    id_polifenol: "1",
    polifenol: "Phenols",
    id_cancer: "8141",
    cancer: "Intestinal Neoplasms",
    quant: "1",
    pmids: "24949441",
  },
  {
    id: "10269",
    id_polifenol: "105",
    polifenol: "Anthocyanins",
    id_cancer: "8141",
    cancer: "Intestinal Neoplasms",
    quant: "2",
    pmids: "12706854,26473158",
  },
  {
    id: "10270",
    id_polifenol: "7235",
    polifenol: "silybin",
    id_cancer: "8141",
    cancer: "Intestinal Neoplasms",
    quant: "2",
    pmids: "23530816,20215518",
  },
  {
    id: "10271",
    id_polifenol: "7",
    polifenol: "Capsaicin",
    id_cancer: "8141",
    cancer: "Intestinal Neoplasms",
    quant: "1",
    pmids: "1373965",
  },
  {
    id: "10272",
    id_polifenol: "4522",
    polifenol: "chrysin",
    id_cancer: "8141",
    cancer: "Intestinal Neoplasms",
    quant: "1",
    pmids: "26347954",
  },
  {
    id: "10273",
    id_polifenol: "123",
    polifenol: "Rutin",
    id_cancer: "8141",
    cancer: "Intestinal Neoplasms",
    quant: "1",
    pmids: "10783313",
  },
  {
    id: "10274",
    id_polifenol: "39",
    polifenol: "Hydrolyzable Tannins",
    id_cancer: "8141",
    cancer: "Intestinal Neoplasms",
    quant: "1",
    pmids: "24949441",
  },
  {
    id: "10275",
    id_polifenol: "5608",
    polifenol: "epicatechin gallate",
    id_cancer: "8141",
    cancer: "Intestinal Neoplasms",
    quant: "2",
    pmids: "12085217,24914720",
  },
  {
    id: "10276",
    id_polifenol: "1356",
    polifenol: "gingerol",
    id_cancer: "8141",
    cancer: "Intestinal Neoplasms",
    quant: "1",
    pmids: "27730672",
  },
  {
    id: "10277",
    id_polifenol: "5607",
    polifenol: "gallocatechol",
    id_cancer: "8141",
    cancer: "Intestinal Neoplasms",
    quant: "2",
    pmids: "12085217,24914720",
  },
  {
    id: "10278",
    id_polifenol: "44",
    polifenol: "Salicylates",
    id_cancer: "8141",
    cancer: "Intestinal Neoplasms",
    quant: "2",
    pmids: "10853036,24516128",
  },
  {
    id: "10279",
    id_polifenol: "47",
    polifenol: "Mesalamine",
    id_cancer: "8141",
    cancer: "Intestinal Neoplasms",
    quant: "2",
    pmids: "10853036,26304465",
  },
  {
    id: "10280",
    id_polifenol: "6455",
    polifenol: "nobiletin",
    id_cancer: "8141",
    cancer: "Intestinal Neoplasms",
    quant: "1",
    pmids: "17472461",
  },
  {
    id: "10281",
    id_polifenol: "4513",
    polifenol: "galangin",
    id_cancer: "8141",
    cancer: "Intestinal Neoplasms",
    quant: "1",
    pmids: "26347954",
  },
  {
    id: "10282",
    id_polifenol: "5488",
    polifenol: "cyanidin",
    id_cancer: "8141",
    cancer: "Intestinal Neoplasms",
    quant: "1",
    pmids: "12706854",
  },
  {
    id: "10283",
    id_polifenol: "7546",
    polifenol: "isoquercitrin",
    id_cancer: "8141",
    cancer: "Intestinal Neoplasms",
    quant: "1",
    pmids: "12085217",
  },
  {
    id: "10284",
    id_polifenol: "6482",
    polifenol: "tangeretin",
    id_cancer: "8141",
    cancer: "Intestinal Neoplasms",
    quant: "1",
    pmids: "17472461",
  },
  {
    id: "10285",
    id_polifenol: "2475",
    polifenol: "6-O-galloylglucose",
    id_cancer: "8141",
    cancer: "Intestinal Neoplasms",
    quant: "1",
    pmids: "12085217",
  },
  {
    id: "10286",
    id_polifenol: "6068",
    polifenol: "pinocembrin",
    id_cancer: "8141",
    cancer: "Intestinal Neoplasms",
    quant: "1",
    pmids: "26347954",
  },
  {
    id: "10287",
    id_polifenol: "2450",
    polifenol: "Geraniin",
    id_cancer: "8141",
    cancer: "Intestinal Neoplasms",
    quant: "1",
    pmids: "12628509",
  },
  {
    id: "10288",
    id_polifenol: "2454",
    polifenol: "corilagin",
    id_cancer: "8141",
    cancer: "Intestinal Neoplasms",
    quant: "1",
    pmids: "12628509",
  },
  {
    id: "10289",
    id_polifenol: "6100",
    polifenol: "pinostrobin",
    id_cancer: "8141",
    cancer: "Intestinal Neoplasms",
    quant: "1",
    pmids: "26347954",
  },
  {
    id: "10290",
    id_polifenol: "4573",
    polifenol: "3,3',4',5,6,7,8-heptamethoxyflavone",
    id_cancer: "8141",
    cancer: "Intestinal Neoplasms",
    quant: "1",
    pmids: "17472461",
  },
  {
    id: "10291",
    id_polifenol: "6093",
    polifenol: "pinobanksin",
    id_cancer: "8141",
    cancer: "Intestinal Neoplasms",
    quant: "1",
    pmids: "26347954",
  },
  {
    id: "10292",
    id_polifenol: "4764",
    polifenol: "tectochrysin",
    id_cancer: "8141",
    cancer: "Intestinal Neoplasms",
    quant: "1",
    pmids: "26347954",
  },
  {
    id: "10293",
    id_polifenol: "106",
    polifenol: "Benzoflavones",
    id_cancer: "8141",
    cancer: "Intestinal Neoplasms",
    quant: "1",
    pmids: "27150634",
  },
  {
    id: "10294",
    id_polifenol: "4670",
    polifenol: "7,2',4',5'-tetramethoxyflavone",
    id_cancer: "8141",
    cancer: "Intestinal Neoplasms",
    quant: "1",
    pmids: "17472461",
  },
  {
    id: "10295",
    id_polifenol: "2933",
    polifenol: "balsalazide",
    id_cancer: "8141",
    cancer: "Intestinal Neoplasms",
    quant: "1",
    pmids: "10853036",
  },
  {
    id: "10296",
    id_polifenol: "1664",
    polifenol: "(2E,4E)-1-(2-hydroxyphenyl)-5-phenylpenta-2,4-dien-1-one",
    id_cancer: "8141",
    cancer: "Intestinal Neoplasms",
    quant: "1",
    pmids: "26347954",
  },
  {
    id: "10297",
    id_polifenol: "1118",
    polifenol: "4-hydroxyphenyl tert-butylnitrone",
    id_cancer: "8141",
    cancer: "Intestinal Neoplasms",
    quant: "1",
    pmids: "19886748",
  },
  {
    id: "10298",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "569",
    cancer: "Chronic Lymphocytic Leukemia",
    quant: "8",
    pmids:
      "27329589,18633129,25096193,22530142,22758641,20166210,29326123,12819936",
  },
  {
    id: "10299",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "569",
    cancer: "Chronic Lymphocytic Leukemia",
    quant: "2",
    pmids: "19228728,28551901",
  },
  {
    id: "10300",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "569",
    cancer: "Chronic Lymphocytic Leukemia",
    quant: "2",
    pmids: "23432965,22758641",
  },
  {
    id: "10301",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "569",
    cancer: "Chronic Lymphocytic Leukemia",
    quant: "5",
    pmids: "25778668,15291360,15183121,24901342,20371726",
  },
  {
    id: "10302",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "569",
    cancer: "Chronic Lymphocytic Leukemia",
    quant: "2",
    pmids: "15183121,15841278",
  },
  {
    id: "10303",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "569",
    cancer: "Chronic Lymphocytic Leukemia",
    quant: "5",
    pmids: "27329589,23432965,18633129,25096193,22758641",
  },
  {
    id: "10304",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "569",
    cancer: "Chronic Lymphocytic Leukemia",
    quant: "1",
    pmids: "19228728",
  },
  {
    id: "10305",
    id_polifenol: "2167",
    polifenol: "phenolic acid",
    id_cancer: "569",
    cancer: "Chronic Lymphocytic Leukemia",
    quant: "1",
    pmids: "23432965",
  },
  {
    id: "10306",
    id_polifenol: "49",
    polifenol: "Aspirin",
    id_cancer: "569",
    cancer: "Chronic Lymphocytic Leukemia",
    quant: "3",
    pmids: "23556096,21097689,18608871",
  },
  {
    id: "10307",
    id_polifenol: "114",
    polifenol: "Apigenin",
    id_cancer: "569",
    cancer: "Chronic Lymphocytic Leukemia",
    quant: "1",
    pmids: "20576813",
  },
  {
    id: "10308",
    id_polifenol: "871",
    polifenol: "ABT-737",
    id_cancer: "569",
    cancer: "Chronic Lymphocytic Leukemia",
    quant: "12",
    pmids:
      "22310286,22689920,26606677,25096193,17200714,18085673,21761401,26088877,26219338,19056433,23907405,27223062",
  },
  {
    id: "10309",
    id_polifenol: "4634",
    polifenol: "alvocidib",
    id_cancer: "569",
    cancer: "Chronic Lymphocytic Leukemia",
    quant: "6",
    pmids: "22740450,18192508,22512551,12819936,27040705,19778838",
  },
  {
    id: "10310",
    id_polifenol: "120",
    polifenol: "Flavonols",
    id_cancer: "569",
    cancer: "Chronic Lymphocytic Leukemia",
    quant: "1",
    pmids: "25096193",
  },
  {
    id: "10311",
    id_polifenol: "4522",
    polifenol: "chrysin",
    id_cancer: "569",
    cancer: "Chronic Lymphocytic Leukemia",
    quant: "1",
    pmids: "28301251",
  },
  {
    id: "10312",
    id_polifenol: "6087",
    polifenol: "wogonin",
    id_cancer: "569",
    cancer: "Chronic Lymphocytic Leukemia",
    quant: "1",
    pmids: "29326123",
  },
  {
    id: "10313",
    id_polifenol: "4519",
    polifenol: "myricetin",
    id_cancer: "569",
    cancer: "Chronic Lymphocytic Leukemia",
    quant: "1",
    pmids: "18633129",
  },
  {
    id: "10314",
    id_polifenol: "44",
    polifenol: "Salicylates",
    id_cancer: "569",
    cancer: "Chronic Lymphocytic Leukemia",
    quant: "1",
    pmids: "16162967",
  },
  {
    id: "10315",
    id_polifenol: "4708",
    polifenol: "xanthohumol",
    id_cancer: "569",
    cancer: "Chronic Lymphocytic Leukemia",
    quant: "1",
    pmids: "16144030",
  },
  {
    id: "10316",
    id_polifenol: "4253",
    polifenol:
      "5-(2,4-dihydroxy-5-isopropylphenyl)-4-(4-morpholin-4-ylmethylphenyl)isoxazole-3-carboxylic acid ethylamide",
    id_cancer: "569",
    cancer: "Chronic Lymphocytic Leukemia",
    quant: "1",
    pmids: "22619113",
  },
  {
    id: "10317",
    id_polifenol: "4537",
    polifenol: "flavone acetic acid",
    id_cancer: "569",
    cancer: "Chronic Lymphocytic Leukemia",
    quant: "1",
    pmids: "20166210",
  },
  {
    id: "10318",
    id_polifenol: "4632",
    polifenol: "ginkgetin",
    id_cancer: "569",
    cancer: "Chronic Lymphocytic Leukemia",
    quant: "1",
    pmids: "28902633",
  },
  {
    id: "10319",
    id_polifenol: "6761",
    polifenol: "P276-00",
    id_cancer: "569",
    cancer: "Chronic Lymphocytic Leukemia",
    quant: "1",
    pmids: "22512551",
  },
  {
    id: "10320",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "8644",
    cancer: "Leukemia, Lymphoid",
    quant: "7",
    pmids: "10963959,8277312,16119003,25096193,20648016,29326123,12608861",
  },
  {
    id: "10321",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "8644",
    cancer: "Leukemia, Lymphoid",
    quant: "2",
    pmids: "26333125,28551901",
  },
  {
    id: "10322",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "8644",
    cancer: "Leukemia, Lymphoid",
    quant: "4",
    pmids: "17630201,23432965,27551472,24039951",
  },
  {
    id: "10323",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "8644",
    cancer: "Leukemia, Lymphoid",
    quant: "4",
    pmids: "12963734,15291360,17137556,20371726",
  },
  {
    id: "10324",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "8644",
    cancer: "Leukemia, Lymphoid",
    quant: "1",
    pmids: "18163589",
  },
  {
    id: "10325",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "8644",
    cancer: "Leukemia, Lymphoid",
    quant: "5",
    pmids: "23432965,27551472,25096193,20648016,22446006",
  },
  {
    id: "10326",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "8644",
    cancer: "Leukemia, Lymphoid",
    quant: "1",
    pmids: "24039951",
  },
  {
    id: "10327",
    id_polifenol: "2167",
    polifenol: "phenolic acid",
    id_cancer: "8644",
    cancer: "Leukemia, Lymphoid",
    quant: "1",
    pmids: "23432965",
  },
  {
    id: "10328",
    id_polifenol: "49",
    polifenol: "Aspirin",
    id_cancer: "8644",
    cancer: "Leukemia, Lymphoid",
    quant: "2",
    pmids: "23556096,21097689",
  },
  {
    id: "10329",
    id_polifenol: "109",
    polifenol: "Catechin",
    id_cancer: "8644",
    cancer: "Leukemia, Lymphoid",
    quant: "1",
    pmids: "3518597",
  },
  {
    id: "10330",
    id_polifenol: "125",
    polifenol: "Isoflavones",
    id_cancer: "8644",
    cancer: "Leukemia, Lymphoid",
    quant: "1",
    pmids: "18163589",
  },
  {
    id: "10331",
    id_polifenol: "114",
    polifenol: "Apigenin",
    id_cancer: "8644",
    cancer: "Leukemia, Lymphoid",
    quant: "3",
    pmids: "27551472,20576813,24895203",
  },
  {
    id: "10332",
    id_polifenol: "113",
    polifenol: "Flavones",
    id_cancer: "8644",
    cancer: "Leukemia, Lymphoid",
    quant: "1",
    pmids: "24895203",
  },
  {
    id: "10333",
    id_polifenol: "117",
    polifenol: "Luteolin",
    id_cancer: "8644",
    cancer: "Leukemia, Lymphoid",
    quant: "1",
    pmids: "24895203",
  },
  {
    id: "10334",
    id_polifenol: "1",
    polifenol: "Phenols",
    id_cancer: "8644",
    cancer: "Leukemia, Lymphoid",
    quant: "1",
    pmids: "16504517",
  },
  {
    id: "10335",
    id_polifenol: "129",
    polifenol: "Rotenone",
    id_cancer: "8644",
    cancer: "Leukemia, Lymphoid",
    quant: "1",
    pmids: "2614425",
  },
  {
    id: "10336",
    id_polifenol: "871",
    polifenol: "ABT-737",
    id_cancer: "8644",
    cancer: "Leukemia, Lymphoid",
    quant: "5",
    pmids: "19390557,25096193,21761401,26088877,27223062",
  },
  {
    id: "10337",
    id_polifenol: "6065",
    polifenol: "baicalein",
    id_cancer: "8644",
    cancer: "Leukemia, Lymphoid",
    quant: "1",
    pmids: "24895203",
  },
  {
    id: "10338",
    id_polifenol: "4634",
    polifenol: "alvocidib",
    id_cancer: "8644",
    cancer: "Leukemia, Lymphoid",
    quant: "4",
    pmids: "21484792,9808574,18192508,27040705",
  },
  {
    id: "10339",
    id_polifenol: "120",
    polifenol: "Flavonols",
    id_cancer: "8644",
    cancer: "Leukemia, Lymphoid",
    quant: "2",
    pmids: "16119003,25096193",
  },
  {
    id: "10340",
    id_polifenol: "4522",
    polifenol: "chrysin",
    id_cancer: "8644",
    cancer: "Leukemia, Lymphoid",
    quant: "1",
    pmids: "24895203",
  },
  {
    id: "10341",
    id_polifenol: "35",
    polifenol: "Hydroquinones",
    id_cancer: "8644",
    cancer: "Leukemia, Lymphoid",
    quant: "1",
    pmids: "16504517",
  },
  {
    id: "10342",
    id_polifenol: "6087",
    polifenol: "wogonin",
    id_cancer: "8644",
    cancer: "Leukemia, Lymphoid",
    quant: "2",
    pmids: "24895203,29326123",
  },
  {
    id: "10343",
    id_polifenol: "4708",
    polifenol: "xanthohumol",
    id_cancer: "8644",
    cancer: "Leukemia, Lymphoid",
    quant: "1",
    pmids: "16144030",
  },
  {
    id: "10344",
    id_polifenol: "93",
    polifenol: "Phloroglucinol",
    id_cancer: "8644",
    cancer: "Leukemia, Lymphoid",
    quant: "2",
    pmids: "17701591,16791262",
  },
  {
    id: "10345",
    id_polifenol: "118",
    polifenol: "Flavonolignans",
    id_cancer: "8644",
    cancer: "Leukemia, Lymphoid",
    quant: "1",
    pmids: "12608861",
  },
  {
    id: "10346",
    id_polifenol: "6625",
    polifenol: "phenoxodiol",
    id_cancer: "8644",
    cancer: "Leukemia, Lymphoid",
    quant: "1",
    pmids: "19535345",
  },
  {
    id: "10347",
    id_polifenol: "77",
    polifenol: "Bezafibrate",
    id_cancer: "8644",
    cancer: "Leukemia, Lymphoid",
    quant: "1",
    pmids: "18923439",
  },
  {
    id: "10348",
    id_polifenol: "2159",
    polifenol: "2,3-dihydroxybenzoic acid",
    id_cancer: "8644",
    cancer: "Leukemia, Lymphoid",
    quant: "1",
    pmids: "3518597",
  },
  {
    id: "10349",
    id_polifenol: "6492",
    polifenol: "3(2H)-isoflavene",
    id_cancer: "8644",
    cancer: "Leukemia, Lymphoid",
    quant: "1",
    pmids: "19535345",
  },
  {
    id: "10350",
    id_polifenol: "4972",
    polifenol: "palstatin",
    id_cancer: "8644",
    cancer: "Leukemia, Lymphoid",
    quant: "1",
    pmids: "12608861",
  },
  {
    id: "10351",
    id_polifenol: "4769",
    polifenol: "5'-methoxyhydnocarpin",
    id_cancer: "8644",
    cancer: "Leukemia, Lymphoid",
    quant: "1",
    pmids: "12608861",
  },
  {
    id: "10352",
    id_polifenol: "6341",
    polifenol: "sideritoflavone",
    id_cancer: "8644",
    cancer: "Leukemia, Lymphoid",
    quant: "1",
    pmids: "8277312",
  },
  {
    id: "10353",
    id_polifenol: "3573",
    polifenol: "combretastatin A3",
    id_cancer: "8644",
    cancer: "Leukemia, Lymphoid",
    quant: "1",
    pmids: "16252907",
  },
  {
    id: "10354",
    id_polifenol: "764",
    polifenol: "methyl asterrate",
    id_cancer: "8644",
    cancer: "Leukemia, Lymphoid",
    quant: "1",
    pmids: "12932125",
  },
  {
    id: "10355",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "518",
    cancer: "Pituitary Tumor",
    quant: "1",
    pmids: "12652656",
  },
  {
    id: "10356",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "518",
    cancer: "Pituitary Tumor",
    quant: "3",
    pmids: "20160430,18450960,20405005",
  },
  {
    id: "10357",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "518",
    cancer: "Pituitary Tumor",
    quant: "2",
    pmids: "20160430,11305413",
  },
  {
    id: "10358",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "518",
    cancer: "Pituitary Tumor",
    quant: "5",
    pmids: "17384283,12943989,16043966,16899572,20798497",
  },
  {
    id: "10359",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "518",
    cancer: "Pituitary Tumor",
    quant: "6",
    pmids: "9772198,19765307,19400946,9215285,12652656,14563396",
  },
  {
    id: "10360",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "518",
    cancer: "Pituitary Tumor",
    quant: "1",
    pmids: "12652656",
  },
  {
    id: "10361",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "518",
    cancer: "Pituitary Tumor",
    quant: "1",
    pmids: "11305413",
  },
  {
    id: "10362",
    id_polifenol: "109",
    polifenol: "Catechin",
    id_cancer: "518",
    cancer: "Pituitary Tumor",
    quant: "1",
    pmids: "12652656",
  },
  {
    id: "10363",
    id_polifenol: "113",
    polifenol: "Flavones",
    id_cancer: "518",
    cancer: "Pituitary Tumor",
    quant: "1",
    pmids: "12652656",
  },
  {
    id: "10364",
    id_polifenol: "1",
    polifenol: "Phenols",
    id_cancer: "518",
    cancer: "Pituitary Tumor",
    quant: "1",
    pmids: "4084586",
  },
  {
    id: "10365",
    id_polifenol: "6451",
    polifenol: "daidzein",
    id_cancer: "518",
    cancer: "Pituitary Tumor",
    quant: "2",
    pmids: "19765307,19400946",
  },
  {
    id: "10366",
    id_polifenol: "4634",
    polifenol: "alvocidib",
    id_cancer: "518",
    cancer: "Pituitary Tumor",
    quant: "1",
    pmids: "15867383",
  },
  {
    id: "10367",
    id_polifenol: "285",
    polifenol: "bisphenol A",
    id_cancer: "518",
    cancer: "Pituitary Tumor",
    quant: "6",
    pmids: "15531431,10652244,22230296,23211298,19479013,15862819",
  },
  {
    id: "10368",
    id_polifenol: "25",
    polifenol: "Butylated Hydroxytoluene",
    id_cancer: "518",
    cancer: "Pituitary Tumor",
    quant: "1",
    pmids: "2983324",
  },
  {
    id: "10369",
    id_polifenol: "15",
    polifenol: "Masoprocol",
    id_cancer: "518",
    cancer: "Pituitary Tumor",
    quant: "1",
    pmids: "2426623",
  },
  {
    id: "10370",
    id_polifenol: "98",
    polifenol: "Propofol",
    id_cancer: "518",
    cancer: "Pituitary Tumor",
    quant: "1",
    pmids: "14570647",
  },
  {
    id: "10371",
    id_polifenol: "5578",
    polifenol: "alpha-naphthoflavone",
    id_cancer: "518",
    cancer: "Pituitary Tumor",
    quant: "1",
    pmids: "10936078",
  },
  {
    id: "10372",
    id_polifenol: "44",
    polifenol: "Salicylates",
    id_cancer: "518",
    cancer: "Pituitary Tumor",
    quant: "1",
    pmids: "17384283",
  },
  {
    id: "10373",
    id_polifenol: "10",
    polifenol: "Estrogens, Catechol",
    id_cancer: "518",
    cancer: "Pituitary Tumor",
    quant: "2",
    pmids: "2820746,28616971",
  },
  {
    id: "10374",
    id_polifenol: "107",
    polifenol: "beta-Naphthoflavone",
    id_cancer: "518",
    cancer: "Pituitary Tumor",
    quant: "1",
    pmids: "22975028",
  },
  {
    id: "10375",
    id_polifenol: "126",
    polifenol: "Coumestrol",
    id_cancer: "518",
    cancer: "Pituitary Tumor",
    quant: "4",
    pmids: "9772198,15531431,19765307,19400946",
  },
  {
    id: "10376",
    id_polifenol: "48",
    polifenol: "Anacardic Acids",
    id_cancer: "518",
    cancer: "Pituitary Tumor",
    quant: "1",
    pmids: "21275565",
  },
  {
    id: "10377",
    id_polifenol: "1673",
    polifenol: "4-hydroxyestradiol",
    id_cancer: "518",
    cancer: "Pituitary Tumor",
    quant: "1",
    pmids: "28616971",
  },
  {
    id: "10378",
    id_polifenol: "350",
    polifenol: "nonylphenol",
    id_cancer: "518",
    cancer: "Pituitary Tumor",
    quant: "4",
    pmids: "15531431,22230296,19479013,14563396",
  },
  {
    id: "10379",
    id_polifenol: "102",
    polifenol: "Zearalenone",
    id_cancer: "518",
    cancer: "Pituitary Tumor",
    quant: "1",
    pmids: "9772198",
  },
  {
    id: "10380",
    id_polifenol: "43",
    polifenol: "Parabens",
    id_cancer: "518",
    cancer: "Pituitary Tumor",
    quant: "2",
    pmids: "21473877,23211298",
  },
  {
    id: "10381",
    id_polifenol: "87",
    polifenol: "Metoclopramide",
    id_cancer: "518",
    cancer: "Pituitary Tumor",
    quant: "3",
    pmids: "3697756,22796279,6871710",
  },
  {
    id: "10382",
    id_polifenol: "299",
    polifenol: "nitrophenylphosphate",
    id_cancer: "518",
    cancer: "Pituitary Tumor",
    quant: "1",
    pmids: "11522334",
  },
  {
    id: "10383",
    id_polifenol: "2331",
    polifenol: "8-(N,N-diethylamino)octyl-3,4,5-trimethoxybenzoate",
    id_cancer: "518",
    cancer: "Pituitary Tumor",
    quant: "1",
    pmids: "2428456",
  },
  {
    id: "10384",
    id_polifenol: "273",
    polifenol: "bis(4-nitrophenyl)phosphate",
    id_cancer: "518",
    cancer: "Pituitary Tumor",
    quant: "1",
    pmids: "11522334",
  },
  {
    id: "10385",
    id_polifenol: "1204",
    polifenol: "2-isopropyl-5-methylphenol",
    id_cancer: "518",
    cancer: "Pituitary Tumor",
    quant: "1",
    pmids: "21473877",
  },
  {
    id: "10386",
    id_polifenol: "2590",
    polifenol: "isobutylparaben",
    id_cancer: "518",
    cancer: "Pituitary Tumor",
    quant: "2",
    pmids: "21473877,23211298",
  },
  {
    id: "10387",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "571",
    cancer: "Chronic Myelogenous Leukemia",
    quant: "5",
    pmids: "26408178,27329589,21777131,29312799,22770910",
  },
  {
    id: "10388",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "571",
    cancer: "Chronic Myelogenous Leukemia",
    quant: "9",
    pmids:
      "12718610,26802277,25157362,16849521,27908756,27190933,26116834,21480667,8142920",
  },
  {
    id: "10389",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "571",
    cancer: "Chronic Myelogenous Leukemia",
    quant: "2",
    pmids: "23811288,25536607",
  },
  {
    id: "10390",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "571",
    cancer: "Chronic Myelogenous Leukemia",
    quant: "3",
    pmids: "21360677,21892628,28639894",
  },
  {
    id: "10391",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "571",
    cancer: "Chronic Myelogenous Leukemia",
    quant: "2",
    pmids: "15353126,18426648",
  },
  {
    id: "10392",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "571",
    cancer: "Chronic Myelogenous Leukemia",
    quant: "4",
    pmids: "27329589,18426648,21843623,7720816",
  },
  {
    id: "10393",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "571",
    cancer: "Chronic Myelogenous Leukemia",
    quant: "2",
    pmids: "25536607,19200260",
  },
  {
    id: "10394",
    id_polifenol: "2167",
    polifenol: "phenolic acid",
    id_cancer: "571",
    cancer: "Chronic Myelogenous Leukemia",
    quant: "2",
    pmids: "12718610,25183268",
  },
  {
    id: "10395",
    id_polifenol: "109",
    polifenol: "Catechin",
    id_cancer: "571",
    cancer: "Chronic Myelogenous Leukemia",
    quant: "1",
    pmids: "19200260",
  },
  {
    id: "10396",
    id_polifenol: "114",
    polifenol: "Apigenin",
    id_cancer: "571",
    cancer: "Chronic Myelogenous Leukemia",
    quant: "1",
    pmids: "21777131",
  },
  {
    id: "10397",
    id_polifenol: "113",
    polifenol: "Flavones",
    id_cancer: "571",
    cancer: "Chronic Myelogenous Leukemia",
    quant: "1",
    pmids: "21777131",
  },
  {
    id: "10398",
    id_polifenol: "38",
    polifenol: "Gallic Acid",
    id_cancer: "571",
    cancer: "Chronic Myelogenous Leukemia",
    quant: "2",
    pmids: "22245431,25183268",
  },
  {
    id: "10399",
    id_polifenol: "117",
    polifenol: "Luteolin",
    id_cancer: "571",
    cancer: "Chronic Myelogenous Leukemia",
    quant: "1",
    pmids: "21777131",
  },
  {
    id: "10400",
    id_polifenol: "129",
    polifenol: "Rotenone",
    id_cancer: "571",
    cancer: "Chronic Myelogenous Leukemia",
    quant: "1",
    pmids: "29692266",
  },
  {
    id: "10401",
    id_polifenol: "6451",
    polifenol: "daidzein",
    id_cancer: "571",
    cancer: "Chronic Myelogenous Leukemia",
    quant: "2",
    pmids: "18426648,8142920",
  },
  {
    id: "10402",
    id_polifenol: "7",
    polifenol: "Capsaicin",
    id_cancer: "571",
    cancer: "Chronic Myelogenous Leukemia",
    quant: "2",
    pmids: "12718610,24870597",
  },
  {
    id: "10403",
    id_polifenol: "123",
    polifenol: "Rutin",
    id_cancer: "571",
    cancer: "Chronic Myelogenous Leukemia",
    quant: "1",
    pmids: "23351440",
  },
  {
    id: "10404",
    id_polifenol: "4502",
    polifenol: "fisetin",
    id_cancer: "571",
    cancer: "Chronic Myelogenous Leukemia",
    quant: "1",
    pmids: "26408178",
  },
  {
    id: "10405",
    id_polifenol: "98",
    polifenol: "Propofol",
    id_cancer: "571",
    cancer: "Chronic Myelogenous Leukemia",
    quant: "1",
    pmids: "28962554",
  },
  {
    id: "10406",
    id_polifenol: "4708",
    polifenol: "xanthohumol",
    id_cancer: "571",
    cancer: "Chronic Myelogenous Leukemia",
    quant: "1",
    pmids: "17823911",
  },
  {
    id: "10407",
    id_polifenol: "6455",
    polifenol: "nobiletin",
    id_cancer: "571",
    cancer: "Chronic Myelogenous Leukemia",
    quant: "1",
    pmids: "26690473",
  },
  {
    id: "10408",
    id_polifenol: "6273",
    polifenol: "hesperetin",
    id_cancer: "571",
    cancer: "Chronic Myelogenous Leukemia",
    quant: "1",
    pmids: "26408178",
  },
  {
    id: "10409",
    id_polifenol: "93",
    polifenol: "Phloroglucinol",
    id_cancer: "571",
    cancer: "Chronic Myelogenous Leukemia",
    quant: "1",
    pmids: "21376709",
  },
  {
    id: "10410",
    id_polifenol: "5806",
    polifenol: "butein",
    id_cancer: "571",
    cancer: "Chronic Myelogenous Leukemia",
    quant: "1",
    pmids: "26676515",
  },
  {
    id: "10411",
    id_polifenol: "80",
    polifenol: "Clofibrate",
    id_cancer: "571",
    cancer: "Chronic Myelogenous Leukemia",
    quant: "1",
    pmids: "2048221",
  },
  {
    id: "10412",
    id_polifenol: "4521",
    polifenol: "3-hydroxyflavone",
    id_cancer: "571",
    cancer: "Chronic Myelogenous Leukemia",
    quant: "1",
    pmids: "22770910",
  },
  {
    id: "10413",
    id_polifenol: "1629",
    polifenol: "bis-1,7-(2-hydroxyphenyl)-hepta-1,6-diene-3,5-dione",
    id_cancer: "571",
    cancer: "Chronic Myelogenous Leukemia",
    quant: "1",
    pmids: "27908756",
  },
  {
    id: "10414",
    id_polifenol: "4574",
    polifenol: "sinensetin",
    id_cancer: "571",
    cancer: "Chronic Myelogenous Leukemia",
    quant: "1",
    pmids: "26690473",
  },
  {
    id: "10415",
    id_polifenol: "7803",
    polifenol: "LQB 118",
    id_cancer: "571",
    cancer: "Chronic Myelogenous Leukemia",
    quant: "2",
    pmids: "29692266,25964959",
  },
  {
    id: "10416",
    id_polifenol: "16",
    polifenol: "Chlorophenols",
    id_cancer: "571",
    cancer: "Chronic Myelogenous Leukemia",
    quant: "1",
    pmids: "17085958",
  },
  {
    id: "10417",
    id_polifenol: "3798",
    polifenol: "n-hexyl vanillate",
    id_cancer: "571",
    cancer: "Chronic Myelogenous Leukemia",
    quant: "1",
    pmids: "23811288",
  },
  {
    id: "10418",
    id_polifenol: "4568",
    polifenol: "umuhengerin",
    id_cancer: "571",
    cancer: "Chronic Myelogenous Leukemia",
    quant: "1",
    pmids: "26690473",
  },
  {
    id: "10419",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "14512",
    cancer: "Tongue Neoplasms",
    quant: "8",
    pmids:
      "25256786,15194215,23969487,23497967,29023018,11131648,26712788,27266882",
  },
  {
    id: "10420",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "14512",
    cancer: "Tongue Neoplasms",
    quant: "5",
    pmids: "21887696,25400722,26036622,29651934,22624612",
  },
  {
    id: "10421",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "14512",
    cancer: "Tongue Neoplasms",
    quant: "3",
    pmids: "25329972,11911242,11131648",
  },
  {
    id: "10422",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "14512",
    cancer: "Tongue Neoplasms",
    quant: "2",
    pmids: "15194215,29180873",
  },
  {
    id: "10423",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "14512",
    cancer: "Tongue Neoplasms",
    quant: "3",
    pmids: "23497967,29142391,26712788",
  },
  {
    id: "10424",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "14512",
    cancer: "Tongue Neoplasms",
    quant: "5",
    pmids: "24249144,25591943,25329972,11911242,11131648",
  },
  {
    id: "10425",
    id_polifenol: "2167",
    polifenol: "phenolic acid",
    id_cancer: "14512",
    cancer: "Tongue Neoplasms",
    quant: "1",
    pmids: "26712788",
  },
  {
    id: "10426",
    id_polifenol: "49",
    polifenol: "Aspirin",
    id_cancer: "14512",
    cancer: "Tongue Neoplasms",
    quant: "1",
    pmids: "18811671",
  },
  {
    id: "10427",
    id_polifenol: "109",
    polifenol: "Catechin",
    id_cancer: "14512",
    cancer: "Tongue Neoplasms",
    quant: "4",
    pmids: "24249144,25591943,25329972,29142391",
  },
  {
    id: "10428",
    id_polifenol: "114",
    polifenol: "Apigenin",
    id_cancer: "14512",
    cancer: "Tongue Neoplasms",
    quant: "2",
    pmids: "23969487,22554915",
  },
  {
    id: "10429",
    id_polifenol: "113",
    polifenol: "Flavones",
    id_cancer: "14512",
    cancer: "Tongue Neoplasms",
    quant: "1",
    pmids: "22554915",
  },
  {
    id: "10430",
    id_polifenol: "117",
    polifenol: "Luteolin",
    id_cancer: "14512",
    cancer: "Tongue Neoplasms",
    quant: "1",
    pmids: "27266882",
  },
  {
    id: "10431",
    id_polifenol: "121",
    polifenol: "Kaempferols",
    id_cancer: "14512",
    cancer: "Tongue Neoplasms",
    quant: "1",
    pmids: "26712788",
  },
  {
    id: "10432",
    id_polifenol: "6065",
    polifenol: "baicalein",
    id_cancer: "14512",
    cancer: "Tongue Neoplasms",
    quant: "1",
    pmids: "15194215",
  },
  {
    id: "10433",
    id_polifenol: "7",
    polifenol: "Capsaicin",
    id_cancer: "14512",
    cancer: "Tongue Neoplasms",
    quant: "1",
    pmids: "20925121",
  },
  {
    id: "10434",
    id_polifenol: "123",
    polifenol: "Rutin",
    id_cancer: "14512",
    cancer: "Tongue Neoplasms",
    quant: "1",
    pmids: "29142391",
  },
  {
    id: "10435",
    id_polifenol: "6062",
    polifenol: "naringenin",
    id_cancer: "14512",
    cancer: "Tongue Neoplasms",
    quant: "1",
    pmids: "25256786",
  },
  {
    id: "10436",
    id_polifenol: "25",
    polifenol: "Butylated Hydroxytoluene",
    id_cancer: "14512",
    cancer: "Tongue Neoplasms",
    quant: "1",
    pmids: "8719597",
  },
  {
    id: "10437",
    id_polifenol: "4519",
    polifenol: "myricetin",
    id_cancer: "14512",
    cancer: "Tongue Neoplasms",
    quant: "1",
    pmids: "25256786",
  },
  {
    id: "10438",
    id_polifenol: "4500",
    polifenol: "procyanidin",
    id_cancer: "14512",
    cancer: "Tongue Neoplasms",
    quant: "1",
    pmids: "22103929",
  },
  {
    id: "10439",
    id_polifenol: "5608",
    polifenol: "epicatechin gallate",
    id_cancer: "14512",
    cancer: "Tongue Neoplasms",
    quant: "1",
    pmids: "11131648",
  },
  {
    id: "10440",
    id_polifenol: "5607",
    polifenol: "gallocatechol",
    id_cancer: "14512",
    cancer: "Tongue Neoplasms",
    quant: "1",
    pmids: "11131648",
  },
  {
    id: "10441",
    id_polifenol: "2158",
    polifenol: "protocatechuic acid",
    id_cancer: "14512",
    cancer: "Tongue Neoplasms",
    quant: "2",
    pmids: "14728590,8162581",
  },
  {
    id: "10442",
    id_polifenol: "81",
    polifenol: "Fenofibrate",
    id_cancer: "14512",
    cancer: "Tongue Neoplasms",
    quant: "1",
    pmids: "28453233",
  },
  {
    id: "10443",
    id_polifenol: "5819",
    polifenol: "licochalcone A",
    id_cancer: "14512",
    cancer: "Tongue Neoplasms",
    quant: "2",
    pmids: "24691971,24789273",
  },
  {
    id: "10444",
    id_polifenol: "4537",
    polifenol: "flavone acetic acid",
    id_cancer: "14512",
    cancer: "Tongue Neoplasms",
    quant: "1",
    pmids: "3653209",
  },
  {
    id: "10445",
    id_polifenol: "7161",
    polifenol: "scutellarin",
    id_cancer: "14512",
    cancer: "Tongue Neoplasms",
    quant: "3",
    pmids: "23546449,20878105,23536878",
  },
  {
    id: "10446",
    id_polifenol: "3019",
    polifenol: "nitroaspirin",
    id_cancer: "14512",
    cancer: "Tongue Neoplasms",
    quant: "1",
    pmids: "12438552",
  },
  {
    id: "10447",
    id_polifenol: "106",
    polifenol: "Benzoflavones",
    id_cancer: "14512",
    cancer: "Tongue Neoplasms",
    quant: "1",
    pmids: "27150634",
  },
  {
    id: "10448",
    id_polifenol: "42",
    polifenol: "Pactamycin",
    id_cancer: "14512",
    cancer: "Tongue Neoplasms",
    quant: "1",
    pmids: "25938491",
  },
  {
    id: "10449",
    id_polifenol: "2556",
    polifenol: "cranomycin",
    id_cancer: "14512",
    cancer: "Tongue Neoplasms",
    quant: "1",
    pmids: "25938491",
  },
  {
    id: "10450",
    id_polifenol: "4535",
    polifenol: "LM 985",
    id_cancer: "14512",
    cancer: "Tongue Neoplasms",
    quant: "1",
    pmids: "3653209",
  },
  {
    id: "10451",
    id_polifenol: "6689",
    polifenol: "scutellarin-7-O-glucuronide",
    id_cancer: "14512",
    cancer: "Tongue Neoplasms",
    quant: "1",
    pmids: "23536878",
  },
  {
    id: "10452",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "230103",
    cancer: "Medulloblastoma",
    quant: "8",
    pmids:
      "21501498,22280307,23192708,20025076,20332461,21193839,21492457,22944718",
  },
  {
    id: "10453",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "230103",
    cancer: "Medulloblastoma",
    quant: "5",
    pmids: "22280307,14769133,14587030,19225784,16458188",
  },
  {
    id: "10454",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "230103",
    cancer: "Medulloblastoma",
    quant: "2",
    pmids: "15994942,10675492",
  },
  {
    id: "10455",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "230103",
    cancer: "Medulloblastoma",
    quant: "4",
    pmids: "22736505,11023825,28877739,1668058",
  },
  {
    id: "10456",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "230103",
    cancer: "Medulloblastoma",
    quant: "2",
    pmids: "22511755,19244381",
  },
  {
    id: "10457",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "230103",
    cancer: "Medulloblastoma",
    quant: "2",
    pmids: "14769133,14587030",
  },
  {
    id: "10458",
    id_polifenol: "125",
    polifenol: "Isoflavones",
    id_cancer: "230103",
    cancer: "Medulloblastoma",
    quant: "1",
    pmids: "22736505",
  },
  {
    id: "10459",
    id_polifenol: "110",
    polifenol: "Chalcones",
    id_cancer: "230103",
    cancer: "Medulloblastoma",
    quant: "1",
    pmids: "27899820",
  },
  {
    id: "10460",
    id_polifenol: "129",
    polifenol: "Rotenone",
    id_cancer: "230103",
    cancer: "Medulloblastoma",
    quant: "2",
    pmids: "19633536,28877739",
  },
  {
    id: "10461",
    id_polifenol: "121",
    polifenol: "Kaempferols",
    id_cancer: "230103",
    cancer: "Medulloblastoma",
    quant: "1",
    pmids: "19244381",
  },
  {
    id: "10462",
    id_polifenol: "871",
    polifenol: "ABT-737",
    id_cancer: "230103",
    cancer: "Medulloblastoma",
    quant: "2",
    pmids: "21880625,26394044",
  },
  {
    id: "10463",
    id_polifenol: "6451",
    polifenol: "daidzein",
    id_cancer: "230103",
    cancer: "Medulloblastoma",
    quant: "1",
    pmids: "28877739",
  },
  {
    id: "10464",
    id_polifenol: "4634",
    polifenol: "alvocidib",
    id_cancer: "230103",
    cancer: "Medulloblastoma",
    quant: "1",
    pmids: "21885916",
  },
  {
    id: "10465",
    id_polifenol: "120",
    polifenol: "Flavonols",
    id_cancer: "230103",
    cancer: "Medulloblastoma",
    quant: "2",
    pmids: "7623025,19244381",
  },
  {
    id: "10466",
    id_polifenol: "39",
    polifenol: "Hydrolyzable Tannins",
    id_cancer: "230103",
    cancer: "Medulloblastoma",
    quant: "1",
    pmids: "1431932",
  },
  {
    id: "10467",
    id_polifenol: "4519",
    polifenol: "myricetin",
    id_cancer: "230103",
    cancer: "Medulloblastoma",
    quant: "1",
    pmids: "19244381",
  },
  {
    id: "10468",
    id_polifenol: "5608",
    polifenol: "epicatechin gallate",
    id_cancer: "230103",
    cancer: "Medulloblastoma",
    quant: "1",
    pmids: "1431932",
  },
  {
    id: "10469",
    id_polifenol: "5578",
    polifenol: "alpha-naphthoflavone",
    id_cancer: "230103",
    cancer: "Medulloblastoma",
    quant: "1",
    pmids: "15893423",
  },
  {
    id: "10470",
    id_polifenol: "81",
    polifenol: "Fenofibrate",
    id_cancer: "230103",
    cancer: "Medulloblastoma",
    quant: "1",
    pmids: "18546270",
  },
  {
    id: "10471",
    id_polifenol: "107",
    polifenol: "beta-Naphthoflavone",
    id_cancer: "230103",
    cancer: "Medulloblastoma",
    quant: "1",
    pmids: "15893423",
  },
  {
    id: "10472",
    id_polifenol: "5844",
    polifenol: "4-dimethylamino-3',4'-dimethoxychalcone",
    id_cancer: "230103",
    cancer: "Medulloblastoma",
    quant: "1",
    pmids: "19633536",
  },
  {
    id: "10473",
    id_polifenol: "4560",
    polifenol: "icariin",
    id_cancer: "230103",
    cancer: "Medulloblastoma",
    quant: "1",
    pmids: "27188746",
  },
  {
    id: "10474",
    id_polifenol: "2014",
    polifenol: "erbstatin",
    id_cancer: "230103",
    cancer: "Medulloblastoma",
    quant: "1",
    pmids: "1668058",
  },
  {
    id: "10475",
    id_polifenol: "4632",
    polifenol: "ginkgetin",
    id_cancer: "230103",
    cancer: "Medulloblastoma",
    quant: "1",
    pmids: "25821199",
  },
  {
    id: "10476",
    id_polifenol: "5245",
    polifenol: "BF6-6 biflavone",
    id_cancer: "230103",
    cancer: "Medulloblastoma",
    quant: "1",
    pmids: "25821199",
  },
  {
    id: "10477",
    id_polifenol: "2474",
    polifenol: "vescalagin",
    id_cancer: "230103",
    cancer: "Medulloblastoma",
    quant: "1",
    pmids: "1431932",
  },
  {
    id: "10478",
    id_polifenol: "4689",
    polifenol: "5,3'-dihydroxy-3,6,7,8,4'-pentamethoxyflavone",
    id_cancer: "230103",
    cancer: "Medulloblastoma",
    quant: "1",
    pmids: "7623025",
  },
  {
    id: "10479",
    id_polifenol: "2531",
    polifenol: "sanguiin H-5",
    id_cancer: "230103",
    cancer: "Medulloblastoma",
    quant: "1",
    pmids: "1431932",
  },
  {
    id: "10480",
    id_polifenol: "5523",
    polifenol: "cinnamtannin A2",
    id_cancer: "230103",
    cancer: "Medulloblastoma",
    quant: "1",
    pmids: "1431932",
  },
  {
    id: "10481",
    id_polifenol: "4372",
    polifenol:
      "quercetin 3-O-alpha-rhamnopyranoside-7-O-beta-D-glucopyranosyl-(1-3)-alpha-L-rhamnopyranoside",
    id_cancer: "230103",
    cancer: "Medulloblastoma",
    quant: "1",
    pmids: "7623025",
  },
  {
    id: "10482",
    id_polifenol: "2496",
    polifenol: "sanguiin H 11",
    id_cancer: "230103",
    cancer: "Medulloblastoma",
    quant: "1",
    pmids: "1431932",
  },
  {
    id: "10483",
    id_polifenol: "2351",
    polifenol: "1,3,4,5-tetra-O-galloylquinic acid",
    id_cancer: "230103",
    cancer: "Medulloblastoma",
    quant: "1",
    pmids: "1431932",
  },
  {
    id: "10484",
    id_polifenol: "2481",
    polifenol: "furosin",
    id_cancer: "230103",
    cancer: "Medulloblastoma",
    quant: "1",
    pmids: "1431932",
  },
  {
    id: "10485",
    id_polifenol: "7857",
    polifenol: "cinnamtannin B-1",
    id_cancer: "230103",
    cancer: "Medulloblastoma",
    quant: "1",
    pmids: "1431932",
  },
  {
    id: "10486",
    id_polifenol: "2371",
    polifenol: "eugeniin",
    id_cancer: "230103",
    cancer: "Medulloblastoma",
    quant: "1",
    pmids: "1431932",
  },
  {
    id: "10487",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "27924",
    cancer: "Prostatic Neoplasms, Castration-Resistant",
    quant: "2",
    pmids: "25060568,25860066",
  },
  {
    id: "10488",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "27924",
    cancer: "Prostatic Neoplasms, Castration-Resistant",
    quant: "7",
    pmids: "11967955,21680704,26203689,29374713,24531225,24949215,25121735",
  },
  {
    id: "10489",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "27924",
    cancer: "Prostatic Neoplasms, Castration-Resistant",
    quant: "4",
    pmids: "14506750,16331603,15466214,17196171",
  },
  {
    id: "10490",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "27924",
    cancer: "Prostatic Neoplasms, Castration-Resistant",
    quant: "3",
    pmids: "7872690,19846946,23999913",
  },
  {
    id: "10491",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "27924",
    cancer: "Prostatic Neoplasms, Castration-Resistant",
    quant: "2",
    pmids: "26875690,19846946",
  },
  {
    id: "10492",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "27924",
    cancer: "Prostatic Neoplasms, Castration-Resistant",
    quant: "1",
    pmids: "19846946",
  },
  {
    id: "10493",
    id_polifenol: "2167",
    polifenol: "phenolic acid",
    id_cancer: "27924",
    cancer: "Prostatic Neoplasms, Castration-Resistant",
    quant: "1",
    pmids: "27163852",
  },
  {
    id: "10494",
    id_polifenol: "125",
    polifenol: "Isoflavones",
    id_cancer: "27924",
    cancer: "Prostatic Neoplasms, Castration-Resistant",
    quant: "2",
    pmids: "23999913,12518321",
  },
  {
    id: "10495",
    id_polifenol: "110",
    polifenol: "Chalcones",
    id_cancer: "27924",
    cancer: "Prostatic Neoplasms, Castration-Resistant",
    quant: "2",
    pmids: "20112340,23877542",
  },
  {
    id: "10496",
    id_polifenol: "114",
    polifenol: "Apigenin",
    id_cancer: "27924",
    cancer: "Prostatic Neoplasms, Castration-Resistant",
    quant: "1",
    pmids: "26309896",
  },
  {
    id: "10497",
    id_polifenol: "113",
    polifenol: "Flavones",
    id_cancer: "27924",
    cancer: "Prostatic Neoplasms, Castration-Resistant",
    quant: "1",
    pmids: "7872690",
  },
  {
    id: "10498",
    id_polifenol: "871",
    polifenol: "ABT-737",
    id_cancer: "27924",
    cancer: "Prostatic Neoplasms, Castration-Resistant",
    quant: "1",
    pmids: "25333266",
  },
  {
    id: "10499",
    id_polifenol: "4634",
    polifenol: "alvocidib",
    id_cancer: "27924",
    cancer: "Prostatic Neoplasms, Castration-Resistant",
    quant: "2",
    pmids: "21042745,25860066",
  },
  {
    id: "10500",
    id_polifenol: "10",
    polifenol: "Estrogens, Catechol",
    id_cancer: "27924",
    cancer: "Prostatic Neoplasms, Castration-Resistant",
    quant: "1",
    pmids: "12587805",
  },
  {
    id: "10501",
    id_polifenol: "4253",
    polifenol:
      "5-(2,4-dihydroxy-5-isopropylphenyl)-4-(4-morpholin-4-ylmethylphenyl)isoxazole-3-carboxylic acid ethylamide",
    id_cancer: "27924",
    cancer: "Prostatic Neoplasms, Castration-Resistant",
    quant: "1",
    pmids: "25072314",
  },
  {
    id: "10502",
    id_polifenol: "69",
    polifenol: "Phenolsulfonphthalein",
    id_cancer: "27924",
    cancer: "Prostatic Neoplasms, Castration-Resistant",
    quant: "1",
    pmids: "11870800",
  },
  {
    id: "10503",
    id_polifenol: "1673",
    polifenol: "4-hydroxyestradiol",
    id_cancer: "27924",
    cancer: "Prostatic Neoplasms, Castration-Resistant",
    quant: "1",
    pmids: "12587805",
  },
  {
    id: "10504",
    id_polifenol: "5071",
    polifenol: "icaritin",
    id_cancer: "27924",
    cancer: "Prostatic Neoplasms, Castration-Resistant",
    quant: "1",
    pmids: "25908644",
  },
  {
    id: "10505",
    id_polifenol: "5815",
    polifenol: "dibenzoylmethane",
    id_cancer: "27924",
    cancer: "Prostatic Neoplasms, Castration-Resistant",
    quant: "1",
    pmids: "17595765",
  },
  {
    id: "10506",
    id_polifenol: "4883",
    polifenol: "flavokawain B",
    id_cancer: "27924",
    cancer: "Prostatic Neoplasms, Castration-Resistant",
    quant: "1",
    pmids: "20112340",
  },
  {
    id: "10507",
    id_polifenol: "2336",
    polifenol: "octyl gallate",
    id_cancer: "27924",
    cancer: "Prostatic Neoplasms, Castration-Resistant",
    quant: "1",
    pmids: "27163852",
  },
  {
    id: "10508",
    id_polifenol: "5730",
    polifenol: "2'-hydroxy-4-methylsulfonylchalcone",
    id_cancer: "27924",
    cancer: "Prostatic Neoplasms, Castration-Resistant",
    quant: "1",
    pmids: "23877542",
  },
  {
    id: "10509",
    id_polifenol: "5731",
    polifenol: "4'-chloro-2'-hydroxy-4-methylsulfonylchalcone",
    id_cancer: "27924",
    cancer: "Prostatic Neoplasms, Castration-Resistant",
    quant: "1",
    pmids: "23877542",
  },
  {
    id: "10510",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "600",
    cancer: "Brain Stem Neoplasms",
    quant: "4",
    pmids: "28036030,24012496,27569589,18952146",
  },
  {
    id: "10511",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "600",
    cancer: "Brain Stem Neoplasms",
    quant: "5",
    pmids: "22129484,21774804,24793792,28981096,27164829",
  },
  {
    id: "10512",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "600",
    cancer: "Brain Stem Neoplasms",
    quant: "3",
    pmids: "29475441,21503893,15478178",
  },
  {
    id: "10513",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "600",
    cancer: "Brain Stem Neoplasms",
    quant: "1",
    pmids: "15789435",
  },
  {
    id: "10514",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "600",
    cancer: "Brain Stem Neoplasms",
    quant: "2",
    pmids: "27279287,15706233",
  },
  {
    id: "10515",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "600",
    cancer: "Brain Stem Neoplasms",
    quant: "2",
    pmids: "29609590,27295129",
  },
  {
    id: "10516",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "600",
    cancer: "Brain Stem Neoplasms",
    quant: "2",
    pmids: "29475441,15478178",
  },
  {
    id: "10517",
    id_polifenol: "49",
    polifenol: "Aspirin",
    id_cancer: "600",
    cancer: "Brain Stem Neoplasms",
    quant: "2",
    pmids: "29179207,21584653",
  },
  {
    id: "10518",
    id_polifenol: "125",
    polifenol: "Isoflavones",
    id_cancer: "600",
    cancer: "Brain Stem Neoplasms",
    quant: "3",
    pmids: "17399896,15706233,18675857",
  },
  {
    id: "10519",
    id_polifenol: "114",
    polifenol: "Apigenin",
    id_cancer: "600",
    cancer: "Brain Stem Neoplasms",
    quant: "1",
    pmids: "27569589",
  },
  {
    id: "10520",
    id_polifenol: "113",
    polifenol: "Flavones",
    id_cancer: "600",
    cancer: "Brain Stem Neoplasms",
    quant: "2",
    pmids: "22863927,18952146",
  },
  {
    id: "10521",
    id_polifenol: "117",
    polifenol: "Luteolin",
    id_cancer: "600",
    cancer: "Brain Stem Neoplasms",
    quant: "1",
    pmids: "18952146",
  },
  {
    id: "10522",
    id_polifenol: "7235",
    polifenol: "silybin",
    id_cancer: "600",
    cancer: "Brain Stem Neoplasms",
    quant: "2",
    pmids: "24012496,25603020",
  },
  {
    id: "10523",
    id_polifenol: "871",
    polifenol: "ABT-737",
    id_cancer: "600",
    cancer: "Brain Stem Neoplasms",
    quant: "2",
    pmids: "25762636,25483065",
  },
  {
    id: "10524",
    id_polifenol: "6451",
    polifenol: "daidzein",
    id_cancer: "600",
    cancer: "Brain Stem Neoplasms",
    quant: "1",
    pmids: "18675857",
  },
  {
    id: "10525",
    id_polifenol: "1356",
    polifenol: "gingerol",
    id_cancer: "600",
    cancer: "Brain Stem Neoplasms",
    quant: "1",
    pmids: "25686711",
  },
  {
    id: "10526",
    id_polifenol: "4708",
    polifenol: "xanthohumol",
    id_cancer: "600",
    cancer: "Brain Stem Neoplasms",
    quant: "1",
    pmids: "28036030",
  },
  {
    id: "10527",
    id_polifenol: "6455",
    polifenol: "nobiletin",
    id_cancer: "600",
    cancer: "Brain Stem Neoplasms",
    quant: "1",
    pmids: "25686711",
  },
  {
    id: "10528",
    id_polifenol: "1380",
    polifenol: "shogaol",
    id_cancer: "600",
    cancer: "Brain Stem Neoplasms",
    quant: "1",
    pmids: "25686711",
  },
  {
    id: "10529",
    id_polifenol: "6454",
    polifenol: "formononetin",
    id_cancer: "600",
    cancer: "Brain Stem Neoplasms",
    quant: "1",
    pmids: "18675857",
  },
  {
    id: "10530",
    id_polifenol: "6461",
    polifenol: "acacetin",
    id_cancer: "600",
    cancer: "Brain Stem Neoplasms",
    quant: "1",
    pmids: "22863927",
  },
  {
    id: "10531",
    id_polifenol: "7912",
    polifenol: "7,9,2',4'-tetrahydroxy-8-isopentenyl-5-methoxychalcone",
    id_cancer: "600",
    cancer: "Brain Stem Neoplasms",
    quant: "1",
    pmids: "28036030",
  },
  {
    id: "10532",
    id_polifenol: "6558",
    polifenol: "7,3'-dihydroxy-4'-methoxyisoflavone",
    id_cancer: "600",
    cancer: "Brain Stem Neoplasms",
    quant: "1",
    pmids: "18675857",
  },
  {
    id: "10533",
    id_polifenol: "4565",
    polifenol: "morusin",
    id_cancer: "600",
    cancer: "Brain Stem Neoplasms",
    quant: "1",
    pmids: "25557841",
  },
  {
    id: "10534",
    id_polifenol: "6770",
    polifenol: "5-hydroxy-3,6,7,8,3',4'-hexamethoxyflavone",
    id_cancer: "600",
    cancer: "Brain Stem Neoplasms",
    quant: "1",
    pmids: "25686711",
  },
  {
    id: "10535",
    id_polifenol: "7741",
    polifenol: "biochanin A",
    id_cancer: "600",
    cancer: "Brain Stem Neoplasms",
    quant: "1",
    pmids: "17399896",
  },
  {
    id: "10536",
    id_polifenol: "7763",
    polifenol: "7-difluoromethoxyl-5,4'-di-n-octylgenistein",
    id_cancer: "600",
    cancer: "Brain Stem Neoplasms",
    quant: "1",
    pmids: "27279287",
  },
  {
    id: "10537",
    id_polifenol: "2648",
    polifenol: "salicylsalicylic acid",
    id_cancer: "600",
    cancer: "Brain Stem Neoplasms",
    quant: "1",
    pmids: "22129484",
  },
  {
    id: "10538",
    id_polifenol: "1424",
    polifenol: "rooperol",
    id_cancer: "600",
    cancer: "Brain Stem Neoplasms",
    quant: "1",
    pmids: "25404486",
  },
  {
    id: "10539",
    id_polifenol: "559",
    polifenol: "squamosamide",
    id_cancer: "600",
    cancer: "Brain Stem Neoplasms",
    quant: "1",
    pmids: "18507839",
  },
  {
    id: "10540",
    id_polifenol: "6897",
    polifenol: "4'-methoxy-3',5,7-trihydroxyisoflavone",
    id_cancer: "600",
    cancer: "Brain Stem Neoplasms",
    quant: "1",
    pmids: "18675857",
  },
  {
    id: "10541",
    id_polifenol: "6821",
    polifenol: "irilone",
    id_cancer: "600",
    cancer: "Brain Stem Neoplasms",
    quant: "1",
    pmids: "18675857",
  },
  {
    id: "10542",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "581",
    cancer: "Non-Hodgkin Lymphoma",
    quant: "4",
    pmids: "24977707,17002470,10665481,12819936",
  },
  {
    id: "10543",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "581",
    cancer: "Non-Hodgkin Lymphoma",
    quant: "4",
    pmids: "23603894,23117293,25861416,26815506",
  },
  {
    id: "10544",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "581",
    cancer: "Non-Hodgkin Lymphoma",
    quant: "3",
    pmids: "26700423,17002470,14512807",
  },
  {
    id: "10545",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "581",
    cancer: "Non-Hodgkin Lymphoma",
    quant: "1",
    pmids: "14707277",
  },
  {
    id: "10546",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "581",
    cancer: "Non-Hodgkin Lymphoma",
    quant: "1",
    pmids: "29928342",
  },
  {
    id: "10547",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "581",
    cancer: "Non-Hodgkin Lymphoma",
    quant: "1",
    pmids: "17905686",
  },
  {
    id: "10548",
    id_polifenol: "2167",
    polifenol: "phenolic acid",
    id_cancer: "581",
    cancer: "Non-Hodgkin Lymphoma",
    quant: "1",
    pmids: "23958424",
  },
  {
    id: "10549",
    id_polifenol: "49",
    polifenol: "Aspirin",
    id_cancer: "581",
    cancer: "Non-Hodgkin Lymphoma",
    quant: "2",
    pmids: "22011910,580932",
  },
  {
    id: "10550",
    id_polifenol: "4634",
    polifenol: "alvocidib",
    id_cancer: "581",
    cancer: "Non-Hodgkin Lymphoma",
    quant: "4",
    pmids: "22558078,11093360,10665481,12819936",
  },
  {
    id: "10551",
    id_polifenol: "120",
    polifenol: "Flavonols",
    id_cancer: "581",
    cancer: "Non-Hodgkin Lymphoma",
    quant: "1",
    pmids: "17905686",
  },
  {
    id: "10552",
    id_polifenol: "35",
    polifenol: "Hydroquinones",
    id_cancer: "581",
    cancer: "Non-Hodgkin Lymphoma",
    quant: "1",
    pmids: "27377594",
  },
  {
    id: "10553",
    id_polifenol: "112",
    polifenol: "Hesperidin",
    id_cancer: "581",
    cancer: "Non-Hodgkin Lymphoma",
    quant: "1",
    pmids: "24977707",
  },
  {
    id: "10554",
    id_polifenol: "55",
    polifenol: "Sodium Salicylate",
    id_cancer: "581",
    cancer: "Non-Hodgkin Lymphoma",
    quant: "2",
    pmids: "24692721,22011910",
  },
  {
    id: "10555",
    id_polifenol: "5844",
    polifenol: "4-dimethylamino-3',4'-dimethoxychalcone",
    id_cancer: "581",
    cancer: "Non-Hodgkin Lymphoma",
    quant: "2",
    pmids: "16081784,16103877",
  },
  {
    id: "10556",
    id_polifenol: "4537",
    polifenol: "flavone acetic acid",
    id_cancer: "581",
    cancer: "Non-Hodgkin Lymphoma",
    quant: "1",
    pmids: "3546183",
  },
  {
    id: "10557",
    id_polifenol: "2328",
    polifenol: "syringic acid",
    id_cancer: "581",
    cancer: "Non-Hodgkin Lymphoma",
    quant: "1",
    pmids: "23958424",
  },
  {
    id: "10558",
    id_polifenol: "2697",
    polifenol: "4-trifluoromethylsalicylic acid",
    id_cancer: "581",
    cancer: "Non-Hodgkin Lymphoma",
    quant: "1",
    pmids: "23958424",
  },
  {
    id: "10559",
    id_polifenol: "315",
    polifenol: "bakuchiol",
    id_cancer: "581",
    cancer: "Non-Hodgkin Lymphoma",
    quant: "1",
    pmids: "15607914",
  },
  {
    id: "10560",
    id_polifenol: "70",
    polifenol: "Sulfobromophthalein",
    id_cancer: "581",
    cancer: "Non-Hodgkin Lymphoma",
    quant: "1",
    pmids: "3884476",
  },
  {
    id: "10561",
    id_polifenol: "1675",
    polifenol: "catechol estrogen 3,4-quinone",
    id_cancer: "581",
    cancer: "Non-Hodgkin Lymphoma",
    quant: "1",
    pmids: "23994691",
  },
  {
    id: "10562",
    id_polifenol: "1106",
    polifenol: "1,1-bis(3'-indolyl)-1-(4-hydroxyphenyl)methane",
    id_cancer: "581",
    cancer: "Non-Hodgkin Lymphoma",
    quant: "1",
    pmids: "24515801",
  },
  {
    id: "10563",
    id_polifenol: "2169",
    polifenol: "ethyl protocatechuate",
    id_cancer: "581",
    cancer: "Non-Hodgkin Lymphoma",
    quant: "1",
    pmids: "23013270",
  },
  {
    id: "10564",
    id_polifenol: "6380",
    polifenol: "oroxin B",
    id_cancer: "581",
    cancer: "Non-Hodgkin Lymphoma",
    quant: "1",
    pmids: "26253462",
  },
  {
    id: "10565",
    id_polifenol: "2238",
    polifenol: "benzyl 2-hydroxy-3,6-dimethoxybenzoate",
    id_cancer: "581",
    cancer: "Non-Hodgkin Lymphoma",
    quant: "1",
    pmids: "23958424",
  },
  {
    id: "10566",
    id_polifenol: "3753",
    polifenol: "benzyl-2,6-dimethoxybenzoate",
    id_cancer: "581",
    cancer: "Non-Hodgkin Lymphoma",
    quant: "1",
    pmids: "23958424",
  },
  {
    id: "10567",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "16523",
    cancer: "B-Cell Lymphoma",
    quant: "4",
    pmids: "28092744,26367700,26622901,26424772",
  },
  {
    id: "10568",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "16523",
    cancer: "B-Cell Lymphoma",
    quant: "4",
    pmids: "10527691,17182546,26707143,29901131",
  },
  {
    id: "10569",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "16523",
    cancer: "B-Cell Lymphoma",
    quant: "1",
    pmids: "12801933",
  },
  {
    id: "10570",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "16523",
    cancer: "B-Cell Lymphoma",
    quant: "2",
    pmids: "28092744,29901131",
  },
  {
    id: "10571",
    id_polifenol: "2167",
    polifenol: "phenolic acid",
    id_cancer: "16523",
    cancer: "B-Cell Lymphoma",
    quant: "1",
    pmids: "29901131",
  },
  {
    id: "10572",
    id_polifenol: "125",
    polifenol: "Isoflavones",
    id_cancer: "16523",
    cancer: "B-Cell Lymphoma",
    quant: "1",
    pmids: "18936203",
  },
  {
    id: "10573",
    id_polifenol: "38",
    polifenol: "Gallic Acid",
    id_cancer: "16523",
    cancer: "B-Cell Lymphoma",
    quant: "1",
    pmids: "29033852",
  },
  {
    id: "10574",
    id_polifenol: "117",
    polifenol: "Luteolin",
    id_cancer: "16523",
    cancer: "B-Cell Lymphoma",
    quant: "1",
    pmids: "28789432",
  },
  {
    id: "10575",
    id_polifenol: "871",
    polifenol: "ABT-737",
    id_cancer: "16523",
    cancer: "B-Cell Lymphoma",
    quant: "6",
    pmids: "22971477,22689920,26707143,23667527,23966420,18451170",
  },
  {
    id: "10576",
    id_polifenol: "7",
    polifenol: "Capsaicin",
    id_cancer: "16523",
    cancer: "B-Cell Lymphoma",
    quant: "1",
    pmids: "10620629",
  },
  {
    id: "10577",
    id_polifenol: "4522",
    polifenol: "chrysin",
    id_cancer: "16523",
    cancer: "B-Cell Lymphoma",
    quant: "1",
    pmids: "26367700",
  },
  {
    id: "10578",
    id_polifenol: "6087",
    polifenol: "wogonin",
    id_cancer: "16523",
    cancer: "B-Cell Lymphoma",
    quant: "1",
    pmids: "28105213",
  },
  {
    id: "10579",
    id_polifenol: "4515",
    polifenol: "baicalin",
    id_cancer: "16523",
    cancer: "B-Cell Lymphoma",
    quant: "1",
    pmids: "29960296",
  },
  {
    id: "10580",
    id_polifenol: "4513",
    polifenol: "galangin",
    id_cancer: "16523",
    cancer: "B-Cell Lymphoma",
    quant: "1",
    pmids: "26367700",
  },
  {
    id: "10581",
    id_polifenol: "107",
    polifenol: "beta-Naphthoflavone",
    id_cancer: "16523",
    cancer: "B-Cell Lymphoma",
    quant: "1",
    pmids: "15371557",
  },
  {
    id: "10582",
    id_polifenol: "6068",
    polifenol: "pinocembrin",
    id_cancer: "16523",
    cancer: "B-Cell Lymphoma",
    quant: "1",
    pmids: "26367700",
  },
  {
    id: "10583",
    id_polifenol: "4516",
    polifenol: "diosmetin",
    id_cancer: "16523",
    cancer: "B-Cell Lymphoma",
    quant: "1",
    pmids: "28101201",
  },
  {
    id: "10584",
    id_polifenol: "7547",
    polifenol: "hyperoside",
    id_cancer: "16523",
    cancer: "B-Cell Lymphoma",
    quant: "1",
    pmids: "29067453",
  },
  {
    id: "10585",
    id_polifenol: "299",
    polifenol: "nitrophenylphosphate",
    id_cancer: "16523",
    cancer: "B-Cell Lymphoma",
    quant: "1",
    pmids: "6163825",
  },
  {
    id: "10586",
    id_polifenol: "1918",
    polifenol: "2,6-di-tert-butyl-4-(aminomethyl)phenol hydrochloride",
    id_cancer: "16523",
    cancer: "B-Cell Lymphoma",
    quant: "1",
    pmids: "10772918",
  },
  {
    id: "10587",
    id_polifenol: "4607",
    polifenol: "orientin",
    id_cancer: "16523",
    cancer: "B-Cell Lymphoma",
    quant: "1",
    pmids: "26622901",
  },
  {
    id: "10588",
    id_polifenol: "6093",
    polifenol: "pinobanksin",
    id_cancer: "16523",
    cancer: "B-Cell Lymphoma",
    quant: "1",
    pmids: "26367700",
  },
  {
    id: "10589",
    id_polifenol: "18",
    polifenol: "Hexachlorophene",
    id_cancer: "16523",
    cancer: "B-Cell Lymphoma",
    quant: "1",
    pmids: "19091460",
  },
  {
    id: "10590",
    id_polifenol: "5667",
    polifenol: "flavocoxid",
    id_cancer: "16523",
    cancer: "B-Cell Lymphoma",
    quant: "1",
    pmids: "26424772",
  },
  {
    id: "10591",
    id_polifenol: "6380",
    polifenol: "oroxin B",
    id_cancer: "16523",
    cancer: "B-Cell Lymphoma",
    quant: "1",
    pmids: "26253462",
  },
  {
    id: "10592",
    id_polifenol: "7485",
    polifenol:
      "kaempherol 3-O-beta-rhamnopyranosyl (1-6)-beta-D-glucopyranoside",
    id_cancer: "16523",
    cancer: "B-Cell Lymphoma",
    quant: "1",
    pmids: "29901131",
  },
  {
    id: "10593",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "602",
    cancer: "Astrocytomas",
    quant: "2",
    pmids: "8277312,24632069",
  },
  {
    id: "10594",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "602",
    cancer: "Astrocytomas",
    quant: "3",
    pmids: "16102725,18946510,24961640",
  },
  {
    id: "10595",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "602",
    cancer: "Astrocytomas",
    quant: "3",
    pmids: "18946510,14647974,21503893",
  },
  {
    id: "10596",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "602",
    cancer: "Astrocytomas",
    quant: "6",
    pmids: "19737348,17327470,21029458,10806212,10442636,18317690",
  },
  {
    id: "10597",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "602",
    cancer: "Astrocytomas",
    quant: "3",
    pmids: "24632069,14647974,21949717",
  },
  {
    id: "10598",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "602",
    cancer: "Astrocytomas",
    quant: "1",
    pmids: "24632069",
  },
  {
    id: "10599",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "602",
    cancer: "Astrocytomas",
    quant: "2",
    pmids: "14647974,23707757",
  },
  {
    id: "10600",
    id_polifenol: "2167",
    polifenol: "phenolic acid",
    id_cancer: "602",
    cancer: "Astrocytomas",
    quant: "1",
    pmids: "17440087",
  },
  {
    id: "10601",
    id_polifenol: "110",
    polifenol: "Chalcones",
    id_cancer: "602",
    cancer: "Astrocytomas",
    quant: "1",
    pmids: "24961640",
  },
  {
    id: "10602",
    id_polifenol: "117",
    polifenol: "Luteolin",
    id_cancer: "602",
    cancer: "Astrocytomas",
    quant: "1",
    pmids: "18946510",
  },
  {
    id: "10603",
    id_polifenol: "1",
    polifenol: "Phenols",
    id_cancer: "602",
    cancer: "Astrocytomas",
    quant: "1",
    pmids: "27163884",
  },
  {
    id: "10604",
    id_polifenol: "129",
    polifenol: "Rotenone",
    id_cancer: "602",
    cancer: "Astrocytomas",
    quant: "2",
    pmids: "19737348,26467198",
  },
  {
    id: "10605",
    id_polifenol: "121",
    polifenol: "Kaempferols",
    id_cancer: "602",
    cancer: "Astrocytomas",
    quant: "1",
    pmids: "18946510",
  },
  {
    id: "10606",
    id_polifenol: "6065",
    polifenol: "baicalein",
    id_cancer: "602",
    cancer: "Astrocytomas",
    quant: "1",
    pmids: "25447764",
  },
  {
    id: "10607",
    id_polifenol: "123",
    polifenol: "Rutin",
    id_cancer: "602",
    cancer: "Astrocytomas",
    quant: "1",
    pmids: "18946510",
  },
  {
    id: "10608",
    id_polifenol: "25",
    polifenol: "Butylated Hydroxytoluene",
    id_cancer: "602",
    cancer: "Astrocytomas",
    quant: "1",
    pmids: "17440087",
  },
  {
    id: "10609",
    id_polifenol: "15",
    polifenol: "Masoprocol",
    id_cancer: "602",
    cancer: "Astrocytomas",
    quant: "1",
    pmids: "9868534",
  },
  {
    id: "10610",
    id_polifenol: "4519",
    polifenol: "myricetin",
    id_cancer: "602",
    cancer: "Astrocytomas",
    quant: "1",
    pmids: "18946510",
  },
  {
    id: "10611",
    id_polifenol: "81",
    polifenol: "Fenofibrate",
    id_cancer: "602",
    cancer: "Astrocytomas",
    quant: "1",
    pmids: "25645911",
  },
  {
    id: "10612",
    id_polifenol: "94",
    polifenol: "Phloretin",
    id_cancer: "602",
    cancer: "Astrocytomas",
    quant: "1",
    pmids: "33341",
  },
  {
    id: "10613",
    id_polifenol: "87",
    polifenol: "Metoclopramide",
    id_cancer: "602",
    cancer: "Astrocytomas",
    quant: "1",
    pmids: "9482687",
  },
  {
    id: "10614",
    id_polifenol: "299",
    polifenol: "nitrophenylphosphate",
    id_cancer: "602",
    cancer: "Astrocytomas",
    quant: "1",
    pmids: "6183663",
  },
  {
    id: "10615",
    id_polifenol: "2331",
    polifenol: "8-(N,N-diethylamino)octyl-3,4,5-trimethoxybenzoate",
    id_cancer: "602",
    cancer: "Astrocytomas",
    quant: "1",
    pmids: "9868534",
  },
  {
    id: "10616",
    id_polifenol: "4052",
    polifenol: "bis-(3-(3',5'-di-tert-butyl-4'-hydroxyphenyl)propyl)sulfide",
    id_cancer: "602",
    cancer: "Astrocytomas",
    quant: "1",
    pmids: "24961640",
  },
  {
    id: "10617",
    id_polifenol: "1566",
    polifenol: "arvanil",
    id_cancer: "602",
    cancer: "Astrocytomas",
    quant: "1",
    pmids: "22820645",
  },
  {
    id: "10618",
    id_polifenol: "16",
    polifenol: "Chlorophenols",
    id_cancer: "602",
    cancer: "Astrocytomas",
    quant: "1",
    pmids: "17085958",
  },
  {
    id: "10619",
    id_polifenol: "6341",
    polifenol: "sideritoflavone",
    id_cancer: "602",
    cancer: "Astrocytomas",
    quant: "1",
    pmids: "8277312",
  },
  {
    id: "10620",
    id_polifenol: "95",
    polifenol: "Polyphloretin Phosphate",
    id_cancer: "602",
    cancer: "Astrocytomas",
    quant: "1",
    pmids: "33341",
  },
  {
    id: "10621",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "595",
    cancer: "Rhabdomyosarcoma",
    quant: "2",
    pmids: "26870944,27013795",
  },
  {
    id: "10622",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "595",
    cancer: "Rhabdomyosarcoma",
    quant: "6",
    pmids: "21109950,22201757,16550606,23408929,22469857,29370243",
  },
  {
    id: "10623",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "595",
    cancer: "Rhabdomyosarcoma",
    quant: "2",
    pmids: "16550606,25084316",
  },
  {
    id: "10624",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "595",
    cancer: "Rhabdomyosarcoma",
    quant: "3",
    pmids: "17519236,23615277,12543789",
  },
  {
    id: "10625",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "595",
    cancer: "Rhabdomyosarcoma",
    quant: "2",
    pmids: "18847459,7884554",
  },
  {
    id: "10626",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "595",
    cancer: "Rhabdomyosarcoma",
    quant: "3",
    pmids: "22289578,27013795,21480807",
  },
  {
    id: "10627",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "595",
    cancer: "Rhabdomyosarcoma",
    quant: "2",
    pmids: "24190483,15765923",
  },
  {
    id: "10628",
    id_polifenol: "2167",
    polifenol: "phenolic acid",
    id_cancer: "595",
    cancer: "Rhabdomyosarcoma",
    quant: "2",
    pmids: "27013795,24066943",
  },
  {
    id: "10629",
    id_polifenol: "49",
    polifenol: "Aspirin",
    id_cancer: "595",
    cancer: "Rhabdomyosarcoma",
    quant: "2",
    pmids: "15120641,26594113",
  },
  {
    id: "10630",
    id_polifenol: "109",
    polifenol: "Catechin",
    id_cancer: "595",
    cancer: "Rhabdomyosarcoma",
    quant: "1",
    pmids: "15765923",
  },
  {
    id: "10631",
    id_polifenol: "3089",
    polifenol: "1,1-diphenyl-2-picrylhydrazyl",
    id_cancer: "595",
    cancer: "Rhabdomyosarcoma",
    quant: "2",
    pmids: "22289578,24066943",
  },
  {
    id: "10632",
    id_polifenol: "38",
    polifenol: "Gallic Acid",
    id_cancer: "595",
    cancer: "Rhabdomyosarcoma",
    quant: "2",
    pmids: "22289578,21480807",
  },
  {
    id: "10633",
    id_polifenol: "117",
    polifenol: "Luteolin",
    id_cancer: "595",
    cancer: "Rhabdomyosarcoma",
    quant: "1",
    pmids: "27013795",
  },
  {
    id: "10634",
    id_polifenol: "129",
    polifenol: "Rotenone",
    id_cancer: "595",
    cancer: "Rhabdomyosarcoma",
    quant: "1",
    pmids: "18847459",
  },
  {
    id: "10635",
    id_polifenol: "121",
    polifenol: "Kaempferols",
    id_cancer: "595",
    cancer: "Rhabdomyosarcoma",
    quant: "1",
    pmids: "27013795",
  },
  {
    id: "10636",
    id_polifenol: "871",
    polifenol: "ABT-737",
    id_cancer: "595",
    cancer: "Rhabdomyosarcoma",
    quant: "1",
    pmids: "24133218",
  },
  {
    id: "10637",
    id_polifenol: "123",
    polifenol: "Rutin",
    id_cancer: "595",
    cancer: "Rhabdomyosarcoma",
    quant: "1",
    pmids: "26870944",
  },
  {
    id: "10638",
    id_polifenol: "6",
    polifenol: "Catechols",
    id_cancer: "595",
    cancer: "Rhabdomyosarcoma",
    quant: "1",
    pmids: "19275619",
  },
  {
    id: "10639",
    id_polifenol: "4559",
    polifenol: "theaflavin",
    id_cancer: "595",
    cancer: "Rhabdomyosarcoma",
    quant: "1",
    pmids: "15765923",
  },
  {
    id: "10640",
    id_polifenol: "969",
    polifenol: "3,4-dihydroxyphenacyl caffeate phenylpropanoid ester",
    id_cancer: "595",
    cancer: "Rhabdomyosarcoma",
    quant: "1",
    pmids: "21480807",
  },
  {
    id: "10641",
    id_polifenol: "452",
    polifenol: "acteoside",
    id_cancer: "595",
    cancer: "Rhabdomyosarcoma",
    quant: "3",
    pmids: "22289578,29166892,21480807",
  },
  {
    id: "10642",
    id_polifenol: "2697",
    polifenol: "4-trifluoromethylsalicylic acid",
    id_cancer: "595",
    cancer: "Rhabdomyosarcoma",
    quant: "1",
    pmids: "21811429",
  },
  {
    id: "10643",
    id_polifenol: "7437",
    polifenol: "kaempferol-3-O-rutinoside",
    id_cancer: "595",
    cancer: "Rhabdomyosarcoma",
    quant: "1",
    pmids: "27013795",
  },
  {
    id: "10644",
    id_polifenol: "1106",
    polifenol: "1,1-bis(3'-indolyl)-1-(4-hydroxyphenyl)methane",
    id_cancer: "595",
    cancer: "Rhabdomyosarcoma",
    quant: "1",
    pmids: "27144436",
  },
  {
    id: "10645",
    id_polifenol: "3665",
    polifenol: "3,5-di-tert-butyl-4-hydroxyanisole",
    id_cancer: "595",
    cancer: "Rhabdomyosarcoma",
    quant: "2",
    pmids: "22289578,21480807",
  },
  {
    id: "10646",
    id_polifenol: "3362",
    polifenol: "bastadin 4",
    id_cancer: "595",
    cancer: "Rhabdomyosarcoma",
    quant: "1",
    pmids: "29166892",
  },
  {
    id: "10647",
    id_polifenol: "7564",
    polifenol: "camelliaside B",
    id_cancer: "595",
    cancer: "Rhabdomyosarcoma",
    quant: "1",
    pmids: "29166892",
  },
  {
    id: "10648",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "549",
    cancer: "Laryngeal Cancer",
    quant: "2",
    pmids: "27551764,14649542",
  },
  {
    id: "10649",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "549",
    cancer: "Laryngeal Cancer",
    quant: "6",
    pmids: "21780253,28409156,29771044,25433549,23147641,24223665",
  },
  {
    id: "10650",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "549",
    cancer: "Laryngeal Cancer",
    quant: "4",
    pmids: "28868867,23351413,23317879,21078381",
  },
  {
    id: "10651",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "549",
    cancer: "Laryngeal Cancer",
    quant: "2",
    pmids: "27121018,26201192",
  },
  {
    id: "10652",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "549",
    cancer: "Laryngeal Cancer",
    quant: "2",
    pmids: "14649542,9688309",
  },
  {
    id: "10653",
    id_polifenol: "2167",
    polifenol: "phenolic acid",
    id_cancer: "549",
    cancer: "Laryngeal Cancer",
    quant: "1",
    pmids: "27470359",
  },
  {
    id: "10654",
    id_polifenol: "109",
    polifenol: "Catechin",
    id_cancer: "549",
    cancer: "Laryngeal Cancer",
    quant: "1",
    pmids: "21780253",
  },
  {
    id: "10655",
    id_polifenol: "3089",
    polifenol: "1,1-diphenyl-2-picrylhydrazyl",
    id_cancer: "549",
    cancer: "Laryngeal Cancer",
    quant: "1",
    pmids: "23351413",
  },
  {
    id: "10656",
    id_polifenol: "7235",
    polifenol: "silybin",
    id_cancer: "549",
    cancer: "Laryngeal Cancer",
    quant: "1",
    pmids: "18998509",
  },
  {
    id: "10657",
    id_polifenol: "129",
    polifenol: "Rotenone",
    id_cancer: "549",
    cancer: "Laryngeal Cancer",
    quant: "1",
    pmids: "23227042",
  },
  {
    id: "10658",
    id_polifenol: "285",
    polifenol: "bisphenol A",
    id_cancer: "549",
    cancer: "Laryngeal Cancer",
    quant: "1",
    pmids: "28466560",
  },
  {
    id: "10659",
    id_polifenol: "4502",
    polifenol: "fisetin",
    id_cancer: "549",
    cancer: "Laryngeal Cancer",
    quant: "1",
    pmids: "27551764",
  },
  {
    id: "10660",
    id_polifenol: "4500",
    polifenol: "procyanidin",
    id_cancer: "549",
    cancer: "Laryngeal Cancer",
    quant: "1",
    pmids: "29737742",
  },
  {
    id: "10661",
    id_polifenol: "4708",
    polifenol: "xanthohumol",
    id_cancer: "549",
    cancer: "Laryngeal Cancer",
    quant: "1",
    pmids: "26297991",
  },
  {
    id: "10662",
    id_polifenol: "4513",
    polifenol: "galangin",
    id_cancer: "549",
    cancer: "Laryngeal Cancer",
    quant: "1",
    pmids: "28677816",
  },
  {
    id: "10663",
    id_polifenol: "1380",
    polifenol: "shogaol",
    id_cancer: "549",
    cancer: "Laryngeal Cancer",
    quant: "1",
    pmids: "27470359",
  },
  {
    id: "10664",
    id_polifenol: "93",
    polifenol: "Phloroglucinol",
    id_cancer: "549",
    cancer: "Laryngeal Cancer",
    quant: "1",
    pmids: "24986654",
  },
  {
    id: "10665",
    id_polifenol: "1611",
    polifenol: "bis(4-hydroxycinnamoyl)methane",
    id_cancer: "549",
    cancer: "Laryngeal Cancer",
    quant: "1",
    pmids: "25433549",
  },
  {
    id: "10666",
    id_polifenol: "107",
    polifenol: "beta-Naphthoflavone",
    id_cancer: "549",
    cancer: "Laryngeal Cancer",
    quant: "1",
    pmids: "25218365",
  },
  {
    id: "10667",
    id_polifenol: "1672",
    polifenol: "B19 monocarbonyl curcumin",
    id_cancer: "549",
    cancer: "Laryngeal Cancer",
    quant: "1",
    pmids: "28409156",
  },
  {
    id: "10668",
    id_polifenol: "428",
    polifenol: "2,2'-bisphenol F",
    id_cancer: "549",
    cancer: "Laryngeal Cancer",
    quant: "1",
    pmids: "25433549",
  },
  {
    id: "10669",
    id_polifenol: "1662",
    polifenol: "BDMC-A",
    id_cancer: "549",
    cancer: "Laryngeal Cancer",
    quant: "1",
    pmids: "25433549",
  },
  {
    id: "10670",
    id_polifenol: "6460",
    polifenol: "ipriflavone",
    id_cancer: "549",
    cancer: "Laryngeal Cancer",
    quant: "1",
    pmids: "9688309",
  },
  {
    id: "10671",
    id_polifenol: "3936",
    polifenol: "sideroxylonal C",
    id_cancer: "549",
    cancer: "Laryngeal Cancer",
    quant: "1",
    pmids: "24986654",
  },
  {
    id: "10672",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "5758",
    cancer: "Leukemia, Erythroblastic, Acute",
    quant: "4",
    pmids: "21364620,28889333,24083712,25075019",
  },
  {
    id: "10673",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "5758",
    cancer: "Leukemia, Erythroblastic, Acute",
    quant: "2",
    pmids: "20332435,28199114",
  },
  {
    id: "10674",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "5758",
    cancer: "Leukemia, Erythroblastic, Acute",
    quant: "2",
    pmids: "23811288,22792417",
  },
  {
    id: "10675",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "5758",
    cancer: "Leukemia, Erythroblastic, Acute",
    quant: "3",
    pmids: "11571231,11390183,20372853",
  },
  {
    id: "10676",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "5758",
    cancer: "Leukemia, Erythroblastic, Acute",
    quant: "2",
    pmids: "24083712,25075019",
  },
  {
    id: "10677",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "5758",
    cancer: "Leukemia, Erythroblastic, Acute",
    quant: "1",
    pmids: "14609132",
  },
  {
    id: "10678",
    id_polifenol: "2167",
    polifenol: "phenolic acid",
    id_cancer: "5758",
    cancer: "Leukemia, Erythroblastic, Acute",
    quant: "2",
    pmids: "28889333,22792417",
  },
  {
    id: "10679",
    id_polifenol: "49",
    polifenol: "Aspirin",
    id_cancer: "5758",
    cancer: "Leukemia, Erythroblastic, Acute",
    quant: "1",
    pmids: "12680248",
  },
  {
    id: "10680",
    id_polifenol: "110",
    polifenol: "Chalcones",
    id_cancer: "5758",
    cancer: "Leukemia, Erythroblastic, Acute",
    quant: "2",
    pmids: "28390228,24494068",
  },
  {
    id: "10681",
    id_polifenol: "114",
    polifenol: "Apigenin",
    id_cancer: "5758",
    cancer: "Leukemia, Erythroblastic, Acute",
    quant: "1",
    pmids: "21364620",
  },
  {
    id: "10682",
    id_polifenol: "38",
    polifenol: "Gallic Acid",
    id_cancer: "5758",
    cancer: "Leukemia, Erythroblastic, Acute",
    quant: "2",
    pmids: "14609132,11497272",
  },
  {
    id: "10683",
    id_polifenol: "120",
    polifenol: "Flavonols",
    id_cancer: "5758",
    cancer: "Leukemia, Erythroblastic, Acute",
    quant: "1",
    pmids: "25075019",
  },
  {
    id: "10684",
    id_polifenol: "39",
    polifenol: "Hydrolyzable Tannins",
    id_cancer: "5758",
    cancer: "Leukemia, Erythroblastic, Acute",
    quant: "2",
    pmids: "11497272,28889333",
  },
  {
    id: "10685",
    id_polifenol: "15",
    polifenol: "Masoprocol",
    id_cancer: "5758",
    cancer: "Leukemia, Erythroblastic, Acute",
    quant: "1",
    pmids: "12110314",
  },
  {
    id: "10686",
    id_polifenol: "4519",
    polifenol: "myricetin",
    id_cancer: "5758",
    cancer: "Leukemia, Erythroblastic, Acute",
    quant: "1",
    pmids: "25075019",
  },
  {
    id: "10687",
    id_polifenol: "44",
    polifenol: "Salicylates",
    id_cancer: "5758",
    cancer: "Leukemia, Erythroblastic, Acute",
    quant: "2",
    pmids: "17646662,12680248",
  },
  {
    id: "10688",
    id_polifenol: "2344",
    polifenol: "methyl gallate",
    id_cancer: "5758",
    cancer: "Leukemia, Erythroblastic, Acute",
    quant: "1",
    pmids: "14609132",
  },
  {
    id: "10689",
    id_polifenol: "2158",
    polifenol: "protocatechuic acid",
    id_cancer: "5758",
    cancer: "Leukemia, Erythroblastic, Acute",
    quant: "1",
    pmids: "22792417",
  },
  {
    id: "10690",
    id_polifenol: "55",
    polifenol: "Sodium Salicylate",
    id_cancer: "5758",
    cancer: "Leukemia, Erythroblastic, Acute",
    quant: "2",
    pmids: "15328418,17646662",
  },
  {
    id: "10691",
    id_polifenol: "5844",
    polifenol: "4-dimethylamino-3',4'-dimethoxychalcone",
    id_cancer: "5758",
    cancer: "Leukemia, Erythroblastic, Acute",
    quant: "1",
    pmids: "10928117",
  },
  {
    id: "10692",
    id_polifenol: "99",
    polifenol: "Pyrogallol",
    id_cancer: "5758",
    cancer: "Leukemia, Erythroblastic, Acute",
    quant: "1",
    pmids: "12063567",
  },
  {
    id: "10693",
    id_polifenol: "100",
    polifenol: "Resorcinols",
    id_cancer: "5758",
    cancer: "Leukemia, Erythroblastic, Acute",
    quant: "1",
    pmids: "24494068",
  },
  {
    id: "10694",
    id_polifenol: "2447",
    polifenol: "beta-penta-O-galloyl-glucose",
    id_cancer: "5758",
    cancer: "Leukemia, Erythroblastic, Acute",
    quant: "1",
    pmids: "14609132",
  },
  {
    id: "10695",
    id_polifenol: "1810",
    polifenol: "heminordihydroguaiaretic acid",
    id_cancer: "5758",
    cancer: "Leukemia, Erythroblastic, Acute",
    quant: "1",
    pmids: "15958646",
  },
  {
    id: "10696",
    id_polifenol: "1353",
    polifenol: "protocatechualdehyde",
    id_cancer: "5758",
    cancer: "Leukemia, Erythroblastic, Acute",
    quant: "1",
    pmids: "28920346",
  },
  {
    id: "10697",
    id_polifenol: "3798",
    polifenol: "n-hexyl vanillate",
    id_cancer: "5758",
    cancer: "Leukemia, Erythroblastic, Acute",
    quant: "1",
    pmids: "23811288",
  },
  {
    id: "10698",
    id_polifenol: "886",
    polifenol: "4-(2-hydroxyphenyl)but-3-en-2-one",
    id_cancer: "5758",
    cancer: "Leukemia, Erythroblastic, Acute",
    quant: "1",
    pmids: "28920346",
  },
  {
    id: "10699",
    id_polifenol: "4079",
    polifenol: "gallacetophenone",
    id_cancer: "5758",
    cancer: "Leukemia, Erythroblastic, Acute",
    quant: "1",
    pmids: "14609132",
  },
  {
    id: "10700",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "616",
    cancer: "Malignant Mesothelioma",
    quant: "1",
    pmids: "22552784",
  },
  {
    id: "10701",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "616",
    cancer: "Malignant Mesothelioma",
    quant: "4",
    pmids: "22388865,28159921,25028262,28841784",
  },
  {
    id: "10702",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "616",
    cancer: "Malignant Mesothelioma",
    quant: "2",
    pmids: "22564432,27171110",
  },
  {
    id: "10703",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "616",
    cancer: "Malignant Mesothelioma",
    quant: "2",
    pmids: "20799280,16619474",
  },
  {
    id: "10704",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "616",
    cancer: "Malignant Mesothelioma",
    quant: "1",
    pmids: "28841784",
  },
  {
    id: "10705",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "616",
    cancer: "Malignant Mesothelioma",
    quant: "1",
    pmids: "28841784",
  },
  {
    id: "10706",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "616",
    cancer: "Malignant Mesothelioma",
    quant: "5",
    pmids: "22564432,23526965,29744892,24200995,28841784",
  },
  {
    id: "10707",
    id_polifenol: "49",
    polifenol: "Aspirin",
    id_cancer: "616",
    cancer: "Malignant Mesothelioma",
    quant: "2",
    pmids: "14961568,26068794",
  },
  {
    id: "10708",
    id_polifenol: "129",
    polifenol: "Rotenone",
    id_cancer: "616",
    cancer: "Malignant Mesothelioma",
    quant: "2",
    pmids: "25544756,24444362",
  },
  {
    id: "10709",
    id_polifenol: "7",
    polifenol: "Capsaicin",
    id_cancer: "616",
    cancer: "Malignant Mesothelioma",
    quant: "1",
    pmids: "28841784",
  },
  {
    id: "10710",
    id_polifenol: "111",
    polifenol: "Flavanones",
    id_cancer: "616",
    cancer: "Malignant Mesothelioma",
    quant: "1",
    pmids: "24130923",
  },
  {
    id: "10711",
    id_polifenol: "54",
    polifenol: "Salicylic Acid",
    id_cancer: "616",
    cancer: "Malignant Mesothelioma",
    quant: "1",
    pmids: "26068794",
  },
  {
    id: "10712",
    id_polifenol: "2344",
    polifenol: "methyl gallate",
    id_cancer: "616",
    cancer: "Malignant Mesothelioma",
    quant: "1",
    pmids: "22564432",
  },
  {
    id: "10713",
    id_polifenol: "112",
    polifenol: "Hesperidin",
    id_cancer: "616",
    cancer: "Malignant Mesothelioma",
    quant: "1",
    pmids: "24130923",
  },
  {
    id: "10714",
    id_polifenol: "4253",
    polifenol:
      "5-(2,4-dihydroxy-5-isopropylphenyl)-4-(4-morpholin-4-ylmethylphenyl)isoxazole-3-carboxylic acid ethylamide",
    id_cancer: "616",
    cancer: "Malignant Mesothelioma",
    quant: "2",
    pmids: "21996088,26870271",
  },
  {
    id: "10715",
    id_polifenol: "5806",
    polifenol: "butein",
    id_cancer: "616",
    cancer: "Malignant Mesothelioma",
    quant: "1",
    pmids: "22185775",
  },
  {
    id: "10716",
    id_polifenol: "5819",
    polifenol: "licochalcone A",
    id_cancer: "616",
    cancer: "Malignant Mesothelioma",
    quant: "1",
    pmids: "25586190",
  },
  {
    id: "10717",
    id_polifenol: "79",
    polifenol: "Clofibric Acid",
    id_cancer: "616",
    cancer: "Malignant Mesothelioma",
    quant: "1",
    pmids: "29892758",
  },
  {
    id: "10718",
    id_polifenol: "2794",
    polifenol: "salazinic acid",
    id_cancer: "616",
    cancer: "Malignant Mesothelioma",
    quant: "1",
    pmids: "19199230",
  },
  {
    id: "10719",
    id_polifenol: "2192",
    polifenol: "evernic acid",
    id_cancer: "616",
    cancer: "Malignant Mesothelioma",
    quant: "1",
    pmids: "19199230",
  },
  {
    id: "10720",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "552",
    cancer: "Nasopharyngeal Cancer",
    quant: "1",
    pmids: "22689083",
  },
  {
    id: "10721",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "552",
    cancer: "Nasopharyngeal Cancer",
    quant: "7",
    pmids: "19317462,23673810,28157708,27313684,16566718,20702493,29788875",
  },
  {
    id: "10722",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "552",
    cancer: "Nasopharyngeal Cancer",
    quant: "1",
    pmids: "25625511",
  },
  {
    id: "10723",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "552",
    cancer: "Nasopharyngeal Cancer",
    quant: "3",
    pmids: "23741254,22689083,19816982",
  },
  {
    id: "10724",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "552",
    cancer: "Nasopharyngeal Cancer",
    quant: "2",
    pmids: "23741254,20574925",
  },
  {
    id: "10725",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "552",
    cancer: "Nasopharyngeal Cancer",
    quant: "1",
    pmids: "14767529",
  },
  {
    id: "10726",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "552",
    cancer: "Nasopharyngeal Cancer",
    quant: "2",
    pmids: "25625511,25487615",
  },
  {
    id: "10727",
    id_polifenol: "114",
    polifenol: "Apigenin",
    id_cancer: "552",
    cancer: "Nasopharyngeal Cancer",
    quant: "1",
    pmids: "29604587",
  },
  {
    id: "10728",
    id_polifenol: "113",
    polifenol: "Flavones",
    id_cancer: "552",
    cancer: "Nasopharyngeal Cancer",
    quant: "1",
    pmids: "29604587",
  },
  {
    id: "10729",
    id_polifenol: "117",
    polifenol: "Luteolin",
    id_cancer: "552",
    cancer: "Nasopharyngeal Cancer",
    quant: "1",
    pmids: "29968360",
  },
  {
    id: "10730",
    id_polifenol: "129",
    polifenol: "Rotenone",
    id_cancer: "552",
    cancer: "Nasopharyngeal Cancer",
    quant: "1",
    pmids: "20574925",
  },
  {
    id: "10731",
    id_polifenol: "4634",
    polifenol: "alvocidib",
    id_cancer: "552",
    cancer: "Nasopharyngeal Cancer",
    quant: "1",
    pmids: "27965750",
  },
  {
    id: "10732",
    id_polifenol: "6087",
    polifenol: "wogonin",
    id_cancer: "552",
    cancer: "Nasopharyngeal Cancer",
    quant: "1",
    pmids: "22689083",
  },
  {
    id: "10733",
    id_polifenol: "4515",
    polifenol: "baicalin",
    id_cancer: "552",
    cancer: "Nasopharyngeal Cancer",
    quant: "1",
    pmids: "29416665",
  },
  {
    id: "10734",
    id_polifenol: "119",
    polifenol: "Silymarin",
    id_cancer: "552",
    cancer: "Nasopharyngeal Cancer",
    quant: "1",
    pmids: "24030447",
  },
  {
    id: "10735",
    id_polifenol: "108",
    polifenol: "Biflavonoids",
    id_cancer: "552",
    cancer: "Nasopharyngeal Cancer",
    quant: "1",
    pmids: "27292193",
  },
  {
    id: "10736",
    id_polifenol: "5850",
    polifenol: "cardamonin",
    id_cancer: "552",
    cancer: "Nasopharyngeal Cancer",
    quant: "1",
    pmids: "29048425",
  },
  {
    id: "10737",
    id_polifenol: "6558",
    polifenol: "7,3'-dihydroxy-4'-methoxyisoflavone",
    id_cancer: "552",
    cancer: "Nasopharyngeal Cancer",
    quant: "1",
    pmids: "29966979",
  },
  {
    id: "10738",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "3229",
    cancer: "Adenocarcinoma, Bronchiolo-Alveolar",
    quant: "3",
    pmids: "22687635,24976450,26966354",
  },
  {
    id: "10739",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "3229",
    cancer: "Adenocarcinoma, Bronchiolo-Alveolar",
    quant: "3",
    pmids: "23946685,28925159,22974604",
  },
  {
    id: "10740",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "3229",
    cancer: "Adenocarcinoma, Bronchiolo-Alveolar",
    quant: "1",
    pmids: "16009452",
  },
  {
    id: "10741",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "3229",
    cancer: "Adenocarcinoma, Bronchiolo-Alveolar",
    quant: "1",
    pmids: "11804877",
  },
  {
    id: "10742",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "3229",
    cancer: "Adenocarcinoma, Bronchiolo-Alveolar",
    quant: "2",
    pmids: "16525038,19138753",
  },
  {
    id: "10743",
    id_polifenol: "49",
    polifenol: "Aspirin",
    id_cancer: "3229",
    cancer: "Adenocarcinoma, Bronchiolo-Alveolar",
    quant: "1",
    pmids: "17535415",
  },
  {
    id: "10744",
    id_polifenol: "109",
    polifenol: "Catechin",
    id_cancer: "3229",
    cancer: "Adenocarcinoma, Bronchiolo-Alveolar",
    quant: "1",
    pmids: "16525038",
  },
  {
    id: "10745",
    id_polifenol: "871",
    polifenol: "ABT-737",
    id_cancer: "3229",
    cancer: "Adenocarcinoma, Bronchiolo-Alveolar",
    quant: "1",
    pmids: "24133218",
  },
  {
    id: "10746",
    id_polifenol: "25",
    polifenol: "Butylated Hydroxytoluene",
    id_cancer: "3229",
    cancer: "Adenocarcinoma, Bronchiolo-Alveolar",
    quant: "3",
    pmids: "25035812,4049395,1773786",
  },
  {
    id: "10747",
    id_polifenol: "75",
    polifenol: "Butylated Hydroxyanisole",
    id_cancer: "3229",
    cancer: "Adenocarcinoma, Bronchiolo-Alveolar",
    quant: "1",
    pmids: "12095135",
  },
  {
    id: "10748",
    id_polifenol: "6087",
    polifenol: "wogonin",
    id_cancer: "3229",
    cancer: "Adenocarcinoma, Bronchiolo-Alveolar",
    quant: "1",
    pmids: "24976450",
  },
  {
    id: "10749",
    id_polifenol: "5578",
    polifenol: "alpha-naphthoflavone",
    id_cancer: "3229",
    cancer: "Adenocarcinoma, Bronchiolo-Alveolar",
    quant: "1",
    pmids: "3004505",
  },
  {
    id: "10750",
    id_polifenol: "4708",
    polifenol: "xanthohumol",
    id_cancer: "3229",
    cancer: "Adenocarcinoma, Bronchiolo-Alveolar",
    quant: "1",
    pmids: "26664015",
  },
  {
    id: "10751",
    id_polifenol: "112",
    polifenol: "Hesperidin",
    id_cancer: "3229",
    cancer: "Adenocarcinoma, Bronchiolo-Alveolar",
    quant: "1",
    pmids: "11689289",
  },
  {
    id: "10752",
    id_polifenol: "1613",
    polifenol: "demethoxycurcumin",
    id_cancer: "3229",
    cancer: "Adenocarcinoma, Bronchiolo-Alveolar",
    quant: "1",
    pmids: "28925159",
  },
  {
    id: "10753",
    id_polifenol: "1611",
    polifenol: "bis(4-hydroxycinnamoyl)methane",
    id_cancer: "3229",
    cancer: "Adenocarcinoma, Bronchiolo-Alveolar",
    quant: "1",
    pmids: "28925159",
  },
  {
    id: "10754",
    id_polifenol: "107",
    polifenol: "beta-Naphthoflavone",
    id_cancer: "3229",
    cancer: "Adenocarcinoma, Bronchiolo-Alveolar",
    quant: "1",
    pmids: "3004505",
  },
  {
    id: "10755",
    id_polifenol: "969",
    polifenol: "3,4-dihydroxyphenacyl caffeate phenylpropanoid ester",
    id_cancer: "3229",
    cancer: "Adenocarcinoma, Bronchiolo-Alveolar",
    quant: "1",
    pmids: "24944685",
  },
  {
    id: "10756",
    id_polifenol: "300",
    polifenol: "rhodioloside",
    id_cancer: "3229",
    cancer: "Adenocarcinoma, Bronchiolo-Alveolar",
    quant: "1",
    pmids: "24944685",
  },
  {
    id: "10757",
    id_polifenol: "7912",
    polifenol: "7,9,2',4'-tetrahydroxy-8-isopentenyl-5-methoxychalcone",
    id_cancer: "3229",
    cancer: "Adenocarcinoma, Bronchiolo-Alveolar",
    quant: "1",
    pmids: "26664015",
  },
  {
    id: "10758",
    id_polifenol: "4585",
    polifenol: "baohuoside I",
    id_cancer: "3229",
    cancer: "Adenocarcinoma, Bronchiolo-Alveolar",
    quant: "1",
    pmids: "22687635",
  },
  {
    id: "10759",
    id_polifenol: "7134",
    polifenol: "vitexin",
    id_cancer: "3229",
    cancer: "Adenocarcinoma, Bronchiolo-Alveolar",
    quant: "1",
    pmids: "27387399",
  },
  {
    id: "10760",
    id_polifenol: "4715",
    polifenol: "ampelopsin",
    id_cancer: "3229",
    cancer: "Adenocarcinoma, Bronchiolo-Alveolar",
    quant: "1",
    pmids: "27609190",
  },
  {
    id: "10761",
    id_polifenol: "6112",
    polifenol: "alpinetin",
    id_cancer: "3229",
    cancer: "Adenocarcinoma, Bronchiolo-Alveolar",
    quant: "1",
    pmids: "26966354",
  },
  {
    id: "10762",
    id_polifenol: "7140",
    polifenol: "isovitexin",
    id_cancer: "3229",
    cancer: "Adenocarcinoma, Bronchiolo-Alveolar",
    quant: "1",
    pmids: "27387399",
  },
  {
    id: "10763",
    id_polifenol: "1934",
    polifenol: "2,6-di-tert-butyl-4-hydroxy-4-methyl-2,5-cyclohexadien-1-one",
    id_cancer: "3229",
    cancer: "Adenocarcinoma, Bronchiolo-Alveolar",
    quant: "1",
    pmids: "1773786",
  },
  {
    id: "10764",
    id_polifenol: "7210",
    polifenol: "luteolin-7-O-glucuronide",
    id_cancer: "3229",
    cancer: "Adenocarcinoma, Bronchiolo-Alveolar",
    quant: "1",
    pmids: "27387399",
  },
  {
    id: "10765",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "230104",
    cancer: "Hepatoblastoma",
    quant: "7",
    pmids: "26439681,26118776,24127655,29524880,24977707,22458642,21080643",
  },
  {
    id: "10766",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "230104",
    cancer: "Hepatoblastoma",
    quant: "1",
    pmids: "27354595",
  },
  {
    id: "10767",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "230104",
    cancer: "Hepatoblastoma",
    quant: "2",
    pmids: "27775667,12430003",
  },
  {
    id: "10768",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "230104",
    cancer: "Hepatoblastoma",
    quant: "1",
    pmids: "11334858",
  },
  {
    id: "10769",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "230104",
    cancer: "Hepatoblastoma",
    quant: "1",
    pmids: "24127655",
  },
  {
    id: "10770",
    id_polifenol: "2167",
    polifenol: "phenolic acid",
    id_cancer: "230104",
    cancer: "Hepatoblastoma",
    quant: "1",
    pmids: "22458642",
  },
  {
    id: "10771",
    id_polifenol: "109",
    polifenol: "Catechin",
    id_cancer: "230104",
    cancer: "Hepatoblastoma",
    quant: "1",
    pmids: "27775667",
  },
  {
    id: "10772",
    id_polifenol: "3089",
    polifenol: "1,1-diphenyl-2-picrylhydrazyl",
    id_cancer: "230104",
    cancer: "Hepatoblastoma",
    quant: "1",
    pmids: "11297806",
  },
  {
    id: "10773",
    id_polifenol: "871",
    polifenol: "ABT-737",
    id_cancer: "230104",
    cancer: "Hepatoblastoma",
    quant: "2",
    pmids: "23229825,25690034",
  },
  {
    id: "10774",
    id_polifenol: "7",
    polifenol: "Capsaicin",
    id_cancer: "230104",
    cancer: "Hepatoblastoma",
    quant: "1",
    pmids: "15190937",
  },
  {
    id: "10775",
    id_polifenol: "39",
    polifenol: "Hydrolyzable Tannins",
    id_cancer: "230104",
    cancer: "Hepatoblastoma",
    quant: "1",
    pmids: "27775667",
  },
  {
    id: "10776",
    id_polifenol: "5607",
    polifenol: "gallocatechol",
    id_cancer: "230104",
    cancer: "Hepatoblastoma",
    quant: "1",
    pmids: "27775667",
  },
  {
    id: "10777",
    id_polifenol: "112",
    polifenol: "Hesperidin",
    id_cancer: "230104",
    cancer: "Hepatoblastoma",
    quant: "2",
    pmids: "24977707,26492105",
  },
  {
    id: "10778",
    id_polifenol: "107",
    polifenol: "beta-Naphthoflavone",
    id_cancer: "230104",
    cancer: "Hepatoblastoma",
    quant: "1",
    pmids: "1340765",
  },
  {
    id: "10779",
    id_polifenol: "1995",
    polifenol: "2-tert-butylhydroquinone",
    id_cancer: "230104",
    cancer: "Hepatoblastoma",
    quant: "1",
    pmids: "22275372",
  },
  {
    id: "10780",
    id_polifenol: "4585",
    polifenol: "baohuoside I",
    id_cancer: "230104",
    cancer: "Hepatoblastoma",
    quant: "1",
    pmids: "26118776",
  },
  {
    id: "10781",
    id_polifenol: "2328",
    polifenol: "syringic acid",
    id_cancer: "230104",
    cancer: "Hepatoblastoma",
    quant: "1",
    pmids: "27775667",
  },
  {
    id: "10782",
    id_polifenol: "7198",
    polifenol: "homoorientin",
    id_cancer: "230104",
    cancer: "Hepatoblastoma",
    quant: "2",
    pmids: "29524880,21080643",
  },
  {
    id: "10783",
    id_polifenol: "1353",
    polifenol: "protocatechualdehyde",
    id_cancer: "230104",
    cancer: "Hepatoblastoma",
    quant: "1",
    pmids: "11297806",
  },
  {
    id: "10784",
    id_polifenol: "353",
    polifenol: "sesamol",
    id_cancer: "230104",
    cancer: "Hepatoblastoma",
    quant: "1",
    pmids: "11297806",
  },
  {
    id: "10785",
    id_polifenol: "5831",
    polifenol: "angoletin",
    id_cancer: "230104",
    cancer: "Hepatoblastoma",
    quant: "1",
    pmids: "22458642",
  },
  {
    id: "10786",
    id_polifenol: "3661",
    polifenol: "2-tert-butyl-4-hydroxyanisole",
    id_cancer: "230104",
    cancer: "Hepatoblastoma",
    quant: "1",
    pmids: "1340765",
  },
  {
    id: "10787",
    id_polifenol: "400",
    polifenol: "cardanol",
    id_cancer: "230104",
    cancer: "Hepatoblastoma",
    quant: "1",
    pmids: "22458642",
  },
  {
    id: "10788",
    id_polifenol: "343",
    polifenol: "2,5-dichloro-4-bromophenol",
    id_cancer: "230104",
    cancer: "Hepatoblastoma",
    quant: "1",
    pmids: "11238185",
  },
  {
    id: "10789",
    id_polifenol: "1402",
    polifenol: "2,4-dihydroxybenzylamine",
    id_cancer: "230104",
    cancer: "Hepatoblastoma",
    quant: "1",
    pmids: "11297806",
  },
  {
    id: "10790",
    id_polifenol: "4287",
    polifenol: "3,5-dihydroxybenzyl alcohol",
    id_cancer: "230104",
    cancer: "Hepatoblastoma",
    quant: "1",
    pmids: "23054715",
  },
  {
    id: "10791",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "16524",
    cancer: "Lymphoma, T-Cell",
    quant: "3",
    pmids: "27038396,22753749,29179521",
  },
  {
    id: "10792",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "16524",
    cancer: "Lymphoma, T-Cell",
    quant: "4",
    pmids: "9605420,21397623,25860911,20534395",
  },
  {
    id: "10793",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "16524",
    cancer: "Lymphoma, T-Cell",
    quant: "1",
    pmids: "27038396",
  },
  {
    id: "10794",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "16524",
    cancer: "Lymphoma, T-Cell",
    quant: "2",
    pmids: "12963487,14707277",
  },
  {
    id: "10795",
    id_polifenol: "49",
    polifenol: "Aspirin",
    id_cancer: "16524",
    cancer: "Lymphoma, T-Cell",
    quant: "4",
    pmids: "11205285,22893064,22421408,22104368",
  },
  {
    id: "10796",
    id_polifenol: "7235",
    polifenol: "silybin",
    id_cancer: "16524",
    cancer: "Lymphoma, T-Cell",
    quant: "1",
    pmids: "29179521",
  },
  {
    id: "10797",
    id_polifenol: "871",
    polifenol: "ABT-737",
    id_cancer: "16524",
    cancer: "Lymphoma, T-Cell",
    quant: "1",
    pmids: "22138435",
  },
  {
    id: "10798",
    id_polifenol: "6065",
    polifenol: "baicalein",
    id_cancer: "16524",
    cancer: "Lymphoma, T-Cell",
    quant: "1",
    pmids: "28864268",
  },
  {
    id: "10799",
    id_polifenol: "35",
    polifenol: "Hydroquinones",
    id_cancer: "16524",
    cancer: "Lymphoma, T-Cell",
    quant: "1",
    pmids: "22753749",
  },
  {
    id: "10800",
    id_polifenol: "1356",
    polifenol: "gingerol",
    id_cancer: "16524",
    cancer: "Lymphoma, T-Cell",
    quant: "1",
    pmids: "23110539",
  },
  {
    id: "10801",
    id_polifenol: "5819",
    polifenol: "licochalcone A",
    id_cancer: "16524",
    cancer: "Lymphoma, T-Cell",
    quant: "1",
    pmids: "27221781",
  },
  {
    id: "10802",
    id_polifenol: "5071",
    polifenol: "icaritin",
    id_cancer: "16524",
    cancer: "Lymphoma, T-Cell",
    quant: "1",
    pmids: "25887673",
  },
  {
    id: "10803",
    id_polifenol: "6783",
    polifenol: "protoapigenone",
    id_cancer: "16524",
    cancer: "Lymphoma, T-Cell",
    quant: "1",
    pmids: "22753749",
  },
  {
    id: "10804",
    id_polifenol: "299",
    polifenol: "nitrophenylphosphate",
    id_cancer: "16524",
    cancer: "Lymphoma, T-Cell",
    quant: "1",
    pmids: "6163825",
  },
  {
    id: "10805",
    id_polifenol: "1716",
    polifenol: "zingerone",
    id_cancer: "16524",
    cancer: "Lymphoma, T-Cell",
    quant: "1",
    pmids: "23110539",
  },
  {
    id: "10806",
    id_polifenol: "6459",
    polifenol: "genkwanin",
    id_cancer: "16524",
    cancer: "Lymphoma, T-Cell",
    quant: "1",
    pmids: "22753749",
  },
  {
    id: "10807",
    id_polifenol: "7614",
    polifenol: "quercetin 3-O-methyl ether",
    id_cancer: "16524",
    cancer: "Lymphoma, T-Cell",
    quant: "1",
    pmids: "27038396",
  },
  {
    id: "10808",
    id_polifenol: "6647",
    polifenol: "6-methylflavone",
    id_cancer: "16524",
    cancer: "Lymphoma, T-Cell",
    quant: "1",
    pmids: "22753749",
  },
  {
    id: "10809",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "3744",
    cancer: "Chondrosarcoma",
    quant: "2",
    pmids: "24975661,27056897",
  },
  {
    id: "10810",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "3744",
    cancer: "Chondrosarcoma",
    quant: "1",
    pmids: "22522053",
  },
  {
    id: "10811",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "3744",
    cancer: "Chondrosarcoma",
    quant: "2",
    pmids: "21328612,25936406",
  },
  {
    id: "10812",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "3744",
    cancer: "Chondrosarcoma",
    quant: "9",
    pmids:
      "17683952,19301259,19475568,21453685,21391218,19399830,20506523,12180971,15880812",
  },
  {
    id: "10813",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "3744",
    cancer: "Chondrosarcoma",
    quant: "2",
    pmids: "21328612,10772904",
  },
  {
    id: "10814",
    id_polifenol: "110",
    polifenol: "Chalcones",
    id_cancer: "3744",
    cancer: "Chondrosarcoma",
    quant: "1",
    pmids: "9591187",
  },
  {
    id: "10815",
    id_polifenol: "39",
    polifenol: "Hydrolyzable Tannins",
    id_cancer: "3744",
    cancer: "Chondrosarcoma",
    quant: "1",
    pmids: "9591187",
  },
  {
    id: "10816",
    id_polifenol: "6063",
    polifenol: "naringin",
    id_cancer: "3744",
    cancer: "Chondrosarcoma",
    quant: "1",
    pmids: "24975661",
  },
  {
    id: "10817",
    id_polifenol: "93",
    polifenol: "Phloroglucinol",
    id_cancer: "3744",
    cancer: "Chondrosarcoma",
    quant: "1",
    pmids: "20067774",
  },
  {
    id: "10818",
    id_polifenol: "5850",
    polifenol: "cardamonin",
    id_cancer: "3744",
    cancer: "Chondrosarcoma",
    quant: "1",
    pmids: "9591187",
  },
  {
    id: "10819",
    id_polifenol: "4585",
    polifenol: "baohuoside I",
    id_cancer: "3744",
    cancer: "Chondrosarcoma",
    quant: "1",
    pmids: "27056897",
  },
  {
    id: "10820",
    id_polifenol: "2697",
    polifenol: "4-trifluoromethylsalicylic acid",
    id_cancer: "3744",
    cancer: "Chondrosarcoma",
    quant: "1",
    pmids: "21811429",
  },
  {
    id: "10821",
    id_polifenol: "3997",
    polifenol: "2,4-bis(2-fluorophenylacetyl)phloroglucinol",
    id_cancer: "3744",
    cancer: "Chondrosarcoma",
    quant: "1",
    pmids: "20067774",
  },
  {
    id: "10822",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "3753",
    cancer: "Choriocarcinoma",
    quant: "3",
    pmids: "26970256,8808829,16608212",
  },
  {
    id: "10823",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "3753",
    cancer: "Choriocarcinoma",
    quant: "1",
    pmids: "27580989",
  },
  {
    id: "10824",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "3753",
    cancer: "Choriocarcinoma",
    quant: "1",
    pmids: "11466319",
  },
  {
    id: "10825",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "3753",
    cancer: "Choriocarcinoma",
    quant: "3",
    pmids: "22866146,19549922,26850786",
  },
  {
    id: "10826",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "3753",
    cancer: "Choriocarcinoma",
    quant: "1",
    pmids: "27714811",
  },
  {
    id: "10827",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "3753",
    cancer: "Choriocarcinoma",
    quant: "1",
    pmids: "28462491",
  },
  {
    id: "10828",
    id_polifenol: "2167",
    polifenol: "phenolic acid",
    id_cancer: "3753",
    cancer: "Choriocarcinoma",
    quant: "1",
    pmids: "27580989",
  },
  {
    id: "10829",
    id_polifenol: "114",
    polifenol: "Apigenin",
    id_cancer: "3753",
    cancer: "Choriocarcinoma",
    quant: "1",
    pmids: "26970256",
  },
  {
    id: "10830",
    id_polifenol: "7235",
    polifenol: "silybin",
    id_cancer: "3753",
    cancer: "Choriocarcinoma",
    quant: "1",
    pmids: "28657208",
  },
  {
    id: "10831",
    id_polifenol: "6451",
    polifenol: "daidzein",
    id_cancer: "3753",
    cancer: "Choriocarcinoma",
    quant: "2",
    pmids: "29436666,28849226",
  },
  {
    id: "10832",
    id_polifenol: "120",
    polifenol: "Flavonols",
    id_cancer: "3753",
    cancer: "Choriocarcinoma",
    quant: "1",
    pmids: "27714811",
  },
  {
    id: "10833",
    id_polifenol: "4519",
    polifenol: "myricetin",
    id_cancer: "3753",
    cancer: "Choriocarcinoma",
    quant: "1",
    pmids: "28428076",
  },
  {
    id: "10834",
    id_polifenol: "4708",
    polifenol: "xanthohumol",
    id_cancer: "3753",
    cancer: "Choriocarcinoma",
    quant: "1",
    pmids: "16608212",
  },
  {
    id: "10835",
    id_polifenol: "126",
    polifenol: "Coumestrol",
    id_cancer: "3753",
    cancer: "Choriocarcinoma",
    quant: "1",
    pmids: "29040664",
  },
  {
    id: "10836",
    id_polifenol: "6463",
    polifenol: "puerarin",
    id_cancer: "3753",
    cancer: "Choriocarcinoma",
    quant: "1",
    pmids: "28352705",
  },
  {
    id: "10837",
    id_polifenol: "118",
    polifenol: "Flavonolignans",
    id_cancer: "3753",
    cancer: "Choriocarcinoma",
    quant: "1",
    pmids: "28657208",
  },
  {
    id: "10838",
    id_polifenol: "6097",
    polifenol: "8-prenylnaringenin",
    id_cancer: "3753",
    cancer: "Choriocarcinoma",
    quant: "1",
    pmids: "16608212",
  },
  {
    id: "10839",
    id_polifenol: "7134",
    polifenol: "vitexin",
    id_cancer: "3753",
    cancer: "Choriocarcinoma",
    quant: "1",
    pmids: "22228428",
  },
  {
    id: "10840",
    id_polifenol: "79",
    polifenol: "Clofibric Acid",
    id_cancer: "3753",
    cancer: "Choriocarcinoma",
    quant: "1",
    pmids: "8070357",
  },
  {
    id: "10841",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "483",
    cancer: "Kaposi Sarcoma",
    quant: "3",
    pmids: "17302199,19213570,20883688",
  },
  {
    id: "10842",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "483",
    cancer: "Kaposi Sarcoma",
    quant: "1",
    pmids: "15269163",
  },
  {
    id: "10843",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "483",
    cancer: "Kaposi Sarcoma",
    quant: "3",
    pmids: "28801242,10543991,10092829",
  },
  {
    id: "10844",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "483",
    cancer: "Kaposi Sarcoma",
    quant: "1",
    pmids: "15855650",
  },
  {
    id: "10845",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "483",
    cancer: "Kaposi Sarcoma",
    quant: "1",
    pmids: "28801242",
  },
  {
    id: "10846",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "483",
    cancer: "Kaposi Sarcoma",
    quant: "3",
    pmids: "17302199,15269163,17127716",
  },
  {
    id: "10847",
    id_polifenol: "2167",
    polifenol: "phenolic acid",
    id_cancer: "483",
    cancer: "Kaposi Sarcoma",
    quant: "1",
    pmids: "16580641",
  },
  {
    id: "10848",
    id_polifenol: "1",
    polifenol: "Phenols",
    id_cancer: "483",
    cancer: "Kaposi Sarcoma",
    quant: "1",
    pmids: "11520941",
  },
  {
    id: "10849",
    id_polifenol: "129",
    polifenol: "Rotenone",
    id_cancer: "483",
    cancer: "Kaposi Sarcoma",
    quant: "1",
    pmids: "29975946",
  },
  {
    id: "10850",
    id_polifenol: "4634",
    polifenol: "alvocidib",
    id_cancer: "483",
    cancer: "Kaposi Sarcoma",
    quant: "2",
    pmids: "12460995,15023361",
  },
  {
    id: "10851",
    id_polifenol: "2344",
    polifenol: "methyl gallate",
    id_cancer: "483",
    cancer: "Kaposi Sarcoma",
    quant: "1",
    pmids: "15269163",
  },
  {
    id: "10852",
    id_polifenol: "4708",
    polifenol: "xanthohumol",
    id_cancer: "483",
    cancer: "Kaposi Sarcoma",
    quant: "3",
    pmids: "17302199,21616523,17127716",
  },
  {
    id: "10853",
    id_polifenol: "112",
    polifenol: "Hesperidin",
    id_cancer: "483",
    cancer: "Kaposi Sarcoma",
    quant: "1",
    pmids: "20883688",
  },
  {
    id: "10854",
    id_polifenol: "119",
    polifenol: "Silymarin",
    id_cancer: "483",
    cancer: "Kaposi Sarcoma",
    quant: "1",
    pmids: "22710359",
  },
  {
    id: "10855",
    id_polifenol: "126",
    polifenol: "Coumestrol",
    id_cancer: "483",
    cancer: "Kaposi Sarcoma",
    quant: "1",
    pmids: "29975946",
  },
  {
    id: "10856",
    id_polifenol: "5844",
    polifenol: "4-dimethylamino-3',4'-dimethoxychalcone",
    id_cancer: "483",
    cancer: "Kaposi Sarcoma",
    quant: "1",
    pmids: "8620507",
  },
  {
    id: "10857",
    id_polifenol: "77",
    polifenol: "Bezafibrate",
    id_cancer: "483",
    cancer: "Kaposi Sarcoma",
    quant: "1",
    pmids: "16574099",
  },
  {
    id: "10858",
    id_polifenol: "830",
    polifenol: "yuccaol D",
    id_cancer: "483",
    cancer: "Kaposi Sarcoma",
    quant: "1",
    pmids: "16580641",
  },
  {
    id: "10859",
    id_polifenol: "838",
    polifenol: "yuccaol C",
    id_cancer: "483",
    cancer: "Kaposi Sarcoma",
    quant: "1",
    pmids: "16580641",
  },
  {
    id: "10860",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "8639",
    cancer: "Leukemia L1210",
    quant: "1",
    pmids: "17447850",
  },
  {
    id: "10861",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "8639",
    cancer: "Leukemia L1210",
    quant: "1",
    pmids: "1786398",
  },
  {
    id: "10862",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "8639",
    cancer: "Leukemia L1210",
    quant: "1",
    pmids: "10368649",
  },
  {
    id: "10863",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "8639",
    cancer: "Leukemia L1210",
    quant: "1",
    pmids: "11395569",
  },
  {
    id: "10864",
    id_polifenol: "109",
    polifenol: "Catechin",
    id_cancer: "8639",
    cancer: "Leukemia L1210",
    quant: "1",
    pmids: "9875442",
  },
  {
    id: "10865",
    id_polifenol: "110",
    polifenol: "Chalcones",
    id_cancer: "8639",
    cancer: "Leukemia L1210",
    quant: "3",
    pmids: "9544201,16055334,2362275",
  },
  {
    id: "10866",
    id_polifenol: "3089",
    polifenol: "1,1-diphenyl-2-picrylhydrazyl",
    id_cancer: "8639",
    cancer: "Leukemia L1210",
    quant: "1",
    pmids: "12530012",
  },
  {
    id: "10867",
    id_polifenol: "113",
    polifenol: "Flavones",
    id_cancer: "8639",
    cancer: "Leukemia L1210",
    quant: "1",
    pmids: "3708611",
  },
  {
    id: "10868",
    id_polifenol: "1",
    polifenol: "Phenols",
    id_cancer: "8639",
    cancer: "Leukemia L1210",
    quant: "1",
    pmids: "6788955",
  },
  {
    id: "10869",
    id_polifenol: "129",
    polifenol: "Rotenone",
    id_cancer: "8639",
    cancer: "Leukemia L1210",
    quant: "1",
    pmids: "1000513",
  },
  {
    id: "10870",
    id_polifenol: "121",
    polifenol: "Kaempferols",
    id_cancer: "8639",
    cancer: "Leukemia L1210",
    quant: "1",
    pmids: "17447850",
  },
  {
    id: "10871",
    id_polifenol: "6065",
    polifenol: "baicalein",
    id_cancer: "8639",
    cancer: "Leukemia L1210",
    quant: "1",
    pmids: "12530012",
  },
  {
    id: "10872",
    id_polifenol: "123",
    polifenol: "Rutin",
    id_cancer: "8639",
    cancer: "Leukemia L1210",
    quant: "1",
    pmids: "17447850",
  },
  {
    id: "10873",
    id_polifenol: "35",
    polifenol: "Hydroquinones",
    id_cancer: "8639",
    cancer: "Leukemia L1210",
    quant: "1",
    pmids: "17722905",
  },
  {
    id: "10874",
    id_polifenol: "6",
    polifenol: "Catechols",
    id_cancer: "8639",
    cancer: "Leukemia L1210",
    quant: "2",
    pmids: "6788955,6771000",
  },
  {
    id: "10875",
    id_polifenol: "4519",
    polifenol: "myricetin",
    id_cancer: "8639",
    cancer: "Leukemia L1210",
    quant: "1",
    pmids: "17447850",
  },
  {
    id: "10876",
    id_polifenol: "4515",
    polifenol: "baicalin",
    id_cancer: "8639",
    cancer: "Leukemia L1210",
    quant: "1",
    pmids: "12530012",
  },
  {
    id: "10877",
    id_polifenol: "7550",
    polifenol: "3-methylquercetin",
    id_cancer: "8639",
    cancer: "Leukemia L1210",
    quant: "1",
    pmids: "17447850",
  },
  {
    id: "10878",
    id_polifenol: "4537",
    polifenol: "flavone acetic acid",
    id_cancer: "8639",
    cancer: "Leukemia L1210",
    quant: "2",
    pmids: "3546183,3708611",
  },
  {
    id: "10879",
    id_polifenol: "80",
    polifenol: "Clofibrate",
    id_cancer: "8639",
    cancer: "Leukemia L1210",
    quant: "1",
    pmids: "1403680",
  },
  {
    id: "10880",
    id_polifenol: "60",
    polifenol: "2,4-Dinitrophenol",
    id_cancer: "8639",
    cancer: "Leukemia L1210",
    quant: "1",
    pmids: "7214322",
  },
  {
    id: "10881",
    id_polifenol: "1364",
    polifenol: "4-methylcatechol",
    id_cancer: "8639",
    cancer: "Leukemia L1210",
    quant: "1",
    pmids: "6788955",
  },
  {
    id: "10882",
    id_polifenol: "1372",
    polifenol: "3-methylcatechol",
    id_cancer: "8639",
    cancer: "Leukemia L1210",
    quant: "1",
    pmids: "6788955",
  },
  {
    id: "10883",
    id_polifenol: "7878",
    polifenol: "MDL 27048",
    id_cancer: "8639",
    cancer: "Leukemia L1210",
    quant: "1",
    pmids: "2362275",
  },
  {
    id: "10884",
    id_polifenol: "1705",
    polifenol: "hylin",
    id_cancer: "8639",
    cancer: "Leukemia L1210",
    quant: "1",
    pmids: "20696583",
  },
  {
    id: "10885",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "988",
    cancer: "Tumor Hypoxia",
    quant: "3",
    pmids: "23969634,22684842,21550553",
  },
  {
    id: "10886",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "988",
    cancer: "Tumor Hypoxia",
    quant: "2",
    pmids: "23225435,22952749",
  },
  {
    id: "10887",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "988",
    cancer: "Tumor Hypoxia",
    quant: "2",
    pmids: "27498957,21671859",
  },
  {
    id: "10888",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "988",
    cancer: "Tumor Hypoxia",
    quant: "1",
    pmids: "15031672",
  },
  {
    id: "10889",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "988",
    cancer: "Tumor Hypoxia",
    quant: "1",
    pmids: "22684842",
  },
  {
    id: "10890",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "988",
    cancer: "Tumor Hypoxia",
    quant: "1",
    pmids: "23725836",
  },
  {
    id: "10891",
    id_polifenol: "113",
    polifenol: "Flavones",
    id_cancer: "988",
    cancer: "Tumor Hypoxia",
    quant: "1",
    pmids: "28104392",
  },
  {
    id: "10892",
    id_polifenol: "129",
    polifenol: "Rotenone",
    id_cancer: "988",
    cancer: "Tumor Hypoxia",
    quant: "2",
    pmids: "19091749,22120717",
  },
  {
    id: "10893",
    id_polifenol: "4634",
    polifenol: "alvocidib",
    id_cancer: "988",
    cancer: "Tumor Hypoxia",
    quant: "1",
    pmids: "16024616",
  },
  {
    id: "10894",
    id_polifenol: "4522",
    polifenol: "chrysin",
    id_cancer: "988",
    cancer: "Tumor Hypoxia",
    quant: "1",
    pmids: "23969634",
  },
  {
    id: "10895",
    id_polifenol: "35",
    polifenol: "Hydroquinones",
    id_cancer: "988",
    cancer: "Tumor Hypoxia",
    quant: "1",
    pmids: "21671859",
  },
  {
    id: "10896",
    id_polifenol: "98",
    polifenol: "Propofol",
    id_cancer: "988",
    cancer: "Tumor Hypoxia",
    quant: "1",
    pmids: "28426124",
  },
  {
    id: "10897",
    id_polifenol: "4253",
    polifenol:
      "5-(2,4-dihydroxy-5-isopropylphenyl)-4-(4-morpholin-4-ylmethylphenyl)isoxazole-3-carboxylic acid ethylamide",
    id_cancer: "988",
    cancer: "Tumor Hypoxia",
    quant: "1",
    pmids: "22347438",
  },
  {
    id: "10898",
    id_polifenol: "4537",
    polifenol: "flavone acetic acid",
    id_cancer: "988",
    cancer: "Tumor Hypoxia",
    quant: "2",
    pmids: "21550553,2790784",
  },
  {
    id: "10899",
    id_polifenol: "59",
    polifenol: "Dinitrophenols",
    id_cancer: "988",
    cancer: "Tumor Hypoxia",
    quant: "1",
    pmids: "21155627",
  },
  {
    id: "10900",
    id_polifenol: "7156",
    polifenol: "scutellarein",
    id_cancer: "988",
    cancer: "Tumor Hypoxia",
    quant: "1",
    pmids: "28104392",
  },
  {
    id: "10901",
    id_polifenol: "6291",
    polifenol: "alpinumisoflavone",
    id_cancer: "988",
    cancer: "Tumor Hypoxia",
    quant: "1",
    pmids: "19091749",
  },
  {
    id: "10902",
    id_polifenol: "6699",
    polifenol: "4'-O-methylalpinumisoflavone",
    id_cancer: "988",
    cancer: "Tumor Hypoxia",
    quant: "1",
    pmids: "19091749",
  },
  {
    id: "10903",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "480",
    cancer: "AIDS-Related Cancers",
    quant: "1",
    pmids: "19212101",
  },
  {
    id: "10904",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "480",
    cancer: "AIDS-Related Cancers",
    quant: "1",
    pmids: "7786295",
  },
  {
    id: "10905",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "480",
    cancer: "AIDS-Related Cancers",
    quant: "1",
    pmids: "10543991",
  },
  {
    id: "10906",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "480",
    cancer: "AIDS-Related Cancers",
    quant: "1",
    pmids: "1612749",
  },
  {
    id: "10907",
    id_polifenol: "109",
    polifenol: "Catechin",
    id_cancer: "480",
    cancer: "AIDS-Related Cancers",
    quant: "1",
    pmids: "19212101",
  },
  {
    id: "10908",
    id_polifenol: "113",
    polifenol: "Flavones",
    id_cancer: "480",
    cancer: "AIDS-Related Cancers",
    quant: "3",
    pmids: "26411959,9516149,28709077",
  },
  {
    id: "10909",
    id_polifenol: "1",
    polifenol: "Phenols",
    id_cancer: "480",
    cancer: "AIDS-Related Cancers",
    quant: "2",
    pmids: "21843795,11520941",
  },
  {
    id: "10910",
    id_polifenol: "6065",
    polifenol: "baicalein",
    id_cancer: "480",
    cancer: "AIDS-Related Cancers",
    quant: "1",
    pmids: "26411959",
  },
  {
    id: "10911",
    id_polifenol: "4634",
    polifenol: "alvocidib",
    id_cancer: "480",
    cancer: "AIDS-Related Cancers",
    quant: "5",
    pmids: "11960328,24886624,14670589,9516149,18473913",
  },
  {
    id: "10912",
    id_polifenol: "130",
    polifenol: "Proanthocyanidins",
    id_cancer: "480",
    cancer: "AIDS-Related Cancers",
    quant: "1",
    pmids: "10962138",
  },
  {
    id: "10913",
    id_polifenol: "6",
    polifenol: "Catechols",
    id_cancer: "480",
    cancer: "AIDS-Related Cancers",
    quant: "1",
    pmids: "8019435",
  },
  {
    id: "10914",
    id_polifenol: "5844",
    polifenol: "4-dimethylamino-3',4'-dimethoxychalcone",
    id_cancer: "480",
    cancer: "AIDS-Related Cancers",
    quant: "1",
    pmids: "8620507",
  },
  {
    id: "10915",
    id_polifenol: "7853",
    polifenol: "Grape Seed Proanthocyanidins",
    id_cancer: "480",
    cancer: "AIDS-Related Cancers",
    quant: "1",
    pmids: "10962138",
  },
  {
    id: "10916",
    id_polifenol: "2331",
    polifenol: "8-(N,N-diethylamino)octyl-3,4,5-trimethoxybenzoate",
    id_cancer: "480",
    cancer: "AIDS-Related Cancers",
    quant: "1",
    pmids: "14715401",
  },
  {
    id: "10917",
    id_polifenol: "1394",
    polifenol: "nitecapone",
    id_cancer: "480",
    cancer: "AIDS-Related Cancers",
    quant: "1",
    pmids: "8019435",
  },
  {
    id: "10918",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "18148",
    cancer: "Neoplasms, Squamous Cell",
    quant: "2",
    pmids: "18362328,15769122",
  },
  {
    id: "10919",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "18148",
    cancer: "Neoplasms, Squamous Cell",
    quant: "4",
    pmids: "21576562,29103764,25573684,21821700",
  },
  {
    id: "10920",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "18148",
    cancer: "Neoplasms, Squamous Cell",
    quant: "2",
    pmids: "15769122,17261341",
  },
  {
    id: "10921",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "18148",
    cancer: "Neoplasms, Squamous Cell",
    quant: "1",
    pmids: "19157822",
  },
  {
    id: "10922",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "18148",
    cancer: "Neoplasms, Squamous Cell",
    quant: "3",
    pmids: "11316564,10453436,29345579",
  },
  {
    id: "10923",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "18148",
    cancer: "Neoplasms, Squamous Cell",
    quant: "2",
    pmids: "29103764,28641180",
  },
  {
    id: "10924",
    id_polifenol: "2167",
    polifenol: "phenolic acid",
    id_cancer: "18148",
    cancer: "Neoplasms, Squamous Cell",
    quant: "2",
    pmids: "15769122,26347954",
  },
  {
    id: "10925",
    id_polifenol: "109",
    polifenol: "Catechin",
    id_cancer: "18148",
    cancer: "Neoplasms, Squamous Cell",
    quant: "2",
    pmids: "15769122,15145696",
  },
  {
    id: "10926",
    id_polifenol: "125",
    polifenol: "Isoflavones",
    id_cancer: "18148",
    cancer: "Neoplasms, Squamous Cell",
    quant: "1",
    pmids: "29345579",
  },
  {
    id: "10927",
    id_polifenol: "38",
    polifenol: "Gallic Acid",
    id_cancer: "18148",
    cancer: "Neoplasms, Squamous Cell",
    quant: "1",
    pmids: "15769122",
  },
  {
    id: "10928",
    id_polifenol: "117",
    polifenol: "Luteolin",
    id_cancer: "18148",
    cancer: "Neoplasms, Squamous Cell",
    quant: "1",
    pmids: "18362328",
  },
  {
    id: "10929",
    id_polifenol: "4522",
    polifenol: "chrysin",
    id_cancer: "18148",
    cancer: "Neoplasms, Squamous Cell",
    quant: "1",
    pmids: "26347954",
  },
  {
    id: "10930",
    id_polifenol: "75",
    polifenol: "Butylated Hydroxyanisole",
    id_cancer: "18148",
    cancer: "Neoplasms, Squamous Cell",
    quant: "1",
    pmids: "8910953",
  },
  {
    id: "10931",
    id_polifenol: "4513",
    polifenol: "galangin",
    id_cancer: "18148",
    cancer: "Neoplasms, Squamous Cell",
    quant: "1",
    pmids: "26347954",
  },
  {
    id: "10932",
    id_polifenol: "6068",
    polifenol: "pinocembrin",
    id_cancer: "18148",
    cancer: "Neoplasms, Squamous Cell",
    quant: "1",
    pmids: "26347954",
  },
  {
    id: "10933",
    id_polifenol: "6100",
    polifenol: "pinostrobin",
    id_cancer: "18148",
    cancer: "Neoplasms, Squamous Cell",
    quant: "1",
    pmids: "26347954",
  },
  {
    id: "10934",
    id_polifenol: "6093",
    polifenol: "pinobanksin",
    id_cancer: "18148",
    cancer: "Neoplasms, Squamous Cell",
    quant: "1",
    pmids: "26347954",
  },
  {
    id: "10935",
    id_polifenol: "4764",
    polifenol: "tectochrysin",
    id_cancer: "18148",
    cancer: "Neoplasms, Squamous Cell",
    quant: "1",
    pmids: "26347954",
  },
  {
    id: "10936",
    id_polifenol: "6642",
    polifenol: "6,7-dihydroxyflavone",
    id_cancer: "18148",
    cancer: "Neoplasms, Squamous Cell",
    quant: "1",
    pmids: "25434704",
  },
  {
    id: "10937",
    id_polifenol: "1642",
    polifenol: "FLLL 32",
    id_cancer: "18148",
    cancer: "Neoplasms, Squamous Cell",
    quant: "1",
    pmids: "21576562",
  },
  {
    id: "10938",
    id_polifenol: "4517",
    polifenol: "primetin",
    id_cancer: "18148",
    cancer: "Neoplasms, Squamous Cell",
    quant: "1",
    pmids: "25434704",
  },
  {
    id: "10939",
    id_polifenol: "1664",
    polifenol: "(2E,4E)-1-(2-hydroxyphenyl)-5-phenylpenta-2,4-dien-1-one",
    id_cancer: "18148",
    cancer: "Neoplasms, Squamous Cell",
    quant: "1",
    pmids: "26347954",
  },
  {
    id: "10940",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "598",
    cancer: "Neurologic Manifestations",
    quant: "1",
    pmids: "23437066",
  },
  {
    id: "10941",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "598",
    cancer: "Neurologic Manifestations",
    quant: "3",
    pmids: "24723245,26551062,17955367",
  },
  {
    id: "10942",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "598",
    cancer: "Neurologic Manifestations",
    quant: "2",
    pmids: "21698507,27781151",
  },
  {
    id: "10943",
    id_polifenol: "109",
    polifenol: "Catechin",
    id_cancer: "598",
    cancer: "Neurologic Manifestations",
    quant: "1",
    pmids: "21698507",
  },
  {
    id: "10944",
    id_polifenol: "105",
    polifenol: "Anthocyanins",
    id_cancer: "598",
    cancer: "Neurologic Manifestations",
    quant: "1",
    pmids: "18816259",
  },
  {
    id: "10945",
    id_polifenol: "129",
    polifenol: "Rotenone",
    id_cancer: "598",
    cancer: "Neurologic Manifestations",
    quant: "1",
    pmids: "25206641",
  },
  {
    id: "10946",
    id_polifenol: "121",
    polifenol: "Kaempferols",
    id_cancer: "598",
    cancer: "Neurologic Manifestations",
    quant: "1",
    pmids: "23437066",
  },
  {
    id: "10947",
    id_polifenol: "6451",
    polifenol: "daidzein",
    id_cancer: "598",
    cancer: "Neurologic Manifestations",
    quant: "1",
    pmids: "29201192",
  },
  {
    id: "10948",
    id_polifenol: "7",
    polifenol: "Capsaicin",
    id_cancer: "598",
    cancer: "Neurologic Manifestations",
    quant: "1",
    pmids: "25736062",
  },
  {
    id: "10949",
    id_polifenol: "98",
    polifenol: "Propofol",
    id_cancer: "598",
    cancer: "Neurologic Manifestations",
    quant: "1",
    pmids: "25323082",
  },
  {
    id: "10950",
    id_polifenol: "6463",
    polifenol: "puerarin",
    id_cancer: "598",
    cancer: "Neurologic Manifestations",
    quant: "1",
    pmids: "25206641",
  },
  {
    id: "10951",
    id_polifenol: "6068",
    polifenol: "pinocembrin",
    id_cancer: "598",
    cancer: "Neurologic Manifestations",
    quant: "1",
    pmids: "28007523",
  },
  {
    id: "10952",
    id_polifenol: "7161",
    polifenol: "scutellarin",
    id_cancer: "598",
    cancer: "Neurologic Manifestations",
    quant: "1",
    pmids: "26730961",
  },
  {
    id: "10953",
    id_polifenol: "2454",
    polifenol: "corilagin",
    id_cancer: "598",
    cancer: "Neurologic Manifestations",
    quant: "1",
    pmids: "27654707",
  },
  {
    id: "10954",
    id_polifenol: "6166",
    polifenol: "liquiritin",
    id_cancer: "598",
    cancer: "Neurologic Manifestations",
    quant: "1",
    pmids: "21128146",
  },
  {
    id: "10955",
    id_polifenol: "7453",
    polifenol: "kaempferol-3-O-glucoside",
    id_cancer: "598",
    cancer: "Neurologic Manifestations",
    quant: "1",
    pmids: "23437066",
  },
  {
    id: "10956",
    id_polifenol: "7437",
    polifenol: "kaempferol-3-O-rutinoside",
    id_cancer: "598",
    cancer: "Neurologic Manifestations",
    quant: "1",
    pmids: "23437066",
  },
  {
    id: "10957",
    id_polifenol: "7503",
    polifenol: "kaempferide-7-O-(4''-O-acetylrhamnosyl)-3-O-rutinoside",
    id_cancer: "598",
    cancer: "Neurologic Manifestations",
    quant: "1",
    pmids: "27497882",
  },
  {
    id: "10958",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "28262",
    cancer: "Thyroid Carcinoma, Anaplastic",
    quant: "3",
    pmids: "29589394,21571321,26365817",
  },
  {
    id: "10959",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "28262",
    cancer: "Thyroid Carcinoma, Anaplastic",
    quant: "1",
    pmids: "24741455",
  },
  {
    id: "10960",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "28262",
    cancer: "Thyroid Carcinoma, Anaplastic",
    quant: "1",
    pmids: "12519884",
  },
  {
    id: "10961",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "28262",
    cancer: "Thyroid Carcinoma, Anaplastic",
    quant: "1",
    pmids: "21725973",
  },
  {
    id: "10962",
    id_polifenol: "109",
    polifenol: "Catechin",
    id_cancer: "28262",
    cancer: "Thyroid Carcinoma, Anaplastic",
    quant: "1",
    pmids: "21725973",
  },
  {
    id: "10963",
    id_polifenol: "114",
    polifenol: "Apigenin",
    id_cancer: "28262",
    cancer: "Thyroid Carcinoma, Anaplastic",
    quant: "1",
    pmids: "26637867",
  },
  {
    id: "10964",
    id_polifenol: "6065",
    polifenol: "baicalein",
    id_cancer: "28262",
    cancer: "Thyroid Carcinoma, Anaplastic",
    quant: "1",
    pmids: "29589394",
  },
  {
    id: "10965",
    id_polifenol: "120",
    polifenol: "Flavonols",
    id_cancer: "28262",
    cancer: "Thyroid Carcinoma, Anaplastic",
    quant: "1",
    pmids: "28373432",
  },
  {
    id: "10966",
    id_polifenol: "4522",
    polifenol: "chrysin",
    id_cancer: "28262",
    cancer: "Thyroid Carcinoma, Anaplastic",
    quant: "2",
    pmids: "22991264,21571321",
  },
  {
    id: "10967",
    id_polifenol: "25",
    polifenol: "Butylated Hydroxytoluene",
    id_cancer: "28262",
    cancer: "Thyroid Carcinoma, Anaplastic",
    quant: "3",
    pmids: "21400508,23598436,24152827",
  },
  {
    id: "10968",
    id_polifenol: "4519",
    polifenol: "myricetin",
    id_cancer: "28262",
    cancer: "Thyroid Carcinoma, Anaplastic",
    quant: "1",
    pmids: "28373432",
  },
  {
    id: "10969",
    id_polifenol: "6273",
    polifenol: "hesperetin",
    id_cancer: "28262",
    cancer: "Thyroid Carcinoma, Anaplastic",
    quant: "1",
    pmids: "24419754",
  },
  {
    id: "10970",
    id_polifenol: "48",
    polifenol: "Anacardic Acids",
    id_cancer: "28262",
    cancer: "Thyroid Carcinoma, Anaplastic",
    quant: "1",
    pmids: "29383121",
  },
  {
    id: "10971",
    id_polifenol: "2773",
    polifenol: "farnesylthiosalicylic acid",
    id_cancer: "28262",
    cancer: "Thyroid Carcinoma, Anaplastic",
    quant: "1",
    pmids: "20682656",
  },
  {
    id: "10972",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "499",
    cancer: "Gallbladder Cancer",
    quant: "4",
    pmids: "28070171,20359814,25617627,23274410",
  },
  {
    id: "10973",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "499",
    cancer: "Gallbladder Cancer",
    quant: "2",
    pmids: "23645731,23802572",
  },
  {
    id: "10974",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "499",
    cancer: "Gallbladder Cancer",
    quant: "1",
    pmids: "29513793",
  },
  {
    id: "10975",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "499",
    cancer: "Gallbladder Cancer",
    quant: "1",
    pmids: "15743030",
  },
  {
    id: "10976",
    id_polifenol: "125",
    polifenol: "Isoflavones",
    id_cancer: "499",
    cancer: "Gallbladder Cancer",
    quant: "1",
    pmids: "24902539",
  },
  {
    id: "10977",
    id_polifenol: "6065",
    polifenol: "baicalein",
    id_cancer: "499",
    cancer: "Gallbladder Cancer",
    quant: "1",
    pmids: "25617627",
  },
  {
    id: "10978",
    id_polifenol: "7",
    polifenol: "Capsaicin",
    id_cancer: "499",
    cancer: "Gallbladder Cancer",
    quant: "1",
    pmids: "22563012",
  },
  {
    id: "10979",
    id_polifenol: "6087",
    polifenol: "wogonin",
    id_cancer: "499",
    cancer: "Gallbladder Cancer",
    quant: "1",
    pmids: "21855619",
  },
  {
    id: "10980",
    id_polifenol: "4515",
    polifenol: "baicalin",
    id_cancer: "499",
    cancer: "Gallbladder Cancer",
    quant: "1",
    pmids: "24568162",
  },
  {
    id: "10981",
    id_polifenol: "98",
    polifenol: "Propofol",
    id_cancer: "499",
    cancer: "Gallbladder Cancer",
    quant: "1",
    pmids: "22901367",
  },
  {
    id: "10982",
    id_polifenol: "4560",
    polifenol: "icariin",
    id_cancer: "499",
    cancer: "Gallbladder Cancer",
    quant: "2",
    pmids: "24435883,23274410",
  },
  {
    id: "10983",
    id_polifenol: "6625",
    polifenol: "phenoxodiol",
    id_cancer: "499",
    cancer: "Gallbladder Cancer",
    quant: "1",
    pmids: "24902539",
  },
  {
    id: "10984",
    id_polifenol: "6477",
    polifenol: "hispidulin",
    id_cancer: "499",
    cancer: "Gallbladder Cancer",
    quant: "1",
    pmids: "25499970",
  },
  {
    id: "10985",
    id_polifenol: "4549",
    polifenol: "casticin",
    id_cancer: "499",
    cancer: "Gallbladder Cancer",
    quant: "1",
    pmids: "28070171",
  },
  {
    id: "10986",
    id_polifenol: "6453",
    polifenol: "cirsimaritin",
    id_cancer: "499",
    cancer: "Gallbladder Cancer",
    quant: "1",
    pmids: "20359814",
  },
  {
    id: "10987",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "592",
    cancer: "Ewing Sarcoma",
    quant: "2",
    pmids: "27547487,12926076",
  },
  {
    id: "10988",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "592",
    cancer: "Ewing Sarcoma",
    quant: "1",
    pmids: "19859844",
  },
  {
    id: "10989",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "592",
    cancer: "Ewing Sarcoma",
    quant: "4",
    pmids: "16930595,18263590,14710346,14648701",
  },
  {
    id: "10990",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "592",
    cancer: "Ewing Sarcoma",
    quant: "1",
    pmids: "21822457",
  },
  {
    id: "10991",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "592",
    cancer: "Ewing Sarcoma",
    quant: "2",
    pmids: "12926076,17680992",
  },
  {
    id: "10992",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "592",
    cancer: "Ewing Sarcoma",
    quant: "2",
    pmids: "20423994,15643507",
  },
  {
    id: "10993",
    id_polifenol: "109",
    polifenol: "Catechin",
    id_cancer: "592",
    cancer: "Ewing Sarcoma",
    quant: "1",
    pmids: "20423994",
  },
  {
    id: "10994",
    id_polifenol: "129",
    polifenol: "Rotenone",
    id_cancer: "592",
    cancer: "Ewing Sarcoma",
    quant: "1",
    pmids: "12730670",
  },
  {
    id: "10995",
    id_polifenol: "6065",
    polifenol: "baicalein",
    id_cancer: "592",
    cancer: "Ewing Sarcoma",
    quant: "1",
    pmids: "29039470",
  },
  {
    id: "10996",
    id_polifenol: "4634",
    polifenol: "alvocidib",
    id_cancer: "592",
    cancer: "Ewing Sarcoma",
    quant: "1",
    pmids: "15818598",
  },
  {
    id: "10997",
    id_polifenol: "7541",
    polifenol: "taxifolin",
    id_cancer: "592",
    cancer: "Ewing Sarcoma",
    quant: "1",
    pmids: "27547487",
  },
  {
    id: "10998",
    id_polifenol: "6558",
    polifenol: "7,3'-dihydroxy-4'-methoxyisoflavone",
    id_cancer: "592",
    cancer: "Ewing Sarcoma",
    quant: "1",
    pmids: "29966979",
  },
  {
    id: "10999",
    id_polifenol: "6090",
    polifenol: "dioclein",
    id_cancer: "592",
    cancer: "Ewing Sarcoma",
    quant: "1",
    pmids: "29039470",
  },
  {
    id: "11000",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "3011",
    cancer: "Burkitt Lymphoma",
    quant: "4",
    pmids: "28962438,28178952,26100136,27681719",
  },
  {
    id: "11001",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "3011",
    cancer: "Burkitt Lymphoma",
    quant: "2",
    pmids: "19326074,23603894",
  },
  {
    id: "11002",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "3011",
    cancer: "Burkitt Lymphoma",
    quant: "1",
    pmids: "12220533",
  },
  {
    id: "11003",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "3011",
    cancer: "Burkitt Lymphoma",
    quant: "2",
    pmids: "28962438,27681719",
  },
  {
    id: "11004",
    id_polifenol: "110",
    polifenol: "Chalcones",
    id_cancer: "3011",
    cancer: "Burkitt Lymphoma",
    quant: "1",
    pmids: "23895019",
  },
  {
    id: "11005",
    id_polifenol: "117",
    polifenol: "Luteolin",
    id_cancer: "3011",
    cancer: "Burkitt Lymphoma",
    quant: "1",
    pmids: "26100136",
  },
  {
    id: "11006",
    id_polifenol: "121",
    polifenol: "Kaempferols",
    id_cancer: "3011",
    cancer: "Burkitt Lymphoma",
    quant: "1",
    pmids: "26100136",
  },
  {
    id: "11007",
    id_polifenol: "871",
    polifenol: "ABT-737",
    id_cancer: "3011",
    cancer: "Burkitt Lymphoma",
    quant: "1",
    pmids: "21796156",
  },
  {
    id: "11008",
    id_polifenol: "6062",
    polifenol: "naringenin",
    id_cancer: "3011",
    cancer: "Burkitt Lymphoma",
    quant: "1",
    pmids: "26100136",
  },
  {
    id: "11009",
    id_polifenol: "111",
    polifenol: "Flavanones",
    id_cancer: "3011",
    cancer: "Burkitt Lymphoma",
    quant: "2",
    pmids: "23895019,17715491",
  },
  {
    id: "11010",
    id_polifenol: "4502",
    polifenol: "fisetin",
    id_cancer: "3011",
    cancer: "Burkitt Lymphoma",
    quant: "1",
    pmids: "28962438",
  },
  {
    id: "11011",
    id_polifenol: "4519",
    polifenol: "myricetin",
    id_cancer: "3011",
    cancer: "Burkitt Lymphoma",
    quant: "1",
    pmids: "28962438",
  },
  {
    id: "11012",
    id_polifenol: "5808",
    polifenol: "isoliquiritigenin",
    id_cancer: "3011",
    cancer: "Burkitt Lymphoma",
    quant: "1",
    pmids: "27681719",
  },
  {
    id: "11013",
    id_polifenol: "6273",
    polifenol: "hesperetin",
    id_cancer: "3011",
    cancer: "Burkitt Lymphoma",
    quant: "1",
    pmids: "26100136",
  },
  {
    id: "11014",
    id_polifenol: "4560",
    polifenol: "icariin",
    id_cancer: "3011",
    cancer: "Burkitt Lymphoma",
    quant: "1",
    pmids: "24895574",
  },
  {
    id: "11015",
    id_polifenol: "7541",
    polifenol: "taxifolin",
    id_cancer: "3011",
    cancer: "Burkitt Lymphoma",
    quant: "1",
    pmids: "26100136",
  },
  {
    id: "11016",
    id_polifenol: "6097",
    polifenol: "8-prenylnaringenin",
    id_cancer: "3011",
    cancer: "Burkitt Lymphoma",
    quant: "1",
    pmids: "17715491",
  },
  {
    id: "11017",
    id_polifenol: "5071",
    polifenol: "icaritin",
    id_cancer: "3011",
    cancer: "Burkitt Lymphoma",
    quant: "1",
    pmids: "24895574",
  },
  {
    id: "11018",
    id_polifenol: "6086",
    polifenol: "liquiritigenin",
    id_cancer: "3011",
    cancer: "Burkitt Lymphoma",
    quant: "1",
    pmids: "27681719",
  },
  {
    id: "11019",
    id_polifenol: "637",
    polifenol: "glabridin",
    id_cancer: "3011",
    cancer: "Burkitt Lymphoma",
    quant: "1",
    pmids: "27681719",
  },
  {
    id: "11020",
    id_polifenol: "77",
    polifenol: "Bezafibrate",
    id_cancer: "3011",
    cancer: "Burkitt Lymphoma",
    quant: "1",
    pmids: "18923439",
  },
  {
    id: "11021",
    id_polifenol: "4304",
    polifenol: "5-7-oxo-zeaenol",
    id_cancer: "3011",
    cancer: "Burkitt Lymphoma",
    quant: "1",
    pmids: "26227222",
  },
  {
    id: "11022",
    id_polifenol: "6166",
    polifenol: "liquiritin",
    id_cancer: "3011",
    cancer: "Burkitt Lymphoma",
    quant: "1",
    pmids: "27681719",
  },
  {
    id: "11023",
    id_polifenol: "1106",
    polifenol: "1,1-bis(3'-indolyl)-1-(4-hydroxyphenyl)methane",
    id_cancer: "3011",
    cancer: "Burkitt Lymphoma",
    quant: "1",
    pmids: "28418095",
  },
  {
    id: "11024",
    id_polifenol: "5063",
    polifenol: "4',7-dihydroxy-3'-methoxy-5'-prenylflavanone",
    id_cancer: "3011",
    cancer: "Burkitt Lymphoma",
    quant: "1",
    pmids: "17715491",
  },
  {
    id: "11025",
    id_polifenol: "7810",
    polifenol: "rotenolone",
    id_cancer: "3011",
    cancer: "Burkitt Lymphoma",
    quant: "1",
    pmids: "23895019",
  },
  {
    id: "11026",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "18078",
    cancer: "Carcinoma, Embryonal",
    quant: "1",
    pmids: "21216935",
  },
  {
    id: "11027",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "18078",
    cancer: "Carcinoma, Embryonal",
    quant: "2",
    pmids: "25755051,19501152",
  },
  {
    id: "11028",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "18078",
    cancer: "Carcinoma, Embryonal",
    quant: "3",
    pmids: "19943082,16617056,21738342",
  },
  {
    id: "11029",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "18078",
    cancer: "Carcinoma, Embryonal",
    quant: "1",
    pmids: "17283246",
  },
  {
    id: "11030",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "18078",
    cancer: "Carcinoma, Embryonal",
    quant: "2",
    pmids: "21738342,18847459",
  },
  {
    id: "11031",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "18078",
    cancer: "Carcinoma, Embryonal",
    quant: "1",
    pmids: "21738342",
  },
  {
    id: "11032",
    id_polifenol: "117",
    polifenol: "Luteolin",
    id_cancer: "18078",
    cancer: "Carcinoma, Embryonal",
    quant: "1",
    pmids: "24494074",
  },
  {
    id: "11033",
    id_polifenol: "129",
    polifenol: "Rotenone",
    id_cancer: "18078",
    cancer: "Carcinoma, Embryonal",
    quant: "1",
    pmids: "18847459",
  },
  {
    id: "11034",
    id_polifenol: "121",
    polifenol: "Kaempferols",
    id_cancer: "18078",
    cancer: "Carcinoma, Embryonal",
    quant: "1",
    pmids: "21738342",
  },
  {
    id: "11035",
    id_polifenol: "130",
    polifenol: "Proanthocyanidins",
    id_cancer: "18078",
    cancer: "Carcinoma, Embryonal",
    quant: "1",
    pmids: "25684483",
  },
  {
    id: "11036",
    id_polifenol: "4502",
    polifenol: "fisetin",
    id_cancer: "18078",
    cancer: "Carcinoma, Embryonal",
    quant: "2",
    pmids: "21216935,24496750",
  },
  {
    id: "11037",
    id_polifenol: "100",
    polifenol: "Resorcinols",
    id_cancer: "18078",
    cancer: "Carcinoma, Embryonal",
    quant: "1",
    pmids: "21738342",
  },
  {
    id: "11038",
    id_polifenol: "413",
    polifenol: "4-nonylphenol",
    id_cancer: "18078",
    cancer: "Carcinoma, Embryonal",
    quant: "1",
    pmids: "23626723",
  },
  {
    id: "11039",
    id_polifenol: "630",
    polifenol: "4-tert-octylphenol",
    id_cancer: "18078",
    cancer: "Carcinoma, Embryonal",
    quant: "1",
    pmids: "23626723",
  },
  {
    id: "11040",
    id_polifenol: "4",
    polifenol: "Bithionol",
    id_cancer: "18078",
    cancer: "Carcinoma, Embryonal",
    quant: "1",
    pmids: "20067776",
  },
  {
    id: "11041",
    id_polifenol: "1424",
    polifenol: "rooperol",
    id_cancer: "18078",
    cancer: "Carcinoma, Embryonal",
    quant: "1",
    pmids: "25404486",
  },
  {
    id: "11042",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "18077",
    cancer: "Smooth Muscle Tumor",
    quant: "1",
    pmids: "23035855",
  },
  {
    id: "11043",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "18077",
    cancer: "Smooth Muscle Tumor",
    quant: "5",
    pmids: "28339005,16288471,18227124,21520062,22588934",
  },
  {
    id: "11044",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "18077",
    cancer: "Smooth Muscle Tumor",
    quant: "4",
    pmids: "10764663,10484455,16199435,10785514",
  },
  {
    id: "11045",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "18077",
    cancer: "Smooth Muscle Tumor",
    quant: "1",
    pmids: "11132607",
  },
  {
    id: "11046",
    id_polifenol: "2167",
    polifenol: "phenolic acid",
    id_cancer: "18077",
    cancer: "Smooth Muscle Tumor",
    quant: "1",
    pmids: "28778046",
  },
  {
    id: "11047",
    id_polifenol: "113",
    polifenol: "Flavones",
    id_cancer: "18077",
    cancer: "Smooth Muscle Tumor",
    quant: "1",
    pmids: "24835111",
  },
  {
    id: "11048",
    id_polifenol: "6065",
    polifenol: "baicalein",
    id_cancer: "18077",
    cancer: "Smooth Muscle Tumor",
    quant: "1",
    pmids: "16199435",
  },
  {
    id: "11049",
    id_polifenol: "120",
    polifenol: "Flavonols",
    id_cancer: "18077",
    cancer: "Smooth Muscle Tumor",
    quant: "1",
    pmids: "28778046",
  },
  {
    id: "11050",
    id_polifenol: "4515",
    polifenol: "baicalin",
    id_cancer: "18077",
    cancer: "Smooth Muscle Tumor",
    quant: "1",
    pmids: "24835111",
  },
  {
    id: "11051",
    id_polifenol: "7550",
    polifenol: "3-methylquercetin",
    id_cancer: "18077",
    cancer: "Smooth Muscle Tumor",
    quant: "1",
    pmids: "28778046",
  },
  {
    id: "11052",
    id_polifenol: "7546",
    polifenol: "isoquercitrin",
    id_cancer: "18077",
    cancer: "Smooth Muscle Tumor",
    quant: "1",
    pmids: "28778046",
  },
  {
    id: "11053",
    id_polifenol: "7289",
    polifenol: "isorhamnetin 3-O-glucoside",
    id_cancer: "18077",
    cancer: "Smooth Muscle Tumor",
    quant: "1",
    pmids: "28778046",
  },
  {
    id: "11054",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "11136",
    cancer: "Peritoneal Neoplasms",
    quant: "4",
    pmids: "29725354,24681039,18187256,24348174",
  },
  {
    id: "11055",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "11136",
    cancer: "Peritoneal Neoplasms",
    quant: "1",
    pmids: "26555741",
  },
  {
    id: "11056",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "11136",
    cancer: "Peritoneal Neoplasms",
    quant: "1",
    pmids: "26555741",
  },
  {
    id: "11057",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "11136",
    cancer: "Peritoneal Neoplasms",
    quant: "1",
    pmids: "12216703",
  },
  {
    id: "11058",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "11136",
    cancer: "Peritoneal Neoplasms",
    quant: "3",
    pmids: "29725354,27770779,24681039",
  },
  {
    id: "11059",
    id_polifenol: "2167",
    polifenol: "phenolic acid",
    id_cancer: "11136",
    cancer: "Peritoneal Neoplasms",
    quant: "1",
    pmids: "24681039",
  },
  {
    id: "11060",
    id_polifenol: "49",
    polifenol: "Aspirin",
    id_cancer: "11136",
    cancer: "Peritoneal Neoplasms",
    quant: "2",
    pmids: "16936242,12746227",
  },
  {
    id: "11061",
    id_polifenol: "38",
    polifenol: "Gallic Acid",
    id_cancer: "11136",
    cancer: "Peritoneal Neoplasms",
    quant: "1",
    pmids: "27770779",
  },
  {
    id: "11062",
    id_polifenol: "117",
    polifenol: "Luteolin",
    id_cancer: "11136",
    cancer: "Peritoneal Neoplasms",
    quant: "3",
    pmids: "29725354,24681039,18187256",
  },
  {
    id: "11063",
    id_polifenol: "1",
    polifenol: "Phenols",
    id_cancer: "11136",
    cancer: "Peritoneal Neoplasms",
    quant: "1",
    pmids: "24681039",
  },
  {
    id: "11064",
    id_polifenol: "121",
    polifenol: "Kaempferols",
    id_cancer: "11136",
    cancer: "Peritoneal Neoplasms",
    quant: "2",
    pmids: "29725354,28754304",
  },
  {
    id: "11065",
    id_polifenol: "6065",
    polifenol: "baicalein",
    id_cancer: "11136",
    cancer: "Peritoneal Neoplasms",
    quant: "1",
    pmids: "28864268",
  },
  {
    id: "11066",
    id_polifenol: "123",
    polifenol: "Rutin",
    id_cancer: "11136",
    cancer: "Peritoneal Neoplasms",
    quant: "3",
    pmids: "27770779,24681039,18187256",
  },
  {
    id: "11067",
    id_polifenol: "6062",
    polifenol: "naringenin",
    id_cancer: "11136",
    cancer: "Peritoneal Neoplasms",
    quant: "1",
    pmids: "24681039",
  },
  {
    id: "11068",
    id_polifenol: "4519",
    polifenol: "myricetin",
    id_cancer: "11136",
    cancer: "Peritoneal Neoplasms",
    quant: "1",
    pmids: "24681039",
  },
  {
    id: "11069",
    id_polifenol: "54",
    polifenol: "Salicylic Acid",
    id_cancer: "11136",
    cancer: "Peritoneal Neoplasms",
    quant: "1",
    pmids: "16936242",
  },
  {
    id: "11070",
    id_polifenol: "44",
    polifenol: "Salicylates",
    id_cancer: "11136",
    cancer: "Peritoneal Neoplasms",
    quant: "1",
    pmids: "16936242",
  },
  {
    id: "11071",
    id_polifenol: "6063",
    polifenol: "naringin",
    id_cancer: "11136",
    cancer: "Peritoneal Neoplasms",
    quant: "1",
    pmids: "24681039",
  },
  {
    id: "11072",
    id_polifenol: "107",
    polifenol: "beta-Naphthoflavone",
    id_cancer: "11136",
    cancer: "Peritoneal Neoplasms",
    quant: "1",
    pmids: "26453957",
  },
  {
    id: "11073",
    id_polifenol: "2328",
    polifenol: "syringic acid",
    id_cancer: "11136",
    cancer: "Peritoneal Neoplasms",
    quant: "1",
    pmids: "27770779",
  },
  {
    id: "11074",
    id_polifenol: "4480",
    polifenol: "myricitrin",
    id_cancer: "11136",
    cancer: "Peritoneal Neoplasms",
    quant: "1",
    pmids: "27770779",
  },
  {
    id: "11075",
    id_polifenol: "3282",
    polifenol: "N-hydroxy-N-(1-(4-(phenylmethoxy)phenyl)ethyl)-acetamide",
    id_cancer: "11136",
    cancer: "Peritoneal Neoplasms",
    quant: "1",
    pmids: "10857857",
  },
  {
    id: "11076",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "15810",
    cancer: "Leukemia, B-Cell",
    quant: "3",
    pmids: "12949627,23762124,9373241",
  },
  {
    id: "11077",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "15810",
    cancer: "Leukemia, B-Cell",
    quant: "1",
    pmids: "28071969",
  },
  {
    id: "11078",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "15810",
    cancer: "Leukemia, B-Cell",
    quant: "1",
    pmids: "15735708",
  },
  {
    id: "11079",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "15810",
    cancer: "Leukemia, B-Cell",
    quant: "2",
    pmids: "15183121,24330068",
  },
  {
    id: "11080",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "15810",
    cancer: "Leukemia, B-Cell",
    quant: "2",
    pmids: "15183121,9373241",
  },
  {
    id: "11081",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "15810",
    cancer: "Leukemia, B-Cell",
    quant: "1",
    pmids: "9373241",
  },
  {
    id: "11082",
    id_polifenol: "113",
    polifenol: "Flavones",
    id_cancer: "15810",
    cancer: "Leukemia, B-Cell",
    quant: "1",
    pmids: "9373241",
  },
  {
    id: "11083",
    id_polifenol: "871",
    polifenol: "ABT-737",
    id_cancer: "15810",
    cancer: "Leukemia, B-Cell",
    quant: "1",
    pmids: "18451170",
  },
  {
    id: "11084",
    id_polifenol: "4634",
    polifenol: "alvocidib",
    id_cancer: "15810",
    cancer: "Leukemia, B-Cell",
    quant: "1",
    pmids: "9373241",
  },
  {
    id: "11085",
    id_polifenol: "35",
    polifenol: "Hydroquinones",
    id_cancer: "15810",
    cancer: "Leukemia, B-Cell",
    quant: "1",
    pmids: "20117936",
  },
  {
    id: "11086",
    id_polifenol: "55",
    polifenol: "Sodium Salicylate",
    id_cancer: "15810",
    cancer: "Leukemia, B-Cell",
    quant: "1",
    pmids: "15328418",
  },
  {
    id: "11087",
    id_polifenol: "1810",
    polifenol: "heminordihydroguaiaretic acid",
    id_cancer: "15810",
    cancer: "Leukemia, B-Cell",
    quant: "1",
    pmids: "17454637",
  },
  {
    id: "11088",
    id_polifenol: "418",
    polifenol: "thiophenol",
    id_cancer: "15810",
    cancer: "Leukemia, B-Cell",
    quant: "1",
    pmids: "20117936",
  },
  {
    id: "11089",
    id_polifenol: "4244",
    polifenol: "malabaricone A",
    id_cancer: "15810",
    cancer: "Leukemia, B-Cell",
    quant: "1",
    pmids: "26141757",
  },
  {
    id: "11090",
    id_polifenol: "5226",
    polifenol: "cudraflavone B",
    id_cancer: "15810",
    cancer: "Leukemia, B-Cell",
    quant: "1",
    pmids: "23762124",
  },
  {
    id: "11091",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "579",
    cancer: "Hodgkin Lymphoma",
    quant: "1",
    pmids: "27681719",
  },
  {
    id: "11092",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "579",
    cancer: "Hodgkin Lymphoma",
    quant: "3",
    pmids: "23603894,24665206,29679536",
  },
  {
    id: "11093",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "579",
    cancer: "Hodgkin Lymphoma",
    quant: "1",
    pmids: "18584482",
  },
  {
    id: "11094",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "579",
    cancer: "Hodgkin Lymphoma",
    quant: "1",
    pmids: "27681719",
  },
  {
    id: "11095",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "579",
    cancer: "Hodgkin Lymphoma",
    quant: "1",
    pmids: "18584482",
  },
  {
    id: "11096",
    id_polifenol: "109",
    polifenol: "Catechin",
    id_cancer: "579",
    cancer: "Hodgkin Lymphoma",
    quant: "1",
    pmids: "17015253",
  },
  {
    id: "11097",
    id_polifenol: "871",
    polifenol: "ABT-737",
    id_cancer: "579",
    cancer: "Hodgkin Lymphoma",
    quant: "1",
    pmids: "21767511",
  },
  {
    id: "11098",
    id_polifenol: "35",
    polifenol: "Hydroquinones",
    id_cancer: "579",
    cancer: "Hodgkin Lymphoma",
    quant: "1",
    pmids: "27377594",
  },
  {
    id: "11099",
    id_polifenol: "5808",
    polifenol: "isoliquiritigenin",
    id_cancer: "579",
    cancer: "Hodgkin Lymphoma",
    quant: "1",
    pmids: "27681719",
  },
  {
    id: "11100",
    id_polifenol: "47",
    polifenol: "Mesalamine",
    id_cancer: "579",
    cancer: "Hodgkin Lymphoma",
    quant: "1",
    pmids: "11587223",
  },
  {
    id: "11101",
    id_polifenol: "81",
    polifenol: "Fenofibrate",
    id_cancer: "579",
    cancer: "Hodgkin Lymphoma",
    quant: "1",
    pmids: "20520642",
  },
  {
    id: "11102",
    id_polifenol: "6086",
    polifenol: "liquiritigenin",
    id_cancer: "579",
    cancer: "Hodgkin Lymphoma",
    quant: "1",
    pmids: "27681719",
  },
  {
    id: "11103",
    id_polifenol: "637",
    polifenol: "glabridin",
    id_cancer: "579",
    cancer: "Hodgkin Lymphoma",
    quant: "1",
    pmids: "27681719",
  },
  {
    id: "11104",
    id_polifenol: "1353",
    polifenol: "protocatechualdehyde",
    id_cancer: "579",
    cancer: "Hodgkin Lymphoma",
    quant: "1",
    pmids: "28920346",
  },
  {
    id: "11105",
    id_polifenol: "6166",
    polifenol: "liquiritin",
    id_cancer: "579",
    cancer: "Hodgkin Lymphoma",
    quant: "1",
    pmids: "27681719",
  },
  {
    id: "11106",
    id_polifenol: "6076",
    polifenol: "vexibinol",
    id_cancer: "579",
    cancer: "Hodgkin Lymphoma",
    quant: "1",
    pmids: "23962443",
  },
  {
    id: "11107",
    id_polifenol: "6109",
    polifenol: "sophoraflavanone A",
    id_cancer: "579",
    cancer: "Hodgkin Lymphoma",
    quant: "1",
    pmids: "23962443",
  },
  {
    id: "11108",
    id_polifenol: "886",
    polifenol: "4-(2-hydroxyphenyl)but-3-en-2-one",
    id_cancer: "579",
    cancer: "Hodgkin Lymphoma",
    quant: "1",
    pmids: "28920346",
  },
  {
    id: "11109",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "7772",
    cancer: "Hypothalamic Neoplasms",
    quant: "2",
    pmids: "25542408,18664365",
  },
  {
    id: "11110",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "7772",
    cancer: "Hypothalamic Neoplasms",
    quant: "1",
    pmids: "29138567",
  },
  {
    id: "11111",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "7772",
    cancer: "Hypothalamic Neoplasms",
    quant: "1",
    pmids: "16222076",
  },
  {
    id: "11112",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "7772",
    cancer: "Hypothalamic Neoplasms",
    quant: "2",
    pmids: "14755680,16513288",
  },
  {
    id: "11113",
    id_polifenol: "125",
    polifenol: "Isoflavones",
    id_cancer: "7772",
    cancer: "Hypothalamic Neoplasms",
    quant: "1",
    pmids: "16513288",
  },
  {
    id: "11114",
    id_polifenol: "129",
    polifenol: "Rotenone",
    id_cancer: "7772",
    cancer: "Hypothalamic Neoplasms",
    quant: "1",
    pmids: "17520785",
  },
  {
    id: "11115",
    id_polifenol: "6451",
    polifenol: "daidzein",
    id_cancer: "7772",
    cancer: "Hypothalamic Neoplasms",
    quant: "1",
    pmids: "16513288",
  },
  {
    id: "11116",
    id_polifenol: "120",
    polifenol: "Flavonols",
    id_cancer: "7772",
    cancer: "Hypothalamic Neoplasms",
    quant: "1",
    pmids: "20104502",
  },
  {
    id: "11117",
    id_polifenol: "98",
    polifenol: "Propofol",
    id_cancer: "7772",
    cancer: "Hypothalamic Neoplasms",
    quant: "2",
    pmids: "24349401,29347949",
  },
  {
    id: "11118",
    id_polifenol: "44",
    polifenol: "Salicylates",
    id_cancer: "7772",
    cancer: "Hypothalamic Neoplasms",
    quant: "1",
    pmids: "18281274",
  },
  {
    id: "11119",
    id_polifenol: "5819",
    polifenol: "licochalcone A",
    id_cancer: "7772",
    cancer: "Hypothalamic Neoplasms",
    quant: "1",
    pmids: "14755680",
  },
  {
    id: "11120",
    id_polifenol: "132",
    polifenol: "Equol",
    id_cancer: "7772",
    cancer: "Hypothalamic Neoplasms",
    quant: "1",
    pmids: "16513288",
  },
  {
    id: "11121",
    id_polifenol: "87",
    polifenol: "Metoclopramide",
    id_cancer: "7772",
    cancer: "Hypothalamic Neoplasms",
    quant: "1",
    pmids: "10099036",
  },
  {
    id: "11122",
    id_polifenol: "7422",
    polifenol: "kaempferide",
    id_cancer: "7772",
    cancer: "Hypothalamic Neoplasms",
    quant: "1",
    pmids: "20104502",
  },
  {
    id: "11123",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "18129",
    cancer: "Carcinoma, Small Cell",
    quant: "2",
    pmids: "11753643,11768610",
  },
  {
    id: "11124",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "18129",
    cancer: "Carcinoma, Small Cell",
    quant: "1",
    pmids: "10072259",
  },
  {
    id: "11125",
    id_polifenol: "38",
    polifenol: "Gallic Acid",
    id_cancer: "18129",
    cancer: "Carcinoma, Small Cell",
    quant: "1",
    pmids: "10587295",
  },
  {
    id: "11126",
    id_polifenol: "871",
    polifenol: "ABT-737",
    id_cancer: "18129",
    cancer: "Carcinoma, Small Cell",
    quant: "2",
    pmids: "26575826,27197306",
  },
  {
    id: "11127",
    id_polifenol: "6451",
    polifenol: "daidzein",
    id_cancer: "18129",
    cancer: "Carcinoma, Small Cell",
    quant: "1",
    pmids: "24490836",
  },
  {
    id: "11128",
    id_polifenol: "6065",
    polifenol: "baicalein",
    id_cancer: "18129",
    cancer: "Carcinoma, Small Cell",
    quant: "1",
    pmids: "21597696",
  },
  {
    id: "11129",
    id_polifenol: "4634",
    polifenol: "alvocidib",
    id_cancer: "18129",
    cancer: "Carcinoma, Small Cell",
    quant: "1",
    pmids: "19174488",
  },
  {
    id: "11130",
    id_polifenol: "15",
    polifenol: "Masoprocol",
    id_cancer: "18129",
    cancer: "Carcinoma, Small Cell",
    quant: "1",
    pmids: "10626810",
  },
  {
    id: "11131",
    id_polifenol: "6087",
    polifenol: "wogonin",
    id_cancer: "18129",
    cancer: "Carcinoma, Small Cell",
    quant: "1",
    pmids: "21597696",
  },
  {
    id: "11132",
    id_polifenol: "4515",
    polifenol: "baicalin",
    id_cancer: "18129",
    cancer: "Carcinoma, Small Cell",
    quant: "1",
    pmids: "21597696",
  },
  {
    id: "11133",
    id_polifenol: "5578",
    polifenol: "alpha-naphthoflavone",
    id_cancer: "18129",
    cancer: "Carcinoma, Small Cell",
    quant: "1",
    pmids: "3004505",
  },
  {
    id: "11134",
    id_polifenol: "107",
    polifenol: "beta-Naphthoflavone",
    id_cancer: "18129",
    cancer: "Carcinoma, Small Cell",
    quant: "2",
    pmids: "3004505,3011249",
  },
  {
    id: "11135",
    id_polifenol: "6465",
    polifenol: "genistin",
    id_cancer: "18129",
    cancer: "Carcinoma, Small Cell",
    quant: "1",
    pmids: "24490836",
  },
  {
    id: "11136",
    id_polifenol: "1810",
    polifenol: "heminordihydroguaiaretic acid",
    id_cancer: "18129",
    cancer: "Carcinoma, Small Cell",
    quant: "1",
    pmids: "10626810",
  },
  {
    id: "11137",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "10021",
    cancer: "Neoplasms, Vascular Tissue",
    quant: "2",
    pmids: "23842450,24587411",
  },
  {
    id: "11138",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "10021",
    cancer: "Neoplasms, Vascular Tissue",
    quant: "2",
    pmids: "20411591,24220325",
  },
  {
    id: "11139",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "10021",
    cancer: "Neoplasms, Vascular Tissue",
    quant: "1",
    pmids: "23796248",
  },
  {
    id: "11140",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "10021",
    cancer: "Neoplasms, Vascular Tissue",
    quant: "2",
    pmids: "19576658,25470344",
  },
  {
    id: "11141",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "10021",
    cancer: "Neoplasms, Vascular Tissue",
    quant: "1",
    pmids: "23796248",
  },
  {
    id: "11142",
    id_polifenol: "2167",
    polifenol: "phenolic acid",
    id_cancer: "10021",
    cancer: "Neoplasms, Vascular Tissue",
    quant: "1",
    pmids: "23842450",
  },
  {
    id: "11143",
    id_polifenol: "125",
    polifenol: "Isoflavones",
    id_cancer: "10021",
    cancer: "Neoplasms, Vascular Tissue",
    quant: "1",
    pmids: "25234792",
  },
  {
    id: "11144",
    id_polifenol: "114",
    polifenol: "Apigenin",
    id_cancer: "10021",
    cancer: "Neoplasms, Vascular Tissue",
    quant: "1",
    pmids: "23796248",
  },
  {
    id: "11145",
    id_polifenol: "113",
    polifenol: "Flavones",
    id_cancer: "10021",
    cancer: "Neoplasms, Vascular Tissue",
    quant: "1",
    pmids: "24587411",
  },
  {
    id: "11146",
    id_polifenol: "117",
    polifenol: "Luteolin",
    id_cancer: "10021",
    cancer: "Neoplasms, Vascular Tissue",
    quant: "1",
    pmids: "24587411",
  },
  {
    id: "11147",
    id_polifenol: "105",
    polifenol: "Anthocyanins",
    id_cancer: "10021",
    cancer: "Neoplasms, Vascular Tissue",
    quant: "1",
    pmids: "18339683",
  },
  {
    id: "11148",
    id_polifenol: "4522",
    polifenol: "chrysin",
    id_cancer: "10021",
    cancer: "Neoplasms, Vascular Tissue",
    quant: "1",
    pmids: "23796248",
  },
  {
    id: "11149",
    id_polifenol: "5489",
    polifenol: "delphinidin",
    id_cancer: "10021",
    cancer: "Neoplasms, Vascular Tissue",
    quant: "1",
    pmids: "18339683",
  },
  {
    id: "11150",
    id_polifenol: "93",
    polifenol: "Phloroglucinol",
    id_cancer: "10021",
    cancer: "Neoplasms, Vascular Tissue",
    quant: "1",
    pmids: "17701591",
  },
  {
    id: "11151",
    id_polifenol: "4537",
    polifenol: "flavone acetic acid",
    id_cancer: "10021",
    cancer: "Neoplasms, Vascular Tissue",
    quant: "1",
    pmids: "3179187",
  },
  {
    id: "11152",
    id_polifenol: "100",
    polifenol: "Resorcinols",
    id_cancer: "10021",
    cancer: "Neoplasms, Vascular Tissue",
    quant: "1",
    pmids: "23896275",
  },
  {
    id: "11153",
    id_polifenol: "6558",
    polifenol: "7,3'-dihydroxy-4'-methoxyisoflavone",
    id_cancer: "10021",
    cancer: "Neoplasms, Vascular Tissue",
    quant: "1",
    pmids: "25234792",
  },
  {
    id: "11154",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "530",
    cancer: "Testicular Cancer",
    quant: "2",
    pmids: "24871203,27863301",
  },
  {
    id: "11155",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "530",
    cancer: "Testicular Cancer",
    quant: "5",
    pmids: "22469952,23001851,22825355,29232190,29545862",
  },
  {
    id: "11156",
    id_polifenol: "49",
    polifenol: "Aspirin",
    id_cancer: "530",
    cancer: "Testicular Cancer",
    quant: "1",
    pmids: "15309515",
  },
  {
    id: "11157",
    id_polifenol: "7235",
    polifenol: "silybin",
    id_cancer: "530",
    cancer: "Testicular Cancer",
    quant: "1",
    pmids: "8980410",
  },
  {
    id: "11158",
    id_polifenol: "285",
    polifenol: "bisphenol A",
    id_cancer: "530",
    cancer: "Testicular Cancer",
    quant: "2",
    pmids: "22496838,9524557",
  },
  {
    id: "11159",
    id_polifenol: "4515",
    polifenol: "baicalin",
    id_cancer: "530",
    cancer: "Testicular Cancer",
    quant: "1",
    pmids: "27863301",
  },
  {
    id: "11160",
    id_polifenol: "350",
    polifenol: "nonylphenol",
    id_cancer: "530",
    cancer: "Testicular Cancer",
    quant: "1",
    pmids: "9524557",
  },
  {
    id: "11161",
    id_polifenol: "413",
    polifenol: "4-nonylphenol",
    id_cancer: "530",
    cancer: "Testicular Cancer",
    quant: "1",
    pmids: "23626723",
  },
  {
    id: "11162",
    id_polifenol: "630",
    polifenol: "4-tert-octylphenol",
    id_cancer: "530",
    cancer: "Testicular Cancer",
    quant: "1",
    pmids: "23626723",
  },
  {
    id: "11163",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "531",
    cancer: "Urethral Cancer",
    quant: "2",
    pmids: "19860939,23356235",
  },
  {
    id: "11164",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "531",
    cancer: "Urethral Cancer",
    quant: "3",
    pmids: "19860939,29966007,29936451",
  },
  {
    id: "11165",
    id_polifenol: "871",
    polifenol: "ABT-737",
    id_cancer: "531",
    cancer: "Urethral Cancer",
    quant: "2",
    pmids: "26100943,25387078",
  },
  {
    id: "11166",
    id_polifenol: "7",
    polifenol: "Capsaicin",
    id_cancer: "531",
    cancer: "Urethral Cancer",
    quant: "2",
    pmids: "21310942,19502594",
  },
  {
    id: "11167",
    id_polifenol: "75",
    polifenol: "Butylated Hydroxyanisole",
    id_cancer: "531",
    cancer: "Urethral Cancer",
    quant: "1",
    pmids: "8776620",
  },
  {
    id: "11168",
    id_polifenol: "4515",
    polifenol: "baicalin",
    id_cancer: "531",
    cancer: "Urethral Cancer",
    quant: "1",
    pmids: "26204831",
  },
  {
    id: "11169",
    id_polifenol: "5578",
    polifenol: "alpha-naphthoflavone",
    id_cancer: "531",
    cancer: "Urethral Cancer",
    quant: "1",
    pmids: "11511187",
  },
  {
    id: "11170",
    id_polifenol: "107",
    polifenol: "beta-Naphthoflavone",
    id_cancer: "531",
    cancer: "Urethral Cancer",
    quant: "1",
    pmids: "11511187",
  },
  {
    id: "11171",
    id_polifenol: "6711",
    polifenol: "3',4'-dimethoxyflavone",
    id_cancer: "531",
    cancer: "Urethral Cancer",
    quant: "1",
    pmids: "26204831",
  },
  {
    id: "11172",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "5555",
    cancer: "Endocrine Gland Neoplasms",
    quant: "3",
    pmids: "29901626,16697971,19084262",
  },
  {
    id: "11173",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "5555",
    cancer: "Endocrine Gland Neoplasms",
    quant: "1",
    pmids: "16158935",
  },
  {
    id: "11174",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "5555",
    cancer: "Endocrine Gland Neoplasms",
    quant: "1",
    pmids: "20389030",
  },
  {
    id: "11175",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "5555",
    cancer: "Endocrine Gland Neoplasms",
    quant: "2",
    pmids: "19765307,10355749",
  },
  {
    id: "11176",
    id_polifenol: "2167",
    polifenol: "phenolic acid",
    id_cancer: "5555",
    cancer: "Endocrine Gland Neoplasms",
    quant: "1",
    pmids: "15517910",
  },
  {
    id: "11177",
    id_polifenol: "3089",
    polifenol: "1,1-diphenyl-2-picrylhydrazyl",
    id_cancer: "5555",
    cancer: "Endocrine Gland Neoplasms",
    quant: "3",
    pmids: "15517910,16177974,19084262",
  },
  {
    id: "11178",
    id_polifenol: "1",
    polifenol: "Phenols",
    id_cancer: "5555",
    cancer: "Endocrine Gland Neoplasms",
    quant: "1",
    pmids: "19084262",
  },
  {
    id: "11179",
    id_polifenol: "6451",
    polifenol: "daidzein",
    id_cancer: "5555",
    cancer: "Endocrine Gland Neoplasms",
    quant: "1",
    pmids: "19765307",
  },
  {
    id: "11180",
    id_polifenol: "285",
    polifenol: "bisphenol A",
    id_cancer: "5555",
    cancer: "Endocrine Gland Neoplasms",
    quant: "1",
    pmids: "10767642",
  },
  {
    id: "11181",
    id_polifenol: "25",
    polifenol: "Butylated Hydroxytoluene",
    id_cancer: "5555",
    cancer: "Endocrine Gland Neoplasms",
    quant: "1",
    pmids: "15517910",
  },
  {
    id: "11182",
    id_polifenol: "75",
    polifenol: "Butylated Hydroxyanisole",
    id_cancer: "5555",
    cancer: "Endocrine Gland Neoplasms",
    quant: "1",
    pmids: "15517910",
  },
  {
    id: "11183",
    id_polifenol: "126",
    polifenol: "Coumestrol",
    id_cancer: "5555",
    cancer: "Endocrine Gland Neoplasms",
    quant: "1",
    pmids: "19765307",
  },
  {
    id: "11184",
    id_polifenol: "2490",
    polifenol: "punicalagin",
    id_cancer: "5555",
    cancer: "Endocrine Gland Neoplasms",
    quant: "1",
    pmids: "29677534",
  },
  {
    id: "11185",
    id_polifenol: "12",
    polifenol: "Guaiacol",
    id_cancer: "5555",
    cancer: "Endocrine Gland Neoplasms",
    quant: "1",
    pmids: "19084262",
  },
  {
    id: "11186",
    id_polifenol: "962",
    polifenol: "2,6-di-tert-butyl-4-methylphenol",
    id_cancer: "5555",
    cancer: "Endocrine Gland Neoplasms",
    quant: "1",
    pmids: "19084262",
  },
  {
    id: "11187",
    id_polifenol: "1934",
    polifenol: "2,6-di-tert-butyl-4-hydroxy-4-methyl-2,5-cyclohexadien-1-one",
    id_cancer: "5555",
    cancer: "Endocrine Gland Neoplasms",
    quant: "1",
    pmids: "15517910",
  },
  {
    id: "11188",
    id_polifenol: "444",
    polifenol: "2,4-di-tert-butylphenol",
    id_cancer: "5555",
    cancer: "Endocrine Gland Neoplasms",
    quant: "1",
    pmids: "15517910",
  },
  {
    id: "11189",
    id_polifenol: "1867",
    polifenol: "creosol",
    id_cancer: "5555",
    cancer: "Endocrine Gland Neoplasms",
    quant: "1",
    pmids: "15517910",
  },
  {
    id: "11190",
    id_polifenol: "393",
    polifenol: "2,6-di-tert-butylphenol",
    id_cancer: "5555",
    cancer: "Endocrine Gland Neoplasms",
    quant: "1",
    pmids: "19084262",
  },
  {
    id: "11191",
    id_polifenol: "392",
    polifenol: "2-tert-butylphenol",
    id_cancer: "5555",
    cancer: "Endocrine Gland Neoplasms",
    quant: "1",
    pmids: "19084262",
  },
  {
    id: "11192",
    id_polifenol: "286",
    polifenol: "butylphen",
    id_cancer: "5555",
    cancer: "Endocrine Gland Neoplasms",
    quant: "1",
    pmids: "15517910",
  },
  {
    id: "11193",
    id_polifenol: "335",
    polifenol: "2,4,6-tri-tert-butylphenol",
    id_cancer: "5555",
    cancer: "Endocrine Gland Neoplasms",
    quant: "1",
    pmids: "19084262",
  },
  {
    id: "11194",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "230106",
    cancer: "Leiomyoma",
    quant: "3",
    pmids: "18487228,15922007,24572052",
  },
  {
    id: "11195",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "230106",
    cancer: "Leiomyoma",
    quant: "1",
    pmids: "20672906",
  },
  {
    id: "11196",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "230106",
    cancer: "Leiomyoma",
    quant: "1",
    pmids: "11238032",
  },
  {
    id: "11197",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "230106",
    cancer: "Leiomyoma",
    quant: "3",
    pmids: "27512718,19903033,10397250",
  },
  {
    id: "11198",
    id_polifenol: "125",
    polifenol: "Isoflavones",
    id_cancer: "230106",
    cancer: "Leiomyoma",
    quant: "1",
    pmids: "27512718",
  },
  {
    id: "11199",
    id_polifenol: "114",
    polifenol: "Apigenin",
    id_cancer: "230106",
    cancer: "Leiomyoma",
    quant: "1",
    pmids: "15922007",
  },
  {
    id: "11200",
    id_polifenol: "113",
    polifenol: "Flavones",
    id_cancer: "230106",
    cancer: "Leiomyoma",
    quant: "1",
    pmids: "15922007",
  },
  {
    id: "11201",
    id_polifenol: "117",
    polifenol: "Luteolin",
    id_cancer: "230106",
    cancer: "Leiomyoma",
    quant: "1",
    pmids: "15922007",
  },
  {
    id: "11202",
    id_polifenol: "1",
    polifenol: "Phenols",
    id_cancer: "230106",
    cancer: "Leiomyoma",
    quant: "1",
    pmids: "17105846",
  },
  {
    id: "11203",
    id_polifenol: "4634",
    polifenol: "alvocidib",
    id_cancer: "230106",
    cancer: "Leiomyoma",
    quant: "1",
    pmids: "24572052",
  },
  {
    id: "11204",
    id_polifenol: "6062",
    polifenol: "naringenin",
    id_cancer: "230106",
    cancer: "Leiomyoma",
    quant: "1",
    pmids: "10397250",
  },
  {
    id: "11205",
    id_polifenol: "4515",
    polifenol: "baicalin",
    id_cancer: "230106",
    cancer: "Leiomyoma",
    quant: "1",
    pmids: "15922007",
  },
  {
    id: "11206",
    id_polifenol: "5808",
    polifenol: "isoliquiritigenin",
    id_cancer: "230106",
    cancer: "Leiomyoma",
    quant: "1",
    pmids: "18487228",
  },
  {
    id: "11207",
    id_polifenol: "69",
    polifenol: "Phenolsulfonphthalein",
    id_cancer: "230106",
    cancer: "Leiomyoma",
    quant: "1",
    pmids: "8989276",
  },
  {
    id: "11208",
    id_polifenol: "126",
    polifenol: "Coumestrol",
    id_cancer: "230106",
    cancer: "Leiomyoma",
    quant: "1",
    pmids: "10397250",
  },
  {
    id: "11209",
    id_polifenol: "2034",
    polifenol: "2,3,5-(triglutathion-S-yl)hydroquinone",
    id_cancer: "230106",
    cancer: "Leiomyoma",
    quant: "1",
    pmids: "21693435",
  },
  {
    id: "11210",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "8679",
    cancer: "Leydig Cell Tumor",
    quant: "4",
    pmids: "12021184,16166197,10749150,26047595",
  },
  {
    id: "11211",
    id_polifenol: "129",
    polifenol: "Rotenone",
    id_cancer: "8679",
    cancer: "Leydig Cell Tumor",
    quant: "1",
    pmids: "16952382",
  },
  {
    id: "11212",
    id_polifenol: "285",
    polifenol: "bisphenol A",
    id_cancer: "8679",
    cancer: "Leydig Cell Tumor",
    quant: "2",
    pmids: "12021184,10373400",
  },
  {
    id: "11213",
    id_polifenol: "4560",
    polifenol: "icariin",
    id_cancer: "8679",
    cancer: "Leydig Cell Tumor",
    quant: "1",
    pmids: "21687940",
  },
  {
    id: "11214",
    id_polifenol: "59",
    polifenol: "Dinitrophenols",
    id_cancer: "8679",
    cancer: "Leydig Cell Tumor",
    quant: "1",
    pmids: "8095048",
  },
  {
    id: "11215",
    id_polifenol: "353",
    polifenol: "sesamol",
    id_cancer: "8679",
    cancer: "Leydig Cell Tumor",
    quant: "1",
    pmids: "21863802",
  },
  {
    id: "11216",
    id_polifenol: "84",
    polifenol: "Halogenated Diphenyl Ethers",
    id_cancer: "8679",
    cancer: "Leydig Cell Tumor",
    quant: "1",
    pmids: "22867812",
  },
  {
    id: "11217",
    id_polifenol: "792",
    polifenol: "octylphenol",
    id_cancer: "8679",
    cancer: "Leydig Cell Tumor",
    quant: "1",
    pmids: "10373400",
  },
  {
    id: "11218",
    id_polifenol: "3386",
    polifenol: "2,2',4,4'-tetrabromodiphenyl ether",
    id_cancer: "8679",
    cancer: "Leydig Cell Tumor",
    quant: "1",
    pmids: "22867812",
  },
  {
    id: "11219",
    id_polifenol: "1246",
    polifenol: "4,4'-hexafluorisopropylidene diphenol",
    id_cancer: "8679",
    cancer: "Leydig Cell Tumor",
    quant: "1",
    pmids: "29575470",
  },
  {
    id: "11220",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "3227",
    cancer: "basal cell carcinoma",
    quant: "3",
    pmids: "17273730,19212627,9764849",
  },
  {
    id: "11221",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "3227",
    cancer: "basal cell carcinoma",
    quant: "1",
    pmids: "14512807",
  },
  {
    id: "11222",
    id_polifenol: "110",
    polifenol: "Chalcones",
    id_cancer: "3227",
    cancer: "basal cell carcinoma",
    quant: "1",
    pmids: "27899820",
  },
  {
    id: "11223",
    id_polifenol: "1",
    polifenol: "Phenols",
    id_cancer: "3227",
    cancer: "basal cell carcinoma",
    quant: "1",
    pmids: "11520941",
  },
  {
    id: "11224",
    id_polifenol: "7235",
    polifenol: "silybin",
    id_cancer: "3227",
    cancer: "basal cell carcinoma",
    quant: "1",
    pmids: "25492239",
  },
  {
    id: "11225",
    id_polifenol: "121",
    polifenol: "Kaempferols",
    id_cancer: "3227",
    cancer: "basal cell carcinoma",
    quant: "1",
    pmids: "23936765",
  },
  {
    id: "11226",
    id_polifenol: "75",
    polifenol: "Butylated Hydroxyanisole",
    id_cancer: "3227",
    cancer: "basal cell carcinoma",
    quant: "1",
    pmids: "1703036",
  },
  {
    id: "11227",
    id_polifenol: "119",
    polifenol: "Silymarin",
    id_cancer: "3227",
    cancer: "basal cell carcinoma",
    quant: "1",
    pmids: "20372777",
  },
  {
    id: "11228",
    id_polifenol: "108",
    polifenol: "Biflavonoids",
    id_cancer: "3227",
    cancer: "basal cell carcinoma",
    quant: "1",
    pmids: "22271084",
  },
  {
    id: "11229",
    id_polifenol: "6066",
    polifenol: "eriodictyol",
    id_cancer: "3227",
    cancer: "basal cell carcinoma",
    quant: "1",
    pmids: "23936765",
  },
  {
    id: "11230",
    id_polifenol: "4579",
    polifenol: "hinokiflavone",
    id_cancer: "3227",
    cancer: "basal cell carcinoma",
    quant: "1",
    pmids: "22271084",
  },
  {
    id: "11231",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "15815",
    cancer: "Human T-cell leukemia-lymphoma virus",
    quant: "3",
    pmids: "16106398,16630125,16157375",
  },
  {
    id: "11232",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "15815",
    cancer: "Human T-cell leukemia-lymphoma virus",
    quant: "2",
    pmids: "28586006,10744042",
  },
  {
    id: "11233",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "15815",
    cancer: "Human T-cell leukemia-lymphoma virus",
    quant: "1",
    pmids: "23918355",
  },
  {
    id: "11234",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "15815",
    cancer: "Human T-cell leukemia-lymphoma virus",
    quant: "2",
    pmids: "10744042,24855377",
  },
  {
    id: "11235",
    id_polifenol: "114",
    polifenol: "Apigenin",
    id_cancer: "15815",
    cancer: "Human T-cell leukemia-lymphoma virus",
    quant: "1",
    pmids: "22086925",
  },
  {
    id: "11236",
    id_polifenol: "113",
    polifenol: "Flavones",
    id_cancer: "15815",
    cancer: "Human T-cell leukemia-lymphoma virus",
    quant: "1",
    pmids: "22086925",
  },
  {
    id: "11237",
    id_polifenol: "871",
    polifenol: "ABT-737",
    id_cancer: "15815",
    cancer: "Human T-cell leukemia-lymphoma virus",
    quant: "1",
    pmids: "22138435",
  },
  {
    id: "11238",
    id_polifenol: "4522",
    polifenol: "chrysin",
    id_cancer: "15815",
    cancer: "Human T-cell leukemia-lymphoma virus",
    quant: "1",
    pmids: "22086925",
  },
  {
    id: "11239",
    id_polifenol: "6087",
    polifenol: "wogonin",
    id_cancer: "15815",
    cancer: "Human T-cell leukemia-lymphoma virus",
    quant: "1",
    pmids: "22086925",
  },
  {
    id: "11240",
    id_polifenol: "55",
    polifenol: "Sodium Salicylate",
    id_cancer: "15815",
    cancer: "Human T-cell leukemia-lymphoma virus",
    quant: "1",
    pmids: "11493471",
  },
  {
    id: "11241",
    id_polifenol: "5806",
    polifenol: "butein",
    id_cancer: "15815",
    cancer: "Human T-cell leukemia-lymphoma virus",
    quant: "1",
    pmids: "28586006",
  },
  {
    id: "11242",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "17541",
    cancer: "Neuroectodermal Tumors",
    quant: "1",
    pmids: "20525240",
  },
  {
    id: "11243",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "17541",
    cancer: "Neuroectodermal Tumors",
    quant: "1",
    pmids: "14769133",
  },
  {
    id: "11244",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "17541",
    cancer: "Neuroectodermal Tumors",
    quant: "5",
    pmids: "16930595,18263590,16239399,12056817,10675492",
  },
  {
    id: "11245",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "17541",
    cancer: "Neuroectodermal Tumors",
    quant: "1",
    pmids: "28877739",
  },
  {
    id: "11246",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "17541",
    cancer: "Neuroectodermal Tumors",
    quant: "2",
    pmids: "14769133,23807168",
  },
  {
    id: "11247",
    id_polifenol: "129",
    polifenol: "Rotenone",
    id_cancer: "17541",
    cancer: "Neuroectodermal Tumors",
    quant: "1",
    pmids: "28877739",
  },
  {
    id: "11248",
    id_polifenol: "6451",
    polifenol: "daidzein",
    id_cancer: "17541",
    cancer: "Neuroectodermal Tumors",
    quant: "1",
    pmids: "28877739",
  },
  {
    id: "11249",
    id_polifenol: "4634",
    polifenol: "alvocidib",
    id_cancer: "17541",
    cancer: "Neuroectodermal Tumors",
    quant: "1",
    pmids: "15818598",
  },
  {
    id: "11250",
    id_polifenol: "6301",
    polifenol: "3-methoxyflavone",
    id_cancer: "17541",
    cancer: "Neuroectodermal Tumors",
    quant: "1",
    pmids: "16239399",
  },
  {
    id: "11251",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "23518",
    cancer: "Tumor Burden",
    quant: "3",
    pmids: "20372819,23619285,28659032",
  },
  {
    id: "11252",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "23518",
    cancer: "Tumor Burden",
    quant: "2",
    pmids: "19655336,26464676",
  },
  {
    id: "11253",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "23518",
    cancer: "Tumor Burden",
    quant: "1",
    pmids: "19540315",
  },
  {
    id: "11254",
    id_polifenol: "125",
    polifenol: "Isoflavones",
    id_cancer: "23518",
    cancer: "Tumor Burden",
    quant: "1",
    pmids: "27456242",
  },
  {
    id: "11255",
    id_polifenol: "871",
    polifenol: "ABT-737",
    id_cancer: "23518",
    cancer: "Tumor Burden",
    quant: "1",
    pmids: "23832737",
  },
  {
    id: "11256",
    id_polifenol: "6065",
    polifenol: "baicalein",
    id_cancer: "23518",
    cancer: "Tumor Burden",
    quant: "1",
    pmids: "23619285",
  },
  {
    id: "11257",
    id_polifenol: "1356",
    polifenol: "gingerol",
    id_cancer: "23518",
    cancer: "Tumor Burden",
    quant: "1",
    pmids: "26621832",
  },
  {
    id: "11258",
    id_polifenol: "4714",
    polifenol: "epimedin C",
    id_cancer: "23518",
    cancer: "Tumor Burden",
    quant: "1",
    pmids: "28659032",
  },
  {
    id: "11259",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "501",
    cancer: "Gastrointestinal Stromal Tumors",
    quant: "2",
    pmids: "17671691,29245915",
  },
  {
    id: "11260",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "501",
    cancer: "Gastrointestinal Stromal Tumors",
    quant: "1",
    pmids: "12894500",
  },
  {
    id: "11261",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "501",
    cancer: "Gastrointestinal Stromal Tumors",
    quant: "1",
    pmids: "19770581",
  },
  {
    id: "11262",
    id_polifenol: "109",
    polifenol: "Catechin",
    id_cancer: "501",
    cancer: "Gastrointestinal Stromal Tumors",
    quant: "1",
    pmids: "19770581",
  },
  {
    id: "11263",
    id_polifenol: "871",
    polifenol: "ABT-737",
    id_cancer: "501",
    cancer: "Gastrointestinal Stromal Tumors",
    quant: "1",
    pmids: "21115411",
  },
  {
    id: "11264",
    id_polifenol: "4634",
    polifenol: "alvocidib",
    id_cancer: "501",
    cancer: "Gastrointestinal Stromal Tumors",
    quant: "1",
    pmids: "16740725",
  },
  {
    id: "11265",
    id_polifenol: "6",
    polifenol: "Catechols",
    id_cancer: "501",
    cancer: "Gastrointestinal Stromal Tumors",
    quant: "1",
    pmids: "8243170",
  },
  {
    id: "11266",
    id_polifenol: "2344",
    polifenol: "methyl gallate",
    id_cancer: "501",
    cancer: "Gastrointestinal Stromal Tumors",
    quant: "1",
    pmids: "19770581",
  },
  {
    id: "11267",
    id_polifenol: "4253",
    polifenol:
      "5-(2,4-dihydroxy-5-isopropylphenyl)-4-(4-morpholin-4-ylmethylphenyl)isoxazole-3-carboxylic acid ethylamide",
    id_cancer: "501",
    cancer: "Gastrointestinal Stromal Tumors",
    quant: "2",
    pmids: "23196876,25375091",
  },
  {
    id: "11268",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "513",
    cancer: "Neuroendocrine Tumor",
    quant: "2",
    pmids: "21367373,23771516",
  },
  {
    id: "11269",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "513",
    cancer: "Neuroendocrine Tumor",
    quant: "2",
    pmids: "9421477,20389030",
  },
  {
    id: "11270",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "513",
    cancer: "Neuroendocrine Tumor",
    quant: "1",
    pmids: "23771516",
  },
  {
    id: "11271",
    id_polifenol: "49",
    polifenol: "Aspirin",
    id_cancer: "513",
    cancer: "Neuroendocrine Tumor",
    quant: "1",
    pmids: "25110431",
  },
  {
    id: "11272",
    id_polifenol: "6065",
    polifenol: "baicalein",
    id_cancer: "513",
    cancer: "Neuroendocrine Tumor",
    quant: "1",
    pmids: "28787336",
  },
  {
    id: "11273",
    id_polifenol: "7",
    polifenol: "Capsaicin",
    id_cancer: "513",
    cancer: "Neuroendocrine Tumor",
    quant: "2",
    pmids: "24075930,21945155",
  },
  {
    id: "11274",
    id_polifenol: "6273",
    polifenol: "hesperetin",
    id_cancer: "513",
    cancer: "Neuroendocrine Tumor",
    quant: "1",
    pmids: "21367373",
  },
  {
    id: "11275",
    id_polifenol: "1558",
    polifenol: "capsazepine",
    id_cancer: "513",
    cancer: "Neuroendocrine Tumor",
    quant: "1",
    pmids: "21945155",
  },
  {
    id: "11276",
    id_polifenol: "2773",
    polifenol: "farnesylthiosalicylic acid",
    id_cancer: "513",
    cancer: "Neuroendocrine Tumor",
    quant: "1",
    pmids: "10619439",
  },
  {
    id: "11277",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "20005",
    cancer: "Lymphoma, Mantle-Cell",
    quant: "1",
    pmids: "12819936",
  },
  {
    id: "11278",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "20005",
    cancer: "Lymphoma, Mantle-Cell",
    quant: "2",
    pmids: "17468512,19469643",
  },
  {
    id: "11279",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "20005",
    cancer: "Lymphoma, Mantle-Cell",
    quant: "1",
    pmids: "18787224",
  },
  {
    id: "11280",
    id_polifenol: "871",
    polifenol: "ABT-737",
    id_cancer: "20005",
    cancer: "Lymphoma, Mantle-Cell",
    quant: "2",
    pmids: "22310286,21821698",
  },
  {
    id: "11281",
    id_polifenol: "4634",
    polifenol: "alvocidib",
    id_cancer: "20005",
    cancer: "Lymphoma, Mantle-Cell",
    quant: "4",
    pmids: "25866220,21821698,17101070,12819936",
  },
  {
    id: "11282",
    id_polifenol: "81",
    polifenol: "Fenofibrate",
    id_cancer: "20005",
    cancer: "Lymphoma, Mantle-Cell",
    quant: "1",
    pmids: "20520642",
  },
  {
    id: "11283",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "4425",
    cancer: "Carcinoma, Adenoid Cystic",
    quant: "3",
    pmids: "21956714,20484154,20386985",
  },
  {
    id: "11284",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "4425",
    cancer: "Carcinoma, Adenoid Cystic",
    quant: "2",
    pmids: "20959361,27515884",
  },
  {
    id: "11285",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "4425",
    cancer: "Carcinoma, Adenoid Cystic",
    quant: "1",
    pmids: "28485162",
  },
  {
    id: "11286",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "4425",
    cancer: "Carcinoma, Adenoid Cystic",
    quant: "1",
    pmids: "20386985",
  },
  {
    id: "11287",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "4425",
    cancer: "Carcinoma, Adenoid Cystic",
    quant: "1",
    pmids: "28485162",
  },
  {
    id: "11288",
    id_polifenol: "110",
    polifenol: "Chalcones",
    id_cancer: "4425",
    cancer: "Carcinoma, Adenoid Cystic",
    quant: "1",
    pmids: "22115332",
  },
  {
    id: "11289",
    id_polifenol: "7235",
    polifenol: "silybin",
    id_cancer: "4425",
    cancer: "Carcinoma, Adenoid Cystic",
    quant: "1",
    pmids: "27822066",
  },
  {
    id: "11290",
    id_polifenol: "5808",
    polifenol: "isoliquiritigenin",
    id_cancer: "4425",
    cancer: "Carcinoma, Adenoid Cystic",
    quant: "2",
    pmids: "21956714,20484154",
  },
  {
    id: "11291",
    id_polifenol: "4883",
    polifenol: "flavokawain B",
    id_cancer: "4425",
    cancer: "Carcinoma, Adenoid Cystic",
    quant: "1",
    pmids: "22115332",
  },
  {
    id: "11292",
    id_polifenol: "49",
    polifenol: "Aspirin",
    id_cancer: "3242",
    cancer: "Carcinosarcoma",
    quant: "4",
    pmids: "8478151,7053849,9213340,4759939",
  },
  {
    id: "11293",
    id_polifenol: "1",
    polifenol: "Phenols",
    id_cancer: "3242",
    cancer: "Carcinosarcoma",
    quant: "1",
    pmids: "2261879",
  },
  {
    id: "11294",
    id_polifenol: "129",
    polifenol: "Rotenone",
    id_cancer: "3242",
    cancer: "Carcinosarcoma",
    quant: "1",
    pmids: "9258337",
  },
  {
    id: "11295",
    id_polifenol: "15",
    polifenol: "Masoprocol",
    id_cancer: "3242",
    cancer: "Carcinosarcoma",
    quant: "3",
    pmids: "9378543,3040230,7053849",
  },
  {
    id: "11296",
    id_polifenol: "1810",
    polifenol: "heminordihydroguaiaretic acid",
    id_cancer: "3242",
    cancer: "Carcinosarcoma",
    quant: "1",
    pmids: "9258337",
  },
  {
    id: "11297",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "609",
    cancer: "Central Nervous System Atypical Teratoid/Rhabdoid Tumor",
    quant: "2",
    pmids: "22201757,20147838",
  },
  {
    id: "11298",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "609",
    cancer: "Central Nervous System Atypical Teratoid/Rhabdoid Tumor",
    quant: "1",
    pmids: "10873031",
  },
  {
    id: "11299",
    id_polifenol: "114",
    polifenol: "Apigenin",
    id_cancer: "609",
    cancer: "Central Nervous System Atypical Teratoid/Rhabdoid Tumor",
    quant: "1",
    pmids: "20147838",
  },
  {
    id: "11300",
    id_polifenol: "7235",
    polifenol: "silybin",
    id_cancer: "609",
    cancer: "Central Nervous System Atypical Teratoid/Rhabdoid Tumor",
    quant: "1",
    pmids: "29344246",
  },
  {
    id: "11301",
    id_polifenol: "4634",
    polifenol: "alvocidib",
    id_cancer: "609",
    cancer: "Central Nervous System Atypical Teratoid/Rhabdoid Tumor",
    quant: "4",
    pmids: "18223228,21092078,24913006,21173237",
  },
  {
    id: "11302",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "23062",
    cancer: "Carcinoma, Ductal",
    quant: "2",
    pmids: "23040919,19944674",
  },
  {
    id: "11303",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "23062",
    cancer: "Carcinoma, Ductal",
    quant: "1",
    pmids: "22128158",
  },
  {
    id: "11304",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "23062",
    cancer: "Carcinoma, Ductal",
    quant: "1",
    pmids: "12239620",
  },
  {
    id: "11305",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "23062",
    cancer: "Carcinoma, Ductal",
    quant: "1",
    pmids: "28693189",
  },
  {
    id: "11306",
    id_polifenol: "125",
    polifenol: "Isoflavones",
    id_cancer: "23062",
    cancer: "Carcinoma, Ductal",
    quant: "1",
    pmids: "19322027",
  },
  {
    id: "11307",
    id_polifenol: "1673",
    polifenol: "4-hydroxyestradiol",
    id_cancer: "23062",
    cancer: "Carcinoma, Ductal",
    quant: "2",
    pmids: "29290975,21170676",
  },
  {
    id: "11308",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "496",
    cancer: "Hereditary NonPolyposis Colorectal Cancer",
    quant: "1",
    pmids: "28373425",
  },
  {
    id: "11309",
    id_polifenol: "49",
    polifenol: "Aspirin",
    id_cancer: "496",
    cancer: "Hereditary NonPolyposis Colorectal Cancer",
    quant: "6",
    pmids: "17316360,9736731,18006842,21158711,16042586,11301836",
  },
  {
    id: "11310",
    id_polifenol: "47",
    polifenol: "Mesalamine",
    id_cancer: "496",
    cancer: "Hereditary NonPolyposis Colorectal Cancer",
    quant: "1",
    pmids: "22366868",
  },
  {
    id: "11311",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "18085",
    cancer: "Teratocarcinoma",
    quant: "2",
    pmids: "23685957,26179929",
  },
  {
    id: "11312",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "18085",
    cancer: "Teratocarcinoma",
    quant: "1",
    pmids: "19943082",
  },
  {
    id: "11313",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "18085",
    cancer: "Teratocarcinoma",
    quant: "1",
    pmids: "9671463",
  },
  {
    id: "11314",
    id_polifenol: "110",
    polifenol: "Chalcones",
    id_cancer: "18085",
    cancer: "Teratocarcinoma",
    quant: "1",
    pmids: "3021829",
  },
  {
    id: "11315",
    id_polifenol: "117",
    polifenol: "Luteolin",
    id_cancer: "18085",
    cancer: "Teratocarcinoma",
    quant: "1",
    pmids: "29865197",
  },
  {
    id: "11316",
    id_polifenol: "129",
    polifenol: "Rotenone",
    id_cancer: "18085",
    cancer: "Teratocarcinoma",
    quant: "1",
    pmids: "23952718",
  },
  {
    id: "11317",
    id_polifenol: "6800",
    polifenol: "3,6-dimethoxy-6'',6''-dimethylchromeno(2'',3''-7,8)flavone",
    id_cancer: "18085",
    cancer: "Teratocarcinoma",
    quant: "1",
    pmids: "23952718",
  },
  {
    id: "11318",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "6902",
    cancer: "Granulosa Cell Tumor",
    quant: "2",
    pmids: "25165122,20019181",
  },
  {
    id: "11319",
    id_polifenol: "2167",
    polifenol: "phenolic acid",
    id_cancer: "6902",
    cancer: "Granulosa Cell Tumor",
    quant: "1",
    pmids: "28811233",
  },
  {
    id: "11320",
    id_polifenol: "125",
    polifenol: "Isoflavones",
    id_cancer: "6902",
    cancer: "Granulosa Cell Tumor",
    quant: "1",
    pmids: "25165122",
  },
  {
    id: "11321",
    id_polifenol: "285",
    polifenol: "bisphenol A",
    id_cancer: "6902",
    cancer: "Granulosa Cell Tumor",
    quant: "4",
    pmids: "29603059,28111160,29653259,28811233",
  },
  {
    id: "11322",
    id_polifenol: "5844",
    polifenol: "4-dimethylamino-3',4'-dimethoxychalcone",
    id_cancer: "6902",
    cancer: "Granulosa Cell Tumor",
    quant: "1",
    pmids: "18603835",
  },
  {
    id: "11323",
    id_polifenol: "409",
    polifenol: "tetrachlorodian",
    id_cancer: "6902",
    cancer: "Granulosa Cell Tumor",
    quant: "3",
    pmids: "28111160,29653259,28811233",
  },
  {
    id: "11324",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "13023",
    cancer: "Sarcoma 180",
    quant: "1",
    pmids: "25119583",
  },
  {
    id: "11325",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "13023",
    cancer: "Sarcoma 180",
    quant: "1",
    pmids: "27956351",
  },
  {
    id: "11326",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "13023",
    cancer: "Sarcoma 180",
    quant: "1",
    pmids: "27956351",
  },
  {
    id: "11327",
    id_polifenol: "49",
    polifenol: "Aspirin",
    id_cancer: "13023",
    cancer: "Sarcoma 180",
    quant: "1",
    pmids: "14563940",
  },
  {
    id: "11328",
    id_polifenol: "110",
    polifenol: "Chalcones",
    id_cancer: "13023",
    cancer: "Sarcoma 180",
    quant: "2",
    pmids: "26615871,20888764",
  },
  {
    id: "11329",
    id_polifenol: "129",
    polifenol: "Rotenone",
    id_cancer: "13023",
    cancer: "Sarcoma 180",
    quant: "1",
    pmids: "184923",
  },
  {
    id: "11330",
    id_polifenol: "130",
    polifenol: "Proanthocyanidins",
    id_cancer: "13023",
    cancer: "Sarcoma 180",
    quant: "1",
    pmids: "21995732",
  },
  {
    id: "11331",
    id_polifenol: "35",
    polifenol: "Hydroquinones",
    id_cancer: "13023",
    cancer: "Sarcoma 180",
    quant: "1",
    pmids: "184923",
  },
  {
    id: "11332",
    id_polifenol: "4585",
    polifenol: "baohuoside I",
    id_cancer: "13023",
    cancer: "Sarcoma 180",
    quant: "1",
    pmids: "25119583",
  },
  {
    id: "11333",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "511",
    cancer: "Adrenocortical Carcinoma",
    quant: "4",
    pmids: "19913079,19418629,11564685,17283246",
  },
  {
    id: "11334",
    id_polifenol: "4253",
    polifenol:
      "5-(2,4-dihydroxy-5-isopropylphenyl)-4-(4-morpholin-4-ylmethylphenyl)isoxazole-3-carboxylic acid ethylamide",
    id_cancer: "511",
    cancer: "Adrenocortical Carcinoma",
    quant: "1",
    pmids: "24850175",
  },
  {
    id: "11335",
    id_polifenol: "477",
    polifenol: "efonidipine",
    id_cancer: "511",
    cancer: "Adrenocortical Carcinoma",
    quant: "1",
    pmids: "17044661",
  },
  {
    id: "11336",
    id_polifenol: "4181",
    polifenol: "L 783277",
    id_cancer: "511",
    cancer: "Adrenocortical Carcinoma",
    quant: "1",
    pmids: "20074452",
  },
  {
    id: "11337",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "18765",
    cancer: "Vascular Neoplasms",
    quant: "3",
    pmids: "16952909,16403733,17034658",
  },
  {
    id: "11338",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "18765",
    cancer: "Vascular Neoplasms",
    quant: "1",
    pmids: "15269163",
  },
  {
    id: "11339",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "18765",
    cancer: "Vascular Neoplasms",
    quant: "1",
    pmids: "25572615",
  },
  {
    id: "11340",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "18765",
    cancer: "Vascular Neoplasms",
    quant: "1",
    pmids: "12496489",
  },
  {
    id: "11341",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "18765",
    cancer: "Vascular Neoplasms",
    quant: "1",
    pmids: "17034658",
  },
  {
    id: "11342",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "18765",
    cancer: "Vascular Neoplasms",
    quant: "1",
    pmids: "15269163",
  },
  {
    id: "11343",
    id_polifenol: "105",
    polifenol: "Anthocyanins",
    id_cancer: "18765",
    cancer: "Vascular Neoplasms",
    quant: "1",
    pmids: "14972022",
  },
  {
    id: "11344",
    id_polifenol: "2344",
    polifenol: "methyl gallate",
    id_cancer: "18765",
    cancer: "Vascular Neoplasms",
    quant: "1",
    pmids: "15269163",
  },
  {
    id: "11345",
    id_polifenol: "4708",
    polifenol: "xanthohumol",
    id_cancer: "18765",
    cancer: "Vascular Neoplasms",
    quant: "1",
    pmids: "16403733",
  },
  {
    id: "11346",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "492",
    cancer: "Bile Duct Cancer",
    quant: "1",
    pmids: "19278301",
  },
  {
    id: "11347",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "492",
    cancer: "Bile Duct Cancer",
    quant: "1",
    pmids: "20510329",
  },
  {
    id: "11348",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "492",
    cancer: "Bile Duct Cancer",
    quant: "1",
    pmids: "23348740",
  },
  {
    id: "11349",
    id_polifenol: "125",
    polifenol: "Isoflavones",
    id_cancer: "492",
    cancer: "Bile Duct Cancer",
    quant: "1",
    pmids: "19278301",
  },
  {
    id: "11350",
    id_polifenol: "114",
    polifenol: "Apigenin",
    id_cancer: "492",
    cancer: "Bile Duct Cancer",
    quant: "1",
    pmids: "26312563",
  },
  {
    id: "11351",
    id_polifenol: "105",
    polifenol: "Anthocyanins",
    id_cancer: "492",
    cancer: "Bile Duct Cancer",
    quant: "1",
    pmids: "29512768",
  },
  {
    id: "11352",
    id_polifenol: "6625",
    polifenol: "phenoxodiol",
    id_cancer: "492",
    cancer: "Bile Duct Cancer",
    quant: "1",
    pmids: "19278301",
  },
  {
    id: "11353",
    id_polifenol: "6477",
    polifenol: "hispidulin",
    id_cancer: "492",
    cancer: "Bile Duct Cancer",
    quant: "1",
    pmids: "25499970",
  },
  {
    id: "11354",
    id_polifenol: "6881",
    polifenol: "triphendiol",
    id_cancer: "492",
    cancer: "Bile Duct Cancer",
    quant: "1",
    pmids: "19278301",
  },
  {
    id: "11355",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "18118",
    cancer: "Carcinoma, Mucoepidermoid",
    quant: "1",
    pmids: "24309154",
  },
  {
    id: "11356",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "18118",
    cancer: "Carcinoma, Mucoepidermoid",
    quant: "1",
    pmids: "16009452",
  },
  {
    id: "11357",
    id_polifenol: "7235",
    polifenol: "silybin",
    id_cancer: "18118",
    cancer: "Carcinoma, Mucoepidermoid",
    quant: "1",
    pmids: "28401485",
  },
  {
    id: "11358",
    id_polifenol: "4515",
    polifenol: "baicalin",
    id_cancer: "18118",
    cancer: "Carcinoma, Mucoepidermoid",
    quant: "1",
    pmids: "20204673",
  },
  {
    id: "11359",
    id_polifenol: "5844",
    polifenol: "4-dimethylamino-3',4'-dimethoxychalcone",
    id_cancer: "18118",
    cancer: "Carcinoma, Mucoepidermoid",
    quant: "1",
    pmids: "11138460",
  },
  {
    id: "11360",
    id_polifenol: "4505",
    polifenol: "pycnogenols",
    id_cancer: "18118",
    cancer: "Carcinoma, Mucoepidermoid",
    quant: "1",
    pmids: "25574461",
  },
  {
    id: "11361",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "16684",
    cancer: "Neoplasms, Second Primary",
    quant: "1",
    pmids: "24705371",
  },
  {
    id: "11362",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "16684",
    cancer: "Neoplasms, Second Primary",
    quant: "2",
    pmids: "18467956,23762158",
  },
  {
    id: "11363",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "16684",
    cancer: "Neoplasms, Second Primary",
    quant: "2",
    pmids: "27550943,18467956",
  },
  {
    id: "11364",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "16684",
    cancer: "Neoplasms, Second Primary",
    quant: "2",
    pmids: "19800779,23762158",
  },
  {
    id: "11365",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "16684",
    cancer: "Neoplasms, Second Primary",
    quant: "1",
    pmids: "23762158",
  },
  {
    id: "11366",
    id_polifenol: "125",
    polifenol: "Isoflavones",
    id_cancer: "16684",
    cancer: "Neoplasms, Second Primary",
    quant: "1",
    pmids: "19800779",
  },
  {
    id: "11367",
    id_polifenol: "114",
    polifenol: "Apigenin",
    id_cancer: "16684",
    cancer: "Neoplasms, Second Primary",
    quant: "1",
    pmids: "22569706",
  },
  {
    id: "11368",
    id_polifenol: "7235",
    polifenol: "silybin",
    id_cancer: "16684",
    cancer: "Neoplasms, Second Primary",
    quant: "1",
    pmids: "24705371",
  },
  {
    id: "11369",
    id_polifenol: "6451",
    polifenol: "daidzein",
    id_cancer: "16684",
    cancer: "Neoplasms, Second Primary",
    quant: "1",
    pmids: "19800779",
  },
  {
    id: "11370",
    id_polifenol: "126",
    polifenol: "Coumestrol",
    id_cancer: "16684",
    cancer: "Neoplasms, Second Primary",
    quant: "1",
    pmids: "19800779",
  },
  {
    id: "11371",
    id_polifenol: "6510",
    polifenol: "glycitein",
    id_cancer: "16684",
    cancer: "Neoplasms, Second Primary",
    quant: "1",
    pmids: "19800779",
  },
  {
    id: "11372",
    id_polifenol: "5697",
    polifenol:
      "3-(3,4-dimethoxyphenyl)-1-(5-hydroxy-2,2-dimethyl-2H-chromen-6-yl)prop-2-en-1-one",
    id_cancer: "16684",
    cancer: "Neoplasms, Second Primary",
    quant: "1",
    pmids: "27550943",
  },
  {
    id: "11373",
    id_polifenol: "1159",
    polifenol: "2-(5-(3-fluorophenyl)-1H-pyrazol-3-yl)-5-methylphenol",
    id_cancer: "16684",
    cancer: "Neoplasms, Second Primary",
    quant: "1",
    pmids: "27550943",
  },
  {
    id: "11374",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "3225",
    cancer: "Carcinoma in Situ",
    quant: "1",
    pmids: "9436857",
  },
  {
    id: "11375",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "3225",
    cancer: "Carcinoma in Situ",
    quant: "1",
    pmids: "18026817",
  },
  {
    id: "11376",
    id_polifenol: "49",
    polifenol: "Aspirin",
    id_cancer: "3225",
    cancer: "Carcinoma in Situ",
    quant: "1",
    pmids: "23019409",
  },
  {
    id: "11377",
    id_polifenol: "125",
    polifenol: "Isoflavones",
    id_cancer: "3225",
    cancer: "Carcinoma in Situ",
    quant: "1",
    pmids: "11795443",
  },
  {
    id: "11378",
    id_polifenol: "285",
    polifenol: "bisphenol A",
    id_cancer: "3225",
    cancer: "Carcinoma in Situ",
    quant: "1",
    pmids: "9524557",
  },
  {
    id: "11379",
    id_polifenol: "1613",
    polifenol: "demethoxycurcumin",
    id_cancer: "3225",
    cancer: "Carcinoma in Situ",
    quant: "1",
    pmids: "29575236",
  },
  {
    id: "11380",
    id_polifenol: "350",
    polifenol: "nonylphenol",
    id_cancer: "3225",
    cancer: "Carcinoma in Situ",
    quant: "1",
    pmids: "9524557",
  },
  {
    id: "11381",
    id_polifenol: "3019",
    polifenol: "nitroaspirin",
    id_cancer: "3225",
    cancer: "Carcinoma in Situ",
    quant: "1",
    pmids: "23019409",
  },
  {
    id: "11382",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "2636",
    cancer: "Biliary Tract Neoplasms",
    quant: "1",
    pmids: "12053219",
  },
  {
    id: "11383",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "2636",
    cancer: "Biliary Tract Neoplasms",
    quant: "1",
    pmids: "10534331",
  },
  {
    id: "11384",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "2636",
    cancer: "Biliary Tract Neoplasms",
    quant: "1",
    pmids: "22211101",
  },
  {
    id: "11385",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "2636",
    cancer: "Biliary Tract Neoplasms",
    quant: "2",
    pmids: "12053219,26100134",
  },
  {
    id: "11386",
    id_polifenol: "49",
    polifenol: "Aspirin",
    id_cancer: "2636",
    cancer: "Biliary Tract Neoplasms",
    quant: "1",
    pmids: "21076843",
  },
  {
    id: "11387",
    id_polifenol: "125",
    polifenol: "Isoflavones",
    id_cancer: "2636",
    cancer: "Biliary Tract Neoplasms",
    quant: "1",
    pmids: "24902539",
  },
  {
    id: "11388",
    id_polifenol: "4519",
    polifenol: "myricetin",
    id_cancer: "2636",
    cancer: "Biliary Tract Neoplasms",
    quant: "1",
    pmids: "22211101",
  },
  {
    id: "11389",
    id_polifenol: "5614",
    polifenol: "catechin gallate",
    id_cancer: "2636",
    cancer: "Biliary Tract Neoplasms",
    quant: "1",
    pmids: "26100134",
  },
  {
    id: "11390",
    id_polifenol: "6625",
    polifenol: "phenoxodiol",
    id_cancer: "2636",
    cancer: "Biliary Tract Neoplasms",
    quant: "1",
    pmids: "24902539",
  },
  {
    id: "11391",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "493",
    cancer: "Carcinoid Tumor, Gastrointestinal",
    quant: "2",
    pmids: "21367373,28713616",
  },
  {
    id: "11392",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "493",
    cancer: "Carcinoid Tumor, Gastrointestinal",
    quant: "1",
    pmids: "16950763",
  },
  {
    id: "11393",
    id_polifenol: "49",
    polifenol: "Aspirin",
    id_cancer: "493",
    cancer: "Carcinoid Tumor, Gastrointestinal",
    quant: "1",
    pmids: "2823818",
  },
  {
    id: "11394",
    id_polifenol: "6065",
    polifenol: "baicalein",
    id_cancer: "493",
    cancer: "Carcinoid Tumor, Gastrointestinal",
    quant: "1",
    pmids: "28713616",
  },
  {
    id: "11395",
    id_polifenol: "6087",
    polifenol: "wogonin",
    id_cancer: "493",
    cancer: "Carcinoid Tumor, Gastrointestinal",
    quant: "1",
    pmids: "28713616",
  },
  {
    id: "11396",
    id_polifenol: "4513",
    polifenol: "galangin",
    id_cancer: "493",
    cancer: "Carcinoid Tumor, Gastrointestinal",
    quant: "1",
    pmids: "23762160",
  },
  {
    id: "11397",
    id_polifenol: "6273",
    polifenol: "hesperetin",
    id_cancer: "493",
    cancer: "Carcinoid Tumor, Gastrointestinal",
    quant: "1",
    pmids: "21367373",
  },
  {
    id: "11398",
    id_polifenol: "4253",
    polifenol:
      "5-(2,4-dihydroxy-5-isopropylphenyl)-4-(4-morpholin-4-ylmethylphenyl)isoxazole-3-carboxylic acid ethylamide",
    id_cancer: "493",
    cancer: "Carcinoid Tumor, Gastrointestinal",
    quant: "1",
    pmids: "25301256",
  },
  {
    id: "11399",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "611",
    cancer: "Ependymoma",
    quant: "1",
    pmids: "19110045",
  },
  {
    id: "11400",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "611",
    cancer: "Ependymoma",
    quant: "1",
    pmids: "11940570",
  },
  {
    id: "11401",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "611",
    cancer: "Ependymoma",
    quant: "1",
    pmids: "11940570",
  },
  {
    id: "11402",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "611",
    cancer: "Ependymoma",
    quant: "1",
    pmids: "21078540",
  },
  {
    id: "11403",
    id_polifenol: "130",
    polifenol: "Proanthocyanidins",
    id_cancer: "611",
    cancer: "Ependymoma",
    quant: "1",
    pmids: "11697199",
  },
  {
    id: "11404",
    id_polifenol: "112",
    polifenol: "Hesperidin",
    id_cancer: "611",
    cancer: "Ependymoma",
    quant: "1",
    pmids: "19110045",
  },
  {
    id: "11405",
    id_polifenol: "59",
    polifenol: "Dinitrophenols",
    id_cancer: "611",
    cancer: "Ependymoma",
    quant: "1",
    pmids: "170904",
  },
  {
    id: "11406",
    id_polifenol: "1353",
    polifenol: "protocatechualdehyde",
    id_cancer: "611",
    cancer: "Ependymoma",
    quant: "1",
    pmids: "23269534",
  },
  {
    id: "11407",
    id_polifenol: "7853",
    polifenol: "Grape Seed Proanthocyanidins",
    id_cancer: "611",
    cancer: "Ependymoma",
    quant: "1",
    pmids: "11697199",
  },
  {
    id: "11408",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "533",
    cancer: "Wilms Tumor",
    quant: "2",
    pmids: "16490174,27569892",
  },
  {
    id: "11409",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "533",
    cancer: "Wilms Tumor",
    quant: "2",
    pmids: "28390675,12717393",
  },
  {
    id: "11410",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "533",
    cancer: "Wilms Tumor",
    quant: "1",
    pmids: "10873031",
  },
  {
    id: "11411",
    id_polifenol: "1353",
    polifenol: "protocatechualdehyde",
    id_cancer: "533",
    cancer: "Wilms Tumor",
    quant: "1",
    pmids: "29285297",
  },
  {
    id: "11412",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "8595",
    cancer: "Leiomyosarcoma",
    quant: "3",
    pmids: "22350026,21450334,23666561",
  },
  {
    id: "11413",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "8595",
    cancer: "Leiomyosarcoma",
    quant: "1",
    pmids: "11238032",
  },
  {
    id: "11414",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "8595",
    cancer: "Leiomyosarcoma",
    quant: "1",
    pmids: "22350026",
  },
  {
    id: "11415",
    id_polifenol: "6",
    polifenol: "Catechols",
    id_cancer: "8595",
    cancer: "Leiomyosarcoma",
    quant: "1",
    pmids: "11323396",
  },
  {
    id: "11416",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "556",
    cancer: "Salivary Gland Cancer",
    quant: "1",
    pmids: "25296980",
  },
  {
    id: "11417",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "556",
    cancer: "Salivary Gland Cancer",
    quant: "2",
    pmids: "27670669,25296980",
  },
  {
    id: "11418",
    id_polifenol: "7235",
    polifenol: "silybin",
    id_cancer: "556",
    cancer: "Salivary Gland Cancer",
    quant: "1",
    pmids: "28401485",
  },
  {
    id: "11419",
    id_polifenol: "6",
    polifenol: "Catechols",
    id_cancer: "556",
    cancer: "Salivary Gland Cancer",
    quant: "1",
    pmids: "6771000",
  },
  {
    id: "11420",
    id_polifenol: "5844",
    polifenol: "4-dimethylamino-3',4'-dimethoxychalcone",
    id_cancer: "556",
    cancer: "Salivary Gland Cancer",
    quant: "1",
    pmids: "15279653",
  },
  {
    id: "11421",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "25413",
    cancer: "Leukemia, Myelomonocytic, Juvenile",
    quant: "1",
    pmids: "29554655",
  },
  {
    id: "11422",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "25413",
    cancer: "Leukemia, Myelomonocytic, Juvenile",
    quant: "1",
    pmids: "21793155",
  },
  {
    id: "11423",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "25413",
    cancer: "Leukemia, Myelomonocytic, Juvenile",
    quant: "1",
    pmids: "16395705",
  },
  {
    id: "11424",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "25413",
    cancer: "Leukemia, Myelomonocytic, Juvenile",
    quant: "1",
    pmids: "11299730",
  },
  {
    id: "11425",
    id_polifenol: "4515",
    polifenol: "baicalin",
    id_cancer: "25413",
    cancer: "Leukemia, Myelomonocytic, Juvenile",
    quant: "1",
    pmids: "29554655",
  },
  {
    id: "11426",
    id_polifenol: "4537",
    polifenol: "flavone acetic acid",
    id_cancer: "25413",
    cancer: "Leukemia, Myelomonocytic, Juvenile",
    quant: "1",
    pmids: "8313372",
  },
  {
    id: "11427",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "3237",
    cancer: "Carcinoma, Papillary",
    quant: "1",
    pmids: "10319943",
  },
  {
    id: "11428",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "3237",
    cancer: "Carcinoma, Papillary",
    quant: "1",
    pmids: "10319943",
  },
  {
    id: "11429",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "3237",
    cancer: "Carcinoma, Papillary",
    quant: "1",
    pmids: "27149655",
  },
  {
    id: "11430",
    id_polifenol: "114",
    polifenol: "Apigenin",
    id_cancer: "3237",
    cancer: "Carcinoma, Papillary",
    quant: "1",
    pmids: "10319943",
  },
  {
    id: "11431",
    id_polifenol: "117",
    polifenol: "Luteolin",
    id_cancer: "3237",
    cancer: "Carcinoma, Papillary",
    quant: "1",
    pmids: "10319943",
  },
  {
    id: "11432",
    id_polifenol: "7235",
    polifenol: "silybin",
    id_cancer: "3237",
    cancer: "Carcinoma, Papillary",
    quant: "1",
    pmids: "18089718",
  },
  {
    id: "11433",
    id_polifenol: "121",
    polifenol: "Kaempferols",
    id_cancer: "3237",
    cancer: "Carcinoma, Papillary",
    quant: "1",
    pmids: "10319943",
  },
  {
    id: "11434",
    id_polifenol: "4522",
    polifenol: "chrysin",
    id_cancer: "3237",
    cancer: "Carcinoma, Papillary",
    quant: "1",
    pmids: "10319943",
  },
  {
    id: "11435",
    id_polifenol: "5578",
    polifenol: "alpha-naphthoflavone",
    id_cancer: "3237",
    cancer: "Carcinoma, Papillary",
    quant: "1",
    pmids: "22485252",
  },
  {
    id: "11436",
    id_polifenol: "107",
    polifenol: "beta-Naphthoflavone",
    id_cancer: "3237",
    cancer: "Carcinoma, Papillary",
    quant: "1",
    pmids: "8565121",
  },
  {
    id: "11437",
    id_polifenol: "4796",
    polifenol: "aminoflavone",
    id_cancer: "3237",
    cancer: "Carcinoma, Papillary",
    quant: "1",
    pmids: "22485252",
  },
  {
    id: "11438",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "8773",
    cancer: "Liposarcoma",
    quant: "1",
    pmids: "21245867",
  },
  {
    id: "11439",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "8773",
    cancer: "Liposarcoma",
    quant: "1",
    pmids: "11238032",
  },
  {
    id: "11440",
    id_polifenol: "110",
    polifenol: "Chalcones",
    id_cancer: "8773",
    cancer: "Liposarcoma",
    quant: "1",
    pmids: "18767861",
  },
  {
    id: "11441",
    id_polifenol: "871",
    polifenol: "ABT-737",
    id_cancer: "8773",
    cancer: "Liposarcoma",
    quant: "1",
    pmids: "27822137",
  },
  {
    id: "11442",
    id_polifenol: "5808",
    polifenol: "isoliquiritigenin",
    id_cancer: "8773",
    cancer: "Liposarcoma",
    quant: "1",
    pmids: "18767861",
  },
  {
    id: "11443",
    id_polifenol: "4253",
    polifenol:
      "5-(2,4-dihydroxy-5-isopropylphenyl)-4-(4-morpholin-4-ylmethylphenyl)isoxazole-3-carboxylic acid ethylamide",
    id_cancer: "8773",
    cancer: "Liposarcoma",
    quant: "1",
    pmids: "26225840",
  },
  {
    id: "11444",
    id_polifenol: "7880",
    polifenol: "xanthoangelol",
    id_cancer: "8773",
    cancer: "Liposarcoma",
    quant: "1",
    pmids: "18767861",
  },
  {
    id: "11445",
    id_polifenol: "7736",
    polifenol: "7-monohydroxyethylrutoside",
    id_cancer: "8773",
    cancer: "Liposarcoma",
    quant: "1",
    pmids: "21245867",
  },
  {
    id: "11446",
    id_polifenol: "7899",
    polifenol: "isolespeol",
    id_cancer: "8773",
    cancer: "Liposarcoma",
    quant: "1",
    pmids: "18767861",
  },
  {
    id: "11447",
    id_polifenol: "5813",
    polifenol: "3,4,2',4'-tetrahydroxy-2-geranyldihydrochalcone",
    id_cancer: "8773",
    cancer: "Liposarcoma",
    quant: "1",
    pmids: "18767861",
  },
  {
    id: "11448",
    id_polifenol: "7702",
    polifenol: "7-mono-O-(beta-hydroxyethyl)rutoside",
    id_cancer: "8773",
    cancer: "Liposarcoma",
    quant: "1",
    pmids: "21245867",
  },
  {
    id: "11449",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "14857",
    cancer: "Tumor Virus Infections",
    quant: "1",
    pmids: "26427909",
  },
  {
    id: "11450",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "14857",
    cancer: "Tumor Virus Infections",
    quant: "2",
    pmids: "28801242,12124453",
  },
  {
    id: "11451",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "14857",
    cancer: "Tumor Virus Infections",
    quant: "1",
    pmids: "28801242",
  },
  {
    id: "11452",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "14857",
    cancer: "Tumor Virus Infections",
    quant: "1",
    pmids: "12742577",
  },
  {
    id: "11453",
    id_polifenol: "49",
    polifenol: "Aspirin",
    id_cancer: "14857",
    cancer: "Tumor Virus Infections",
    quant: "1",
    pmids: "12124453",
  },
  {
    id: "11454",
    id_polifenol: "109",
    polifenol: "Catechin",
    id_cancer: "14857",
    cancer: "Tumor Virus Infections",
    quant: "2",
    pmids: "12742577,26427909",
  },
  {
    id: "11455",
    id_polifenol: "44",
    polifenol: "Salicylates",
    id_cancer: "14857",
    cancer: "Tumor Virus Infections",
    quant: "1",
    pmids: "12124453",
  },
  {
    id: "11456",
    id_polifenol: "55",
    polifenol: "Sodium Salicylate",
    id_cancer: "14857",
    cancer: "Tumor Virus Infections",
    quant: "1",
    pmids: "12124453",
  },
  {
    id: "11457",
    id_polifenol: "452",
    polifenol: "acteoside",
    id_cancer: "14857",
    cancer: "Tumor Virus Infections",
    quant: "1",
    pmids: "26427909",
  },
  {
    id: "11458",
    id_polifenol: "42",
    polifenol: "Pactamycin",
    id_cancer: "14857",
    cancer: "Tumor Virus Infections",
    quant: "1",
    pmids: "4368674",
  },
  {
    id: "11459",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "18157",
    cancer: "Gliosarcoma",
    quant: "1",
    pmids: "11523680",
  },
  {
    id: "11460",
    id_polifenol: "110",
    polifenol: "Chalcones",
    id_cancer: "18157",
    cancer: "Gliosarcoma",
    quant: "1",
    pmids: "22713877",
  },
  {
    id: "11461",
    id_polifenol: "1",
    polifenol: "Phenols",
    id_cancer: "18157",
    cancer: "Gliosarcoma",
    quant: "1",
    pmids: "19869465",
  },
  {
    id: "11462",
    id_polifenol: "60",
    polifenol: "2,4-Dinitrophenol",
    id_cancer: "18157",
    cancer: "Gliosarcoma",
    quant: "1",
    pmids: "3468375",
  },
  {
    id: "11463",
    id_polifenol: "59",
    polifenol: "Dinitrophenols",
    id_cancer: "18157",
    cancer: "Gliosarcoma",
    quant: "1",
    pmids: "3468375",
  },
  {
    id: "11464",
    id_polifenol: "714",
    polifenol: "3-(4-hydroxyphenyl)propanol",
    id_cancer: "18157",
    cancer: "Gliosarcoma",
    quant: "1",
    pmids: "11118049",
  },
  {
    id: "11465",
    id_polifenol: "476",
    polifenol: "N-acetyl-4-S-cysteaminylphenol",
    id_cancer: "18157",
    cancer: "Gliosarcoma",
    quant: "1",
    pmids: "11118049",
  },
  {
    id: "11466",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "229154",
    cancer: "Neural crest tumor",
    quant: "1",
    pmids: "26398443",
  },
  {
    id: "11467",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "229154",
    cancer: "Neural crest tumor",
    quant: "1",
    pmids: "29054984",
  },
  {
    id: "11468",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "229154",
    cancer: "Neural crest tumor",
    quant: "1",
    pmids: "1668058",
  },
  {
    id: "11469",
    id_polifenol: "111",
    polifenol: "Flavanones",
    id_cancer: "229154",
    cancer: "Neural crest tumor",
    quant: "1",
    pmids: "28428136",
  },
  {
    id: "11470",
    id_polifenol: "6273",
    polifenol: "hesperetin",
    id_cancer: "229154",
    cancer: "Neural crest tumor",
    quant: "1",
    pmids: "28428136",
  },
  {
    id: "11471",
    id_polifenol: "2014",
    polifenol: "erbstatin",
    id_cancer: "229154",
    cancer: "Neural crest tumor",
    quant: "1",
    pmids: "1668058",
  },
  {
    id: "11472",
    id_polifenol: "9",
    polifenol: "1,2-Dihydroxybenzene-3,5-Disulfonic Acid Disodium Salt",
    id_cancer: "229154",
    cancer: "Neural crest tumor",
    quant: "1",
    pmids: "18760622",
  },
  {
    id: "11473",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "16632",
    cancer: "Central Nervous System Neoplasms",
    quant: "1",
    pmids: "8642556",
  },
  {
    id: "11474",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "16632",
    cancer: "Central Nervous System Neoplasms",
    quant: "2",
    pmids: "17594054,29588587",
  },
  {
    id: "11475",
    id_polifenol: "110",
    polifenol: "Chalcones",
    id_cancer: "16632",
    cancer: "Central Nervous System Neoplasms",
    quant: "1",
    pmids: "22209415",
  },
  {
    id: "11476",
    id_polifenol: "113",
    polifenol: "Flavones",
    id_cancer: "16632",
    cancer: "Central Nervous System Neoplasms",
    quant: "1",
    pmids: "17363487",
  },
  {
    id: "11477",
    id_polifenol: "418",
    polifenol: "thiophenol",
    id_cancer: "16632",
    cancer: "Central Nervous System Neoplasms",
    quant: "1",
    pmids: "8642556",
  },
  {
    id: "11478",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "508",
    cancer: "Rectal Cancer",
    quant: "1",
    pmids: "19087425",
  },
  {
    id: "11479",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "508",
    cancer: "Rectal Cancer",
    quant: "3",
    pmids: "19735878,28000198,22204522",
  },
  {
    id: "11480",
    id_polifenol: "113",
    polifenol: "Flavones",
    id_cancer: "508",
    cancer: "Rectal Cancer",
    quant: "1",
    pmids: "7139549",
  },
  {
    id: "11481",
    id_polifenol: "1613",
    polifenol: "demethoxycurcumin",
    id_cancer: "508",
    cancer: "Rectal Cancer",
    quant: "1",
    pmids: "22204522",
  },
  {
    id: "11482",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "10016",
    cancer: "Oligodendroglioma",
    quant: "1",
    pmids: "9163681",
  },
  {
    id: "11483",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "10016",
    cancer: "Oligodendroglioma",
    quant: "1",
    pmids: "21801144",
  },
  {
    id: "11484",
    id_polifenol: "49",
    polifenol: "Aspirin",
    id_cancer: "10016",
    cancer: "Oligodendroglioma",
    quant: "2",
    pmids: "16042578,15992053",
  },
  {
    id: "11485",
    id_polifenol: "871",
    polifenol: "ABT-737",
    id_cancer: "10016",
    cancer: "Oligodendroglioma",
    quant: "1",
    pmids: "25624498",
  },
  {
    id: "11486",
    id_polifenol: "112",
    polifenol: "Hesperidin",
    id_cancer: "10016",
    cancer: "Oligodendroglioma",
    quant: "1",
    pmids: "9163681",
  },
  {
    id: "11487",
    id_polifenol: "115",
    polifenol: "Diosmin",
    id_cancer: "10016",
    cancer: "Oligodendroglioma",
    quant: "1",
    pmids: "9163681",
  },
  {
    id: "11488",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "18047",
    cancer: "Adenocarcinoma, Mucinous",
    quant: "1",
    pmids: "22751848",
  },
  {
    id: "11489",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "18047",
    cancer: "Adenocarcinoma, Mucinous",
    quant: "1",
    pmids: "19157828",
  },
  {
    id: "11490",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "18047",
    cancer: "Adenocarcinoma, Mucinous",
    quant: "1",
    pmids: "23302779",
  },
  {
    id: "11491",
    id_polifenol: "49",
    polifenol: "Aspirin",
    id_cancer: "18047",
    cancer: "Adenocarcinoma, Mucinous",
    quant: "1",
    pmids: "11908906",
  },
  {
    id: "11492",
    id_polifenol: "1",
    polifenol: "Phenols",
    id_cancer: "18047",
    cancer: "Adenocarcinoma, Mucinous",
    quant: "1",
    pmids: "28659738",
  },
  {
    id: "11493",
    id_polifenol: "2284",
    polifenol: "rosmarinic acid",
    id_cancer: "18047",
    cancer: "Adenocarcinoma, Mucinous",
    quant: "1",
    pmids: "28659738",
  },
  {
    id: "11494",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "13650",
    cancer: "Sarcoma, Clear Cell",
    quant: "2",
    pmids: "27069807,22784284",
  },
  {
    id: "11495",
    id_polifenol: "110",
    polifenol: "Chalcones",
    id_cancer: "13650",
    cancer: "Sarcoma, Clear Cell",
    quant: "1",
    pmids: "26251468",
  },
  {
    id: "11496",
    id_polifenol: "1",
    polifenol: "Phenols",
    id_cancer: "13650",
    cancer: "Sarcoma, Clear Cell",
    quant: "1",
    pmids: "6213807",
  },
  {
    id: "11497",
    id_polifenol: "130",
    polifenol: "Proanthocyanidins",
    id_cancer: "13650",
    cancer: "Sarcoma, Clear Cell",
    quant: "1",
    pmids: "27070584",
  },
  {
    id: "11498",
    id_polifenol: "5850",
    polifenol: "cardamonin",
    id_cancer: "13650",
    cancer: "Sarcoma, Clear Cell",
    quant: "1",
    pmids: "26251468",
  },
  {
    id: "11499",
    id_polifenol: "7853",
    polifenol: "Grape Seed Proanthocyanidins",
    id_cancer: "13650",
    cancer: "Sarcoma, Clear Cell",
    quant: "1",
    pmids: "27070584",
  },
  {
    id: "11500",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "25551",
    cancer: "Lymphoma, Primary Effusion",
    quant: "1",
    pmids: "28092744",
  },
  {
    id: "11501",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "25551",
    cancer: "Lymphoma, Primary Effusion",
    quant: "1",
    pmids: "28801242",
  },
  {
    id: "11502",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "25551",
    cancer: "Lymphoma, Primary Effusion",
    quant: "2",
    pmids: "28092744,28801242",
  },
  {
    id: "11503",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "25551",
    cancer: "Lymphoma, Primary Effusion",
    quant: "1",
    pmids: "29267216",
  },
  {
    id: "11504",
    id_polifenol: "55",
    polifenol: "Sodium Salicylate",
    id_cancer: "25551",
    cancer: "Lymphoma, Primary Effusion",
    quant: "1",
    pmids: "24692721",
  },
  {
    id: "11505",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "18114",
    cancer: "Carcinoma, Islet Cell",
    quant: "1",
    pmids: "28098903",
  },
  {
    id: "11506",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "18114",
    cancer: "Carcinoma, Islet Cell",
    quant: "1",
    pmids: "25517601",
  },
  {
    id: "11507",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "18114",
    cancer: "Carcinoma, Islet Cell",
    quant: "1",
    pmids: "23521677",
  },
  {
    id: "11508",
    id_polifenol: "2167",
    polifenol: "phenolic acid",
    id_cancer: "18114",
    cancer: "Carcinoma, Islet Cell",
    quant: "1",
    pmids: "23521677",
  },
  {
    id: "11509",
    id_polifenol: "4253",
    polifenol:
      "5-(2,4-dihydroxy-5-isopropylphenyl)-4-(4-morpholin-4-ylmethylphenyl)isoxazole-3-carboxylic acid ethylamide",
    id_cancer: "18114",
    cancer: "Carcinoma, Islet Cell",
    quant: "1",
    pmids: "25301256",
  },
  {
    id: "11510",
    id_polifenol: "7134",
    polifenol: "vitexin",
    id_cancer: "18114",
    cancer: "Carcinoma, Islet Cell",
    quant: "1",
    pmids: "28098903",
  },
  {
    id: "11511",
    id_polifenol: "885",
    polifenol: "oleocanthal",
    id_cancer: "18114",
    cancer: "Carcinoma, Islet Cell",
    quant: "1",
    pmids: "23521677",
  },
  {
    id: "11512",
    id_polifenol: "49",
    polifenol: "Aspirin",
    id_cancer: "18158",
    cancer: "Nerve Sheath Neoplasms",
    quant: "1",
    pmids: "27236462",
  },
  {
    id: "11513",
    id_polifenol: "871",
    polifenol: "ABT-737",
    id_cancer: "18158",
    cancer: "Nerve Sheath Neoplasms",
    quant: "2",
    pmids: "22664653,28055968",
  },
  {
    id: "11514",
    id_polifenol: "2773",
    polifenol: "farnesylthiosalicylic acid",
    id_cancer: "18158",
    cancer: "Nerve Sheath Neoplasms",
    quant: "1",
    pmids: "23530091",
  },
  {
    id: "11515",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "14775",
    cancer: "Trophoblastic Neoplasms",
    quant: "1",
    pmids: "26608647",
  },
  {
    id: "11516",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "14775",
    cancer: "Trophoblastic Neoplasms",
    quant: "1",
    pmids: "22866146",
  },
  {
    id: "11517",
    id_polifenol: "113",
    polifenol: "Flavones",
    id_cancer: "14775",
    cancer: "Trophoblastic Neoplasms",
    quant: "1",
    pmids: "23859042",
  },
  {
    id: "11518",
    id_polifenol: "108",
    polifenol: "Biflavonoids",
    id_cancer: "14775",
    cancer: "Trophoblastic Neoplasms",
    quant: "1",
    pmids: "27292193",
  },
  {
    id: "11519",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "14407",
    cancer: "Thymus Neoplasms",
    quant: "1",
    pmids: "17210719",
  },
  {
    id: "11520",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "14407",
    cancer: "Thymus Neoplasms",
    quant: "1",
    pmids: "16257011",
  },
  {
    id: "11521",
    id_polifenol: "125",
    polifenol: "Isoflavones",
    id_cancer: "14407",
    cancer: "Thymus Neoplasms",
    quant: "1",
    pmids: "16257011",
  },
  {
    id: "11522",
    id_polifenol: "2284",
    polifenol: "rosmarinic acid",
    id_cancer: "14407",
    cancer: "Thymus Neoplasms",
    quant: "1",
    pmids: "23285814",
  },
  {
    id: "11523",
    id_polifenol: "6465",
    polifenol: "genistin",
    id_cancer: "14407",
    cancer: "Thymus Neoplasms",
    quant: "1",
    pmids: "16257011",
  },
  {
    id: "11524",
    id_polifenol: "4698",
    polifenol: "sakuranetin",
    id_cancer: "14407",
    cancer: "Thymus Neoplasms",
    quant: "1",
    pmids: "23285814",
  },
  {
    id: "11525",
    id_polifenol: "7197",
    polifenol: "6-hydroxyluteolin",
    id_cancer: "14407",
    cancer: "Thymus Neoplasms",
    quant: "1",
    pmids: "23285814",
  },
  {
    id: "11526",
    id_polifenol: "42",
    polifenol: "Pactamycin",
    id_cancer: "14407",
    cancer: "Thymus Neoplasms",
    quant: "1",
    pmids: "192917",
  },
  {
    id: "11527",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "8914",
    cancer: "Lymphoma, Follicular",
    quant: "1",
    pmids: "17198877",
  },
  {
    id: "11528",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "8914",
    cancer: "Lymphoma, Follicular",
    quant: "1",
    pmids: "17198877",
  },
  {
    id: "11529",
    id_polifenol: "871",
    polifenol: "ABT-737",
    id_cancer: "8914",
    cancer: "Lymphoma, Follicular",
    quant: "3",
    pmids: "17200714,16023593,27919179",
  },
  {
    id: "11530",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "588",
    cancer: "Myelodysplastic Syndromes",
    quant: "1",
    pmids: "29786746",
  },
  {
    id: "11531",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "588",
    cancer: "Myelodysplastic Syndromes",
    quant: "1",
    pmids: "28188793",
  },
  {
    id: "11532",
    id_polifenol: "110",
    polifenol: "Chalcones",
    id_cancer: "588",
    cancer: "Myelodysplastic Syndromes",
    quant: "1",
    pmids: "9591187",
  },
  {
    id: "11533",
    id_polifenol: "117",
    polifenol: "Luteolin",
    id_cancer: "588",
    cancer: "Myelodysplastic Syndromes",
    quant: "1",
    pmids: "29786746",
  },
  {
    id: "11534",
    id_polifenol: "7",
    polifenol: "Capsaicin",
    id_cancer: "588",
    cancer: "Myelodysplastic Syndromes",
    quant: "1",
    pmids: "25929448",
  },
  {
    id: "11535",
    id_polifenol: "39",
    polifenol: "Hydrolyzable Tannins",
    id_cancer: "588",
    cancer: "Myelodysplastic Syndromes",
    quant: "1",
    pmids: "9591187",
  },
  {
    id: "11536",
    id_polifenol: "5850",
    polifenol: "cardamonin",
    id_cancer: "588",
    cancer: "Myelodysplastic Syndromes",
    quant: "1",
    pmids: "9591187",
  },
  {
    id: "11537",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "18065",
    cancer: "Dermatofibrosarcoma",
    quant: "2",
    pmids: "24647337,29890744",
  },
  {
    id: "11538",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "18065",
    cancer: "Dermatofibrosarcoma",
    quant: "1",
    pmids: "29890744",
  },
  {
    id: "11539",
    id_polifenol: "49",
    polifenol: "Aspirin",
    id_cancer: "18065",
    cancer: "Dermatofibrosarcoma",
    quant: "1",
    pmids: "17612047",
  },
  {
    id: "11540",
    id_polifenol: "2284",
    polifenol: "rosmarinic acid",
    id_cancer: "18065",
    cancer: "Dermatofibrosarcoma",
    quant: "1",
    pmids: "20157877",
  },
  {
    id: "11541",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "3235",
    cancer: "Neoplasms, Multiple Primary",
    quant: "1",
    pmids: "23936796",
  },
  {
    id: "11542",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "3235",
    cancer: "Neoplasms, Multiple Primary",
    quant: "1",
    pmids: "12163380",
  },
  {
    id: "11543",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "3235",
    cancer: "Neoplasms, Multiple Primary",
    quant: "1",
    pmids: "26225796",
  },
  {
    id: "11544",
    id_polifenol: "123",
    polifenol: "Rutin",
    id_cancer: "3235",
    cancer: "Neoplasms, Multiple Primary",
    quant: "1",
    pmids: "17953789",
  },
  {
    id: "11545",
    id_polifenol: "75",
    polifenol: "Butylated Hydroxyanisole",
    id_cancer: "3235",
    cancer: "Neoplasms, Multiple Primary",
    quant: "1",
    pmids: "17953789",
  },
  {
    id: "11546",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "10060",
    cancer: "Nervous System Neoplasms",
    quant: "1",
    pmids: "25730045",
  },
  {
    id: "11547",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "10060",
    cancer: "Nervous System Neoplasms",
    quant: "1",
    pmids: "16595125",
  },
  {
    id: "11548",
    id_polifenol: "117",
    polifenol: "Luteolin",
    id_cancer: "10060",
    cancer: "Nervous System Neoplasms",
    quant: "1",
    pmids: "23333558",
  },
  {
    id: "11549",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "1351",
    cancer: "Adrenal Gland Neoplasms",
    quant: "1",
    pmids: "19414399",
  },
  {
    id: "11550",
    id_polifenol: "15",
    polifenol: "Masoprocol",
    id_cancer: "1351",
    cancer: "Adrenal Gland Neoplasms",
    quant: "1",
    pmids: "12423359",
  },
  {
    id: "11551",
    id_polifenol: "4181",
    polifenol: "L 783277",
    id_cancer: "1351",
    cancer: "Adrenal Gland Neoplasms",
    quant: "1",
    pmids: "20074452",
  },
  {
    id: "11552",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "3230",
    cancer: "Carcinoma, Bronchogenic",
    quant: "1",
    pmids: "17406801",
  },
  {
    id: "11553",
    id_polifenol: "5578",
    polifenol: "alpha-naphthoflavone",
    id_cancer: "3230",
    cancer: "Carcinoma, Bronchogenic",
    quant: "1",
    pmids: "4066758",
  },
  {
    id: "11554",
    id_polifenol: "60",
    polifenol: "2,4-Dinitrophenol",
    id_cancer: "3230",
    cancer: "Carcinoma, Bronchogenic",
    quant: "1",
    pmids: "8119778",
  },
  {
    id: "11555",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "10004",
    cancer: "Neoplasm Seeding",
    quant: "1",
    pmids: "26745094",
  },
  {
    id: "11556",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "10004",
    cancer: "Neoplasm Seeding",
    quant: "1",
    pmids: "25123131",
  },
  {
    id: "11557",
    id_polifenol: "109",
    polifenol: "Catechin",
    id_cancer: "10004",
    cancer: "Neoplasm Seeding",
    quant: "1",
    pmids: "26745094",
  },
  {
    id: "11558",
    id_polifenol: "38",
    polifenol: "Gallic Acid",
    id_cancer: "10004",
    cancer: "Neoplasm Seeding",
    quant: "1",
    pmids: "26745094",
  },
  {
    id: "11559",
    id_polifenol: "1",
    polifenol: "Phenols",
    id_cancer: "10004",
    cancer: "Neoplasm Seeding",
    quant: "1",
    pmids: "21779655",
  },
  {
    id: "11560",
    id_polifenol: "130",
    polifenol: "Proanthocyanidins",
    id_cancer: "10004",
    cancer: "Neoplasm Seeding",
    quant: "1",
    pmids: "25123131",
  },
  {
    id: "11561",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "18125",
    cancer: "Cystadenocarcinoma, Serous",
    quant: "1",
    pmids: "22479527",
  },
  {
    id: "11562",
    id_polifenol: "4522",
    polifenol: "chrysin",
    id_cancer: "18125",
    cancer: "Cystadenocarcinoma, Serous",
    quant: "1",
    pmids: "28816359",
  },
  {
    id: "11563",
    id_polifenol: "126",
    polifenol: "Coumestrol",
    id_cancer: "18125",
    cancer: "Cystadenocarcinoma, Serous",
    quant: "1",
    pmids: "26698565",
  },
  {
    id: "11564",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "11126",
    cancer: "Peripheral Nervous System Cancer",
    quant: "1",
    pmids: "23437333",
  },
  {
    id: "11565",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "11126",
    cancer: "Peripheral Nervous System Cancer",
    quant: "1",
    pmids: "18053169",
  },
  {
    id: "11566",
    id_polifenol: "871",
    polifenol: "ABT-737",
    id_cancer: "11126",
    cancer: "Peripheral Nervous System Cancer",
    quant: "1",
    pmids: "22664653",
  },
  {
    id: "11567",
    id_polifenol: "896",
    polifenol: "polyphenon B",
    id_cancer: "11126",
    cancer: "Peripheral Nervous System Cancer",
    quant: "1",
    pmids: "18053169",
  },
  {
    id: "11568",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "10013",
    cancer: "Neoplasms, Glandular and Epithelial",
    quant: "1",
    pmids: "26515460",
  },
  {
    id: "11569",
    id_polifenol: "98",
    polifenol: "Propofol",
    id_cancer: "10013",
    cancer: "Neoplasms, Glandular and Epithelial",
    quant: "1",
    pmids: "19764911",
  },
  {
    id: "11570",
    id_polifenol: "5844",
    polifenol: "4-dimethylamino-3',4'-dimethoxychalcone",
    id_cancer: "10013",
    cancer: "Neoplasms, Glandular and Epithelial",
    quant: "1",
    pmids: "27416926",
  },
  {
    id: "11571",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "14056",
    cancer: "Sarcoma, Synovial",
    quant: "2",
    pmids: "10424432,11238032",
  },
  {
    id: "11572",
    id_polifenol: "2697",
    polifenol: "4-trifluoromethylsalicylic acid",
    id_cancer: "14056",
    cancer: "Sarcoma, Synovial",
    quant: "1",
    pmids: "21811429",
  },
  {
    id: "11573",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "18074",
    cancer: "Rhabdomyosarcoma, Alveolar",
    quant: "1",
    pmids: "23408929",
  },
  {
    id: "11574",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "18074",
    cancer: "Rhabdomyosarcoma, Alveolar",
    quant: "1",
    pmids: "27840956",
  },
  {
    id: "11575",
    id_polifenol: "871",
    polifenol: "ABT-737",
    id_cancer: "18074",
    cancer: "Rhabdomyosarcoma, Alveolar",
    quant: "1",
    pmids: "23814486",
  },
  {
    id: "11576",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "534",
    cancer: "Germ Cell",
    quant: "1",
    pmids: "21193839",
  },
  {
    id: "11577",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "534",
    cancer: "Germ Cell",
    quant: "1",
    pmids: "22259050",
  },
  {
    id: "11578",
    id_polifenol: "285",
    polifenol: "bisphenol A",
    id_cancer: "534",
    cancer: "Germ Cell",
    quant: "1",
    pmids: "9524557",
  },
  {
    id: "11579",
    id_polifenol: "350",
    polifenol: "nonylphenol",
    id_cancer: "534",
    cancer: "Germ Cell",
    quant: "1",
    pmids: "9524557",
  },
  {
    id: "11580",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "18767",
    cancer: "Bone Marrow Neoplasms",
    quant: "1",
    pmids: "29786746",
  },
  {
    id: "11581",
    id_polifenol: "49",
    polifenol: "Aspirin",
    id_cancer: "18767",
    cancer: "Bone Marrow Neoplasms",
    quant: "1",
    pmids: "21324923",
  },
  {
    id: "11582",
    id_polifenol: "117",
    polifenol: "Luteolin",
    id_cancer: "18767",
    cancer: "Bone Marrow Neoplasms",
    quant: "1",
    pmids: "29786746",
  },
  {
    id: "11583",
    id_polifenol: "1",
    polifenol: "Phenols",
    id_cancer: "18767",
    cancer: "Bone Marrow Neoplasms",
    quant: "1",
    pmids: "2261879",
  },
  {
    id: "11584",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "578",
    cancer: "Cutaneous T-Cell Lymphoma",
    quant: "2",
    pmids: "20393484,26244872",
  },
  {
    id: "11585",
    id_polifenol: "49",
    polifenol: "Aspirin",
    id_cancer: "578",
    cancer: "Cutaneous T-Cell Lymphoma",
    quant: "1",
    pmids: "22011910",
  },
  {
    id: "11586",
    id_polifenol: "55",
    polifenol: "Sodium Salicylate",
    id_cancer: "578",
    cancer: "Cutaneous T-Cell Lymphoma",
    quant: "1",
    pmids: "22011910",
  },
  {
    id: "11587",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "18032",
    cancer: "Lymphatic Vessel Tumors",
    quant: "1",
    pmids: "11827069",
  },
  {
    id: "11588",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "18032",
    cancer: "Lymphatic Vessel Tumors",
    quant: "1",
    pmids: "25874494",
  },
  {
    id: "11589",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "18032",
    cancer: "Lymphatic Vessel Tumors",
    quant: "1",
    pmids: "10760831",
  },
  {
    id: "11590",
    id_polifenol: "114",
    polifenol: "Apigenin",
    id_cancer: "18032",
    cancer: "Lymphatic Vessel Tumors",
    quant: "1",
    pmids: "11827069",
  },
  {
    id: "11591",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "18108",
    cancer: "Carcinoma, Acinar Cell",
    quant: "1",
    pmids: "20823570",
  },
  {
    id: "11592",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "18108",
    cancer: "Carcinoma, Acinar Cell",
    quant: "1",
    pmids: "20823570",
  },
  {
    id: "11593",
    id_polifenol: "110",
    polifenol: "Chalcones",
    id_cancer: "18108",
    cancer: "Carcinoma, Acinar Cell",
    quant: "1",
    pmids: "21778460",
  },
  {
    id: "11594",
    id_polifenol: "6065",
    polifenol: "baicalein",
    id_cancer: "18108",
    cancer: "Carcinoma, Acinar Cell",
    quant: "1",
    pmids: "29155449",
  },
  {
    id: "11595",
    id_polifenol: "5899",
    polifenol: "2',4',6'-tris(methoxymethoxy) chalcone",
    id_cancer: "18108",
    cancer: "Carcinoma, Acinar Cell",
    quant: "1",
    pmids: "21778460",
  },
  {
    id: "11596",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "3226",
    cancer: "Abdominal Neoplasms",
    quant: "1",
    pmids: "29966007",
  },
  {
    id: "11597",
    id_polifenol: "49",
    polifenol: "Aspirin",
    id_cancer: "3226",
    cancer: "Abdominal Neoplasms",
    quant: "1",
    pmids: "7053849",
  },
  {
    id: "11598",
    id_polifenol: "110",
    polifenol: "Chalcones",
    id_cancer: "3226",
    cancer: "Abdominal Neoplasms",
    quant: "1",
    pmids: "1099024",
  },
  {
    id: "11599",
    id_polifenol: "15",
    polifenol: "Masoprocol",
    id_cancer: "3226",
    cancer: "Abdominal Neoplasms",
    quant: "1",
    pmids: "7053849",
  },
  {
    id: "11600",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "523",
    cancer: "Triple Negative Breast Neoplasms",
    quant: "1",
    pmids: "18462866",
  },
  {
    id: "11601",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "523",
    cancer: "Triple Negative Breast Neoplasms",
    quant: "1",
    pmids: "23714466",
  },
  {
    id: "11602",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "523",
    cancer: "Triple Negative Breast Neoplasms",
    quant: "1",
    pmids: "23714466",
  },
  {
    id: "11603",
    id_polifenol: "109",
    polifenol: "Catechin",
    id_cancer: "523",
    cancer: "Triple Negative Breast Neoplasms",
    quant: "2",
    pmids: "18941371,23714466",
  },
  {
    id: "11604",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "17637",
    cancer: "Lymphoma, Large-Cell, Anaplastic",
    quant: "1",
    pmids: "29179521",
  },
  {
    id: "11605",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "17637",
    cancer: "Lymphoma, Large-Cell, Anaplastic",
    quant: "1",
    pmids: "15883821",
  },
  {
    id: "11606",
    id_polifenol: "7235",
    polifenol: "silybin",
    id_cancer: "17637",
    cancer: "Lymphoma, Large-Cell, Anaplastic",
    quant: "1",
    pmids: "29179521",
  },
  {
    id: "11607",
    id_polifenol: "129",
    polifenol: "Rotenone",
    id_cancer: "17637",
    cancer: "Lymphoma, Large-Cell, Anaplastic",
    quant: "1",
    pmids: "15883821",
  },
  {
    id: "11608",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "18070",
    cancer: "Sarcoma, Small Cell",
    quant: "1",
    pmids: "22201757",
  },
  {
    id: "11609",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "18070",
    cancer: "Sarcoma, Small Cell",
    quant: "1",
    pmids: "26026076",
  },
  {
    id: "11610",
    id_polifenol: "871",
    polifenol: "ABT-737",
    id_cancer: "18050",
    cancer: "Liposarcoma, Myxoid",
    quant: "1",
    pmids: "27822137",
  },
  {
    id: "11611",
    id_polifenol: "4253",
    polifenol:
      "5-(2,4-dihydroxy-5-isopropylphenyl)-4-(4-morpholin-4-ylmethylphenyl)isoxazole-3-carboxylic acid ethylamide",
    id_cancer: "18050",
    cancer: "Liposarcoma, Myxoid",
    quant: "1",
    pmids: "26225840",
  },
  {
    id: "11612",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "596",
    cancer: "Rhabdomyosarcoma, Embryonal",
    quant: "2",
    pmids: "23615277,27840956",
  },
  {
    id: "11613",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "7119",
    cancer: "Heart Neoplasms",
    quant: "2",
    pmids: "20305684,24848068",
  },
  {
    id: "11614",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "7119",
    cancer: "Heart Neoplasms",
    quant: "1",
    pmids: "20305684",
  },
  {
    id: "11615",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "543",
    cancer: "Gestational Trophoblastic Tumor",
    quant: "1",
    pmids: "28462491",
  },
  {
    id: "11616",
    id_polifenol: "6451",
    polifenol: "daidzein",
    id_cancer: "543",
    cancer: "Gestational Trophoblastic Tumor",
    quant: "1",
    pmids: "29436666",
  },
  {
    id: "11617",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "25579",
    cancer: "Dendritic Cell Sarcoma, Follicular",
    quant: "2",
    pmids: "11568005,21455573",
  },
  {
    id: "11618",
    id_polifenol: "6087",
    polifenol: "wogonin",
    id_cancer: "18136",
    cancer: "Neoplasms, Basal Cell",
    quant: "1",
    pmids: "18829980",
  },
  {
    id: "11619",
    id_polifenol: "2773",
    polifenol: "farnesylthiosalicylic acid",
    id_cancer: "18136",
    cancer: "Neoplasms, Basal Cell",
    quant: "1",
    pmids: "25593982",
  },
  {
    id: "11620",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "18038",
    cancer: "Carcinoma, Adenosquamous",
    quant: "1",
    pmids: "9588219",
  },
  {
    id: "11621",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "18038",
    cancer: "Carcinoma, Adenosquamous",
    quant: "1",
    pmids: "10202397",
  },
  {
    id: "11622",
    id_polifenol: "4559",
    polifenol: "theaflavin",
    id_cancer: "18038",
    cancer: "Carcinoma, Adenosquamous",
    quant: "1",
    pmids: "10202397",
  },
  {
    id: "11623",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "2950",
    cancer: "Bronchial Neoplasms",
    quant: "1",
    pmids: "16911524",
  },
  {
    id: "11624",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "2950",
    cancer: "Bronchial Neoplasms",
    quant: "1",
    pmids: "18426555",
  },
  {
    id: "11625",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "10014",
    cancer: "Neoplasms, Hormone-Dependent",
    quant: "2",
    pmids: "16434996,18815740",
  },
  {
    id: "11626",
    id_polifenol: "125",
    polifenol: "Isoflavones",
    id_cancer: "10014",
    cancer: "Neoplasms, Hormone-Dependent",
    quant: "1",
    pmids: "18815740",
  },
  {
    id: "11627",
    id_polifenol: "6465",
    polifenol: "genistin",
    id_cancer: "10014",
    cancer: "Neoplasms, Hormone-Dependent",
    quant: "1",
    pmids: "18815740",
  },
  {
    id: "11628",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "544",
    cancer: "Uterine Sarcoma",
    quant: "1",
    pmids: "29677109",
  },
  {
    id: "11629",
    id_polifenol: "2167",
    polifenol: "phenolic acid",
    id_cancer: "544",
    cancer: "Uterine Sarcoma",
    quant: "1",
    pmids: "29677109",
  },
  {
    id: "11630",
    id_polifenol: "3089",
    polifenol: "1,1-diphenyl-2-picrylhydrazyl",
    id_cancer: "544",
    cancer: "Uterine Sarcoma",
    quant: "1",
    pmids: "29677109",
  },
  {
    id: "11631",
    id_polifenol: "38",
    polifenol: "Gallic Acid",
    id_cancer: "544",
    cancer: "Uterine Sarcoma",
    quant: "1",
    pmids: "29677109",
  },
  {
    id: "11632",
    id_polifenol: "452",
    polifenol: "acteoside",
    id_cancer: "544",
    cancer: "Uterine Sarcoma",
    quant: "1",
    pmids: "11725977",
  },
  {
    id: "11633",
    id_polifenol: "2159",
    polifenol: "2,3-dihydroxybenzoic acid",
    id_cancer: "544",
    cancer: "Uterine Sarcoma",
    quant: "1",
    pmids: "11725977",
  },
  {
    id: "11634",
    id_polifenol: "472",
    polifenol: "isoacteoside",
    id_cancer: "544",
    cancer: "Uterine Sarcoma",
    quant: "1",
    pmids: "11725977",
  },
  {
    id: "11635",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "3241",
    cancer: "Transitional Cell Carcinoma",
    quant: "1",
    pmids: "23152782",
  },
  {
    id: "11636",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "3241",
    cancer: "Transitional Cell Carcinoma",
    quant: "1",
    pmids: "19424573",
  },
  {
    id: "11637",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "520",
    cancer: "Eye Neoplasms",
    quant: "1",
    pmids: "21730846",
  },
  {
    id: "11638",
    id_polifenol: "92",
    polifenol: "Triclosan",
    id_cancer: "520",
    cancer: "Eye Neoplasms",
    quant: "1",
    pmids: "23816424",
  },
  {
    id: "11639",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "18764",
    cancer: "Muscle Neoplasms",
    quant: "1",
    pmids: "15477867",
  },
  {
    id: "11640",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "18764",
    cancer: "Muscle Neoplasms",
    quant: "1",
    pmids: "9833772",
  },
  {
    id: "11641",
    id_polifenol: "125",
    polifenol: "Isoflavones",
    id_cancer: "18764",
    cancer: "Muscle Neoplasms",
    quant: "1",
    pmids: "9833772",
  },
  {
    id: "11642",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "536",
    cancer: "Extracranial Germ Cell Tumor",
    quant: "1",
    pmids: "24902844",
  },
  {
    id: "11643",
    id_polifenol: "2066",
    polifenol: "NSC 680410",
    id_cancer: "536",
    cancer: "Extracranial Germ Cell Tumor",
    quant: "1",
    pmids: "12451475",
  },
  {
    id: "11644",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "7175",
    cancer: "Hemangiosarcoma",
    quant: "1",
    pmids: "11238032",
  },
  {
    id: "11645",
    id_polifenol: "713",
    polifenol:
      "3-(3-chloro-4-hydroxyphenylamino)-4-(4-nitrophenyl)-1H-pyrrole-2,5-dione",
    id_cancer: "7175",
    cancer: "Hemangiosarcoma",
    quant: "1",
    pmids: "20705954",
  },
  {
    id: "11646",
    id_polifenol: "4244",
    polifenol: "malabaricone A",
    id_cancer: "16526",
    cancer: "Lymphoma, Large B-Cell, Diffuse",
    quant: "1",
    pmids: "27398613",
  },
  {
    id: "11647",
    id_polifenol: "5829",
    polifenol: "1-phenyl-1,2-propanedione",
    id_cancer: "16526",
    cancer: "Lymphoma, Large B-Cell, Diffuse",
    quant: "1",
    pmids: "29623853",
  },
  {
    id: "11648",
    id_polifenol: "129",
    polifenol: "Rotenone",
    id_cancer: "8807",
    cancer: "Liver Neoplasms, Experimental",
    quant: "1",
    pmids: "177206",
  },
  {
    id: "11649",
    id_polifenol: "107",
    polifenol: "beta-Naphthoflavone",
    id_cancer: "8807",
    cancer: "Liver Neoplasms, Experimental",
    quant: "1",
    pmids: "3450",
  },
  {
    id: "11650",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "485",
    cancer: "Peripheral Nervous System Cancer",
    quant: "1",
    pmids: "11525601",
  },
  {
    id: "11651",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "485",
    cancer: "Peripheral Nervous System Cancer",
    quant: "1",
    pmids: "16239064",
  },
  {
    id: "11652",
    id_polifenol: "6451",
    polifenol: "daidzein",
    id_cancer: "485",
    cancer: "Peripheral Nervous System Cancer",
    quant: "1",
    pmids: "11525601",
  },
  {
    id: "11653",
    id_polifenol: "126",
    polifenol: "Coumestrol",
    id_cancer: "485",
    cancer: "Peripheral Nervous System Cancer",
    quant: "1",
    pmids: "11525601",
  },
  {
    id: "11654",
    id_polifenol: "1",
    polifenol: "Phenols",
    id_cancer: "6675",
    cancer: "Myosarcoma",
    quant: "2",
    pmids: "15346059,24718514",
  },
  {
    id: "11655",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "15956",
    cancer: "Soft Tissue Neoplasms",
    quant: "1",
    pmids: "9771944",
  },
  {
    id: "11656",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "15956",
    cancer: "Soft Tissue Neoplasms",
    quant: "1",
    pmids: "18815740",
  },
  {
    id: "11657",
    id_polifenol: "125",
    polifenol: "Isoflavones",
    id_cancer: "15956",
    cancer: "Soft Tissue Neoplasms",
    quant: "1",
    pmids: "18815740",
  },
  {
    id: "11658",
    id_polifenol: "6465",
    polifenol: "genistin",
    id_cancer: "15956",
    cancer: "Soft Tissue Neoplasms",
    quant: "1",
    pmids: "18815740",
  },
  {
    id: "11659",
    id_polifenol: "5815",
    polifenol: "dibenzoylmethane",
    id_cancer: "15956",
    cancer: "Soft Tissue Neoplasms",
    quant: "1",
    pmids: "9771944",
  },
  {
    id: "11660",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "18116",
    cancer: "Splenic Neoplasms",
    quant: "1",
    pmids: "28417445",
  },
  {
    id: "11661",
    id_polifenol: "4253",
    polifenol:
      "5-(2,4-dihydroxy-5-isopropylphenyl)-4-(4-morpholin-4-ylmethylphenyl)isoxazole-3-carboxylic acid ethylamide",
    id_cancer: "18116",
    cancer: "Splenic Neoplasms",
    quant: "1",
    pmids: "24280702",
  },
  {
    id: "11662",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "8",
    cancer: "Carcinoma, Lobular",
    quant: "1",
    pmids: "21865023",
  },
  {
    id: "11663",
    id_polifenol: "110",
    polifenol: "Chalcones",
    id_cancer: "8",
    cancer: "Carcinoma, Lobular",
    quant: "1",
    pmids: "18418697",
  },
  {
    id: "11664",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "19205",
    cancer: "Leukemia, Experimental",
    quant: "1",
    pmids: "21354136",
  },
  {
    id: "11665",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "19205",
    cancer: "Leukemia, Experimental",
    quant: "1",
    pmids: "29404861",
  },
  {
    id: "11666",
    id_polifenol: "110",
    polifenol: "Chalcones",
    id_cancer: "19205",
    cancer: "Leukemia, Experimental",
    quant: "1",
    pmids: "21354136",
  },
  {
    id: "11667",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "26753",
    cancer: "Carcinoma, Verrucous",
    quant: "1",
    pmids: "28414916",
  },
  {
    id: "11668",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "26753",
    cancer: "Carcinoma, Verrucous",
    quant: "1",
    pmids: "28414916",
  },
  {
    id: "11669",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "26753",
    cancer: "Carcinoma, Verrucous",
    quant: "1",
    pmids: "17234792",
  },
  {
    id: "11670",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "11524",
    cancer: "Precursor B-Cell Lymphoblastic Leukemia-Lymphoma",
    quant: "1",
    pmids: "14523649",
  },
  {
    id: "11671",
    id_polifenol: "125",
    polifenol: "Isoflavones",
    id_cancer: "11524",
    cancer: "Precursor B-Cell Lymphoblastic Leukemia-Lymphoma",
    quant: "1",
    pmids: "14523649",
  },
  {
    id: "11672",
    id_polifenol: "110",
    polifenol: "Chalcones",
    id_cancer: "11524",
    cancer: "Precursor B-Cell Lymphoblastic Leukemia-Lymphoma",
    quant: "1",
    pmids: "14523649",
  },
  {
    id: "11673",
    id_polifenol: "113",
    polifenol: "Flavones",
    id_cancer: "11524",
    cancer: "Precursor B-Cell Lymphoblastic Leukemia-Lymphoma",
    quant: "1",
    pmids: "14523649",
  },
  {
    id: "11674",
    id_polifenol: "54",
    polifenol: "Salicylic Acid",
    id_cancer: "11524",
    cancer: "Precursor B-Cell Lymphoblastic Leukemia-Lymphoma",
    quant: "1",
    pmids: "25071805",
  },
  {
    id: "11675",
    id_polifenol: "6454",
    polifenol: "formononetin",
    id_cancer: "11524",
    cancer: "Precursor B-Cell Lymphoblastic Leukemia-Lymphoma",
    quant: "1",
    pmids: "14523649",
  },
  {
    id: "11676",
    id_polifenol: "128",
    polifenol: "Pterocarpans",
    id_cancer: "11524",
    cancer: "Precursor B-Cell Lymphoblastic Leukemia-Lymphoma",
    quant: "1",
    pmids: "14523649",
  },
  {
    id: "11677",
    id_polifenol: "4653",
    polifenol: "4',7-dihydroxyflavone",
    id_cancer: "11524",
    cancer: "Precursor B-Cell Lymphoblastic Leukemia-Lymphoma",
    quant: "1",
    pmids: "14523649",
  },
  {
    id: "11678",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "495",
    cancer: "Plant Tumors",
    quant: "1",
    pmids: "23529990",
  },
  {
    id: "11679",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "495",
    cancer: "Plant Tumors",
    quant: "1",
    pmids: "16155276",
  },
  {
    id: "11680",
    id_polifenol: "125",
    polifenol: "Isoflavones",
    id_cancer: "495",
    cancer: "Plant Tumors",
    quant: "1",
    pmids: "16155276",
  },
  {
    id: "11681",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "8646",
    cancer: "Acute Megakaryocytic Leukemia",
    quant: "1",
    pmids: "27042290",
  },
  {
    id: "11682",
    id_polifenol: "6065",
    polifenol: "baicalein",
    id_cancer: "8646",
    cancer: "Acute Megakaryocytic Leukemia",
    quant: "1",
    pmids: "27042290",
  },
  {
    id: "11683",
    id_polifenol: "285",
    polifenol: "bisphenol A",
    id_cancer: "488",
    cancer: "Inflammatory Breast Neoplasms",
    quant: "1",
    pmids: "28426875",
  },
  {
    id: "11684",
    id_polifenol: "696",
    polifenol: "2,2-bis(4-hydroxyphenyl)-1,1,1-trichloroethane",
    id_cancer: "488",
    cancer: "Inflammatory Breast Neoplasms",
    quant: "1",
    pmids: "28426875",
  },
  {
    id: "11685",
    id_polifenol: "2693",
    polifenol: "copper bis(3,5-diisopropylsalicylate)",
    id_cancer: "617",
    cancer: "Thymoma",
    quant: "1",
    pmids: "3019529",
  },
  {
    id: "11686",
    id_polifenol: "2744",
    polifenol: "3,5-diisopropylsalicylic acid",
    id_cancer: "617",
    cancer: "Thymoma",
    quant: "1",
    pmids: "3019529",
  },
  {
    id: "11687",
    id_polifenol: "1556",
    polifenol: "olvanil",
    id_cancer: "15823",
    cancer: "Leukemia, Basophilic, Acute",
    quant: "1",
    pmids: "10785541",
  },
  {
    id: "11688",
    id_polifenol: "1566",
    polifenol: "arvanil",
    id_cancer: "15823",
    cancer: "Leukemia, Basophilic, Acute",
    quant: "1",
    pmids: "10785541",
  },
  {
    id: "11689",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "21794",
    cancer: "Choriocarcinoma, Non-gestational",
    quant: "1",
    pmids: "27714811",
  },
  {
    id: "11690",
    id_polifenol: "120",
    polifenol: "Flavonols",
    id_cancer: "21794",
    cancer: "Choriocarcinoma, Non-gestational",
    quant: "1",
    pmids: "27714811",
  },
  {
    id: "11691",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "8645",
    cancer: "Leukemia, Mast-Cell",
    quant: "1",
    pmids: "15800027",
  },
  {
    id: "11692",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "548",
    cancer: "Hypopharyngeal Cancer",
    quant: "1",
    pmids: "18632202",
  },
  {
    id: "11693",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "18084",
    cancer: "Neuroectodermal Tumors, Primitive",
    quant: "1",
    pmids: "14769133",
  },
  {
    id: "11694",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "18084",
    cancer: "Neuroectodermal Tumors, Primitive",
    quant: "1",
    pmids: "14769133",
  },
  {
    id: "11695",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "18160",
    cancer: "Neurofibrosarcoma",
    quant: "1",
    pmids: "16239399",
  },
  {
    id: "11696",
    id_polifenol: "6301",
    polifenol: "3-methoxyflavone",
    id_cancer: "18160",
    cancer: "Neurofibrosarcoma",
    quant: "1",
    pmids: "16239399",
  },
  {
    id: "11697",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "18111",
    cancer: "Carcinoma, Ductal, Breast",
    quant: "1",
    pmids: "19944674",
  },
  {
    id: "11698",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "27908",
    cancer: "Intraocular Lymphoma",
    quant: "1",
    pmids: "22470431",
  },
  {
    id: "11699",
    id_polifenol: "1644",
    polifenol: "Cur1 compound",
    id_cancer: "27908",
    cancer: "Intraocular Lymphoma",
    quant: "1",
    pmids: "22470431",
  },
  {
    id: "11700",
    id_polifenol: "4883",
    polifenol: "flavokawain B",
    id_cancer: "562",
    cancer: "Acute Biphenotypic Leukemia",
    quant: "1",
    pmids: "25641429",
  },
  {
    id: "11701",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "570",
    cancer: "T-Cell Prolymphocytic Leukemia",
    quant: "1",
    pmids: "17430639",
  },
  {
    id: "11702",
    id_polifenol: "3089",
    polifenol: "1,1-diphenyl-2-picrylhydrazyl",
    id_cancer: "570",
    cancer: "T-Cell Prolymphocytic Leukemia",
    quant: "1",
    pmids: "17430639",
  },
  {
    id: "11703",
    id_polifenol: "5910",
    polifenol: "3'-formyl-4',6'-dihydroxy-2'-methoxy-5'-methylchalcone",
    id_cancer: "570",
    cancer: "T-Cell Prolymphocytic Leukemia",
    quant: "1",
    pmids: "17430639",
  },
  {
    id: "11704",
    id_polifenol: "6174",
    polifenol: "(2S)-8-formyl-5-hydroxy-7-methoxy-6-methylflavanone",
    id_cancer: "570",
    cancer: "T-Cell Prolymphocytic Leukemia",
    quant: "1",
    pmids: "17430639",
  },
  {
    id: "11705",
    id_polifenol: "871",
    polifenol: "ABT-737",
    id_cancer: "576",
    cancer: "Hairy Cell Leukemia",
    quant: "1",
    pmids: "20587662",
  },
  {
    id: "11706",
    id_polifenol: "4253",
    polifenol:
      "5-(2,4-dihydroxy-5-isopropylphenyl)-4-(4-morpholin-4-ylmethylphenyl)isoxazole-3-carboxylic acid ethylamide",
    id_cancer: "502",
    cancer: "Islet Cell Tumors",
    quant: "1",
    pmids: "25301256",
  },
  {
    id: "11707",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "1347",
    cancer: "Adrenal Cortex Neoplasms",
    quant: "1",
    pmids: "17283246",
  },
  {
    id: "11708",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "25366",
    cancer: "Solitary Fibrous Tumor, Pleural",
    quant: "1",
    pmids: "25028262",
  },
  {
    id: "11709",
    id_polifenol: "113",
    polifenol: "Flavones",
    id_cancer: "8303",
    cancer: "Jejunal Neoplasms",
    quant: "1",
    pmids: "22309980",
  },
  {
    id: "11710",
    id_polifenol: "4522",
    polifenol: "chrysin",
    id_cancer: "8303",
    cancer: "Jejunal Neoplasms",
    quant: "1",
    pmids: "22309980",
  },
  {
    id: "11711",
    id_polifenol: "2773",
    polifenol: "farnesylthiosalicylic acid",
    id_cancer: "512",
    cancer: "Merkel Cell Carcinoma",
    quant: "1",
    pmids: "10619439",
  },
  {
    id: "11712",
    id_polifenol: "129",
    polifenol: "Rotenone",
    id_cancer: "3234",
    cancer: "Carcinoma, Krebs 2",
    quant: "1",
    pmids: "177206",
  },
  {
    id: "11713",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "15015",
    cancer: "Urologic Neoplasms",
    quant: "1",
    pmids: "16157026",
  },
  {
    id: "11714",
    id_polifenol: "49",
    polifenol: "Aspirin",
    id_cancer: "18128",
    cancer: "Male Breast Cancer",
    quant: "1",
    pmids: "2823818",
  },
  {
    id: "11715",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "516",
    cancer: "Carcinoma, Large Cell",
    quant: "1",
    pmids: "16153436",
  },
  {
    id: "11716",
    id_polifenol: "871",
    polifenol: "ABT-737",
    id_cancer: "16528",
    cancer: "Multiple Endocrine Neoplasia Type 2a",
    quant: "1",
    pmids: "22138435",
  },
  {
    id: "11717",
    id_polifenol: "4683",
    polifenol: "2-(2-amino-3-methoxyphenyl)-4H-1-benzopyran-4-one",
    id_cancer: "9253",
    cancer: "Lymphoma, T-Cell, Peripheral",
    quant: "1",
    pmids: "17384278",
  },
  {
    id: "11718",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "605",
    cancer: "Meningeal Neoplasms",
    quant: "1",
    pmids: "19368804",
  },
  {
    id: "11719",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "9862",
    cancer: "Neoplasms, Adipose Tissue",
    quant: "1",
    pmids: "14968209",
  },
  {
    id: "11720",
    id_polifenol: "6465",
    polifenol: "genistin",
    id_cancer: "9862",
    cancer: "Neoplasms, Adipose Tissue",
    quant: "1",
    pmids: "14968209",
  },
  {
    id: "11721",
    id_polifenol: "6510",
    polifenol: "glycitein",
    id_cancer: "9862",
    cancer: "Neoplasms, Adipose Tissue",
    quant: "1",
    pmids: "14968209",
  },
  {
    id: "11722",
    id_polifenol: "6587",
    polifenol: "glycitin",
    id_cancer: "9862",
    cancer: "Neoplasms, Adipose Tissue",
    quant: "1",
    pmids: "14968209",
  },
  {
    id: "11723",
    id_polifenol: "4634",
    polifenol: "alvocidib",
    id_cancer: "13480",
    cancer: "Giant Cell Tumors",
    quant: "1",
    pmids: "23576573",
  },
  {
    id: "11724",
    id_polifenol: "6554",
    polifenol: "tectorigenin",
    id_cancer: "250269",
    cancer: "Mammary Neoplasms, Animal",
    quant: "1",
    pmids: "23969837",
  },
  {
    id: "11725",
    id_polifenol: "122",
    polifenol: "Quercetin",
    id_cancer: "2345",
    cancer: "Testicular Germ Cell Tumor",
    quant: "1",
    pmids: "3083811",
  },
  {
    id: "11726",
    id_polifenol: "5606",
    polifenol: "epigallocatechin gallate",
    id_cancer: "539",
    cancer: "Sarcoma, Avian",
    quant: "1",
    pmids: "28462491",
  },
  {
    id: "11727",
    id_polifenol: "347",
    polifenol: "4-nitrophenyl",
    id_cancer: "18069",
    cancer: "Gynecologic",
    quant: "1",
    pmids: "6586923",
  },
  {
    id: "11728",
    id_polifenol: "49",
    polifenol: "Aspirin",
    id_cancer: "487",
    cancer: "Carcinoma 256, Walker",
    quant: "1",
    pmids: "29087320",
  },
  {
    id: "11729",
    id_polifenol: "2167",
    polifenol: "phenolic acid",
    id_cancer: "26870",
    cancer: "Genitourinary",
    quant: "1",
    pmids: "29556122",
  },
  {
    id: "11730",
    id_polifenol: "4698",
    polifenol: "sakuranetin",
    id_cancer: "26870",
    cancer: "Genitourinary",
    quant: "1",
    pmids: "29556122",
  },
  {
    id: "11731",
    id_polifenol: "5198",
    polifenol: "isosakuranetin",
    id_cancer: "26870",
    cancer: "Genitourinary",
    quant: "1",
    pmids: "29556122",
  },
  {
    id: "11732",
    id_polifenol: "871",
    polifenol: "ABT-737",
    id_cancer: "8642",
    cancer: "Composite Lymphoma",
    quant: "1",
    pmids: "25754349",
  },
  {
    id: "11733",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "510",
    cancer: "Retinal Neoplasms",
    quant: "1",
    pmids: "27223841",
  },
  {
    id: "11734",
    id_polifenol: "125",
    polifenol: "Isoflavones",
    id_cancer: "510",
    cancer: "Retinal Neoplasms",
    quant: "1",
    pmids: "27223841",
  },
  {
    id: "11735",
    id_polifenol: "6693",
    polifenol: "2',4',7-trihydroxyisoflavone",
    id_cancer: "510",
    cancer: "Retinal Neoplasms",
    quant: "1",
    pmids: "27223841",
  },
  {
    id: "11736",
    id_polifenol: "109",
    polifenol: "Catechin",
    id_cancer: "18130",
    cancer: "Endocrine and Neuroendocrine",
    quant: "1",
    pmids: "24604315",
  },
  {
    id: "11737",
    id_polifenol: "6454",
    polifenol: "formononetin",
    id_cancer: "18130",
    cancer: "Endocrine and Neuroendocrine",
    quant: "1",
    pmids: "24604315",
  },
  {
    id: "11738",
    id_polifenol: "40",
    polifenol: "Propyl Gallate",
    id_cancer: "18130",
    cancer: "Endocrine and Neuroendocrine",
    quant: "1",
    pmids: "24604315",
  },
  {
    id: "11739",
    id_polifenol: "104",
    polifenol: "Flavonoids",
    id_cancer: "7819",
    cancer: "Desmoplastic Small Round Cell Tumor",
    quant: "1",
    pmids: "27698775",
  },
  {
    id: "11740",
    id_polifenol: "8",
    polifenol: "Curcumin",
    id_cancer: "26032",
    cancer: "Ileal Neoplasms",
    quant: "1",
    pmids: "12543061",
  },
  {
    id: "11741",
    id_polifenol: "1611",
    polifenol: "bis(4-hydroxycinnamoyl)methane",
    id_cancer: "26032",
    cancer: "Ileal Neoplasms",
    quant: "1",
    pmids: "12543061",
  },
  {
    id: "11742",
    id_polifenol: "1662",
    polifenol: "BDMC-A",
    id_cancer: "26032",
    cancer: "Ileal Neoplasms",
    quant: "1",
    pmids: "12543061",
  },
  {
    id: "11743",
    id_polifenol: "1629",
    polifenol: "bis-1,7-(2-hydroxyphenyl)-hepta-1,6-diene-3,5-dione",
    id_cancer: "26032",
    cancer: "Ileal Neoplasms",
    quant: "1",
    pmids: "12543061",
  },
  {
    id: "11744",
    id_polifenol: "1",
    polifenol: "Phenols",
    id_cancer: "25383",
    cancer: "Meningeal Carcinomatosis",
    quant: "1",
    pmids: "7295822",
  },
  {
    id: "11745",
    id_polifenol: "96",
    polifenol: "Polyphenols",
    id_cancer: "590",
    cancer: "Lymphoma, Extranodal NK-T-Cell",
    quant: "1",
    pmids: "26417311",
  },
  {
    id: "11746",
    id_polifenol: "127",
    polifenol: "Genistein",
    id_cancer: "15812",
    cancer: "Musculoskeletal diseases",
    quant: "1",
    pmids: "7531365",
  },
  {
    id: "11747",
    id_polifenol: "4634",
    polifenol: "alvocidib",
    id_cancer: "14019",
    cancer: "Sigmoid Neoplasms",
    quant: "1",
    pmids: "19934304",
  },
  {
    id: "11748",
    id_polifenol: "687",
    polifenol: "calix(4)arene",
    id_cancer: "25690",
    cancer: "Sweat Gland Neoplasms",
    quant: "1",
    pmids: "18509838",
  },
  {
    id: "11749",
    id_polifenol: "799",
    polifenol: "calix(6)arene",
    id_cancer: "25690",
    cancer: "Sweat Gland Neoplasms",
    quant: "1",
    pmids: "18509838",
  },
  {
    id: "11750",
    id_polifenol: "4634",
    polifenol: "alvocidib",
    id_cancer: "15670",
    cancer: "Perivascular Epithelioid Cell Neoplasms",
    quant: "1",
    pmids: "19778838",
  },
];
